import * as React from "react";
import React__default, { useMemo, useState, useRef, useEffect, useCallback, isValidElement, PureComponent, Component, useLayoutEffect, createContext, memo, useReducer, useContext } from "react";
import * as PIXI from "pixi.js";
import ReactDOM, { unstable_batchedUpdates, createPortal } from "react-dom";
import { jsx, jsxs } from "react/jsx-runtime";
function r$1(e) {
  var t, f2, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f2 = r$1(e[t])) && (n && (n += " "), n += f2);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx$2() {
  for (var e, t, f2 = 0, n = ""; f2 < arguments.length; ) (e = arguments[f2++]) && (t = r$1(e)) && (n && (n += " "), n += t);
  return n;
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f2 = n.default;
  if (typeof f2 == "function") {
    var a = function a2() {
      var isInstance = false;
      try {
        isInstance = this instanceof a2;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a.prototype = f2.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var ResizeSensor$1 = { exports: {} };
var ResizeSensor = ResizeSensor$1.exports;
var hasRequiredResizeSensor;
function requireResizeSensor() {
  if (hasRequiredResizeSensor) return ResizeSensor$1.exports;
  hasRequiredResizeSensor = 1;
  (function(module2, exports2) {
    (function(root2, factory) {
      {
        module2.exports = factory();
      }
    })(typeof window !== "undefined" ? window : ResizeSensor, function() {
      if (typeof window === "undefined") {
        return null;
      }
      var globalWindow = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
      var requestAnimationFrame2 = globalWindow.requestAnimationFrame || globalWindow.mozRequestAnimationFrame || globalWindow.webkitRequestAnimationFrame || function(fn) {
        return globalWindow.setTimeout(fn, 20);
      };
      var cancelAnimationFrame = globalWindow.cancelAnimationFrame || globalWindow.mozCancelAnimationFrame || globalWindow.webkitCancelAnimationFrame || function(timer2) {
        globalWindow.clearTimeout(timer2);
      };
      function forEachElement(elements, callback) {
        var elementsType = Object.prototype.toString.call(elements);
        var isCollectionTyped = "[object Array]" === elementsType || "[object NodeList]" === elementsType || "[object HTMLCollection]" === elementsType || "[object Object]" === elementsType || "undefined" !== typeof jQuery && elements instanceof jQuery || "undefined" !== typeof Elements && elements instanceof Elements;
        var i = 0, j = elements.length;
        if (isCollectionTyped) {
          for (; i < j; i++) {
            callback(elements[i]);
          }
        } else {
          callback(elements);
        }
      }
      function getElementSize(element) {
        if (!element.getBoundingClientRect) {
          return {
            width: element.offsetWidth,
            height: element.offsetHeight
          };
        }
        var rect2 = element.getBoundingClientRect();
        return {
          width: Math.round(rect2.width),
          height: Math.round(rect2.height)
        };
      }
      function setStyle(element, style) {
        Object.keys(style).forEach(function(key) {
          element.style[key] = style[key];
        });
      }
      var ResizeSensor2 = function(element, callback) {
        var lastAnimationFrameForInvisibleCheck = 0;
        function EventQueue() {
          var q2 = [];
          this.add = function(ev) {
            q2.push(ev);
          };
          var i, j;
          this.call = function(sizeInfo) {
            for (i = 0, j = q2.length; i < j; i++) {
              q2[i].call(this, sizeInfo);
            }
          };
          this.remove = function(ev) {
            var newQueue = [];
            for (i = 0, j = q2.length; i < j; i++) {
              if (q2[i] !== ev) newQueue.push(q2[i]);
            }
            q2 = newQueue;
          };
          this.length = function() {
            return q2.length;
          };
        }
        function attachResizeEvent(element2, resized) {
          if (!element2) return;
          if (element2.resizedAttached) {
            element2.resizedAttached.add(resized);
            return;
          }
          element2.resizedAttached = new EventQueue();
          element2.resizedAttached.add(resized);
          element2.resizeSensor = document.createElement("div");
          element2.resizeSensor.dir = "ltr";
          element2.resizeSensor.className = "resize-sensor";
          var style = {
            pointerEvents: "none",
            position: "absolute",
            left: "0px",
            top: "0px",
            right: "0px",
            bottom: "0px",
            overflow: "hidden",
            zIndex: "-1",
            visibility: "hidden",
            maxWidth: "100%"
          };
          var styleChild = {
            position: "absolute",
            left: "0px",
            top: "0px",
            transition: "0s"
          };
          setStyle(element2.resizeSensor, style);
          var expand = document.createElement("div");
          expand.className = "resize-sensor-expand";
          setStyle(expand, style);
          var expandChild = document.createElement("div");
          setStyle(expandChild, styleChild);
          expand.appendChild(expandChild);
          var shrink = document.createElement("div");
          shrink.className = "resize-sensor-shrink";
          setStyle(shrink, style);
          var shrinkChild = document.createElement("div");
          setStyle(shrinkChild, styleChild);
          setStyle(shrinkChild, {
            width: "200%",
            height: "200%"
          });
          shrink.appendChild(shrinkChild);
          element2.resizeSensor.appendChild(expand);
          element2.resizeSensor.appendChild(shrink);
          element2.appendChild(element2.resizeSensor);
          var computedStyle = window.getComputedStyle(element2);
          var position = computedStyle ? computedStyle.getPropertyValue("position") : null;
          if ("absolute" !== position && "relative" !== position && "fixed" !== position && "sticky" !== position) {
            element2.style.position = "relative";
          }
          var dirty = false;
          var rafId = 0;
          var size = getElementSize(element2);
          var lastWidth = 0;
          var lastHeight = 0;
          var initialHiddenCheck = true;
          lastAnimationFrameForInvisibleCheck = 0;
          var resetExpandShrink = function() {
            var width = element2.offsetWidth;
            var height = element2.offsetHeight;
            expandChild.style.width = width + 10 + "px";
            expandChild.style.height = height + 10 + "px";
            expand.scrollLeft = width + 10;
            expand.scrollTop = height + 10;
            shrink.scrollLeft = width + 10;
            shrink.scrollTop = height + 10;
          };
          var reset = function() {
            if (initialHiddenCheck) {
              var invisible = element2.offsetWidth === 0 && element2.offsetHeight === 0;
              if (invisible) {
                if (!lastAnimationFrameForInvisibleCheck) {
                  lastAnimationFrameForInvisibleCheck = requestAnimationFrame2(function() {
                    lastAnimationFrameForInvisibleCheck = 0;
                    reset();
                  });
                }
                return;
              } else {
                initialHiddenCheck = false;
              }
            }
            resetExpandShrink();
          };
          element2.resizeSensor.resetSensor = reset;
          var onResized = function() {
            rafId = 0;
            if (!dirty) return;
            lastWidth = size.width;
            lastHeight = size.height;
            if (element2.resizedAttached) {
              element2.resizedAttached.call(size);
            }
          };
          var onScroll = function() {
            size = getElementSize(element2);
            dirty = size.width !== lastWidth || size.height !== lastHeight;
            if (dirty && !rafId) {
              rafId = requestAnimationFrame2(onResized);
            }
            reset();
          };
          var addEvent = function(el2, name, cb) {
            if (el2.attachEvent) {
              el2.attachEvent("on" + name, cb);
            } else {
              el2.addEventListener(name, cb);
            }
          };
          addEvent(expand, "scroll", onScroll);
          addEvent(shrink, "scroll", onScroll);
          lastAnimationFrameForInvisibleCheck = requestAnimationFrame2(function() {
            lastAnimationFrameForInvisibleCheck = 0;
            reset();
          });
        }
        forEachElement(element, function(elem) {
          attachResizeEvent(elem, callback);
        });
        this.detach = function(ev) {
          if (!lastAnimationFrameForInvisibleCheck) {
            cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
            lastAnimationFrameForInvisibleCheck = 0;
          }
          ResizeSensor2.detach(element, ev);
        };
        this.reset = function() {
          element.resizeSensor.resetSensor();
        };
      };
      ResizeSensor2.reset = function(element) {
        forEachElement(element, function(elem) {
          elem.resizeSensor.resetSensor();
        });
      };
      ResizeSensor2.detach = function(element, ev) {
        forEachElement(element, function(elem) {
          if (!elem) return;
          if (elem.resizedAttached && typeof ev === "function") {
            elem.resizedAttached.remove(ev);
            if (elem.resizedAttached.length()) return;
          }
          if (elem.resizeSensor) {
            if (elem.contains(elem.resizeSensor)) {
              elem.removeChild(elem.resizeSensor);
            }
            delete elem.resizeSensor;
            delete elem.resizedAttached;
          }
        });
      };
      if (typeof MutationObserver !== "undefined") {
        var observer = new MutationObserver(function(mutations) {
          for (var i in mutations) {
            if (mutations.hasOwnProperty(i)) {
              var items2 = mutations[i].addedNodes;
              for (var j = 0; j < items2.length; j++) {
                if (items2[j].resizeSensor) {
                  ResizeSensor2.reset(items2[j]);
                }
              }
            }
          }
        });
        document.addEventListener("DOMContentLoaded", function(event) {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }
      return ResizeSensor2;
    });
  })(ResizeSensor$1);
  return ResizeSensor$1.exports;
}
var ElementQueries$1 = { exports: {} };
var ElementQueries = ElementQueries$1.exports;
var hasRequiredElementQueries;
function requireElementQueries() {
  if (hasRequiredElementQueries) return ElementQueries$1.exports;
  hasRequiredElementQueries = 1;
  (function(module2, exports2) {
    (function(root2, factory) {
      {
        module2.exports = factory(requireResizeSensor());
      }
    })(typeof window !== "undefined" ? window : ElementQueries, function(ResizeSensor2) {
      var ElementQueries2 = function() {
        var cssStyleElement;
        var allQueries = {};
        var idToSelectorMapping = [];
        function getEmSize(element) {
          if (!element) {
            element = document.documentElement;
          }
          var fontSize = window.getComputedStyle(element, null).fontSize;
          return parseFloat(fontSize) || 16;
        }
        function getElementSize(element) {
          if (!element.getBoundingClientRect) {
            return {
              width: element.offsetWidth,
              height: element.offsetHeight
            };
          }
          var rect2 = element.getBoundingClientRect();
          return {
            width: Math.round(rect2.width),
            height: Math.round(rect2.height)
          };
        }
        function convertToPx(element, value) {
          var numbers2 = value.split(/\d/);
          var units = numbers2[numbers2.length - 1];
          value = parseFloat(value);
          switch (units) {
            case "px":
              return value;
            case "em":
              return value * getEmSize(element);
            case "rem":
              return value * getEmSize();
            // Viewport units!
            // According to http://quirksmode.org/mobile/tableViewport.html
            // documentElement.clientWidth/Height gets us the most reliable info
            case "vw":
              return value * document.documentElement.clientWidth / 100;
            case "vh":
              return value * document.documentElement.clientHeight / 100;
            case "vmin":
            case "vmax":
              var vw = document.documentElement.clientWidth / 100;
              var vh = document.documentElement.clientHeight / 100;
              var chooser = Math[units === "vmin" ? "min" : "max"];
              return value * chooser(vw, vh);
            default:
              return value;
          }
        }
        function SetupInformation(element, id2) {
          this.element = element;
          var key, option, elementSize, value, actualValue, attrValues, attrValue, attrName;
          var attributes2 = ["min-width", "min-height", "max-width", "max-height"];
          this.call = function() {
            elementSize = getElementSize(this.element);
            attrValues = {};
            for (key in allQueries[id2]) {
              if (!allQueries[id2].hasOwnProperty(key)) {
                continue;
              }
              option = allQueries[id2][key];
              value = convertToPx(this.element, option.value);
              actualValue = option.property === "width" ? elementSize.width : elementSize.height;
              attrName = option.mode + "-" + option.property;
              attrValue = "";
              if (option.mode === "min" && actualValue >= value) {
                attrValue += option.value;
              }
              if (option.mode === "max" && actualValue <= value) {
                attrValue += option.value;
              }
              if (!attrValues[attrName]) attrValues[attrName] = "";
              if (attrValue && -1 === (" " + attrValues[attrName] + " ").indexOf(" " + attrValue + " ")) {
                attrValues[attrName] += " " + attrValue;
              }
            }
            for (var k in attributes2) {
              if (!attributes2.hasOwnProperty(k)) continue;
              if (attrValues[attributes2[k]]) {
                this.element.setAttribute(attributes2[k], attrValues[attributes2[k]].substr(1));
              } else {
                this.element.removeAttribute(attributes2[k]);
              }
            }
          };
        }
        function setupElement(element, id2) {
          if (!element.elementQueriesSetupInformation) {
            element.elementQueriesSetupInformation = new SetupInformation(element, id2);
          }
          if (!element.elementQueriesSensor) {
            element.elementQueriesSensor = new ResizeSensor2(element, function() {
              element.elementQueriesSetupInformation.call();
            });
          }
        }
        function queueQuery(selector2, mode, property2, value) {
          if (typeof allQueries[selector2] === "undefined") {
            allQueries[selector2] = [];
            var id2 = idToSelectorMapping.length;
            cssStyleElement.innerHTML += "\n" + selector2 + " {animation: 0.1s element-queries;}";
            cssStyleElement.innerHTML += "\n" + selector2 + " > .resize-sensor {min-width: " + id2 + "px;}";
            idToSelectorMapping.push(selector2);
          }
          allQueries[selector2].push({
            mode,
            property: property2,
            value
          });
        }
        function getQuery(container) {
          var query;
          if (document.querySelectorAll) query = container ? container.querySelectorAll.bind(container) : document.querySelectorAll.bind(document);
          if (!query && "undefined" !== typeof $$) query = $$;
          if (!query && "undefined" !== typeof jQuery) query = jQuery;
          if (!query) {
            throw "No document.querySelectorAll, jQuery or Mootools's $$ found.";
          }
          return query;
        }
        function findElementQueriesElements(container) {
          var query = getQuery(container);
          for (var selector2 in allQueries) if (allQueries.hasOwnProperty(selector2)) {
            var elements = query(selector2, container);
            for (var i = 0, j = elements.length; i < j; i++) {
              setupElement(elements[i], selector2);
            }
          }
        }
        function attachResponsiveImage(element) {
          var children2 = [];
          var rules2 = [];
          var sources = [];
          var defaultImageId = 0;
          var lastActiveImage = -1;
          var loadedImages = [];
          for (var i in element.children) {
            if (!element.children.hasOwnProperty(i)) continue;
            if (element.children[i].tagName && element.children[i].tagName.toLowerCase() === "img") {
              children2.push(element.children[i]);
              var minWidth = element.children[i].getAttribute("min-width") || element.children[i].getAttribute("data-min-width");
              var src2 = element.children[i].getAttribute("data-src") || element.children[i].getAttribute("url");
              sources.push(src2);
              var rule = {
                minWidth
              };
              rules2.push(rule);
              if (!minWidth) {
                defaultImageId = children2.length - 1;
                element.children[i].style.display = "block";
              } else {
                element.children[i].style.display = "none";
              }
            }
          }
          lastActiveImage = defaultImageId;
          function check2() {
            var imageToDisplay = false, i2;
            for (i2 in children2) {
              if (!children2.hasOwnProperty(i2)) continue;
              if (rules2[i2].minWidth) {
                if (element.offsetWidth > rules2[i2].minWidth) {
                  imageToDisplay = i2;
                }
              }
            }
            if (!imageToDisplay) {
              imageToDisplay = defaultImageId;
            }
            if (lastActiveImage !== imageToDisplay) {
              if (!loadedImages[imageToDisplay]) {
                var image2 = new Image();
                image2.onload = function() {
                  children2[imageToDisplay].src = sources[imageToDisplay];
                  children2[lastActiveImage].style.display = "none";
                  children2[imageToDisplay].style.display = "block";
                  loadedImages[imageToDisplay] = true;
                  lastActiveImage = imageToDisplay;
                };
                image2.src = sources[imageToDisplay];
              } else {
                children2[lastActiveImage].style.display = "none";
                children2[imageToDisplay].style.display = "block";
                lastActiveImage = imageToDisplay;
              }
            } else {
              children2[imageToDisplay].src = sources[imageToDisplay];
            }
          }
          element.resizeSensorInstance = new ResizeSensor2(element, check2);
          check2();
        }
        function findResponsiveImages() {
          var query = getQuery();
          var elements = query("[data-responsive-image],[responsive-image]");
          for (var i = 0, j = elements.length; i < j; i++) {
            attachResponsiveImage(elements[i]);
          }
        }
        var regex = /,?[\s\t]*([^,\n]*?)((?:\[[\s\t]*?(?:min|max)-(?:width|height)[\s\t]*?[~$\^]?=[\s\t]*?"[^"]*?"[\s\t]*?])+)([^,\n\s\{]*)/mgi;
        var attrRegex = /\[[\s\t]*?(min|max)-(width|height)[\s\t]*?[~$\^]?=[\s\t]*?"([^"]*?)"[\s\t]*?]/mgi;
        function extractQuery(css2) {
          var match, smatch, attrs, attrMatch;
          css2 = css2.replace(/'/g, '"');
          while (null !== (match = regex.exec(css2))) {
            smatch = match[1] + match[3];
            attrs = match[2];
            while (null !== (attrMatch = attrRegex.exec(attrs))) {
              queueQuery(smatch, attrMatch[1], attrMatch[2], attrMatch[3]);
            }
          }
        }
        function readRules(rules2) {
          var selector2 = "";
          if (!rules2) {
            return;
          }
          if ("string" === typeof rules2) {
            rules2 = rules2.toLowerCase();
            if (-1 !== rules2.indexOf("min-width") || -1 !== rules2.indexOf("max-width")) {
              extractQuery(rules2);
            }
          } else {
            for (var i = 0, j = rules2.length; i < j; i++) {
              if (1 === rules2[i].type) {
                selector2 = rules2[i].selectorText || rules2[i].cssText;
                if (-1 !== selector2.indexOf("min-height") || -1 !== selector2.indexOf("max-height")) {
                  extractQuery(selector2);
                } else if (-1 !== selector2.indexOf("min-width") || -1 !== selector2.indexOf("max-width")) {
                  extractQuery(selector2);
                }
              } else if (4 === rules2[i].type) {
                readRules(rules2[i].cssRules || rules2[i].rules);
              } else if (3 === rules2[i].type) {
                if (rules2[i].styleSheet.hasOwnProperty("cssRules")) {
                  readRules(rules2[i].styleSheet.cssRules);
                }
              }
            }
          }
        }
        var defaultCssInjected = false;
        this.init = function() {
          var animationStart = "animationstart";
          if (typeof document.documentElement.style["webkitAnimationName"] !== "undefined") {
            animationStart = "webkitAnimationStart";
          } else if (typeof document.documentElement.style["MozAnimationName"] !== "undefined") {
            animationStart = "mozanimationstart";
          } else if (typeof document.documentElement.style["OAnimationName"] !== "undefined") {
            animationStart = "oanimationstart";
          }
          document.body.addEventListener(animationStart, function(e) {
            var element = e.target;
            var styles2 = element && window.getComputedStyle(element, null);
            var animationName = styles2 && styles2.getPropertyValue("animation-name");
            var requiresSetup = animationName && -1 !== animationName.indexOf("element-queries");
            if (requiresSetup) {
              element.elementQueriesSensor = new ResizeSensor2(element, function() {
                if (element.elementQueriesSetupInformation) {
                  element.elementQueriesSetupInformation.call();
                }
              });
              var sensorStyles = window.getComputedStyle(element.resizeSensor, null);
              var id2 = sensorStyles.getPropertyValue("min-width");
              id2 = parseInt(id2.replace("px", ""));
              setupElement(e.target, idToSelectorMapping[id2]);
            }
          });
          if (!defaultCssInjected) {
            cssStyleElement = document.createElement("style");
            cssStyleElement.type = "text/css";
            cssStyleElement.innerHTML = "[responsive-image] > img, [data-responsive-image] {overflow: hidden; padding: 0; } [responsive-image] > img, [data-responsive-image] > img {width: 100%;}";
            cssStyleElement.innerHTML += "\n@keyframes element-queries { 0% { visibility: inherit; } }";
            document.getElementsByTagName("head")[0].appendChild(cssStyleElement);
            defaultCssInjected = true;
          }
          for (var i = 0, j = document.styleSheets.length; i < j; i++) {
            try {
              if (document.styleSheets[i].href && 0 === document.styleSheets[i].href.indexOf("file://")) {
                console.warn("CssElementQueries: unable to parse local css files, " + document.styleSheets[i].href);
              }
              readRules(document.styleSheets[i].cssRules || document.styleSheets[i].rules || document.styleSheets[i].cssText);
            } catch (e) {
            }
          }
          findResponsiveImages();
        };
        this.findElementQueriesElements = function(container) {
          findElementQueriesElements(container);
        };
        this.update = function() {
          this.init();
        };
      };
      ElementQueries2.update = function() {
        ElementQueries2.instance.update();
      };
      ElementQueries2.detach = function(element) {
        if (element.elementQueriesSetupInformation) {
          element.elementQueriesSensor.detach();
          delete element.elementQueriesSetupInformation;
          delete element.elementQueriesSensor;
        } else if (element.resizeSensorInstance) {
          element.resizeSensorInstance.detach();
          delete element.resizeSensorInstance;
        }
      };
      ElementQueries2.init = function() {
        if (!ElementQueries2.instance) {
          ElementQueries2.instance = new ElementQueries2();
        }
        ElementQueries2.instance.init();
      };
      var domLoaded = function(callback) {
        if (document.addEventListener) {
          document.addEventListener("DOMContentLoaded", callback, false);
        } else if (/KHTML|WebKit|iCab/i.test(navigator.userAgent)) {
          var DOMLoadTimer = setInterval(function() {
            if (/loaded|complete/i.test(document.readyState)) {
              callback();
              clearInterval(DOMLoadTimer);
            }
          }, 10);
        } else window.onload = callback;
      };
      ElementQueries2.findElementQueriesElements = function(container) {
        ElementQueries2.instance.findElementQueriesElements(container);
      };
      ElementQueries2.listen = function() {
        domLoaded(ElementQueries2.init);
      };
      return ElementQueries2;
    });
  })(ElementQueries$1);
  return ElementQueries$1.exports;
}
var cssElementQueries;
var hasRequiredCssElementQueries;
function requireCssElementQueries() {
  if (hasRequiredCssElementQueries) return cssElementQueries;
  hasRequiredCssElementQueries = 1;
  cssElementQueries = {
    ResizeSensor: requireResizeSensor(),
    ElementQueries: requireElementQueries()
  };
  return cssElementQueries;
}
var cssElementQueriesExports = requireCssElementQueries();
function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function bisector(f2) {
  let delta2 = f2;
  let compare = f2;
  if (f2.length === 1) {
    delta2 = (d, x) => f2(d) - x;
    compare = ascendingComparator(f2);
  }
  function left2(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid2 = lo + hi >>> 1;
      if (compare(a[mid2], x) < 0) lo = mid2 + 1;
      else hi = mid2;
    }
    return lo;
  }
  function right2(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid2 = lo + hi >>> 1;
      if (compare(a[mid2], x) > 0) hi = mid2;
      else lo = mid2 + 1;
    }
    return lo;
  }
  function center2(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left2(a, x, lo, hi - 1);
    return i > lo && delta2(a[i - 1], x) > -delta2(a[i], x) ? i - 1 : i;
  }
  return {
    left: left2,
    center: center2,
    right: right2
  };
}
function ascendingComparator(f2) {
  return (d, x) => ascending$1(f2(d), x);
}
function number$3(x) {
  return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
const ascendingBisect = bisector(ascending$1);
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = bisector(number$3).center;
function count(values, valueof) {
  let count2 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count2;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (value = +value) >= value) {
        ++count2;
      }
    }
  }
  return count2;
}
function length$2(array2) {
  return array2.length | 0;
}
function empty$3(length2) {
  return !(length2 > 0);
}
function arrayify(values) {
  return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer$1(reduce2) {
  return (values) => reduce2(...values);
}
function cross$2(...values) {
  const reduce2 = typeof values[values.length - 1] === "function" && reducer$1(values.pop());
  values = values.map(arrayify);
  const lengths = values.map(length$2);
  const j = values.length - 1;
  const index2 = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty$3)) return product;
  while (true) {
    product.push(index2.map((j2, i2) => values[i2][j2]));
    let i = j;
    while (++index2[i] === lengths[i]) {
      if (i === 0) return reduce2 ? product.map(reduce2) : product;
      index2[i--] = 0;
    }
  }
}
function cumsum$1(values, valueof) {
  var sum2 = 0, index2 = 0;
  return Float64Array.from(values, valueof === void 0 ? (v) => sum2 += +v || 0 : (v) => sum2 += +valueof(v, index2++, values) || 0);
}
function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}
function variance(values, valueof) {
  let count2 = 0;
  let delta2;
  let mean2 = 0;
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        delta2 = value - mean2;
        mean2 += delta2 / ++count2;
        sum2 += delta2 * (value - mean2);
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (value = +value) >= value) {
        delta2 = value - mean2;
        mean2 += delta2 / ++count2;
        sum2 += delta2 * (value - mean2);
      }
    }
  }
  if (count2 > 1) return sum2 / (count2 - 1);
}
function deviation(values, valueof) {
  const v = variance(values, valueof);
  return v ? Math.sqrt(v) : v;
}
function extent$1(values, valueof) {
  let min2;
  let max2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value) min2 = max2 = value;
        } else {
          if (min2 > value) min2 = value;
          if (max2 < value) max2 = value;
        }
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null) {
        if (min2 === void 0) {
          if (value >= value) min2 = max2 = value;
        } else {
          if (min2 > value) min2 = value;
          if (max2 < value) max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}
function _classCallCheck$1E(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1w(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1w(o.key), o);
  }
}
function _createClass$1E(e, r2, t) {
  return r2 && _defineProperties$1w(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1w(t) {
  var i = _toPrimitive$1w(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1w(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let Adder = /* @__PURE__ */ (function() {
  function Adder2() {
    _classCallCheck$1E(this, Adder2);
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  return _createClass$1E(Adder2, [{
    key: "add",
    value: function add2(x) {
      const p = this._partials;
      let i = 0;
      for (let j = 0; j < this._n && j < 32; j++) {
        const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
        if (lo) p[i++] = lo;
        x = hi;
      }
      p[i] = x;
      this._n = i + 1;
      return this;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      const p = this._partials;
      let n = this._n, x, y, lo, hi = 0;
      if (n > 0) {
        hi = p[--n];
        while (n > 0) {
          x = hi;
          y = p[--n];
          hi = x + y;
          lo = y - (hi - x);
          if (lo) break;
        }
        if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
          y = lo * 2;
          x = hi + y;
          if (y == x - hi) hi = x;
        }
      }
      return hi;
    }
  }]);
})();
function fsum(values, valueof) {
  const adder = new Adder();
  if (valueof === void 0) {
    for (let value of values) {
      if (value = +value) {
        adder.add(value);
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index2, values)) {
        adder.add(value);
      }
    }
  }
  return +adder;
}
function fcumsum(values, valueof) {
  const adder = new Adder();
  let index2 = -1;
  return Float64Array.from(values, valueof === void 0 ? (v) => adder.add(+v || 0) : (v) => adder.add(+valueof(v, ++index2, values) || 0));
}
function _classCallCheck$1D(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1v(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1v(o.key), o);
  }
}
function _createClass$1D(e, r2, t) {
  return r2 && _defineProperties$1v(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1v(t) {
  var i = _toPrimitive$1v(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1v(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1h(t, o, e) {
  return o = _getPrototypeOf$1h(o), _possibleConstructorReturn$1p(t, _isNativeReflectConstruct$1h() ? Reflect.construct(o, [], _getPrototypeOf$1h(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1p(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1h(t);
}
function _assertThisInitialized$1h(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _superPropGet$F(t, o, e, r2) {
  var p = _get$F(_getPrototypeOf$1h(t.prototype), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$F() {
  return _get$F = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$F(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$F.apply(null, arguments);
}
function _superPropBase$F(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$1h(t)); ) ;
  return t;
}
function _inherits$1p(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1h(t, e);
}
function _wrapNativeSuper$1(t) {
  var r2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper$1 = function(t4) {
    if (null === t4 || !_isNativeFunction$1(t4)) return t4;
    if ("function" != typeof t4) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r2) {
      if (r2.has(t4)) return r2.get(t4);
      r2.set(t4, Wrapper);
    }
    function Wrapper() {
      return _construct$1(t4, arguments, _getPrototypeOf$1h(this).constructor);
    }
    return Wrapper.prototype = Object.create(t4.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }), _setPrototypeOf$1h(Wrapper, t4);
  }, _wrapNativeSuper$1(t);
}
function _construct$1(t, e, r2) {
  if (_isNativeReflectConstruct$1h()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r2 && _setPrototypeOf$1h(p, r2.prototype), p;
}
function _isNativeReflectConstruct$1h() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$1h = function() {
    return !!t;
  })();
}
function _isNativeFunction$1(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf$1h(t, e) {
  return _setPrototypeOf$1h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$1h(t, e);
}
function _getPrototypeOf$1h(t) {
  return _getPrototypeOf$1h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$1h(t);
}
let InternMap = /* @__PURE__ */ (function(_Map) {
  function InternMap2(entries, key = keyof) {
    var _this;
    _classCallCheck$1D(this, InternMap2);
    _this = _callSuper$1h(this, InternMap2);
    Object.defineProperties(_this, {
      _intern: {
        value: /* @__PURE__ */ new Map()
      },
      _key: {
        value: key
      }
    });
    if (entries != null) for (const [key2, value] of entries) _this.set(key2, value);
    return _this;
  }
  _inherits$1p(InternMap2, _Map);
  return _createClass$1D(InternMap2, [{
    key: "get",
    value: function get3(key) {
      return _superPropGet$F(InternMap2, "get", this, 3)([intern_get(this, key)]);
    }
  }, {
    key: "has",
    value: function has(key) {
      return _superPropGet$F(InternMap2, "has", this, 3)([intern_get(this, key)]);
    }
  }, {
    key: "set",
    value: function set2(key, value) {
      return _superPropGet$F(InternMap2, "set", this, 3)([intern_set(this, key), value]);
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return _superPropGet$F(InternMap2, "delete", this, 3)([intern_delete(this, key)]);
    }
  }]);
})(/* @__PURE__ */ _wrapNativeSuper$1(Map));
let InternSet = /* @__PURE__ */ (function(_Set) {
  function InternSet2(values, key = keyof) {
    var _this2;
    _classCallCheck$1D(this, InternSet2);
    _this2 = _callSuper$1h(this, InternSet2);
    Object.defineProperties(_this2, {
      _intern: {
        value: /* @__PURE__ */ new Map()
      },
      _key: {
        value: key
      }
    });
    if (values != null) for (const value of values) _this2.add(value);
    return _this2;
  }
  _inherits$1p(InternSet2, _Set);
  return _createClass$1D(InternSet2, [{
    key: "has",
    value: function has(value) {
      return _superPropGet$F(InternSet2, "has", this, 3)([intern_get(this, value)]);
    }
  }, {
    key: "add",
    value: function add2(value) {
      return _superPropGet$F(InternSet2, "add", this, 3)([intern_set(this, value)]);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      return _superPropGet$F(InternSet2, "delete", this, 3)([intern_delete(this, value)]);
    }
  }]);
})(/* @__PURE__ */ _wrapNativeSuper$1(Set));
function intern_get({
  _intern,
  _key
}, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({
  _intern,
  _key
}, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({
  _intern,
  _key
}, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(value);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function identity$a(x) {
  return x;
}
function group(values, ...keys2) {
  return nest(values, identity$a, identity$a, keys2);
}
function groups(values, ...keys2) {
  return nest(values, Array.from, identity$a, keys2);
}
function rollup(values, reduce2, ...keys2) {
  return nest(values, identity$a, reduce2, keys2);
}
function rollups(values, reduce2, ...keys2) {
  return nest(values, Array.from, reduce2, keys2);
}
function index$1(values, ...keys2) {
  return nest(values, identity$a, unique, keys2);
}
function indexes(values, ...keys2) {
  return nest(values, Array.from, unique, keys2);
}
function unique(values) {
  if (values.length !== 1) throw new Error("duplicate key");
  return values[0];
}
function nest(values, map2, reduce2, keys2) {
  return (function regroup(values2, i) {
    if (i >= keys2.length) return reduce2(values2);
    const groups2 = new InternMap();
    const keyof2 = keys2[i++];
    let index2 = -1;
    for (const value of values2) {
      const key = keyof2(value, ++index2, values2);
      const group2 = groups2.get(key);
      if (group2) group2.push(value);
      else groups2.set(key, [value]);
    }
    for (const [key, values3] of groups2) {
      groups2.set(key, regroup(values3, i));
    }
    return map2(groups2);
  })(values, 0);
}
function permute(source, keys2) {
  return Array.from(keys2, (key) => source[key]);
}
function sort$2(values, ...F) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  values = Array.from(values);
  let [f2 = ascending$1] = F;
  if (f2.length === 1 || F.length > 1) {
    const index2 = Uint32Array.from(values, (d, i) => i);
    if (F.length > 1) {
      F = F.map((f3) => values.map(f3));
      index2.sort((i, j) => {
        for (const f3 of F) {
          const c = ascending$1(f3[i], f3[j]);
          if (c) return c;
        }
      });
    } else {
      f2 = values.map(f2);
      index2.sort((i, j) => ascending$1(f2[i], f2[j]));
    }
    return permute(values, index2);
  }
  return values.sort(f2);
}
function groupSort(values, reduce2, key) {
  return (reduce2.length === 1 ? sort$2(rollup(values, reduce2, key), ([ak, av], [bk, bv]) => ascending$1(av, bv) || ascending$1(ak, bk)) : sort$2(group(values, key), ([ak, av], [bk, bv]) => reduce2(av, bv) || ascending$1(ak, bk))).map(([key2]) => key2);
}
var array$1 = Array.prototype;
var slice$2 = array$1.slice;
function constant$7(x) {
  return function() {
    return x;
  };
}
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start2, stop, count2) {
  var reverse2, i = -1, n, ticks2, step;
  stop = +stop, start2 = +start2, count2 = +count2;
  if (start2 === stop && count2 > 0) return [start2];
  if (reverse2 = stop < start2) n = start2, start2 = stop, stop = n;
  if ((step = tickIncrement(start2, stop, count2)) === 0 || !isFinite(step)) return [];
  if (step > 0) {
    let r0 = Math.round(start2 / step), r1 = Math.round(stop / step);
    if (r0 * step < start2) ++r0;
    if (r1 * step > stop) --r1;
    ticks2 = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks2[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start2 * step), r1 = Math.round(stop * step);
    if (r0 / step < start2) ++r0;
    if (r1 / step > stop) --r1;
    ticks2 = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks2[i] = (r0 + i) / step;
  }
  if (reverse2) ticks2.reverse();
  return ticks2;
}
function tickIncrement(start2, stop, count2) {
  var step = (stop - start2) / Math.max(0, count2), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
  return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start2, stop, count2) {
  var step0 = Math.abs(stop - start2) / Math.max(0, count2), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start2 ? -step1 : step1;
}
function nice$1(start2, stop, count2) {
  let prestep;
  while (true) {
    const step = tickIncrement(start2, stop, count2);
    if (step === prestep || step === 0 || !isFinite(step)) {
      return [start2, stop];
    } else if (step > 0) {
      start2 = Math.floor(start2 / step) * step;
      stop = Math.ceil(stop / step) * step;
    } else if (step < 0) {
      start2 = Math.ceil(start2 * step) / step;
      stop = Math.floor(stop * step) / step;
    }
    prestep = step;
  }
}
function sturges(values) {
  return Math.ceil(Math.log(count(values)) / Math.LN2) + 1;
}
function bin() {
  var value = identity$a, domain2 = extent$1, threshold2 = sturges;
  function histogram(data2) {
    if (!Array.isArray(data2)) data2 = Array.from(data2);
    var i, n = data2.length, x, values = new Array(n);
    for (i = 0; i < n; ++i) {
      values[i] = value(data2[i], i, data2);
    }
    var xz = domain2(values), x02 = xz[0], x12 = xz[1], tz = threshold2(values, x02, x12);
    if (!Array.isArray(tz)) {
      const max2 = x12, tn = +tz;
      if (domain2 === extent$1) [x02, x12] = nice$1(x02, x12, tn);
      tz = ticks(x02, x12, tn);
      if (tz[tz.length - 1] >= x12) {
        if (max2 >= x12 && domain2 === extent$1) {
          const step = tickIncrement(x02, x12, tn);
          if (isFinite(step)) {
            if (step > 0) {
              x12 = (Math.floor(x12 / step) + 1) * step;
            } else if (step < 0) {
              x12 = (Math.ceil(x12 * -step) + 1) / -step;
            }
          }
        } else {
          tz.pop();
        }
      }
    }
    var m = tz.length;
    while (tz[0] <= x02) tz.shift(), --m;
    while (tz[m - 1] > x12) tz.pop(), --m;
    var bins = new Array(m + 1), bin2;
    for (i = 0; i <= m; ++i) {
      bin2 = bins[i] = [];
      bin2.x0 = i > 0 ? tz[i - 1] : x02;
      bin2.x1 = i < m ? tz[i] : x12;
    }
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x02 <= x && x <= x12) {
        bins[bisectRight(tz, x, 0, m)].push(data2[i]);
      }
    }
    return bins;
  }
  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$7(_), histogram) : value;
  };
  histogram.domain = function(_) {
    return arguments.length ? (domain2 = typeof _ === "function" ? _ : constant$7([_[0], _[1]]), histogram) : domain2;
  };
  histogram.thresholds = function(_) {
    return arguments.length ? (threshold2 = typeof _ === "function" ? _ : Array.isArray(_) ? constant$7(slice$2.call(_)) : constant$7(_), histogram) : threshold2;
  };
  return histogram;
}
function max$3(values, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$3(values, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function quickselect(array2, k, left2 = 0, right2 = array2.length - 1, compare = ascending$1) {
  while (right2 > left2) {
    if (right2 - left2 > 600) {
      const n = right2 - left2 + 1;
      const m = k - left2 + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left2, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right2, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array2, k, newLeft, newRight, compare);
    }
    const t = array2[k];
    let i = left2;
    let j = right2;
    swap(array2, left2, k);
    if (compare(array2[right2], t) > 0) swap(array2, left2, right2);
    while (i < j) {
      swap(array2, i, j), ++i, --j;
      while (compare(array2[i], t) < 0) ++i;
      while (compare(array2[j], t) > 0) --j;
    }
    if (compare(array2[left2], t) === 0) swap(array2, left2, j);
    else ++j, swap(array2, j, right2);
    if (j <= k) left2 = j + 1;
    if (k <= j) right2 = j - 1;
  }
  return array2;
}
function swap(array2, i, j) {
  const t = array2[i];
  array2[i] = array2[j];
  array2[j] = t;
}
function quantile$1(values, p, valueof) {
  values = Float64Array.from(numbers(values, valueof));
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return min$3(values);
  if (p >= 1) return max$3(values);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max$3(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$3(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = number$3) {
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}
function freedmanDiaconis(values, min2, max2) {
  return Math.ceil((max2 - min2) / (2 * (quantile$1(values, 0.75) - quantile$1(values, 0.25)) * Math.pow(count(values), -1 / 3)));
}
function scott(values, min2, max2) {
  return Math.ceil((max2 - min2) / (3.5 * deviation(values) * Math.pow(count(values), -1 / 3)));
}
function maxIndex(values, valueof) {
  let max2;
  let maxIndex2 = -1;
  let index2 = -1;
  if (valueof === void 0) {
    for (const value of values) {
      ++index2;
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value, maxIndex2 = index2;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value, maxIndex2 = index2;
      }
    }
  }
  return maxIndex2;
}
function mean(values, valueof) {
  let count2 = 0;
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count2, sum2 += value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (value = +value) >= value) {
        ++count2, sum2 += value;
      }
    }
  }
  if (count2) return sum2 / count2;
}
function median$1(values, valueof) {
  return quantile$1(values, 0.5, valueof);
}
function* flatten$1(arrays) {
  for (const array2 of arrays) {
    yield* array2;
  }
}
function merge$2(arrays) {
  return Array.from(flatten$1(arrays));
}
function minIndex(values, valueof) {
  let min2;
  let minIndex2 = -1;
  let index2 = -1;
  if (valueof === void 0) {
    for (const value of values) {
      ++index2;
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value, minIndex2 = index2;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index2, values)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value, minIndex2 = index2;
      }
    }
  }
  return minIndex2;
}
function pairs(values, pairof = pair) {
  const pairs2 = [];
  let previous;
  let first = false;
  for (const value of values) {
    if (first) pairs2.push(pairof(previous, value));
    previous = value;
    first = true;
  }
  return pairs2;
}
function pair(a, b) {
  return [a, b];
}
function range$4(start2, stop, step) {
  start2 = +start2, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start2, start2 = 0, 1) : n < 3 ? 1 : +step;
  var i = -1, n = Math.max(0, Math.ceil((stop - start2) / step)) | 0, range2 = new Array(n);
  while (++i < n) {
    range2[i] = start2 + i * step;
  }
  return range2;
}
function least(values, compare = ascending$1) {
  let min2;
  let defined = false;
  if (compare.length === 1) {
    let minValue;
    for (const element of values) {
      const value = compare(element);
      if (defined ? ascending$1(value, minValue) < 0 : ascending$1(value, value) === 0) {
        min2 = element;
        minValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined ? compare(value, min2) < 0 : compare(value, value) === 0) {
        min2 = value;
        defined = true;
      }
    }
  }
  return min2;
}
function leastIndex(values, compare = ascending$1) {
  if (compare.length === 1) return minIndex(values, compare);
  let minValue;
  let min2 = -1;
  let index2 = -1;
  for (const value of values) {
    ++index2;
    if (min2 < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
      minValue = value;
      min2 = index2;
    }
  }
  return min2;
}
function greatest(values, compare = ascending$1) {
  let max2;
  let defined = false;
  if (compare.length === 1) {
    let maxValue;
    for (const element of values) {
      const value = compare(element);
      if (defined ? ascending$1(value, maxValue) > 0 : ascending$1(value, value) === 0) {
        max2 = element;
        maxValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined ? compare(value, max2) > 0 : compare(value, value) === 0) {
        max2 = value;
        defined = true;
      }
    }
  }
  return max2;
}
function greatestIndex(values, compare = ascending$1) {
  if (compare.length === 1) return maxIndex(values, compare);
  let maxValue;
  let max2 = -1;
  let index2 = -1;
  for (const value of values) {
    ++index2;
    if (max2 < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
      maxValue = value;
      max2 = index2;
    }
  }
  return max2;
}
function scan(values, compare) {
  const index2 = leastIndex(values, compare);
  return index2 < 0 ? void 0 : index2;
}
const shuffle$1 = shuffler(Math.random);
function shuffler(random) {
  return function shuffle2(array2, i0 = 0, i1 = array2.length) {
    let m = i1 - (i0 = +i0);
    while (m) {
      const i = random() * m-- | 0, t = array2[m + i0];
      array2[m + i0] = array2[i + i0];
      array2[i + i0] = t;
    }
    return array2;
  };
}
function sum$2(values, valueof) {
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values) {
      if (value = +value) {
        sum2 += value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index2, values)) {
        sum2 += value;
      }
    }
  }
  return sum2;
}
function transpose(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min$3(matrix, length$1), transpose2 = new Array(m); ++i < m; ) {
    for (var j = -1, n, row = transpose2[i] = new Array(n); ++j < n; ) {
      row[j] = matrix[j][i];
    }
  }
  return transpose2;
}
function length$1(d) {
  return d.length;
}
function zip() {
  return transpose(arguments);
}
function every(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index2 = -1;
  for (const value of values) {
    if (!test(value, ++index2, values)) {
      return false;
    }
  }
  return true;
}
function some$1(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index2 = -1;
  for (const value of values) {
    if (test(value, ++index2, values)) {
      return true;
    }
  }
  return false;
}
function filter$1(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  const array2 = [];
  let index2 = -1;
  for (const value of values) {
    if (test(value, ++index2, values)) {
      array2.push(value);
    }
  }
  return array2;
}
function map$6(values, mapper) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
  return Array.from(values, (value, index2) => mapper(value, index2, values));
}
function reduce$1(values, reducer2, value) {
  if (typeof reducer2 !== "function") throw new TypeError("reducer is not a function");
  const iterator = values[Symbol.iterator]();
  let done, next, index2 = -1;
  if (arguments.length < 3) {
    ({
      done,
      value
    } = iterator.next());
    if (done) return;
    ++index2;
  }
  while ({
    done,
    value: next
  } = iterator.next(), !done) {
    value = reducer2(value, next, ++index2, values);
  }
  return value;
}
function reverse(values) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  return Array.from(values).reverse();
}
function difference(values, ...others) {
  values = new Set(values);
  for (const other of others) {
    for (const value of other) {
      values.delete(value);
    }
  }
  return values;
}
function disjoint(values, other) {
  const iterator = other[Symbol.iterator](), set2 = /* @__PURE__ */ new Set();
  for (const v of values) {
    if (set2.has(v)) return false;
    let value, done;
    while ({
      value,
      done
    } = iterator.next()) {
      if (done) break;
      if (Object.is(v, value)) return false;
      set2.add(value);
    }
  }
  return true;
}
function set$6(values) {
  return values instanceof Set ? values : new Set(values);
}
function intersection(values, ...others) {
  values = new Set(values);
  others = others.map(set$6);
  out: for (const value of values) {
    for (const other of others) {
      if (!other.has(value)) {
        values.delete(value);
        continue out;
      }
    }
  }
  return values;
}
function superset(values, other) {
  const iterator = values[Symbol.iterator](), set2 = /* @__PURE__ */ new Set();
  for (const o of other) {
    if (set2.has(o)) continue;
    let value, done;
    while ({
      value,
      done
    } = iterator.next()) {
      if (done) return false;
      set2.add(value);
      if (Object.is(o, value)) break;
    }
  }
  return true;
}
function subset$1(values, other) {
  return superset(other, values);
}
function union(...others) {
  const set2 = /* @__PURE__ */ new Set();
  for (const other of others) {
    for (const o of other) {
      set2.add(o);
    }
  }
  return set2;
}
const d3Array = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Adder,
  InternMap,
  InternSet,
  ascending: ascending$1,
  bin,
  bisect: bisectRight,
  bisectCenter,
  bisectLeft,
  bisectRight,
  bisector,
  count,
  cross: cross$2,
  cumsum: cumsum$1,
  descending,
  deviation,
  difference,
  disjoint,
  every,
  extent: extent$1,
  fcumsum,
  filter: filter$1,
  fsum,
  greatest,
  greatestIndex,
  group,
  groupSort,
  groups,
  histogram: bin,
  index: index$1,
  indexes,
  intersection,
  least,
  leastIndex,
  map: map$6,
  max: max$3,
  maxIndex,
  mean,
  median: median$1,
  merge: merge$2,
  min: min$3,
  minIndex,
  nice: nice$1,
  pairs,
  permute,
  quantile: quantile$1,
  quantileSorted,
  quickselect,
  range: range$4,
  reduce: reduce$1,
  reverse,
  rollup,
  rollups,
  scan,
  shuffle: shuffle$1,
  shuffler,
  some: some$1,
  sort: sort$2,
  subset: subset$1,
  sum: sum$2,
  superset,
  thresholdFreedmanDiaconis: freedmanDiaconis,
  thresholdScott: scott,
  thresholdSturges: sturges,
  tickIncrement,
  tickStep,
  ticks,
  transpose,
  union,
  variance,
  zip
}, Symbol.toStringTag, { value: "Module" }));
function initRange(domain2, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain2);
      break;
    default:
      this.range(range2).domain(domain2);
      break;
  }
  return this;
}
function initInterpolator(domain2, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain2 === "function") this.interpolator(domain2);
      else this.range(domain2);
      break;
    }
    default: {
      this.domain(domain2);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = /* @__PURE__ */ Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain2 = [], range2 = [], unknown = implicit;
  function scale(d) {
    let i = index2.get(d);
    if (i === void 0) {
      if (unknown !== implicit) return unknown;
      index2.set(d, i = domain2.push(d) - 1);
    }
    return range2[i % range2.length];
  }
  scale.domain = function(_) {
    if (!arguments.length) return domain2.slice();
    domain2 = [], index2 = new InternMap();
    for (const value of _) {
      if (index2.has(value)) continue;
      index2.set(value, domain2.push(value) - 1);
    }
    return scale;
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), scale) : range2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return ordinal(domain2, range2).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain2 = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n = domain2().length, reverse2 = r1 < r0, start2 = reverse2 ? r1 : r0, stop = reverse2 ? r0 : r1;
    step = (stop - start2) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round2) step = Math.floor(step);
    start2 += (stop - start2 - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round2) start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values = range$4(n).map(function(i) {
      return start2 + step * i;
    });
    return ordinalRange(reverse2 ? values.reverse() : values);
  }
  scale.domain = function(_) {
    return arguments.length ? (domain2(_), rescale()) : domain2();
  };
  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step;
  };
  scale.round = function(_) {
    return arguments.length ? (round2 = !!_, rescale()) : round2;
  };
  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale.copy = function() {
    return band(domain2(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale) {
  var copy2 = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function() {
    return pointish(copy2());
  };
  return scale;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m = reHex.exec(format2)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) : l === 3 ? new Rgb(m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, (m & 15) << 4 | m & 15, 1) : l === 8 ? rgba(m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, (m & 255) / 255) : l === 4 ? rgba(m >> 12 & 15 | m >> 8 & 240, m >> 8 & 15 | m >> 4 & 240, m >> 4 & 15 | m & 240, ((m & 15) << 4 | m & 15) / 255) : null) : (m = reRgbInteger.exec(format2)) ? new Rgb(m[1], m[2], m[3], 1) : (m = reRgbPercent.exec(format2)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) : (m = reRgbaInteger.exec(format2)) ? rgba(m[1], m[2], m[3], m[4]) : (m = reRgbaPercent.exec(format2)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) : (m = reHslPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) : (m = reHslaPercent.exec(format2)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r2, g, b, a) {
  if (a <= 0) r2 = g = b = NaN;
  return new Rgb(r2, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r2, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r2, g, b, opacity) {
  this.r = +r2;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
  var a = this.opacity;
  a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r2 = o.r / 255, g = o.g / 255, b = o.b / 255, min2 = Math.min(r2, g, b), max2 = Math.max(r2, g, b), h = NaN, s = max2 - min2, l = (max2 + min2) / 2;
  if (s) {
    if (r2 === max2) h = (g - b) / s + (g < b) * 6;
    else if (g === max2) h = (b - r2) / s + 2;
    else h = (r2 - g) / s + 4;
    s /= l < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
const radians$1 = Math.PI / 180;
const degrees$2 = 180 / Math.PI;
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r2 = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r2 + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r2 === g && g === b) x = z = y;
  else {
    x = xyz2lab((0.4360747 * r2 + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r2 + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}
define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.033454 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }
}));
function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
}
function lab2xyz(t) {
  return t > t1$1 ? t * t * t : t2 * (t - t0$1);
}
function lrgb2rgb(x) {
  return 255 * (x <= 31308e-7 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * degrees$2;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}
function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * radians$1;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r2 = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r2 - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh2 = Math.cos(h), sinh2 = Math.sin(h);
    return new Rgb(255 * (l + a * (A * cosh2 + B * sinh2)), 255 * (l + a * (C * cosh2 + D * sinh2)), 255 * (l + a * (E * cosh2)), this.opacity);
  }
}));
const d3Color = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color,
  cubehelix,
  gray,
  hcl,
  hsl,
  lab,
  lch,
  rgb
}, Symbol.toStringTag, { value: "Module" }));
const constant$6 = (x) => () => x;
function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}
function gamma$1(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$6(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$6(isNaN(a) ? b : a);
}
const interpolateRgb = (function rgbGamma(y) {
  var color2 = gamma$1(y);
  function rgb$1(start2, end2) {
    var r2 = color2((start2 = rgb(start2)).r, (end2 = rgb(end2)).r), g = color2(start2.g, end2.g), b = color2(start2.b, end2.b), opacity = nogamma(start2.opacity, end2.opacity);
    return function(t) {
      start2.r = r2(t);
      start2.g = g(t);
      start2.b = b(t);
      start2.opacity = opacity(t);
      return start2 + "";
    };
  }
  rgb$1.gamma = rgbGamma;
  return rgb$1;
})(1);
function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
function genericArray(a, b) {
  var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
  for (i = 0; i < na; ++i) x[i] = interpolate$3(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}
function date$1(a, b) {
  var d = /* @__PURE__ */ new Date();
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}
function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}
function object$1(a, b) {
  var i = {}, c = {}, k;
  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate$3(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q2 = [];
  a = a + "", b = b + "";
  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs;
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i]) s[i] += bm;
      else s[++i] = bm;
    } else {
      s[++i] = null;
      q2.push({
        i,
        x: interpolateNumber(am, bm)
      });
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs;
    else s[++i] = bs;
  }
  return s.length < 2 ? q2[0] ? one(q2[0].x) : zero(b) : (b = q2.length, function(t) {
    for (var i2 = 0, o; i2 < b; ++i2) s[(o = q2[i2]).i] = o.x(t);
    return s.join("");
  });
}
function interpolate$3(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$6(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color(b)) ? (b = c, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1 : interpolateNumber)(a, b);
}
function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}
var degrees$1 = 180 / Math.PI;
var identity$9 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose(a, b, c, d, e, f2) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f2,
    rotate: Math.atan2(b, a) * degrees$1,
    skewX: Math.atan(skewX) * degrees$1,
    scaleX,
    scaleY
  };
}
var svgNode;
function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? identity$9 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
  if (value == null) return identity$9;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$9;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}
function interpolateTransform(parse2, pxComma, pxParen, degParen) {
  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q2.push({
        i: i - 4,
        x: interpolateNumber(xa, xb)
      }, {
        i: i - 2,
        x: interpolateNumber(ya, yb)
      });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a, b, s, q2) {
    if (a !== b) {
      if (a - b > 180) b += 360;
      else if (b - a > 180) a += 360;
      q2.push({
        i: s.push(pop(s) + "rotate(", null, degParen) - 2,
        x: interpolateNumber(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }
  function skewX(a, b, s, q2) {
    if (a !== b) {
      q2.push({
        i: s.push(pop(s) + "skewX(", null, degParen) - 2,
        x: interpolateNumber(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q2.push({
        i: i - 4,
        x: interpolateNumber(xa, xb)
      }, {
        i: i - 2,
        x: interpolateNumber(ya, yb)
      });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a, b) {
    var s = [], q2 = [];
    a = parse2(a), b = parse2(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q2);
    rotate(a.rotate, b.rotate, s, q2);
    skewX(a.skewX, b.skewX, s, q2);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q2);
    a = b = null;
    return function(t) {
      var i = -1, n = q2.length, o;
      while (++i < n) s[(o = q2[i]).i] = o.x(t);
      return s.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
var epsilon2$1 = 1e-12;
function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
const interpolateZoom = (function zoomRho(rho2, rho22, rho4) {
  function zoom2(p02, p1) {
    var ux0 = p02[0], uy0 = p02[1], w0 = p02[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < epsilon2$1) {
      S = Math.log(w1 / w0) / rho2;
      i = function(t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho2 * t * S)];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho22 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho22 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho2;
      i = function(t) {
        var s = t * S, coshr0 = cosh(r0), u = w0 / (rho22 * d1) * (coshr0 * tanh(rho2 * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho2 * s + r0)];
      };
    }
    i.duration = S * 1e3 * rho2 / Math.SQRT2;
    return i;
  }
  zoom2.rho = function(_) {
    var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
    return zoomRho(_1, _2, _4);
  };
  return zoom2;
})(Math.SQRT2, 2, 4);
function piecewise(interpolate2, values) {
  if (values === void 0) values = interpolate2, interpolate2 = interpolate$3;
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate2(v, v = values[++i]);
  return function(t) {
    var i2 = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i2](t - i2);
  };
}
function constants(x) {
  return function() {
    return x;
  };
}
function number$2(x) {
  return +x;
}
var unit = [0, 1];
function identity$8(x) {
  return x;
}
function normalize(a, b) {
  return (b -= a = +a) ? function(x) {
    return (x - a) / b;
  } : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) {
    return Math.max(a, Math.min(b, x));
  };
}
function bimap(domain2, range2, interpolate2) {
  var d0 = domain2[0], d1 = domain2[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x) {
    return r0(d0(x));
  };
}
function polymap(domain2, range2, interpolate2) {
  var j = Math.min(domain2.length, range2.length) - 1, d = new Array(j), r2 = new Array(j), i = -1;
  if (domain2[j] < domain2[0]) {
    domain2 = domain2.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize(domain2[i], domain2[i + 1]);
    r2[i] = interpolate2(range2[i], range2[i + 1]);
  }
  return function(x) {
    var i2 = bisectRight(domain2, x, 1, j) - 1;
    return r2[i2](d[i2](x));
  };
}
function copy$3(source, target2) {
  return target2.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$3() {
  var domain2 = unit, range2 = unit, interpolate2 = interpolate$3, transform2, untransform, unknown, clamp2 = identity$8, piecewise2, output, input;
  function rescale() {
    var n = Math.min(domain2.length, range2.length);
    if (clamp2 !== identity$8) clamp2 = clamper(domain2[0], domain2[n - 1]);
    piecewise2 = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise2(domain2.map(transform2), range2, interpolate2)))(transform2(clamp2(x)));
  }
  scale.invert = function(y) {
    return clamp2(untransform((input || (input = piecewise2(range2, domain2.map(transform2), interpolateNumber)))(y)));
  };
  scale.domain = function(_) {
    return arguments.length ? (domain2 = Array.from(_, number$2), rescale()) : domain2.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_) {
    return range2 = Array.from(_), interpolate2 = interpolateRound, rescale();
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp2 = _ ? true : identity$8, rescale()) : clamp2 !== identity$8;
  };
  scale.interpolate = function(_) {
    return arguments.length ? (interpolate2 = _, rescale()) : interpolate2;
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t, u) {
    transform2 = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer$3()(identity$8, identity$8);
}
function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
  var i, coefficient = x.slice(0, i);
  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}
function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length, t = [], j = 0, g = grouping[0], length2 = 0;
    while (i > 0 && g > 0) {
      if (length2 + g + 1 > width) g = Math.max(1, width - length2);
      t.push(value.substring(i -= g, i + g));
      if ((length2 += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
var prefixExponent;
function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0], exponent2 = d[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
}
function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0], exponent2 = d[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
const formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};
function identity$7(x) {
  return x;
}
var map$5 = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group2 = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$7 : formatGroup(map$5.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$7 : formatNumerals(map$5.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus2 = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma2 = specifier.comma, precision = specifier.precision, trim = specifier.trim, type2 = specifier.type;
    if (type2 === "n") comma2 = true, type2 = "g";
    else if (!formatTypes[type2]) precision === void 0 && (precision = 12), trim = true, type2 = "g";
    if (zero2 || fill === "0" && align === "=") zero2 = true, fill = "0", align = "=";
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type2) ? "0" + type2.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type2) ? percent : "";
    var formatType = formatTypes[type2], maybeSuffix = /[defgprs%]/.test(type2);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type2) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix, i, n, c;
      if (type2 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus2 : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type2 === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma2 && !zero2) value = group2(value, Infinity);
      var length2 = valuePrefix.length + value.length + valueSuffix.length, padding = length2 < width ? new Array(width - length2 + 1).join(fill) : "";
      if (comma2 && zero2) value = group2(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length2 = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length2);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix2 = prefixes[8 + e / 3];
    return function(value2) {
      return f2(k * value2) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale$1;
var format$1;
var formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format$1 = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
const d3Format = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FormatSpecifier,
  get format() {
    return format$1;
  },
  formatDefaultLocale: defaultLocale$1,
  formatLocale: formatLocale$1,
  get formatPrefix() {
    return formatPrefix;
  },
  formatSpecifier,
  precisionFixed,
  precisionPrefix,
  precisionRound
}, Symbol.toStringTag, { value: "Module" }));
function tickFormat(start2, stop, count2, specifier) {
  var step = tickStep(start2, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start2), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start2), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}
function linearish(scale) {
  var domain2 = scale.domain;
  scale.ticks = function(count2) {
    var d = domain2();
    return ticks(d[0], d[d.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d = domain2();
    return tickFormat(d[0], d[d.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null) count2 = 10;
    var d = domain2();
    var i0 = 0;
    var i1 = d.length - 1;
    var start2 = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start2) {
      step = start2, start2 = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start2, stop, count2);
      if (step === prestep) {
        d[i0] = start2;
        d[i1] = stop;
        return domain2(d);
      } else if (step > 0) {
        start2 = Math.floor(start2 / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start2 = Math.ceil(start2 * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy$3(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function identity$6(domain2) {
  var unknown;
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : x;
  }
  scale.invert = scale;
  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain2 = Array.from(_, number$2), scale) : domain2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return identity$6(domain2).unknown(unknown);
  };
  domain2 = arguments.length ? Array.from(domain2, number$2) : [0, 1];
  return linearish(scale);
}
function nice(domain2, interval2) {
  domain2 = domain2.slice();
  var i0 = 0, i1 = domain2.length - 1, x02 = domain2[i0], x12 = domain2[i1], t;
  if (x12 < x02) {
    t = i0, i0 = i1, i1 = t;
    t = x02, x02 = x12, x12 = t;
  }
  domain2[i0] = interval2.floor(x02);
  domain2[i1] = interval2.ceil(x12);
  return domain2;
}
function transformLog(x) {
  return Math.log(x);
}
function transformExp(x) {
  return Math.exp(x);
}
function transformLogn(x) {
  return -Math.log(-x);
}
function transformExpn(x) {
  return -Math.exp(-x);
}
function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : (x) => Math.pow(base, x);
}
function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x) => Math.log(x) / base);
}
function reflect(f2) {
  return (x, k) => -f2(-x, k);
}
function loggish(transform2) {
  const scale = transform2(transformLog, transformExp);
  const domain2 = scale.domain;
  let base = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain2()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform2(transformLogn, transformExpn);
    } else {
      transform2(transformLog, transformExp);
    }
    return scale;
  }
  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };
  scale.domain = function(_) {
    return arguments.length ? (domain2(_), rescale()) : domain2();
  };
  scale.ticks = (count2) => {
    const d = domain2();
    let u = d[0];
    let v = d[d.length - 1];
    const r2 = v < u;
    if (r2) [u, v] = [v, u];
    let i = logs(u);
    let j = logs(v);
    let k;
    let t;
    const n = count2 == null ? 10 : +count2;
    let z = [];
    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1; k < base; ++k) {
          t = i < 0 ? k / pows(-i) : k * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      else for (; i <= j; ++i) {
        for (k = base - 1; k >= 1; --k) {
          t = i > 0 ? k / pows(-i) : k * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }
    return r2 ? z.reverse() : z;
  };
  scale.tickFormat = (count2, specifier) => {
    if (count2 == null) count2 = 10;
    if (specifier == null) specifier = base === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
      specifier = format$1(specifier);
    }
    if (count2 === Infinity) return specifier;
    const k = Math.max(1, base * count2 / scale.ticks().length);
    return (d) => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };
  scale.nice = () => {
    return domain2(nice(domain2(), {
      floor: (x) => pows(Math.floor(logs(x))),
      ceil: (x) => pows(Math.ceil(logs(x)))
    }));
  };
  return scale;
}
function log$2() {
  const scale = loggish(transformer$3()).domain([1, 10]);
  scale.copy = () => copy$3(scale, log$2()).base(scale.base());
  initRange.apply(scale, arguments);
  return scale;
}
function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}
function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}
function symlogish(transform2) {
  var c = 1, scale = transform2(transformSymlog(c), transformSymexp(c));
  scale.constant = function(_) {
    return arguments.length ? transform2(transformSymlog(c = +_), transformSymexp(c)) : c;
  };
  return linearish(scale);
}
function symlog() {
  var scale = symlogish(transformer$3());
  scale.copy = function() {
    return copy$3(scale, symlog()).constant(scale.constant());
  };
  return initRange.apply(scale, arguments);
}
function transformPow(exponent2) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent2) : Math.pow(x, exponent2);
  };
}
function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}
function powish(transform2) {
  var scale = transform2(identity$8, identity$8), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform2(identity$8, identity$8) : exponent2 === 0.5 ? transform2(transformSqrt, transformSquare) : transform2(transformPow(exponent2), transformPow(1 / exponent2));
  }
  scale.exponent = function(_) {
    return arguments.length ? (exponent2 = +_, rescale()) : exponent2;
  };
  return linearish(scale);
}
function pow$2() {
  var scale = powish(transformer$3());
  scale.copy = function() {
    return copy$3(scale, pow$2()).exponent(scale.exponent());
  };
  initRange.apply(scale, arguments);
  return scale;
}
function sqrt$1() {
  return pow$2.apply(null, arguments).exponent(0.5);
}
function square$1(x) {
  return Math.sign(x) * x * x;
}
function unsquare(x) {
  return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
  var squared = continuous(), range2 = [0, 1], round2 = false, unknown;
  function scale(x) {
    var y = unsquare(squared(x));
    return isNaN(y) ? unknown : round2 ? Math.round(y) : y;
  }
  scale.invert = function(y) {
    return squared.invert(square$1(y));
  };
  scale.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };
  scale.range = function(_) {
    return arguments.length ? (squared.range((range2 = Array.from(_, number$2)).map(square$1)), scale) : range2.slice();
  };
  scale.rangeRound = function(_) {
    return scale.range(_).round(true);
  };
  scale.round = function(_) {
    return arguments.length ? (round2 = !!_, scale) : round2;
  };
  scale.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return radial(squared.domain(), range2).round(round2).clamp(squared.clamp()).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function quantile() {
  var domain2 = [], range2 = [], thresholds = [], unknown;
  function rescale() {
    var i = 0, n = Math.max(1, range2.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantileSorted(domain2, i / n);
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : range2[bisectRight(thresholds, x)];
  }
  scale.invertExtent = function(y) {
    var i = range2.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain2[0], i < thresholds.length ? thresholds[i] : domain2[domain2.length - 1]];
  };
  scale.domain = function(_) {
    if (!arguments.length) return domain2.slice();
    domain2 = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain2.push(d);
    domain2.sort(ascending$1);
    return rescale();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), rescale()) : range2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.quantiles = function() {
    return thresholds.slice();
  };
  scale.copy = function() {
    return quantile().domain(domain2).range(range2).unknown(unknown);
  };
  return initRange.apply(scale, arguments);
}
function quantize() {
  var x02 = 0, x12 = 1, n = 1, domain2 = [0.5], range2 = [0, 1], unknown;
  function scale(x) {
    return x != null && x <= x ? range2[bisectRight(domain2, x, 0, n)] : unknown;
  }
  function rescale() {
    var i = -1;
    domain2 = new Array(n);
    while (++i < n) domain2[i] = ((i + 1) * x12 - (i - n) * x02) / (n + 1);
    return scale;
  }
  scale.domain = function(_) {
    return arguments.length ? ([x02, x12] = _, x02 = +x02, x12 = +x12, rescale()) : [x02, x12];
  };
  scale.range = function(_) {
    return arguments.length ? (n = (range2 = Array.from(_)).length - 1, rescale()) : range2.slice();
  };
  scale.invertExtent = function(y) {
    var i = range2.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x02, domain2[0]] : i >= n ? [domain2[n - 1], x12] : [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };
  scale.thresholds = function() {
    return domain2.slice();
  };
  scale.copy = function() {
    return quantize().domain([x02, x12]).range(range2).unknown(unknown);
  };
  return initRange.apply(linearish(scale), arguments);
}
function threshold() {
  var domain2 = [0.5], range2 = [0, 1], unknown, n = 1;
  function scale(x) {
    return x != null && x <= x ? range2[bisectRight(domain2, x, 0, n)] : unknown;
  }
  scale.domain = function(_) {
    return arguments.length ? (domain2 = Array.from(_), n = Math.min(domain2.length, range2.length - 1), scale) : domain2.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), n = Math.min(domain2.length, range2.length - 1), scale) : range2.slice();
  };
  scale.invertExtent = function(y) {
    var i = range2.indexOf(y);
    return [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function() {
    return threshold().domain(domain2).range(range2).unknown(unknown);
  };
  return initRange.apply(scale, arguments);
}
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(floori, offseti, count2, field) {
  function interval2(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  interval2.floor = (date2) => {
    return floori(date2 = /* @__PURE__ */ new Date(+date2)), date2;
  };
  interval2.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval2.round = (date2) => {
    const d0 = interval2(date2), d1 = interval2.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval2.offset = (date2, step) => {
    return offseti(date2 = /* @__PURE__ */ new Date(+date2), step == null ? 1 : Math.floor(step)), date2;
  };
  interval2.range = (start2, stop, step) => {
    const range2 = [];
    start2 = interval2.ceil(start2);
    step = step == null ? 1 : Math.floor(step);
    if (!(start2 < stop) || !(step > 0)) return range2;
    let previous;
    do
      range2.push(previous = /* @__PURE__ */ new Date(+start2)), offseti(start2, step), floori(start2);
    while (previous < start2 && start2 < stop);
    return range2;
  };
  interval2.filter = (test) => {
    return timeInterval((date2) => {
      if (date2 >= date2) while (floori(date2), !test(date2)) date2.setTime(date2 - 1);
    }, (date2, step) => {
      if (date2 >= date2) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date2, -1), !test(date2)) {
          }
        }
        else while (--step >= 0) {
          while (offseti(date2, 1), !test(date2)) {
          }
        }
      }
    });
  };
  if (count2) {
    interval2.count = (start2, end2) => {
      t0.setTime(+start2), t1.setTime(+end2);
      floori(t0), floori(t1);
      return Math.floor(count2(t0, t1));
    };
    interval2.every = (step) => {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval2 : interval2.filter(field ? (d) => field(d) % step === 0 : (d) => interval2.count(0, d) % step === 0);
    };
  }
  return interval2;
}
const millisecond = timeInterval(() => {
}, (date2, step) => {
  date2.setTime(+date2 + step);
}, (start2, end2) => {
  return end2 - start2;
});
millisecond.every = (k) => {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return timeInterval((date2) => {
    date2.setTime(Math.floor(date2 / k) * k);
  }, (date2, step) => {
    date2.setTime(+date2 + step * k);
  }, (start2, end2) => {
    return (end2 - start2) / k;
  });
};
millisecond.range;
const durationSecond = 1e3;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;
const second = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step) => {
  date2.setTime(+date2 + step * durationSecond);
}, (start2, end2) => {
  return (end2 - start2) / durationSecond;
}, (date2) => {
  return date2.getUTCSeconds();
});
second.range;
const timeMinute = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute;
}, (date2) => {
  return date2.getMinutes();
});
timeMinute.range;
const utcMinute = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationMinute);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute;
}, (date2) => {
  return date2.getUTCMinutes();
});
utcMinute.range;
const timeHour = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start2, end2) => {
  return (end2 - start2) / durationHour;
}, (date2) => {
  return date2.getHours();
});
timeHour.range;
const utcHour = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step) => {
  date2.setTime(+date2 + step * durationHour);
}, (start2, end2) => {
  return (end2 - start2) / durationHour;
}, (date2) => {
  return date2.getUTCHours();
});
utcHour.range;
const timeDay = timeInterval((date2) => date2.setHours(0, 0, 0, 0), (date2, step) => date2.setDate(date2.getDate() + step), (start2, end2) => (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationDay, (date2) => date2.getDate() - 1);
timeDay.range;
const utcDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start2, end2) => {
  return (end2 - start2) / durationDay;
}, (date2) => {
  return date2.getUTCDate() - 1;
});
utcDay.range;
const unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCDate(date2.getUTCDate() + step);
}, (start2, end2) => {
  return (end2 - start2) / durationDay;
}, (date2) => {
  return Math.floor(date2 / durationDay);
});
unixDay.range;
function timeWeekday(i) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setDate(date2.getDate() + step * 7);
  }, (start2, end2) => {
    return (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCDate(date2.getUTCDate() + step * 7);
  }, (start2, end2) => {
    return (end2 - start2) / durationWeek;
  });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((date2) => {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setMonth(date2.getMonth() + step);
}, (start2, end2) => {
  return end2.getMonth() - start2.getMonth() + (end2.getFullYear() - start2.getFullYear()) * 12;
}, (date2) => {
  return date2.getMonth();
});
timeMonth.range;
const utcMonth = timeInterval((date2) => {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCMonth(date2.getUTCMonth() + step);
}, (start2, end2) => {
  return end2.getUTCMonth() - start2.getUTCMonth() + (end2.getUTCFullYear() - start2.getUTCFullYear()) * 12;
}, (date2) => {
  return date2.getUTCMonth();
});
utcMonth.range;
const timeYear = timeInterval((date2) => {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setFullYear(date2.getFullYear() + step);
}, (start2, end2) => {
  return end2.getFullYear() - start2.getFullYear();
}, (date2) => {
  return date2.getFullYear();
});
timeYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date2) => {
    date2.setFullYear(Math.floor(date2.getFullYear() / k) * k);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setFullYear(date2.getFullYear() + step * k);
  });
};
timeYear.range;
const utcYear = timeInterval((date2) => {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step);
}, (start2, end2) => {
  return end2.getUTCFullYear() - start2.getUTCFullYear();
}, (date2) => {
  return date2.getUTCFullYear();
});
utcYear.every = (k) => {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date2) => {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k) * k);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step) => {
    date2.setUTCFullYear(date2.getUTCFullYear() + step * k);
  });
};
utcYear.range;
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [[second, 1, durationSecond], [second, 5, 5 * durationSecond], [second, 15, 15 * durationSecond], [second, 30, 30 * durationSecond], [minute, 1, durationMinute], [minute, 5, 5 * durationMinute], [minute, 15, 15 * durationMinute], [minute, 30, 30 * durationMinute], [hour, 1, durationHour], [hour, 3, 3 * durationHour], [hour, 6, 6 * durationHour], [hour, 12, 12 * durationHour], [day, 1, durationDay], [day, 2, 2 * durationDay], [week, 1, durationWeek], [month, 1, durationMonth], [month, 3, 3 * durationMonth], [year, 1, durationYear]];
  function ticks2(start2, stop, count2) {
    const reverse2 = stop < start2;
    if (reverse2) [start2, stop] = [stop, start2];
    const interval2 = count2 && typeof count2.range === "function" ? count2 : tickInterval(start2, stop, count2);
    const ticks3 = interval2 ? interval2.range(start2, +stop + 1) : [];
    return reverse2 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start2, stop, count2) {
    const target2 = Math.abs(stop - start2) / count2;
    const i = bisector(([, , step2]) => step2).right(tickIntervals, target2);
    if (i === tickIntervals.length) return year.every(tickStep(start2 / durationYear, stop / durationYear, count2));
    if (i === 0) return millisecond.every(Math.max(tickStep(start2, stop, count2), 1));
    const [t, step] = tickIntervals[target2 / tickIntervals[i - 1][2] < tickIntervals[i][2] / target2 ? i - 1 : i];
    return t.every(step);
  }
  return [ticks2, tickInterval];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date2.setFullYear(d.y);
    return date2;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date2 = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date2.setUTCFullYear(d.y);
    return date2;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
  return {
    y,
    m,
    d,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear$2,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string = [], i = -1, j = 0, n = specifier.length, c, pad3, format2;
      if (!(date2 instanceof Date)) date2 = /* @__PURE__ */ new Date(+date2);
      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad3 = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad3 = c === "e" ? " " : "0";
          if (format2 = formats2[c]) c = format2(date2, pad3);
          string.push(c);
          j = i + 1;
        }
      }
      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, void 0, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
      if (i != string.length) return null;
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1e3 + ("L" in d ? d.L : 0));
      if (Z && !("Z" in d)) d.Z = 0;
      if ("p" in d) d.H = d.H % 12 + d.p * 12;
      if (d.m === void 0) d.m = "q" in d ? d.q : 0;
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }
      return localDate(d);
    };
  }
  function parseSpecifier(d, specifier, string, j) {
    var i = 0, n = specifier.length, m = string.length, c, parse2;
    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse2 = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse2 || (j = parse2(d, string, j)) < 0) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }
  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }
  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }
  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }
  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }
  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }
  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }
  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }
  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }
  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }
  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }
  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }
  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }
  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }
  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() {
        return specifier;
      };
      return p;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() {
        return specifier;
      };
      return p;
    }
  };
}
var pads = {
  "-": "",
  "_": " ",
  "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad$2(value, fill, width) {
  var sign2 = value < 0 ? "-" : "", string = (sign2 ? -value : value) + "", length2 = string.length;
  return sign2 + (length2 < width ? new Array(width - length2 + 1).join(fill) + string : string);
}
function requote(s) {
  return s.replace(requoteRe, "\\$&");
}
function formatRe(names2) {
  return new RegExp("^(?:" + names2.map(requote).join("|") + ")", "i");
}
function formatLookup(names2) {
  return new Map(names2.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1e3), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
  return pad$2(d.getDate(), p, 2);
}
function formatHour24(d, p) {
  return pad$2(d.getHours(), p, 2);
}
function formatHour12(d, p) {
  return pad$2(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
  return pad$2(1 + timeDay.count(timeYear(d), d), p, 3);
}
function formatMilliseconds(d, p) {
  return pad$2(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
  return pad$2(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
  return pad$2(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
  return pad$2(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
  return pad$2(timeSunday.count(timeYear(d) - 1, d), p, 2);
}
function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad$2(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
  return d.getDay();
}
function formatWeekNumberMonday(d, p) {
  return pad$2(timeMonday.count(timeYear(d) - 1, d), p, 2);
}
function formatYear$2(d, p) {
  return pad$2(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
  d = dISO(d);
  return pad$2(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
  return pad$2(d.getFullYear() % 1e4, p, 4);
}
function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
  return pad$2(d.getFullYear() % 1e4, p, 4);
}
function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad$2(z / 60 | 0, "0", 2) + pad$2(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
  return pad$2(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
  return pad$2(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
  return pad$2(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
  return pad$2(1 + utcDay.count(utcYear(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
  return pad$2(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
  return pad$2(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
  return pad$2(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
  return pad$2(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
  return pad$2(utcSunday.count(utcYear(d) - 1, d), p, 2);
}
function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad$2(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
  return pad$2(utcMonday.count(utcYear(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
  return pad$2(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
  return pad$2(d.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d) {
  return +d;
}
function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1e3);
}
var locale;
var timeFormat;
var utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  locale.parse;
  utcFormat = locale.utcFormat;
  locale.utcParse;
  return locale;
}
function date(t) {
  return new Date(t);
}
function number$1(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale = continuous(), invert = scale.invert, domain2 = scale.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale.invert = function(y) {
    return new Date(invert(y));
  };
  scale.domain = function(_) {
    return arguments.length ? domain2(Array.from(_, number$1)) : domain2().map(date);
  };
  scale.ticks = function(interval2) {
    var d = domain2();
    return ticks2(d[0], d[d.length - 1], interval2 == null ? 10 : interval2);
  };
  scale.tickFormat = function(count2, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale.nice = function(interval2) {
    var d = domain2();
    if (!interval2 || typeof interval2.range !== "function") interval2 = tickInterval(d[0], d[d.length - 1], interval2 == null ? 10 : interval2);
    return interval2 ? domain2(nice(d, interval2)) : scale;
  };
  scale.copy = function() {
    return copy$3(scale, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  };
  return scale;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$2() {
  var x02 = 0, x12 = 1, t02, t12, k10, transform2, interpolator = identity$8, clamp2 = false, unknown;
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform2(x) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x)) : x));
  }
  scale.domain = function(_) {
    return arguments.length ? ([x02, x12] = _, t02 = transform2(x02 = +x02), t12 = transform2(x12 = +x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x02, x12];
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale) : clamp2;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate$3);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t) {
    transform2 = t, t02 = t(x02), t12 = t(x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy$2(source, target2) {
  return target2.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer$2()(identity$8));
  scale.copy = function() {
    return copy$2(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
  var scale = loggish(transformer$2()).domain([1, 10]);
  scale.copy = function() {
    return copy$2(scale, sequentialLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
  var scale = symlogish(transformer$2());
  scale.copy = function() {
    return copy$2(scale, sequentialSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
  var scale = powish(transformer$2());
  scale.copy = function() {
    return copy$2(scale, sequentialPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var domain2 = [], interpolator = identity$8;
  function scale(x) {
    if (x != null && !isNaN(x = +x)) return interpolator((bisectRight(domain2, x, 1) - 1) / (domain2.length - 1));
  }
  scale.domain = function(_) {
    if (!arguments.length) return domain2.slice();
    domain2 = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain2.push(d);
    domain2.sort(ascending$1);
    return scale;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  scale.range = function() {
    return domain2.map((d, i) => interpolator(i / (domain2.length - 1)));
  };
  scale.quantiles = function(n) {
    return Array.from({
      length: n + 1
    }, (_, i) => quantile$1(domain2, i / n));
  };
  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain2);
  };
  return initInterpolator.apply(scale, arguments);
}
function transformer$1() {
  var x02 = 0, x12 = 0.5, x2 = 1, s = 1, t02, t12, t22, k10, k21, interpolator = identity$8, transform2, clamp2 = false, unknown;
  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform2(x)) - t12) * (s * x < s * t12 ? k10 : k21), interpolator(clamp2 ? Math.max(0, Math.min(1, x)) : x));
  }
  scale.domain = function(_) {
    return arguments.length ? ([x02, x12, x2] = _, t02 = transform2(x02 = +x02), t12 = transform2(x12 = +x12), t22 = transform2(x2 = +x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s = t12 < t02 ? -1 : 1, scale) : [x02, x12, x2];
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale) : clamp2;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate2, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale.range = range2(interpolate$3);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t) {
    transform2 = t, t02 = t(x02), t12 = t(x12), t22 = t(x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s = t12 < t02 ? -1 : 1;
    return scale;
  };
}
function diverging() {
  var scale = linearish(transformer$1()(identity$8));
  scale.copy = function() {
    return copy$2(scale, diverging());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingLog() {
  var scale = loggish(transformer$1()).domain([0.1, 1, 10]);
  scale.copy = function() {
    return copy$2(scale, divergingLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
  var scale = symlogish(transformer$1());
  scale.copy = function() {
    return copy$2(scale, divergingSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingPow() {
  var scale = powish(transformer$1());
  scale.copy = function() {
    return copy$2(scale, divergingPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
const d3Scale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity$6,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log$2,
  scaleOrdinal: ordinal,
  scalePoint: point,
  scalePow: pow$2,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt$1,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
var xhtml = "http://www.w3.org/1999/xhtml";
const namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(name) {
  var prefix2 = name += "", i = prefix2.indexOf(":");
  if (i >= 0 && (prefix2 = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix2) ? {
    space: namespaces[prefix2],
    local: name
  } : name;
}
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri2 = this.namespaceURI;
    return uri2 === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri2, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
function none() {
}
function selector(selector2) {
  return selector2 == null ? none : function() {
    return this.querySelector(selector2);
  };
}
function selection_select(select2) {
  if (typeof select2 !== "function") select2 = selector(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node2, subnode, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2) subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection$2(subgroups, this._parents);
}
function array(x) {
  return typeof x === "object" && "length" in x ? x : Array.from(x);
}
function empty$2() {
  return [];
}
function selectorAll(selector2) {
  return selector2 == null ? empty$2 : function() {
    return this.querySelectorAll(selector2);
  };
}
function arrayAll(select2) {
  return function() {
    var group2 = select2.apply(this, arguments);
    return group2 == null ? [] : array(group2);
  };
}
function selection_selectAll(select2) {
  if (typeof select2 === "function") select2 = arrayAll(select2);
  else select2 = selectorAll(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        subgroups.push(select2.call(node2, node2.__data__, i, group2));
        parents.push(node2);
      }
    }
  }
  return new Selection$2(subgroups, parents);
}
function matcher(selector2) {
  return function() {
    return this.matches(selector2);
  };
}
function childMatcher(selector2) {
  return function(node2) {
    return node2.matches(selector2);
  };
}
var find$1 = Array.prototype.find;
function childFind(match) {
  return function() {
    return find$1.call(this.children, match);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(match) {
  return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
}
var filter = Array.prototype.filter;
function children() {
  return this.children;
}
function childrenFilter(match) {
  return function() {
    return filter.call(this.children, match);
  };
}
function selection_selectChildren(match) {
  return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
}
function selection_filter(match) {
  if (typeof match !== "function") match = matcher(match);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && match.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Selection$2(subgroups, this._parents);
}
function sparse(update) {
  return new Array(update.length);
}
function selection_enter() {
  return new Selection$2(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};
function constant$5(x) {
  return function() {
    return x;
  };
}
function bindIndex(parent, group2, enter, update, exit, data2) {
  var i = 0, node2, groupLength = group2.length, dataLength = data2.length;
  for (; i < dataLength; ++i) {
    if (node2 = group2[i]) {
      node2.__data__ = data2[i];
      update[i] = node2;
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node2 = group2[i]) {
      exit[i] = node2;
    }
  }
}
function bindKey(parent, group2, enter, update, exit, data2, key) {
  var i, node2, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group2.length, dataLength = data2.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node2 = group2[i]) {
      keyValues[i] = keyValue = key.call(node2, node2.__data__, i, group2) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node2;
      } else {
        nodeByKeyValue.set(keyValue, node2);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data2[i], i, data2) + "";
    if (node2 = nodeByKeyValue.get(keyValue)) {
      update[i] = node2;
      node2.__data__ = data2[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node2 = group2[i]) && nodeByKeyValue.get(keyValues[i]) === node2) {
      exit[i] = node2;
    }
  }
}
function datum(node2) {
  return node2.__data__;
}
function selection_data(value, key) {
  if (!arguments.length) return Array.from(this, datum);
  var bind = key ? bindKey : bindIndex, parents = this._parents, groups2 = this._groups;
  if (typeof value !== "function") value = constant$5(value);
  for (var m = groups2.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j], group2 = groups2[j], groupLength = group2.length, data2 = array(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data2.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
    bind(parent, group2, enterGroup, updateGroup, exitGroup, data2, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength) ;
        previous._next = next || null;
      }
    }
  }
  update = new Selection$2(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}
function selection_exit() {
  return new Selection$2(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null) update = onupdate(update);
  if (onexit == null) exit.remove();
  else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}
function selection_merge(selection2) {
  if (!(selection2 instanceof Selection$2)) throw new Error("invalid merge");
  for (var groups0 = this._groups, groups1 = selection2._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection$2(merges, this._parents);
}
function selection_order() {
  for (var groups2 = this._groups, j = -1, m = groups2.length; ++j < m; ) {
    for (var group2 = groups2[j], i = group2.length - 1, next = group2[i], node2; --i >= 0; ) {
      if (node2 = group2[i]) {
        if (next && node2.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node2, next);
        next = node2;
      }
    }
  }
  return this;
}
function selection_sort(compare) {
  if (!compare) compare = ascending;
  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }
  for (var groups2 = this._groups, m = groups2.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, sortgroup = sortgroups[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        sortgroup[i] = node2;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection$2(sortgroups, this._parents).order();
}
function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}
function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var groups2 = this._groups, j = 0, m = groups2.length; j < m; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length; i < n; ++i) {
      var node2 = group2[i];
      if (node2) return node2;
    }
  }
  return null;
}
function selection_size() {
  let size = 0;
  for (const node2 of this) ++size;
  return size;
}
function selection_empty() {
  return !this.node();
}
function selection_each(callback) {
  for (var groups2 = this._groups, j = 0, m = groups2.length; j < m; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length, node2; i < n; ++i) {
      if (node2 = group2[i]) callback.call(node2, node2.__data__, i, group2);
    }
  }
  return this;
}
function attrRemove$2(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS$2(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant$2(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS$2(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction$2(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}
function attrFunctionNS$2(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}
function selection_attr(name, value) {
  var fullname = namespace(name);
  if (arguments.length < 2) {
    var node2 = this.node();
    return fullname.local ? node2.getAttributeNS(fullname.space, fullname.local) : node2.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS$2 : attrRemove$2 : typeof value === "function" ? fullname.local ? attrFunctionNS$2 : attrFunction$2 : fullname.local ? attrConstantNS$2 : attrConstant$2)(fullname, value));
}
function defaultView(node2) {
  return node2.ownerDocument && node2.ownerDocument.defaultView || node2.document && node2 || node2.defaultView;
}
function styleRemove$2(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant$2(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction$2(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}
function selection_style(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove$2 : typeof value === "function" ? styleFunction$2 : styleConstant$2)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node2, name) {
  return node2.style.getPropertyValue(name) || defaultView(node2).getComputedStyle(node2, null).getPropertyValue(name);
}
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}
function selection_property(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}
function classArray(string) {
  return string.trim().split(/^|\s+/);
}
function classList(node2) {
  return node2.classList || new ClassList(node2);
}
function ClassList(node2) {
  this._node = node2;
  this._names = classArray(node2.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node2, names2) {
  var list2 = classList(node2), i = -1, n = names2.length;
  while (++i < n) list2.add(names2[i]);
}
function classedRemove(node2, names2) {
  var list2 = classList(node2), i = -1, n = names2.length;
  while (++i < n) list2.remove(names2[i]);
}
function classedTrue(names2) {
  return function() {
    classedAdd(this, names2);
  };
}
function classedFalse(names2) {
  return function() {
    classedRemove(this, names2);
  };
}
function classedFunction(names2, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names2);
  };
}
function selection_classed(name, value) {
  var names2 = classArray(name + "");
  if (arguments.length < 2) {
    var list2 = classList(this.node()), i = -1, n = names2.length;
    while (++i < n) if (!list2.contains(names2[i])) return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names2, value));
}
function textRemove() {
  this.textContent = "";
}
function textConstant$2(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction$2(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}
function selection_text(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$2 : textConstant$2)(value)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}
function selection_html(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(name) {
  var create2 = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create2.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(name, before) {
  var create2 = typeof name === "function" ? name : creator(name), select2 = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create2.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}
function remove$1() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}
function selection_remove() {
  return this.each(remove$1);
}
function selection_cloneShallow() {
  var clone2 = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone2, this.nextSibling) : clone2;
}
function selection_cloneDeep() {
  var clone2 = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone2, this.nextSibling) : clone2;
}
function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames$2(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {
      type: t,
      name
    };
  });
}
function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}
function onAdd(typename, value, options2) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options2);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options2);
    o = {
      type: typename.type,
      name: typename.name,
      value,
      listener,
      options: options2
    };
    if (!on) this.__on = [o];
    else on.push(o);
  };
}
function selection_on(typename, value, options2) {
  var typenames = parseTypenames$2(typename + ""), i, n = typenames.length, t;
  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }
  on = value ? onAdd : onRemove;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, options2));
  return this;
}
function dispatchEvent(node2, type2, params) {
  var window2 = defaultView(node2), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type2, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params) event.initEvent(type2, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type2, false, false);
  }
  node2.dispatchEvent(event);
}
function dispatchConstant(type2, params) {
  return function() {
    return dispatchEvent(this, type2, params);
  };
}
function dispatchFunction(type2, params) {
  return function() {
    return dispatchEvent(this, type2, params.apply(this, arguments));
  };
}
function selection_dispatch(type2, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type2, params));
}
function* selection_iterator() {
  for (var groups2 = this._groups, j = 0, m = groups2.length; j < m; ++j) {
    for (var group2 = groups2[j], i = 0, n = group2.length, node2; i < n; ++i) {
      if (node2 = group2[i]) yield node2;
    }
  }
}
var root$2 = [null];
function Selection$2(groups2, parents) {
  this._groups = groups2;
  this._parents = parents;
}
function selection() {
  return new Selection$2([[document.documentElement]], root$2);
}
function selection_selection() {
  return this;
}
Selection$2.prototype = selection.prototype = {
  constructor: Selection$2,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select(selector2) {
  return typeof selector2 === "string" ? new Selection$2([[document.querySelector(selector2)]], [document.documentElement]) : new Selection$2([[selector2]], root$2);
}
function create$2(name) {
  return select(creator(name).call(document.documentElement));
}
var nextId = 0;
function local$1() {
  return new Local();
}
function Local() {
  this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node2) {
    var id2 = this._;
    while (!(id2 in node2)) if (!(node2 = node2.parentNode)) return;
    return node2[id2];
  },
  set: function(node2, value) {
    return node2[this._] = value;
  },
  remove: function(node2) {
    return this._ in node2 && delete node2[this._];
  },
  toString: function() {
    return this._;
  }
};
function sourceEvent$3(event) {
  let sourceEvent2;
  while (sourceEvent2 = event.sourceEvent) event = sourceEvent2;
  return event;
}
function pointer(event, node2) {
  event = sourceEvent$3(event);
  if (node2 === void 0) node2 = event.currentTarget;
  if (node2) {
    var svg = node2.ownerSVGElement || node2;
    if (svg.createSVGPoint) {
      var point2 = svg.createSVGPoint();
      point2.x = event.clientX, point2.y = event.clientY;
      point2 = point2.matrixTransform(node2.getScreenCTM().inverse());
      return [point2.x, point2.y];
    }
    if (node2.getBoundingClientRect) {
      var rect2 = node2.getBoundingClientRect();
      return [event.clientX - rect2.left - node2.clientLeft, event.clientY - rect2.top - node2.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}
function pointers(events2, node2) {
  if (events2.target) {
    events2 = sourceEvent$3(events2);
    if (node2 === void 0) node2 = events2.currentTarget;
    events2 = events2.touches || [events2];
  }
  return Array.from(events2, (event) => pointer(event, node2));
}
function selectAll(selector2) {
  return typeof selector2 === "string" ? new Selection$2([document.querySelectorAll(selector2)], [document.documentElement]) : new Selection$2([selector2 == null ? [] : array(selector2)], root$2);
}
const d3Selection = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: create$2,
  creator,
  local: local$1,
  matcher,
  namespace,
  namespaces,
  pointer,
  pointers,
  select,
  selectAll,
  selection,
  selector,
  selectorAll,
  style: styleValue,
  window: defaultView
}, Symbol.toStringTag, { value: "Module" }));
var propTypes$1 = { exports: {} };
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes$1;
function requirePropTypes$1() {
  if (hasRequiredPropTypes$1) return propTypes$1.exports;
  hasRequiredPropTypes$1 = 1;
  {
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes$1.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes$1();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const bc = (() => {
  try {
    return new window.BroadcastChannel("pub-sub-es");
  } catch (e) {
    return {
      postMessage: () => {
      }
    };
  }
})();
const getEventName = (eventName, caseInsensitive) => caseInsensitive ? eventName.toLowerCase() : eventName;
const createSubscribe = (stack, {
  caseInsensitive
} = {}) => (event, handler, times2 = Infinity) => {
  const e = getEventName(event, caseInsensitive);
  if (!stack[e]) {
    stack[e] = [];
    stack.__times__[e] = [];
  }
  stack[e].push(handler);
  stack.__times__[e].push(+times2 || Infinity);
  return {
    event: e,
    handler
  };
};
const createUnsubscribe = (stack, {
  caseInsensitive
} = {}) => (event, handler) => {
  if (typeof event === "object") {
    handler = event.handler;
    event = event.event;
  }
  const e = getEventName(event, caseInsensitive);
  if (!stack[e]) return;
  const id2 = stack[e].indexOf(handler);
  if (id2 === -1 || id2 >= stack[e].length) return;
  stack[e].splice(id2, 1);
  stack.__times__[e].splice(id2, 1);
};
const inform = (listeners, news) => () => {
  listeners.forEach((listener) => listener(news));
};
const createPublish = (stack, {
  isGlobal,
  caseInsensitive,
  async: async2
} = {}) => {
  const unsubscribe = createUnsubscribe(stack);
  return (event, news, options2 = {}) => {
    const e = getEventName(event, caseInsensitive);
    if (!stack[e]) return;
    const listeners = [...stack[e]];
    listeners.forEach((listener, i) => {
      if (--stack.__times__[e][i] < 1) unsubscribe(e, listener);
    });
    const localAsync = options2.async !== void 0 ? options2.async : async2;
    if (localAsync) {
      setTimeout(inform(listeners, news), 0);
    } else {
      inform(listeners, news)();
    }
    if (isGlobal && !options2.isNoGlobalBroadcast) {
      try {
        bc.postMessage({
          event: e,
          news
        });
      } catch (error) {
        if (error instanceof DOMException) {
          console.warn(`Could not broadcast '${e}' globally. Payload is not clonable.`);
        } else {
          throw error;
        }
      }
    }
  };
};
const createClear = (stack) => () => {
  Object.keys(stack).filter((eventName) => eventName[0] !== "_").forEach((eventName) => {
    stack[eventName] = void 0;
    stack.__times__[eventName] = void 0;
    delete stack[eventName];
    delete stack.__times__[eventName];
  });
};
const createEmptyStack = () => ({
  __times__: {}
});
const createPubSub = (options2 = {}) => {
  const async2 = options2.async || false;
  const caseInsensitive = options2.caseInsensitive || false;
  const stack = options2.stack || createEmptyStack();
  if (!stack.__times__) stack.__times__ = {};
  return {
    publish: createPublish(stack, {
      async: async2,
      caseInsensitive
    }),
    subscribe: createSubscribe(stack, {
      caseInsensitive
    }),
    unsubscribe: createUnsubscribe(stack, {
      caseInsensitive
    }),
    clear: createClear(stack),
    stack
  };
};
const globalPubSubStack = createEmptyStack();
const globalPubSub = {
  publish: createPublish(globalPubSubStack, {
    isGlobal: true
  }),
  subscribe: createSubscribe(globalPubSubStack),
  unsubscribe: createUnsubscribe(globalPubSubStack),
  clear: createClear(globalPubSubStack),
  stack: globalPubSubStack
};
bc.onmessage = ({
  data: {
    event,
    news
  }
}) => globalPubSub.publish(event, news, {
  isNoGlobalBroadcast: true
});
function calcGridColWidth(positionParams) {
  const { margin, containerPadding, containerWidth, cols } = positionParams;
  return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
function calcGridItemWHPx(gridUnits, colOrRowSize, marginPx) {
  if (!Number.isFinite(gridUnits)) return gridUnits;
  return Math.round(
    colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx
  );
}
function calcGridItemPosition(positionParams, x, y, w, h, dragPosition, resizePosition) {
  const { margin, containerPadding, rowHeight } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  let width;
  let height;
  let top2;
  let left2;
  if (resizePosition) {
    width = Math.round(resizePosition.width);
    height = Math.round(resizePosition.height);
  } else {
    width = calcGridItemWHPx(w, colWidth, margin[0]);
    height = calcGridItemWHPx(h, rowHeight, margin[1]);
  }
  if (dragPosition) {
    top2 = Math.round(dragPosition.top);
    left2 = Math.round(dragPosition.left);
  } else if (resizePosition) {
    top2 = Math.round(resizePosition.top);
    left2 = Math.round(resizePosition.left);
  } else {
    top2 = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
    left2 = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
  }
  if (!dragPosition && !resizePosition) {
    if (Number.isFinite(w)) {
      const siblingLeft = Math.round(
        (colWidth + margin[0]) * (x + w) + containerPadding[0]
      );
      const actualMarginRight = siblingLeft - left2 - width;
      if (actualMarginRight !== margin[0]) {
        width += actualMarginRight - margin[0];
      }
    }
    if (Number.isFinite(h)) {
      const siblingTop = Math.round(
        (rowHeight + margin[1]) * (y + h) + containerPadding[1]
      );
      const actualMarginBottom = siblingTop - top2 - height;
      if (actualMarginBottom !== margin[1]) {
        height += actualMarginBottom - margin[1];
      }
    }
  }
  return { top: top2, left: left2, width, height };
}
function calcXY(positionParams, top2, left2, w, h) {
  const { margin, containerPadding, cols, rowHeight, maxRows } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  let x = Math.round((left2 - containerPadding[0]) / (colWidth + margin[0]));
  let y = Math.round((top2 - containerPadding[1]) / (rowHeight + margin[1]));
  x = clamp$1(x, 0, cols - w);
  y = clamp$1(y, 0, maxRows - h);
  return { x, y };
}
function calcXYRaw(positionParams, top2, left2) {
  const { margin, containerPadding, rowHeight } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  const x = Math.round((left2 - containerPadding[0]) / (colWidth + margin[0]));
  const y = Math.round((top2 - containerPadding[1]) / (rowHeight + margin[1]));
  return { x, y };
}
function calcWHRaw(positionParams, width, height) {
  const { margin, rowHeight } = positionParams;
  const colWidth = calcGridColWidth(positionParams);
  const w = Math.max(
    1,
    Math.round((width + margin[0]) / (colWidth + margin[0]))
  );
  const h = Math.max(
    1,
    Math.round((height + margin[1]) / (rowHeight + margin[1]))
  );
  return { w, h };
}
function clamp$1(num2, lowerBound, upperBound) {
  return Math.max(Math.min(num2, upperBound), lowerBound);
}
function collides(l1, l2) {
  if (l1.i === l2.i) return false;
  if (l1.x + l1.w <= l2.x) return false;
  if (l1.x >= l2.x + l2.w) return false;
  if (l1.y + l1.h <= l2.y) return false;
  if (l1.y >= l2.y + l2.h) return false;
  return true;
}
function getFirstCollision$1(layout, layoutItem) {
  for (let i = 0; i < layout.length; i++) {
    const item = layout[i];
    if (item !== void 0 && collides(item, layoutItem)) {
      return item;
    }
  }
  return void 0;
}
function getAllCollisions(layout, layoutItem) {
  return layout.filter((l) => collides(l, layoutItem));
}
function sortLayoutItems(layout, compactType) {
  if (compactType === "horizontal") {
    return sortLayoutItemsByColRow(layout);
  }
  if (compactType === "vertical") {
    return sortLayoutItemsByRowCol(layout);
  }
  if (compactType === "wrap") {
    return sortLayoutItemsByRowCol(layout);
  }
  return [...layout];
}
function sortLayoutItemsByRowCol(layout) {
  return [...layout].sort((a, b) => {
    if (a.y !== b.y) {
      return a.y - b.y;
    }
    return a.x - b.x;
  });
}
function sortLayoutItemsByColRow(layout) {
  return [...layout].sort((a, b) => {
    if (a.x !== b.x) {
      return a.x - b.x;
    }
    return a.y - b.y;
  });
}
function bottom$2(layout) {
  let max2 = 0;
  for (let i = 0; i < layout.length; i++) {
    const item = layout[i];
    if (item !== void 0) {
      const bottomY = item.y + item.h;
      if (bottomY > max2) max2 = bottomY;
    }
  }
  return max2;
}
function getLayoutItem(layout, id2) {
  for (let i = 0; i < layout.length; i++) {
    const item = layout[i];
    if (item !== void 0 && item.i === id2) {
      return item;
    }
  }
  return void 0;
}
function getStatics(layout) {
  return layout.filter((l) => l.static === true);
}
function cloneLayoutItem(layoutItem) {
  return {
    i: layoutItem.i,
    x: layoutItem.x,
    y: layoutItem.y,
    w: layoutItem.w,
    h: layoutItem.h,
    minW: layoutItem.minW,
    maxW: layoutItem.maxW,
    minH: layoutItem.minH,
    maxH: layoutItem.maxH,
    moved: Boolean(layoutItem.moved),
    static: Boolean(layoutItem.static),
    isDraggable: layoutItem.isDraggable,
    isResizable: layoutItem.isResizable,
    resizeHandles: layoutItem.resizeHandles,
    constraints: layoutItem.constraints,
    isBounded: layoutItem.isBounded
  };
}
function cloneLayout(layout) {
  const newLayout = new Array(layout.length);
  for (let i = 0; i < layout.length; i++) {
    const item = layout[i];
    if (item !== void 0) {
      newLayout[i] = cloneLayoutItem(item);
    }
  }
  return newLayout;
}
function modifyLayout(layout, layoutItem) {
  const newLayout = new Array(layout.length);
  for (let i = 0; i < layout.length; i++) {
    const item = layout[i];
    if (item !== void 0) {
      if (layoutItem.i === item.i) {
        newLayout[i] = layoutItem;
      } else {
        newLayout[i] = item;
      }
    }
  }
  return newLayout;
}
function withLayoutItem(layout, itemKey, cb) {
  let item = getLayoutItem(layout, itemKey);
  if (!item) {
    return [[...layout], null];
  }
  item = cb(cloneLayoutItem(item));
  const newLayout = modifyLayout(layout, item);
  return [newLayout, item];
}
function correctBounds(layout, bounds2) {
  const collidesWith = getStatics(layout);
  for (let i = 0; i < layout.length; i++) {
    const l = layout[i];
    if (l === void 0) continue;
    if (l.x + l.w > bounds2.cols) {
      l.x = bounds2.cols - l.w;
    }
    if (l.x < 0) {
      l.x = 0;
      l.w = bounds2.cols;
    }
    if (!l.static) {
      collidesWith.push(l);
    } else {
      while (getFirstCollision$1(collidesWith, l)) {
        l.y++;
      }
    }
  }
  return layout;
}
function moveElement(layout, l, x, y, isUserAction, preventCollision, compactType, cols, allowOverlap) {
  if (l.static && l.isDraggable !== true) {
    return [...layout];
  }
  if (l.y === y && l.x === x) {
    return [...layout];
  }
  const oldX = l.x;
  const oldY = l.y;
  if (typeof x === "number") l.x = x;
  if (typeof y === "number") l.y = y;
  l.moved = true;
  let sorted = sortLayoutItems(layout, compactType);
  const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
  if (movingUp) {
    sorted = sorted.reverse();
  }
  const collisions = getAllCollisions(sorted, l);
  const hasCollisions = collisions.length > 0;
  if (hasCollisions && allowOverlap) {
    return cloneLayout(layout);
  }
  if (hasCollisions && preventCollision) {
    l.x = oldX;
    l.y = oldY;
    l.moved = false;
    return layout;
  }
  let resultLayout = [...layout];
  for (let i = 0; i < collisions.length; i++) {
    const collision = collisions[i];
    if (collision === void 0) continue;
    if (collision.moved) continue;
    if (collision.static) {
      resultLayout = moveElementAwayFromCollision(
        resultLayout,
        collision,
        l,
        isUserAction,
        compactType
      );
    } else {
      resultLayout = moveElementAwayFromCollision(
        resultLayout,
        l,
        collision,
        isUserAction,
        compactType
      );
    }
  }
  return resultLayout;
}
function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction, compactType, cols) {
  const compactH = compactType === "horizontal";
  const compactV = compactType === "vertical";
  const preventCollision = collidesWith.static;
  if (isUserAction) {
    isUserAction = false;
    const fakeItem = {
      x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
      y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
      w: itemToMove.w,
      h: itemToMove.h,
      i: "-1"
    };
    const firstCollision = getFirstCollision$1(layout, fakeItem);
    const collisionNorth = firstCollision !== void 0 && firstCollision.y + firstCollision.h > collidesWith.y;
    const collisionWest = firstCollision !== void 0 && collidesWith.x + collidesWith.w > firstCollision.x;
    if (!firstCollision) {
      return moveElement(
        layout,
        itemToMove,
        compactH ? fakeItem.x : void 0,
        compactV ? fakeItem.y : void 0,
        isUserAction,
        preventCollision,
        compactType
      );
    }
    if (collisionNorth && compactV) {
      return moveElement(
        layout,
        itemToMove,
        void 0,
        itemToMove.y + 1,
        isUserAction,
        preventCollision,
        compactType
      );
    }
    if (collisionNorth && compactType === null) {
      collidesWith.y = itemToMove.y;
      itemToMove.y = itemToMove.y + itemToMove.h;
      return [...layout];
    }
    if (collisionWest && compactH) {
      return moveElement(
        layout,
        collidesWith,
        itemToMove.x,
        void 0,
        isUserAction,
        preventCollision,
        compactType
      );
    }
  }
  const newX = compactH ? itemToMove.x + 1 : void 0;
  const newY = compactV ? itemToMove.y + 1 : void 0;
  if (newX === void 0 && newY === void 0) {
    return [...layout];
  }
  return moveElement(
    layout,
    itemToMove,
    newX,
    newY,
    isUserAction,
    preventCollision,
    compactType
  );
}
function clamp(value, min2, max2) {
  return Math.max(min2, Math.min(max2, value));
}
var gridBounds = {
  name: "gridBounds",
  constrainPosition(item, x, y, { cols, maxRows }) {
    return {
      x: clamp(x, 0, Math.max(0, cols - item.w)),
      y: clamp(y, 0, Math.max(0, maxRows - item.h))
    };
  },
  constrainSize(item, w, h, handle, { cols, maxRows }) {
    const maxW = handle === "w" || handle === "nw" || handle === "sw" ? item.x + item.w : cols - item.x;
    const maxH = handle === "n" || handle === "nw" || handle === "ne" ? item.y + item.h : maxRows - item.y;
    return {
      w: clamp(w, 1, Math.max(1, maxW)),
      h: clamp(h, 1, Math.max(1, maxH))
    };
  }
};
var minMaxSize = {
  name: "minMaxSize",
  constrainSize(item, w, h) {
    return {
      w: clamp(w, item.minW ?? 1, item.maxW ?? Infinity),
      h: clamp(h, item.minH ?? 1, item.maxH ?? Infinity)
    };
  }
};
var defaultConstraints = [gridBounds, minMaxSize];
function applyPositionConstraints(constraints, item, x, y, context) {
  let result = { x, y };
  for (const constraint of constraints) {
    if (constraint.constrainPosition) {
      result = constraint.constrainPosition(item, result.x, result.y, context);
    }
  }
  if (item.constraints) {
    for (const constraint of item.constraints) {
      if (constraint.constrainPosition) {
        result = constraint.constrainPosition(
          item,
          result.x,
          result.y,
          context
        );
      }
    }
  }
  return result;
}
function applySizeConstraints(constraints, item, w, h, handle, context) {
  let result = { w, h };
  for (const constraint of constraints) {
    if (constraint.constrainSize) {
      result = constraint.constrainSize(
        item,
        result.w,
        result.h,
        handle,
        context
      );
    }
  }
  if (item.constraints) {
    for (const constraint of item.constraints) {
      if (constraint.constrainSize) {
        result = constraint.constrainSize(
          item,
          result.w,
          result.h,
          handle,
          context
        );
      }
    }
  }
  return result;
}
function setTransform({
  top: top2,
  left: left2,
  width,
  height
}) {
  const translate = `translate(${left2}px,${top2}px)`;
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: `${width}px`,
    height: `${height}px`,
    position: "absolute"
  };
}
function setTopLeft({
  top: top2,
  left: left2,
  width,
  height
}) {
  return {
    top: `${top2}px`,
    left: `${left2}px`,
    width: `${width}px`,
    height: `${height}px`,
    position: "absolute"
  };
}
function perc(num2) {
  return num2 * 100 + "%";
}
function constrainWidth(left2, currentWidth, newWidth, containerWidth) {
  return left2 + newWidth > containerWidth ? currentWidth : newWidth;
}
function constrainHeight(top2, currentHeight, newHeight) {
  return top2 < 0 ? currentHeight : newHeight;
}
function constrainLeft(left2) {
  return Math.max(0, left2);
}
function constrainTop(top2) {
  return Math.max(0, top2);
}
var resizeNorth = (currentSize, newSize, _containerWidth) => {
  const { left: left2, height, width } = newSize;
  const top2 = currentSize.top - (height - currentSize.height);
  return {
    left: left2,
    width,
    height: constrainHeight(top2, currentSize.height, height),
    top: constrainTop(top2)
  };
};
var resizeEast = (currentSize, newSize, containerWidth) => {
  const { top: top2, left: left2, height, width } = newSize;
  return {
    top: top2,
    height,
    width: constrainWidth(
      currentSize.left,
      currentSize.width,
      width,
      containerWidth
    ),
    left: constrainLeft(left2)
  };
};
var resizeWest = (currentSize, newSize, _containerWidth) => {
  const { top: top2, height, width } = newSize;
  const left2 = currentSize.left + currentSize.width - width;
  if (left2 < 0) {
    return {
      height,
      width: currentSize.left + currentSize.width,
      top: constrainTop(top2),
      left: 0
    };
  }
  return {
    height,
    width,
    top: constrainTop(top2),
    left: left2
  };
};
var resizeSouth = (currentSize, newSize, _containerWidth) => {
  const { top: top2, left: left2, height, width } = newSize;
  return {
    width,
    left: left2,
    height: constrainHeight(top2, currentSize.height, height),
    top: constrainTop(top2)
  };
};
var resizeNorthEast = (currentSize, newSize, containerWidth) => resizeNorth(
  currentSize,
  resizeEast(currentSize, newSize, containerWidth)
);
var resizeNorthWest = (currentSize, newSize, containerWidth) => resizeNorth(
  currentSize,
  resizeWest(currentSize, newSize)
);
var resizeSouthEast = (currentSize, newSize, containerWidth) => resizeSouth(
  currentSize,
  resizeEast(currentSize, newSize, containerWidth)
);
var resizeSouthWest = (currentSize, newSize, containerWidth) => resizeSouth(
  currentSize,
  resizeWest(currentSize, newSize)
);
var resizeHandlerMap = {
  n: resizeNorth,
  ne: resizeNorthEast,
  e: resizeEast,
  se: resizeSouthEast,
  s: resizeSouth,
  sw: resizeSouthWest,
  w: resizeWest,
  nw: resizeNorthWest
};
function resizeItemInDirection(direction, currentSize, newSize, containerWidth) {
  const handler = resizeHandlerMap[direction];
  if (!handler) {
    return newSize;
  }
  return handler(currentSize, { ...currentSize, ...newSize }, containerWidth);
}
var transformStrategy = {
  type: "transform",
  scale: 1,
  calcStyle(pos) {
    return setTransform(pos);
  }
};
var defaultPositionStrategy = transformStrategy;
var defaultGridConfig = {
  cols: 12,
  rowHeight: 150,
  margin: [10, 10],
  containerPadding: null,
  maxRows: Infinity
};
var defaultDragConfig = {
  enabled: true,
  bounded: false,
  threshold: 3
};
var defaultResizeConfig = {
  enabled: true,
  handles: ["se"]
};
var defaultDropConfig = {
  enabled: false,
  defaultItem: { w: 1, h: 1 }
};
function resolveCompactionCollision(layout, item, moveToCoord, axis2, hasStatics) {
  const sizeProp = axis2 === "x" ? "w" : "h";
  item[axis2] += 1;
  const itemIndex = layout.findIndex((l) => l.i === item.i);
  const layoutHasStatics = hasStatics ?? getStatics(layout).length > 0;
  for (let i = itemIndex + 1; i < layout.length; i++) {
    const otherItem = layout[i];
    if (otherItem === void 0) continue;
    if (otherItem.static) continue;
    if (!layoutHasStatics && otherItem.y > item.y + item.h) break;
    if (collides(item, otherItem)) {
      resolveCompactionCollision(
        layout,
        otherItem,
        moveToCoord + item[sizeProp],
        axis2,
        layoutHasStatics
      );
    }
  }
  item[axis2] = moveToCoord;
}
function compactItemVertical(compareWith, l, fullLayout, maxY) {
  l.x = Math.max(l.x, 0);
  l.y = Math.max(l.y, 0);
  l.y = Math.min(maxY, l.y);
  while (l.y > 0 && !getFirstCollision$1(compareWith, l)) {
    l.y--;
  }
  let collision;
  while ((collision = getFirstCollision$1(compareWith, l)) !== void 0) {
    resolveCompactionCollision(fullLayout, l, collision.y + collision.h, "y");
  }
  l.y = Math.max(l.y, 0);
  return l;
}
function compactItemHorizontal(compareWith, l, cols, fullLayout) {
  l.x = Math.max(l.x, 0);
  l.y = Math.max(l.y, 0);
  while (l.x > 0 && !getFirstCollision$1(compareWith, l)) {
    l.x--;
  }
  let collision;
  while ((collision = getFirstCollision$1(compareWith, l)) !== void 0) {
    resolveCompactionCollision(fullLayout, l, collision.x + collision.w, "x");
    if (l.x + l.w > cols) {
      l.x = cols - l.w;
      l.y++;
      while (l.x > 0 && !getFirstCollision$1(compareWith, l)) {
        l.x--;
      }
    }
  }
  l.x = Math.max(l.x, 0);
  return l;
}
var verticalCompactor = {
  type: "vertical",
  allowOverlap: false,
  compact(layout, _cols) {
    const compareWith = getStatics(layout);
    let maxY = bottom$2(compareWith);
    const sorted = sortLayoutItemsByRowCol(layout);
    const out = new Array(layout.length);
    for (let i = 0; i < sorted.length; i++) {
      const sortedItem = sorted[i];
      if (sortedItem === void 0) continue;
      let l = cloneLayoutItem(sortedItem);
      if (!l.static) {
        l = compactItemVertical(compareWith, l, sorted, maxY);
        maxY = Math.max(maxY, l.y + l.h);
        compareWith.push(l);
      }
      const originalIndex = layout.indexOf(sortedItem);
      out[originalIndex] = l;
      l.moved = false;
    }
    return out;
  }
};
var horizontalCompactor = {
  type: "horizontal",
  allowOverlap: false,
  compact(layout, cols) {
    const compareWith = getStatics(layout);
    const sorted = sortLayoutItemsByColRow(layout);
    const out = new Array(layout.length);
    for (let i = 0; i < sorted.length; i++) {
      const sortedItem = sorted[i];
      if (sortedItem === void 0) continue;
      let l = cloneLayoutItem(sortedItem);
      if (!l.static) {
        l = compactItemHorizontal(compareWith, l, cols, sorted);
        compareWith.push(l);
      }
      const originalIndex = layout.indexOf(sortedItem);
      out[originalIndex] = l;
      l.moved = false;
    }
    return out;
  }
};
var noCompactor = {
  type: null,
  allowOverlap: false,
  compact(layout, _cols) {
    return cloneLayout(layout);
  }
};
var verticalOverlapCompactor = {
  ...verticalCompactor,
  allowOverlap: true,
  compact(layout, _cols) {
    return cloneLayout(layout);
  }
};
var horizontalOverlapCompactor = {
  ...horizontalCompactor,
  allowOverlap: true,
  compact(layout, _cols) {
    return cloneLayout(layout);
  }
};
var noOverlapCompactor = {
  ...noCompactor,
  allowOverlap: true
};
function getCompactor(compactType, allowOverlap = false, preventCollision = false) {
  let baseCompactor;
  if (allowOverlap) {
    if (compactType === "vertical") baseCompactor = verticalOverlapCompactor;
    else if (compactType === "horizontal")
      baseCompactor = horizontalOverlapCompactor;
    else baseCompactor = noOverlapCompactor;
  } else {
    if (compactType === "vertical") baseCompactor = verticalCompactor;
    else if (compactType === "horizontal") baseCompactor = horizontalCompactor;
    else baseCompactor = noCompactor;
  }
  if (preventCollision) {
    return { ...baseCompactor, preventCollision };
  }
  return baseCompactor;
}
function createDefaultIsNestedEqual(comparator) {
  return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
    return comparator(a, b, meta);
  };
}
function createIsCircular(areItemsEqual) {
  return function isCircular(a, b, isEqual, cache2) {
    if (!a || !b || typeof a !== "object" || typeof b !== "object") {
      return areItemsEqual(a, b, isEqual, cache2);
    }
    var cachedA = cache2.get(a);
    var cachedB = cache2.get(b);
    if (cachedA && cachedB) {
      return cachedA === b && cachedB === a;
    }
    cache2.set(a, b);
    cache2.set(b, a);
    var result = areItemsEqual(a, b, isEqual, cache2);
    cache2.delete(a);
    cache2.delete(b);
    return result;
  };
}
function merge$1(a, b) {
  var merged = {};
  for (var key in a) {
    merged[key] = a[key];
  }
  for (var key in b) {
    merged[key] = b[key];
  }
  return merged;
}
function isPlainObject$2(value) {
  return value.constructor === Object || value.constructor == null;
}
function isPromiseLike(value) {
  return typeof value.then === "function";
}
function sameValueZeroEqual(a, b) {
  return a === b || a !== a && b !== b;
}
var ARGUMENTS_TAG = "[object Arguments]";
var BOOLEAN_TAG = "[object Boolean]";
var DATE_TAG = "[object Date]";
var REG_EXP_TAG = "[object RegExp]";
var MAP_TAG = "[object Map]";
var NUMBER_TAG = "[object Number]";
var OBJECT_TAG = "[object Object]";
var SET_TAG = "[object Set]";
var STRING_TAG = "[object String]";
var toString$2 = Object.prototype.toString;
function createComparator(_a) {
  var areArraysEqual2 = _a.areArraysEqual, areDatesEqual2 = _a.areDatesEqual, areMapsEqual2 = _a.areMapsEqual, areObjectsEqual2 = _a.areObjectsEqual, areRegExpsEqual2 = _a.areRegExpsEqual, areSetsEqual2 = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
  var isEqual = createIsNestedEqual(comparator);
  function comparator(a, b, meta) {
    if (a === b) {
      return true;
    }
    if (!a || !b || typeof a !== "object" || typeof b !== "object") {
      return a !== a && b !== b;
    }
    if (isPlainObject$2(a) && isPlainObject$2(b)) {
      return areObjectsEqual2(a, b, isEqual, meta);
    }
    var aArray = Array.isArray(a);
    var bArray = Array.isArray(b);
    if (aArray || bArray) {
      return aArray === bArray && areArraysEqual2(a, b, isEqual, meta);
    }
    var aTag = toString$2.call(a);
    if (aTag !== toString$2.call(b)) {
      return false;
    }
    if (aTag === DATE_TAG) {
      return areDatesEqual2(a, b, isEqual, meta);
    }
    if (aTag === REG_EXP_TAG) {
      return areRegExpsEqual2(a, b, isEqual, meta);
    }
    if (aTag === MAP_TAG) {
      return areMapsEqual2(a, b, isEqual, meta);
    }
    if (aTag === SET_TAG) {
      return areSetsEqual2(a, b, isEqual, meta);
    }
    if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) {
      return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual2(a, b, isEqual, meta);
    }
    if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) {
      return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    return false;
  }
  return comparator;
}
function areArraysEqual(a, b, isEqual, meta) {
  var index2 = a.length;
  if (b.length !== index2) {
    return false;
  }
  while (index2-- > 0) {
    if (!isEqual(a[index2], b[index2], index2, index2, a, b, meta)) {
      return false;
    }
  }
  return true;
}
var areArraysEqualCircular = createIsCircular(areArraysEqual);
function areDatesEqual(a, b) {
  return sameValueZeroEqual(a.valueOf(), b.valueOf());
}
function areMapsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;
  if (!isValueEqual) {
    return false;
  }
  if (!a.size) {
    return true;
  }
  var matchedIndices = {};
  var indexA = 0;
  a.forEach(function(aValue, aKey) {
    if (!isValueEqual) {
      return;
    }
    var hasMatch = false;
    var matchIndexB = 0;
    b.forEach(function(bValue, bKey) {
      if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) {
        matchedIndices[matchIndexB] = true;
      }
      matchIndexB++;
    });
    indexA++;
    isValueEqual = hasMatch;
  });
  return isValueEqual;
}
var areMapsEqualCircular = createIsCircular(areMapsEqual);
var OWNER = "_owner";
var hasOwnProperty$d = Object.prototype.hasOwnProperty;
function areObjectsEqual(a, b, isEqual, meta) {
  var keysA = Object.keys(a);
  var index2 = keysA.length;
  if (Object.keys(b).length !== index2) {
    return false;
  }
  var key;
  while (index2-- > 0) {
    key = keysA[index2];
    if (key === OWNER) {
      var reactElementA = !!a.$$typeof;
      var reactElementB = !!b.$$typeof;
      if ((reactElementA || reactElementB) && reactElementA !== reactElementB) {
        return false;
      }
    }
    if (!hasOwnProperty$d.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) {
      return false;
    }
  }
  return true;
}
var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
function areRegExpsEqual(a, b) {
  return a.source === b.source && a.flags === b.flags;
}
function areSetsEqual(a, b, isEqual, meta) {
  var isValueEqual = a.size === b.size;
  if (!isValueEqual) {
    return false;
  }
  if (!a.size) {
    return true;
  }
  var matchedIndices = {};
  a.forEach(function(aValue, aKey) {
    if (!isValueEqual) {
      return;
    }
    var hasMatch = false;
    var matchIndex = 0;
    b.forEach(function(bValue, bKey) {
      if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) {
        matchedIndices[matchIndex] = true;
      }
      matchIndex++;
    });
    isValueEqual = hasMatch;
  });
  return isValueEqual;
}
var areSetsEqualCircular = createIsCircular(areSetsEqual);
var DEFAULT_CONFIG = Object.freeze({
  areArraysEqual,
  areDatesEqual,
  areMapsEqual,
  areObjectsEqual,
  areRegExpsEqual,
  areSetsEqual,
  createIsNestedEqual: createDefaultIsNestedEqual
});
var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
  areArraysEqual: areArraysEqualCircular,
  areDatesEqual,
  areMapsEqual: areMapsEqualCircular,
  areObjectsEqual: areObjectsEqualCircular,
  areRegExpsEqual,
  areSetsEqual: areSetsEqualCircular,
  createIsNestedEqual: createDefaultIsNestedEqual
});
var isDeepEqual = createComparator(DEFAULT_CONFIG);
function deepEqual(a, b) {
  return isDeepEqual(a, b, void 0);
}
createComparator(merge$1(DEFAULT_CONFIG, {
  createIsNestedEqual: function() {
    return sameValueZeroEqual;
  }
}));
createComparator(DEFAULT_CIRCULAR_CONFIG);
createComparator(merge$1(DEFAULT_CIRCULAR_CONFIG, {
  createIsNestedEqual: function() {
    return sameValueZeroEqual;
  }
}));
var cjs = { exports: {} };
var Draggable = {};
var clsx$1 = { exports: {} };
var hasRequiredClsx;
function requireClsx() {
  if (hasRequiredClsx) return clsx$1.exports;
  hasRequiredClsx = 1;
  function r2(e3) {
    var o, t, f2 = "";
    if ("string" == typeof e3 || "number" == typeof e3) f2 += e3;
    else if ("object" == typeof e3) if (Array.isArray(e3)) {
      var n = e3.length;
      for (o = 0; o < n; o++) e3[o] && (t = r2(e3[o])) && (f2 && (f2 += " "), f2 += t);
    } else for (t in e3) e3[t] && (f2 && (f2 += " "), f2 += t);
    return f2;
  }
  function e() {
    for (var e3, o, t = 0, f2 = "", n = arguments.length; t < n; t++) (e3 = arguments[t]) && (o = r2(e3)) && (f2 && (f2 += " "), f2 += o);
    return f2;
  }
  clsx$1.exports = e, clsx$1.exports.clsx = e;
  return clsx$1.exports;
}
var domFns = {};
var shims = {};
var hasRequiredShims;
function requireShims() {
  if (hasRequiredShims) return shims;
  hasRequiredShims = 1;
  Object.defineProperty(shims, "__esModule", {
    value: true
  });
  shims.dontSetMe = dontSetMe;
  shims.findInArray = findInArray;
  shims.int = int2;
  shims.isFunction = isFunction2;
  shims.isNum = isNum;
  function findInArray(array2, callback) {
    for (let i = 0, length2 = array2.length; i < length2; i++) {
      if (callback.apply(callback, [array2[i], i, array2])) return array2[i];
    }
  }
  function isFunction2(func) {
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
  }
  function isNum(num2) {
    return typeof num2 === "number" && !isNaN(num2);
  }
  function int2(a) {
    return parseInt(a, 10);
  }
  function dontSetMe(props, propName, componentName) {
    if (props[propName]) {
      return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
    }
  }
  return shims;
}
var getPrefix = {};
var hasRequiredGetPrefix;
function requireGetPrefix() {
  if (hasRequiredGetPrefix) return getPrefix;
  hasRequiredGetPrefix = 1;
  Object.defineProperty(getPrefix, "__esModule", {
    value: true
  });
  getPrefix.browserPrefixToKey = browserPrefixToKey;
  getPrefix.browserPrefixToStyle = browserPrefixToStyle;
  getPrefix.default = void 0;
  getPrefix.getPrefix = getPrefix$1;
  const prefixes2 = ["Moz", "Webkit", "O", "ms"];
  function getPrefix$1() {
    let prop2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
    if (typeof window === "undefined") return "";
    const style = window.document?.documentElement?.style;
    if (!style) return "";
    if (prop2 in style) return "";
    for (let i = 0; i < prefixes2.length; i++) {
      if (browserPrefixToKey(prop2, prefixes2[i]) in style) return prefixes2[i];
    }
    return "";
  }
  function browserPrefixToKey(prop2, prefix2) {
    return prefix2 ? `${prefix2}${kebabToTitleCase(prop2)}` : prop2;
  }
  function browserPrefixToStyle(prop2, prefix2) {
    return prefix2 ? `-${prefix2.toLowerCase()}-${prop2}` : prop2;
  }
  function kebabToTitleCase(str) {
    let out = "";
    let shouldCapitalize = true;
    for (let i = 0; i < str.length; i++) {
      if (shouldCapitalize) {
        out += str[i].toUpperCase();
        shouldCapitalize = false;
      } else if (str[i] === "-") {
        shouldCapitalize = true;
      } else {
        out += str[i];
      }
    }
    return out;
  }
  getPrefix.default = getPrefix$1();
  return getPrefix;
}
var hasRequiredDomFns;
function requireDomFns() {
  if (hasRequiredDomFns) return domFns;
  hasRequiredDomFns = 1;
  Object.defineProperty(domFns, "__esModule", {
    value: true
  });
  domFns.addClassName = addClassName;
  domFns.addEvent = addEvent;
  domFns.addUserSelectStyles = addUserSelectStyles;
  domFns.createCSSTransform = createCSSTransform;
  domFns.createSVGTransform = createSVGTransform;
  domFns.getTouch = getTouch;
  domFns.getTouchIdentifier = getTouchIdentifier;
  domFns.getTranslation = getTranslation;
  domFns.innerHeight = innerHeight;
  domFns.innerWidth = innerWidth;
  domFns.matchesSelector = matchesSelector;
  domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
  domFns.offsetXYFromParent = offsetXYFromParent;
  domFns.outerHeight = outerHeight;
  domFns.outerWidth = outerWidth;
  domFns.removeClassName = removeClassName;
  domFns.removeEvent = removeEvent;
  domFns.scheduleRemoveUserSelectStyles = scheduleRemoveUserSelectStyles;
  var _shims = requireShims();
  var _getPrefix = _interopRequireWildcard(requireGetPrefix());
  function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r2 = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
    return (_interopRequireWildcard = function(e3, t4) {
      if (!t4 && e3 && e3.__esModule) return e3;
      var o, i, f2 = {
        __proto__: null,
        default: e3
      };
      if (null === e3 || "object" != typeof e3 && "function" != typeof e3) return f2;
      if (o = t4 ? n : r2) {
        if (o.has(e3)) return o.get(e3);
        o.set(e3, f2);
      }
      for (const t5 in e3) "default" !== t5 && {}.hasOwnProperty.call(e3, t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e3, t5)) && (i.get || i.set) ? o(f2, t5, i) : f2[t5] = e3[t5]);
      return f2;
    })(e, t);
  }
  let matchesSelectorFunc = "";
  function matchesSelector(el2, selector2) {
    if (!matchesSelectorFunc) {
      matchesSelectorFunc = (0, _shims.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(method) {
        return (0, _shims.isFunction)(el2[method]);
      });
    }
    if (!(0, _shims.isFunction)(el2[matchesSelectorFunc])) return false;
    return el2[matchesSelectorFunc](selector2);
  }
  function matchesSelectorAndParentsTo(el2, selector2, baseNode) {
    let node2 = el2;
    do {
      if (matchesSelector(node2, selector2)) return true;
      if (node2 === baseNode) return false;
      node2 = node2.parentNode;
    } while (node2);
    return false;
  }
  function addEvent(el2, event, handler, inputOptions) {
    if (!el2) return;
    const options2 = {
      capture: true,
      ...inputOptions
    };
    if (el2.addEventListener) {
      el2.addEventListener(event, handler, options2);
    } else if (el2.attachEvent) {
      el2.attachEvent("on" + event, handler);
    } else {
      el2["on" + event] = handler;
    }
  }
  function removeEvent(el2, event, handler, inputOptions) {
    if (!el2) return;
    const options2 = {
      capture: true,
      ...inputOptions
    };
    if (el2.removeEventListener) {
      el2.removeEventListener(event, handler, options2);
    } else if (el2.detachEvent) {
      el2.detachEvent("on" + event, handler);
    } else {
      el2["on" + event] = null;
    }
  }
  function outerHeight(node2) {
    let height = node2.clientHeight;
    const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
    height += (0, _shims.int)(computedStyle.borderTopWidth);
    height += (0, _shims.int)(computedStyle.borderBottomWidth);
    return height;
  }
  function outerWidth(node2) {
    let width = node2.clientWidth;
    const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
    width += (0, _shims.int)(computedStyle.borderLeftWidth);
    width += (0, _shims.int)(computedStyle.borderRightWidth);
    return width;
  }
  function innerHeight(node2) {
    let height = node2.clientHeight;
    const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
    height -= (0, _shims.int)(computedStyle.paddingTop);
    height -= (0, _shims.int)(computedStyle.paddingBottom);
    return height;
  }
  function innerWidth(node2) {
    let width = node2.clientWidth;
    const computedStyle = node2.ownerDocument.defaultView.getComputedStyle(node2);
    width -= (0, _shims.int)(computedStyle.paddingLeft);
    width -= (0, _shims.int)(computedStyle.paddingRight);
    return width;
  }
  function offsetXYFromParent(evt, offsetParent, scale) {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
      left: 0,
      top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
      x,
      y
    };
  }
  function createCSSTransform(controlPos, positionOffset) {
    const translation = getTranslation(controlPos, positionOffset, "px");
    return {
      [(0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default)]: translation
    };
  }
  function createSVGTransform(controlPos, positionOffset) {
    const translation = getTranslation(controlPos, positionOffset, "");
    return translation;
  }
  function getTranslation(_ref, positionOffset, unitSuffix) {
    let {
      x,
      y
    } = _ref;
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
      const defaultX = `${typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix}`;
      const defaultY = `${typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix}`;
      translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
  }
  function getTouch(e, identifier) {
    return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, (t) => identifier === t.identifier) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, (t) => identifier === t.identifier);
  }
  function getTouchIdentifier(e) {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
  }
  function addUserSelectStyles(doc) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
      styleEl = doc.createElement("style");
      styleEl.type = "text/css";
      styleEl.id = "react-draggable-style-el";
      styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
      styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
      doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) addClassName(doc.body, "react-draggable-transparent-selection");
  }
  function scheduleRemoveUserSelectStyles(doc) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => {
        removeUserSelectStyles(doc);
      });
    } else {
      removeUserSelectStyles(doc);
    }
  }
  function removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
      if (doc.body) removeClassName(doc.body, "react-draggable-transparent-selection");
      if (doc.selection) {
        doc.selection.empty();
      } else {
        const selection2 = (doc.defaultView || window).getSelection();
        if (selection2 && selection2.type !== "Caret") {
          selection2.removeAllRanges();
        }
      }
    } catch (e) {
    }
  }
  function addClassName(el2, className) {
    if (el2.classList) {
      el2.classList.add(className);
    } else {
      if (!el2.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) {
        el2.className += ` ${className}`;
      }
    }
  }
  function removeClassName(el2, className) {
    if (el2.classList) {
      el2.classList.remove(className);
    } else {
      el2.className = el2.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, "g"), "");
    }
  }
  return domFns;
}
var positionFns = {};
var hasRequiredPositionFns;
function requirePositionFns() {
  if (hasRequiredPositionFns) return positionFns;
  hasRequiredPositionFns = 1;
  Object.defineProperty(positionFns, "__esModule", {
    value: true
  });
  positionFns.canDragX = canDragX;
  positionFns.canDragY = canDragY;
  positionFns.createCoreData = createCoreData;
  positionFns.createDraggableData = createDraggableData;
  positionFns.getBoundPosition = getBoundPosition;
  positionFns.getControlPosition = getControlPosition;
  positionFns.snapToGrid = snapToGrid;
  var _shims = requireShims();
  var _domFns = requireDomFns();
  function getBoundPosition(draggable, x, y) {
    if (!draggable.props.bounds) return [x, y];
    let {
      bounds: bounds2
    } = draggable.props;
    bounds2 = typeof bounds2 === "string" ? bounds2 : cloneBounds(bounds2);
    const node2 = findDOMNode(draggable);
    if (typeof bounds2 === "string") {
      const {
        ownerDocument
      } = node2;
      const ownerWindow = ownerDocument.defaultView;
      let boundNode;
      if (bounds2 === "parent") {
        boundNode = node2.parentNode;
      } else {
        const rootNode = node2.getRootNode();
        boundNode = rootNode.querySelector(bounds2);
      }
      if (!(boundNode instanceof ownerWindow.HTMLElement)) {
        throw new Error('Bounds selector "' + bounds2 + '" could not find an element.');
      }
      const boundNodeEl = boundNode;
      const nodeStyle = ownerWindow.getComputedStyle(node2);
      const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
      bounds2 = {
        left: -node2.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
        top: -node2.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
        right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node2) - node2.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
        bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node2) - node2.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
      };
    }
    if ((0, _shims.isNum)(bounds2.right)) x = Math.min(x, bounds2.right);
    if ((0, _shims.isNum)(bounds2.bottom)) y = Math.min(y, bounds2.bottom);
    if ((0, _shims.isNum)(bounds2.left)) x = Math.max(x, bounds2.left);
    if ((0, _shims.isNum)(bounds2.top)) y = Math.max(y, bounds2.top);
    return [x, y];
  }
  function snapToGrid(grid, pendingX, pendingY) {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [x, y];
  }
  function canDragX(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
  }
  function canDragY(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
  }
  function getControlPosition(e, touchIdentifier, draggableCore) {
    const touchObj = typeof touchIdentifier === "number" ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null;
    const node2 = findDOMNode(draggableCore);
    const offsetParent = draggableCore.props.offsetParent || node2.offsetParent || node2.ownerDocument.body;
    return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
  }
  function createCoreData(draggable, x, y) {
    const isStart = !(0, _shims.isNum)(draggable.lastX);
    const node2 = findDOMNode(draggable);
    if (isStart) {
      return {
        node: node2,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x,
        y
      };
    } else {
      return {
        node: node2,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x,
        y
      };
    }
  }
  function createDraggableData(draggable, coreData) {
    const scale = draggable.props.scale;
    return {
      node: coreData.node,
      x: draggable.state.x + coreData.deltaX / scale,
      y: draggable.state.y + coreData.deltaY / scale,
      deltaX: coreData.deltaX / scale,
      deltaY: coreData.deltaY / scale,
      lastX: draggable.state.x,
      lastY: draggable.state.y
    };
  }
  function cloneBounds(bounds2) {
    return {
      left: bounds2.left,
      top: bounds2.top,
      right: bounds2.right,
      bottom: bounds2.bottom
    };
  }
  function findDOMNode(draggable) {
    const node2 = draggable.findDOMNode();
    if (!node2) {
      throw new Error("<DraggableCore>: Unmounted during event!");
    }
    return node2;
  }
  return positionFns;
}
var DraggableCore = {};
var log$1 = {};
var hasRequiredLog;
function requireLog() {
  if (hasRequiredLog) return log$1;
  hasRequiredLog = 1;
  Object.defineProperty(log$1, "__esModule", {
    value: true
  });
  log$1.default = log2;
  function log2() {
  }
  return log$1;
}
var hasRequiredDraggableCore;
function requireDraggableCore() {
  if (hasRequiredDraggableCore) return DraggableCore;
  hasRequiredDraggableCore = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  Object.defineProperty(DraggableCore, "__esModule", {
    value: true
  });
  DraggableCore.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _propTypes = _interopRequireDefault(/* @__PURE__ */ requirePropTypes$1());
  var _reactDom = _interopRequireDefault(ReactDOM);
  var _domFns = requireDomFns();
  var _positionFns = requirePositionFns();
  var _shims = requireShims();
  var _log = _interopRequireDefault(requireLog());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r2 = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
    return (_interopRequireWildcard = function(e3, t4) {
      if (!t4 && e3 && e3.__esModule) return e3;
      var o, i, f2 = {
        __proto__: null,
        default: e3
      };
      if (null === e3 || "object" != typeof e3 && "function" != typeof e3) return f2;
      if (o = t4 ? n : r2) {
        if (o.has(e3)) return o.get(e3);
        o.set(e3, f2);
      }
      for (const t5 in e3) "default" !== t5 && {}.hasOwnProperty.call(e3, t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e3, t5)) && (i.get || i.set) ? o(f2, t5, i) : f2[t5] = e3[t5]);
      return f2;
    })(e, t);
  }
  function _defineProperty2(e, r2, t) {
    return (r2 = _toPropertyKey3(r2)) in e ? Object.defineProperty(e, r2, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r2] = t, e;
  }
  function _toPropertyKey3(t) {
    var i = _toPrimitive3(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive3(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r2 ? String : Number)(t);
  }
  const eventsFor = {
    touch: {
      start: "touchstart",
      move: "touchmove",
      stop: "touchend"
    },
    mouse: {
      start: "mousedown",
      move: "mousemove",
      stop: "mouseup"
    }
  };
  let dragEventFor = eventsFor.mouse;
  let DraggableCore$1 = /* @__PURE__ */ (function(_React$Component) {
    function DraggableCore2() {
      var _this;
      _classCallCheck2(this, DraggableCore2);
      _this = _callSuper2(this, DraggableCore2, arguments);
      _defineProperty2(_this, "dragging", false);
      _defineProperty2(_this, "lastX", NaN);
      _defineProperty2(_this, "lastY", NaN);
      _defineProperty2(_this, "touchIdentifier", null);
      _defineProperty2(_this, "mounted", false);
      _defineProperty2(_this, "handleDragStart", (e) => {
        _this.props.onMouseDown(e);
        if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
        const thisNode = _this.findDOMNode();
        if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
          throw new Error("<DraggableCore> not mounted on DragStart!");
        }
        const {
          ownerDocument
        } = thisNode;
        if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
          return;
        }
        if (e.type === "touchstart" && !_this.props.allowMobileScroll) e.preventDefault();
        const touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
        _this.touchIdentifier = touchIdentifier;
        const position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
        if (position == null) return;
        const {
          x,
          y
        } = position;
        const coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
        (0, _log.default)("DraggableCore: handleDragStart: %j", coreEvent);
        (0, _log.default)("calling", _this.props.onStart);
        const shouldUpdate = _this.props.onStart(e, coreEvent);
        if (shouldUpdate === false || _this.mounted === false) return;
        if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);
        _this.dragging = true;
        _this.lastX = x;
        _this.lastY = y;
        (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
      });
      _defineProperty2(_this, "handleDrag", (e) => {
        const position = (0, _positionFns.getControlPosition)(e, _this.touchIdentifier, _this);
        if (position == null) return;
        let {
          x,
          y
        } = position;
        if (Array.isArray(_this.props.grid)) {
          let deltaX = x - _this.lastX, deltaY = y - _this.lastY;
          [deltaX, deltaY] = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
          if (!deltaX && !deltaY) return;
          x = _this.lastX + deltaX, y = _this.lastY + deltaY;
        }
        const coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
        (0, _log.default)("DraggableCore: handleDrag: %j", coreEvent);
        const shouldUpdate = _this.props.onDrag(e, coreEvent);
        if (shouldUpdate === false || _this.mounted === false) {
          try {
            _this.handleDragStop(new MouseEvent("mouseup"));
          } catch (err) {
            const event = document.createEvent("MouseEvents");
            event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            _this.handleDragStop(event);
          }
          return;
        }
        _this.lastX = x;
        _this.lastY = y;
      });
      _defineProperty2(_this, "handleDragStop", (e) => {
        if (!_this.dragging) return;
        const position = (0, _positionFns.getControlPosition)(e, _this.touchIdentifier, _this);
        if (position == null) return;
        let {
          x,
          y
        } = position;
        if (Array.isArray(_this.props.grid)) {
          let deltaX = x - _this.lastX || 0;
          let deltaY = y - _this.lastY || 0;
          [deltaX, deltaY] = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
          x = _this.lastX + deltaX, y = _this.lastY + deltaY;
        }
        const coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
        const shouldContinue = _this.props.onStop(e, coreEvent);
        if (shouldContinue === false || _this.mounted === false) return false;
        const thisNode = _this.findDOMNode();
        if (thisNode) {
          if (_this.props.enableUserSelectHack) (0, _domFns.scheduleRemoveUserSelectStyles)(thisNode.ownerDocument);
        }
        (0, _log.default)("DraggableCore: handleDragStop: %j", coreEvent);
        _this.dragging = false;
        _this.lastX = NaN;
        _this.lastY = NaN;
        if (thisNode) {
          (0, _log.default)("DraggableCore: Removing handlers");
          (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
          (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
        }
      });
      _defineProperty2(_this, "onMouseDown", (e) => {
        dragEventFor = eventsFor.mouse;
        return _this.handleDragStart(e);
      });
      _defineProperty2(_this, "onMouseUp", (e) => {
        dragEventFor = eventsFor.mouse;
        return _this.handleDragStop(e);
      });
      _defineProperty2(_this, "onTouchStart", (e) => {
        dragEventFor = eventsFor.touch;
        return _this.handleDragStart(e);
      });
      _defineProperty2(_this, "onTouchEnd", (e) => {
        dragEventFor = eventsFor.touch;
        return _this.handleDragStop(e);
      });
      return _this;
    }
    _inherits2(DraggableCore2, _React$Component);
    return _createClass2(DraggableCore2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
        const thisNode = this.findDOMNode();
        if (thisNode) {
          (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
            passive: false
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
        const thisNode = this.findDOMNode();
        if (thisNode) {
          const {
            ownerDocument
          } = thisNode;
          (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
          (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
          (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
          (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
          (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
            passive: false
          });
          if (this.props.enableUserSelectHack) (0, _domFns.scheduleRemoveUserSelectStyles)(ownerDocument);
        }
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
    }, {
      key: "findDOMNode",
      value: function findDOMNode() {
        return this.props?.nodeRef ? this.props?.nodeRef?.current : _reactDom.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function render3() {
        return /* @__PURE__ */ React2.cloneElement(React2.Children.only(this.props.children), {
          // Note: mouseMove handler is attached to document so it will still function
          // when the user drags quickly and leaves the bounds of the element.
          onMouseDown: this.onMouseDown,
          onMouseUp: this.onMouseUp,
          // onTouchStart is added on `componentDidMount` so they can be added with
          // {passive: false}, which allows it to cancel. See
          // https://developers.google.com/web/updates/2017/01/scrolling-intervention
          onTouchEnd: this.onTouchEnd
        });
      }
    }]);
  })(
    React2.Component
    /*:: <DraggableCoreProps>*/
  );
  DraggableCore.default = DraggableCore$1;
  _defineProperty2(DraggableCore$1, "displayName", "DraggableCore");
  _defineProperty2(DraggableCore$1, "propTypes", {
    /**
     * `allowAnyClick` allows dragging using any mouse button.
     * By default, we only accept the left button.
     *
     * Defaults to `false`.
     */
    allowAnyClick: _propTypes.default.bool,
    /**
     * `allowMobileScroll` turns off cancellation of the 'touchstart' event
     * on mobile devices. Only enable this if you are having trouble with click
     * events. Prefer using 'handle' / 'cancel' instead.
     *
     * Defaults to `false`.
     */
    allowMobileScroll: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired,
    /**
     * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
     * with the exception of `onMouseDown`, will not fire.
     */
    disabled: _propTypes.default.bool,
    /**
     * By default, we add 'user-select:none' attributes to the document body
     * to prevent ugly text selection during drag. If this is causing problems
     * for your app, set this to `false`.
     */
    enableUserSelectHack: _propTypes.default.bool,
    /**
     * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
     * instead of using the parent node.
     */
    offsetParent: function(props, propName) {
      if (props[propName] && props[propName].nodeType !== 1) {
        throw new Error("Draggable's offsetParent must be a DOM Node.");
      }
    },
    /**
     * `grid` specifies the x and y that dragging should snap to.
     */
    grid: _propTypes.default.arrayOf(_propTypes.default.number),
    /**
     * `handle` specifies a selector to be used as the handle that initiates drag.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable handle=".handle">
     *              <div>
     *                  <div className="handle">Click me to drag</div>
     *                  <div>This is some other content</div>
     *              </div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    handle: _propTypes.default.string,
    /**
     * `cancel` specifies a selector to be used to prevent drag initialization.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *           return(
     *               <Draggable cancel=".cancel">
     *                   <div>
     *                     <div className="cancel">You can't drag from here</div>
     *                     <div>Dragging here works fine</div>
     *                   </div>
     *               </Draggable>
     *           );
     *       }
     *   });
     * ```
     */
    cancel: _propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
     * Unfortunately, in order for <Draggable> to work properly, we need raw access
     * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
     * as in this example:
     *
     * function MyComponent() {
     *   const nodeRef = React.useRef(null);
     *   return (
     *     <Draggable nodeRef={nodeRef}>
     *       <div ref={nodeRef}>Example Target</div>
     *     </Draggable>
     *   );
     * }
     *
     * This can be used for arbitrarily nested components, so long as the ref ends up
     * pointing to the actual child DOM node and not a custom component.
     */
    nodeRef: _propTypes.default.object,
    /**
     * Called when dragging starts.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onStart: _propTypes.default.func,
    /**
     * Called while dragging.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onDrag: _propTypes.default.func,
    /**
     * Called when dragging stops.
     * If this function returns the boolean false, the drag will remain active.
     */
    onStop: _propTypes.default.func,
    /**
     * A workaround option which can be passed if onMouseDown needs to be accessed,
     * since it'll always be blocked (as there is internal use of onMouseDown)
     */
    onMouseDown: _propTypes.default.func,
    /**
     * `scale`, if set, applies scaling while dragging an element
     */
    scale: _propTypes.default.number,
    /**
     * These properties should be defined on the child, not here.
     */
    className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
  });
  _defineProperty2(DraggableCore$1, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {
    },
    onDrag: function() {
    },
    onStop: function() {
    },
    onMouseDown: function() {
    },
    scale: 1
  });
  return DraggableCore;
}
var hasRequiredDraggable;
function requireDraggable() {
  if (hasRequiredDraggable) return Draggable;
  hasRequiredDraggable = 1;
  (function(exports2) {
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r2) {
      for (var t = 0; t < r2.length; t++) {
        var o = r2[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r2, t) {
      return r2 && _defineProperties2(e.prototype, r2), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _toPropertyKey2(t) {
      var i = _toPrimitive2(t, "string");
      return "symbol" == typeof i ? i : i + "";
    }
    function _toPrimitive2(t, r2) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r2);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(t);
    }
    function _callSuper2(t, o, e) {
      return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
    }
    function _possibleConstructorReturn2(t, e) {
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return _assertThisInitialized2(t);
    }
    function _assertThisInitialized2(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function _isNativeReflectConstruct2() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch (t4) {
      }
      return (_isNativeReflectConstruct2 = function() {
        return !!t;
      })();
    }
    function _getPrototypeOf2(t) {
      return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
        return t4.__proto__ || Object.getPrototypeOf(t4);
      }, _getPrototypeOf2(t);
    }
    function _inherits2(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
    }
    function _setPrototypeOf2(t, e) {
      return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
        return t4.__proto__ = e3, t4;
      }, _setPrototypeOf2(t, e);
    }
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    Object.defineProperty(exports2, "DraggableCore", {
      enumerable: true,
      get: function() {
        return _DraggableCore.default;
      }
    });
    exports2.default = void 0;
    var React2 = _interopRequireWildcard(React__default);
    var _propTypes = _interopRequireDefault(/* @__PURE__ */ requirePropTypes$1());
    var _reactDom = _interopRequireDefault(ReactDOM);
    var _clsx = requireClsx();
    var _domFns = requireDomFns();
    var _positionFns = requirePositionFns();
    var _shims = requireShims();
    var _DraggableCore = _interopRequireDefault(requireDraggableCore());
    var _log = _interopRequireDefault(requireLog());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function _interopRequireWildcard(e, t) {
      if ("function" == typeof WeakMap) var r2 = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
      return (_interopRequireWildcard = function(e3, t4) {
        if (!t4 && e3 && e3.__esModule) return e3;
        var o, i, f2 = {
          __proto__: null,
          default: e3
        };
        if (null === e3 || "object" != typeof e3 && "function" != typeof e3) return f2;
        if (o = t4 ? n : r2) {
          if (o.has(e3)) return o.get(e3);
          o.set(e3, f2);
        }
        for (const t5 in e3) "default" !== t5 && {}.hasOwnProperty.call(e3, t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e3, t5)) && (i.get || i.set) ? o(f2, t5, i) : f2[t5] = e3[t5]);
        return f2;
      })(e, t);
    }
    function _extends2() {
      return _extends2 = Object.assign ? Object.assign.bind() : function(n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
        }
        return n;
      }, _extends2.apply(null, arguments);
    }
    function _defineProperty2(e, r2, t) {
      return (r2 = _toPropertyKey3(r2)) in e ? Object.defineProperty(e, r2, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
      }) : e[r2] = t, e;
    }
    function _toPropertyKey3(t) {
      var i = _toPrimitive3(t, "string");
      return "symbol" == typeof i ? i : i + "";
    }
    function _toPrimitive3(t, r2) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r2);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r2 ? String : Number)(t);
    }
    let Draggable2 = /* @__PURE__ */ (function(_React$Component) {
      function Draggable3(props) {
        var _this;
        _classCallCheck2(this, Draggable3);
        _this = _callSuper2(this, Draggable3, [props]);
        _defineProperty2(_this, "onDragStart", (e, coreData) => {
          (0, _log.default)("Draggable: onDragStart: %j", coreData);
          const shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
          if (shouldStart === false) return false;
          _this.setState({
            dragging: true,
            dragged: true
          });
        });
        _defineProperty2(_this, "onDrag", (e, coreData) => {
          if (!_this.state.dragging) return false;
          (0, _log.default)("Draggable: onDrag: %j", coreData);
          const uiData = (0, _positionFns.createDraggableData)(_this, coreData);
          const newState = {
            x: uiData.x,
            y: uiData.y,
            slackX: 0,
            slackY: 0
          };
          if (_this.props.bounds) {
            const {
              x,
              y
            } = newState;
            newState.x += _this.state.slackX;
            newState.y += _this.state.slackY;
            const [newStateX, newStateY] = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y);
            newState.x = newStateX;
            newState.y = newStateY;
            newState.slackX = _this.state.slackX + (x - newState.x);
            newState.slackY = _this.state.slackY + (y - newState.y);
            uiData.x = newState.x;
            uiData.y = newState.y;
            uiData.deltaX = newState.x - _this.state.x;
            uiData.deltaY = newState.y - _this.state.y;
          }
          const shouldUpdate = _this.props.onDrag(e, uiData);
          if (shouldUpdate === false) return false;
          _this.setState(newState);
        });
        _defineProperty2(_this, "onDragStop", (e, coreData) => {
          if (!_this.state.dragging) return false;
          const shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
          if (shouldContinue === false) return false;
          (0, _log.default)("Draggable: onDragStop: %j", coreData);
          const newState = {
            dragging: false,
            slackX: 0,
            slackY: 0
          };
          const controlled = Boolean(_this.props.position);
          if (controlled) {
            const {
              x,
              y
            } = _this.props.position;
            newState.x = x;
            newState.y = y;
          }
          _this.setState(newState);
        });
        _this.state = {
          // Whether or not we are currently dragging.
          dragging: false,
          // Whether or not we have been dragged before.
          dragged: false,
          // Current transform x and y.
          x: props.position ? props.position.x : props.defaultPosition.x,
          y: props.position ? props.position.y : props.defaultPosition.y,
          prevPropsPosition: {
            ...props.position
          },
          // Used for compensating for out-of-bounds drags
          slackX: 0,
          slackY: 0,
          // Can only determine if SVG after mounting
          isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) {
          console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
        }
        return _this;
      }
      _inherits2(Draggable3, _React$Component);
      return _createClass2(Draggable3, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) {
            this.setState({
              isElementSVG: true
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.state.dragging) {
            this.setState({
              dragging: false
            });
          }
        }
        // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        // the underlying DOM node ourselves. See the README for more information.
      }, {
        key: "findDOMNode",
        value: function findDOMNode() {
          return this.props?.nodeRef?.current ?? _reactDom.default.findDOMNode(this);
        }
      }, {
        key: "render",
        value: function render3() {
          const {
            axis: axis2,
            bounds: bounds2,
            children: children2,
            defaultPosition,
            defaultClassName,
            defaultClassNameDragging,
            defaultClassNameDragged,
            position,
            positionOffset,
            scale,
            ...draggableCoreProps
          } = this.props;
          let style = {};
          let svgTransform = null;
          const controlled = Boolean(position);
          const draggable = !controlled || this.state.dragging;
          const validPosition = position || defaultPosition;
          const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
          };
          if (this.state.isElementSVG) {
            svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
          } else {
            style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
          }
          const className = (0, _clsx.clsx)(children2.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
          });
          return /* @__PURE__ */ React2.createElement(_DraggableCore.default, _extends2({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
          }), /* @__PURE__ */ React2.cloneElement(React2.Children.only(children2), {
            className,
            style: {
              ...children2.props.style,
              ...style
            },
            transform: svgTransform
          }));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: (
          // React 16.3+
          // Arity (props, state)
          function getDerivedStateFromProps(_ref, _ref2) {
            let {
              position
            } = _ref;
            let {
              prevPropsPosition
            } = _ref2;
            if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
              (0, _log.default)("Draggable: getDerivedStateFromProps %j", {
                position,
                prevPropsPosition
              });
              return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                  ...position
                }
              };
            }
            return null;
          }
        )
      }]);
    })(
      React2.Component
      /*:: <DraggableProps, DraggableState>*/
    );
    exports2.default = Draggable2;
    _defineProperty2(Draggable2, "displayName", "Draggable");
    _defineProperty2(Draggable2, "propTypes", {
      // Accepts all props <DraggableCore> accepts.
      ..._DraggableCore.default.propTypes,
      /**
       * `axis` determines which axis the draggable can move.
       *
       *  Note that all callbacks will still return data as normal. This only
       *  controls flushing to the DOM.
       *
       * 'both' allows movement horizontally and vertically.
       * 'x' limits movement to horizontal axis.
       * 'y' limits movement to vertical axis.
       * 'none' limits all movement.
       *
       * Defaults to 'both'.
       */
      axis: _propTypes.default.oneOf(["both", "x", "y", "none"]),
      /**
       * `bounds` determines the range of movement available to the element.
       * Available values are:
       *
       * 'parent' restricts movement within the Draggable's parent node.
       *
       * Alternatively, pass an object with the following properties, all of which are optional:
       *
       * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
       *
       * All values are in px.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable bounds={{right: 300, bottom: 300}}>
       *              <div>Content</div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
        left: _propTypes.default.number,
        right: _propTypes.default.number,
        top: _propTypes.default.number,
        bottom: _propTypes.default.number
      }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
      defaultClassName: _propTypes.default.string,
      defaultClassNameDragging: _propTypes.default.string,
      defaultClassNameDragged: _propTypes.default.string,
      /**
       * `defaultPosition` specifies the x and y that the dragged item should start at
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable defaultPosition={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      defaultPosition: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
      }),
      positionOffset: _propTypes.default.shape({
        x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
        y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
      }),
      /**
       * `position`, if present, defines the current position of the element.
       *
       *  This is similar to how form elements in React work - if no `position` is supplied, the component
       *  is uncontrolled.
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable position={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      position: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
      }),
      /**
       * These properties should be defined on the child, not here.
       */
      className: _shims.dontSetMe,
      style: _shims.dontSetMe,
      transform: _shims.dontSetMe
    });
    _defineProperty2(Draggable2, "defaultProps", {
      ..._DraggableCore.default.defaultProps,
      axis: "both",
      bounds: false,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    });
  })(Draggable);
  return Draggable;
}
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs.exports;
  hasRequiredCjs = 1;
  const {
    default: Draggable2,
    DraggableCore: DraggableCore2
  } = requireDraggable();
  cjs.exports = Draggable2;
  cjs.exports.default = Draggable2;
  cjs.exports.DraggableCore = DraggableCore2;
  return cjs.exports;
}
var cjsExports = requireCjs();
var reactResizable = { exports: {} };
var Resizable = {};
var utils$2 = {};
var hasRequiredUtils$2;
function requireUtils$2() {
  if (hasRequiredUtils$2) return utils$2;
  hasRequiredUtils$2 = 1;
  utils$2.__esModule = true;
  utils$2.cloneElement = cloneElement;
  var _react = _interopRequireDefault(React__default);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys2 = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      })), keys2.push.apply(keys2, symbols);
    }
    return keys2;
  }
  function _objectSpread(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty2(target2, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target2;
  }
  function _defineProperty2(obj, key, value) {
    key = _toPropertyKey2(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey2(arg) {
    var key = _toPrimitive2(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive2(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function cloneElement(element, props) {
    if (props.style && element.props.style) {
      props.style = _objectSpread(_objectSpread({}, element.props.style), props.style);
    }
    if (props.className && element.props.className) {
      props.className = element.props.className + " " + props.className;
    }
    return /* @__PURE__ */ _react.default.cloneElement(element, props);
  }
  return utils$2;
}
var propTypes = {};
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes;
  hasRequiredPropTypes = 1;
  propTypes.__esModule = true;
  propTypes.resizableProps = void 0;
  var _propTypes = _interopRequireDefault(/* @__PURE__ */ requirePropTypes$1());
  requireCjs();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var resizableProps = {
    /*
    * Restricts resizing to a particular axis (default: 'both')
    * 'both' - allows resizing by width or height
    * 'x' - only allows the width to be changed
    * 'y' - only allows the height to be changed
    * 'none' - disables resizing altogether
    * */
    axis: _propTypes.default.oneOf(["both", "x", "y", "none"]),
    className: _propTypes.default.string,
    /*
    * Require that one and only one child be present.
    * */
    children: _propTypes.default.element.isRequired,
    /*
    * These will be passed wholesale to react-draggable's DraggableCore
    * */
    draggableOpts: _propTypes.default.shape({
      allowAnyClick: _propTypes.default.bool,
      cancel: _propTypes.default.string,
      children: _propTypes.default.node,
      disabled: _propTypes.default.bool,
      enableUserSelectHack: _propTypes.default.bool,
      offsetParent: _propTypes.default.node,
      grid: _propTypes.default.arrayOf(_propTypes.default.number),
      handle: _propTypes.default.string,
      nodeRef: _propTypes.default.object,
      onStart: _propTypes.default.func,
      onDrag: _propTypes.default.func,
      onStop: _propTypes.default.func,
      onMouseDown: _propTypes.default.func,
      scale: _propTypes.default.number
    }),
    /*
    * Initial height
    * */
    height: function height() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var props = args[0];
      if (props.axis === "both" || props.axis === "y") {
        var _PropTypes$number;
        return (_PropTypes$number = _propTypes.default.number).isRequired.apply(_PropTypes$number, args);
      }
      return _propTypes.default.number.apply(_propTypes.default, args);
    },
    /*
    * Customize cursor resize handle
    * */
    handle: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
    /*
    * If you change this, be sure to update your css
    * */
    handleSize: _propTypes.default.arrayOf(_propTypes.default.number),
    lockAspectRatio: _propTypes.default.bool,
    /*
    * Max X & Y measure
    * */
    maxConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
    /*
    * Min X & Y measure
    * */
    minConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
    /*
    * Called on stop resize event
    * */
    onResizeStop: _propTypes.default.func,
    /*
    * Called on start resize event
    * */
    onResizeStart: _propTypes.default.func,
    /*
    * Called on resize event
    * */
    onResize: _propTypes.default.func,
    /*
    * Defines which resize handles should be rendered (default: 'se')
    * 's' - South handle (bottom-center)
    * 'w' - West handle (left-center)
    * 'e' - East handle (right-center)
    * 'n' - North handle (top-center)
    * 'sw' - Southwest handle (bottom-left)
    * 'nw' - Northwest handle (top-left)
    * 'se' - Southeast handle (bottom-right)
    * 'ne' - Northeast handle (top-center)
    * */
    resizeHandles: _propTypes.default.arrayOf(_propTypes.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
    /*
    * If `transform: scale(n)` is set on the parent, this should be set to `n`.
    * */
    transformScale: _propTypes.default.number,
    /*
     * Initial width
     */
    width: function width() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var props = args[0];
      if (props.axis === "both" || props.axis === "x") {
        var _PropTypes$number2;
        return (_PropTypes$number2 = _propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
      }
      return _propTypes.default.number.apply(_propTypes.default, args);
    }
  };
  propTypes.resizableProps = resizableProps;
  return propTypes;
}
var hasRequiredResizable;
function requireResizable() {
  if (hasRequiredResizable) return Resizable;
  hasRequiredResizable = 1;
  Resizable.__esModule = true;
  Resizable.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _reactDraggable = requireCjs();
  var _utils = requireUtils$2();
  var _propTypes = requirePropTypes();
  var _excluded = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache2 = _getRequireWildcardCache(nodeInterop);
    if (cache2 && cache2.has(obj)) {
      return cache2.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache2) {
      cache2.set(obj, newObj);
    }
    return newObj;
  }
  function _extends2() {
    _extends2 = Object.assign ? Object.assign.bind() : function(target2) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target2[key] = source[key];
          }
        }
      }
      return target2;
    };
    return _extends2.apply(this, arguments);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target2 = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target2[key] = source[key];
    }
    return target2;
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys2 = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      })), keys2.push.apply(keys2, symbols);
    }
    return keys2;
  }
  function _objectSpread(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty2(target2, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target2;
  }
  function _defineProperty2(obj, key, value) {
    key = _toPropertyKey2(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey2(arg) {
    var key = _toPrimitive2(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive2(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  var Resizable$1 = /* @__PURE__ */ (function(_React$Component) {
    _inheritsLoose(Resizable2, _React$Component);
    function Resizable2() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handleRefs = {};
      _this.lastHandleRect = null;
      _this.slack = null;
      return _this;
    }
    var _proto = Resizable2.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.resetData();
    };
    _proto.resetData = function resetData() {
      this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
      var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
      if (!minConstraints && !maxConstraints && !lockAspectRatio) return [width, height];
      if (lockAspectRatio) {
        var ratio2 = this.props.width / this.props.height;
        var deltaW = width - this.props.width;
        var deltaH = height - this.props.height;
        if (Math.abs(deltaW) > Math.abs(deltaH * ratio2)) {
          height = width / ratio2;
        } else {
          width = height * ratio2;
        }
      }
      var oldW = width, oldH = height;
      var _ref = this.slack || [0, 0], slackW = _ref[0], slackH = _ref[1];
      width += slackW;
      height += slackH;
      if (minConstraints) {
        width = Math.max(minConstraints[0], width);
        height = Math.max(minConstraints[1], height);
      }
      if (maxConstraints) {
        width = Math.min(maxConstraints[0], width);
        height = Math.min(maxConstraints[1], height);
      }
      this.slack = [slackW + (oldW - width), slackH + (oldH - height)];
      return [width, height];
    };
    _proto.resizeHandler = function resizeHandler(handlerName, axis2) {
      var _this2 = this;
      return function(e, _ref2) {
        var node2 = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
        if (handlerName === "onResizeStart") _this2.resetData();
        var canDragX = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis2 !== "n" && axis2 !== "s";
        var canDragY = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis2 !== "e" && axis2 !== "w";
        if (!canDragX && !canDragY) return;
        var axisV = axis2[0];
        var axisH = axis2[axis2.length - 1];
        var handleRect = node2.getBoundingClientRect();
        if (_this2.lastHandleRect != null) {
          if (axisH === "w") {
            var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
            deltaX += deltaLeftSinceLast;
          }
          if (axisV === "n") {
            var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
            deltaY += deltaTopSinceLast;
          }
        }
        _this2.lastHandleRect = handleRect;
        if (axisH === "w") deltaX = -deltaX;
        if (axisV === "n") deltaY = -deltaY;
        var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
        var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
        var _this2$runConstraints = _this2.runConstraints(width, height);
        width = _this2$runConstraints[0];
        height = _this2$runConstraints[1];
        var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
        var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
        var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
        if (cb && !shouldSkipCb) {
          e.persist == null ? void 0 : e.persist();
          cb(e, {
            node: node2,
            size: {
              width,
              height
            },
            handle: axis2
          });
        }
        if (handlerName === "onResizeStop") _this2.resetData();
      };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref2) {
      var handle = this.props.handle;
      if (!handle) {
        return /* @__PURE__ */ React2.createElement("span", {
          className: "react-resizable-handle react-resizable-handle-" + handleAxis,
          ref: ref2
        });
      }
      if (typeof handle === "function") {
        return handle(handleAxis, ref2);
      }
      var isDOMElement = typeof handle.type === "string";
      var props = _objectSpread({
        ref: ref2
      }, isDOMElement ? {} : {
        handleAxis
      });
      return /* @__PURE__ */ React2.cloneElement(handle, props);
    };
    _proto.render = function render3() {
      var _this3 = this;
      var _this$props2 = this.props, children2 = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts;
      _this$props2.width;
      _this$props2.height;
      _this$props2.handle;
      _this$props2.handleSize;
      _this$props2.lockAspectRatio;
      _this$props2.axis;
      _this$props2.minConstraints;
      _this$props2.maxConstraints;
      _this$props2.onResize;
      _this$props2.onResizeStop;
      _this$props2.onResizeStart;
      var resizeHandles = _this$props2.resizeHandles;
      _this$props2.transformScale;
      var p = _objectWithoutPropertiesLoose(_this$props2, _excluded);
      return (0, _utils.cloneElement)(children2, _objectSpread(_objectSpread({}, p), {}, {
        className: (className ? className + " " : "") + "react-resizable",
        children: [].concat(children2.props.children, resizeHandles.map(function(handleAxis) {
          var _this3$handleRefs$han;
          var ref2 = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /* @__PURE__ */ React2.createRef();
          return /* @__PURE__ */ React2.createElement(_reactDraggable.DraggableCore, _extends2({}, draggableOpts, {
            nodeRef: ref2,
            key: "resizableHandle-" + handleAxis,
            onStop: _this3.resizeHandler("onResizeStop", handleAxis),
            onStart: _this3.resizeHandler("onResizeStart", handleAxis),
            onDrag: _this3.resizeHandler("onResize", handleAxis)
          }), _this3.renderResizeHandle(handleAxis, ref2));
        }))
      }));
    };
    return Resizable2;
  })(React2.Component);
  Resizable.default = Resizable$1;
  Resizable$1.propTypes = _propTypes.resizableProps;
  Resizable$1.defaultProps = {
    axis: "both",
    handleSize: [20, 20],
    lockAspectRatio: false,
    minConstraints: [20, 20],
    maxConstraints: [Infinity, Infinity],
    resizeHandles: ["se"],
    transformScale: 1
  };
  return Resizable;
}
var ResizableBox = {};
var hasRequiredResizableBox;
function requireResizableBox() {
  if (hasRequiredResizableBox) return ResizableBox;
  hasRequiredResizableBox = 1;
  ResizableBox.__esModule = true;
  ResizableBox.default = void 0;
  var React2 = _interopRequireWildcard(React__default);
  var _propTypes = _interopRequireDefault(/* @__PURE__ */ requirePropTypes$1());
  var _Resizable = _interopRequireDefault(requireResizable());
  var _propTypes2 = requirePropTypes();
  var _excluded = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache2 = _getRequireWildcardCache(nodeInterop);
    if (cache2 && cache2.has(obj)) {
      return cache2.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache2) {
      cache2.set(obj, newObj);
    }
    return newObj;
  }
  function _extends2() {
    _extends2 = Object.assign ? Object.assign.bind() : function(target2) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target2[key] = source[key];
          }
        }
      }
      return target2;
    };
    return _extends2.apply(this, arguments);
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys2 = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      })), keys2.push.apply(keys2, symbols);
    }
    return keys2;
  }
  function _objectSpread(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty2(target2, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target2, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target2, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target2;
  }
  function _defineProperty2(obj, key, value) {
    key = _toPropertyKey2(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey2(arg) {
    var key = _toPrimitive2(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive2(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== void 0) {
      var res = prim.call(input, hint);
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target2 = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target2[key] = source[key];
    }
    return target2;
  }
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  var ResizableBox$1 = /* @__PURE__ */ (function(_React$Component) {
    _inheritsLoose(ResizableBox2, _React$Component);
    function ResizableBox2() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.state = {
        width: _this.props.width,
        height: _this.props.height,
        propsWidth: _this.props.width,
        propsHeight: _this.props.height
      };
      _this.onResize = function(e, data2) {
        var size = data2.size;
        if (_this.props.onResize) {
          e.persist == null ? void 0 : e.persist();
          _this.setState(size, function() {
            return _this.props.onResize && _this.props.onResize(e, data2);
          });
        } else {
          _this.setState(size);
        }
      };
      return _this;
    }
    ResizableBox2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
      if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
        return {
          width: props.width,
          height: props.height,
          propsWidth: props.width,
          propsHeight: props.height
        };
      }
      return null;
    };
    var _proto = ResizableBox2.prototype;
    _proto.render = function render3() {
      var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize;
      _this$props.onResize;
      var onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis2 = _this$props.axis;
      _this$props.width;
      _this$props.height;
      var resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /* @__PURE__ */ React2.createElement(_Resizable.default, {
        axis: axis2,
        draggableOpts,
        handle,
        handleSize,
        height: this.state.height,
        lockAspectRatio,
        maxConstraints,
        minConstraints,
        onResizeStart,
        onResize: this.onResize,
        onResizeStop,
        resizeHandles,
        transformScale,
        width: this.state.width
      }, /* @__PURE__ */ React2.createElement("div", _extends2({}, props, {
        style: _objectSpread(_objectSpread({}, style), {}, {
          width: this.state.width + "px",
          height: this.state.height + "px"
        })
      })));
    };
    return ResizableBox2;
  })(React2.Component);
  ResizableBox.default = ResizableBox$1;
  ResizableBox$1.propTypes = _objectSpread(_objectSpread({}, _propTypes2.resizableProps), {}, {
    children: _propTypes.default.element
  });
  return ResizableBox;
}
var hasRequiredReactResizable;
function requireReactResizable() {
  if (hasRequiredReactResizable) return reactResizable.exports;
  hasRequiredReactResizable = 1;
  reactResizable.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
  };
  reactResizable.exports.Resizable = requireResizable().default;
  reactResizable.exports.ResizableBox = requireResizableBox().default;
  return reactResizable.exports;
}
var reactResizableExports = requireReactResizable();
function r(e) {
  var t, f2, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f2 = r(e[t])) && (n && (n += " "), n += f2);
  } else for (f2 in e) e[f2] && (n && (n += " "), n += f2);
  return n;
}
function clsx() {
  for (var e, t, f2 = 0, n = "", o = arguments.length; f2 < o; f2++) (e = arguments[f2]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
function GridItem(props) {
  const {
    children: children2,
    cols,
    containerWidth,
    margin,
    containerPadding,
    rowHeight,
    maxRows,
    isDraggable,
    isResizable,
    isBounded,
    static: isStatic,
    useCSSTransforms = true,
    usePercentages = false,
    transformScale = 1,
    positionStrategy,
    dragThreshold = 0,
    droppingPosition,
    className = "",
    style,
    handle = "",
    cancel = "",
    x,
    y,
    w,
    h,
    minW = 1,
    maxW = Infinity,
    minH = 1,
    maxH = Infinity,
    i,
    resizeHandles,
    resizeHandle,
    constraints = defaultConstraints,
    layoutItem,
    layout = [],
    onDragStart: onDragStartProp,
    onDrag: onDragProp,
    onDragStop: onDragStopProp,
    onResizeStart: onResizeStartProp,
    onResize: onResizeProp,
    onResizeStop: onResizeStopProp
  } = props;
  const [dragging, setDragging] = useState(false);
  const [resizing, setResizing] = useState(false);
  const elementRef = useRef(null);
  const dragPositionRef = useRef({ left: 0, top: 0 });
  const resizePositionRef = useRef({
    top: 0,
    left: 0,
    width: 0,
    height: 0
  });
  const prevDroppingPositionRef = useRef(
    void 0
  );
  const layoutRef = useRef(layout);
  layoutRef.current = layout;
  const onDragStartRef = useRef(null);
  const onDragRef = useRef(null);
  const dragPendingRef = useRef(false);
  const initialDragClientRef = useRef({ x: 0, y: 0 });
  const thresholdExceededRef = useRef(false);
  const positionParams = useMemo(
    () => ({
      cols,
      containerPadding,
      containerWidth,
      margin,
      maxRows,
      rowHeight
    }),
    [cols, containerPadding, containerWidth, margin, maxRows, rowHeight]
  );
  const constraintContext = useMemo(
    () => ({
      cols,
      maxRows,
      containerWidth,
      containerHeight: 0,
      // Auto-height grids don't have a fixed container height
      rowHeight,
      margin,
      // Use empty layout here - the actual layout will be accessed via layoutRef when needed
      // This prevents the context from changing when layout changes, avoiding callback recreation
      layout: []
    }),
    [cols, maxRows, containerWidth, rowHeight, margin]
  );
  const getConstraintContext = useCallback(
    () => ({
      ...constraintContext,
      layout: layoutRef.current
    }),
    [constraintContext]
  );
  const effectiveLayoutItem = useMemo(
    () => layoutItem ?? {
      i,
      x,
      y,
      w,
      h,
      minW,
      maxW,
      minH,
      maxH
    },
    [layoutItem, i, x, y, w, h, minW, maxW, minH, maxH]
  );
  const createStyle = useCallback(
    (pos2) => {
      if (positionStrategy?.calcStyle) {
        return positionStrategy.calcStyle(pos2);
      }
      if (useCSSTransforms) {
        return setTransform(pos2);
      }
      const styleObj = setTopLeft(pos2);
      if (usePercentages) {
        return {
          ...styleObj,
          left: perc(pos2.left / containerWidth),
          width: perc(pos2.width / containerWidth)
        };
      }
      return styleObj;
    },
    [positionStrategy, useCSSTransforms, usePercentages, containerWidth]
  );
  const onDragStart = useCallback(
    (e, { node: node2 }) => {
      if (!onDragStartProp) return;
      const { offsetParent } = node2;
      if (!offsetParent) return;
      const parentRect = offsetParent.getBoundingClientRect();
      const clientRect = node2.getBoundingClientRect();
      const cLeft = clientRect.left / transformScale;
      const pLeft = parentRect.left / transformScale;
      const cTop = clientRect.top / transformScale;
      const pTop = parentRect.top / transformScale;
      let newPosition;
      if (positionStrategy?.calcDragPosition) {
        const mouseEvent = e;
        newPosition = positionStrategy.calcDragPosition(
          mouseEvent.clientX,
          mouseEvent.clientY,
          mouseEvent.clientX - clientRect.left,
          mouseEvent.clientY - clientRect.top
        );
      } else {
        newPosition = {
          left: cLeft - pLeft + offsetParent.scrollLeft,
          top: cTop - pTop + offsetParent.scrollTop
        };
      }
      dragPositionRef.current = newPosition;
      if (dragThreshold > 0) {
        const mouseEvent = e;
        initialDragClientRef.current = {
          x: mouseEvent.clientX,
          y: mouseEvent.clientY
        };
        dragPendingRef.current = true;
        thresholdExceededRef.current = false;
        setDragging(true);
        return;
      }
      setDragging(true);
      const rawPos = calcXYRaw(
        positionParams,
        newPosition.top,
        newPosition.left
      );
      const { x: newX, y: newY } = applyPositionConstraints(
        constraints,
        effectiveLayoutItem,
        rawPos.x,
        rawPos.y,
        getConstraintContext()
      );
      onDragStartProp(i, newX, newY, {
        e,
        node: node2,
        newPosition
      });
    },
    [
      onDragStartProp,
      transformScale,
      positionParams,
      positionStrategy,
      dragThreshold,
      constraints,
      effectiveLayoutItem,
      getConstraintContext,
      i
    ]
  );
  const onDrag = useCallback(
    (e, { node: node2, deltaX, deltaY }) => {
      if (!onDragProp || !dragging) return;
      const mouseEvent = e;
      if (dragPendingRef.current && !thresholdExceededRef.current) {
        const dx = mouseEvent.clientX - initialDragClientRef.current.x;
        const dy = mouseEvent.clientY - initialDragClientRef.current.y;
        const distance2 = Math.hypot(dx, dy);
        if (distance2 < dragThreshold) {
          return;
        }
        thresholdExceededRef.current = true;
        dragPendingRef.current = false;
        if (onDragStartProp) {
          const rawPos2 = calcXYRaw(
            positionParams,
            dragPositionRef.current.top,
            dragPositionRef.current.left
          );
          const { x: startX, y: startY } = applyPositionConstraints(
            constraints,
            effectiveLayoutItem,
            rawPos2.x,
            rawPos2.y,
            getConstraintContext()
          );
          onDragStartProp(i, startX, startY, {
            e,
            node: node2,
            newPosition: dragPositionRef.current
          });
        }
      }
      let top2 = dragPositionRef.current.top + deltaY;
      let left2 = dragPositionRef.current.left + deltaX;
      if (isBounded) {
        const { offsetParent } = node2;
        if (offsetParent) {
          const bottomBoundary = offsetParent.clientHeight - calcGridItemWHPx(h, rowHeight, margin[1]);
          top2 = clamp$1(top2, 0, bottomBoundary);
          const colWidth = calcGridColWidth(positionParams);
          const rightBoundary = containerWidth - calcGridItemWHPx(w, colWidth, margin[0]);
          left2 = clamp$1(left2, 0, rightBoundary);
        }
      }
      const newPosition = { top: top2, left: left2 };
      dragPositionRef.current = newPosition;
      const rawPos = calcXYRaw(positionParams, top2, left2);
      const { x: newX, y: newY } = applyPositionConstraints(
        constraints,
        effectiveLayoutItem,
        rawPos.x,
        rawPos.y,
        getConstraintContext()
      );
      onDragProp(i, newX, newY, {
        e,
        node: node2,
        newPosition
      });
    },
    [
      onDragProp,
      onDragStartProp,
      dragging,
      dragThreshold,
      isBounded,
      h,
      rowHeight,
      margin,
      positionParams,
      containerWidth,
      w,
      i,
      constraints,
      effectiveLayoutItem,
      getConstraintContext
    ]
  );
  const onDragStop = useCallback(
    (e, { node: node2 }) => {
      if (!onDragStopProp || !dragging) return;
      const wasPending = dragPendingRef.current;
      dragPendingRef.current = false;
      thresholdExceededRef.current = false;
      initialDragClientRef.current = { x: 0, y: 0 };
      if (wasPending) {
        setDragging(false);
        dragPositionRef.current = { left: 0, top: 0 };
        return;
      }
      const { left: left2, top: top2 } = dragPositionRef.current;
      const newPosition = { top: top2, left: left2 };
      setDragging(false);
      dragPositionRef.current = { left: 0, top: 0 };
      const rawPos = calcXYRaw(positionParams, top2, left2);
      const { x: newX, y: newY } = applyPositionConstraints(
        constraints,
        effectiveLayoutItem,
        rawPos.x,
        rawPos.y,
        getConstraintContext()
      );
      onDragStopProp(i, newX, newY, {
        e,
        node: node2,
        newPosition
      });
    },
    [
      onDragStopProp,
      dragging,
      positionParams,
      constraints,
      effectiveLayoutItem,
      getConstraintContext,
      i
    ]
  );
  onDragStartRef.current = onDragStart;
  onDragRef.current = onDrag;
  const onResizeHandler = useCallback(
    (e, { node: node2, size, handle: resizeHandle2 }, position, handlerName) => {
      const handler = handlerName === "onResizeStart" ? onResizeStartProp : handlerName === "onResize" ? onResizeProp : onResizeStopProp;
      if (!handler) return;
      let updatedSize;
      if (node2) {
        updatedSize = resizeItemInDirection(
          resizeHandle2,
          position,
          size,
          containerWidth
        );
      } else {
        updatedSize = {
          ...size,
          top: position.top,
          left: position.left
        };
      }
      resizePositionRef.current = updatedSize;
      const rawSize = calcWHRaw(
        positionParams,
        updatedSize.width,
        updatedSize.height
      );
      const { w: newW, h: newH } = applySizeConstraints(
        constraints,
        effectiveLayoutItem,
        rawSize.w,
        rawSize.h,
        resizeHandle2,
        getConstraintContext()
      );
      handler(i, newW, newH, {
        e: e.nativeEvent,
        node: node2,
        size: updatedSize,
        handle: resizeHandle2
      });
    },
    [
      onResizeStartProp,
      onResizeProp,
      onResizeStopProp,
      containerWidth,
      positionParams,
      i,
      constraints,
      effectiveLayoutItem,
      getConstraintContext
    ]
  );
  const handleResizeStart = useCallback(
    (e, data2) => {
      setResizing(true);
      const pos2 = calcGridItemPosition(positionParams, x, y, w, h);
      const typedData = {
        ...data2,
        handle: data2.handle
      };
      onResizeHandler(e, typedData, pos2, "onResizeStart");
    },
    [onResizeHandler, positionParams, x, y, w, h]
  );
  const handleResize = useCallback(
    (e, data2) => {
      const pos2 = calcGridItemPosition(positionParams, x, y, w, h);
      const typedData = {
        ...data2,
        handle: data2.handle
      };
      onResizeHandler(e, typedData, pos2, "onResize");
    },
    [onResizeHandler, positionParams, x, y, w, h]
  );
  const handleResizeStop = useCallback(
    (e, data2) => {
      setResizing(false);
      resizePositionRef.current = { top: 0, left: 0, width: 0, height: 0 };
      const pos2 = calcGridItemPosition(positionParams, x, y, w, h);
      const typedData = {
        ...data2,
        handle: data2.handle
      };
      onResizeHandler(e, typedData, pos2, "onResizeStop");
    },
    [onResizeHandler, positionParams, x, y, w, h]
  );
  useEffect(() => {
    if (!droppingPosition) return;
    const node2 = elementRef.current;
    if (!node2) return;
    const prevDroppingPosition = prevDroppingPositionRef.current || {
      left: 0,
      top: 0
    };
    const shouldDrag = dragging && (droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top);
    if (!dragging) {
      const fakeData = {
        node: node2,
        deltaX: droppingPosition.left,
        deltaY: droppingPosition.top,
        lastX: 0,
        lastY: 0,
        x: droppingPosition.left,
        y: droppingPosition.top
      };
      onDragStartRef.current?.(
        droppingPosition.e,
        fakeData
      );
    } else if (shouldDrag) {
      const deltaX = droppingPosition.left - dragPositionRef.current.left;
      const deltaY = droppingPosition.top - dragPositionRef.current.top;
      const fakeData = {
        node: node2,
        deltaX,
        deltaY,
        lastX: dragPositionRef.current.left,
        lastY: dragPositionRef.current.top,
        x: droppingPosition.left,
        y: droppingPosition.top
      };
      onDragRef.current?.(
        droppingPosition.e,
        fakeData
      );
    }
    prevDroppingPositionRef.current = droppingPosition;
  }, [droppingPosition, dragging, i]);
  const pos = calcGridItemPosition(
    positionParams,
    x,
    y,
    w,
    h,
    dragging ? dragPositionRef.current : null,
    resizing ? resizePositionRef.current : null
  );
  const child = React__default.Children.only(children2);
  const minGridUnit = calcGridItemPosition(positionParams, 0, 0, 1, 1);
  const minConstraints = [
    minGridUnit.width,
    minGridUnit.height
  ];
  const maxConstraints = [Infinity, Infinity];
  const childProps = child.props;
  const childClassName = childProps["className"];
  const childStyle = childProps["style"];
  let newChild = React__default.cloneElement(child, {
    ref: elementRef,
    className: clsx("react-grid-item", childClassName, className, {
      static: isStatic,
      resizing,
      "react-draggable": isDraggable,
      "react-draggable-dragging": dragging,
      dropping: Boolean(droppingPosition),
      cssTransforms: useCSSTransforms
    }),
    style: {
      ...style,
      ...childStyle,
      ...createStyle(pos)
    }
  });
  const resizableHandle = resizeHandle;
  newChild = /* @__PURE__ */ jsx(
    reactResizableExports.Resizable,
    {
      draggableOpts: { disabled: !isResizable },
      className: isResizable ? void 0 : "react-resizable-hide",
      width: pos.width,
      height: pos.height,
      minConstraints,
      maxConstraints,
      onResizeStart: handleResizeStart,
      onResize: handleResize,
      onResizeStop: handleResizeStop,
      transformScale,
      resizeHandles,
      handle: resizableHandle,
      children: newChild
    }
  );
  newChild = /* @__PURE__ */ jsx(
    cjsExports.DraggableCore,
    {
      disabled: !isDraggable,
      onStart: onDragStart,
      onDrag,
      onStop: onDragStop,
      handle,
      cancel: ".react-resizable-handle" + (cancel ? "," + cancel : ""),
      scale: transformScale,
      nodeRef: elementRef,
      children: newChild
    }
  );
  return newChild;
}
var noop$4 = () => {
};
var layoutClassName = "react-grid-layout";
var isFirefox = false;
try {
  isFirefox = /firefox/i.test(navigator.userAgent);
} catch {
}
function childrenEqual(a, b) {
  const aArr = React__default.Children.toArray(a);
  const bArr = React__default.Children.toArray(b);
  if (aArr.length !== bArr.length) return false;
  for (let i = 0; i < aArr.length; i++) {
    const aChild = aArr[i];
    const bChild = bArr[i];
    if (aChild?.key !== bChild?.key) return false;
  }
  return true;
}
function synchronizeLayoutWithChildren(initialLayout, children2, cols, compactor) {
  const layout = [];
  const childKeys = /* @__PURE__ */ new Set();
  React__default.Children.forEach(children2, (child) => {
    if (!React__default.isValidElement(child) || child.key === null) return;
    const key = String(child.key);
    childKeys.add(key);
    const existingItem = initialLayout.find((l) => l.i === key);
    if (existingItem) {
      layout.push(cloneLayoutItem(existingItem));
    } else {
      const childProps = child.props;
      const dataGrid = childProps["data-grid"];
      if (dataGrid) {
        layout.push({
          i: key,
          x: dataGrid.x ?? 0,
          y: dataGrid.y ?? 0,
          w: dataGrid.w ?? 1,
          h: dataGrid.h ?? 1,
          minW: dataGrid.minW,
          maxW: dataGrid.maxW,
          minH: dataGrid.minH,
          maxH: dataGrid.maxH,
          static: dataGrid.static,
          isDraggable: dataGrid.isDraggable,
          isResizable: dataGrid.isResizable,
          resizeHandles: dataGrid.resizeHandles,
          isBounded: dataGrid.isBounded
        });
      } else {
        layout.push({
          i: key,
          x: 0,
          y: bottom$2(layout),
          w: 1,
          h: 1
        });
      }
    }
  });
  const corrected = correctBounds(layout, { cols });
  return compactor.compact(corrected, cols);
}
function GridLayout(props) {
  const {
    // Required
    children: children2,
    width,
    // Composable config interfaces
    gridConfig: gridConfigProp,
    dragConfig: dragConfigProp,
    resizeConfig: resizeConfigProp,
    dropConfig: dropConfigProp,
    positionStrategy = defaultPositionStrategy,
    compactor: compactorProp,
    constraints = defaultConstraints,
    // Layout data
    layout: propsLayout = [],
    droppingItem: droppingItemProp,
    // Container props
    autoSize = true,
    className = "",
    style = {},
    innerRef,
    // Callbacks
    onLayoutChange = noop$4,
    onDragStart: onDragStartProp = noop$4,
    onDrag: onDragProp = noop$4,
    onDragStop: onDragStopProp = noop$4,
    onResizeStart: onResizeStartProp = noop$4,
    onResize: onResizeProp = noop$4,
    onResizeStop: onResizeStopProp = noop$4,
    onDrop: onDropProp = noop$4,
    onDropDragOver: onDropDragOverProp = noop$4
  } = props;
  const gridConfig = useMemo(
    () => ({ ...defaultGridConfig, ...gridConfigProp }),
    [gridConfigProp]
  );
  const dragConfig = useMemo(
    () => ({ ...defaultDragConfig, ...dragConfigProp }),
    [dragConfigProp]
  );
  const resizeConfig = useMemo(
    () => ({ ...defaultResizeConfig, ...resizeConfigProp }),
    [resizeConfigProp]
  );
  const dropConfig = useMemo(
    () => ({ ...defaultDropConfig, ...dropConfigProp }),
    [dropConfigProp]
  );
  const { cols, rowHeight, maxRows, margin, containerPadding } = gridConfig;
  const {
    enabled: isDraggable,
    bounded: isBounded,
    handle: draggableHandle,
    cancel: draggableCancel,
    threshold: dragThreshold
  } = dragConfig;
  const {
    enabled: isResizable,
    handles: resizeHandles,
    handleComponent: resizeHandle
  } = resizeConfig;
  const {
    enabled: isDroppable,
    defaultItem: defaultDropItem,
    onDragOver: dropConfigOnDragOver
  } = dropConfig;
  const compactor = compactorProp ?? getCompactor("vertical");
  const compactType = compactor.type;
  const allowOverlap = compactor.allowOverlap;
  const preventCollision = compactor.preventCollision ?? false;
  const droppingItem = useMemo(
    () => droppingItemProp ?? {
      i: "__dropping-elem__",
      ...defaultDropItem
    },
    [droppingItemProp, defaultDropItem]
  );
  const useCSSTransforms = positionStrategy.type === "transform";
  const transformScale = positionStrategy.scale;
  const effectiveContainerPadding = containerPadding ?? margin;
  const [mounted, setMounted] = useState(false);
  const [layout, setLayout] = useState(
    () => synchronizeLayoutWithChildren(propsLayout, children2, cols, compactor)
  );
  const [activeDrag, setActiveDrag] = useState(null);
  const [resizing, setResizing] = useState(false);
  const [droppingDOMNode, setDroppingDOMNode] = useState(
    null
  );
  const [droppingPosition, setDroppingPosition] = useState();
  const oldDragItemRef = useRef(null);
  const oldResizeItemRef = useRef(null);
  const oldLayoutRef = useRef(null);
  const dragEnterCounterRef = useRef(0);
  const prevLayoutRef = useRef(layout);
  const prevPropsLayoutRef = useRef(propsLayout);
  const prevChildrenRef = useRef(children2);
  const prevCompactTypeRef = useRef(compactType);
  const layoutRef = useRef(layout);
  layoutRef.current = layout;
  useEffect(() => {
    setMounted(true);
    if (!deepEqual(layout, propsLayout)) {
      onLayoutChange(layout);
    }
  }, []);
  useEffect(() => {
    if (activeDrag) return;
    if (droppingDOMNode) return;
    const layoutChanged = !deepEqual(propsLayout, prevPropsLayoutRef.current);
    const childrenChanged = !childrenEqual(children2, prevChildrenRef.current);
    const compactTypeChanged = compactType !== prevCompactTypeRef.current;
    if (layoutChanged || childrenChanged || compactTypeChanged) {
      const baseLayout = layoutChanged ? propsLayout : layout;
      const newLayout = synchronizeLayoutWithChildren(
        baseLayout,
        children2,
        cols,
        compactor
      );
      if (!deepEqual(newLayout, layout)) {
        setLayout(newLayout);
      }
    }
    prevPropsLayoutRef.current = propsLayout;
    prevChildrenRef.current = children2;
    prevCompactTypeRef.current = compactType;
  }, [
    propsLayout,
    children2,
    cols,
    compactType,
    compactor,
    activeDrag,
    droppingDOMNode,
    layout
  ]);
  useEffect(() => {
    if (!activeDrag && !deepEqual(layout, prevLayoutRef.current)) {
      prevLayoutRef.current = layout;
      const publicLayout = layout.filter((l) => l.i !== droppingItem.i);
      onLayoutChange(publicLayout);
    }
  }, [layout, activeDrag, onLayoutChange, droppingItem.i]);
  const containerHeight = useMemo(() => {
    if (!autoSize) return void 0;
    const nbRow = bottom$2(layout);
    const containerPaddingY = effectiveContainerPadding[1];
    return nbRow * rowHeight + (nbRow - 1) * margin[1] + containerPaddingY * 2 + "px";
  }, [autoSize, layout, rowHeight, margin, effectiveContainerPadding]);
  const onDragStart = useCallback(
    (i, _x, _y, data2) => {
      const currentLayout = layoutRef.current;
      const l = getLayoutItem(currentLayout, i);
      if (!l) return;
      const placeholder = {
        w: l.w,
        h: l.h,
        x: l.x,
        y: l.y,
        i
      };
      oldDragItemRef.current = cloneLayoutItem(l);
      oldLayoutRef.current = currentLayout;
      setActiveDrag(placeholder);
      onDragStartProp(currentLayout, l, l, null, data2.e, data2.node);
    },
    [onDragStartProp]
  );
  const onDrag = useCallback(
    (i, x, y, data2) => {
      const currentLayout = layoutRef.current;
      const oldDragItem = oldDragItemRef.current;
      const l = getLayoutItem(currentLayout, i);
      if (!l) return;
      const placeholder = {
        w: l.w,
        h: l.h,
        x: l.x,
        y: l.y,
        i
      };
      const newLayout = moveElement(
        currentLayout,
        l,
        x,
        y,
        true,
        preventCollision,
        compactType,
        cols,
        allowOverlap
      );
      onDragProp(newLayout, oldDragItem, l, placeholder, data2.e, data2.node);
      setLayout(compactor.compact(newLayout, cols));
      setActiveDrag(placeholder);
    },
    [preventCollision, compactType, cols, allowOverlap, compactor, onDragProp]
  );
  const onDragStop = useCallback(
    (i, x, y, data2) => {
      if (!activeDrag) return;
      const currentLayout = layoutRef.current;
      const oldDragItem = oldDragItemRef.current;
      const l = getLayoutItem(currentLayout, i);
      if (!l) return;
      const newLayout = moveElement(
        currentLayout,
        l,
        x,
        y,
        true,
        preventCollision,
        compactType,
        cols,
        allowOverlap
      );
      const finalLayout = compactor.compact(newLayout, cols);
      onDragStopProp(finalLayout, oldDragItem, l, null, data2.e, data2.node);
      const oldLayout = oldLayoutRef.current;
      oldDragItemRef.current = null;
      oldLayoutRef.current = null;
      setActiveDrag(null);
      setLayout(finalLayout);
      if (oldLayout && !deepEqual(oldLayout, finalLayout)) {
        onLayoutChange(finalLayout);
      }
    },
    [
      activeDrag,
      preventCollision,
      compactType,
      cols,
      allowOverlap,
      compactor,
      onDragStopProp,
      onLayoutChange
    ]
  );
  const onResizeStart = useCallback(
    (i, _w, _h, data2) => {
      const currentLayout = layoutRef.current;
      const l = getLayoutItem(currentLayout, i);
      if (!l) return;
      oldResizeItemRef.current = cloneLayoutItem(l);
      oldLayoutRef.current = currentLayout;
      setResizing(true);
      onResizeStartProp(currentLayout, l, l, null, data2.e, data2.node);
    },
    [onResizeStartProp]
  );
  const onResize = useCallback(
    (i, w, h, data2) => {
      const currentLayout = layoutRef.current;
      const oldResizeItem = oldResizeItemRef.current;
      const { handle } = data2;
      let shouldMoveItem = false;
      let newX;
      let newY;
      const [newLayout, l] = withLayoutItem(currentLayout, i, (item) => {
        newX = item.x;
        newY = item.y;
        if (["sw", "w", "nw", "n", "ne"].includes(handle)) {
          if (["sw", "nw", "w"].includes(handle)) {
            newX = item.x + (item.w - w);
            w = item.x !== newX && newX < 0 ? item.w : w;
            newX = newX < 0 ? 0 : newX;
          }
          if (["ne", "n", "nw"].includes(handle)) {
            newY = item.y + (item.h - h);
            h = item.y !== newY && newY < 0 ? item.h : h;
            newY = newY < 0 ? 0 : newY;
          }
          shouldMoveItem = true;
        }
        if (preventCollision && !allowOverlap) {
          const collisions = getAllCollisions(currentLayout, {
            ...item,
            w,
            h,
            x: newX ?? item.x,
            y: newY ?? item.y
          }).filter((layoutItem) => layoutItem.i !== item.i);
          if (collisions.length > 0) {
            newY = item.y;
            h = item.h;
            newX = item.x;
            w = item.w;
            shouldMoveItem = false;
          }
        }
        item.w = w;
        item.h = h;
        return item;
      });
      if (!l) return;
      let finalLayout = newLayout;
      if (shouldMoveItem && newX !== void 0 && newY !== void 0) {
        finalLayout = moveElement(
          newLayout,
          l,
          newX,
          newY,
          true,
          preventCollision,
          compactType,
          cols,
          allowOverlap
        );
      }
      const placeholder = {
        w: l.w,
        h: l.h,
        x: l.x,
        y: l.y,
        i,
        static: true
      };
      onResizeProp(
        finalLayout,
        oldResizeItem,
        l,
        placeholder,
        data2.e,
        data2.node
      );
      setLayout(compactor.compact(finalLayout, cols));
      setActiveDrag(placeholder);
    },
    [preventCollision, compactType, cols, allowOverlap, compactor, onResizeProp]
  );
  const onResizeStop = useCallback(
    (i, _w, _h, data2) => {
      const currentLayout = layoutRef.current;
      const oldResizeItem = oldResizeItemRef.current;
      const l = getLayoutItem(currentLayout, i);
      const finalLayout = compactor.compact(currentLayout, cols);
      onResizeStopProp(
        finalLayout,
        oldResizeItem,
        l ?? null,
        null,
        data2.e,
        data2.node
      );
      const oldLayout = oldLayoutRef.current;
      oldResizeItemRef.current = null;
      oldLayoutRef.current = null;
      setActiveDrag(null);
      setResizing(false);
      setLayout(finalLayout);
      if (oldLayout && !deepEqual(oldLayout, finalLayout)) {
        onLayoutChange(finalLayout);
      }
    },
    [cols, compactor, onResizeStopProp, onLayoutChange]
  );
  const removeDroppingPlaceholder = useCallback(() => {
    const currentLayout = layoutRef.current;
    const hasDroppingItem = currentLayout.some((l) => l.i === droppingItem.i);
    if (!hasDroppingItem) {
      setDroppingDOMNode(null);
      setActiveDrag(null);
      setDroppingPosition(void 0);
      return;
    }
    const newLayout = compactor.compact(
      currentLayout.filter((l) => l.i !== droppingItem.i),
      cols
    );
    setLayout(newLayout);
    setDroppingDOMNode(null);
    setActiveDrag(null);
    setDroppingPosition(void 0);
  }, [droppingItem.i, cols, compactor]);
  const handleDragOver = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isFirefox && !e.nativeEvent.target?.classList.contains(
        layoutClassName
      )) {
        return false;
      }
      const rawResult = dropConfigOnDragOver ? dropConfigOnDragOver(e.nativeEvent) : onDropDragOverProp(e);
      if (rawResult === false) {
        if (droppingDOMNode) {
          removeDroppingPlaceholder();
        }
        return false;
      }
      const {
        dragOffsetX = 0,
        dragOffsetY = 0,
        ...onDragOverResult
      } = rawResult ?? {};
      const finalDroppingItem = { ...droppingItem, ...onDragOverResult };
      const gridRect = e.currentTarget.getBoundingClientRect();
      const positionParams = {
        cols,
        margin,
        maxRows,
        rowHeight,
        containerWidth: width,
        containerPadding: effectiveContainerPadding
      };
      const actualColWidth = calcGridColWidth(positionParams);
      const itemPixelWidth = calcGridItemWHPx(
        finalDroppingItem.w,
        actualColWidth,
        margin[0]
      );
      const itemPixelHeight = calcGridItemWHPx(
        finalDroppingItem.h,
        rowHeight,
        margin[1]
      );
      const itemCenterOffsetX = itemPixelWidth / 2;
      const itemCenterOffsetY = itemPixelHeight / 2;
      const rawGridX = e.clientX - gridRect.left + dragOffsetX - itemCenterOffsetX;
      const rawGridY = e.clientY - gridRect.top + dragOffsetY - itemCenterOffsetY;
      const clampedGridX = Math.max(0, rawGridX);
      const clampedGridY = Math.max(0, rawGridY);
      const newDroppingPosition = {
        left: clampedGridX / transformScale,
        top: clampedGridY / transformScale,
        e: e.nativeEvent
      };
      if (!droppingDOMNode) {
        const calculatedPosition = calcXY(
          positionParams,
          clampedGridY,
          clampedGridX,
          finalDroppingItem.w,
          finalDroppingItem.h
        );
        setDroppingDOMNode(/* @__PURE__ */ jsx("div", {}, finalDroppingItem.i));
        setDroppingPosition(newDroppingPosition);
        setLayout([
          ...layoutRef.current,
          {
            ...finalDroppingItem,
            x: calculatedPosition.x,
            y: calculatedPosition.y,
            static: false,
            isDraggable: true
          }
        ]);
      } else if (droppingPosition) {
        const shouldUpdate = droppingPosition.left !== newDroppingPosition.left || droppingPosition.top !== newDroppingPosition.top;
        if (shouldUpdate) {
          setDroppingPosition(newDroppingPosition);
        }
      }
    },
    [
      droppingDOMNode,
      droppingPosition,
      droppingItem,
      dropConfigOnDragOver,
      onDropDragOverProp,
      removeDroppingPlaceholder,
      transformScale,
      cols,
      margin,
      maxRows,
      rowHeight,
      width,
      effectiveContainerPadding
    ]
  );
  const handleDragLeave = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      dragEnterCounterRef.current--;
      if (dragEnterCounterRef.current < 0) {
        dragEnterCounterRef.current = 0;
      }
      if (dragEnterCounterRef.current === 0) {
        removeDroppingPlaceholder();
      }
    },
    [removeDroppingPlaceholder]
  );
  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    dragEnterCounterRef.current++;
  }, []);
  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      const currentLayout = layoutRef.current;
      const item = currentLayout.find((l) => l.i === droppingItem.i);
      dragEnterCounterRef.current = 0;
      removeDroppingPlaceholder();
      onDropProp(currentLayout, item, e.nativeEvent);
    },
    [droppingItem.i, removeDroppingPlaceholder, onDropProp]
  );
  const processGridItem = useCallback(
    (child, isDroppingItem) => {
      if (!child || !child.key) return null;
      const l = getLayoutItem(layout, String(child.key));
      if (!l) return null;
      const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
      const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
      const resizeHandlesOptions = l.resizeHandles || [...resizeHandles];
      const bounded = draggable && isBounded && l.isBounded !== false;
      const resizeHandleElement = resizeHandle;
      return /* @__PURE__ */ jsx(
        GridItem,
        {
          containerWidth: width,
          cols,
          margin,
          containerPadding: effectiveContainerPadding,
          maxRows,
          rowHeight,
          cancel: draggableCancel,
          handle: draggableHandle,
          onDragStart,
          onDrag,
          onDragStop,
          onResizeStart,
          onResize,
          onResizeStop,
          isDraggable: draggable,
          isResizable: resizable,
          isBounded: bounded,
          useCSSTransforms: useCSSTransforms && mounted,
          usePercentages: !mounted,
          transformScale,
          positionStrategy,
          dragThreshold,
          w: l.w,
          h: l.h,
          x: l.x,
          y: l.y,
          i: l.i,
          minH: l.minH,
          minW: l.minW,
          maxH: l.maxH,
          maxW: l.maxW,
          static: l.static,
          droppingPosition: isDroppingItem ? droppingPosition : void 0,
          resizeHandles: resizeHandlesOptions,
          resizeHandle: resizeHandleElement,
          constraints,
          layoutItem: l,
          layout,
          children: child
        },
        l.i
      );
    },
    [
      layout,
      width,
      cols,
      margin,
      effectiveContainerPadding,
      maxRows,
      rowHeight,
      draggableCancel,
      draggableHandle,
      onDragStart,
      onDrag,
      onDragStop,
      onResizeStart,
      onResize,
      onResizeStop,
      isDraggable,
      isResizable,
      isBounded,
      useCSSTransforms,
      mounted,
      transformScale,
      positionStrategy,
      dragThreshold,
      droppingPosition,
      resizeHandles,
      resizeHandle,
      constraints
    ]
  );
  const renderPlaceholder = () => {
    if (!activeDrag) return null;
    return /* @__PURE__ */ jsx(
      GridItem,
      {
        w: activeDrag.w,
        h: activeDrag.h,
        x: activeDrag.x,
        y: activeDrag.y,
        i: activeDrag.i,
        className: `react-grid-placeholder ${resizing ? "placeholder-resizing" : ""}`,
        containerWidth: width,
        cols,
        margin,
        containerPadding: effectiveContainerPadding,
        maxRows,
        rowHeight,
        isDraggable: false,
        isResizable: false,
        isBounded: false,
        useCSSTransforms,
        transformScale,
        constraints,
        layout,
        children: /* @__PURE__ */ jsx("div", {})
      }
    );
  };
  const mergedClassName = clsx(layoutClassName, className);
  const mergedStyle = {
    height: containerHeight,
    ...style
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: innerRef,
      className: mergedClassName,
      style: mergedStyle,
      onDrop: isDroppable ? handleDrop : void 0,
      onDragLeave: isDroppable ? handleDragLeave : void 0,
      onDragEnter: isDroppable ? handleDragEnter : void 0,
      onDragOver: isDroppable ? handleDragOver : void 0,
      children: [
        React__default.Children.map(children2, (child) => {
          if (!React__default.isValidElement(child)) return null;
          return processGridItem(child);
        }),
        isDroppable && droppingDOMNode && processGridItem(droppingDOMNode, true),
        renderPlaceholder()
      ]
    }
  );
}
var slugid$2 = {};
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$1(uuid) {
  return typeof uuid === "string" && REGEX.test(uuid);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).substr(1));
}
function stringify$2(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate$1(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1(options2, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options2 = options2 || {};
  var node2 = options2.node || _nodeId;
  var clockseq = options2.clockseq !== void 0 ? options2.clockseq : _clockseq;
  if (node2 == null || clockseq == null) {
    var seedBytes = options2.random || (options2.rng || rng)();
    if (node2 == null) {
      node2 = _nodeId = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options2.msecs !== void 0 ? options2.msecs : Date.now();
  var nsecs = options2.nsecs !== void 0 ? options2.nsecs : _lastNSecs + 1;
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options2.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options2.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b[i++] = tl >>> 24 & 255;
  b[i++] = tl >>> 16 & 255;
  b[i++] = tl >>> 8 & 255;
  b[i++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b[i++] = tmh >>> 8 & 255;
  b[i++] = tmh & 255;
  b[i++] = tmh >>> 24 & 15 | 16;
  b[i++] = tmh >>> 16 & 255;
  b[i++] = clockseq >>> 8 | 128;
  b[i++] = clockseq & 255;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node2[n];
  }
  return buf || stringify$2(b);
}
function parse$3(uuid) {
  if (!validate$1(uuid)) {
    throw TypeError("Invalid UUID");
  }
  var v;
  var arr = new Uint8Array(16);
  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 255;
  arr[2] = v >>> 8 & 255;
  arr[3] = v & 255;
  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 255;
  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 255;
  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 255;
  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v / 4294967296 & 255;
  arr[12] = v >>> 24 & 255;
  arr[13] = v >>> 16 & 255;
  arr[14] = v >>> 8 & 255;
  arr[15] = v & 255;
  return arr;
}
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  var bytes = [];
  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }
  return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(name, version2, hashfunc) {
  function generateUUID(value, namespace2, buf, offset) {
    if (typeof value === "string") {
      value = stringToBytes(value);
    }
    if (typeof namespace2 === "string") {
      namespace2 = parse$3(namespace2);
    }
    if (namespace2.length !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace2);
    bytes.set(value, namespace2.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version2;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset = offset || 0;
      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }
      return buf;
    }
    return stringify$2(bytes);
  }
  try {
    generateUUID.name = name;
  } catch (err) {
  }
  generateUUID.DNS = DNS;
  generateUUID.URL = URL$1;
  return generateUUID;
}
function md5(bytes) {
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = new Uint8Array(msg.length);
    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = "0123456789abcdef";
  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 255;
    var hex2 = parseInt(hexTab.charAt(x >>> 4 & 15) + hexTab.charAt(x & 15), 16);
    output.push(hex2);
  }
  return output;
}
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x, len) {
  x[len >> 5] |= 128 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));
  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 255) << i % 32;
  }
  return output;
}
function safeAdd(x, y) {
  var lsw = (x & 65535) + (y & 65535);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function bitRotateLeft(num2, cnt) {
  return num2 << cnt | num2 >>> 32 - cnt;
}
function md5cmn(q2, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q2), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
var v3 = v35("v3", 48, md5);
function v4(options2, buf, offset) {
  options2 = options2 || {};
  var rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify$2(rnds);
}
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;
    case 1:
      return x ^ y ^ z;
    case 2:
      return x & y ^ x & z ^ y & z;
    case 3:
      return x ^ y ^ z;
  }
}
function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}
function sha1(bytes) {
  var K2 = [1518500249, 1859775393, 2400959708, 3395469782];
  var H = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof bytes === "string") {
    var msg = unescape(encodeURIComponent(bytes));
    bytes = [];
    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(128);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M2 = new Array(N);
  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);
    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }
    M2[_i] = arr;
  }
  M2[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M2[N - 1][14] = Math.floor(M2[N - 1][14]);
  M2[N - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);
    for (var t = 0; t < 16; ++t) {
      W[t] = M2[_i2][t];
    }
    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }
    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];
    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K2[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }
    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }
  return [H[0] >> 24 & 255, H[0] >> 16 & 255, H[0] >> 8 & 255, H[0] & 255, H[1] >> 24 & 255, H[1] >> 16 & 255, H[1] >> 8 & 255, H[1] & 255, H[2] >> 24 & 255, H[2] >> 16 & 255, H[2] >> 8 & 255, H[2] & 255, H[3] >> 24 & 255, H[3] >> 16 & 255, H[3] >> 8 & 255, H[3] & 255, H[4] >> 24 & 255, H[4] >> 16 & 255, H[4] >> 8 & 255, H[4] & 255];
}
var v5 = v35("v5", 80, sha1);
const nil = "00000000-0000-0000-0000-000000000000";
function version$1(uuid) {
  if (!validate$1(uuid)) {
    throw TypeError("Invalid UUID");
  }
  return parseInt(uuid.substr(14, 1), 16);
}
const esmBrowser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: nil,
  parse: parse$3,
  stringify: stringify$2,
  v1,
  v3,
  v4,
  v5,
  validate: validate$1,
  version: version$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$6 = /* @__PURE__ */ getAugmentedNamespace(esmBrowser);
var hasRequiredSlugid$1;
function requireSlugid$1() {
  if (hasRequiredSlugid$1) return slugid$2;
  hasRequiredSlugid$1 = 1;
  var uuid = require$$0$6;
  var toBase64 = (() => {
    if (typeof Buffer !== "undefined") {
      return (bytes) => Buffer.from(bytes).toString("base64");
    }
    return (bytes) => btoa(String.fromCharCode(...bytes));
  })();
  var fromBase64 = (() => {
    if (typeof Buffer !== "undefined") {
      return (base64) => Buffer.from(base64, "base64");
    }
    return (base64) => Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  })();
  slugid$2.encode = function(uuid_) {
    var bytes = uuid.parse(uuid_);
    var base64 = toBase64(bytes);
    var slug = base64.replace(/\+/g, "-").replace(/\//g, "_").substring(0, 22);
    return slug;
  };
  slugid$2.decode = function(slug) {
    var base64 = slug.replace(/-/g, "+").replace(/_/g, "/") + "==";
    return uuid.stringify(fromBase64(base64));
  };
  slugid$2.v4 = function() {
    var bytes = uuid.v4(null, new Uint8Array(16));
    var base64 = toBase64(bytes);
    var slug = base64.replace(/\+/g, "-").replace(/\//g, "_").substring(0, 22);
    return slug;
  };
  slugid$2.nice = function() {
    var bytes = uuid.v4(null, new Uint8Array(16));
    bytes[0] = bytes[0] & 127;
    var base64 = toBase64(bytes);
    var slug = base64.replace(/\+/g, "-").replace(/\//g, "_").substring(0, 22);
    return slug;
  };
  return slugid$2;
}
var slugid$1;
var hasRequiredSlugid;
function requireSlugid() {
  if (hasRequiredSlugid) return slugid$1;
  hasRequiredSlugid = 1;
  slugid$1 = requireSlugid$1();
  return slugid$1;
}
var slugidExports = requireSlugid();
const slugid = /* @__PURE__ */ getDefaultExportFromCjs(slugidExports);
var vkbeautify_1;
var hasRequiredVkbeautify;
function requireVkbeautify() {
  if (hasRequiredVkbeautify) return vkbeautify_1;
  hasRequiredVkbeautify = 1;
  function createShiftArr(step) {
    var space = "    ";
    if (isNaN(parseInt(step))) {
      space = step;
    } else {
      switch (step) {
        case 1:
          space = " ";
          break;
        case 2:
          space = "  ";
          break;
        case 3:
          space = "   ";
          break;
        case 4:
          space = "    ";
          break;
        case 5:
          space = "     ";
          break;
        case 6:
          space = "      ";
          break;
        case 7:
          space = "       ";
          break;
        case 8:
          space = "        ";
          break;
        case 9:
          space = "         ";
          break;
        case 10:
          space = "          ";
          break;
        case 11:
          space = "           ";
          break;
        case 12:
          space = "            ";
          break;
      }
    }
    var shift2 = ["\n"];
    for (var ix = 0; ix < 100; ix++) {
      shift2.push(shift2[ix] + space);
    }
    return shift2;
  }
  function vkbeautify2() {
    this.step = "    ";
    this.shift = createShiftArr(this.step);
  }
  vkbeautify2.prototype.xml = function(text2, step) {
    var ar = text2.replace(/>\s{0,}</g, "><").replace(/</g, "~::~<").replace(/\s*xmlns\:/g, "~::~xmlns:").replace(/\s*xmlns\=/g, "~::~xmlns=").split("~::~"), len = ar.length, inComment = false, deep = 0, str = "", ix = 0, shift2 = step ? createShiftArr(step) : this.shift;
    for (ix = 0; ix < len; ix++) {
      if (ar[ix].search(/<!/) > -1) {
        str += shift2[deep] + ar[ix];
        inComment = true;
        if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1 || ar[ix].search(/!DOCTYPE/) > -1) {
          inComment = false;
        }
      } else if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1) {
        str += ar[ix];
        inComment = false;
      } else if (/^<\w/.exec(ar[ix - 1]) && /^<\/\w/.exec(ar[ix]) && /^<[\w:\-\.\,]+/.exec(ar[ix - 1]) == /^<\/[\w:\-\.\,]+/.exec(ar[ix])[0].replace("/", "")) {
        str += ar[ix];
        if (!inComment) deep--;
      } else if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) == -1 && ar[ix].search(/\/>/) == -1) {
        str = !inComment ? str += shift2[deep++] + ar[ix] : str += ar[ix];
      } else if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) > -1) {
        str = !inComment ? str += shift2[deep] + ar[ix] : str += ar[ix];
      } else if (ar[ix].search(/<\//) > -1) {
        str = !inComment ? str += shift2[--deep] + ar[ix] : str += ar[ix];
      } else if (ar[ix].search(/\/>/) > -1) {
        str = !inComment ? str += shift2[deep] + ar[ix] : str += ar[ix];
      } else if (ar[ix].search(/<\?/) > -1) {
        str += shift2[deep] + ar[ix];
      } else if (ar[ix].search(/xmlns\:/) > -1 || ar[ix].search(/xmlns\=/) > -1) {
        str += shift2[deep] + ar[ix];
      } else {
        str += ar[ix];
      }
    }
    return str[0] == "\n" ? str.slice(1) : str;
  };
  vkbeautify2.prototype.json = function(text2, step) {
    var step = step ? step : this.step;
    if (typeof JSON === "undefined") return text2;
    if (typeof text2 === "string") return JSON.stringify(JSON.parse(text2), null, step);
    if (typeof text2 === "object") return JSON.stringify(text2, null, step);
    return text2;
  };
  vkbeautify2.prototype.css = function(text2, step) {
    var ar = text2.replace(/\s{1,}/g, " ").replace(/\{/g, "{~::~").replace(/\}/g, "~::~}~::~").replace(/\;/g, ";~::~").replace(/\/\*/g, "~::~/*").replace(/\*\//g, "*/~::~").replace(/~::~\s{0,}~::~/g, "~::~").split("~::~"), len = ar.length, deep = 0, str = "", ix = 0, shift2 = step ? createShiftArr(step) : this.shift;
    for (ix = 0; ix < len; ix++) {
      if (/\{/.exec(ar[ix])) {
        str += shift2[deep++] + ar[ix];
      } else if (/\}/.exec(ar[ix])) {
        str += shift2[--deep] + ar[ix];
      } else if (/\*\\/.exec(ar[ix])) {
        str += shift2[deep] + ar[ix];
      } else {
        str += shift2[deep] + ar[ix];
      }
    }
    return str.replace(/^\n{1,}/, "");
  };
  function isSubquery(str, parenthesisLevel) {
    return parenthesisLevel - (str.replace(/\(/g, "").length - str.replace(/\)/g, "").length);
  }
  function split_sql(str, tab) {
    return str.replace(/\s{1,}/g, " ").replace(/ AND /ig, "~::~" + tab + tab + "AND ").replace(/ BETWEEN /ig, "~::~" + tab + "BETWEEN ").replace(/ CASE /ig, "~::~" + tab + "CASE ").replace(/ ELSE /ig, "~::~" + tab + "ELSE ").replace(/ END /ig, "~::~" + tab + "END ").replace(/ FROM /ig, "~::~FROM ").replace(/ GROUP\s{1,}BY/ig, "~::~GROUP BY ").replace(/ HAVING /ig, "~::~HAVING ").replace(/ IN /ig, " IN ").replace(/ JOIN /ig, "~::~JOIN ").replace(/ CROSS~::~{1,}JOIN /ig, "~::~CROSS JOIN ").replace(/ INNER~::~{1,}JOIN /ig, "~::~INNER JOIN ").replace(/ LEFT~::~{1,}JOIN /ig, "~::~LEFT JOIN ").replace(/ RIGHT~::~{1,}JOIN /ig, "~::~RIGHT JOIN ").replace(/ ON /ig, "~::~" + tab + "ON ").replace(/ OR /ig, "~::~" + tab + tab + "OR ").replace(/ ORDER\s{1,}BY/ig, "~::~ORDER BY ").replace(/ OVER /ig, "~::~" + tab + "OVER ").replace(/\(\s{0,}SELECT /ig, "~::~(SELECT ").replace(/\)\s{0,}SELECT /ig, ")~::~SELECT ").replace(/ THEN /ig, " THEN~::~" + tab).replace(/ UNION /ig, "~::~UNION~::~").replace(/ USING /ig, "~::~USING ").replace(/ WHEN /ig, "~::~" + tab + "WHEN ").replace(/ WHERE /ig, "~::~WHERE ").replace(/ WITH /ig, "~::~WITH ").replace(/ ALL /ig, " ALL ").replace(/ AS /ig, " AS ").replace(/ ASC /ig, " ASC ").replace(/ DESC /ig, " DESC ").replace(/ DISTINCT /ig, " DISTINCT ").replace(/ EXISTS /ig, " EXISTS ").replace(/ NOT /ig, " NOT ").replace(/ NULL /ig, " NULL ").replace(/ LIKE /ig, " LIKE ").replace(/\s{0,}SELECT /ig, "SELECT ").replace(/\s{0,}UPDATE /ig, "UPDATE ").replace(/ SET /ig, " SET ").replace(/~::~{1,}/g, "~::~").split("~::~");
  }
  vkbeautify2.prototype.sql = function(text2, step) {
    var ar_by_quote = text2.replace(/\s{1,}/g, " ").replace(/\'/ig, "~::~'").split("~::~"), len = ar_by_quote.length, ar = [], deep = 0, tab = this.step, parenthesisLevel = 0, str = "", ix = 0, shift2 = step ? createShiftArr(step) : this.shift;
    for (ix = 0; ix < len; ix++) {
      if (ix % 2) {
        ar = ar.concat(ar_by_quote[ix]);
      } else {
        ar = ar.concat(split_sql(ar_by_quote[ix], tab));
      }
    }
    len = ar.length;
    for (ix = 0; ix < len; ix++) {
      parenthesisLevel = isSubquery(ar[ix], parenthesisLevel);
      if (/\s{0,}\s{0,}SELECT\s{0,}/.exec(ar[ix])) {
        ar[ix] = ar[ix].replace(/\,/g, ",\n" + tab + tab);
      }
      if (/\s{0,}\s{0,}SET\s{0,}/.exec(ar[ix])) {
        ar[ix] = ar[ix].replace(/\,/g, ",\n" + tab + tab);
      }
      if (/\s{0,}\(\s{0,}SELECT\s{0,}/.exec(ar[ix])) {
        deep++;
        str += shift2[deep] + ar[ix];
      } else if (/\'/.exec(ar[ix])) {
        if (parenthesisLevel < 1 && deep) {
          deep--;
        }
        str += ar[ix];
      } else {
        str += shift2[deep] + ar[ix];
        if (parenthesisLevel < 1 && deep) {
          deep--;
        }
      }
    }
    str = str.replace(/^\n{1,}/, "").replace(/\n{1,}/g, "\n");
    return str;
  };
  vkbeautify2.prototype.xmlmin = function(text2, preserveComments) {
    var str = preserveComments ? text2 : text2.replace(/\<![ \r\n\t]*(--([^\-]|[\r\n]|-[^\-])*--[ \r\n\t]*)\>/g, "").replace(/[ \r\n\t]{1,}xmlns/g, " xmlns");
    return str.replace(/>\s{0,}</g, "><");
  };
  vkbeautify2.prototype.jsonmin = function(text2) {
    if (typeof JSON === "undefined") return text2;
    return JSON.stringify(JSON.parse(text2), null, 0);
  };
  vkbeautify2.prototype.cssmin = function(text2, preserveComments) {
    var str = preserveComments ? text2 : text2.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\//g, "");
    return str.replace(/\s{1,}/g, " ").replace(/\{\s{1,}/g, "{").replace(/\}\s{1,}/g, "}").replace(/\;\s{1,}/g, ";").replace(/\/\*\s{1,}/g, "/*").replace(/\*\/\s{1,}/g, "*/");
  };
  vkbeautify2.prototype.sqlmin = function(text2) {
    return text2.replace(/\s{1,}/g, " ").replace(/\s{1,}\(/, "(").replace(/\s{1,}\)/, ")");
  };
  vkbeautify_1 = new vkbeautify2();
  return vkbeautify_1;
}
var vkbeautifyExports = requireVkbeautify();
const vkbeautify = /* @__PURE__ */ getDefaultExportFromCjs(vkbeautifyExports);
var EOL$1 = {}, EOF$1 = {}, QUOTE$1 = 34, NEWLINE$1 = 10, RETURN$1 = 13;
function objectConverter$1(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter$1(columns, f2) {
  var object2 = objectConverter$1(columns);
  return function(row, i) {
    return f2(object2(row), i, columns);
  };
}
function inferColumns$1(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad$1(value, width) {
  var s = value + "", length2 = s.length;
  return length2 < width ? new Array(width - length2 + 1).join(0) + s : s;
}
function formatYear$1(year) {
  return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
}
function formatDate$1(date2) {
  var hours = date2.getUTCHours(), minutes = date2.getUTCMinutes(), seconds = date2.getUTCSeconds(), milliseconds = date2.getUTCMilliseconds();
  return isNaN(date2) ? "Invalid Date" : formatYear$1(date2.getUTCFullYear()) + "-" + pad$1(date2.getUTCMonth() + 1, 2) + "-" + pad$1(date2.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
}
function dsv$2(delimiter) {
  var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
  function parse2(text2, f2) {
    var convert, columns, rows = parseRows(text2, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f2 ? customConverter$1(row, f2) : objectConverter$1(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text2, f2) {
    var rows = [], N = text2.length, I = 0, n = 0, t, eof = N <= 0, eol = false;
    if (text2.charCodeAt(N - 1) === NEWLINE$1) --N;
    if (text2.charCodeAt(N - 1) === RETURN$1) --N;
    function token() {
      if (eof) return EOF$1;
      if (eol) return eol = false, EOL$1;
      var i, j = I, c;
      if (text2.charCodeAt(j) === QUOTE$1) {
        while (I++ < N && text2.charCodeAt(I) !== QUOTE$1 || text2.charCodeAt(++I) === QUOTE$1) ;
        if ((i = I) >= N) eof = true;
        else if ((c = text2.charCodeAt(I++)) === NEWLINE$1) eol = true;
        else if (c === RETURN$1) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE$1) ++I;
        }
        return text2.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c = text2.charCodeAt(i = I++)) === NEWLINE$1) eol = true;
        else if (c === RETURN$1) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE$1) ++I;
        } else if (c !== DELIMITER) continue;
        return text2.slice(j, i);
      }
      return eof = true, text2.slice(j, N);
    }
    while ((t = token()) !== EOF$1) {
      var row = [];
      while (t !== EOL$1 && t !== EOF$1) row.push(t), t = token();
      if (f2 && (row = f2(row, n++)) == null) continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format2(rows, columns) {
    if (columns == null) columns = inferColumns$1(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null) columns = inferColumns$1(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value) {
    return value == null ? "" : value instanceof Date ? formatDate$1(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
  }
  return {
    parse: parse2,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var csv$2 = dsv$2(",");
var csvParse$1 = csv$2.parse;
var csvParseRows = csv$2.parseRows;
var csvFormat = csv$2.format;
var csvFormatBody = csv$2.formatBody;
var csvFormatRows = csv$2.formatRows;
var csvFormatRow = csv$2.formatRow;
var csvFormatValue = csv$2.formatValue;
var tsv$2 = dsv$2("	");
var tsvParse$1 = tsv$2.parse;
var tsvParseRows = tsv$2.parseRows;
var tsvFormat = tsv$2.format;
var tsvFormatBody = tsv$2.formatBody;
var tsvFormatRows = tsv$2.formatRows;
var tsvFormatRow = tsv$2.formatRow;
var tsvFormatValue = tsv$2.formatValue;
function autoType(object2) {
  for (var key in object2) {
    var value = object2[key].trim(), number3, m;
    if (!value) value = null;
    else if (value === "true") value = true;
    else if (value === "false") value = false;
    else if (value === "NaN") value = NaN;
    else if (!isNaN(number3 = +value)) value = number3;
    else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
      value = new Date(value);
    } else continue;
    object2[key] = value;
  }
  return object2;
}
const fixtz = (/* @__PURE__ */ new Date("2019-01-01T00:00")).getHours() || (/* @__PURE__ */ new Date("2019-07-01T00:00")).getHours();
const d3Dsv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  autoType,
  csvFormat,
  csvFormatBody,
  csvFormatRow,
  csvFormatRows,
  csvFormatValue,
  csvParse: csvParse$1,
  csvParseRows,
  dsvFormat: dsv$2,
  tsvFormat,
  tsvFormatBody,
  tsvFormatRow,
  tsvFormatRows,
  tsvFormatValue,
  tsvParse: tsvParse$1,
  tsvParseRows
}, Symbol.toStringTag, { value: "Module" }));
function parseChromsizesRows(data2) {
  const cumValues = [];
  const chromLengths = {};
  const chrPositions = {};
  let totalLength = 0;
  for (let i = 0; i < data2.length; i++) {
    const length2 = Number(data2[i][1]);
    totalLength += length2;
    const newValue = {
      id: i,
      chr: data2[i][0],
      pos: totalLength - length2
    };
    cumValues.push(newValue);
    chrPositions[newValue.chr] = newValue;
    chromLengths[data2[i][0]] = length2;
  }
  return {
    cumPositions: cumValues,
    chrPositions,
    totalLength,
    chromLengths
  };
}
const cache$1 = {};
const getFromCache = (url, fallback) => cache$1[url] ? Promise.resolve(cache$1[url]) : fallback(url);
const parseChromInfo = (text2) => {
  if (text2.length === 0) return null;
  const tsv2 = tsvParseRows(text2);
  return parseChromsizesRows(tsv2);
};
const getFromRemote = (url) => fetch(url, {
  credentials: "same-origin"
}).then((response) => response.text()).then((text2) => parseChromInfo(text2)).catch((error) => {
  console.error("Could not retrieve or parse chrom info.", error);
  return null;
});
const cacheResults = (key, getter, fallback) => getter(key, fallback).then((results) => {
  if (results) cache$1[key] = results;
  return results;
});
const get$8 = (url) => cacheResults(url, getFromCache, getFromRemote);
const api$1 = {
  get: get$8
};
function _classCallCheck$1C(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1u(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1u(o.key), o);
  }
}
function _createClass$1C(e, r2, t) {
  return r2 && _defineProperties$1u(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1u(t) {
  var i = _toPrimitive$1u(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1u(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let DomEvent = /* @__PURE__ */ (function() {
  function DomEvent2(pubSub) {
    _classCallCheck$1C(this, DomEvent2);
    this.customEventHandlers = {};
    this.registeredEls = {};
    this.pubSub = pubSub;
  }
  return _createClass$1C(DomEvent2, [{
    key: "getEventHandler",
    value: function getEventHandler(eventName) {
      if (this.customEventHandlers[eventName]) {
        return this.customEventHandlers[eventName];
      }
      return (event) => this.pubSub.publish(eventName, event);
    }
    /**
     * Unregister an event listener.
     *
     * @param {string} event - Name of the event to stop listening from.
     * @param {object} element - DOM element which we listened to.
     */
  }, {
    key: "unregister",
    value: function unregister(event, element) {
      if (!this.registeredEls[event] && this.registeredEls[event] !== element) return;
      this.registeredEls[event].removeEventListener(event, this.registeredEls[event].__handler__);
      this.registeredEls[event] = void 0;
      delete this.registeredEls[event];
    }
    /**
     * Register an event listener.
     *
     * @param {string} event - Name of the event to listen to.
     * @param {object} newElement - DOM element which to listen to.
     */
  }, {
    key: "register",
    value: function register(event, newElement, useCapture = false) {
      if (!newElement || this.registeredEls[event] === newElement) {
        return;
      }
      if (this.registeredEls[event]) {
        this.unregister(this.registeredEls[event]);
      }
      this.registeredEls[event] = newElement;
      this.registeredEls[event].__handler__ = this.getEventHandler(event);
      this.registeredEls[event].addEventListener(event, this.registeredEls[event].__handler__, {
        capture: useCapture,
        passive: false
      });
    }
  }]);
})();
const domEvent = (pubSub) => new DomEvent(pubSub);
const chromInfoBisector = bisector((d) => d.pos).left;
const absToChr = (absPosition, chromInfo) => {
  if (!chromInfo || !chromInfo.cumPositions || !chromInfo.cumPositions.length) {
    return null;
  }
  let insertPoint = chromInfoBisector(chromInfo.cumPositions, absPosition);
  const lastChr = chromInfo.cumPositions[chromInfo.cumPositions.length - 1].chr;
  const lastLength = chromInfo.chromLengths[lastChr];
  if (insertPoint > 0) {
    insertPoint -= 1;
  }
  let chrPosition = Math.floor(absPosition - chromInfo.cumPositions[insertPoint].pos);
  let offset = 0;
  if (chrPosition < 0) {
    offset = chrPosition - 1;
    chrPosition = 1;
  }
  if (insertPoint === chromInfo.cumPositions.length - 1 && chrPosition > lastLength) {
    offset = chrPosition - lastLength;
    chrPosition = lastLength;
  }
  return [chromInfo.cumPositions[insertPoint].chr, chrPosition, offset, insertPoint];
};
const accessorTransposition = (x, y) => (i) => i % x * y + Math.floor(i / x);
const identity$5 = (i) => i;
const addArrays = (a1, a2, accessor = identity$5) => a1.map((val, i) => val + a2[accessor(i)]);
const XMLNS$2 = "http://www.w3.org/2000/svg";
const hasClass = (el2, className) => {
  if (el2.namespaceURI === XMLNS$2) {
    const _class = el2.getAttribute("class");
    return !!_class && !!_class.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
  }
  if (el2.classList) return el2.classList.contains(className);
  return !!el2.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
};
const XMLNS$1 = "http://www.w3.org/2000/svg";
const addClass = (el2, className) => {
  if (el2.namespaceURI === XMLNS$1) {
    if (!hasClass(el2, className)) {
      const _class = el2.getAttribute("class") || "";
      el2.setAttribute("class", `${_class} ${className}`);
    }
  } else if (el2.classList) {
    el2.classList.add(className);
  } else if (!hasClass(el2, className)) {
    el2.className += ` ${className}`;
  }
};
const base64ToCanvas = (base64, width, height) => {
  const canvas = document.createElement("canvas");
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = () => {
      canvas.width = width || img.width;
      canvas.height = height || img.height;
      const context = canvas.getContext("2d");
      if (!context) {
        reject(new Error("Could not get canvas context"));
        return;
      }
      context.drawImage(img, 0, 0);
      resolve(canvas);
    };
    img.onerror = () => {
      reject(new Error("Could not convert base64 to canvas"));
    };
    img.src = `data:image/png;base64,${base64}`;
  });
};
const chrToAbs = (chrom, chromPos, chromInfo) => chromInfo.chrPositions[chrom].pos + chromPos;
const cloneEvent = (event) => {
  if (!(event instanceof Event)) {
    throw new Error("Event must be an instance of Event");
  }
  const newEvent = new event.constructor(event.type, event);
  newEvent.sourceUid = event.sourceUid;
  newEvent.forwarded = event.forwarded;
  return newEvent;
};
const colorDomainToRgbaArray = (colorRange, noTansparent = false) => {
  const domain2 = colorRange.map((x, i) => i * (255 / (colorRange.length - 1)));
  const d3Scale2 = linear().domain(domain2).range(
    // @ts-expect-error - d3-color types aren't correctly inferred here
    colorRange
  );
  const fromX = noTansparent ? 255 : 254;
  const rgbaArray = range$4(fromX, -1, -1).map(d3Scale2).map((x) => {
    const r2 = rgb(x);
    return [r2.r, r2.g, r2.b, r2.opacity * 255];
  });
  if (rgbaArray.length < 256) rgbaArray.push([255, 255, 255, 0]);
  return rgbaArray;
};
const GLOBALS = {
  PIXI
};
const colorToHex = (colorValue) => {
  const c = color(colorValue);
  const hex2 = GLOBALS.PIXI.utils.rgb2hex([c.r / 255, c.g / 255, c.b / 255]);
  return hex2;
};
const colorToRgba = (colorValue) => {
  if (colorValue === "transparent") {
    return [255, 255, 255, 0];
  }
  const c = color(colorValue);
  return [c.r, c.g, c.b, 255];
};
const dataToGenomicLoci = (x02, x12, chromInfo) => {
  const gX0 = absToChr(x02, chromInfo);
  const gX1 = absToChr(x12, chromInfo);
  if (!gX0 || !gX1) {
    throw new Error("Couldn't convert data to genomic coordinates");
  }
  return [gX0[0], Math.round(gX0[1]), gX1[0], Math.round(gX1[1])];
};
const debounce$1 = (func, wait, immediate) => {
  let timeout2;
  const debounced = (...args) => {
    const later = () => {
      timeout2 = void 0;
      if (!immediate) {
        func(...args);
      }
    };
    const callNow = immediate && !timeout2;
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, wait);
    if (callNow) {
      func(...args);
    }
  };
  debounced.cancel = () => {
    clearTimeout(timeout2);
    timeout2 = void 0;
  };
  return debounced;
};
const decToHexStr = (dec) => (dec + 16 ** 6).toString(16).substr(-6);
const dictFromTuples = (tuples) => {
  const dict = {};
  tuples.forEach((x) => {
    dict[x[0]] = x[1];
  });
  return dict;
};
const dictItems = (dictionary) => {
  const keyValues = [];
  for (const key in dictionary) {
    if (dictionary.hasOwnProperty(key)) {
      keyValues.push([key, dictionary[key]]);
    }
  }
  return keyValues;
};
function dictKeys(dictionary) {
  const keys2 = [];
  for (const key in dictionary) {
    if (dictionary.hasOwnProperty(key)) {
      keys2.push(key);
    }
  }
  return keys2;
}
function dictValues(dictionary) {
  const values = [];
  for (const key in dictionary) {
    if (dictionary.hasOwnProperty(key)) {
      values.push(dictionary[key]);
    }
  }
  return values;
}
function download(filename, stringOrBlob) {
  const blob = typeof stringOrBlob === "string" ? new Blob([stringOrBlob], {
    type: "application/octet-stream"
  }) : stringOrBlob;
  const elem = window.document.createElement("a");
  elem.href = window.URL.createObjectURL(blob);
  elem.download = filename;
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
  URL.revokeObjectURL(elem.href);
}
const DEFAULT_VIEW_MARGIN = 0;
const DEFAULT_VIEW_PADDING = 5;
const DEFAULT_CONTAINER_PADDING_X = 10;
const DEFAULT_CONTAINER_PADDING_Y = 10;
const MAX_CLICK_DELAY$1 = 300;
const MOUSE_TOOL_MOVE = "move";
const MOUSE_TOOL_SELECT = "select";
const MOUSE_TOOL_TRACK_SELECT = "track-select";
const TILE_FETCH_DEBOUNCE = 100;
const ZOOM_DEBOUNCE = 10;
const SHORT_DRAG_TIMEOUT = 110;
const LONG_DRAG_TIMEOUT = 3e3;
const LOCATION_LISTENER_PREFIX = "locationListenerPrefix";
const ZOOM_TRANSITION_DURATION = 1e3;
const DEFAULT_SERVER = "http://higlass.io/api/v1";
const VIEW_HEADER_MED_WIDTH_SEARCH_BAR = 400;
const VIEW_HEADER_MIN_WIDTH_SEARCH_BAR = 300;
const TRACK_LOCATIONS = (
  /** @type {const} */
  ["top", "left", "right", "bottom", "center", "whole", "gallery"]
);
const MIN_HORIZONTAL_HEIGHT = 20;
const MIN_VERTICAL_WIDTH = 20;
const THEME_LIGHT = /* @__PURE__ */ Symbol("Light theme");
const THEME_DARK = /* @__PURE__ */ Symbol("Dark theme");
const THEME_DEFAULT = THEME_LIGHT;
const stylesMTHeader = {
  "multitrack-header": "_multitrack-header_4g480_1",
  "multitrack-header-focus": "_multitrack-header-focus_4g480_2",
  "multitrack-header-squeazed": "_multitrack-header-squeazed_4g480_3",
  "multitrack-header-dark": "_multitrack-header-dark_4g480_20",
  "multitrack-header-id": "_multitrack-header-id_4g480_30",
  "multitrack-header-left": "_multitrack-header-left_4g480_39",
  "multitrack-header-grabber": "_multitrack-header-grabber_4g480_44",
  "multitrack-header-grabber-squeazed": "_multitrack-header-grabber-squeazed_4g480_45",
  "multitrack-header-search": "_multitrack-header-search_4g480_80",
  "multitrack-header-nav-list": "_multitrack-header-nav-list_4g480_102",
  "multitrack-header-icon": "_multitrack-header-icon_4g480_107",
  "multitrack-header-icon-squeazed": "_multitrack-header-icon-squeazed_4g480_108",
  "mouse-tool-selection": "_mouse-tool-selection_4g480_136"
};
const COLLAPSE = {
  id: "collapse",
  paths: ["M22.6,15.4a1.9,1.9,0,0,0,2.8,0l6-5.9a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L26,9.2V4a2,2,0,0,0-4,0V9.2L19.4,6.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7Z", "M25.4,32.6a1.9,1.9,0,0,0-2.8,0l-6,5.9a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L22,38.8V44a2,2,0,0,0,4,0V38.8l2.6,2.6a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7Z", "M6,22H42a2,2,0,0,0,0-4H6a2,2,0,0,0,0,4Z", "M42,26H6a2,2,0,0,0,0,4H42a2,2,0,0,0,0-4Z"],
  viewBox: "0 0 48 48"
};
const EXPAND = {
  id: "expand",
  paths: ["M28.6,17.4a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7l-6-5.9a1.9,1.9,0,0,0-2.8,0l-6,5.9a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L22,14.8V33.2l-2.6-2.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7l6,5.9a1.9,1.9,0,0,0,2.8,0l6-5.9a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L26,33.2V14.8Z", "M6,6H42a2,2,0,0,0,0-4H6A2,2,0,0,0,6,6Z", "M42,42H6a2,2,0,0,0,0,4H42a2,2,0,0,0,0-4Z"],
  viewBox: "0 0 48 48"
};
const COG = {
  id: "cog",
  paths: ["M466.895 305.125c-26.863-46.527-10.708-106.152 36.076-133.244l-50.313-87.146c-14.375 8.427-31.088 13.259-48.923 13.259-53.768 0-97.354-43.873-97.354-97.995h-100.629c0.133 16.705-4.037 33.641-12.979 49.126-26.862 46.528-86.578 62.351-133.431 35.379l-50.312 87.146c14.485 8.236 27.025 20.294 35.943 35.739 26.819 46.454 10.756 105.96-35.854 133.112l50.313 87.146c14.325-8.348 30.958-13.127 48.7-13.127 53.598 0 97.072 43.596 97.35 97.479h100.627c-0.043-16.537 4.136-33.285 12.983-48.609 26.818-46.453 86.388-62.297 133.207-35.506l50.313-87.145c-14.39-8.233-26.846-20.249-35.717-35.614zM256 359.666c-57.254 0-103.668-46.412-103.668-103.667 0-57.254 46.413-103.667 103.668-103.667s103.666 46.413 103.666 103.667c-0.001 57.255-46.412 103.667-103.666 103.667z"],
  viewBox: "0 0 512 512"
};
const CROSS = {
  id: "cross",
  paths: ["M507.331 411.33c-0.002-0.002-0.004-0.004-0.006-0.005l-155.322-155.325 155.322-155.325c0.002-0.002 0.004-0.003 0.006-0.005 1.672-1.673 2.881-3.627 3.656-5.708 2.123-5.688 0.912-12.341-3.662-16.915l-73.373-73.373c-4.574-4.573-11.225-5.783-16.914-3.66-2.080 0.775-4.035 1.984-5.709 3.655 0 0.002-0.002 0.003-0.004 0.005l-155.324 155.326-155.324-155.325c-0.002-0.002-0.003-0.003-0.005-0.005-1.673-1.671-3.627-2.88-5.707-3.655-5.69-2.124-12.341-0.913-16.915 3.66l-73.374 73.374c-4.574 4.574-5.784 11.226-3.661 16.914 0.776 2.080 1.985 4.036 3.656 5.708 0.002 0.001 0.003 0.003 0.005 0.005l155.325 155.324-155.325 155.326c-0.001 0.002-0.003 0.003-0.004 0.005-1.671 1.673-2.88 3.627-3.657 5.707-2.124 5.688-0.913 12.341 3.661 16.915l73.374 73.373c4.575 4.574 11.226 5.784 16.915 3.661 2.080-0.776 4.035-1.985 5.708-3.656 0.001-0.002 0.003-0.003 0.005-0.005l155.324-155.325 155.324 155.325c0.002 0.001 0.004 0.003 0.006 0.004 1.674 1.672 3.627 2.881 5.707 3.657 5.689 2.123 12.342 0.913 16.914-3.661l73.373-73.374c4.574-4.574 5.785-11.227 3.662-16.915-0.776-2.080-1.985-4.034-3.657-5.707z"],
  viewBox: "0 0 512 512"
};
const ENLARGE = {
  id: "enlarge",
  paths: ["M512 0h-208l80 80-96 96 48 48 96-96 80 80z", "M512 512v-208l-80 80-96-96-48 48 96 96-80 80z", "M0 512h208l-80-80 96-96-48-48-96 96-80-80z", "M0 0v208l80-80 96 96 48-48-96-96 80-80z"],
  viewBox: "0 0 512 512"
};
const MINUS = {
  id: "minus",
  paths: ["M0 208v96c0 8.836 7.164 16 16 16h480c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16h-480c-8.836 0-16 7.164-16 16z"],
  viewBox: "0 0 512 512"
};
const MOVE = {
  id: "move",
  paths: ["M512,260.096L405.5,161.79v49.155H301.061v-104.45h49.149L251.904,0L160.77,106.495h49.15v104.45H106.495V161.79L0,260.096l106.495,91.135v-49.149h104.45v104.45H161.79L251.904,512l98.306-106.5h-49.149V301.061H405.5v49.149L512,260.096z"],
  viewBox: "0 0 512 512"
};
const PLAY = {
  id: "play",
  paths: ["M96 64l320 192-320 192z"],
  viewBox: "0 0 512 512"
};
const PLUS = {
  id: "plus",
  paths: ["M496 192h-176v-176c0-8.836-7.164-16-16-16h-96c-8.836 0-16 7.164-16 16v176h-176c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h176v176c0 8.836 7.164 16 16 16h96c8.836 0 16-7.164 16-16v-176h176c8.836 0 16-7.164 16-16v-96c0-8.836-7.164-16-16-16z"],
  viewBox: "0 0 512 512"
};
const CONTENT_COPY = {
  id: "copy",
  paths: ["M607.5 672v-448.5h-351v448.5h351zM607.5 160.5c34.5 0 64.5 28.5 64.5 63v448.5c0 34.5-30 64.5-64.5 64.5h-351c-34.5 0-64.5-30-64.5-64.5v-448.5c0-34.5 30-63 64.5-63h351zM511.5 31.5v64.5h-384v448.5h-63v-448.5c0-34.5 28.5-64.5 63-64.5h384z"],
  viewBox: "0 0 712 712"
};
const SELECT = {
  id: "select",
  viewBox: "0 0 16 16",
  paths: ["M2 14h2v1H1v-3h1v2zm8 1H6v-1h4v1zm5 0h-3v-1h2v-2h1v3zm0-5h-1V6h1v4zM2 10H1V6h1v4zm13-6h-1V2h-2V1h3v3zM4 2H2v2H1V1h3v1zm6 0H6V1h4.03L10 2z"]
};
const CHECK_SQUARE_O = {
  id: "check_square_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"]
};
const SQUARE_O = {
  id: "square_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1312 256h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-832q0-66-47-113t-113-47zm288 160v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"]
};
const FILE_O = {
  id: "file_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z"]
};
const CHEVRON_RIGHT = {
  id: "chevron_right",
  viewBox: "0 0 1792 1792",
  paths: ["M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"]
};
const CHEVRON_DOWN = {
  id: "chevron_down",
  viewBox: "0 0 1792 1792",
  paths: ["M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"]
};
const FOLDER_O = {
  id: "folder_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1600 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zm128-704v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"]
};
const FOLDER_OPEN_O = {
  id: "folder_open_o",
  viewBox: "0 0 1792 1792",
  paths: ["M1845 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zm-1141-163h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zm1269 163q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z"]
};
const all = [COLLAPSE, EXPAND, COG, CROSS, ENLARGE, MINUS, MOVE, PLAY, PLUS, CONTENT_COPY, SELECT, CHECK_SQUARE_O, SQUARE_O, FILE_O, FOLDER_O, FOLDER_OPEN_O, CHEVRON_RIGHT, CHEVRON_DOWN];
const parser$1 = new DOMParser();
const svgGeoMapStr = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1.5"><path d="M4 2.1L.5 3.5v12l5-2 5 2 5-2v-12l-5 2-3.17-1.268M10.5 3.5v12" fill="none" stroke="currentColor"/><path d="M5.5 13.5v-7" fill="none" stroke="currentColor" stroke-width=".9969299999999999"/><path d="M5.494 0c-1.803 0-3.26 1.496-3.26 3.35 0 .427.124.97.264 1.343L5.5 11l3.003-6.306c.142-.375.263-.916.263-1.342C8.766 1.496 7.3 0 5.494 0zM5.5 4.64c-.76 0-1.375-.616-1.375-1.374 0-.76.616-1.376 1.375-1.376.76 0 1.374.616 1.374 1.376 0 .758-.614 1.375-1.374 1.375z" fill="currentColor"/></svg>';
const svgGeoMapIcon = parser$1.parseFromString(svgGeoMapStr, "text/xml").documentElement;
const horizontal1dHeatmap = `
<svg width="20px" height="20px" viewBox="0 0 20 20">
  <rect x="0" y="3" width="4" height="14" fill="#637993"/>
  <rect x="4" y="3" width="2" height="14" fill="#c7d1de"/>
  <rect x="6" y="3" width="5" height="14" fill="#3c5068"/>
  <rect x="11" y="3" width="3" height="14" fill="#92a3ba"/>
  <rect x="14" y="3" width="2" height="14" fill="#000000"/>
  <rect x="16" y="3" width="4" height="14" fill="#637993"/>
</svg>
`;
const svgHorizontal1dHeatmap = parser$1.parseFromString(horizontal1dHeatmap, "text/xml").documentElement;
const horizontalLineStr = `
<svg width="20px" height="20px" viewBox="0 0 135 85" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>line</title>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polyline id="Path" stroke="#4990E2" stroke-width="8" points="2 45.5625 20.7460938 6.3359375 36.828125 86.6484375 59.8945312 17.5742188 79.0390625 70.703125 99.9335938 27 112.769531 81.1601562 132.078125 3"></polyline>
    </g>
</svg>
`;
const svgHorizontalLineIcon = parser$1.parseFromString(horizontalLineStr, "text/xml").documentElement;
const tiles2DIconStr = `
<svg width="20px" height="20px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>2d-tiles-icon</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="tiles2DIconStr-path-1" x="0" y="0" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-1"></use>
        </mask>
        <rect id="tiles2DIconStr-path-3" x="0" y="30" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-3"></use>
        </mask>
        <rect id="tiles2DIconStr-path-5" x="30" y="0" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-5"></use>
        </mask>
        <rect id="tiles2DIconStr-path-7" x="30" y="30" width="30" height="30"></rect>
        <mask id="tiles2DIconStr-mask-8" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="30" height="30" fill="white">
            <use xlink:href="#tiles2DIconStr-path-7"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-2)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-4)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-3"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-6)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-5"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles2DIconStr-mask-8)" stroke-width="6" fill="#EEE0E0" xlink:href="#tiles2DIconStr-path-7"></use>
    </g>
</svg>
`;
const svg2DTilesIcon = parser$1.parseFromString(tiles2DIconStr, "text/xml").documentElement;
const heatmap2DStr = `
<svg width="20px" height="20px" viewBox="0 0 90 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>2d-heatmap</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="heatmap2DStr-path-1" x="0" y="0" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-2" x="30" y="0" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-3" x="60" y="0" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-4" x="0" y="30" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-5" x="30" y="30" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-6" x="60" y="30" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-7" x="0" y="60" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-8" x="30" y="60" width="30" height="30"></rect>
        <rect id="heatmap2DStr-path-9" x="60" y="60" width="30" height="30"></rect>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <use id="Rectangle" fill="#858372" xlink:href="#heatmap2DStr-path-1"></use>
        <use id="Rectangle" fill="#BBBAA4" xlink:href="#heatmap2DStr-path-2"></use>
        <use id="Rectangle" fill="#ECECD5" xlink:href="#heatmap2DStr-path-3"></use>
        <use id="Rectangle" fill="#BCBD9E" xlink:href="#heatmap2DStr-path-4"></use>
        <use id="Rectangle" fill="#817C7C" xlink:href="#heatmap2DStr-path-5"></use>
        <use id="Rectangle" fill="#BBBAA4" xlink:href="#heatmap2DStr-path-6"></use>
        <use id="Rectangle" fill="#ECECD5" xlink:href="#heatmap2DStr-path-7"></use>
        <use id="Rectangle" fill="#BBBAA4" xlink:href="#heatmap2DStr-path-8"></use>
        <use id="Rectangle" fill="#7B7777" xlink:href="#heatmap2DStr-path-9"></use>
    </g>
</svg>
`;
const svg2DHeatmapIcon = parser$1.parseFromString(heatmap2DStr, "text/xml").documentElement;
const axis1D = `
<svg width="20px" height="20px" viewBox="0 0 77 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>axis-1d</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polyline id="Path" stroke="#979797" stroke-width="8" transform="translate(38.258485, 27.557860) scale(1, -1) translate(-38.258485, -27.557860) " points="4 27.05786 36.7512307 27.05786 72.5169695 27.05786"></polyline>
        <path d="M38,24.484375 L38,3" id="Path-2" stroke="#979797" stroke-width="4"></path>
    </g>
</svg>
`;
const svg1DAxisIcon = parser$1.parseFromString(axis1D, "text/xml").documentElement;
const svgVertical1DAxisIcon = select(parser$1.parseFromString(axis1D, "text/xml").documentElement).style("transform", "rotate(90deg)").node();
const geneAnnotations = `
<svg width="20px" height="20px" viewBox="0 0 171 116" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 41 (35326) - http://www.bohemiancoding.com/sketch -->
    <title>gene-annotations</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="geneAnnotations-path-1" x="34" y="0" width="24" height="116"></rect>
        <mask id="geneAnnotations-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="24" height="116" fill="white">
            <use xlink:href="#geneAnnotations-path-1"></use>
        </mask>
        <rect id="geneAnnotations-path-3" x="80" y="0" width="56" height="116"></rect>
        <mask id="geneAnnotations-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="56" height="116" fill="white">
            <use xlink:href="#geneAnnotations-path-3"></use>
        </mask>
        <rect id="geneAnnotations-path-5" x="147" y="40" width="24" height="35"></rect>
        <mask id="geneAnnotations-mask-6" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="24" height="35" fill="white">
            <use xlink:href="#geneAnnotations-path-5"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12.71875,58 L147.10172,58" id="Path" stroke="#979797" stroke-width="8"></path>
        <use id="Rectangle" stroke="#979797" mask="url(#geneAnnotations-mask-2)" stroke-width="4" fill="#DDDD66" xlink:href="#geneAnnotations-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#geneAnnotations-mask-4)" stroke-width="4" fill="#DDDD66" xlink:href="#geneAnnotations-path-3"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#geneAnnotations-mask-6)" stroke-width="4" fill="#DDDD66" xlink:href="#geneAnnotations-path-5"></use>
        <polygon id="Triangle" stroke="#979797" fill="#D8D8D8" points="25 57.5 1 75 1 40"></polygon>
    </g>
</svg>
`;
const svgGeneAnnotationsIcon = parser$1.parseFromString(geneAnnotations, "text/xml").documentElement;
const tiles1DIconStr = `
<svg width="20px" height="20px" viewBox="0 0 180 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
    <title>1d-tiles-icon</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="tiles1DIconStr-path-1" x="0" y="0" width="90" height="90"></rect>
        <mask id="tiles1DIconStr-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="90" height="90" fill="white">
            <use xlink:href="#tiles1DIconStr-path-1"></use>
        </mask>
        <rect id="tiles1DIconStr-path-3" x="90" y="0" width="90" height="90"></rect>
        <mask id="tiles1DIconStr-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="90" height="90" fill="white">
            <use xlink:href="#tiles1DIconStr-path-3"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <use id="Rectangle" stroke="#979797" mask="url(#tiles1DIconStr-mask-2)" stroke-width="12" fill="#E6D5D5" xlink:href="#tiles1DIconStr-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#tiles1DIconStr-mask-4)" stroke-width="12" fill="#E6D5D5" xlink:href="#tiles1DIconStr-path-3"></use>
    </g>
</svg>
`;
const svg1DTilesIcon = parser$1.parseFromString(tiles1DIconStr, "text/xml").documentElement;
const svgVertical1DTilesIcon = select(parser$1.parseFromString(tiles1DIconStr, "text/xml").documentElement).style("transform", "rotate(90deg)").node();
const arrowHeadDomainsStr = `
<svg width="20px" height="20px" viewBox="0 0 111 111" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->
    <title>arrowhead-domains</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <rect id="arrowHeadDomainsStr-path-1" x="0" y="0" width="90" height="90"></rect>
        <mask id="arrowHeadDomainsStr-mask-2" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="90" height="90" fill="white">
            <use xlink:href="#arrowHeadDomainsStr-path-1"></use>
        </mask>
        <rect id="arrowHeadDomainsStr-path-3" x="52" y="52" width="59" height="59"></rect>
        <mask id="arrowHeadDomainsStr-mask-4" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="59" height="59" fill="white">
            <use xlink:href="#arrowHeadDomainsStr-path-3"></use>
        </mask>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0">
        <use id="Rectangle" stroke="#979797" mask="url(#arrowHeadDomainsStr-mask-2)" stroke-width="22" fill="#D8D8D8" xlink:href="#arrowHeadDomainsStr-path-1"></use>
        <use id="Rectangle" stroke="#979797" mask="url(#arrowHeadDomainsStr-mask-4)" stroke-width="22" fill="#D8D8D8" xlink:href="#arrowHeadDomainsStr-path-3"></use>
    </g>
</svg>
`;
const svgArrowheadDomainsIcon = parser$1.parseFromString(arrowHeadDomainsStr, "text/xml").documentElement;
function SearchIcon({
  theStyle,
  onClick
}) {
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: stylesMTHeader[theStyle],
    viewBox: "0 0 12 13",
    onClick,
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, "Search"), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none",
    stroke: "#6c6c6c",
    strokeWidth: "2"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M11.29 11.71l-4-4"
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4"
  })));
}
SearchIcon.propTypes = {
  theStyle: PropTypes.string,
  onClick: PropTypes.func
};
const osm = {
  type: "osm-tiles",
  datatype: ["map-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "OSM Tiles",
  thumbnail: svgGeoMapIcon,
  availableOptions: ["minPos", "maxPos", "maxZoom", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    minPos: -180,
    maxPos: 180,
    maxZoom: 19,
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
};
const mapbox = {
  type: "mapbox-tiles",
  datatype: ["map-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "Mapbox Tiles",
  thumbnail: svgGeoMapIcon,
  availableOptions: ["style", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    style: "mapbox.streets",
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
};
const TRACKS_INFO = [osm, {
  ...osm,
  type: "osm"
}, mapbox, {
  ...mapbox,
  type: "mapbox"
}, {
  type: "left-axis",
  datatype: ["axis"],
  local: true,
  orientation: "1d-vertical",
  name: "Left Axis",
  thumbnail: svgVertical1DAxisIcon,
  availableOptions: ["minWidth", "reverseAxis"],
  defaultOptions: {
    minWidth: 100,
    reverseAxis: false
  }
}, {
  type: "top-axis",
  datatype: ["axis"],
  local: true,
  orientation: "1d-horizontal",
  name: "Top Axis",
  thumbnail: svg1DAxisIcon,
  defaultOptions: {}
}, {
  type: "horizontal-rule",
  datatype: ["x-coord"],
  local: true,
  orientation: "whole",
  name: "Horizontal Rule",
  thumbnail: null,
  availableOptions: ["color"],
  defaultOptions: {
    color: "black"
  }
}, {
  type: "vertical-rule",
  datatype: ["y-coord"],
  local: true,
  orientation: "whole",
  name: "Vertical Rule",
  thumbnail: null,
  availableOptions: ["color"],
  defaultOptions: {
    color: "black"
  }
}, {
  type: "cross-rule",
  datatype: ["xy-coord"],
  local: true,
  orientation: "whole",
  name: "Cross Rule",
  thumbnail: null,
  availableOptions: ["color"],
  defaultOptions: {
    color: "black"
  }
}, {
  type: "simple-svg",
  datatype: [],
  local: false,
  orientation: "2d",
  exportable: true,
  availableOptions: ["minWidth", "minHeight"],
  defaultOptions: {
    minWidth: 100,
    minHeight: 100
  }
}, {
  type: "heatmap",
  datatype: ["matrix"],
  local: false,
  orientation: "2d",
  thumbnail: svg2DHeatmapIcon,
  exportable: true,
  availableOptions: ["backgroundColor", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "colorbarBackgroundColor", "maxZoom", "minWidth", "minHeight", "dataTransform", "colorbarPosition", "trackBorderWidth", "trackBorderColor", "heatmapValueScaling", "showMousePosition", "mousePositionColor", "showTooltip", "extent", "zeroValueColor"],
  defaultOptions: {
    backgroundColor: "#eeeeee",
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: true,
    labelShowAssembly: true,
    colorRange: [
      // corresponding to the fall colormap
      "white",
      "rgba(245,166,35,1.0)",
      "rgba(208,2,27,1.0)",
      "black"
    ],
    colorbarBackgroundColor: "#ffffff",
    maxZoom: null,
    minWidth: 100,
    minHeight: 100,
    colorbarPosition: "topRight",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    heatmapValueScaling: "log",
    showMousePosition: false,
    mousePositionColor: "#000000",
    showTooltip: false,
    extent: "full",
    zeroValueColor: null
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      backgroundColor: "#000000",
      colorRange: [
        // corresponding to the inverted fall colormap
        "black",
        "rgba(208,2,27,1.0)",
        "rgba(245,166,35,1.0)",
        "white"
      ],
      colorbarBackgroundColor: "#000000",
      labelColor: "#ffffff",
      labelBackgroundColor: "#000000",
      trackBorderColor: "#ffffff",
      mousePositionColor: "#ffffff"
    }
  }
}, {
  type: "linear-heatmap",
  aliases: ["horizontal-heatmap", "vertical-heatmap"],
  datatype: ["matrix"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: svg2DHeatmapIcon,
  defaultOptions: {
    backgroundColor: "#eeeeee",
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: true,
    labelShowAssembly: true,
    labelColor: "black",
    colorRange: [
      // corresponding to the fall colormap
      "white",
      "rgba(245,166,35,1.0)",
      "rgba(208,2,27,1.0)",
      "black"
    ],
    maxZoom: null,
    minWidth: 100,
    minHeight: 40,
    trackBorderWidth: 0,
    trackBorderColor: "black"
  },
  availableOptions: ["backgroundColor", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "maxZoom", "minWidth", "minHeight", "dataTransform", "oneDHeatmapFlipped", "colorbarPosition", "trackBorderWidth", "trackBorderColor", "heatmapValueScaling"]
}, {
  type: "line",
  aliases: ["horizontal-line", "vertical-line"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: svgHorizontalLineIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundColor", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "lineStrokeWidth", "lineStrokeColor", "valueScaling", "valueScaleMin", "valueScaleMax", "trackBorderWidth", "trackBorderColor", "trackType", "showMousePosition", "showTooltip", "mousePositionColor", "aggregationMode", "minHeight"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelBackgroundColor: "white",
    labelShowResolution: false,
    labelShowAssembly: true,
    axisLabelFormatting: "scientific",
    axisPositionHorizontal: "right",
    lineStrokeColor: "blue",
    lineStrokeWidth: 1,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    showMousePosition: false,
    minHeight: 20,
    mousePositionColor: "#000000",
    showTooltip: false
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      labelColor: "#ffffff",
      labelBackgroundColor: "#000000",
      trackBorderColor: "#ffffff",
      mousePositionColor: "#ffffff"
    }
  }
}, {
  type: "1d-heatmap",
  aliases: ["horizontal-1d-heatmap", "vertical-1d-heatmap"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: svgHorizontal1dHeatmap,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisPositionHorizontal", "axisMargin", "colorRange", "valueScaling", "trackBorderWidth", "trackBorderColor", "trackType", "showMousePosition", "showTooltip", "mousePositionColor", "aggregationMode"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisPositionHorizontal: "right",
    colorRange: [
      // corresponding to the fall colormap
      "white",
      "rgba(245,166,35,1.0)",
      "rgba(208,2,27,1.0)",
      "black"
    ],
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    showMousePosition: false,
    mousePositionColor: "#000000",
    showTooltip: false
  }
}, {
  type: "vector-heatmap",
  aliases: ["horizontal-vector-heatmap", "vertical-vector-heatmap"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  minHeight: 1,
  thumbnail: null,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "valueScaling", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "trackBorderWidth", "trackBorderColor", "trackType", "heatmapValueScaling"],
  defaultOptions: {
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    labelColor: "black",
    labelTextOpacity: 0.4,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    heatmapValueScaling: "log"
  }
}, {
  type: "multivec",
  aliases: ["horizontal-multivec", "vertical-multivec"],
  datatype: ["multivec"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: null,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "minHeight", "valueScaling", "labelTextOpacity", "labelBackgroundOpacity", "colorRange", "trackBorderWidth", "trackBorderColor", "trackType", "heatmapValueScaling", "selectRows", "selectRowsAggregationMode", "selectRowsAggregationWithRelativeHeight", "selectRowsAggregationMethod", "colorbarBackgroundColor", "colorbarPosition", "zeroValueColor"],
  defaultOptions: {
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: true,
    labelShowAssembly: true,
    labelColor: "black",
    labelTextOpacity: 0.4,
    minHeight: 100,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    heatmapValueScaling: "log",
    selectRows: null,
    selectRowsAggregationMode: "mean",
    selectRowsAggregationWithRelativeHeight: true,
    selectRowsAggregationMethod: "client",
    colorbarBackgroundColor: "#ffffff",
    colorbarPosition: "topRight",
    zeroValueColor: null
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      colorbarBackgroundColor: "#000000"
    }
  }
}, {
  type: "point",
  aliases: ["horizontal-point", "vertical-point"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "pointColor", "pointSize", "valueScaling", "trackBorderWidth", "trackBorderColor"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisLabelFormatting: "scientific",
    axisPositionHorizontal: "right",
    pointColor: "red",
    pointSize: 3,
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4
  }
}, {
  type: "divergent-bar",
  aliases: ["horizontal-divergent-bar", "vertical-divergent-bar"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "barFillColorTop", "barFillColorBottom", "valueScaling", "trackBorderWidth", "trackBorderColor", "barOpacity"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisPositionHorizontal: "right",
    axisLabelFormatting: "scientific",
    barFillColorBottom: "red",
    barFillColorTop: "green",
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    barOpacity: 1
  }
}, {
  type: "bar",
  aliases: ["horizontal-bar", "vertical-bar"],
  datatype: ["vector"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  availableOptions: ["align", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelShowResolution", "labelShowAssembly", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisLabelFormatting", "axisPositionHorizontal", "axisMargin", "barFillColor", "colorRange", "colorRangeGradient", "valueScaling", "valueScaleMin", "valueScaleMax", "trackBorderWidth", "trackBorderColor", "barOpacity", "showMousePosition", "showTooltip", "aggregationMode", "zeroLineVisible", "zeroLineColor", "zeroLineOpacity"],
  defaultOptions: {
    align: "bottom",
    labelColor: "[glyph-color]",
    labelPosition: "topLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    labelShowResolution: false,
    labelShowAssembly: true,
    axisLabelFormatting: "scientific",
    axisPositionHorizontal: "right",
    barFillColor: "darkgreen",
    valueScaling: "linear",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    labelTextOpacity: 0.4,
    barOpacity: 1
  }
}, {
  type: "2d-tiles",
  datatype: ["matrix"],
  local: false,
  orientation: "2d",
  name: "2D Tile Outlines",
  thumbnail: svg2DTilesIcon
}, {
  type: "1d-value-interval",
  aliases: ["horizontal-1d-value-interval", "vertical-1d-value-interval"],
  datatype: ["bed-value"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  name: "1D Rectangles",
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "axisPositionHorizontal", "axisMargin"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "bottomLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    axisPositionHorizontal: "left",
    lineStrokeColor: "blue",
    valueScaling: "linear"
  }
}, {
  type: "stacked-interval",
  aliases: ["top-stacked-interval", "left-stacked-interval"],
  datatype: ["stacked-interval"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  thumbnail: "horizontal-stacked-interval.png",
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity"]
}, {
  type: "viewport-projection-vertical",
  datatype: ["1d-projection"],
  local: true,
  hidden: true,
  projection: true,
  orientation: "1d-vertical",
  name: "Viewport Projection",
  thumbnail: "viewport-projection-center.png",
  availableOptions: ["projectionFillColor", "projectionStrokeColor", "strokeWidth"],
  defaultOptions: {
    projectionFillColor: "#777",
    projectionStrokeColor: "#777",
    projectionFillOpacity: 0.3,
    projectionStrokeOpacity: 0.7,
    strokeWidth: 1
  }
}, {
  type: "viewport-projection-horizontal",
  datatype: ["1d-projection"],
  local: true,
  hidden: true,
  projection: true,
  orientation: "1d-horizontal",
  name: "Viewport Projection",
  thumbnail: "viewport-projection-center.png",
  availableOptions: ["projectionFillColor", "projectionStrokeColor", "strokeWidth"],
  defaultOptions: {
    projectionFillColor: "#777",
    projectionStrokeColor: "#777",
    projectionFillOpacity: 0.3,
    projectionStrokeOpacity: 0.7,
    strokeWidth: 1
  }
}, {
  type: "viewport-projection-center",
  datatype: ["2d-projection"],
  local: true,
  hidden: true,
  projection: true,
  orientation: "2d",
  name: "Viewport Projection",
  thumbnail: "viewport-projection-center.png",
  availableOptions: ["projectionFillColor", "projectionStrokeColor", "strokeWidth"],
  defaultOptions: {
    projectionFillColor: "#777",
    projectionStrokeColor: "#777",
    projectionFillOpacity: 0.3,
    projectionStrokeOpacity: 0.7,
    strokeWidth: 1
  }
}, {
  type: "gene-annotations",
  aliases: ["horizontal-gene-annotations", "vertical-gene-annotations"],
  datatype: ["gene-annotation"],
  local: false,
  defaultHeight: 90,
  defaultWidth: 90,
  rotatable: true,
  orientation: "1d-horizontal",
  name: "Gene Annotations",
  thumbnail: svgGeneAnnotationsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundColor", "labelBackgroundOpacity", "minHeight", "plusStrandColor", "minusStrandColor", "trackBorderWidth", "trackBorderColor", "showMousePosition", "mousePositionColor", "fontSize", "geneAnnotationHeight", "geneLabelPosition", "geneStrandSpacing"],
  defaultOptions: {
    fontSize: 10,
    labelColor: "black",
    labelBackgroundColor: "#ffffff",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    minHeight: 24,
    plusStrandColor: "blue",
    minusStrandColor: "red",
    trackBorderWidth: 0,
    trackBorderColor: "black",
    showMousePosition: false,
    mousePositionColor: "#000000",
    geneAnnotationHeight: 16,
    geneLabelPosition: "outside",
    geneStrandSpacing: 4
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      labelColor: "#ffffff",
      labelBackgroundColor: "#000000",
      trackBorderColor: "#ffffff",
      mousePositionColor: "#ffffff",
      plusStrandColor: "#40a0ff"
    }
  }
}, {
  type: "arrowhead-domains",
  datatype: ["arrowhead-domains"],
  local: false,
  orientation: "2d",
  name: "Arrowhead Domains",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black"
  }
}, {
  type: "linear-2d-rectangle-domains",
  aliases: ["horizontal-2d-rectangle-domains", "vertical-2d-rectangle-domains"],
  datatype: ["2d-rectangle-domains"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  name: "Horizontal 2D Rectangle Domains",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor", "rectangleDomainFillColor", "rectangleDomainStrokeColor", "rectangleDomainOpacity", "minSquareSize"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "bottomLeft",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    rectangleDomainFillColor: "grey",
    rectangleDomainStrokeColor: "black",
    rectangleDomainOpacity: 0.6,
    minSquareSize: "none"
  }
}, {
  type: "2d-rectangle-domains",
  datatype: ["2d-rectangle-domains"],
  local: false,
  orientation: "2d",
  name: "2D Rectangle Domains",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["flipDiagonal", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor", "rectangleDomainFillColor", "rectangleDomainFillOpacity", "rectangleDomainStrokeColor", "rectangleDomainOpacity", "minSquareSize"],
  defaultOptions: {
    flipDiagonal: "none",
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    rectangleDomainFillColor: "grey",
    rectangleDomainFillOpacity: 0.4,
    rectangleDomainStrokeColor: "black",
    rectangleDomainOpacity: 0.6,
    minSquareSize: "none"
  }
}, {
  type: "horizontal-1d-annotations",
  datatype: ["nothing"],
  // Unfortunately one has to specify something here
  local: false,
  orientation: "1d-horizontal",
  name: "Horizontal 1D Annotations",
  thumbnail: null,
  availableOptions: ["fill", "fillOpacity", "stroke", "strokeOpacity", "strokeWidth", "strokePos", "regions"],
  defaultOptions: {
    fill: "red",
    fillOpacity: 0.2,
    stroke: "red",
    strokeOpacity: 0,
    strokeWidth: 1,
    regions: [],
    strokePos: []
  }
}, {
  type: "vertical-1d-annotations",
  datatype: ["nothing"],
  // Unfortunately one has to specify something here
  local: false,
  orientation: "1d-vertical",
  name: "Vertical 1D Annotations",
  thumbnail: null,
  availableOptions: ["fill", "fillOpacity", "stroke", "strokeOpacity", "regions"],
  defaultOptions: {
    fill: "red",
    fillOpacity: "0.2",
    stroke: "red",
    strokeOpacity: "0",
    regions: []
  }
}, {
  type: "2d-annotations",
  datatype: ["2d-annotations"],
  local: false,
  orientation: "2d",
  name: "2D Annotations",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor", "labelTextOpacity", "labelBackgroundOpacity", "trackBorderWidth", "trackBorderColor", "rectangleDomainFillColor", "rectangleDomainStrokeColor", "rectangleDomainOpacity", "minSquareSize", "isClickable", "hoverColor", "selectColor", "exclude", "trackBorderBgWidth", "trackBorderBgColor", "trackBorderBgAlpha"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    rectangleDomainFillColor: "grey",
    rectangleDomainStrokeColor: "black",
    rectangleDomainOpacity: 0.6,
    minSquareSize: "none",
    isClickable: false,
    hoverColor: "orange",
    selectColor: "fuchsia",
    exclude: [],
    trackBorderBgWidth: 0,
    trackBorderBgColor: "black",
    trackBorderBgAlpha: 0.33
  }
}, {
  type: "square-markers",
  datatype: ["bedpe"],
  local: false,
  orientation: "2d",
  name: "Square Markers",
  thumbnail: svgArrowheadDomainsIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "labelColor"],
  defaultOptions: {
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    trackBorderWidth: 0,
    trackBorderColor: "black"
  }
}, {
  type: "combined",
  datatype: "any",
  local: true,
  orientation: "any"
}, {
  type: "horizontal-chromosome-grid",
  datatype: ["chromsizes"],
  local: false,
  orientation: "1d-horizontal",
  name: "Chromosome Grid",
  chromInfoPath: "//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv",
  thumbnail: null,
  availableOptions: ["lineStrokeWidth", "lineStrokeColor", "showMousePosition"],
  defaultOptions: {
    lineStrokeWidth: 1,
    lineStrokeColor: "grey",
    showMousePosition: false
  }
}, {
  type: "vertical-chromosome-grid",
  datatype: ["chromsizes"],
  local: false,
  orientation: "1d-vertical",
  name: "Chromosome Grid",
  chromInfoPath: "//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv",
  thumbnail: null,
  availableOptions: ["lineStrokeWidth", "lineStrokeColor", "showMousePosition"],
  defaultOptions: {
    lineStrokeWidth: 1,
    lineStrokeColor: "grey",
    showMousePosition: false
  }
}, {
  type: "2d-chromosome-grid",
  datatype: ["chromsizes"],
  local: false,
  orientation: "2d",
  name: "Chromosome Grid",
  chromInfoPath: "//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv",
  thumbnail: null,
  availableOptions: ["lineStrokeWidth", "lineStrokeColor"],
  defaultOptions: {
    lineStrokeWidth: 1,
    lineStrokeColor: "grey"
  }
}, {
  type: "2d-chromosome-annotations",
  datatype: ["chromsizes"],
  local: true,
  orientation: "2d",
  name: "2D Chromosome Annotations",
  thumbnail: null,
  hidden: true
}, {
  type: "2d-chromosome-labels",
  datatype: ["chromsizes"],
  local: true,
  orientation: "2d",
  name: "Pairwise Chromosome Labels",
  thumbnail: null
}, {
  type: "chromosome-labels",
  aliases: ["horizontal-chromosome-labels", "vertical-chromosome-labels"],
  datatype: ["chromsizes"],
  orientation: "1d-horizontal",
  rotatable: true,
  minHeight: 35,
  defaultHeight: 30,
  name: "Chromosome Axis",
  thumbnail: null,
  availableOptions: ["color", "stroke", "fontSize", "fontIsLeftAligned", "showMousePosition", "mousePositionColor", "tickPositions", "tickFormat", "reverseOrientation"],
  defaultOptions: {
    color: "#808080",
    stroke: "#ffffff",
    fontSize: 12,
    fontIsLeftAligned: false,
    showMousePosition: false,
    mousePositionColor: "#000000",
    reverseOrientation: false
  },
  defaultOptionsByTheme: {
    [THEME_DARK]: {
      color: "#808080",
      stroke: "#000000",
      mousePositionColor: "#ffffff"
    }
  }
}, {
  type: "vertical-1d-tiles",
  datatype: ["1d-tiles"],
  local: false,
  orientation: "1d-vertical",
  name: "Vertical 1D Tile Outlines",
  thumbnail: svgVertical1DTilesIcon
}, {
  type: "horizontal-1d-tiles",
  datatype: ["vector", "stacked-interval", "gene-annotation"],
  local: false,
  orientation: "1d-horizontal",
  name: "Horizontal 1D Tile Outlines",
  thumbnail: svg1DTilesIcon
}, {
  type: "osm-2d-tile-ids",
  datatype: ["map-tiles"],
  local: false,
  orientation: "2d",
  name: "OSM Tile Outlines",
  thumbnail: svg2DTilesIcon,
  availableOptions: ["minPos", "maxPos", "maxZoom", "labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    minPos: -180,
    maxPos: 180,
    maxZoom: 19,
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
}, {
  type: "raster-tiles",
  datatype: ["map-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "Raster Tiles",
  thumbnail: svgGeoMapIcon,
  availableOptions: ["labelPosition", "labelLeftMargin", "labelRightMargin", "labelTopMargin", "labelBottomMargin", "name"],
  defaultOptions: {
    labelPosition: "bottomRight",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0
  }
}, {
  type: "image-tiles",
  datatype: ["image-tiles"],
  local: true,
  orientation: "2d",
  hidden: true,
  name: "Image Tiles",
  thumbnail: null
}, {
  type: "bedlike",
  datatype: ["bedlike"],
  aliases: ["vertical-bedlike"],
  local: false,
  orientation: "1d-horizontal",
  rotatable: true,
  name: "BED-like track",
  thumbnail: null,
  availableOptions: ["alternating", "annotationHeight", "annotationStyle", "fillColor", "fillOpacity", "fontColor", "fontSize", "minusStrandColor", "plusStrandColor", "labelBottomMargin", "labelColor", "labelLeftMargin", "labelPosition", "labelRightMargin", "labelTopMargin", "labelTextOpacity", "labelBackgroundOpacity", "maxAnnotationHeight", "minHeight", "trackBorderWidth", "trackBorderColor", "valueColumn", "colorEncoding", "colorRange", "colorEncodingRange", "separatePlusMinusStrands", "showTexts", "axisPositionHorizontal", "axisMargin"],
  defaultOptions: {
    alternating: false,
    annotationStyle: "box",
    fillColor: "blue",
    fillOpacity: 0.3,
    fontSize: "10",
    axisPositionHorizontal: "right",
    labelColor: "black",
    labelPosition: "hidden",
    labelLeftMargin: 0,
    labelRightMargin: 0,
    labelTopMargin: 0,
    labelBottomMargin: 0,
    minHeight: 20,
    maxAnnotationHeight: null,
    trackBorderWidth: 0,
    trackBorderColor: "black",
    valueColumn: null,
    colorEncoding: "itemRgb",
    showTexts: false,
    colorRange: ["#000000", "#652537", "#bf5458", "#fba273", "#ffffe0"],
    colorEncodingRange: false,
    separatePlusMinusStrands: true,
    annotationHeight: 16
  }
}, {
  type: "empty",
  datatype: [],
  orientation: "1d-horizontal",
  name: "Empty track",
  thumbnail: null,
  availableOptions: [],
  defaultOptions: {}
}];
const DATATYPE_TO_TRACK_TYPE = (orientation2) => {
  const localDatatypeToTrackType = {};
  const orientationMatches = (trackInfo2) => {
    if (trackInfo2.orientation === orientation2) {
      return true;
    }
    if (orientation2 === "1d-vertical" && trackInfo2.orientation === "1d-horizontal" && trackInfo2.rotatable) {
      return true;
    }
    return false;
  };
  TRACKS_INFO.filter(orientationMatches).forEach((ti) => {
    let datatypes = ti.datatype;
    if (!Array.isArray(ti.datatype)) {
      datatypes = [datatypes];
    }
    datatypes.forEach((datatype) => {
      if (!(datatype in localDatatypeToTrackType)) {
        localDatatypeToTrackType[datatype] = [];
      }
      localDatatypeToTrackType[datatype].push(ti);
    });
  });
  localDatatypeToTrackType.none = [];
  return localDatatypeToTrackType;
};
const HEATED_OBJECT_MAP = [[0, 0, 0, 255], [35, 0, 0, 255], [52, 0, 0, 255], [60, 0, 0, 255], [63, 1, 0, 255], [64, 2, 0, 255], [68, 5, 0, 255], [69, 6, 0, 255], [72, 8, 0, 255], [74, 10, 0, 255], [77, 12, 0, 255], [78, 14, 0, 255], [81, 16, 0, 255], [83, 17, 0, 255], [85, 19, 0, 255], [86, 20, 0, 255], [89, 22, 0, 255], [91, 24, 0, 255], [92, 25, 0, 255], [94, 26, 0, 255], [95, 28, 0, 255], [98, 30, 0, 255], [100, 31, 0, 255], [102, 33, 0, 255], [103, 34, 0, 255], [105, 35, 0, 255], [106, 36, 0, 255], [108, 38, 0, 255], [109, 39, 0, 255], [111, 40, 0, 255], [112, 42, 0, 255], [114, 43, 0, 255], [115, 44, 0, 255], [117, 45, 0, 255], [119, 47, 0, 255], [119, 47, 0, 255], [120, 48, 0, 255], [122, 49, 0, 255], [123, 51, 0, 255], [125, 52, 0, 255], [125, 52, 0, 255], [126, 53, 0, 255], [128, 54, 0, 255], [129, 56, 0, 255], [129, 56, 0, 255], [131, 57, 0, 255], [132, 58, 0, 255], [134, 59, 0, 255], [134, 59, 0, 255], [136, 61, 0, 255], [137, 62, 0, 255], [137, 62, 0, 255], [139, 63, 0, 255], [139, 63, 0, 255], [140, 65, 0, 255], [142, 66, 0, 255], [142, 66, 0, 255], [143, 67, 0, 255], [143, 67, 0, 255], [145, 68, 0, 255], [145, 68, 0, 255], [146, 70, 0, 255], [146, 70, 0, 255], [148, 71, 0, 255], [148, 71, 0, 255], [149, 72, 0, 255], [149, 72, 0, 255], [151, 73, 0, 255], [151, 73, 0, 255], [153, 75, 0, 255], [153, 75, 0, 255], [154, 76, 0, 255], [154, 76, 0, 255], [154, 76, 0, 255], [156, 77, 0, 255], [156, 77, 0, 255], [157, 79, 0, 255], [157, 79, 0, 255], [159, 80, 0, 255], [159, 80, 0, 255], [159, 80, 0, 255], [160, 81, 0, 255], [160, 81, 0, 255], [162, 82, 0, 255], [162, 82, 0, 255], [163, 84, 0, 255], [163, 84, 0, 255], [165, 85, 0, 255], [165, 85, 0, 255], [166, 86, 0, 255], [166, 86, 0, 255], [166, 86, 0, 255], [168, 87, 0, 255], [168, 87, 0, 255], [170, 89, 0, 255], [170, 89, 0, 255], [171, 90, 0, 255], [171, 90, 0, 255], [173, 91, 0, 255], [173, 91, 0, 255], [174, 93, 0, 255], [174, 93, 0, 255], [176, 94, 0, 255], [176, 94, 0, 255], [177, 95, 0, 255], [177, 95, 0, 255], [179, 96, 0, 255], [179, 96, 0, 255], [180, 98, 0, 255], [182, 99, 0, 255], [182, 99, 0, 255], [183, 100, 0, 255], [183, 100, 0, 255], [185, 102, 0, 255], [185, 102, 0, 255], [187, 103, 0, 255], [187, 103, 0, 255], [188, 104, 0, 255], [188, 104, 0, 255], [190, 105, 0, 255], [191, 107, 0, 255], [191, 107, 0, 255], [193, 108, 0, 255], [193, 108, 0, 255], [194, 109, 0, 255], [196, 110, 0, 255], [196, 110, 0, 255], [197, 112, 0, 255], [197, 112, 0, 255], [199, 113, 0, 255], [200, 114, 0, 255], [200, 114, 0, 255], [202, 116, 0, 255], [202, 116, 0, 255], [204, 117, 0, 255], [205, 118, 0, 255], [205, 118, 0, 255], [207, 119, 0, 255], [208, 121, 0, 255], [208, 121, 0, 255], [210, 122, 0, 255], [211, 123, 0, 255], [211, 123, 0, 255], [213, 124, 0, 255], [214, 126, 0, 255], [214, 126, 0, 255], [216, 127, 0, 255], [217, 128, 0, 255], [217, 128, 0, 255], [219, 130, 0, 255], [221, 131, 0, 255], [221, 131, 0, 255], [222, 132, 0, 255], [224, 133, 0, 255], [224, 133, 0, 255], [225, 135, 0, 255], [227, 136, 0, 255], [227, 136, 0, 255], [228, 137, 0, 255], [230, 138, 0, 255], [230, 138, 0, 255], [231, 140, 0, 255], [233, 141, 0, 255], [233, 141, 0, 255], [234, 142, 0, 255], [236, 144, 0, 255], [236, 144, 0, 255], [238, 145, 0, 255], [239, 146, 0, 255], [241, 147, 0, 255], [241, 147, 0, 255], [242, 149, 0, 255], [244, 150, 0, 255], [244, 150, 0, 255], [245, 151, 0, 255], [247, 153, 0, 255], [247, 153, 0, 255], [248, 154, 0, 255], [250, 155, 0, 255], [251, 156, 0, 255], [251, 156, 0, 255], [253, 158, 0, 255], [255, 159, 0, 255], [255, 159, 0, 255], [255, 160, 0, 255], [255, 161, 0, 255], [255, 163, 0, 255], [255, 163, 0, 255], [255, 164, 0, 255], [255, 165, 0, 255], [255, 167, 0, 255], [255, 167, 0, 255], [255, 168, 0, 255], [255, 169, 0, 255], [255, 169, 0, 255], [255, 170, 0, 255], [255, 172, 0, 255], [255, 173, 0, 255], [255, 173, 0, 255], [255, 174, 0, 255], [255, 175, 0, 255], [255, 177, 0, 255], [255, 178, 0, 255], [255, 179, 0, 255], [255, 181, 0, 255], [255, 181, 0, 255], [255, 182, 0, 255], [255, 183, 0, 255], [255, 184, 0, 255], [255, 187, 7, 255], [255, 188, 10, 255], [255, 189, 14, 255], [255, 191, 18, 255], [255, 192, 21, 255], [255, 193, 25, 255], [255, 195, 29, 255], [255, 197, 36, 255], [255, 198, 40, 255], [255, 200, 43, 255], [255, 202, 51, 255], [255, 204, 54, 255], [255, 206, 61, 255], [255, 207, 65, 255], [255, 210, 72, 255], [255, 211, 76, 255], [255, 214, 83, 255], [255, 216, 91, 255], [255, 219, 98, 255], [255, 221, 105, 255], [255, 223, 109, 255], [255, 225, 116, 255], [255, 228, 123, 255], [255, 232, 134, 255], [255, 234, 142, 255], [255, 237, 149, 255], [255, 239, 156, 255], [255, 240, 160, 255], [255, 243, 167, 255], [255, 246, 174, 255], [255, 248, 182, 255], [255, 249, 185, 255], [255, 252, 193, 255], [255, 253, 196, 255], [255, 255, 204, 255], [255, 255, 207, 255], [255, 255, 211, 255], [255, 255, 218, 255], [255, 255, 222, 255], [255, 255, 225, 255], [255, 255, 229, 255], [255, 255, 233, 255], [255, 255, 236, 255], [255, 255, 240, 255], [255, 255, 244, 255], [255, 255, 247, 255], [255, 255, 255, 0]];
const TRACKS_INFO_BY_TYPE = TRACKS_INFO.reduce(
  (tracksByType, track) => {
    tracksByType[track.type] = track;
    if (track.aliases) {
      for (const alias of track.aliases) {
        tracksByType[alias] = track;
      }
    }
    return tracksByType;
  },
  /** @type {TracksInfoByType} */
  {}
);
const POSITIONS_BY_DATATYPE = TRACKS_INFO.reduce((positionsByDatatype, track) => {
  for (let i = 0; i < track.datatype.length; i++) {
    const datatype = track.datatype[i];
    if (positionsByDatatype[datatype]) {
      positionsByDatatype[datatype].add(track.orientation);
    } else {
      positionsByDatatype[datatype] = /* @__PURE__ */ new Set();
    }
    return positionsByDatatype;
  }
  return {};
}, {});
const DEFAULT_TRACKS_FOR_DATATYPE = (
  /** @type {const} */
  {
    chromsizes: {
      center: "2d-chromosome-grid",
      top: "chromosome-labels",
      left: "chromosome-labels",
      bottom: "chromosome-labels",
      right: "chromosome-labels"
    },
    matrix: {
      center: "heatmap",
      top: "linear-heatmap",
      left: "linear-heatmap",
      right: "linear-heatmap",
      bottom: "linear-heatmap"
    },
    vector: {
      top: "bar",
      bottom: "bar",
      left: "bar",
      right: "bar"
    },
    "geo-json": {
      center: "geo-json"
    },
    "gene-annotation": {
      top: "gene-annotations",
      bottom: "gene-annotations",
      left: "gene-annotations",
      right: "gene-annotations"
    },
    bedlike: {
      top: "bedlike",
      bottom: "bedlike",
      left: "vertical-bedlike",
      right: "vertical-bedlike"
    }
  }
);
const AVAILABLE_TRACK_TYPES = (datatypes, orientation2) => {
  const datatypesToTrackTypes = DATATYPE_TO_TRACK_TYPE(orientation2);
  let availableTrackTypes = new Set(Object.values(datatypesToTrackTypes).flat());
  for (const datatype of datatypes) {
    const dataTypeSet = new Set(datatype);
    availableTrackTypes = new Set([...availableTrackTypes].filter((x) => x.datatype.filter((y) => dataTypeSet.has(y)).length > 0));
  }
  return [...availableTrackTypes];
};
const NUM_PRECOMP_SUBSETS_PER_1D_TTILE = 8;
const NUM_PRECOMP_SUBSETS_PER_2D_TTILE = 8;
const SIZE_MODE_DEFAULT = "default";
const SIZE_MODE_BOUNDED = "bounded";
const SIZE_MODE_OVERFLOW = "overflow";
const SIZE_MODE_BOUNDED_OVERFLOW = "bounded-overflow";
const SIZE_MODE_SCROLL = "scroll";
const _configs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AVAILABLE_TRACK_TYPES,
  DATATYPE_TO_TRACK_TYPE,
  DEFAULT_CONTAINER_PADDING_X,
  DEFAULT_CONTAINER_PADDING_Y,
  DEFAULT_SERVER,
  DEFAULT_TRACKS_FOR_DATATYPE,
  DEFAULT_VIEW_MARGIN,
  DEFAULT_VIEW_PADDING,
  GLOBALS,
  HEATED_OBJECT_MAP,
  LOCATION_LISTENER_PREFIX,
  LONG_DRAG_TIMEOUT,
  MAX_CLICK_DELAY: MAX_CLICK_DELAY$1,
  MIN_HORIZONTAL_HEIGHT,
  MIN_VERTICAL_WIDTH,
  MOUSE_TOOL_MOVE,
  MOUSE_TOOL_SELECT,
  MOUSE_TOOL_TRACK_SELECT,
  NUM_PRECOMP_SUBSETS_PER_1D_TTILE,
  NUM_PRECOMP_SUBSETS_PER_2D_TTILE,
  POSITIONS_BY_DATATYPE,
  SHORT_DRAG_TIMEOUT,
  SIZE_MODE_BOUNDED,
  SIZE_MODE_BOUNDED_OVERFLOW,
  SIZE_MODE_DEFAULT,
  SIZE_MODE_OVERFLOW,
  SIZE_MODE_SCROLL,
  THEME_DARK,
  THEME_DEFAULT,
  THEME_LIGHT,
  TILE_FETCH_DEBOUNCE,
  TRACKS_INFO,
  TRACKS_INFO_BY_TYPE,
  TRACK_LOCATIONS,
  VIEW_HEADER_MED_WIDTH_SEARCH_BAR,
  VIEW_HEADER_MIN_WIDTH_SEARCH_BAR,
  ZOOM_DEBOUNCE,
  ZOOM_TRANSITION_DURATION
}, Symbol.toStringTag, { value: "Module" }));
const fillInMinWidths = (tracks2) => {
  const horizontalLocations = (
    /** @type {const} */
    ["top", "bottom", "gallery"]
  );
  const verticalLocations = (
    /** @type {const} */
    ["left", "right", "gallery"]
  );
  tracks2.center ??= [];
  tracks2.left ??= [];
  tracks2.right ??= [];
  tracks2.top ??= [];
  tracks2.bottom ??= [];
  tracks2.whole ??= [];
  tracks2.gallery ??= [];
  horizontalLocations.map((horizontalLocation) => tracks2[horizontalLocation]).forEach((horizontalTracks) => (horizontalTracks ?? []).forEach((track) => {
    const trackInfo2 = TRACKS_INFO_BY_TYPE[track.type];
    const defaultOptions2 = trackInfo2?.defaultOptions || {};
    const options2 = track.options ? {
      ...defaultOptions2,
      ...track.options
    } : defaultOptions2;
    if (options2.minHeight !== void 0 && track.height === void 0) {
      track.height = options2.minHeight;
    }
    if (track.height === void 0) {
      track.height = trackInfo2?.defaultHeight || MIN_HORIZONTAL_HEIGHT;
    }
  }));
  verticalLocations.map((verticalLocation) => tracks2[verticalLocation]).forEach((verticalTracks) => (verticalTracks ?? []).forEach((track) => {
    const trackInfo2 = TRACKS_INFO_BY_TYPE[track.type];
    const defaultOptions2 = trackInfo2?.defaultOptions || {};
    const options2 = track.options ? {
      ...defaultOptions2,
      ...track.options
    } : defaultOptions2;
    if (options2.minWidth !== void 0 && track.width === void 0) {
      track.width = options2.minWidth;
    }
    if (track.width === void 0) {
      track.width = trackInfo2?.defaultWidth || MIN_VERTICAL_WIDTH;
    }
  }));
  return tracks2;
};
const reduce = (callbackfn, initialValue) => (x) => x.reduce(callbackfn, initialValue);
const flatten = reduce((a, b) => a.concat(b), []);
const forEach$2 = (f2) => (x) => Array.prototype.forEach.call(x, f2);
const forwardEvent = (event, target2) => {
  target2.dispatchEvent(cloneEvent(event));
};
const genomeLociToPixels = (genomeLoci, chromInfo) => [chrToAbs(genomeLoci[0], genomeLoci[1], chromInfo), chrToAbs(genomeLoci[2], genomeLoci[3], chromInfo)];
function genomicRangeToChromosomeChunks(chromSizes, genomicStart, genomicEnd, binSize, tileSize) {
  const {
    chr: chrStart,
    pos: chrStartPos
  } = genomicStart;
  const {
    chr: chrEnd,
    pos: chrEndPos
  } = genomicEnd;
  const chrChunks = [];
  if (chrStart === chrEnd) {
    const chrName = chrStart;
    const zStart = Math.floor(chrStartPos / binSize);
    const zEnd = Math.min(zStart + tileSize, Math.ceil(chrEndPos / binSize));
    chrChunks.push([chrName, zStart, zEnd]);
  } else {
    let zRemaining = tileSize;
    const chrStartIndex = chromSizes.findIndex(([chrName]) => chrName === chrStart);
    const chrEndIndex = chromSizes.findIndex(([chrName]) => chrName === chrEnd);
    for (let chrIndex = chrStartIndex; chrIndex <= chrEndIndex; chrIndex++) {
      let chrChunkStart;
      let chrChunkEnd;
      const [currChrName, currChrLen] = chromSizes[chrIndex];
      if (chrIndex < chrEndIndex) {
        if (chrIndex === chrStartIndex) {
          chrChunkStart = chrStartPos;
        } else {
          chrChunkStart = 0;
        }
        chrChunkEnd = currChrLen;
      } else {
        chrChunkStart = 0;
        chrChunkEnd = chrEndPos;
      }
      const zStart = Math.floor(chrChunkStart / binSize);
      const zEnd = Math.min(zStart + zRemaining, Math.ceil(chrChunkEnd / binSize));
      chrChunks.push([currChrName, zStart, zEnd]);
      zRemaining -= zEnd - zStart;
    }
  }
  return chrChunks;
}
function findDefaultTrackType(datatype, position) {
  return DEFAULT_TRACKS_FOR_DATATYPE[datatype] !== void 0 ? (
    // @ts-expect-error - ok with undefined check
    DEFAULT_TRACKS_FOR_DATATYPE[datatype][position]
  ) : (
    // @ts-expect-error - ok with undefined check
    void 0
  );
}
const getDefaultTrackForDatatype = (datatype, position, availableTracks) => {
  if (availableTracks.length === 0) {
    return void 0;
  }
  if (availableTracks.length === 1) {
    return availableTracks[0];
  }
  let usedTrack = availableTracks[0];
  const defaultTrackType = findDefaultTrackType(datatype, position);
  if (defaultTrackType !== void 0) {
    usedTrack = availableTracks.find((tt) => tt.type === defaultTrackType) || usedTrack;
  }
  return usedTrack;
};
const getElementDim = (element) => {
  ElementResizeListener.listen();
  return [element.clientWidth, element.clientHeight];
};
const getTrackByUid = (tracks2, uid) => {
  let found = null;
  const checkTrack = (track) => {
    if (track.uid === uid) found = track;
    if (track.type.substr(0, 8) === "combined") track.contents.forEach(checkTrack);
    return null;
  };
  Object.keys(tracks2).map((trackType) => tracks2[trackType]).filter((tracksByPos) => tracksByPos.filter).reduce((a, b) => a.concat(b), []).forEach(checkTrack);
  return found;
};
const getTrackConfFromHGC = (hgc, viewUid, trackUid) => {
  const views = hgc.state.views;
  const myView = views[viewUid];
  if (!myView) return null;
  let found = null;
  const checkTrack = (track) => {
    if (track.uid === trackUid) found = track;
    if (track.type.substr(0, 8) === "combined") track.contents.forEach(checkTrack);
    return null;
  };
  const tracks2 = myView.tracks;
  Object.keys(tracks2).map((trackType) => tracks2[trackType]).filter((tracksByPos) => tracksByPos.filter).reduce((a, b) => a.concat(b), []).forEach(checkTrack);
  return found;
};
const getTrackObjById = (tiledPlots, viewId, trackId) => {
  const tiledPlot = viewId ? tiledPlots[viewId] : Object.values(tiledPlots)[0];
  if (!tiledPlot) {
    if (!viewId) console.warn("No views available.");
    else console.warn(`Could't find view with id "${viewId}"`);
    return void 0;
  }
  let track = tiledPlot.trackRenderer.trackDefObjects[trackId];
  if (!track) {
    Object.values(tiledPlot.trackRenderer.trackDefObjects).map((trackDef) => trackDef.trackObject).filter((trackObj) => trackObj.childTracks).forEach((combinedTrack) => {
      if (combinedTrack.createdTracks[trackId]) {
        track = combinedTrack.createdTracks[trackId];
      }
    });
  } else {
    track = track.trackObject;
  }
  return track;
};
function isCombinedTrackConfig(trackConfig) {
  return "contents" in trackConfig && trackConfig.type === "combined";
}
function isWheelEvent(event) {
  return "deltaY" in event && "deltaMode" in event;
}
function isObject$2(obj) {
  return obj !== null && typeof obj === "object";
}
function isLegacyTilesetInfo(info) {
  return isObject$2(info) && "max_width" in info;
}
function isResolutionsTilesetInfo(info) {
  return isObject$2(info) && "resolutions" in info;
}
function isTilesetInfo(info) {
  return isObject$2(info) && !("error" in info);
}
const visitTracks = (tracks2, visit, includeCombinedTracks = true, position = null) => tracks2.forEach((track) => {
  if (includeCombinedTracks && isCombinedTrackConfig(track)) {
    visitTracks(track.contents, visit, includeCombinedTracks, position);
  }
  visit(track, position);
});
const visitPositionedTracks = (positionedTracks, visitor, inclCombinedTracks = true) => {
  const allTracks = [];
  for (const [stringPosition, tracks2] of Object.entries(positionedTracks)) {
    const position = stringPosition;
    visitTracks(tracks2, visitor, inclCombinedTracks, position);
    allTracks.push(...tracks2);
  }
  return allTracks;
};
const getTrackPositionByUid = (positionedTracks, uid) => {
  let position = null;
  visitPositionedTracks(positionedTracks, (track, trackPosition) => {
    if (track.uid === uid) {
      position = trackPosition;
    }
  });
  return position;
};
const map$4 = (f2) => (x) => Array.prototype.map.call(x, f2);
const getXylofon = () => (
  /** @type {const} */
  [window, map$4((c) => c.charCodeAt(0))(
    // @ts-expect-error - A global added by `vite.config.js`.
    "2.3.4"
  ).map((number3) => number3 <= 999 ? `00${number3}`.slice(-3) : number3).join("")]
);
const gradient = (steps, width = 1, height = 100, fromX = 0, fromY = 0, toX = 0, toY = 100) => {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get canvas context");
  }
  const grd = ctx.createLinearGradient(fromX, fromY, toX, toY);
  steps.forEach((step) => {
    grd.addColorStop(step.from, step.color);
  });
  ctx.fillStyle = grd;
  ctx.fillRect(0, 0, width, height);
  return canvas;
};
const hasParent = (el2, target2) => {
  let _el = el2;
  while (_el && _el !== target2 && _el.tagName !== "HTML") {
    _el = _el.parentNode;
  }
  if (_el === target2) {
    return true;
  }
  return false;
};
const hexStrToInt = (str) => Number.parseInt(str.replace(/^#/, ""), 16);
const intoTheVoid = () => {
};
function _classCallCheck$1B(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1t(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1t(o.key), o);
  }
}
function _createClass$1B(e, r2, t) {
  return r2 && _defineProperties$1t(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1t(t) {
  var i = _toPrimitive$1t(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1t(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let CombinedTrack = /* @__PURE__ */ (function() {
  function CombinedTrack2(context) {
    _classCallCheck$1B(this, CombinedTrack2);
    this.context = context;
    const {
      tracks: tracks2,
      createTrackObject
    } = context;
    this.childTracks = tracks2.map(createTrackObject);
    this.createdTracks = {};
    this.uid = slugid.nice();
    this.childTracks.forEach((ct, i) => {
      this.createdTracks[tracks2[i].uid] = ct;
    });
    for (let i = 0; i < this.childTracks.length; i++) {
      if (!this.childTracks[i]) {
        console.error("Empty child track in CombinedTrack:", this);
      }
    }
  }
  return _createClass$1B(CombinedTrack2, [{
    key: "updateContents",
    value: function updateContents(newContents, trackCreator) {
      const newTracks = [];
      const currentTracks = /* @__PURE__ */ new Set();
      newContents.forEach((nc) => {
        currentTracks.add(nc.uid);
        if (nc.uid in this.createdTracks) {
          newTracks.push(this.createdTracks[nc.uid]);
        } else {
          const newTrack = trackCreator(nc);
          newTrack.setPosition(this.position);
          newTrack.setDimensions(this.dimensions);
          newTracks.push(newTrack);
          newTrack.zoomed(this._xScale, this._yScale);
          this.createdTracks[nc.uid] = newTrack;
        }
      });
      this.childTracks = newTracks;
      const knownTracks = new Set(Object.keys(this.createdTracks));
      const exitTracks = new Set([...knownTracks].filter((x) => !currentTracks.has(x)));
      [...exitTracks].forEach((trackUid) => {
        this.createdTracks[trackUid].remove();
        delete this.createdTracks[trackUid];
      });
      return this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].setPosition(newPosition);
      }
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].setDimensions(newDimensions);
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, x, y, xPositionOffset, yPositionOffset) {
      this._xScale = newXScale;
      this._yScale = newYScale;
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].zoomed(newXScale, newYScale, k, x, y, xPositionOffset, yPositionOffset);
      }
    }
    // refXScale(xScale) {
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].refXScale(xScale);
    //   }
    // }
    // refYScale(yScale) {
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].refYScale(yScale);
    //   }
    // }
  }, {
    key: "clickOutside",
    value: function clickOutside() {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].clickOutside();
      }
    }
  }, {
    key: "click",
    value: function click(...args) {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].click(...args);
      }
    }
  }, {
    key: "draw",
    value: function draw() {
    }
    // xScale(xScale) {
    //   this._xScale = xScale;
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].xScale(xScale);
    //   }
    // }
    // yScale(xScale) {
    //   this._yScale = yScale;
    //   for (let i = 0; i < this.childTracks.length; i++) {
    //     this.childTracks[i].yScale(yScale);
    //   }
    // }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].refScalesChanged(refXScale, refYScale);
      }
    }
  }, {
    key: "remove",
    value: function remove2() {
      for (let i = 0; i < this.childTracks.length; i++) {
        this.childTracks[i].remove();
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      const svg = document.createElement("g");
      for (const childTrack of this.childTracks) {
        if (childTrack.exportSVG) {
          svg.appendChild(childTrack.exportSVG()[0]);
        }
      }
      return [svg, svg];
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
    }
  }, {
    key: "minValue",
    value: function minValue(_) {
      if (arguments.length === 0) {
        const minValues = this.childTracks.filter((x) => x.minValue).map((x) => x.minValue()).filter((x) => x);
        return Math.min(...minValues);
      }
      for (const childTrack of this.childTracks) {
        if (childTrack.minValue) {
          childTrack.minValue(_);
        }
      }
      return void 0;
    }
  }, {
    key: "maxValue",
    value: function maxValue(_) {
      if (arguments.length === 0) {
        const maxValues = this.childTracks.filter((x) => x.maxValue).map((x) => x.maxValue()).filter((x) => x);
        return Math.max(...maxValues);
      }
      for (const childTrack of this.childTracks) {
        if (childTrack.maxValue) {
          childTrack.maxValue(_);
        }
      }
      return void 0;
    }
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition(x, y) {
      return x >= this.position[0] && x <= this.dimensions[0] + this.position[0] && y >= this.position[1] && y <= this.dimensions[1] + this.position[1];
    }
  }, {
    key: "stopHover",
    value: function stopHover() {
      for (const childTrack of this.childTracks) {
        if (childTrack.stopHover) childTrack.stopHover();
      }
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY) {
      let mouseOverHtml = "";
      for (const childTrack of this.childTracks) {
        if (childTrack.getMouseOverHtml) {
          const trackHtml = childTrack.getMouseOverHtml(trackX, trackY);
          if (trackHtml?.length) {
            mouseOverHtml += trackHtml;
            mouseOverHtml += "<br/>";
          }
        }
      }
      return mouseOverHtml;
    }
    /**
     * Get the uids of any items that are below the mouse
     *
     * @param {*} trackX
     * @param {*} trackY
     * @returns
     */
  }, {
    key: "getMouseOverUids",
    value: function getMouseOverUids(trackX, trackY) {
      const mouseOverUids = [];
      for (const childTrack of this.childTracks) {
        if (childTrack.getMouseOverUids) {
          const trackMouseOverUids = childTrack.getMouseOverUids(trackX, trackY);
          if (trackMouseOverUids) {
            mouseOverUids.push(...trackMouseOverUids);
          }
        }
      }
      return mouseOverUids;
    }
  }]);
})();
const isTrackOrChildTrack = (testTrack, track) => {
  if (track === testTrack) return true;
  if (track instanceof CombinedTrack) {
    return Object.keys(track.createdTracks).map((trackName) => track.createdTracks[trackName]).some((createdTrack) => isTrackOrChildTrack(testTrack, createdTrack));
  }
  return false;
};
const isWithin = (x, y, minX, maxX, minY, maxY, is1d = false) => is1d ? x >= minX && x <= maxX || y >= minY && y <= maxY : x >= minX && x <= maxX && y >= minY && y <= maxY;
const invGudermannian = (y) => Math.log(Math.tan((y + Math.PI / 2) / 2));
const latToY = (lat2, zoom2) => {
  let latRad = lat2 * Math.PI / 180;
  latRad = invGudermannian(latRad);
  return 2 ** zoom2 * (Math.PI - latRad) / (2 * Math.PI);
};
const objVals = (obj) => map$4((key) => obj[key])(Object.keys(obj));
const loadChromInfos = (views) => objVals(views).map((view) => view.chromInfoPath).forEach((chromInfoPath) => api$1.get(chromInfoPath));
const lngToX = (lng, zoom2) => 2 ** zoom2 * (lng + 180) / 360;
const max$2 = (a, b) => a > b ? a : b;
const epsilon$4 = 1e-7;
function maxNonZero(data2) {
  let maxNonZeroNum = Number.MIN_SAFE_INTEGER;
  for (let i = 0; i < data2.length; i++) {
    const x = data2[i];
    if (x < epsilon$4 && x > -epsilon$4) {
      continue;
    }
    if (x > maxNonZeroNum) {
      maxNonZeroNum = x;
    }
  }
  return maxNonZeroNum;
}
const min$2 = (a, b) => a < b ? a : b;
const epsilon$3 = 1e-7;
function minNonZero(data2) {
  let minNonZeroNum = Number.MAX_SAFE_INTEGER;
  for (let i = 0; i < data2.length; i++) {
    const x = data2[i];
    if (x < epsilon$3 && x > -epsilon$3) {
      continue;
    }
    if (x < minNonZeroNum) {
      minNonZeroNum = x;
    }
  }
  return minNonZeroNum;
}
const mod = (n, m) => (n % m + m) % m;
const ndarrayAssign = (target2, source) => {
  const numSource = +source;
  const isScalar = !Number.isNaN(numSource);
  if (isScalar) {
    if (target2.dimension === 1) {
      for (let i = 0; i < target2.shape[0]; ++i) {
        target2.set(i, numSource);
      }
    } else {
      for (let i = 0; i < target2.shape[0]; ++i) {
        for (let j = 0; j < target2.shape[1]; ++j) {
          target2.set(i, j, numSource);
        }
      }
    }
  } else {
    const ty = target2.shape[0];
    const tx = target2.shape[1];
    const sy = source.shape[0];
    const sx = source.shape[1];
    if (ty !== sy || tx !== sx) {
      console.warn("Cannot assign source to target ndarray as the dimensions do not match", ty, sy, tx, sx);
      return;
    }
    if (target2.dimension === 1) {
      for (let i = 0; i < target2.shape[0]; ++i) {
        target2.set(i, source.get(i));
      }
    } else {
      for (let i = 0; i < target2.shape[0]; ++i) {
        for (let j = 0; j < target2.shape[1]; ++j) {
          target2.set(i, j, source.get(i, j));
        }
      }
    }
  }
};
var iota_1;
var hasRequiredIota;
function requireIota() {
  if (hasRequiredIota) return iota_1;
  hasRequiredIota = 1;
  function iota2(n) {
    var result = new Array(n);
    for (var i = 0; i < n; ++i) {
      result[i] = i;
    }
    return result;
  }
  iota_1 = iota2;
  return iota_1;
}
var isBuffer_1;
var hasRequiredIsBuffer;
function requireIsBuffer() {
  if (hasRequiredIsBuffer) return isBuffer_1;
  hasRequiredIsBuffer = 1;
  isBuffer_1 = function(obj) {
    return obj != null && (isBuffer2(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
  };
  function isBuffer2(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
  }
  function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer2(obj.slice(0, 0));
  }
  return isBuffer_1;
}
var ndarray$1;
var hasRequiredNdarray;
function requireNdarray() {
  if (hasRequiredNdarray) return ndarray$1;
  hasRequiredNdarray = 1;
  var iota2 = requireIota();
  var isBuffer2 = requireIsBuffer();
  var hasTypedArrays = typeof Float64Array !== "undefined";
  function compare1st(a, b) {
    return a[0] - b[0];
  }
  function order2() {
    var stride = this.stride;
    var terms = new Array(stride.length);
    var i;
    for (i = 0; i < terms.length; ++i) {
      terms[i] = [Math.abs(stride[i]), i];
    }
    terms.sort(compare1st);
    var result = new Array(terms.length);
    for (i = 0; i < result.length; ++i) {
      result[i] = terms[i][1];
    }
    return result;
  }
  function compileConstructor(dtype, dimension) {
    var className = ["View", dimension, "d", dtype].join("");
    if (dimension < 0) {
      className = "View_Nil" + dtype;
    }
    var useGetters = dtype === "generic";
    if (dimension === -1) {
      var code = "function " + className + "(a){this.data=a;};	var proto=" + className + ".prototype;	proto.dtype='" + dtype + "';	proto.index=function(){return -1};	proto.size=0;	proto.dimension=-1;	proto.shape=proto.stride=proto.order=[];	proto.lo=proto.hi=proto.transpose=proto.step=	function(){return new " + className + "(this.data);};	proto.get=proto.set=function(){};	proto.pick=function(){return null};	return function construct_" + className + "(a){return new " + className + "(a);}";
      var procedure2 = new Function(code);
      return procedure2();
    } else if (dimension === 0) {
      var code = "function " + className + "(a,d) {	this.data = a;	this.offset = d	};	var proto=" + className + ".prototype;	proto.dtype='" + dtype + "';	proto.index=function(){return this.offset};	proto.dimension=0;	proto.size=1;	proto.shape=	proto.stride=	proto.order=[];	proto.lo=	proto.hi=	proto.transpose=	proto.step=function " + className + "_copy() {	return new " + className + "(this.data,this.offset)	};	proto.pick=function " + className + "_pick(){	return TrivialArray(this.data);	};	proto.valueOf=proto.get=function " + className + "_get(){	return " + (useGetters ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};	proto.set=function " + className + "_set(v){	return " + (useGetters ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "	};	return function construct_" + className + "(a,b,c,d){return new " + className + "(a,d)}";
      var procedure2 = new Function("TrivialArray", code);
      return procedure2(CACHED_CONSTRUCTORS[dtype][0]);
    }
    var code = ["'use strict'"];
    var indices = iota2(dimension);
    var args = indices.map(function(i2) {
      return "i" + i2;
    });
    var index_str = "this.offset+" + indices.map(function(i2) {
      return "this.stride[" + i2 + "]*i" + i2;
    }).join("+");
    var shapeArg = indices.map(function(i2) {
      return "b" + i2;
    }).join(",");
    var strideArg = indices.map(function(i2) {
      return "c" + i2;
    }).join(",");
    code.push("function " + className + "(a," + shapeArg + "," + strideArg + ",d){this.data=a", "this.shape=[" + shapeArg + "]", "this.stride=[" + strideArg + "]", "this.offset=d|0}", "var proto=" + className + ".prototype", "proto.dtype='" + dtype + "'", "proto.dimension=" + dimension);
    code.push("Object.defineProperty(proto,'size',{get:function " + className + "_size(){	return " + indices.map(function(i2) {
      return "this.shape[" + i2 + "]";
    }).join("*"), "}})");
    if (dimension === 1) {
      code.push("proto.order=[0]");
    } else {
      code.push("Object.defineProperty(proto,'order',{get:");
      if (dimension < 4) {
        code.push("function " + className + "_order(){");
        if (dimension === 2) {
          code.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})");
        } else if (dimension === 3) {
          code.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);	if(s0>s1){	if(s1>s2){	return [2,1,0];	}else if(s0>s2){	return [1,2,0];	}else{	return [1,0,2];	}	}else if(s0>s2){	return [2,0,1];	}else if(s2>s1){	return [0,1,2];	}else{	return [0,2,1];	}}})");
        }
      } else {
        code.push("ORDER})");
      }
    }
    code.push("proto.set=function " + className + "_set(" + args.join(",") + ",v){");
    if (useGetters) {
      code.push("return this.data.set(" + index_str + ",v)}");
    } else {
      code.push("return this.data[" + index_str + "]=v}");
    }
    code.push("proto.get=function " + className + "_get(" + args.join(",") + "){");
    if (useGetters) {
      code.push("return this.data.get(" + index_str + ")}");
    } else {
      code.push("return this.data[" + index_str + "]}");
    }
    code.push("proto.index=function " + className + "_index(", args.join(), "){return " + index_str + "}");
    code.push("proto.hi=function " + className + "_hi(" + args.join(",") + "){return new " + className + "(this.data," + indices.map(function(i2) {
      return ["(typeof i", i2, "!=='number'||i", i2, "<0)?this.shape[", i2, "]:i", i2, "|0"].join("");
    }).join(",") + "," + indices.map(function(i2) {
      return "this.stride[" + i2 + "]";
    }).join(",") + ",this.offset)}");
    var a_vars = indices.map(function(i2) {
      return "a" + i2 + "=this.shape[" + i2 + "]";
    });
    var c_vars = indices.map(function(i2) {
      return "c" + i2 + "=this.stride[" + i2 + "]";
    });
    code.push("proto.lo=function " + className + "_lo(" + args.join(",") + "){var b=this.offset,d=0," + a_vars.join(",") + "," + c_vars.join(","));
    for (var i = 0; i < dimension; ++i) {
      code.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){	d=i" + i + "|0;	b+=c" + i + "*d;	a" + i + "-=d}");
    }
    code.push("return new " + className + "(this.data," + indices.map(function(i2) {
      return "a" + i2;
    }).join(",") + "," + indices.map(function(i2) {
      return "c" + i2;
    }).join(",") + ",b)}");
    code.push("proto.step=function " + className + "_step(" + args.join(",") + "){var " + indices.map(function(i2) {
      return "a" + i2 + "=this.shape[" + i2 + "]";
    }).join(",") + "," + indices.map(function(i2) {
      return "b" + i2 + "=this.stride[" + i2 + "]";
    }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");
    for (var i = 0; i < dimension; ++i) {
      code.push("if(typeof i" + i + "==='number'){	d=i" + i + "|0;	if(d<0){	c+=b" + i + "*(a" + i + "-1);	a" + i + "=ceil(-a" + i + "/d)	}else{	a" + i + "=ceil(a" + i + "/d)	}	b" + i + "*=d	}");
    }
    code.push("return new " + className + "(this.data," + indices.map(function(i2) {
      return "a" + i2;
    }).join(",") + "," + indices.map(function(i2) {
      return "b" + i2;
    }).join(",") + ",c)}");
    var tShape = new Array(dimension);
    var tStride = new Array(dimension);
    for (var i = 0; i < dimension; ++i) {
      tShape[i] = "a[i" + i + "]";
      tStride[i] = "b[i" + i + "]";
    }
    code.push("proto.transpose=function " + className + "_transpose(" + args + "){" + args.map(function(n, idx) {
      return n + "=(" + n + "===undefined?" + idx + ":" + n + "|0)";
    }).join(";"), "var a=this.shape,b=this.stride;return new " + className + "(this.data," + tShape.join(",") + "," + tStride.join(",") + ",this.offset)}");
    code.push("proto.pick=function " + className + "_pick(" + args + "){var a=[],b=[],c=this.offset");
    for (var i = 0; i < dimension; ++i) {
      code.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){c=(c+this.stride[" + i + "]*i" + i + ")|0}else{a.push(this.shape[" + i + "]);b.push(this.stride[" + i + "])}");
    }
    code.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}");
    code.push("return function construct_" + className + "(data,shape,stride,offset){return new " + className + "(data," + indices.map(function(i2) {
      return "shape[" + i2 + "]";
    }).join(",") + "," + indices.map(function(i2) {
      return "stride[" + i2 + "]";
    }).join(",") + ",offset)}");
    var procedure2 = new Function("CTOR_LIST", "ORDER", code.join("\n"));
    return procedure2(CACHED_CONSTRUCTORS[dtype], order2);
  }
  function arrayDType(data2) {
    if (isBuffer2(data2)) {
      return "buffer";
    }
    if (hasTypedArrays) {
      switch (Object.prototype.toString.call(data2)) {
        case "[object Float64Array]":
          return "float64";
        case "[object Float32Array]":
          return "float32";
        case "[object Int8Array]":
          return "int8";
        case "[object Int16Array]":
          return "int16";
        case "[object Int32Array]":
          return "int32";
        case "[object Uint8Array]":
          return "uint8";
        case "[object Uint16Array]":
          return "uint16";
        case "[object Uint32Array]":
          return "uint32";
        case "[object Uint8ClampedArray]":
          return "uint8_clamped";
        case "[object BigInt64Array]":
          return "bigint64";
        case "[object BigUint64Array]":
          return "biguint64";
      }
    }
    if (Array.isArray(data2)) {
      return "array";
    }
    return "generic";
  }
  var CACHED_CONSTRUCTORS = {
    "float32": [],
    "float64": [],
    "int8": [],
    "int16": [],
    "int32": [],
    "uint8": [],
    "uint16": [],
    "uint32": [],
    "array": [],
    "uint8_clamped": [],
    "bigint64": [],
    "biguint64": [],
    "buffer": [],
    "generic": []
  };
  function wrappedNDArrayCtor(data2, shape, stride, offset) {
    if (data2 === void 0) {
      var ctor = CACHED_CONSTRUCTORS.array[0];
      return ctor([]);
    } else if (typeof data2 === "number") {
      data2 = [data2];
    }
    if (shape === void 0) {
      shape = [data2.length];
    }
    var d = shape.length;
    if (stride === void 0) {
      stride = new Array(d);
      for (var i = d - 1, sz = 1; i >= 0; --i) {
        stride[i] = sz;
        sz *= shape[i];
      }
    }
    if (offset === void 0) {
      offset = 0;
      for (var i = 0; i < d; ++i) {
        if (stride[i] < 0) {
          offset -= (shape[i] - 1) * stride[i];
        }
      }
    }
    var dtype = arrayDType(data2);
    var ctor_list = CACHED_CONSTRUCTORS[dtype];
    while (ctor_list.length <= d + 1) {
      ctor_list.push(compileConstructor(dtype, ctor_list.length - 1));
    }
    var ctor = ctor_list[d + 1];
    return ctor(data2, shape, stride, offset);
  }
  ndarray$1 = wrappedNDArrayCtor;
  return ndarray$1;
}
var ndarrayExports = requireNdarray();
const ndarray = /* @__PURE__ */ getDefaultExportFromCjs(ndarrayExports);
const ndarrayToList = (arr) => {
  const size = arr.shape.reduce((s, x) => s * x, 1);
  const list2 = new Array(size);
  if (arr.dimension === 1) {
    let l = 0;
    for (let i = 0; i < arr.shape[0]; ++i) {
      list2[l] = arr.get(i);
      l++;
    }
  } else {
    let l = 0;
    for (let i = 0; i < arr.shape[0]; ++i) {
      for (let j = 0; j < arr.shape[1]; ++j) {
        list2[l] = arr.get(i, j);
        l++;
      }
    }
  }
  return list2;
};
const ndarrayFlatten = (arr) => {
  if (arr.shape.length === 1) return arr;
  return ndarray(ndarrayToList(arr));
};
const numericifyVersion = (version2) => {
  const parts = version2.split(".");
  const tailLen = parts.slice(1).join("").length;
  return +parts.join("") / 10 ** tailLen;
};
const or$1 = (a, b) => a || b;
const pixiTextToSvg = (pixiText) => {
  const g = document.createElement("g");
  const t = document.createElement("text");
  if (pixiText.anchor.x === 0) {
    t.setAttribute("text-anchor", "start");
  } else if (pixiText.anchor.x === 1) {
    t.setAttribute("text-anchor", "end");
  } else {
    t.setAttribute("text-anchor", "middle");
  }
  t.setAttribute("font-family", pixiText.style.fontFamily?.toString() ?? "");
  t.setAttribute("font-size", pixiText.style.fontSize?.toString() ?? "");
  g.setAttribute("transform", `scale(${pixiText.scale.x},1)`);
  t.setAttribute("fill", pixiText.style.fill?.toString() ?? "");
  t.innerHTML = pixiText.text;
  g.appendChild(t);
  g.setAttribute("transform", `translate(${pixiText.x},${pixiText.y})scale(${pixiText.scale.x},1)`);
  return g;
};
const q = (queryStr) => {
  try {
    const queries = queryStr.split(".");
    return (rootObj) => {
      let obj = rootObj;
      queries.forEach((query) => {
        obj = obj[query];
      });
      return obj;
    };
  } catch (e) {
    return void 0;
  }
};
const rangeQuery2d = (src2, xDimSrc, xDimOut, xRange, yRange, mirrored, xOff = 0, yOff = 0, outList) => {
  const _xRange = mirrored ? yRange : xRange;
  const _yRange = mirrored ? xRange : yRange;
  const _xOff = mirrored ? yOff : xOff;
  const _yOff = mirrored ? xOff : yOff;
  const xFrom = Math.max(0, +_xRange[0] || 0);
  const xTo = Math.max(0, +_xRange[1] || 0);
  const yFrom = Math.max(0, +_yRange[0] || 0);
  const yTo = Math.max(0, +_yRange[1] || 0);
  let subList = [];
  if (!ArrayBuffer.isView(outList)) {
    console.warn("Not supported yet");
  }
  try {
    const newList = new outList.constructor(outList.length);
    let c = 0 + _yOff;
    for (let i = yFrom; i < yTo; i++) {
      newList.set(src2.slice(i * xDimSrc + xFrom, i * xDimSrc + xTo), _xOff + c * xDimOut);
      c += 1;
    }
    const acc = mirrored ? accessorTransposition(xDimOut, xDimOut) : void 0;
    subList = addArrays(outList, newList, acc);
  } catch (e) {
  }
  return subList;
};
const relToAbsChromPos = (chrom, x, y, chromInfo) => [chromInfo.chrPositions[chrom].pos + +x, chromInfo.chrPositions[chrom].pos + +y];
const XMLNS = "http://www.w3.org/2000/svg";
const removeClass = (el2, className) => {
  const reg2 = new RegExp(`(\\s|^)${className}(\\s|$)`);
  if (el2.namespaceURI === XMLNS) {
    const _class = el2.getAttribute("class") || "";
    el2.setAttribute("class", _class.replace(reg2, " "));
  } else if (el2.classList) {
    el2.classList.remove(className);
  } else if (hasClass(el2, className)) {
    el2.className = el2.className.replace(reg2, " ");
  }
};
const resetD3BrushStyle = (el2, className) => {
  el2.select(".selection").attr("fill", null).attr("fill-opacity", null).attr("stroke", null).classed(className, true);
};
const componentToHex = (c) => {
  const hex2 = c.toString(16);
  return hex2.length === 1 ? `0${hex2}` : hex2;
};
const rgbToHex$1 = (r2, g, b) => `#${componentToHex(r2)}${componentToHex(g)}${componentToHex(b)}`;
const scalesCenterAndK = (xScale, yScale) => {
  const xCenter = xScale.invert((xScale.range()[0] + xScale.range()[1]) / 2);
  const yCenter = yScale.invert((yScale.range()[0] + yScale.range()[1]) / 2);
  const k = xScale.invert(1) - xScale.invert(0);
  return [xCenter, yCenter, k];
};
const scalesToGenomeLoci = (xScale, yScale, chromInfo) => {
  if (chromInfo === null || !xScale || !yScale) return void 0;
  const x02 = xScale.domain()[0];
  const x12 = xScale.domain()[1];
  const y02 = yScale.domain()[0];
  const y12 = yScale.domain()[1];
  return [...dataToGenomicLoci(x02, x12, chromInfo), ...dataToGenomicLoci(y02, y12, chromInfo)];
};
const COLOR = 11184810;
const ALPHA = 1;
const showMousePosition = (pubSub, pubSubs, options2, getScales, getPosition, getDimensions, getIsFlipped, is2d, isGlobal) => {
  pubSub.publish("app.animateOnMouseMove", true);
  const color2 = options2.mousePositionColor ? hexStrToInt(options2.mousePositionColor) : COLOR;
  const alpha2 = options2.mousePositionAlpha || ALPHA;
  const graphics = new GLOBALS.PIXI.Graphics();
  const clearGraphics = () => {
    graphics.clear();
  };
  const drawMousePosition = (mousePos, isHorizontal, isNoClear) => {
    if (!isNoClear) clearGraphics();
    graphics.lineStyle(1, color2, alpha2);
    if (isHorizontal) {
      const addition = is2d ? getPosition()[0] : 0;
      graphics.moveTo(0, mousePos);
      graphics.lineTo(getDimensions()[0] + addition, mousePos);
    } else {
      const addition = is2d ? getPosition()[1] : 0;
      graphics.moveTo(mousePos, 0);
      graphics.lineTo(mousePos, getDimensions()[1] + addition);
    }
  };
  const mouseMoveHandler = (event) => {
    if (event.noHoveredTracks) {
      clearGraphics();
      return graphics;
    }
    let x;
    let y;
    if (event.isFromVerticalTrack) {
      x = event.dataY;
      y = event.dataY;
    } else {
      x = event.dataX;
      y = event.isFrom2dTrack ? event.dataY : event.dataX;
    }
    const offset = is2d ? getPosition() : [0, 0];
    const mousePos = getIsFlipped() ? getScales()[0](y) + offset[1] : getScales()[0](x) + offset[0];
    drawMousePosition(mousePos);
    if (is2d) drawMousePosition(getScales()[1](y) + offset[1], true, true);
    return graphics;
  };
  pubSubs.push(pubSub.subscribe("app.mouseMove", mouseMoveHandler));
  pubSubs.push(pubSub.subscribe("app.mouseLeave", clearGraphics));
  pubSubs.push(pubSub.subscribe("blur", clearGraphics));
  if (isGlobal) {
    pubSubs.push(globalPubSub.subscribe("higlass.mouseMove", mouseMoveHandler));
  }
  return graphics;
};
const setupShowMousePosition = (context, is2d = false, isGlobal = false) => {
  const scene = is2d ? context.pMasked : context.pForeground || context.pMain;
  if (!scene) {
    throw new Error("setupShowMousePosition: No scene found. Please make sure to call this method after the scene has been initialized.");
  }
  const getScales = () => [context.xScale(), context.yScale()];
  const graphics = showMousePosition(context.pubSub, context.pubSubs, context.options, getScales, context.getPosition.bind(context), context.getDimensions.bind(context), context.getProp("flipText"), is2d, isGlobal);
  scene.addChild(graphics);
  return () => {
    scene.removeChild(graphics);
  };
};
const some = (f2) => (x) => Array.prototype.some.call(x, f2);
const sum$1 = (a, b) => a + b;
const svgLine = (x12, y12, x2, y2, strokeWidth, strokeColor) => {
  const line = document.createElement("line");
  line.setAttribute("x1", String(x12));
  line.setAttribute("x2", String(x2));
  line.setAttribute("y1", String(y12));
  line.setAttribute("y2", String(y2));
  if (strokeWidth) {
    line.setAttribute("stroke-width", String(strokeWidth));
  }
  if (strokeColor) {
    line.setAttribute("stroke", strokeColor);
  }
  return line;
};
const throttleAndDebounce = (func, interval2, finalWait) => {
  let timeout2;
  let blockedCalls = 0;
  const reset = () => {
    timeout2 = void 0;
  };
  const debounced = (...args) => {
    const later = () => {
      if (blockedCalls > 0) {
        func(...args);
        blockedCalls = 0;
      }
    };
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, finalWait);
  };
  debounced.cancel = () => {
    clearTimeout(timeout2);
    reset();
  };
  debounced.immediate = (...args) => {
    func(...args);
  };
  let wait = false;
  const throttled = (_request, ...args) => {
    if (!wait) {
      func(...args);
      debounced(...args);
      wait = true;
      blockedCalls = 0;
      setTimeout(() => {
        wait = false;
      }, interval2);
    } else {
      blockedCalls++;
    }
  };
  return throttled;
};
const tileToCanvas = (pixData, w = 256, h = 256) => {
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get canvas context");
  }
  ctx.fillStyle = "transparent";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  const pix = new ImageData(pixData, canvas.width, canvas.height);
  ctx.putImageData(pix, 0, 0);
  return canvas;
};
const timeout$4 = (ms) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});
const totalTrackPixelHeight = (view) => {
  if (!view.tracks) return 0;
  let totalHeight = 0;
  if (view.tracks.top) {
    totalHeight += view.tracks.top.map((x) => x.height).reduce((a, b) => a + b, 0);
  }
  if (view.tracks.center) {
    totalHeight += view.tracks.center.map((x) => x.height).reduce((a, b) => a + b, 0);
  }
  if (view.tracks.bottom) {
    totalHeight += view.tracks.bottom.map((x) => x.height).reduce((a, b) => a + b, 0);
  }
  return totalHeight;
};
const toVoid = () => {
};
const trimTrailingSlash = (url) => (url || "").replace(/\/$/, "");
const valueToColor = (valueScale, colorScale, pseudoCounts = 0, eps = 1e-6) => (value) => {
  let rgbIdx = 255;
  if (value > eps) {
    rgbIdx = Math.max(0, Math.min(255, Math.floor(valueScale(value + pseudoCounts))));
  }
  return colorScale[rgbIdx];
};
const expandCombinedTracks = (trackList) => {
  let newTracks = [];
  for (const track of trackList) {
    if (isCombinedTrackConfig(track)) {
      newTracks = newTracks.concat(track.contents);
    } else {
      newTracks.push(track);
    }
  }
  return newTracks;
};
function _defineProperties$1s(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1s(o.key), o);
  }
}
function _createClass$1A(e, r2, t) {
  return r2 && _defineProperties$1s(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1s(t) {
  var i = _toPrimitive$1s(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1s(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _classCallCheck$1A(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
let IntervalTreeNode = /* @__PURE__ */ _createClass$1A(
  /**
   * @param {number} start
   * @param {number} end
   * @param {IntervalTreeNode} [left]
   * @param {IntervalTreeNode} [right]
   */
  function IntervalTreeNode2(start2, end2, left2, right2) {
    _classCallCheck$1A(this, IntervalTreeNode2);
    this.interval = [start2, end2];
    this.max = Number.NEGATIVE_INFINITY;
    this.parentNode = null;
    this.left = left2 ?? null;
    this.right = right2 ?? null;
  }
);
let IntervalTree = /* @__PURE__ */ (function() {
  function IntervalTree2() {
    _classCallCheck$1A(this, IntervalTree2);
    this.root = null;
  }
  return _createClass$1A(IntervalTree2, [{
    key: "add",
    value: function add2(interval2) {
      if (!this.root) {
        this.root = new IntervalTreeNode(interval2[0], interval2[1]);
        this.root.max = interval2[1];
        return;
      }
      addHelper(this.root, interval2);
    }
    /**
     * Checks or point belongs to at least one intarval from the tree.<br><br>
     * Complexity: O(log N).
     *
     * @public
     * @method
     * @param {Number} point Point which should be checked.
     * @return {Boolean} True if point belongs to one of the intervals.
     */
  }, {
    key: "contains",
    value: function contains2(point2) {
      return _contains(point2, this.root);
    }
    /**
     * Checks or interval belongs to at least one intarval from the tree.<br><br>
     * Complexity: O(log N).
     *
     * @public
     * @method
     * @param {Interval} interval Interval which should be checked.
     * @return {boolean} True if interval intersects with one of the intervals.
     */
  }, {
    key: "intersects",
    value: function intersects2(interval2) {
      return intersectsHelper(interval2, this.root);
    }
    /**
     * Returns height of the tree.
     *
     * @public
     * @method
     * @return {Number} Height of the tree.
     */
  }, {
    key: "height",
    value: function height() {
      return heightHelper(this.root);
    }
    /**
     * Returns node with the max endpoint in subtree.
     *
     * @public
     * @method
     * @param {IntervalTreeNode} node Root node of subtree.
     * @return {IntervalTreeNode | null} IntervalTreeNode with the largest endpoint.
     */
  }, {
    key: "findMax",
    value: function findMax(node2) {
      const stack = [node2];
      let current;
      let max2 = Number.NEGATIVE_INFINITY;
      let maxNode;
      while (stack.length) {
        current = stack.pop();
        if (current?.left) {
          stack.push(current.left);
        }
        if (current?.right) {
          stack.push(current.right);
        }
        if (current?.interval[1] > max2) {
          max2 = current.interval[1];
          maxNode = current;
        }
      }
      return maxNode ?? null;
    }
    /**
     * Adjust the max value.
     *
     * @param {Interval} interval
     * @param {IntervalTreeNode | null} node
     */
  }, {
    key: "_removeHelper",
    value: function _removeHelper(interval2, node2) {
      if (!node2) {
        return;
      }
      if (node2.interval[0] === interval2[0] && node2.interval[1] === interval2[1]) {
        if (node2.left && node2.right) {
          let replacement = node2.left;
          while (replacement.left) {
            replacement = replacement.left;
          }
          const temp = replacement.interval;
          replacement.interval = node2.interval;
          node2.interval = temp;
          this._removeHelper(replacement.interval, node2);
        } else {
          let side = "left";
          if (node2.right) {
            side = "right";
          }
          const parentNode = node2.parentNode;
          if (parentNode) {
            if (parentNode.left === node2) {
              parentNode.left = node2[side];
            } else {
              parentNode.right = node2[side];
            }
            if (node2[side]) {
              node2[side].parentNode = parentNode;
            }
          } else {
            this.root = node2[side];
            if (this.root) {
              this.root.parentNode = null;
            }
          }
        }
        const p = node2.parentNode;
        if (p) {
          let maxNode = this.findMax(p);
          const max2 = maxNode?.interval[1] ?? Number.NEGATIVE_INFINITY;
          while (maxNode) {
            if (maxNode.max === node2.interval[1]) {
              maxNode.max = max2;
              maxNode = maxNode.parentNode;
            } else {
              maxNode = null;
            }
          }
        }
      } else {
        this._removeHelper(interval2, node2.left);
        this._removeHelper(interval2, node2.right);
      }
    }
    /**
     * Remove interval from the tree.
     *
     * @public
     * @method
     * @param {Interval} interval - Array with start and end of the interval.
     */
  }, {
    key: "remove",
    value: function remove2(interval2) {
      return this._removeHelper(interval2, this.root);
    }
  }]);
})();
function addNode(node2, side, interval2) {
  let child = new IntervalTreeNode(interval2[0], interval2[1]);
  child.max = interval2[1];
  child.parentNode = node2;
  node2[side] = child;
  if (node2.max < interval2[1]) {
    while (child) {
      if (child.max < interval2[1]) {
        child.max = interval2[1];
      }
      child = child.parentNode;
    }
  }
}
function addHelper(node2, interval2) {
  if (node2.interval[0] > interval2[0]) {
    if (node2.left) {
      addHelper(node2.left, interval2);
    } else {
      addNode(node2, "left", interval2);
    }
  } else if (node2.right) {
    addHelper(node2.right, interval2);
  } else {
    addNode(node2, "right", interval2);
  }
}
function _contains(point2, node2) {
  if (!node2) {
    return false;
  }
  if (node2.interval[0] <= point2 && node2.interval[1] >= point2) {
    return true;
  }
  let result = false;
  let temp;
  ["left", "right"].forEach((key) => {
    temp = node2[key];
    if (temp) {
      if (temp.max > point2) {
        result = result || _contains(point2, temp);
      }
    }
  });
  return result;
}
function intersects(a, b) {
  return (
    // The first case checks for completely overlapping
    // intervals. Necessary because we usually consider
    // the ends to be open ended and that misses completely
    // overlapping intervals
    a[0] === b[0] && a[1] === b[1] || a[0] < b[0] && a[1] > b[0] || a[0] < b[1] && a[1] > b[1] || b[0] < a[0] && b[1] > a[0] || b[0] < a[1] && b[1] > a[1]
  );
}
function intersectsHelper(interval2, node2) {
  if (!node2) {
    return false;
  }
  if (intersects(node2.interval, interval2)) {
    return true;
  }
  let result = false;
  let temp;
  ["left", "right"].forEach((side) => {
    temp = node2[side];
    if (temp && temp.max >= interval2[0]) {
      result = result || intersectsHelper(interval2, temp);
    }
  });
  return result;
}
function heightHelper(node2) {
  if (!node2) {
    return 0;
  }
  return 1 + Math.max(heightHelper(node2.left), heightHelper(node2.right));
}
function segmentsToRows(segments) {
  segments.sort((a, b) => b.to - b.from - (a.to - a.from));
  const rows = [[]];
  const rowIts = [new IntervalTree()];
  for (let i = 0; i < segments.length; i++) {
    let placed = false;
    for (let j = 0; j < rows.length; j++) {
      const it2 = rowIts[j];
      const toCheck = [+segments[i].from, +segments[i].to];
      const occluded = it2.intersects(toCheck);
      if (!occluded) {
        it2.add(toCheck);
        rows[j].push(segments[i]);
        placed = true;
        break;
      }
    }
    if (!placed) {
      const newTree = new IntervalTree();
      newTree.add([segments[i].from, segments[i].to]);
      rows.push([segments[i]]);
      rowIts.push(newTree);
    }
  }
  return rows;
}
function _classCallCheck$1z(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1r(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1r(o.key), o);
  }
}
function _createClass$1z(e, r2, t) {
  return r2 && _defineProperties$1r(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1r(t) {
  var i = _toPrimitive$1r(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1r(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let DenseDataExtrema1D = /* @__PURE__ */ (function() {
  function DenseDataExtrema1D2(data2) {
    _classCallCheck$1z(this, DenseDataExtrema1D2);
    this.epsilon = 1e-6;
    this.data = data2;
    this.tileSize = this.data.length;
    this.paddedTileSize = 2 ** Math.ceil(Math.log2(this.tileSize));
    this.numSubsets = Math.min(NUM_PRECOMP_SUBSETS_PER_1D_TTILE, this.paddedTileSize);
    this.subsetSize = this.paddedTileSize / this.numSubsets;
    this.subsetMinimums = this.computeSubsetNonZeroMinimums();
    this.subsetMaximums = this.computeSubsetNonZeroMaximums();
    this.minNonZeroInTile = this.getMinNonZeroInTile();
    this.maxNonZeroInTile = this.getMaxNonZeroInTile();
  }
  return _createClass$1z(DenseDataExtrema1D2, [{
    key: "getMinNonZeroInSubset",
    value: function getMinNonZeroInSubset(indexBounds) {
      const start2 = indexBounds[0];
      const end2 = indexBounds[1];
      let curMin = Number.MAX_SAFE_INTEGER;
      if (start2 === 0 && end2 === this.tileSize) {
        return this.minNonZeroInTile;
      }
      const firstSubsetIndex = Math.ceil(start2 / this.subsetSize);
      const lastSubsetIndex = Math.floor((end2 - 1) / this.subsetSize);
      if (firstSubsetIndex >= lastSubsetIndex) {
        return this.minNonZero(this.data, start2, end2);
      }
      if (start2 < firstSubsetIndex * this.subsetSize) {
        curMin = Math.min(curMin, this.minNonZero(this.data, start2, firstSubsetIndex * this.subsetSize));
      }
      curMin = Math.min(curMin, this.minNonZero(this.subsetMinimums, firstSubsetIndex, lastSubsetIndex));
      if (end2 > lastSubsetIndex * this.subsetSize) {
        curMin = Math.min(curMin, this.minNonZero(this.data, lastSubsetIndex * this.subsetSize, end2));
      }
      return curMin;
    }
    /**
     * Computes the non-zero maximum in a subset using precomputed values, if possible
     *
     * @param {[start: number, end: number]}  indexBounds
     * @return {number} non-zero maxium of the subset
     */
  }, {
    key: "getMaxNonZeroInSubset",
    value: function getMaxNonZeroInSubset(indexBounds) {
      const start2 = indexBounds[0];
      const end2 = indexBounds[1];
      let curMax = Number.MIN_SAFE_INTEGER;
      if (start2 === 0 && end2 === this.tileSize) {
        return this.maxNonZeroInTile;
      }
      const firstSubsetIndex = Math.ceil(start2 / this.subsetSize);
      const lastSubsetIndex = Math.floor((end2 - 1) / this.subsetSize);
      if (firstSubsetIndex >= lastSubsetIndex) {
        return this.maxNonZero(this.data, start2, end2);
      }
      if (start2 < firstSubsetIndex * this.subsetSize) {
        curMax = Math.max(curMax, this.maxNonZero(this.data, start2, firstSubsetIndex * this.subsetSize));
      }
      curMax = Math.max(curMax, this.maxNonZero(this.subsetMaximums, firstSubsetIndex, lastSubsetIndex));
      if (end2 > lastSubsetIndex * this.subsetSize) {
        curMax = Math.max(curMax, this.maxNonZero(this.data, lastSubsetIndex * this.subsetSize, end2));
      }
      return curMax;
    }
    /**
     * Precomputes non-zero minimums of subsets of the given data vector
     *
     * @returns {Array<number>} - Minimums of the regularly subdivided data vector
     */
  }, {
    key: "computeSubsetNonZeroMinimums",
    value: function computeSubsetNonZeroMinimums() {
      const minimums = [];
      for (let i = 0; i < this.numSubsets; i++) {
        let curMin = Number.MAX_SAFE_INTEGER;
        for (let j = 0; j < this.subsetSize; j++) {
          const x = this.data[i * this.subsetSize + j];
          if (x === void 0) {
            continue;
          }
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x < curMin) {
            curMin = x;
          }
        }
        minimums.push(curMin);
      }
      return minimums;
    }
    /**
     * Precomputes non-zero maximums of subsets of the given data vector
     * @return {Array<number>} Maximums of the regularly subdivided data vector
     */
  }, {
    key: "computeSubsetNonZeroMaximums",
    value: function computeSubsetNonZeroMaximums() {
      const maximums = [];
      for (let i = 0; i < this.numSubsets; i++) {
        let curMax = Number.MIN_SAFE_INTEGER;
        for (let j = 0; j < this.subsetSize; j++) {
          const x = this.data[i * this.subsetSize + j];
          if (x === void 0) {
            continue;
          }
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x > curMax) {
            curMax = x;
          }
        }
        maximums.push(curMax);
      }
      return maximums;
    }
    /**
     * Computes the non-zero minimum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros maximum of the data
     */
  }, {
    key: "getMinNonZeroInTile",
    value: function getMinNonZeroInTile() {
      return Math.min(...this.subsetMinimums);
    }
    /**
     * Computes the non-zero maximum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros maximum of the data
     */
  }, {
    key: "getMaxNonZeroInTile",
    value: function getMaxNonZeroInTile() {
      return Math.max(...this.subsetMaximums);
    }
    /**
     * Calculate the minimum non-zero value in the data from start
     * to end. No precomputations are used to compute the min.
     *
     * @param {ArrayLike<number>} data
     * @param {number} start
     * @param {number} end
     * @return {number} non-zero min in subset
     */
  }, {
    key: "minNonZero",
    value: function minNonZero2(data2, start2, end2) {
      let minNonZeroNum = Number.MAX_SAFE_INTEGER;
      for (let i = start2; i < end2; i++) {
        const x = data2[i];
        if (x < this.epsilon && x > -this.epsilon) {
          continue;
        }
        if (x < minNonZeroNum) {
          minNonZeroNum = x;
        }
      }
      return minNonZeroNum;
    }
    /**
     * Calculate the maximum non-zero value in the data from start
     * to end. No precomputations are used to compute the max.
     *
     * @param {ArrayLike<number>} data
     * @param {number} start
     * @param {number} end
     * @return {number} non-zero max in subset
     */
  }, {
    key: "maxNonZero",
    value: function maxNonZero2(data2, start2, end2) {
      let maxNonZeroNum = Number.MIN_SAFE_INTEGER;
      for (let i = start2; i < end2; i++) {
        const x = data2[i];
        if (x < this.epsilon && x > -this.epsilon) {
          continue;
        }
        if (x > maxNonZeroNum) {
          maxNonZeroNum = x;
        }
      }
      return maxNonZeroNum;
    }
  }]);
})();
function _classCallCheck$1y(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1q(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1q(o.key), o);
  }
}
function _createClass$1y(e, r2, t) {
  return r2 && _defineProperties$1q(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1q(t) {
  var i = _toPrimitive$1q(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1q(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let DenseDataExtrema2D = /* @__PURE__ */ (function() {
  function DenseDataExtrema2D2(data2) {
    _classCallCheck$1y(this, DenseDataExtrema2D2);
    this.epsilon = 1e-6;
    this.tileSize = Math.sqrt(data2.length);
    if (!Number.isSafeInteger(this.tileSize)) {
      console.error("The DenseDataExtrema2D module only works for data of quadratic length.");
    }
    this.numSubsets = Math.min(NUM_PRECOMP_SUBSETS_PER_2D_TTILE, this.tileSize);
    this.subsetSize = this.tileSize / this.numSubsets;
    const dataMatrix = ndarray(Array.from(data2), [this.tileSize, this.tileSize]);
    this.subsetMinimums = this.computeSubsetNonZeroMinimums(dataMatrix);
    this.subsetMaximums = this.computeSubsetNonZeroMaximums(dataMatrix);
    this.minNonZeroInTile = this.getMinNonZeroInTile();
    this.maxNonZeroInTile = this.getMaxNonZeroInTile();
  }
  return _createClass$1y(DenseDataExtrema2D2, [{
    key: "getMinNonZeroInSubset",
    value: function getMinNonZeroInSubset(indexBounds) {
      const startX = indexBounds[0];
      const startY = indexBounds[1];
      const endX = indexBounds[2];
      const endY = indexBounds[3];
      const rowOffsetStart = Math.floor(startY / this.subsetSize);
      const colOffsetStart = Math.floor(startX / this.subsetSize);
      const height = Math.ceil((endY + 1) / this.subsetSize) - rowOffsetStart;
      const width = Math.ceil((endX + 1) / this.subsetSize) - colOffsetStart;
      const min2 = this.getMinNonZeroInNdarraySubset(this.subsetMinimums, rowOffsetStart, colOffsetStart, width, height);
      return min2;
    }
    /**
     * Computes an approximation of the non-zero maximum in a subset
     *
     * @param {[startX: number, startY: number, endX: number, endY: number]} indexBounds
     * @return {number} Non-zero maxium of the subset
     */
  }, {
    key: "getMaxNonZeroInSubset",
    value: function getMaxNonZeroInSubset(indexBounds) {
      const startX = indexBounds[0];
      const startY = indexBounds[1];
      const endX = indexBounds[2];
      const endY = indexBounds[3];
      const rowOffsetStart = Math.floor(startY / this.subsetSize);
      const colOffsetStart = Math.floor(startX / this.subsetSize);
      const height = Math.ceil((endY + 1) / this.subsetSize) - rowOffsetStart;
      const width = Math.ceil((endX + 1) / this.subsetSize) - colOffsetStart;
      const max2 = this.getMaxNonZeroInNdarraySubset(this.subsetMaximums, rowOffsetStart, colOffsetStart, width, height);
      return max2;
    }
    /**
     * Precomputes non-zero minimums of subsets of a given matrix
     * @param {View2D} dataMatrix
     * @return {View2D} Matrix containing minimums of the dataMatrix after subdivision using a regular grid
     */
  }, {
    key: "computeSubsetNonZeroMinimums",
    value: function computeSubsetNonZeroMinimums(dataMatrix) {
      const minimums = ndarray(new Array(this.numSubsets ** 2), [this.numSubsets, this.numSubsets]);
      for (let i = 0; i < this.numSubsets; i++) {
        for (let j = 0; j < this.numSubsets; j++) {
          const curMin = this.getMinNonZeroInNdarraySubset(dataMatrix, i * this.subsetSize, j * this.subsetSize, this.subsetSize, this.subsetSize);
          minimums.set(i, j, curMin);
        }
      }
      return minimums;
    }
    /**
     * Precomputes non-zero maximums of subsets of a given matrix
     *
     * @param {View2D} dataMatrix
     * @return {View2D} Matrix containing maximums of the dataMatrix after subdivision using a regular grid
     */
  }, {
    key: "computeSubsetNonZeroMaximums",
    value: function computeSubsetNonZeroMaximums(dataMatrix) {
      const maximums = ndarray(new Array(this.numSubsets ** 2), [this.numSubsets, this.numSubsets]);
      for (let i = 0; i < this.numSubsets; i++) {
        for (let j = 0; j < this.numSubsets; j++) {
          const curMax = this.getMaxNonZeroInNdarraySubset(dataMatrix, i * this.subsetSize, j * this.subsetSize, this.subsetSize, this.subsetSize);
          maximums.set(i, j, curMax);
        }
      }
      return maximums;
    }
    /**
     * Computes the non-zero minimum of a subset of a matrix (ndarray)
     * @param {View2D} arr
     * @param {number} rowOffset - Starting row of the subset
     * @param {number} colOffset - Starting column of the subset
     * @param {number} width - Width (num columns) of the subset
     * @param {number} height - Height (num rows) of the subset
     * @return {number} Non-zeros - minimum of the subset
     */
  }, {
    key: "getMinNonZeroInNdarraySubset",
    value: function getMinNonZeroInNdarraySubset(arr, rowOffset, colOffset, width, height) {
      let curMin = Number.MAX_SAFE_INTEGER;
      for (let k = 0; k < width; k++) {
        for (let l = 0; l < height; l++) {
          const x = arr.get(rowOffset + l, colOffset + k);
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x < curMin) {
            curMin = x;
          }
        }
      }
      return curMin;
    }
    /**
     * Computes the non-zero maximum of a subset of a matrix (ndarray)
     * @param {View2D} arr
     * @param {number} rowOffset - Starting row of the subset
     * @param {number} colOffset - Starting column of the subset
     * @param {number} width - Width (num columns) of the subset
     * @param {number} height - Height (num rows) of the subset
     * @return {number} Non-zeros maximum of the subset
     */
  }, {
    key: "getMaxNonZeroInNdarraySubset",
    value: function getMaxNonZeroInNdarraySubset(arr, rowOffset, colOffset, width, height) {
      let curMax = Number.MIN_SAFE_INTEGER;
      for (let k = 0; k < width; k++) {
        for (let l = 0; l < height; l++) {
          const x = arr.get(rowOffset + l, colOffset + k);
          if (x < this.epsilon && x > -this.epsilon) {
            continue;
          }
          if (x > curMax) {
            curMax = x;
          }
        }
      }
      return curMax;
    }
  }, {
    key: "mirrorPrecomputedExtrema",
    value: function mirrorPrecomputedExtrema() {
      for (let row = 1; row < this.numSubsets; row++) {
        for (let col = 0; col < row; col++) {
          this.subsetMinimums.set(col, row, this.subsetMinimums.get(row, col));
          this.subsetMaximums.set(col, row, this.subsetMaximums.get(row, col));
        }
      }
    }
    /**
     * Computes the non-zero minimum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros minimum of the data
     */
  }, {
    key: "getMinNonZeroInTile",
    value: function getMinNonZeroInTile() {
      return this.getMinNonZeroInNdarraySubset(this.subsetMinimums, 0, 0, this.numSubsets, this.numSubsets);
    }
    /**
     * Computes the non-zero maximum in the entire data array using precomputed values
     *
     * @return {number} Non-zeros maximum of the data
     */
  }, {
    key: "getMaxNonZeroInTile",
    value: function getMaxNonZeroInTile() {
      return this.getMaxNonZeroInNdarraySubset(this.subsetMaximums, 0, 0, this.numSubsets, this.numSubsets);
    }
  }]);
})();
const getAggregationFunction = (name) => {
  let aggFunc;
  const lowerCaseName = name ? name.toLowerCase() : name;
  switch (lowerCaseName) {
    case "mean":
      aggFunc = mean;
      break;
    case "sum":
      aggFunc = sum$2;
      break;
    case "variance":
      aggFunc = variance;
      break;
    case "deviation":
      aggFunc = deviation;
      break;
    default:
      aggFunc = mean;
      console.warn("Encountered an unsupported selectedRowsAggregationMode option.");
  }
  return aggFunc;
};
const selectedItemsToSize = (selectedItems, withRelativeSize) => selectedItems.reduce((a, h) => a + (Array.isArray(h) && withRelativeSize ? h.length : 1), 0);
const IS_TRACK_RANGE_SELECTABLE = (track) => {
  switch (track.type) {
    case "heatmap":
    case "horizontal-1d-heatmap":
    case "horizontal-bar":
    case "horizontal-line":
    case "horizontal-point":
    case "vertical-1d-heatmap":
    case "vertical-bar":
    case "vertical-line":
    case "vertical-point":
    case "horizontal-1d-tiles":
    case "vertical-1d-tiles":
    case "2d-tiles":
    case "horizontal-gene-annotations":
    case "vertical-gene-annotations":
    case "horizontal-heatmap":
    case "vertical-heatmap":
    case "osm-tiles":
    case "mapbox-tiles":
    case "horizontal-multivec":
      return true;
    case "combined": {
      const contents = track.contents;
      return contents.map((t) => IS_TRACK_RANGE_SELECTABLE(t)).reduce(or$1, false);
    }
    default:
      return false;
  }
};
function getDefaultTracksForDatatype$1(datatype, otherDefaultTracks) {
  if (window.higlassTracksByType) {
    Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
      TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
    });
  }
  if (!(datatype in DEFAULT_TRACKS_FOR_DATATYPE) && !otherDefaultTracks) {
    console.warn("unknown data type:", datatype);
    return void 0;
  }
  const orientationToPositions = {
    "1d-horizontal": ["top", "bottom", "left", "right"],
    "2d": ["center"],
    "1d-vertical": ["left", "right"]
  };
  const defaultTracks = DEFAULT_TRACKS_FOR_DATATYPE[datatype] || {};
  if (otherDefaultTracks) {
    for (const trackType of otherDefaultTracks) {
      if (!TRACKS_INFO_BY_TYPE[trackType]) {
        console.warn("unknown track type", trackType);
      } else {
        for (const position of orientationToPositions[TRACKS_INFO_BY_TYPE[trackType].orientation]) {
          defaultTracks[position] = trackType;
        }
      }
    }
  }
  return defaultTracks;
}
const COLLAPSED_HEIGHT = 10;
const trackHeight = (track) => {
  if (track.options?.collapsed) return COLLAPSED_HEIGHT;
  return track.height;
};
const trackWidth = (track) => {
  if (track.options?.collapsed) return COLLAPSED_HEIGHT;
  return track.width;
};
const getTrackObjectFromHGC = (hgc, viewUid, trackUid) => {
  let newViewUid = viewUid;
  let newTrackUid;
  if (!trackUid) {
    newTrackUid = viewUid;
    newViewUid = Object.values(hgc.state.views)[0].uid;
  } else {
    newTrackUid = trackUid;
  }
  return hgc.tiledPlots[newViewUid]?.trackRenderer?.getTrackObject(newTrackUid);
};
const getTrackRenderer = (hgc, viewUid) => hgc.tiledPlots[viewUid]?.trackRenderer;
const getTiledPlot = (hgc, viewUid) => hgc.tiledPlots[viewUid];
var ReactWrapper = {};
var isArguments$1;
var hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments) return isArguments$1;
  hasRequiredIsArguments = 1;
  var toStr = Object.prototype.toString;
  isArguments$1 = function isArguments2(value) {
    var str = toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) {
      isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
    }
    return isArgs;
  };
  return isArguments$1;
}
var implementation$9;
var hasRequiredImplementation$9;
function requireImplementation$9() {
  if (hasRequiredImplementation$9) return implementation$9;
  hasRequiredImplementation$9 = 1;
  var keysShim;
  if (!Object.keys) {
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = requireIsArguments();
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
      toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {
    }, "prototype");
    var dontEnums = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"];
    var equalsConstructorPrototype = function(o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = (function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k in window) {
        try {
          if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") {
            try {
              equalsConstructorPrototype(window[k]);
            } catch (e) {
              return true;
            }
          }
        } catch (e) {
          return true;
        }
      }
      return false;
    })();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e) {
        return false;
      }
    };
    keysShim = function keys2(object2) {
      var isObject2 = object2 !== null && typeof object2 === "object";
      var isFunction2 = toStr.call(object2) === "[object Function]";
      var isArguments2 = isArgs(object2);
      var isString2 = isObject2 && toStr.call(object2) === "[object String]";
      var theKeys = [];
      if (!isObject2 && !isFunction2 && !isArguments2) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction2;
      if (isString2 && object2.length > 0 && !has.call(object2, 0)) {
        for (var i = 0; i < object2.length; ++i) {
          theKeys.push(String(i));
        }
      }
      if (isArguments2 && object2.length > 0) {
        for (var j = 0; j < object2.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name in object2) {
          if (!(skipProto && name === "prototype") && has.call(object2, name)) {
            theKeys.push(String(name));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object2);
        for (var k = 0; k < dontEnums.length; ++k) {
          if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object2, dontEnums[k])) {
            theKeys.push(dontEnums[k]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$9 = keysShim;
  return implementation$9;
}
var objectKeys;
var hasRequiredObjectKeys;
function requireObjectKeys() {
  if (hasRequiredObjectKeys) return objectKeys;
  hasRequiredObjectKeys = 1;
  var slice2 = Array.prototype.slice;
  var isArgs = requireIsArguments();
  var origKeys = Object.keys;
  var keysShim = origKeys ? function keys2(o) {
    return origKeys(o);
  } : requireImplementation$9();
  var originalKeys = Object.keys;
  keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
      var keysWorksWithArguments = (function() {
        var args = Object.keys(arguments);
        return args && args.length === arguments.length;
      })(1, 2);
      if (!keysWorksWithArguments) {
        Object.keys = function keys2(object2) {
          if (isArgs(object2)) {
            return originalKeys(slice2.call(object2));
          }
          return originalKeys(object2);
        };
      }
    } else {
      Object.keys = keysShim;
    }
    return Object.keys || keysShim;
  };
  objectKeys = keysShim;
  return objectKeys;
}
var esDefineProperty;
var hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var $defineProperty = Object.defineProperty || false;
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", {
        value: 1
      });
    } catch (e) {
      $defineProperty = false;
    }
  }
  esDefineProperty = $defineProperty;
  return esDefineProperty;
}
var syntax;
var hasRequiredSyntax;
function requireSyntax() {
  if (hasRequiredSyntax) return syntax;
  hasRequiredSyntax = 1;
  syntax = SyntaxError;
  return syntax;
}
var type$5;
var hasRequiredType;
function requireType() {
  if (hasRequiredType) return type$5;
  hasRequiredType = 1;
  type$5 = TypeError;
  return type$5;
}
var gOPD;
var hasRequiredGOPD;
function requireGOPD() {
  if (hasRequiredGOPD) return gOPD;
  hasRequiredGOPD = 1;
  gOPD = Object.getOwnPropertyDescriptor;
  return gOPD;
}
var gopd;
var hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd) return gopd;
  hasRequiredGopd = 1;
  var $gOPD = /* @__PURE__ */ requireGOPD();
  if ($gOPD) {
    try {
      $gOPD([], "length");
    } catch (e) {
      $gOPD = null;
    }
  }
  gopd = $gOPD;
  return gopd;
}
var defineDataProperty;
var hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty) return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var gopd2 = /* @__PURE__ */ requireGopd();
  defineDataProperty = function defineDataProperty2(obj, property2, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") {
      throw new $TypeError("`obj` must be an object or a function`");
    }
    if (typeof property2 !== "string" && typeof property2 !== "symbol") {
      throw new $TypeError("`property` must be a string or a symbol`");
    }
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
      throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    }
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
      throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
    }
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
      throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    }
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
      throw new $TypeError("`loose`, if provided, must be a boolean");
    }
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    var desc = !!gopd2 && gopd2(obj, property2);
    if ($defineProperty) {
      $defineProperty(obj, property2, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
      });
    } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
      obj[property2] = value;
    } else {
      throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
    }
  };
  return defineDataProperty;
}
var hasPropertyDescriptors_1;
var hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors) return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var hasPropertyDescriptors = function hasPropertyDescriptors2() {
    return !!$defineProperty;
  };
  hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    if (!$defineProperty) {
      return null;
    }
    try {
      return $defineProperty([], "length", {
        value: 1
      }).length !== 1;
    } catch (e) {
      return true;
    }
  };
  hasPropertyDescriptors_1 = hasPropertyDescriptors;
  return hasPropertyDescriptors_1;
}
var defineProperties_1;
var hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var keys2 = requireObjectKeys();
  var hasSymbols2 = typeof Symbol === "function" && typeof /* @__PURE__ */ Symbol("foo") === "symbol";
  var toStr = Object.prototype.toString;
  var concat = Array.prototype.concat;
  var defineDataProperty2 = /* @__PURE__ */ requireDefineDataProperty();
  var isFunction2 = function(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
  };
  var supportsDescriptors = /* @__PURE__ */ requireHasPropertyDescriptors()();
  var defineProperty2 = function(object2, name, value, predicate) {
    if (name in object2) {
      if (predicate === true) {
        if (object2[name] === value) {
          return;
        }
      } else if (!isFunction2(predicate) || !predicate()) {
        return;
      }
    }
    if (supportsDescriptors) {
      defineDataProperty2(object2, name, value, true);
    } else {
      defineDataProperty2(object2, name, value);
    }
  };
  var defineProperties = function(object2, map2) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys2(map2);
    if (hasSymbols2) {
      props = concat.call(props, Object.getOwnPropertySymbols(map2));
    }
    for (var i = 0; i < props.length; i += 1) {
      defineProperty2(object2, props[i], map2[props[i]], predicates[props[i]]);
    }
  };
  defineProperties.supportsDescriptors = !!supportsDescriptors;
  defineProperties_1 = defineProperties;
  return defineProperties_1;
}
var callBind = { exports: {} };
var esObjectAtoms;
var hasRequiredEsObjectAtoms;
function requireEsObjectAtoms() {
  if (hasRequiredEsObjectAtoms) return esObjectAtoms;
  hasRequiredEsObjectAtoms = 1;
  esObjectAtoms = Object;
  return esObjectAtoms;
}
var esErrors;
var hasRequiredEsErrors;
function requireEsErrors() {
  if (hasRequiredEsErrors) return esErrors;
  hasRequiredEsErrors = 1;
  esErrors = Error;
  return esErrors;
}
var _eval;
var hasRequired_eval;
function require_eval() {
  if (hasRequired_eval) return _eval;
  hasRequired_eval = 1;
  _eval = EvalError;
  return _eval;
}
var range$3;
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range$3;
  hasRequiredRange = 1;
  range$3 = RangeError;
  return range$3;
}
var ref$1;
var hasRequiredRef$1;
function requireRef$1() {
  if (hasRequiredRef$1) return ref$1;
  hasRequiredRef$1 = 1;
  ref$1 = ReferenceError;
  return ref$1;
}
var uri;
var hasRequiredUri;
function requireUri() {
  if (hasRequiredUri) return uri;
  hasRequiredUri = 1;
  uri = URIError;
  return uri;
}
var abs$2;
var hasRequiredAbs;
function requireAbs() {
  if (hasRequiredAbs) return abs$2;
  hasRequiredAbs = 1;
  abs$2 = Math.abs;
  return abs$2;
}
var floor$1;
var hasRequiredFloor$1;
function requireFloor$1() {
  if (hasRequiredFloor$1) return floor$1;
  hasRequiredFloor$1 = 1;
  floor$1 = Math.floor;
  return floor$1;
}
var max$1;
var hasRequiredMax;
function requireMax() {
  if (hasRequiredMax) return max$1;
  hasRequiredMax = 1;
  max$1 = Math.max;
  return max$1;
}
var min$1;
var hasRequiredMin;
function requireMin() {
  if (hasRequiredMin) return min$1;
  hasRequiredMin = 1;
  min$1 = Math.min;
  return min$1;
}
var pow$1;
var hasRequiredPow;
function requirePow() {
  if (hasRequiredPow) return pow$1;
  hasRequiredPow = 1;
  pow$1 = Math.pow;
  return pow$1;
}
var round;
var hasRequiredRound;
function requireRound() {
  if (hasRequiredRound) return round;
  hasRequiredRound = 1;
  round = Math.round;
  return round;
}
var _isNaN;
var hasRequired_isNaN;
function require_isNaN() {
  if (hasRequired_isNaN) return _isNaN;
  hasRequired_isNaN = 1;
  _isNaN = Number.isNaN || function isNaN2(a) {
    return a !== a;
  };
  return _isNaN;
}
var sign$1;
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign$1;
  hasRequiredSign = 1;
  var $isNaN = /* @__PURE__ */ require_isNaN();
  sign$1 = function sign2(number3) {
    if ($isNaN(number3) || number3 === 0) {
      return number3;
    }
    return number3 < 0 ? -1 : 1;
  };
  return sign$1;
}
var shams$1;
var hasRequiredShams$1;
function requireShams$1() {
  if (hasRequiredShams$1) return shams$1;
  hasRequiredShams$1 = 1;
  shams$1 = function hasSymbols2() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
      return false;
    }
    if (typeof Symbol.iterator === "symbol") {
      return true;
    }
    var obj = {};
    var sym = /* @__PURE__ */ Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
      return false;
    }
    var symVal = 42;
    obj[sym] = symVal;
    for (var _ in obj) {
      return false;
    }
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === "function") {
      var descriptor = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(obj, sym)
      );
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };
  return shams$1;
}
var hasSymbols;
var hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols;
  hasRequiredHasSymbols = 1;
  var origSymbol = typeof Symbol !== "undefined" && Symbol;
  var hasSymbolSham = requireShams$1();
  hasSymbols = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") {
      return false;
    }
    if (typeof Symbol !== "function") {
      return false;
    }
    if (typeof origSymbol("foo") !== "symbol") {
      return false;
    }
    if (typeof /* @__PURE__ */ Symbol("bar") !== "symbol") {
      return false;
    }
    return hasSymbolSham();
  };
  return hasSymbols;
}
var Reflect_getPrototypeOf;
var hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  if (hasRequiredReflect_getPrototypeOf) return Reflect_getPrototypeOf;
  hasRequiredReflect_getPrototypeOf = 1;
  Reflect_getPrototypeOf = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
  return Reflect_getPrototypeOf;
}
var Object_getPrototypeOf;
var hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  Object_getPrototypeOf = $Object.getPrototypeOf || null;
  return Object_getPrototypeOf;
}
var implementation$8;
var hasRequiredImplementation$8;
function requireImplementation$8() {
  if (hasRequiredImplementation$8) return implementation$8;
  hasRequiredImplementation$8 = 1;
  var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
  var toStr = Object.prototype.toString;
  var max2 = Math.max;
  var funcType = "[object Function]";
  var concatty = function concatty2(a, b) {
    var arr = [];
    for (var i = 0; i < a.length; i += 1) {
      arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
      arr[j + a.length] = b[j];
    }
    return arr;
  };
  var slicy = function slicy2(arrLike, offset) {
    var arr = [];
    for (var i = offset, j = 0; i < arrLike.length; i += 1, j += 1) {
      arr[j] = arrLike[i];
    }
    return arr;
  };
  var joiny = function(arr, joiner) {
    var str = "";
    for (var i = 0; i < arr.length; i += 1) {
      str += arr[i];
      if (i + 1 < arr.length) {
        str += joiner;
      }
    }
    return str;
  };
  implementation$8 = function bind(that) {
    var target2 = this;
    if (typeof target2 !== "function" || toStr.apply(target2) !== funcType) {
      throw new TypeError(ERROR_MESSAGE + target2);
    }
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
      if (this instanceof bound) {
        var result = target2.apply(this, concatty(args, arguments));
        if (Object(result) === result) {
          return result;
        }
        return this;
      }
      return target2.apply(that, concatty(args, arguments));
    };
    var boundLength = max2(0, target2.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
      boundArgs[i] = "$" + i;
    }
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target2.prototype) {
      var Empty = function Empty2() {
      };
      Empty.prototype = target2.prototype;
      bound.prototype = new Empty();
      Empty.prototype = null;
    }
    return bound;
  };
  return implementation$8;
}
var functionBind;
var hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind) return functionBind;
  hasRequiredFunctionBind = 1;
  var implementation2 = requireImplementation$8();
  functionBind = Function.prototype.bind || implementation2;
  return functionBind;
}
var functionCall;
var hasRequiredFunctionCall;
function requireFunctionCall() {
  if (hasRequiredFunctionCall) return functionCall;
  hasRequiredFunctionCall = 1;
  functionCall = Function.prototype.call;
  return functionCall;
}
var functionApply;
var hasRequiredFunctionApply;
function requireFunctionApply() {
  if (hasRequiredFunctionApply) return functionApply;
  hasRequiredFunctionApply = 1;
  functionApply = Function.prototype.apply;
  return functionApply;
}
var reflectApply;
var hasRequiredReflectApply;
function requireReflectApply() {
  if (hasRequiredReflectApply) return reflectApply;
  hasRequiredReflectApply = 1;
  reflectApply = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
  return reflectApply;
}
var actualApply;
var hasRequiredActualApply;
function requireActualApply() {
  if (hasRequiredActualApply) return actualApply;
  hasRequiredActualApply = 1;
  var bind = requireFunctionBind();
  var $apply = requireFunctionApply();
  var $call = requireFunctionCall();
  var $reflectApply = requireReflectApply();
  actualApply = $reflectApply || bind.call($call, $apply);
  return actualApply;
}
var callBindApplyHelpers;
var hasRequiredCallBindApplyHelpers;
function requireCallBindApplyHelpers() {
  if (hasRequiredCallBindApplyHelpers) return callBindApplyHelpers;
  hasRequiredCallBindApplyHelpers = 1;
  var bind = requireFunctionBind();
  var $TypeError = /* @__PURE__ */ requireType();
  var $call = requireFunctionCall();
  var $actualApply = requireActualApply();
  callBindApplyHelpers = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== "function") {
      throw new $TypeError("a function is required");
    }
    return $actualApply(bind, $call, args);
  };
  return callBindApplyHelpers;
}
var get$7;
var hasRequiredGet$1;
function requireGet$1() {
  if (hasRequiredGet$1) return get$7;
  hasRequiredGet$1 = 1;
  var callBind2 = requireCallBindApplyHelpers();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var hasProtoAccessor;
  try {
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e) {
    if (!e || typeof e !== "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") {
      throw e;
    }
  }
  var desc = !!hasProtoAccessor && gOPD2 && gOPD2(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  );
  var $Object = Object;
  var $getPrototypeOf = $Object.getPrototypeOf;
  get$7 = desc && typeof desc.get === "function" ? callBind2([desc.get]) : typeof $getPrototypeOf === "function" ? (
    /** @type {import('./get')} */
    function getDunder(value) {
      return $getPrototypeOf(value == null ? value : $Object(value));
    }
  ) : false;
  return get$7;
}
var getProto;
var hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto;
  hasRequiredGetProto = 1;
  var reflectGetProto = requireReflect_getPrototypeOf();
  var originalGetProto = requireObject_getPrototypeOf();
  var getDunderProto = /* @__PURE__ */ requireGet$1();
  getProto = reflectGetProto ? function getProto2(O) {
    return reflectGetProto(O);
  } : originalGetProto ? function getProto2(O) {
    if (!O || typeof O !== "object" && typeof O !== "function") {
      throw new TypeError("getProto: not an object");
    }
    return originalGetProto(O);
  } : getDunderProto ? function getProto2(O) {
    return getDunderProto(O);
  } : null;
  return getProto;
}
var hasown;
var hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var call = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;
  var bind = requireFunctionBind();
  hasown = bind.call(call, $hasOwn);
  return hasown;
}
var getIntrinsic;
var hasRequiredGetIntrinsic$1;
function requireGetIntrinsic$1() {
  if (hasRequiredGetIntrinsic$1) return getIntrinsic;
  hasRequiredGetIntrinsic$1 = 1;
  var undefined$1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  var $Error = /* @__PURE__ */ requireEsErrors();
  var $EvalError = /* @__PURE__ */ require_eval();
  var $RangeError = /* @__PURE__ */ requireRange();
  var $ReferenceError = /* @__PURE__ */ requireRef$1();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var $URIError = /* @__PURE__ */ requireUri();
  var abs2 = /* @__PURE__ */ requireAbs();
  var floor2 = /* @__PURE__ */ requireFloor$1();
  var max2 = /* @__PURE__ */ requireMax();
  var min2 = /* @__PURE__ */ requireMin();
  var pow2 = /* @__PURE__ */ requirePow();
  var round2 = /* @__PURE__ */ requireRound();
  var sign2 = /* @__PURE__ */ requireSign();
  var $Function = Function;
  var getEvalledConstructor = function(expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {
    }
  };
  var $gOPD = /* @__PURE__ */ requireGopd();
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var throwTypeError = function() {
    throw new $TypeError();
  };
  var ThrowTypeError = $gOPD ? (function() {
    try {
      arguments.callee;
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        return $gOPD(arguments, "callee").get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  })() : throwTypeError;
  var hasSymbols2 = requireHasSymbols()();
  var getProto2 = requireGetProto();
  var $ObjectGPO = requireObject_getPrototypeOf();
  var $ReflectGPO = requireReflect_getPrototypeOf();
  var $apply = requireFunctionApply();
  var $call = requireFunctionCall();
  var needsEval = {};
  var TypedArray = typeof Uint8Array === "undefined" || !getProto2 ? undefined$1 : getProto2(Uint8Array);
  var INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2([][Symbol.iterator]()) : undefined$1,
    "%AsyncFromSyncIteratorPrototype%": undefined$1,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": $EvalError,
    "%Float16Array%": typeof Float16Array === "undefined" ? undefined$1 : Float16Array,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(getProto2([][Symbol.iterator]())) : undefined$1,
    "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
    "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": $Object,
    "%Object.getOwnPropertyDescriptor%": $gOPD,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
    "%RangeError%": $RangeError,
    "%ReferenceError%": $ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto2 ? undefined$1 : getProto2((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols2 && getProto2 ? getProto2(""[Symbol.iterator]()) : undefined$1,
    "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
    "%URIError%": $URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet,
    "%Function.prototype.call%": $call,
    "%Function.prototype.apply%": $apply,
    "%Object.defineProperty%": $defineProperty,
    "%Object.getPrototypeOf%": $ObjectGPO,
    "%Math.abs%": abs2,
    "%Math.floor%": floor2,
    "%Math.max%": max2,
    "%Math.min%": min2,
    "%Math.pow%": pow2,
    "%Math.round%": round2,
    "%Math.sign%": sign2,
    "%Reflect.getPrototypeOf%": $ReflectGPO
  };
  if (getProto2) {
    try {
      null.error;
    } catch (e) {
      var errorProto = getProto2(getProto2(e));
      INTRINSICS["%Error.prototype%"] = errorProto;
    }
  }
  var doEval = function doEval2(name) {
    var value;
    if (name === "%AsyncFunction%") {
      value = getEvalledConstructor("async function () {}");
    } else if (name === "%GeneratorFunction%") {
      value = getEvalledConstructor("function* () {}");
    } else if (name === "%AsyncGeneratorFunction%") {
      value = getEvalledConstructor("async function* () {}");
    } else if (name === "%AsyncGenerator%") {
      var fn = doEval2("%AsyncGeneratorFunction%");
      if (fn) {
        value = fn.prototype;
      }
    } else if (name === "%AsyncIteratorPrototype%") {
      var gen = doEval2("%AsyncGenerator%");
      if (gen && getProto2) {
        value = getProto2(gen.prototype);
      }
    }
    INTRINSICS[name] = value;
    return value;
  };
  var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  };
  var bind = requireFunctionBind();
  var hasOwn = /* @__PURE__ */ requireHasown();
  var $concat = bind.call($call, Array.prototype.concat);
  var $spliceApply = bind.call($apply, Array.prototype.splice);
  var $replace = bind.call($call, String.prototype.replace);
  var $strSlice = bind.call($call, String.prototype.slice);
  var $exec = bind.call($call, RegExp.prototype.exec);
  var rePropName2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
  var reEscapeChar2 = /\\(\\)?/g;
  var stringToPath2 = function stringToPath3(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") {
      throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    } else if (last === "%" && first !== "%") {
      throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    }
    var result = [];
    $replace(string, rePropName2, function(match, number3, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar2, "$1") : number3 || match;
    });
    return result;
  };
  var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
      alias = LEGACY_ALIASES[intrinsicName];
      intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval) {
        value = doEval(intrinsicName);
      }
      if (typeof value === "undefined" && !allowMissing) {
        throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
      }
      return {
        alias,
        name: intrinsicName,
        value
      };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
  };
  getIntrinsic = function GetIntrinsic2(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) {
      throw new $TypeError("intrinsic name must be a non-empty string");
    }
    if (arguments.length > 1 && typeof allowMissing !== "boolean") {
      throw new $TypeError('"allowMissing" argument must be a boolean');
    }
    if ($exec(/^%?[^%]*%?$/, name) === null) {
      throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    }
    var parts = stringToPath2(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
      intrinsicBaseName = alias[0];
      $spliceApply(parts, $concat([0, 1], alias));
    }
    for (var i = 1, isOwn = true; i < parts.length; i += 1) {
      var part2 = parts[i];
      var first = $strSlice(part2, 0, 1);
      var last = $strSlice(part2, -1);
      if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) {
        throw new $SyntaxError("property names with quotes must have matching quotes");
      }
      if (part2 === "constructor" || !isOwn) {
        skipFurtherCaching = true;
      }
      intrinsicBaseName += "." + part2;
      intrinsicRealName = "%" + intrinsicBaseName + "%";
      if (hasOwn(INTRINSICS, intrinsicRealName)) {
        value = INTRINSICS[intrinsicRealName];
      } else if (value != null) {
        if (!(part2 in value)) {
          if (!allowMissing) {
            throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
          }
          return void undefined$1;
        }
        if ($gOPD && i + 1 >= parts.length) {
          var desc = $gOPD(value, part2);
          isOwn = !!desc;
          if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
            value = desc.get;
          } else {
            value = value[part2];
          }
        } else {
          isOwn = hasOwn(value, part2);
          value = value[part2];
        }
        if (isOwn && !skipFurtherCaching) {
          INTRINSICS[intrinsicRealName] = value;
        }
      }
    }
    return value;
  };
  return getIntrinsic;
}
var setFunctionLength;
var hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength) return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var define2 = /* @__PURE__ */ requireDefineDataProperty();
  var hasDescriptors = /* @__PURE__ */ requireHasPropertyDescriptors()();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var $TypeError = /* @__PURE__ */ requireType();
  var $floor = GetIntrinsic2("%Math.floor%");
  setFunctionLength = function setFunctionLength2(fn, length2) {
    if (typeof fn !== "function") {
      throw new $TypeError("`fn` is not a function");
    }
    if (typeof length2 !== "number" || length2 < 0 || length2 > 4294967295 || $floor(length2) !== length2) {
      throw new $TypeError("`length` must be a positive 32-bit integer");
    }
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && gOPD2) {
      var desc = gOPD2(fn, "length");
      if (desc && !desc.configurable) {
        functionLengthIsConfigurable = false;
      }
      if (desc && !desc.writable) {
        functionLengthIsWritable = false;
      }
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
      if (hasDescriptors) {
        define2(
          /** @type {Parameters<define>[0]} */
          fn,
          "length",
          length2,
          true,
          true
        );
      } else {
        define2(
          /** @type {Parameters<define>[0]} */
          fn,
          "length",
          length2
        );
      }
    }
    return fn;
  };
  return setFunctionLength;
}
var applyBind;
var hasRequiredApplyBind;
function requireApplyBind() {
  if (hasRequiredApplyBind) return applyBind;
  hasRequiredApplyBind = 1;
  var bind = requireFunctionBind();
  var $apply = requireFunctionApply();
  var actualApply2 = requireActualApply();
  applyBind = function applyBind2() {
    return actualApply2(bind, $apply, arguments);
  };
  return applyBind;
}
var hasRequiredCallBind;
function requireCallBind() {
  if (hasRequiredCallBind) return callBind.exports;
  hasRequiredCallBind = 1;
  (function(module2) {
    var setFunctionLength2 = /* @__PURE__ */ requireSetFunctionLength();
    var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
    var callBindBasic = requireCallBindApplyHelpers();
    var applyBind2 = requireApplyBind();
    module2.exports = function callBind2(originalFunction) {
      var func = callBindBasic(arguments);
      var adjustedLength = originalFunction.length - (arguments.length - 1);
      return setFunctionLength2(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
    };
    if ($defineProperty) {
      $defineProperty(module2.exports, "apply", {
        value: applyBind2
      });
    } else {
      module2.exports.apply = applyBind2;
    }
  })(callBind);
  return callBind.exports;
}
var callBound$1;
var hasRequiredCallBound$1;
function requireCallBound$1() {
  if (hasRequiredCallBound$1) return callBound$1;
  hasRequiredCallBound$1 = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var callBindBasic = requireCallBindApplyHelpers();
  var $indexOf = callBindBasic([GetIntrinsic2("%String.prototype.indexOf%")]);
  callBound$1 = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      GetIntrinsic2(name, !!allowMissing)
    );
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
      return callBindBasic(
        /** @type {const} */
        [intrinsic]
      );
    }
    return intrinsic;
  };
  return callBound$1;
}
var implementation$7;
var hasRequiredImplementation$7;
function requireImplementation$7() {
  if (hasRequiredImplementation$7) return implementation$7;
  hasRequiredImplementation$7 = 1;
  var objectKeys2 = requireObjectKeys();
  var hasSymbols2 = requireShams$1()();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  var $push = callBound2("Array.prototype.push");
  var $propIsEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  var originalGetSymbols = hasSymbols2 ? $Object.getOwnPropertySymbols : null;
  implementation$7 = function assign(target2, source1) {
    if (target2 == null) {
      throw new TypeError("target must be an object");
    }
    var to = $Object(target2);
    if (arguments.length === 1) {
      return to;
    }
    for (var s = 1; s < arguments.length; ++s) {
      var from = $Object(arguments[s]);
      var keys2 = objectKeys2(from);
      var getSymbols2 = hasSymbols2 && ($Object.getOwnPropertySymbols || originalGetSymbols);
      if (getSymbols2) {
        var syms = getSymbols2(from);
        for (var j = 0; j < syms.length; ++j) {
          var key = syms[j];
          if ($propIsEnumerable(from, key)) {
            $push(keys2, key);
          }
        }
      }
      for (var i = 0; i < keys2.length; ++i) {
        var nextKey = keys2[i];
        if ($propIsEnumerable(from, nextKey)) {
          var propValue = from[nextKey];
          to[nextKey] = propValue;
        }
      }
    }
    return to;
  };
  return implementation$7;
}
var polyfill$7;
var hasRequiredPolyfill$7;
function requirePolyfill$7() {
  if (hasRequiredPolyfill$7) return polyfill$7;
  hasRequiredPolyfill$7 = 1;
  var implementation2 = requireImplementation$7();
  var lacksProperEnumerationOrder = function() {
    if (!Object.assign) {
      return false;
    }
    var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map2 = {};
    for (var i = 0; i < letters.length; ++i) {
      map2[letters[i]] = letters[i];
    }
    var obj = Object.assign({}, map2);
    var actual = "";
    for (var k in obj) {
      actual += k;
    }
    return str !== actual;
  };
  var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) {
      return false;
    }
    var thrower = Object.preventExtensions({
      1: 2
    });
    try {
      Object.assign(thrower, "xy");
    } catch (e) {
      return thrower[1] === "y";
    }
    return false;
  };
  polyfill$7 = function getPolyfill() {
    if (!Object.assign) {
      return implementation2;
    }
    if (lacksProperEnumerationOrder()) {
      return implementation2;
    }
    if (assignHasPendingExceptions()) {
      return implementation2;
    }
    return Object.assign;
  };
  return polyfill$7;
}
var shim$7;
var hasRequiredShim$7;
function requireShim$7() {
  if (hasRequiredShim$7) return shim$7;
  hasRequiredShim$7 = 1;
  var define2 = requireDefineProperties();
  var getPolyfill = requirePolyfill$7();
  shim$7 = function shimAssign() {
    var polyfill2 = getPolyfill();
    define2(Object, {
      assign: polyfill2
    }, {
      assign: function() {
        return Object.assign !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$7;
}
var object_assign;
var hasRequiredObject_assign;
function requireObject_assign() {
  if (hasRequiredObject_assign) return object_assign;
  hasRequiredObject_assign = 1;
  var defineProperties = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$7();
  var getPolyfill = requirePolyfill$7();
  var shim2 = requireShim$7();
  var polyfill2 = callBind2.apply(getPolyfill());
  var bound = function assign(target2, source1) {
    return polyfill2(Object, arguments);
  };
  defineProperties(bound, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  object_assign = bound;
  return object_assign;
}
var _isFinite;
var hasRequired_isFinite;
function require_isFinite() {
  if (hasRequired_isFinite) return _isFinite;
  hasRequired_isFinite = 1;
  var $isNaN = /* @__PURE__ */ require_isNaN();
  _isFinite = function isFinite2(x) {
    return (typeof x === "number" || typeof x === "bigint") && !$isNaN(x) && x !== Infinity && x !== -Infinity;
  };
  return _isFinite;
}
var isInteger;
var hasRequiredIsInteger;
function requireIsInteger() {
  if (hasRequiredIsInteger) return isInteger;
  hasRequiredIsInteger = 1;
  var $abs = /* @__PURE__ */ requireAbs();
  var $floor = /* @__PURE__ */ requireFloor$1();
  var $isNaN = /* @__PURE__ */ require_isNaN();
  var $isFinite = /* @__PURE__ */ require_isFinite();
  isInteger = function isInteger2(argument) {
    if (typeof argument !== "number" || $isNaN(argument) || !$isFinite(argument)) {
      return false;
    }
    var absValue = $abs(argument);
    return $floor(absValue) === absValue;
  };
  return isInteger;
}
var isObject$1;
var hasRequiredIsObject;
function requireIsObject() {
  if (hasRequiredIsObject) return isObject$1;
  hasRequiredIsObject = 1;
  isObject$1 = function isObject2(x) {
    return !!x && (typeof x === "function" || typeof x === "object");
  };
  return isObject$1;
}
var maxArrayLength;
var hasRequiredMaxArrayLength;
function requireMaxArrayLength() {
  if (hasRequiredMaxArrayLength) return maxArrayLength;
  hasRequiredMaxArrayLength = 1;
  maxArrayLength = 4294967295;
  return maxArrayLength;
}
var Reflect_setPrototypeOf;
var hasRequiredReflect_setPrototypeOf;
function requireReflect_setPrototypeOf() {
  if (hasRequiredReflect_setPrototypeOf) return Reflect_setPrototypeOf;
  hasRequiredReflect_setPrototypeOf = 1;
  Reflect_setPrototypeOf = typeof Reflect !== "undefined" && Reflect.setPrototypeOf || null;
  return Reflect_setPrototypeOf;
}
var Object_setPrototypeOf;
var hasRequiredObject_setPrototypeOf;
function requireObject_setPrototypeOf() {
  if (hasRequiredObject_setPrototypeOf) return Object_setPrototypeOf;
  hasRequiredObject_setPrototypeOf = 1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  Object_setPrototypeOf = $Object.setPrototypeOf || null;
  return Object_setPrototypeOf;
}
var set$5;
var hasRequiredSet;
function requireSet() {
  if (hasRequiredSet) return set$5;
  hasRequiredSet = 1;
  var callBind2 = requireCallBindApplyHelpers();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var $TypeError = /* @__PURE__ */ requireType();
  var obj = {};
  try {
    obj.__proto__ = null;
  } catch (e) {
    if (!e || typeof e !== "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") {
      throw e;
    }
  }
  var hasProtoMutator = !("toString" in obj);
  var desc = gOPD2 && gOPD2(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  );
  set$5 = hasProtoMutator && // eslint-disable-next-line no-extra-parens
  (!!desc && typeof desc.set === "function" && /** @type {import('./set')} */
  callBind2([desc.set]) || /** @type {import('./set')} */
  function setDunder(object2, proto2) {
    if (object2 == null) {
      throw new $TypeError("set Object.prototype.__proto__ called on null or undefined");
    }
    object2.__proto__ = proto2;
    return proto2;
  });
  return set$5;
}
var setProto;
var hasRequiredSetProto;
function requireSetProto() {
  if (hasRequiredSetProto) return setProto;
  hasRequiredSetProto = 1;
  var reflectSetProto = requireReflect_setPrototypeOf();
  var originalSetProto = requireObject_setPrototypeOf();
  var setDunderProto = /* @__PURE__ */ requireSet();
  var $TypeError = /* @__PURE__ */ requireType();
  setProto = reflectSetProto ? function setProto2(O, proto2) {
    if (reflectSetProto(O, proto2)) {
      return O;
    }
    throw new $TypeError("Reflect.setPrototypeOf: failed to set [[Prototype]]");
  } : originalSetProto || (setDunderProto ? function setProto2(O, proto2) {
    setDunderProto(O, proto2);
    return O;
  } : null);
  return setProto;
}
var ArrayCreate;
var hasRequiredArrayCreate;
function requireArrayCreate() {
  if (hasRequiredArrayCreate) return ArrayCreate;
  hasRequiredArrayCreate = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $ArrayPrototype = GetIntrinsic2("%Array.prototype%");
  var $RangeError = /* @__PURE__ */ requireRange();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var isInteger2 = /* @__PURE__ */ requireIsInteger();
  var MAX_ARRAY_LENGTH = /* @__PURE__ */ requireMaxArrayLength();
  var $setProto = requireSetProto();
  ArrayCreate = function ArrayCreate2(length2) {
    if (!isInteger2(length2) || length2 < 0) {
      throw new $TypeError("Assertion failed: `length` must be an integer Number >= 0");
    }
    if (length2 > MAX_ARRAY_LENGTH) {
      throw new $RangeError("length is greater than (2**32 - 1)");
    }
    var proto2 = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
    var A5 = [];
    if (proto2 !== $ArrayPrototype) {
      if (!$setProto) {
        throw new $SyntaxError("ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]");
      }
      $setProto(A5, proto2);
    }
    if (length2 !== 0) {
      A5.length = length2;
    }
    return A5;
  };
  return ArrayCreate;
}
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var objectInspect;
var hasRequiredObjectInspect;
function requireObjectInspect() {
  if (hasRequiredObjectInspect) return objectInspect;
  hasRequiredObjectInspect = 1;
  var hasMap = typeof Map === "function" && Map.prototype;
  var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
  var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
  var mapForEach = hasMap && Map.prototype.forEach;
  var hasSet = typeof Set === "function" && Set.prototype;
  var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
  var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
  var setForEach = hasSet && Set.prototype.forEach;
  var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
  var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
  var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
  var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
  var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
  var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
  var booleanValueOf = Boolean.prototype.valueOf;
  var objectToString2 = Object.prototype.toString;
  var functionToString = Function.prototype.toString;
  var $match = String.prototype.match;
  var $slice = String.prototype.slice;
  var $replace = String.prototype.replace;
  var $toUpperCase = String.prototype.toUpperCase;
  var $toLowerCase = String.prototype.toLowerCase;
  var $test = RegExp.prototype.test;
  var $concat = Array.prototype.concat;
  var $join = Array.prototype.join;
  var $arrSlice = Array.prototype.slice;
  var $floor = Math.floor;
  var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
  var gOPS = Object.getOwnPropertySymbols;
  var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
  var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
  var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
    return O.__proto__;
  } : null);
  function addNumericSeparator(num2, str) {
    if (num2 === Infinity || num2 === -Infinity || num2 !== num2 || num2 && num2 > -1e3 && num2 < 1e3 || $test.call(/e/, str)) {
      return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num2 === "number") {
      var int2 = num2 < 0 ? -$floor(-num2) : $floor(num2);
      if (int2 !== num2) {
        var intStr = String(int2);
        var dec = $slice.call(str, intStr.length + 1);
        return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return $replace.call(str, sepRegex, "$&_");
  }
  var utilInspect = require$$0$5;
  var inspectCustom = utilInspect.custom;
  var inspectSymbol = isSymbol2(inspectCustom) ? inspectCustom : null;
  var quotes = {
    __proto__: null,
    "double": '"',
    single: "'"
  };
  var quoteREs = {
    __proto__: null,
    "double": /(["\\])/g,
    single: /(['\\])/g
  };
  objectInspect = function inspect_(obj, options2, depth, seen) {
    var opts = options2 || {};
    if (has(opts, "quoteStyle") && !has(quotes, opts.quoteStyle)) {
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    }
    if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") {
      return "undefined";
    }
    if (obj === null) {
      return "null";
    }
    if (typeof obj === "boolean") {
      return obj ? "true" : "false";
    }
    if (typeof obj === "string") {
      return inspectString(obj, opts);
    }
    if (typeof obj === "number") {
      if (obj === 0) {
        return Infinity / obj > 0 ? "0" : "-0";
      }
      var str = String(obj);
      return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
      var bigIntStr = String(obj) + "n";
      return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth2 = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") {
      depth = 0;
    }
    if (depth >= maxDepth2 && maxDepth2 > 0 && typeof obj === "object") {
      return isArray2(obj) ? "[Array]" : "[Object]";
    }
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") {
      seen = [];
    } else if (indexOf(seen, obj) >= 0) {
      return "[Circular]";
    }
    function inspect(value, from, noIndent) {
      if (from) {
        seen = $arrSlice.call(seen);
        seen.push(from);
      }
      if (noIndent) {
        var newOpts = {
          depth: opts.depth
        };
        if (has(opts, "quoteStyle")) {
          newOpts.quoteStyle = opts.quoteStyle;
        }
        return inspect_(value, newOpts, depth + 1, seen);
      }
      return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
      var name = nameOf(obj);
      var keys2 = arrObjKeys(obj, inspect);
      return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys2.length > 0 ? " { " + $join.call(keys2, ", ") + " }" : "");
    }
    if (isSymbol2(obj)) {
      var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
      return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
      var s = "<" + $toLowerCase.call(String(obj.nodeName));
      var attrs = obj.attributes || [];
      for (var i = 0; i < attrs.length; i++) {
        s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
      }
      s += ">";
      if (obj.childNodes && obj.childNodes.length) {
        s += "...";
      }
      s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
      return s;
    }
    if (isArray2(obj)) {
      if (obj.length === 0) {
        return "[]";
      }
      var xs = arrObjKeys(obj, inspect);
      if (indent && !singleLineValues(xs)) {
        return "[" + indentedJoin(xs, indent) + "]";
      }
      return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
      var parts = arrObjKeys(obj, inspect);
      if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
        return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
      }
      if (parts.length === 0) {
        return "[" + String(obj) + "]";
      }
      return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
      if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
        return utilInspect(obj, {
          depth: maxDepth2 - depth
        });
      } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
        return obj.inspect();
      }
    }
    if (isMap2(obj)) {
      var mapParts = [];
      if (mapForEach) {
        mapForEach.call(obj, function(value, key) {
          mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
      }
      return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet2(obj)) {
      var setParts = [];
      if (setForEach) {
        setForEach.call(obj, function(value) {
          setParts.push(inspect(value, obj));
        });
      }
      return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
      return weakCollectionOf("WeakMap");
    }
    if (isWeakSet(obj)) {
      return weakCollectionOf("WeakSet");
    }
    if (isWeakRef(obj)) {
      return weakCollectionOf("WeakRef");
    }
    if (isNumber(obj)) {
      return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
      return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
      return markBoxed(booleanValueOf.call(obj));
    }
    if (isString2(obj)) {
      return markBoxed(inspect(String(obj)));
    }
    if (typeof window !== "undefined" && obj === window) {
      return "{ [object Window] }";
    }
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof globalThis !== "undefined" && obj === globalThis) {
      return "{ [object globalThis] }";
    }
    if (!isDate(obj) && !isRegExp(obj)) {
      var ys = arrObjKeys(obj, inspect);
      var isPlainObject2 = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
      var protoTag = obj instanceof Object ? "" : "null prototype";
      var stringTag2 = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
      var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
      var tag = constructorTag + (stringTag2 || protoTag ? "[" + $join.call($concat.call([], stringTag2 || [], protoTag || []), ": ") + "] " : "");
      if (ys.length === 0) {
        return tag + "{}";
      }
      if (indent) {
        return tag + "{" + indentedJoin(ys, indent) + "}";
      }
      return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
  };
  function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
  }
  function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
  }
  function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === "object" && (toStringTag in obj || typeof obj[toStringTag] !== "undefined"));
  }
  function isArray2(obj) {
    return toStr(obj) === "[object Array]" && canTrustToString(obj);
  }
  function isDate(obj) {
    return toStr(obj) === "[object Date]" && canTrustToString(obj);
  }
  function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && canTrustToString(obj);
  }
  function isError(obj) {
    return toStr(obj) === "[object Error]" && canTrustToString(obj);
  }
  function isString2(obj) {
    return toStr(obj) === "[object String]" && canTrustToString(obj);
  }
  function isNumber(obj) {
    return toStr(obj) === "[object Number]" && canTrustToString(obj);
  }
  function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && canTrustToString(obj);
  }
  function isSymbol2(obj) {
    if (hasShammedSymbols) {
      return obj && typeof obj === "object" && obj instanceof Symbol;
    }
    if (typeof obj === "symbol") {
      return true;
    }
    if (!obj || typeof obj !== "object" || !symToString) {
      return false;
    }
    try {
      symToString.call(obj);
      return true;
    } catch (e) {
    }
    return false;
  }
  function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) {
      return false;
    }
    try {
      bigIntValueOf.call(obj);
      return true;
    } catch (e) {
    }
    return false;
  }
  var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
  };
  function has(obj, key) {
    return hasOwn.call(obj, key);
  }
  function toStr(obj) {
    return objectToString2.call(obj);
  }
  function nameOf(f2) {
    if (f2.name) {
      return f2.name;
    }
    var m = $match.call(functionToString.call(f2), /^function\s*([\w$]+)/);
    if (m) {
      return m[1];
    }
    return null;
  }
  function indexOf(xs, x) {
    if (xs.indexOf) {
      return xs.indexOf(x);
    }
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) {
        return i;
      }
    }
    return -1;
  }
  function isMap2(x) {
    if (!mapSize || !x || typeof x !== "object") {
      return false;
    }
    try {
      mapSize.call(x);
      try {
        setSize.call(x);
      } catch (s) {
        return true;
      }
      return x instanceof Map;
    } catch (e) {
    }
    return false;
  }
  function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") {
      return false;
    }
    try {
      weakMapHas.call(x, weakMapHas);
      try {
        weakSetHas.call(x, weakSetHas);
      } catch (s) {
        return true;
      }
      return x instanceof WeakMap;
    } catch (e) {
    }
    return false;
  }
  function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") {
      return false;
    }
    try {
      weakRefDeref.call(x);
      return true;
    } catch (e) {
    }
    return false;
  }
  function isSet2(x) {
    if (!setSize || !x || typeof x !== "object") {
      return false;
    }
    try {
      setSize.call(x);
      try {
        mapSize.call(x);
      } catch (m) {
        return true;
      }
      return x instanceof Set;
    } catch (e) {
    }
    return false;
  }
  function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") {
      return false;
    }
    try {
      weakSetHas.call(x, weakSetHas);
      try {
        weakMapHas.call(x, weakMapHas);
      } catch (s) {
        return true;
      }
      return x instanceof WeakSet;
    } catch (e) {
    }
    return false;
  }
  function isElement(x) {
    if (!x || typeof x !== "object") {
      return false;
    }
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
      return true;
    }
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
  }
  function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
      var remaining = str.length - opts.maxStringLength;
      var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
      return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || "single"];
    quoteRE.lastIndex = 0;
    var s = $replace.call($replace.call(str, quoteRE, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
  }
  function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[n];
    if (x) {
      return "\\" + x;
    }
    return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
  }
  function markBoxed(str) {
    return "Object(" + str + ")";
  }
  function weakCollectionOf(type2) {
    return type2 + " { ? }";
  }
  function collectionOf(type2, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type2 + " (" + size + ") {" + joinedEntries + "}";
  }
  function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
      if (indexOf(xs[i], "\n") >= 0) {
        return false;
      }
    }
    return true;
  }
  function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") {
      baseIndent = "	";
    } else if (typeof opts.indent === "number" && opts.indent > 0) {
      baseIndent = $join.call(Array(opts.indent + 1), " ");
    } else {
      return null;
    }
    return {
      base: baseIndent,
      prev: $join.call(Array(depth + 1), baseIndent)
    };
  }
  function indentedJoin(xs, indent) {
    if (xs.length === 0) {
      return "";
    }
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
  }
  function arrObjKeys(obj, inspect) {
    var isArr = isArray2(obj);
    var xs = [];
    if (isArr) {
      xs.length = obj.length;
      for (var i = 0; i < obj.length; i++) {
        xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
      }
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
      symMap = {};
      for (var k = 0; k < syms.length; k++) {
        symMap["$" + syms[k]] = syms[k];
      }
    }
    for (var key in obj) {
      if (!has(obj, key)) {
        continue;
      }
      if (isArr && String(Number(key)) === key && key < obj.length) {
        continue;
      }
      if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
        continue;
      } else if ($test.call(/[^\w$]/, key)) {
        xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
      } else {
        xs.push(key + ": " + inspect(obj[key], obj));
      }
    }
    if (typeof gOPS === "function") {
      for (var j = 0; j < syms.length; j++) {
        if (isEnumerable.call(obj, syms[j])) {
          xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
        }
      }
    }
    return xs;
  }
  return objectInspect;
}
var isPropertyKey;
var hasRequiredIsPropertyKey;
function requireIsPropertyKey() {
  if (hasRequiredIsPropertyKey) return isPropertyKey;
  hasRequiredIsPropertyKey = 1;
  isPropertyKey = function isPropertyKey2(argument) {
    return typeof argument === "string" || typeof argument === "symbol";
  };
  return isPropertyKey;
}
var Get;
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return Get;
  hasRequiredGet = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var inspect = /* @__PURE__ */ requireObjectInspect();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  Get = function Get2(O, P) {
    if (!isObject2(O)) {
      throw new $TypeError("Assertion failed: Type(O) is not Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: P is not a Property Key, got " + inspect(P));
    }
    return O[P];
  };
  return Get;
}
var IsArray$1;
var hasRequiredIsArray$1;
function requireIsArray$1() {
  if (hasRequiredIsArray$1) return IsArray$1;
  hasRequiredIsArray$1 = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $Array = GetIntrinsic2("%Array%");
  var toStr = !$Array.isArray && /* @__PURE__ */ requireCallBound$1()("Object.prototype.toString");
  IsArray$1 = $Array.isArray || function IsArray2(argument) {
    return toStr(argument) === "[object Array]";
  };
  return IsArray$1;
}
var IsArray;
var hasRequiredIsArray;
function requireIsArray() {
  if (hasRequiredIsArray) return IsArray;
  hasRequiredIsArray = 1;
  IsArray = /* @__PURE__ */ requireIsArray$1();
  return IsArray;
}
var IsConstructor = { exports: {} };
var GetIntrinsic;
var hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic) return GetIntrinsic;
  hasRequiredGetIntrinsic = 1;
  GetIntrinsic = /* @__PURE__ */ requireGetIntrinsic$1();
  return GetIntrinsic;
}
var propertyDescriptor;
var hasRequiredPropertyDescriptor;
function requirePropertyDescriptor() {
  if (hasRequiredPropertyDescriptor) return propertyDescriptor;
  hasRequiredPropertyDescriptor = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var hasOwn = /* @__PURE__ */ requireHasown();
  var allowed = {
    __proto__: null,
    "[[Configurable]]": true,
    "[[Enumerable]]": true,
    "[[Get]]": true,
    "[[Set]]": true,
    "[[Value]]": true,
    "[[Writable]]": true
  };
  propertyDescriptor = function isPropertyDescriptor(Desc) {
    if (!Desc || typeof Desc !== "object") {
      return false;
    }
    for (var key in Desc) {
      if (hasOwn(Desc, key) && !allowed[key]) {
        return false;
      }
    }
    var isData = hasOwn(Desc, "[[Value]]") || hasOwn(Desc, "[[Writable]]");
    var IsAccessor = hasOwn(Desc, "[[Get]]") || hasOwn(Desc, "[[Set]]");
    if (isData && IsAccessor) {
      throw new $TypeError("Property Descriptors may not be both accessor and data descriptors");
    }
    return true;
  };
  return propertyDescriptor;
}
var DefineOwnProperty;
var hasRequiredDefineOwnProperty;
function requireDefineOwnProperty() {
  if (hasRequiredDefineOwnProperty) return DefineOwnProperty;
  hasRequiredDefineOwnProperty = 1;
  var hasPropertyDescriptors = /* @__PURE__ */ requireHasPropertyDescriptors();
  var $defineProperty = /* @__PURE__ */ requireEsDefineProperty();
  var hasArrayLengthDefineBug = hasPropertyDescriptors.hasArrayLengthDefineBug();
  var isArray2 = hasArrayLengthDefineBug && /* @__PURE__ */ requireIsArray$1();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $isEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  DefineOwnProperty = function DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, desc) {
    if (!$defineProperty) {
      if (!IsDataDescriptor2(desc)) {
        return false;
      }
      if (!desc["[[Configurable]]"] || !desc["[[Writable]]"]) {
        return false;
      }
      if (P in O && $isEnumerable(O, P) !== !!desc["[[Enumerable]]"]) {
        return false;
      }
      var V = desc["[[Value]]"];
      O[P] = V;
      return SameValue2(O[P], V);
    }
    if (hasArrayLengthDefineBug && P === "length" && "[[Value]]" in desc && isArray2(O) && O.length !== desc["[[Value]]"]) {
      O.length = desc["[[Value]]"];
      return O.length === desc["[[Value]]"];
    }
    $defineProperty(O, P, FromPropertyDescriptor2(desc));
    return true;
  };
  return DefineOwnProperty;
}
var fromPropertyDescriptor;
var hasRequiredFromPropertyDescriptor$1;
function requireFromPropertyDescriptor$1() {
  if (hasRequiredFromPropertyDescriptor$1) return fromPropertyDescriptor;
  hasRequiredFromPropertyDescriptor$1 = 1;
  fromPropertyDescriptor = function fromPropertyDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return Desc;
    }
    var obj = {};
    if ("[[Value]]" in Desc) {
      obj.value = Desc["[[Value]]"];
    }
    if ("[[Writable]]" in Desc) {
      obj.writable = !!Desc["[[Writable]]"];
    }
    if ("[[Get]]" in Desc) {
      obj.get = Desc["[[Get]]"];
    }
    if ("[[Set]]" in Desc) {
      obj.set = Desc["[[Set]]"];
    }
    if ("[[Enumerable]]" in Desc) {
      obj.enumerable = !!Desc["[[Enumerable]]"];
    }
    if ("[[Configurable]]" in Desc) {
      obj.configurable = !!Desc["[[Configurable]]"];
    }
    return obj;
  };
  return fromPropertyDescriptor;
}
var FromPropertyDescriptor;
var hasRequiredFromPropertyDescriptor;
function requireFromPropertyDescriptor() {
  if (hasRequiredFromPropertyDescriptor) return FromPropertyDescriptor;
  hasRequiredFromPropertyDescriptor = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  var fromPropertyDescriptor2 = /* @__PURE__ */ requireFromPropertyDescriptor$1();
  FromPropertyDescriptor = function FromPropertyDescriptor2(Desc) {
    if (typeof Desc !== "undefined" && !isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: `Desc` must be a Property Descriptor");
    }
    return fromPropertyDescriptor2(Desc);
  };
  return FromPropertyDescriptor;
}
var IsDataDescriptor;
var hasRequiredIsDataDescriptor;
function requireIsDataDescriptor() {
  if (hasRequiredIsDataDescriptor) return IsDataDescriptor;
  hasRequiredIsDataDescriptor = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var hasOwn = /* @__PURE__ */ requireHasown();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  IsDataDescriptor = function IsDataDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return false;
    }
    if (!isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: `Desc` must be a Property Descriptor");
    }
    if (!hasOwn(Desc, "[[Value]]") && !hasOwn(Desc, "[[Writable]]")) {
      return false;
    }
    return true;
  };
  return IsDataDescriptor;
}
var SameValue;
var hasRequiredSameValue;
function requireSameValue() {
  if (hasRequiredSameValue) return SameValue;
  hasRequiredSameValue = 1;
  var $isNaN = /* @__PURE__ */ require_isNaN();
  SameValue = function SameValue2(x, y) {
    if (x === y) {
      if (x === 0) {
        return 1 / x === 1 / y;
      }
      return true;
    }
    return $isNaN(x) && $isNaN(y);
  };
  return SameValue;
}
var isCallable;
var hasRequiredIsCallable$1;
function requireIsCallable$1() {
  if (hasRequiredIsCallable$1) return isCallable;
  hasRequiredIsCallable$1 = 1;
  var fnToStr = Function.prototype.toString;
  var reflectApply2 = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
  var badArrayLike;
  var isCallableMarker;
  if (typeof reflectApply2 === "function" && typeof Object.defineProperty === "function") {
    try {
      badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
          throw isCallableMarker;
        }
      });
      isCallableMarker = {};
      reflectApply2(function() {
        throw 42;
      }, null, badArrayLike);
    } catch (_) {
      if (_ !== isCallableMarker) {
        reflectApply2 = null;
      }
    }
  } else {
    reflectApply2 = null;
  }
  var constructorRegex = /^\s*class\b/;
  var isES6ClassFn = function isES6ClassFunction(value) {
    try {
      var fnStr = fnToStr.call(value);
      return constructorRegex.test(fnStr);
    } catch (e) {
      return false;
    }
  };
  var tryFunctionObject = function tryFunctionToStr(value) {
    try {
      if (isES6ClassFn(value)) {
        return false;
      }
      fnToStr.call(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = Object.prototype.toString;
  var objectClass = "[object Object]";
  var fnClass = "[object Function]";
  var genClass = "[object GeneratorFunction]";
  var ddaClass = "[object HTMLAllCollection]";
  var ddaClass2 = "[object HTML document.all class]";
  var ddaClass3 = "[object HTMLCollection]";
  var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
  var isIE68 = !(0 in [,]);
  var isDDA = function isDocumentDotAll() {
    return false;
  };
  if (typeof document === "object") {
    var all2 = document.all;
    if (toStr.call(all2) === toStr.call(document.all)) {
      isDDA = function isDocumentDotAll2(value) {
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
          try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
          } catch (e) {
          }
        }
        return false;
      };
    }
  }
  isCallable = reflectApply2 ? function isCallable2(value) {
    if (isDDA(value)) {
      return true;
    }
    if (!value) {
      return false;
    }
    if (typeof value !== "function" && typeof value !== "object") {
      return false;
    }
    try {
      reflectApply2(value, null, badArrayLike);
    } catch (e) {
      if (e !== isCallableMarker) {
        return false;
      }
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
  } : function isCallable2(value) {
    if (isDDA(value)) {
      return true;
    }
    if (!value) {
      return false;
    }
    if (typeof value !== "function" && typeof value !== "object") {
      return false;
    }
    if (hasToStringTag) {
      return tryFunctionObject(value);
    }
    if (isES6ClassFn(value)) {
      return false;
    }
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
      return false;
    }
    return tryFunctionObject(value);
  };
  return isCallable;
}
var IsCallable;
var hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable) return IsCallable;
  hasRequiredIsCallable = 1;
  IsCallable = requireIsCallable$1();
  return IsCallable;
}
var ToBoolean;
var hasRequiredToBoolean;
function requireToBoolean() {
  if (hasRequiredToBoolean) return ToBoolean;
  hasRequiredToBoolean = 1;
  ToBoolean = function ToBoolean2(value) {
    return !!value;
  };
  return ToBoolean;
}
var ToPropertyDescriptor;
var hasRequiredToPropertyDescriptor;
function requireToPropertyDescriptor() {
  if (hasRequiredToPropertyDescriptor) return ToPropertyDescriptor;
  hasRequiredToPropertyDescriptor = 1;
  var hasOwn = /* @__PURE__ */ requireHasown();
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var IsCallable2 = /* @__PURE__ */ requireIsCallable();
  var ToBoolean2 = /* @__PURE__ */ requireToBoolean();
  ToPropertyDescriptor = function ToPropertyDescriptor2(Obj) {
    if (!isObject2(Obj)) {
      throw new $TypeError("ToPropertyDescriptor requires an object");
    }
    var desc = {};
    if (hasOwn(Obj, "enumerable")) {
      desc["[[Enumerable]]"] = ToBoolean2(Obj.enumerable);
    }
    if (hasOwn(Obj, "configurable")) {
      desc["[[Configurable]]"] = ToBoolean2(Obj.configurable);
    }
    if (hasOwn(Obj, "value")) {
      desc["[[Value]]"] = Obj.value;
    }
    if (hasOwn(Obj, "writable")) {
      desc["[[Writable]]"] = ToBoolean2(Obj.writable);
    }
    if (hasOwn(Obj, "get")) {
      var getter = Obj.get;
      if (typeof getter !== "undefined" && !IsCallable2(getter)) {
        throw new $TypeError("getter must be a function");
      }
      desc["[[Get]]"] = getter;
    }
    if (hasOwn(Obj, "set")) {
      var setter = Obj.set;
      if (typeof setter !== "undefined" && !IsCallable2(setter)) {
        throw new $TypeError("setter must be a function");
      }
      desc["[[Set]]"] = setter;
    }
    if ((hasOwn(desc, "[[Get]]") || hasOwn(desc, "[[Set]]")) && (hasOwn(desc, "[[Value]]") || hasOwn(desc, "[[Writable]]"))) {
      throw new $TypeError("Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
    }
    return desc;
  };
  return ToPropertyDescriptor;
}
var DefinePropertyOrThrow;
var hasRequiredDefinePropertyOrThrow;
function requireDefinePropertyOrThrow() {
  if (hasRequiredDefinePropertyOrThrow) return DefinePropertyOrThrow;
  hasRequiredDefinePropertyOrThrow = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  var DefineOwnProperty2 = /* @__PURE__ */ requireDefineOwnProperty();
  var FromPropertyDescriptor2 = /* @__PURE__ */ requireFromPropertyDescriptor();
  var IsDataDescriptor2 = /* @__PURE__ */ requireIsDataDescriptor();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  var SameValue2 = /* @__PURE__ */ requireSameValue();
  var ToPropertyDescriptor2 = /* @__PURE__ */ requireToPropertyDescriptor();
  DefinePropertyOrThrow = function DefinePropertyOrThrow2(O, P, desc) {
    if (!isObject2(O)) {
      throw new $TypeError("Assertion failed: Type(O) is not Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: P is not a Property Key");
    }
    var Desc = isPropertyDescriptor(desc) ? desc : ToPropertyDescriptor2(desc);
    if (!isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: Desc is not a valid Property Descriptor");
    }
    return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, Desc);
  };
  return DefinePropertyOrThrow;
}
var hasRequiredIsConstructor;
function requireIsConstructor() {
  if (hasRequiredIsConstructor) return IsConstructor.exports;
  hasRequiredIsConstructor = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic();
  var $construct = GetIntrinsic2("%Reflect.construct%", true);
  var DefinePropertyOrThrow2 = /* @__PURE__ */ requireDefinePropertyOrThrow();
  try {
    DefinePropertyOrThrow2({}, "", {
      "[[Get]]": function() {
      }
    });
  } catch (e) {
    DefinePropertyOrThrow2 = null;
  }
  if (DefinePropertyOrThrow2 && $construct) {
    var isConstructorMarker = {};
    var badArrayLike = {};
    DefinePropertyOrThrow2(badArrayLike, "length", {
      "[[Get]]": function() {
        throw isConstructorMarker;
      },
      "[[Enumerable]]": true
    });
    IsConstructor.exports = function IsConstructor2(argument) {
      try {
        $construct(argument, badArrayLike);
      } catch (err) {
        return err === isConstructorMarker;
      }
    };
  } else {
    IsConstructor.exports = function IsConstructor2(argument) {
      return typeof argument === "function" && !!argument.prototype;
    };
  }
  return IsConstructor.exports;
}
var ArraySpeciesCreate;
var hasRequiredArraySpeciesCreate;
function requireArraySpeciesCreate() {
  if (hasRequiredArraySpeciesCreate) return ArraySpeciesCreate;
  hasRequiredArraySpeciesCreate = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $species = GetIntrinsic2("%Symbol.species%", true);
  var $TypeError = /* @__PURE__ */ requireType();
  var isInteger2 = /* @__PURE__ */ requireIsInteger();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var ArrayCreate2 = /* @__PURE__ */ requireArrayCreate();
  var Get2 = /* @__PURE__ */ requireGet();
  var IsArray2 = /* @__PURE__ */ requireIsArray();
  var IsConstructor2 = /* @__PURE__ */ requireIsConstructor();
  ArraySpeciesCreate = function ArraySpeciesCreate2(originalArray, length2) {
    if (!isInteger2(length2) || length2 < 0) {
      throw new $TypeError("Assertion failed: length must be an integer >= 0");
    }
    var isArray2 = IsArray2(originalArray);
    if (!isArray2) {
      return ArrayCreate2(length2);
    }
    var C2 = Get2(originalArray, "constructor");
    if ($species && isObject2(C2)) {
      C2 = Get2(C2, $species);
      if (C2 === null) {
        C2 = void 0;
      }
    }
    if (typeof C2 === "undefined") {
      return ArrayCreate2(length2);
    }
    if (!IsConstructor2(C2)) {
      throw new $TypeError("C must be a constructor");
    }
    return new C2(length2);
  };
  return ArraySpeciesCreate;
}
var maxSafeInteger;
var hasRequiredMaxSafeInteger;
function requireMaxSafeInteger() {
  if (hasRequiredMaxSafeInteger) return maxSafeInteger;
  hasRequiredMaxSafeInteger = 1;
  maxSafeInteger = /** @type {import('./maxSafeInteger')} */
  Number.MAX_SAFE_INTEGER || 9007199254740991;
  return maxSafeInteger;
}
var Call;
var hasRequiredCall;
function requireCall() {
  if (hasRequiredCall) return Call;
  hasRequiredCall = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $TypeError = /* @__PURE__ */ requireType();
  var IsArray2 = /* @__PURE__ */ requireIsArray();
  var $apply = GetIntrinsic2("%Reflect.apply%", true) || callBound2("Function.prototype.apply");
  Call = function Call2(F, V) {
    var argumentsList = arguments.length > 2 ? arguments[2] : [];
    if (!IsArray2(argumentsList)) {
      throw new $TypeError("Assertion failed: optional `argumentsList`, if provided, must be a List");
    }
    return $apply(F, V, argumentsList);
  };
  return Call;
}
var IsAccessorDescriptor;
var hasRequiredIsAccessorDescriptor;
function requireIsAccessorDescriptor() {
  if (hasRequiredIsAccessorDescriptor) return IsAccessorDescriptor;
  hasRequiredIsAccessorDescriptor = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var hasOwn = /* @__PURE__ */ requireHasown();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  IsAccessorDescriptor = function IsAccessorDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return false;
    }
    if (!isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: `Desc` must be a Property Descriptor");
    }
    if (!hasOwn(Desc, "[[Get]]") && !hasOwn(Desc, "[[Set]]")) {
      return false;
    }
    return true;
  };
  return IsAccessorDescriptor;
}
var isPrimitive$1;
var hasRequiredIsPrimitive$1;
function requireIsPrimitive$1() {
  if (hasRequiredIsPrimitive$1) return isPrimitive$1;
  hasRequiredIsPrimitive$1 = 1;
  isPrimitive$1 = function isPrimitive2(value) {
    return value === null || typeof value !== "function" && typeof value !== "object";
  };
  return isPrimitive$1;
}
var IsExtensible;
var hasRequiredIsExtensible;
function requireIsExtensible() {
  if (hasRequiredIsExtensible) return IsExtensible;
  hasRequiredIsExtensible = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $preventExtensions = GetIntrinsic2("%Object.preventExtensions%", true);
  var $isExtensible = GetIntrinsic2("%Object.isExtensible%", true);
  var isPrimitive2 = /* @__PURE__ */ requireIsPrimitive$1();
  IsExtensible = $preventExtensions ? function IsExtensible2(obj) {
    return !isPrimitive2(obj) && $isExtensible(obj);
  } : function IsExtensible2(obj) {
    return !isPrimitive2(obj);
  };
  return IsExtensible;
}
var isFullyPopulatedPropertyDescriptor;
var hasRequiredIsFullyPopulatedPropertyDescriptor;
function requireIsFullyPopulatedPropertyDescriptor() {
  if (hasRequiredIsFullyPopulatedPropertyDescriptor) return isFullyPopulatedPropertyDescriptor;
  hasRequiredIsFullyPopulatedPropertyDescriptor = 1;
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  isFullyPopulatedPropertyDescriptor = function isFullyPopulatedPropertyDescriptor2(ES, Desc) {
    return isPropertyDescriptor(Desc) && "[[Enumerable]]" in Desc && "[[Configurable]]" in Desc && (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
  };
  return isFullyPopulatedPropertyDescriptor;
}
var IsGenericDescriptor;
var hasRequiredIsGenericDescriptor;
function requireIsGenericDescriptor() {
  if (hasRequiredIsGenericDescriptor) return IsGenericDescriptor;
  hasRequiredIsGenericDescriptor = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var IsAccessorDescriptor2 = /* @__PURE__ */ requireIsAccessorDescriptor();
  var IsDataDescriptor2 = /* @__PURE__ */ requireIsDataDescriptor();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  IsGenericDescriptor = function IsGenericDescriptor2(Desc) {
    if (typeof Desc === "undefined") {
      return false;
    }
    if (!isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: `Desc` must be a Property Descriptor");
    }
    if (!IsAccessorDescriptor2(Desc) && !IsDataDescriptor2(Desc)) {
      return true;
    }
    return false;
  };
  return IsGenericDescriptor;
}
var ValidateAndApplyPropertyDescriptor;
var hasRequiredValidateAndApplyPropertyDescriptor;
function requireValidateAndApplyPropertyDescriptor() {
  if (hasRequiredValidateAndApplyPropertyDescriptor) return ValidateAndApplyPropertyDescriptor;
  hasRequiredValidateAndApplyPropertyDescriptor = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var DefineOwnProperty2 = /* @__PURE__ */ requireDefineOwnProperty();
  var isFullyPopulatedPropertyDescriptor2 = /* @__PURE__ */ requireIsFullyPopulatedPropertyDescriptor();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  var FromPropertyDescriptor2 = /* @__PURE__ */ requireFromPropertyDescriptor();
  var IsAccessorDescriptor2 = /* @__PURE__ */ requireIsAccessorDescriptor();
  var IsDataDescriptor2 = /* @__PURE__ */ requireIsDataDescriptor();
  var IsGenericDescriptor2 = /* @__PURE__ */ requireIsGenericDescriptor();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  var SameValue2 = /* @__PURE__ */ requireSameValue();
  ValidateAndApplyPropertyDescriptor = function ValidateAndApplyPropertyDescriptor2(O, P, extensible, Desc, current) {
    if (typeof O !== "undefined" && !isObject2(O)) {
      throw new $TypeError("Assertion failed: O must be undefined or an Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: P must be a Property Key");
    }
    if (typeof extensible !== "boolean") {
      throw new $TypeError("Assertion failed: extensible must be a Boolean");
    }
    if (!isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: Desc must be a Property Descriptor");
    }
    if (typeof current !== "undefined" && !isPropertyDescriptor(current)) {
      throw new $TypeError("Assertion failed: current must be a Property Descriptor, or undefined");
    }
    if (typeof current === "undefined") {
      if (!extensible) {
        return false;
      }
      if (typeof O === "undefined") {
        return true;
      }
      if (IsAccessorDescriptor2(Desc)) {
        return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, Desc);
      }
      return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, {
        "[[Configurable]]": !!Desc["[[Configurable]]"],
        "[[Enumerable]]": !!Desc["[[Enumerable]]"],
        "[[Value]]": Desc["[[Value]]"],
        "[[Writable]]": !!Desc["[[Writable]]"]
      });
    }
    if (!isFullyPopulatedPropertyDescriptor2({
      IsAccessorDescriptor: IsAccessorDescriptor2,
      IsDataDescriptor: IsDataDescriptor2
    }, current)) {
      throw new $TypeError("`current`, when present, must be a fully populated and valid Property Descriptor");
    }
    if (!current["[[Configurable]]"]) {
      if ("[[Configurable]]" in Desc && Desc["[[Configurable]]"]) {
        return false;
      }
      if ("[[Enumerable]]" in Desc && !SameValue2(Desc["[[Enumerable]]"], current["[[Enumerable]]"])) {
        return false;
      }
      if (!IsGenericDescriptor2(Desc) && !SameValue2(IsAccessorDescriptor2(Desc), IsAccessorDescriptor2(current))) {
        return false;
      }
      if (IsAccessorDescriptor2(current)) {
        if ("[[Get]]" in Desc && !SameValue2(Desc["[[Get]]"], current["[[Get]]"])) {
          return false;
        }
        if ("[[Set]]" in Desc && !SameValue2(Desc["[[Set]]"], current["[[Set]]"])) {
          return false;
        }
      } else if (!current["[[Writable]]"]) {
        if ("[[Writable]]" in Desc && Desc["[[Writable]]"]) {
          return false;
        }
        if ("[[Value]]" in Desc && !SameValue2(Desc["[[Value]]"], current["[[Value]]"])) {
          return false;
        }
      }
    }
    if (typeof O !== "undefined") {
      var configurable;
      var enumerable;
      if (IsDataDescriptor2(current) && IsAccessorDescriptor2(Desc)) {
        configurable = ("[[Configurable]]" in Desc ? Desc : current)["[[Configurable]]"];
        enumerable = ("[[Enumerable]]" in Desc ? Desc : current)["[[Enumerable]]"];
        return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, {
          "[[Configurable]]": !!configurable,
          "[[Enumerable]]": !!enumerable,
          "[[Get]]": ("[[Get]]" in Desc ? Desc : current)["[[Get]]"],
          "[[Set]]": ("[[Set]]" in Desc ? Desc : current)["[[Set]]"]
        });
      } else if (IsAccessorDescriptor2(current) && IsDataDescriptor2(Desc)) {
        configurable = ("[[Configurable]]" in Desc ? Desc : current)["[[Configurable]]"];
        enumerable = ("[[Enumerable]]" in Desc ? Desc : current)["[[Enumerable]]"];
        return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, {
          "[[Configurable]]": !!configurable,
          "[[Enumerable]]": !!enumerable,
          "[[Value]]": ("[[Value]]" in Desc ? Desc : current)["[[Value]]"],
          "[[Writable]]": !!("[[Writable]]" in Desc ? Desc : current)["[[Writable]]"]
        });
      }
      return DefineOwnProperty2(IsDataDescriptor2, SameValue2, FromPropertyDescriptor2, O, P, Desc);
    }
    return true;
  };
  return ValidateAndApplyPropertyDescriptor;
}
var OrdinaryDefineOwnProperty;
var hasRequiredOrdinaryDefineOwnProperty;
function requireOrdinaryDefineOwnProperty() {
  if (hasRequiredOrdinaryDefineOwnProperty) return OrdinaryDefineOwnProperty;
  hasRequiredOrdinaryDefineOwnProperty = 1;
  var $gOPD = /* @__PURE__ */ requireGopd();
  var $SyntaxError = /* @__PURE__ */ requireSyntax();
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var isPropertyDescriptor = /* @__PURE__ */ requirePropertyDescriptor();
  var IsAccessorDescriptor2 = /* @__PURE__ */ requireIsAccessorDescriptor();
  var IsExtensible2 = /* @__PURE__ */ requireIsExtensible();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  var ToPropertyDescriptor2 = /* @__PURE__ */ requireToPropertyDescriptor();
  var SameValue2 = /* @__PURE__ */ requireSameValue();
  var ValidateAndApplyPropertyDescriptor2 = /* @__PURE__ */ requireValidateAndApplyPropertyDescriptor();
  OrdinaryDefineOwnProperty = function OrdinaryDefineOwnProperty2(O, P, Desc) {
    if (!isObject2(O)) {
      throw new $TypeError("Assertion failed: O must be an Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: P must be a Property Key");
    }
    if (!isPropertyDescriptor(Desc)) {
      throw new $TypeError("Assertion failed: Desc must be a Property Descriptor");
    }
    if (!$gOPD) {
      if (IsAccessorDescriptor2(Desc)) {
        throw new $SyntaxError("This environment does not support accessor property descriptors.");
      }
      var creatingNormalDataProperty = !(P in O) && Desc["[[Writable]]"] && Desc["[[Enumerable]]"] && Desc["[[Configurable]]"] && "[[Value]]" in Desc;
      var settingExistingDataProperty = P in O && (!("[[Configurable]]" in Desc) || Desc["[[Configurable]]"]) && (!("[[Enumerable]]" in Desc) || Desc["[[Enumerable]]"]) && (!("[[Writable]]" in Desc) || Desc["[[Writable]]"]) && "[[Value]]" in Desc;
      if (creatingNormalDataProperty || settingExistingDataProperty) {
        O[P] = Desc["[[Value]]"];
        return SameValue2(O[P], Desc["[[Value]]"]);
      }
      throw new $SyntaxError("This environment does not support defining non-writable, non-enumerable, or non-configurable properties");
    }
    var desc = $gOPD(O, P);
    var current = desc && ToPropertyDescriptor2(desc);
    var extensible = IsExtensible2(O);
    return ValidateAndApplyPropertyDescriptor2(O, P, extensible, Desc, current);
  };
  return OrdinaryDefineOwnProperty;
}
var CreateDataProperty;
var hasRequiredCreateDataProperty;
function requireCreateDataProperty() {
  if (hasRequiredCreateDataProperty) return CreateDataProperty;
  hasRequiredCreateDataProperty = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  var OrdinaryDefineOwnProperty2 = /* @__PURE__ */ requireOrdinaryDefineOwnProperty();
  CreateDataProperty = function CreateDataProperty2(O, P, V) {
    if (!isObject2(O)) {
      throw new $TypeError("Assertion failed: Type(O) is not Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: P is not a Property Key");
    }
    var newDesc = {
      "[[Configurable]]": true,
      "[[Enumerable]]": true,
      "[[Value]]": V,
      "[[Writable]]": true
    };
    return OrdinaryDefineOwnProperty2(O, P, newDesc);
  };
  return CreateDataProperty;
}
var CreateDataPropertyOrThrow;
var hasRequiredCreateDataPropertyOrThrow;
function requireCreateDataPropertyOrThrow() {
  if (hasRequiredCreateDataPropertyOrThrow) return CreateDataPropertyOrThrow;
  hasRequiredCreateDataPropertyOrThrow = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var CreateDataProperty2 = /* @__PURE__ */ requireCreateDataProperty();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  CreateDataPropertyOrThrow = function CreateDataPropertyOrThrow2(O, P, V) {
    if (!isObject2(O)) {
      throw new $TypeError("Assertion failed: Type(O) is not Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: P is not a Property Key");
    }
    var success = CreateDataProperty2(O, P, V);
    if (!success) {
      throw new $TypeError("unable to create data property");
    }
  };
  return CreateDataPropertyOrThrow;
}
var HasProperty;
var hasRequiredHasProperty;
function requireHasProperty() {
  if (hasRequiredHasProperty) return HasProperty;
  hasRequiredHasProperty = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var isPropertyKey2 = /* @__PURE__ */ requireIsPropertyKey();
  HasProperty = function HasProperty2(O, P) {
    if (!isObject2(O)) {
      throw new $TypeError("Assertion failed: `O` must be an Object");
    }
    if (!isPropertyKey2(P)) {
      throw new $TypeError("Assertion failed: `P` must be a Property Key");
    }
    return P in O;
  };
  return HasProperty;
}
var isPrimitive;
var hasRequiredIsPrimitive;
function requireIsPrimitive() {
  if (hasRequiredIsPrimitive) return isPrimitive;
  hasRequiredIsPrimitive = 1;
  isPrimitive = function isPrimitive2(value) {
    return value === null || typeof value !== "function" && typeof value !== "object";
  };
  return isPrimitive;
}
var shams;
var hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var hasSymbols2 = requireShams$1();
  shams = function hasToStringTagShams() {
    return hasSymbols2() && !!Symbol.toStringTag;
  };
  return shams;
}
var isDateObject;
var hasRequiredIsDateObject;
function requireIsDateObject() {
  if (hasRequiredIsDateObject) return isDateObject;
  hasRequiredIsDateObject = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var getDay = callBound2("Date.prototype.getDay");
  var tryDateObject = function tryDateGetDayCall(value) {
    try {
      getDay(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = callBound2("Object.prototype.toString");
  var dateClass = "[object Date]";
  var hasToStringTag = requireShams()();
  isDateObject = function isDateObject2(value) {
    if (typeof value !== "object" || value === null) {
      return false;
    }
    return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
  };
  return isDateObject;
}
var isSymbol$1 = { exports: {} };
var isRegex;
var hasRequiredIsRegex;
function requireIsRegex() {
  if (hasRequiredIsRegex) return isRegex;
  hasRequiredIsRegex = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var hasToStringTag = requireShams()();
  var hasOwn = /* @__PURE__ */ requireHasown();
  var gOPD2 = /* @__PURE__ */ requireGopd();
  var fn;
  if (hasToStringTag) {
    var $exec = callBound2("RegExp.prototype.exec");
    var isRegexMarker = {};
    var throwRegexMarker = function() {
      throw isRegexMarker;
    };
    var badStringifier = {
      toString: throwRegexMarker,
      valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") {
      badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    }
    fn = function isRegex2(value) {
      if (!value || typeof value !== "object") {
        return false;
      }
      var descriptor = (
        /** @type {NonNullable<typeof gOPD>} */
        gOPD2(
          /** @type {{ lastIndex?: unknown }} */
          value,
          "lastIndex"
        )
      );
      var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, "value");
      if (!hasLastIndexDataProperty) {
        return false;
      }
      try {
        $exec(
          value,
          /** @type {string} */
          /** @type {unknown} */
          badStringifier
        );
      } catch (e) {
        return e === isRegexMarker;
      }
    };
  } else {
    var $toString = callBound2("Object.prototype.toString");
    var regexClass = "[object RegExp]";
    fn = function isRegex2(value) {
      if (!value || typeof value !== "object" && typeof value !== "function") {
        return false;
      }
      return $toString(value) === regexClass;
    };
  }
  isRegex = fn;
  return isRegex;
}
var safeRegexTest;
var hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
  if (hasRequiredSafeRegexTest) return safeRegexTest;
  hasRequiredSafeRegexTest = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var isRegex2 = requireIsRegex();
  var $exec = callBound2("RegExp.prototype.exec");
  var $TypeError = /* @__PURE__ */ requireType();
  safeRegexTest = function regexTester(regex) {
    if (!isRegex2(regex)) {
      throw new $TypeError("`regex` must be a RegExp");
    }
    return function test(s) {
      return $exec(regex, s) !== null;
    };
  };
  return safeRegexTest;
}
var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol$1.exports;
  hasRequiredIsSymbol = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $toString = callBound2("Object.prototype.toString");
  var hasSymbols2 = requireHasSymbols()();
  var safeRegexTest2 = /* @__PURE__ */ requireSafeRegexTest();
  if (hasSymbols2) {
    var $symToStr = callBound2("Symbol.prototype.toString");
    var isSymString = safeRegexTest2(/^Symbol\(.*\)$/);
    var isSymbolObject = function isRealSymbolObject(value) {
      if (typeof value.valueOf() !== "symbol") {
        return false;
      }
      return isSymString($symToStr(value));
    };
    isSymbol$1.exports = function isSymbol2(value) {
      if (typeof value === "symbol") {
        return true;
      }
      if (!value || typeof value !== "object" || $toString(value) !== "[object Symbol]") {
        return false;
      }
      try {
        return isSymbolObject(value);
      } catch (e) {
        return false;
      }
    };
  } else {
    isSymbol$1.exports = function isSymbol2(value) {
      return false;
    };
  }
  return isSymbol$1.exports;
}
var es2015;
var hasRequiredEs2015;
function requireEs2015() {
  if (hasRequiredEs2015) return es2015;
  hasRequiredEs2015 = 1;
  var hasSymbols2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol";
  var isPrimitive2 = requireIsPrimitive();
  var isCallable2 = requireIsCallable$1();
  var isDate = /* @__PURE__ */ requireIsDateObject();
  var isSymbol2 = requireIsSymbol();
  var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
    if (typeof O === "undefined" || O === null) {
      throw new TypeError("Cannot call method on " + O);
    }
    if (typeof hint !== "string" || hint !== "number" && hint !== "string") {
      throw new TypeError('hint must be "string" or "number"');
    }
    var methodNames = hint === "string" ? ["toString", "valueOf"] : ["valueOf", "toString"];
    var method, result, i;
    for (i = 0; i < methodNames.length; ++i) {
      method = O[methodNames[i]];
      if (isCallable2(method)) {
        result = method.call(O);
        if (isPrimitive2(result)) {
          return result;
        }
      }
    }
    throw new TypeError("No default value");
  };
  var GetMethod = function GetMethod2(O, P) {
    var func = O[P];
    if (func !== null && typeof func !== "undefined") {
      if (!isCallable2(func)) {
        throw new TypeError(func + " returned for property " + String(P) + " of object " + O + " is not a function");
      }
      return func;
    }
    return void 0;
  };
  es2015 = function ToPrimitive2(input) {
    if (isPrimitive2(input)) {
      return input;
    }
    var hint = "default";
    if (arguments.length > 1) {
      if (arguments[1] === String) {
        hint = "string";
      } else if (arguments[1] === Number) {
        hint = "number";
      }
    }
    var exoticToPrim;
    if (hasSymbols2) {
      if (Symbol.toPrimitive) {
        exoticToPrim = GetMethod(
          /** @type {Record<PropertyKey, unknown>} */
          input,
          Symbol.toPrimitive
        );
      } else if (isSymbol2(input)) {
        exoticToPrim = Symbol.prototype.valueOf;
      }
    }
    if (typeof exoticToPrim !== "undefined") {
      var result = exoticToPrim.call(input, hint);
      if (isPrimitive2(result)) {
        return result;
      }
      throw new TypeError("unable to convert exotic object to primitive");
    }
    if (hint === "default" && (isDate(input) || isSymbol2(input))) {
      hint = "string";
    }
    return ordinaryToPrimitive(
      /** @type {object} */
      input,
      hint === "default" ? "number" : hint
    );
  };
  return es2015;
}
var ToPrimitive;
var hasRequiredToPrimitive;
function requireToPrimitive() {
  if (hasRequiredToPrimitive) return ToPrimitive;
  hasRequiredToPrimitive = 1;
  var toPrimitive = requireEs2015();
  ToPrimitive = function ToPrimitive2(input) {
    if (arguments.length > 1) {
      return toPrimitive(input, arguments[1]);
    }
    return toPrimitive(input);
  };
  return ToPrimitive;
}
var RequireObjectCoercible;
var hasRequiredRequireObjectCoercible;
function requireRequireObjectCoercible() {
  if (hasRequiredRequireObjectCoercible) return RequireObjectCoercible;
  hasRequiredRequireObjectCoercible = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  RequireObjectCoercible = function RequireObjectCoercible2(value) {
    if (value == null) {
      throw new $TypeError(arguments.length > 0 && arguments[1] || "Cannot call method on " + value);
    }
    return value;
  };
  return RequireObjectCoercible;
}
var ToString;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return ToString;
  hasRequiredToString = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $String = GetIntrinsic2("%String%");
  var $TypeError = /* @__PURE__ */ requireType();
  ToString = function ToString2(argument) {
    if (typeof argument === "symbol") {
      throw new $TypeError("Cannot convert a Symbol value to a string");
    }
    return $String(argument);
  };
  return ToString;
}
var implementation$6;
var hasRequiredImplementation$6;
function requireImplementation$6() {
  if (hasRequiredImplementation$6) return implementation$6;
  hasRequiredImplementation$6 = 1;
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  var ToString2 = /* @__PURE__ */ requireToString();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $replace = callBound2("String.prototype.replace");
  var mvsIsWS = /^\s$/.test("᠎");
  var leftWhitespace = mvsIsWS ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
  var rightWhitespace = mvsIsWS ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
  implementation$6 = function trim() {
    var S = ToString2(RequireObjectCoercible2(this));
    return $replace($replace(S, leftWhitespace, ""), rightWhitespace, "");
  };
  return implementation$6;
}
var polyfill$6;
var hasRequiredPolyfill$6;
function requirePolyfill$6() {
  if (hasRequiredPolyfill$6) return polyfill$6;
  hasRequiredPolyfill$6 = 1;
  var implementation2 = requireImplementation$6();
  var zeroWidthSpace = "​";
  var mongolianVowelSeparator = "᠎";
  polyfill$6 = function getPolyfill() {
    if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace && mongolianVowelSeparator.trim() === mongolianVowelSeparator && ("_" + mongolianVowelSeparator).trim() === "_" + mongolianVowelSeparator && (mongolianVowelSeparator + "_").trim() === mongolianVowelSeparator + "_") {
      return String.prototype.trim;
    }
    return implementation2;
  };
  return polyfill$6;
}
var shim$6;
var hasRequiredShim$6;
function requireShim$6() {
  if (hasRequiredShim$6) return shim$6;
  hasRequiredShim$6 = 1;
  var supportsDescriptors = /* @__PURE__ */ requireHasPropertyDescriptors()();
  var defineDataProperty2 = /* @__PURE__ */ requireDefineDataProperty();
  var getPolyfill = requirePolyfill$6();
  shim$6 = function shimStringTrim() {
    var polyfill2 = getPolyfill();
    if (String.prototype.trim !== polyfill2) {
      if (supportsDescriptors) {
        defineDataProperty2(String.prototype, "trim", polyfill2, true);
      } else {
        defineDataProperty2(String.prototype, "trim", polyfill2);
      }
    }
    return polyfill2;
  };
  return shim$6;
}
var string_prototype_trim;
var hasRequiredString_prototype_trim;
function requireString_prototype_trim() {
  if (hasRequiredString_prototype_trim) return string_prototype_trim;
  hasRequiredString_prototype_trim = 1;
  var callBind2 = requireCallBind();
  var define2 = requireDefineProperties();
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  var implementation2 = requireImplementation$6();
  var getPolyfill = requirePolyfill$6();
  var shim2 = requireShim$6();
  var bound = callBind2(getPolyfill());
  var boundMethod = function trim(receiver) {
    RequireObjectCoercible2(receiver);
    return bound(receiver);
  };
  define2(boundMethod, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  string_prototype_trim = boundMethod;
  return string_prototype_trim;
}
var StringToNumber;
var hasRequiredStringToNumber;
function requireStringToNumber() {
  if (hasRequiredStringToNumber) return StringToNumber;
  hasRequiredStringToNumber = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $RegExp = GetIntrinsic2("%RegExp%");
  var $TypeError = /* @__PURE__ */ requireType();
  var $parseInteger = GetIntrinsic2("%parseInt%");
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var regexTester = /* @__PURE__ */ requireSafeRegexTest();
  var $strSlice = callBound2("String.prototype.slice");
  var isBinary = regexTester(/^0b[01]+$/i);
  var isOctal = regexTester(/^0o[0-7]+$/i);
  var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
  var nonWS = ["", "​", "￾"].join("");
  var nonWSregex = new $RegExp("[" + nonWS + "]", "g");
  var hasNonWS = regexTester(nonWSregex);
  var $trim = requireString_prototype_trim();
  StringToNumber = function StringToNumber2(argument) {
    if (typeof argument !== "string") {
      throw new $TypeError("Assertion failed: `argument` is not a String");
    }
    if (isBinary(argument)) {
      return +$parseInteger($strSlice(argument, 2), 2);
    }
    if (isOctal(argument)) {
      return +$parseInteger($strSlice(argument, 2), 8);
    }
    if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
      return NaN;
    }
    var trimmed = $trim(argument);
    if (trimmed !== argument) {
      return StringToNumber2(trimmed);
    }
    return +argument;
  };
  return StringToNumber;
}
var ToNumber;
var hasRequiredToNumber;
function requireToNumber() {
  if (hasRequiredToNumber) return ToNumber;
  hasRequiredToNumber = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var $TypeError = /* @__PURE__ */ requireType();
  var $Number = GetIntrinsic2("%Number%");
  var isPrimitive2 = /* @__PURE__ */ requireIsPrimitive$1();
  var ToPrimitive2 = /* @__PURE__ */ requireToPrimitive();
  var StringToNumber2 = /* @__PURE__ */ requireStringToNumber();
  ToNumber = function ToNumber2(argument) {
    var value = isPrimitive2(argument) ? argument : ToPrimitive2(argument, $Number);
    if (typeof value === "symbol") {
      throw new $TypeError("Cannot convert a Symbol value to a number");
    }
    if (typeof value === "bigint") {
      throw new $TypeError("Conversion from 'BigInt' to 'number' is not allowed.");
    }
    if (typeof value === "string") {
      return StringToNumber2(value);
    }
    return +value;
  };
  return ToNumber;
}
var floor;
var hasRequiredFloor;
function requireFloor() {
  if (hasRequiredFloor) return floor;
  hasRequiredFloor = 1;
  var $floor = /* @__PURE__ */ requireFloor$1();
  floor = function floor2(x) {
    if (typeof x === "bigint") {
      return x;
    }
    return $floor(x);
  };
  return floor;
}
var truncate;
var hasRequiredTruncate;
function requireTruncate() {
  if (hasRequiredTruncate) return truncate;
  hasRequiredTruncate = 1;
  var floor2 = /* @__PURE__ */ requireFloor();
  var $TypeError = /* @__PURE__ */ requireType();
  truncate = function truncate2(x) {
    if (typeof x !== "number" && typeof x !== "bigint") {
      throw new $TypeError("argument must be a Number or a BigInt");
    }
    var result = x < 0 ? -floor2(-x) : floor2(x);
    return result === 0 ? 0 : result;
  };
  return truncate;
}
var ToIntegerOrInfinity;
var hasRequiredToIntegerOrInfinity;
function requireToIntegerOrInfinity() {
  if (hasRequiredToIntegerOrInfinity) return ToIntegerOrInfinity;
  hasRequiredToIntegerOrInfinity = 1;
  var ToNumber2 = /* @__PURE__ */ requireToNumber();
  var truncate2 = /* @__PURE__ */ requireTruncate();
  var $isNaN = /* @__PURE__ */ require_isNaN();
  var $isFinite = /* @__PURE__ */ require_isFinite();
  ToIntegerOrInfinity = function ToIntegerOrInfinity2(value) {
    var number3 = ToNumber2(value);
    if ($isNaN(number3) || number3 === 0) {
      return 0;
    }
    if (!$isFinite(number3)) {
      return number3;
    }
    return truncate2(number3);
  };
  return ToIntegerOrInfinity;
}
var ToLength;
var hasRequiredToLength;
function requireToLength() {
  if (hasRequiredToLength) return ToLength;
  hasRequiredToLength = 1;
  var MAX_SAFE_INTEGER2 = /* @__PURE__ */ requireMaxSafeInteger();
  var ToIntegerOrInfinity2 = /* @__PURE__ */ requireToIntegerOrInfinity();
  ToLength = function ToLength2(argument) {
    var len = ToIntegerOrInfinity2(argument);
    if (len <= 0) {
      return 0;
    }
    if (len > MAX_SAFE_INTEGER2) {
      return MAX_SAFE_INTEGER2;
    }
    return len;
  };
  return ToLength;
}
var LengthOfArrayLike;
var hasRequiredLengthOfArrayLike;
function requireLengthOfArrayLike() {
  if (hasRequiredLengthOfArrayLike) return LengthOfArrayLike;
  hasRequiredLengthOfArrayLike = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var isObject2 = /* @__PURE__ */ requireIsObject();
  var Get2 = /* @__PURE__ */ requireGet();
  var ToLength2 = /* @__PURE__ */ requireToLength();
  LengthOfArrayLike = function LengthOfArrayLike2(obj) {
    if (!isObject2(obj)) {
      throw new $TypeError("Assertion failed: `obj` must be an Object");
    }
    return ToLength2(Get2(obj, "length"));
  };
  return LengthOfArrayLike;
}
var FlattenIntoArray;
var hasRequiredFlattenIntoArray;
function requireFlattenIntoArray() {
  if (hasRequiredFlattenIntoArray) return FlattenIntoArray;
  hasRequiredFlattenIntoArray = 1;
  var $TypeError = /* @__PURE__ */ requireType();
  var MAX_SAFE_INTEGER2 = /* @__PURE__ */ requireMaxSafeInteger();
  var Call2 = /* @__PURE__ */ requireCall();
  var CreateDataPropertyOrThrow2 = /* @__PURE__ */ requireCreateDataPropertyOrThrow();
  var Get2 = /* @__PURE__ */ requireGet();
  var HasProperty2 = /* @__PURE__ */ requireHasProperty();
  var IsArray2 = /* @__PURE__ */ requireIsArray();
  var LengthOfArrayLike2 = /* @__PURE__ */ requireLengthOfArrayLike();
  var ToString2 = /* @__PURE__ */ requireToString();
  FlattenIntoArray = function FlattenIntoArray2(target2, source, sourceLen, start2, depth) {
    var mapperFunction;
    if (arguments.length > 5) {
      mapperFunction = arguments[5];
    }
    var targetIndex = start2;
    var sourceIndex = 0;
    while (sourceIndex < sourceLen) {
      var P = ToString2(sourceIndex);
      var exists = HasProperty2(source, P);
      if (exists === true) {
        var element = Get2(source, P);
        if (typeof mapperFunction !== "undefined") {
          if (arguments.length <= 6) {
            throw new $TypeError("Assertion failed: thisArg is required when mapperFunction is provided");
          }
          element = Call2(mapperFunction, arguments[6], [element, sourceIndex, source]);
        }
        var shouldFlatten = false;
        if (depth > 0) {
          shouldFlatten = IsArray2(element);
        }
        if (shouldFlatten) {
          var elementLen = LengthOfArrayLike2(element);
          targetIndex = FlattenIntoArray2(target2, element, elementLen, targetIndex, depth - 1);
        } else {
          if (targetIndex >= MAX_SAFE_INTEGER2) {
            throw new $TypeError("index too large");
          }
          CreateDataPropertyOrThrow2(target2, ToString2(targetIndex), element);
          targetIndex += 1;
        }
      }
      sourceIndex += 1;
    }
    return targetIndex;
  };
  return FlattenIntoArray;
}
var ToObject$1;
var hasRequiredToObject$1;
function requireToObject$1() {
  if (hasRequiredToObject$1) return ToObject$1;
  hasRequiredToObject$1 = 1;
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  ToObject$1 = function ToObject2(value) {
    RequireObjectCoercible2(value);
    return $Object(value);
  };
  return ToObject$1;
}
var ToObject;
var hasRequiredToObject;
function requireToObject() {
  if (hasRequiredToObject) return ToObject;
  hasRequiredToObject = 1;
  ToObject = /* @__PURE__ */ requireToObject$1();
  return ToObject;
}
var implementation$5;
var hasRequiredImplementation$5;
function requireImplementation$5() {
  if (hasRequiredImplementation$5) return implementation$5;
  hasRequiredImplementation$5 = 1;
  var ArraySpeciesCreate2 = /* @__PURE__ */ requireArraySpeciesCreate();
  var FlattenIntoArray2 = /* @__PURE__ */ requireFlattenIntoArray();
  var Get2 = /* @__PURE__ */ requireGet();
  var ToIntegerOrInfinity2 = /* @__PURE__ */ requireToIntegerOrInfinity();
  var ToLength2 = /* @__PURE__ */ requireToLength();
  var ToObject2 = /* @__PURE__ */ requireToObject();
  implementation$5 = function flat2() {
    var O = ToObject2(this);
    var sourceLen = ToLength2(Get2(O, "length"));
    var depthNum = 1;
    if (arguments.length > 0 && typeof arguments[0] !== "undefined") {
      depthNum = ToIntegerOrInfinity2(arguments[0]);
    }
    var A5 = ArraySpeciesCreate2(O, 0);
    FlattenIntoArray2(A5, O, sourceLen, 0, depthNum);
    return A5;
  };
  return implementation$5;
}
var polyfill$5;
var hasRequiredPolyfill$5;
function requirePolyfill$5() {
  if (hasRequiredPolyfill$5) return polyfill$5;
  hasRequiredPolyfill$5 = 1;
  var implementation2 = requireImplementation$5();
  polyfill$5 = function getPolyfill() {
    return Array.prototype.flat || implementation2;
  };
  return polyfill$5;
}
var esShimUnscopables;
var hasRequiredEsShimUnscopables;
function requireEsShimUnscopables() {
  if (hasRequiredEsShimUnscopables) return esShimUnscopables;
  hasRequiredEsShimUnscopables = 1;
  var hasOwn = /* @__PURE__ */ requireHasown();
  var hasUnscopables = typeof Symbol === "function" && typeof Symbol.unscopables === "symbol";
  var map2 = hasUnscopables && Array.prototype[Symbol.unscopables];
  var $TypeError = TypeError;
  esShimUnscopables = function shimUnscopables(method) {
    if (typeof method !== "string" || !method) {
      throw new $TypeError("method must be a non-empty string");
    }
    if (!hasOwn(Array.prototype, method)) {
      throw new $TypeError("method must be on Array.prototype");
    }
    if (hasUnscopables && map2) {
      map2[method] = true;
    }
  };
  return esShimUnscopables;
}
var shim$5;
var hasRequiredShim$5;
function requireShim$5() {
  if (hasRequiredShim$5) return shim$5;
  hasRequiredShim$5 = 1;
  var define2 = requireDefineProperties();
  var shimUnscopables = requireEsShimUnscopables();
  var getPolyfill = requirePolyfill$5();
  shim$5 = function shimFlat() {
    var polyfill2 = getPolyfill();
    define2(Array.prototype, {
      flat: polyfill2
    }, {
      flat: function() {
        return Array.prototype.flat !== polyfill2;
      }
    });
    shimUnscopables("flat");
    return polyfill2;
  };
  return shim$5;
}
var array_prototype_flat;
var hasRequiredArray_prototype_flat;
function requireArray_prototype_flat() {
  if (hasRequiredArray_prototype_flat) return array_prototype_flat;
  hasRequiredArray_prototype_flat = 1;
  var define2 = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$5();
  var getPolyfill = requirePolyfill$5();
  var polyfill2 = getPolyfill();
  var shim2 = requireShim$5();
  var boundFlat = callBind2(polyfill2);
  define2(boundFlat, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  array_prototype_flat = boundFlat;
  return array_prototype_flat;
}
var src$1;
var hasRequiredSrc$1;
function requireSrc$1() {
  if (hasRequiredSrc$1) return src$1;
  hasRequiredSrc$1 = 1;
  var hasOwnProperty2 = {}.hasOwnProperty;
  var call = Function.prototype.call;
  src$1 = call.bind ? call.bind(hasOwnProperty2) : function(O, P) {
    return call.call(hasOwnProperty2, O, P);
  };
  return src$1;
}
var Utils = {};
var build$1 = { exports: {} };
var implementation$4;
var hasRequiredImplementation$4;
function requireImplementation$4() {
  if (hasRequiredImplementation$4) return implementation$4;
  hasRequiredImplementation$4 = 1;
  var numberIsNaN = function(value) {
    return value !== value;
  };
  implementation$4 = function is(a, b) {
    if (a === 0 && b === 0) {
      return 1 / a === 1 / b;
    }
    if (a === b) {
      return true;
    }
    if (numberIsNaN(a) && numberIsNaN(b)) {
      return true;
    }
    return false;
  };
  return implementation$4;
}
var polyfill$4;
var hasRequiredPolyfill$4;
function requirePolyfill$4() {
  if (hasRequiredPolyfill$4) return polyfill$4;
  hasRequiredPolyfill$4 = 1;
  var implementation2 = requireImplementation$4();
  polyfill$4 = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation2;
  };
  return polyfill$4;
}
var shim$4;
var hasRequiredShim$4;
function requireShim$4() {
  if (hasRequiredShim$4) return shim$4;
  hasRequiredShim$4 = 1;
  var getPolyfill = requirePolyfill$4();
  var define2 = requireDefineProperties();
  shim$4 = function shimObjectIs() {
    var polyfill2 = getPolyfill();
    define2(Object, {
      is: polyfill2
    }, {
      is: function testObjectIs() {
        return Object.is !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$4;
}
var objectIs;
var hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var define2 = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$4();
  var getPolyfill = requirePolyfill$4();
  var shim2 = requireShim$4();
  var polyfill2 = callBind2(getPolyfill(), Object);
  define2(polyfill2, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  objectIs = polyfill2;
  return objectIs;
}
var hasRequiredBuild$1;
function requireBuild$1() {
  if (hasRequiredBuild$1) return build$1.exports;
  hasRequiredBuild$1 = 1;
  (function(module2, exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = shallowEqual;
    var _objectIs = _interopRequireDefault(requireObjectIs());
    var _hasown = _interopRequireDefault(/* @__PURE__ */ requireHasown());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function _typeof2(o) {
      "@babel/helpers - typeof";
      return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof2(o);
    }
    function shallowEqual(objA, objB) {
      if ((0, _objectIs["default"])(objA, objB)) {
        return true;
      }
      if (!objA || !objB || _typeof2(objA) !== "object" || _typeof2(objB) !== "object") {
        return false;
      }
      var keysA = Object.keys(objA);
      var keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) {
        return false;
      }
      keysA.sort();
      keysB.sort();
      for (var i = 0; i < keysA.length; i += 1) {
        if (!(0, _hasown["default"])(objB, keysA[i]) || !(0, _objectIs["default"])(objA[keysA[i]], objB[keysA[i]])) {
          return false;
        }
      }
      return true;
    }
    module2.exports = exports2.default;
  })(build$1, build$1.exports);
  return build$1.exports;
}
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
var hasRequiredLodash_isequal;
function requireLodash_isequal() {
  if (hasRequiredLodash_isequal) return lodash_isequal.exports;
  hasRequiredLodash_isequal = 1;
  (function(module2, exports2) {
    var LARGE_ARRAY_SIZE2 = 200;
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
    var MAX_SAFE_INTEGER2 = 9007199254740991;
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var freeGlobal2 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var freeProcess2 = moduleExports2 && freeGlobal2.process;
    var nodeUtil2 = (function() {
      try {
        return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
      } catch (e) {
      }
    })();
    var nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function arrayFilter2(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array2[index2];
        if (predicate(value, index2, array2)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayPush2(array2, values) {
      var index2 = -1, length2 = values.length, offset = array2.length;
      while (++index2 < length2) {
        array2[offset + index2] = values[index2];
      }
      return array2;
    }
    function arraySome2(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (predicate(array2[index2], index2, array2)) {
          return true;
        }
      }
      return false;
    }
    function baseTimes2(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseUnary2(func) {
      return function(value) {
        return func(value);
      };
    }
    function cacheHas2(cache2, key) {
      return cache2.has(key);
    }
    function getValue2(object2, key) {
      return object2 == null ? void 0 : object2[key];
    }
    function mapToArray2(map2) {
      var index2 = -1, result = Array(map2.size);
      map2.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg2(func, transform2) {
      return function(arg) {
        return func(transform2(arg));
      };
    }
    function setToArray2(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
    var coreJsData2 = root2["__core-js_shared__"];
    var funcToString2 = funcProto2.toString;
    var hasOwnProperty2 = objectProto2.hasOwnProperty;
    var maskSrcKey2 = (function() {
      var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    })();
    var nativeObjectToString2 = objectProto2.toString;
    var reIsNative2 = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var Buffer2 = moduleExports2 ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys2 = overArg2(Object.keys, Object);
    var DataView2 = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
    var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
    var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : void 0;
    function Hash2(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear2() {
      this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
      this.size = 0;
    }
    function hashDelete2(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet2(key) {
      var data2 = this.__data__;
      if (nativeCreate2) {
        var result = data2[key];
        return result === HASH_UNDEFINED2 ? void 0 : result;
      }
      return hasOwnProperty2.call(data2, key) ? data2[key] : void 0;
    }
    function hashHas2(key) {
      var data2 = this.__data__;
      return nativeCreate2 ? data2[key] !== void 0 : hasOwnProperty2.call(data2, key);
    }
    function hashSet2(key, value) {
      var data2 = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data2[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
      return this;
    }
    Hash2.prototype.clear = hashClear2;
    Hash2.prototype["delete"] = hashDelete2;
    Hash2.prototype.get = hashGet2;
    Hash2.prototype.has = hashHas2;
    Hash2.prototype.set = hashSet2;
    function ListCache2(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear2() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete2(key) {
      var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
      if (index2 < 0) {
        return false;
      }
      var lastIndex = data2.length - 1;
      if (index2 == lastIndex) {
        data2.pop();
      } else {
        splice2.call(data2, index2, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet2(key) {
      var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
      return index2 < 0 ? void 0 : data2[index2][1];
    }
    function listCacheHas2(key) {
      return assocIndexOf2(this.__data__, key) > -1;
    }
    function listCacheSet2(key, value) {
      var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
      if (index2 < 0) {
        ++this.size;
        data2.push([key, value]);
      } else {
        data2[index2][1] = value;
      }
      return this;
    }
    ListCache2.prototype.clear = listCacheClear2;
    ListCache2.prototype["delete"] = listCacheDelete2;
    ListCache2.prototype.get = listCacheGet2;
    ListCache2.prototype.has = listCacheHas2;
    ListCache2.prototype.set = listCacheSet2;
    function MapCache2(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear2() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash2(),
        "map": new (Map2 || ListCache2)(),
        "string": new Hash2()
      };
    }
    function mapCacheDelete2(key) {
      var result = getMapData2(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet2(key) {
      return getMapData2(this, key).get(key);
    }
    function mapCacheHas2(key) {
      return getMapData2(this, key).has(key);
    }
    function mapCacheSet2(key, value) {
      var data2 = getMapData2(this, key), size = data2.size;
      data2.set(key, value);
      this.size += data2.size == size ? 0 : 1;
      return this;
    }
    MapCache2.prototype.clear = mapCacheClear2;
    MapCache2.prototype["delete"] = mapCacheDelete2;
    MapCache2.prototype.get = mapCacheGet2;
    MapCache2.prototype.has = mapCacheHas2;
    MapCache2.prototype.set = mapCacheSet2;
    function SetCache2(values) {
      var index2 = -1, length2 = values == null ? 0 : values.length;
      this.__data__ = new MapCache2();
      while (++index2 < length2) {
        this.add(values[index2]);
      }
    }
    function setCacheAdd2(value) {
      this.__data__.set(value, HASH_UNDEFINED2);
      return this;
    }
    function setCacheHas2(value) {
      return this.__data__.has(value);
    }
    SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
    SetCache2.prototype.has = setCacheHas2;
    function Stack2(entries) {
      var data2 = this.__data__ = new ListCache2(entries);
      this.size = data2.size;
    }
    function stackClear2() {
      this.__data__ = new ListCache2();
      this.size = 0;
    }
    function stackDelete2(key) {
      var data2 = this.__data__, result = data2["delete"](key);
      this.size = data2.size;
      return result;
    }
    function stackGet2(key) {
      return this.__data__.get(key);
    }
    function stackHas2(key) {
      return this.__data__.has(key);
    }
    function stackSet2(key, value) {
      var data2 = this.__data__;
      if (data2 instanceof ListCache2) {
        var pairs2 = data2.__data__;
        if (!Map2 || pairs2.length < LARGE_ARRAY_SIZE2 - 1) {
          pairs2.push([key, value]);
          this.size = ++data2.size;
          return this;
        }
        data2 = this.__data__ = new MapCache2(pairs2);
      }
      data2.set(key, value);
      this.size = data2.size;
      return this;
    }
    Stack2.prototype.clear = stackClear2;
    Stack2.prototype["delete"] = stackDelete2;
    Stack2.prototype.get = stackGet2;
    Stack2.prototype.has = stackHas2;
    Stack2.prototype.set = stackSet2;
    function arrayLikeKeys2(value, inherited) {
      var isArr = isArray2(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length2 = result.length;
      for (var key in value) {
        if (hasOwnProperty2.call(value, key) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex2(key, length2)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf2(array2, key) {
      var length2 = array2.length;
      while (length2--) {
        if (eq2(array2[length2][0], key)) {
          return length2;
        }
      }
      return -1;
    }
    function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
      var result = keysFunc(object2);
      return isArray2(object2) ? result : arrayPush2(result, symbolsFunc(object2));
    }
    function baseGetTag2(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag2 : nullTag2;
      }
      return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag2(value) : objectToString2(value);
    }
    function baseIsArguments2(value) {
      return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
    }
    function baseIsEqual2(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack);
    }
    function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
      objTag = objTag == argsTag2 ? objectTag2 : objTag;
      othTag = othTag == argsTag2 ? objectTag2 : othTag;
      var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer2(object2)) {
        if (!isBuffer2(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack2());
        return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
        var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack2());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack2());
      return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack);
    }
    function baseIsNative2(value) {
      if (!isObject2(value) || isMasked2(value)) {
        return false;
      }
      var pattern2 = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
      return pattern2.test(toSource2(value));
    }
    function baseIsTypedArray2(value) {
      return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
    }
    function baseKeys2(object2) {
      if (!isPrototype2(object2)) {
        return nativeKeys2(object2);
      }
      var result = [];
      for (var key in Object(object2)) {
        if (hasOwnProperty2.call(object2, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function equalArrays2(array2, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array2.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array2);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : void 0;
      stack.set(array2, other);
      stack.set(other, array2);
      while (++index2 < arrLength) {
        var arrValue = array2[index2], othValue = other[index2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome2(other, function(othValue2, othIndex) {
            if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array2);
      stack["delete"](other);
      return result;
    }
    function equalByTag2(object2, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag2:
          if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
            return false;
          }
          object2 = object2.buffer;
          other = other.buffer;
        case arrayBufferTag2:
          if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag2:
        case dateTag2:
        case numberTag2:
          return eq2(+object2, +other);
        case errorTag2:
          return object2.name == other.name && object2.message == other.message;
        case regexpTag2:
        case stringTag2:
          return object2 == other + "";
        case mapTag2:
          var convert = mapToArray2;
        case setTag2:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
          convert || (convert = setToArray2);
          if (object2.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object2);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG2;
          stack.set(object2, other);
          var result = equalArrays2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object2);
          return result;
        case symbolTag2:
          if (symbolValueOf2) {
            return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
          }
      }
      return false;
    }
    function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index2 = objLength;
      while (index2--) {
        var key = objProps[index2];
        if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object2);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object2, other);
      stack.set(other, object2);
      var skipCtor = isPartial;
      while (++index2 < objLength) {
        key = objProps[index2];
        var objValue = object2[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object2.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object2);
      stack["delete"](other);
      return result;
    }
    function getAllKeys2(object2) {
      return baseGetAllKeys2(object2, keys2, getSymbols2);
    }
    function getMapData2(map2, key) {
      var data2 = map2.__data__;
      return isKeyable2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
    }
    function getNative2(object2, key) {
      var value = getValue2(object2, key);
      return baseIsNative2(value) ? value : void 0;
    }
    function getRawTag2(value) {
      var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag = value[symToStringTag2];
      try {
        value[symToStringTag2] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString2.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag2] = tag;
        } else {
          delete value[symToStringTag2];
        }
      }
      return result;
    }
    var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
      if (object2 == null) {
        return [];
      }
      object2 = Object(object2);
      return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
        return propertyIsEnumerable2.call(object2, symbol);
      });
    };
    var getTag2 = baseGetTag2;
    if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
      getTag2 = function(value) {
        var result = baseGetTag2(value), Ctor = result == objectTag2 ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString2:
              return dataViewTag2;
            case mapCtorString2:
              return mapTag2;
            case promiseCtorString2:
              return promiseTag2;
            case setCtorString2:
              return setTag2;
            case weakMapCtorString2:
              return weakMapTag2;
          }
        }
        return result;
      };
    }
    function isIndex2(value, length2) {
      length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
      return !!length2 && (typeof value == "number" || reIsUint2.test(value)) && value > -1 && value % 1 == 0 && value < length2;
    }
    function isKeyable2(value) {
      var type2 = typeof value;
      return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked2(func) {
      return !!maskSrcKey2 && maskSrcKey2 in func;
    }
    function isPrototype2(value) {
      var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto2;
      return value === proto2;
    }
    function objectToString2(value) {
      return nativeObjectToString2.call(value);
    }
    function toSource2(func) {
      if (func != null) {
        try {
          return funcToString2.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function eq2(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments2 = baseIsArguments2(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? baseIsArguments2 : function(value) {
      return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
    };
    var isArray2 = Array.isArray;
    function isArrayLike2(value) {
      return value != null && isLength2(value.length) && !isFunction2(value);
    }
    var isBuffer2 = nativeIsBuffer2 || stubFalse2;
    function isEqual(value, other) {
      return baseIsEqual2(value, other);
    }
    function isFunction2(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag = baseGetTag2(value);
      return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
    }
    function isLength2(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
    }
    function isObject2(value) {
      var type2 = typeof value;
      return value != null && (type2 == "object" || type2 == "function");
    }
    function isObjectLike2(value) {
      return value != null && typeof value == "object";
    }
    var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
    function keys2(object2) {
      return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
    }
    function stubArray2() {
      return [];
    }
    function stubFalse2() {
      return false;
    }
    module2.exports = isEqual;
  })(lodash_isequal, lodash_isequal.exports);
  return lodash_isequal.exports;
}
var implementation$3;
var hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3) return implementation$3;
  hasRequiredImplementation$3 = 1;
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $isEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  var $push = callBound2("Array.prototype.push");
  implementation$3 = function entries(O) {
    var obj = RequireObjectCoercible2(O);
    var entrys = [];
    for (var key in obj) {
      if ($isEnumerable(obj, key)) {
        $push(entrys, [key, obj[key]]);
      }
    }
    return entrys;
  };
  return implementation$3;
}
var polyfill$3;
var hasRequiredPolyfill$3;
function requirePolyfill$3() {
  if (hasRequiredPolyfill$3) return polyfill$3;
  hasRequiredPolyfill$3 = 1;
  var implementation2 = requireImplementation$3();
  polyfill$3 = function getPolyfill() {
    return typeof Object.entries === "function" ? Object.entries : implementation2;
  };
  return polyfill$3;
}
var shim$3;
var hasRequiredShim$3;
function requireShim$3() {
  if (hasRequiredShim$3) return shim$3;
  hasRequiredShim$3 = 1;
  var getPolyfill = requirePolyfill$3();
  var define2 = requireDefineProperties();
  shim$3 = function shimEntries() {
    var polyfill2 = getPolyfill();
    define2(Object, {
      entries: polyfill2
    }, {
      entries: function testEntries() {
        return Object.entries !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$3;
}
var object_entries;
var hasRequiredObject_entries;
function requireObject_entries() {
  if (hasRequiredObject_entries) return object_entries;
  hasRequiredObject_entries = 1;
  var define2 = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$3();
  var getPolyfill = requirePolyfill$3();
  var shim2 = requireShim$3();
  var polyfill2 = callBind2(getPolyfill(), Object);
  define2(polyfill2, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  object_entries = polyfill2;
  return object_entries;
}
var functionsHaveNames_1;
var hasRequiredFunctionsHaveNames;
function requireFunctionsHaveNames() {
  if (hasRequiredFunctionsHaveNames) return functionsHaveNames_1;
  hasRequiredFunctionsHaveNames = 1;
  var functionsHaveNames = function functionsHaveNames2() {
    return typeof (function f2() {
    }).name === "string";
  };
  var gOPD2 = Object.getOwnPropertyDescriptor;
  if (gOPD2) {
    try {
      gOPD2([], "length");
    } catch (e) {
      gOPD2 = null;
    }
  }
  functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD2) {
      return false;
    }
    var desc = gOPD2(function() {
    }, "name");
    return !!desc && !!desc.configurable;
  };
  var $bind = Function.prototype.bind;
  functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === "function" && (function f2() {
    }).bind().name !== "";
  };
  functionsHaveNames_1 = functionsHaveNames;
  return functionsHaveNames_1;
}
var implementation$2;
var hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$2;
  hasRequiredImplementation$2 = 1;
  var IsCallable2 = requireIsCallable$1();
  var hasOwn = /* @__PURE__ */ requireHasown();
  var functionsHaveNames = requireFunctionsHaveNames()();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $functionToString = callBound2("Function.prototype.toString");
  var $stringMatch = callBound2("String.prototype.match");
  var toStr = callBound2("Object.prototype.toString");
  var classRegex = /^class /;
  var isClass = function isClassConstructor(fn) {
    if (IsCallable2(fn)) {
      return false;
    }
    if (typeof fn !== "function") {
      return false;
    }
    try {
      var match = $stringMatch($functionToString(fn), classRegex);
      return !!match;
    } catch (e) {
    }
    return false;
  };
  var regex = /\s*function\s+([^(\s]*)\s*/;
  var isIE68 = !(0 in [,]);
  var objectClass = "[object Object]";
  var ddaClass = "[object HTMLAllCollection]";
  var functionProto = Function.prototype;
  var isDDA = function isDocumentDotAll() {
    return false;
  };
  if (typeof document === "object") {
    var all2 = document.all;
    if (toStr(all2) === toStr(document.all)) {
      isDDA = function isDocumentDotAll2(value) {
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
          try {
            var str = toStr(value);
            return (str === ddaClass || str === objectClass) && value("") == null;
          } catch (e) {
          }
        }
        return false;
      };
    }
  }
  implementation$2 = function getName() {
    if (isDDA(this) || !isClass(this) && !IsCallable2(this)) {
      throw new TypeError("Function.prototype.name sham getter called on non-function");
    }
    if (functionsHaveNames && hasOwn(this, "name")) {
      return this.name;
    }
    if (this === functionProto) {
      return "";
    }
    var str = $functionToString(this);
    var match = $stringMatch(str, regex);
    var name = match && match[1];
    return name;
  };
  return implementation$2;
}
var polyfill$2;
var hasRequiredPolyfill$2;
function requirePolyfill$2() {
  if (hasRequiredPolyfill$2) return polyfill$2;
  hasRequiredPolyfill$2 = 1;
  var implementation2 = requireImplementation$2();
  polyfill$2 = function getPolyfill() {
    return implementation2;
  };
  return polyfill$2;
}
var shim$2;
var hasRequiredShim$2;
function requireShim$2() {
  if (hasRequiredShim$2) return shim$2;
  hasRequiredShim$2 = 1;
  var supportsDescriptors = requireDefineProperties().supportsDescriptors;
  var functionsHaveNames = requireFunctionsHaveNames()();
  var getPolyfill = requirePolyfill$2();
  var defineProperty2 = Object.defineProperty;
  var TypeErr = TypeError;
  shim$2 = function shimName() {
    var polyfill2 = getPolyfill();
    if (functionsHaveNames) {
      return polyfill2;
    }
    if (!supportsDescriptors) {
      throw new TypeErr("Shimming Function.prototype.name support requires ES5 property descriptor support.");
    }
    var functionProto = Function.prototype;
    defineProperty2(functionProto, "name", {
      configurable: true,
      enumerable: false,
      get: function() {
        var name = polyfill2.call(this);
        if (this !== functionProto) {
          defineProperty2(this, "name", {
            configurable: true,
            enumerable: false,
            value: name,
            writable: false
          });
        }
        return name;
      }
    });
    return polyfill2;
  };
  return shim$2;
}
var function_prototype_name;
var hasRequiredFunction_prototype_name;
function requireFunction_prototype_name() {
  if (hasRequiredFunction_prototype_name) return function_prototype_name;
  hasRequiredFunction_prototype_name = 1;
  var define2 = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$2();
  var getPolyfill = requirePolyfill$2();
  var shim2 = requireShim$2();
  var bound = callBind2(implementation2);
  define2(bound, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  function_prototype_name = bound;
  return function_prototype_name;
}
var lib$d = {};
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __decorate(decorators, target2, key, desc) {
  var c = arguments.length, r2 = c < 3 ? target2 : desc === null ? desc = Object.getOwnPropertyDescriptor(target2, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r2 = Reflect.decorate(decorators, target2, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r2 = (c < 3 ? d(r2) : c > 3 ? d(target2, key, r2) : d(target2, key)) || r2;
  return c > 3 && r2 && Object.defineProperty(target2, key, r2), r2;
}
function __param(paramIndex, decorator) {
  return function(target2, key) {
    decorator(target2, key, paramIndex);
  };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f2) {
    if (f2 !== void 0 && typeof f2 !== "function") throw new TypeError("Function expected");
    return f2;
  }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target2 = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target2 ? Object.getOwnPropertyDescriptor(target2, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
    var context = {};
    for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
    for (var p in contextIn.access) context.access[p] = contextIn.access[p];
    context.addInitializer = function(f2) {
      if (done) throw new TypeError("Cannot add initializers after decoration has completed");
      extraInitializers.push(accept(f2 || null));
    };
    var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
    if (kind === "accessor") {
      if (result === void 0) continue;
      if (result === null || typeof result !== "object") throw new TypeError("Object expected");
      if (_ = accept(result.get)) descriptor.get = _;
      if (_ = accept(result.set)) descriptor.set = _;
      if (_ = accept(result.init)) initializers.unshift(_);
    } else if (_ = accept(result)) {
      if (kind === "field") initializers.unshift(_);
      else descriptor[key] = _;
    }
  }
  if (target2) Object.defineProperty(target2, contextIn.name, descriptor);
  done = true;
}
function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
    value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
}
function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f2, name, prefix2) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f2, "name", { configurable: true, value: prefix2 ? "".concat(prefix2, " ", name) : name });
}
function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f2, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f2) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f2 = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f2 = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === void 0) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === void 0) k2 = k;
  o[k2] = m[k];
});
function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r2, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r2 = i.next()).done) ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read(arguments[i]));
  return ar;
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r2 = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r2[k] = a[j];
  return r2;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q2 = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function awaitReturn(f2) {
    return function(v) {
      return Promise.resolve(v).then(f2, reject);
    };
  }
  function verb(n, f2) {
    if (g[n]) {
      i[n] = function(v) {
        return new Promise(function(a, b) {
          q2.push([n, v, a, b]) > 1 || resume(n, v);
        });
      };
      if (f2) i[n] = f2(i[n]);
    }
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q2[0][3], e);
    }
  }
  function step(r2) {
    r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f2, v) {
    if (f2(v), q2.shift(), q2.length) resume(q2[0][0], q2[0][1]);
  }
}
function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function(e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function() {
    return this;
  }, i;
  function verb(n, f2) {
    i[n] = o[n] ? function(v) {
      return (p = !p) ? { value: __await(o[n](v)), done: false } : f2 ? f2(v) : v;
    } : f2;
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function(v) {
      return new Promise(function(resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }
  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function(v2) {
      resolve({ value: v2, done: d });
    }, reject);
  }
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", { value: raw });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};
var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function(o2) {
    var ar = [];
    for (var k in o2) if (Object.prototype.hasOwnProperty.call(o2, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};
function __importStar(mod2) {
  if (mod2 && mod2.__esModule) return mod2;
  var result = {};
  if (mod2 != null) {
    for (var k = ownKeys(mod2), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod2, k[i]);
  }
  __setModuleDefault(result, mod2);
  return result;
}
function __importDefault(mod2) {
  return mod2 && mod2.__esModule ? mod2 : { default: mod2 };
}
function __classPrivateFieldGet(receiver, state, kind, f2) {
  if (kind === "a" && !f2) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f2 : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f2 : kind === "a" ? f2.call(receiver) : f2 ? f2.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f2) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f2) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f2 : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f2.call(receiver, value) : f2 ? f2.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async2) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async2) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async2) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() {
      try {
        inner.call(this);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    env.stack.push({ value, dispose, async: async2 });
  } else if (async2) {
    env.stack.push({ async: true });
  }
  return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r2, s = 0;
  function next() {
    while (r2 = env.stack.pop()) {
      try {
        if (!r2.async && s === 1) return s = 0, env.stack.push(r2), Promise.resolve().then(next);
        if (r2.dispose) {
          var result = r2.dispose.call(r2.value);
          if (r2.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
            fail(e);
            return next();
          });
        } else s |= 1;
      } catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
    return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
      return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
  }
  return path;
}
const tslib_es6 = {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension
};
const tslib_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource,
  get __assign() {
    return __assign;
  },
  __asyncDelegator,
  __asyncGenerator,
  __asyncValues,
  __await,
  __awaiter,
  __classPrivateFieldGet,
  __classPrivateFieldIn,
  __classPrivateFieldSet,
  __createBinding,
  __decorate,
  __disposeResources,
  __esDecorate,
  __exportStar,
  __extends,
  __generator,
  __importDefault,
  __importStar,
  __makeTemplateObject,
  __metadata,
  __param,
  __propKey,
  __read,
  __rest,
  __rewriteRelativeImportExtension,
  __runInitializers,
  __setFunctionName,
  __spread,
  __spreadArray,
  __spreadArrays,
  __values,
  default: tslib_es6
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(tslib_es6$1);
var types = {};
var hasRequiredTypes;
function requireTypes() {
  if (hasRequiredTypes) return types;
  hasRequiredTypes = 1;
  Object.defineProperty(types, "__esModule", {
    value: true
  });
  return types;
}
var load = {};
var options = {};
var hasRequiredOptions;
function requireOptions() {
  if (hasRequiredOptions) return options;
  hasRequiredOptions = 1;
  Object.defineProperty(options, "__esModule", {
    value: true
  });
  options.flatten = void 0;
  var tslib_1 = require$$0$4;
  var defaultOpts = {
    xml: false,
    decodeEntities: true
  };
  options.default = defaultOpts;
  var xmlModeDefault = {
    _useHtmlParser2: true,
    xmlMode: true
  };
  function flatten2(options2) {
    return (options2 === null || options2 === void 0 ? void 0 : options2.xml) ? typeof options2.xml === "boolean" ? xmlModeDefault : tslib_1.__assign(tslib_1.__assign({}, xmlModeDefault), options2.xml) : options2 !== null && options2 !== void 0 ? options2 : void 0;
  }
  options.flatten = flatten2;
  return options;
}
var _static = {};
var lib$c = {};
var SelectorType;
(function(SelectorType2) {
  SelectorType2["Attribute"] = "attribute";
  SelectorType2["Pseudo"] = "pseudo";
  SelectorType2["PseudoElement"] = "pseudo-element";
  SelectorType2["Tag"] = "tag";
  SelectorType2["Universal"] = "universal";
  SelectorType2["Adjacent"] = "adjacent";
  SelectorType2["Child"] = "child";
  SelectorType2["Descendant"] = "descendant";
  SelectorType2["Parent"] = "parent";
  SelectorType2["Sibling"] = "sibling";
  SelectorType2["ColumnCombinator"] = "column-combinator";
})(SelectorType || (SelectorType = {}));
const IgnoreCaseMode = {
  Unknown: null,
  QuirksMode: "quirks",
  IgnoreCase: true,
  CaseSensitive: false
};
var AttributeAction;
(function(AttributeAction2) {
  AttributeAction2["Any"] = "any";
  AttributeAction2["Element"] = "element";
  AttributeAction2["End"] = "end";
  AttributeAction2["Equals"] = "equals";
  AttributeAction2["Exists"] = "exists";
  AttributeAction2["Hyphen"] = "hyphen";
  AttributeAction2["Not"] = "not";
  AttributeAction2["Start"] = "start";
})(AttributeAction || (AttributeAction = {}));
const reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const actionTypes = /* @__PURE__ */ new Map([[126, AttributeAction.Element], [94, AttributeAction.Start], [36, AttributeAction.End], [42, AttributeAction.Any], [33, AttributeAction.Not], [124, AttributeAction.Hyphen]]);
const unpackPseudos = /* @__PURE__ */ new Set(["has", "not", "matches", "is", "where", "host", "host-context"]);
function isTraversal(selector2) {
  switch (selector2.type) {
    case SelectorType.Adjacent:
    case SelectorType.Child:
    case SelectorType.Descendant:
    case SelectorType.Parent:
    case SelectorType.Sibling:
    case SelectorType.ColumnCombinator:
      return true;
    default:
      return false;
  }
}
const stripQuotesFromPseudos = /* @__PURE__ */ new Set(["contains", "icontains"]);
function funescape(_, escaped, escapedWhitespace) {
  const high = parseInt(escaped, 16) - 65536;
  return high !== high || escapedWhitespace ? escaped : high < 0 ? (
    // BMP codepoint
    String.fromCharCode(high + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320)
  );
}
function unescapeCSS(str) {
  return str.replace(reEscape, funescape);
}
function isQuote(c) {
  return c === 39 || c === 34;
}
function isWhitespace(c) {
  return c === 32 || c === 9 || c === 10 || c === 12 || c === 13;
}
function parse$2(selector2) {
  const subselects2 = [];
  const endIndex = parseSelector(subselects2, `${selector2}`, 0);
  if (endIndex < selector2.length) {
    throw new Error(`Unmatched selector: ${selector2.slice(endIndex)}`);
  }
  return subselects2;
}
function parseSelector(subselects2, selector2, selectorIndex) {
  let tokens = [];
  function getName(offset) {
    const match = selector2.slice(selectorIndex + offset).match(reName);
    if (!match) {
      throw new Error(`Expected name, found ${selector2.slice(selectorIndex)}`);
    }
    const [name] = match;
    selectorIndex += offset + name.length;
    return unescapeCSS(name);
  }
  function stripWhitespace(offset) {
    selectorIndex += offset;
    while (selectorIndex < selector2.length && isWhitespace(selector2.charCodeAt(selectorIndex))) {
      selectorIndex++;
    }
  }
  function readValueWithParenthesis() {
    selectorIndex += 1;
    const start2 = selectorIndex;
    let counter = 1;
    for (; counter > 0 && selectorIndex < selector2.length; selectorIndex++) {
      if (selector2.charCodeAt(selectorIndex) === 40 && !isEscaped(selectorIndex)) {
        counter++;
      } else if (selector2.charCodeAt(selectorIndex) === 41 && !isEscaped(selectorIndex)) {
        counter--;
      }
    }
    if (counter) {
      throw new Error("Parenthesis not matched");
    }
    return unescapeCSS(selector2.slice(start2, selectorIndex - 1));
  }
  function isEscaped(pos) {
    let slashCount = 0;
    while (selector2.charCodeAt(--pos) === 92) slashCount++;
    return (slashCount & 1) === 1;
  }
  function ensureNotTraversal() {
    if (tokens.length > 0 && isTraversal(tokens[tokens.length - 1])) {
      throw new Error("Did not expect successive traversals.");
    }
  }
  function addTraversal(type2) {
    if (tokens.length > 0 && tokens[tokens.length - 1].type === SelectorType.Descendant) {
      tokens[tokens.length - 1].type = type2;
      return;
    }
    ensureNotTraversal();
    tokens.push({
      type: type2
    });
  }
  function addSpecialAttribute(name, action) {
    tokens.push({
      type: SelectorType.Attribute,
      name,
      action,
      value: getName(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function finalizeSubselector() {
    if (tokens.length && tokens[tokens.length - 1].type === SelectorType.Descendant) {
      tokens.pop();
    }
    if (tokens.length === 0) {
      throw new Error("Empty sub-selector");
    }
    subselects2.push(tokens);
  }
  stripWhitespace(0);
  if (selector2.length === selectorIndex) {
    return selectorIndex;
  }
  loop: while (selectorIndex < selector2.length) {
    const firstChar = selector2.charCodeAt(selectorIndex);
    switch (firstChar) {
      // Whitespace
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        if (tokens.length === 0 || tokens[0].type !== SelectorType.Descendant) {
          ensureNotTraversal();
          tokens.push({
            type: SelectorType.Descendant
          });
        }
        stripWhitespace(1);
        break;
      }
      // Traversals
      case 62: {
        addTraversal(SelectorType.Child);
        stripWhitespace(1);
        break;
      }
      case 60: {
        addTraversal(SelectorType.Parent);
        stripWhitespace(1);
        break;
      }
      case 126: {
        addTraversal(SelectorType.Sibling);
        stripWhitespace(1);
        break;
      }
      case 43: {
        addTraversal(SelectorType.Adjacent);
        stripWhitespace(1);
        break;
      }
      // Special attribute selectors: .class, #id
      case 46: {
        addSpecialAttribute("class", AttributeAction.Element);
        break;
      }
      case 35: {
        addSpecialAttribute("id", AttributeAction.Equals);
        break;
      }
      case 91: {
        stripWhitespace(1);
        let name;
        let namespace2 = null;
        if (selector2.charCodeAt(selectorIndex) === 124) {
          name = getName(1);
        } else if (selector2.startsWith("*|", selectorIndex)) {
          namespace2 = "*";
          name = getName(2);
        } else {
          name = getName(0);
          if (selector2.charCodeAt(selectorIndex) === 124 && selector2.charCodeAt(selectorIndex + 1) !== 61) {
            namespace2 = name;
            name = getName(1);
          }
        }
        stripWhitespace(0);
        let action = AttributeAction.Exists;
        const possibleAction = actionTypes.get(selector2.charCodeAt(selectorIndex));
        if (possibleAction) {
          action = possibleAction;
          if (selector2.charCodeAt(selectorIndex + 1) !== 61) {
            throw new Error("Expected `=`");
          }
          stripWhitespace(2);
        } else if (selector2.charCodeAt(selectorIndex) === 61) {
          action = AttributeAction.Equals;
          stripWhitespace(1);
        }
        let value = "";
        let ignoreCase = null;
        if (action !== "exists") {
          if (isQuote(selector2.charCodeAt(selectorIndex))) {
            const quote = selector2.charCodeAt(selectorIndex);
            let sectionEnd = selectorIndex + 1;
            while (sectionEnd < selector2.length && (selector2.charCodeAt(sectionEnd) !== quote || isEscaped(sectionEnd))) {
              sectionEnd += 1;
            }
            if (selector2.charCodeAt(sectionEnd) !== quote) {
              throw new Error("Attribute value didn't end");
            }
            value = unescapeCSS(selector2.slice(selectorIndex + 1, sectionEnd));
            selectorIndex = sectionEnd + 1;
          } else {
            const valueStart = selectorIndex;
            while (selectorIndex < selector2.length && (!isWhitespace(selector2.charCodeAt(selectorIndex)) && selector2.charCodeAt(selectorIndex) !== 93 || isEscaped(selectorIndex))) {
              selectorIndex += 1;
            }
            value = unescapeCSS(selector2.slice(valueStart, selectorIndex));
          }
          stripWhitespace(0);
          const forceIgnore = selector2.charCodeAt(selectorIndex) | 32;
          if (forceIgnore === 115) {
            ignoreCase = false;
            stripWhitespace(1);
          } else if (forceIgnore === 105) {
            ignoreCase = true;
            stripWhitespace(1);
          }
        }
        if (selector2.charCodeAt(selectorIndex) !== 93) {
          throw new Error("Attribute selector didn't terminate");
        }
        selectorIndex += 1;
        const attributeSelector = {
          type: SelectorType.Attribute,
          name,
          action,
          value,
          namespace: namespace2,
          ignoreCase
        };
        tokens.push(attributeSelector);
        break;
      }
      case 58: {
        if (selector2.charCodeAt(selectorIndex + 1) === 58) {
          tokens.push({
            type: SelectorType.PseudoElement,
            name: getName(2).toLowerCase(),
            data: selector2.charCodeAt(selectorIndex) === 40 ? readValueWithParenthesis() : null
          });
          continue;
        }
        const name = getName(1).toLowerCase();
        let data2 = null;
        if (selector2.charCodeAt(selectorIndex) === 40) {
          if (unpackPseudos.has(name)) {
            if (isQuote(selector2.charCodeAt(selectorIndex + 1))) {
              throw new Error(`Pseudo-selector ${name} cannot be quoted`);
            }
            data2 = [];
            selectorIndex = parseSelector(data2, selector2, selectorIndex + 1);
            if (selector2.charCodeAt(selectorIndex) !== 41) {
              throw new Error(`Missing closing parenthesis in :${name} (${selector2})`);
            }
            selectorIndex += 1;
          } else {
            data2 = readValueWithParenthesis();
            if (stripQuotesFromPseudos.has(name)) {
              const quot2 = data2.charCodeAt(0);
              if (quot2 === data2.charCodeAt(data2.length - 1) && isQuote(quot2)) {
                data2 = data2.slice(1, -1);
              }
            }
            data2 = unescapeCSS(data2);
          }
        }
        tokens.push({
          type: SelectorType.Pseudo,
          name,
          data: data2
        });
        break;
      }
      case 44: {
        finalizeSubselector();
        tokens = [];
        stripWhitespace(1);
        break;
      }
      default: {
        if (selector2.startsWith("/*", selectorIndex)) {
          const endIndex = selector2.indexOf("*/", selectorIndex + 2);
          if (endIndex < 0) {
            throw new Error("Comment was not terminated");
          }
          selectorIndex = endIndex + 2;
          if (tokens.length === 0) {
            stripWhitespace(0);
          }
          break;
        }
        let namespace2 = null;
        let name;
        if (firstChar === 42) {
          selectorIndex += 1;
          name = "*";
        } else if (firstChar === 124) {
          name = "";
          if (selector2.charCodeAt(selectorIndex + 1) === 124) {
            addTraversal(SelectorType.ColumnCombinator);
            stripWhitespace(2);
            break;
          }
        } else if (reName.test(selector2.slice(selectorIndex))) {
          name = getName(0);
        } else {
          break loop;
        }
        if (selector2.charCodeAt(selectorIndex) === 124 && selector2.charCodeAt(selectorIndex + 1) !== 124) {
          namespace2 = name;
          if (selector2.charCodeAt(selectorIndex + 1) === 42) {
            name = "*";
            selectorIndex += 2;
          } else {
            name = getName(1);
          }
        }
        tokens.push(name === "*" ? {
          type: SelectorType.Universal,
          namespace: namespace2
        } : {
          type: SelectorType.Tag,
          name,
          namespace: namespace2
        });
      }
    }
  }
  finalizeSubselector();
  return selectorIndex;
}
const attribValChars = ["\\", '"'];
const pseudoValChars = [...attribValChars, "(", ")"];
const charsToEscapeInAttributeValue = new Set(attribValChars.map((c) => c.charCodeAt(0)));
const charsToEscapeInPseudoValue = new Set(pseudoValChars.map((c) => c.charCodeAt(0)));
const charsToEscapeInName = new Set([...pseudoValChars, "~", "^", "$", "*", "+", "!", "|", ":", "[", "]", " ", "."].map((c) => c.charCodeAt(0)));
function stringify$1(selector2) {
  return selector2.map((token) => token.map(stringifyToken).join("")).join(", ");
}
function stringifyToken(token, index2, arr) {
  switch (token.type) {
    // Simple types
    case SelectorType.Child:
      return index2 === 0 ? "> " : " > ";
    case SelectorType.Parent:
      return index2 === 0 ? "< " : " < ";
    case SelectorType.Sibling:
      return index2 === 0 ? "~ " : " ~ ";
    case SelectorType.Adjacent:
      return index2 === 0 ? "+ " : " + ";
    case SelectorType.Descendant:
      return " ";
    case SelectorType.ColumnCombinator:
      return index2 === 0 ? "|| " : " || ";
    case SelectorType.Universal:
      return token.namespace === "*" && index2 + 1 < arr.length && "name" in arr[index2 + 1] ? "" : `${getNamespace(token.namespace)}*`;
    case SelectorType.Tag:
      return getNamespacedName(token);
    case SelectorType.PseudoElement:
      return `::${escapeName(token.name, charsToEscapeInName)}${token.data === null ? "" : `(${escapeName(token.data, charsToEscapeInPseudoValue)})`}`;
    case SelectorType.Pseudo:
      return `:${escapeName(token.name, charsToEscapeInName)}${token.data === null ? "" : `(${typeof token.data === "string" ? escapeName(token.data, charsToEscapeInPseudoValue) : stringify$1(token.data)})`}`;
    case SelectorType.Attribute: {
      if (token.name === "id" && token.action === AttributeAction.Equals && token.ignoreCase === "quirks" && !token.namespace) {
        return `#${escapeName(token.value, charsToEscapeInName)}`;
      }
      if (token.name === "class" && token.action === AttributeAction.Element && token.ignoreCase === "quirks" && !token.namespace) {
        return `.${escapeName(token.value, charsToEscapeInName)}`;
      }
      const name = getNamespacedName(token);
      if (token.action === AttributeAction.Exists) {
        return `[${name}]`;
      }
      return `[${name}${getActionValue(token.action)}="${escapeName(token.value, charsToEscapeInAttributeValue)}"${token.ignoreCase === null ? "" : token.ignoreCase ? " i" : " s"}]`;
    }
  }
}
function getActionValue(action) {
  switch (action) {
    case AttributeAction.Equals:
      return "";
    case AttributeAction.Element:
      return "~";
    case AttributeAction.Start:
      return "^";
    case AttributeAction.End:
      return "$";
    case AttributeAction.Any:
      return "*";
    case AttributeAction.Not:
      return "!";
    case AttributeAction.Hyphen:
      return "|";
    case AttributeAction.Exists:
      throw new Error("Shouldn't be here");
  }
}
function getNamespacedName(token) {
  return `${getNamespace(token.namespace)}${escapeName(token.name, charsToEscapeInName)}`;
}
function getNamespace(namespace2) {
  return namespace2 !== null ? `${namespace2 === "*" ? "*" : escapeName(namespace2, charsToEscapeInName)}|` : "";
}
function escapeName(str, charsToEscape) {
  let lastIdx = 0;
  let ret = "";
  for (let i = 0; i < str.length; i++) {
    if (charsToEscape.has(str.charCodeAt(i))) {
      ret += `${str.slice(lastIdx, i)}\\${str.charAt(i)}`;
      lastIdx = i + 1;
    }
  }
  return ret.length > 0 ? ret + str.slice(lastIdx) : str;
}
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AttributeAction() {
    return AttributeAction;
  },
  IgnoreCaseMode,
  get SelectorType() {
    return SelectorType;
  },
  isTraversal,
  parse: parse$2,
  stringify: stringify$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(es);
var lib$b = {};
var lib$a = {};
var stringify = {};
var lib$9 = {};
var lib$8 = {};
var hasRequiredLib$d;
function requireLib$d() {
  if (hasRequiredLib$d) return lib$8;
  hasRequiredLib$d = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.Doctype = exports2.CDATA = exports2.Tag = exports2.Style = exports2.Script = exports2.Comment = exports2.Directive = exports2.Text = exports2.Root = exports2.isTag = exports2.ElementType = void 0;
    var ElementType;
    (function(ElementType2) {
      ElementType2["Root"] = "root";
      ElementType2["Text"] = "text";
      ElementType2["Directive"] = "directive";
      ElementType2["Comment"] = "comment";
      ElementType2["Script"] = "script";
      ElementType2["Style"] = "style";
      ElementType2["Tag"] = "tag";
      ElementType2["CDATA"] = "cdata";
      ElementType2["Doctype"] = "doctype";
    })(ElementType = exports2.ElementType || (exports2.ElementType = {}));
    function isTag(elem) {
      return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
    }
    exports2.isTag = isTag;
    exports2.Root = ElementType.Root;
    exports2.Text = ElementType.Text;
    exports2.Directive = ElementType.Directive;
    exports2.Comment = ElementType.Comment;
    exports2.Script = ElementType.Script;
    exports2.Style = ElementType.Style;
    exports2.Tag = ElementType.Tag;
    exports2.CDATA = ElementType.CDATA;
    exports2.Doctype = ElementType.Doctype;
  })(lib$8);
  return lib$8;
}
var node = {};
var hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var __extends2 = node && node.__extends || /* @__PURE__ */ (function() {
    var extendStatics2 = function(d, b) {
      extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
      };
      return extendStatics2(d, b);
    };
    return function(d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics2(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __assign2 = node && node.__assign || function() {
    __assign2 = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign2.apply(this, arguments);
  };
  Object.defineProperty(node, "__esModule", {
    value: true
  });
  node.cloneNode = node.hasChildren = node.isDocument = node.isDirective = node.isComment = node.isText = node.isCDATA = node.isTag = node.Element = node.Document = node.NodeWithChildren = node.ProcessingInstruction = node.Comment = node.Text = node.DataNode = node.Node = void 0;
  var domelementtype_1 = /* @__PURE__ */ requireLib$d();
  var nodeTypes = /* @__PURE__ */ new Map([[domelementtype_1.ElementType.Tag, 1], [domelementtype_1.ElementType.Script, 1], [domelementtype_1.ElementType.Style, 1], [domelementtype_1.ElementType.Directive, 1], [domelementtype_1.ElementType.Text, 3], [domelementtype_1.ElementType.CDATA, 4], [domelementtype_1.ElementType.Comment, 8], [domelementtype_1.ElementType.Root, 9]]);
  var Node = (
    /** @class */
    (function() {
      function Node2(type2) {
        this.type = type2;
        this.parent = null;
        this.prev = null;
        this.next = null;
        this.startIndex = null;
        this.endIndex = null;
      }
      Object.defineProperty(Node2.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */
        get: function() {
          var _a;
          return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Node2.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(parent) {
          this.parent = parent;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Node2.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(prev) {
          this.prev = prev;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Node2.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(next) {
          this.next = next;
        },
        enumerable: false,
        configurable: true
      });
      Node2.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) {
          recursive = false;
        }
        return cloneNode(this, recursive);
      };
      return Node2;
    })()
  );
  node.Node = Node;
  var DataNode = (
    /** @class */
    (function(_super) {
      __extends2(DataNode2, _super);
      function DataNode2(type2, data2) {
        var _this = _super.call(this, type2) || this;
        _this.data = data2;
        return _this;
      }
      Object.defineProperty(DataNode2.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(data2) {
          this.data = data2;
        },
        enumerable: false,
        configurable: true
      });
      return DataNode2;
    })(Node)
  );
  node.DataNode = DataNode;
  var Text = (
    /** @class */
    (function(_super) {
      __extends2(Text2, _super);
      function Text2(data2) {
        return _super.call(this, domelementtype_1.ElementType.Text, data2) || this;
      }
      return Text2;
    })(DataNode)
  );
  node.Text = Text;
  var Comment = (
    /** @class */
    (function(_super) {
      __extends2(Comment2, _super);
      function Comment2(data2) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data2) || this;
      }
      return Comment2;
    })(DataNode)
  );
  node.Comment = Comment;
  var ProcessingInstruction = (
    /** @class */
    (function(_super) {
      __extends2(ProcessingInstruction2, _super);
      function ProcessingInstruction2(name, data2) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data2) || this;
        _this.name = name;
        return _this;
      }
      return ProcessingInstruction2;
    })(DataNode)
  );
  node.ProcessingInstruction = ProcessingInstruction;
  var NodeWithChildren = (
    /** @class */
    (function(_super) {
      __extends2(NodeWithChildren2, _super);
      function NodeWithChildren2(type2, children2) {
        var _this = _super.call(this, type2) || this;
        _this.children = children2;
        return _this;
      }
      Object.defineProperty(NodeWithChildren2.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var _a;
          return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(NodeWithChildren2.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(NodeWithChildren2.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(children2) {
          this.children = children2;
        },
        enumerable: false,
        configurable: true
      });
      return NodeWithChildren2;
    })(Node)
  );
  node.NodeWithChildren = NodeWithChildren;
  var Document = (
    /** @class */
    (function(_super) {
      __extends2(Document2, _super);
      function Document2(children2) {
        return _super.call(this, domelementtype_1.ElementType.Root, children2) || this;
      }
      return Document2;
    })(NodeWithChildren)
  );
  node.Document = Document;
  var Element2 = (
    /** @class */
    (function(_super) {
      __extends2(Element3, _super);
      function Element3(name, attribs, children2, type2) {
        if (children2 === void 0) {
          children2 = [];
        }
        if (type2 === void 0) {
          type2 = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
        }
        var _this = _super.call(this, type2, children2) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
      }
      Object.defineProperty(Element3.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(name) {
          this.name = name;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Element3.prototype, "attributes", {
        get: function() {
          var _this = this;
          return Object.keys(this.attribs).map(function(name) {
            var _a, _b;
            return {
              name,
              value: _this.attribs[name],
              namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
              prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
          });
        },
        enumerable: false,
        configurable: true
      });
      return Element3;
    })(NodeWithChildren)
  );
  node.Element = Element2;
  function isTag(node2) {
    return (0, domelementtype_1.isTag)(node2);
  }
  node.isTag = isTag;
  function isCDATA(node2) {
    return node2.type === domelementtype_1.ElementType.CDATA;
  }
  node.isCDATA = isCDATA;
  function isText(node2) {
    return node2.type === domelementtype_1.ElementType.Text;
  }
  node.isText = isText;
  function isComment(node2) {
    return node2.type === domelementtype_1.ElementType.Comment;
  }
  node.isComment = isComment;
  function isDirective(node2) {
    return node2.type === domelementtype_1.ElementType.Directive;
  }
  node.isDirective = isDirective;
  function isDocument2(node2) {
    return node2.type === domelementtype_1.ElementType.Root;
  }
  node.isDocument = isDocument2;
  function hasChildren(node2) {
    return Object.prototype.hasOwnProperty.call(node2, "children");
  }
  node.hasChildren = hasChildren;
  function cloneNode(node2, recursive) {
    if (recursive === void 0) {
      recursive = false;
    }
    var result;
    if (isText(node2)) {
      result = new Text(node2.data);
    } else if (isComment(node2)) {
      result = new Comment(node2.data);
    } else if (isTag(node2)) {
      var children2 = recursive ? cloneChildren(node2.children) : [];
      var clone_1 = new Element2(node2.name, __assign2({}, node2.attribs), children2);
      children2.forEach(function(child) {
        return child.parent = clone_1;
      });
      if (node2.namespace != null) {
        clone_1.namespace = node2.namespace;
      }
      if (node2["x-attribsNamespace"]) {
        clone_1["x-attribsNamespace"] = __assign2({}, node2["x-attribsNamespace"]);
      }
      if (node2["x-attribsPrefix"]) {
        clone_1["x-attribsPrefix"] = __assign2({}, node2["x-attribsPrefix"]);
      }
      result = clone_1;
    } else if (isCDATA(node2)) {
      var children2 = recursive ? cloneChildren(node2.children) : [];
      var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children2);
      children2.forEach(function(child) {
        return child.parent = clone_2;
      });
      result = clone_2;
    } else if (isDocument2(node2)) {
      var children2 = recursive ? cloneChildren(node2.children) : [];
      var clone_3 = new Document(children2);
      children2.forEach(function(child) {
        return child.parent = clone_3;
      });
      if (node2["x-mode"]) {
        clone_3["x-mode"] = node2["x-mode"];
      }
      result = clone_3;
    } else if (isDirective(node2)) {
      var instruction = new ProcessingInstruction(node2.name, node2.data);
      if (node2["x-name"] != null) {
        instruction["x-name"] = node2["x-name"];
        instruction["x-publicId"] = node2["x-publicId"];
        instruction["x-systemId"] = node2["x-systemId"];
      }
      result = instruction;
    } else {
      throw new Error("Not implemented yet: ".concat(node2.type));
    }
    result.startIndex = node2.startIndex;
    result.endIndex = node2.endIndex;
    if (node2.sourceCodeLocation != null) {
      result.sourceCodeLocation = node2.sourceCodeLocation;
    }
    return result;
  }
  node.cloneNode = cloneNode;
  function cloneChildren(childs) {
    var children2 = childs.map(function(child) {
      return cloneNode(child, true);
    });
    for (var i = 1; i < children2.length; i++) {
      children2[i].prev = children2[i - 1];
      children2[i - 1].next = children2[i];
    }
    return children2;
  }
  return node;
}
var hasRequiredLib$c;
function requireLib$c() {
  if (hasRequiredLib$c) return lib$9;
  hasRequiredLib$c = 1;
  (function(exports2) {
    var __createBinding2 = lib$9 && lib$9.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
          enumerable: true,
          get: function() {
            return m[k];
          }
        };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __exportStar2 = lib$9 && lib$9.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding2(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.DomHandler = void 0;
    var domelementtype_1 = /* @__PURE__ */ requireLib$d();
    var node_1 = /* @__PURE__ */ requireNode();
    __exportStar2(/* @__PURE__ */ requireNode(), exports2);
    var reWhitespace2 = /\s+/g;
    var defaultOpts = {
      normalizeWhitespace: false,
      withStartIndices: false,
      withEndIndices: false,
      xmlMode: false
    };
    var DomHandler = (
      /** @class */
      (function() {
        function DomHandler2(callback, options2, elementCB) {
          this.dom = [];
          this.root = new node_1.Document(this.dom);
          this.done = false;
          this.tagStack = [this.root];
          this.lastNode = null;
          this.parser = null;
          if (typeof options2 === "function") {
            elementCB = options2;
            options2 = defaultOpts;
          }
          if (typeof callback === "object") {
            options2 = callback;
            callback = void 0;
          }
          this.callback = callback !== null && callback !== void 0 ? callback : null;
          this.options = options2 !== null && options2 !== void 0 ? options2 : defaultOpts;
          this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
        }
        DomHandler2.prototype.onparserinit = function(parser2) {
          this.parser = parser2;
        };
        DomHandler2.prototype.onreset = function() {
          this.dom = [];
          this.root = new node_1.Document(this.dom);
          this.done = false;
          this.tagStack = [this.root];
          this.lastNode = null;
          this.parser = null;
        };
        DomHandler2.prototype.onend = function() {
          if (this.done) return;
          this.done = true;
          this.parser = null;
          this.handleCallback(null);
        };
        DomHandler2.prototype.onerror = function(error) {
          this.handleCallback(error);
        };
        DomHandler2.prototype.onclosetag = function() {
          this.lastNode = null;
          var elem = this.tagStack.pop();
          if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
          }
          if (this.elementCB) this.elementCB(elem);
        };
        DomHandler2.prototype.onopentag = function(name, attribs) {
          var type2 = this.options.xmlMode ? domelementtype_1.ElementType.Tag : void 0;
          var element = new node_1.Element(name, attribs, void 0, type2);
          this.addNode(element);
          this.tagStack.push(element);
        };
        DomHandler2.prototype.ontext = function(data2) {
          var normalizeWhitespace = this.options.normalizeWhitespace;
          var lastNode = this.lastNode;
          if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
              lastNode.data = (lastNode.data + data2).replace(reWhitespace2, " ");
            } else {
              lastNode.data += data2;
            }
            if (this.options.withEndIndices) {
              lastNode.endIndex = this.parser.endIndex;
            }
          } else {
            if (normalizeWhitespace) {
              data2 = data2.replace(reWhitespace2, " ");
            }
            var node2 = new node_1.Text(data2);
            this.addNode(node2);
            this.lastNode = node2;
          }
        };
        DomHandler2.prototype.oncomment = function(data2) {
          if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data2;
            return;
          }
          var node2 = new node_1.Comment(data2);
          this.addNode(node2);
          this.lastNode = node2;
        };
        DomHandler2.prototype.oncommentend = function() {
          this.lastNode = null;
        };
        DomHandler2.prototype.oncdatastart = function() {
          var text2 = new node_1.Text("");
          var node2 = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text2]);
          this.addNode(node2);
          text2.parent = node2;
          this.lastNode = text2;
        };
        DomHandler2.prototype.oncdataend = function() {
          this.lastNode = null;
        };
        DomHandler2.prototype.onprocessinginstruction = function(name, data2) {
          var node2 = new node_1.ProcessingInstruction(name, data2);
          this.addNode(node2);
        };
        DomHandler2.prototype.handleCallback = function(error) {
          if (typeof this.callback === "function") {
            this.callback(error, this.dom);
          } else if (error) {
            throw error;
          }
        };
        DomHandler2.prototype.addNode = function(node2) {
          var parent = this.tagStack[this.tagStack.length - 1];
          var previousSibling = parent.children[parent.children.length - 1];
          if (this.options.withStartIndices) {
            node2.startIndex = this.parser.startIndex;
          }
          if (this.options.withEndIndices) {
            node2.endIndex = this.parser.endIndex;
          }
          parent.children.push(node2);
          if (previousSibling) {
            node2.prev = previousSibling;
            previousSibling.next = node2;
          }
          node2.parent = parent;
          this.lastNode = null;
        };
        return DomHandler2;
      })()
    );
    exports2.DomHandler = DomHandler;
    exports2.default = DomHandler;
  })(lib$9);
  return lib$9;
}
var lib$7 = {};
var lib$6 = {};
var decode = {};
const Aacute$1 = "Á";
const aacute$1 = "á";
const Abreve = "Ă";
const abreve = "ă";
const ac = "∾";
const acd = "∿";
const acE = "∾̳";
const Acirc$1 = "Â";
const acirc$1 = "â";
const acute$1 = "´";
const Acy = "А";
const acy = "а";
const AElig$1 = "Æ";
const aelig$1 = "æ";
const af = "⁡";
const Afr = "𝔄";
const afr = "𝔞";
const Agrave$1 = "À";
const agrave$1 = "à";
const alefsym = "ℵ";
const aleph = "ℵ";
const Alpha$1 = "Α";
const alpha = "α";
const Amacr = "Ā";
const amacr = "ā";
const amalg = "⨿";
const amp$2 = "&";
const AMP$1 = "&";
const andand = "⩕";
const And = "⩓";
const and = "∧";
const andd = "⩜";
const andslope = "⩘";
const andv = "⩚";
const ang = "∠";
const ange = "⦤";
const angle$1 = "∠";
const angmsdaa = "⦨";
const angmsdab = "⦩";
const angmsdac = "⦪";
const angmsdad = "⦫";
const angmsdae = "⦬";
const angmsdaf = "⦭";
const angmsdag = "⦮";
const angmsdah = "⦯";
const angmsd = "∡";
const angrt = "∟";
const angrtvb = "⊾";
const angrtvbd = "⦝";
const angsph = "∢";
const angst = "Å";
const angzarr = "⍼";
const Aogon = "Ą";
const aogon = "ą";
const Aopf = "𝔸";
const aopf = "𝕒";
const apacir = "⩯";
const ap = "≈";
const apE = "⩰";
const ape = "≊";
const apid = "≋";
const apos$1 = "'";
const ApplyFunction = "⁡";
const approx = "≈";
const approxeq = "≊";
const Aring$1 = "Å";
const aring$1 = "å";
const Ascr = "𝒜";
const ascr = "𝒶";
const Assign = "≔";
const ast = "*";
const asymp = "≈";
const asympeq = "≍";
const Atilde$1 = "Ã";
const atilde$1 = "ã";
const Auml$1 = "Ä";
const auml$1 = "ä";
const awconint = "∳";
const awint = "⨑";
const backcong = "≌";
const backepsilon = "϶";
const backprime = "‵";
const backsim = "∽";
const backsimeq = "⋍";
const Backslash = "∖";
const Barv = "⫧";
const barvee = "⊽";
const barwed = "⌅";
const Barwed = "⌆";
const barwedge = "⌅";
const bbrk = "⎵";
const bbrktbrk = "⎶";
const bcong = "≌";
const Bcy = "Б";
const bcy = "б";
const bdquo = "„";
const becaus = "∵";
const because = "∵";
const Because = "∵";
const bemptyv = "⦰";
const bepsi = "϶";
const bernou = "ℬ";
const Bernoullis = "ℬ";
const Beta = "Β";
const beta = "β";
const beth = "ℶ";
const between = "≬";
const Bfr = "𝔅";
const bfr = "𝔟";
const bigcap = "⋂";
const bigcirc = "◯";
const bigcup = "⋃";
const bigodot = "⨀";
const bigoplus = "⨁";
const bigotimes = "⨂";
const bigsqcup = "⨆";
const bigstar = "★";
const bigtriangledown = "▽";
const bigtriangleup = "△";
const biguplus = "⨄";
const bigvee = "⋁";
const bigwedge = "⋀";
const bkarow = "⤍";
const blacklozenge = "⧫";
const blacksquare = "▪";
const blacktriangle = "▴";
const blacktriangledown = "▾";
const blacktriangleleft = "◂";
const blacktriangleright = "▸";
const blank = "␣";
const blk12 = "▒";
const blk14 = "░";
const blk34 = "▓";
const block = "█";
const bne = "=⃥";
const bnequiv = "≡⃥";
const bNot = "⫭";
const bnot = "⌐";
const Bopf = "𝔹";
const bopf = "𝕓";
const bot = "⊥";
const bottom$1 = "⊥";
const bowtie = "⋈";
const boxbox = "⧉";
const boxdl = "┐";
const boxdL = "╕";
const boxDl = "╖";
const boxDL = "╗";
const boxdr = "┌";
const boxdR = "╒";
const boxDr = "╓";
const boxDR = "╔";
const boxh = "─";
const boxH = "═";
const boxhd = "┬";
const boxHd = "╤";
const boxhD = "╥";
const boxHD = "╦";
const boxhu = "┴";
const boxHu = "╧";
const boxhU = "╨";
const boxHU = "╩";
const boxminus = "⊟";
const boxplus = "⊞";
const boxtimes = "⊠";
const boxul = "┘";
const boxuL = "╛";
const boxUl = "╜";
const boxUL = "╝";
const boxur = "└";
const boxuR = "╘";
const boxUr = "╙";
const boxUR = "╚";
const boxv = "│";
const boxV = "║";
const boxvh = "┼";
const boxvH = "╪";
const boxVh = "╫";
const boxVH = "╬";
const boxvl = "┤";
const boxvL = "╡";
const boxVl = "╢";
const boxVL = "╣";
const boxvr = "├";
const boxvR = "╞";
const boxVr = "╟";
const boxVR = "╠";
const bprime = "‵";
const breve = "˘";
const Breve = "˘";
const brvbar$1 = "¦";
const bscr = "𝒷";
const Bscr = "ℬ";
const bsemi = "⁏";
const bsim = "∽";
const bsime = "⋍";
const bsolb = "⧅";
const bsol = "\\";
const bsolhsub = "⟈";
const bull = "•";
const bullet = "•";
const bump = "≎";
const bumpE = "⪮";
const bumpe = "≏";
const Bumpeq = "≎";
const bumpeq = "≏";
const Cacute = "Ć";
const cacute = "ć";
const capand = "⩄";
const capbrcup = "⩉";
const capcap = "⩋";
const cap = "∩";
const Cap = "⋒";
const capcup = "⩇";
const capdot = "⩀";
const CapitalDifferentialD = "ⅅ";
const caps = "∩︀";
const caret = "⁁";
const caron = "ˇ";
const Cayleys = "ℭ";
const ccaps = "⩍";
const Ccaron = "Č";
const ccaron = "č";
const Ccedil$1 = "Ç";
const ccedil$1 = "ç";
const Ccirc = "Ĉ";
const ccirc = "ĉ";
const Cconint = "∰";
const ccups = "⩌";
const ccupssm = "⩐";
const Cdot = "Ċ";
const cdot = "ċ";
const cedil$1 = "¸";
const Cedilla = "¸";
const cemptyv = "⦲";
const cent$1 = "¢";
const centerdot = "·";
const CenterDot = "·";
const cfr = "𝔠";
const Cfr = "ℭ";
const CHcy = "Ч";
const chcy = "ч";
const check = "✓";
const checkmark = "✓";
const Chi = "Χ";
const chi = "χ";
const circ = "ˆ";
const circeq = "≗";
const circlearrowleft = "↺";
const circlearrowright = "↻";
const circledast = "⊛";
const circledcirc = "⊚";
const circleddash = "⊝";
const CircleDot = "⊙";
const circledR = "®";
const circledS = "Ⓢ";
const CircleMinus = "⊖";
const CirclePlus = "⊕";
const CircleTimes = "⊗";
const cir = "○";
const cirE = "⧃";
const cire = "≗";
const cirfnint = "⨐";
const cirmid = "⫯";
const cirscir = "⧂";
const ClockwiseContourIntegral = "∲";
const CloseCurlyDoubleQuote = "”";
const CloseCurlyQuote = "’";
const clubs = "♣";
const clubsuit = "♣";
const colon = ":";
const Colon = "∷";
const Colone = "⩴";
const colone = "≔";
const coloneq = "≔";
const comma = ",";
const commat = "@";
const comp = "∁";
const compfn = "∘";
const complement = "∁";
const complexes = "ℂ";
const cong = "≅";
const congdot = "⩭";
const Congruent = "≡";
const conint = "∮";
const Conint = "∯";
const ContourIntegral = "∮";
const copf = "𝕔";
const Copf = "ℂ";
const coprod = "∐";
const Coproduct = "∐";
const copy$1 = "©";
const COPY$1 = "©";
const copysr = "℗";
const CounterClockwiseContourIntegral = "∳";
const crarr = "↵";
const cross$1 = "✗";
const Cross$1 = "⨯";
const Cscr = "𝒞";
const cscr = "𝒸";
const csub = "⫏";
const csube = "⫑";
const csup = "⫐";
const csupe = "⫒";
const ctdot = "⋯";
const cudarrl = "⤸";
const cudarrr = "⤵";
const cuepr = "⋞";
const cuesc = "⋟";
const cularr = "↶";
const cularrp = "⤽";
const cupbrcap = "⩈";
const cupcap = "⩆";
const CupCap = "≍";
const cup = "∪";
const Cup = "⋓";
const cupcup = "⩊";
const cupdot = "⊍";
const cupor = "⩅";
const cups = "∪︀";
const curarr = "↷";
const curarrm = "⤼";
const curlyeqprec = "⋞";
const curlyeqsucc = "⋟";
const curlyvee = "⋎";
const curlywedge = "⋏";
const curren$1 = "¤";
const curvearrowleft = "↶";
const curvearrowright = "↷";
const cuvee = "⋎";
const cuwed = "⋏";
const cwconint = "∲";
const cwint = "∱";
const cylcty = "⌭";
const dagger = "†";
const Dagger = "‡";
const daleth = "ℸ";
const darr = "↓";
const Darr = "↡";
const dArr = "⇓";
const dash = "‐";
const Dashv = "⫤";
const dashv = "⊣";
const dbkarow = "⤏";
const dblac = "˝";
const Dcaron = "Ď";
const dcaron = "ď";
const Dcy = "Д";
const dcy = "д";
const ddagger = "‡";
const ddarr = "⇊";
const DD = "ⅅ";
const dd = "ⅆ";
const DDotrahd = "⤑";
const ddotseq = "⩷";
const deg$1 = "°";
const Del = "∇";
const Delta = "Δ";
const delta = "δ";
const demptyv = "⦱";
const dfisht = "⥿";
const Dfr = "𝔇";
const dfr = "𝔡";
const dHar = "⥥";
const dharl = "⇃";
const dharr = "⇂";
const DiacriticalAcute = "´";
const DiacriticalDot = "˙";
const DiacriticalDoubleAcute = "˝";
const DiacriticalGrave = "`";
const DiacriticalTilde = "˜";
const diam = "⋄";
const diamond = "⋄";
const Diamond = "⋄";
const diamondsuit = "♦";
const diams = "♦";
const die = "¨";
const DifferentialD = "ⅆ";
const digamma = "ϝ";
const disin = "⋲";
const div = "÷";
const divide$1 = "÷";
const divideontimes = "⋇";
const divonx = "⋇";
const DJcy = "Ђ";
const djcy = "ђ";
const dlcorn = "⌞";
const dlcrop = "⌍";
const dollar = "$";
const Dopf = "𝔻";
const dopf = "𝕕";
const Dot = "¨";
const dot = "˙";
const DotDot = "⃜";
const doteq = "≐";
const doteqdot = "≑";
const DotEqual = "≐";
const dotminus = "∸";
const dotplus = "∔";
const dotsquare = "⊡";
const doublebarwedge = "⌆";
const DoubleContourIntegral = "∯";
const DoubleDot = "¨";
const DoubleDownArrow = "⇓";
const DoubleLeftArrow = "⇐";
const DoubleLeftRightArrow = "⇔";
const DoubleLeftTee = "⫤";
const DoubleLongLeftArrow = "⟸";
const DoubleLongLeftRightArrow = "⟺";
const DoubleLongRightArrow = "⟹";
const DoubleRightArrow = "⇒";
const DoubleRightTee = "⊨";
const DoubleUpArrow = "⇑";
const DoubleUpDownArrow = "⇕";
const DoubleVerticalBar = "∥";
const DownArrowBar = "⤓";
const downarrow = "↓";
const DownArrow = "↓";
const Downarrow = "⇓";
const DownArrowUpArrow = "⇵";
const DownBreve = "̑";
const downdownarrows = "⇊";
const downharpoonleft = "⇃";
const downharpoonright = "⇂";
const DownLeftRightVector = "⥐";
const DownLeftTeeVector = "⥞";
const DownLeftVectorBar = "⥖";
const DownLeftVector = "↽";
const DownRightTeeVector = "⥟";
const DownRightVectorBar = "⥗";
const DownRightVector = "⇁";
const DownTeeArrow = "↧";
const DownTee = "⊤";
const drbkarow = "⤐";
const drcorn = "⌟";
const drcrop = "⌌";
const Dscr = "𝒟";
const dscr = "𝒹";
const DScy = "Ѕ";
const dscy = "ѕ";
const dsol = "⧶";
const Dstrok = "Đ";
const dstrok = "đ";
const dtdot = "⋱";
const dtri = "▿";
const dtrif = "▾";
const duarr = "⇵";
const duhar = "⥯";
const dwangle = "⦦";
const DZcy = "Џ";
const dzcy = "џ";
const dzigrarr = "⟿";
const Eacute$1 = "É";
const eacute$1 = "é";
const easter = "⩮";
const Ecaron = "Ě";
const ecaron = "ě";
const Ecirc$1 = "Ê";
const ecirc$1 = "ê";
const ecir = "≖";
const ecolon = "≕";
const Ecy = "Э";
const ecy = "э";
const eDDot = "⩷";
const Edot = "Ė";
const edot = "ė";
const eDot = "≑";
const ee = "ⅇ";
const efDot = "≒";
const Efr = "𝔈";
const efr = "𝔢";
const eg = "⪚";
const Egrave$1 = "È";
const egrave$1 = "è";
const egs = "⪖";
const egsdot = "⪘";
const el = "⪙";
const Element = "∈";
const elinters = "⏧";
const ell = "ℓ";
const els = "⪕";
const elsdot = "⪗";
const Emacr = "Ē";
const emacr = "ē";
const empty$1 = "∅";
const emptyset = "∅";
const EmptySmallSquare = "◻";
const emptyv = "∅";
const EmptyVerySmallSquare = "▫";
const emsp13 = " ";
const emsp14 = " ";
const emsp = " ";
const ENG = "Ŋ";
const eng = "ŋ";
const ensp = " ";
const Eogon = "Ę";
const eogon = "ę";
const Eopf = "𝔼";
const eopf = "𝕖";
const epar = "⋕";
const eparsl = "⧣";
const eplus = "⩱";
const epsi = "ε";
const Epsilon = "Ε";
const epsilon$2 = "ε";
const epsiv = "ϵ";
const eqcirc = "≖";
const eqcolon = "≕";
const eqsim = "≂";
const eqslantgtr = "⪖";
const eqslantless = "⪕";
const Equal = "⩵";
const equals = "=";
const EqualTilde = "≂";
const equest = "≟";
const Equilibrium = "⇌";
const equiv = "≡";
const equivDD = "⩸";
const eqvparsl = "⧥";
const erarr = "⥱";
const erDot = "≓";
const escr = "ℯ";
const Escr = "ℰ";
const esdot = "≐";
const Esim = "⩳";
const esim = "≂";
const Eta = "Η";
const eta = "η";
const ETH$1 = "Ð";
const eth$1 = "ð";
const Euml$1 = "Ë";
const euml$1 = "ë";
const euro = "€";
const excl = "!";
const exist = "∃";
const Exists = "∃";
const expectation = "ℰ";
const exponentiale = "ⅇ";
const ExponentialE = "ⅇ";
const fallingdotseq = "≒";
const Fcy = "Ф";
const fcy = "ф";
const female = "♀";
const ffilig = "ﬃ";
const fflig = "ﬀ";
const ffllig = "ﬄ";
const Ffr = "𝔉";
const ffr = "𝔣";
const filig = "ﬁ";
const FilledSmallSquare = "◼";
const FilledVerySmallSquare = "▪";
const fjlig = "fj";
const flat = "♭";
const fllig = "ﬂ";
const fltns = "▱";
const fnof = "ƒ";
const Fopf = "𝔽";
const fopf = "𝕗";
const forall = "∀";
const ForAll = "∀";
const fork = "⋔";
const forkv = "⫙";
const Fouriertrf = "ℱ";
const fpartint = "⨍";
const frac12$1 = "½";
const frac13 = "⅓";
const frac14$1 = "¼";
const frac15 = "⅕";
const frac16 = "⅙";
const frac18 = "⅛";
const frac23 = "⅔";
const frac25 = "⅖";
const frac34$1 = "¾";
const frac35 = "⅗";
const frac38 = "⅜";
const frac45 = "⅘";
const frac56 = "⅚";
const frac58 = "⅝";
const frac78 = "⅞";
const frasl = "⁄";
const frown = "⌢";
const fscr = "𝒻";
const Fscr = "ℱ";
const gacute = "ǵ";
const Gamma = "Γ";
const gamma = "γ";
const Gammad = "Ϝ";
const gammad = "ϝ";
const gap = "⪆";
const Gbreve = "Ğ";
const gbreve = "ğ";
const Gcedil = "Ģ";
const Gcirc = "Ĝ";
const gcirc = "ĝ";
const Gcy = "Г";
const gcy = "г";
const Gdot = "Ġ";
const gdot = "ġ";
const ge = "≥";
const gE = "≧";
const gEl = "⪌";
const gel = "⋛";
const geq = "≥";
const geqq = "≧";
const geqslant = "⩾";
const gescc = "⪩";
const ges = "⩾";
const gesdot = "⪀";
const gesdoto = "⪂";
const gesdotol = "⪄";
const gesl = "⋛︀";
const gesles = "⪔";
const Gfr = "𝔊";
const gfr = "𝔤";
const gg = "≫";
const Gg = "⋙";
const ggg = "⋙";
const gimel = "ℷ";
const GJcy = "Ѓ";
const gjcy = "ѓ";
const gla = "⪥";
const gl = "≷";
const glE = "⪒";
const glj = "⪤";
const gnap = "⪊";
const gnapprox = "⪊";
const gne = "⪈";
const gnE = "≩";
const gneq = "⪈";
const gneqq = "≩";
const gnsim = "⋧";
const Gopf = "𝔾";
const gopf = "𝕘";
const grave = "`";
const GreaterEqual = "≥";
const GreaterEqualLess = "⋛";
const GreaterFullEqual = "≧";
const GreaterGreater = "⪢";
const GreaterLess = "≷";
const GreaterSlantEqual = "⩾";
const GreaterTilde = "≳";
const Gscr = "𝒢";
const gscr = "ℊ";
const gsim = "≳";
const gsime = "⪎";
const gsiml = "⪐";
const gtcc = "⪧";
const gtcir = "⩺";
const gt$2 = ">";
const GT$1 = ">";
const Gt = "≫";
const gtdot = "⋗";
const gtlPar = "⦕";
const gtquest = "⩼";
const gtrapprox = "⪆";
const gtrarr = "⥸";
const gtrdot = "⋗";
const gtreqless = "⋛";
const gtreqqless = "⪌";
const gtrless = "≷";
const gtrsim = "≳";
const gvertneqq = "≩︀";
const gvnE = "≩︀";
const Hacek = "ˇ";
const hairsp = " ";
const half = "½";
const hamilt = "ℋ";
const HARDcy = "Ъ";
const hardcy = "ъ";
const harrcir = "⥈";
const harr = "↔";
const hArr = "⇔";
const harrw = "↭";
const Hat = "^";
const hbar = "ℏ";
const Hcirc = "Ĥ";
const hcirc = "ĥ";
const hearts = "♥";
const heartsuit = "♥";
const hellip = "…";
const hercon = "⊹";
const hfr = "𝔥";
const Hfr = "ℌ";
const HilbertSpace = "ℋ";
const hksearow = "⤥";
const hkswarow = "⤦";
const hoarr = "⇿";
const homtht = "∻";
const hookleftarrow = "↩";
const hookrightarrow = "↪";
const hopf = "𝕙";
const Hopf = "ℍ";
const horbar = "―";
const HorizontalLine = "─";
const hscr = "𝒽";
const Hscr = "ℋ";
const hslash = "ℏ";
const Hstrok = "Ħ";
const hstrok = "ħ";
const HumpDownHump = "≎";
const HumpEqual = "≏";
const hybull = "⁃";
const hyphen = "‐";
const Iacute$1 = "Í";
const iacute$1 = "í";
const ic = "⁣";
const Icirc$1 = "Î";
const icirc$1 = "î";
const Icy = "И";
const icy = "и";
const Idot = "İ";
const IEcy = "Е";
const iecy = "е";
const iexcl$1 = "¡";
const iff = "⇔";
const ifr = "𝔦";
const Ifr = "ℑ";
const Igrave$1 = "Ì";
const igrave$1 = "ì";
const ii = "ⅈ";
const iiiint = "⨌";
const iiint = "∭";
const iinfin = "⧜";
const iiota = "℩";
const IJlig = "Ĳ";
const ijlig = "ĳ";
const Imacr = "Ī";
const imacr = "ī";
const image = "ℑ";
const ImaginaryI = "ⅈ";
const imagline = "ℐ";
const imagpart = "ℑ";
const imath = "ı";
const Im = "ℑ";
const imof = "⊷";
const imped = "Ƶ";
const Implies = "⇒";
const incare = "℅";
const infin = "∞";
const infintie = "⧝";
const inodot = "ı";
const intcal = "⊺";
const int = "∫";
const Int = "∬";
const integers = "ℤ";
const Integral = "∫";
const intercal = "⊺";
const Intersection$1 = "⋂";
const intlarhk = "⨗";
const intprod = "⨼";
const InvisibleComma = "⁣";
const InvisibleTimes = "⁢";
const IOcy = "Ё";
const iocy = "ё";
const Iogon = "Į";
const iogon = "į";
const Iopf = "𝕀";
const iopf = "𝕚";
const Iota = "Ι";
const iota = "ι";
const iprod = "⨼";
const iquest$1 = "¿";
const iscr = "𝒾";
const Iscr = "ℐ";
const isin = "∈";
const isindot = "⋵";
const isinE = "⋹";
const isins = "⋴";
const isinsv = "⋳";
const isinv = "∈";
const it = "⁢";
const Itilde = "Ĩ";
const itilde = "ĩ";
const Iukcy = "І";
const iukcy = "і";
const Iuml$1 = "Ï";
const iuml$1 = "ï";
const Jcirc = "Ĵ";
const jcirc = "ĵ";
const Jcy = "Й";
const jcy = "й";
const Jfr = "𝔍";
const jfr = "𝔧";
const jmath = "ȷ";
const Jopf = "𝕁";
const jopf = "𝕛";
const Jscr = "𝒥";
const jscr = "𝒿";
const Jsercy = "Ј";
const jsercy = "ј";
const Jukcy = "Є";
const jukcy = "є";
const Kappa = "Κ";
const kappa = "κ";
const kappav = "ϰ";
const Kcedil = "Ķ";
const kcedil = "ķ";
const Kcy = "К";
const kcy = "к";
const Kfr = "𝔎";
const kfr = "𝔨";
const kgreen = "ĸ";
const KHcy = "Х";
const khcy = "х";
const KJcy = "Ќ";
const kjcy = "ќ";
const Kopf = "𝕂";
const kopf = "𝕜";
const Kscr = "𝒦";
const kscr = "𝓀";
const lAarr = "⇚";
const Lacute = "Ĺ";
const lacute = "ĺ";
const laemptyv = "⦴";
const lagran = "ℒ";
const Lambda = "Λ";
const lambda = "λ";
const lang = "⟨";
const Lang = "⟪";
const langd = "⦑";
const langle = "⟨";
const lap = "⪅";
const Laplacetrf = "ℒ";
const laquo$1 = "«";
const larrb = "⇤";
const larrbfs = "⤟";
const larr = "←";
const Larr = "↞";
const lArr = "⇐";
const larrfs = "⤝";
const larrhk = "↩";
const larrlp = "↫";
const larrpl = "⤹";
const larrsim = "⥳";
const larrtl = "↢";
const latail = "⤙";
const lAtail = "⤛";
const lat = "⪫";
const late = "⪭";
const lates = "⪭︀";
const lbarr = "⤌";
const lBarr = "⤎";
const lbbrk = "❲";
const lbrace = "{";
const lbrack = "[";
const lbrke = "⦋";
const lbrksld = "⦏";
const lbrkslu = "⦍";
const Lcaron = "Ľ";
const lcaron = "ľ";
const Lcedil = "Ļ";
const lcedil = "ļ";
const lceil = "⌈";
const lcub = "{";
const Lcy = "Л";
const lcy = "л";
const ldca = "⤶";
const ldquo = "“";
const ldquor = "„";
const ldrdhar = "⥧";
const ldrushar = "⥋";
const ldsh = "↲";
const le = "≤";
const lE = "≦";
const LeftAngleBracket = "⟨";
const LeftArrowBar = "⇤";
const leftarrow = "←";
const LeftArrow = "←";
const Leftarrow = "⇐";
const LeftArrowRightArrow = "⇆";
const leftarrowtail = "↢";
const LeftCeiling = "⌈";
const LeftDoubleBracket = "⟦";
const LeftDownTeeVector = "⥡";
const LeftDownVectorBar = "⥙";
const LeftDownVector = "⇃";
const LeftFloor = "⌊";
const leftharpoondown = "↽";
const leftharpoonup = "↼";
const leftleftarrows = "⇇";
const leftrightarrow = "↔";
const LeftRightArrow = "↔";
const Leftrightarrow = "⇔";
const leftrightarrows = "⇆";
const leftrightharpoons = "⇋";
const leftrightsquigarrow = "↭";
const LeftRightVector = "⥎";
const LeftTeeArrow = "↤";
const LeftTee = "⊣";
const LeftTeeVector = "⥚";
const leftthreetimes = "⋋";
const LeftTriangleBar = "⧏";
const LeftTriangle = "⊲";
const LeftTriangleEqual = "⊴";
const LeftUpDownVector = "⥑";
const LeftUpTeeVector = "⥠";
const LeftUpVectorBar = "⥘";
const LeftUpVector = "↿";
const LeftVectorBar = "⥒";
const LeftVector = "↼";
const lEg = "⪋";
const leg = "⋚";
const leq = "≤";
const leqq = "≦";
const leqslant = "⩽";
const lescc = "⪨";
const les = "⩽";
const lesdot = "⩿";
const lesdoto = "⪁";
const lesdotor = "⪃";
const lesg = "⋚︀";
const lesges = "⪓";
const lessapprox = "⪅";
const lessdot = "⋖";
const lesseqgtr = "⋚";
const lesseqqgtr = "⪋";
const LessEqualGreater = "⋚";
const LessFullEqual = "≦";
const LessGreater = "≶";
const lessgtr = "≶";
const LessLess = "⪡";
const lesssim = "≲";
const LessSlantEqual = "⩽";
const LessTilde = "≲";
const lfisht = "⥼";
const lfloor = "⌊";
const Lfr = "𝔏";
const lfr = "𝔩";
const lg = "≶";
const lgE = "⪑";
const lHar = "⥢";
const lhard = "↽";
const lharu = "↼";
const lharul = "⥪";
const lhblk = "▄";
const LJcy = "Љ";
const ljcy = "љ";
const llarr = "⇇";
const ll = "≪";
const Ll = "⋘";
const llcorner = "⌞";
const Lleftarrow = "⇚";
const llhard = "⥫";
const lltri = "◺";
const Lmidot = "Ŀ";
const lmidot = "ŀ";
const lmoustache = "⎰";
const lmoust = "⎰";
const lnap = "⪉";
const lnapprox = "⪉";
const lne = "⪇";
const lnE = "≨";
const lneq = "⪇";
const lneqq = "≨";
const lnsim = "⋦";
const loang = "⟬";
const loarr = "⇽";
const lobrk = "⟦";
const longleftarrow = "⟵";
const LongLeftArrow = "⟵";
const Longleftarrow = "⟸";
const longleftrightarrow = "⟷";
const LongLeftRightArrow = "⟷";
const Longleftrightarrow = "⟺";
const longmapsto = "⟼";
const longrightarrow = "⟶";
const LongRightArrow = "⟶";
const Longrightarrow = "⟹";
const looparrowleft = "↫";
const looparrowright = "↬";
const lopar = "⦅";
const Lopf = "𝕃";
const lopf = "𝕝";
const loplus = "⨭";
const lotimes = "⨴";
const lowast = "∗";
const lowbar = "_";
const LowerLeftArrow = "↙";
const LowerRightArrow = "↘";
const loz = "◊";
const lozenge = "◊";
const lozf = "⧫";
const lpar = "(";
const lparlt = "⦓";
const lrarr = "⇆";
const lrcorner = "⌟";
const lrhar = "⇋";
const lrhard = "⥭";
const lrm = "‎";
const lrtri = "⊿";
const lsaquo = "‹";
const lscr = "𝓁";
const Lscr = "ℒ";
const lsh = "↰";
const Lsh = "↰";
const lsim = "≲";
const lsime = "⪍";
const lsimg = "⪏";
const lsqb = "[";
const lsquo = "‘";
const lsquor = "‚";
const Lstrok = "Ł";
const lstrok = "ł";
const ltcc = "⪦";
const ltcir = "⩹";
const lt$2 = "<";
const LT$1 = "<";
const Lt = "≪";
const ltdot = "⋖";
const lthree = "⋋";
const ltimes = "⋉";
const ltlarr = "⥶";
const ltquest = "⩻";
const ltri = "◃";
const ltrie = "⊴";
const ltrif = "◂";
const ltrPar = "⦖";
const lurdshar = "⥊";
const luruhar = "⥦";
const lvertneqq = "≨︀";
const lvnE = "≨︀";
const macr$1 = "¯";
const male = "♂";
const malt = "✠";
const maltese = "✠";
const map$3 = "↦";
const mapsto = "↦";
const mapstodown = "↧";
const mapstoleft = "↤";
const mapstoup = "↥";
const marker = "▮";
const mcomma = "⨩";
const Mcy = "М";
const mcy = "м";
const mdash = "—";
const mDDot = "∺";
const measuredangle = "∡";
const MediumSpace = " ";
const Mellintrf = "ℳ";
const Mfr = "𝔐";
const mfr = "𝔪";
const mho = "℧";
const micro$1 = "µ";
const midast = "*";
const midcir = "⫰";
const mid = "∣";
const middot$1 = "·";
const minusb = "⊟";
const minus = "−";
const minusd = "∸";
const minusdu = "⨪";
const MinusPlus = "∓";
const mlcp = "⫛";
const mldr = "…";
const mnplus = "∓";
const models = "⊧";
const Mopf = "𝕄";
const mopf = "𝕞";
const mp = "∓";
const mscr = "𝓂";
const Mscr = "ℳ";
const mstpos = "∾";
const Mu = "Μ";
const mu = "μ";
const multimap = "⊸";
const mumap = "⊸";
const nabla = "∇";
const Nacute = "Ń";
const nacute = "ń";
const nang = "∠⃒";
const nap$2 = "≉";
const napE = "⩰̸";
const napid = "≋̸";
const napos = "ŉ";
const napprox = "≉";
const natural = "♮";
const naturals = "ℕ";
const natur = "♮";
const nbsp$1 = " ";
const nbump = "≎̸";
const nbumpe = "≏̸";
const ncap = "⩃";
const Ncaron = "Ň";
const ncaron = "ň";
const Ncedil = "Ņ";
const ncedil = "ņ";
const ncong = "≇";
const ncongdot = "⩭̸";
const ncup = "⩂";
const Ncy = "Н";
const ncy = "н";
const ndash = "–";
const nearhk = "⤤";
const nearr = "↗";
const neArr = "⇗";
const nearrow = "↗";
const ne = "≠";
const nedot = "≐̸";
const NegativeMediumSpace = "​";
const NegativeThickSpace = "​";
const NegativeThinSpace = "​";
const NegativeVeryThinSpace = "​";
const nequiv = "≢";
const nesear = "⤨";
const nesim = "≂̸";
const NestedGreaterGreater = "≫";
const NestedLessLess = "≪";
const NewLine = "\n";
const nexist = "∄";
const nexists = "∄";
const Nfr = "𝔑";
const nfr = "𝔫";
const ngE = "≧̸";
const nge = "≱";
const ngeq = "≱";
const ngeqq = "≧̸";
const ngeqslant = "⩾̸";
const nges = "⩾̸";
const nGg = "⋙̸";
const ngsim = "≵";
const nGt = "≫⃒";
const ngt = "≯";
const ngtr = "≯";
const nGtv = "≫̸";
const nharr = "↮";
const nhArr = "⇎";
const nhpar = "⫲";
const ni = "∋";
const nis = "⋼";
const nisd = "⋺";
const niv = "∋";
const NJcy = "Њ";
const njcy = "њ";
const nlarr = "↚";
const nlArr = "⇍";
const nldr = "‥";
const nlE = "≦̸";
const nle = "≰";
const nleftarrow = "↚";
const nLeftarrow = "⇍";
const nleftrightarrow = "↮";
const nLeftrightarrow = "⇎";
const nleq = "≰";
const nleqq = "≦̸";
const nleqslant = "⩽̸";
const nles = "⩽̸";
const nless = "≮";
const nLl = "⋘̸";
const nlsim = "≴";
const nLt = "≪⃒";
const nlt = "≮";
const nltri = "⋪";
const nltrie = "⋬";
const nLtv = "≪̸";
const nmid = "∤";
const NoBreak = "⁠";
const NonBreakingSpace = " ";
const nopf = "𝕟";
const Nopf = "ℕ";
const Not = "⫬";
const not$2 = "¬";
const NotCongruent = "≢";
const NotCupCap = "≭";
const NotDoubleVerticalBar = "∦";
const NotElement = "∉";
const NotEqual = "≠";
const NotEqualTilde = "≂̸";
const NotExists = "∄";
const NotGreater = "≯";
const NotGreaterEqual = "≱";
const NotGreaterFullEqual = "≧̸";
const NotGreaterGreater = "≫̸";
const NotGreaterLess = "≹";
const NotGreaterSlantEqual = "⩾̸";
const NotGreaterTilde = "≵";
const NotHumpDownHump = "≎̸";
const NotHumpEqual = "≏̸";
const notin = "∉";
const notindot = "⋵̸";
const notinE = "⋹̸";
const notinva = "∉";
const notinvb = "⋷";
const notinvc = "⋶";
const NotLeftTriangleBar = "⧏̸";
const NotLeftTriangle = "⋪";
const NotLeftTriangleEqual = "⋬";
const NotLess = "≮";
const NotLessEqual = "≰";
const NotLessGreater = "≸";
const NotLessLess = "≪̸";
const NotLessSlantEqual = "⩽̸";
const NotLessTilde = "≴";
const NotNestedGreaterGreater = "⪢̸";
const NotNestedLessLess = "⪡̸";
const notni = "∌";
const notniva = "∌";
const notnivb = "⋾";
const notnivc = "⋽";
const NotPrecedes = "⊀";
const NotPrecedesEqual = "⪯̸";
const NotPrecedesSlantEqual = "⋠";
const NotReverseElement = "∌";
const NotRightTriangleBar = "⧐̸";
const NotRightTriangle = "⋫";
const NotRightTriangleEqual = "⋭";
const NotSquareSubset = "⊏̸";
const NotSquareSubsetEqual = "⋢";
const NotSquareSuperset = "⊐̸";
const NotSquareSupersetEqual = "⋣";
const NotSubset = "⊂⃒";
const NotSubsetEqual = "⊈";
const NotSucceeds = "⊁";
const NotSucceedsEqual = "⪰̸";
const NotSucceedsSlantEqual = "⋡";
const NotSucceedsTilde = "≿̸";
const NotSuperset = "⊃⃒";
const NotSupersetEqual = "⊉";
const NotTilde = "≁";
const NotTildeEqual = "≄";
const NotTildeFullEqual = "≇";
const NotTildeTilde = "≉";
const NotVerticalBar = "∤";
const nparallel = "∦";
const npar = "∦";
const nparsl = "⫽⃥";
const npart = "∂̸";
const npolint = "⨔";
const npr = "⊀";
const nprcue = "⋠";
const nprec = "⊀";
const npreceq = "⪯̸";
const npre = "⪯̸";
const nrarrc = "⤳̸";
const nrarr = "↛";
const nrArr = "⇏";
const nrarrw = "↝̸";
const nrightarrow = "↛";
const nRightarrow = "⇏";
const nrtri = "⋫";
const nrtrie = "⋭";
const nsc = "⊁";
const nsccue = "⋡";
const nsce = "⪰̸";
const Nscr = "𝒩";
const nscr = "𝓃";
const nshortmid = "∤";
const nshortparallel = "∦";
const nsim = "≁";
const nsime = "≄";
const nsimeq = "≄";
const nsmid = "∤";
const nspar = "∦";
const nsqsube = "⋢";
const nsqsupe = "⋣";
const nsub = "⊄";
const nsubE = "⫅̸";
const nsube = "⊈";
const nsubset = "⊂⃒";
const nsubseteq = "⊈";
const nsubseteqq = "⫅̸";
const nsucc = "⊁";
const nsucceq = "⪰̸";
const nsup = "⊅";
const nsupE = "⫆̸";
const nsupe = "⊉";
const nsupset = "⊃⃒";
const nsupseteq = "⊉";
const nsupseteqq = "⫆̸";
const ntgl = "≹";
const Ntilde$1 = "Ñ";
const ntilde$1 = "ñ";
const ntlg = "≸";
const ntriangleleft = "⋪";
const ntrianglelefteq = "⋬";
const ntriangleright = "⋫";
const ntrianglerighteq = "⋭";
const Nu = "Ν";
const nu = "ν";
const num = "#";
const numero = "№";
const numsp = " ";
const nvap = "≍⃒";
const nvdash = "⊬";
const nvDash = "⊭";
const nVdash = "⊮";
const nVDash = "⊯";
const nvge = "≥⃒";
const nvgt = ">⃒";
const nvHarr = "⤄";
const nvinfin = "⧞";
const nvlArr = "⤂";
const nvle = "≤⃒";
const nvlt = "<⃒";
const nvltrie = "⊴⃒";
const nvrArr = "⤃";
const nvrtrie = "⊵⃒";
const nvsim = "∼⃒";
const nwarhk = "⤣";
const nwarr = "↖";
const nwArr = "⇖";
const nwarrow = "↖";
const nwnear = "⤧";
const Oacute$1 = "Ó";
const oacute$1 = "ó";
const oast = "⊛";
const Ocirc$1 = "Ô";
const ocirc$1 = "ô";
const ocir = "⊚";
const Ocy = "О";
const ocy = "о";
const odash = "⊝";
const Odblac = "Ő";
const odblac = "ő";
const odiv = "⨸";
const odot = "⊙";
const odsold = "⦼";
const OElig = "Œ";
const oelig = "œ";
const ofcir = "⦿";
const Ofr = "𝔒";
const ofr = "𝔬";
const ogon = "˛";
const Ograve$1 = "Ò";
const ograve$1 = "ò";
const ogt = "⧁";
const ohbar = "⦵";
const ohm = "Ω";
const oint = "∮";
const olarr = "↺";
const olcir = "⦾";
const olcross = "⦻";
const oline = "‾";
const olt = "⧀";
const Omacr = "Ō";
const omacr = "ō";
const Omega = "Ω";
const omega = "ω";
const Omicron = "Ο";
const omicron = "ο";
const omid = "⦶";
const ominus = "⊖";
const Oopf = "𝕆";
const oopf = "𝕠";
const opar = "⦷";
const OpenCurlyDoubleQuote = "“";
const OpenCurlyQuote = "‘";
const operp = "⦹";
const oplus = "⊕";
const orarr = "↻";
const Or = "⩔";
const or = "∨";
const ord = "⩝";
const order = "ℴ";
const orderof = "ℴ";
const ordf$1 = "ª";
const ordm$1 = "º";
const origof = "⊶";
const oror = "⩖";
const orslope = "⩗";
const orv = "⩛";
const oS = "Ⓢ";
const Oscr = "𝒪";
const oscr = "ℴ";
const Oslash$1 = "Ø";
const oslash$1 = "ø";
const osol = "⊘";
const Otilde$1 = "Õ";
const otilde$1 = "õ";
const otimesas = "⨶";
const Otimes = "⨷";
const otimes = "⊗";
const Ouml$1 = "Ö";
const ouml$1 = "ö";
const ovbar = "⌽";
const OverBar = "‾";
const OverBrace = "⏞";
const OverBracket = "⎴";
const OverParenthesis = "⏜";
const para$1 = "¶";
const parallel = "∥";
const par = "∥";
const parsim = "⫳";
const parsl = "⫽";
const part = "∂";
const PartialD = "∂";
const Pcy = "П";
const pcy = "п";
const percnt = "%";
const period = ".";
const permil = "‰";
const perp = "⊥";
const pertenk = "‱";
const Pfr = "𝔓";
const pfr = "𝔭";
const Phi = "Φ";
const phi = "φ";
const phiv = "ϕ";
const phmmat = "ℳ";
const phone = "☎";
const Pi = "Π";
const pi$1 = "π";
const pitchfork = "⋔";
const piv = "ϖ";
const planck = "ℏ";
const planckh = "ℎ";
const plankv = "ℏ";
const plusacir = "⨣";
const plusb = "⊞";
const pluscir = "⨢";
const plus = "+";
const plusdo = "∔";
const plusdu = "⨥";
const pluse = "⩲";
const PlusMinus = "±";
const plusmn$1 = "±";
const plussim = "⨦";
const plustwo = "⨧";
const pm = "±";
const Poincareplane = "ℌ";
const pointint = "⨕";
const popf = "𝕡";
const Popf = "ℙ";
const pound$1 = "£";
const prap = "⪷";
const Pr = "⪻";
const pr = "≺";
const prcue = "≼";
const precapprox = "⪷";
const prec = "≺";
const preccurlyeq = "≼";
const Precedes = "≺";
const PrecedesEqual = "⪯";
const PrecedesSlantEqual = "≼";
const PrecedesTilde = "≾";
const preceq = "⪯";
const precnapprox = "⪹";
const precneqq = "⪵";
const precnsim = "⋨";
const pre = "⪯";
const prE = "⪳";
const precsim = "≾";
const prime = "′";
const Prime = "″";
const primes = "ℙ";
const prnap = "⪹";
const prnE = "⪵";
const prnsim = "⋨";
const prod = "∏";
const Product = "∏";
const profalar = "⌮";
const profline = "⌒";
const profsurf = "⌓";
const prop = "∝";
const Proportional = "∝";
const Proportion = "∷";
const propto = "∝";
const prsim = "≾";
const prurel = "⊰";
const Pscr = "𝒫";
const pscr = "𝓅";
const Psi = "Ψ";
const psi = "ψ";
const puncsp = " ";
const Qfr = "𝔔";
const qfr = "𝔮";
const qint = "⨌";
const qopf = "𝕢";
const Qopf = "ℚ";
const qprime = "⁗";
const Qscr = "𝒬";
const qscr = "𝓆";
const quaternions = "ℍ";
const quatint = "⨖";
const quest = "?";
const questeq = "≟";
const quot$2 = '"';
const QUOT$1 = '"';
const rAarr = "⇛";
const race = "∽̱";
const Racute = "Ŕ";
const racute = "ŕ";
const radic = "√";
const raemptyv = "⦳";
const rang = "⟩";
const Rang = "⟫";
const rangd = "⦒";
const range$2 = "⦥";
const rangle = "⟩";
const raquo$1 = "»";
const rarrap = "⥵";
const rarrb = "⇥";
const rarrbfs = "⤠";
const rarrc = "⤳";
const rarr = "→";
const Rarr = "↠";
const rArr = "⇒";
const rarrfs = "⤞";
const rarrhk = "↪";
const rarrlp = "↬";
const rarrpl = "⥅";
const rarrsim = "⥴";
const Rarrtl = "⤖";
const rarrtl = "↣";
const rarrw = "↝";
const ratail = "⤚";
const rAtail = "⤜";
const ratio = "∶";
const rationals = "ℚ";
const rbarr = "⤍";
const rBarr = "⤏";
const RBarr = "⤐";
const rbbrk = "❳";
const rbrace = "}";
const rbrack = "]";
const rbrke = "⦌";
const rbrksld = "⦎";
const rbrkslu = "⦐";
const Rcaron = "Ř";
const rcaron = "ř";
const Rcedil = "Ŗ";
const rcedil = "ŗ";
const rceil = "⌉";
const rcub = "}";
const Rcy = "Р";
const rcy = "р";
const rdca = "⤷";
const rdldhar = "⥩";
const rdquo = "”";
const rdquor = "”";
const rdsh = "↳";
const real = "ℜ";
const realine = "ℛ";
const realpart = "ℜ";
const reals = "ℝ";
const Re = "ℜ";
const rect = "▭";
const reg$1 = "®";
const REG$1 = "®";
const ReverseElement = "∋";
const ReverseEquilibrium = "⇋";
const ReverseUpEquilibrium = "⥯";
const rfisht = "⥽";
const rfloor = "⌋";
const rfr = "𝔯";
const Rfr = "ℜ";
const rHar = "⥤";
const rhard = "⇁";
const rharu = "⇀";
const rharul = "⥬";
const Rho = "Ρ";
const rho = "ρ";
const rhov = "ϱ";
const RightAngleBracket = "⟩";
const RightArrowBar = "⇥";
const rightarrow = "→";
const RightArrow = "→";
const Rightarrow = "⇒";
const RightArrowLeftArrow = "⇄";
const rightarrowtail = "↣";
const RightCeiling = "⌉";
const RightDoubleBracket = "⟧";
const RightDownTeeVector = "⥝";
const RightDownVectorBar = "⥕";
const RightDownVector = "⇂";
const RightFloor = "⌋";
const rightharpoondown = "⇁";
const rightharpoonup = "⇀";
const rightleftarrows = "⇄";
const rightleftharpoons = "⇌";
const rightrightarrows = "⇉";
const rightsquigarrow = "↝";
const RightTeeArrow = "↦";
const RightTee = "⊢";
const RightTeeVector = "⥛";
const rightthreetimes = "⋌";
const RightTriangleBar = "⧐";
const RightTriangle = "⊳";
const RightTriangleEqual = "⊵";
const RightUpDownVector = "⥏";
const RightUpTeeVector = "⥜";
const RightUpVectorBar = "⥔";
const RightUpVector = "↾";
const RightVectorBar = "⥓";
const RightVector = "⇀";
const ring = "˚";
const risingdotseq = "≓";
const rlarr = "⇄";
const rlhar = "⇌";
const rlm = "‏";
const rmoustache = "⎱";
const rmoust = "⎱";
const rnmid = "⫮";
const roang = "⟭";
const roarr = "⇾";
const robrk = "⟧";
const ropar = "⦆";
const ropf = "𝕣";
const Ropf = "ℝ";
const roplus = "⨮";
const rotimes = "⨵";
const RoundImplies = "⥰";
const rpar = ")";
const rpargt = "⦔";
const rppolint = "⨒";
const rrarr = "⇉";
const Rrightarrow = "⇛";
const rsaquo = "›";
const rscr = "𝓇";
const Rscr = "ℛ";
const rsh = "↱";
const Rsh = "↱";
const rsqb = "]";
const rsquo = "’";
const rsquor = "’";
const rthree = "⋌";
const rtimes = "⋊";
const rtri = "▹";
const rtrie = "⊵";
const rtrif = "▸";
const rtriltri = "⧎";
const RuleDelayed = "⧴";
const ruluhar = "⥨";
const rx = "℞";
const Sacute = "Ś";
const sacute = "ś";
const sbquo = "‚";
const scap = "⪸";
const Scaron = "Š";
const scaron = "š";
const Sc = "⪼";
const sc = "≻";
const sccue = "≽";
const sce = "⪰";
const scE = "⪴";
const Scedil = "Ş";
const scedil = "ş";
const Scirc = "Ŝ";
const scirc = "ŝ";
const scnap = "⪺";
const scnE = "⪶";
const scnsim = "⋩";
const scpolint = "⨓";
const scsim = "≿";
const Scy = "С";
const scy = "с";
const sdotb = "⊡";
const sdot = "⋅";
const sdote = "⩦";
const searhk = "⤥";
const searr = "↘";
const seArr = "⇘";
const searrow = "↘";
const sect$1 = "§";
const semi = ";";
const seswar = "⤩";
const setminus = "∖";
const setmn = "∖";
const sext = "✶";
const Sfr = "𝔖";
const sfr = "𝔰";
const sfrown = "⌢";
const sharp = "♯";
const SHCHcy = "Щ";
const shchcy = "щ";
const SHcy = "Ш";
const shcy = "ш";
const ShortDownArrow = "↓";
const ShortLeftArrow = "←";
const shortmid = "∣";
const shortparallel = "∥";
const ShortRightArrow = "→";
const ShortUpArrow = "↑";
const shy$1 = "­";
const Sigma = "Σ";
const sigma = "σ";
const sigmaf = "ς";
const sigmav = "ς";
const sim = "∼";
const simdot = "⩪";
const sime = "≃";
const simeq = "≃";
const simg = "⪞";
const simgE = "⪠";
const siml = "⪝";
const simlE = "⪟";
const simne = "≆";
const simplus = "⨤";
const simrarr = "⥲";
const slarr = "←";
const SmallCircle = "∘";
const smallsetminus = "∖";
const smashp = "⨳";
const smeparsl = "⧤";
const smid = "∣";
const smile = "⌣";
const smt = "⪪";
const smte = "⪬";
const smtes = "⪬︀";
const SOFTcy = "Ь";
const softcy = "ь";
const solbar = "⌿";
const solb = "⧄";
const sol = "/";
const Sopf = "𝕊";
const sopf = "𝕤";
const spades = "♠";
const spadesuit = "♠";
const spar = "∥";
const sqcap = "⊓";
const sqcaps = "⊓︀";
const sqcup = "⊔";
const sqcups = "⊔︀";
const Sqrt = "√";
const sqsub = "⊏";
const sqsube = "⊑";
const sqsubset = "⊏";
const sqsubseteq = "⊑";
const sqsup = "⊐";
const sqsupe = "⊒";
const sqsupset = "⊐";
const sqsupseteq = "⊒";
const square = "□";
const Square = "□";
const SquareIntersection = "⊓";
const SquareSubset = "⊏";
const SquareSubsetEqual = "⊑";
const SquareSuperset = "⊐";
const SquareSupersetEqual = "⊒";
const SquareUnion = "⊔";
const squarf = "▪";
const squ = "□";
const squf = "▪";
const srarr = "→";
const Sscr = "𝒮";
const sscr = "𝓈";
const ssetmn = "∖";
const ssmile = "⌣";
const sstarf = "⋆";
const Star = "⋆";
const star = "☆";
const starf = "★";
const straightepsilon = "ϵ";
const straightphi = "ϕ";
const strns = "¯";
const sub = "⊂";
const Sub = "⋐";
const subdot = "⪽";
const subE = "⫅";
const sube = "⊆";
const subedot = "⫃";
const submult = "⫁";
const subnE = "⫋";
const subne = "⊊";
const subplus = "⪿";
const subrarr = "⥹";
const subset = "⊂";
const Subset = "⋐";
const subseteq = "⊆";
const subseteqq = "⫅";
const SubsetEqual = "⊆";
const subsetneq = "⊊";
const subsetneqq = "⫋";
const subsim = "⫇";
const subsub = "⫕";
const subsup = "⫓";
const succapprox = "⪸";
const succ = "≻";
const succcurlyeq = "≽";
const Succeeds = "≻";
const SucceedsEqual = "⪰";
const SucceedsSlantEqual = "≽";
const SucceedsTilde = "≿";
const succeq = "⪰";
const succnapprox = "⪺";
const succneqq = "⪶";
const succnsim = "⋩";
const succsim = "≿";
const SuchThat = "∋";
const sum = "∑";
const Sum = "∑";
const sung = "♪";
const sup1$1 = "¹";
const sup2$1 = "²";
const sup3$1 = "³";
const sup = "⊃";
const Sup = "⋑";
const supdot = "⪾";
const supdsub = "⫘";
const supE = "⫆";
const supe = "⊇";
const supedot = "⫄";
const Superset = "⊃";
const SupersetEqual = "⊇";
const suphsol = "⟉";
const suphsub = "⫗";
const suplarr = "⥻";
const supmult = "⫂";
const supnE = "⫌";
const supne = "⊋";
const supplus = "⫀";
const supset = "⊃";
const Supset = "⋑";
const supseteq = "⊇";
const supseteqq = "⫆";
const supsetneq = "⊋";
const supsetneqq = "⫌";
const supsim = "⫈";
const supsub = "⫔";
const supsup = "⫖";
const swarhk = "⤦";
const swarr = "↙";
const swArr = "⇙";
const swarrow = "↙";
const swnwar = "⤪";
const szlig$1 = "ß";
const Tab = "	";
const target = "⌖";
const Tau = "Τ";
const tau$1 = "τ";
const tbrk = "⎴";
const Tcaron = "Ť";
const tcaron = "ť";
const Tcedil = "Ţ";
const tcedil = "ţ";
const Tcy = "Т";
const tcy = "т";
const tdot = "⃛";
const telrec = "⌕";
const Tfr = "𝔗";
const tfr = "𝔱";
const there4 = "∴";
const therefore = "∴";
const Therefore = "∴";
const Theta = "Θ";
const theta = "θ";
const thetasym = "ϑ";
const thetav = "ϑ";
const thickapprox = "≈";
const thicksim = "∼";
const ThickSpace = "  ";
const ThinSpace = " ";
const thinsp = " ";
const thkap = "≈";
const thksim = "∼";
const THORN$1 = "Þ";
const thorn$1 = "þ";
const tilde = "˜";
const Tilde = "∼";
const TildeEqual = "≃";
const TildeFullEqual = "≅";
const TildeTilde = "≈";
const timesbar = "⨱";
const timesb = "⊠";
const times$1 = "×";
const timesd = "⨰";
const tint = "∭";
const toea = "⤨";
const topbot = "⌶";
const topcir = "⫱";
const top$1 = "⊤";
const Topf = "𝕋";
const topf = "𝕥";
const topfork = "⫚";
const tosa = "⤩";
const tprime = "‴";
const trade = "™";
const TRADE = "™";
const triangle = "▵";
const triangledown = "▿";
const triangleleft = "◃";
const trianglelefteq = "⊴";
const triangleq = "≜";
const triangleright = "▹";
const trianglerighteq = "⊵";
const tridot = "◬";
const trie = "≜";
const triminus = "⨺";
const TripleDot = "⃛";
const triplus = "⨹";
const trisb = "⧍";
const tritime = "⨻";
const trpezium = "⏢";
const Tscr = "𝒯";
const tscr = "𝓉";
const TScy = "Ц";
const tscy = "ц";
const TSHcy = "Ћ";
const tshcy = "ћ";
const Tstrok = "Ŧ";
const tstrok = "ŧ";
const twixt = "≬";
const twoheadleftarrow = "↞";
const twoheadrightarrow = "↠";
const Uacute$1 = "Ú";
const uacute$1 = "ú";
const uarr = "↑";
const Uarr = "↟";
const uArr = "⇑";
const Uarrocir = "⥉";
const Ubrcy = "Ў";
const ubrcy = "ў";
const Ubreve = "Ŭ";
const ubreve = "ŭ";
const Ucirc$1 = "Û";
const ucirc$1 = "û";
const Ucy = "У";
const ucy = "у";
const udarr = "⇅";
const Udblac = "Ű";
const udblac = "ű";
const udhar = "⥮";
const ufisht = "⥾";
const Ufr = "𝔘";
const ufr = "𝔲";
const Ugrave$1 = "Ù";
const ugrave$1 = "ù";
const uHar = "⥣";
const uharl = "↿";
const uharr = "↾";
const uhblk = "▀";
const ulcorn = "⌜";
const ulcorner = "⌜";
const ulcrop = "⌏";
const ultri = "◸";
const Umacr = "Ū";
const umacr = "ū";
const uml$1 = "¨";
const UnderBar = "_";
const UnderBrace = "⏟";
const UnderBracket = "⎵";
const UnderParenthesis = "⏝";
const Union = "⋃";
const UnionPlus = "⊎";
const Uogon = "Ų";
const uogon = "ų";
const Uopf = "𝕌";
const uopf = "𝕦";
const UpArrowBar = "⤒";
const uparrow = "↑";
const UpArrow = "↑";
const Uparrow = "⇑";
const UpArrowDownArrow = "⇅";
const updownarrow = "↕";
const UpDownArrow = "↕";
const Updownarrow = "⇕";
const UpEquilibrium = "⥮";
const upharpoonleft = "↿";
const upharpoonright = "↾";
const uplus = "⊎";
const UpperLeftArrow = "↖";
const UpperRightArrow = "↗";
const upsi = "υ";
const Upsi = "ϒ";
const upsih = "ϒ";
const Upsilon = "Υ";
const upsilon = "υ";
const UpTeeArrow = "↥";
const UpTee = "⊥";
const upuparrows = "⇈";
const urcorn = "⌝";
const urcorner = "⌝";
const urcrop = "⌎";
const Uring = "Ů";
const uring = "ů";
const urtri = "◹";
const Uscr = "𝒰";
const uscr = "𝓊";
const utdot = "⋰";
const Utilde = "Ũ";
const utilde = "ũ";
const utri = "▵";
const utrif = "▴";
const uuarr = "⇈";
const Uuml$1 = "Ü";
const uuml$1 = "ü";
const uwangle = "⦧";
const vangrt = "⦜";
const varepsilon = "ϵ";
const varkappa = "ϰ";
const varnothing = "∅";
const varphi = "ϕ";
const varpi = "ϖ";
const varpropto = "∝";
const varr = "↕";
const vArr = "⇕";
const varrho = "ϱ";
const varsigma = "ς";
const varsubsetneq = "⊊︀";
const varsubsetneqq = "⫋︀";
const varsupsetneq = "⊋︀";
const varsupsetneqq = "⫌︀";
const vartheta = "ϑ";
const vartriangleleft = "⊲";
const vartriangleright = "⊳";
const vBar = "⫨";
const Vbar = "⫫";
const vBarv = "⫩";
const Vcy = "В";
const vcy = "в";
const vdash = "⊢";
const vDash = "⊨";
const Vdash = "⊩";
const VDash = "⊫";
const Vdashl = "⫦";
const veebar = "⊻";
const vee = "∨";
const Vee = "⋁";
const veeeq = "≚";
const vellip = "⋮";
const verbar = "|";
const Verbar = "‖";
const vert = "|";
const Vert = "‖";
const VerticalBar = "∣";
const VerticalLine = "|";
const VerticalSeparator = "❘";
const VerticalTilde = "≀";
const VeryThinSpace = " ";
const Vfr = "𝔙";
const vfr = "𝔳";
const vltri = "⊲";
const vnsub = "⊂⃒";
const vnsup = "⊃⃒";
const Vopf = "𝕍";
const vopf = "𝕧";
const vprop = "∝";
const vrtri = "⊳";
const Vscr = "𝒱";
const vscr = "𝓋";
const vsubnE = "⫋︀";
const vsubne = "⊊︀";
const vsupnE = "⫌︀";
const vsupne = "⊋︀";
const Vvdash = "⊪";
const vzigzag = "⦚";
const Wcirc = "Ŵ";
const wcirc = "ŵ";
const wedbar = "⩟";
const wedge = "∧";
const Wedge = "⋀";
const wedgeq = "≙";
const weierp = "℘";
const Wfr = "𝔚";
const wfr = "𝔴";
const Wopf = "𝕎";
const wopf = "𝕨";
const wp = "℘";
const wr = "≀";
const wreath = "≀";
const Wscr = "𝒲";
const wscr = "𝓌";
const xcap = "⋂";
const xcirc = "◯";
const xcup = "⋃";
const xdtri = "▽";
const Xfr = "𝔛";
const xfr = "𝔵";
const xharr = "⟷";
const xhArr = "⟺";
const Xi = "Ξ";
const xi = "ξ";
const xlarr = "⟵";
const xlArr = "⟸";
const xmap = "⟼";
const xnis = "⋻";
const xodot = "⨀";
const Xopf = "𝕏";
const xopf = "𝕩";
const xoplus = "⨁";
const xotime = "⨂";
const xrarr = "⟶";
const xrArr = "⟹";
const Xscr = "𝒳";
const xscr = "𝓍";
const xsqcup = "⨆";
const xuplus = "⨄";
const xutri = "△";
const xvee = "⋁";
const xwedge = "⋀";
const Yacute$1 = "Ý";
const yacute$1 = "ý";
const YAcy = "Я";
const yacy = "я";
const Ycirc = "Ŷ";
const ycirc = "ŷ";
const Ycy = "Ы";
const ycy = "ы";
const yen$1 = "¥";
const Yfr = "𝔜";
const yfr = "𝔶";
const YIcy = "Ї";
const yicy = "ї";
const Yopf = "𝕐";
const yopf = "𝕪";
const Yscr = "𝒴";
const yscr = "𝓎";
const YUcy = "Ю";
const yucy = "ю";
const yuml$1 = "ÿ";
const Yuml = "Ÿ";
const Zacute = "Ź";
const zacute = "ź";
const Zcaron = "Ž";
const zcaron = "ž";
const Zcy = "З";
const zcy = "з";
const Zdot = "Ż";
const zdot = "ż";
const zeetrf = "ℨ";
const ZeroWidthSpace = "​";
const Zeta = "Ζ";
const zeta = "ζ";
const zfr = "𝔷";
const Zfr = "ℨ";
const ZHcy = "Ж";
const zhcy = "ж";
const zigrarr = "⇝";
const zopf = "𝕫";
const Zopf = "ℤ";
const Zscr = "𝒵";
const zscr = "𝓏";
const zwj = "‍";
const zwnj = "‌";
const require$$1$1 = {
  Aacute: Aacute$1,
  aacute: aacute$1,
  Abreve,
  abreve,
  ac,
  acd,
  acE,
  Acirc: Acirc$1,
  acirc: acirc$1,
  acute: acute$1,
  Acy,
  acy,
  AElig: AElig$1,
  aelig: aelig$1,
  af,
  Afr,
  afr,
  Agrave: Agrave$1,
  agrave: agrave$1,
  alefsym,
  aleph,
  Alpha: Alpha$1,
  alpha,
  Amacr,
  amacr,
  amalg,
  amp: amp$2,
  AMP: AMP$1,
  andand,
  And,
  and,
  andd,
  andslope,
  andv,
  ang,
  ange,
  angle: angle$1,
  angmsdaa,
  angmsdab,
  angmsdac,
  angmsdad,
  angmsdae,
  angmsdaf,
  angmsdag,
  angmsdah,
  angmsd,
  angrt,
  angrtvb,
  angrtvbd,
  angsph,
  angst,
  angzarr,
  Aogon,
  aogon,
  Aopf,
  aopf,
  apacir,
  ap,
  apE,
  ape,
  apid,
  apos: apos$1,
  ApplyFunction,
  approx,
  approxeq,
  Aring: Aring$1,
  aring: aring$1,
  Ascr,
  ascr,
  Assign,
  ast,
  asymp,
  asympeq,
  Atilde: Atilde$1,
  atilde: atilde$1,
  Auml: Auml$1,
  auml: auml$1,
  awconint,
  awint,
  backcong,
  backepsilon,
  backprime,
  backsim,
  backsimeq,
  Backslash,
  Barv,
  barvee,
  barwed,
  Barwed,
  barwedge,
  bbrk,
  bbrktbrk,
  bcong,
  Bcy,
  bcy,
  bdquo,
  becaus,
  because,
  Because,
  bemptyv,
  bepsi,
  bernou,
  Bernoullis,
  Beta,
  beta,
  beth,
  between,
  Bfr,
  bfr,
  bigcap,
  bigcirc,
  bigcup,
  bigodot,
  bigoplus,
  bigotimes,
  bigsqcup,
  bigstar,
  bigtriangledown,
  bigtriangleup,
  biguplus,
  bigvee,
  bigwedge,
  bkarow,
  blacklozenge,
  blacksquare,
  blacktriangle,
  blacktriangledown,
  blacktriangleleft,
  blacktriangleright,
  blank,
  blk12,
  blk14,
  blk34,
  block,
  bne,
  bnequiv,
  bNot,
  bnot,
  Bopf,
  bopf,
  bot,
  bottom: bottom$1,
  bowtie,
  boxbox,
  boxdl,
  boxdL,
  boxDl,
  boxDL,
  boxdr,
  boxdR,
  boxDr,
  boxDR,
  boxh,
  boxH,
  boxhd,
  boxHd,
  boxhD,
  boxHD,
  boxhu,
  boxHu,
  boxhU,
  boxHU,
  boxminus,
  boxplus,
  boxtimes,
  boxul,
  boxuL,
  boxUl,
  boxUL,
  boxur,
  boxuR,
  boxUr,
  boxUR,
  boxv,
  boxV,
  boxvh,
  boxvH,
  boxVh,
  boxVH,
  boxvl,
  boxvL,
  boxVl,
  boxVL,
  boxvr,
  boxvR,
  boxVr,
  boxVR,
  bprime,
  breve,
  Breve,
  brvbar: brvbar$1,
  bscr,
  Bscr,
  bsemi,
  bsim,
  bsime,
  bsolb,
  bsol,
  bsolhsub,
  bull,
  bullet,
  bump,
  bumpE,
  bumpe,
  Bumpeq,
  bumpeq,
  Cacute,
  cacute,
  capand,
  capbrcup,
  capcap,
  cap,
  Cap,
  capcup,
  capdot,
  CapitalDifferentialD,
  caps,
  caret,
  caron,
  Cayleys,
  ccaps,
  Ccaron,
  ccaron,
  Ccedil: Ccedil$1,
  ccedil: ccedil$1,
  Ccirc,
  ccirc,
  Cconint,
  ccups,
  ccupssm,
  Cdot,
  cdot,
  cedil: cedil$1,
  Cedilla,
  cemptyv,
  cent: cent$1,
  centerdot,
  CenterDot,
  cfr,
  Cfr,
  CHcy,
  chcy,
  check,
  checkmark,
  Chi,
  chi,
  circ,
  circeq,
  circlearrowleft,
  circlearrowright,
  circledast,
  circledcirc,
  circleddash,
  CircleDot,
  circledR,
  circledS,
  CircleMinus,
  CirclePlus,
  CircleTimes,
  cir,
  cirE,
  cire,
  cirfnint,
  cirmid,
  cirscir,
  ClockwiseContourIntegral,
  CloseCurlyDoubleQuote,
  CloseCurlyQuote,
  clubs,
  clubsuit,
  colon,
  Colon,
  Colone,
  colone,
  coloneq,
  comma,
  commat,
  comp,
  compfn,
  complement,
  complexes,
  cong,
  congdot,
  Congruent,
  conint,
  Conint,
  ContourIntegral,
  copf,
  Copf,
  coprod,
  Coproduct,
  copy: copy$1,
  COPY: COPY$1,
  copysr,
  CounterClockwiseContourIntegral,
  crarr,
  cross: cross$1,
  Cross: Cross$1,
  Cscr,
  cscr,
  csub,
  csube,
  csup,
  csupe,
  ctdot,
  cudarrl,
  cudarrr,
  cuepr,
  cuesc,
  cularr,
  cularrp,
  cupbrcap,
  cupcap,
  CupCap,
  cup,
  Cup,
  cupcup,
  cupdot,
  cupor,
  cups,
  curarr,
  curarrm,
  curlyeqprec,
  curlyeqsucc,
  curlyvee,
  curlywedge,
  curren: curren$1,
  curvearrowleft,
  curvearrowright,
  cuvee,
  cuwed,
  cwconint,
  cwint,
  cylcty,
  dagger,
  Dagger,
  daleth,
  darr,
  Darr,
  dArr,
  dash,
  Dashv,
  dashv,
  dbkarow,
  dblac,
  Dcaron,
  dcaron,
  Dcy,
  dcy,
  ddagger,
  ddarr,
  DD,
  dd,
  DDotrahd,
  ddotseq,
  deg: deg$1,
  Del,
  Delta,
  delta,
  demptyv,
  dfisht,
  Dfr,
  dfr,
  dHar,
  dharl,
  dharr,
  DiacriticalAcute,
  DiacriticalDot,
  DiacriticalDoubleAcute,
  DiacriticalGrave,
  DiacriticalTilde,
  diam,
  diamond,
  Diamond,
  diamondsuit,
  diams,
  die,
  DifferentialD,
  digamma,
  disin,
  div,
  divide: divide$1,
  divideontimes,
  divonx,
  DJcy,
  djcy,
  dlcorn,
  dlcrop,
  dollar,
  Dopf,
  dopf,
  Dot,
  dot,
  DotDot,
  doteq,
  doteqdot,
  DotEqual,
  dotminus,
  dotplus,
  dotsquare,
  doublebarwedge,
  DoubleContourIntegral,
  DoubleDot,
  DoubleDownArrow,
  DoubleLeftArrow,
  DoubleLeftRightArrow,
  DoubleLeftTee,
  DoubleLongLeftArrow,
  DoubleLongLeftRightArrow,
  DoubleLongRightArrow,
  DoubleRightArrow,
  DoubleRightTee,
  DoubleUpArrow,
  DoubleUpDownArrow,
  DoubleVerticalBar,
  DownArrowBar,
  downarrow,
  DownArrow,
  Downarrow,
  DownArrowUpArrow,
  DownBreve,
  downdownarrows,
  downharpoonleft,
  downharpoonright,
  DownLeftRightVector,
  DownLeftTeeVector,
  DownLeftVectorBar,
  DownLeftVector,
  DownRightTeeVector,
  DownRightVectorBar,
  DownRightVector,
  DownTeeArrow,
  DownTee,
  drbkarow,
  drcorn,
  drcrop,
  Dscr,
  dscr,
  DScy,
  dscy,
  dsol,
  Dstrok,
  dstrok,
  dtdot,
  dtri,
  dtrif,
  duarr,
  duhar,
  dwangle,
  DZcy,
  dzcy,
  dzigrarr,
  Eacute: Eacute$1,
  eacute: eacute$1,
  easter,
  Ecaron,
  ecaron,
  Ecirc: Ecirc$1,
  ecirc: ecirc$1,
  ecir,
  ecolon,
  Ecy,
  ecy,
  eDDot,
  Edot,
  edot,
  eDot,
  ee,
  efDot,
  Efr,
  efr,
  eg,
  Egrave: Egrave$1,
  egrave: egrave$1,
  egs,
  egsdot,
  el,
  Element,
  elinters,
  ell,
  els,
  elsdot,
  Emacr,
  emacr,
  empty: empty$1,
  emptyset,
  EmptySmallSquare,
  emptyv,
  EmptyVerySmallSquare,
  emsp13,
  emsp14,
  emsp,
  ENG,
  eng,
  ensp,
  Eogon,
  eogon,
  Eopf,
  eopf,
  epar,
  eparsl,
  eplus,
  epsi,
  Epsilon,
  epsilon: epsilon$2,
  epsiv,
  eqcirc,
  eqcolon,
  eqsim,
  eqslantgtr,
  eqslantless,
  Equal,
  equals,
  EqualTilde,
  equest,
  Equilibrium,
  equiv,
  equivDD,
  eqvparsl,
  erarr,
  erDot,
  escr,
  Escr,
  esdot,
  Esim,
  esim,
  Eta,
  eta,
  ETH: ETH$1,
  eth: eth$1,
  Euml: Euml$1,
  euml: euml$1,
  euro,
  excl,
  exist,
  Exists,
  expectation,
  exponentiale,
  ExponentialE,
  fallingdotseq,
  Fcy,
  fcy,
  female,
  ffilig,
  fflig,
  ffllig,
  Ffr,
  ffr,
  filig,
  FilledSmallSquare,
  FilledVerySmallSquare,
  fjlig,
  flat,
  fllig,
  fltns,
  fnof,
  Fopf,
  fopf,
  forall,
  ForAll,
  fork,
  forkv,
  Fouriertrf,
  fpartint,
  frac12: frac12$1,
  frac13,
  frac14: frac14$1,
  frac15,
  frac16,
  frac18,
  frac23,
  frac25,
  frac34: frac34$1,
  frac35,
  frac38,
  frac45,
  frac56,
  frac58,
  frac78,
  frasl,
  frown,
  fscr,
  Fscr,
  gacute,
  Gamma,
  gamma,
  Gammad,
  gammad,
  gap,
  Gbreve,
  gbreve,
  Gcedil,
  Gcirc,
  gcirc,
  Gcy,
  gcy,
  Gdot,
  gdot,
  ge,
  gE,
  gEl,
  gel,
  geq,
  geqq,
  geqslant,
  gescc,
  ges,
  gesdot,
  gesdoto,
  gesdotol,
  gesl,
  gesles,
  Gfr,
  gfr,
  gg,
  Gg,
  ggg,
  gimel,
  GJcy,
  gjcy,
  gla,
  gl,
  glE,
  glj,
  gnap,
  gnapprox,
  gne,
  gnE,
  gneq,
  gneqq,
  gnsim,
  Gopf,
  gopf,
  grave,
  GreaterEqual,
  GreaterEqualLess,
  GreaterFullEqual,
  GreaterGreater,
  GreaterLess,
  GreaterSlantEqual,
  GreaterTilde,
  Gscr,
  gscr,
  gsim,
  gsime,
  gsiml,
  gtcc,
  gtcir,
  gt: gt$2,
  GT: GT$1,
  Gt,
  gtdot,
  gtlPar,
  gtquest,
  gtrapprox,
  gtrarr,
  gtrdot,
  gtreqless,
  gtreqqless,
  gtrless,
  gtrsim,
  gvertneqq,
  gvnE,
  Hacek,
  hairsp,
  half,
  hamilt,
  HARDcy,
  hardcy,
  harrcir,
  harr,
  hArr,
  harrw,
  Hat,
  hbar,
  Hcirc,
  hcirc,
  hearts,
  heartsuit,
  hellip,
  hercon,
  hfr,
  Hfr,
  HilbertSpace,
  hksearow,
  hkswarow,
  hoarr,
  homtht,
  hookleftarrow,
  hookrightarrow,
  hopf,
  Hopf,
  horbar,
  HorizontalLine,
  hscr,
  Hscr,
  hslash,
  Hstrok,
  hstrok,
  HumpDownHump,
  HumpEqual,
  hybull,
  hyphen,
  Iacute: Iacute$1,
  iacute: iacute$1,
  ic,
  Icirc: Icirc$1,
  icirc: icirc$1,
  Icy,
  icy,
  Idot,
  IEcy,
  iecy,
  iexcl: iexcl$1,
  iff,
  ifr,
  Ifr,
  Igrave: Igrave$1,
  igrave: igrave$1,
  ii,
  iiiint,
  iiint,
  iinfin,
  iiota,
  IJlig,
  ijlig,
  Imacr,
  imacr,
  image,
  ImaginaryI,
  imagline,
  imagpart,
  imath,
  Im,
  imof,
  imped,
  Implies,
  incare,
  "in": "∈",
  infin,
  infintie,
  inodot,
  intcal,
  int,
  Int,
  integers,
  Integral,
  intercal,
  Intersection: Intersection$1,
  intlarhk,
  intprod,
  InvisibleComma,
  InvisibleTimes,
  IOcy,
  iocy,
  Iogon,
  iogon,
  Iopf,
  iopf,
  Iota,
  iota,
  iprod,
  iquest: iquest$1,
  iscr,
  Iscr,
  isin,
  isindot,
  isinE,
  isins,
  isinsv,
  isinv,
  it,
  Itilde,
  itilde,
  Iukcy,
  iukcy,
  Iuml: Iuml$1,
  iuml: iuml$1,
  Jcirc,
  jcirc,
  Jcy,
  jcy,
  Jfr,
  jfr,
  jmath,
  Jopf,
  jopf,
  Jscr,
  jscr,
  Jsercy,
  jsercy,
  Jukcy,
  jukcy,
  Kappa,
  kappa,
  kappav,
  Kcedil,
  kcedil,
  Kcy,
  kcy,
  Kfr,
  kfr,
  kgreen,
  KHcy,
  khcy,
  KJcy,
  kjcy,
  Kopf,
  kopf,
  Kscr,
  kscr,
  lAarr,
  Lacute,
  lacute,
  laemptyv,
  lagran,
  Lambda,
  lambda,
  lang,
  Lang,
  langd,
  langle,
  lap,
  Laplacetrf,
  laquo: laquo$1,
  larrb,
  larrbfs,
  larr,
  Larr,
  lArr,
  larrfs,
  larrhk,
  larrlp,
  larrpl,
  larrsim,
  larrtl,
  latail,
  lAtail,
  lat,
  late,
  lates,
  lbarr,
  lBarr,
  lbbrk,
  lbrace,
  lbrack,
  lbrke,
  lbrksld,
  lbrkslu,
  Lcaron,
  lcaron,
  Lcedil,
  lcedil,
  lceil,
  lcub,
  Lcy,
  lcy,
  ldca,
  ldquo,
  ldquor,
  ldrdhar,
  ldrushar,
  ldsh,
  le,
  lE,
  LeftAngleBracket,
  LeftArrowBar,
  leftarrow,
  LeftArrow,
  Leftarrow,
  LeftArrowRightArrow,
  leftarrowtail,
  LeftCeiling,
  LeftDoubleBracket,
  LeftDownTeeVector,
  LeftDownVectorBar,
  LeftDownVector,
  LeftFloor,
  leftharpoondown,
  leftharpoonup,
  leftleftarrows,
  leftrightarrow,
  LeftRightArrow,
  Leftrightarrow,
  leftrightarrows,
  leftrightharpoons,
  leftrightsquigarrow,
  LeftRightVector,
  LeftTeeArrow,
  LeftTee,
  LeftTeeVector,
  leftthreetimes,
  LeftTriangleBar,
  LeftTriangle,
  LeftTriangleEqual,
  LeftUpDownVector,
  LeftUpTeeVector,
  LeftUpVectorBar,
  LeftUpVector,
  LeftVectorBar,
  LeftVector,
  lEg,
  leg,
  leq,
  leqq,
  leqslant,
  lescc,
  les,
  lesdot,
  lesdoto,
  lesdotor,
  lesg,
  lesges,
  lessapprox,
  lessdot,
  lesseqgtr,
  lesseqqgtr,
  LessEqualGreater,
  LessFullEqual,
  LessGreater,
  lessgtr,
  LessLess,
  lesssim,
  LessSlantEqual,
  LessTilde,
  lfisht,
  lfloor,
  Lfr,
  lfr,
  lg,
  lgE,
  lHar,
  lhard,
  lharu,
  lharul,
  lhblk,
  LJcy,
  ljcy,
  llarr,
  ll,
  Ll,
  llcorner,
  Lleftarrow,
  llhard,
  lltri,
  Lmidot,
  lmidot,
  lmoustache,
  lmoust,
  lnap,
  lnapprox,
  lne,
  lnE,
  lneq,
  lneqq,
  lnsim,
  loang,
  loarr,
  lobrk,
  longleftarrow,
  LongLeftArrow,
  Longleftarrow,
  longleftrightarrow,
  LongLeftRightArrow,
  Longleftrightarrow,
  longmapsto,
  longrightarrow,
  LongRightArrow,
  Longrightarrow,
  looparrowleft,
  looparrowright,
  lopar,
  Lopf,
  lopf,
  loplus,
  lotimes,
  lowast,
  lowbar,
  LowerLeftArrow,
  LowerRightArrow,
  loz,
  lozenge,
  lozf,
  lpar,
  lparlt,
  lrarr,
  lrcorner,
  lrhar,
  lrhard,
  lrm,
  lrtri,
  lsaquo,
  lscr,
  Lscr,
  lsh,
  Lsh,
  lsim,
  lsime,
  lsimg,
  lsqb,
  lsquo,
  lsquor,
  Lstrok,
  lstrok,
  ltcc,
  ltcir,
  lt: lt$2,
  LT: LT$1,
  Lt,
  ltdot,
  lthree,
  ltimes,
  ltlarr,
  ltquest,
  ltri,
  ltrie,
  ltrif,
  ltrPar,
  lurdshar,
  luruhar,
  lvertneqq,
  lvnE,
  macr: macr$1,
  male,
  malt,
  maltese,
  "Map": "⤅",
  map: map$3,
  mapsto,
  mapstodown,
  mapstoleft,
  mapstoup,
  marker,
  mcomma,
  Mcy,
  mcy,
  mdash,
  mDDot,
  measuredangle,
  MediumSpace,
  Mellintrf,
  Mfr,
  mfr,
  mho,
  micro: micro$1,
  midast,
  midcir,
  mid,
  middot: middot$1,
  minusb,
  minus,
  minusd,
  minusdu,
  MinusPlus,
  mlcp,
  mldr,
  mnplus,
  models,
  Mopf,
  mopf,
  mp,
  mscr,
  Mscr,
  mstpos,
  Mu,
  mu,
  multimap,
  mumap,
  nabla,
  Nacute,
  nacute,
  nang,
  nap: nap$2,
  napE,
  napid,
  napos,
  napprox,
  natural,
  naturals,
  natur,
  nbsp: nbsp$1,
  nbump,
  nbumpe,
  ncap,
  Ncaron,
  ncaron,
  Ncedil,
  ncedil,
  ncong,
  ncongdot,
  ncup,
  Ncy,
  ncy,
  ndash,
  nearhk,
  nearr,
  neArr,
  nearrow,
  ne,
  nedot,
  NegativeMediumSpace,
  NegativeThickSpace,
  NegativeThinSpace,
  NegativeVeryThinSpace,
  nequiv,
  nesear,
  nesim,
  NestedGreaterGreater,
  NestedLessLess,
  NewLine,
  nexist,
  nexists,
  Nfr,
  nfr,
  ngE,
  nge,
  ngeq,
  ngeqq,
  ngeqslant,
  nges,
  nGg,
  ngsim,
  nGt,
  ngt,
  ngtr,
  nGtv,
  nharr,
  nhArr,
  nhpar,
  ni,
  nis,
  nisd,
  niv,
  NJcy,
  njcy,
  nlarr,
  nlArr,
  nldr,
  nlE,
  nle,
  nleftarrow,
  nLeftarrow,
  nleftrightarrow,
  nLeftrightarrow,
  nleq,
  nleqq,
  nleqslant,
  nles,
  nless,
  nLl,
  nlsim,
  nLt,
  nlt,
  nltri,
  nltrie,
  nLtv,
  nmid,
  NoBreak,
  NonBreakingSpace,
  nopf,
  Nopf,
  Not,
  not: not$2,
  NotCongruent,
  NotCupCap,
  NotDoubleVerticalBar,
  NotElement,
  NotEqual,
  NotEqualTilde,
  NotExists,
  NotGreater,
  NotGreaterEqual,
  NotGreaterFullEqual,
  NotGreaterGreater,
  NotGreaterLess,
  NotGreaterSlantEqual,
  NotGreaterTilde,
  NotHumpDownHump,
  NotHumpEqual,
  notin,
  notindot,
  notinE,
  notinva,
  notinvb,
  notinvc,
  NotLeftTriangleBar,
  NotLeftTriangle,
  NotLeftTriangleEqual,
  NotLess,
  NotLessEqual,
  NotLessGreater,
  NotLessLess,
  NotLessSlantEqual,
  NotLessTilde,
  NotNestedGreaterGreater,
  NotNestedLessLess,
  notni,
  notniva,
  notnivb,
  notnivc,
  NotPrecedes,
  NotPrecedesEqual,
  NotPrecedesSlantEqual,
  NotReverseElement,
  NotRightTriangleBar,
  NotRightTriangle,
  NotRightTriangleEqual,
  NotSquareSubset,
  NotSquareSubsetEqual,
  NotSquareSuperset,
  NotSquareSupersetEqual,
  NotSubset,
  NotSubsetEqual,
  NotSucceeds,
  NotSucceedsEqual,
  NotSucceedsSlantEqual,
  NotSucceedsTilde,
  NotSuperset,
  NotSupersetEqual,
  NotTilde,
  NotTildeEqual,
  NotTildeFullEqual,
  NotTildeTilde,
  NotVerticalBar,
  nparallel,
  npar,
  nparsl,
  npart,
  npolint,
  npr,
  nprcue,
  nprec,
  npreceq,
  npre,
  nrarrc,
  nrarr,
  nrArr,
  nrarrw,
  nrightarrow,
  nRightarrow,
  nrtri,
  nrtrie,
  nsc,
  nsccue,
  nsce,
  Nscr,
  nscr,
  nshortmid,
  nshortparallel,
  nsim,
  nsime,
  nsimeq,
  nsmid,
  nspar,
  nsqsube,
  nsqsupe,
  nsub,
  nsubE,
  nsube,
  nsubset,
  nsubseteq,
  nsubseteqq,
  nsucc,
  nsucceq,
  nsup,
  nsupE,
  nsupe,
  nsupset,
  nsupseteq,
  nsupseteqq,
  ntgl,
  Ntilde: Ntilde$1,
  ntilde: ntilde$1,
  ntlg,
  ntriangleleft,
  ntrianglelefteq,
  ntriangleright,
  ntrianglerighteq,
  Nu,
  nu,
  num,
  numero,
  numsp,
  nvap,
  nvdash,
  nvDash,
  nVdash,
  nVDash,
  nvge,
  nvgt,
  nvHarr,
  nvinfin,
  nvlArr,
  nvle,
  nvlt,
  nvltrie,
  nvrArr,
  nvrtrie,
  nvsim,
  nwarhk,
  nwarr,
  nwArr,
  nwarrow,
  nwnear,
  Oacute: Oacute$1,
  oacute: oacute$1,
  oast,
  Ocirc: Ocirc$1,
  ocirc: ocirc$1,
  ocir,
  Ocy,
  ocy,
  odash,
  Odblac,
  odblac,
  odiv,
  odot,
  odsold,
  OElig,
  oelig,
  ofcir,
  Ofr,
  ofr,
  ogon,
  Ograve: Ograve$1,
  ograve: ograve$1,
  ogt,
  ohbar,
  ohm,
  oint,
  olarr,
  olcir,
  olcross,
  oline,
  olt,
  Omacr,
  omacr,
  Omega,
  omega,
  Omicron,
  omicron,
  omid,
  ominus,
  Oopf,
  oopf,
  opar,
  OpenCurlyDoubleQuote,
  OpenCurlyQuote,
  operp,
  oplus,
  orarr,
  Or,
  or,
  ord,
  order,
  orderof,
  ordf: ordf$1,
  ordm: ordm$1,
  origof,
  oror,
  orslope,
  orv,
  oS,
  Oscr,
  oscr,
  Oslash: Oslash$1,
  oslash: oslash$1,
  osol,
  Otilde: Otilde$1,
  otilde: otilde$1,
  otimesas,
  Otimes,
  otimes,
  Ouml: Ouml$1,
  ouml: ouml$1,
  ovbar,
  OverBar,
  OverBrace,
  OverBracket,
  OverParenthesis,
  para: para$1,
  parallel,
  par,
  parsim,
  parsl,
  part,
  PartialD,
  Pcy,
  pcy,
  percnt,
  period,
  permil,
  perp,
  pertenk,
  Pfr,
  pfr,
  Phi,
  phi,
  phiv,
  phmmat,
  phone,
  Pi,
  pi: pi$1,
  pitchfork,
  piv,
  planck,
  planckh,
  plankv,
  plusacir,
  plusb,
  pluscir,
  plus,
  plusdo,
  plusdu,
  pluse,
  PlusMinus,
  plusmn: plusmn$1,
  plussim,
  plustwo,
  pm,
  Poincareplane,
  pointint,
  popf,
  Popf,
  pound: pound$1,
  prap,
  Pr,
  pr,
  prcue,
  precapprox,
  prec,
  preccurlyeq,
  Precedes,
  PrecedesEqual,
  PrecedesSlantEqual,
  PrecedesTilde,
  preceq,
  precnapprox,
  precneqq,
  precnsim,
  pre,
  prE,
  precsim,
  prime,
  Prime,
  primes,
  prnap,
  prnE,
  prnsim,
  prod,
  Product,
  profalar,
  profline,
  profsurf,
  prop,
  Proportional,
  Proportion,
  propto,
  prsim,
  prurel,
  Pscr,
  pscr,
  Psi,
  psi,
  puncsp,
  Qfr,
  qfr,
  qint,
  qopf,
  Qopf,
  qprime,
  Qscr,
  qscr,
  quaternions,
  quatint,
  quest,
  questeq,
  quot: quot$2,
  QUOT: QUOT$1,
  rAarr,
  race,
  Racute,
  racute,
  radic,
  raemptyv,
  rang,
  Rang,
  rangd,
  range: range$2,
  rangle,
  raquo: raquo$1,
  rarrap,
  rarrb,
  rarrbfs,
  rarrc,
  rarr,
  Rarr,
  rArr,
  rarrfs,
  rarrhk,
  rarrlp,
  rarrpl,
  rarrsim,
  Rarrtl,
  rarrtl,
  rarrw,
  ratail,
  rAtail,
  ratio,
  rationals,
  rbarr,
  rBarr,
  RBarr,
  rbbrk,
  rbrace,
  rbrack,
  rbrke,
  rbrksld,
  rbrkslu,
  Rcaron,
  rcaron,
  Rcedil,
  rcedil,
  rceil,
  rcub,
  Rcy,
  rcy,
  rdca,
  rdldhar,
  rdquo,
  rdquor,
  rdsh,
  real,
  realine,
  realpart,
  reals,
  Re,
  rect,
  reg: reg$1,
  REG: REG$1,
  ReverseElement,
  ReverseEquilibrium,
  ReverseUpEquilibrium,
  rfisht,
  rfloor,
  rfr,
  Rfr,
  rHar,
  rhard,
  rharu,
  rharul,
  Rho,
  rho,
  rhov,
  RightAngleBracket,
  RightArrowBar,
  rightarrow,
  RightArrow,
  Rightarrow,
  RightArrowLeftArrow,
  rightarrowtail,
  RightCeiling,
  RightDoubleBracket,
  RightDownTeeVector,
  RightDownVectorBar,
  RightDownVector,
  RightFloor,
  rightharpoondown,
  rightharpoonup,
  rightleftarrows,
  rightleftharpoons,
  rightrightarrows,
  rightsquigarrow,
  RightTeeArrow,
  RightTee,
  RightTeeVector,
  rightthreetimes,
  RightTriangleBar,
  RightTriangle,
  RightTriangleEqual,
  RightUpDownVector,
  RightUpTeeVector,
  RightUpVectorBar,
  RightUpVector,
  RightVectorBar,
  RightVector,
  ring,
  risingdotseq,
  rlarr,
  rlhar,
  rlm,
  rmoustache,
  rmoust,
  rnmid,
  roang,
  roarr,
  robrk,
  ropar,
  ropf,
  Ropf,
  roplus,
  rotimes,
  RoundImplies,
  rpar,
  rpargt,
  rppolint,
  rrarr,
  Rrightarrow,
  rsaquo,
  rscr,
  Rscr,
  rsh,
  Rsh,
  rsqb,
  rsquo,
  rsquor,
  rthree,
  rtimes,
  rtri,
  rtrie,
  rtrif,
  rtriltri,
  RuleDelayed,
  ruluhar,
  rx,
  Sacute,
  sacute,
  sbquo,
  scap,
  Scaron,
  scaron,
  Sc,
  sc,
  sccue,
  sce,
  scE,
  Scedil,
  scedil,
  Scirc,
  scirc,
  scnap,
  scnE,
  scnsim,
  scpolint,
  scsim,
  Scy,
  scy,
  sdotb,
  sdot,
  sdote,
  searhk,
  searr,
  seArr,
  searrow,
  sect: sect$1,
  semi,
  seswar,
  setminus,
  setmn,
  sext,
  Sfr,
  sfr,
  sfrown,
  sharp,
  SHCHcy,
  shchcy,
  SHcy,
  shcy,
  ShortDownArrow,
  ShortLeftArrow,
  shortmid,
  shortparallel,
  ShortRightArrow,
  ShortUpArrow,
  shy: shy$1,
  Sigma,
  sigma,
  sigmaf,
  sigmav,
  sim,
  simdot,
  sime,
  simeq,
  simg,
  simgE,
  siml,
  simlE,
  simne,
  simplus,
  simrarr,
  slarr,
  SmallCircle,
  smallsetminus,
  smashp,
  smeparsl,
  smid,
  smile,
  smt,
  smte,
  smtes,
  SOFTcy,
  softcy,
  solbar,
  solb,
  sol,
  Sopf,
  sopf,
  spades,
  spadesuit,
  spar,
  sqcap,
  sqcaps,
  sqcup,
  sqcups,
  Sqrt,
  sqsub,
  sqsube,
  sqsubset,
  sqsubseteq,
  sqsup,
  sqsupe,
  sqsupset,
  sqsupseteq,
  square,
  Square,
  SquareIntersection,
  SquareSubset,
  SquareSubsetEqual,
  SquareSuperset,
  SquareSupersetEqual,
  SquareUnion,
  squarf,
  squ,
  squf,
  srarr,
  Sscr,
  sscr,
  ssetmn,
  ssmile,
  sstarf,
  Star,
  star,
  starf,
  straightepsilon,
  straightphi,
  strns,
  sub,
  Sub,
  subdot,
  subE,
  sube,
  subedot,
  submult,
  subnE,
  subne,
  subplus,
  subrarr,
  subset,
  Subset,
  subseteq,
  subseteqq,
  SubsetEqual,
  subsetneq,
  subsetneqq,
  subsim,
  subsub,
  subsup,
  succapprox,
  succ,
  succcurlyeq,
  Succeeds,
  SucceedsEqual,
  SucceedsSlantEqual,
  SucceedsTilde,
  succeq,
  succnapprox,
  succneqq,
  succnsim,
  succsim,
  SuchThat,
  sum,
  Sum,
  sung,
  sup1: sup1$1,
  sup2: sup2$1,
  sup3: sup3$1,
  sup,
  Sup,
  supdot,
  supdsub,
  supE,
  supe,
  supedot,
  Superset,
  SupersetEqual,
  suphsol,
  suphsub,
  suplarr,
  supmult,
  supnE,
  supne,
  supplus,
  supset,
  Supset,
  supseteq,
  supseteqq,
  supsetneq,
  supsetneqq,
  supsim,
  supsub,
  supsup,
  swarhk,
  swarr,
  swArr,
  swarrow,
  swnwar,
  szlig: szlig$1,
  Tab,
  target,
  Tau,
  tau: tau$1,
  tbrk,
  Tcaron,
  tcaron,
  Tcedil,
  tcedil,
  Tcy,
  tcy,
  tdot,
  telrec,
  Tfr,
  tfr,
  there4,
  therefore,
  Therefore,
  Theta,
  theta,
  thetasym,
  thetav,
  thickapprox,
  thicksim,
  ThickSpace,
  ThinSpace,
  thinsp,
  thkap,
  thksim,
  THORN: THORN$1,
  thorn: thorn$1,
  tilde,
  Tilde,
  TildeEqual,
  TildeFullEqual,
  TildeTilde,
  timesbar,
  timesb,
  times: times$1,
  timesd,
  tint,
  toea,
  topbot,
  topcir,
  top: top$1,
  Topf,
  topf,
  topfork,
  tosa,
  tprime,
  trade,
  TRADE,
  triangle,
  triangledown,
  triangleleft,
  trianglelefteq,
  triangleq,
  triangleright,
  trianglerighteq,
  tridot,
  trie,
  triminus,
  TripleDot,
  triplus,
  trisb,
  tritime,
  trpezium,
  Tscr,
  tscr,
  TScy,
  tscy,
  TSHcy,
  tshcy,
  Tstrok,
  tstrok,
  twixt,
  twoheadleftarrow,
  twoheadrightarrow,
  Uacute: Uacute$1,
  uacute: uacute$1,
  uarr,
  Uarr,
  uArr,
  Uarrocir,
  Ubrcy,
  ubrcy,
  Ubreve,
  ubreve,
  Ucirc: Ucirc$1,
  ucirc: ucirc$1,
  Ucy,
  ucy,
  udarr,
  Udblac,
  udblac,
  udhar,
  ufisht,
  Ufr,
  ufr,
  Ugrave: Ugrave$1,
  ugrave: ugrave$1,
  uHar,
  uharl,
  uharr,
  uhblk,
  ulcorn,
  ulcorner,
  ulcrop,
  ultri,
  Umacr,
  umacr,
  uml: uml$1,
  UnderBar,
  UnderBrace,
  UnderBracket,
  UnderParenthesis,
  Union,
  UnionPlus,
  Uogon,
  uogon,
  Uopf,
  uopf,
  UpArrowBar,
  uparrow,
  UpArrow,
  Uparrow,
  UpArrowDownArrow,
  updownarrow,
  UpDownArrow,
  Updownarrow,
  UpEquilibrium,
  upharpoonleft,
  upharpoonright,
  uplus,
  UpperLeftArrow,
  UpperRightArrow,
  upsi,
  Upsi,
  upsih,
  Upsilon,
  upsilon,
  UpTeeArrow,
  UpTee,
  upuparrows,
  urcorn,
  urcorner,
  urcrop,
  Uring,
  uring,
  urtri,
  Uscr,
  uscr,
  utdot,
  Utilde,
  utilde,
  utri,
  utrif,
  uuarr,
  Uuml: Uuml$1,
  uuml: uuml$1,
  uwangle,
  vangrt,
  varepsilon,
  varkappa,
  varnothing,
  varphi,
  varpi,
  varpropto,
  varr,
  vArr,
  varrho,
  varsigma,
  varsubsetneq,
  varsubsetneqq,
  varsupsetneq,
  varsupsetneqq,
  vartheta,
  vartriangleleft,
  vartriangleright,
  vBar,
  Vbar,
  vBarv,
  Vcy,
  vcy,
  vdash,
  vDash,
  Vdash,
  VDash,
  Vdashl,
  veebar,
  vee,
  Vee,
  veeeq,
  vellip,
  verbar,
  Verbar,
  vert,
  Vert,
  VerticalBar,
  VerticalLine,
  VerticalSeparator,
  VerticalTilde,
  VeryThinSpace,
  Vfr,
  vfr,
  vltri,
  vnsub,
  vnsup,
  Vopf,
  vopf,
  vprop,
  vrtri,
  Vscr,
  vscr,
  vsubnE,
  vsubne,
  vsupnE,
  vsupne,
  Vvdash,
  vzigzag,
  Wcirc,
  wcirc,
  wedbar,
  wedge,
  Wedge,
  wedgeq,
  weierp,
  Wfr,
  wfr,
  Wopf,
  wopf,
  wp,
  wr,
  wreath,
  Wscr,
  wscr,
  xcap,
  xcirc,
  xcup,
  xdtri,
  Xfr,
  xfr,
  xharr,
  xhArr,
  Xi,
  xi,
  xlarr,
  xlArr,
  xmap,
  xnis,
  xodot,
  Xopf,
  xopf,
  xoplus,
  xotime,
  xrarr,
  xrArr,
  Xscr,
  xscr,
  xsqcup,
  xuplus,
  xutri,
  xvee,
  xwedge,
  Yacute: Yacute$1,
  yacute: yacute$1,
  YAcy,
  yacy,
  Ycirc,
  ycirc,
  Ycy,
  ycy,
  yen: yen$1,
  Yfr,
  yfr,
  YIcy,
  yicy,
  Yopf,
  yopf,
  Yscr,
  yscr,
  YUcy,
  yucy,
  yuml: yuml$1,
  Yuml,
  Zacute,
  zacute,
  Zcaron,
  zcaron,
  Zcy,
  zcy,
  Zdot,
  zdot,
  zeetrf,
  ZeroWidthSpace,
  Zeta,
  zeta,
  zfr,
  Zfr,
  ZHcy,
  zhcy,
  zigrarr,
  zopf,
  Zopf,
  Zscr,
  zscr,
  zwj,
  zwnj
};
const Aacute = "Á";
const aacute = "á";
const Acirc = "Â";
const acirc = "â";
const acute = "´";
const AElig = "Æ";
const aelig = "æ";
const Agrave = "À";
const agrave = "à";
const amp$1 = "&";
const AMP = "&";
const Aring = "Å";
const aring = "å";
const Atilde = "Ã";
const atilde = "ã";
const Auml = "Ä";
const auml = "ä";
const brvbar = "¦";
const Ccedil = "Ç";
const ccedil = "ç";
const cedil = "¸";
const cent = "¢";
const copy = "©";
const COPY = "©";
const curren = "¤";
const deg = "°";
const divide = "÷";
const Eacute = "É";
const eacute = "é";
const Ecirc = "Ê";
const ecirc = "ê";
const Egrave = "È";
const egrave = "è";
const ETH = "Ð";
const eth = "ð";
const Euml = "Ë";
const euml = "ë";
const frac12 = "½";
const frac14 = "¼";
const frac34 = "¾";
const gt$1 = ">";
const GT = ">";
const Iacute = "Í";
const iacute = "í";
const Icirc = "Î";
const icirc = "î";
const iexcl = "¡";
const Igrave = "Ì";
const igrave = "ì";
const iquest = "¿";
const Iuml = "Ï";
const iuml = "ï";
const laquo = "«";
const lt$1 = "<";
const LT = "<";
const macr = "¯";
const micro = "µ";
const middot = "·";
const nbsp = " ";
const not$1 = "¬";
const Ntilde = "Ñ";
const ntilde = "ñ";
const Oacute = "Ó";
const oacute = "ó";
const Ocirc = "Ô";
const ocirc = "ô";
const Ograve = "Ò";
const ograve = "ò";
const ordf = "ª";
const ordm = "º";
const Oslash = "Ø";
const oslash = "ø";
const Otilde = "Õ";
const otilde = "õ";
const Ouml = "Ö";
const ouml = "ö";
const para = "¶";
const plusmn = "±";
const pound = "£";
const quot$1 = '"';
const QUOT = '"';
const raquo = "»";
const reg = "®";
const REG = "®";
const sect = "§";
const shy = "­";
const sup1 = "¹";
const sup2 = "²";
const sup3 = "³";
const szlig = "ß";
const THORN = "Þ";
const thorn = "þ";
const times = "×";
const Uacute = "Ú";
const uacute = "ú";
const Ucirc = "Û";
const ucirc = "û";
const Ugrave = "Ù";
const ugrave = "ù";
const uml = "¨";
const Uuml = "Ü";
const uuml = "ü";
const Yacute = "Ý";
const yacute = "ý";
const yen = "¥";
const yuml = "ÿ";
const require$$2$1 = {
  Aacute,
  aacute,
  Acirc,
  acirc,
  acute,
  AElig,
  aelig,
  Agrave,
  agrave,
  amp: amp$1,
  AMP,
  Aring,
  aring,
  Atilde,
  atilde,
  Auml,
  auml,
  brvbar,
  Ccedil,
  ccedil,
  cedil,
  cent,
  copy,
  COPY,
  curren,
  deg,
  divide,
  Eacute,
  eacute,
  Ecirc,
  ecirc,
  Egrave,
  egrave,
  ETH,
  eth,
  Euml,
  euml,
  frac12,
  frac14,
  frac34,
  gt: gt$1,
  GT,
  Iacute,
  iacute,
  Icirc,
  icirc,
  iexcl,
  Igrave,
  igrave,
  iquest,
  Iuml,
  iuml,
  laquo,
  lt: lt$1,
  LT,
  macr,
  micro,
  middot,
  nbsp,
  not: not$1,
  Ntilde,
  ntilde,
  Oacute,
  oacute,
  Ocirc,
  ocirc,
  Ograve,
  ograve,
  ordf,
  ordm,
  Oslash,
  oslash,
  Otilde,
  otilde,
  Ouml,
  ouml,
  para,
  plusmn,
  pound,
  quot: quot$1,
  QUOT,
  raquo,
  reg,
  REG,
  sect,
  shy,
  sup1,
  sup2,
  sup3,
  szlig,
  THORN,
  thorn,
  times,
  Uacute,
  uacute,
  Ucirc,
  ucirc,
  Ugrave,
  ugrave,
  uml,
  Uuml,
  uuml,
  Yacute,
  yacute,
  yen,
  yuml
};
const amp = "&";
const apos = "'";
const gt = ">";
const lt = "<";
const quot = '"';
const require$$3$1 = {
  amp,
  apos,
  gt,
  lt,
  quot
};
var decode_codepoint = {};
const require$$0$2 = {
  "0": 65533,
  "128": 8364,
  "130": 8218,
  "131": 402,
  "132": 8222,
  "133": 8230,
  "134": 8224,
  "135": 8225,
  "136": 710,
  "137": 8240,
  "138": 352,
  "139": 8249,
  "140": 338,
  "142": 381,
  "145": 8216,
  "146": 8217,
  "147": 8220,
  "148": 8221,
  "149": 8226,
  "150": 8211,
  "151": 8212,
  "152": 732,
  "153": 8482,
  "154": 353,
  "155": 8250,
  "156": 339,
  "158": 382,
  "159": 376
};
var hasRequiredDecode_codepoint;
function requireDecode_codepoint() {
  if (hasRequiredDecode_codepoint) return decode_codepoint;
  hasRequiredDecode_codepoint = 1;
  var __importDefault2 = decode_codepoint && decode_codepoint.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(decode_codepoint, "__esModule", {
    value: true
  });
  var decode_json_1 = __importDefault2(require$$0$2);
  var fromCodePoint = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(codePoint) {
      var output = "";
      if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      output += String.fromCharCode(codePoint);
      return output;
    }
  );
  function decodeCodePoint(codePoint) {
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
      return "�";
    }
    if (codePoint in decode_json_1.default) {
      codePoint = decode_json_1.default[codePoint];
    }
    return fromCodePoint(codePoint);
  }
  decode_codepoint.default = decodeCodePoint;
  return decode_codepoint;
}
var hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode) return decode;
  hasRequiredDecode = 1;
  var __importDefault2 = decode && decode.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(decode, "__esModule", {
    value: true
  });
  decode.decodeHTML = decode.decodeHTMLStrict = decode.decodeXML = void 0;
  var entities_json_1 = __importDefault2(require$$1$1);
  var legacy_json_1 = __importDefault2(require$$2$1);
  var xml_json_1 = __importDefault2(require$$3$1);
  var decode_codepoint_1 = __importDefault2(/* @__PURE__ */ requireDecode_codepoint());
  var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  decode.decodeXML = getStrictDecoder(xml_json_1.default);
  decode.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
  function getStrictDecoder(map2) {
    var replace = getReplacer(map2);
    return function(str) {
      return String(str).replace(strictEntityRe, replace);
    };
  }
  var sorter = function(a, b) {
    return a < b ? 1 : -1;
  };
  decode.decodeHTML = (function() {
    var legacy2 = Object.keys(legacy_json_1.default).sort(sorter);
    var keys2 = Object.keys(entities_json_1.default).sort(sorter);
    for (var i = 0, j = 0; i < keys2.length; i++) {
      if (legacy2[j] === keys2[i]) {
        keys2[i] += ";?";
        j++;
      } else {
        keys2[i] += ";";
      }
    }
    var re2 = new RegExp("&(?:" + keys2.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1.default);
    function replacer(str) {
      if (str.substr(-1) !== ";") str += ";";
      return replace(str);
    }
    return function(str) {
      return String(str).replace(re2, replacer);
    };
  })();
  function getReplacer(map2) {
    return function replace(str) {
      if (str.charAt(1) === "#") {
        var secondChar = str.charAt(2);
        if (secondChar === "X" || secondChar === "x") {
          return decode_codepoint_1.default(parseInt(str.substr(3), 16));
        }
        return decode_codepoint_1.default(parseInt(str.substr(2), 10));
      }
      return map2[str.slice(1, -1)] || str;
    };
  }
  return decode;
}
var encode = {};
var hasRequiredEncode;
function requireEncode() {
  if (hasRequiredEncode) return encode;
  hasRequiredEncode = 1;
  var __importDefault2 = encode && encode.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(encode, "__esModule", {
    value: true
  });
  encode.escapeUTF8 = encode.escape = encode.encodeNonAsciiHTML = encode.encodeHTML = encode.encodeXML = void 0;
  var xml_json_1 = __importDefault2(require$$3$1);
  var inverseXML = getInverseObj(xml_json_1.default);
  var xmlReplacer = getInverseReplacer(inverseXML);
  encode.encodeXML = getASCIIEncoder(inverseXML);
  var entities_json_1 = __importDefault2(require$$1$1);
  var inverseHTML = getInverseObj(entities_json_1.default);
  var htmlReplacer = getInverseReplacer(inverseHTML);
  encode.encodeHTML = getInverse(inverseHTML, htmlReplacer);
  encode.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
  function getInverseObj(obj) {
    return Object.keys(obj).sort().reduce(function(inverse, name) {
      inverse[obj[name]] = "&" + name + ";";
      return inverse;
    }, {});
  }
  function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
      var k = _a[_i];
      if (k.length === 1) {
        single.push("\\" + k);
      } else {
        multiple.push(k);
      }
    }
    single.sort();
    for (var start2 = 0; start2 < single.length - 1; start2++) {
      var end2 = start2;
      while (end2 < single.length - 1 && single[end2].charCodeAt(1) + 1 === single[end2 + 1].charCodeAt(1)) {
        end2 += 1;
      }
      var count2 = 1 + end2 - start2;
      if (count2 < 3) continue;
      single.splice(start2, count2, single[start2] + "-" + single[end2]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
  }
  var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
  var getCodePoint = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      function(str) {
        return str.codePointAt(0);
      }
    ) : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(c) {
        return (c.charCodeAt(0) - 55296) * 1024 + c.charCodeAt(1) - 56320 + 65536;
      }
    )
  );
  function singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  function getInverse(inverse, re2) {
    return function(data2) {
      return data2.replace(re2, function(name) {
        return inverse[name];
      }).replace(reNonASCII, singleCharReplacer);
    };
  }
  var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
  function escape(data2) {
    return data2.replace(reEscapeChars, singleCharReplacer);
  }
  encode.escape = escape;
  function escapeUTF8(data2) {
    return data2.replace(xmlReplacer, singleCharReplacer);
  }
  encode.escapeUTF8 = escapeUTF8;
  function getASCIIEncoder(obj) {
    return function(data2) {
      return data2.replace(reEscapeChars, function(c) {
        return obj[c] || singleCharReplacer(c);
      });
    };
  }
  return encode;
}
var hasRequiredLib$b;
function requireLib$b() {
  if (hasRequiredLib$b) return lib$6;
  hasRequiredLib$b = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.decodeXMLStrict = exports2.decodeHTML5Strict = exports2.decodeHTML4Strict = exports2.decodeHTML5 = exports2.decodeHTML4 = exports2.decodeHTMLStrict = exports2.decodeHTML = exports2.decodeXML = exports2.encodeHTML5 = exports2.encodeHTML4 = exports2.escapeUTF8 = exports2.escape = exports2.encodeNonAsciiHTML = exports2.encodeHTML = exports2.encodeXML = exports2.encode = exports2.decodeStrict = exports2.decode = void 0;
    var decode_1 = /* @__PURE__ */ requireDecode();
    var encode_1 = /* @__PURE__ */ requireEncode();
    function decode2(data2, level) {
      return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data2);
    }
    exports2.decode = decode2;
    function decodeStrict(data2, level) {
      return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data2);
    }
    exports2.decodeStrict = decodeStrict;
    function encode2(data2, level) {
      return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data2);
    }
    exports2.encode = encode2;
    var encode_2 = /* @__PURE__ */ requireEncode();
    Object.defineProperty(exports2, "encodeXML", {
      enumerable: true,
      get: function() {
        return encode_2.encodeXML;
      }
    });
    Object.defineProperty(exports2, "encodeHTML", {
      enumerable: true,
      get: function() {
        return encode_2.encodeHTML;
      }
    });
    Object.defineProperty(exports2, "encodeNonAsciiHTML", {
      enumerable: true,
      get: function() {
        return encode_2.encodeNonAsciiHTML;
      }
    });
    Object.defineProperty(exports2, "escape", {
      enumerable: true,
      get: function() {
        return encode_2.escape;
      }
    });
    Object.defineProperty(exports2, "escapeUTF8", {
      enumerable: true,
      get: function() {
        return encode_2.escapeUTF8;
      }
    });
    Object.defineProperty(exports2, "encodeHTML4", {
      enumerable: true,
      get: function() {
        return encode_2.encodeHTML;
      }
    });
    Object.defineProperty(exports2, "encodeHTML5", {
      enumerable: true,
      get: function() {
        return encode_2.encodeHTML;
      }
    });
    var decode_2 = /* @__PURE__ */ requireDecode();
    Object.defineProperty(exports2, "decodeXML", {
      enumerable: true,
      get: function() {
        return decode_2.decodeXML;
      }
    });
    Object.defineProperty(exports2, "decodeHTML", {
      enumerable: true,
      get: function() {
        return decode_2.decodeHTML;
      }
    });
    Object.defineProperty(exports2, "decodeHTMLStrict", {
      enumerable: true,
      get: function() {
        return decode_2.decodeHTMLStrict;
      }
    });
    Object.defineProperty(exports2, "decodeHTML4", {
      enumerable: true,
      get: function() {
        return decode_2.decodeHTML;
      }
    });
    Object.defineProperty(exports2, "decodeHTML5", {
      enumerable: true,
      get: function() {
        return decode_2.decodeHTML;
      }
    });
    Object.defineProperty(exports2, "decodeHTML4Strict", {
      enumerable: true,
      get: function() {
        return decode_2.decodeHTMLStrict;
      }
    });
    Object.defineProperty(exports2, "decodeHTML5Strict", {
      enumerable: true,
      get: function() {
        return decode_2.decodeHTMLStrict;
      }
    });
    Object.defineProperty(exports2, "decodeXMLStrict", {
      enumerable: true,
      get: function() {
        return decode_2.decodeXML;
      }
    });
  })(lib$6);
  return lib$6;
}
var foreignNames = {};
var hasRequiredForeignNames;
function requireForeignNames() {
  if (hasRequiredForeignNames) return foreignNames;
  hasRequiredForeignNames = 1;
  Object.defineProperty(foreignNames, "__esModule", {
    value: true
  });
  foreignNames.attributeNames = foreignNames.elementNames = void 0;
  foreignNames.elementNames = /* @__PURE__ */ new Map([["altglyph", "altGlyph"], ["altglyphdef", "altGlyphDef"], ["altglyphitem", "altGlyphItem"], ["animatecolor", "animateColor"], ["animatemotion", "animateMotion"], ["animatetransform", "animateTransform"], ["clippath", "clipPath"], ["feblend", "feBlend"], ["fecolormatrix", "feColorMatrix"], ["fecomponenttransfer", "feComponentTransfer"], ["fecomposite", "feComposite"], ["feconvolvematrix", "feConvolveMatrix"], ["fediffuselighting", "feDiffuseLighting"], ["fedisplacementmap", "feDisplacementMap"], ["fedistantlight", "feDistantLight"], ["fedropshadow", "feDropShadow"], ["feflood", "feFlood"], ["fefunca", "feFuncA"], ["fefuncb", "feFuncB"], ["fefuncg", "feFuncG"], ["fefuncr", "feFuncR"], ["fegaussianblur", "feGaussianBlur"], ["feimage", "feImage"], ["femerge", "feMerge"], ["femergenode", "feMergeNode"], ["femorphology", "feMorphology"], ["feoffset", "feOffset"], ["fepointlight", "fePointLight"], ["fespecularlighting", "feSpecularLighting"], ["fespotlight", "feSpotLight"], ["fetile", "feTile"], ["feturbulence", "feTurbulence"], ["foreignobject", "foreignObject"], ["glyphref", "glyphRef"], ["lineargradient", "linearGradient"], ["radialgradient", "radialGradient"], ["textpath", "textPath"]]);
  foreignNames.attributeNames = /* @__PURE__ */ new Map([["definitionurl", "definitionURL"], ["attributename", "attributeName"], ["attributetype", "attributeType"], ["basefrequency", "baseFrequency"], ["baseprofile", "baseProfile"], ["calcmode", "calcMode"], ["clippathunits", "clipPathUnits"], ["diffuseconstant", "diffuseConstant"], ["edgemode", "edgeMode"], ["filterunits", "filterUnits"], ["glyphref", "glyphRef"], ["gradienttransform", "gradientTransform"], ["gradientunits", "gradientUnits"], ["kernelmatrix", "kernelMatrix"], ["kernelunitlength", "kernelUnitLength"], ["keypoints", "keyPoints"], ["keysplines", "keySplines"], ["keytimes", "keyTimes"], ["lengthadjust", "lengthAdjust"], ["limitingconeangle", "limitingConeAngle"], ["markerheight", "markerHeight"], ["markerunits", "markerUnits"], ["markerwidth", "markerWidth"], ["maskcontentunits", "maskContentUnits"], ["maskunits", "maskUnits"], ["numoctaves", "numOctaves"], ["pathlength", "pathLength"], ["patterncontentunits", "patternContentUnits"], ["patterntransform", "patternTransform"], ["patternunits", "patternUnits"], ["pointsatx", "pointsAtX"], ["pointsaty", "pointsAtY"], ["pointsatz", "pointsAtZ"], ["preservealpha", "preserveAlpha"], ["preserveaspectratio", "preserveAspectRatio"], ["primitiveunits", "primitiveUnits"], ["refx", "refX"], ["refy", "refY"], ["repeatcount", "repeatCount"], ["repeatdur", "repeatDur"], ["requiredextensions", "requiredExtensions"], ["requiredfeatures", "requiredFeatures"], ["specularconstant", "specularConstant"], ["specularexponent", "specularExponent"], ["spreadmethod", "spreadMethod"], ["startoffset", "startOffset"], ["stddeviation", "stdDeviation"], ["stitchtiles", "stitchTiles"], ["surfacescale", "surfaceScale"], ["systemlanguage", "systemLanguage"], ["tablevalues", "tableValues"], ["targetx", "targetX"], ["targety", "targetY"], ["textlength", "textLength"], ["viewbox", "viewBox"], ["viewtarget", "viewTarget"], ["xchannelselector", "xChannelSelector"], ["ychannelselector", "yChannelSelector"], ["zoomandpan", "zoomAndPan"]]);
  return foreignNames;
}
var hasRequiredLib$a;
function requireLib$a() {
  if (hasRequiredLib$a) return lib$7;
  hasRequiredLib$a = 1;
  var __assign2 = lib$7 && lib$7.__assign || function() {
    __assign2 = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign2.apply(this, arguments);
  };
  var __createBinding2 = lib$7 && lib$7.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function() {
        return m[k];
      }
    });
  } : function(o, m, k, k2) {
    if (k2 === void 0) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = lib$7 && lib$7.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = lib$7 && lib$7.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule) return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k)) __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  Object.defineProperty(lib$7, "__esModule", {
    value: true
  });
  var ElementType = __importStar2(/* @__PURE__ */ requireLib$d());
  var entities_1 = /* @__PURE__ */ requireLib$b();
  var foreignNames_1 = /* @__PURE__ */ requireForeignNames();
  var unencodedElements = /* @__PURE__ */ new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
  function formatAttributes(attributes2, opts) {
    if (!attributes2) return;
    return Object.keys(attributes2).map(function(key) {
      var _a, _b;
      var value = (_a = attributes2[key]) !== null && _a !== void 0 ? _a : "";
      if (opts.xmlMode === "foreign") {
        key = (_b = foreignNames_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
      }
      if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
        return key;
      }
      return key + '="' + (opts.decodeEntities !== false ? entities_1.encodeXML(value) : value.replace(/"/g, "&quot;")) + '"';
    }).join(" ");
  }
  var singleTag = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
  function render3(node2, options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    var nodes = "length" in node2 ? node2 : [node2];
    var output = "";
    for (var i = 0; i < nodes.length; i++) {
      output += renderNode(nodes[i], options2);
    }
    return output;
  }
  lib$7.default = render3;
  function renderNode(node2, options2) {
    switch (node2.type) {
      case ElementType.Root:
        return render3(node2.children, options2);
      case ElementType.Directive:
      case ElementType.Doctype:
        return renderDirective(node2);
      case ElementType.Comment:
        return renderComment(node2);
      case ElementType.CDATA:
        return renderCdata(node2);
      case ElementType.Script:
      case ElementType.Style:
      case ElementType.Tag:
        return renderTag(node2, options2);
      case ElementType.Text:
        return renderText(node2, options2);
    }
  }
  var foreignModeIntegrationPoints = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]);
  var foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
  function renderTag(elem, opts) {
    var _a;
    if (opts.xmlMode === "foreign") {
      elem.name = (_a = foreignNames_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
      if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
        opts = __assign2(__assign2({}, opts), {
          xmlMode: false
        });
      }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
      opts = __assign2(__assign2({}, opts), {
        xmlMode: "foreign"
      });
    }
    var tag = "<" + elem.name;
    var attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
      tag += " " + attribs;
    }
    if (elem.children.length === 0 && (opts.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      opts.selfClosingTags !== false
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      opts.selfClosingTags && singleTag.has(elem.name)
    ))) {
      if (!opts.xmlMode) tag += " ";
      tag += "/>";
    } else {
      tag += ">";
      if (elem.children.length > 0) {
        tag += render3(elem.children, opts);
      }
      if (opts.xmlMode || !singleTag.has(elem.name)) {
        tag += "</" + elem.name + ">";
      }
    }
    return tag;
  }
  function renderDirective(elem) {
    return "<" + elem.data + ">";
  }
  function renderText(elem, opts) {
    var data2 = elem.data || "";
    if (opts.decodeEntities !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
      data2 = entities_1.encodeXML(data2);
    }
    return data2;
  }
  function renderCdata(elem) {
    return "<![CDATA[" + elem.children[0].data + "]]>";
  }
  function renderComment(elem) {
    return "<!--" + elem.data + "-->";
  }
  return lib$7;
}
var hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify;
  hasRequiredStringify = 1;
  var __importDefault2 = stringify && stringify.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(stringify, "__esModule", {
    value: true
  });
  stringify.innerText = stringify.textContent = stringify.getText = stringify.getInnerHTML = stringify.getOuterHTML = void 0;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  var dom_serializer_1 = __importDefault2(/* @__PURE__ */ requireLib$a());
  var domelementtype_1 = /* @__PURE__ */ requireLib$d();
  function getOuterHTML(node2, options2) {
    return (0, dom_serializer_1.default)(node2, options2);
  }
  stringify.getOuterHTML = getOuterHTML;
  function getInnerHTML(node2, options2) {
    return (0, domhandler_1.hasChildren)(node2) ? node2.children.map(function(node3) {
      return getOuterHTML(node3, options2);
    }).join("") : "";
  }
  stringify.getInnerHTML = getInnerHTML;
  function getText(node2) {
    if (Array.isArray(node2)) return node2.map(getText).join("");
    if ((0, domhandler_1.isTag)(node2)) return node2.name === "br" ? "\n" : getText(node2.children);
    if ((0, domhandler_1.isCDATA)(node2)) return getText(node2.children);
    if ((0, domhandler_1.isText)(node2)) return node2.data;
    return "";
  }
  stringify.getText = getText;
  function textContent(node2) {
    if (Array.isArray(node2)) return node2.map(textContent).join("");
    if ((0, domhandler_1.hasChildren)(node2) && !(0, domhandler_1.isComment)(node2)) {
      return textContent(node2.children);
    }
    if ((0, domhandler_1.isText)(node2)) return node2.data;
    return "";
  }
  stringify.textContent = textContent;
  function innerText(node2) {
    if (Array.isArray(node2)) return node2.map(innerText).join("");
    if ((0, domhandler_1.hasChildren)(node2) && (node2.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node2))) {
      return innerText(node2.children);
    }
    if ((0, domhandler_1.isText)(node2)) return node2.data;
    return "";
  }
  stringify.innerText = innerText;
  return stringify;
}
var traversal = {};
var hasRequiredTraversal;
function requireTraversal() {
  if (hasRequiredTraversal) return traversal;
  hasRequiredTraversal = 1;
  Object.defineProperty(traversal, "__esModule", {
    value: true
  });
  traversal.prevElementSibling = traversal.nextElementSibling = traversal.getName = traversal.hasAttrib = traversal.getAttributeValue = traversal.getSiblings = traversal.getParent = traversal.getChildren = void 0;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  var emptyArray = [];
  function getChildren(elem) {
    var _a;
    return (_a = elem.children) !== null && _a !== void 0 ? _a : emptyArray;
  }
  traversal.getChildren = getChildren;
  function getParent(elem) {
    return elem.parent || null;
  }
  traversal.getParent = getParent;
  function getSiblings(elem) {
    var _a, _b;
    var parent = getParent(elem);
    if (parent != null) return getChildren(parent);
    var siblings = [elem];
    var prev = elem.prev, next = elem.next;
    while (prev != null) {
      siblings.unshift(prev);
      _a = prev, prev = _a.prev;
    }
    while (next != null) {
      siblings.push(next);
      _b = next, next = _b.next;
    }
    return siblings;
  }
  traversal.getSiblings = getSiblings;
  function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
  }
  traversal.getAttributeValue = getAttributeValue;
  function hasAttrib(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
  }
  traversal.hasAttrib = hasAttrib;
  function getName(elem) {
    return elem.name;
  }
  traversal.getName = getName;
  function nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while (next !== null && !(0, domhandler_1.isTag)(next)) _a = next, next = _a.next;
    return next;
  }
  traversal.nextElementSibling = nextElementSibling;
  function prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while (prev !== null && !(0, domhandler_1.isTag)(prev)) _a = prev, prev = _a.prev;
    return prev;
  }
  traversal.prevElementSibling = prevElementSibling;
  return traversal;
}
var manipulation$1 = {};
var hasRequiredManipulation$1;
function requireManipulation$1() {
  if (hasRequiredManipulation$1) return manipulation$1;
  hasRequiredManipulation$1 = 1;
  Object.defineProperty(manipulation$1, "__esModule", {
    value: true
  });
  manipulation$1.prepend = manipulation$1.prependChild = manipulation$1.append = manipulation$1.appendChild = manipulation$1.replaceElement = manipulation$1.removeElement = void 0;
  function removeElement(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
      var childs = elem.parent.children;
      childs.splice(childs.lastIndexOf(elem), 1);
    }
  }
  manipulation$1.removeElement = removeElement;
  function replaceElement(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) {
      prev.next = replacement;
    }
    var next = replacement.next = elem.next;
    if (next) {
      next.prev = replacement;
    }
    var parent = replacement.parent = elem.parent;
    if (parent) {
      var childs = parent.children;
      childs[childs.lastIndexOf(elem)] = replacement;
    }
  }
  manipulation$1.replaceElement = replaceElement;
  function appendChild(elem, child) {
    removeElement(child);
    child.next = null;
    child.parent = elem;
    if (elem.children.push(child) > 1) {
      var sibling = elem.children[elem.children.length - 2];
      sibling.next = child;
      child.prev = sibling;
    } else {
      child.prev = null;
    }
  }
  manipulation$1.appendChild = appendChild;
  function append(elem, next) {
    removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
      currNext.prev = next;
      if (parent) {
        var childs = parent.children;
        childs.splice(childs.lastIndexOf(currNext), 0, next);
      }
    } else if (parent) {
      parent.children.push(next);
    }
  }
  manipulation$1.append = append;
  function prependChild(elem, child) {
    removeElement(child);
    child.parent = elem;
    child.prev = null;
    if (elem.children.unshift(child) !== 1) {
      var sibling = elem.children[1];
      sibling.prev = child;
      child.next = sibling;
    } else {
      child.next = null;
    }
  }
  manipulation$1.prependChild = prependChild;
  function prepend(elem, prev) {
    removeElement(prev);
    var parent = elem.parent;
    if (parent) {
      var childs = parent.children;
      childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) {
      elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
  }
  manipulation$1.prepend = prepend;
  return manipulation$1;
}
var querying = {};
var hasRequiredQuerying;
function requireQuerying() {
  if (hasRequiredQuerying) return querying;
  hasRequiredQuerying = 1;
  Object.defineProperty(querying, "__esModule", {
    value: true
  });
  querying.findAll = querying.existsOne = querying.findOne = querying.findOneChild = querying.find = querying.filter = void 0;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  function filter2(test, node2, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    if (!Array.isArray(node2)) node2 = [node2];
    return find2(test, node2, recurse, limit);
  }
  querying.filter = filter2;
  function find2(test, nodes, recurse, limit) {
    var result = [];
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
      var elem = nodes_1[_i];
      if (test(elem)) {
        result.push(elem);
        if (--limit <= 0) break;
      }
      if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
        var children2 = find2(test, elem.children, recurse, limit);
        result.push.apply(result, children2);
        limit -= children2.length;
        if (limit <= 0) break;
      }
    }
    return result;
  }
  querying.find = find2;
  function findOneChild(test, nodes) {
    return nodes.find(test);
  }
  querying.findOneChild = findOneChild;
  function findOne(test, nodes, recurse) {
    if (recurse === void 0) {
      recurse = true;
    }
    var elem = null;
    for (var i = 0; i < nodes.length && !elem; i++) {
      var checked = nodes[i];
      if (!(0, domhandler_1.isTag)(checked)) {
        continue;
      } else if (test(checked)) {
        elem = checked;
      } else if (recurse && checked.children.length > 0) {
        elem = findOne(test, checked.children);
      }
    }
    return elem;
  }
  querying.findOne = findOne;
  function existsOne(test, nodes) {
    return nodes.some(function(checked) {
      return (0, domhandler_1.isTag)(checked) && (test(checked) || checked.children.length > 0 && existsOne(test, checked.children));
    });
  }
  querying.existsOne = existsOne;
  function findAll(test, nodes) {
    var _a;
    var result = [];
    var stack = nodes.filter(domhandler_1.isTag);
    var elem;
    while (elem = stack.shift()) {
      var children2 = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(domhandler_1.isTag);
      if (children2 && children2.length > 0) {
        stack.unshift.apply(stack, children2);
      }
      if (test(elem)) result.push(elem);
    }
    return result;
  }
  querying.findAll = findAll;
  return querying;
}
var legacy = {};
var hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  Object.defineProperty(legacy, "__esModule", {
    value: true
  });
  legacy.getElementsByTagType = legacy.getElementsByTagName = legacy.getElementById = legacy.getElements = legacy.testElement = void 0;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  var querying_1 = /* @__PURE__ */ requireQuerying();
  var Checks = {
    tag_name: function(name) {
      if (typeof name === "function") {
        return function(elem) {
          return (0, domhandler_1.isTag)(elem) && name(elem.name);
        };
      } else if (name === "*") {
        return domhandler_1.isTag;
      }
      return function(elem) {
        return (0, domhandler_1.isTag)(elem) && elem.name === name;
      };
    },
    tag_type: function(type2) {
      if (typeof type2 === "function") {
        return function(elem) {
          return type2(elem.type);
        };
      }
      return function(elem) {
        return elem.type === type2;
      };
    },
    tag_contains: function(data2) {
      if (typeof data2 === "function") {
        return function(elem) {
          return (0, domhandler_1.isText)(elem) && data2(elem.data);
        };
      }
      return function(elem) {
        return (0, domhandler_1.isText)(elem) && elem.data === data2;
      };
    }
  };
  function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
      return function(elem) {
        return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]);
      };
    }
    return function(elem) {
      return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value;
    };
  }
  function combineFuncs(a, b) {
    return function(elem) {
      return a(elem) || b(elem);
    };
  }
  function compileTest(options2) {
    var funcs = Object.keys(options2).map(function(key) {
      var value = options2[key];
      return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
  }
  function testElement(options2, node2) {
    var test = compileTest(options2);
    return test ? test(node2) : true;
  }
  legacy.testElement = testElement;
  function getElements(options2, nodes, recurse, limit) {
    if (limit === void 0) {
      limit = Infinity;
    }
    var test = compileTest(options2);
    return test ? (0, querying_1.filter)(test, nodes, recurse, limit) : [];
  }
  legacy.getElements = getElements;
  function getElementById(id2, nodes, recurse) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (!Array.isArray(nodes)) nodes = [nodes];
    return (0, querying_1.findOne)(getAttribCheck("id", id2), nodes, recurse);
  }
  legacy.getElementById = getElementById;
  function getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    return (0, querying_1.filter)(Checks.tag_name(tagName), nodes, recurse, limit);
  }
  legacy.getElementsByTagName = getElementsByTagName;
  function getElementsByTagType(type2, nodes, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    return (0, querying_1.filter)(Checks.tag_type(type2), nodes, recurse, limit);
  }
  legacy.getElementsByTagType = getElementsByTagType;
  return legacy;
}
var helpers$1 = {};
var hasRequiredHelpers$1;
function requireHelpers$1() {
  if (hasRequiredHelpers$1) return helpers$1;
  hasRequiredHelpers$1 = 1;
  Object.defineProperty(helpers$1, "__esModule", {
    value: true
  });
  helpers$1.uniqueSort = helpers$1.compareDocumentPosition = helpers$1.removeSubsets = void 0;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  function removeSubsets(nodes) {
    var idx = nodes.length;
    while (--idx >= 0) {
      var node2 = nodes[idx];
      if (idx > 0 && nodes.lastIndexOf(node2, idx - 1) >= 0) {
        nodes.splice(idx, 1);
        continue;
      }
      for (var ancestor = node2.parent; ancestor; ancestor = ancestor.parent) {
        if (nodes.includes(ancestor)) {
          nodes.splice(idx, 1);
          break;
        }
      }
    }
    return nodes;
  }
  helpers$1.removeSubsets = removeSubsets;
  function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
      return 0;
    }
    var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
      aParents.unshift(current);
      current = current.parent;
    }
    current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
      bParents.unshift(current);
      current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
      idx++;
    }
    if (idx === 0) {
      return 1;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
      if (sharedParent === nodeB) {
        return 4 | 16;
      }
      return 4;
    }
    if (sharedParent === nodeA) {
      return 2 | 8;
    }
    return 2;
  }
  helpers$1.compareDocumentPosition = compareDocumentPosition;
  function uniqueSort(nodes) {
    nodes = nodes.filter(function(node2, i, arr) {
      return !arr.includes(node2, i + 1);
    });
    nodes.sort(function(a, b) {
      var relative = compareDocumentPosition(a, b);
      if (relative & 2) {
        return -1;
      } else if (relative & 4) {
        return 1;
      }
      return 0;
    });
    return nodes;
  }
  helpers$1.uniqueSort = uniqueSort;
  return helpers$1;
}
var feeds = {};
var hasRequiredFeeds;
function requireFeeds() {
  if (hasRequiredFeeds) return feeds;
  hasRequiredFeeds = 1;
  Object.defineProperty(feeds, "__esModule", {
    value: true
  });
  feeds.getFeed = void 0;
  var stringify_1 = /* @__PURE__ */ requireStringify();
  var legacy_1 = /* @__PURE__ */ requireLegacy();
  function getFeed(doc) {
    var feedRoot = getOneElement(isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
  }
  feeds.getFeed = getFeed;
  function getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
      type: "atom",
      items: (0, legacy_1.getElementsByTagName)("entry", childs).map(function(item) {
        var _a2;
        var children2 = item.children;
        var entry = {
          media: getMediaElements(children2)
        };
        addConditionally(entry, "id", "id", children2);
        addConditionally(entry, "title", "title", children2);
        var href2 = (_a2 = getOneElement("link", children2)) === null || _a2 === void 0 ? void 0 : _a2.attribs.href;
        if (href2) {
          entry.link = href2;
        }
        var description2 = fetch2("summary", children2) || fetch2("content", children2);
        if (description2) {
          entry.description = description2;
        }
        var pubDate = fetch2("updated", children2);
        if (pubDate) {
          entry.pubDate = new Date(pubDate);
        }
        return entry;
      })
    };
    addConditionally(feed, "id", "id", childs);
    addConditionally(feed, "title", "title", childs);
    var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs.href;
    if (href) {
      feed.link = href;
    }
    addConditionally(feed, "description", "subtitle", childs);
    var updated = fetch2("updated", childs);
    if (updated) {
      feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "email", childs, true);
    return feed;
  }
  function getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
      type: feedRoot.name.substr(0, 3),
      id: "",
      items: (0, legacy_1.getElementsByTagName)("item", feedRoot.children).map(function(item) {
        var children2 = item.children;
        var entry = {
          media: getMediaElements(children2)
        };
        addConditionally(entry, "id", "guid", children2);
        addConditionally(entry, "title", "title", children2);
        addConditionally(entry, "link", "link", children2);
        addConditionally(entry, "description", "description", children2);
        var pubDate = fetch2("pubDate", children2);
        if (pubDate) entry.pubDate = new Date(pubDate);
        return entry;
      })
    };
    addConditionally(feed, "title", "title", childs);
    addConditionally(feed, "link", "link", childs);
    addConditionally(feed, "description", "description", childs);
    var updated = fetch2("lastBuildDate", childs);
    if (updated) {
      feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
  }
  var MEDIA_KEYS_STRING = ["url", "type", "lang"];
  var MEDIA_KEYS_INT = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
  function getMediaElements(where) {
    return (0, legacy_1.getElementsByTagName)("media:content", where).map(function(elem) {
      var attribs = elem.attribs;
      var media = {
        medium: attribs.medium,
        isDefault: !!attribs.isDefault
      };
      for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
        var attrib = MEDIA_KEYS_STRING_1[_i];
        if (attribs[attrib]) {
          media[attrib] = attribs[attrib];
        }
      }
      for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
        var attrib = MEDIA_KEYS_INT_1[_a];
        if (attribs[attrib]) {
          media[attrib] = parseInt(attribs[attrib], 10);
        }
      }
      if (attribs.expression) {
        media.expression = attribs.expression;
      }
      return media;
    });
  }
  function getOneElement(tagName, node2) {
    return (0, legacy_1.getElementsByTagName)(tagName, node2, true, 1)[0];
  }
  function fetch2(tagName, where, recurse) {
    if (recurse === void 0) {
      recurse = false;
    }
    return (0, stringify_1.textContent)((0, legacy_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
  }
  function addConditionally(obj, prop2, tagName, where, recurse) {
    if (recurse === void 0) {
      recurse = false;
    }
    var val = fetch2(tagName, where, recurse);
    if (val) obj[prop2] = val;
  }
  function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
  }
  return feeds;
}
var hasRequiredLib$9;
function requireLib$9() {
  if (hasRequiredLib$9) return lib$a;
  hasRequiredLib$9 = 1;
  (function(exports2) {
    var __createBinding2 = lib$a && lib$a.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
          return m[k];
        }
      });
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __exportStar2 = lib$a && lib$a.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding2(exports3, m, p);
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.hasChildren = exports2.isDocument = exports2.isComment = exports2.isText = exports2.isCDATA = exports2.isTag = void 0;
    __exportStar2(/* @__PURE__ */ requireStringify(), exports2);
    __exportStar2(/* @__PURE__ */ requireTraversal(), exports2);
    __exportStar2(/* @__PURE__ */ requireManipulation$1(), exports2);
    __exportStar2(/* @__PURE__ */ requireQuerying(), exports2);
    __exportStar2(/* @__PURE__ */ requireLegacy(), exports2);
    __exportStar2(/* @__PURE__ */ requireHelpers$1(), exports2);
    __exportStar2(/* @__PURE__ */ requireFeeds(), exports2);
    var domhandler_1 = /* @__PURE__ */ requireLib$c();
    Object.defineProperty(exports2, "isTag", {
      enumerable: true,
      get: function() {
        return domhandler_1.isTag;
      }
    });
    Object.defineProperty(exports2, "isCDATA", {
      enumerable: true,
      get: function() {
        return domhandler_1.isCDATA;
      }
    });
    Object.defineProperty(exports2, "isText", {
      enumerable: true,
      get: function() {
        return domhandler_1.isText;
      }
    });
    Object.defineProperty(exports2, "isComment", {
      enumerable: true,
      get: function() {
        return domhandler_1.isComment;
      }
    });
    Object.defineProperty(exports2, "isDocument", {
      enumerable: true,
      get: function() {
        return domhandler_1.isDocument;
      }
    });
    Object.defineProperty(exports2, "hasChildren", {
      enumerable: true,
      get: function() {
        return domhandler_1.hasChildren;
      }
    });
  })(lib$a);
  return lib$a;
}
var boolbase;
var hasRequiredBoolbase;
function requireBoolbase() {
  if (hasRequiredBoolbase) return boolbase;
  hasRequiredBoolbase = 1;
  boolbase = {
    trueFunc: function trueFunc() {
      return true;
    },
    falseFunc: function falseFunc() {
      return false;
    }
  };
  return boolbase;
}
var compile$1 = {};
var sort$1 = {};
var procedure = {};
var hasRequiredProcedure;
function requireProcedure() {
  if (hasRequiredProcedure) return procedure;
  hasRequiredProcedure = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.isTraversal = exports2.procedure = void 0;
    exports2.procedure = {
      universal: 50,
      tag: 30,
      attribute: 1,
      pseudo: 0,
      "pseudo-element": 0,
      "column-combinator": -1,
      descendant: -1,
      child: -1,
      parent: -1,
      sibling: -1,
      adjacent: -1,
      _flexibleDescendant: -1
    };
    function isTraversal2(t) {
      return exports2.procedure[t.type] < 0;
    }
    exports2.isTraversal = isTraversal2;
  })(procedure);
  return procedure;
}
var hasRequiredSort$1;
function requireSort$1() {
  if (hasRequiredSort$1) return sort$1;
  hasRequiredSort$1 = 1;
  Object.defineProperty(sort$1, "__esModule", {
    value: true
  });
  var css_what_1 = require$$0$3;
  var procedure_1 = requireProcedure();
  var attributes2 = {
    exists: 10,
    equals: 8,
    not: 7,
    start: 6,
    end: 6,
    any: 5,
    hyphen: 4,
    element: 4
  };
  function sortByProcedure(arr) {
    var procs = arr.map(getProcedure);
    for (var i = 1; i < arr.length; i++) {
      var procNew = procs[i];
      if (procNew < 0) continue;
      for (var j = i - 1; j >= 0 && procNew < procs[j]; j--) {
        var token = arr[j + 1];
        arr[j + 1] = arr[j];
        arr[j] = token;
        procs[j + 1] = procs[j];
        procs[j] = procNew;
      }
    }
  }
  sort$1.default = sortByProcedure;
  function getProcedure(token) {
    var proc = procedure_1.procedure[token.type];
    if (token.type === css_what_1.SelectorType.Attribute) {
      proc = attributes2[token.action];
      if (proc === attributes2.equals && token.name === "id") {
        proc = 9;
      }
      if (token.ignoreCase) {
        proc >>= 1;
      }
    } else if (token.type === css_what_1.SelectorType.Pseudo) {
      if (!token.data) {
        proc = 3;
      } else if (token.name === "has" || token.name === "contains") {
        proc = 0;
      } else if (Array.isArray(token.data)) {
        proc = 0;
        for (var i = 0; i < token.data.length; i++) {
          if (token.data[i].length !== 1) continue;
          var cur = getProcedure(token.data[i][0]);
          if (cur === 0) {
            proc = 0;
            break;
          }
          if (cur > proc) proc = cur;
        }
        if (token.data.length > 1 && proc > 0) proc -= 1;
      } else {
        proc = 1;
      }
    }
    return proc;
  }
  return sort$1;
}
var general = {};
var attributes$1 = {};
var hasRequiredAttributes$1;
function requireAttributes$1() {
  if (hasRequiredAttributes$1) return attributes$1;
  hasRequiredAttributes$1 = 1;
  Object.defineProperty(attributes$1, "__esModule", {
    value: true
  });
  attributes$1.attributeRules = void 0;
  var boolbase_1 = requireBoolbase();
  var reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
  function escapeRegex(value) {
    return value.replace(reChars, "\\$&");
  }
  var caseInsensitiveAttributes = /* @__PURE__ */ new Set(["accept", "accept-charset", "align", "alink", "axis", "bgcolor", "charset", "checked", "clear", "codetype", "color", "compact", "declare", "defer", "dir", "direction", "disabled", "enctype", "face", "frame", "hreflang", "http-equiv", "lang", "language", "link", "media", "method", "multiple", "nohref", "noresize", "noshade", "nowrap", "readonly", "rel", "rev", "rules", "scope", "scrolling", "selected", "shape", "target", "text", "type", "valign", "valuetype", "vlink"]);
  function shouldIgnoreCase(selector2, options2) {
    return typeof selector2.ignoreCase === "boolean" ? selector2.ignoreCase : selector2.ignoreCase === "quirks" ? !!options2.quirksMode : !options2.xmlMode && caseInsensitiveAttributes.has(selector2.name);
  }
  attributes$1.attributeRules = {
    equals: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name;
      var value = data2.value;
      if (shouldIgnoreCase(data2, options2)) {
        value = value.toLowerCase();
        return function(elem) {
          var attr = adapter.getAttributeValue(elem, name);
          return attr != null && attr.length === value.length && attr.toLowerCase() === value && next(elem);
        };
      }
      return function(elem) {
        return adapter.getAttributeValue(elem, name) === value && next(elem);
      };
    },
    hyphen: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name;
      var value = data2.value;
      var len = value.length;
      if (shouldIgnoreCase(data2, options2)) {
        value = value.toLowerCase();
        return function hyphenIC(elem) {
          var attr = adapter.getAttributeValue(elem, name);
          return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len).toLowerCase() === value && next(elem);
        };
      }
      return function hyphen2(elem) {
        var attr = adapter.getAttributeValue(elem, name);
        return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len) === value && next(elem);
      };
    },
    element: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name, value = data2.value;
      if (/\s/.test(value)) {
        return boolbase_1.falseFunc;
      }
      var regex = new RegExp("(?:^|\\s)".concat(escapeRegex(value), "(?:$|\\s)"), shouldIgnoreCase(data2, options2) ? "i" : "");
      return function element(elem) {
        var attr = adapter.getAttributeValue(elem, name);
        return attr != null && attr.length >= value.length && regex.test(attr) && next(elem);
      };
    },
    exists: function(next, _a, _b) {
      var name = _a.name;
      var adapter = _b.adapter;
      return function(elem) {
        return adapter.hasAttrib(elem, name) && next(elem);
      };
    },
    start: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name;
      var value = data2.value;
      var len = value.length;
      if (len === 0) {
        return boolbase_1.falseFunc;
      }
      if (shouldIgnoreCase(data2, options2)) {
        value = value.toLowerCase();
        return function(elem) {
          var attr = adapter.getAttributeValue(elem, name);
          return attr != null && attr.length >= len && attr.substr(0, len).toLowerCase() === value && next(elem);
        };
      }
      return function(elem) {
        var _a;
        return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value)) && next(elem);
      };
    },
    end: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name;
      var value = data2.value;
      var len = -value.length;
      if (len === 0) {
        return boolbase_1.falseFunc;
      }
      if (shouldIgnoreCase(data2, options2)) {
        value = value.toLowerCase();
        return function(elem) {
          var _a;
          return ((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value && next(elem);
        };
      }
      return function(elem) {
        var _a;
        return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value)) && next(elem);
      };
    },
    any: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name, value = data2.value;
      if (value === "") {
        return boolbase_1.falseFunc;
      }
      if (shouldIgnoreCase(data2, options2)) {
        var regex_1 = new RegExp(escapeRegex(value), "i");
        return function anyIC(elem) {
          var attr = adapter.getAttributeValue(elem, name);
          return attr != null && attr.length >= value.length && regex_1.test(attr) && next(elem);
        };
      }
      return function(elem) {
        var _a;
        return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value)) && next(elem);
      };
    },
    not: function(next, data2, options2) {
      var adapter = options2.adapter;
      var name = data2.name;
      var value = data2.value;
      if (value === "") {
        return function(elem) {
          return !!adapter.getAttributeValue(elem, name) && next(elem);
        };
      } else if (shouldIgnoreCase(data2, options2)) {
        value = value.toLowerCase();
        return function(elem) {
          var attr = adapter.getAttributeValue(elem, name);
          return (attr == null || attr.length !== value.length || attr.toLowerCase() !== value) && next(elem);
        };
      }
      return function(elem) {
        return adapter.getAttributeValue(elem, name) !== value && next(elem);
      };
    }
  };
  return attributes$1;
}
var pseudoSelectors = {};
var filters = {};
var lib$5 = {};
var parse$1 = {};
var hasRequiredParse$1;
function requireParse$1() {
  if (hasRequiredParse$1) return parse$1;
  hasRequiredParse$1 = 1;
  Object.defineProperty(parse$1, "__esModule", {
    value: true
  });
  parse$1.parse = void 0;
  var whitespace = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]);
  var ZERO = "0".charCodeAt(0);
  var NINE = "9".charCodeAt(0);
  function parse2(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") {
      return [2, 0];
    } else if (formula === "odd") {
      return [2, 1];
    }
    var idx = 0;
    var a = 0;
    var sign2 = readSign();
    var number3 = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
      idx++;
      a = sign2 * (number3 !== null && number3 !== void 0 ? number3 : 1);
      skipWhitespace();
      if (idx < formula.length) {
        sign2 = readSign();
        skipWhitespace();
        number3 = readNumber();
      } else {
        sign2 = number3 = 0;
      }
    }
    if (number3 === null || idx < formula.length) {
      throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
    }
    return [a, sign2 * number3];
    function readSign() {
      if (formula.charAt(idx) === "-") {
        idx++;
        return -1;
      }
      if (formula.charAt(idx) === "+") {
        idx++;
      }
      return 1;
    }
    function readNumber() {
      var start2 = idx;
      var value = 0;
      while (idx < formula.length && formula.charCodeAt(idx) >= ZERO && formula.charCodeAt(idx) <= NINE) {
        value = value * 10 + (formula.charCodeAt(idx) - ZERO);
        idx++;
      }
      return idx === start2 ? null : value;
    }
    function skipWhitespace() {
      while (idx < formula.length && whitespace.has(formula.charCodeAt(idx))) {
        idx++;
      }
    }
  }
  parse$1.parse = parse2;
  return parse$1;
}
var compile = {};
var hasRequiredCompile$2;
function requireCompile$2() {
  if (hasRequiredCompile$2) return compile;
  hasRequiredCompile$2 = 1;
  var __importDefault2 = compile && compile.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(compile, "__esModule", {
    value: true
  });
  compile.generate = compile.compile = void 0;
  var boolbase_1 = __importDefault2(requireBoolbase());
  function compile$12(parsed) {
    var a = parsed[0];
    var b = parsed[1] - 1;
    if (b < 0 && a <= 0) return boolbase_1.default.falseFunc;
    if (a === -1) return function(index2) {
      return index2 <= b;
    };
    if (a === 0) return function(index2) {
      return index2 === b;
    };
    if (a === 1) return b < 0 ? boolbase_1.default.trueFunc : function(index2) {
      return index2 >= b;
    };
    var absA = Math.abs(a);
    var bMod = (b % absA + absA) % absA;
    return a > 1 ? function(index2) {
      return index2 >= b && index2 % absA === bMod;
    } : function(index2) {
      return index2 <= b && index2 % absA === bMod;
    };
  }
  compile.compile = compile$12;
  function generate(parsed) {
    var a = parsed[0];
    var b = parsed[1] - 1;
    var n = 0;
    if (a < 0) {
      var aPos_1 = -a;
      var minValue_1 = (b % aPos_1 + aPos_1) % aPos_1;
      return function() {
        var val = minValue_1 + aPos_1 * n++;
        return val > b ? null : val;
      };
    }
    if (a === 0) return b < 0 ? (
      // There are no result — always return `null`
      function() {
        return null;
      }
    ) : (
      // Return `b` exactly once
      function() {
        return n++ === 0 ? b : null;
      }
    );
    if (b < 0) {
      b += a * Math.ceil(-b / a);
    }
    return function() {
      return a * n++ + b;
    };
  }
  compile.generate = generate;
  return compile;
}
var hasRequiredLib$8;
function requireLib$8() {
  if (hasRequiredLib$8) return lib$5;
  hasRequiredLib$8 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.sequence = exports2.generate = exports2.compile = exports2.parse = void 0;
    var parse_js_1 = /* @__PURE__ */ requireParse$1();
    Object.defineProperty(exports2, "parse", {
      enumerable: true,
      get: function() {
        return parse_js_1.parse;
      }
    });
    var compile_js_1 = /* @__PURE__ */ requireCompile$2();
    Object.defineProperty(exports2, "compile", {
      enumerable: true,
      get: function() {
        return compile_js_1.compile;
      }
    });
    Object.defineProperty(exports2, "generate", {
      enumerable: true,
      get: function() {
        return compile_js_1.generate;
      }
    });
    function nthCheck(formula) {
      return (0, compile_js_1.compile)((0, parse_js_1.parse)(formula));
    }
    exports2.default = nthCheck;
    function sequence(formula) {
      return (0, compile_js_1.generate)((0, parse_js_1.parse)(formula));
    }
    exports2.sequence = sequence;
  })(lib$5);
  return lib$5;
}
var hasRequiredFilters;
function requireFilters() {
  if (hasRequiredFilters) return filters;
  hasRequiredFilters = 1;
  (function(exports2) {
    var __importDefault2 = filters && filters.__importDefault || function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : {
        "default": mod2
      };
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.filters = void 0;
    var nth_check_1 = __importDefault2(/* @__PURE__ */ requireLib$8());
    var boolbase_1 = requireBoolbase();
    function getChildFunc(next, adapter) {
      return function(elem) {
        var parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(elem);
      };
    }
    exports2.filters = {
      contains: function(next, text2, _a) {
        var adapter = _a.adapter;
        return function contains2(elem) {
          return next(elem) && adapter.getText(elem).includes(text2);
        };
      },
      icontains: function(next, text2, _a) {
        var adapter = _a.adapter;
        var itext = text2.toLowerCase();
        return function icontains(elem) {
          return next(elem) && adapter.getText(elem).toLowerCase().includes(itext);
        };
      },
      // Location specific methods
      "nth-child": function(next, rule, _a) {
        var adapter = _a.adapter, equals2 = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc) return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc) return getChildFunc(next, adapter);
        return function nthChild(elem) {
          var siblings = adapter.getSiblings(elem);
          var pos = 0;
          for (var i = 0; i < siblings.length; i++) {
            if (equals2(elem, siblings[i])) break;
            if (adapter.isTag(siblings[i])) {
              pos++;
            }
          }
          return func(pos) && next(elem);
        };
      },
      "nth-last-child": function(next, rule, _a) {
        var adapter = _a.adapter, equals2 = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc) return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc) return getChildFunc(next, adapter);
        return function nthLastChild(elem) {
          var siblings = adapter.getSiblings(elem);
          var pos = 0;
          for (var i = siblings.length - 1; i >= 0; i--) {
            if (equals2(elem, siblings[i])) break;
            if (adapter.isTag(siblings[i])) {
              pos++;
            }
          }
          return func(pos) && next(elem);
        };
      },
      "nth-of-type": function(next, rule, _a) {
        var adapter = _a.adapter, equals2 = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc) return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc) return getChildFunc(next, adapter);
        return function nthOfType(elem) {
          var siblings = adapter.getSiblings(elem);
          var pos = 0;
          for (var i = 0; i < siblings.length; i++) {
            var currentSibling = siblings[i];
            if (equals2(elem, currentSibling)) break;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) {
              pos++;
            }
          }
          return func(pos) && next(elem);
        };
      },
      "nth-last-of-type": function(next, rule, _a) {
        var adapter = _a.adapter, equals2 = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc) return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc) return getChildFunc(next, adapter);
        return function nthLastOfType(elem) {
          var siblings = adapter.getSiblings(elem);
          var pos = 0;
          for (var i = siblings.length - 1; i >= 0; i--) {
            var currentSibling = siblings[i];
            if (equals2(elem, currentSibling)) break;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) {
              pos++;
            }
          }
          return func(pos) && next(elem);
        };
      },
      // TODO determine the actual root element
      root: function(next, _rule, _a) {
        var adapter = _a.adapter;
        return function(elem) {
          var parent = adapter.getParent(elem);
          return (parent == null || !adapter.isTag(parent)) && next(elem);
        };
      },
      scope: function(next, rule, options2, context) {
        var equals2 = options2.equals;
        if (!context || context.length === 0) {
          return exports2.filters.root(next, rule, options2);
        }
        if (context.length === 1) {
          return function(elem) {
            return equals2(context[0], elem) && next(elem);
          };
        }
        return function(elem) {
          return context.includes(elem) && next(elem);
        };
      },
      hover: dynamicStatePseudo("isHovered"),
      visited: dynamicStatePseudo("isVisited"),
      active: dynamicStatePseudo("isActive")
    };
    function dynamicStatePseudo(name) {
      return function dynamicPseudo(next, _rule, _a) {
        var adapter = _a.adapter;
        var func = adapter[name];
        if (typeof func !== "function") {
          return boolbase_1.falseFunc;
        }
        return function active2(elem) {
          return func(elem) && next(elem);
        };
      };
    }
  })(filters);
  return filters;
}
var pseudos = {};
var hasRequiredPseudos;
function requirePseudos() {
  if (hasRequiredPseudos) return pseudos;
  hasRequiredPseudos = 1;
  Object.defineProperty(pseudos, "__esModule", {
    value: true
  });
  pseudos.verifyPseudoArgs = pseudos.pseudos = void 0;
  pseudos.pseudos = {
    empty: function(elem, _a) {
      var adapter = _a.adapter;
      return !adapter.getChildren(elem).some(function(elem2) {
        return adapter.isTag(elem2) || adapter.getText(elem2) !== "";
      });
    },
    "first-child": function(elem, _a) {
      var adapter = _a.adapter, equals2 = _a.equals;
      var firstChild = adapter.getSiblings(elem).find(function(elem2) {
        return adapter.isTag(elem2);
      });
      return firstChild != null && equals2(elem, firstChild);
    },
    "last-child": function(elem, _a) {
      var adapter = _a.adapter, equals2 = _a.equals;
      var siblings = adapter.getSiblings(elem);
      for (var i = siblings.length - 1; i >= 0; i--) {
        if (equals2(elem, siblings[i])) return true;
        if (adapter.isTag(siblings[i])) break;
      }
      return false;
    },
    "first-of-type": function(elem, _a) {
      var adapter = _a.adapter, equals2 = _a.equals;
      var siblings = adapter.getSiblings(elem);
      var elemName = adapter.getName(elem);
      for (var i = 0; i < siblings.length; i++) {
        var currentSibling = siblings[i];
        if (equals2(elem, currentSibling)) return true;
        if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) {
          break;
        }
      }
      return false;
    },
    "last-of-type": function(elem, _a) {
      var adapter = _a.adapter, equals2 = _a.equals;
      var siblings = adapter.getSiblings(elem);
      var elemName = adapter.getName(elem);
      for (var i = siblings.length - 1; i >= 0; i--) {
        var currentSibling = siblings[i];
        if (equals2(elem, currentSibling)) return true;
        if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) {
          break;
        }
      }
      return false;
    },
    "only-of-type": function(elem, _a) {
      var adapter = _a.adapter, equals2 = _a.equals;
      var elemName = adapter.getName(elem);
      return adapter.getSiblings(elem).every(function(sibling) {
        return equals2(elem, sibling) || !adapter.isTag(sibling) || adapter.getName(sibling) !== elemName;
      });
    },
    "only-child": function(elem, _a) {
      var adapter = _a.adapter, equals2 = _a.equals;
      return adapter.getSiblings(elem).every(function(sibling) {
        return equals2(elem, sibling) || !adapter.isTag(sibling);
      });
    }
  };
  function verifyPseudoArgs(func, name, subselect) {
    if (subselect === null) {
      if (func.length > 2) {
        throw new Error("pseudo-selector :".concat(name, " requires an argument"));
      }
    } else if (func.length === 2) {
      throw new Error("pseudo-selector :".concat(name, " doesn't have any arguments"));
    }
  }
  pseudos.verifyPseudoArgs = verifyPseudoArgs;
  return pseudos;
}
var aliases = {};
var hasRequiredAliases;
function requireAliases() {
  if (hasRequiredAliases) return aliases;
  hasRequiredAliases = 1;
  Object.defineProperty(aliases, "__esModule", {
    value: true
  });
  aliases.aliases = void 0;
  aliases.aliases = {
    // Links
    "any-link": ":is(a, area, link)[href]",
    link: ":any-link:not(:visited)",
    // Forms
    // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
    disabled: ":is(\n        :is(button, input, select, textarea, optgroup, option)[disabled],\n        optgroup[disabled] > option,\n        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)\n    )",
    enabled: ":not(:disabled)",
    checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
    required: ":is(input, select, textarea)[required]",
    optional: ":is(input, select, textarea):not([required])",
    // JQuery extensions
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
    selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
    checkbox: "[type=checkbox]",
    file: "[type=file]",
    password: "[type=password]",
    radio: "[type=radio]",
    reset: "[type=reset]",
    image: "[type=image]",
    submit: "[type=submit]",
    parent: ":not(:empty)",
    header: ":is(h1, h2, h3, h4, h5, h6)",
    button: ":is(button, input[type=button])",
    input: ":is(input, textarea, select, button)",
    text: "input:is(:not([type!='']), [type=text])"
  };
  return aliases;
}
var subselects = {};
var hasRequiredSubselects;
function requireSubselects() {
  if (hasRequiredSubselects) return subselects;
  hasRequiredSubselects = 1;
  (function(exports2) {
    var __spreadArray2 = subselects && subselects.__spreadArray || function(to, from, pack) {
      if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
      return to.concat(ar || Array.prototype.slice.call(from));
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.subselects = exports2.getNextSiblings = exports2.ensureIsTag = exports2.PLACEHOLDER_ELEMENT = void 0;
    var boolbase_1 = requireBoolbase();
    var procedure_1 = requireProcedure();
    exports2.PLACEHOLDER_ELEMENT = {};
    function ensureIsTag(next, adapter) {
      if (next === boolbase_1.falseFunc) return boolbase_1.falseFunc;
      return function(elem) {
        return adapter.isTag(elem) && next(elem);
      };
    }
    exports2.ensureIsTag = ensureIsTag;
    function getNextSiblings(elem, adapter) {
      var siblings = adapter.getSiblings(elem);
      if (siblings.length <= 1) return [];
      var elemIndex = siblings.indexOf(elem);
      if (elemIndex < 0 || elemIndex === siblings.length - 1) return [];
      return siblings.slice(elemIndex + 1).filter(adapter.isTag);
    }
    exports2.getNextSiblings = getNextSiblings;
    var is = function(next, token, options2, context, compileToken) {
      var opts = {
        xmlMode: !!options2.xmlMode,
        adapter: options2.adapter,
        equals: options2.equals
      };
      var func = compileToken(token, opts, context);
      return function(elem) {
        return func(elem) && next(elem);
      };
    };
    exports2.subselects = {
      is,
      /**
       * `:matches` and `:where` are aliases for `:is`.
       */
      matches: is,
      where: is,
      not: function(next, token, options2, context, compileToken) {
        var opts = {
          xmlMode: !!options2.xmlMode,
          adapter: options2.adapter,
          equals: options2.equals
        };
        var func = compileToken(token, opts, context);
        if (func === boolbase_1.falseFunc) return next;
        if (func === boolbase_1.trueFunc) return boolbase_1.falseFunc;
        return function not2(elem) {
          return !func(elem) && next(elem);
        };
      },
      has: function(next, subselect, options2, _context, compileToken) {
        var adapter = options2.adapter;
        var opts = {
          xmlMode: !!options2.xmlMode,
          adapter,
          equals: options2.equals
        };
        var context = subselect.some(function(s) {
          return s.some(procedure_1.isTraversal);
        }) ? [exports2.PLACEHOLDER_ELEMENT] : void 0;
        var compiled = compileToken(subselect, opts, context);
        if (compiled === boolbase_1.falseFunc) return boolbase_1.falseFunc;
        if (compiled === boolbase_1.trueFunc) {
          return function(elem) {
            return adapter.getChildren(elem).some(adapter.isTag) && next(elem);
          };
        }
        var hasElement = ensureIsTag(compiled, adapter);
        var _a = compiled.shouldTestNextSiblings, shouldTestNextSiblings = _a === void 0 ? false : _a;
        if (context) {
          return function(elem) {
            context[0] = elem;
            var childs = adapter.getChildren(elem);
            var nextElements = shouldTestNextSiblings ? __spreadArray2(__spreadArray2([], childs, true), getNextSiblings(elem, adapter), true) : childs;
            return next(elem) && adapter.existsOne(hasElement, nextElements);
          };
        }
        return function(elem) {
          return next(elem) && adapter.existsOne(hasElement, adapter.getChildren(elem));
        };
      }
    };
  })(subselects);
  return subselects;
}
var hasRequiredPseudoSelectors;
function requirePseudoSelectors() {
  if (hasRequiredPseudoSelectors) return pseudoSelectors;
  hasRequiredPseudoSelectors = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.compilePseudoSelector = exports2.aliases = exports2.pseudos = exports2.filters = void 0;
    var boolbase_1 = requireBoolbase();
    var css_what_1 = require$$0$3;
    var filters_1 = requireFilters();
    Object.defineProperty(exports2, "filters", {
      enumerable: true,
      get: function() {
        return filters_1.filters;
      }
    });
    var pseudos_1 = requirePseudos();
    Object.defineProperty(exports2, "pseudos", {
      enumerable: true,
      get: function() {
        return pseudos_1.pseudos;
      }
    });
    var aliases_1 = requireAliases();
    Object.defineProperty(exports2, "aliases", {
      enumerable: true,
      get: function() {
        return aliases_1.aliases;
      }
    });
    var subselects_1 = requireSubselects();
    function compilePseudoSelector(next, selector2, options2, context, compileToken) {
      var name = selector2.name, data2 = selector2.data;
      if (Array.isArray(data2)) {
        return subselects_1.subselects[name](next, data2, options2, context, compileToken);
      }
      if (name in aliases_1.aliases) {
        if (data2 != null) {
          throw new Error("Pseudo ".concat(name, " doesn't have any arguments"));
        }
        var alias = (0, css_what_1.parse)(aliases_1.aliases[name]);
        return subselects_1.subselects.is(next, alias, options2, context, compileToken);
      }
      if (name in filters_1.filters) {
        return filters_1.filters[name](next, data2, options2, context);
      }
      if (name in pseudos_1.pseudos) {
        var pseudo_1 = pseudos_1.pseudos[name];
        (0, pseudos_1.verifyPseudoArgs)(pseudo_1, name, data2);
        return pseudo_1 === boolbase_1.falseFunc ? boolbase_1.falseFunc : next === boolbase_1.trueFunc ? function(elem) {
          return pseudo_1(elem, options2, data2);
        } : function(elem) {
          return pseudo_1(elem, options2, data2) && next(elem);
        };
      }
      throw new Error("unmatched pseudo-class :".concat(name));
    }
    exports2.compilePseudoSelector = compilePseudoSelector;
  })(pseudoSelectors);
  return pseudoSelectors;
}
var hasRequiredGeneral;
function requireGeneral() {
  if (hasRequiredGeneral) return general;
  hasRequiredGeneral = 1;
  Object.defineProperty(general, "__esModule", {
    value: true
  });
  general.compileGeneralSelector = void 0;
  var attributes_1 = requireAttributes$1();
  var pseudo_selectors_1 = requirePseudoSelectors();
  var css_what_1 = require$$0$3;
  function compileGeneralSelector(next, selector2, options2, context, compileToken) {
    var adapter = options2.adapter, equals2 = options2.equals;
    switch (selector2.type) {
      case css_what_1.SelectorType.PseudoElement: {
        throw new Error("Pseudo-elements are not supported by css-select");
      }
      case css_what_1.SelectorType.ColumnCombinator: {
        throw new Error("Column combinators are not yet supported by css-select");
      }
      case css_what_1.SelectorType.Attribute: {
        if (selector2.namespace != null) {
          throw new Error("Namespaced attributes are not yet supported by css-select");
        }
        if (!options2.xmlMode || options2.lowerCaseAttributeNames) {
          selector2.name = selector2.name.toLowerCase();
        }
        return attributes_1.attributeRules[selector2.action](next, selector2, options2);
      }
      case css_what_1.SelectorType.Pseudo: {
        return (0, pseudo_selectors_1.compilePseudoSelector)(next, selector2, options2, context, compileToken);
      }
      // Tags
      case css_what_1.SelectorType.Tag: {
        if (selector2.namespace != null) {
          throw new Error("Namespaced tag names are not yet supported by css-select");
        }
        var name_1 = selector2.name;
        if (!options2.xmlMode || options2.lowerCaseTags) {
          name_1 = name_1.toLowerCase();
        }
        return function tag(elem) {
          return adapter.getName(elem) === name_1 && next(elem);
        };
      }
      // Traversal
      case css_what_1.SelectorType.Descendant: {
        if (options2.cacheResults === false || typeof WeakSet === "undefined") {
          return function descendant(elem) {
            var current = elem;
            while (current = adapter.getParent(current)) {
              if (adapter.isTag(current) && next(current)) {
                return true;
              }
            }
            return false;
          };
        }
        var isFalseCache_1 = /* @__PURE__ */ new WeakSet();
        return function cachedDescendant(elem) {
          var current = elem;
          while (current = adapter.getParent(current)) {
            if (!isFalseCache_1.has(current)) {
              if (adapter.isTag(current) && next(current)) {
                return true;
              }
              isFalseCache_1.add(current);
            }
          }
          return false;
        };
      }
      case "_flexibleDescendant": {
        return function flexibleDescendant(elem) {
          var current = elem;
          do {
            if (adapter.isTag(current) && next(current)) return true;
          } while (current = adapter.getParent(current));
          return false;
        };
      }
      case css_what_1.SelectorType.Parent: {
        return function parent(elem) {
          return adapter.getChildren(elem).some(function(elem2) {
            return adapter.isTag(elem2) && next(elem2);
          });
        };
      }
      case css_what_1.SelectorType.Child: {
        return function child(elem) {
          var parent = adapter.getParent(elem);
          return parent != null && adapter.isTag(parent) && next(parent);
        };
      }
      case css_what_1.SelectorType.Sibling: {
        return function sibling(elem) {
          var siblings = adapter.getSiblings(elem);
          for (var i = 0; i < siblings.length; i++) {
            var currentSibling = siblings[i];
            if (equals2(elem, currentSibling)) break;
            if (adapter.isTag(currentSibling) && next(currentSibling)) {
              return true;
            }
          }
          return false;
        };
      }
      case css_what_1.SelectorType.Adjacent: {
        if (adapter.prevElementSibling) {
          return function adjacent(elem) {
            var previous = adapter.prevElementSibling(elem);
            return previous != null && next(previous);
          };
        }
        return function adjacent(elem) {
          var siblings = adapter.getSiblings(elem);
          var lastElement;
          for (var i = 0; i < siblings.length; i++) {
            var currentSibling = siblings[i];
            if (equals2(elem, currentSibling)) break;
            if (adapter.isTag(currentSibling)) {
              lastElement = currentSibling;
            }
          }
          return !!lastElement && next(lastElement);
        };
      }
      case css_what_1.SelectorType.Universal: {
        if (selector2.namespace != null && selector2.namespace !== "*") {
          throw new Error("Namespaced universal selectors are not yet supported by css-select");
        }
        return next;
      }
    }
  }
  general.compileGeneralSelector = compileGeneralSelector;
  return general;
}
var hasRequiredCompile$1;
function requireCompile$1() {
  if (hasRequiredCompile$1) return compile$1;
  hasRequiredCompile$1 = 1;
  var __importDefault2 = compile$1 && compile$1.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(compile$1, "__esModule", {
    value: true
  });
  compile$1.compileToken = compile$1.compileUnsafe = compile$1.compile = void 0;
  var css_what_1 = require$$0$3;
  var boolbase_1 = requireBoolbase();
  var sort_1 = __importDefault2(requireSort$1());
  var procedure_1 = requireProcedure();
  var general_1 = requireGeneral();
  var subselects_1 = requireSubselects();
  function compile2(selector2, options2, context) {
    var next = compileUnsafe(selector2, options2, context);
    return (0, subselects_1.ensureIsTag)(next, options2.adapter);
  }
  compile$1.compile = compile2;
  function compileUnsafe(selector2, options2, context) {
    var token = typeof selector2 === "string" ? (0, css_what_1.parse)(selector2) : selector2;
    return compileToken(token, options2, context);
  }
  compile$1.compileUnsafe = compileUnsafe;
  function includesScopePseudo(t) {
    return t.type === "pseudo" && (t.name === "scope" || Array.isArray(t.data) && t.data.some(function(data2) {
      return data2.some(includesScopePseudo);
    }));
  }
  var DESCENDANT_TOKEN = {
    type: css_what_1.SelectorType.Descendant
  };
  var FLEXIBLE_DESCENDANT_TOKEN = {
    type: "_flexibleDescendant"
  };
  var SCOPE_TOKEN = {
    type: css_what_1.SelectorType.Pseudo,
    name: "scope",
    data: null
  };
  function absolutize(token, _a, context) {
    var adapter = _a.adapter;
    var hasContext = !!(context === null || context === void 0 ? void 0 : context.every(function(e) {
      var parent = adapter.isTag(e) && adapter.getParent(e);
      return e === subselects_1.PLACEHOLDER_ELEMENT || parent && adapter.isTag(parent);
    }));
    for (var _i = 0, token_1 = token; _i < token_1.length; _i++) {
      var t = token_1[_i];
      if (t.length > 0 && (0, procedure_1.isTraversal)(t[0]) && t[0].type !== "descendant") ;
      else if (hasContext && !t.some(includesScopePseudo)) {
        t.unshift(DESCENDANT_TOKEN);
      } else {
        continue;
      }
      t.unshift(SCOPE_TOKEN);
    }
  }
  function compileToken(token, options2, context) {
    var _a;
    token = token.filter(function(t) {
      return t.length > 0;
    });
    token.forEach(sort_1.default);
    context = (_a = options2.context) !== null && _a !== void 0 ? _a : context;
    var isArrayContext = Array.isArray(context);
    var finalContext = context && (Array.isArray(context) ? context : [context]);
    absolutize(token, options2, finalContext);
    var shouldTestNextSiblings = false;
    var query = token.map(function(rules2) {
      if (rules2.length >= 2) {
        var first = rules2[0], second2 = rules2[1];
        if (first.type !== "pseudo" || first.name !== "scope") ;
        else if (isArrayContext && second2.type === "descendant") {
          rules2[1] = FLEXIBLE_DESCENDANT_TOKEN;
        } else if (second2.type === "adjacent" || second2.type === "sibling") {
          shouldTestNextSiblings = true;
        }
      }
      return compileRules(rules2, options2, finalContext);
    }).reduce(reduceRules, boolbase_1.falseFunc);
    query.shouldTestNextSiblings = shouldTestNextSiblings;
    return query;
  }
  compile$1.compileToken = compileToken;
  function compileRules(rules2, options2, context) {
    var _a;
    return rules2.reduce(function(previous, rule) {
      return previous === boolbase_1.falseFunc ? boolbase_1.falseFunc : (0, general_1.compileGeneralSelector)(previous, rule, options2, context, compileToken);
    }, (_a = options2.rootFunc) !== null && _a !== void 0 ? _a : boolbase_1.trueFunc);
  }
  function reduceRules(a, b) {
    if (b === boolbase_1.falseFunc || a === boolbase_1.trueFunc) {
      return a;
    }
    if (a === boolbase_1.falseFunc || b === boolbase_1.trueFunc) {
      return b;
    }
    return function combine(elem) {
      return a(elem) || b(elem);
    };
  }
  return compile$1;
}
var hasRequiredLib$7;
function requireLib$7() {
  if (hasRequiredLib$7) return lib$b;
  hasRequiredLib$7 = 1;
  (function(exports2) {
    var __createBinding2 = lib$b && lib$b.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
          enumerable: true,
          get: function() {
            return m[k];
          }
        };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault2 = lib$b && lib$b.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
      });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar2 = lib$b && lib$b.__importStar || function(mod2) {
      if (mod2 && mod2.__esModule) return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k in mod2) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k)) __createBinding2(result, mod2, k);
      }
      __setModuleDefault2(result, mod2);
      return result;
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.aliases = exports2.pseudos = exports2.filters = exports2.is = exports2.selectOne = exports2.selectAll = exports2.prepareContext = exports2._compileToken = exports2._compileUnsafe = exports2.compile = void 0;
    var DomUtils = __importStar2(/* @__PURE__ */ requireLib$9());
    var boolbase_1 = requireBoolbase();
    var compile_12 = requireCompile$1();
    var subselects_1 = requireSubselects();
    var defaultEquals = function(a, b) {
      return a === b;
    };
    var defaultOptions2 = {
      adapter: DomUtils,
      equals: defaultEquals
    };
    function convertOptionFormats(options2) {
      var _a, _b, _c, _d;
      var opts = options2 !== null && options2 !== void 0 ? options2 : defaultOptions2;
      (_a = opts.adapter) !== null && _a !== void 0 ? _a : opts.adapter = DomUtils;
      (_b = opts.equals) !== null && _b !== void 0 ? _b : opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : defaultEquals;
      return opts;
    }
    function wrapCompile(func) {
      return function addAdapter(selector2, options2, context) {
        var opts = convertOptionFormats(options2);
        return func(selector2, opts, context);
      };
    }
    exports2.compile = wrapCompile(compile_12.compile);
    exports2._compileUnsafe = wrapCompile(compile_12.compileUnsafe);
    exports2._compileToken = wrapCompile(compile_12.compileToken);
    function getSelectorFunc(searchFunc) {
      return function select2(query, elements, options2) {
        var opts = convertOptionFormats(options2);
        if (typeof query !== "function") {
          query = (0, compile_12.compileUnsafe)(query, opts, elements);
        }
        var filteredElements = prepareContext(elements, opts.adapter, query.shouldTestNextSiblings);
        return searchFunc(query, filteredElements, opts);
      };
    }
    function prepareContext(elems, adapter, shouldTestNextSiblings) {
      if (shouldTestNextSiblings === void 0) {
        shouldTestNextSiblings = false;
      }
      if (shouldTestNextSiblings) {
        elems = appendNextSiblings(elems, adapter);
      }
      return Array.isArray(elems) ? adapter.removeSubsets(elems) : adapter.getChildren(elems);
    }
    exports2.prepareContext = prepareContext;
    function appendNextSiblings(elem, adapter) {
      var elems = Array.isArray(elem) ? elem.slice(0) : [elem];
      var elemsLength = elems.length;
      for (var i = 0; i < elemsLength; i++) {
        var nextSiblings = (0, subselects_1.getNextSiblings)(elems[i], adapter);
        elems.push.apply(elems, nextSiblings);
      }
      return elems;
    }
    exports2.selectAll = getSelectorFunc(function(query, elems, options2) {
      return query === boolbase_1.falseFunc || !elems || elems.length === 0 ? [] : options2.adapter.findAll(query, elems);
    });
    exports2.selectOne = getSelectorFunc(function(query, elems, options2) {
      return query === boolbase_1.falseFunc || !elems || elems.length === 0 ? null : options2.adapter.findOne(query, elems);
    });
    function is(elem, query, options2) {
      var opts = convertOptionFormats(options2);
      return (typeof query === "function" ? query : (0, compile_12.compile)(query, opts))(elem);
    }
    exports2.is = is;
    exports2.default = exports2.selectAll;
    var pseudo_selectors_1 = requirePseudoSelectors();
    Object.defineProperty(exports2, "filters", {
      enumerable: true,
      get: function() {
        return pseudo_selectors_1.filters;
      }
    });
    Object.defineProperty(exports2, "pseudos", {
      enumerable: true,
      get: function() {
        return pseudo_selectors_1.pseudos;
      }
    });
    Object.defineProperty(exports2, "aliases", {
      enumerable: true,
      get: function() {
        return pseudo_selectors_1.aliases;
      }
    });
  })(lib$b);
  return lib$b;
}
var helpers = {};
var positionals = {};
var hasRequiredPositionals;
function requirePositionals() {
  if (hasRequiredPositionals) return positionals;
  hasRequiredPositionals = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.getLimit = exports2.isFilter = exports2.filterNames = void 0;
    exports2.filterNames = /* @__PURE__ */ new Set(["first", "last", "eq", "gt", "nth", "lt", "even", "odd"]);
    function isFilter(s) {
      if (s.type !== "pseudo") return false;
      if (exports2.filterNames.has(s.name)) return true;
      if (s.name === "not" && Array.isArray(s.data)) {
        return s.data.some(function(s2) {
          return s2.some(isFilter);
        });
      }
      return false;
    }
    exports2.isFilter = isFilter;
    function getLimit(filter2, data2) {
      var num2 = data2 != null ? parseInt(data2, 10) : NaN;
      switch (filter2) {
        case "first":
          return 1;
        case "nth":
        case "eq":
          return isFinite(num2) ? num2 >= 0 ? num2 + 1 : Infinity : 0;
        case "lt":
          return isFinite(num2) ? num2 >= 0 ? num2 : Infinity : 0;
        case "gt":
          return isFinite(num2) ? Infinity : 0;
        default:
          return Infinity;
      }
    }
    exports2.getLimit = getLimit;
  })(positionals);
  return positionals;
}
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1;
  Object.defineProperty(helpers, "__esModule", {
    value: true
  });
  helpers.groupSelectors = helpers.getDocumentRoot = void 0;
  var positionals_1 = /* @__PURE__ */ requirePositionals();
  function getDocumentRoot(node2) {
    while (node2.parent) node2 = node2.parent;
    return node2;
  }
  helpers.getDocumentRoot = getDocumentRoot;
  function groupSelectors(selectors2) {
    var filteredSelectors = [];
    var plainSelectors = [];
    for (var _i = 0, selectors_1 = selectors2; _i < selectors_1.length; _i++) {
      var selector2 = selectors_1[_i];
      if (selector2.some(positionals_1.isFilter)) {
        filteredSelectors.push(selector2);
      } else {
        plainSelectors.push(selector2);
      }
    }
    return [plainSelectors, filteredSelectors];
  }
  helpers.groupSelectors = groupSelectors;
  return helpers;
}
var hasRequiredLib$6;
function requireLib$6() {
  if (hasRequiredLib$6) return lib$c;
  hasRequiredLib$6 = 1;
  (function(exports2) {
    var __assign2 = lib$c && lib$c.__assign || function() {
      __assign2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return __assign2.apply(this, arguments);
    };
    var __createBinding2 = lib$c && lib$c.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
          enumerable: true,
          get: function() {
            return m[k];
          }
        };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault2 = lib$c && lib$c.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
      });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar2 = lib$c && lib$c.__importStar || function(mod2) {
      if (mod2 && mod2.__esModule) return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k in mod2) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k)) __createBinding2(result, mod2, k);
      }
      __setModuleDefault2(result, mod2);
      return result;
    };
    var __spreadArray2 = lib$c && lib$c.__spreadArray || function(to, from, pack) {
      if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
      return to.concat(ar || Array.prototype.slice.call(from));
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.select = exports2.filter = exports2.some = exports2.is = exports2.aliases = exports2.pseudos = exports2.filters = void 0;
    var css_what_1 = require$$0$3;
    var css_select_1 = requireLib$7();
    var DomUtils = __importStar2(/* @__PURE__ */ requireLib$9());
    var helpers_1 = /* @__PURE__ */ requireHelpers();
    var positionals_1 = /* @__PURE__ */ requirePositionals();
    var css_select_2 = requireLib$7();
    Object.defineProperty(exports2, "filters", {
      enumerable: true,
      get: function() {
        return css_select_2.filters;
      }
    });
    Object.defineProperty(exports2, "pseudos", {
      enumerable: true,
      get: function() {
        return css_select_2.pseudos;
      }
    });
    Object.defineProperty(exports2, "aliases", {
      enumerable: true,
      get: function() {
        return css_select_2.aliases;
      }
    });
    var SCOPE_PSEUDO = {
      type: css_what_1.SelectorType.Pseudo,
      name: "scope",
      data: null
    };
    var CUSTOM_SCOPE_PSEUDO = __assign2({}, SCOPE_PSEUDO);
    var UNIVERSAL_SELECTOR = {
      type: css_what_1.SelectorType.Universal,
      namespace: null
    };
    function is(element, selector2, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      return some2([element], selector2, options2);
    }
    exports2.is = is;
    function some2(elements, selector2, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      if (typeof selector2 === "function") return elements.some(selector2);
      var _a = (0, helpers_1.groupSelectors)((0, css_what_1.parse)(selector2)), plain = _a[0], filtered = _a[1];
      return plain.length > 0 && elements.some((0, css_select_1._compileToken)(plain, options2)) || filtered.some(function(sel) {
        return filterBySelector(sel, elements, options2).length > 0;
      });
    }
    exports2.some = some2;
    function filterByPosition(filter3, elems, data2, options2) {
      var num2 = typeof data2 === "string" ? parseInt(data2, 10) : NaN;
      switch (filter3) {
        case "first":
        case "lt":
          return elems;
        case "last":
          return elems.length > 0 ? [elems[elems.length - 1]] : elems;
        case "nth":
        case "eq":
          return isFinite(num2) && Math.abs(num2) < elems.length ? [num2 < 0 ? elems[elems.length + num2] : elems[num2]] : [];
        case "gt":
          return isFinite(num2) ? elems.slice(num2 + 1) : [];
        case "even":
          return elems.filter(function(_, i) {
            return i % 2 === 0;
          });
        case "odd":
          return elems.filter(function(_, i) {
            return i % 2 === 1;
          });
        case "not": {
          var filtered_1 = new Set(filterParsed(data2, elems, options2));
          return elems.filter(function(e) {
            return !filtered_1.has(e);
          });
        }
      }
    }
    function filter2(selector2, elements, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      return filterParsed((0, css_what_1.parse)(selector2), elements, options2);
    }
    exports2.filter = filter2;
    function filterParsed(selector2, elements, options2) {
      if (elements.length === 0) return [];
      var _a = (0, helpers_1.groupSelectors)(selector2), plainSelectors = _a[0], filteredSelectors = _a[1];
      var found;
      if (plainSelectors.length) {
        var filtered = filterElements(elements, plainSelectors, options2);
        if (filteredSelectors.length === 0) {
          return filtered;
        }
        if (filtered.length) {
          found = new Set(filtered);
        }
      }
      for (var i = 0; i < filteredSelectors.length && (found === null || found === void 0 ? void 0 : found.size) !== elements.length; i++) {
        var filteredSelector = filteredSelectors[i];
        var missing = found ? elements.filter(function(e) {
          return DomUtils.isTag(e) && !found.has(e);
        }) : elements;
        if (missing.length === 0) break;
        var filtered = filterBySelector(filteredSelector, elements, options2);
        if (filtered.length) {
          if (!found) {
            if (i === filteredSelectors.length - 1) {
              return filtered;
            }
            found = new Set(filtered);
          } else {
            filtered.forEach(function(el2) {
              return found.add(el2);
            });
          }
        }
      }
      return typeof found !== "undefined" ? found.size === elements.length ? elements : (
        // Filter elements to preserve order
        elements.filter(function(el2) {
          return found.has(el2);
        })
      ) : [];
    }
    function filterBySelector(selector2, elements, options2) {
      var _a;
      if (selector2.some(css_what_1.isTraversal)) {
        var root2 = (_a = options2.root) !== null && _a !== void 0 ? _a : (0, helpers_1.getDocumentRoot)(elements[0]);
        var sel = __spreadArray2(__spreadArray2([], selector2, true), [CUSTOM_SCOPE_PSEUDO], false);
        return findFilterElements(root2, sel, options2, true, elements);
      }
      return findFilterElements(elements, selector2, options2, false);
    }
    function select2(selector2, root2, options2) {
      if (options2 === void 0) {
        options2 = {};
      }
      if (typeof selector2 === "function") {
        return find2(root2, selector2);
      }
      var _a = (0, helpers_1.groupSelectors)((0, css_what_1.parse)(selector2)), plain = _a[0], filtered = _a[1];
      var results = filtered.map(function(sel) {
        return findFilterElements(root2, sel, options2, true);
      });
      if (plain.length) {
        results.push(findElements(root2, plain, options2, Infinity));
      }
      if (results.length === 0) {
        return [];
      }
      if (results.length === 1) {
        return results[0];
      }
      return DomUtils.uniqueSort(results.reduce(function(a, b) {
        return __spreadArray2(__spreadArray2([], a, true), b, true);
      }));
    }
    exports2.select = select2;
    var specialTraversal = /* @__PURE__ */ new Set([css_what_1.SelectorType.Descendant, css_what_1.SelectorType.Adjacent]);
    function includesScopePseudo(t) {
      return t !== SCOPE_PSEUDO && t.type === "pseudo" && (t.name === "scope" || Array.isArray(t.data) && t.data.some(function(data2) {
        return data2.some(includesScopePseudo);
      }));
    }
    function addContextIfScope(selector2, options2, scopeContext) {
      return scopeContext && selector2.some(includesScopePseudo) ? __assign2(__assign2({}, options2), {
        context: scopeContext
      }) : options2;
    }
    function findFilterElements(root2, selector2, options2, queryForSelector, scopeContext) {
      var filterIndex = selector2.findIndex(positionals_1.isFilter);
      var sub2 = selector2.slice(0, filterIndex);
      var filter3 = selector2[filterIndex];
      var limit = (0, positionals_1.getLimit)(filter3.name, filter3.data);
      if (limit === 0) return [];
      var subOpts = addContextIfScope(sub2, options2, scopeContext);
      var elemsNoLimit = sub2.length === 0 && !Array.isArray(root2) ? DomUtils.getChildren(root2).filter(DomUtils.isTag) : sub2.length === 0 || sub2.length === 1 && sub2[0] === SCOPE_PSEUDO ? (Array.isArray(root2) ? root2 : [root2]).filter(DomUtils.isTag) : queryForSelector || sub2.some(css_what_1.isTraversal) ? findElements(root2, [sub2], subOpts, limit) : filterElements(root2, [sub2], subOpts);
      var elems = elemsNoLimit.slice(0, limit);
      var result = filterByPosition(filter3.name, elems, filter3.data, options2);
      if (result.length === 0 || selector2.length === filterIndex + 1) {
        return result;
      }
      var remainingSelector = selector2.slice(filterIndex + 1);
      var remainingHasTraversal = remainingSelector.some(css_what_1.isTraversal);
      var remainingOpts = addContextIfScope(remainingSelector, options2, scopeContext);
      if (remainingHasTraversal) {
        if (specialTraversal.has(remainingSelector[0].type)) {
          remainingSelector.unshift(UNIVERSAL_SELECTOR);
        }
        remainingSelector.unshift(SCOPE_PSEUDO);
      }
      return remainingSelector.some(positionals_1.isFilter) ? findFilterElements(result, remainingSelector, options2, false, scopeContext) : remainingHasTraversal ? (
        // Query existing elements to resolve traversal.
        findElements(result, [remainingSelector], remainingOpts, Infinity)
      ) : (
        // If we don't have any more traversals, simply filter elements.
        filterElements(result, [remainingSelector], remainingOpts)
      );
    }
    function findElements(root2, sel, options2, limit) {
      if (limit === 0) return [];
      var query = (0, css_select_1._compileToken)(sel, options2, root2);
      return find2(root2, query, limit);
    }
    function find2(root2, query, limit) {
      if (limit === void 0) {
        limit = Infinity;
      }
      var elems = (0, css_select_1.prepareContext)(root2, DomUtils, query.shouldTestNextSiblings);
      return DomUtils.find(function(node2) {
        return DomUtils.isTag(node2) && query(node2);
      }, elems, true, limit);
    }
    function filterElements(elements, sel, options2) {
      var els2 = (Array.isArray(elements) ? elements : [elements]).filter(DomUtils.isTag);
      if (els2.length === 0) return els2;
      var query = (0, css_select_1._compileToken)(sel, options2);
      return els2.filter(query);
    }
  })(lib$c);
  return lib$c;
}
var lib$4 = {};
var Parser = {};
var Tokenizer = {};
var hasRequiredTokenizer$1;
function requireTokenizer$1() {
  if (hasRequiredTokenizer$1) return Tokenizer;
  hasRequiredTokenizer$1 = 1;
  var __importDefault2 = Tokenizer && Tokenizer.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(Tokenizer, "__esModule", {
    value: true
  });
  var decode_codepoint_1 = __importDefault2(/* @__PURE__ */ requireDecode_codepoint());
  var entities_json_1 = __importDefault2(require$$1$1);
  var legacy_json_1 = __importDefault2(require$$2$1);
  var xml_json_1 = __importDefault2(require$$3$1);
  function whitespace(c) {
    return c === " " || c === "\n" || c === "	" || c === "\f" || c === "\r";
  }
  function isASCIIAlpha(c) {
    return c >= "a" && c <= "z" || c >= "A" && c <= "Z";
  }
  function ifElseState(upper, SUCCESS, FAILURE) {
    var lower2 = upper.toLowerCase();
    if (upper === lower2) {
      return function(t, c) {
        if (c === lower2) {
          t._state = SUCCESS;
        } else {
          t._state = FAILURE;
          t._index--;
        }
      };
    }
    return function(t, c) {
      if (c === lower2 || c === upper) {
        t._state = SUCCESS;
      } else {
        t._state = FAILURE;
        t._index--;
      }
    };
  }
  function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower2 = upper.toLowerCase();
    return function(t, c) {
      if (c === lower2 || c === upper) {
        t._state = NEXT_STATE;
      } else {
        t._state = 3;
        t._index--;
      }
    };
  }
  var stateBeforeCdata1 = ifElseState(
    "C",
    24,
    16
    /* InDeclaration */
  );
  var stateBeforeCdata2 = ifElseState(
    "D",
    25,
    16
    /* InDeclaration */
  );
  var stateBeforeCdata3 = ifElseState(
    "A",
    26,
    16
    /* InDeclaration */
  );
  var stateBeforeCdata4 = ifElseState(
    "T",
    27,
    16
    /* InDeclaration */
  );
  var stateBeforeCdata5 = ifElseState(
    "A",
    28,
    16
    /* InDeclaration */
  );
  var stateBeforeScript1 = consumeSpecialNameChar(
    "R",
    35
    /* BeforeScript2 */
  );
  var stateBeforeScript2 = consumeSpecialNameChar(
    "I",
    36
    /* BeforeScript3 */
  );
  var stateBeforeScript3 = consumeSpecialNameChar(
    "P",
    37
    /* BeforeScript4 */
  );
  var stateBeforeScript4 = consumeSpecialNameChar(
    "T",
    38
    /* BeforeScript5 */
  );
  var stateAfterScript1 = ifElseState(
    "R",
    40,
    1
    /* Text */
  );
  var stateAfterScript2 = ifElseState(
    "I",
    41,
    1
    /* Text */
  );
  var stateAfterScript3 = ifElseState(
    "P",
    42,
    1
    /* Text */
  );
  var stateAfterScript4 = ifElseState(
    "T",
    43,
    1
    /* Text */
  );
  var stateBeforeStyle1 = consumeSpecialNameChar(
    "Y",
    45
    /* BeforeStyle2 */
  );
  var stateBeforeStyle2 = consumeSpecialNameChar(
    "L",
    46
    /* BeforeStyle3 */
  );
  var stateBeforeStyle3 = consumeSpecialNameChar(
    "E",
    47
    /* BeforeStyle4 */
  );
  var stateAfterStyle1 = ifElseState(
    "Y",
    49,
    1
    /* Text */
  );
  var stateAfterStyle2 = ifElseState(
    "L",
    50,
    1
    /* Text */
  );
  var stateAfterStyle3 = ifElseState(
    "E",
    51,
    1
    /* Text */
  );
  var stateBeforeSpecialT = consumeSpecialNameChar(
    "I",
    54
    /* BeforeTitle1 */
  );
  var stateBeforeTitle1 = consumeSpecialNameChar(
    "T",
    55
    /* BeforeTitle2 */
  );
  var stateBeforeTitle2 = consumeSpecialNameChar(
    "L",
    56
    /* BeforeTitle3 */
  );
  var stateBeforeTitle3 = consumeSpecialNameChar(
    "E",
    57
    /* BeforeTitle4 */
  );
  var stateAfterSpecialTEnd = ifElseState(
    "I",
    58,
    1
    /* Text */
  );
  var stateAfterTitle1 = ifElseState(
    "T",
    59,
    1
    /* Text */
  );
  var stateAfterTitle2 = ifElseState(
    "L",
    60,
    1
    /* Text */
  );
  var stateAfterTitle3 = ifElseState(
    "E",
    61,
    1
    /* Text */
  );
  var stateBeforeEntity = ifElseState(
    "#",
    63,
    64
    /* InNamedEntity */
  );
  var stateBeforeNumericEntity = ifElseState(
    "X",
    66,
    65
    /* InNumericEntity */
  );
  var Tokenizer$1 = (
    /** @class */
    (function() {
      function Tokenizer2(options2, cbs) {
        var _a;
        this._state = 1;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1;
        this.special = 1;
        this.running = true;
        this.ended = false;
        this.cbs = cbs;
        this.xmlMode = !!(options2 === null || options2 === void 0 ? void 0 : options2.xmlMode);
        this.decodeEntities = (_a = options2 === null || options2 === void 0 ? void 0 : options2.decodeEntities) !== null && _a !== void 0 ? _a : true;
      }
      Tokenizer2.prototype.reset = function() {
        this._state = 1;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1;
        this.special = 1;
        this.running = true;
        this.ended = false;
      };
      Tokenizer2.prototype.write = function(chunk) {
        if (this.ended) this.cbs.onerror(Error(".write() after done!"));
        this.buffer += chunk;
        this.parse();
      };
      Tokenizer2.prototype.end = function(chunk) {
        if (this.ended) this.cbs.onerror(Error(".end() after done!"));
        if (chunk) this.write(chunk);
        this.ended = true;
        if (this.running) this.finish();
      };
      Tokenizer2.prototype.pause = function() {
        this.running = false;
      };
      Tokenizer2.prototype.resume = function() {
        this.running = true;
        if (this._index < this.buffer.length) {
          this.parse();
        }
        if (this.ended) {
          this.finish();
        }
      };
      Tokenizer2.prototype.getAbsoluteIndex = function() {
        return this.bufferOffset + this._index;
      };
      Tokenizer2.prototype.stateText = function(c) {
        if (c === "<") {
          if (this._index > this.sectionStart) {
            this.cbs.ontext(this.getSection());
          }
          this._state = 2;
          this.sectionStart = this._index;
        } else if (this.decodeEntities && c === "&" && (this.special === 1 || this.special === 4)) {
          if (this._index > this.sectionStart) {
            this.cbs.ontext(this.getSection());
          }
          this.baseState = 1;
          this._state = 62;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.isTagStartChar = function(c) {
        return isASCIIAlpha(c) || this.xmlMode && !whitespace(c) && c !== "/" && c !== ">";
      };
      Tokenizer2.prototype.stateBeforeTagName = function(c) {
        if (c === "/") {
          this._state = 5;
        } else if (c === "<") {
          this.cbs.ontext(this.getSection());
          this.sectionStart = this._index;
        } else if (c === ">" || this.special !== 1 || whitespace(c)) {
          this._state = 1;
        } else if (c === "!") {
          this._state = 15;
          this.sectionStart = this._index + 1;
        } else if (c === "?") {
          this._state = 17;
          this.sectionStart = this._index + 1;
        } else if (!this.isTagStartChar(c)) {
          this._state = 1;
        } else {
          this._state = !this.xmlMode && (c === "s" || c === "S") ? 32 : !this.xmlMode && (c === "t" || c === "T") ? 52 : 3;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.stateInTagName = function(c) {
        if (c === "/" || c === ">" || whitespace(c)) {
          this.emitToken("onopentagname");
          this._state = 8;
          this._index--;
        }
      };
      Tokenizer2.prototype.stateBeforeClosingTagName = function(c) {
        if (whitespace(c)) ;
        else if (c === ">") {
          this._state = 1;
        } else if (this.special !== 1) {
          if (this.special !== 4 && (c === "s" || c === "S")) {
            this._state = 33;
          } else if (this.special === 4 && (c === "t" || c === "T")) {
            this._state = 53;
          } else {
            this._state = 1;
            this._index--;
          }
        } else if (!this.isTagStartChar(c)) {
          this._state = 20;
          this.sectionStart = this._index;
        } else {
          this._state = 6;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.stateInClosingTagName = function(c) {
        if (c === ">" || whitespace(c)) {
          this.emitToken("onclosetag");
          this._state = 7;
          this._index--;
        }
      };
      Tokenizer2.prototype.stateAfterClosingTagName = function(c) {
        if (c === ">") {
          this._state = 1;
          this.sectionStart = this._index + 1;
        }
      };
      Tokenizer2.prototype.stateBeforeAttributeName = function(c) {
        if (c === ">") {
          this.cbs.onopentagend();
          this._state = 1;
          this.sectionStart = this._index + 1;
        } else if (c === "/") {
          this._state = 4;
        } else if (!whitespace(c)) {
          this._state = 9;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.stateInSelfClosingTag = function(c) {
        if (c === ">") {
          this.cbs.onselfclosingtag();
          this._state = 1;
          this.sectionStart = this._index + 1;
          this.special = 1;
        } else if (!whitespace(c)) {
          this._state = 8;
          this._index--;
        }
      };
      Tokenizer2.prototype.stateInAttributeName = function(c) {
        if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
          this.cbs.onattribname(this.getSection());
          this.sectionStart = -1;
          this._state = 10;
          this._index--;
        }
      };
      Tokenizer2.prototype.stateAfterAttributeName = function(c) {
        if (c === "=") {
          this._state = 11;
        } else if (c === "/" || c === ">") {
          this.cbs.onattribend(void 0);
          this._state = 8;
          this._index--;
        } else if (!whitespace(c)) {
          this.cbs.onattribend(void 0);
          this._state = 9;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.stateBeforeAttributeValue = function(c) {
        if (c === '"') {
          this._state = 12;
          this.sectionStart = this._index + 1;
        } else if (c === "'") {
          this._state = 13;
          this.sectionStart = this._index + 1;
        } else if (!whitespace(c)) {
          this._state = 14;
          this.sectionStart = this._index;
          this._index--;
        }
      };
      Tokenizer2.prototype.handleInAttributeValue = function(c, quote) {
        if (c === quote) {
          this.emitToken("onattribdata");
          this.cbs.onattribend(quote);
          this._state = 8;
        } else if (this.decodeEntities && c === "&") {
          this.emitToken("onattribdata");
          this.baseState = this._state;
          this._state = 62;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, '"');
      };
      Tokenizer2.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, "'");
      };
      Tokenizer2.prototype.stateInAttributeValueNoQuotes = function(c) {
        if (whitespace(c) || c === ">") {
          this.emitToken("onattribdata");
          this.cbs.onattribend(null);
          this._state = 8;
          this._index--;
        } else if (this.decodeEntities && c === "&") {
          this.emitToken("onattribdata");
          this.baseState = this._state;
          this._state = 62;
          this.sectionStart = this._index;
        }
      };
      Tokenizer2.prototype.stateBeforeDeclaration = function(c) {
        this._state = c === "[" ? 23 : c === "-" ? 18 : 16;
      };
      Tokenizer2.prototype.stateInDeclaration = function(c) {
        if (c === ">") {
          this.cbs.ondeclaration(this.getSection());
          this._state = 1;
          this.sectionStart = this._index + 1;
        }
      };
      Tokenizer2.prototype.stateInProcessingInstruction = function(c) {
        if (c === ">") {
          this.cbs.onprocessinginstruction(this.getSection());
          this._state = 1;
          this.sectionStart = this._index + 1;
        }
      };
      Tokenizer2.prototype.stateBeforeComment = function(c) {
        if (c === "-") {
          this._state = 19;
          this.sectionStart = this._index + 1;
        } else {
          this._state = 16;
        }
      };
      Tokenizer2.prototype.stateInComment = function(c) {
        if (c === "-") this._state = 21;
      };
      Tokenizer2.prototype.stateInSpecialComment = function(c) {
        if (c === ">") {
          this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index));
          this._state = 1;
          this.sectionStart = this._index + 1;
        }
      };
      Tokenizer2.prototype.stateAfterComment1 = function(c) {
        if (c === "-") {
          this._state = 22;
        } else {
          this._state = 19;
        }
      };
      Tokenizer2.prototype.stateAfterComment2 = function(c) {
        if (c === ">") {
          this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index - 2));
          this._state = 1;
          this.sectionStart = this._index + 1;
        } else if (c !== "-") {
          this._state = 19;
        }
      };
      Tokenizer2.prototype.stateBeforeCdata6 = function(c) {
        if (c === "[") {
          this._state = 29;
          this.sectionStart = this._index + 1;
        } else {
          this._state = 16;
          this._index--;
        }
      };
      Tokenizer2.prototype.stateInCdata = function(c) {
        if (c === "]") this._state = 30;
      };
      Tokenizer2.prototype.stateAfterCdata1 = function(c) {
        if (c === "]") this._state = 31;
        else this._state = 29;
      };
      Tokenizer2.prototype.stateAfterCdata2 = function(c) {
        if (c === ">") {
          this.cbs.oncdata(this.buffer.substring(this.sectionStart, this._index - 2));
          this._state = 1;
          this.sectionStart = this._index + 1;
        } else if (c !== "]") {
          this._state = 29;
        }
      };
      Tokenizer2.prototype.stateBeforeSpecialS = function(c) {
        if (c === "c" || c === "C") {
          this._state = 34;
        } else if (c === "t" || c === "T") {
          this._state = 44;
        } else {
          this._state = 3;
          this._index--;
        }
      };
      Tokenizer2.prototype.stateBeforeSpecialSEnd = function(c) {
        if (this.special === 2 && (c === "c" || c === "C")) {
          this._state = 39;
        } else if (this.special === 3 && (c === "t" || c === "T")) {
          this._state = 48;
        } else this._state = 1;
      };
      Tokenizer2.prototype.stateBeforeSpecialLast = function(c, special) {
        if (c === "/" || c === ">" || whitespace(c)) {
          this.special = special;
        }
        this._state = 3;
        this._index--;
      };
      Tokenizer2.prototype.stateAfterSpecialLast = function(c, sectionStartOffset) {
        if (c === ">" || whitespace(c)) {
          this.special = 1;
          this._state = 6;
          this.sectionStart = this._index - sectionStartOffset;
          this._index--;
        } else this._state = 1;
      };
      Tokenizer2.prototype.parseFixedEntity = function(map2) {
        if (map2 === void 0) {
          map2 = this.xmlMode ? xml_json_1.default : entities_json_1.default;
        }
        if (this.sectionStart + 1 < this._index) {
          var entity = this.buffer.substring(this.sectionStart + 1, this._index);
          if (Object.prototype.hasOwnProperty.call(map2, entity)) {
            this.emitPartial(map2[entity]);
            this.sectionStart = this._index + 1;
          }
        }
      };
      Tokenizer2.prototype.parseLegacyEntity = function() {
        var start2 = this.sectionStart + 1;
        var limit = Math.min(this._index - start2, 6);
        while (limit >= 2) {
          var entity = this.buffer.substr(start2, limit);
          if (Object.prototype.hasOwnProperty.call(legacy_json_1.default, entity)) {
            this.emitPartial(legacy_json_1.default[entity]);
            this.sectionStart += limit + 1;
            return;
          }
          limit--;
        }
      };
      Tokenizer2.prototype.stateInNamedEntity = function(c) {
        if (c === ";") {
          this.parseFixedEntity();
          if (this.baseState === 1 && this.sectionStart + 1 < this._index && !this.xmlMode) {
            this.parseLegacyEntity();
          }
          this._state = this.baseState;
        } else if ((c < "0" || c > "9") && !isASCIIAlpha(c)) {
          if (this.xmlMode || this.sectionStart + 1 === this._index) ;
          else if (this.baseState !== 1) {
            if (c !== "=") {
              this.parseFixedEntity(legacy_json_1.default);
            }
          } else {
            this.parseLegacyEntity();
          }
          this._state = this.baseState;
          this._index--;
        }
      };
      Tokenizer2.prototype.decodeNumericEntity = function(offset, base, strict) {
        var sectionStart = this.sectionStart + offset;
        if (sectionStart !== this._index) {
          var entity = this.buffer.substring(sectionStart, this._index);
          var parsed = parseInt(entity, base);
          this.emitPartial(decode_codepoint_1.default(parsed));
          this.sectionStart = strict ? this._index + 1 : this._index;
        }
        this._state = this.baseState;
      };
      Tokenizer2.prototype.stateInNumericEntity = function(c) {
        if (c === ";") {
          this.decodeNumericEntity(2, 10, true);
        } else if (c < "0" || c > "9") {
          if (!this.xmlMode) {
            this.decodeNumericEntity(2, 10, false);
          } else {
            this._state = this.baseState;
          }
          this._index--;
        }
      };
      Tokenizer2.prototype.stateInHexEntity = function(c) {
        if (c === ";") {
          this.decodeNumericEntity(3, 16, true);
        } else if ((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")) {
          if (!this.xmlMode) {
            this.decodeNumericEntity(3, 16, false);
          } else {
            this._state = this.baseState;
          }
          this._index--;
        }
      };
      Tokenizer2.prototype.cleanup = function() {
        if (this.sectionStart < 0) {
          this.buffer = "";
          this.bufferOffset += this._index;
          this._index = 0;
        } else if (this.running) {
          if (this._state === 1) {
            if (this.sectionStart !== this._index) {
              this.cbs.ontext(this.buffer.substr(this.sectionStart));
            }
            this.buffer = "";
            this.bufferOffset += this._index;
            this._index = 0;
          } else if (this.sectionStart === this._index) {
            this.buffer = "";
            this.bufferOffset += this._index;
            this._index = 0;
          } else {
            this.buffer = this.buffer.substr(this.sectionStart);
            this._index -= this.sectionStart;
            this.bufferOffset += this.sectionStart;
          }
          this.sectionStart = 0;
        }
      };
      Tokenizer2.prototype.parse = function() {
        while (this._index < this.buffer.length && this.running) {
          var c = this.buffer.charAt(this._index);
          if (this._state === 1) {
            this.stateText(c);
          } else if (this._state === 12) {
            this.stateInAttributeValueDoubleQuotes(c);
          } else if (this._state === 9) {
            this.stateInAttributeName(c);
          } else if (this._state === 19) {
            this.stateInComment(c);
          } else if (this._state === 20) {
            this.stateInSpecialComment(c);
          } else if (this._state === 8) {
            this.stateBeforeAttributeName(c);
          } else if (this._state === 3) {
            this.stateInTagName(c);
          } else if (this._state === 6) {
            this.stateInClosingTagName(c);
          } else if (this._state === 2) {
            this.stateBeforeTagName(c);
          } else if (this._state === 10) {
            this.stateAfterAttributeName(c);
          } else if (this._state === 13) {
            this.stateInAttributeValueSingleQuotes(c);
          } else if (this._state === 11) {
            this.stateBeforeAttributeValue(c);
          } else if (this._state === 5) {
            this.stateBeforeClosingTagName(c);
          } else if (this._state === 7) {
            this.stateAfterClosingTagName(c);
          } else if (this._state === 32) {
            this.stateBeforeSpecialS(c);
          } else if (this._state === 21) {
            this.stateAfterComment1(c);
          } else if (this._state === 14) {
            this.stateInAttributeValueNoQuotes(c);
          } else if (this._state === 4) {
            this.stateInSelfClosingTag(c);
          } else if (this._state === 16) {
            this.stateInDeclaration(c);
          } else if (this._state === 15) {
            this.stateBeforeDeclaration(c);
          } else if (this._state === 22) {
            this.stateAfterComment2(c);
          } else if (this._state === 18) {
            this.stateBeforeComment(c);
          } else if (this._state === 33) {
            this.stateBeforeSpecialSEnd(c);
          } else if (this._state === 53) {
            stateAfterSpecialTEnd(this, c);
          } else if (this._state === 39) {
            stateAfterScript1(this, c);
          } else if (this._state === 40) {
            stateAfterScript2(this, c);
          } else if (this._state === 41) {
            stateAfterScript3(this, c);
          } else if (this._state === 34) {
            stateBeforeScript1(this, c);
          } else if (this._state === 35) {
            stateBeforeScript2(this, c);
          } else if (this._state === 36) {
            stateBeforeScript3(this, c);
          } else if (this._state === 37) {
            stateBeforeScript4(this, c);
          } else if (this._state === 38) {
            this.stateBeforeSpecialLast(
              c,
              2
              /* Script */
            );
          } else if (this._state === 42) {
            stateAfterScript4(this, c);
          } else if (this._state === 43) {
            this.stateAfterSpecialLast(c, 6);
          } else if (this._state === 44) {
            stateBeforeStyle1(this, c);
          } else if (this._state === 29) {
            this.stateInCdata(c);
          } else if (this._state === 45) {
            stateBeforeStyle2(this, c);
          } else if (this._state === 46) {
            stateBeforeStyle3(this, c);
          } else if (this._state === 47) {
            this.stateBeforeSpecialLast(
              c,
              3
              /* Style */
            );
          } else if (this._state === 48) {
            stateAfterStyle1(this, c);
          } else if (this._state === 49) {
            stateAfterStyle2(this, c);
          } else if (this._state === 50) {
            stateAfterStyle3(this, c);
          } else if (this._state === 51) {
            this.stateAfterSpecialLast(c, 5);
          } else if (this._state === 52) {
            stateBeforeSpecialT(this, c);
          } else if (this._state === 54) {
            stateBeforeTitle1(this, c);
          } else if (this._state === 55) {
            stateBeforeTitle2(this, c);
          } else if (this._state === 56) {
            stateBeforeTitle3(this, c);
          } else if (this._state === 57) {
            this.stateBeforeSpecialLast(
              c,
              4
              /* Title */
            );
          } else if (this._state === 58) {
            stateAfterTitle1(this, c);
          } else if (this._state === 59) {
            stateAfterTitle2(this, c);
          } else if (this._state === 60) {
            stateAfterTitle3(this, c);
          } else if (this._state === 61) {
            this.stateAfterSpecialLast(c, 5);
          } else if (this._state === 17) {
            this.stateInProcessingInstruction(c);
          } else if (this._state === 64) {
            this.stateInNamedEntity(c);
          } else if (this._state === 23) {
            stateBeforeCdata1(this, c);
          } else if (this._state === 62) {
            stateBeforeEntity(this, c);
          } else if (this._state === 24) {
            stateBeforeCdata2(this, c);
          } else if (this._state === 25) {
            stateBeforeCdata3(this, c);
          } else if (this._state === 30) {
            this.stateAfterCdata1(c);
          } else if (this._state === 31) {
            this.stateAfterCdata2(c);
          } else if (this._state === 26) {
            stateBeforeCdata4(this, c);
          } else if (this._state === 27) {
            stateBeforeCdata5(this, c);
          } else if (this._state === 28) {
            this.stateBeforeCdata6(c);
          } else if (this._state === 66) {
            this.stateInHexEntity(c);
          } else if (this._state === 65) {
            this.stateInNumericEntity(c);
          } else if (this._state === 63) {
            stateBeforeNumericEntity(this, c);
          } else {
            this.cbs.onerror(Error("unknown _state"), this._state);
          }
          this._index++;
        }
        this.cleanup();
      };
      Tokenizer2.prototype.finish = function() {
        if (this.sectionStart < this._index) {
          this.handleTrailingData();
        }
        this.cbs.onend();
      };
      Tokenizer2.prototype.handleTrailingData = function() {
        var data2 = this.buffer.substr(this.sectionStart);
        if (this._state === 29 || this._state === 30 || this._state === 31) {
          this.cbs.oncdata(data2);
        } else if (this._state === 19 || this._state === 21 || this._state === 22) {
          this.cbs.oncomment(data2);
        } else if (this._state === 64 && !this.xmlMode) {
          this.parseLegacyEntity();
          if (this.sectionStart < this._index) {
            this._state = this.baseState;
            this.handleTrailingData();
          }
        } else if (this._state === 65 && !this.xmlMode) {
          this.decodeNumericEntity(2, 10, false);
          if (this.sectionStart < this._index) {
            this._state = this.baseState;
            this.handleTrailingData();
          }
        } else if (this._state === 66 && !this.xmlMode) {
          this.decodeNumericEntity(3, 16, false);
          if (this.sectionStart < this._index) {
            this._state = this.baseState;
            this.handleTrailingData();
          }
        } else if (this._state !== 3 && this._state !== 8 && this._state !== 11 && this._state !== 10 && this._state !== 9 && this._state !== 13 && this._state !== 12 && this._state !== 14 && this._state !== 6) {
          this.cbs.ontext(data2);
        }
      };
      Tokenizer2.prototype.getSection = function() {
        return this.buffer.substring(this.sectionStart, this._index);
      };
      Tokenizer2.prototype.emitToken = function(name) {
        this.cbs[name](this.getSection());
        this.sectionStart = -1;
      };
      Tokenizer2.prototype.emitPartial = function(value) {
        if (this.baseState !== 1) {
          this.cbs.onattribdata(value);
        } else {
          this.cbs.ontext(value);
        }
      };
      return Tokenizer2;
    })()
  );
  Tokenizer.default = Tokenizer$1;
  return Tokenizer;
}
var hasRequiredParser$1;
function requireParser$1() {
  if (hasRequiredParser$1) return Parser;
  hasRequiredParser$1 = 1;
  var __importDefault2 = Parser && Parser.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(Parser, "__esModule", {
    value: true
  });
  Parser.Parser = void 0;
  var Tokenizer_1 = __importDefault2(/* @__PURE__ */ requireTokenizer$1());
  var formTags = /* @__PURE__ */ new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]);
  var pTag = /* @__PURE__ */ new Set(["p"]);
  var openImpliesClose = {
    tr: /* @__PURE__ */ new Set(["tr", "th", "td"]),
    th: /* @__PURE__ */ new Set(["th"]),
    td: /* @__PURE__ */ new Set(["thead", "th", "td"]),
    body: /* @__PURE__ */ new Set(["head", "link", "script"]),
    li: /* @__PURE__ */ new Set(["li"]),
    p: pTag,
    h1: pTag,
    h2: pTag,
    h3: pTag,
    h4: pTag,
    h5: pTag,
    h6: pTag,
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: /* @__PURE__ */ new Set(["option"]),
    optgroup: /* @__PURE__ */ new Set(["optgroup", "option"]),
    dd: /* @__PURE__ */ new Set(["dt", "dd"]),
    dt: /* @__PURE__ */ new Set(["dt", "dd"]),
    address: pTag,
    article: pTag,
    aside: pTag,
    blockquote: pTag,
    details: pTag,
    div: pTag,
    dl: pTag,
    fieldset: pTag,
    figcaption: pTag,
    figure: pTag,
    footer: pTag,
    form: pTag,
    header: pTag,
    hr: pTag,
    main: pTag,
    nav: pTag,
    ol: pTag,
    pre: pTag,
    section: pTag,
    table: pTag,
    ul: pTag,
    rt: /* @__PURE__ */ new Set(["rt", "rp"]),
    rp: /* @__PURE__ */ new Set(["rt", "rp"]),
    tbody: /* @__PURE__ */ new Set(["thead", "tbody"]),
    tfoot: /* @__PURE__ */ new Set(["thead", "tbody"])
  };
  var voidElements = /* @__PURE__ */ new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
  var foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]);
  var htmlIntegrationElements = /* @__PURE__ */ new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]);
  var reNameEnd = /\s|\//;
  var Parser$1 = (
    /** @class */
    (function() {
      function Parser2(cbs, options2) {
        if (options2 === void 0) {
          options2 = {};
        }
        var _a, _b, _c, _d, _e;
        this.startIndex = 0;
        this.endIndex = null;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.options = options2;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options2.lowerCaseTags) !== null && _a !== void 0 ? _a : !options2.xmlMode;
        this.lowerCaseAttributeNames = (_b = options2.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options2.xmlMode;
        this.tokenizer = new ((_c = options2.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
      }
      Parser2.prototype.updatePosition = function(initialOffset) {
        if (this.endIndex === null) {
          if (this.tokenizer.sectionStart <= initialOffset) {
            this.startIndex = 0;
          } else {
            this.startIndex = this.tokenizer.sectionStart - initialOffset;
          }
        } else {
          this.startIndex = this.endIndex + 1;
        }
        this.endIndex = this.tokenizer.getAbsoluteIndex();
      };
      Parser2.prototype.ontext = function(data2) {
        var _a, _b;
        this.updatePosition(1);
        this.endIndex--;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data2);
      };
      Parser2.prototype.onopentagname = function(name) {
        var _a, _b;
        if (this.lowerCaseTagNames) {
          name = name.toLowerCase();
        }
        this.tagname = name;
        if (!this.options.xmlMode && Object.prototype.hasOwnProperty.call(openImpliesClose, name)) {
          var el2 = void 0;
          while (this.stack.length > 0 && openImpliesClose[name].has(el2 = this.stack[this.stack.length - 1])) {
            this.onclosetag(el2);
          }
        }
        if (this.options.xmlMode || !voidElements.has(name)) {
          this.stack.push(name);
          if (foreignContextElements.has(name)) {
            this.foreignContext.push(true);
          } else if (htmlIntegrationElements.has(name)) {
            this.foreignContext.push(false);
          }
        }
        (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
        if (this.cbs.onopentag) this.attribs = {};
      };
      Parser2.prototype.onopentagend = function() {
        var _a, _b;
        this.updatePosition(1);
        if (this.attribs) {
          (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs);
          this.attribs = null;
        }
        if (!this.options.xmlMode && this.cbs.onclosetag && voidElements.has(this.tagname)) {
          this.cbs.onclosetag(this.tagname);
        }
        this.tagname = "";
      };
      Parser2.prototype.onclosetag = function(name) {
        this.updatePosition(1);
        if (this.lowerCaseTagNames) {
          name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
          this.foreignContext.pop();
        }
        if (this.stack.length && (this.options.xmlMode || !voidElements.has(name))) {
          var pos = this.stack.lastIndexOf(name);
          if (pos !== -1) {
            if (this.cbs.onclosetag) {
              pos = this.stack.length - pos;
              while (pos--) {
                this.cbs.onclosetag(this.stack.pop());
              }
            } else this.stack.length = pos;
          } else if (name === "p" && !this.options.xmlMode) {
            this.onopentagname(name);
            this.closeCurrentTag();
          }
        } else if (!this.options.xmlMode && (name === "br" || name === "p")) {
          this.onopentagname(name);
          this.closeCurrentTag();
        }
      };
      Parser2.prototype.onselfclosingtag = function() {
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
          this.closeCurrentTag();
        } else {
          this.onopentagend();
        }
      };
      Parser2.prototype.closeCurrentTag = function() {
        var _a, _b;
        var name = this.tagname;
        this.onopentagend();
        if (this.stack[this.stack.length - 1] === name) {
          (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name);
          this.stack.pop();
        }
      };
      Parser2.prototype.onattribname = function(name) {
        if (this.lowerCaseAttributeNames) {
          name = name.toLowerCase();
        }
        this.attribname = name;
      };
      Parser2.prototype.onattribdata = function(value) {
        this.attribvalue += value;
      };
      Parser2.prototype.onattribend = function(quote) {
        var _a, _b;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
          this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribname = "";
        this.attribvalue = "";
      };
      Parser2.prototype.getInstructionName = function(value) {
        var idx = value.search(reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this.lowerCaseTagNames) {
          name = name.toLowerCase();
        }
        return name;
      };
      Parser2.prototype.ondeclaration = function(value) {
        if (this.cbs.onprocessinginstruction) {
          var name_1 = this.getInstructionName(value);
          this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
      };
      Parser2.prototype.onprocessinginstruction = function(value) {
        if (this.cbs.onprocessinginstruction) {
          var name_2 = this.getInstructionName(value);
          this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
      };
      Parser2.prototype.oncomment = function(value) {
        var _a, _b, _c, _d;
        this.updatePosition(4);
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
      };
      Parser2.prototype.oncdata = function(value) {
        var _a, _b, _c, _d, _e, _f;
        this.updatePosition(1);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
          (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
          (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
          (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        } else {
          this.oncomment("[CDATA[" + value + "]]");
        }
      };
      Parser2.prototype.onerror = function(err) {
        var _a, _b;
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
      };
      Parser2.prototype.onend = function() {
        var _a, _b;
        if (this.cbs.onclosetag) {
          for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i])) ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
      };
      Parser2.prototype.reset = function() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack = [];
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
      };
      Parser2.prototype.parseComplete = function(data2) {
        this.reset();
        this.end(data2);
      };
      Parser2.prototype.write = function(chunk) {
        this.tokenizer.write(chunk);
      };
      Parser2.prototype.end = function(chunk) {
        this.tokenizer.end(chunk);
      };
      Parser2.prototype.pause = function() {
        this.tokenizer.pause();
      };
      Parser2.prototype.resume = function() {
        this.tokenizer.resume();
      };
      Parser2.prototype.parseChunk = function(chunk) {
        this.write(chunk);
      };
      Parser2.prototype.done = function(chunk) {
        this.end(chunk);
      };
      return Parser2;
    })()
  );
  Parser.Parser = Parser$1;
  return Parser;
}
var FeedHandler = {};
var hasRequiredFeedHandler;
function requireFeedHandler() {
  if (hasRequiredFeedHandler) return FeedHandler;
  hasRequiredFeedHandler = 1;
  var __extends2 = FeedHandler && FeedHandler.__extends || /* @__PURE__ */ (function() {
    var extendStatics2 = function(d, b) {
      extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
      };
      return extendStatics2(d, b);
    };
    return function(d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics2(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __createBinding2 = FeedHandler && FeedHandler.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function() {
        return m[k];
      }
    });
  } : function(o, m, k, k2) {
    if (k2 === void 0) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = FeedHandler && FeedHandler.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = FeedHandler && FeedHandler.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule) return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k)) __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __importDefault2 = FeedHandler && FeedHandler.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : {
      "default": mod2
    };
  };
  Object.defineProperty(FeedHandler, "__esModule", {
    value: true
  });
  FeedHandler.parseFeed = FeedHandler.FeedHandler = void 0;
  var domhandler_1 = __importDefault2(/* @__PURE__ */ requireLib$c());
  var DomUtils = __importStar2(/* @__PURE__ */ requireLib$9());
  var Parser_1 = /* @__PURE__ */ requireParser$1();
  var FeedItemMediaMedium;
  (function(FeedItemMediaMedium2) {
    FeedItemMediaMedium2[FeedItemMediaMedium2["image"] = 0] = "image";
    FeedItemMediaMedium2[FeedItemMediaMedium2["audio"] = 1] = "audio";
    FeedItemMediaMedium2[FeedItemMediaMedium2["video"] = 2] = "video";
    FeedItemMediaMedium2[FeedItemMediaMedium2["document"] = 3] = "document";
    FeedItemMediaMedium2[FeedItemMediaMedium2["executable"] = 4] = "executable";
  })(FeedItemMediaMedium || (FeedItemMediaMedium = {}));
  var FeedItemMediaExpression;
  (function(FeedItemMediaExpression2) {
    FeedItemMediaExpression2[FeedItemMediaExpression2["sample"] = 0] = "sample";
    FeedItemMediaExpression2[FeedItemMediaExpression2["full"] = 1] = "full";
    FeedItemMediaExpression2[FeedItemMediaExpression2["nonstop"] = 2] = "nonstop";
  })(FeedItemMediaExpression || (FeedItemMediaExpression = {}));
  var FeedHandler$1 = (
    /** @class */
    (function(_super) {
      __extends2(FeedHandler2, _super);
      function FeedHandler2(callback, options2) {
        var _this = this;
        if (typeof callback === "object") {
          callback = void 0;
          options2 = callback;
        }
        _this = _super.call(this, callback, options2) || this;
        return _this;
      }
      FeedHandler2.prototype.onend = function() {
        var _a, _b;
        var feedRoot = getOneElement(isValidFeed, this.dom);
        if (!feedRoot) {
          this.handleCallback(new Error("couldn't find root of feed"));
          return;
        }
        var feed = {};
        if (feedRoot.name === "feed") {
          var childs = feedRoot.children;
          feed.type = "atom";
          addConditionally(feed, "id", "id", childs);
          addConditionally(feed, "title", "title", childs);
          var href = getAttribute("href", getOneElement("link", childs));
          if (href) {
            feed.link = href;
          }
          addConditionally(feed, "description", "subtitle", childs);
          var updated = fetch2("updated", childs);
          if (updated) {
            feed.updated = new Date(updated);
          }
          addConditionally(feed, "author", "email", childs, true);
          feed.items = getElements("entry", childs).map(function(item) {
            var entry = {};
            var children2 = item.children;
            addConditionally(entry, "id", "id", children2);
            addConditionally(entry, "title", "title", children2);
            var href2 = getAttribute("href", getOneElement("link", children2));
            if (href2) {
              entry.link = href2;
            }
            var description2 = fetch2("summary", children2) || fetch2("content", children2);
            if (description2) {
              entry.description = description2;
            }
            var pubDate = fetch2("updated", children2);
            if (pubDate) {
              entry.pubDate = new Date(pubDate);
            }
            entry.media = getMediaElements(children2);
            return entry;
          });
        } else {
          var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
          feed.type = feedRoot.name.substr(0, 3);
          feed.id = "";
          addConditionally(feed, "title", "title", childs);
          addConditionally(feed, "link", "link", childs);
          addConditionally(feed, "description", "description", childs);
          var updated = fetch2("lastBuildDate", childs);
          if (updated) {
            feed.updated = new Date(updated);
          }
          addConditionally(feed, "author", "managingEditor", childs, true);
          feed.items = getElements("item", feedRoot.children).map(function(item) {
            var entry = {};
            var children2 = item.children;
            addConditionally(entry, "id", "guid", children2);
            addConditionally(entry, "title", "title", children2);
            addConditionally(entry, "link", "link", children2);
            addConditionally(entry, "description", "description", children2);
            var pubDate = fetch2("pubDate", children2);
            if (pubDate) entry.pubDate = new Date(pubDate);
            entry.media = getMediaElements(children2);
            return entry;
          });
        }
        this.feed = feed;
        this.handleCallback(null);
      };
      return FeedHandler2;
    })(domhandler_1.default)
  );
  FeedHandler.FeedHandler = FeedHandler$1;
  function getMediaElements(where) {
    return getElements("media:content", where).map(function(elem) {
      var media = {
        medium: elem.attribs.medium,
        isDefault: !!elem.attribs.isDefault
      };
      if (elem.attribs.url) {
        media.url = elem.attribs.url;
      }
      if (elem.attribs.fileSize) {
        media.fileSize = parseInt(elem.attribs.fileSize, 10);
      }
      if (elem.attribs.type) {
        media.type = elem.attribs.type;
      }
      if (elem.attribs.expression) {
        media.expression = elem.attribs.expression;
      }
      if (elem.attribs.bitrate) {
        media.bitrate = parseInt(elem.attribs.bitrate, 10);
      }
      if (elem.attribs.framerate) {
        media.framerate = parseInt(elem.attribs.framerate, 10);
      }
      if (elem.attribs.samplingrate) {
        media.samplingrate = parseInt(elem.attribs.samplingrate, 10);
      }
      if (elem.attribs.channels) {
        media.channels = parseInt(elem.attribs.channels, 10);
      }
      if (elem.attribs.duration) {
        media.duration = parseInt(elem.attribs.duration, 10);
      }
      if (elem.attribs.height) {
        media.height = parseInt(elem.attribs.height, 10);
      }
      if (elem.attribs.width) {
        media.width = parseInt(elem.attribs.width, 10);
      }
      if (elem.attribs.lang) {
        media.lang = elem.attribs.lang;
      }
      return media;
    });
  }
  function getElements(tagName, where) {
    return DomUtils.getElementsByTagName(tagName, where, true);
  }
  function getOneElement(tagName, node2) {
    return DomUtils.getElementsByTagName(tagName, node2, true, 1)[0];
  }
  function fetch2(tagName, where, recurse) {
    if (recurse === void 0) {
      recurse = false;
    }
    return DomUtils.getText(DomUtils.getElementsByTagName(tagName, where, recurse, 1)).trim();
  }
  function getAttribute(name, elem) {
    if (!elem) {
      return null;
    }
    var attribs = elem.attribs;
    return attribs[name];
  }
  function addConditionally(obj, prop2, what, where, recurse) {
    if (recurse === void 0) {
      recurse = false;
    }
    var tmp = fetch2(what, where, recurse);
    if (tmp) obj[prop2] = tmp;
  }
  function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
  }
  function parseFeed(feed, options2) {
    if (options2 === void 0) {
      options2 = {
        xmlMode: true
      };
    }
    var handler = new FeedHandler$1(options2);
    new Parser_1.Parser(handler, options2).end(feed);
    return handler.feed;
  }
  FeedHandler.parseFeed = parseFeed;
  return FeedHandler;
}
var hasRequiredLib$5;
function requireLib$5() {
  if (hasRequiredLib$5) return lib$4;
  hasRequiredLib$5 = 1;
  (function(exports2) {
    var __createBinding2 = lib$4 && lib$4.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
          return m[k];
        }
      });
    } : function(o, m, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault2 = lib$4 && lib$4.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
      });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar2 = lib$4 && lib$4.__importStar || function(mod2) {
      if (mod2 && mod2.__esModule) return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k in mod2) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k)) __createBinding2(result, mod2, k);
      }
      __setModuleDefault2(result, mod2);
      return result;
    };
    var __exportStar2 = lib$4 && lib$4.__exportStar || function(m, exports3) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p)) __createBinding2(exports3, m, p);
    };
    var __importDefault2 = lib$4 && lib$4.__importDefault || function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : {
        "default": mod2
      };
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.RssHandler = exports2.DefaultHandler = exports2.DomUtils = exports2.ElementType = exports2.Tokenizer = exports2.createDomStream = exports2.parseDOM = exports2.parseDocument = exports2.DomHandler = exports2.Parser = void 0;
    var Parser_1 = /* @__PURE__ */ requireParser$1();
    Object.defineProperty(exports2, "Parser", {
      enumerable: true,
      get: function() {
        return Parser_1.Parser;
      }
    });
    var domhandler_1 = /* @__PURE__ */ requireLib$c();
    Object.defineProperty(exports2, "DomHandler", {
      enumerable: true,
      get: function() {
        return domhandler_1.DomHandler;
      }
    });
    Object.defineProperty(exports2, "DefaultHandler", {
      enumerable: true,
      get: function() {
        return domhandler_1.DomHandler;
      }
    });
    function parseDocument(data2, options2) {
      var handler = new domhandler_1.DomHandler(void 0, options2);
      new Parser_1.Parser(handler, options2).end(data2);
      return handler.root;
    }
    exports2.parseDocument = parseDocument;
    function parseDOM(data2, options2) {
      return parseDocument(data2, options2).children;
    }
    exports2.parseDOM = parseDOM;
    function createDomStream(cb, options2, elementCb) {
      var handler = new domhandler_1.DomHandler(cb, options2, elementCb);
      return new Parser_1.Parser(handler, options2);
    }
    exports2.createDomStream = createDomStream;
    var Tokenizer_1 = /* @__PURE__ */ requireTokenizer$1();
    Object.defineProperty(exports2, "Tokenizer", {
      enumerable: true,
      get: function() {
        return __importDefault2(Tokenizer_1).default;
      }
    });
    var ElementType = __importStar2(/* @__PURE__ */ requireLib$d());
    exports2.ElementType = ElementType;
    __exportStar2(/* @__PURE__ */ requireFeedHandler(), exports2);
    exports2.DomUtils = __importStar2(/* @__PURE__ */ requireLib$9());
    var FeedHandler_1 = /* @__PURE__ */ requireFeedHandler();
    Object.defineProperty(exports2, "RssHandler", {
      enumerable: true,
      get: function() {
        return FeedHandler_1.FeedHandler;
      }
    });
  })(lib$4);
  return lib$4;
}
var parse5Adapter = {};
var lib$3 = {};
var unicode = {};
var hasRequiredUnicode;
function requireUnicode() {
  if (hasRequiredUnicode) return unicode;
  hasRequiredUnicode = 1;
  const UNDEFINED_CODE_POINTS = [65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111];
  unicode.REPLACEMENT_CHARACTER = "�";
  unicode.CODE_POINTS = {
    EOF: -1,
    NULL: 0,
    TABULATION: 9,
    CARRIAGE_RETURN: 13,
    LINE_FEED: 10,
    FORM_FEED: 12,
    SPACE: 32,
    EXCLAMATION_MARK: 33,
    QUOTATION_MARK: 34,
    NUMBER_SIGN: 35,
    AMPERSAND: 38,
    APOSTROPHE: 39,
    HYPHEN_MINUS: 45,
    SOLIDUS: 47,
    DIGIT_0: 48,
    DIGIT_9: 57,
    SEMICOLON: 59,
    LESS_THAN_SIGN: 60,
    EQUALS_SIGN: 61,
    GREATER_THAN_SIGN: 62,
    QUESTION_MARK: 63,
    LATIN_CAPITAL_A: 65,
    LATIN_CAPITAL_F: 70,
    LATIN_CAPITAL_X: 88,
    LATIN_CAPITAL_Z: 90,
    RIGHT_SQUARE_BRACKET: 93,
    GRAVE_ACCENT: 96,
    LATIN_SMALL_A: 97,
    LATIN_SMALL_F: 102,
    LATIN_SMALL_X: 120,
    LATIN_SMALL_Z: 122,
    REPLACEMENT_CHARACTER: 65533
  };
  unicode.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [45, 45],
    //--
    DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
    //DOCTYPE
    CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
    //[CDATA[
    SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
    //script
    PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
    //PUBLIC
    SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
    //SYSTEM
  };
  unicode.isSurrogate = function(cp) {
    return cp >= 55296 && cp <= 57343;
  };
  unicode.isSurrogatePair = function(cp) {
    return cp >= 56320 && cp <= 57343;
  };
  unicode.getSurrogatePairCodePoint = function(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
  };
  unicode.isControlCodePoint = function(cp) {
    return cp !== 32 && cp !== 10 && cp !== 13 && cp !== 9 && cp !== 12 && cp >= 1 && cp <= 31 || cp >= 127 && cp <= 159;
  };
  unicode.isUndefinedCodePoint = function(cp) {
    return cp >= 64976 && cp <= 65007 || UNDEFINED_CODE_POINTS.indexOf(cp) > -1;
  };
  return unicode;
}
var errorCodes;
var hasRequiredErrorCodes;
function requireErrorCodes() {
  if (hasRequiredErrorCodes) return errorCodes;
  hasRequiredErrorCodes = 1;
  errorCodes = {
    controlCharacterInInputStream: "control-character-in-input-stream",
    noncharacterInInputStream: "noncharacter-in-input-stream",
    surrogateInInputStream: "surrogate-in-input-stream",
    nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
    endTagWithAttributes: "end-tag-with-attributes",
    endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
    unexpectedSolidusInTag: "unexpected-solidus-in-tag",
    unexpectedNullCharacter: "unexpected-null-character",
    unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
    invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
    unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
    missingEndTagName: "missing-end-tag-name",
    unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
    unknownNamedCharacterReference: "unknown-named-character-reference",
    missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
    unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
    unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
    eofBeforeTagName: "eof-before-tag-name",
    eofInTag: "eof-in-tag",
    missingAttributeValue: "missing-attribute-value",
    missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
    missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
    missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
    missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
    missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
    missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
    missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
    abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
    abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
    cdataInHtmlContent: "cdata-in-html-content",
    incorrectlyOpenedComment: "incorrectly-opened-comment",
    eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
    eofInDoctype: "eof-in-doctype",
    nestedComment: "nested-comment",
    abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
    eofInComment: "eof-in-comment",
    incorrectlyClosedComment: "incorrectly-closed-comment",
    eofInCdata: "eof-in-cdata",
    absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
    nullCharacterReference: "null-character-reference",
    surrogateCharacterReference: "surrogate-character-reference",
    characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
    controlCharacterReference: "control-character-reference",
    noncharacterCharacterReference: "noncharacter-character-reference",
    missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
    missingDoctypeName: "missing-doctype-name",
    invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
    duplicateAttribute: "duplicate-attribute",
    nonConformingDoctype: "non-conforming-doctype",
    missingDoctype: "missing-doctype",
    misplacedDoctype: "misplaced-doctype",
    endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
    closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
    disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
    openElementsLeftAfterEof: "open-elements-left-after-eof",
    abandonedHeadElementChild: "abandoned-head-element-child",
    misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
    nestedNoscriptInHead: "nested-noscript-in-head",
    eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
  };
  return errorCodes;
}
var preprocessor;
var hasRequiredPreprocessor;
function requirePreprocessor() {
  if (hasRequiredPreprocessor) return preprocessor;
  hasRequiredPreprocessor = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const unicode2 = requireUnicode();
  const ERR = requireErrorCodes();
  const $ = unicode2.CODE_POINTS;
  const DEFAULT_BUFFER_WATERLINE = 1 << 16;
  let Preprocessor = /* @__PURE__ */ (function() {
    function Preprocessor2() {
      _classCallCheck2(this, Preprocessor2);
      this.html = null;
      this.pos = -1;
      this.lastGapPos = -1;
      this.lastCharPos = -1;
      this.gapStack = [];
      this.skipNextNewLine = false;
      this.lastChunkWritten = false;
      this.endOfChunkHit = false;
      this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
    }
    return _createClass2(Preprocessor2, [{
      key: "_err",
      value: function _err() {
      }
    }, {
      key: "_addGap",
      value: function _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
      }
    }, {
      key: "_processSurrogate",
      value: function _processSurrogate(cp) {
        if (this.pos !== this.lastCharPos) {
          const nextCp = this.html.charCodeAt(this.pos + 1);
          if (unicode2.isSurrogatePair(nextCp)) {
            this.pos++;
            this._addGap();
            return unicode2.getSurrogatePairCodePoint(cp, nextCp);
          }
        } else if (!this.lastChunkWritten) {
          this.endOfChunkHit = true;
          return $.EOF;
        }
        this._err(ERR.surrogateInInputStream);
        return cp;
      }
    }, {
      key: "dropParsedChunk",
      value: function dropParsedChunk() {
        if (this.pos > this.bufferWaterline) {
          this.lastCharPos -= this.pos;
          this.html = this.html.substring(this.pos);
          this.pos = 0;
          this.lastGapPos = -1;
          this.gapStack = [];
        }
      }
    }, {
      key: "write",
      value: function write(chunk, isLastChunk) {
        if (this.html) {
          this.html += chunk;
        } else {
          this.html = chunk;
        }
        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
      }
    }, {
      key: "insertHtmlAtCurrentPos",
      value: function insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1, this.html.length);
        this.lastCharPos = this.html.length - 1;
        this.endOfChunkHit = false;
      }
    }, {
      key: "advance",
      value: function advance() {
        this.pos++;
        if (this.pos > this.lastCharPos) {
          this.endOfChunkHit = !this.lastChunkWritten;
          return $.EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        if (this.skipNextNewLine && cp === $.LINE_FEED) {
          this.skipNextNewLine = false;
          this._addGap();
          return this.advance();
        }
        if (cp === $.CARRIAGE_RETURN) {
          this.skipNextNewLine = true;
          return $.LINE_FEED;
        }
        this.skipNextNewLine = false;
        if (unicode2.isSurrogate(cp)) {
          cp = this._processSurrogate(cp);
        }
        const isCommonValidRange = cp > 31 && cp < 127 || cp === $.LINE_FEED || cp === $.CARRIAGE_RETURN || cp > 159 && cp < 64976;
        if (!isCommonValidRange) {
          this._checkForProblematicCharacters(cp);
        }
        return cp;
      }
    }, {
      key: "_checkForProblematicCharacters",
      value: function _checkForProblematicCharacters(cp) {
        if (unicode2.isControlCodePoint(cp)) {
          this._err(ERR.controlCharacterInInputStream);
        } else if (unicode2.isUndefinedCodePoint(cp)) {
          this._err(ERR.noncharacterInInputStream);
        }
      }
    }, {
      key: "retreat",
      value: function retreat() {
        if (this.pos === this.lastGapPos) {
          this.lastGapPos = this.gapStack.pop();
          this.pos--;
        }
        this.pos--;
      }
    }]);
  })();
  preprocessor = Preprocessor;
  return preprocessor;
}
var namedEntityData;
var hasRequiredNamedEntityData;
function requireNamedEntityData() {
  if (hasRequiredNamedEntityData) return namedEntityData;
  hasRequiredNamedEntityData = 1;
  namedEntityData = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
  return namedEntityData;
}
var tokenizer;
var hasRequiredTokenizer;
function requireTokenizer() {
  if (hasRequiredTokenizer) return tokenizer;
  hasRequiredTokenizer = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const Preprocessor = requirePreprocessor();
  const unicode2 = requireUnicode();
  const neTree = requireNamedEntityData();
  const ERR = requireErrorCodes();
  const $ = unicode2.CODE_POINTS;
  const $$2 = unicode2.CODE_POINT_SEQUENCES;
  const C1_CONTROLS_REFERENCE_REPLACEMENTS = {
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
  };
  const HAS_DATA_FLAG = 1 << 0;
  const DATA_DUPLET_FLAG = 1 << 1;
  const HAS_BRANCHES_FLAG = 1 << 2;
  const MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;
  const DATA_STATE = "DATA_STATE";
  const RCDATA_STATE = "RCDATA_STATE";
  const RAWTEXT_STATE = "RAWTEXT_STATE";
  const SCRIPT_DATA_STATE = "SCRIPT_DATA_STATE";
  const PLAINTEXT_STATE = "PLAINTEXT_STATE";
  const TAG_OPEN_STATE = "TAG_OPEN_STATE";
  const END_TAG_OPEN_STATE = "END_TAG_OPEN_STATE";
  const TAG_NAME_STATE = "TAG_NAME_STATE";
  const RCDATA_LESS_THAN_SIGN_STATE = "RCDATA_LESS_THAN_SIGN_STATE";
  const RCDATA_END_TAG_OPEN_STATE = "RCDATA_END_TAG_OPEN_STATE";
  const RCDATA_END_TAG_NAME_STATE = "RCDATA_END_TAG_NAME_STATE";
  const RAWTEXT_LESS_THAN_SIGN_STATE = "RAWTEXT_LESS_THAN_SIGN_STATE";
  const RAWTEXT_END_TAG_OPEN_STATE = "RAWTEXT_END_TAG_OPEN_STATE";
  const RAWTEXT_END_TAG_NAME_STATE = "RAWTEXT_END_TAG_NAME_STATE";
  const SCRIPT_DATA_LESS_THAN_SIGN_STATE = "SCRIPT_DATA_LESS_THAN_SIGN_STATE";
  const SCRIPT_DATA_END_TAG_OPEN_STATE = "SCRIPT_DATA_END_TAG_OPEN_STATE";
  const SCRIPT_DATA_END_TAG_NAME_STATE = "SCRIPT_DATA_END_TAG_NAME_STATE";
  const SCRIPT_DATA_ESCAPE_START_STATE = "SCRIPT_DATA_ESCAPE_START_STATE";
  const SCRIPT_DATA_ESCAPE_START_DASH_STATE = "SCRIPT_DATA_ESCAPE_START_DASH_STATE";
  const SCRIPT_DATA_ESCAPED_STATE = "SCRIPT_DATA_ESCAPED_STATE";
  const SCRIPT_DATA_ESCAPED_DASH_STATE = "SCRIPT_DATA_ESCAPED_DASH_STATE";
  const SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE";
  const SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE";
  const SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE";
  const SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE";
  const SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE";
  const SCRIPT_DATA_DOUBLE_ESCAPED_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE";
  const SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE";
  const SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE";
  const SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE";
  const SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE";
  const BEFORE_ATTRIBUTE_NAME_STATE = "BEFORE_ATTRIBUTE_NAME_STATE";
  const ATTRIBUTE_NAME_STATE = "ATTRIBUTE_NAME_STATE";
  const AFTER_ATTRIBUTE_NAME_STATE = "AFTER_ATTRIBUTE_NAME_STATE";
  const BEFORE_ATTRIBUTE_VALUE_STATE = "BEFORE_ATTRIBUTE_VALUE_STATE";
  const ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE";
  const ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE";
  const ATTRIBUTE_VALUE_UNQUOTED_STATE = "ATTRIBUTE_VALUE_UNQUOTED_STATE";
  const AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE";
  const SELF_CLOSING_START_TAG_STATE = "SELF_CLOSING_START_TAG_STATE";
  const BOGUS_COMMENT_STATE = "BOGUS_COMMENT_STATE";
  const MARKUP_DECLARATION_OPEN_STATE = "MARKUP_DECLARATION_OPEN_STATE";
  const COMMENT_START_STATE = "COMMENT_START_STATE";
  const COMMENT_START_DASH_STATE = "COMMENT_START_DASH_STATE";
  const COMMENT_STATE = "COMMENT_STATE";
  const COMMENT_LESS_THAN_SIGN_STATE = "COMMENT_LESS_THAN_SIGN_STATE";
  const COMMENT_LESS_THAN_SIGN_BANG_STATE = "COMMENT_LESS_THAN_SIGN_BANG_STATE";
  const COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE";
  const COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE";
  const COMMENT_END_DASH_STATE = "COMMENT_END_DASH_STATE";
  const COMMENT_END_STATE = "COMMENT_END_STATE";
  const COMMENT_END_BANG_STATE = "COMMENT_END_BANG_STATE";
  const DOCTYPE_STATE = "DOCTYPE_STATE";
  const BEFORE_DOCTYPE_NAME_STATE = "BEFORE_DOCTYPE_NAME_STATE";
  const DOCTYPE_NAME_STATE = "DOCTYPE_NAME_STATE";
  const AFTER_DOCTYPE_NAME_STATE = "AFTER_DOCTYPE_NAME_STATE";
  const AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE";
  const BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE";
  const DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE";
  const DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE";
  const AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE";
  const BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE";
  const AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE";
  const BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE";
  const DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE";
  const DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE";
  const AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE";
  const BOGUS_DOCTYPE_STATE = "BOGUS_DOCTYPE_STATE";
  const CDATA_SECTION_STATE = "CDATA_SECTION_STATE";
  const CDATA_SECTION_BRACKET_STATE = "CDATA_SECTION_BRACKET_STATE";
  const CDATA_SECTION_END_STATE = "CDATA_SECTION_END_STATE";
  const CHARACTER_REFERENCE_STATE = "CHARACTER_REFERENCE_STATE";
  const NAMED_CHARACTER_REFERENCE_STATE = "NAMED_CHARACTER_REFERENCE_STATE";
  const AMBIGUOUS_AMPERSAND_STATE = "AMBIGUOS_AMPERSAND_STATE";
  const NUMERIC_CHARACTER_REFERENCE_STATE = "NUMERIC_CHARACTER_REFERENCE_STATE";
  const HEXADEMICAL_CHARACTER_REFERENCE_START_STATE = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE";
  const DECIMAL_CHARACTER_REFERENCE_START_STATE = "DECIMAL_CHARACTER_REFERENCE_START_STATE";
  const HEXADEMICAL_CHARACTER_REFERENCE_STATE = "HEXADEMICAL_CHARACTER_REFERENCE_STATE";
  const DECIMAL_CHARACTER_REFERENCE_STATE = "DECIMAL_CHARACTER_REFERENCE_STATE";
  const NUMERIC_CHARACTER_REFERENCE_END_STATE = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
  function isWhitespace2(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
  }
  function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
  }
  function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
  }
  function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
  }
  function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
  }
  function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
  }
  function isAsciiUpperHexDigit(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F;
  }
  function isAsciiLowerHexDigit(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F;
  }
  function isAsciiHexDigit(cp) {
    return isAsciiDigit(cp) || isAsciiUpperHexDigit(cp) || isAsciiLowerHexDigit(cp);
  }
  function toAsciiLowerCodePoint(cp) {
    return cp + 32;
  }
  function toChar(cp) {
    if (cp <= 65535) {
      return String.fromCharCode(cp);
    }
    cp -= 65536;
    return String.fromCharCode(cp >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | cp & 1023);
  }
  function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
  }
  function findNamedEntityTreeBranch(nodeIx, cp) {
    const branchCount = neTree[++nodeIx];
    let lo = ++nodeIx;
    let hi = lo + branchCount - 1;
    while (lo <= hi) {
      const mid2 = lo + hi >>> 1;
      const midCp = neTree[mid2];
      if (midCp < cp) {
        lo = mid2 + 1;
      } else if (midCp > cp) {
        hi = mid2 - 1;
      } else {
        return neTree[mid2 + branchCount];
      }
    }
    return -1;
  }
  let Tokenizer2 = /* @__PURE__ */ (function() {
    function Tokenizer3() {
      _classCallCheck2(this, Tokenizer3);
      this.preprocessor = new Preprocessor();
      this.tokenQueue = [];
      this.allowCDATA = false;
      this.state = DATA_STATE;
      this.returnState = "";
      this.charRefCode = -1;
      this.tempBuff = [];
      this.lastStartTagName = "";
      this.consumedAfterSnapshot = -1;
      this.active = false;
      this.currentCharacterToken = null;
      this.currentToken = null;
      this.currentAttr = null;
    }
    return _createClass2(Tokenizer3, [{
      key: "_err",
      value: function _err() {
      }
    }, {
      key: "_errOnNextCodePoint",
      value: function _errOnNextCodePoint(err) {
        this._consume();
        this._err(err);
        this._unconsume();
      }
      //API
    }, {
      key: "getNextToken",
      value: function getNextToken() {
        while (!this.tokenQueue.length && this.active) {
          this.consumedAfterSnapshot = 0;
          const cp = this._consume();
          if (!this._ensureHibernation()) {
            this[this.state](cp);
          }
        }
        return this.tokenQueue.shift();
      }
    }, {
      key: "write",
      value: function write(chunk, isLastChunk) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
      }
    }, {
      key: "insertHtmlAtCurrentPos",
      value: function insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
      }
      //Hibernation
    }, {
      key: "_ensureHibernation",
      value: function _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
          for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--) {
            this.preprocessor.retreat();
          }
          this.active = false;
          this.tokenQueue.push({
            type: Tokenizer3.HIBERNATION_TOKEN
          });
          return true;
        }
        return false;
      }
      //Consumption
    }, {
      key: "_consume",
      value: function _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
      }
    }, {
      key: "_unconsume",
      value: function _unconsume() {
        this.consumedAfterSnapshot--;
        this.preprocessor.retreat();
      }
    }, {
      key: "_reconsumeInState",
      value: function _reconsumeInState(state) {
        this.state = state;
        this._unconsume();
      }
    }, {
      key: "_consumeSequenceIfMatch",
      value: function _consumeSequenceIfMatch(pattern2, startCp, caseSensitive) {
        let consumedCount = 0;
        let isMatch = true;
        const patternLength = pattern2.length;
        let patternPos = 0;
        let cp = startCp;
        let patternCp = void 0;
        for (; patternPos < patternLength; patternPos++) {
          if (patternPos > 0) {
            cp = this._consume();
            consumedCount++;
          }
          if (cp === $.EOF) {
            isMatch = false;
            break;
          }
          patternCp = pattern2[patternPos];
          if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
            isMatch = false;
            break;
          }
        }
        if (!isMatch) {
          while (consumedCount--) {
            this._unconsume();
          }
        }
        return isMatch;
      }
      //Temp buffer
    }, {
      key: "_isTempBufferEqualToScriptString",
      value: function _isTempBufferEqualToScriptString() {
        if (this.tempBuff.length !== $$2.SCRIPT_STRING.length) {
          return false;
        }
        for (let i = 0; i < this.tempBuff.length; i++) {
          if (this.tempBuff[i] !== $$2.SCRIPT_STRING[i]) {
            return false;
          }
        }
        return true;
      }
      //Token creation
    }, {
      key: "_createStartTagToken",
      value: function _createStartTagToken() {
        this.currentToken = {
          type: Tokenizer3.START_TAG_TOKEN,
          tagName: "",
          selfClosing: false,
          ackSelfClosing: false,
          attrs: []
        };
      }
    }, {
      key: "_createEndTagToken",
      value: function _createEndTagToken() {
        this.currentToken = {
          type: Tokenizer3.END_TAG_TOKEN,
          tagName: "",
          selfClosing: false,
          attrs: []
        };
      }
    }, {
      key: "_createCommentToken",
      value: function _createCommentToken() {
        this.currentToken = {
          type: Tokenizer3.COMMENT_TOKEN,
          data: ""
        };
      }
    }, {
      key: "_createDoctypeToken",
      value: function _createDoctypeToken(initialName) {
        this.currentToken = {
          type: Tokenizer3.DOCTYPE_TOKEN,
          name: initialName,
          forceQuirks: false,
          publicId: null,
          systemId: null
        };
      }
    }, {
      key: "_createCharacterToken",
      value: function _createCharacterToken(type2, ch) {
        this.currentCharacterToken = {
          type: type2,
          chars: ch
        };
      }
    }, {
      key: "_createEOFToken",
      value: function _createEOFToken() {
        this.currentToken = {
          type: Tokenizer3.EOF_TOKEN
        };
      }
      //Tag attributes
    }, {
      key: "_createAttr",
      value: function _createAttr(attrNameFirstCh) {
        this.currentAttr = {
          name: attrNameFirstCh,
          value: ""
        };
      }
    }, {
      key: "_leaveAttrName",
      value: function _leaveAttrName(toState3) {
        if (Tokenizer3.getTokenAttr(this.currentToken, this.currentAttr.name) === null) {
          this.currentToken.attrs.push(this.currentAttr);
        } else {
          this._err(ERR.duplicateAttribute);
        }
        this.state = toState3;
      }
    }, {
      key: "_leaveAttrValue",
      value: function _leaveAttrValue(toState3) {
        this.state = toState3;
      }
      //Token emission
    }, {
      key: "_emitCurrentToken",
      value: function _emitCurrentToken() {
        this._emitCurrentCharacterToken();
        const ct = this.currentToken;
        this.currentToken = null;
        if (ct.type === Tokenizer3.START_TAG_TOKEN) {
          this.lastStartTagName = ct.tagName;
        } else if (ct.type === Tokenizer3.END_TAG_TOKEN) {
          if (ct.attrs.length > 0) {
            this._err(ERR.endTagWithAttributes);
          }
          if (ct.selfClosing) {
            this._err(ERR.endTagWithTrailingSolidus);
          }
        }
        this.tokenQueue.push(ct);
      }
    }, {
      key: "_emitCurrentCharacterToken",
      value: function _emitCurrentCharacterToken() {
        if (this.currentCharacterToken) {
          this.tokenQueue.push(this.currentCharacterToken);
          this.currentCharacterToken = null;
        }
      }
    }, {
      key: "_emitEOFToken",
      value: function _emitEOFToken() {
        this._createEOFToken();
        this._emitCurrentToken();
      }
      //Characters emission
      //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
      //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
      //If we have a sequence of characters that belong to the same group, parser can process it
      //as a single solid character token.
      //So, there are 3 types of character tokens in parse5:
      //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
      //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
      //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    }, {
      key: "_appendCharToCurrentCharacterToken",
      value: function _appendCharToCurrentCharacterToken(type2, ch) {
        if (this.currentCharacterToken && this.currentCharacterToken.type !== type2) {
          this._emitCurrentCharacterToken();
        }
        if (this.currentCharacterToken) {
          this.currentCharacterToken.chars += ch;
        } else {
          this._createCharacterToken(type2, ch);
        }
      }
    }, {
      key: "_emitCodePoint",
      value: function _emitCodePoint(cp) {
        let type2 = Tokenizer3.CHARACTER_TOKEN;
        if (isWhitespace2(cp)) {
          type2 = Tokenizer3.WHITESPACE_CHARACTER_TOKEN;
        } else if (cp === $.NULL) {
          type2 = Tokenizer3.NULL_CHARACTER_TOKEN;
        }
        this._appendCharToCurrentCharacterToken(type2, toChar(cp));
      }
    }, {
      key: "_emitSeveralCodePoints",
      value: function _emitSeveralCodePoints(codePoints) {
        for (let i = 0; i < codePoints.length; i++) {
          this._emitCodePoint(codePoints[i]);
        }
      }
      //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
      //So we can avoid additional checks here.
    }, {
      key: "_emitChars",
      value: function _emitChars(ch) {
        this._appendCharToCurrentCharacterToken(Tokenizer3.CHARACTER_TOKEN, ch);
      }
      // Character reference helpers
    }, {
      key: "_matchNamedCharacterReference",
      value: function _matchNamedCharacterReference(startCp) {
        let result = null;
        let excess = 1;
        let i = findNamedEntityTreeBranch(0, startCp);
        this.tempBuff.push(startCp);
        while (i > -1) {
          const current = neTree[i];
          const inNode = current < MAX_BRANCH_MARKER_VALUE;
          const nodeWithData = inNode && current & HAS_DATA_FLAG;
          if (nodeWithData) {
            result = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
            excess = 0;
          }
          const cp = this._consume();
          this.tempBuff.push(cp);
          excess++;
          if (cp === $.EOF) {
            break;
          }
          if (inNode) {
            i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;
          } else {
            i = cp === current ? ++i : -1;
          }
        }
        while (excess--) {
          this.tempBuff.pop();
          this._unconsume();
        }
        return result;
      }
    }, {
      key: "_isCharacterReferenceInAttribute",
      value: function _isCharacterReferenceInAttribute() {
        return this.returnState === ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE || this.returnState === ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE || this.returnState === ATTRIBUTE_VALUE_UNQUOTED_STATE;
      }
    }, {
      key: "_isCharacterReferenceAttributeQuirk",
      value: function _isCharacterReferenceAttributeQuirk(withSemicolon) {
        if (!withSemicolon && this._isCharacterReferenceInAttribute()) {
          const nextCp = this._consume();
          this._unconsume();
          return nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp);
        }
        return false;
      }
    }, {
      key: "_flushCodePointsConsumedAsCharacterReference",
      value: function _flushCodePointsConsumedAsCharacterReference() {
        if (this._isCharacterReferenceInAttribute()) {
          for (let i = 0; i < this.tempBuff.length; i++) {
            this.currentAttr.value += toChar(this.tempBuff[i]);
          }
        } else {
          this._emitSeveralCodePoints(this.tempBuff);
        }
        this.tempBuff = [];
      }
      // State machine
      // Data state
      //------------------------------------------------------------------
    }, {
      key: DATA_STATE,
      value: function(cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $.LESS_THAN_SIGN) {
          this.state = TAG_OPEN_STATE;
        } else if (cp === $.AMPERSAND) {
          this.returnState = DATA_STATE;
          this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitCodePoint(cp);
        } else if (cp === $.EOF) {
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      //  RCDATA state
      //------------------------------------------------------------------
    }, {
      key: RCDATA_STATE,
      value: function(cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $.AMPERSAND) {
          this.returnState = RCDATA_STATE;
          this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = RCDATA_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // RAWTEXT state
      //------------------------------------------------------------------
    }, {
      key: RAWTEXT_STATE,
      value: function(cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $.LESS_THAN_SIGN) {
          this.state = RAWTEXT_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // Script data state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_STATE,
      value: function(cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // PLAINTEXT state
      //------------------------------------------------------------------
    }, {
      key: PLAINTEXT_STATE,
      value: function(cp) {
        this.preprocessor.dropParsedChunk();
        if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // Tag open state
      //------------------------------------------------------------------
    }, {
      key: TAG_OPEN_STATE,
      value: function(cp) {
        if (cp === $.EXCLAMATION_MARK) {
          this.state = MARKUP_DECLARATION_OPEN_STATE;
        } else if (cp === $.SOLIDUS) {
          this.state = END_TAG_OPEN_STATE;
        } else if (isAsciiLetter(cp)) {
          this._createStartTagToken();
          this._reconsumeInState(TAG_NAME_STATE);
        } else if (cp === $.QUESTION_MARK) {
          this._err(ERR.unexpectedQuestionMarkInsteadOfTagName);
          this._createCommentToken();
          this._reconsumeInState(BOGUS_COMMENT_STATE);
        } else if (cp === $.EOF) {
          this._err(ERR.eofBeforeTagName);
          this._emitChars("<");
          this._emitEOFToken();
        } else {
          this._err(ERR.invalidFirstCharacterOfTagName);
          this._emitChars("<");
          this._reconsumeInState(DATA_STATE);
        }
      }
      // End tag open state
      //------------------------------------------------------------------
    }, {
      key: END_TAG_OPEN_STATE,
      value: function(cp) {
        if (isAsciiLetter(cp)) {
          this._createEndTagToken();
          this._reconsumeInState(TAG_NAME_STATE);
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingEndTagName);
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofBeforeTagName);
          this._emitChars("</");
          this._emitEOFToken();
        } else {
          this._err(ERR.invalidFirstCharacterOfTagName);
          this._createCommentToken();
          this._reconsumeInState(BOGUS_COMMENT_STATE);
        }
      }
      // Tag name state
      //------------------------------------------------------------------
    }, {
      key: TAG_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this.state = BEFORE_ATTRIBUTE_NAME_STATE;
        } else if (cp === $.SOLIDUS) {
          this.state = SELF_CLOSING_START_TAG_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (isAsciiUpper(cp)) {
          this.currentToken.tagName += toAsciiLowerChar(cp);
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.tagName += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this.currentToken.tagName += toChar(cp);
        }
      }
      // RCDATA less-than sign state
      //------------------------------------------------------------------
    }, {
      key: RCDATA_LESS_THAN_SIGN_STATE,
      value: function(cp) {
        if (cp === $.SOLIDUS) {
          this.tempBuff = [];
          this.state = RCDATA_END_TAG_OPEN_STATE;
        } else {
          this._emitChars("<");
          this._reconsumeInState(RCDATA_STATE);
        }
      }
      // RCDATA end tag open state
      //------------------------------------------------------------------
    }, {
      key: RCDATA_END_TAG_OPEN_STATE,
      value: function(cp) {
        if (isAsciiLetter(cp)) {
          this._createEndTagToken();
          this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
        } else {
          this._emitChars("</");
          this._reconsumeInState(RCDATA_STATE);
        }
      }
      // RCDATA end tag name state
      //------------------------------------------------------------------
    }, {
      key: RCDATA_END_TAG_NAME_STATE,
      value: function(cp) {
        if (isAsciiUpper(cp)) {
          this.currentToken.tagName += toAsciiLowerChar(cp);
          this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
          this.currentToken.tagName += toChar(cp);
          this.tempBuff.push(cp);
        } else {
          if (this.lastStartTagName === this.currentToken.tagName) {
            if (isWhitespace2(cp)) {
              this.state = BEFORE_ATTRIBUTE_NAME_STATE;
              return;
            }
            if (cp === $.SOLIDUS) {
              this.state = SELF_CLOSING_START_TAG_STATE;
              return;
            }
            if (cp === $.GREATER_THAN_SIGN) {
              this.state = DATA_STATE;
              this._emitCurrentToken();
              return;
            }
          }
          this._emitChars("</");
          this._emitSeveralCodePoints(this.tempBuff);
          this._reconsumeInState(RCDATA_STATE);
        }
      }
      // RAWTEXT less-than sign state
      //------------------------------------------------------------------
    }, {
      key: RAWTEXT_LESS_THAN_SIGN_STATE,
      value: function(cp) {
        if (cp === $.SOLIDUS) {
          this.tempBuff = [];
          this.state = RAWTEXT_END_TAG_OPEN_STATE;
        } else {
          this._emitChars("<");
          this._reconsumeInState(RAWTEXT_STATE);
        }
      }
      // RAWTEXT end tag open state
      //------------------------------------------------------------------
    }, {
      key: RAWTEXT_END_TAG_OPEN_STATE,
      value: function(cp) {
        if (isAsciiLetter(cp)) {
          this._createEndTagToken();
          this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
        } else {
          this._emitChars("</");
          this._reconsumeInState(RAWTEXT_STATE);
        }
      }
      // RAWTEXT end tag name state
      //------------------------------------------------------------------
    }, {
      key: RAWTEXT_END_TAG_NAME_STATE,
      value: function(cp) {
        if (isAsciiUpper(cp)) {
          this.currentToken.tagName += toAsciiLowerChar(cp);
          this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
          this.currentToken.tagName += toChar(cp);
          this.tempBuff.push(cp);
        } else {
          if (this.lastStartTagName === this.currentToken.tagName) {
            if (isWhitespace2(cp)) {
              this.state = BEFORE_ATTRIBUTE_NAME_STATE;
              return;
            }
            if (cp === $.SOLIDUS) {
              this.state = SELF_CLOSING_START_TAG_STATE;
              return;
            }
            if (cp === $.GREATER_THAN_SIGN) {
              this._emitCurrentToken();
              this.state = DATA_STATE;
              return;
            }
          }
          this._emitChars("</");
          this._emitSeveralCodePoints(this.tempBuff);
          this._reconsumeInState(RAWTEXT_STATE);
        }
      }
      // Script data less-than sign state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_LESS_THAN_SIGN_STATE,
      value: function(cp) {
        if (cp === $.SOLIDUS) {
          this.tempBuff = [];
          this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
        } else if (cp === $.EXCLAMATION_MARK) {
          this.state = SCRIPT_DATA_ESCAPE_START_STATE;
          this._emitChars("<!");
        } else {
          this._emitChars("<");
          this._reconsumeInState(SCRIPT_DATA_STATE);
        }
      }
      // Script data end tag open state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_END_TAG_OPEN_STATE,
      value: function(cp) {
        if (isAsciiLetter(cp)) {
          this._createEndTagToken();
          this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
        } else {
          this._emitChars("</");
          this._reconsumeInState(SCRIPT_DATA_STATE);
        }
      }
      // Script data end tag name state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_END_TAG_NAME_STATE,
      value: function(cp) {
        if (isAsciiUpper(cp)) {
          this.currentToken.tagName += toAsciiLowerChar(cp);
          this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
          this.currentToken.tagName += toChar(cp);
          this.tempBuff.push(cp);
        } else {
          if (this.lastStartTagName === this.currentToken.tagName) {
            if (isWhitespace2(cp)) {
              this.state = BEFORE_ATTRIBUTE_NAME_STATE;
              return;
            } else if (cp === $.SOLIDUS) {
              this.state = SELF_CLOSING_START_TAG_STATE;
              return;
            } else if (cp === $.GREATER_THAN_SIGN) {
              this._emitCurrentToken();
              this.state = DATA_STATE;
              return;
            }
          }
          this._emitChars("</");
          this._emitSeveralCodePoints(this.tempBuff);
          this._reconsumeInState(SCRIPT_DATA_STATE);
        }
      }
      // Script data escape start state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPE_START_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
          this._emitChars("-");
        } else {
          this._reconsumeInState(SCRIPT_DATA_STATE);
        }
      }
      // Script data escape start dash state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPE_START_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
          this._emitChars("-");
        } else {
          this._reconsumeInState(SCRIPT_DATA_STATE);
        }
      }
      // Script data escaped state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPED_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
          this._emitChars("-");
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // Script data escaped dash state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPED_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
          this._emitChars("-");
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.state = SCRIPT_DATA_ESCAPED_STATE;
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
        } else {
          this.state = SCRIPT_DATA_ESCAPED_STATE;
          this._emitCodePoint(cp);
        }
      }
      // Script data escaped dash dash state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPED_DASH_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this._emitChars("-");
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this.state = SCRIPT_DATA_STATE;
          this._emitChars(">");
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.state = SCRIPT_DATA_ESCAPED_STATE;
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
        } else {
          this.state = SCRIPT_DATA_ESCAPED_STATE;
          this._emitCodePoint(cp);
        }
      }
      // Script data escaped less-than sign state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE,
      value: function(cp) {
        if (cp === $.SOLIDUS) {
          this.tempBuff = [];
          this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
        } else if (isAsciiLetter(cp)) {
          this.tempBuff = [];
          this._emitChars("<");
          this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
        } else {
          this._emitChars("<");
          this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
      }
      // Script data escaped end tag open state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE,
      value: function(cp) {
        if (isAsciiLetter(cp)) {
          this._createEndTagToken();
          this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
        } else {
          this._emitChars("</");
          this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
      }
      // Script data escaped end tag name state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE,
      value: function(cp) {
        if (isAsciiUpper(cp)) {
          this.currentToken.tagName += toAsciiLowerChar(cp);
          this.tempBuff.push(cp);
        } else if (isAsciiLower(cp)) {
          this.currentToken.tagName += toChar(cp);
          this.tempBuff.push(cp);
        } else {
          if (this.lastStartTagName === this.currentToken.tagName) {
            if (isWhitespace2(cp)) {
              this.state = BEFORE_ATTRIBUTE_NAME_STATE;
              return;
            }
            if (cp === $.SOLIDUS) {
              this.state = SELF_CLOSING_START_TAG_STATE;
              return;
            }
            if (cp === $.GREATER_THAN_SIGN) {
              this._emitCurrentToken();
              this.state = DATA_STATE;
              return;
            }
          }
          this._emitChars("</");
          this._emitSeveralCodePoints(this.tempBuff);
          this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
      }
      // Script data double escape start state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE,
      value: function(cp) {
        if (isWhitespace2(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
          this.state = this._isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
          this._emitCodePoint(cp);
        } else if (isAsciiUpper(cp)) {
          this.tempBuff.push(toAsciiLowerCodePoint(cp));
          this._emitCodePoint(cp);
        } else if (isAsciiLower(cp)) {
          this.tempBuff.push(cp);
          this._emitCodePoint(cp);
        } else {
          this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
        }
      }
      // Script data double escaped state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_DOUBLE_ESCAPED_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
          this._emitChars("-");
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
          this._emitChars("<");
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // Script data double escaped dash state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
          this._emitChars("-");
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
          this._emitChars("<");
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
        } else {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
          this._emitCodePoint(cp);
        }
      }
      // Script data double escaped dash dash state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this._emitChars("-");
        } else if (cp === $.LESS_THAN_SIGN) {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
          this._emitChars("<");
        } else if (cp === $.GREATER_THAN_SIGN) {
          this.state = SCRIPT_DATA_STATE;
          this._emitChars(">");
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
          this._emitChars(unicode2.REPLACEMENT_CHARACTER);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInScriptHtmlCommentLikeText);
          this._emitEOFToken();
        } else {
          this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
          this._emitCodePoint(cp);
        }
      }
      // Script data double escaped less-than sign state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE,
      value: function(cp) {
        if (cp === $.SOLIDUS) {
          this.tempBuff = [];
          this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
          this._emitChars("/");
        } else {
          this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
        }
      }
      // Script data double escape end state
      //------------------------------------------------------------------
    }, {
      key: SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE,
      value: function(cp) {
        if (isWhitespace2(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
          this.state = this._isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
          this._emitCodePoint(cp);
        } else if (isAsciiUpper(cp)) {
          this.tempBuff.push(toAsciiLowerCodePoint(cp));
          this._emitCodePoint(cp);
        } else if (isAsciiLower(cp)) {
          this.tempBuff.push(cp);
          this._emitCodePoint(cp);
        } else {
          this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
        }
      }
      // Before attribute name state
      //------------------------------------------------------------------
    }, {
      key: BEFORE_ATTRIBUTE_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
          this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.EQUALS_SIGN) {
          this._err(ERR.unexpectedEqualsSignBeforeAttributeName);
          this._createAttr("=");
          this.state = ATTRIBUTE_NAME_STATE;
        } else {
          this._createAttr("");
          this._reconsumeInState(ATTRIBUTE_NAME_STATE);
        }
      }
      // Attribute name state
      //------------------------------------------------------------------
    }, {
      key: ATTRIBUTE_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
          this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
          this._unconsume();
        } else if (cp === $.EQUALS_SIGN) {
          this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);
        } else if (isAsciiUpper(cp)) {
          this.currentAttr.name += toAsciiLowerChar(cp);
        } else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN) {
          this._err(ERR.unexpectedCharacterInAttributeName);
          this.currentAttr.name += toChar(cp);
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentAttr.name += unicode2.REPLACEMENT_CHARACTER;
        } else {
          this.currentAttr.name += toChar(cp);
        }
      }
      // After attribute name state
      //------------------------------------------------------------------
    }, {
      key: AFTER_ATTRIBUTE_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.SOLIDUS) {
          this.state = SELF_CLOSING_START_TAG_STATE;
        } else if (cp === $.EQUALS_SIGN) {
          this.state = BEFORE_ATTRIBUTE_VALUE_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this._createAttr("");
          this._reconsumeInState(ATTRIBUTE_NAME_STATE);
        }
      }
      // Before attribute value state
      //------------------------------------------------------------------
    }, {
      key: BEFORE_ATTRIBUTE_VALUE_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.QUOTATION_MARK) {
          this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingAttributeValue);
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else {
          this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
        }
      }
      // Attribute value (double-quoted) state
      //------------------------------------------------------------------
    }, {
      key: ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE,
      value: function(cp) {
        if (cp === $.QUOTATION_MARK) {
          this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        } else if (cp === $.AMPERSAND) {
          this.returnState = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
          this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this.currentAttr.value += toChar(cp);
        }
      }
      // Attribute value (single-quoted) state
      //------------------------------------------------------------------
    }, {
      key: ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE,
      value: function(cp) {
        if (cp === $.APOSTROPHE) {
          this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
        } else if (cp === $.AMPERSAND) {
          this.returnState = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
          this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this.currentAttr.value += toChar(cp);
        }
      }
      // Attribute value (unquoted) state
      //------------------------------------------------------------------
    }, {
      key: ATTRIBUTE_VALUE_UNQUOTED_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.AMPERSAND) {
          this.returnState = ATTRIBUTE_VALUE_UNQUOTED_STATE;
          this.state = CHARACTER_REFERENCE_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._leaveAttrValue(DATA_STATE);
          this._emitCurrentToken();
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentAttr.value += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN || cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT) {
          this._err(ERR.unexpectedCharacterInUnquotedAttributeValue);
          this.currentAttr.value += toChar(cp);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this.currentAttr.value += toChar(cp);
        }
      }
      // After attribute value (quoted) state
      //------------------------------------------------------------------
    }, {
      key: AFTER_ATTRIBUTE_VALUE_QUOTED_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
        } else if (cp === $.SOLIDUS) {
          this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._leaveAttrValue(DATA_STATE);
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this._err(ERR.missingWhitespaceBetweenAttributes);
          this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
        }
      }
      // Self-closing start tag state
      //------------------------------------------------------------------
    }, {
      key: SELF_CLOSING_START_TAG_STATE,
      value: function(cp) {
        if (cp === $.GREATER_THAN_SIGN) {
          this.currentToken.selfClosing = true;
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInTag);
          this._emitEOFToken();
        } else {
          this._err(ERR.unexpectedSolidusInTag);
          this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
        }
      }
      // Bogus comment state
      //------------------------------------------------------------------
    }, {
      key: BOGUS_COMMENT_STATE,
      value: function(cp) {
        if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._emitCurrentToken();
          this._emitEOFToken();
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.data += unicode2.REPLACEMENT_CHARACTER;
        } else {
          this.currentToken.data += toChar(cp);
        }
      }
      // Markup declaration open state
      //------------------------------------------------------------------
    }, {
      key: MARKUP_DECLARATION_OPEN_STATE,
      value: function(cp) {
        if (this._consumeSequenceIfMatch($$2.DASH_DASH_STRING, cp, true)) {
          this._createCommentToken();
          this.state = COMMENT_START_STATE;
        } else if (this._consumeSequenceIfMatch($$2.DOCTYPE_STRING, cp, false)) {
          this.state = DOCTYPE_STATE;
        } else if (this._consumeSequenceIfMatch($$2.CDATA_START_STRING, cp, true)) {
          if (this.allowCDATA) {
            this.state = CDATA_SECTION_STATE;
          } else {
            this._err(ERR.cdataInHtmlContent);
            this._createCommentToken();
            this.currentToken.data = "[CDATA[";
            this.state = BOGUS_COMMENT_STATE;
          }
        } else if (!this._ensureHibernation()) {
          this._err(ERR.incorrectlyOpenedComment);
          this._createCommentToken();
          this._reconsumeInState(BOGUS_COMMENT_STATE);
        }
      }
      // Comment start state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_START_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = COMMENT_START_DASH_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.abruptClosingOfEmptyComment);
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else {
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // Comment start dash state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_START_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = COMMENT_END_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.abruptClosingOfEmptyComment);
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInComment);
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.data += "-";
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // Comment state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = COMMENT_END_DASH_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
          this.currentToken.data += "<";
          this.state = COMMENT_LESS_THAN_SIGN_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.data += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInComment);
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.data += toChar(cp);
        }
      }
      // Comment less-than sign state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_LESS_THAN_SIGN_STATE,
      value: function(cp) {
        if (cp === $.EXCLAMATION_MARK) {
          this.currentToken.data += "!";
          this.state = COMMENT_LESS_THAN_SIGN_BANG_STATE;
        } else if (cp === $.LESS_THAN_SIGN) {
          this.currentToken.data += "!";
        } else {
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // Comment less-than sign bang state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_LESS_THAN_SIGN_BANG_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE;
        } else {
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // Comment less-than sign bang dash state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE;
        } else {
          this._reconsumeInState(COMMENT_END_DASH_STATE);
        }
      }
      // Comment less-than sign bang dash dash state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE,
      value: function(cp) {
        if (cp !== $.GREATER_THAN_SIGN && cp !== $.EOF) {
          this._err(ERR.nestedComment);
        }
        this._reconsumeInState(COMMENT_END_STATE);
      }
      // Comment end dash state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_END_DASH_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.state = COMMENT_END_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInComment);
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.data += "-";
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // Comment end state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_END_STATE,
      value: function(cp) {
        if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EXCLAMATION_MARK) {
          this.state = COMMENT_END_BANG_STATE;
        } else if (cp === $.HYPHEN_MINUS) {
          this.currentToken.data += "-";
        } else if (cp === $.EOF) {
          this._err(ERR.eofInComment);
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.data += "--";
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // Comment end bang state
      //------------------------------------------------------------------
    }, {
      key: COMMENT_END_BANG_STATE,
      value: function(cp) {
        if (cp === $.HYPHEN_MINUS) {
          this.currentToken.data += "--!";
          this.state = COMMENT_END_DASH_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.incorrectlyClosedComment);
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInComment);
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.data += "--!";
          this._reconsumeInState(COMMENT_STATE);
        }
      }
      // DOCTYPE state
      //------------------------------------------------------------------
    }, {
      key: DOCTYPE_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this.state = BEFORE_DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this._createDoctypeToken(null);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingWhitespaceBeforeDoctypeName);
          this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
        }
      }
      // Before DOCTYPE name state
      //------------------------------------------------------------------
    }, {
      key: BEFORE_DOCTYPE_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (isAsciiUpper(cp)) {
          this._createDoctypeToken(toAsciiLowerChar(cp));
          this.state = DOCTYPE_NAME_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this._createDoctypeToken(unicode2.REPLACEMENT_CHARACTER);
          this.state = DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingDoctypeName);
          this._createDoctypeToken(null);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this._createDoctypeToken(null);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._createDoctypeToken(toChar(cp));
          this.state = DOCTYPE_NAME_STATE;
        }
      }
      // DOCTYPE name state
      //------------------------------------------------------------------
    }, {
      key: DOCTYPE_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this.state = AFTER_DOCTYPE_NAME_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (isAsciiUpper(cp)) {
          this.currentToken.name += toAsciiLowerChar(cp);
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.name += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.name += toChar(cp);
        }
      }
      // After DOCTYPE name state
      //------------------------------------------------------------------
    }, {
      key: AFTER_DOCTYPE_NAME_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else if (this._consumeSequenceIfMatch($$2.PUBLIC_STRING, cp, false)) {
          this.state = AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE;
        } else if (this._consumeSequenceIfMatch($$2.SYSTEM_STRING, cp, false)) {
          this.state = AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE;
        } else if (!this._ensureHibernation()) {
          this._err(ERR.invalidCharacterSequenceAfterDoctypeName);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // After DOCTYPE public keyword state
      //------------------------------------------------------------------
    }, {
      key: AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.QUOTATION_MARK) {
          this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
          this.currentToken.publicId = "";
          this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
          this.currentToken.publicId = "";
          this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingDoctypePublicIdentifier);
          this.currentToken.forceQuirks = true;
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // Before DOCTYPE public identifier state
      //------------------------------------------------------------------
    }, {
      key: BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.QUOTATION_MARK) {
          this.currentToken.publicId = "";
          this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this.currentToken.publicId = "";
          this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingDoctypePublicIdentifier);
          this.currentToken.forceQuirks = true;
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // DOCTYPE public identifier (double-quoted) state
      //------------------------------------------------------------------
    }, {
      key: DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE,
      value: function(cp) {
        if (cp === $.QUOTATION_MARK) {
          this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.publicId += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.abruptDoctypePublicIdentifier);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.publicId += toChar(cp);
        }
      }
      // DOCTYPE public identifier (single-quoted) state
      //------------------------------------------------------------------
    }, {
      key: DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE,
      value: function(cp) {
        if (cp === $.APOSTROPHE) {
          this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.publicId += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.abruptDoctypePublicIdentifier);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.publicId += toChar(cp);
        }
      }
      // After DOCTYPE public identifier state
      //------------------------------------------------------------------
    }, {
      key: AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.QUOTATION_MARK) {
          this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // Between DOCTYPE public and system identifiers state
      //------------------------------------------------------------------
    }, {
      key: BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.GREATER_THAN_SIGN) {
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.QUOTATION_MARK) {
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // After DOCTYPE system keyword state
      //------------------------------------------------------------------
    }, {
      key: AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.QUOTATION_MARK) {
          this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // Before DOCTYPE system identifier state
      //------------------------------------------------------------------
    }, {
      key: BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.QUOTATION_MARK) {
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
        } else if (cp === $.APOSTROPHE) {
          this.currentToken.systemId = "";
          this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.missingDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this.state = DATA_STATE;
          this._emitCurrentToken();
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // DOCTYPE system identifier (double-quoted) state
      //------------------------------------------------------------------
    }, {
      key: DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE,
      value: function(cp) {
        if (cp === $.QUOTATION_MARK) {
          this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.systemId += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.abruptDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.systemId += toChar(cp);
        }
      }
      // DOCTYPE system identifier (single-quoted) state
      //------------------------------------------------------------------
    }, {
      key: DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE,
      value: function(cp) {
        if (cp === $.APOSTROPHE) {
          this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
          this.currentToken.systemId += unicode2.REPLACEMENT_CHARACTER;
        } else if (cp === $.GREATER_THAN_SIGN) {
          this._err(ERR.abruptDoctypeSystemIdentifier);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this.currentToken.systemId += toChar(cp);
        }
      }
      // After DOCTYPE system identifier state
      //------------------------------------------------------------------
    }, {
      key: AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE,
      value: function(cp) {
        if (isWhitespace2(cp)) {
          return;
        }
        if (cp === $.GREATER_THAN_SIGN) {
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInDoctype);
          this.currentToken.forceQuirks = true;
          this._emitCurrentToken();
          this._emitEOFToken();
        } else {
          this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
          this._reconsumeInState(BOGUS_DOCTYPE_STATE);
        }
      }
      // Bogus DOCTYPE state
      //------------------------------------------------------------------
    }, {
      key: BOGUS_DOCTYPE_STATE,
      value: function(cp) {
        if (cp === $.GREATER_THAN_SIGN) {
          this._emitCurrentToken();
          this.state = DATA_STATE;
        } else if (cp === $.NULL) {
          this._err(ERR.unexpectedNullCharacter);
        } else if (cp === $.EOF) {
          this._emitCurrentToken();
          this._emitEOFToken();
        }
      }
      // CDATA section state
      //------------------------------------------------------------------
    }, {
      key: CDATA_SECTION_STATE,
      value: function(cp) {
        if (cp === $.RIGHT_SQUARE_BRACKET) {
          this.state = CDATA_SECTION_BRACKET_STATE;
        } else if (cp === $.EOF) {
          this._err(ERR.eofInCdata);
          this._emitEOFToken();
        } else {
          this._emitCodePoint(cp);
        }
      }
      // CDATA section bracket state
      //------------------------------------------------------------------
    }, {
      key: CDATA_SECTION_BRACKET_STATE,
      value: function(cp) {
        if (cp === $.RIGHT_SQUARE_BRACKET) {
          this.state = CDATA_SECTION_END_STATE;
        } else {
          this._emitChars("]");
          this._reconsumeInState(CDATA_SECTION_STATE);
        }
      }
      // CDATA section end state
      //------------------------------------------------------------------
    }, {
      key: CDATA_SECTION_END_STATE,
      value: function(cp) {
        if (cp === $.GREATER_THAN_SIGN) {
          this.state = DATA_STATE;
        } else if (cp === $.RIGHT_SQUARE_BRACKET) {
          this._emitChars("]");
        } else {
          this._emitChars("]]");
          this._reconsumeInState(CDATA_SECTION_STATE);
        }
      }
      // Character reference state
      //------------------------------------------------------------------
    }, {
      key: CHARACTER_REFERENCE_STATE,
      value: function(cp) {
        this.tempBuff = [$.AMPERSAND];
        if (cp === $.NUMBER_SIGN) {
          this.tempBuff.push(cp);
          this.state = NUMERIC_CHARACTER_REFERENCE_STATE;
        } else if (isAsciiAlphaNumeric(cp)) {
          this._reconsumeInState(NAMED_CHARACTER_REFERENCE_STATE);
        } else {
          this._flushCodePointsConsumedAsCharacterReference();
          this._reconsumeInState(this.returnState);
        }
      }
      // Named character reference state
      //------------------------------------------------------------------
    }, {
      key: NAMED_CHARACTER_REFERENCE_STATE,
      value: function(cp) {
        const matchResult = this._matchNamedCharacterReference(cp);
        if (this._ensureHibernation()) {
          this.tempBuff = [$.AMPERSAND];
        } else if (matchResult) {
          const withSemicolon = this.tempBuff[this.tempBuff.length - 1] === $.SEMICOLON;
          if (!this._isCharacterReferenceAttributeQuirk(withSemicolon)) {
            if (!withSemicolon) {
              this._errOnNextCodePoint(ERR.missingSemicolonAfterCharacterReference);
            }
            this.tempBuff = matchResult;
          }
          this._flushCodePointsConsumedAsCharacterReference();
          this.state = this.returnState;
        } else {
          this._flushCodePointsConsumedAsCharacterReference();
          this.state = AMBIGUOUS_AMPERSAND_STATE;
        }
      }
      // Ambiguos ampersand state
      //------------------------------------------------------------------
    }, {
      key: AMBIGUOUS_AMPERSAND_STATE,
      value: function(cp) {
        if (isAsciiAlphaNumeric(cp)) {
          if (this._isCharacterReferenceInAttribute()) {
            this.currentAttr.value += toChar(cp);
          } else {
            this._emitCodePoint(cp);
          }
        } else {
          if (cp === $.SEMICOLON) {
            this._err(ERR.unknownNamedCharacterReference);
          }
          this._reconsumeInState(this.returnState);
        }
      }
      // Numeric character reference state
      //------------------------------------------------------------------
    }, {
      key: NUMERIC_CHARACTER_REFERENCE_STATE,
      value: function(cp) {
        this.charRefCode = 0;
        if (cp === $.LATIN_SMALL_X || cp === $.LATIN_CAPITAL_X) {
          this.tempBuff.push(cp);
          this.state = HEXADEMICAL_CHARACTER_REFERENCE_START_STATE;
        } else {
          this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_START_STATE);
        }
      }
      // Hexademical character reference start state
      //------------------------------------------------------------------
    }, {
      key: HEXADEMICAL_CHARACTER_REFERENCE_START_STATE,
      value: function(cp) {
        if (isAsciiHexDigit(cp)) {
          this._reconsumeInState(HEXADEMICAL_CHARACTER_REFERENCE_STATE);
        } else {
          this._err(ERR.absenceOfDigitsInNumericCharacterReference);
          this._flushCodePointsConsumedAsCharacterReference();
          this._reconsumeInState(this.returnState);
        }
      }
      // Decimal character reference start state
      //------------------------------------------------------------------
    }, {
      key: DECIMAL_CHARACTER_REFERENCE_START_STATE,
      value: function(cp) {
        if (isAsciiDigit(cp)) {
          this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_STATE);
        } else {
          this._err(ERR.absenceOfDigitsInNumericCharacterReference);
          this._flushCodePointsConsumedAsCharacterReference();
          this._reconsumeInState(this.returnState);
        }
      }
      // Hexademical character reference state
      //------------------------------------------------------------------
    }, {
      key: HEXADEMICAL_CHARACTER_REFERENCE_STATE,
      value: function(cp) {
        if (isAsciiUpperHexDigit(cp)) {
          this.charRefCode = this.charRefCode * 16 + cp - 55;
        } else if (isAsciiLowerHexDigit(cp)) {
          this.charRefCode = this.charRefCode * 16 + cp - 87;
        } else if (isAsciiDigit(cp)) {
          this.charRefCode = this.charRefCode * 16 + cp - 48;
        } else if (cp === $.SEMICOLON) {
          this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
        } else {
          this._err(ERR.missingSemicolonAfterCharacterReference);
          this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
      }
      // Decimal character reference state
      //------------------------------------------------------------------
    }, {
      key: DECIMAL_CHARACTER_REFERENCE_STATE,
      value: function(cp) {
        if (isAsciiDigit(cp)) {
          this.charRefCode = this.charRefCode * 10 + cp - 48;
        } else if (cp === $.SEMICOLON) {
          this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
        } else {
          this._err(ERR.missingSemicolonAfterCharacterReference);
          this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
        }
      }
      // Numeric character reference end state
      //------------------------------------------------------------------
    }, {
      key: NUMERIC_CHARACTER_REFERENCE_END_STATE,
      value: function() {
        if (this.charRefCode === $.NULL) {
          this._err(ERR.nullCharacterReference);
          this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (this.charRefCode > 1114111) {
          this._err(ERR.characterReferenceOutsideUnicodeRange);
          this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (unicode2.isSurrogate(this.charRefCode)) {
          this._err(ERR.surrogateCharacterReference);
          this.charRefCode = $.REPLACEMENT_CHARACTER;
        } else if (unicode2.isUndefinedCodePoint(this.charRefCode)) {
          this._err(ERR.noncharacterCharacterReference);
        } else if (unicode2.isControlCodePoint(this.charRefCode) || this.charRefCode === $.CARRIAGE_RETURN) {
          this._err(ERR.controlCharacterReference);
          const replacement = C1_CONTROLS_REFERENCE_REPLACEMENTS[this.charRefCode];
          if (replacement) {
            this.charRefCode = replacement;
          }
        }
        this.tempBuff = [this.charRefCode];
        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
      }
    }]);
  })();
  Tokenizer2.CHARACTER_TOKEN = "CHARACTER_TOKEN";
  Tokenizer2.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
  Tokenizer2.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
  Tokenizer2.START_TAG_TOKEN = "START_TAG_TOKEN";
  Tokenizer2.END_TAG_TOKEN = "END_TAG_TOKEN";
  Tokenizer2.COMMENT_TOKEN = "COMMENT_TOKEN";
  Tokenizer2.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
  Tokenizer2.EOF_TOKEN = "EOF_TOKEN";
  Tokenizer2.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
  Tokenizer2.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
  };
  Tokenizer2.getTokenAttr = function(token, attrName) {
    for (let i = token.attrs.length - 1; i >= 0; i--) {
      if (token.attrs[i].name === attrName) {
        return token.attrs[i].value;
      }
    }
    return null;
  };
  tokenizer = Tokenizer2;
  return tokenizer;
}
var html$1 = {};
var hasRequiredHtml;
function requireHtml() {
  if (hasRequiredHtml) return html$1;
  hasRequiredHtml = 1;
  const NS = html$1.NAMESPACES = {
    HTML: "http://www.w3.org/1999/xhtml",
    MATHML: "http://www.w3.org/1998/Math/MathML",
    SVG: "http://www.w3.org/2000/svg",
    XLINK: "http://www.w3.org/1999/xlink",
    XML: "http://www.w3.org/XML/1998/namespace",
    XMLNS: "http://www.w3.org/2000/xmlns/"
  };
  html$1.ATTRS = {
    TYPE: "type",
    ACTION: "action",
    ENCODING: "encoding",
    PROMPT: "prompt",
    NAME: "name",
    COLOR: "color",
    FACE: "face",
    SIZE: "size"
  };
  html$1.DOCUMENT_MODE = {
    NO_QUIRKS: "no-quirks",
    QUIRKS: "quirks",
    LIMITED_QUIRKS: "limited-quirks"
  };
  const $ = html$1.TAG_NAMES = {
    A: "a",
    ADDRESS: "address",
    ANNOTATION_XML: "annotation-xml",
    APPLET: "applet",
    AREA: "area",
    ARTICLE: "article",
    ASIDE: "aside",
    B: "b",
    BASE: "base",
    BASEFONT: "basefont",
    BGSOUND: "bgsound",
    BIG: "big",
    BLOCKQUOTE: "blockquote",
    BODY: "body",
    BR: "br",
    BUTTON: "button",
    CAPTION: "caption",
    CENTER: "center",
    CODE: "code",
    COL: "col",
    COLGROUP: "colgroup",
    DD: "dd",
    DESC: "desc",
    DETAILS: "details",
    DIALOG: "dialog",
    DIR: "dir",
    DIV: "div",
    DL: "dl",
    DT: "dt",
    EM: "em",
    EMBED: "embed",
    FIELDSET: "fieldset",
    FIGCAPTION: "figcaption",
    FIGURE: "figure",
    FONT: "font",
    FOOTER: "footer",
    FOREIGN_OBJECT: "foreignObject",
    FORM: "form",
    FRAME: "frame",
    FRAMESET: "frameset",
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6",
    HEAD: "head",
    HEADER: "header",
    HGROUP: "hgroup",
    HR: "hr",
    HTML: "html",
    I: "i",
    IMG: "img",
    IMAGE: "image",
    INPUT: "input",
    IFRAME: "iframe",
    KEYGEN: "keygen",
    LABEL: "label",
    LI: "li",
    LINK: "link",
    LISTING: "listing",
    MAIN: "main",
    MALIGNMARK: "malignmark",
    MARQUEE: "marquee",
    MATH: "math",
    MENU: "menu",
    META: "meta",
    MGLYPH: "mglyph",
    MI: "mi",
    MO: "mo",
    MN: "mn",
    MS: "ms",
    MTEXT: "mtext",
    NAV: "nav",
    NOBR: "nobr",
    NOFRAMES: "noframes",
    NOEMBED: "noembed",
    NOSCRIPT: "noscript",
    OBJECT: "object",
    OL: "ol",
    OPTGROUP: "optgroup",
    OPTION: "option",
    P: "p",
    PARAM: "param",
    PLAINTEXT: "plaintext",
    PRE: "pre",
    RB: "rb",
    RP: "rp",
    RT: "rt",
    RTC: "rtc",
    RUBY: "ruby",
    S: "s",
    SCRIPT: "script",
    SECTION: "section",
    SELECT: "select",
    SOURCE: "source",
    SMALL: "small",
    SPAN: "span",
    STRIKE: "strike",
    STRONG: "strong",
    STYLE: "style",
    SUB: "sub",
    SUMMARY: "summary",
    SUP: "sup",
    TABLE: "table",
    TBODY: "tbody",
    TEMPLATE: "template",
    TEXTAREA: "textarea",
    TFOOT: "tfoot",
    TD: "td",
    TH: "th",
    THEAD: "thead",
    TITLE: "title",
    TR: "tr",
    TRACK: "track",
    TT: "tt",
    U: "u",
    UL: "ul",
    SVG: "svg",
    VAR: "var",
    WBR: "wbr",
    XMP: "xmp"
  };
  html$1.SPECIAL_ELEMENTS = {
    [NS.HTML]: {
      [$.ADDRESS]: true,
      [$.APPLET]: true,
      [$.AREA]: true,
      [$.ARTICLE]: true,
      [$.ASIDE]: true,
      [$.BASE]: true,
      [$.BASEFONT]: true,
      [$.BGSOUND]: true,
      [$.BLOCKQUOTE]: true,
      [$.BODY]: true,
      [$.BR]: true,
      [$.BUTTON]: true,
      [$.CAPTION]: true,
      [$.CENTER]: true,
      [$.COL]: true,
      [$.COLGROUP]: true,
      [$.DD]: true,
      [$.DETAILS]: true,
      [$.DIR]: true,
      [$.DIV]: true,
      [$.DL]: true,
      [$.DT]: true,
      [$.EMBED]: true,
      [$.FIELDSET]: true,
      [$.FIGCAPTION]: true,
      [$.FIGURE]: true,
      [$.FOOTER]: true,
      [$.FORM]: true,
      [$.FRAME]: true,
      [$.FRAMESET]: true,
      [$.H1]: true,
      [$.H2]: true,
      [$.H3]: true,
      [$.H4]: true,
      [$.H5]: true,
      [$.H6]: true,
      [$.HEAD]: true,
      [$.HEADER]: true,
      [$.HGROUP]: true,
      [$.HR]: true,
      [$.HTML]: true,
      [$.IFRAME]: true,
      [$.IMG]: true,
      [$.INPUT]: true,
      [$.LI]: true,
      [$.LINK]: true,
      [$.LISTING]: true,
      [$.MAIN]: true,
      [$.MARQUEE]: true,
      [$.MENU]: true,
      [$.META]: true,
      [$.NAV]: true,
      [$.NOEMBED]: true,
      [$.NOFRAMES]: true,
      [$.NOSCRIPT]: true,
      [$.OBJECT]: true,
      [$.OL]: true,
      [$.P]: true,
      [$.PARAM]: true,
      [$.PLAINTEXT]: true,
      [$.PRE]: true,
      [$.SCRIPT]: true,
      [$.SECTION]: true,
      [$.SELECT]: true,
      [$.SOURCE]: true,
      [$.STYLE]: true,
      [$.SUMMARY]: true,
      [$.TABLE]: true,
      [$.TBODY]: true,
      [$.TD]: true,
      [$.TEMPLATE]: true,
      [$.TEXTAREA]: true,
      [$.TFOOT]: true,
      [$.TH]: true,
      [$.THEAD]: true,
      [$.TITLE]: true,
      [$.TR]: true,
      [$.TRACK]: true,
      [$.UL]: true,
      [$.WBR]: true,
      [$.XMP]: true
    },
    [NS.MATHML]: {
      [$.MI]: true,
      [$.MO]: true,
      [$.MN]: true,
      [$.MS]: true,
      [$.MTEXT]: true,
      [$.ANNOTATION_XML]: true
    },
    [NS.SVG]: {
      [$.TITLE]: true,
      [$.FOREIGN_OBJECT]: true,
      [$.DESC]: true
    }
  };
  return html$1;
}
var openElementStack;
var hasRequiredOpenElementStack;
function requireOpenElementStack() {
  if (hasRequiredOpenElementStack) return openElementStack;
  hasRequiredOpenElementStack = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const HTML = requireHtml();
  const $ = HTML.TAG_NAMES;
  const NS = HTML.NAMESPACES;
  function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
      case 1:
        return tn === $.P;
      case 2:
        return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;
      case 3:
        return tn === $.RTC;
      case 6:
        return tn === $.OPTION;
      case 8:
        return tn === $.OPTGROUP;
    }
    return false;
  }
  function isImpliedEndTagRequiredThoroughly(tn) {
    switch (tn.length) {
      case 1:
        return tn === $.P;
      case 2:
        return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI || tn === $.TD || tn === $.TH || tn === $.TR;
      case 3:
        return tn === $.RTC;
      case 5:
        return tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD;
      case 6:
        return tn === $.OPTION;
      case 7:
        return tn === $.CAPTION;
      case 8:
        return tn === $.OPTGROUP || tn === $.COLGROUP;
    }
    return false;
  }
  function isScopingElement(tn, ns) {
    switch (tn.length) {
      case 2:
        if (tn === $.TD || tn === $.TH) {
          return ns === NS.HTML;
        } else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS) {
          return ns === NS.MATHML;
        }
        break;
      case 4:
        if (tn === $.HTML) {
          return ns === NS.HTML;
        } else if (tn === $.DESC) {
          return ns === NS.SVG;
        }
        break;
      case 5:
        if (tn === $.TABLE) {
          return ns === NS.HTML;
        } else if (tn === $.MTEXT) {
          return ns === NS.MATHML;
        } else if (tn === $.TITLE) {
          return ns === NS.SVG;
        }
        break;
      case 6:
        return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;
      case 7:
        return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;
      case 8:
        return tn === $.TEMPLATE && ns === NS.HTML;
      case 13:
        return tn === $.FOREIGN_OBJECT && ns === NS.SVG;
      case 14:
        return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }
    return false;
  }
  let OpenElementStack = /* @__PURE__ */ (function() {
    function OpenElementStack2(document2, treeAdapter) {
      _classCallCheck2(this, OpenElementStack2);
      this.stackTop = -1;
      this.items = [];
      this.current = document2;
      this.currentTagName = null;
      this.currentTmplContent = null;
      this.tmplCount = 0;
      this.treeAdapter = treeAdapter;
    }
    return _createClass2(OpenElementStack2, [{
      key: "_indexOf",
      value: function _indexOf(element) {
        let idx = -1;
        for (let i = this.stackTop; i >= 0; i--) {
          if (this.items[i] === element) {
            idx = i;
            break;
          }
        }
        return idx;
      }
      //Update current element
    }, {
      key: "_isInTemplate",
      value: function _isInTemplate() {
        return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
      }
    }, {
      key: "_updateCurrentElement",
      value: function _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);
        this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
      }
      //Mutations
    }, {
      key: "push",
      value: function push(element) {
        this.items[++this.stackTop] = element;
        this._updateCurrentElement();
        if (this._isInTemplate()) {
          this.tmplCount++;
        }
      }
    }, {
      key: "pop",
      value: function pop() {
        this.stackTop--;
        if (this.tmplCount > 0 && this._isInTemplate()) {
          this.tmplCount--;
        }
        this._updateCurrentElement();
      }
    }, {
      key: "replace",
      value: function replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) {
          this._updateCurrentElement();
        }
      }
    }, {
      key: "insertAfter",
      value: function insertAfter(referenceElement, newElement) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        if (insertionIdx === ++this.stackTop) {
          this._updateCurrentElement();
        }
      }
    }, {
      key: "popUntilTagNamePopped",
      value: function popUntilTagNamePopped(tagName) {
        while (this.stackTop > -1) {
          const tn = this.currentTagName;
          const ns = this.treeAdapter.getNamespaceURI(this.current);
          this.pop();
          if (tn === tagName && ns === NS.HTML) {
            break;
          }
        }
      }
    }, {
      key: "popUntilElementPopped",
      value: function popUntilElementPopped(element) {
        while (this.stackTop > -1) {
          const poppedElement = this.current;
          this.pop();
          if (poppedElement === element) {
            break;
          }
        }
      }
    }, {
      key: "popUntilNumberedHeaderPopped",
      value: function popUntilNumberedHeaderPopped() {
        while (this.stackTop > -1) {
          const tn = this.currentTagName;
          const ns = this.treeAdapter.getNamespaceURI(this.current);
          this.pop();
          if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML) {
            break;
          }
        }
      }
    }, {
      key: "popUntilTableCellPopped",
      value: function popUntilTableCellPopped() {
        while (this.stackTop > -1) {
          const tn = this.currentTagName;
          const ns = this.treeAdapter.getNamespaceURI(this.current);
          this.pop();
          if (tn === $.TD || tn === $.TH && ns === NS.HTML) {
            break;
          }
        }
      }
    }, {
      key: "popAllUpToHtmlElement",
      value: function popAllUpToHtmlElement() {
        this.stackTop = 0;
        this._updateCurrentElement();
      }
    }, {
      key: "clearBackToTableContext",
      value: function clearBackToTableContext() {
        while (this.currentTagName !== $.TABLE && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML || this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML) {
          this.pop();
        }
      }
    }, {
      key: "clearBackToTableBodyContext",
      value: function clearBackToTableBodyContext() {
        while (this.currentTagName !== $.TBODY && this.currentTagName !== $.TFOOT && this.currentTagName !== $.THEAD && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML || this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML) {
          this.pop();
        }
      }
    }, {
      key: "clearBackToTableRowContext",
      value: function clearBackToTableRowContext() {
        while (this.currentTagName !== $.TR && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML || this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML) {
          this.pop();
        }
      }
    }, {
      key: "remove",
      value: function remove2(element) {
        for (let i = this.stackTop; i >= 0; i--) {
          if (this.items[i] === element) {
            this.items.splice(i, 1);
            this.stackTop--;
            this._updateCurrentElement();
            break;
          }
        }
      }
      //Search
    }, {
      key: "tryPeekProperlyNestedBodyElement",
      value: function tryPeekProperlyNestedBodyElement() {
        const element = this.items[1];
        return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
      }
    }, {
      key: "contains",
      value: function contains2(element) {
        return this._indexOf(element) > -1;
      }
    }, {
      key: "getCommonAncestor",
      value: function getCommonAncestor(element) {
        let elementIdx = this._indexOf(element);
        return --elementIdx >= 0 ? this.items[elementIdx] : null;
      }
    }, {
      key: "isRootHtmlElementCurrent",
      value: function isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.currentTagName === $.HTML;
      }
      //Element in scope
    }, {
      key: "hasInScope",
      value: function hasInScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if (tn === tagName && ns === NS.HTML) {
            return true;
          }
          if (isScopingElement(tn, ns)) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "hasNumberedHeaderInScope",
      value: function hasNumberedHeaderInScope() {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML) {
            return true;
          }
          if (isScopingElement(tn, ns)) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "hasInListItemScope",
      value: function hasInListItemScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if (tn === tagName && ns === NS.HTML) {
            return true;
          }
          if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns)) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "hasInButtonScope",
      value: function hasInButtonScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if (tn === tagName && ns === NS.HTML) {
            return true;
          }
          if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns)) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "hasInTableScope",
      value: function hasInTableScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if (ns !== NS.HTML) {
            continue;
          }
          if (tn === tagName) {
            return true;
          }
          if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "hasTableBodyContextInTableScope",
      value: function hasTableBodyContextInTableScope() {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if (ns !== NS.HTML) {
            continue;
          }
          if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT) {
            return true;
          }
          if (tn === $.TABLE || tn === $.HTML) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "hasInSelectScope",
      value: function hasInSelectScope(tagName) {
        for (let i = this.stackTop; i >= 0; i--) {
          const tn = this.treeAdapter.getTagName(this.items[i]);
          const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
          if (ns !== NS.HTML) {
            continue;
          }
          if (tn === tagName) {
            return true;
          }
          if (tn !== $.OPTION && tn !== $.OPTGROUP) {
            return false;
          }
        }
        return true;
      }
      //Implied end tags
    }, {
      key: "generateImpliedEndTags",
      value: function generateImpliedEndTags() {
        while (isImpliedEndTagRequired(this.currentTagName)) {
          this.pop();
        }
      }
    }, {
      key: "generateImpliedEndTagsThoroughly",
      value: function generateImpliedEndTagsThoroughly() {
        while (isImpliedEndTagRequiredThoroughly(this.currentTagName)) {
          this.pop();
        }
      }
    }, {
      key: "generateImpliedEndTagsWithExclusion",
      value: function generateImpliedEndTagsWithExclusion(exclusionTagName) {
        while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName) {
          this.pop();
        }
      }
    }]);
  })();
  openElementStack = OpenElementStack;
  return openElementStack;
}
var formattingElementList;
var hasRequiredFormattingElementList;
function requireFormattingElementList() {
  if (hasRequiredFormattingElementList) return formattingElementList;
  hasRequiredFormattingElementList = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const NOAH_ARK_CAPACITY = 3;
  let FormattingElementList = /* @__PURE__ */ (function() {
    function FormattingElementList2(treeAdapter) {
      _classCallCheck2(this, FormattingElementList2);
      this.length = 0;
      this.entries = [];
      this.treeAdapter = treeAdapter;
      this.bookmark = null;
    }
    return _createClass2(FormattingElementList2, [{
      key: "_getNoahArkConditionCandidates",
      value: function _getNoahArkConditionCandidates(newElement) {
        const candidates = [];
        if (this.length >= NOAH_ARK_CAPACITY) {
          const neAttrsLength = this.treeAdapter.getAttrList(newElement).length;
          const neTagName = this.treeAdapter.getTagName(newElement);
          const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
          for (let i = this.length - 1; i >= 0; i--) {
            const entry = this.entries[i];
            if (entry.type === FormattingElementList2.MARKER_ENTRY) {
              break;
            }
            const element = entry.element;
            const elementAttrs = this.treeAdapter.getAttrList(element);
            const isCandidate = this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI && elementAttrs.length === neAttrsLength;
            if (isCandidate) {
              candidates.push({
                idx: i,
                attrs: elementAttrs
              });
            }
          }
        }
        return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
      }
    }, {
      key: "_ensureNoahArkCondition",
      value: function _ensureNoahArkCondition(newElement) {
        const candidates = this._getNoahArkConditionCandidates(newElement);
        let cLength = candidates.length;
        if (cLength) {
          const neAttrs = this.treeAdapter.getAttrList(newElement);
          const neAttrsLength = neAttrs.length;
          const neAttrsMap = /* @__PURE__ */ Object.create(null);
          for (let i = 0; i < neAttrsLength; i++) {
            const neAttr = neAttrs[i];
            neAttrsMap[neAttr.name] = neAttr.value;
          }
          for (let i = 0; i < neAttrsLength; i++) {
            for (let j = 0; j < cLength; j++) {
              const cAttr = candidates[j].attrs[i];
              if (neAttrsMap[cAttr.name] !== cAttr.value) {
                candidates.splice(j, 1);
                cLength--;
              }
              if (candidates.length < NOAH_ARK_CAPACITY) {
                return;
              }
            }
          }
          for (let i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
            this.entries.splice(candidates[i].idx, 1);
            this.length--;
          }
        }
      }
      //Mutations
    }, {
      key: "insertMarker",
      value: function insertMarker() {
        this.entries.push({
          type: FormattingElementList2.MARKER_ENTRY
        });
        this.length++;
      }
    }, {
      key: "pushElement",
      value: function pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.push({
          type: FormattingElementList2.ELEMENT_ENTRY,
          element,
          token
        });
        this.length++;
      }
    }, {
      key: "insertElementAfterBookmark",
      value: function insertElementAfterBookmark(element, token) {
        let bookmarkIdx = this.length - 1;
        for (; bookmarkIdx >= 0; bookmarkIdx--) {
          if (this.entries[bookmarkIdx] === this.bookmark) {
            break;
          }
        }
        this.entries.splice(bookmarkIdx + 1, 0, {
          type: FormattingElementList2.ELEMENT_ENTRY,
          element,
          token
        });
        this.length++;
      }
    }, {
      key: "removeEntry",
      value: function removeEntry(entry) {
        for (let i = this.length - 1; i >= 0; i--) {
          if (this.entries[i] === entry) {
            this.entries.splice(i, 1);
            this.length--;
            break;
          }
        }
      }
    }, {
      key: "clearToLastMarker",
      value: function clearToLastMarker() {
        while (this.length) {
          const entry = this.entries.pop();
          this.length--;
          if (entry.type === FormattingElementList2.MARKER_ENTRY) {
            break;
          }
        }
      }
      //Search
    }, {
      key: "getElementEntryInScopeWithTagName",
      value: function getElementEntryInScopeWithTagName(tagName) {
        for (let i = this.length - 1; i >= 0; i--) {
          const entry = this.entries[i];
          if (entry.type === FormattingElementList2.MARKER_ENTRY) {
            return null;
          }
          if (this.treeAdapter.getTagName(entry.element) === tagName) {
            return entry;
          }
        }
        return null;
      }
    }, {
      key: "getElementEntry",
      value: function getElementEntry(element) {
        for (let i = this.length - 1; i >= 0; i--) {
          const entry = this.entries[i];
          if (entry.type === FormattingElementList2.ELEMENT_ENTRY && entry.element === element) {
            return entry;
          }
        }
        return null;
      }
    }]);
  })();
  FormattingElementList.MARKER_ENTRY = "MARKER_ENTRY";
  FormattingElementList.ELEMENT_ENTRY = "ELEMENT_ENTRY";
  formattingElementList = FormattingElementList;
  return formattingElementList;
}
var mixin;
var hasRequiredMixin;
function requireMixin() {
  if (hasRequiredMixin) return mixin;
  hasRequiredMixin = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  let Mixin2 = /* @__PURE__ */ (function() {
    function Mixin3(host) {
      _classCallCheck2(this, Mixin3);
      const originalMethods = {};
      const overriddenMethods = this._getOverriddenMethods(this, originalMethods);
      for (const key of Object.keys(overriddenMethods)) {
        if (typeof overriddenMethods[key] === "function") {
          originalMethods[key] = host[key];
          host[key] = overriddenMethods[key];
        }
      }
    }
    return _createClass2(Mixin3, [{
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods() {
        throw new Error("Not implemented");
      }
    }]);
  })();
  Mixin2.install = function(host, Ctor, opts) {
    if (!host.__mixins) {
      host.__mixins = [];
    }
    for (let i = 0; i < host.__mixins.length; i++) {
      if (host.__mixins[i].constructor === Ctor) {
        return host.__mixins[i];
      }
    }
    const mixin2 = new Ctor(host, opts);
    host.__mixins.push(mixin2);
    return mixin2;
  };
  mixin = Mixin2;
  return mixin;
}
var preprocessorMixin$1;
var hasRequiredPreprocessorMixin$1;
function requirePreprocessorMixin$1() {
  if (hasRequiredPreprocessorMixin$1) return preprocessorMixin$1;
  hasRequiredPreprocessorMixin$1 = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const Mixin2 = requireMixin();
  let PositionTrackingPreprocessorMixin = /* @__PURE__ */ (function(_Mixin) {
    function PositionTrackingPreprocessorMixin2(preprocessor2) {
      var _this;
      _classCallCheck2(this, PositionTrackingPreprocessorMixin2);
      _this = _callSuper2(this, PositionTrackingPreprocessorMixin2, [preprocessor2]);
      _this.preprocessor = preprocessor2;
      _this.isEol = false;
      _this.lineStartPos = 0;
      _this.droppedBufferSize = 0;
      _this.offset = 0;
      _this.col = 0;
      _this.line = 1;
      return _this;
    }
    _inherits2(PositionTrackingPreprocessorMixin2, _Mixin);
    return _createClass2(PositionTrackingPreprocessorMixin2, [{
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods(mxn, orig) {
        return {
          advance() {
            const pos = this.pos + 1;
            const ch = this.html[pos];
            if (mxn.isEol) {
              mxn.isEol = false;
              mxn.line++;
              mxn.lineStartPos = pos;
            }
            if (ch === "\n" || ch === "\r" && this.html[pos + 1] !== "\n") {
              mxn.isEol = true;
            }
            mxn.col = pos - mxn.lineStartPos + 1;
            mxn.offset = mxn.droppedBufferSize + pos;
            return orig.advance.call(this);
          },
          retreat() {
            orig.retreat.call(this);
            mxn.isEol = false;
            mxn.col = this.pos - mxn.lineStartPos + 1;
          },
          dropParsedChunk() {
            const prevPos = this.pos;
            orig.dropParsedChunk.call(this);
            const reduction = prevPos - this.pos;
            mxn.lineStartPos -= reduction;
            mxn.droppedBufferSize += reduction;
            mxn.offset = mxn.droppedBufferSize + this.pos;
          }
        };
      }
    }]);
  })(Mixin2);
  preprocessorMixin$1 = PositionTrackingPreprocessorMixin;
  return preprocessorMixin$1;
}
var tokenizerMixin$1;
var hasRequiredTokenizerMixin$1;
function requireTokenizerMixin$1() {
  if (hasRequiredTokenizerMixin$1) return tokenizerMixin$1;
  hasRequiredTokenizerMixin$1 = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const Mixin2 = requireMixin();
  const Tokenizer2 = requireTokenizer();
  const PositionTrackingPreprocessorMixin = requirePreprocessorMixin$1();
  let LocationInfoTokenizerMixin = /* @__PURE__ */ (function(_Mixin) {
    function LocationInfoTokenizerMixin2(tokenizer2) {
      var _this;
      _classCallCheck2(this, LocationInfoTokenizerMixin2);
      _this = _callSuper2(this, LocationInfoTokenizerMixin2, [tokenizer2]);
      _this.tokenizer = tokenizer2;
      _this.posTracker = Mixin2.install(tokenizer2.preprocessor, PositionTrackingPreprocessorMixin);
      _this.currentAttrLocation = null;
      _this.ctLoc = null;
      return _this;
    }
    _inherits2(LocationInfoTokenizerMixin2, _Mixin);
    return _createClass2(LocationInfoTokenizerMixin2, [{
      key: "_getCurrentLocation",
      value: function _getCurrentLocation() {
        return {
          startLine: this.posTracker.line,
          startCol: this.posTracker.col,
          startOffset: this.posTracker.offset,
          endLine: -1,
          endCol: -1,
          endOffset: -1
        };
      }
    }, {
      key: "_attachCurrentAttrLocationInfo",
      value: function _attachCurrentAttrLocationInfo() {
        this.currentAttrLocation.endLine = this.posTracker.line;
        this.currentAttrLocation.endCol = this.posTracker.col;
        this.currentAttrLocation.endOffset = this.posTracker.offset;
        const currentToken = this.tokenizer.currentToken;
        const currentAttr = this.tokenizer.currentAttr;
        if (!currentToken.location.attrs) {
          currentToken.location.attrs = /* @__PURE__ */ Object.create(null);
        }
        currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
      }
    }, {
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods(mxn, orig) {
        const methods = {
          _createStartTagToken() {
            orig._createStartTagToken.call(this);
            this.currentToken.location = mxn.ctLoc;
          },
          _createEndTagToken() {
            orig._createEndTagToken.call(this);
            this.currentToken.location = mxn.ctLoc;
          },
          _createCommentToken() {
            orig._createCommentToken.call(this);
            this.currentToken.location = mxn.ctLoc;
          },
          _createDoctypeToken(initialName) {
            orig._createDoctypeToken.call(this, initialName);
            this.currentToken.location = mxn.ctLoc;
          },
          _createCharacterToken(type2, ch) {
            orig._createCharacterToken.call(this, type2, ch);
            this.currentCharacterToken.location = mxn.ctLoc;
          },
          _createEOFToken() {
            orig._createEOFToken.call(this);
            this.currentToken.location = mxn._getCurrentLocation();
          },
          _createAttr(attrNameFirstCh) {
            orig._createAttr.call(this, attrNameFirstCh);
            mxn.currentAttrLocation = mxn._getCurrentLocation();
          },
          _leaveAttrName(toState3) {
            orig._leaveAttrName.call(this, toState3);
            mxn._attachCurrentAttrLocationInfo();
          },
          _leaveAttrValue(toState3) {
            orig._leaveAttrValue.call(this, toState3);
            mxn._attachCurrentAttrLocationInfo();
          },
          _emitCurrentToken() {
            const ctLoc = this.currentToken.location;
            if (this.currentCharacterToken) {
              this.currentCharacterToken.location.endLine = ctLoc.startLine;
              this.currentCharacterToken.location.endCol = ctLoc.startCol;
              this.currentCharacterToken.location.endOffset = ctLoc.startOffset;
            }
            if (this.currentToken.type === Tokenizer2.EOF_TOKEN) {
              ctLoc.endLine = ctLoc.startLine;
              ctLoc.endCol = ctLoc.startCol;
              ctLoc.endOffset = ctLoc.startOffset;
            } else {
              ctLoc.endLine = mxn.posTracker.line;
              ctLoc.endCol = mxn.posTracker.col + 1;
              ctLoc.endOffset = mxn.posTracker.offset + 1;
            }
            orig._emitCurrentToken.call(this);
          },
          _emitCurrentCharacterToken() {
            const ctLoc = this.currentCharacterToken && this.currentCharacterToken.location;
            if (ctLoc && ctLoc.endOffset === -1) {
              ctLoc.endLine = mxn.posTracker.line;
              ctLoc.endCol = mxn.posTracker.col;
              ctLoc.endOffset = mxn.posTracker.offset;
            }
            orig._emitCurrentCharacterToken.call(this);
          }
        };
        Object.keys(Tokenizer2.MODE).forEach((modeName) => {
          const state = Tokenizer2.MODE[modeName];
          methods[state] = function(cp) {
            mxn.ctLoc = mxn._getCurrentLocation();
            orig[state].call(this, cp);
          };
        });
        return methods;
      }
    }]);
  })(Mixin2);
  tokenizerMixin$1 = LocationInfoTokenizerMixin;
  return tokenizerMixin$1;
}
var openElementStackMixin;
var hasRequiredOpenElementStackMixin;
function requireOpenElementStackMixin() {
  if (hasRequiredOpenElementStackMixin) return openElementStackMixin;
  hasRequiredOpenElementStackMixin = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const Mixin2 = requireMixin();
  let LocationInfoOpenElementStackMixin = /* @__PURE__ */ (function(_Mixin) {
    function LocationInfoOpenElementStackMixin2(stack, opts) {
      var _this;
      _classCallCheck2(this, LocationInfoOpenElementStackMixin2);
      _this = _callSuper2(this, LocationInfoOpenElementStackMixin2, [stack]);
      _this.onItemPop = opts.onItemPop;
      return _this;
    }
    _inherits2(LocationInfoOpenElementStackMixin2, _Mixin);
    return _createClass2(LocationInfoOpenElementStackMixin2, [{
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods(mxn, orig) {
        return {
          pop() {
            mxn.onItemPop(this.current);
            orig.pop.call(this);
          },
          popAllUpToHtmlElement() {
            for (let i = this.stackTop; i > 0; i--) {
              mxn.onItemPop(this.items[i]);
            }
            orig.popAllUpToHtmlElement.call(this);
          },
          remove(element) {
            mxn.onItemPop(this.current);
            orig.remove.call(this, element);
          }
        };
      }
    }]);
  })(Mixin2);
  openElementStackMixin = LocationInfoOpenElementStackMixin;
  return openElementStackMixin;
}
var parserMixin$1;
var hasRequiredParserMixin$1;
function requireParserMixin$1() {
  if (hasRequiredParserMixin$1) return parserMixin$1;
  hasRequiredParserMixin$1 = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const Mixin2 = requireMixin();
  const Tokenizer2 = requireTokenizer();
  const LocationInfoTokenizerMixin = requireTokenizerMixin$1();
  const LocationInfoOpenElementStackMixin = requireOpenElementStackMixin();
  const HTML = requireHtml();
  const $ = HTML.TAG_NAMES;
  let LocationInfoParserMixin = /* @__PURE__ */ (function(_Mixin) {
    function LocationInfoParserMixin2(parser2) {
      var _this;
      _classCallCheck2(this, LocationInfoParserMixin2);
      _this = _callSuper2(this, LocationInfoParserMixin2, [parser2]);
      _this.parser = parser2;
      _this.treeAdapter = _this.parser.treeAdapter;
      _this.posTracker = null;
      _this.lastStartTagToken = null;
      _this.lastFosterParentingLocation = null;
      _this.currentToken = null;
      return _this;
    }
    _inherits2(LocationInfoParserMixin2, _Mixin);
    return _createClass2(LocationInfoParserMixin2, [{
      key: "_setStartLocation",
      value: function _setStartLocation(element) {
        let loc = null;
        if (this.lastStartTagToken) {
          loc = Object.assign({}, this.lastStartTagToken.location);
          loc.startTag = this.lastStartTagToken.location;
        }
        this.treeAdapter.setNodeSourceCodeLocation(element, loc);
      }
    }, {
      key: "_setEndLocation",
      value: function _setEndLocation(element, closingToken) {
        const loc = this.treeAdapter.getNodeSourceCodeLocation(element);
        if (loc) {
          if (closingToken.location) {
            const ctLoc = closingToken.location;
            const tn = this.treeAdapter.getTagName(element);
            const isClosingEndTag = closingToken.type === Tokenizer2.END_TAG_TOKEN && tn === closingToken.tagName;
            const endLoc = {};
            if (isClosingEndTag) {
              endLoc.endTag = Object.assign({}, ctLoc);
              endLoc.endLine = ctLoc.endLine;
              endLoc.endCol = ctLoc.endCol;
              endLoc.endOffset = ctLoc.endOffset;
            } else {
              endLoc.endLine = ctLoc.startLine;
              endLoc.endCol = ctLoc.startCol;
              endLoc.endOffset = ctLoc.startOffset;
            }
            this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
          }
        }
      }
    }, {
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods(mxn, orig) {
        return {
          _bootstrap(document2, fragmentContext) {
            orig._bootstrap.call(this, document2, fragmentContext);
            mxn.lastStartTagToken = null;
            mxn.lastFosterParentingLocation = null;
            mxn.currentToken = null;
            const tokenizerMixin2 = Mixin2.install(this.tokenizer, LocationInfoTokenizerMixin);
            mxn.posTracker = tokenizerMixin2.posTracker;
            Mixin2.install(this.openElements, LocationInfoOpenElementStackMixin, {
              onItemPop: function(element) {
                mxn._setEndLocation(element, mxn.currentToken);
              }
            });
          },
          _runParsingLoop(scriptHandler) {
            orig._runParsingLoop.call(this, scriptHandler);
            for (let i = this.openElements.stackTop; i >= 0; i--) {
              mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
            }
          },
          //Token processing
          _processTokenInForeignContent(token) {
            mxn.currentToken = token;
            orig._processTokenInForeignContent.call(this, token);
          },
          _processToken(token) {
            mxn.currentToken = token;
            orig._processToken.call(this, token);
            const requireExplicitUpdate = token.type === Tokenizer2.END_TAG_TOKEN && (token.tagName === $.HTML || token.tagName === $.BODY && this.openElements.hasInScope($.BODY));
            if (requireExplicitUpdate) {
              for (let i = this.openElements.stackTop; i >= 0; i--) {
                const element = this.openElements.items[i];
                if (this.treeAdapter.getTagName(element) === token.tagName) {
                  mxn._setEndLocation(element, token);
                  break;
                }
              }
            }
          },
          //Doctype
          _setDocumentType(token) {
            orig._setDocumentType.call(this, token);
            const documentChildren = this.treeAdapter.getChildNodes(this.document);
            const cnLength = documentChildren.length;
            for (let i = 0; i < cnLength; i++) {
              const node2 = documentChildren[i];
              if (this.treeAdapter.isDocumentTypeNode(node2)) {
                this.treeAdapter.setNodeSourceCodeLocation(node2, token.location);
                break;
              }
            }
          },
          //Elements
          _attachElementToTree(element) {
            mxn._setStartLocation(element);
            mxn.lastStartTagToken = null;
            orig._attachElementToTree.call(this, element);
          },
          _appendElement(token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._appendElement.call(this, token, namespaceURI);
          },
          _insertElement(token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._insertElement.call(this, token, namespaceURI);
          },
          _insertTemplate(token) {
            mxn.lastStartTagToken = token;
            orig._insertTemplate.call(this, token);
            const tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);
            this.treeAdapter.setNodeSourceCodeLocation(tmplContent, null);
          },
          _insertFakeRootElement() {
            orig._insertFakeRootElement.call(this);
            this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
          },
          //Comments
          _appendCommentNode(token, parent) {
            orig._appendCommentNode.call(this, token, parent);
            const children2 = this.treeAdapter.getChildNodes(parent);
            const commentNode = children2[children2.length - 1];
            this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
          },
          //Text
          _findFosterParentingLocation() {
            mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);
            return mxn.lastFosterParentingLocation;
          },
          _insertCharacters(token) {
            orig._insertCharacters.call(this, token);
            const hasFosterParent = this._shouldFosterParentOnInsertion();
            const parent = hasFosterParent && mxn.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current;
            const siblings = this.treeAdapter.getChildNodes(parent);
            const textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ? siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 : siblings.length - 1;
            const textNode = siblings[textNodeIdx];
            const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
            if (tnLoc) {
              const {
                endLine,
                endCol,
                endOffset
              } = token.location;
              this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
                endLine,
                endCol,
                endOffset
              });
            } else {
              this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
            }
          }
        };
      }
    }]);
  })(Mixin2);
  parserMixin$1 = LocationInfoParserMixin;
  return parserMixin$1;
}
var mixinBase;
var hasRequiredMixinBase;
function requireMixinBase() {
  if (hasRequiredMixinBase) return mixinBase;
  hasRequiredMixinBase = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const Mixin2 = requireMixin();
  let ErrorReportingMixinBase = /* @__PURE__ */ (function(_Mixin) {
    function ErrorReportingMixinBase2(host, opts) {
      var _this;
      _classCallCheck2(this, ErrorReportingMixinBase2);
      _this = _callSuper2(this, ErrorReportingMixinBase2, [host]);
      _this.posTracker = null;
      _this.onParseError = opts.onParseError;
      return _this;
    }
    _inherits2(ErrorReportingMixinBase2, _Mixin);
    return _createClass2(ErrorReportingMixinBase2, [{
      key: "_setErrorLocation",
      value: function _setErrorLocation(err) {
        err.startLine = err.endLine = this.posTracker.line;
        err.startCol = err.endCol = this.posTracker.col;
        err.startOffset = err.endOffset = this.posTracker.offset;
      }
    }, {
      key: "_reportError",
      value: function _reportError(code) {
        const err = {
          code,
          startLine: -1,
          startCol: -1,
          startOffset: -1,
          endLine: -1,
          endCol: -1,
          endOffset: -1
        };
        this._setErrorLocation(err);
        this.onParseError(err);
      }
    }, {
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods(mxn) {
        return {
          _err(code) {
            mxn._reportError(code);
          }
        };
      }
    }]);
  })(Mixin2);
  mixinBase = ErrorReportingMixinBase;
  return mixinBase;
}
var preprocessorMixin;
var hasRequiredPreprocessorMixin;
function requirePreprocessorMixin() {
  if (hasRequiredPreprocessorMixin) return preprocessorMixin;
  hasRequiredPreprocessorMixin = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _superPropGet2(t, o, e, r2) {
    var p = _get2(_getPrototypeOf2(t.prototype), o, e);
    return "function" == typeof p ? function(t4) {
      return p.apply(e, t4);
    } : p;
  }
  function _get2() {
    return _get2 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
      var p = _superPropBase2(e, t);
      if (p) {
        var n = Object.getOwnPropertyDescriptor(p, t);
        return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
      }
    }, _get2.apply(null, arguments);
  }
  function _superPropBase2(t, o) {
    for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf2(t)); ) ;
    return t;
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const ErrorReportingMixinBase = requireMixinBase();
  const PositionTrackingPreprocessorMixin = requirePreprocessorMixin$1();
  const Mixin2 = requireMixin();
  let ErrorReportingPreprocessorMixin = /* @__PURE__ */ (function(_ErrorReportingMixinB) {
    function ErrorReportingPreprocessorMixin2(preprocessor2, opts) {
      var _this;
      _classCallCheck2(this, ErrorReportingPreprocessorMixin2);
      _this = _callSuper2(this, ErrorReportingPreprocessorMixin2, [preprocessor2, opts]);
      _this.posTracker = Mixin2.install(preprocessor2, PositionTrackingPreprocessorMixin);
      _this.lastErrOffset = -1;
      return _this;
    }
    _inherits2(ErrorReportingPreprocessorMixin2, _ErrorReportingMixinB);
    return _createClass2(ErrorReportingPreprocessorMixin2, [{
      key: "_reportError",
      value: function _reportError(code) {
        if (this.lastErrOffset !== this.posTracker.offset) {
          this.lastErrOffset = this.posTracker.offset;
          _superPropGet2(ErrorReportingPreprocessorMixin2, "_reportError", this)([code]);
        }
      }
    }]);
  })(ErrorReportingMixinBase);
  preprocessorMixin = ErrorReportingPreprocessorMixin;
  return preprocessorMixin;
}
var tokenizerMixin;
var hasRequiredTokenizerMixin;
function requireTokenizerMixin() {
  if (hasRequiredTokenizerMixin) return tokenizerMixin;
  hasRequiredTokenizerMixin = 1;
  function _createClass2(e, r2, t) {
    return Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const ErrorReportingMixinBase = requireMixinBase();
  const ErrorReportingPreprocessorMixin = requirePreprocessorMixin();
  const Mixin2 = requireMixin();
  let ErrorReportingTokenizerMixin = /* @__PURE__ */ (function(_ErrorReportingMixinB) {
    function ErrorReportingTokenizerMixin2(tokenizer2, opts) {
      var _this;
      _classCallCheck2(this, ErrorReportingTokenizerMixin2);
      _this = _callSuper2(this, ErrorReportingTokenizerMixin2, [tokenizer2, opts]);
      const preprocessorMixin2 = Mixin2.install(tokenizer2.preprocessor, ErrorReportingPreprocessorMixin, opts);
      _this.posTracker = preprocessorMixin2.posTracker;
      return _this;
    }
    _inherits2(ErrorReportingTokenizerMixin2, _ErrorReportingMixinB);
    return _createClass2(ErrorReportingTokenizerMixin2);
  })(ErrorReportingMixinBase);
  tokenizerMixin = ErrorReportingTokenizerMixin;
  return tokenizerMixin;
}
var parserMixin;
var hasRequiredParserMixin;
function requireParserMixin() {
  if (hasRequiredParserMixin) return parserMixin;
  hasRequiredParserMixin = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  function _callSuper2(t, o, e) {
    return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
  }
  function _possibleConstructorReturn2(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized2(t);
  }
  function _assertThisInitialized2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _isNativeReflectConstruct2() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch (t4) {
    }
    return (_isNativeReflectConstruct2 = function() {
      return !!t;
    })();
  }
  function _getPrototypeOf2(t) {
    return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
      return t4.__proto__ || Object.getPrototypeOf(t4);
    }, _getPrototypeOf2(t);
  }
  function _inherits2(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
  }
  function _setPrototypeOf2(t, e) {
    return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
      return t4.__proto__ = e3, t4;
    }, _setPrototypeOf2(t, e);
  }
  const ErrorReportingMixinBase = requireMixinBase();
  const ErrorReportingTokenizerMixin = requireTokenizerMixin();
  const LocationInfoTokenizerMixin = requireTokenizerMixin$1();
  const Mixin2 = requireMixin();
  let ErrorReportingParserMixin = /* @__PURE__ */ (function(_ErrorReportingMixinB) {
    function ErrorReportingParserMixin2(parser2, opts) {
      var _this;
      _classCallCheck2(this, ErrorReportingParserMixin2);
      _this = _callSuper2(this, ErrorReportingParserMixin2, [parser2, opts]);
      _this.opts = opts;
      _this.ctLoc = null;
      _this.locBeforeToken = false;
      return _this;
    }
    _inherits2(ErrorReportingParserMixin2, _ErrorReportingMixinB);
    return _createClass2(ErrorReportingParserMixin2, [{
      key: "_setErrorLocation",
      value: function _setErrorLocation(err) {
        if (this.ctLoc) {
          err.startLine = this.ctLoc.startLine;
          err.startCol = this.ctLoc.startCol;
          err.startOffset = this.ctLoc.startOffset;
          err.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine;
          err.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol;
          err.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset;
        }
      }
    }, {
      key: "_getOverriddenMethods",
      value: function _getOverriddenMethods(mxn, orig) {
        return {
          _bootstrap(document2, fragmentContext) {
            orig._bootstrap.call(this, document2, fragmentContext);
            Mixin2.install(this.tokenizer, ErrorReportingTokenizerMixin, mxn.opts);
            Mixin2.install(this.tokenizer, LocationInfoTokenizerMixin);
          },
          _processInputToken(token) {
            mxn.ctLoc = token.location;
            orig._processInputToken.call(this, token);
          },
          _err(code, options2) {
            mxn.locBeforeToken = options2 && options2.beforeToken;
            mxn._reportError(code);
          }
        };
      }
    }]);
  })(ErrorReportingMixinBase);
  parserMixin = ErrorReportingParserMixin;
  return parserMixin;
}
var _default = {};
var hasRequired_default;
function require_default() {
  if (hasRequired_default) return _default;
  hasRequired_default = 1;
  const {
    DOCUMENT_MODE
  } = requireHtml();
  _default.createDocument = function() {
    return {
      nodeName: "#document",
      mode: DOCUMENT_MODE.NO_QUIRKS,
      childNodes: []
    };
  };
  _default.createDocumentFragment = function() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  };
  _default.createElement = function(tagName, namespaceURI, attrs) {
    return {
      nodeName: tagName,
      tagName,
      attrs,
      namespaceURI,
      childNodes: [],
      parentNode: null
    };
  };
  _default.createCommentNode = function(data2) {
    return {
      nodeName: "#comment",
      data: data2,
      parentNode: null
    };
  };
  const createTextNode = function(value) {
    return {
      nodeName: "#text",
      value,
      parentNode: null
    };
  };
  const appendChild = _default.appendChild = function(parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
  };
  const insertBefore = _default.insertBefore = function(parentNode, newNode, referenceNode) {
    const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
  };
  _default.setTemplateContent = function(templateElement, contentElement) {
    templateElement.content = contentElement;
  };
  _default.getTemplateContent = function(templateElement) {
    return templateElement.content;
  };
  _default.setDocumentType = function(document2, name, publicId, systemId) {
    let doctypeNode = null;
    for (let i = 0; i < document2.childNodes.length; i++) {
      if (document2.childNodes[i].nodeName === "#documentType") {
        doctypeNode = document2.childNodes[i];
        break;
      }
    }
    if (doctypeNode) {
      doctypeNode.name = name;
      doctypeNode.publicId = publicId;
      doctypeNode.systemId = systemId;
    } else {
      appendChild(document2, {
        nodeName: "#documentType",
        name,
        publicId,
        systemId
      });
    }
  };
  _default.setDocumentMode = function(document2, mode) {
    document2.mode = mode;
  };
  _default.getDocumentMode = function(document2) {
    return document2.mode;
  };
  _default.detachNode = function(node2) {
    if (node2.parentNode) {
      const idx = node2.parentNode.childNodes.indexOf(node2);
      node2.parentNode.childNodes.splice(idx, 1);
      node2.parentNode = null;
    }
  };
  _default.insertText = function(parentNode, text2) {
    if (parentNode.childNodes.length) {
      const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
      if (prevNode.nodeName === "#text") {
        prevNode.value += text2;
        return;
      }
    }
    appendChild(parentNode, createTextNode(text2));
  };
  _default.insertTextBefore = function(parentNode, text2, referenceNode) {
    const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
    if (prevNode && prevNode.nodeName === "#text") {
      prevNode.value += text2;
    } else {
      insertBefore(parentNode, createTextNode(text2), referenceNode);
    }
  };
  _default.adoptAttributes = function(recipient, attrs) {
    const recipientAttrsMap = [];
    for (let i = 0; i < recipient.attrs.length; i++) {
      recipientAttrsMap.push(recipient.attrs[i].name);
    }
    for (let j = 0; j < attrs.length; j++) {
      if (recipientAttrsMap.indexOf(attrs[j].name) === -1) {
        recipient.attrs.push(attrs[j]);
      }
    }
  };
  _default.getFirstChild = function(node2) {
    return node2.childNodes[0];
  };
  _default.getChildNodes = function(node2) {
    return node2.childNodes;
  };
  _default.getParentNode = function(node2) {
    return node2.parentNode;
  };
  _default.getAttrList = function(element) {
    return element.attrs;
  };
  _default.getTagName = function(element) {
    return element.tagName;
  };
  _default.getNamespaceURI = function(element) {
    return element.namespaceURI;
  };
  _default.getTextNodeContent = function(textNode) {
    return textNode.value;
  };
  _default.getCommentNodeContent = function(commentNode) {
    return commentNode.data;
  };
  _default.getDocumentTypeNodeName = function(doctypeNode) {
    return doctypeNode.name;
  };
  _default.getDocumentTypeNodePublicId = function(doctypeNode) {
    return doctypeNode.publicId;
  };
  _default.getDocumentTypeNodeSystemId = function(doctypeNode) {
    return doctypeNode.systemId;
  };
  _default.isTextNode = function(node2) {
    return node2.nodeName === "#text";
  };
  _default.isCommentNode = function(node2) {
    return node2.nodeName === "#comment";
  };
  _default.isDocumentTypeNode = function(node2) {
    return node2.nodeName === "#documentType";
  };
  _default.isElementNode = function(node2) {
    return !!node2.tagName;
  };
  _default.setNodeSourceCodeLocation = function(node2, location) {
    node2.sourceCodeLocation = location;
  };
  _default.getNodeSourceCodeLocation = function(node2) {
    return node2.sourceCodeLocation;
  };
  _default.updateNodeSourceCodeLocation = function(node2, endLocation) {
    node2.sourceCodeLocation = Object.assign(node2.sourceCodeLocation, endLocation);
  };
  return _default;
}
var mergeOptions;
var hasRequiredMergeOptions;
function requireMergeOptions() {
  if (hasRequiredMergeOptions) return mergeOptions;
  hasRequiredMergeOptions = 1;
  mergeOptions = function mergeOptions2(defaults, options2) {
    options2 = options2 || /* @__PURE__ */ Object.create(null);
    return [defaults, options2].reduce((merged, optObj) => {
      Object.keys(optObj).forEach((key) => {
        merged[key] = optObj[key];
      });
      return merged;
    }, /* @__PURE__ */ Object.create(null));
  };
  return mergeOptions;
}
var doctype = {};
var hasRequiredDoctype;
function requireDoctype() {
  if (hasRequiredDoctype) return doctype;
  hasRequiredDoctype = 1;
  const {
    DOCUMENT_MODE
  } = requireHtml();
  const VALID_DOCTYPE_NAME = "html";
  const VALID_SYSTEM_ID = "about:legacy-compat";
  const QUIRKS_MODE_SYSTEM_ID = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd";
  const QUIRKS_MODE_PUBLIC_ID_PREFIXES = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", "-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", "-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", "-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", "-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"];
  const QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat(["-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"]);
  const QUIRKS_MODE_PUBLIC_IDS = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"];
  const LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"];
  const LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat(["-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"]);
  function enquoteDoctypeId(id2) {
    const quote = id2.indexOf('"') !== -1 ? "'" : '"';
    return quote + id2 + quote;
  }
  function hasPrefix(publicId, prefixes2) {
    for (let i = 0; i < prefixes2.length; i++) {
      if (publicId.indexOf(prefixes2[i]) === 0) {
        return true;
      }
    }
    return false;
  }
  doctype.isConforming = function(token) {
    return token.name === VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === VALID_SYSTEM_ID);
  };
  doctype.getDocumentMode = function(token) {
    if (token.name !== VALID_DOCTYPE_NAME) {
      return DOCUMENT_MODE.QUIRKS;
    }
    const systemId = token.systemId;
    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
      return DOCUMENT_MODE.QUIRKS;
    }
    let publicId = token.publicId;
    if (publicId !== null) {
      publicId = publicId.toLowerCase();
      if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1) {
        return DOCUMENT_MODE.QUIRKS;
      }
      let prefixes2 = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
      if (hasPrefix(publicId, prefixes2)) {
        return DOCUMENT_MODE.QUIRKS;
      }
      prefixes2 = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
      if (hasPrefix(publicId, prefixes2)) {
        return DOCUMENT_MODE.LIMITED_QUIRKS;
      }
    }
    return DOCUMENT_MODE.NO_QUIRKS;
  };
  doctype.serializeContent = function(name, publicId, systemId) {
    let str = "!DOCTYPE ";
    if (name) {
      str += name;
    }
    if (publicId) {
      str += " PUBLIC " + enquoteDoctypeId(publicId);
    } else if (systemId) {
      str += " SYSTEM";
    }
    if (systemId !== null) {
      str += " " + enquoteDoctypeId(systemId);
    }
    return str;
  };
  return doctype;
}
var foreignContent = {};
var hasRequiredForeignContent;
function requireForeignContent() {
  if (hasRequiredForeignContent) return foreignContent;
  hasRequiredForeignContent = 1;
  const Tokenizer2 = requireTokenizer();
  const HTML = requireHtml();
  const $ = HTML.TAG_NAMES;
  const NS = HTML.NAMESPACES;
  const ATTRS = HTML.ATTRS;
  const MIME_TYPES = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
  };
  const DEFINITION_URL_ATTR = "definitionurl";
  const ADJUSTED_DEFINITION_URL_ATTR = "definitionURL";
  const SVG_ATTRS_ADJUSTMENT_MAP = {
    attributename: "attributeName",
    attributetype: "attributeType",
    basefrequency: "baseFrequency",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    clippathunits: "clipPathUnits",
    diffuseconstant: "diffuseConstant",
    edgemode: "edgeMode",
    filterunits: "filterUnits",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    limitingconeangle: "limitingConeAngle",
    markerheight: "markerHeight",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textlength: "textLength",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    xchannelselector: "xChannelSelector",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan"
  };
  const XML_ATTRS_ADJUSTMENT_MAP = {
    "xlink:actuate": {
      prefix: "xlink",
      name: "actuate",
      namespace: NS.XLINK
    },
    "xlink:arcrole": {
      prefix: "xlink",
      name: "arcrole",
      namespace: NS.XLINK
    },
    "xlink:href": {
      prefix: "xlink",
      name: "href",
      namespace: NS.XLINK
    },
    "xlink:role": {
      prefix: "xlink",
      name: "role",
      namespace: NS.XLINK
    },
    "xlink:show": {
      prefix: "xlink",
      name: "show",
      namespace: NS.XLINK
    },
    "xlink:title": {
      prefix: "xlink",
      name: "title",
      namespace: NS.XLINK
    },
    "xlink:type": {
      prefix: "xlink",
      name: "type",
      namespace: NS.XLINK
    },
    "xml:base": {
      prefix: "xml",
      name: "base",
      namespace: NS.XML
    },
    "xml:lang": {
      prefix: "xml",
      name: "lang",
      namespace: NS.XML
    },
    "xml:space": {
      prefix: "xml",
      name: "space",
      namespace: NS.XML
    },
    xmlns: {
      prefix: "",
      name: "xmlns",
      namespace: NS.XMLNS
    },
    "xmlns:xlink": {
      prefix: "xmlns",
      name: "xlink",
      namespace: NS.XMLNS
    }
  };
  const SVG_TAG_NAMES_ADJUSTMENT_MAP = foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient",
    textpath: "textPath"
  };
  const EXITS_FOREIGN_CONTENT = {
    [$.B]: true,
    [$.BIG]: true,
    [$.BLOCKQUOTE]: true,
    [$.BODY]: true,
    [$.BR]: true,
    [$.CENTER]: true,
    [$.CODE]: true,
    [$.DD]: true,
    [$.DIV]: true,
    [$.DL]: true,
    [$.DT]: true,
    [$.EM]: true,
    [$.EMBED]: true,
    [$.H1]: true,
    [$.H2]: true,
    [$.H3]: true,
    [$.H4]: true,
    [$.H5]: true,
    [$.H6]: true,
    [$.HEAD]: true,
    [$.HR]: true,
    [$.I]: true,
    [$.IMG]: true,
    [$.LI]: true,
    [$.LISTING]: true,
    [$.MENU]: true,
    [$.META]: true,
    [$.NOBR]: true,
    [$.OL]: true,
    [$.P]: true,
    [$.PRE]: true,
    [$.RUBY]: true,
    [$.S]: true,
    [$.SMALL]: true,
    [$.SPAN]: true,
    [$.STRONG]: true,
    [$.STRIKE]: true,
    [$.SUB]: true,
    [$.SUP]: true,
    [$.TABLE]: true,
    [$.TT]: true,
    [$.U]: true,
    [$.UL]: true,
    [$.VAR]: true
  };
  foreignContent.causesExit = function(startTagToken) {
    const tn = startTagToken.tagName;
    const isFontWithAttrs = tn === $.FONT && (Tokenizer2.getTokenAttr(startTagToken, ATTRS.COLOR) !== null || Tokenizer2.getTokenAttr(startTagToken, ATTRS.SIZE) !== null || Tokenizer2.getTokenAttr(startTagToken, ATTRS.FACE) !== null);
    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
  };
  foreignContent.adjustTokenMathMLAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
      if (token.attrs[i].name === DEFINITION_URL_ATTR) {
        token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
        break;
      }
    }
  };
  foreignContent.adjustTokenSVGAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
      const adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
      if (adjustedAttrName) {
        token.attrs[i].name = adjustedAttrName;
      }
    }
  };
  foreignContent.adjustTokenXMLAttrs = function(token) {
    for (let i = 0; i < token.attrs.length; i++) {
      const adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
      if (adjustedAttrEntry) {
        token.attrs[i].prefix = adjustedAttrEntry.prefix;
        token.attrs[i].name = adjustedAttrEntry.name;
        token.attrs[i].namespace = adjustedAttrEntry.namespace;
      }
    }
  };
  foreignContent.adjustTokenSVGTagName = function(token) {
    const adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];
    if (adjustedTagName) {
      token.tagName = adjustedTagName;
    }
  };
  function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
  }
  function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
      for (let i = 0; i < attrs.length; i++) {
        if (attrs[i].name === ATTRS.ENCODING) {
          const value = attrs[i].value.toLowerCase();
          return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
        }
      }
    }
    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
  }
  foreignContent.isIntegrationPoint = function(tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs)) {
      return true;
    }
    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns)) {
      return true;
    }
    return false;
  };
  return foreignContent;
}
var parser;
var hasRequiredParser;
function requireParser() {
  if (hasRequiredParser) return parser;
  hasRequiredParser = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const Tokenizer2 = requireTokenizer();
  const OpenElementStack = requireOpenElementStack();
  const FormattingElementList = requireFormattingElementList();
  const LocationInfoParserMixin = requireParserMixin$1();
  const ErrorReportingParserMixin = requireParserMixin();
  const Mixin2 = requireMixin();
  const defaultTreeAdapter = require_default();
  const mergeOptions2 = requireMergeOptions();
  const doctype2 = requireDoctype();
  const foreignContent2 = requireForeignContent();
  const ERR = requireErrorCodes();
  const unicode2 = requireUnicode();
  const HTML = requireHtml();
  const $ = HTML.TAG_NAMES;
  const NS = HTML.NAMESPACES;
  const ATTRS = HTML.ATTRS;
  const DEFAULT_OPTIONS = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    onParseError: null,
    treeAdapter: defaultTreeAdapter
  };
  const HIDDEN_INPUT_TYPE = "hidden";
  const AA_OUTER_LOOP_ITER = 8;
  const AA_INNER_LOOP_ITER = 3;
  const INITIAL_MODE = "INITIAL_MODE";
  const BEFORE_HTML_MODE = "BEFORE_HTML_MODE";
  const BEFORE_HEAD_MODE = "BEFORE_HEAD_MODE";
  const IN_HEAD_MODE = "IN_HEAD_MODE";
  const IN_HEAD_NO_SCRIPT_MODE = "IN_HEAD_NO_SCRIPT_MODE";
  const AFTER_HEAD_MODE = "AFTER_HEAD_MODE";
  const IN_BODY_MODE = "IN_BODY_MODE";
  const TEXT_MODE = "TEXT_MODE";
  const IN_TABLE_MODE = "IN_TABLE_MODE";
  const IN_TABLE_TEXT_MODE = "IN_TABLE_TEXT_MODE";
  const IN_CAPTION_MODE = "IN_CAPTION_MODE";
  const IN_COLUMN_GROUP_MODE = "IN_COLUMN_GROUP_MODE";
  const IN_TABLE_BODY_MODE = "IN_TABLE_BODY_MODE";
  const IN_ROW_MODE = "IN_ROW_MODE";
  const IN_CELL_MODE = "IN_CELL_MODE";
  const IN_SELECT_MODE = "IN_SELECT_MODE";
  const IN_SELECT_IN_TABLE_MODE = "IN_SELECT_IN_TABLE_MODE";
  const IN_TEMPLATE_MODE = "IN_TEMPLATE_MODE";
  const AFTER_BODY_MODE = "AFTER_BODY_MODE";
  const IN_FRAMESET_MODE = "IN_FRAMESET_MODE";
  const AFTER_FRAMESET_MODE = "AFTER_FRAMESET_MODE";
  const AFTER_AFTER_BODY_MODE = "AFTER_AFTER_BODY_MODE";
  const AFTER_AFTER_FRAMESET_MODE = "AFTER_AFTER_FRAMESET_MODE";
  const INSERTION_MODE_RESET_MAP = {
    [$.TR]: IN_ROW_MODE,
    [$.TBODY]: IN_TABLE_BODY_MODE,
    [$.THEAD]: IN_TABLE_BODY_MODE,
    [$.TFOOT]: IN_TABLE_BODY_MODE,
    [$.CAPTION]: IN_CAPTION_MODE,
    [$.COLGROUP]: IN_COLUMN_GROUP_MODE,
    [$.TABLE]: IN_TABLE_MODE,
    [$.BODY]: IN_BODY_MODE,
    [$.FRAMESET]: IN_FRAMESET_MODE
  };
  const TEMPLATE_INSERTION_MODE_SWITCH_MAP = {
    [$.CAPTION]: IN_TABLE_MODE,
    [$.COLGROUP]: IN_TABLE_MODE,
    [$.TBODY]: IN_TABLE_MODE,
    [$.TFOOT]: IN_TABLE_MODE,
    [$.THEAD]: IN_TABLE_MODE,
    [$.COL]: IN_COLUMN_GROUP_MODE,
    [$.TR]: IN_TABLE_BODY_MODE,
    [$.TD]: IN_ROW_MODE,
    [$.TH]: IN_ROW_MODE
  };
  const TOKEN_HANDLERS = {
    [INITIAL_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenInInitialMode,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenInInitialMode,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: doctypeInInitialMode,
      [Tokenizer2.START_TAG_TOKEN]: tokenInInitialMode,
      [Tokenizer2.END_TAG_TOKEN]: tokenInInitialMode,
      [Tokenizer2.EOF_TOKEN]: tokenInInitialMode
    },
    [BEFORE_HTML_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenBeforeHtml,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenBeforeHtml,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagBeforeHtml,
      [Tokenizer2.END_TAG_TOKEN]: endTagBeforeHtml,
      [Tokenizer2.EOF_TOKEN]: tokenBeforeHtml
    },
    [BEFORE_HEAD_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenBeforeHead,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenBeforeHead,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: misplacedDoctype,
      [Tokenizer2.START_TAG_TOKEN]: startTagBeforeHead,
      [Tokenizer2.END_TAG_TOKEN]: endTagBeforeHead,
      [Tokenizer2.EOF_TOKEN]: tokenBeforeHead
    },
    [IN_HEAD_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenInHead,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenInHead,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: misplacedDoctype,
      [Tokenizer2.START_TAG_TOKEN]: startTagInHead,
      [Tokenizer2.END_TAG_TOKEN]: endTagInHead,
      [Tokenizer2.EOF_TOKEN]: tokenInHead
    },
    [IN_HEAD_NO_SCRIPT_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenInHeadNoScript,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenInHeadNoScript,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: misplacedDoctype,
      [Tokenizer2.START_TAG_TOKEN]: startTagInHeadNoScript,
      [Tokenizer2.END_TAG_TOKEN]: endTagInHeadNoScript,
      [Tokenizer2.EOF_TOKEN]: tokenInHeadNoScript
    },
    [AFTER_HEAD_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenAfterHead,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenAfterHead,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: misplacedDoctype,
      [Tokenizer2.START_TAG_TOKEN]: startTagAfterHead,
      [Tokenizer2.END_TAG_TOKEN]: endTagAfterHead,
      [Tokenizer2.EOF_TOKEN]: tokenAfterHead
    },
    [IN_BODY_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInBody,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInBody,
      [Tokenizer2.END_TAG_TOKEN]: endTagInBody,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [TEXT_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: ignoreToken,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: ignoreToken,
      [Tokenizer2.END_TAG_TOKEN]: endTagInText,
      [Tokenizer2.EOF_TOKEN]: eofInText
    },
    [IN_TABLE_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInTable,
      [Tokenizer2.END_TAG_TOKEN]: endTagInTable,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_TABLE_TEXT_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInTableText,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInTableText,
      [Tokenizer2.COMMENT_TOKEN]: tokenInTableText,
      [Tokenizer2.DOCTYPE_TOKEN]: tokenInTableText,
      [Tokenizer2.START_TAG_TOKEN]: tokenInTableText,
      [Tokenizer2.END_TAG_TOKEN]: tokenInTableText,
      [Tokenizer2.EOF_TOKEN]: tokenInTableText
    },
    [IN_CAPTION_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInBody,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInCaption,
      [Tokenizer2.END_TAG_TOKEN]: endTagInCaption,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_COLUMN_GROUP_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenInColumnGroup,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenInColumnGroup,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInColumnGroup,
      [Tokenizer2.END_TAG_TOKEN]: endTagInColumnGroup,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_TABLE_BODY_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInTableBody,
      [Tokenizer2.END_TAG_TOKEN]: endTagInTableBody,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_ROW_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: characterInTable,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInRow,
      [Tokenizer2.END_TAG_TOKEN]: endTagInRow,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_CELL_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInBody,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInCell,
      [Tokenizer2.END_TAG_TOKEN]: endTagInCell,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_SELECT_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInSelect,
      [Tokenizer2.END_TAG_TOKEN]: endTagInSelect,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_SELECT_IN_TABLE_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInSelectInTable,
      [Tokenizer2.END_TAG_TOKEN]: endTagInSelectInTable,
      [Tokenizer2.EOF_TOKEN]: eofInBody
    },
    [IN_TEMPLATE_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: characterInBody,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInTemplate,
      [Tokenizer2.END_TAG_TOKEN]: endTagInTemplate,
      [Tokenizer2.EOF_TOKEN]: eofInTemplate
    },
    [AFTER_BODY_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenAfterBody,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenAfterBody,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendCommentToRootHtmlElement,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagAfterBody,
      [Tokenizer2.END_TAG_TOKEN]: endTagAfterBody,
      [Tokenizer2.EOF_TOKEN]: stopParsing
    },
    [IN_FRAMESET_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagInFrameset,
      [Tokenizer2.END_TAG_TOKEN]: endTagInFrameset,
      [Tokenizer2.EOF_TOKEN]: stopParsing
    },
    [AFTER_FRAMESET_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: insertCharacters,
      [Tokenizer2.COMMENT_TOKEN]: appendComment,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagAfterFrameset,
      [Tokenizer2.END_TAG_TOKEN]: endTagAfterFrameset,
      [Tokenizer2.EOF_TOKEN]: stopParsing
    },
    [AFTER_AFTER_BODY_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: tokenAfterAfterBody,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: tokenAfterAfterBody,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendCommentToDocument,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagAfterAfterBody,
      [Tokenizer2.END_TAG_TOKEN]: tokenAfterAfterBody,
      [Tokenizer2.EOF_TOKEN]: stopParsing
    },
    [AFTER_AFTER_FRAMESET_MODE]: {
      [Tokenizer2.CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.NULL_CHARACTER_TOKEN]: ignoreToken,
      [Tokenizer2.WHITESPACE_CHARACTER_TOKEN]: whitespaceCharacterInBody,
      [Tokenizer2.COMMENT_TOKEN]: appendCommentToDocument,
      [Tokenizer2.DOCTYPE_TOKEN]: ignoreToken,
      [Tokenizer2.START_TAG_TOKEN]: startTagAfterAfterFrameset,
      [Tokenizer2.END_TAG_TOKEN]: ignoreToken,
      [Tokenizer2.EOF_TOKEN]: stopParsing
    }
  };
  let Parser2 = /* @__PURE__ */ (function() {
    function Parser3(options2) {
      _classCallCheck2(this, Parser3);
      this.options = mergeOptions2(DEFAULT_OPTIONS, options2);
      this.treeAdapter = this.options.treeAdapter;
      this.pendingScript = null;
      if (this.options.sourceCodeLocationInfo) {
        Mixin2.install(this, LocationInfoParserMixin);
      }
      if (this.options.onParseError) {
        Mixin2.install(this, ErrorReportingParserMixin, {
          onParseError: this.options.onParseError
        });
      }
    }
    return _createClass2(Parser3, [{
      key: "parse",
      value: function parse2(html2) {
        const document2 = this.treeAdapter.createDocument();
        this._bootstrap(document2, null);
        this.tokenizer.write(html2, true);
        this._runParsingLoop(null);
        return document2;
      }
    }, {
      key: "parseFragment",
      value: function parseFragment(html2, fragmentContext) {
        if (!fragmentContext) {
          fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);
        }
        const documentMock = this.treeAdapter.createElement("documentmock", NS.HTML, []);
        this._bootstrap(documentMock, fragmentContext);
        if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE) {
          this._pushTmplInsertionMode(IN_TEMPLATE_MODE);
        }
        this._initTokenizerForFragmentParsing();
        this._insertFakeRootElement();
        this._resetInsertionMode();
        this._findFormInFragmentContext();
        this.tokenizer.write(html2, true);
        this._runParsingLoop(null);
        const rootElement = this.treeAdapter.getFirstChild(documentMock);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
      }
      //Bootstrap parser
    }, {
      key: "_bootstrap",
      value: function _bootstrap(document2, fragmentContext) {
        this.tokenizer = new Tokenizer2(this.options);
        this.stopped = false;
        this.insertionMode = INITIAL_MODE;
        this.originalInsertionMode = "";
        this.document = document2;
        this.fragmentContext = fragmentContext;
        this.headElement = null;
        this.formElement = null;
        this.openElements = new OpenElementStack(this.document, this.treeAdapter);
        this.activeFormattingElements = new FormattingElementList(this.treeAdapter);
        this.tmplInsertionModeStack = [];
        this.tmplInsertionModeStackTop = -1;
        this.currentTmplInsertionMode = null;
        this.pendingCharacterTokens = [];
        this.hasNonWhitespacePendingCharacterToken = false;
        this.framesetOk = true;
        this.skipNextNewLine = false;
        this.fosterParentingEnabled = false;
      }
      //Errors
    }, {
      key: "_err",
      value: function _err() {
      }
      //Parsing loop
    }, {
      key: "_runParsingLoop",
      value: function _runParsingLoop(scriptHandler) {
        while (!this.stopped) {
          this._setupTokenizerCDATAMode();
          const token = this.tokenizer.getNextToken();
          if (token.type === Tokenizer2.HIBERNATION_TOKEN) {
            break;
          }
          if (this.skipNextNewLine) {
            this.skipNextNewLine = false;
            if (token.type === Tokenizer2.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === "\n") {
              if (token.chars.length === 1) {
                continue;
              }
              token.chars = token.chars.substr(1);
            }
          }
          this._processInputToken(token);
          if (scriptHandler && this.pendingScript) {
            break;
          }
        }
      }
    }, {
      key: "runParsingLoopForCurrentChunk",
      value: function runParsingLoopForCurrentChunk(writeCallback, scriptHandler) {
        this._runParsingLoop(scriptHandler);
        if (scriptHandler && this.pendingScript) {
          const script = this.pendingScript;
          this.pendingScript = null;
          scriptHandler(script);
          return;
        }
        if (writeCallback) {
          writeCallback();
        }
      }
      //Text parsing
    }, {
      key: "_setupTokenizerCDATAMode",
      value: function _setupTokenizerCDATAMode() {
        const current = this._getAdjustedCurrentElement();
        this.tokenizer.allowCDATA = current && current !== this.document && this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
      }
    }, {
      key: "_switchToTextParsing",
      value: function _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, NS.HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = TEXT_MODE;
      }
    }, {
      key: "switchToPlaintextParsing",
      value: function switchToPlaintextParsing() {
        this.insertionMode = TEXT_MODE;
        this.originalInsertionMode = IN_BODY_MODE;
        this.tokenizer.state = Tokenizer2.MODE.PLAINTEXT;
      }
      //Fragment parsing
    }, {
      key: "_getAdjustedCurrentElement",
      value: function _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
      }
    }, {
      key: "_findFormInFragmentContext",
      value: function _findFormInFragmentContext() {
        let node2 = this.fragmentContext;
        do {
          if (this.treeAdapter.getTagName(node2) === $.FORM) {
            this.formElement = node2;
            break;
          }
          node2 = this.treeAdapter.getParentNode(node2);
        } while (node2);
      }
    }, {
      key: "_initTokenizerForFragmentParsing",
      value: function _initTokenizerForFragmentParsing() {
        if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
          const tn = this.treeAdapter.getTagName(this.fragmentContext);
          if (tn === $.TITLE || tn === $.TEXTAREA) {
            this.tokenizer.state = Tokenizer2.MODE.RCDATA;
          } else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME || tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT) {
            this.tokenizer.state = Tokenizer2.MODE.RAWTEXT;
          } else if (tn === $.SCRIPT) {
            this.tokenizer.state = Tokenizer2.MODE.SCRIPT_DATA;
          } else if (tn === $.PLAINTEXT) {
            this.tokenizer.state = Tokenizer2.MODE.PLAINTEXT;
          }
        }
      }
      //Tree mutation
    }, {
      key: "_setDocumentType",
      value: function _setDocumentType(token) {
        const name = token.name || "";
        const publicId = token.publicId || "";
        const systemId = token.systemId || "";
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
      }
    }, {
      key: "_attachElementToTree",
      value: function _attachElementToTree(element) {
        if (this._shouldFosterParentOnInsertion()) {
          this._fosterParentElement(element);
        } else {
          const parent = this.openElements.currentTmplContent || this.openElements.current;
          this.treeAdapter.appendChild(parent, element);
        }
      }
    }, {
      key: "_appendElement",
      value: function _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element);
      }
    }, {
      key: "_insertElement",
      value: function _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element);
        this.openElements.push(element);
      }
    }, {
      key: "_insertFakeElement",
      value: function _insertFakeElement(tagName) {
        const element = this.treeAdapter.createElement(tagName, NS.HTML, []);
        this._attachElementToTree(element);
        this.openElements.push(element);
      }
    }, {
      key: "_insertTemplate",
      value: function _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl);
        this.openElements.push(tmpl);
      }
    }, {
      key: "_insertFakeRootElement",
      value: function _insertFakeRootElement() {
        const element = this.treeAdapter.createElement($.HTML, NS.HTML, []);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element);
      }
    }, {
      key: "_appendCommentNode",
      value: function _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
      }
    }, {
      key: "_insertCharacters",
      value: function _insertCharacters(token) {
        if (this._shouldFosterParentOnInsertion()) {
          this._fosterParentText(token.chars);
        } else {
          const parent = this.openElements.currentTmplContent || this.openElements.current;
          this.treeAdapter.insertText(parent, token.chars);
        }
      }
    }, {
      key: "_adoptNodes",
      value: function _adoptNodes(donor, recipient) {
        for (let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
          this.treeAdapter.detachNode(child);
          this.treeAdapter.appendChild(recipient, child);
        }
      }
      //Token processing
    }, {
      key: "_shouldProcessTokenInForeignContent",
      value: function _shouldProcessTokenInForeignContent(token) {
        const current = this._getAdjustedCurrentElement();
        if (!current || current === this.document) {
          return false;
        }
        const ns = this.treeAdapter.getNamespaceURI(current);
        if (ns === NS.HTML) {
          return false;
        }
        if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML && token.type === Tokenizer2.START_TAG_TOKEN && token.tagName === $.SVG) {
          return false;
        }
        const isCharacterToken = token.type === Tokenizer2.CHARACTER_TOKEN || token.type === Tokenizer2.NULL_CHARACTER_TOKEN || token.type === Tokenizer2.WHITESPACE_CHARACTER_TOKEN;
        const isMathMLTextStartTag = token.type === Tokenizer2.START_TAG_TOKEN && token.tagName !== $.MGLYPH && token.tagName !== $.MALIGNMARK;
        if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML)) {
          return false;
        }
        if ((token.type === Tokenizer2.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML)) {
          return false;
        }
        return token.type !== Tokenizer2.EOF_TOKEN;
      }
    }, {
      key: "_processToken",
      value: function _processToken(token) {
        TOKEN_HANDLERS[this.insertionMode][token.type](this, token);
      }
    }, {
      key: "_processTokenInBodyMode",
      value: function _processTokenInBodyMode(token) {
        TOKEN_HANDLERS[IN_BODY_MODE][token.type](this, token);
      }
    }, {
      key: "_processTokenInForeignContent",
      value: function _processTokenInForeignContent(token) {
        if (token.type === Tokenizer2.CHARACTER_TOKEN) {
          characterInForeignContent(this, token);
        } else if (token.type === Tokenizer2.NULL_CHARACTER_TOKEN) {
          nullCharacterInForeignContent(this, token);
        } else if (token.type === Tokenizer2.WHITESPACE_CHARACTER_TOKEN) {
          insertCharacters(this, token);
        } else if (token.type === Tokenizer2.COMMENT_TOKEN) {
          appendComment(this, token);
        } else if (token.type === Tokenizer2.START_TAG_TOKEN) {
          startTagInForeignContent(this, token);
        } else if (token.type === Tokenizer2.END_TAG_TOKEN) {
          endTagInForeignContent(this, token);
        }
      }
    }, {
      key: "_processInputToken",
      value: function _processInputToken(token) {
        if (this._shouldProcessTokenInForeignContent(token)) {
          this._processTokenInForeignContent(token);
        } else {
          this._processToken(token);
        }
        if (token.type === Tokenizer2.START_TAG_TOKEN && token.selfClosing && !token.ackSelfClosing) {
          this._err(ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
        }
      }
      //Integration points
    }, {
      key: "_isIntegrationPoint",
      value: function _isIntegrationPoint(element, foreignNS) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return foreignContent2.isIntegrationPoint(tn, ns, attrs, foreignNS);
      }
      //Active formatting elements reconstruction
    }, {
      key: "_reconstructActiveFormattingElements",
      value: function _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.length;
        if (listLength) {
          let unopenIdx = listLength;
          let entry = null;
          do {
            unopenIdx--;
            entry = this.activeFormattingElements.entries[unopenIdx];
            if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
              unopenIdx++;
              break;
            }
          } while (unopenIdx > 0);
          for (let i = unopenIdx; i < listLength; i++) {
            entry = this.activeFormattingElements.entries[i];
            this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
            entry.element = this.openElements.current;
          }
        }
      }
      //Close elements
    }, {
      key: "_closeTableCell",
      value: function _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = IN_ROW_MODE;
      }
    }, {
      key: "_closePElement",
      value: function _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion($.P);
        this.openElements.popUntilTagNamePopped($.P);
      }
      //Insertion modes
    }, {
      key: "_resetInsertionMode",
      value: function _resetInsertionMode() {
        for (let i = this.openElements.stackTop, last = false; i >= 0; i--) {
          let element = this.openElements.items[i];
          if (i === 0) {
            last = true;
            if (this.fragmentContext) {
              element = this.fragmentContext;
            }
          }
          const tn = this.treeAdapter.getTagName(element);
          const newInsertionMode = INSERTION_MODE_RESET_MAP[tn];
          if (newInsertionMode) {
            this.insertionMode = newInsertionMode;
            break;
          } else if (!last && (tn === $.TD || tn === $.TH)) {
            this.insertionMode = IN_CELL_MODE;
            break;
          } else if (!last && tn === $.HEAD) {
            this.insertionMode = IN_HEAD_MODE;
            break;
          } else if (tn === $.SELECT) {
            this._resetInsertionModeForSelect(i);
            break;
          } else if (tn === $.TEMPLATE) {
            this.insertionMode = this.currentTmplInsertionMode;
            break;
          } else if (tn === $.HTML) {
            this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
            break;
          } else if (last) {
            this.insertionMode = IN_BODY_MODE;
            break;
          }
        }
      }
    }, {
      key: "_resetInsertionModeForSelect",
      value: function _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) {
          for (let i = selectIdx - 1; i > 0; i--) {
            const ancestor = this.openElements.items[i];
            const tn = this.treeAdapter.getTagName(ancestor);
            if (tn === $.TEMPLATE) {
              break;
            } else if (tn === $.TABLE) {
              this.insertionMode = IN_SELECT_IN_TABLE_MODE;
              return;
            }
          }
        }
        this.insertionMode = IN_SELECT_MODE;
      }
    }, {
      key: "_pushTmplInsertionMode",
      value: function _pushTmplInsertionMode(mode) {
        this.tmplInsertionModeStack.push(mode);
        this.tmplInsertionModeStackTop++;
        this.currentTmplInsertionMode = mode;
      }
    }, {
      key: "_popTmplInsertionMode",
      value: function _popTmplInsertionMode() {
        this.tmplInsertionModeStack.pop();
        this.tmplInsertionModeStackTop--;
        this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
      }
      //Foster parenting
    }, {
      key: "_isElementCausesFosterParenting",
      value: function _isElementCausesFosterParenting(element) {
        const tn = this.treeAdapter.getTagName(element);
        return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
      }
    }, {
      key: "_shouldFosterParentOnInsertion",
      value: function _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
      }
    }, {
      key: "_findFosterParentingLocation",
      value: function _findFosterParentingLocation() {
        const location = {
          parent: null,
          beforeElement: null
        };
        for (let i = this.openElements.stackTop; i >= 0; i--) {
          const openElement = this.openElements.items[i];
          const tn = this.treeAdapter.getTagName(openElement);
          const ns = this.treeAdapter.getNamespaceURI(openElement);
          if (tn === $.TEMPLATE && ns === NS.HTML) {
            location.parent = this.treeAdapter.getTemplateContent(openElement);
            break;
          } else if (tn === $.TABLE) {
            location.parent = this.treeAdapter.getParentNode(openElement);
            if (location.parent) {
              location.beforeElement = openElement;
            } else {
              location.parent = this.openElements.items[i - 1];
            }
            break;
          }
        }
        if (!location.parent) {
          location.parent = this.openElements.items[0];
        }
        return location;
      }
    }, {
      key: "_fosterParentElement",
      value: function _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) {
          this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        } else {
          this.treeAdapter.appendChild(location.parent, element);
        }
      }
    }, {
      key: "_fosterParentText",
      value: function _fosterParentText(chars) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) {
          this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
        } else {
          this.treeAdapter.insertText(location.parent, chars);
        }
      }
      //Special elements
    }, {
      key: "_isSpecialElement",
      value: function _isSpecialElement(element) {
        const tn = this.treeAdapter.getTagName(element);
        const ns = this.treeAdapter.getNamespaceURI(element);
        return HTML.SPECIAL_ELEMENTS[ns][tn];
      }
    }]);
  })();
  parser = Parser2;
  function aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
      if (!p.openElements.contains(formattingElementEntry.element)) {
        p.activeFormattingElements.removeEntry(formattingElementEntry);
        formattingElementEntry = null;
      } else if (!p.openElements.hasInScope(token.tagName)) {
        formattingElementEntry = null;
      }
    } else {
      genericEndTagInBody(p, token);
    }
    return formattingElementEntry;
  }
  function aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    for (let i = p.openElements.stackTop; i >= 0; i--) {
      const element = p.openElements.items[i];
      if (element === formattingElementEntry.element) {
        break;
      }
      if (p._isSpecialElement(element)) {
        furthestBlock = element;
      }
    }
    if (!furthestBlock) {
      p.openElements.popUntilElementPopped(formattingElementEntry.element);
      p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
  }
  function aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for (let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
      nextElement = p.openElements.getCommonAncestor(element);
      const elementEntry = p.activeFormattingElements.getElementEntry(element);
      const counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
      const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
      if (shouldRemoveFromOpenElements) {
        if (counterOverflow) {
          p.activeFormattingElements.removeEntry(elementEntry);
        }
        p.openElements.remove(element);
      } else {
        element = aaRecreateElementFromEntry(p, elementEntry);
        if (lastElement === furthestBlock) {
          p.activeFormattingElements.bookmark = elementEntry;
        }
        p.treeAdapter.detachNode(lastElement);
        p.treeAdapter.appendChild(element, lastElement);
        lastElement = element;
      }
    }
    return lastElement;
  }
  function aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
  }
  function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor)) {
      p._fosterParentElement(lastElement);
    } else {
      const tn = p.treeAdapter.getTagName(commonAncestor);
      const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
      if (tn === $.TEMPLATE && ns === NS.HTML) {
        commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
      }
      p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
  }
  function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const token = formattingElementEntry.token;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
  }
  function callAdoptionAgency(p, token) {
    let formattingElementEntry;
    for (let i = 0; i < AA_OUTER_LOOP_ITER; i++) {
      formattingElementEntry = aaObtainFormattingElementEntry(p, token);
      if (!formattingElementEntry) {
        break;
      }
      const furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);
      if (!furthestBlock) {
        break;
      }
      p.activeFormattingElements.bookmark = formattingElementEntry;
      const lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
      const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
      p.treeAdapter.detachNode(lastElement);
      aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
      aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
  }
  function ignoreToken() {
  }
  function misplacedDoctype(p) {
    p._err(ERR.misplacedDoctype);
  }
  function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
  }
  function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
  }
  function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
  }
  function insertCharacters(p, token) {
    p._insertCharacters(token);
  }
  function stopParsing(p) {
    p.stopped = true;
  }
  function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? HTML.DOCUMENT_MODE.QUIRKS : doctype2.getDocumentMode(token);
    if (!doctype2.isConforming(token)) {
      p._err(ERR.nonConformingDoctype);
    }
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = BEFORE_HTML_MODE;
  }
  function tokenInInitialMode(p, token) {
    p._err(ERR.missingDoctype, {
      beforeToken: true
    });
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
  }
  function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
      p._insertElement(token, NS.HTML);
      p.insertionMode = BEFORE_HEAD_MODE;
    } else {
      tokenBeforeHtml(p, token);
    }
  }
  function endTagBeforeHtml(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR) {
      tokenBeforeHtml(p, token);
    }
  }
  function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
  }
  function startTagBeforeHead(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.HEAD) {
      p._insertElement(token, NS.HTML);
      p.headElement = p.openElements.current;
      p.insertionMode = IN_HEAD_MODE;
    } else {
      tokenBeforeHead(p, token);
    }
  }
  function endTagBeforeHead(p, token) {
    const tn = token.tagName;
    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR) {
      tokenBeforeHead(p, token);
    } else {
      p._err(ERR.endTagWithoutMatchingOpenElement);
    }
  }
  function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
  }
  function startTagInHead(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META) {
      p._appendElement(token, NS.HTML);
      token.ackSelfClosing = true;
    } else if (tn === $.TITLE) {
      p._switchToTextParsing(token, Tokenizer2.MODE.RCDATA);
    } else if (tn === $.NOSCRIPT) {
      if (p.options.scriptingEnabled) {
        p._switchToTextParsing(token, Tokenizer2.MODE.RAWTEXT);
      } else {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_HEAD_NO_SCRIPT_MODE;
      }
    } else if (tn === $.NOFRAMES || tn === $.STYLE) {
      p._switchToTextParsing(token, Tokenizer2.MODE.RAWTEXT);
    } else if (tn === $.SCRIPT) {
      p._switchToTextParsing(token, Tokenizer2.MODE.SCRIPT_DATA);
    } else if (tn === $.TEMPLATE) {
      p._insertTemplate(token, NS.HTML);
      p.activeFormattingElements.insertMarker();
      p.framesetOk = false;
      p.insertionMode = IN_TEMPLATE_MODE;
      p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    } else if (tn === $.HEAD) {
      p._err(ERR.misplacedStartTagForHeadElement);
    } else {
      tokenInHead(p, token);
    }
  }
  function endTagInHead(p, token) {
    const tn = token.tagName;
    if (tn === $.HEAD) {
      p.openElements.pop();
      p.insertionMode = AFTER_HEAD_MODE;
    } else if (tn === $.BODY || tn === $.BR || tn === $.HTML) {
      tokenInHead(p, token);
    } else if (tn === $.TEMPLATE) {
      if (p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTagsThoroughly();
        if (p.openElements.currentTagName !== $.TEMPLATE) {
          p._err(ERR.closingOfElementWithOpenChildElements);
        }
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
      } else {
        p._err(ERR.endTagWithoutMatchingOpenElement);
      }
    } else {
      p._err(ERR.endTagWithoutMatchingOpenElement);
    }
  }
  function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
  }
  function startTagInHeadNoScript(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.BASEFONT || tn === $.BGSOUND || tn === $.HEAD || tn === $.LINK || tn === $.META || tn === $.NOFRAMES || tn === $.STYLE) {
      startTagInHead(p, token);
    } else if (tn === $.NOSCRIPT) {
      p._err(ERR.nestedNoscriptInHead);
    } else {
      tokenInHeadNoScript(p, token);
    }
  }
  function endTagInHeadNoScript(p, token) {
    const tn = token.tagName;
    if (tn === $.NOSCRIPT) {
      p.openElements.pop();
      p.insertionMode = IN_HEAD_MODE;
    } else if (tn === $.BR) {
      tokenInHeadNoScript(p, token);
    } else {
      p._err(ERR.endTagWithoutMatchingOpenElement);
    }
  }
  function tokenInHeadNoScript(p, token) {
    const errCode = token.type === Tokenizer2.EOF_TOKEN ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;
    p._err(errCode);
    p.openElements.pop();
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
  }
  function startTagAfterHead(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.BODY) {
      p._insertElement(token, NS.HTML);
      p.framesetOk = false;
      p.insertionMode = IN_BODY_MODE;
    } else if (tn === $.FRAMESET) {
      p._insertElement(token, NS.HTML);
      p.insertionMode = IN_FRAMESET_MODE;
    } else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META || tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
      p._err(ERR.abandonedHeadElementChild);
      p.openElements.push(p.headElement);
      startTagInHead(p, token);
      p.openElements.remove(p.headElement);
    } else if (tn === $.HEAD) {
      p._err(ERR.misplacedStartTagForHeadElement);
    } else {
      tokenAfterHead(p, token);
    }
  }
  function endTagAfterHead(p, token) {
    const tn = token.tagName;
    if (tn === $.BODY || tn === $.HTML || tn === $.BR) {
      tokenAfterHead(p, token);
    } else if (tn === $.TEMPLATE) {
      endTagInHead(p, token);
    } else {
      p._err(ERR.endTagWithoutMatchingOpenElement);
    }
  }
  function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
  }
  function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
  }
  function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
  }
  function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) {
      p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
    }
  }
  function bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
      p.framesetOk = false;
      p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
  }
  function framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
      p.treeAdapter.detachNode(bodyElement);
      p.openElements.popAllUpToHtmlElement();
      p._insertElement(token, NS.HTML);
      p.insertionMode = IN_FRAMESET_MODE;
    }
  }
  function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
  }
  function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    const tn = p.openElements.currentTagName;
    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
      p.openElements.pop();
    }
    p._insertElement(token, NS.HTML);
  }
  function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    p.skipNextNewLine = true;
    p.framesetOk = false;
  }
  function formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
      if (p.openElements.hasInButtonScope($.P)) {
        p._closePElement();
      }
      p._insertElement(token, NS.HTML);
      if (!inTemplate) {
        p.formElement = p.openElements.current;
      }
    }
  }
  function listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagName;
    for (let i = p.openElements.stackTop; i >= 0; i--) {
      const element = p.openElements.items[i];
      const elementTn = p.treeAdapter.getTagName(element);
      let closeTn = null;
      if (tn === $.LI && elementTn === $.LI) {
        closeTn = $.LI;
      } else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT)) {
        closeTn = elementTn;
      }
      if (closeTn) {
        p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
        p.openElements.popUntilTagNamePopped(closeTn);
        break;
      }
      if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element)) {
        break;
      }
    }
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
  }
  function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer2.MODE.PLAINTEXT;
  }
  function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped($.BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
  }
  function aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);
    if (activeElementEntry) {
      callAdoptionAgency(p, token);
      p.openElements.remove(activeElementEntry.element);
      p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
  }
  function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
  }
  function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope($.NOBR)) {
      callAdoptionAgency(p, token);
      p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
  }
  function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
  }
  function tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
  }
  function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
  }
  function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    const inputType = Tokenizer2.getTokenAttr(token, ATTRS.TYPE);
    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE) {
      p.framesetOk = false;
    }
    token.ackSelfClosing = true;
  }
  function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
  }
  function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
  }
  function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
  }
  function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer2.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
  }
  function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer2.MODE.RAWTEXT);
  }
  function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer2.MODE.RAWTEXT);
  }
  function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer2.MODE.RAWTEXT);
  }
  function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    if (p.insertionMode === IN_TABLE_MODE || p.insertionMode === IN_CAPTION_MODE || p.insertionMode === IN_TABLE_BODY_MODE || p.insertionMode === IN_ROW_MODE || p.insertionMode === IN_CELL_MODE) {
      p.insertionMode = IN_SELECT_IN_TABLE_MODE;
    } else {
      p.insertionMode = IN_SELECT_MODE;
    }
  }
  function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION) {
      p.openElements.pop();
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
  }
  function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY)) {
      p.openElements.generateImpliedEndTags();
    }
    p._insertElement(token, NS.HTML);
  }
  function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY)) {
      p.openElements.generateImpliedEndTagsWithExclusion($.RTC);
    }
    p._insertElement(token, NS.HTML);
  }
  function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
  }
  function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    foreignContent2.adjustTokenMathMLAttrs(token);
    foreignContent2.adjustTokenXMLAttrs(token);
    if (token.selfClosing) {
      p._appendElement(token, NS.MATHML);
    } else {
      p._insertElement(token, NS.MATHML);
    }
    token.ackSelfClosing = true;
  }
  function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    foreignContent2.adjustTokenSVGAttrs(token);
    foreignContent2.adjustTokenXMLAttrs(token);
    if (token.selfClosing) {
      p._appendElement(token, NS.SVG);
    } else {
      p._insertElement(token, NS.SVG);
    }
    token.ackSelfClosing = true;
  }
  function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
  }
  function startTagInBody(p, token) {
    const tn = token.tagName;
    switch (tn.length) {
      case 1:
        if (tn === $.I || tn === $.S || tn === $.B || tn === $.U) {
          bStartTagInBody(p, token);
        } else if (tn === $.P) {
          addressStartTagInBody(p, token);
        } else if (tn === $.A) {
          aStartTagInBody(p, token);
        } else {
          genericStartTagInBody(p, token);
        }
        break;
      case 2:
        if (tn === $.DL || tn === $.OL || tn === $.UL) {
          addressStartTagInBody(p, token);
        } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
          numberedHeaderStartTagInBody(p, token);
        } else if (tn === $.LI || tn === $.DD || tn === $.DT) {
          listItemStartTagInBody(p, token);
        } else if (tn === $.EM || tn === $.TT) {
          bStartTagInBody(p, token);
        } else if (tn === $.BR) {
          areaStartTagInBody(p, token);
        } else if (tn === $.HR) {
          hrStartTagInBody(p, token);
        } else if (tn === $.RB) {
          rbStartTagInBody(p, token);
        } else if (tn === $.RT || tn === $.RP) {
          rtStartTagInBody(p, token);
        } else if (tn !== $.TH && tn !== $.TD && tn !== $.TR) {
          genericStartTagInBody(p, token);
        }
        break;
      case 3:
        if (tn === $.DIV || tn === $.DIR || tn === $.NAV) {
          addressStartTagInBody(p, token);
        } else if (tn === $.PRE) {
          preStartTagInBody(p, token);
        } else if (tn === $.BIG) {
          bStartTagInBody(p, token);
        } else if (tn === $.IMG || tn === $.WBR) {
          areaStartTagInBody(p, token);
        } else if (tn === $.XMP) {
          xmpStartTagInBody(p, token);
        } else if (tn === $.SVG) {
          svgStartTagInBody(p, token);
        } else if (tn === $.RTC) {
          rbStartTagInBody(p, token);
        } else if (tn !== $.COL) {
          genericStartTagInBody(p, token);
        }
        break;
      case 4:
        if (tn === $.HTML) {
          htmlStartTagInBody(p, token);
        } else if (tn === $.BASE || tn === $.LINK || tn === $.META) {
          startTagInHead(p, token);
        } else if (tn === $.BODY) {
          bodyStartTagInBody(p, token);
        } else if (tn === $.MAIN || tn === $.MENU) {
          addressStartTagInBody(p, token);
        } else if (tn === $.FORM) {
          formStartTagInBody(p, token);
        } else if (tn === $.CODE || tn === $.FONT) {
          bStartTagInBody(p, token);
        } else if (tn === $.NOBR) {
          nobrStartTagInBody(p, token);
        } else if (tn === $.AREA) {
          areaStartTagInBody(p, token);
        } else if (tn === $.MATH) {
          mathStartTagInBody(p, token);
        } else if (tn === $.MENU) {
          menuStartTagInBody(p, token);
        } else if (tn !== $.HEAD) {
          genericStartTagInBody(p, token);
        }
        break;
      case 5:
        if (tn === $.STYLE || tn === $.TITLE) {
          startTagInHead(p, token);
        } else if (tn === $.ASIDE) {
          addressStartTagInBody(p, token);
        } else if (tn === $.SMALL) {
          bStartTagInBody(p, token);
        } else if (tn === $.TABLE) {
          tableStartTagInBody(p, token);
        } else if (tn === $.EMBED) {
          areaStartTagInBody(p, token);
        } else if (tn === $.INPUT) {
          inputStartTagInBody(p, token);
        } else if (tn === $.PARAM || tn === $.TRACK) {
          paramStartTagInBody(p, token);
        } else if (tn === $.IMAGE) {
          imageStartTagInBody(p, token);
        } else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD) {
          genericStartTagInBody(p, token);
        }
        break;
      case 6:
        if (tn === $.SCRIPT) {
          startTagInHead(p, token);
        } else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP || tn === $.DIALOG) {
          addressStartTagInBody(p, token);
        } else if (tn === $.BUTTON) {
          buttonStartTagInBody(p, token);
        } else if (tn === $.STRIKE || tn === $.STRONG) {
          bStartTagInBody(p, token);
        } else if (tn === $.APPLET || tn === $.OBJECT) {
          appletStartTagInBody(p, token);
        } else if (tn === $.KEYGEN) {
          areaStartTagInBody(p, token);
        } else if (tn === $.SOURCE) {
          paramStartTagInBody(p, token);
        } else if (tn === $.IFRAME) {
          iframeStartTagInBody(p, token);
        } else if (tn === $.SELECT) {
          selectStartTagInBody(p, token);
        } else if (tn === $.OPTION) {
          optgroupStartTagInBody(p, token);
        } else {
          genericStartTagInBody(p, token);
        }
        break;
      case 7:
        if (tn === $.BGSOUND) {
          startTagInHead(p, token);
        } else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY) {
          addressStartTagInBody(p, token);
        } else if (tn === $.LISTING) {
          preStartTagInBody(p, token);
        } else if (tn === $.MARQUEE) {
          appletStartTagInBody(p, token);
        } else if (tn === $.NOEMBED) {
          noembedStartTagInBody(p, token);
        } else if (tn !== $.CAPTION) {
          genericStartTagInBody(p, token);
        }
        break;
      case 8:
        if (tn === $.BASEFONT) {
          startTagInHead(p, token);
        } else if (tn === $.FRAMESET) {
          framesetStartTagInBody(p, token);
        } else if (tn === $.FIELDSET) {
          addressStartTagInBody(p, token);
        } else if (tn === $.TEXTAREA) {
          textareaStartTagInBody(p, token);
        } else if (tn === $.TEMPLATE) {
          startTagInHead(p, token);
        } else if (tn === $.NOSCRIPT) {
          if (p.options.scriptingEnabled) {
            noembedStartTagInBody(p, token);
          } else {
            genericStartTagInBody(p, token);
          }
        } else if (tn === $.OPTGROUP) {
          optgroupStartTagInBody(p, token);
        } else if (tn !== $.COLGROUP) {
          genericStartTagInBody(p, token);
        }
        break;
      case 9:
        if (tn === $.PLAINTEXT) {
          plaintextStartTagInBody(p, token);
        } else {
          genericStartTagInBody(p, token);
        }
        break;
      case 10:
        if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
          addressStartTagInBody(p, token);
        } else {
          genericStartTagInBody(p, token);
        }
        break;
      default:
        genericStartTagInBody(p, token);
    }
  }
  function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY)) {
      p.insertionMode = AFTER_BODY_MODE;
    }
  }
  function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
      p.insertionMode = AFTER_BODY_MODE;
      p._processToken(token);
    }
  }
  function addressEndTagInBody(p, token) {
    const tn = token.tagName;
    if (p.openElements.hasInScope(tn)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped(tn);
    }
  }
  function formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const formElement = p.formElement;
    if (!inTemplate) {
      p.formElement = null;
    }
    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
      p.openElements.generateImpliedEndTags();
      if (inTemplate) {
        p.openElements.popUntilTagNamePopped($.FORM);
      } else {
        p.openElements.remove(formElement);
      }
    }
  }
  function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P)) {
      p._insertFakeElement($.P);
    }
    p._closePElement();
  }
  function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
      p.openElements.generateImpliedEndTagsWithExclusion($.LI);
      p.openElements.popUntilTagNamePopped($.LI);
    }
  }
  function ddEndTagInBody(p, token) {
    const tn = token.tagName;
    if (p.openElements.hasInScope(tn)) {
      p.openElements.generateImpliedEndTagsWithExclusion(tn);
      p.openElements.popUntilTagNamePopped(tn);
    }
  }
  function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilNumberedHeaderPopped();
    }
  }
  function appletEndTagInBody(p, token) {
    const tn = token.tagName;
    if (p.openElements.hasInScope(tn)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped(tn);
      p.activeFormattingElements.clearToLastMarker();
    }
  }
  function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
  }
  function genericEndTagInBody(p, token) {
    const tn = token.tagName;
    for (let i = p.openElements.stackTop; i > 0; i--) {
      const element = p.openElements.items[i];
      if (p.treeAdapter.getTagName(element) === tn) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilElementPopped(element);
        break;
      }
      if (p._isSpecialElement(element)) {
        break;
      }
    }
  }
  function endTagInBody(p, token) {
    const tn = token.tagName;
    switch (tn.length) {
      case 1:
        if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U) {
          callAdoptionAgency(p, token);
        } else if (tn === $.P) {
          pEndTagInBody(p);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 2:
        if (tn === $.DL || tn === $.UL || tn === $.OL) {
          addressEndTagInBody(p, token);
        } else if (tn === $.LI) {
          liEndTagInBody(p);
        } else if (tn === $.DD || tn === $.DT) {
          ddEndTagInBody(p, token);
        } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
          numberedHeaderEndTagInBody(p);
        } else if (tn === $.BR) {
          brEndTagInBody(p);
        } else if (tn === $.EM || tn === $.TT) {
          callAdoptionAgency(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 3:
        if (tn === $.BIG) {
          callAdoptionAgency(p, token);
        } else if (tn === $.DIR || tn === $.DIV || tn === $.NAV || tn === $.PRE) {
          addressEndTagInBody(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 4:
        if (tn === $.BODY) {
          bodyEndTagInBody(p);
        } else if (tn === $.HTML) {
          htmlEndTagInBody(p, token);
        } else if (tn === $.FORM) {
          formEndTagInBody(p);
        } else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR) {
          callAdoptionAgency(p, token);
        } else if (tn === $.MAIN || tn === $.MENU) {
          addressEndTagInBody(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 5:
        if (tn === $.ASIDE) {
          addressEndTagInBody(p, token);
        } else if (tn === $.SMALL) {
          callAdoptionAgency(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 6:
        if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP || tn === $.DIALOG) {
          addressEndTagInBody(p, token);
        } else if (tn === $.APPLET || tn === $.OBJECT) {
          appletEndTagInBody(p, token);
        } else if (tn === $.STRIKE || tn === $.STRONG) {
          callAdoptionAgency(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 7:
        if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY || tn === $.LISTING) {
          addressEndTagInBody(p, token);
        } else if (tn === $.MARQUEE) {
          appletEndTagInBody(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 8:
        if (tn === $.FIELDSET) {
          addressEndTagInBody(p, token);
        } else if (tn === $.TEMPLATE) {
          endTagInHead(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      case 10:
        if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
          addressEndTagInBody(p, token);
        } else {
          genericEndTagInBody(p, token);
        }
        break;
      default:
        genericEndTagInBody(p, token);
    }
  }
  function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1) {
      eofInTemplate(p, token);
    } else {
      p.stopped = true;
    }
  }
  function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT) {
      p.pendingScript = p.openElements.current;
    }
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
  }
  function eofInText(p, token) {
    p._err(ERR.eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
  }
  function characterInTable(p, token) {
    const curTn = p.openElements.currentTagName;
    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
      p.pendingCharacterTokens = [];
      p.hasNonWhitespacePendingCharacterToken = false;
      p.originalInsertionMode = p.insertionMode;
      p.insertionMode = IN_TABLE_TEXT_MODE;
      p._processToken(token);
    } else {
      tokenInTable(p, token);
    }
  }
  function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
  }
  function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
  }
  function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
  }
  function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
  }
  function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
  }
  function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
      p.openElements.popUntilTagNamePopped($.TABLE);
      p._resetInsertionMode();
      p._processToken(token);
    }
  }
  function inputStartTagInTable(p, token) {
    const inputType = Tokenizer2.getTokenAttr(token, ATTRS.TYPE);
    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE) {
      p._appendElement(token, NS.HTML);
    } else {
      tokenInTable(p, token);
    }
    token.ackSelfClosing = true;
  }
  function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
      p._insertElement(token, NS.HTML);
      p.formElement = p.openElements.current;
      p.openElements.pop();
    }
  }
  function startTagInTable(p, token) {
    const tn = token.tagName;
    switch (tn.length) {
      case 2:
        if (tn === $.TD || tn === $.TH || tn === $.TR) {
          tdStartTagInTable(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      case 3:
        if (tn === $.COL) {
          colStartTagInTable(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      case 4:
        if (tn === $.FORM) {
          formStartTagInTable(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      case 5:
        if (tn === $.TABLE) {
          tableStartTagInTable(p, token);
        } else if (tn === $.STYLE) {
          startTagInHead(p, token);
        } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
          tbodyStartTagInTable(p, token);
        } else if (tn === $.INPUT) {
          inputStartTagInTable(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      case 6:
        if (tn === $.SCRIPT) {
          startTagInHead(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      case 7:
        if (tn === $.CAPTION) {
          captionStartTagInTable(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      case 8:
        if (tn === $.COLGROUP) {
          colgroupStartTagInTable(p, token);
        } else if (tn === $.TEMPLATE) {
          startTagInHead(p, token);
        } else {
          tokenInTable(p, token);
        }
        break;
      default:
        tokenInTable(p, token);
    }
  }
  function endTagInTable(p, token) {
    const tn = token.tagName;
    if (tn === $.TABLE) {
      if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
      }
    } else if (tn === $.TEMPLATE) {
      endTagInHead(p, token);
    } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR) {
      tokenInTable(p, token);
    }
  }
  function tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
  }
  function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
  }
  function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
  }
  function tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) {
      for (; i < p.pendingCharacterTokens.length; i++) {
        tokenInTable(p, p.pendingCharacterTokens[i]);
      }
    } else {
      for (; i < p.pendingCharacterTokens.length; i++) {
        p._insertCharacters(p.pendingCharacterTokens[i]);
      }
    }
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
  }
  function startTagInCaption(p, token) {
    const tn = token.tagName;
    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
      if (p.openElements.hasInTableScope($.CAPTION)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.CAPTION);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
      }
    } else {
      startTagInBody(p, token);
    }
  }
  function endTagInCaption(p, token) {
    const tn = token.tagName;
    if (tn === $.CAPTION || tn === $.TABLE) {
      if (p.openElements.hasInTableScope($.CAPTION)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.CAPTION);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = IN_TABLE_MODE;
        if (tn === $.TABLE) {
          p._processToken(token);
        }
      }
    } else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR) {
      endTagInBody(p, token);
    }
  }
  function startTagInColumnGroup(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.COL) {
      p._appendElement(token, NS.HTML);
      token.ackSelfClosing = true;
    } else if (tn === $.TEMPLATE) {
      startTagInHead(p, token);
    } else {
      tokenInColumnGroup(p, token);
    }
  }
  function endTagInColumnGroup(p, token) {
    const tn = token.tagName;
    if (tn === $.COLGROUP) {
      if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
      }
    } else if (tn === $.TEMPLATE) {
      endTagInHead(p, token);
    } else if (tn !== $.COL) {
      tokenInColumnGroup(p, token);
    }
  }
  function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
      p.openElements.pop();
      p.insertionMode = IN_TABLE_MODE;
      p._processToken(token);
    }
  }
  function startTagInTableBody(p, token) {
    const tn = token.tagName;
    if (tn === $.TR) {
      p.openElements.clearBackToTableBodyContext();
      p._insertElement(token, NS.HTML);
      p.insertionMode = IN_ROW_MODE;
    } else if (tn === $.TH || tn === $.TD) {
      p.openElements.clearBackToTableBodyContext();
      p._insertFakeElement($.TR);
      p.insertionMode = IN_ROW_MODE;
      p._processToken(token);
    } else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
      if (p.openElements.hasTableBodyContextInTableScope()) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
      }
    } else {
      startTagInTable(p, token);
    }
  }
  function endTagInTableBody(p, token) {
    const tn = token.tagName;
    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
      }
    } else if (tn === $.TABLE) {
      if (p.openElements.hasTableBodyContextInTableScope()) {
        p.openElements.clearBackToTableBodyContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
      }
    } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP || tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR) {
      endTagInTable(p, token);
    }
  }
  function startTagInRow(p, token) {
    const tn = token.tagName;
    if (tn === $.TH || tn === $.TD) {
      p.openElements.clearBackToTableRowContext();
      p._insertElement(token, NS.HTML);
      p.insertionMode = IN_CELL_MODE;
      p.activeFormattingElements.insertMarker();
    } else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
      if (p.openElements.hasInTableScope($.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_BODY_MODE;
        p._processToken(token);
      }
    } else {
      startTagInTable(p, token);
    }
  }
  function endTagInRow(p, token) {
    const tn = token.tagName;
    if (tn === $.TR) {
      if (p.openElements.hasInTableScope($.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_BODY_MODE;
      }
    } else if (tn === $.TABLE) {
      if (p.openElements.hasInTableScope($.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_BODY_MODE;
        p._processToken(token);
      }
    } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
      if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
        p.openElements.clearBackToTableRowContext();
        p.openElements.pop();
        p.insertionMode = IN_TABLE_BODY_MODE;
        p._processToken(token);
      }
    } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP || tn !== $.HTML && tn !== $.TD && tn !== $.TH) {
      endTagInTable(p, token);
    }
  }
  function startTagInCell(p, token) {
    const tn = token.tagName;
    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
      if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
        p._closeTableCell();
        p._processToken(token);
      }
    } else {
      startTagInBody(p, token);
    }
  }
  function endTagInCell(p, token) {
    const tn = token.tagName;
    if (tn === $.TD || tn === $.TH) {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
        p.insertionMode = IN_ROW_MODE;
      }
    } else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
      if (p.openElements.hasInTableScope(tn)) {
        p._closeTableCell();
        p._processToken(token);
      }
    } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML) {
      endTagInBody(p, token);
    }
  }
  function startTagInSelect(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.OPTION) {
      if (p.openElements.currentTagName === $.OPTION) {
        p.openElements.pop();
      }
      p._insertElement(token, NS.HTML);
    } else if (tn === $.OPTGROUP) {
      if (p.openElements.currentTagName === $.OPTION) {
        p.openElements.pop();
      }
      if (p.openElements.currentTagName === $.OPTGROUP) {
        p.openElements.pop();
      }
      p._insertElement(token, NS.HTML);
    } else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
      if (p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        if (tn !== $.SELECT) {
          p._processToken(token);
        }
      }
    } else if (tn === $.SCRIPT || tn === $.TEMPLATE) {
      startTagInHead(p, token);
    }
  }
  function endTagInSelect(p, token) {
    const tn = token.tagName;
    if (tn === $.OPTGROUP) {
      const prevOpenElement = p.openElements.items[p.openElements.stackTop - 1];
      const prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);
      if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP) {
        p.openElements.pop();
      }
      if (p.openElements.currentTagName === $.OPTGROUP) {
        p.openElements.pop();
      }
    } else if (tn === $.OPTION) {
      if (p.openElements.currentTagName === $.OPTION) {
        p.openElements.pop();
      }
    } else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
      p.openElements.popUntilTagNamePopped($.SELECT);
      p._resetInsertionMode();
    } else if (tn === $.TEMPLATE) {
      endTagInHead(p, token);
    }
  }
  function startTagInSelectInTable(p, token) {
    const tn = token.tagName;
    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
      p.openElements.popUntilTagNamePopped($.SELECT);
      p._resetInsertionMode();
      p._processToken(token);
    } else {
      startTagInSelect(p, token);
    }
  }
  function endTagInSelectInTable(p, token) {
    const tn = token.tagName;
    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
      if (p.openElements.hasInTableScope(tn)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
      }
    } else {
      endTagInSelect(p, token);
    }
  }
  function startTagInTemplate(p, token) {
    const tn = token.tagName;
    if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META || tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
      startTagInHead(p, token);
    } else {
      const newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;
      p._popTmplInsertionMode();
      p._pushTmplInsertionMode(newInsertionMode);
      p.insertionMode = newInsertionMode;
      p._processToken(token);
    }
  }
  function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE) {
      endTagInHead(p, token);
    }
  }
  function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
      p.openElements.popUntilTagNamePopped($.TEMPLATE);
      p.activeFormattingElements.clearToLastMarker();
      p._popTmplInsertionMode();
      p._resetInsertionMode();
      p._processToken(token);
    } else {
      p.stopped = true;
    }
  }
  function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
      startTagInBody(p, token);
    } else {
      tokenAfterBody(p, token);
    }
  }
  function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
      if (!p.fragmentContext) {
        p.insertionMode = AFTER_AFTER_BODY_MODE;
      }
    } else {
      tokenAfterBody(p, token);
    }
  }
  function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
  }
  function startTagInFrameset(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.FRAMESET) {
      p._insertElement(token, NS.HTML);
    } else if (tn === $.FRAME) {
      p._appendElement(token, NS.HTML);
      token.ackSelfClosing = true;
    } else if (tn === $.NOFRAMES) {
      startTagInHead(p, token);
    }
  }
  function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
      p.openElements.pop();
      if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET) {
        p.insertionMode = AFTER_FRAMESET_MODE;
      }
    }
  }
  function startTagAfterFrameset(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.NOFRAMES) {
      startTagInHead(p, token);
    }
  }
  function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML) {
      p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
    }
  }
  function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML) {
      startTagInBody(p, token);
    } else {
      tokenAfterAfterBody(p, token);
    }
  }
  function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
  }
  function startTagAfterAfterFrameset(p, token) {
    const tn = token.tagName;
    if (tn === $.HTML) {
      startTagInBody(p, token);
    } else if (tn === $.NOFRAMES) {
      startTagInHead(p, token);
    }
  }
  function nullCharacterInForeignContent(p, token) {
    token.chars = unicode2.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
  }
  function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
  }
  function startTagInForeignContent(p, token) {
    if (foreignContent2.causesExit(token) && !p.fragmentContext) {
      while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current)) {
        p.openElements.pop();
      }
      p._processToken(token);
    } else {
      const current = p._getAdjustedCurrentElement();
      const currentNs = p.treeAdapter.getNamespaceURI(current);
      if (currentNs === NS.MATHML) {
        foreignContent2.adjustTokenMathMLAttrs(token);
      } else if (currentNs === NS.SVG) {
        foreignContent2.adjustTokenSVGTagName(token);
        foreignContent2.adjustTokenSVGAttrs(token);
      }
      foreignContent2.adjustTokenXMLAttrs(token);
      if (token.selfClosing) {
        p._appendElement(token, currentNs);
      } else {
        p._insertElement(token, currentNs);
      }
      token.ackSelfClosing = true;
    }
  }
  function endTagInForeignContent(p, token) {
    for (let i = p.openElements.stackTop; i > 0; i--) {
      const element = p.openElements.items[i];
      if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
        p._processToken(token);
        break;
      }
      if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
        p.openElements.popUntilElementPopped(element);
        break;
      }
    }
  }
  return parser;
}
var serializer;
var hasRequiredSerializer;
function requireSerializer() {
  if (hasRequiredSerializer) return serializer;
  hasRequiredSerializer = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const defaultTreeAdapter = require_default();
  const mergeOptions2 = requireMergeOptions();
  const doctype2 = requireDoctype();
  const HTML = requireHtml();
  const $ = HTML.TAG_NAMES;
  const NS = HTML.NAMESPACES;
  const DEFAULT_OPTIONS = {
    treeAdapter: defaultTreeAdapter
  };
  const AMP_REGEX = /&/g;
  const NBSP_REGEX = /\u00a0/g;
  const DOUBLE_QUOTE_REGEX = /"/g;
  const LT_REGEX = /</g;
  const GT_REGEX = />/g;
  let Serializer = /* @__PURE__ */ (function() {
    function Serializer2(node2, options2) {
      _classCallCheck2(this, Serializer2);
      this.options = mergeOptions2(DEFAULT_OPTIONS, options2);
      this.treeAdapter = this.options.treeAdapter;
      this.html = "";
      this.startNode = node2;
    }
    return _createClass2(Serializer2, [{
      key: "serialize",
      value: function serialize() {
        this._serializeChildNodes(this.startNode);
        return this.html;
      }
      //Internals
    }, {
      key: "_serializeChildNodes",
      value: function _serializeChildNodes(parentNode) {
        const childNodes = this.treeAdapter.getChildNodes(parentNode);
        if (childNodes) {
          for (let i = 0, cnLength = childNodes.length; i < cnLength; i++) {
            const currentNode = childNodes[i];
            if (this.treeAdapter.isElementNode(currentNode)) {
              this._serializeElement(currentNode);
            } else if (this.treeAdapter.isTextNode(currentNode)) {
              this._serializeTextNode(currentNode);
            } else if (this.treeAdapter.isCommentNode(currentNode)) {
              this._serializeCommentNode(currentNode);
            } else if (this.treeAdapter.isDocumentTypeNode(currentNode)) {
              this._serializeDocumentTypeNode(currentNode);
            }
          }
        }
      }
    }, {
      key: "_serializeElement",
      value: function _serializeElement(node2) {
        const tn = this.treeAdapter.getTagName(node2);
        const ns = this.treeAdapter.getNamespaceURI(node2);
        this.html += "<" + tn;
        this._serializeAttributes(node2);
        this.html += ">";
        if (tn !== $.AREA && tn !== $.BASE && tn !== $.BASEFONT && tn !== $.BGSOUND && tn !== $.BR && tn !== $.COL && tn !== $.EMBED && tn !== $.FRAME && tn !== $.HR && tn !== $.IMG && tn !== $.INPUT && tn !== $.KEYGEN && tn !== $.LINK && tn !== $.META && tn !== $.PARAM && tn !== $.SOURCE && tn !== $.TRACK && tn !== $.WBR) {
          const childNodesHolder = tn === $.TEMPLATE && ns === NS.HTML ? this.treeAdapter.getTemplateContent(node2) : node2;
          this._serializeChildNodes(childNodesHolder);
          this.html += "</" + tn + ">";
        }
      }
    }, {
      key: "_serializeAttributes",
      value: function _serializeAttributes(node2) {
        const attrs = this.treeAdapter.getAttrList(node2);
        for (let i = 0, attrsLength = attrs.length; i < attrsLength; i++) {
          const attr = attrs[i];
          const value = Serializer2.escapeString(attr.value, true);
          this.html += " ";
          if (!attr.namespace) {
            this.html += attr.name;
          } else if (attr.namespace === NS.XML) {
            this.html += "xml:" + attr.name;
          } else if (attr.namespace === NS.XMLNS) {
            if (attr.name !== "xmlns") {
              this.html += "xmlns:";
            }
            this.html += attr.name;
          } else if (attr.namespace === NS.XLINK) {
            this.html += "xlink:" + attr.name;
          } else {
            this.html += attr.prefix + ":" + attr.name;
          }
          this.html += '="' + value + '"';
        }
      }
    }, {
      key: "_serializeTextNode",
      value: function _serializeTextNode(node2) {
        const content = this.treeAdapter.getTextNodeContent(node2);
        const parent = this.treeAdapter.getParentNode(node2);
        let parentTn = void 0;
        if (parent && this.treeAdapter.isElementNode(parent)) {
          parentTn = this.treeAdapter.getTagName(parent);
        }
        if (parentTn === $.STYLE || parentTn === $.SCRIPT || parentTn === $.XMP || parentTn === $.IFRAME || parentTn === $.NOEMBED || parentTn === $.NOFRAMES || parentTn === $.PLAINTEXT || parentTn === $.NOSCRIPT) {
          this.html += content;
        } else {
          this.html += Serializer2.escapeString(content, false);
        }
      }
    }, {
      key: "_serializeCommentNode",
      value: function _serializeCommentNode(node2) {
        this.html += "<!--" + this.treeAdapter.getCommentNodeContent(node2) + "-->";
      }
    }, {
      key: "_serializeDocumentTypeNode",
      value: function _serializeDocumentTypeNode(node2) {
        const name = this.treeAdapter.getDocumentTypeNodeName(node2);
        this.html += "<" + doctype2.serializeContent(name, null, null) + ">";
      }
    }]);
  })();
  Serializer.escapeString = function(str, attrMode) {
    str = str.replace(AMP_REGEX, "&amp;").replace(NBSP_REGEX, "&nbsp;");
    if (attrMode) {
      str = str.replace(DOUBLE_QUOTE_REGEX, "&quot;");
    } else {
      str = str.replace(LT_REGEX, "&lt;").replace(GT_REGEX, "&gt;");
    }
    return str;
  };
  serializer = Serializer;
  return serializer;
}
var hasRequiredLib$4;
function requireLib$4() {
  if (hasRequiredLib$4) return lib$3;
  hasRequiredLib$4 = 1;
  const Parser2 = requireParser();
  const Serializer = requireSerializer();
  lib$3.parse = function parse2(html2, options2) {
    const parser2 = new Parser2(options2);
    return parser2.parse(html2);
  };
  lib$3.parseFragment = function parseFragment(fragmentContext, html2, options2) {
    if (typeof fragmentContext === "string") {
      options2 = html2;
      html2 = fragmentContext;
      fragmentContext = null;
    }
    const parser2 = new Parser2(options2);
    return parser2.parseFragment(html2, fragmentContext);
  };
  lib$3.serialize = function(node2, options2) {
    const serializer2 = new Serializer(node2, options2);
    return serializer2.serialize();
  };
  return lib$3;
}
var lib$2 = {};
var hasRequiredLib$3;
function requireLib$3() {
  if (hasRequiredLib$3) return lib$2;
  hasRequiredLib$3 = 1;
  function _classCallCheck2(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties2(e, r2) {
    for (var t = 0; t < r2.length; t++) {
      var o = r2[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
    }
  }
  function _createClass2(e, r2, t) {
    return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  function _toPropertyKey2(t) {
    var i = _toPrimitive2(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive2(t, r2) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r2);
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }
  const doctype2 = requireDoctype();
  const {
    DOCUMENT_MODE
  } = requireHtml();
  const nodeTypes = {
    element: 1,
    text: 3,
    cdata: 4,
    comment: 8
  };
  const nodePropertyShorthands = {
    tagName: "name",
    childNodes: "children",
    parentNode: "parent",
    previousSibling: "prev",
    nextSibling: "next",
    nodeValue: "data"
  };
  let Node = /* @__PURE__ */ (function() {
    function Node2(props) {
      _classCallCheck2(this, Node2);
      for (const key of Object.keys(props)) {
        this[key] = props[key];
      }
    }
    return _createClass2(Node2, [{
      key: "firstChild",
      get: function() {
        const children2 = this.children;
        return children2 && children2[0] || null;
      }
    }, {
      key: "lastChild",
      get: function() {
        const children2 = this.children;
        return children2 && children2[children2.length - 1] || null;
      }
    }, {
      key: "nodeType",
      get: function() {
        return nodeTypes[this.type] || nodeTypes.element;
      }
    }]);
  })();
  Object.keys(nodePropertyShorthands).forEach((key) => {
    const shorthand = nodePropertyShorthands[key];
    Object.defineProperty(Node.prototype, key, {
      get: function() {
        return this[shorthand] || null;
      },
      set: function(val) {
        this[shorthand] = val;
        return val;
      }
    });
  });
  lib$2.createDocument = function() {
    return new Node({
      type: "root",
      name: "root",
      parent: null,
      prev: null,
      next: null,
      children: [],
      "x-mode": DOCUMENT_MODE.NO_QUIRKS
    });
  };
  lib$2.createDocumentFragment = function() {
    return new Node({
      type: "root",
      name: "root",
      parent: null,
      prev: null,
      next: null,
      children: []
    });
  };
  lib$2.createElement = function(tagName, namespaceURI, attrs) {
    const attribs = /* @__PURE__ */ Object.create(null);
    const attribsNamespace = /* @__PURE__ */ Object.create(null);
    const attribsPrefix = /* @__PURE__ */ Object.create(null);
    for (let i = 0; i < attrs.length; i++) {
      const attrName = attrs[i].name;
      attribs[attrName] = attrs[i].value;
      attribsNamespace[attrName] = attrs[i].namespace;
      attribsPrefix[attrName] = attrs[i].prefix;
    }
    return new Node({
      type: tagName === "script" || tagName === "style" ? tagName : "tag",
      name: tagName,
      namespace: namespaceURI,
      attribs,
      "x-attribsNamespace": attribsNamespace,
      "x-attribsPrefix": attribsPrefix,
      children: [],
      parent: null,
      prev: null,
      next: null
    });
  };
  lib$2.createCommentNode = function(data2) {
    return new Node({
      type: "comment",
      data: data2,
      parent: null,
      prev: null,
      next: null
    });
  };
  const createTextNode = function(value) {
    return new Node({
      type: "text",
      data: value,
      parent: null,
      prev: null,
      next: null
    });
  };
  const appendChild = lib$2.appendChild = function(parentNode, newNode) {
    const prev = parentNode.children[parentNode.children.length - 1];
    if (prev) {
      prev.next = newNode;
      newNode.prev = prev;
    }
    parentNode.children.push(newNode);
    newNode.parent = parentNode;
  };
  const insertBefore = lib$2.insertBefore = function(parentNode, newNode, referenceNode) {
    const insertionIdx = parentNode.children.indexOf(referenceNode);
    const prev = referenceNode.prev;
    if (prev) {
      prev.next = newNode;
      newNode.prev = prev;
    }
    referenceNode.prev = newNode;
    newNode.next = referenceNode;
    parentNode.children.splice(insertionIdx, 0, newNode);
    newNode.parent = parentNode;
  };
  lib$2.setTemplateContent = function(templateElement, contentElement) {
    appendChild(templateElement, contentElement);
  };
  lib$2.getTemplateContent = function(templateElement) {
    return templateElement.children[0];
  };
  lib$2.setDocumentType = function(document2, name, publicId, systemId) {
    const data2 = doctype2.serializeContent(name, publicId, systemId);
    let doctypeNode = null;
    for (let i = 0; i < document2.children.length; i++) {
      if (document2.children[i].type === "directive" && document2.children[i].name === "!doctype") {
        doctypeNode = document2.children[i];
        break;
      }
    }
    if (doctypeNode) {
      doctypeNode.data = data2;
      doctypeNode["x-name"] = name;
      doctypeNode["x-publicId"] = publicId;
      doctypeNode["x-systemId"] = systemId;
    } else {
      appendChild(document2, new Node({
        type: "directive",
        name: "!doctype",
        data: data2,
        "x-name": name,
        "x-publicId": publicId,
        "x-systemId": systemId
      }));
    }
  };
  lib$2.setDocumentMode = function(document2, mode) {
    document2["x-mode"] = mode;
  };
  lib$2.getDocumentMode = function(document2) {
    return document2["x-mode"];
  };
  lib$2.detachNode = function(node2) {
    if (node2.parent) {
      const idx = node2.parent.children.indexOf(node2);
      const prev = node2.prev;
      const next = node2.next;
      node2.prev = null;
      node2.next = null;
      if (prev) {
        prev.next = next;
      }
      if (next) {
        next.prev = prev;
      }
      node2.parent.children.splice(idx, 1);
      node2.parent = null;
    }
  };
  lib$2.insertText = function(parentNode, text2) {
    const lastChild = parentNode.children[parentNode.children.length - 1];
    if (lastChild && lastChild.type === "text") {
      lastChild.data += text2;
    } else {
      appendChild(parentNode, createTextNode(text2));
    }
  };
  lib$2.insertTextBefore = function(parentNode, text2, referenceNode) {
    const prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];
    if (prevNode && prevNode.type === "text") {
      prevNode.data += text2;
    } else {
      insertBefore(parentNode, createTextNode(text2), referenceNode);
    }
  };
  lib$2.adoptAttributes = function(recipient, attrs) {
    for (let i = 0; i < attrs.length; i++) {
      const attrName = attrs[i].name;
      if (typeof recipient.attribs[attrName] === "undefined") {
        recipient.attribs[attrName] = attrs[i].value;
        recipient["x-attribsNamespace"][attrName] = attrs[i].namespace;
        recipient["x-attribsPrefix"][attrName] = attrs[i].prefix;
      }
    }
  };
  lib$2.getFirstChild = function(node2) {
    return node2.children[0];
  };
  lib$2.getChildNodes = function(node2) {
    return node2.children;
  };
  lib$2.getParentNode = function(node2) {
    return node2.parent;
  };
  lib$2.getAttrList = function(element) {
    const attrList = [];
    for (const name in element.attribs) {
      attrList.push({
        name,
        value: element.attribs[name],
        namespace: element["x-attribsNamespace"][name],
        prefix: element["x-attribsPrefix"][name]
      });
    }
    return attrList;
  };
  lib$2.getTagName = function(element) {
    return element.name;
  };
  lib$2.getNamespaceURI = function(element) {
    return element.namespace;
  };
  lib$2.getTextNodeContent = function(textNode) {
    return textNode.data;
  };
  lib$2.getCommentNodeContent = function(commentNode) {
    return commentNode.data;
  };
  lib$2.getDocumentTypeNodeName = function(doctypeNode) {
    return doctypeNode["x-name"];
  };
  lib$2.getDocumentTypeNodePublicId = function(doctypeNode) {
    return doctypeNode["x-publicId"];
  };
  lib$2.getDocumentTypeNodeSystemId = function(doctypeNode) {
    return doctypeNode["x-systemId"];
  };
  lib$2.isTextNode = function(node2) {
    return node2.type === "text";
  };
  lib$2.isCommentNode = function(node2) {
    return node2.type === "comment";
  };
  lib$2.isDocumentTypeNode = function(node2) {
    return node2.type === "directive" && node2.name === "!doctype";
  };
  lib$2.isElementNode = function(node2) {
    return !!node2.attribs;
  };
  lib$2.setNodeSourceCodeLocation = function(node2, location) {
    node2.sourceCodeLocation = location;
  };
  lib$2.getNodeSourceCodeLocation = function(node2) {
    return node2.sourceCodeLocation;
  };
  lib$2.updateNodeSourceCodeLocation = function(node2, endLocation) {
    node2.sourceCodeLocation = Object.assign(node2.sourceCodeLocation, endLocation);
  };
  return lib$2;
}
var hasRequiredParse5Adapter;
function requireParse5Adapter() {
  if (hasRequiredParse5Adapter) return parse5Adapter;
  hasRequiredParse5Adapter = 1;
  Object.defineProperty(parse5Adapter, "__esModule", {
    value: true
  });
  parse5Adapter.render = parse5Adapter.parse = void 0;
  var tslib_1 = require$$0$4;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  var parse5_1 = requireLib$4();
  var parse5_htmlparser2_tree_adapter_1 = tslib_1.__importDefault(requireLib$3());
  function parse2(content, options2, isDocument2) {
    var opts = {
      scriptingEnabled: typeof options2.scriptingEnabled === "boolean" ? options2.scriptingEnabled : true,
      treeAdapter: parse5_htmlparser2_tree_adapter_1.default,
      sourceCodeLocationInfo: options2.sourceCodeLocationInfo
    };
    var context = options2.context;
    return isDocument2 ? parse5_1.parse(content, opts) : (
      // @ts-expect-error Same issue again.
      parse5_1.parseFragment(context, content, opts)
    );
  }
  parse5Adapter.parse = parse2;
  function render3(dom) {
    var _a;
    var nodes = "length" in dom ? dom : [dom];
    for (var index2 = 0; index2 < nodes.length; index2 += 1) {
      var node2 = nodes[index2];
      if (domhandler_1.isDocument(node2)) {
        (_a = Array.prototype.splice).call.apply(_a, tslib_1.__spreadArray([nodes, index2, 1], node2.children));
      }
    }
    return parse5_1.serialize({
      children: nodes
    }, {
      treeAdapter: parse5_htmlparser2_tree_adapter_1.default
    });
  }
  parse5Adapter.render = render3;
  return parse5Adapter;
}
var htmlparser2Adapter = {};
var hasRequiredHtmlparser2Adapter;
function requireHtmlparser2Adapter() {
  if (hasRequiredHtmlparser2Adapter) return htmlparser2Adapter;
  hasRequiredHtmlparser2Adapter = 1;
  (function(exports2) {
    var __importDefault2 = htmlparser2Adapter && htmlparser2Adapter.__importDefault || function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : {
        "default": mod2
      };
    };
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.render = exports2.parse = void 0;
    var htmlparser2_1 = /* @__PURE__ */ requireLib$5();
    Object.defineProperty(exports2, "parse", {
      enumerable: true,
      get: function() {
        return htmlparser2_1.parseDocument;
      }
    });
    var dom_serializer_1 = /* @__PURE__ */ requireLib$a();
    Object.defineProperty(exports2, "render", {
      enumerable: true,
      get: function() {
        return __importDefault2(dom_serializer_1).default;
      }
    });
  })(htmlparser2Adapter);
  return htmlparser2Adapter;
}
var hasRequired_static;
function require_static() {
  if (hasRequired_static) return _static;
  hasRequired_static = 1;
  Object.defineProperty(_static, "__esModule", {
    value: true
  });
  _static.merge = _static.contains = _static.root = _static.parseHTML = _static.text = _static.xml = _static.html = void 0;
  var tslib_1 = require$$0$4;
  var options_1 = tslib_1.__importStar(requireOptions());
  var cheerio_select_1 = /* @__PURE__ */ requireLib$6();
  var htmlparser2_1 = /* @__PURE__ */ requireLib$5();
  var parse5_adapter_1 = requireParse5Adapter();
  var htmlparser2_adapter_1 = requireHtmlparser2Adapter();
  function render3(that, dom, options2) {
    var _a;
    var toRender = dom ? typeof dom === "string" ? cheerio_select_1.select(dom, (_a = that === null || that === void 0 ? void 0 : that._root) !== null && _a !== void 0 ? _a : [], options2) : dom : that === null || that === void 0 ? void 0 : that._root.children;
    if (!toRender) return "";
    return options2.xmlMode || options2._useHtmlParser2 ? htmlparser2_adapter_1.render(toRender, options2) : parse5_adapter_1.render(toRender);
  }
  function isOptions(dom) {
    return typeof dom === "object" && dom != null && !("length" in dom) && !("type" in dom);
  }
  function html2(dom, options2) {
    if (!options2 && isOptions(dom)) {
      options2 = dom;
      dom = void 0;
    }
    var opts = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, options_1.default), this ? this._options : {}), options_1.flatten(options2 !== null && options2 !== void 0 ? options2 : {}));
    return render3(this || void 0, dom, opts);
  }
  _static.html = html2;
  function xml2(dom) {
    var options2 = tslib_1.__assign(tslib_1.__assign({}, this._options), {
      xmlMode: true
    });
    return render3(this, dom, options2);
  }
  _static.xml = xml2;
  function text2(elements) {
    var elems = elements ? elements : this ? this.root() : [];
    var ret = "";
    for (var i = 0; i < elems.length; i++) {
      var elem = elems[i];
      if (htmlparser2_1.DomUtils.isText(elem)) ret += elem.data;
      else if (htmlparser2_1.DomUtils.hasChildren(elem) && elem.type !== htmlparser2_1.ElementType.Comment && elem.type !== htmlparser2_1.ElementType.Script && elem.type !== htmlparser2_1.ElementType.Style) {
        ret += text2(elem.children);
      }
    }
    return ret;
  }
  _static.text = text2;
  function parseHTML(data2, context, keepScripts) {
    if (keepScripts === void 0) {
      keepScripts = typeof context === "boolean" ? context : false;
    }
    if (!data2 || typeof data2 !== "string") {
      return null;
    }
    if (typeof context === "boolean") {
      keepScripts = context;
    }
    var parsed = this.load(data2, options_1.default, false);
    if (!keepScripts) {
      parsed("script").remove();
    }
    return parsed.root()[0].children.slice();
  }
  _static.parseHTML = parseHTML;
  function root2() {
    return this(this._root);
  }
  _static.root = root2;
  function contains2(container, contained) {
    if (contained === container) {
      return false;
    }
    var next = contained;
    while (next && next !== next.parent) {
      next = next.parent;
      if (next === container) {
        return true;
      }
    }
    return false;
  }
  _static.contains = contains2;
  function merge2(arr1, arr2) {
    if (!isArrayLike2(arr1) || !isArrayLike2(arr2)) {
      return;
    }
    var newLength = arr1.length;
    var len = +arr2.length;
    for (var i = 0; i < len; i++) {
      arr1[newLength++] = arr2[i];
    }
    arr1.length = newLength;
    return arr1;
  }
  _static.merge = merge2;
  function isArrayLike2(item) {
    if (Array.isArray(item)) {
      return true;
    }
    if (typeof item !== "object" || !Object.prototype.hasOwnProperty.call(item, "length") || typeof item.length !== "number" || item.length < 0) {
      return false;
    }
    for (var i = 0; i < item.length; i++) {
      if (!(i in item)) {
        return false;
      }
    }
    return true;
  }
  return _static;
}
var cheerio = {};
var parse = {};
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse;
  hasRequiredParse = 1;
  Object.defineProperty(parse, "__esModule", {
    value: true
  });
  parse.update = void 0;
  var htmlparser2_1 = /* @__PURE__ */ requireLib$5();
  var htmlparser2_adapter_1 = requireHtmlparser2Adapter();
  var parse5_adapter_1 = requireParse5Adapter();
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  function parse$12(content, options2, isDocument2) {
    if (typeof Buffer !== "undefined" && Buffer.isBuffer(content)) {
      content = content.toString();
    }
    if (typeof content === "string") {
      return options2.xmlMode || options2._useHtmlParser2 ? htmlparser2_adapter_1.parse(content, options2) : parse5_adapter_1.parse(content, options2, isDocument2);
    }
    var doc = content;
    if (!Array.isArray(doc) && domhandler_1.isDocument(doc)) {
      return doc;
    }
    var root2 = new domhandler_1.Document([]);
    update(doc, root2);
    return root2;
  }
  parse.default = parse$12;
  function update(newChilds, parent) {
    var arr = Array.isArray(newChilds) ? newChilds : [newChilds];
    if (parent) {
      parent.children = arr;
    } else {
      parent = null;
    }
    for (var i = 0; i < arr.length; i++) {
      var node2 = arr[i];
      if (node2.parent && node2.parent.children !== arr) {
        htmlparser2_1.DomUtils.removeElement(node2);
      }
      if (parent) {
        node2.prev = arr[i - 1] || null;
        node2.next = arr[i + 1] || null;
      } else {
        node2.prev = node2.next = null;
      }
      node2.parent = parent;
    }
    return parent;
  }
  parse.update = update;
  return parse;
}
var utils$1 = {};
var hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$1;
  hasRequiredUtils$1 = 1;
  Object.defineProperty(utils$1, "__esModule", {
    value: true
  });
  utils$1.isHtml = utils$1.cloneDom = utils$1.domEach = utils$1.cssCase = utils$1.camelCase = utils$1.isCheerio = utils$1.isTag = void 0;
  var htmlparser2_1 = /* @__PURE__ */ requireLib$5();
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  utils$1.isTag = htmlparser2_1.DomUtils.isTag;
  function isCheerio(maybeCheerio) {
    return maybeCheerio.cheerio != null;
  }
  utils$1.isCheerio = isCheerio;
  function camelCase(str) {
    return str.replace(/[_.-](\w|$)/g, function(_, x) {
      return x.toUpperCase();
    });
  }
  utils$1.camelCase = camelCase;
  function cssCase(str) {
    return str.replace(/[A-Z]/g, "-$&").toLowerCase();
  }
  utils$1.cssCase = cssCase;
  function domEach(array2, fn) {
    var len = array2.length;
    for (var i = 0; i < len; i++) fn(array2[i], i);
    return array2;
  }
  utils$1.domEach = domEach;
  function cloneDom(dom) {
    var clone2 = "length" in dom ? Array.prototype.map.call(dom, function(el2) {
      return domhandler_1.cloneNode(el2, true);
    }) : [domhandler_1.cloneNode(dom, true)];
    var root2 = new domhandler_1.Document(clone2);
    clone2.forEach(function(node2) {
      node2.parent = root2;
    });
    return clone2;
  }
  utils$1.cloneDom = cloneDom;
  var quickExpr = /<[a-zA-Z][^]*>/;
  function isHtml(str) {
    return quickExpr.test(str);
  }
  utils$1.isHtml = isHtml;
  return utils$1;
}
var attributes = {};
var hasRequiredAttributes;
function requireAttributes() {
  if (hasRequiredAttributes) return attributes;
  hasRequiredAttributes = 1;
  Object.defineProperty(attributes, "__esModule", {
    value: true
  });
  attributes.toggleClass = attributes.removeClass = attributes.addClass = attributes.hasClass = attributes.removeAttr = attributes.val = attributes.data = attributes.prop = attributes.attr = void 0;
  var static_1 = require_static();
  var utils_1 = requireUtils$1();
  var hasOwn = Object.prototype.hasOwnProperty;
  var rspace = /\s+/;
  var dataAttrPrefix = "data-";
  var primitives = {
    null: null,
    true: true,
    false: false
  };
  var rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i;
  var rbrace2 = /^{[^]*}$|^\[[^]*]$/;
  function getAttr(elem, name, xmlMode) {
    var _a;
    if (!elem || !utils_1.isTag(elem)) return void 0;
    (_a = elem.attribs) !== null && _a !== void 0 ? _a : elem.attribs = {};
    if (!name) {
      return elem.attribs;
    }
    if (hasOwn.call(elem.attribs, name)) {
      return !xmlMode && rboolean.test(name) ? name : elem.attribs[name];
    }
    if (elem.name === "option" && name === "value") {
      return static_1.text(elem.children);
    }
    if (elem.name === "input" && (elem.attribs.type === "radio" || elem.attribs.type === "checkbox") && name === "value") {
      return "on";
    }
    return void 0;
  }
  function setAttr(el2, name, value) {
    if (value === null) {
      removeAttribute(el2, name);
    } else {
      el2.attribs[name] = "" + value;
    }
  }
  function attr(name, value) {
    if (typeof name === "object" || value !== void 0) {
      if (typeof value === "function") {
        if (typeof name !== "string") {
          {
            throw new Error("Bad combination of arguments.");
          }
        }
        return utils_1.domEach(this, function(el2, i) {
          if (utils_1.isTag(el2)) setAttr(el2, name, value.call(el2, i, el2.attribs[name]));
        });
      }
      return utils_1.domEach(this, function(el2) {
        if (!utils_1.isTag(el2)) return;
        if (typeof name === "object") {
          Object.keys(name).forEach(function(objName) {
            var objValue = name[objName];
            setAttr(el2, objName, objValue);
          });
        } else {
          setAttr(el2, name, value);
        }
      });
    }
    return arguments.length > 1 ? this : getAttr(this[0], name, this.options.xmlMode);
  }
  attributes.attr = attr;
  function getProp(el2, name, xmlMode) {
    if (!el2 || !utils_1.isTag(el2)) return;
    return name in el2 ? (
      // @ts-expect-error TS doesn't like us accessing the value directly here.
      el2[name]
    ) : !xmlMode && rboolean.test(name) ? getAttr(el2, name, false) !== void 0 : getAttr(el2, name, xmlMode);
  }
  function setProp(el2, name, value, xmlMode) {
    if (name in el2) {
      el2[name] = value;
    } else {
      setAttr(el2, name, !xmlMode && rboolean.test(name) ? value ? "" : null : "" + value);
    }
  }
  function prop2(name, value) {
    var _this = this;
    if (typeof name === "string" && value === void 0) {
      switch (name) {
        case "style": {
          var property_1 = this.css();
          var keys2 = Object.keys(property_1);
          keys2.forEach(function(p, i) {
            property_1[i] = p;
          });
          property_1.length = keys2.length;
          return property_1;
        }
        case "tagName":
        case "nodeName": {
          var el2 = this[0];
          return utils_1.isTag(el2) ? el2.name.toUpperCase() : void 0;
        }
        case "outerHTML":
          return this.clone().wrap("<container />").parent().html();
        case "innerHTML":
          return this.html();
        default:
          return getProp(this[0], name, this.options.xmlMode);
      }
    }
    if (typeof name === "object" || value !== void 0) {
      if (typeof value === "function") {
        if (typeof name === "object") {
          throw new Error("Bad combination of arguments.");
        }
        return utils_1.domEach(this, function(el3, i) {
          if (utils_1.isTag(el3)) setProp(el3, name, value.call(el3, i, getProp(el3, name, _this.options.xmlMode)), _this.options.xmlMode);
        });
      }
      return utils_1.domEach(this, function(el3) {
        if (!utils_1.isTag(el3)) return;
        if (typeof name === "object") {
          Object.keys(name).forEach(function(key) {
            var val2 = name[key];
            setProp(el3, key, val2, _this.options.xmlMode);
          });
        } else {
          setProp(el3, name, value, _this.options.xmlMode);
        }
      });
    }
    return void 0;
  }
  attributes.prop = prop2;
  function setData(el2, name, value) {
    var _a;
    var elem = el2;
    (_a = elem.data) !== null && _a !== void 0 ? _a : elem.data = {};
    if (typeof name === "object") Object.assign(elem.data, name);
    else if (typeof name === "string" && value !== void 0) {
      elem.data[name] = value;
    }
  }
  function readData(el2, name) {
    var domNames;
    var jsNames;
    var value;
    if (name == null) {
      domNames = Object.keys(el2.attribs).filter(function(attrName) {
        return attrName.startsWith(dataAttrPrefix);
      });
      jsNames = domNames.map(function(domName2) {
        return utils_1.camelCase(domName2.slice(dataAttrPrefix.length));
      });
    } else {
      domNames = [dataAttrPrefix + utils_1.cssCase(name)];
      jsNames = [name];
    }
    for (var idx = 0; idx < domNames.length; ++idx) {
      var domName = domNames[idx];
      var jsName = jsNames[idx];
      if (hasOwn.call(el2.attribs, domName) && !hasOwn.call(el2.data, jsName)) {
        value = el2.attribs[domName];
        if (hasOwn.call(primitives, value)) {
          value = primitives[value];
        } else if (value === String(Number(value))) {
          value = Number(value);
        } else if (rbrace2.test(value)) {
          try {
            value = JSON.parse(value);
          } catch (e) {
          }
        }
        el2.data[jsName] = value;
      }
    }
    return name == null ? el2.data : value;
  }
  function data2(name, value) {
    var _a;
    var elem = this[0];
    if (!elem || !utils_1.isTag(elem)) return;
    var dataEl = elem;
    (_a = dataEl.data) !== null && _a !== void 0 ? _a : dataEl.data = {};
    if (!name) {
      return readData(dataEl);
    }
    if (typeof name === "object" || value !== void 0) {
      utils_1.domEach(this, function(el2) {
        if (utils_1.isTag(el2)) if (typeof name === "object") setData(el2, name);
        else setData(el2, name, value);
      });
      return this;
    }
    if (hasOwn.call(dataEl.data, name)) {
      return dataEl.data[name];
    }
    return readData(dataEl, name);
  }
  attributes.data = data2;
  function val(value) {
    var querying2 = arguments.length === 0;
    var element = this[0];
    if (!element || !utils_1.isTag(element)) return querying2 ? void 0 : this;
    switch (element.name) {
      case "textarea":
        return this.text(value);
      case "select": {
        var option = this.find("option:selected");
        if (!querying2) {
          if (this.attr("multiple") == null && typeof value === "object") {
            return this;
          }
          this.find("option").removeAttr("selected");
          var values = typeof value !== "object" ? [value] : value;
          for (var i = 0; i < values.length; i++) {
            this.find('option[value="' + values[i] + '"]').attr("selected", "");
          }
          return this;
        }
        return this.attr("multiple") ? option.toArray().map(function(el2) {
          return static_1.text(el2.children);
        }) : option.attr("value");
      }
      case "input":
      case "option":
        return querying2 ? this.attr("value") : this.attr("value", value);
    }
    return void 0;
  }
  attributes.val = val;
  function removeAttribute(elem, name) {
    if (!elem.attribs || !hasOwn.call(elem.attribs, name)) return;
    delete elem.attribs[name];
  }
  function splitNames(names2) {
    return names2 ? names2.trim().split(rspace) : [];
  }
  function removeAttr(name) {
    var attrNames = splitNames(name);
    var _loop_1 = function(i2) {
      utils_1.domEach(this_1, function(elem) {
        if (utils_1.isTag(elem)) removeAttribute(elem, attrNames[i2]);
      });
    };
    var this_1 = this;
    for (var i = 0; i < attrNames.length; i++) {
      _loop_1(i);
    }
    return this;
  }
  attributes.removeAttr = removeAttr;
  function hasClass2(className) {
    return this.toArray().some(function(elem) {
      var clazz = utils_1.isTag(elem) && elem.attribs.class;
      var idx = -1;
      if (clazz && className.length) {
        while ((idx = clazz.indexOf(className, idx + 1)) > -1) {
          var end2 = idx + className.length;
          if ((idx === 0 || rspace.test(clazz[idx - 1])) && (end2 === clazz.length || rspace.test(clazz[end2]))) {
            return true;
          }
        }
      }
      return false;
    });
  }
  attributes.hasClass = hasClass2;
  function addClass2(value) {
    if (typeof value === "function") {
      return utils_1.domEach(this, function(el3, i2) {
        if (utils_1.isTag(el3)) {
          var className2 = el3.attribs.class || "";
          addClass2.call([el3], value.call(el3, i2, className2));
        }
      });
    }
    if (!value || typeof value !== "string") return this;
    var classNames = value.split(rspace);
    var numElements = this.length;
    for (var i = 0; i < numElements; i++) {
      var el2 = this[i];
      if (!utils_1.isTag(el2)) continue;
      var className = getAttr(el2, "class", false);
      if (!className) {
        setAttr(el2, "class", classNames.join(" ").trim());
      } else {
        var setClass = " " + className + " ";
        for (var j = 0; j < classNames.length; j++) {
          var appendClass = classNames[j] + " ";
          if (!setClass.includes(" " + appendClass)) setClass += appendClass;
        }
        setAttr(el2, "class", setClass.trim());
      }
    }
    return this;
  }
  attributes.addClass = addClass2;
  function removeClass2(name) {
    if (typeof name === "function") {
      return utils_1.domEach(this, function(el2, i) {
        if (utils_1.isTag(el2)) removeClass2.call([el2], name.call(el2, i, el2.attribs.class || ""));
      });
    }
    var classes2 = splitNames(name);
    var numClasses = classes2.length;
    var removeAll2 = arguments.length === 0;
    return utils_1.domEach(this, function(el2) {
      if (!utils_1.isTag(el2)) return;
      if (removeAll2) {
        el2.attribs.class = "";
      } else {
        var elClasses = splitNames(el2.attribs.class);
        var changed = false;
        for (var j = 0; j < numClasses; j++) {
          var index2 = elClasses.indexOf(classes2[j]);
          if (index2 >= 0) {
            elClasses.splice(index2, 1);
            changed = true;
            j--;
          }
        }
        if (changed) {
          el2.attribs.class = elClasses.join(" ");
        }
      }
    });
  }
  attributes.removeClass = removeClass2;
  function toggleClass(value, stateVal) {
    if (typeof value === "function") {
      return utils_1.domEach(this, function(el3, i2) {
        if (utils_1.isTag(el3)) {
          toggleClass.call([el3], value.call(el3, i2, el3.attribs.class || "", stateVal), stateVal);
        }
      });
    }
    if (!value || typeof value !== "string") return this;
    var classNames = value.split(rspace);
    var numClasses = classNames.length;
    var state = typeof stateVal === "boolean" ? stateVal ? 1 : -1 : 0;
    var numElements = this.length;
    for (var i = 0; i < numElements; i++) {
      var el2 = this[i];
      if (!utils_1.isTag(el2)) continue;
      var elementClasses = splitNames(el2.attribs.class);
      for (var j = 0; j < numClasses; j++) {
        var index2 = elementClasses.indexOf(classNames[j]);
        if (state >= 0 && index2 < 0) {
          elementClasses.push(classNames[j]);
        } else if (state <= 0 && index2 >= 0) {
          elementClasses.splice(index2, 1);
        }
      }
      el2.attribs.class = elementClasses.join(" ");
    }
    return this;
  }
  attributes.toggleClass = toggleClass;
  return attributes;
}
var traversing = {};
var hasRequiredTraversing;
function requireTraversing() {
  if (hasRequiredTraversing) return traversing;
  hasRequiredTraversing = 1;
  Object.defineProperty(traversing, "__esModule", {
    value: true
  });
  traversing.addBack = traversing.add = traversing.end = traversing.slice = traversing.index = traversing.toArray = traversing.get = traversing.eq = traversing.last = traversing.first = traversing.has = traversing.not = traversing.is = traversing.filterArray = traversing.filter = traversing.map = traversing.each = traversing.contents = traversing.children = traversing.siblings = traversing.prevUntil = traversing.prevAll = traversing.prev = traversing.nextUntil = traversing.nextAll = traversing.next = traversing.closest = traversing.parentsUntil = traversing.parents = traversing.parent = traversing.find = void 0;
  var tslib_1 = require$$0$4;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  var select2 = tslib_1.__importStar(/* @__PURE__ */ requireLib$6());
  var utils_1 = requireUtils$1();
  var static_1 = require_static();
  var htmlparser2_1 = /* @__PURE__ */ requireLib$5();
  var uniqueSort = htmlparser2_1.DomUtils.uniqueSort;
  var reSiblingSelector = /^\s*[~+]/;
  function find2(selectorOrHaystack) {
    var _a;
    if (!selectorOrHaystack) {
      return this._make([]);
    }
    var context = this.toArray();
    if (typeof selectorOrHaystack !== "string") {
      var haystack = utils_1.isCheerio(selectorOrHaystack) ? selectorOrHaystack.toArray() : [selectorOrHaystack];
      return this._make(haystack.filter(function(elem) {
        return context.some(function(node2) {
          return static_1.contains(node2, elem);
        });
      }));
    }
    var elems = reSiblingSelector.test(selectorOrHaystack) ? context : this.children().toArray();
    var options2 = {
      context,
      root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0],
      xmlMode: this.options.xmlMode
    };
    return this._make(select2.select(selectorOrHaystack, elems, options2));
  }
  traversing.find = find2;
  function _getMatcher(matchMap) {
    return function(fn) {
      var postFns = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        postFns[_i - 1] = arguments[_i];
      }
      return function(selector2) {
        var _a;
        var matched = matchMap(fn, this);
        if (selector2) {
          matched = filterArray(matched, selector2, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]);
        }
        return this._make(
          // Post processing is only necessary if there is more than one element.
          this.length > 1 && matched.length > 1 ? postFns.reduce(function(elems, fn2) {
            return fn2(elems);
          }, matched) : matched
        );
      };
    };
  }
  var _matcher = _getMatcher(function(fn, elems) {
    var _a;
    var ret = [];
    for (var i = 0; i < elems.length; i++) {
      var value = fn(elems[i]);
      ret.push(value);
    }
    return (_a = new Array()).concat.apply(_a, ret);
  });
  var _singleMatcher = _getMatcher(function(fn, elems) {
    var ret = [];
    for (var i = 0; i < elems.length; i++) {
      var value = fn(elems[i]);
      if (value !== null) {
        ret.push(value);
      }
    }
    return ret;
  });
  function _matchUntil(nextElem) {
    var postFns = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      postFns[_i - 1] = arguments[_i];
    }
    var matches = null;
    var innerMatcher = _getMatcher(function(nextElem2, elems) {
      var matched = [];
      utils_1.domEach(elems, function(elem) {
        for (var next_1; next_1 = nextElem2(elem); elem = next_1) {
          if (matches === null || matches === void 0 ? void 0 : matches(next_1, matched.length)) break;
          matched.push(next_1);
        }
      });
      return matched;
    }).apply(void 0, tslib_1.__spreadArray([nextElem], postFns));
    return function(selector2, filterSelector) {
      var _this = this;
      matches = typeof selector2 === "string" ? function(elem) {
        return select2.is(elem, selector2, _this.options);
      } : selector2 ? getFilterFn(selector2) : null;
      var ret = innerMatcher.call(this, filterSelector);
      matches = null;
      return ret;
    };
  }
  function _removeDuplicates(elems) {
    return Array.from(new Set(elems));
  }
  traversing.parent = _singleMatcher(function(_a) {
    var parent = _a.parent;
    return parent && !domhandler_1.isDocument(parent) ? parent : null;
  }, _removeDuplicates);
  traversing.parents = _matcher(function(elem) {
    var matched = [];
    while (elem.parent && !domhandler_1.isDocument(elem.parent)) {
      matched.push(elem.parent);
      elem = elem.parent;
    }
    return matched;
  }, uniqueSort, function(elems) {
    return elems.reverse();
  });
  traversing.parentsUntil = _matchUntil(function(_a) {
    var parent = _a.parent;
    return parent && !domhandler_1.isDocument(parent) ? parent : null;
  }, uniqueSort, function(elems) {
    return elems.reverse();
  });
  function closest(selector2) {
    var _this = this;
    var set2 = [];
    if (!selector2) {
      return this._make(set2);
    }
    utils_1.domEach(this, function(elem) {
      var _a;
      while (elem && elem.type !== "root") {
        if (!selector2 || filterArray([elem], selector2, _this.options.xmlMode, (_a = _this._root) === null || _a === void 0 ? void 0 : _a[0]).length) {
          if (elem && !set2.includes(elem)) {
            set2.push(elem);
          }
          break;
        }
        elem = elem.parent;
      }
    });
    return this._make(set2);
  }
  traversing.closest = closest;
  traversing.next = _singleMatcher(function(elem) {
    return htmlparser2_1.DomUtils.nextElementSibling(elem);
  });
  traversing.nextAll = _matcher(function(elem) {
    var matched = [];
    while (elem.next) {
      elem = elem.next;
      if (utils_1.isTag(elem)) matched.push(elem);
    }
    return matched;
  }, _removeDuplicates);
  traversing.nextUntil = _matchUntil(function(el2) {
    return htmlparser2_1.DomUtils.nextElementSibling(el2);
  }, _removeDuplicates);
  traversing.prev = _singleMatcher(function(elem) {
    return htmlparser2_1.DomUtils.prevElementSibling(elem);
  });
  traversing.prevAll = _matcher(function(elem) {
    var matched = [];
    while (elem.prev) {
      elem = elem.prev;
      if (utils_1.isTag(elem)) matched.push(elem);
    }
    return matched;
  }, _removeDuplicates);
  traversing.prevUntil = _matchUntil(function(el2) {
    return htmlparser2_1.DomUtils.prevElementSibling(el2);
  }, _removeDuplicates);
  traversing.siblings = _matcher(function(elem) {
    return htmlparser2_1.DomUtils.getSiblings(elem).filter(function(el2) {
      return utils_1.isTag(el2) && el2 !== elem;
    });
  }, uniqueSort);
  traversing.children = _matcher(function(elem) {
    return htmlparser2_1.DomUtils.getChildren(elem).filter(utils_1.isTag);
  }, _removeDuplicates);
  function contents() {
    var elems = this.toArray().reduce(function(newElems, elem) {
      return domhandler_1.hasChildren(elem) ? newElems.concat(elem.children) : newElems;
    }, []);
    return this._make(elems);
  }
  traversing.contents = contents;
  function each(fn) {
    var i = 0;
    var len = this.length;
    while (i < len && fn.call(this[i], i, this[i]) !== false) ++i;
    return this;
  }
  traversing.each = each;
  function map2(fn) {
    var elems = [];
    for (var i = 0; i < this.length; i++) {
      var el2 = this[i];
      var val = fn.call(el2, i, el2);
      if (val != null) {
        elems = elems.concat(val);
      }
    }
    return this._make(elems);
  }
  traversing.map = map2;
  function getFilterFn(match) {
    if (typeof match === "function") {
      return function(el2, i) {
        return match.call(el2, i, el2);
      };
    }
    if (utils_1.isCheerio(match)) {
      return function(el2) {
        return Array.prototype.includes.call(match, el2);
      };
    }
    return function(el2) {
      return match === el2;
    };
  }
  function filter2(match) {
    var _a;
    return this._make(filterArray(this.toArray(), match, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]));
  }
  traversing.filter = filter2;
  function filterArray(nodes, match, xmlMode, root2) {
    return typeof match === "string" ? select2.filter(match, nodes, {
      xmlMode,
      root: root2
    }) : nodes.filter(getFilterFn(match));
  }
  traversing.filterArray = filterArray;
  function is(selector2) {
    var nodes = this.toArray();
    return typeof selector2 === "string" ? select2.some(nodes.filter(utils_1.isTag), selector2, this.options) : selector2 ? nodes.some(getFilterFn(selector2)) : false;
  }
  traversing.is = is;
  function not2(match) {
    var nodes = this.toArray();
    if (typeof match === "string") {
      var matches_1 = new Set(select2.filter(match, nodes, this.options));
      nodes = nodes.filter(function(el2) {
        return !matches_1.has(el2);
      });
    } else {
      var filterFn_1 = getFilterFn(match);
      nodes = nodes.filter(function(el2, i) {
        return !filterFn_1(el2, i);
      });
    }
    return this._make(nodes);
  }
  traversing.not = not2;
  function has(selectorOrHaystack) {
    var _this = this;
    return this.filter(typeof selectorOrHaystack === "string" ? (
      // Using the `:has` selector here short-circuits searches.
      ":has(" + selectorOrHaystack + ")"
    ) : function(_, el2) {
      return _this._make(el2).find(selectorOrHaystack).length > 0;
    });
  }
  traversing.has = has;
  function first() {
    return this.length > 1 ? this._make(this[0]) : this;
  }
  traversing.first = first;
  function last() {
    return this.length > 0 ? this._make(this[this.length - 1]) : this;
  }
  traversing.last = last;
  function eq2(i) {
    var _a;
    i = +i;
    if (i === 0 && this.length <= 1) return this;
    if (i < 0) i = this.length + i;
    return this._make((_a = this[i]) !== null && _a !== void 0 ? _a : []);
  }
  traversing.eq = eq2;
  function get3(i) {
    if (i == null) {
      return this.toArray();
    }
    return this[i < 0 ? this.length + i : i];
  }
  traversing.get = get3;
  function toArray() {
    return Array.prototype.slice.call(this);
  }
  traversing.toArray = toArray;
  function index2(selectorOrNeedle) {
    var $haystack;
    var needle;
    if (selectorOrNeedle == null) {
      $haystack = this.parent().children();
      needle = this[0];
    } else if (typeof selectorOrNeedle === "string") {
      $haystack = this._make(selectorOrNeedle);
      needle = this[0];
    } else {
      $haystack = this;
      needle = utils_1.isCheerio(selectorOrNeedle) ? selectorOrNeedle[0] : selectorOrNeedle;
    }
    return Array.prototype.indexOf.call($haystack, needle);
  }
  traversing.index = index2;
  function slice2(start2, end3) {
    return this._make(Array.prototype.slice.call(this, start2, end3));
  }
  traversing.slice = slice2;
  function end2() {
    var _a;
    return (_a = this.prevObject) !== null && _a !== void 0 ? _a : this._make([]);
  }
  traversing.end = end2;
  function add2(other, context) {
    var selection2 = this._make(other, context);
    var contents2 = uniqueSort(tslib_1.__spreadArray(tslib_1.__spreadArray([], this.get()), selection2.get()));
    return this._make(contents2);
  }
  traversing.add = add2;
  function addBack(selector2) {
    return this.prevObject ? this.add(selector2 ? this.prevObject.filter(selector2) : this.prevObject) : this;
  }
  traversing.addBack = addBack;
  return traversing;
}
var manipulation = {};
var hasRequiredManipulation;
function requireManipulation() {
  if (hasRequiredManipulation) return manipulation;
  hasRequiredManipulation = 1;
  Object.defineProperty(manipulation, "__esModule", {
    value: true
  });
  manipulation.clone = manipulation.text = manipulation.toString = manipulation.html = manipulation.empty = manipulation.replaceWith = manipulation.remove = manipulation.insertBefore = manipulation.before = manipulation.insertAfter = manipulation.after = manipulation.wrapAll = manipulation.unwrap = manipulation.wrapInner = manipulation.wrap = manipulation.prepend = manipulation.append = manipulation.prependTo = manipulation.appendTo = manipulation._makeDomArray = void 0;
  var tslib_1 = require$$0$4;
  var domhandler_1 = /* @__PURE__ */ requireLib$c();
  var domhandler_2 = /* @__PURE__ */ requireLib$c();
  var parse_1 = tslib_1.__importStar(requireParse());
  var static_1 = require_static();
  var utils_1 = requireUtils$1();
  var htmlparser2_1 = /* @__PURE__ */ requireLib$5();
  function _makeDomArray(elem, clone3) {
    var _this = this;
    if (elem == null) {
      return [];
    }
    if (utils_1.isCheerio(elem)) {
      return clone3 ? utils_1.cloneDom(elem.get()) : elem.get();
    }
    if (Array.isArray(elem)) {
      return elem.reduce(function(newElems, el2) {
        return newElems.concat(_this._makeDomArray(el2, clone3));
      }, []);
    }
    if (typeof elem === "string") {
      return parse_1.default(elem, this.options, false).children;
    }
    return clone3 ? utils_1.cloneDom([elem]) : [elem];
  }
  manipulation._makeDomArray = _makeDomArray;
  function _insert(concatenator) {
    return function() {
      var _this = this;
      var elems = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        elems[_i] = arguments[_i];
      }
      var lastIdx = this.length - 1;
      return utils_1.domEach(this, function(el2, i) {
        if (!domhandler_1.hasChildren(el2)) return;
        var domSrc = typeof elems[0] === "function" ? elems[0].call(el2, i, static_1.html(el2.children)) : elems;
        var dom = _this._makeDomArray(domSrc, i < lastIdx);
        concatenator(dom, el2.children, el2);
      });
    };
  }
  function uniqueSplice(array2, spliceIdx, spliceCount, newElems, parent) {
    var _a, _b;
    var spliceArgs = tslib_1.__spreadArray([spliceIdx, spliceCount], newElems);
    var prev = array2[spliceIdx - 1] || null;
    var next = array2[spliceIdx + spliceCount] || null;
    for (var idx = 0; idx < newElems.length; ++idx) {
      var node2 = newElems[idx];
      var oldParent = node2.parent;
      if (oldParent) {
        var prevIdx = oldParent.children.indexOf(newElems[idx]);
        if (prevIdx > -1) {
          oldParent.children.splice(prevIdx, 1);
          if (parent === oldParent && spliceIdx > prevIdx) {
            spliceArgs[0]--;
          }
        }
      }
      node2.parent = parent;
      if (node2.prev) {
        node2.prev.next = (_a = node2.next) !== null && _a !== void 0 ? _a : null;
      }
      if (node2.next) {
        node2.next.prev = (_b = node2.prev) !== null && _b !== void 0 ? _b : null;
      }
      node2.prev = newElems[idx - 1] || prev;
      node2.next = newElems[idx + 1] || next;
    }
    if (prev) {
      prev.next = newElems[0];
    }
    if (next) {
      next.prev = newElems[newElems.length - 1];
    }
    return array2.splice.apply(array2, spliceArgs);
  }
  function appendTo(target2) {
    var appendTarget = utils_1.isCheerio(target2) ? target2 : this._make(target2);
    appendTarget.append(this);
    return this;
  }
  manipulation.appendTo = appendTo;
  function prependTo(target2) {
    var prependTarget = utils_1.isCheerio(target2) ? target2 : this._make(target2);
    prependTarget.prepend(this);
    return this;
  }
  manipulation.prependTo = prependTo;
  manipulation.append = _insert(function(dom, children2, parent) {
    uniqueSplice(children2, children2.length, 0, dom, parent);
  });
  manipulation.prepend = _insert(function(dom, children2, parent) {
    uniqueSplice(children2, 0, 0, dom, parent);
  });
  function _wrap(insert) {
    return function(wrapper) {
      var lastIdx = this.length - 1;
      var lastParent = this.parents().last();
      for (var i = 0; i < this.length; i++) {
        var el2 = this[i];
        var wrap_1 = typeof wrapper === "function" ? wrapper.call(el2, i, el2) : typeof wrapper === "string" && !utils_1.isHtml(wrapper) ? lastParent.find(wrapper).clone() : wrapper;
        var wrapperDom = this._makeDomArray(wrap_1, i < lastIdx)[0];
        if (!wrapperDom || !htmlparser2_1.DomUtils.hasChildren(wrapperDom)) continue;
        var elInsertLocation = wrapperDom;
        var j = 0;
        while (j < elInsertLocation.children.length) {
          var child = elInsertLocation.children[j];
          if (utils_1.isTag(child)) {
            elInsertLocation = child;
            j = 0;
          } else {
            j++;
          }
        }
        insert(el2, elInsertLocation, [wrapperDom]);
      }
      return this;
    };
  }
  manipulation.wrap = _wrap(function(el2, elInsertLocation, wrapperDom) {
    var parent = el2.parent;
    if (!parent) return;
    var siblings = parent.children;
    var index2 = siblings.indexOf(el2);
    parse_1.update([el2], elInsertLocation);
    uniqueSplice(siblings, index2, 0, wrapperDom, parent);
  });
  manipulation.wrapInner = _wrap(function(el2, elInsertLocation, wrapperDom) {
    if (!domhandler_1.hasChildren(el2)) return;
    parse_1.update(el2.children, elInsertLocation);
    parse_1.update(wrapperDom, el2);
  });
  function unwrap2(selector2) {
    var _this = this;
    this.parent(selector2).not("body").each(function(_, el2) {
      _this._make(el2).replaceWith(el2.children);
    });
    return this;
  }
  manipulation.unwrap = unwrap2;
  function wrapAll(wrapper) {
    var el2 = this[0];
    if (el2) {
      var wrap_2 = this._make(typeof wrapper === "function" ? wrapper.call(el2, 0, el2) : wrapper).insertBefore(el2);
      var elInsertLocation = void 0;
      for (var i = 0; i < wrap_2.length; i++) {
        if (wrap_2[i].type === "tag") elInsertLocation = wrap_2[i];
      }
      var j = 0;
      while (elInsertLocation && j < elInsertLocation.children.length) {
        var child = elInsertLocation.children[j];
        if (child.type === "tag") {
          elInsertLocation = child;
          j = 0;
        } else {
          j++;
        }
      }
      if (elInsertLocation) this._make(elInsertLocation).append(this);
    }
    return this;
  }
  manipulation.wrapAll = wrapAll;
  function after() {
    var _this = this;
    var elems = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      elems[_i] = arguments[_i];
    }
    var lastIdx = this.length - 1;
    return utils_1.domEach(this, function(el2, i) {
      var parent = el2.parent;
      if (!htmlparser2_1.DomUtils.hasChildren(el2) || !parent) {
        return;
      }
      var siblings = parent.children;
      var index2 = siblings.indexOf(el2);
      if (index2 < 0) return;
      var domSrc = typeof elems[0] === "function" ? elems[0].call(el2, i, static_1.html(el2.children)) : elems;
      var dom = _this._makeDomArray(domSrc, i < lastIdx);
      uniqueSplice(siblings, index2 + 1, 0, dom, parent);
    });
  }
  manipulation.after = after;
  function insertAfter(target2) {
    var _this = this;
    if (typeof target2 === "string") {
      target2 = this._make(target2);
    }
    this.remove();
    var clones = [];
    this._makeDomArray(target2).forEach(function(el2) {
      var clonedSelf = _this.clone().toArray();
      var parent = el2.parent;
      if (!parent) {
        return;
      }
      var siblings = parent.children;
      var index2 = siblings.indexOf(el2);
      if (index2 < 0) return;
      uniqueSplice(siblings, index2 + 1, 0, clonedSelf, parent);
      clones.push.apply(clones, clonedSelf);
    });
    return this._make(clones);
  }
  manipulation.insertAfter = insertAfter;
  function before() {
    var _this = this;
    var elems = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      elems[_i] = arguments[_i];
    }
    var lastIdx = this.length - 1;
    return utils_1.domEach(this, function(el2, i) {
      var parent = el2.parent;
      if (!htmlparser2_1.DomUtils.hasChildren(el2) || !parent) {
        return;
      }
      var siblings = parent.children;
      var index2 = siblings.indexOf(el2);
      if (index2 < 0) return;
      var domSrc = typeof elems[0] === "function" ? elems[0].call(el2, i, static_1.html(el2.children)) : elems;
      var dom = _this._makeDomArray(domSrc, i < lastIdx);
      uniqueSplice(siblings, index2, 0, dom, parent);
    });
  }
  manipulation.before = before;
  function insertBefore(target2) {
    var _this = this;
    var targetArr = this._make(target2);
    this.remove();
    var clones = [];
    utils_1.domEach(targetArr, function(el2) {
      var clonedSelf = _this.clone().toArray();
      var parent = el2.parent;
      if (!parent) {
        return;
      }
      var siblings = parent.children;
      var index2 = siblings.indexOf(el2);
      if (index2 < 0) return;
      uniqueSplice(siblings, index2, 0, clonedSelf, parent);
      clones.push.apply(clones, clonedSelf);
    });
    return this._make(clones);
  }
  manipulation.insertBefore = insertBefore;
  function remove2(selector2) {
    var elems = selector2 ? this.filter(selector2) : this;
    utils_1.domEach(elems, function(el2) {
      htmlparser2_1.DomUtils.removeElement(el2);
      el2.prev = el2.next = el2.parent = null;
    });
    return this;
  }
  manipulation.remove = remove2;
  function replaceWith(content) {
    var _this = this;
    return utils_1.domEach(this, function(el2, i) {
      var parent = el2.parent;
      if (!parent) {
        return;
      }
      var siblings = parent.children;
      var cont = typeof content === "function" ? content.call(el2, i, el2) : content;
      var dom = _this._makeDomArray(cont);
      parse_1.update(dom, null);
      var index2 = siblings.indexOf(el2);
      uniqueSplice(siblings, index2, 1, dom, parent);
      if (!dom.includes(el2)) {
        el2.parent = el2.prev = el2.next = null;
      }
    });
  }
  manipulation.replaceWith = replaceWith;
  function empty2() {
    return utils_1.domEach(this, function(el2) {
      if (!htmlparser2_1.DomUtils.hasChildren(el2)) return;
      el2.children.forEach(function(child) {
        child.next = child.prev = child.parent = null;
      });
      el2.children.length = 0;
    });
  }
  manipulation.empty = empty2;
  function html2(str) {
    if (str === void 0) {
      var el2 = this[0];
      if (!el2 || !htmlparser2_1.DomUtils.hasChildren(el2)) return null;
      return static_1.html(el2.children, this.options);
    }
    var opts = tslib_1.__assign(tslib_1.__assign({}, this.options), {
      context: null
    });
    return utils_1.domEach(this, function(el3) {
      if (!htmlparser2_1.DomUtils.hasChildren(el3)) return;
      el3.children.forEach(function(child) {
        child.next = child.prev = child.parent = null;
      });
      opts.context = el3;
      var content = utils_1.isCheerio(str) ? str.toArray() : parse_1.default("" + str, opts, false).children;
      parse_1.update(content, el3);
    });
  }
  manipulation.html = html2;
  function toString3() {
    return static_1.html(this, this.options);
  }
  manipulation.toString = toString3;
  function text2(str) {
    var _this = this;
    if (str === void 0) {
      return static_1.text(this);
    }
    if (typeof str === "function") {
      return utils_1.domEach(this, function(el2, i) {
        text2.call(_this._make(el2), str.call(el2, i, static_1.text([el2])));
      });
    }
    return utils_1.domEach(this, function(el2) {
      if (!htmlparser2_1.DomUtils.hasChildren(el2)) return;
      el2.children.forEach(function(child) {
        child.next = child.prev = child.parent = null;
      });
      var textNode = new domhandler_2.Text(str);
      parse_1.update(textNode, el2);
    });
  }
  manipulation.text = text2;
  function clone2() {
    return this._make(utils_1.cloneDom(this.get()));
  }
  manipulation.clone = clone2;
  return manipulation;
}
var css = {};
var hasRequiredCss;
function requireCss() {
  if (hasRequiredCss) return css;
  hasRequiredCss = 1;
  Object.defineProperty(css, "__esModule", {
    value: true
  });
  css.css = void 0;
  var utils_1 = requireUtils$1();
  function css$1(prop2, val) {
    if (prop2 != null && val != null || // When `prop` is a "plain" object
    typeof prop2 === "object" && !Array.isArray(prop2)) {
      return utils_1.domEach(this, function(el2, i) {
        if (utils_1.isTag(el2)) {
          setCss(el2, prop2, val, i);
        }
      });
    }
    return getCss(this[0], prop2);
  }
  css.css = css$1;
  function setCss(el2, prop2, value, idx) {
    if (typeof prop2 === "string") {
      var styles2 = getCss(el2);
      var val = typeof value === "function" ? value.call(el2, idx, styles2[prop2]) : value;
      if (val === "") {
        delete styles2[prop2];
      } else if (val != null) {
        styles2[prop2] = val;
      }
      el2.attribs.style = stringify2(styles2);
    } else if (typeof prop2 === "object") {
      Object.keys(prop2).forEach(function(k, i) {
        setCss(el2, k, prop2[k], i);
      });
    }
  }
  function getCss(el2, prop2) {
    if (!el2 || !utils_1.isTag(el2)) return;
    var styles2 = parse2(el2.attribs.style);
    if (typeof prop2 === "string") {
      return styles2[prop2];
    }
    if (Array.isArray(prop2)) {
      var newStyles_1 = {};
      prop2.forEach(function(item) {
        if (styles2[item] != null) {
          newStyles_1[item] = styles2[item];
        }
      });
      return newStyles_1;
    }
    return styles2;
  }
  function stringify2(obj) {
    return Object.keys(obj).reduce(function(str, prop2) {
      return "" + str + (str ? " " : "") + prop2 + ": " + obj[prop2] + ";";
    }, "");
  }
  function parse2(styles2) {
    styles2 = (styles2 || "").trim();
    if (!styles2) return {};
    return styles2.split(";").reduce(function(obj, str) {
      var n = str.indexOf(":");
      if (n < 1 || n === str.length - 1) return obj;
      obj[str.slice(0, n).trim()] = str.slice(n + 1).trim();
      return obj;
    }, {});
  }
  return css;
}
var forms = {};
var hasRequiredForms;
function requireForms() {
  if (hasRequiredForms) return forms;
  hasRequiredForms = 1;
  Object.defineProperty(forms, "__esModule", {
    value: true
  });
  forms.serializeArray = forms.serialize = void 0;
  var utils_1 = requireUtils$1();
  var submittableSelector = "input,select,textarea,keygen";
  var r20 = /%20/g;
  var rCRLF = /\r?\n/g;
  function serialize() {
    var arr = this.serializeArray();
    var retArr = arr.map(function(data2) {
      return encodeURIComponent(data2.name) + "=" + encodeURIComponent(data2.value);
    });
    return retArr.join("&").replace(r20, "+");
  }
  forms.serialize = serialize;
  function serializeArray() {
    var _this = this;
    return this.map(function(_, elem) {
      var $elem = _this._make(elem);
      if (utils_1.isTag(elem) && elem.name === "form") {
        return $elem.find(submittableSelector).toArray();
      }
      return $elem.filter(submittableSelector).toArray();
    }).filter(
      // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
      '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
      // Convert each of the elements to its value(s)
    ).map(function(_, elem) {
      var _a;
      var $elem = _this._make(elem);
      var name = $elem.attr("name");
      var value = (_a = $elem.val()) !== null && _a !== void 0 ? _a : "";
      if (Array.isArray(value)) {
        return value.map(function(val) {
          return {
            name,
            value: val.replace(rCRLF, "\r\n")
          };
        });
      }
      return {
        name,
        value: value.replace(rCRLF, "\r\n")
      };
    }).toArray();
  }
  forms.serializeArray = serializeArray;
  return forms;
}
var hasRequiredCheerio;
function requireCheerio() {
  if (hasRequiredCheerio) return cheerio;
  hasRequiredCheerio = 1;
  Object.defineProperty(cheerio, "__esModule", {
    value: true
  });
  cheerio.Cheerio = void 0;
  var tslib_1 = require$$0$4;
  var parse_1 = tslib_1.__importDefault(requireParse());
  var options_1 = tslib_1.__importDefault(requireOptions());
  var utils_1 = requireUtils$1();
  var Attributes = tslib_1.__importStar(requireAttributes());
  var Traversing = tslib_1.__importStar(requireTraversing());
  var Manipulation = tslib_1.__importStar(requireManipulation());
  var Css = tslib_1.__importStar(requireCss());
  var Forms = tslib_1.__importStar(requireForms());
  var Cheerio = (
    /** @class */
    (function() {
      function Cheerio2(selector2, context, root2, options2) {
        var _this = this;
        if (options2 === void 0) {
          options2 = options_1.default;
        }
        this.length = 0;
        this.options = options2;
        if (!selector2) return this;
        if (root2) {
          if (typeof root2 === "string") root2 = parse_1.default(root2, this.options, false);
          this._root = new this.constructor(root2, null, null, this.options);
          this._root._root = this._root;
        }
        if (utils_1.isCheerio(selector2)) return selector2;
        var elements = typeof selector2 === "string" && utils_1.isHtml(selector2) ? (
          // $(<html>)
          parse_1.default(selector2, this.options, false).children
        ) : isNode2(selector2) ? (
          // $(dom)
          [selector2]
        ) : Array.isArray(selector2) ? (
          // $([dom])
          selector2
        ) : null;
        if (elements) {
          elements.forEach(function(elem, idx) {
            _this[idx] = elem;
          });
          this.length = elements.length;
          return this;
        }
        var search = selector2;
        var searchContext = !context ? (
          // If we don't have a context, maybe we have a root, from loading
          this._root
        ) : typeof context === "string" ? utils_1.isHtml(context) ? (
          // $('li', '<ul>...</ul>')
          this._make(parse_1.default(context, this.options, false))
        ) : (
          // $('li', 'ul')
          (search = context + " " + search, this._root)
        ) : utils_1.isCheerio(context) ? (
          // $('li', $)
          context
        ) : (
          // $('li', node), $('li', [nodes])
          this._make(context)
        );
        if (!searchContext) return this;
        return searchContext.find(search);
      }
      Cheerio2.prototype._make = function(dom, context) {
        var cheerio2 = new this.constructor(dom, context, this._root, this.options);
        cheerio2.prevObject = this;
        return cheerio2;
      };
      return Cheerio2;
    })()
  );
  cheerio.Cheerio = Cheerio;
  Cheerio.prototype.cheerio = "[cheerio object]";
  Cheerio.prototype.splice = Array.prototype.splice;
  Cheerio.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
  Object.assign(Cheerio.prototype, Attributes, Traversing, Manipulation, Css, Forms);
  function isNode2(obj) {
    return !!obj.name || obj.type === "root" || obj.type === "text" || obj.type === "comment";
  }
  return cheerio;
}
var hasRequiredLoad;
function requireLoad() {
  if (hasRequiredLoad) return load;
  hasRequiredLoad = 1;
  Object.defineProperty(load, "__esModule", {
    value: true
  });
  load.load = void 0;
  var tslib_1 = require$$0$4;
  var options_1 = tslib_1.__importStar(requireOptions());
  var staticMethods = tslib_1.__importStar(require_static());
  var cheerio_1 = requireCheerio();
  var parse_1 = tslib_1.__importDefault(requireParse());
  function load$1(content, options2, isDocument2) {
    if (isDocument2 === void 0) {
      isDocument2 = true;
    }
    if (content == null) {
      throw new Error("cheerio.load() expects a string");
    }
    var internalOpts = tslib_1.__assign(tslib_1.__assign({}, options_1.default), options_1.flatten(options2));
    var root2 = parse_1.default(content, internalOpts, isDocument2);
    var LoadedCheerio = (
      /** @class */
      (function(_super) {
        tslib_1.__extends(LoadedCheerio2, _super);
        function LoadedCheerio2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        return LoadedCheerio2;
      })(cheerio_1.Cheerio)
    );
    function initialize(selector2, context, r2, opts) {
      if (r2 === void 0) {
        r2 = root2;
      }
      return new LoadedCheerio(selector2, context, r2, tslib_1.__assign(tslib_1.__assign({}, internalOpts), options_1.flatten(opts)));
    }
    Object.assign(initialize, staticMethods, {
      load: load$1,
      // `_root` and `_options` are used in static methods.
      _root: root2,
      _options: internalOpts,
      // Add `fn` for plugins
      fn: LoadedCheerio.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: LoadedCheerio.prototype
    });
    return initialize;
  }
  load.load = load$1;
  return load;
}
var hasRequiredLib$2;
function requireLib$2() {
  if (hasRequiredLib$2) return lib$d;
  hasRequiredLib$2 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.root = exports2.parseHTML = exports2.merge = exports2.contains = void 0;
    var tslib_1 = require$$0$4;
    tslib_1.__exportStar(requireTypes(), exports2);
    tslib_1.__exportStar(requireLoad(), exports2);
    var load_1 = requireLoad();
    exports2.default = load_1.load([]);
    var staticMethods = tslib_1.__importStar(require_static());
    exports2.contains = staticMethods.contains;
    exports2.merge = staticMethods.merge;
    exports2.parseHTML = staticMethods.parseHTML;
    exports2.root = staticMethods.root;
  })(lib$d);
  return lib$d;
}
var configuration = {};
var validateAdapter = {};
var EnzymeAdapter_1;
var hasRequiredEnzymeAdapter;
function requireEnzymeAdapter() {
  if (hasRequiredEnzymeAdapter) return EnzymeAdapter_1;
  hasRequiredEnzymeAdapter = 1;
  var _createClass2 = /* @__PURE__ */ (function() {
    function defineProperties(target2, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target2, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function unimplementedError(methodName, classname) {
    return new Error(String(methodName) + " is a required method of " + String(classname) + ", but was not implemented.");
  }
  var EnzymeAdapter = (function() {
    function EnzymeAdapter2() {
      _classCallCheck2(this, EnzymeAdapter2);
      this.options = {};
    }
    _createClass2(EnzymeAdapter2, [{
      key: "createRenderer",
      value: /* @__PURE__ */ (function() {
        function createRenderer(options2) {
          throw unimplementedError("createRenderer", "EnzymeAdapter");
        }
        return createRenderer;
      })()
      // converts an RSTNode to the corresponding JSX Pragma Element. This will be needed
      // in order to implement the `Wrapper.mount()` and `Wrapper.shallow()` methods, but should
      // be pretty straightforward for people to implement.
      // eslint-disable-next-line class-methods-use-this, no-unused-vars
    }, {
      key: "nodeToElement",
      value: /* @__PURE__ */ (function() {
        function nodeToElement(node2) {
          throw unimplementedError("nodeToElement", "EnzymeAdapter");
        }
        return nodeToElement;
      })()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "matchesElementType",
      value: /* @__PURE__ */ (function() {
        function matchesElementType(node2, matchingType) {
          if (!node2) {
            return node2;
          }
          var type2 = node2.type;
          return type2 === matchingType;
        }
        return matchesElementType;
      })()
      // eslint-disable-next-line class-methods-use-this, no-unused-vars
    }, {
      key: "isValidElement",
      value: /* @__PURE__ */ (function() {
        function isValidElement2(element) {
          throw unimplementedError("isValidElement", "EnzymeAdapter");
        }
        return isValidElement2;
      })()
      // eslint-disable-next-line class-methods-use-this, no-unused-vars
    }, {
      key: "createElement",
      value: /* @__PURE__ */ (function() {
        function createElement(type2, props) {
          throw unimplementedError("createElement", "EnzymeAdapter");
        }
        return createElement;
      })()
      // eslint-disable-next-line class-methods-use-this
    }, {
      key: "invokeSetStateCallback",
      value: /* @__PURE__ */ (function() {
        function invokeSetStateCallback(instance, callback) {
          callback.call(instance);
        }
        return invokeSetStateCallback;
      })()
    }]);
    return EnzymeAdapter2;
  })();
  EnzymeAdapter.MODES = {
    STRING: "string",
    MOUNT: "mount",
    SHALLOW: "shallow"
  };
  EnzymeAdapter_1 = EnzymeAdapter;
  return EnzymeAdapter_1;
}
var hasRequiredValidateAdapter;
function requireValidateAdapter() {
  if (hasRequiredValidateAdapter) return validateAdapter;
  hasRequiredValidateAdapter = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = validateAdapter2;
    var _EnzymeAdapter = requireEnzymeAdapter();
    var _EnzymeAdapter2 = _interopRequireDefault(_EnzymeAdapter);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function validateAdapter2(adapter) {
      if (!adapter) {
        throw new Error("\n      Enzyme Internal Error: Enzyme expects an adapter to be configured, but found none.\n      To configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n      before using any of Enzyme's top level APIs, where `Adapter` is the adapter\n      corresponding to the library currently being tested. For example:\n\n      import Adapter from 'enzyme-adapter-react-15';\n\n      To find out more about this, see https://airbnb.io/enzyme/docs/installation/index.html\n    ");
      }
      if (typeof adapter === "function") {
        if (Object.getPrototypeOf(adapter) === _EnzymeAdapter2["default"]) {
          throw new Error("\n        Enzyme Internal Error: Enzyme expects an adapter instance to be configured -\n        you provided an adapter *constructor*.\n        To configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n        before using any of Enzyme's top level APIs, where `Adapter` is the adapter\n        corresponding to the library currently being tested. For example:\n\n        import Adapter from 'enzyme-adapter-react-15';\n\n        To find out more about this, see https://airbnb.io/enzyme/docs/installation/index.html\n      ");
        }
        throw new Error("\n      Enzyme Internal Error: Enzyme expects an adapter to be configured -\n      an enzyme adapter must be an object instance; you provided a function.\n      To configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n      before using any of Enzyme's top level APIs, where `Adapter` is the adapter\n      corresponding to the library currently being tested. For example:\n\n      import Adapter from 'enzyme-adapter-react-15';\n\n      To find out more about this, see https://airbnb.io/enzyme/docs/installation/index.html\n    ");
      }
      if (!(adapter instanceof _EnzymeAdapter2["default"])) {
        throw new Error("Enzyme Internal Error: configured enzyme adapter did not inherit from the EnzymeAdapter base class");
      }
    }
  })(validateAdapter);
  return validateAdapter;
}
var hasRequiredConfiguration;
function requireConfiguration() {
  if (hasRequiredConfiguration) return configuration;
  hasRequiredConfiguration = 1;
  Object.defineProperty(configuration, "__esModule", {
    value: true
  });
  configuration.get = get3;
  configuration.merge = merge2;
  configuration.reset = reset;
  var _object = requireObject_assign();
  var _object2 = _interopRequireDefault(_object);
  var _validateAdapter = requireValidateAdapter();
  var _validateAdapter2 = _interopRequireDefault(_validateAdapter);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  var configuration$1 = {};
  function get3() {
    return (0, _object2["default"])({}, configuration$1);
  }
  function merge2(extra) {
    if (extra.adapter) {
      (0, _validateAdapter2["default"])(extra.adapter);
    }
    (0, _object2["default"])(configuration$1, extra);
  }
  function reset() {
    var replacementConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    configuration$1 = {};
    merge2(replacementConfig);
  }
  return configuration;
}
var RSTTraversal = {};
var isSubset = { exports: {} };
var hasRequiredIsSubset;
function requireIsSubset() {
  if (hasRequiredIsSubset) return isSubset.exports;
  hasRequiredIsSubset = 1;
  (function(module2, exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var isSubset2 = (function(_isSubset) {
      function isSubset3(_x, _x2) {
        return _isSubset.apply(this, arguments);
      }
      isSubset3.toString = function() {
        return _isSubset.toString();
      };
      return isSubset3;
    })(function(superset2, subset2) {
      if (typeof superset2 !== "object" || superset2 === null || typeof subset2 !== "object" || subset2 === null) return false;
      return Object.keys(subset2).every(function(key) {
        if (!superset2.propertyIsEnumerable(key)) return false;
        var subsetItem = subset2[key];
        var supersetItem = superset2[key];
        if (typeof subsetItem === "object" && subsetItem !== null ? !isSubset2(supersetItem, subsetItem) : supersetItem !== subsetItem) return false;
        return true;
      });
    });
    exports2["default"] = isSubset2;
    module2.exports = exports2["default"];
  })(isSubset, isSubset.exports);
  return isSubset.exports;
}
var getAdapter = {};
var hasRequiredGetAdapter;
function requireGetAdapter() {
  if (hasRequiredGetAdapter) return getAdapter;
  hasRequiredGetAdapter = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = getAdapter2;
    var _validateAdapter = requireValidateAdapter();
    var _validateAdapter2 = _interopRequireDefault(_validateAdapter);
    var _configuration = requireConfiguration();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function getAdapter2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (options2.adapter) {
        (0, _validateAdapter2["default"])(options2.adapter);
        return options2.adapter;
      }
      var _get2 = (0, _configuration.get)(), adapter = _get2.adapter;
      (0, _validateAdapter2["default"])(adapter);
      return adapter;
    }
  })(getAdapter);
  return getAdapter;
}
var hasRequiredRSTTraversal;
function requireRSTTraversal() {
  if (hasRequiredRSTTraversal) return RSTTraversal;
  hasRequiredRSTTraversal = 1;
  Object.defineProperty(RSTTraversal, "__esModule", {
    value: true
  });
  var _slicedToArray = /* @__PURE__ */ (function() {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function(arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  })();
  RSTTraversal.propsOfNode = propsOfNode;
  RSTTraversal.childrenOfNode = childrenOfNode;
  RSTTraversal.hasClassName = hasClassName;
  RSTTraversal.treeForEach = treeForEach;
  RSTTraversal.treeFilter = treeFilter;
  RSTTraversal.findParentNode = findParentNode;
  RSTTraversal.pathToNode = pathToNode;
  RSTTraversal.parentsOfNode = parentsOfNode;
  RSTTraversal.nodeHasId = nodeHasId;
  RSTTraversal.nodeMatchesObjectProps = nodeMatchesObjectProps;
  RSTTraversal.getTextFromNode = getTextFromNode;
  RSTTraversal.getTextFromHostNodes = getTextFromHostNodes;
  RSTTraversal.getHTMLFromHostNodes = getHTMLFromHostNodes;
  var _object = requireObject_assign();
  var _object2 = _interopRequireDefault(_object);
  var _arrayPrototype = requireArray_prototype_flat();
  var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
  var _object3 = requireObject_entries();
  var _object4 = _interopRequireDefault(_object3);
  var _isSubset = requireIsSubset();
  var _isSubset2 = _interopRequireDefault(_isSubset);
  var _functionPrototype = requireFunction_prototype_name();
  var _functionPrototype2 = _interopRequireDefault(_functionPrototype);
  var _isRegex = requireIsRegex();
  var _isRegex2 = _interopRequireDefault(_isRegex);
  var _getAdapter = requireGetAdapter();
  var _getAdapter2 = _interopRequireDefault(_getAdapter);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  function propsOfNode(node2) {
    return node2 && node2.props || {};
  }
  function childrenOfNode(node2) {
    if (!node2) return [];
    var adapter = (0, _getAdapter2["default"])();
    var adapterHasIsFragment = adapter.isFragment && typeof adapter.isFragment === "function";
    var renderedArray = Array.isArray(node2.rendered) ? (0, _arrayPrototype2["default"])(node2.rendered, 1) : [node2.rendered];
    if (!adapterHasIsFragment) {
      return renderedArray;
    }
    return (0, _arrayPrototype2["default"])(renderedArray.map(function(currentChild) {
      if (adapter.isFragment(currentChild)) {
        return childrenOfNode(currentChild);
      }
      return currentChild;
    }), 1);
  }
  function hasClassName(node2, className) {
    var classes2 = propsOfNode(node2).className || "";
    classes2 = String(classes2).replace(/\s/g, " ");
    if ((0, _isRegex2["default"])(className)) return className.test(classes2);
    return (" " + String(classes2) + " ").indexOf(" " + String(className) + " ") > -1;
  }
  function treeForEach(tree, fn) {
    if (tree) {
      fn(tree);
    }
    childrenOfNode(tree).forEach(function(node2) {
      return treeForEach(node2, fn);
    });
  }
  function treeFilter(tree, fn) {
    var results = [];
    treeForEach(tree, function(node2) {
      if (fn(node2)) {
        results.push(node2);
      }
    });
    return results;
  }
  function findParentNode(root2, targetNode) {
    var results = treeFilter(root2, function(node2) {
      if (!node2.rendered) {
        return false;
      }
      return childrenOfNode(node2).indexOf(targetNode) !== -1;
    });
    return results[0] || null;
  }
  function pathFilter(path, fn) {
    return path.filter(function(tree) {
      return treeFilter(tree, fn).length !== 0;
    });
  }
  function pathToNode(node2, root2) {
    var queue2 = [root2];
    var path = [];
    var hasNode = function hasNode2(testNode) {
      return node2 === testNode;
    };
    while (queue2.length) {
      var current = queue2.pop();
      var children2 = childrenOfNode(current);
      if (current === node2) return pathFilter(path, hasNode);
      path.push(current);
      if (children2.length === 0) {
        path.pop();
      }
      queue2.push.apply(queue2, _toConsumableArray(children2));
    }
    return null;
  }
  function parentsOfNode(node2, root2) {
    return (pathToNode(node2, root2) || []).reverse();
  }
  function nodeHasId(node2, id2) {
    return propsOfNode(node2).id === id2;
  }
  var CAN_NEVER_MATCH = {};
  function replaceUndefined(v) {
    return typeof v !== "undefined" ? v : CAN_NEVER_MATCH;
  }
  function replaceUndefinedValues(obj) {
    return (0, _object4["default"])(obj).reduce(function(acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2), k = _ref2[0], v = _ref2[1];
      return (0, _object2["default"])({}, acc, _defineProperty2({}, k, replaceUndefined(v)));
    }, {});
  }
  function nodeMatchesObjectProps(node2, props) {
    return (0, _isSubset2["default"])(propsOfNode(node2), replaceUndefinedValues(props));
  }
  function getTextFromHostNode(hostNode) {
    if (typeof hostNode === "string") {
      return String(hostNode || "");
    }
    if (!hostNode) {
      return "";
    }
    return hostNode.textContent || "";
  }
  function getTextFromRSTNode(node2, _ref3) {
    var getCustom = _ref3.getCustom, handleHostNodes = _ref3.handleHostNodes, recurse = _ref3.recurse, _ref3$nullRenderRetur = _ref3.nullRenderReturnsNull, nullRenderReturnsNull = _ref3$nullRenderRetur === void 0 ? false : _ref3$nullRenderRetur;
    if (node2 == null) {
      return "";
    }
    if (typeof node2 === "string" || typeof node2 === "number") {
      return String(node2);
    }
    if (getCustom && node2.type && typeof node2.type === "function") {
      return getCustom(node2);
    }
    if (handleHostNodes && node2.nodeType === "host") {
      return handleHostNodes(node2);
    }
    if (node2.rendered == null && nullRenderReturnsNull) {
      return null;
    }
    return childrenOfNode(node2).map(recurse).join("");
  }
  function getTextFromNode(node2) {
    return getTextFromRSTNode(node2, {
      recurse: getTextFromNode,
      getCustom: /* @__PURE__ */ (function() {
        function getCustom(_ref4) {
          var type2 = _ref4.type;
          return "<" + String(type2.displayName || (0, _functionPrototype2["default"])(type2)) + " />";
        }
        return getCustom;
      })()
    });
  }
  function getTextFromHostNodes(node2, adapter) {
    return getTextFromRSTNode(node2, {
      recurse: /* @__PURE__ */ (function() {
        function recurse(item) {
          return getTextFromHostNodes(item, adapter);
        }
        return recurse;
      })(),
      handleHostNodes: /* @__PURE__ */ (function() {
        function handleHostNodes(item) {
          var nodes = [].concat(adapter.nodeToHostNode(item, true));
          return nodes.map(getTextFromHostNode).join("");
        }
        return handleHostNodes;
      })()
    });
  }
  function getHTMLFromHostNode(hostNode) {
    if (hostNode == null) {
      return null;
    }
    return hostNode.outerHTML.replace(/\sdata-(reactid|reactroot)+="([^"]*)+"/g, "");
  }
  function getHTMLFromHostNodes(node2, adapter) {
    return getTextFromRSTNode(node2, {
      recurse: /* @__PURE__ */ (function() {
        function recurse(item) {
          return getHTMLFromHostNodes(item, adapter);
        }
        return recurse;
      })(),
      handleHostNodes: /* @__PURE__ */ (function() {
        function handleHostNodes(item) {
          var nodes = [].concat(adapter.nodeToHostNode(item, true));
          return nodes.map(getHTMLFromHostNode).join("");
        }
        return handleHostNodes;
      })(),
      nullRenderReturnsNull: true
    });
  }
  return RSTTraversal;
}
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return Utils;
  hasRequiredUtils = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.shallowEqual = exports2.ITERATOR_SYMBOL = void 0;
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _slicedToArray = /* @__PURE__ */ (function() {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = void 0;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      return function(arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    })();
    exports2.getAdapter = getAdapter2;
    exports2.makeOptions = makeOptions;
    exports2.isCustomComponent = isCustomComponent;
    exports2.isCustomComponentElement = isCustomComponentElement;
    exports2.propsOfNode = propsOfNode;
    exports2.typeOfNode = typeOfNode;
    exports2.nodeHasType = nodeHasType;
    exports2.nodeMatches = nodeMatches;
    exports2.nodeEqual = nodeEqual;
    exports2.containsChildrenSubArray = containsChildrenSubArray;
    exports2.childrenToSimplifiedArray = childrenToSimplifiedArray;
    exports2.isReactElementAlike = isReactElementAlike;
    exports2.withSetStateAllowed = withSetStateAllowed;
    exports2.AND = AND;
    exports2.displayNameOfNode = displayNameOfNode;
    exports2.sym = sym;
    exports2.privateSet = privateSet;
    exports2.cloneElement = cloneElement;
    exports2.spyMethod = spyMethod;
    var _enzymeShallowEqual = requireBuild$1();
    Object.defineProperty(exports2, "shallowEqual", {
      enumerable: true,
      get: /* @__PURE__ */ (function() {
        function get3() {
          return _interopRequireDefault(_enzymeShallowEqual)["default"];
        }
        return get3;
      })()
    });
    exports2.isEmptyValue = isEmptyValue;
    exports2.renderedDive = renderedDive;
    exports2.loadCheerioRoot = loadCheerioRoot;
    var _object = requireObject_assign();
    var _object2 = _interopRequireDefault(_object);
    var _lodash = requireLodash_isequal();
    var _lodash2 = _interopRequireDefault(_lodash);
    var _objectIs = requireObjectIs();
    var _objectIs2 = _interopRequireDefault(_objectIs);
    var _object3 = requireObject_entries();
    var _object4 = _interopRequireDefault(_object3);
    var _functionPrototype = requireFunction_prototype_name();
    var _functionPrototype2 = _interopRequireDefault(_functionPrototype);
    var _has = requireSrc$1();
    var _has2 = _interopRequireDefault(_has);
    var _arrayPrototype = requireArray_prototype_flat();
    var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
    var _stringPrototype = requireString_prototype_trim();
    var _stringPrototype2 = _interopRequireDefault(_stringPrototype);
    var _cheerio = requireLib$2();
    var _cheerio2 = _interopRequireDefault(_cheerio);
    var _utils = requireUtils$1();
    var _configuration = requireConfiguration();
    var _RSTTraversal = requireRSTTraversal();
    var _getAdapter = requireGetAdapter();
    var _getAdapter2 = _interopRequireDefault(_getAdapter);
    var _validateAdapter = requireValidateAdapter();
    var _validateAdapter2 = _interopRequireDefault(_validateAdapter);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function _objectWithoutProperties(obj, keys2) {
      var target2 = {};
      for (var i in obj) {
        if (keys2.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target2[i] = obj[i];
      }
      return target2;
    }
    exports2.ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    function getAdapter2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      console.warn("getAdapter from Utils is deprecated; please use ./getAdapter instead");
      return (0, _getAdapter2["default"])(options2);
    }
    function validateMountOptions(attachTo, hydrateIn) {
      if (attachTo && hydrateIn && attachTo !== hydrateIn) {
        throw new TypeError("If both the `attachTo` and `hydrateIn` options are provided, they must be === (for backwards compatibility)");
      }
    }
    function makeOptions(options2) {
      var _get2 = (0, _configuration.get)(), configAttachTo = _get2.attachTo, configHydrateIn = _get2.hydrateIn, config = _objectWithoutProperties(_get2, ["attachTo", "hydrateIn"]);
      validateMountOptions(configAttachTo, configHydrateIn);
      var attachTo = options2.attachTo, hydrateIn = options2.hydrateIn;
      validateMountOptions(attachTo, hydrateIn);
      var finalAttachTo = hydrateIn || configHydrateIn || configAttachTo || attachTo || void 0;
      var finalHydrateIn = hydrateIn || configHydrateIn || void 0;
      var mountTargets = (0, _object2["default"])({}, finalAttachTo && {
        attachTo: finalAttachTo
      }, finalHydrateIn && {
        hydrateIn: finalHydrateIn
      });
      return (0, _object2["default"])({}, config, options2, mountTargets);
    }
    function isCustomComponent(component, adapter) {
      (0, _validateAdapter2["default"])(adapter);
      if (adapter.isCustomComponent) {
        return !!adapter.isCustomComponent(component);
      }
      return typeof component === "function";
    }
    function isCustomComponentElement(inst, adapter) {
      if (adapter.isCustomComponentElement) {
        return !!adapter.isCustomComponentElement(inst);
      }
      return !!inst && adapter.isValidElement(inst) && typeof inst.type === "function";
    }
    function propsOfNode(node2) {
      return (0, _object4["default"])(node2 && node2.props || {}).filter(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), value = _ref2[1];
        return typeof value !== "undefined";
      }).reduce(function(acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
        return (0, _object2["default"])(acc, _defineProperty2({}, key, value));
      }, {});
    }
    function typeOfNode(node2) {
      return node2 ? node2.type : null;
    }
    function nodeHasType(node2, type2) {
      if (!type2 || !node2) return false;
      var adapter = (0, _getAdapter2["default"])();
      if (adapter.displayNameOfNode) {
        var displayName = adapter.displayNameOfNode(node2);
        return displayName === type2;
      }
      if (!node2.type) return false;
      if (typeof node2.type === "string") return node2.type === type2;
      return (typeof node2.type === "function" ? (0, _functionPrototype2["default"])(node2.type) === type2 : node2.type.name === type2) || node2.type.displayName === type2;
    }
    function internalChildrenCompare(a, b, lenComp, isLoose) {
      var nodeCompare = isLoose ? nodeMatches : nodeEqual;
      if (a === b) return true;
      if (!Array.isArray(a) && !Array.isArray(b)) {
        return nodeCompare(a, b, lenComp);
      }
      var flatA = (0, _arrayPrototype2["default"])(a, Infinity);
      var flatB = (0, _arrayPrototype2["default"])(b, Infinity);
      if (flatA.length !== flatB.length) return false;
      if (flatA.length === 0 && flatB.length === 0) return true;
      for (var i = 0; i < flatA.length; i += 1) {
        if (!nodeCompare(flatA[i], flatB[i], lenComp)) return false;
      }
      return true;
    }
    function childrenMatch(a, b, lenComp) {
      return internalChildrenCompare(a, b, lenComp, true);
    }
    function childrenEqual2(a, b, lenComp) {
      return internalChildrenCompare(a, b, lenComp, false);
    }
    function removeNullaryReducer(acc, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
      var addition = value == null ? {} : _defineProperty2({}, key, value);
      return (0, _object2["default"])({}, acc, addition);
    }
    function internalNodeCompare(a, b, lenComp, isLoose) {
      if (a === b) return true;
      if (!a || !b) return false;
      if (a.type !== b.type) return false;
      var left2 = propsOfNode(a);
      var right2 = propsOfNode(b);
      if (isLoose) {
        left2 = (0, _object4["default"])(left2).reduce(removeNullaryReducer, {});
        right2 = (0, _object4["default"])(right2).reduce(removeNullaryReducer, {});
      }
      var leftKeys = Object.keys(left2);
      for (var i = 0; i < leftKeys.length; i += 1) {
        var prop2 = leftKeys[i];
        if (prop2 === "children") ;
        else if (!(prop2 in right2)) {
          return false;
        } else if (right2[prop2] === left2[prop2]) ;
        else if (_typeof2(right2[prop2]) === _typeof2(left2[prop2]) && _typeof2(left2[prop2]) === "object") {
          if (!(0, _lodash2["default"])(left2[prop2], right2[prop2])) return false;
        } else {
          return false;
        }
      }
      var leftHasChildren = "children" in left2;
      var rightHasChildren = "children" in right2;
      var childCompare = isLoose ? childrenMatch : childrenEqual2;
      if (leftHasChildren || rightHasChildren) {
        if (!childCompare(childrenToSimplifiedArray(left2.children, isLoose), childrenToSimplifiedArray(right2.children, isLoose), lenComp)) {
          return false;
        }
      }
      if (!isTextualNode(a)) {
        var rightKeys = Object.keys(right2);
        return lenComp(leftKeys.length - leftHasChildren, rightKeys.length - rightHasChildren);
      }
      return false;
    }
    function nodeMatches(a, b) {
      var lenComp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _objectIs2["default"];
      return internalNodeCompare(a, b, lenComp, true);
    }
    function nodeEqual(a, b) {
      var lenComp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _objectIs2["default"];
      return internalNodeCompare(a, b, lenComp, false);
    }
    function containsChildrenSubArray(match, node2, subArray) {
      var children2 = (0, _RSTTraversal.childrenOfNode)(node2);
      var checker = function checker2(_, i) {
        return arraysEqual(match, children2.slice(i, i + subArray.length), subArray);
      };
      return children2.some(checker);
    }
    function arraysEqual(match, left2, right2) {
      return left2.length === right2.length && left2.every(function(el2, i) {
        return match(el2, right2[i]);
      });
    }
    function childrenToArray(children2) {
      var result = [];
      var push = function push2(el2) {
        if (el2 === null || el2 === false || typeof el2 === "undefined") return;
        result.push(el2);
      };
      if (Array.isArray(children2)) {
        children2.forEach(push);
      } else {
        push(children2);
      }
      return result;
    }
    function childrenToSimplifiedArray(nodeChildren) {
      var isLoose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var childrenArray = childrenToArray(nodeChildren);
      var simplifiedArray = [];
      for (var i = 0; i < childrenArray.length; i += 1) {
        var child = childrenArray[i];
        var previousChild = simplifiedArray.pop();
        if (typeof previousChild === "undefined") {
          simplifiedArray.push(child);
        } else if (isTextualNode(child) && isTextualNode(previousChild)) {
          simplifiedArray.push(previousChild + child);
        } else {
          simplifiedArray.push(previousChild);
          simplifiedArray.push(child);
        }
      }
      if (isLoose) {
        return simplifiedArray.map(function(x) {
          return typeof x === "string" ? (0, _stringPrototype2["default"])(x) : x;
        });
      }
      return simplifiedArray;
    }
    function isTextualNode(node2) {
      return typeof node2 === "string" || typeof node2 === "number";
    }
    function isReactElementAlike(arg, adapter) {
      return adapter.isValidElement(arg) || isTextualNode(arg) || Array.isArray(arg);
    }
    function withSetStateAllowed(fn) {
      var cleanup = false;
      if (typeof globalThis.document === "undefined") {
        cleanup = true;
        globalThis.document = {};
      }
      fn();
      if (cleanup) {
        globalThis.document = void 0;
        delete globalThis.document;
      }
    }
    function AND(fns) {
      var fnsReversed = fns.slice().reverse();
      return function(x) {
        return fnsReversed.every(function(fn) {
          return fn(x);
        });
      };
    }
    function displayNameOfNode(node2) {
      if (!node2) return null;
      var type2 = node2.type;
      if (!type2) return null;
      return type2.displayName || (typeof type2 === "function" ? (0, _functionPrototype2["default"])(type2) : type2.name || type2);
    }
    function sym(s) {
      return typeof Symbol === "function" ? Symbol["for"]("enzyme." + String(s)) : s;
    }
    function privateSet(obj, prop2, value) {
      Object.defineProperty(obj, prop2, {
        value,
        enumerable: false,
        writable: true
      });
    }
    function cloneElement(adapter, el2, props) {
      return adapter.createElement(el2.type, (0, _object2["default"])({}, el2.props, props));
    }
    function spyMethod(instance, methodName) {
      var getStub = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      };
      var lastReturnValue = void 0;
      var originalMethod = instance[methodName];
      var hasOwn = (0, _has2["default"])(instance, methodName);
      var descriptor = void 0;
      if (hasOwn) {
        descriptor = Object.getOwnPropertyDescriptor(instance, methodName);
      }
      Object.defineProperty(instance, methodName, {
        configurable: true,
        enumerable: !descriptor || !!descriptor.enumerable,
        value: getStub(originalMethod) || /* @__PURE__ */ (function() {
          function spied() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var result = originalMethod.apply(this, args);
            lastReturnValue = result;
            return result;
          }
          return spied;
        })()
      });
      return {
        restore: /* @__PURE__ */ (function() {
          function restore() {
            if (hasOwn) {
              if (descriptor) {
                Object.defineProperty(instance, methodName, descriptor);
              } else {
                instance[methodName] = originalMethod;
              }
            } else {
              delete instance[methodName];
            }
          }
          return restore;
        })(),
        getLastReturnValue: /* @__PURE__ */ (function() {
          function getLastReturnValue() {
            return lastReturnValue;
          }
          return getLastReturnValue;
        })()
      };
    }
    function isEmptyValue(renderedValue) {
      return renderedValue === null || renderedValue === false;
    }
    function renderedDive(nodes) {
      if (isEmptyValue(nodes)) {
        return true;
      }
      return [].concat(nodes).every(function(n) {
        if (n) {
          var rendered = n.rendered;
          return isEmptyValue(rendered) || renderedDive(rendered);
        }
        return isEmptyValue(n);
      });
    }
    function loadCheerioRoot(html2) {
      if (!html2) {
        return _cheerio2["default"].root();
      }
      if (!(0, _utils.isHtml)(html2)) {
        return _cheerio2["default"].load(html2, null, false).root();
      }
      return _cheerio2["default"].load("")(html2);
    }
  })(Utils);
  return Utils;
}
var Debug = {};
var lodash_escape;
var hasRequiredLodash_escape;
function requireLodash_escape() {
  if (hasRequiredLodash_escape) return lodash_escape;
  hasRequiredLodash_escape = 1;
  var symbolTag2 = "[object Symbol]";
  var reUnescapedHtml = /[&<>"'`]/g, reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "`": "&#96;"
  };
  var freeGlobal2 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  function basePropertyOf(object2) {
    return function(key) {
      return object2 == null ? void 0 : object2[key];
    };
  }
  var escapeHtmlChar = basePropertyOf(htmlEscapes);
  var objectProto2 = Object.prototype;
  var objectToString2 = objectProto2.toString;
  var Symbol2 = root2.Symbol;
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolToString2 = symbolProto2 ? symbolProto2.toString : void 0;
  function baseToString2(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isSymbol2(value)) {
      return symbolToString2 ? symbolToString2.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -Infinity ? "-0" : result;
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  function isSymbol2(value) {
    return typeof value == "symbol" || isObjectLike2(value) && objectToString2.call(value) == symbolTag2;
  }
  function toString3(value) {
    return value == null ? "" : baseToString2(value);
  }
  function escape(string) {
    string = toString3(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
  }
  lodash_escape = escape;
  return lodash_escape;
}
var isString$2;
var hasRequiredIsString;
function requireIsString() {
  if (hasRequiredIsString) return isString$2;
  hasRequiredIsString = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $strValueOf = callBound2("String.prototype.valueOf");
  var tryStringObject = function tryStringObject2(value) {
    try {
      $strValueOf(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var $toString = callBound2("Object.prototype.toString");
  var strClass = "[object String]";
  var hasToStringTag = requireShams()();
  isString$2 = function isString2(value) {
    if (typeof value === "string") {
      return true;
    }
    if (!value || typeof value !== "object") {
      return false;
    }
    return hasToStringTag ? tryStringObject(value) : $toString(value) === strClass;
  };
  return isString$2;
}
var isNumberObject;
var hasRequiredIsNumberObject;
function requireIsNumberObject() {
  if (hasRequiredIsNumberObject) return isNumberObject;
  hasRequiredIsNumberObject = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $numToStr = callBound2("Number.prototype.toString");
  var tryNumberObject = function tryNumberObject2(value) {
    try {
      $numToStr(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var $toString = callBound2("Object.prototype.toString");
  var numClass = "[object Number]";
  var hasToStringTag = requireShams()();
  isNumberObject = function isNumberObject2(value) {
    if (typeof value === "number") {
      return true;
    }
    if (!value || typeof value !== "object") {
      return false;
    }
    return hasToStringTag ? tryNumberObject(value) : $toString(value) === numClass;
  };
  return isNumberObject;
}
var isBooleanObject;
var hasRequiredIsBooleanObject;
function requireIsBooleanObject() {
  if (hasRequiredIsBooleanObject) return isBooleanObject;
  hasRequiredIsBooleanObject = 1;
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $boolToStr = callBound2("Boolean.prototype.toString");
  var $toString = callBound2("Object.prototype.toString");
  var tryBooleanObject = function booleanBrandCheck(value) {
    try {
      $boolToStr(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var boolClass = "[object Boolean]";
  var hasToStringTag = requireShams()();
  isBooleanObject = function isBoolean(value) {
    if (typeof value === "boolean") {
      return true;
    }
    if (value === null || typeof value !== "object") {
      return false;
    }
    return hasToStringTag ? tryBooleanObject(value) : $toString(value) === boolClass;
  };
  return isBooleanObject;
}
var hasRequiredDebug;
function requireDebug() {
  if (hasRequiredDebug) return Debug;
  hasRequiredDebug = 1;
  Object.defineProperty(Debug, "__esModule", {
    value: true
  });
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  Debug.typeName = typeName;
  Debug.spaces = spaces;
  Debug.indent = indent;
  Debug.debugNode = debugNode;
  Debug.debugNodes = debugNodes;
  var _lodash = requireLodash_escape();
  var _lodash2 = _interopRequireDefault(_lodash);
  var _functionPrototype = requireFunction_prototype_name();
  var _functionPrototype2 = _interopRequireDefault(_functionPrototype);
  var _isString = requireIsString();
  var _isString2 = _interopRequireDefault(_isString);
  var _isNumberObject = requireIsNumberObject();
  var _isNumberObject2 = _interopRequireDefault(_isNumberObject);
  var _isCallable = requireIsCallable$1();
  var _isCallable2 = _interopRequireDefault(_isCallable);
  var _isBooleanObject = requireIsBooleanObject();
  var _isBooleanObject2 = _interopRequireDefault(_isBooleanObject);
  var _objectInspect = /* @__PURE__ */ requireObjectInspect();
  var _objectInspect2 = _interopRequireDefault(_objectInspect);
  var _has = requireSrc$1();
  var _has2 = _interopRequireDefault(_has);
  var _RSTTraversal = requireRSTTraversal();
  var _getAdapter = requireGetAdapter();
  var _getAdapter2 = _interopRequireDefault(_getAdapter);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  var booleanValue = Function.bind.call(Function.call, Boolean.prototype.valueOf);
  function typeName(node2) {
    var adapter = (0, _getAdapter2["default"])();
    if (adapter.displayNameOfNode) {
      return (0, _getAdapter2["default"])().displayNameOfNode(node2) || "Component";
    }
    return typeof node2.type === "function" ? node2.type.displayName || (0, _functionPrototype2["default"])(node2.type) || "Component" : node2.type;
  }
  function spaces(n) {
    return Array(n + 1).join(" ");
  }
  function indent(depth, string) {
    return string.split("\n").map(function(x) {
      return "" + String(spaces(depth)) + String(x);
    }).join("\n");
  }
  function propString(prop2, options2) {
    if ((0, _isString2["default"])(prop2)) {
      return (0, _objectInspect2["default"])(String(prop2), {
        quoteStyle: "double"
      });
    }
    if ((0, _isNumberObject2["default"])(prop2)) {
      return "{" + String((0, _objectInspect2["default"])(Number(prop2))) + "}";
    }
    if ((0, _isBooleanObject2["default"])(prop2)) {
      return "{" + String((0, _objectInspect2["default"])(booleanValue(prop2))) + "}";
    }
    if ((0, _isCallable2["default"])(prop2)) {
      return "{" + String((0, _objectInspect2["default"])(prop2)) + "}";
    }
    if ((typeof prop2 === "undefined" ? "undefined" : _typeof2(prop2)) === "object") {
      if (options2.verbose) {
        return "{" + String((0, _objectInspect2["default"])(prop2)) + "}";
      }
      return "{{...}}";
    }
    return "{[" + (typeof prop2 === "undefined" ? "undefined" : _typeof2(prop2)) + "]}";
  }
  function propsString(node2, options2) {
    var props = (0, _RSTTraversal.propsOfNode)(node2);
    var keys2 = Object.keys(props).filter(function(x) {
      return x !== "children";
    });
    return keys2.map(function(key) {
      return String(key) + "=" + String(propString(props[key], options2));
    }).join(" ");
  }
  function indentChildren(childrenStrs, indentLength) {
    return childrenStrs.length ? "\n" + String(childrenStrs.map(function(x) {
      return indent(indentLength, x);
    }).join("\n")) + "\n" : "";
  }
  function isRSTNodeLike(node2) {
    return (0, _has2["default"])(node2, "nodeType") && typeof node2.nodeType === "string" && (0, _has2["default"])(node2, "type") && (0, _has2["default"])(node2, "key") && (0, _has2["default"])(node2, "ref") && (0, _has2["default"])(node2, "instance") && (0, _has2["default"])(node2, "rendered");
  }
  function debugNode(node2) {
    var indentLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (typeof node2 === "string" || typeof node2 === "number") return (0, _lodash2["default"])(node2);
    if (typeof node2 === "function") {
      var name = (0, _functionPrototype2["default"])(node2);
      return "[function" + (name ? " " + String(name) : "") + "]";
    }
    if (!node2) return "";
    var adapter = (0, _getAdapter2["default"])();
    if (!adapter.isValidElement(node2) && !isRSTNodeLike(node2)) {
      return "{" + String((0, _objectInspect2["default"])(node2)) + "}";
    }
    var childrenStrs = (0, _RSTTraversal.childrenOfNode)(node2).map(function(n) {
      return debugNode(n, indentLength, options2);
    }).filter(Boolean);
    var type2 = typeName(node2);
    var props = options2.ignoreProps ? "" : propsString(node2, options2);
    var beforeProps = props ? " " : "";
    var afterProps = childrenStrs.length ? ">" : " ";
    var childrenIndented = indentChildren(childrenStrs, indentLength);
    var nodeClose = childrenStrs.length ? "</" + String(type2) + ">" : "/>";
    return "<" + String(type2) + beforeProps + String(props) + afterProps + String(childrenIndented) + nodeClose;
  }
  function debugNodes(nodes) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return nodes.map(function(node2) {
      return debugNode(node2, void 0, options2);
    }).join("\n\n\n");
  }
  return Debug;
}
var selectors = {};
var dist = {};
var createGenerator = {};
var hasRequiredCreateGenerator;
function requireCreateGenerator() {
  if (hasRequiredCreateGenerator) return createGenerator;
  hasRequiredCreateGenerator = 1;
  Object.defineProperty(createGenerator, "__esModule", {
    value: true
  });
  var escapeValue = function escapeValue2(value) {
    return JSON.stringify(value);
  };
  var renderSelector = function renderSelector2(selectorToken) {
    var tokens = selectorToken.body;
    var parts = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = void 0;
    try {
      for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var token = _step.value;
        var part2 = void 0;
        if (token.type === "universalSelector") {
          part2 = "*";
        } else if (token.type === "typeSelector") {
          part2 = token.name;
        } else if (token.type === "idSelector") {
          part2 = "#" + token.name;
        } else if (token.type === "classSelector") {
          part2 = "." + token.name;
        } else if (token.type === "attributePresenceSelector") {
          part2 = "[" + token.name + "]";
        } else if (token.type === "attributeValueSelector") {
          part2 = "[" + token.name + token.operator + escapeValue(token.value) + "]";
        } else if (token.type === "pseudoClassSelector") {
          part2 = ":" + token.name;
          if (token.parameters.length) {
            part2 += "(" + token.parameters.map(escapeValue).join(", ") + ")";
          }
        } else if (token.type === "pseudoElementSelector") {
          part2 = "::" + token.name;
        } else {
          throw new Error("Unknown token.");
        }
        parts.push(part2);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return parts.join("");
  };
  createGenerator.default = function() {
    var generate = function generate2(tokens) {
      var sequences = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = void 0;
      try {
        for (var _iterator2 = tokens[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var token = _step2.value;
          if (token.type === "selector") {
            sequences.push(renderSelector(token));
          } else if (token.type === "descendantCombinator") {
            sequences.push(" ");
          } else if (token.type === "childCombinator") {
            sequences.push(" > ");
          } else if (token.type === "adjacentSiblingCombinator") {
            sequences.push(" + ");
          } else if (token.type === "generalSiblingCombinator") {
            sequences.push(" ~ ");
          } else {
            throw new Error("Unknown token.");
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
      return sequences.join("");
    };
    return {
      generate
    };
  };
  return createGenerator;
}
var createParser = {};
var nearley$1 = { exports: {} };
var nearley = nearley$1.exports;
var hasRequiredNearley;
function requireNearley() {
  if (hasRequiredNearley) return nearley$1.exports;
  hasRequiredNearley = 1;
  (function(module2) {
    (function(root2, factory) {
      if (module2.exports) {
        module2.exports = factory();
      } else {
        root2.nearley = factory();
      }
    })(nearley, function() {
      function Rule(name, symbols, postprocess) {
        this.id = ++Rule.highestId;
        this.name = name;
        this.symbols = symbols;
        this.postprocess = postprocess;
        return this;
      }
      Rule.highestId = 0;
      Rule.prototype.toString = function(withCursorAt) {
        var symbolSequence = typeof withCursorAt === "undefined" ? this.symbols.map(getSymbolShortDisplay).join(" ") : this.symbols.slice(0, withCursorAt).map(getSymbolShortDisplay).join(" ") + " ● " + this.symbols.slice(withCursorAt).map(getSymbolShortDisplay).join(" ");
        return this.name + " → " + symbolSequence;
      };
      function State(rule, dot2, reference, wantedBy) {
        this.rule = rule;
        this.dot = dot2;
        this.reference = reference;
        this.data = [];
        this.wantedBy = wantedBy;
        this.isComplete = this.dot === rule.symbols.length;
      }
      State.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
      };
      State.prototype.nextState = function(child) {
        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
        state.left = this;
        state.right = child;
        if (state.isComplete) {
          state.data = state.build();
          state.right = void 0;
        }
        return state;
      };
      State.prototype.build = function() {
        var children2 = [];
        var node2 = this;
        do {
          children2.push(node2.right.data);
          node2 = node2.left;
        } while (node2.left);
        children2.reverse();
        return children2;
      };
      State.prototype.finish = function() {
        if (this.rule.postprocess) {
          this.data = this.rule.postprocess(this.data, this.reference, Parser2.fail);
        }
      };
      function Column(grammar2, index2) {
        this.grammar = grammar2;
        this.index = index2;
        this.states = [];
        this.wants = {};
        this.scannable = [];
        this.completed = {};
      }
      Column.prototype.process = function(nextColumn) {
        var states = this.states;
        var wants = this.wants;
        var completed = this.completed;
        for (var w = 0; w < states.length; w++) {
          var state = states[w];
          if (state.isComplete) {
            state.finish();
            if (state.data !== Parser2.fail) {
              var wantedBy = state.wantedBy;
              for (var i = wantedBy.length; i--; ) {
                var left2 = wantedBy[i];
                this.complete(left2, state);
              }
              if (state.reference === this.index) {
                var exp2 = state.rule.name;
                (this.completed[exp2] = this.completed[exp2] || []).push(state);
              }
            }
          } else {
            var exp2 = state.rule.symbols[state.dot];
            if (typeof exp2 !== "string") {
              this.scannable.push(state);
              continue;
            }
            if (wants[exp2]) {
              wants[exp2].push(state);
              if (completed.hasOwnProperty(exp2)) {
                var nulls = completed[exp2];
                for (var i = 0; i < nulls.length; i++) {
                  var right2 = nulls[i];
                  this.complete(state, right2);
                }
              }
            } else {
              wants[exp2] = [state];
              this.predict(exp2);
            }
          }
        }
      };
      Column.prototype.predict = function(exp2) {
        var rules2 = this.grammar.byName[exp2] || [];
        for (var i = 0; i < rules2.length; i++) {
          var r2 = rules2[i];
          var wantedBy = this.wants[exp2];
          var s = new State(r2, 0, this.index, wantedBy);
          this.states.push(s);
        }
      };
      Column.prototype.complete = function(left2, right2) {
        var copy2 = left2.nextState(right2);
        this.states.push(copy2);
      };
      function Grammar(rules2, start2) {
        this.rules = rules2;
        this.start = start2 || this.rules[0].name;
        var byName = this.byName = {};
        this.rules.forEach(function(rule) {
          if (!byName.hasOwnProperty(rule.name)) {
            byName[rule.name] = [];
          }
          byName[rule.name].push(rule);
        });
      }
      Grammar.fromCompiled = function(rules2, start2) {
        var lexer = rules2.Lexer;
        if (rules2.ParserStart) {
          start2 = rules2.ParserStart;
          rules2 = rules2.ParserRules;
        }
        var rules2 = rules2.map(function(r2) {
          return new Rule(r2.name, r2.symbols, r2.postprocess);
        });
        var g = new Grammar(rules2, start2);
        g.lexer = lexer;
        return g;
      };
      function StreamLexer() {
        this.reset("");
      }
      StreamLexer.prototype.reset = function(data2, state) {
        this.buffer = data2;
        this.index = 0;
        this.line = state ? state.line : 1;
        this.lastLineBreak = state ? -state.col : 0;
      };
      StreamLexer.prototype.next = function() {
        if (this.index < this.buffer.length) {
          var ch = this.buffer[this.index++];
          if (ch === "\n") {
            this.line += 1;
            this.lastLineBreak = this.index;
          }
          return {
            value: ch
          };
        }
      };
      StreamLexer.prototype.save = function() {
        return {
          line: this.line,
          col: this.index - this.lastLineBreak
        };
      };
      StreamLexer.prototype.formatError = function(token, message) {
        var buffer2 = this.buffer;
        if (typeof buffer2 === "string") {
          var lines = buffer2.split("\n").slice(Math.max(0, this.line - 5), this.line);
          var nextLineBreak = buffer2.indexOf("\n", this.index);
          if (nextLineBreak === -1) nextLineBreak = buffer2.length;
          var col = this.index - this.lastLineBreak;
          var lastLineDigits = String(this.line).length;
          message += " at line " + this.line + " col " + col + ":\n\n";
          message += lines.map(function(line, i) {
            return pad3(this.line - lines.length + i + 1, lastLineDigits) + " " + line;
          }, this).join("\n");
          message += "\n" + pad3("", lastLineDigits + col) + "^\n";
          return message;
        } else {
          return message + " at index " + (this.index - 1);
        }
        function pad3(n, length2) {
          var s = String(n);
          return Array(length2 - s.length + 1).join(" ") + s;
        }
      };
      function Parser2(rules2, start2, options2) {
        if (rules2 instanceof Grammar) {
          var grammar2 = rules2;
          var options2 = start2;
        } else {
          var grammar2 = Grammar.fromCompiled(rules2, start2);
        }
        this.grammar = grammar2;
        this.options = {
          keepHistory: false,
          lexer: grammar2.lexer || new StreamLexer()
        };
        for (var key in options2 || {}) {
          this.options[key] = options2[key];
        }
        this.lexer = this.options.lexer;
        this.lexerState = void 0;
        var column = new Column(grammar2, 0);
        this.table = [column];
        column.wants[grammar2.start] = [];
        column.predict(grammar2.start);
        column.process();
        this.current = 0;
      }
      Parser2.fail = {};
      Parser2.prototype.feed = function(chunk) {
        var lexer = this.lexer;
        lexer.reset(chunk, this.lexerState);
        var token;
        while (true) {
          try {
            token = lexer.next();
            if (!token) {
              break;
            }
          } catch (e) {
            var nextColumn = new Column(this.grammar, this.current + 1);
            this.table.push(nextColumn);
            var err = new Error(this.reportLexerError(e));
            err.offset = this.current;
            err.token = e.token;
            throw err;
          }
          var column = this.table[this.current];
          if (!this.options.keepHistory) {
            delete this.table[this.current - 1];
          }
          var n = this.current + 1;
          var nextColumn = new Column(this.grammar, n);
          this.table.push(nextColumn);
          var literal = token.text !== void 0 ? token.text : token.value;
          var value = lexer.constructor === StreamLexer ? token.value : token;
          var scannable = column.scannable;
          for (var w = scannable.length; w--; ) {
            var state = scannable[w];
            var expect = state.rule.symbols[state.dot];
            if (expect.test ? expect.test(value) : expect.type ? expect.type === token.type : expect.literal === literal) {
              var next = state.nextState({
                data: value,
                token,
                isToken: true,
                reference: n - 1
              });
              nextColumn.states.push(next);
            }
          }
          nextColumn.process();
          if (nextColumn.states.length === 0) {
            var err = new Error(this.reportError(token));
            err.offset = this.current;
            err.token = token;
            throw err;
          }
          if (this.options.keepHistory) {
            column.lexerState = lexer.save();
          }
          this.current++;
        }
        if (column) {
          this.lexerState = lexer.save();
        }
        this.results = this.finish();
        return this;
      };
      Parser2.prototype.reportLexerError = function(lexerError) {
        var tokenDisplay, lexerMessage;
        var token = lexerError.token;
        if (token) {
          tokenDisplay = "input " + JSON.stringify(token.text[0]) + " (lexer error)";
          lexerMessage = this.lexer.formatError(token, "Syntax error");
        } else {
          tokenDisplay = "input (lexer error)";
          lexerMessage = lexerError.message;
        }
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
      };
      Parser2.prototype.reportError = function(token) {
        var tokenDisplay = (token.type ? token.type + " token: " : "") + JSON.stringify(token.value !== void 0 ? token.value : token);
        var lexerMessage = this.lexer.formatError(token, "Syntax error");
        return this.reportErrorCommon(lexerMessage, tokenDisplay);
      };
      Parser2.prototype.reportErrorCommon = function(lexerMessage, tokenDisplay) {
        var lines = [];
        lines.push(lexerMessage);
        var lastColumnIndex = this.table.length - 2;
        var lastColumn = this.table[lastColumnIndex];
        var expectantStates = lastColumn.states.filter(function(state) {
          var nextSymbol = state.rule.symbols[state.dot];
          return nextSymbol && typeof nextSymbol !== "string";
        });
        if (expectantStates.length === 0) {
          lines.push("Unexpected " + tokenDisplay + ". I did not expect any more input. Here is the state of my parse table:\n");
          this.displayStateStack(lastColumn.states, lines);
        } else {
          lines.push("Unexpected " + tokenDisplay + ". Instead, I was expecting to see one of the following:\n");
          var stateStacks = expectantStates.map(function(state) {
            return this.buildFirstStateStack(state, []) || [state];
          }, this);
          stateStacks.forEach(function(stateStack) {
            var state = stateStack[0];
            var nextSymbol = state.rule.symbols[state.dot];
            var symbolDisplay = this.getSymbolDisplay(nextSymbol);
            lines.push("A " + symbolDisplay + " based on:");
            this.displayStateStack(stateStack, lines);
          }, this);
        }
        lines.push("");
        return lines.join("\n");
      };
      Parser2.prototype.displayStateStack = function(stateStack, lines) {
        var lastDisplay;
        var sameDisplayCount = 0;
        for (var j = 0; j < stateStack.length; j++) {
          var state = stateStack[j];
          var display = state.rule.toString(state.dot);
          if (display === lastDisplay) {
            sameDisplayCount++;
          } else {
            if (sameDisplayCount > 0) {
              lines.push("    ^ " + sameDisplayCount + " more lines identical to this");
            }
            sameDisplayCount = 0;
            lines.push("    " + display);
          }
          lastDisplay = display;
        }
      };
      Parser2.prototype.getSymbolDisplay = function(symbol) {
        return getSymbolLongDisplay(symbol);
      };
      Parser2.prototype.buildFirstStateStack = function(state, visited) {
        if (visited.indexOf(state) !== -1) {
          return null;
        }
        if (state.wantedBy.length === 0) {
          return [state];
        }
        var prevState = state.wantedBy[0];
        var childVisited = [state].concat(visited);
        var childResult = this.buildFirstStateStack(prevState, childVisited);
        if (childResult === null) {
          return null;
        }
        return [state].concat(childResult);
      };
      Parser2.prototype.save = function() {
        var column = this.table[this.current];
        column.lexerState = this.lexerState;
        return column;
      };
      Parser2.prototype.restore = function(column) {
        var index2 = column.index;
        this.current = index2;
        this.table[index2] = column;
        this.table.splice(index2 + 1);
        this.lexerState = column.lexerState;
        this.results = this.finish();
      };
      Parser2.prototype.rewind = function(index2) {
        if (!this.options.keepHistory) {
          throw new Error("set option `keepHistory` to enable rewinding");
        }
        this.restore(this.table[index2]);
      };
      Parser2.prototype.finish = function() {
        var considerations = [];
        var start2 = this.grammar.start;
        var column = this.table[this.table.length - 1];
        column.states.forEach(function(t) {
          if (t.rule.name === start2 && t.dot === t.rule.symbols.length && t.reference === 0 && t.data !== Parser2.fail) {
            considerations.push(t);
          }
        });
        return considerations.map(function(c) {
          return c.data;
        });
      };
      function getSymbolLongDisplay(symbol) {
        var type2 = typeof symbol;
        if (type2 === "string") {
          return symbol;
        } else if (type2 === "object") {
          if (symbol.literal) {
            return JSON.stringify(symbol.literal);
          } else if (symbol instanceof RegExp) {
            return "character matching " + symbol;
          } else if (symbol.type) {
            return symbol.type + " token";
          } else if (symbol.test) {
            return "token matching " + String(symbol.test);
          } else {
            throw new Error("Unknown symbol type: " + symbol);
          }
        }
      }
      function getSymbolShortDisplay(symbol) {
        var type2 = typeof symbol;
        if (type2 === "string") {
          return symbol;
        } else if (type2 === "object") {
          if (symbol.literal) {
            return JSON.stringify(symbol.literal);
          } else if (symbol instanceof RegExp) {
            return symbol.toString();
          } else if (symbol.type) {
            return "%" + symbol.type;
          } else if (symbol.test) {
            return "<" + String(symbol.test) + ">";
          } else {
            throw new Error("Unknown symbol type: " + symbol);
          }
        }
      }
      return {
        Parser: Parser2,
        Grammar,
        Rule
      };
    });
  })(nearley$1);
  return nearley$1.exports;
}
var grammar = { exports: {} };
var lodash_flattendeep;
var hasRequiredLodash_flattendeep;
function requireLodash_flattendeep() {
  if (hasRequiredLodash_flattendeep) return lodash_flattendeep;
  hasRequiredLodash_flattendeep = 1;
  var INFINITY = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]";
  var freeGlobal2 = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var objectProto2 = Object.prototype;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var Symbol2 = root2.Symbol, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
  function baseFlatten(array2, depth, predicate, isStrict, result) {
    var index2 = -1, length2 = array2.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while (++index2 < length2) {
      var value = array2[index2];
      if (predicate(value)) {
        {
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        }
      } else {
        result[result.length] = value;
      }
    }
    return result;
  }
  function isFlattenable(value) {
    return isArray2(value) || isArguments2(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  function flattenDeep(array2) {
    var length2 = array2 ? array2.length : 0;
    return length2 ? baseFlatten(array2, INFINITY) : [];
  }
  function isArguments2(value) {
    return isArrayLikeObject2(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable2.call(value, "callee") || objectToString2.call(value) == argsTag2);
  }
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject2(value) {
    return isObjectLike2(value) && isArrayLike2(value);
  }
  function isFunction2(value) {
    var tag = isObject2(value) ? objectToString2.call(value) : "";
    return tag == funcTag2 || tag == genTag2;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type2 = typeof value;
    return !!value && (type2 == "object" || type2 == "function");
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  lodash_flattendeep = flattenDeep;
  return lodash_flattendeep;
}
var hasRequiredGrammar;
function requireGrammar() {
  if (hasRequiredGrammar) return grammar.exports;
  hasRequiredGrammar = 1;
  (function(module2) {
    (function() {
      function id2(x) {
        return x[0];
      }
      var flattenDeep = requireLodash_flattendeep();
      var appendItem = function appendItem2(a, b) {
        return function(d) {
          return d[a].concat([d[b]]);
        };
      };
      var flatten2 = function flatten3(d) {
        d = d.filter(function(r2) {
          return r2 !== null;
        });
        return flattenDeep(d);
      };
      var combinatorMap = {
        " ": "descendantCombinator",
        "+": "adjacentSiblingCombinator",
        ">": "childCombinator",
        "~": "generalSiblingCombinator"
      };
      var concatUsingCombinator = function concatUsingCombinator2(d) {
        return (Array.isArray(d[0]) ? d[0] : [d[0]]).concat({
          type: combinatorMap[d[2]]
        }).concat(d[4]);
      };
      var parseAsNumber = function parseAsNumber2(d, i, reject) {
        var joined = flattenDeep(d).join("");
        var parsed = parseFloat(joined);
        if (isNaN(parsed)) {
          return reject;
        }
        return parsed;
      };
      var parseAsBoolean = function parseAsBoolean2(d, i, reject) {
        if (d[0] === "true") return true;
        if (d[0] === "false") return false;
        return reject;
      };
      var parseFalsyPrimitive = function parseFalsyPrimitive2(d, i, reject) {
        if (d[0] === "NaN") return NaN;
        if (d[0] === "undefined") return void 0;
        if (d[0] === "null") return null;
        return reject;
      };
      var grammar2 = {
        Lexer: void 0,
        ParserRules: [{
          "name": "combinator",
          "symbols": ["selector"]
        }, {
          "name": "combinator",
          "symbols": ["combinator", "_", /[>+~ ]/, "_", "selector"],
          "postprocess": concatUsingCombinator
        }, {
          "name": "selector",
          "symbols": ["selectorBody"],
          "postprocess": function postprocess(d) {
            return {
              type: "selector",
              body: d[0]
            };
          }
        }, {
          "name": "selectorBody$ebnf$1",
          "symbols": ["typeSelector"],
          "postprocess": id2
        }, {
          "name": "selectorBody$ebnf$1",
          "symbols": [],
          "postprocess": function postprocess(d) {
            return null;
          }
        }, {
          "name": "selectorBody$ebnf$2",
          "symbols": []
        }, {
          "name": "selectorBody$ebnf$2",
          "symbols": ["selectorBody$ebnf$2", "simpleSelector"],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "selectorBody",
          "symbols": ["selectorBody$ebnf$1", "selectorBody$ebnf$2"],
          "postprocess": function postprocess(d, i, reject) {
            var selectors2 = flatten2(d);
            if (!selectors2.length) return reject;
            return selectors2;
          }
        }, {
          "name": "selectorBody$ebnf$3",
          "symbols": []
        }, {
          "name": "selectorBody$ebnf$3",
          "symbols": ["selectorBody$ebnf$3", "simpleSelector"],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "selectorBody",
          "symbols": ["universalSelector", "selectorBody$ebnf$3"],
          "postprocess": flatten2
        }, {
          "name": "simpleSelector",
          "symbols": ["idSelector"]
        }, {
          "name": "simpleSelector",
          "symbols": ["classSelector"]
        }, {
          "name": "simpleSelector",
          "symbols": ["attributeValueSelector"]
        }, {
          "name": "simpleSelector",
          "symbols": ["attributePresenceSelector"]
        }, {
          "name": "simpleSelector",
          "symbols": ["pseudoClassSelector"]
        }, {
          "name": "simpleSelector",
          "symbols": ["pseudoElementSelector"]
        }, {
          "name": "typeSelector",
          "symbols": ["attributeName"],
          "postprocess": function postprocess(d) {
            return {
              type: "typeSelector",
              name: d[0]
            };
          }
        }, {
          "name": "className$ebnf$1",
          "symbols": [{
            "literal": "-"
          }],
          "postprocess": id2
        }, {
          "name": "className$ebnf$1",
          "symbols": [],
          "postprocess": function postprocess(d) {
            return null;
          }
        }, {
          "name": "className$ebnf$2",
          "symbols": []
        }, {
          "name": "className$ebnf$2",
          "symbols": ["className$ebnf$2", /[_a-zA-Z0-9-]/],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "className",
          "symbols": ["className$ebnf$1", /[_a-zA-Z]/, "className$ebnf$2"],
          "postprocess": function postprocess(d) {
            return (d[0] || "") + d[1] + d[2].join("");
          }
        }, {
          "name": "attributeName$ebnf$1",
          "symbols": []
        }, {
          "name": "attributeName$ebnf$1",
          "symbols": ["attributeName$ebnf$1", /[_a-zA-Z()0-9-]/],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "attributeName",
          "symbols": [/[_a-z()A-Z]/, "attributeName$ebnf$1"],
          "postprocess": function postprocess(d) {
            return d[0] + d[1].join("");
          }
        }, {
          "name": "classSelector",
          "symbols": [{
            "literal": "."
          }, "className"],
          "postprocess": function postprocess(d) {
            return {
              type: "classSelector",
              name: d[1]
            };
          }
        }, {
          "name": "idSelector",
          "symbols": [{
            "literal": "#"
          }, "attributeName"],
          "postprocess": function postprocess(d) {
            return {
              type: "idSelector",
              name: d[1]
            };
          }
        }, {
          "name": "universalSelector",
          "symbols": [{
            "literal": "*"
          }],
          "postprocess": function postprocess(d) {
            return {
              type: "universalSelector"
            };
          }
        }, {
          "name": "attributePresenceSelector",
          "symbols": [{
            "literal": "["
          }, "attributeName", {
            "literal": "]"
          }],
          "postprocess": function postprocess(d) {
            return {
              type: "attributePresenceSelector",
              name: d[1]
            };
          }
        }, {
          "name": "attributeOperator",
          "symbols": [{
            "literal": "="
          }]
        }, {
          "name": "attributeOperator$string$1",
          "symbols": [{
            "literal": "~"
          }, {
            "literal": "="
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "attributeOperator",
          "symbols": ["attributeOperator$string$1"]
        }, {
          "name": "attributeOperator$string$2",
          "symbols": [{
            "literal": "|"
          }, {
            "literal": "="
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "attributeOperator",
          "symbols": ["attributeOperator$string$2"]
        }, {
          "name": "attributeOperator$string$3",
          "symbols": [{
            "literal": "^"
          }, {
            "literal": "="
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "attributeOperator",
          "symbols": ["attributeOperator$string$3"]
        }, {
          "name": "attributeOperator$string$4",
          "symbols": [{
            "literal": "$"
          }, {
            "literal": "="
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "attributeOperator",
          "symbols": ["attributeOperator$string$4"]
        }, {
          "name": "attributeOperator$string$5",
          "symbols": [{
            "literal": "*"
          }, {
            "literal": "="
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "attributeOperator",
          "symbols": ["attributeOperator$string$5"]
        }, {
          "name": "attributeValueSelector",
          "symbols": [{
            "literal": "["
          }, "attributeName", "attributeOperator", "attributeValue", {
            "literal": "]"
          }],
          "postprocess": function postprocess(d) {
            return {
              type: "attributeValueSelector",
              name: d[1],
              value: d[3],
              operator: d[2][0]
            };
          }
        }, {
          "name": "attributeValue",
          "symbols": ["falsyPrimitiveStrings"],
          "postprocess": id2
        }, {
          "name": "attributeValue",
          "symbols": ["numericValue"],
          "postprocess": id2
        }, {
          "name": "attributeValue",
          "symbols": ["sqstring"],
          "postprocess": id2
        }, {
          "name": "attributeValue",
          "symbols": ["dqstring"],
          "postprocess": id2
        }, {
          "name": "falsyPrimitiveStrings$string$1",
          "symbols": [{
            "literal": "f"
          }, {
            "literal": "a"
          }, {
            "literal": "l"
          }, {
            "literal": "s"
          }, {
            "literal": "e"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "falsyPrimitiveStrings",
          "symbols": ["falsyPrimitiveStrings$string$1"],
          "postprocess": parseAsBoolean
        }, {
          "name": "falsyPrimitiveStrings$string$2",
          "symbols": [{
            "literal": "t"
          }, {
            "literal": "r"
          }, {
            "literal": "u"
          }, {
            "literal": "e"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "falsyPrimitiveStrings",
          "symbols": ["falsyPrimitiveStrings$string$2"],
          "postprocess": parseAsBoolean
        }, {
          "name": "falsyPrimitiveStrings$string$3",
          "symbols": [{
            "literal": "N"
          }, {
            "literal": "a"
          }, {
            "literal": "N"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "falsyPrimitiveStrings",
          "symbols": ["falsyPrimitiveStrings$string$3"],
          "postprocess": parseFalsyPrimitive
        }, {
          "name": "falsyPrimitiveStrings$string$4",
          "symbols": [{
            "literal": "n"
          }, {
            "literal": "u"
          }, {
            "literal": "l"
          }, {
            "literal": "l"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "falsyPrimitiveStrings",
          "symbols": ["falsyPrimitiveStrings$string$4"],
          "postprocess": parseFalsyPrimitive
        }, {
          "name": "falsyPrimitiveStrings$string$5",
          "symbols": [{
            "literal": "u"
          }, {
            "literal": "n"
          }, {
            "literal": "d"
          }, {
            "literal": "e"
          }, {
            "literal": "f"
          }, {
            "literal": "i"
          }, {
            "literal": "n"
          }, {
            "literal": "e"
          }, {
            "literal": "d"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "falsyPrimitiveStrings",
          "symbols": ["falsyPrimitiveStrings$string$5"],
          "postprocess": parseFalsyPrimitive
        }, {
          "name": "numericValue",
          "symbols": ["int", {
            "literal": "."
          }, "int"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue",
          "symbols": [{
            "literal": "+"
          }, "int", {
            "literal": "."
          }, "int"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue",
          "symbols": [{
            "literal": "-"
          }, "int", {
            "literal": "."
          }, "int"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue",
          "symbols": [{
            "literal": "-"
          }, "int"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue",
          "symbols": ["int"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue",
          "symbols": [{
            "literal": "+"
          }, "int"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue$string$1",
          "symbols": [{
            "literal": "I"
          }, {
            "literal": "n"
          }, {
            "literal": "f"
          }, {
            "literal": "i"
          }, {
            "literal": "n"
          }, {
            "literal": "i"
          }, {
            "literal": "t"
          }, {
            "literal": "y"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "numericValue",
          "symbols": ["numericValue$string$1"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue$string$2",
          "symbols": [{
            "literal": "+"
          }, {
            "literal": "I"
          }, {
            "literal": "n"
          }, {
            "literal": "f"
          }, {
            "literal": "i"
          }, {
            "literal": "n"
          }, {
            "literal": "i"
          }, {
            "literal": "t"
          }, {
            "literal": "y"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "numericValue",
          "symbols": ["numericValue$string$2"],
          "postprocess": parseAsNumber
        }, {
          "name": "numericValue$string$3",
          "symbols": [{
            "literal": "-"
          }, {
            "literal": "I"
          }, {
            "literal": "n"
          }, {
            "literal": "f"
          }, {
            "literal": "i"
          }, {
            "literal": "n"
          }, {
            "literal": "i"
          }, {
            "literal": "t"
          }, {
            "literal": "y"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "numericValue",
          "symbols": ["numericValue$string$3"],
          "postprocess": parseAsNumber
        }, {
          "name": "int$ebnf$1",
          "symbols": [/[0-9]/]
        }, {
          "name": "int$ebnf$1",
          "symbols": ["int$ebnf$1", /[0-9]/],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "int",
          "symbols": ["int$ebnf$1"]
        }, {
          "name": "classParameters",
          "symbols": []
        }, {
          "name": "classParameters",
          "symbols": ["classParameter"]
        }, {
          "name": "classParameters",
          "symbols": ["classParameters", {
            "literal": ","
          }, "_", "classParameter"],
          "postprocess": appendItem(0, 3)
        }, {
          "name": "classParameter$ebnf$1",
          "symbols": [/[^()"', ]/]
        }, {
          "name": "classParameter$ebnf$1",
          "symbols": ["classParameter$ebnf$1", /[^()"', ]/],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "classParameter",
          "symbols": ["classParameter$ebnf$1"],
          "postprocess": function postprocess(d) {
            return d[0].join("");
          }
        }, {
          "name": "classParameter",
          "symbols": ["sqstring"],
          "postprocess": id2
        }, {
          "name": "classParameter",
          "symbols": ["dqstring"],
          "postprocess": id2
        }, {
          "name": "pseudoElementSelector$string$1",
          "symbols": [{
            "literal": ":"
          }, {
            "literal": ":"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "pseudoElementSelector",
          "symbols": ["pseudoElementSelector$string$1", "pseudoClassSelectorName"],
          "postprocess": function postprocess(d) {
            return {
              type: "pseudoElementSelector",
              name: d[1]
            };
          }
        }, {
          "name": "pseudoClassSelector",
          "symbols": [{
            "literal": ":"
          }, "pseudoClassSelectorName"],
          "postprocess": function postprocess(d) {
            return {
              type: "pseudoClassSelector",
              name: d[1]
            };
          }
        }, {
          "name": "pseudoClassSelector",
          "symbols": [{
            "literal": ":"
          }, "pseudoClassSelectorName", {
            "literal": "("
          }, "classParameters", {
            "literal": ")"
          }],
          "postprocess": function postprocess(d) {
            return {
              type: "pseudoClassSelector",
              name: d[1],
              parameters: d[3]
            };
          }
        }, {
          "name": "pseudoClassSelectorName$ebnf$1",
          "symbols": [/[a-zA-Z0-9-_]/]
        }, {
          "name": "pseudoClassSelectorName$ebnf$1",
          "symbols": ["pseudoClassSelectorName$ebnf$1", /[a-zA-Z0-9-_]/],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "pseudoClassSelectorName",
          "symbols": [/[a-zA-Z]/, "pseudoClassSelectorName$ebnf$1"],
          "postprocess": function postprocess(d) {
            return d[0] + d[1].join("");
          }
        }, {
          "name": "dqstring$ebnf$1",
          "symbols": []
        }, {
          "name": "dqstring$ebnf$1",
          "symbols": ["dqstring$ebnf$1", "dstrchar"],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "dqstring",
          "symbols": [{
            "literal": '"'
          }, "dqstring$ebnf$1", {
            "literal": '"'
          }],
          "postprocess": function postprocess(d) {
            return d[1].join("");
          }
        }, {
          "name": "dstrchar",
          "symbols": [/[^"]/],
          "postprocess": id2
        }, {
          "name": "dstrchar$string$1",
          "symbols": [{
            "literal": "\\"
          }, {
            "literal": '"'
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "dstrchar",
          "symbols": ["dstrchar$string$1"],
          "postprocess": function postprocess(d) {
            return '"';
          }
        }, {
          "name": "sqstring$ebnf$1",
          "symbols": []
        }, {
          "name": "sqstring$ebnf$1",
          "symbols": ["sqstring$ebnf$1", "sstrchar"],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "sqstring",
          "symbols": [{
            "literal": "'"
          }, "sqstring$ebnf$1", {
            "literal": "'"
          }],
          "postprocess": function postprocess(d) {
            return d[1].join("");
          }
        }, {
          "name": "sstrchar",
          "symbols": [/[^']/],
          "postprocess": id2
        }, {
          "name": "sstrchar$string$1",
          "symbols": [{
            "literal": "\\"
          }, {
            "literal": "'"
          }],
          "postprocess": function joiner(d) {
            return d.join("");
          }
        }, {
          "name": "sstrchar",
          "symbols": ["sstrchar$string$1"],
          "postprocess": function postprocess(d) {
            return "'";
          }
        }, {
          "name": "_$ebnf$1",
          "symbols": []
        }, {
          "name": "_$ebnf$1",
          "symbols": ["_$ebnf$1", /[ ]/],
          "postprocess": function arrpush(d) {
            return d[0].concat([d[1]]);
          }
        }, {
          "name": "_",
          "symbols": ["_$ebnf$1"],
          "postprocess": function postprocess(d) {
            return null;
          }
        }],
        ParserStart: "combinator"
      };
      {
        module2.exports = grammar2;
      }
    })();
  })(grammar);
  return grammar.exports;
}
var hasRequiredCreateParser;
function requireCreateParser() {
  if (hasRequiredCreateParser) return createParser;
  hasRequiredCreateParser = 1;
  Object.defineProperty(createParser, "__esModule", {
    value: true
  });
  var _nearley = requireNearley();
  var _grammar = requireGrammar();
  var _grammar2 = _interopRequireDefault(_grammar);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  createParser.default = function() {
    var parse2 = function parse3(selector2) {
      var parser2 = new _nearley.Parser(_grammar2.default.ParserRules, _grammar2.default.ParserStart);
      var results = parser2.feed(selector2).results;
      if (results.length === 0) {
        throw new Error("Found no parsings.");
      }
      if (results.length > 1) {
        throw new Error("Ambiguous results.");
      }
      return results[0];
    };
    return {
      parse: parse2
    };
  };
  return createParser;
}
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist;
  hasRequiredDist = 1;
  Object.defineProperty(dist, "__esModule", {
    value: true
  });
  dist.createParser = dist.createGenerator = void 0;
  var _createGenerator = requireCreateGenerator();
  var _createGenerator2 = _interopRequireDefault(_createGenerator);
  var _createParser = requireCreateParser();
  var _createParser2 = _interopRequireDefault(_createParser);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  dist.createGenerator = _createGenerator2.default;
  dist.createParser = _createParser2.default;
  return dist;
}
var implementation$1;
var hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$1;
  hasRequiredImplementation$1 = 1;
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  var callBound2 = /* @__PURE__ */ requireCallBound$1();
  var $isEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  implementation$1 = function values(O) {
    var obj = RequireObjectCoercible2(O);
    var vals = [];
    for (var key in obj) {
      if ($isEnumerable(obj, key)) {
        vals[vals.length] = obj[key];
      }
    }
    return vals;
  };
  return implementation$1;
}
var polyfill$1;
var hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1) return polyfill$1;
  hasRequiredPolyfill$1 = 1;
  var implementation2 = requireImplementation$1();
  polyfill$1 = function getPolyfill() {
    return typeof Object.values === "function" ? Object.values : implementation2;
  };
  return polyfill$1;
}
var shim$1;
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var getPolyfill = requirePolyfill$1();
  var define2 = requireDefineProperties();
  shim$1 = function shimValues() {
    var polyfill2 = getPolyfill();
    define2(Object, {
      values: polyfill2
    }, {
      values: function testValues() {
        return Object.values !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$1;
}
var object_values;
var hasRequiredObject_values;
function requireObject_values() {
  if (hasRequiredObject_values) return object_values;
  hasRequiredObject_values = 1;
  var define2 = requireDefineProperties();
  var callBind2 = requireCallBind();
  var implementation2 = requireImplementation$1();
  var getPolyfill = requirePolyfill$1();
  var shim2 = requireShim$1();
  var polyfill2 = callBind2(getPolyfill(), Object);
  define2(polyfill2, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  object_values = polyfill2;
  return object_values;
}
var callBound;
var hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound;
  hasRequiredCallBound = 1;
  var GetIntrinsic2 = /* @__PURE__ */ requireGetIntrinsic$1();
  var callBind2 = requireCallBind();
  var $indexOf = callBind2(GetIntrinsic2("String.prototype.indexOf"));
  callBound = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic2(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
      return callBind2(intrinsic);
    }
    return intrinsic;
  };
  return callBound;
}
var implementation;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation;
  hasRequiredImplementation = 1;
  var ArraySpeciesCreate2 = /* @__PURE__ */ requireArraySpeciesCreate();
  var Call2 = /* @__PURE__ */ requireCall();
  var CreateDataPropertyOrThrow2 = /* @__PURE__ */ requireCreateDataPropertyOrThrow();
  var Get2 = /* @__PURE__ */ requireGet();
  var HasProperty2 = /* @__PURE__ */ requireHasProperty();
  var IsCallable2 = /* @__PURE__ */ requireIsCallable();
  var LengthOfArrayLike2 = /* @__PURE__ */ requireLengthOfArrayLike();
  var ToBoolean2 = /* @__PURE__ */ requireToBoolean();
  var ToObject2 = /* @__PURE__ */ requireToObject$1();
  var ToString2 = /* @__PURE__ */ requireToString();
  var callBound2 = requireCallBound();
  var isString2 = requireIsString();
  var $Object = /* @__PURE__ */ requireEsObjectAtoms();
  var boxedString = $Object("a");
  var splitString = boxedString[0] !== "a" || !(0 in boxedString);
  var strSplit = callBound2("String.prototype.split");
  implementation = function filter2(callbackfn) {
    var O = ToObject2(this);
    var self2 = splitString && isString2(O) ? strSplit(O, "") : O;
    var len = LengthOfArrayLike2(self2);
    if (!IsCallable2(callbackfn)) {
      throw new TypeError("Array.prototype.filter callback must be a function");
    }
    var thisArg;
    if (arguments.length > 1) {
      thisArg = arguments[1];
    }
    var A5 = ArraySpeciesCreate2(O, 0);
    var k = 0;
    var to = 0;
    while (k < len) {
      var Pk = ToString2(k);
      var kPresent = HasProperty2(O, Pk);
      if (kPresent) {
        var kValue = Get2(O, Pk);
        var selected = ToBoolean2(Call2(callbackfn, thisArg, [kValue, k, O]));
        if (selected) {
          CreateDataPropertyOrThrow2(A5, ToString2(to), kValue);
          to += 1;
        }
      }
      k += 1;
    }
    return A5;
  };
  return implementation;
}
var esArrayMethodBoxesProperly;
var hasRequiredEsArrayMethodBoxesProperly;
function requireEsArrayMethodBoxesProperly() {
  if (hasRequiredEsArrayMethodBoxesProperly) return esArrayMethodBoxesProperly;
  hasRequiredEsArrayMethodBoxesProperly = 1;
  esArrayMethodBoxesProperly = function properlyBoxed(method) {
    var properlyBoxesNonStrict = true;
    var properlyBoxesStrict = true;
    var threwException = false;
    if (typeof method === "function") {
      try {
        method.call("f", function(_, __, O) {
          if (typeof O !== "object") {
            properlyBoxesNonStrict = false;
          }
        });
        method.call([null], function() {
          "use strict";
          properlyBoxesStrict = typeof this === "string";
        }, "x");
      } catch (e) {
        threwException = true;
      }
      return !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
    }
    return false;
  };
  return esArrayMethodBoxesProperly;
}
var polyfill;
var hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill;
  hasRequiredPolyfill = 1;
  var arrayMethodBoxesProperly = requireEsArrayMethodBoxesProperly();
  var implementation2 = requireImplementation();
  polyfill = function getPolyfill() {
    var method = Array.prototype.filter;
    return arrayMethodBoxesProperly(method) ? method : implementation2;
  };
  return polyfill;
}
var shim;
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var define2 = requireDefineProperties();
  var getPolyfill = requirePolyfill();
  shim = function shimArrayPrototypeMap() {
    var polyfill2 = getPolyfill();
    define2(Array.prototype, {
      filter: polyfill2
    }, {
      filter: function() {
        return Array.prototype.filter !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim;
}
var array_prototype_filter;
var hasRequiredArray_prototype_filter;
function requireArray_prototype_filter() {
  if (hasRequiredArray_prototype_filter) return array_prototype_filter;
  hasRequiredArray_prototype_filter = 1;
  var define2 = requireDefineProperties();
  var RequireObjectCoercible2 = /* @__PURE__ */ requireRequireObjectCoercible();
  var callBind2 = requireCallBind();
  var callBound2 = requireCallBound();
  var implementation2 = requireImplementation();
  var getPolyfill = requirePolyfill();
  var polyfill2 = callBind2.apply(getPolyfill());
  var shim2 = requireShim();
  var $slice = callBound2("Array.prototype.slice");
  var bound = function filter2(array2, callbackfn) {
    RequireObjectCoercible2(array2);
    return polyfill2(array2, $slice(arguments, 1));
  };
  define2(bound, {
    getPolyfill,
    implementation: implementation2,
    shim: shim2
  });
  array_prototype_filter = bound;
  return array_prototype_filter;
}
var getData;
var hasRequiredGetData;
function requireGetData() {
  if (hasRequiredGetData) return getData;
  hasRequiredGetData = 1;
  var callBound2 = requireCallBound();
  var $push = callBound2("Array.prototype.push");
  var map2 = function(arr, mapper) {
    var mapped = [];
    for (var i = 0; i < arr.length; i += 1) {
      $push(mapped, mapper(arr[i], i));
    }
    return mapped;
  };
  var expecteds = [
    ["HTMLElement", "article"],
    ["HTMLElement", "section"],
    ["HTMLBaseFontElement", "basefont", "HTMLBaseFontElementConstructor"],
    // Safari 5.1
    ["HTMLPhraseElement", "cite", "HTMLElement"],
    // Safari 5.1
    ["HTMLElement", "noscript"],
    ["HTMLBGSoundElement", "bgsound", "HTMLElement"],
    // Safari 5.1
    ["HTMLPhraseElement", "blink", "HTMLElement"],
    // Safari 5.1
    ["HTMLElement", "multicol"],
    ["HTMLNextIdElement", "nextid", "HTMLElement"],
    // Safari 5.1
    ["HTMLElement", "rb"],
    ["HTMLElement", "spacer"],
    ["HTMLAnchorElement", "a", "HTMLElement"],
    // Safari 5.1
    // ['HTMLAppletElement', 'applet'], // commented out due to IE 11 java update popup
    ["HTMLAreaElement", "area", "HTMLElement"],
    // Safari 5.1
    ["HTMLAudioElement", "audio", "HTMLElement"],
    // Safari 5.1
    ["HTMLBaseElement", "base", "HTMLElement"],
    // Safari 5.1
    ["HTMLBodyElement", "body", "HTMLElement"],
    // Safari 5.1
    ["HTMLBRElement", "br", "HTMLElement"],
    // Safari 5.1
    ["HTMLButtonElement", "button"],
    ["HTMLCanvasElement", "canvas"],
    ["HTMLContentElement", "content", "HTMLElement"],
    // Safari 5.1
    ["HTMLDataElement", "data", "HTMLElement"],
    // Safari 5.1
    ["HTMLDataListElement", "datalist"],
    ["HTMLDialogElement", "dialog", "HTMLElement"],
    // Safari 5.1
    ["HTMLDirectoryElement", "dir"],
    ["HTMLDivElement", "div"],
    ["HTMLDListElement", "dl"],
    ["HTMLEmbedElement", "embed"],
    ["HTMLFieldSetElement", "fieldset"],
    ["HTMLFontElement", "font"],
    ["HTMLFormElement", "form"],
    ["HTMLFrameElement", "frame"],
    ["HTMLFrameSetElement", "frameset"],
    ["HTMLHeadElement", "head"],
    ["HTMLHeadingElement", "h1"],
    ["HTMLHeadingElement", "h2"],
    ["HTMLHeadingElement", "h3"],
    ["HTMLHeadingElement", "h4"],
    ["HTMLHeadingElement", "h5"],
    ["HTMLHeadingElement", "h6"],
    ["HTMLHtmlElement", "html"],
    ["HTMLHRElement", "hr"],
    ["HTMLIFrameElement", "iframe"],
    ["HTMLImageElement", "img"],
    ["HTMLInputElement", "input"],
    ["HTMLIsIndexElement", "index", "HTMLElement"],
    // in HTML5, this is HTMLUnknownElement (Safari 5.1 for HTMLElement)
    ["HTMLKeygenElement", "keygen", "HTMLBlockElement"],
    ["HTMLLabelElement", "label"],
    ["HTMLLegendElement", "legend"],
    ["HTMLLIElement", "li"],
    ["HTMLLinkElement", "link"],
    ["HTMLElement", "main"],
    // in IE 9-11, this is HTMLUnknownElement
    ["HTMLMapElement", "map"],
    ["HTMLMarqueeElement", "marquee"],
    ["HTMLMenuElement", "menu"],
    ["HTMLMetaElement", "meta"],
    ["HTMLMeterElement", "meter", "HTMLElement"],
    // Safari 5.1
    ["HTMLModElement", "del"],
    ["HTMLModElement", "ins"],
    ["HTMLObjectElement", "object"],
    ["HTMLOListElement", "ol"],
    ["HTMLOptGroupElement", "optgroup"],
    ["HTMLOptionElement", "option"],
    ["HTMLOutputElement", "output"],
    ["HTMLParagraphElement", "p"],
    ["HTMLParamElement", "param"],
    ["HTMLPictureElement", "picture", "HTMLElement"],
    // Safari 5.1
    ["HTMLPreElement", "pre"],
    ["HTMLProgressElement", "progress", "HTMLElement"],
    // Safari 5.1
    ["HTMLQuoteElement", "q", "HTMLBlockquoteElement"],
    // Safari 5.1
    ["HTMLQuoteElement", "blockquote", "HTMLBlockElement", "HTMLBlockquoteElement"],
    // Safari 5.1
    ["HTMLScriptElement", "script"],
    ["HTMLSelectElement", "select"],
    ["HTMLShadowElement", "shadow", "HTMLElement"],
    // Safari 5.1
    ["HTMLSourceElement", "source"],
    ["HTMLSpanElement", "span", "HTMLElement"],
    // Safari 5.1
    ["HTMLStyleElement", "style"],
    ["HTMLTableElement", "table"],
    ["HTMLTableCaptionElement", "caption"],
    ["HTMLTableCellElement", "td", "HTMLTableDataCellElement"],
    ["HTMLTableCellElement", "th", "HTMLTableHeaderCellElement"],
    ["HTMLTableRowElement", "tr"],
    ["HTMLTableColElement", "col"],
    ["HTMLTableColElement", "colgroup"],
    ["HTMLTableSectionElement", "tbody"],
    ["HTMLTableSectionElement", "thead"],
    ["HTMLTableSectionElement", "tfoot"],
    ["HTMLTemplateElement", "template", "HTMLElement"],
    // Safari 5.1
    ["HTMLTextAreaElement", "textarea"],
    ["HTMLTimeElement", "time", "HTMLElement"],
    // Safari 5.1
    ["HTMLTitleElement", "title"],
    ["HTMLTrackElement", "track", "HTMLElement"],
    // Safari 5.1
    ["HTMLUListElement", "ul"],
    ["HTMLVideoElement", "video"],
    ["HTMLElement", "abbr"],
    ["HTMLElement", "address"],
    ["HTMLElement", "aside"],
    ["HTMLElement", "b"],
    ["HTMLElement", "bdi"],
    ["HTMLElement", "bdo"],
    ["HTMLElement", "code"],
    ["HTMLElement", "dd"],
    ["HTMLDetailsElement", "details", "HTMLElement"],
    // Safari 5.1
    ["HTMLElement", "dfn"],
    ["HTMLElement", "dt"],
    ["HTMLElement", "em"],
    ["HTMLElement", "figcaption"],
    ["HTMLElement", "figure"],
    ["HTMLElement", "footer"],
    ["HTMLElement", "header"],
    ["HTMLElement", "hgroup"],
    ["HTMLElement", "i"],
    ["HTMLElement", "kbd"],
    ["HTMLElement", "mark"],
    ["HTMLElement", "nav"],
    ["HTMLElement", "rp"],
    ["HTMLElement", "rt"],
    ["HTMLElement", "ruby"],
    ["HTMLElement", "s"],
    ["HTMLElement", "samp"],
    ["HTMLSlotElement", "slot", "HTMLElement"],
    // Safari 5.1
    ["HTMLElement", "small"],
    ["HTMLElement", "strong"],
    ["HTMLElement", "summary"],
    ["HTMLElement", "u"],
    ["HTMLElement", "var"],
    ["HTMLElement", "wbr"]
  ];
  var getConstructor = function getTagConstructor(tag, constructor, unknown) {
    if (typeof document !== "undefined" && typeof document.createElement === "function") {
      var actual = document.createElement(tag).constructor;
      if (actual !== unknown) {
        return actual;
      }
    }
  };
  getData = function getData2() {
    var unknown = globalThis.HTMLUnknownElement;
    return {
      all: globalThis.HTMLElement,
      elements: map2(expecteds, function(expected) {
        var constructorName = expected[0];
        var tag = expected[1];
        var alternate;
        var altConstructor;
        for (var i = 2; i < arguments.length && !altConstructor; i += 1) {
          alternate = expected[i];
          altConstructor = alternate && globalThis[alternate];
        }
        var constructor = globalThis[constructorName];
        return {
          constructor: getConstructor(tag, altConstructor || constructor, unknown),
          constructorName: altConstructor ? alternate : constructorName,
          expectedConstructor: altConstructor || constructor,
          tag
        };
      }),
      unknown
    };
  };
  return getData;
}
var byConstructor;
var hasRequiredByConstructor;
function requireByConstructor() {
  if (hasRequiredByConstructor) return byConstructor;
  hasRequiredByConstructor = 1;
  var filter2 = requireArray_prototype_filter();
  var getData2 = requireGetData();
  byConstructor = function byConstructor2(constructor) {
    if (!constructor) {
      return [];
    }
    var data2 = getData2();
    if (constructor === data2.unknown) {
      return [];
    }
    if (constructor === data2.all) {
      return data2.elements;
    }
    return filter2(data2.elements, function(item) {
      return item.constructor === constructor;
    });
  };
  return byConstructor;
}
var hasRequiredSelectors;
function requireSelectors() {
  if (hasRequiredSelectors) return selectors;
  hasRequiredSelectors = 1;
  Object.defineProperty(selectors, "__esModule", {
    value: true
  });
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _slicedToArray = /* @__PURE__ */ (function() {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function(arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  })();
  selectors.buildPredicate = buildPredicate;
  selectors.reduceTreeBySelector = reduceTreeBySelector;
  selectors.reduceTreesBySelector = reduceTreesBySelector;
  var _rstSelectorParser = requireDist();
  var _object = requireObject_values();
  var _object2 = _interopRequireDefault(_object);
  var _arrayPrototype = requireArray_prototype_flat();
  var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
  var _objectIs = requireObjectIs();
  var _objectIs2 = _interopRequireDefault(_objectIs);
  var _has = requireSrc$1();
  var _has2 = _interopRequireDefault(_has);
  var _byConstructor = requireByConstructor();
  var _byConstructor2 = _interopRequireDefault(_byConstructor);
  var _RSTTraversal = requireRSTTraversal();
  var _Utils = requireUtils();
  var _getAdapter = requireGetAdapter();
  var _getAdapter2 = _interopRequireDefault(_getAdapter);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  var parser2 = (0, _rstSelectorParser.createParser)();
  var CHILD = "childCombinator";
  var ADJACENT_SIBLING = "adjacentSiblingCombinator";
  var GENERAL_SIBLING = "generalSiblingCombinator";
  var DESCENDANT = "descendantCombinator";
  var SELECTOR2 = "selector";
  var TYPE_SELECTOR = "typeSelector";
  var CLASS_SELECTOR = "classSelector";
  var ID_SELECTOR = "idSelector";
  var UNIVERSAL_SELECTOR = "universalSelector";
  var ATTRIBUTE_PRESENCE = "attributePresenceSelector";
  var ATTRIBUTE_VALUE = "attributeValueSelector";
  var PSEUDO_CLASS = "pseudoClassSelector";
  var PSEUDO_ELEMENT = "pseudoElementSelector";
  var EXACT_ATTRIBUTE_OPERATOR = "=";
  var WHITELIST_ATTRIBUTE_OPERATOR = "~=";
  var HYPHENATED_ATTRIBUTE_OPERATOR = "|=";
  var PREFIX_ATTRIBUTE_OPERATOR = "^=";
  var SUFFIX_ATTRIBUTE_OPERATOR = "$=";
  var SUBSTRING_ATTRIBUTE_OPERATOR = "*=";
  function unique2(arr) {
    return [].concat(_toConsumableArray(new Set(arr)));
  }
  function uniqueReduce(fn, nodes) {
    return unique2(nodes.reduce(fn, []));
  }
  function safelyGenerateTokens(selector2) {
    try {
      return parser2.parse(selector2);
    } catch (err) {
      throw new Error("Failed to parse selector: " + String(selector2));
    }
  }
  function matchAttributeSelector(node2, token) {
    var operator = token.operator, value = token.value, name = token.name;
    var nodeProps = (0, _Utils.propsOfNode)(node2);
    var descriptor = Object.getOwnPropertyDescriptor(nodeProps, name);
    if (descriptor && descriptor.get) {
      return false;
    }
    var nodePropValue = nodeProps[name];
    if (typeof nodePropValue === "undefined") {
      return false;
    }
    if (token.type === ATTRIBUTE_PRESENCE) {
      return (0, _has2["default"])(nodeProps, token.name);
    }
    if (typeof nodePropValue !== "string" || typeof value !== "string") {
      if (operator !== EXACT_ATTRIBUTE_OPERATOR) {
        return false;
      }
    }
    switch (operator) {
      /**
       * Represents an element with the att attribute whose value is exactly "val".
       * @example
       * [attr="val"] matches attr="val"
       */
      case EXACT_ATTRIBUTE_OPERATOR:
        return (0, _objectIs2["default"])(nodePropValue, value);
      /**
       * Represents an element with the att attribute whose value is a whitespace-separated
       * list of words, one of which is exactly
       * @example
       *  [rel~="copyright"] matches rel="copyright other"
       */
      case WHITELIST_ATTRIBUTE_OPERATOR:
        return nodePropValue.split(" ").indexOf(value) !== -1;
      /**
       * Represents an element with the att attribute, its value either being exactly the
       * value or beginning with the value immediately followed by "-"
       * @example
       * [hreflang|="en"] matches hreflang="en-US"
       */
      case HYPHENATED_ATTRIBUTE_OPERATOR:
        return nodePropValue === value || nodePropValue.startsWith(String(value) + "-");
      /**
       * Represents an element with the att attribute whose value begins with the prefix value.
       * If the value is the empty string then the selector does not represent anything.
       * @example
       * [type^="image"] matches type="imageobject"
       */
      case PREFIX_ATTRIBUTE_OPERATOR:
        return value === "" ? false : nodePropValue.slice(0, value.length) === value;
      /**
       * Represents an element with the att attribute whose value ends with the suffix value.
       * If the value is the empty string then the selector does not represent anything.
       * @example
       * [type$="image"] matches type="imageobject"
       */
      case SUFFIX_ATTRIBUTE_OPERATOR:
        return value === "" ? false : nodePropValue.slice(-value.length) === value;
      /**
       * Represents an element with the att attribute whose value contains at least one
       * instance of the value. If value is the empty string then the
       * selector does not represent anything.
       * @example
       * [title*="hello"] matches title="well hello there"
       */
      case SUBSTRING_ATTRIBUTE_OPERATOR:
        return value === "" ? false : nodePropValue.indexOf(value) !== -1;
      default:
        throw new Error('Enzyme::Selector: Unknown attribute selector operator "' + String(operator) + '"');
    }
  }
  function matchPseudoSelector(node2, token, root2) {
    var name = token.name, parameters = token.parameters;
    if (name === "not") {
      return parameters.every(function(selector2) {
        return reduceTreeBySelector(selector2, node2).length === 0;
      });
    }
    if (name === "empty") {
      return (0, _RSTTraversal.treeFilter)(node2, function(n) {
        return n !== node2;
      }).length === 0;
    }
    if (name === "first-child") {
      var _findParentNode = (0, _RSTTraversal.findParentNode)(root2, node2), rendered = _findParentNode.rendered;
      var _rendered = _slicedToArray(rendered, 1), firstChild = _rendered[0];
      return firstChild === node2;
    }
    if (name === "last-child") {
      var _findParentNode2 = (0, _RSTTraversal.findParentNode)(root2, node2), _rendered2 = _findParentNode2.rendered;
      return _rendered2[_rendered2.length - 1] === node2;
    }
    if (name === "focus") {
      if (typeof document === "undefined") {
        throw new Error('Enzyme::Selector does not support the ":focus" pseudo-element without a global `document`.');
      }
      var adapter = (0, _getAdapter2["default"])();
      return document.activeElement && adapter.nodeToHostNode(node2) === document.activeElement;
    }
    throw new TypeError('Enzyme::Selector does not support the "' + String(token.name) + '" pseudo-element or pseudo-class selectors.');
  }
  function nodeMatchesToken(node2, token, root2) {
    if (node2 === null || typeof node2 === "string") {
      return false;
    }
    switch (token.type) {
      /**
       * Match every node
       * @example '*' matches every node
       */
      case UNIVERSAL_SELECTOR:
        return true;
      /**
       * Match against the className prop
       * @example '.active' matches <div className='active' />
       */
      case CLASS_SELECTOR:
        return (0, _RSTTraversal.hasClassName)(node2, token.name);
      /**
       * Simple type matching
       * @example 'div' matches <div />
       */
      case TYPE_SELECTOR:
        return (0, _Utils.nodeHasType)(node2, token.name);
      /**
       * Match against the `id` prop
       * @example '#nav' matches <ul id="nav" />
       */
      case ID_SELECTOR:
        return (0, _RSTTraversal.nodeHasId)(node2, token.name);
      /**
       * Matches if an attribute is present, regardless
       * of its value
       * @example '[disabled]' matches <a disabled />
       */
      case ATTRIBUTE_PRESENCE:
        return matchAttributeSelector(node2, token);
      /**
       * Matches if an attribute is present with the
       * provided value
       * @example '[data-foo=foo]' matches <div data-foo="foo" />
       */
      case ATTRIBUTE_VALUE:
        return matchAttributeSelector(node2, token);
      case PSEUDO_ELEMENT:
      case PSEUDO_CLASS:
        return matchPseudoSelector(node2, token, root2);
      default:
        throw new Error("Unknown token type: " + String(token.type));
    }
  }
  function buildPredicateFromToken(token, root2) {
    return function(node2) {
      return token.body.every(function(bodyToken) {
        return nodeMatchesToken(node2, bodyToken, root2);
      });
    };
  }
  function isComplexSelector(tokens) {
    return tokens.some(function(token) {
      return token.type !== SELECTOR2;
    });
  }
  function buildPredicate(selector2) {
    if (typeof selector2 === "string") {
      var tokens = safelyGenerateTokens(selector2);
      if (isComplexSelector(tokens)) {
        throw new TypeError("This method does not support complex CSS selectors");
      }
      return buildPredicateFromToken(tokens[0]);
    }
    var adapter = (0, _getAdapter2["default"])();
    var isElementType = adapter.isValidElementType ? adapter.isValidElementType(selector2) : typeof selector2 === "function";
    if (isElementType) {
      return function(node2) {
        return adapter.matchesElementType(node2, selector2);
      };
    }
    if ((typeof selector2 === "undefined" ? "undefined" : _typeof2(selector2)) === "object") {
      if (!Array.isArray(selector2) && selector2 !== null && Object.keys(selector2).length > 0) {
        var hasUndefinedValues = (0, _object2["default"])(selector2).some(function(value) {
          return typeof value === "undefined";
        });
        if (hasUndefinedValues) {
          throw new TypeError("Enzyme::Props can’t have `undefined` values. Try using ‘findWhere()’ instead.");
        }
        return function(node2) {
          return (0, _RSTTraversal.nodeMatchesObjectProps)(node2, selector2);
        };
      }
      throw new TypeError("Enzyme::Selector does not support an array, null, or empty object as a selector");
    }
    throw new TypeError("Enzyme::Selector expects a string, object, or valid element type (Component Constructor)");
  }
  function matchAdjacentSiblings(nodes, predicate, root2) {
    return nodes.reduce(function(matches, node2) {
      var parent = (0, _RSTTraversal.findParentNode)(root2, node2);
      if (!parent) {
        return matches;
      }
      var parentChildren = (0, _RSTTraversal.childrenOfNode)(parent);
      var nodeIndex = parentChildren.indexOf(node2);
      var adjacentSibling = parentChildren[nodeIndex + 1];
      if (!adjacentSibling) {
        return matches;
      }
      if (predicate(adjacentSibling)) {
        matches.push(adjacentSibling);
      }
      return matches;
    }, []);
  }
  function matchGeneralSibling(nodes, predicate, root2) {
    return uniqueReduce(function(matches, node2) {
      var parent = (0, _RSTTraversal.findParentNode)(root2, node2);
      if (!parent) {
        return matches;
      }
      var parentChildren = (0, _RSTTraversal.childrenOfNode)(parent);
      var nodeIndex = parentChildren.indexOf(node2);
      var youngerSiblings = parentChildren.slice(nodeIndex + 1);
      return matches.concat(youngerSiblings.filter(predicate));
    }, nodes);
  }
  function matchDirectChild(nodes, predicate) {
    return uniqueReduce(function(matches, node2) {
      return matches.concat((0, _RSTTraversal.childrenOfNode)(node2).filter(predicate));
    }, nodes);
  }
  function matchDescendant(nodes, predicate) {
    return uniqueReduce(function(matches, node2) {
      return matches.concat((0, _RSTTraversal.treeFilter)(node2, predicate));
    }, (0, _arrayPrototype2["default"])(nodes.map(_RSTTraversal.childrenOfNode)));
  }
  function reduceTreeBySelector(selector2, root2) {
    if (typeof selector2 !== "string") {
      var elements = (0, _byConstructor2["default"])(selector2);
      if (elements.length > 0) {
        return (0, _arrayPrototype2["default"])(elements.map(function(x) {
          return reduceTreeBySelector(x.tag, root2);
        }));
      }
    }
    if (typeof selector2 === "function" || (typeof selector2 === "undefined" ? "undefined" : _typeof2(selector2)) === "object") {
      return (0, _RSTTraversal.treeFilter)(root2, buildPredicate(selector2));
    }
    var results = [];
    if (typeof selector2 === "string") {
      var tokens = safelyGenerateTokens(selector2);
      var index2 = 0;
      while (index2 < tokens.length) {
        var token = tokens[index2];
        if (token.type === SELECTOR2) {
          var predicate = buildPredicateFromToken(token, root2);
          results = results.concat((0, _RSTTraversal.treeFilter)(root2, predicate));
        } else {
          var type2 = token.type;
          index2 += 1;
          var _predicate = buildPredicateFromToken(tokens[index2], root2);
          switch (type2) {
            // The + combinator
            case ADJACENT_SIBLING:
              results = matchAdjacentSiblings(results, _predicate, root2);
              break;
            // The ~ combinator
            case GENERAL_SIBLING:
              results = matchGeneralSibling(results, _predicate, root2);
              break;
            // The > combinator
            case CHILD:
              results = matchDirectChild(results, _predicate);
              break;
            // The ' ' (whitespace) combinator
            case DESCENDANT: {
              results = matchDescendant(results, _predicate);
              break;
            }
            default:
              throw new Error("Unknown combinator selector: " + String(type2));
          }
        }
        index2 += 1;
      }
    } else {
      throw new TypeError("Enzyme::Selector expects a string, object, or Component Constructor");
    }
    return results;
  }
  function reduceTreesBySelector(selector2, roots) {
    var results = roots.map(function(n) {
      return reduceTreeBySelector(selector2, n);
    });
    return unique2((0, _arrayPrototype2["default"])(results, 1));
  }
  return selectors;
}
var hasRequiredReactWrapper;
function requireReactWrapper() {
  if (hasRequiredReactWrapper) return ReactWrapper;
  hasRequiredReactWrapper = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _createClass2 = /* @__PURE__ */ (function() {
      function defineProperties(target2, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target2, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();
    var _object = requireObject_assign();
    var _object2 = _interopRequireDefault(_object);
    var _arrayPrototype = requireArray_prototype_flat();
    var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
    var _has = requireSrc$1();
    var _has2 = _interopRequireDefault(_has);
    var _Utils = requireUtils();
    var _getAdapter = requireGetAdapter();
    var _getAdapter2 = _interopRequireDefault(_getAdapter);
    var _Debug = requireDebug();
    var _RSTTraversal = requireRSTTraversal();
    var _selectors = requireSelectors();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function _possibleConstructorReturn2(self2, call) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var NODE = (0, _Utils.sym)("__node__");
    var NODES = (0, _Utils.sym)("__nodes__");
    var RENDERER = (0, _Utils.sym)("__renderer__");
    var UNRENDERED = (0, _Utils.sym)("__unrendered__");
    var ROOT = (0, _Utils.sym)("__root__");
    var OPTIONS = (0, _Utils.sym)("__options__");
    var ROOT_NODES = (0, _Utils.sym)("__rootNodes__");
    var WRAPPING_COMPONENT = (0, _Utils.sym)("__wrappingComponent__");
    var LINKED_ROOTS = (0, _Utils.sym)("__linkedRoots__");
    var UPDATED_BY = (0, _Utils.sym)("__updatedBy__");
    function findWhereUnwrapped(wrapper, predicate) {
      var filter2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _RSTTraversal.treeFilter;
      return wrapper.flatMap(function(n) {
        return filter2(n.getNodeInternal(), predicate);
      });
    }
    function filterWhereUnwrapped(wrapper, predicate) {
      return wrapper.wrap(wrapper.getNodesInternal().filter(predicate).filter(Boolean));
    }
    function getRootNodeInternal(wrapper) {
      if (wrapper[ROOT].length !== 1) {
        throw new Error("getRootNodeInternal(wrapper) can only be called when wrapper wraps one node");
      }
      if (wrapper[ROOT] !== wrapper) {
        return wrapper[ROOT_NODES][0];
      }
      return wrapper[ROOT][NODE];
    }
    function nodeParents(wrapper, node2) {
      return (0, _RSTTraversal.parentsOfNode)(node2, getRootNodeInternal(wrapper));
    }
    function privateSetNodes(wrapper, nodes) {
      if (!nodes) {
        (0, _Utils.privateSet)(wrapper, NODE, null);
        (0, _Utils.privateSet)(wrapper, NODES, []);
      } else if (!Array.isArray(nodes)) {
        (0, _Utils.privateSet)(wrapper, NODE, nodes);
        (0, _Utils.privateSet)(wrapper, NODES, [nodes]);
      } else {
        (0, _Utils.privateSet)(wrapper, NODE, nodes[0]);
        (0, _Utils.privateSet)(wrapper, NODES, nodes);
      }
      (0, _Utils.privateSet)(wrapper, "length", wrapper[NODES].length);
    }
    var ReactWrapper2 = (function() {
      function ReactWrapper22(nodes, root2) {
        var passedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        _classCallCheck2(this, ReactWrapper22);
        if (!globalThis.window && !globalThis.document) {
          throw new Error("It looks like you called `mount()` without a global document being loaded.");
        }
        var options2 = (0, _Utils.makeOptions)(passedOptions);
        if (!root2) {
          var adapter = (0, _getAdapter2["default"])(options2);
          if (!adapter.isValidElement(nodes)) {
            throw new TypeError("ReactWrapper can only wrap valid elements");
          }
          var renderer = adapter.createRenderer((0, _object2["default"])({
            mode: "mount"
          }, options2));
          (0, _Utils.privateSet)(this, RENDERER, renderer);
          renderer.render(nodes, options2.context);
          (0, _Utils.privateSet)(this, ROOT, this);
          privateSetNodes(this, this[RENDERER].getNode());
          (0, _Utils.privateSet)(this, OPTIONS, options2);
          (0, _Utils.privateSet)(this, LINKED_ROOTS, []);
          if ((0, _Utils.isCustomComponent)(options2.wrappingComponent, adapter)) {
            if (typeof this[RENDERER].getWrappingComponentRenderer !== "function") {
              throw new TypeError("your adapter does not support `wrappingComponent`. Try upgrading it!");
            }
            (0, _Utils.privateSet)(this, WRAPPING_COMPONENT, new WrappingComponentWrapper(this, this[RENDERER].getWrappingComponentRenderer()));
            this[LINKED_ROOTS].push(this[WRAPPING_COMPONENT]);
          }
        } else {
          (0, _Utils.privateSet)(this, RENDERER, root2[RENDERER]);
          (0, _Utils.privateSet)(this, ROOT, root2);
          privateSetNodes(this, nodes);
          (0, _Utils.privateSet)(this, ROOT_NODES, root2[NODES]);
          (0, _Utils.privateSet)(this, OPTIONS, root2[OPTIONS]);
          (0, _Utils.privateSet)(this, LINKED_ROOTS, []);
        }
        (0, _Utils.privateSet)(this, UNRENDERED, nodes);
        (0, _Utils.privateSet)(this, UPDATED_BY, null);
      }
      _createClass2(ReactWrapper22, [{
        key: "root",
        value: /* @__PURE__ */ (function() {
          function root2() {
            return this[ROOT];
          }
          return root2;
        })()
        /**
         * Returns the wrapped component.
         *
         * @return {ReactComponent}
         */
      }, {
        key: "getNodeInternal",
        value: /* @__PURE__ */ (function() {
          function getNodeInternal() {
            if (this.length !== 1) {
              throw new Error("ReactWrapper::getNode() can only be called when wrapping one node");
            }
            return this[NODES][0];
          }
          return getNodeInternal;
        })()
        /**
         * Returns the the wrapped components.
         *
         * @return {Array<ReactComponent>}
         */
      }, {
        key: "getNodesInternal",
        value: /* @__PURE__ */ (function() {
          function getNodesInternal() {
            return this[NODES];
          }
          return getNodesInternal;
        })()
        /**
         * Returns the wrapped ReactElement.
         *
         * @return {ReactElement}
         */
      }, {
        key: "getElement",
        value: /* @__PURE__ */ (function() {
          function getElement() {
            var _this = this;
            return this.single("getElement", function() {
              return (0, _getAdapter2["default"])(_this[OPTIONS]).nodeToElement(_this[NODE]);
            });
          }
          return getElement;
        })()
        /**
         * Returns the wrapped ReactElements.
         *
         * @return {Array<ReactElement>}
         */
      }, {
        key: "getElements",
        value: /* @__PURE__ */ (function() {
          function getElements() {
            var _this2 = this;
            return this[NODES].map(function(n) {
              return (0, _getAdapter2["default"])(_this2[OPTIONS]).nodeToElement(n);
            });
          }
          return getElements;
        })()
        // eslint-disable-next-line class-methods-use-this
      }, {
        key: "getNode",
        value: /* @__PURE__ */ (function() {
          function getNode() {
            throw new Error("ReactWrapper::getNode() is no longer supported. Use ReactWrapper::instance() instead");
          }
          return getNode;
        })()
        // eslint-disable-next-line class-methods-use-this
      }, {
        key: "getNodes",
        value: /* @__PURE__ */ (function() {
          function getNodes() {
            throw new Error("ReactWrapper::getNodes() is no longer supported.");
          }
          return getNodes;
        })()
        /**
         * Returns the outer most DOMComponent of the current wrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {DOMComponent}
         */
      }, {
        key: "getDOMNode",
        value: /* @__PURE__ */ (function() {
          function getDOMNode() {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return this.single("getDOMNode", function(n) {
              return adapter.nodeToHostNode(n, true);
            });
          }
          return getDOMNode;
        })()
        /**
         * If the root component contained a ref, you can access it here and get the relevant
         * react component instance or HTML element instance.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {String} refname
         * @returns {ReactComponent | HTMLElement}
         */
      }, {
        key: "ref",
        value: /* @__PURE__ */ (function() {
          function ref2(refname) {
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::ref(refname) can only be called on the root");
            }
            return this.instance().refs[refname];
          }
          return ref2;
        })()
        /**
         * Returns the wrapper's underlying instance.
         *
         * Example:
         * ```
         * const wrapper = mount(<MyComponent />);
         * const inst = wrapper.instance();
         * expect(inst).to.be.instanceOf(MyComponent);
         * ```
         * @returns {ReactComponent|DOMComponent}
         */
      }, {
        key: "instance",
        value: /* @__PURE__ */ (function() {
          function instance() {
            var _this3 = this;
            return this.single("instance", function() {
              return _this3[NODE].instance;
            });
          }
          return instance;
        })()
        /**
         * If a `wrappingComponent` was passed in `options`, this methods returns a `ReactWrapper` around
         * the rendered `wrappingComponent`. This `ReactWrapper` can be used to update the
         * `wrappingComponent`'s props, state, etc.
         *
         * @returns ReactWrapper
         */
      }, {
        key: "getWrappingComponent",
        value: /* @__PURE__ */ (function() {
          function getWrappingComponent() {
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::getWrappingComponent() can only be called on the root");
            }
            if (!this[OPTIONS].wrappingComponent) {
              throw new Error("ReactWrapper::getWrappingComponent() can only be called on a wrapper that was originally passed a `wrappingComponent` option");
            }
            return this[WRAPPING_COMPONENT];
          }
          return getWrappingComponent;
        })()
        /**
         * Forces a re-render. Useful to run before checking the render output if something external
         * may be updating the state of the component somewhere.
         *
         * NOTE: no matter what instance this is called on, it will always update the root.
         *
         * @returns {ReactWrapper}
         */
      }, {
        key: "update",
        value: /* @__PURE__ */ (function() {
          function update() {
            var _this4 = this;
            var root2 = this[ROOT];
            if (this !== root2) {
              return root2.update();
            }
            privateSetNodes(this, this[RENDERER].getNode());
            this[LINKED_ROOTS].forEach(function(linkedRoot) {
              if (linkedRoot !== _this4[UPDATED_BY]) {
                linkedRoot[UPDATED_BY] = _this4;
                try {
                  linkedRoot.update();
                } finally {
                  linkedRoot[UPDATED_BY] = null;
                }
              }
            });
            return this;
          }
          return update;
        })()
        /**
         * A method that unmounts the component. This can be used to simulate a component going through
         * and unmount/mount lifecycle.
         *
         * @returns {ReactWrapper}
         */
      }, {
        key: "unmount",
        value: /* @__PURE__ */ (function() {
          function unmount() {
            var _this5 = this;
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::unmount() can only be called on the root");
            }
            this.single("unmount", function() {
              _this5[RENDERER].unmount();
              _this5.update();
            });
            return this;
          }
          return unmount;
        })()
        /**
         * A method that re-mounts the component, if it is not currently mounted.
         * This can be used to simulate a component going through
         * an unmount/mount lifecycle.
         *
         * @returns {ReactWrapper}
         */
      }, {
        key: "mount",
        value: /* @__PURE__ */ (function() {
          function mount2() {
            var _this6 = this;
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::mount() can only be called on the root");
            }
            this[RENDERER].render(this[UNRENDERED], this[OPTIONS].context, function() {
              return _this6.update();
            });
            return this;
          }
          return mount2;
        })()
        /**
         * A method that sets the props of the root component, and re-renders. Useful for when you are
         * wanting to test how the component behaves over time with changing props. Calling this, for
         * instance, will call the `componentWillReceiveProps` lifecycle method.
         *
         * Similar to `setState`, this method accepts a props object and will merge it in with the already
         * existing props.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} props object
         * @param {Function} cb - callback function
         * @returns {ReactWrapper}
         */
      }, {
        key: "setProps",
        value: /* @__PURE__ */ (function() {
          function setProps(props) {
            var _this7 = this;
            var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::setProps() can only be called on the root");
            }
            if (arguments.length > 1 && typeof callback !== "function") {
              throw new TypeError("ReactWrapper::setProps() expects a function as its second argument");
            }
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            this[UNRENDERED] = (0, _Utils.cloneElement)(adapter, this[UNRENDERED], props);
            this[RENDERER].render(this[UNRENDERED], null, function() {
              _this7.update();
              if (callback) {
                callback();
              }
            });
            return this;
          }
          return setProps;
        })()
        /**
         * A method to invoke `setState` on the root component instance similar to how you might in the
         * definition of the component, and re-renders.  This method is useful for testing your component
         * in hard to achieve states, however should be used sparingly. If possible, you should utilize
         * your component's external API in order to get it into whatever state you want to test, in order
         * to be as accurate of a test as possible. This is not always practical, however.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} state to merge
         * @param {Function} cb - callback function
         * @returns {ReactWrapper}
         */
      }, {
        key: "setState",
        value: /* @__PURE__ */ (function() {
          function setState(state) {
            var _this8 = this;
            var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (this.instance() === null || this.getNodeInternal().nodeType !== "class") {
              throw new Error("ReactWrapper::setState() can only be called on class components");
            }
            if (arguments.length > 1 && typeof callback !== "function") {
              throw new TypeError("ReactWrapper::setState() expects a function as its second argument");
            }
            this.instance().setState(state, function() {
              _this8.update();
              if (callback) {
                var adapter = (0, _getAdapter2["default"])(_this8[OPTIONS]);
                var instance = _this8.instance();
                if (adapter.invokeSetStateCallback) {
                  adapter.invokeSetStateCallback(instance, callback);
                } else {
                  callback.call(instance);
                }
              }
            });
            return this;
          }
          return setState;
        })()
        /**
         * A method that sets the context of the root component, and re-renders. Useful for when you are
         * wanting to test how the component behaves over time with changing contexts.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} context object
         * @returns {ReactWrapper}
         */
      }, {
        key: "setContext",
        value: /* @__PURE__ */ (function() {
          function setContext(context) {
            var _this9 = this;
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::setContext() can only be called on the root");
            }
            if (!this[OPTIONS].context) {
              throw new Error("ReactWrapper::setContext() can only be called on a wrapper that was originally passed a context option");
            }
            this[RENDERER].render(this[UNRENDERED], context, function() {
              return _this9.update();
            });
            return this;
          }
          return setContext;
        })()
        /**
         * Whether or not a given react element exists in the mount render tree.
         *
         * Example:
         * ```
         * const wrapper = mount(<MyComponent />);
         * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
         * ```
         *
         * @param {ReactElement|Array<ReactElement>} nodeOrNodes
         * @returns {Boolean}
         */
      }, {
        key: "contains",
        value: /* @__PURE__ */ (function() {
          function contains2(nodeOrNodes) {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            var predicate = Array.isArray(nodeOrNodes) ? function(other) {
              return (0, _Utils.containsChildrenSubArray)(_Utils.nodeEqual, other, nodeOrNodes.map(function(node2) {
                return adapter.elementToNode(node2);
              }));
            } : function(other) {
              return (0, _Utils.nodeEqual)(adapter.elementToNode(nodeOrNodes), other);
            };
            return findWhereUnwrapped(this, predicate).length > 0;
          }
          return contains2;
        })()
        /**
         * Whether or not a given react element exists in the current render tree.
         * It will determine if one of the wrappers element "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrappers element and equals to each other.
         *
         * Example:
         * ```
         * // MyComponent outputs <div><div class="foo">Hello</div></div>
         * const wrapper = mount(<MyComponent />);
         * expect(wrapper.containsMatchingElement(<div>Hello</div>)).to.equal(true);
         * ```
         *
         * @param {ReactElement} node
         * @returns {Boolean}
         */
      }, {
        key: "containsMatchingElement",
        value: /* @__PURE__ */ (function() {
          function containsMatchingElement(node2) {
            var rstNode = (0, _getAdapter2["default"])(this[OPTIONS]).elementToNode(node2);
            var predicate = /* @__PURE__ */ (function() {
              function predicate2(other) {
                return (0, _Utils.nodeMatches)(rstNode, other, function(a, b) {
                  return a <= b;
                });
              }
              return predicate2;
            })();
            return findWhereUnwrapped(this, predicate).length > 0;
          }
          return containsMatchingElement;
        })()
        /**
         * Whether or not all the given react elements exist in the current render tree.
         * It will determine if one of the wrappers element "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrappers element and equals to each other.
         *
         * Example:
         * ```
         * const wrapper = mount(<MyComponent />);
         * expect(wrapper.containsAllMatchingElements([
         *   <div>Hello</div>,
         *   <div>Goodbye</div>,
         * ])).to.equal(true);
         * ```
         *
         * @param {Array<ReactElement>} nodes
         * @returns {Boolean}
         */
      }, {
        key: "containsAllMatchingElements",
        value: /* @__PURE__ */ (function() {
          function containsAllMatchingElements(nodes) {
            var _this10 = this;
            if (!Array.isArray(nodes)) {
              throw new TypeError("nodes should be an Array");
            }
            return nodes.every(function(node2) {
              return _this10.containsMatchingElement(node2);
            });
          }
          return containsAllMatchingElements;
        })()
        /**
         * Whether or not one of the given react elements exists in the current render tree.
         * It will determine if one of the wrappers element "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrappers element and equals to each other.
         *
         * Example:
         * ```
         * const wrapper = mount(<MyComponent />);
         * expect(wrapper.containsAnyMatchingElements([
         *   <div>Hello</div>,
         *   <div>Goodbye</div>,
         * ])).to.equal(true);
         * ```
         *
         * @param {Array<ReactElement>} nodes
         * @returns {Boolean}
         */
      }, {
        key: "containsAnyMatchingElements",
        value: /* @__PURE__ */ (function() {
          function containsAnyMatchingElements(nodes) {
            var _this11 = this;
            return Array.isArray(nodes) && nodes.some(function(node2) {
              return _this11.containsMatchingElement(node2);
            });
          }
          return containsAnyMatchingElements;
        })()
        /**
         * Whether or not a given react element exists in the render tree.
         *
         * Example:
         * ```
         * const wrapper = mount(<MyComponent />);
         * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
         * ```
         *
         * @param {ReactElement} node
         * @returns {Boolean}
         */
      }, {
        key: "equals",
        value: /* @__PURE__ */ (function() {
          function equals2(node2) {
            var _this12 = this;
            return this.single("equals", function() {
              return (0, _Utils.nodeEqual)(_this12.getNodeInternal(), node2);
            });
          }
          return equals2;
        })()
        /**
         * Whether or not a given react element matches the render tree.
         * Match is based on the expected element and not on wrapper root node.
         * It will determine if the wrapper root node "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrapper root node and equals to each other.
         *
         * Example:
         * ```
         * // MyComponent outputs <div class="foo">Hello</div>
         * const wrapper = mount(<MyComponent />);
         * expect(wrapper.matchesElement(<div>Hello</div>)).to.equal(true);
         * ```
         *
         * @param {ReactElement} node
         * @returns {Boolean}
         */
      }, {
        key: "matchesElement",
        value: /* @__PURE__ */ (function() {
          function matchesElement(node2) {
            var _this13 = this;
            return this.single("matchesElement", function() {
              var adapter = (0, _getAdapter2["default"])(_this13[OPTIONS]);
              var rstNode = adapter.elementToNode(node2);
              return (0, _Utils.nodeMatches)(rstNode, _this13.getNodeInternal(), function(a, b) {
                return a <= b;
              });
            });
          }
          return matchesElement;
        })()
        /**
         * Finds every node in the render tree of the current wrapper that matches the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {ReactWrapper}
         */
      }, {
        key: "find",
        value: /* @__PURE__ */ (function() {
          function find2(selector2) {
            return this.wrap((0, _selectors.reduceTreesBySelector)(selector2, this.getNodesInternal()));
          }
          return find2;
        })()
        /**
         * Returns whether or not current node matches a provided selector.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {EnzymeSelector} selector
         * @returns {boolean}
         */
      }, {
        key: "is",
        value: /* @__PURE__ */ (function() {
          function is(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return this.single("is", function(n) {
              return predicate(n);
            });
          }
          return is;
        })()
        /**
         * Returns true if the component rendered nothing, i.e., null or false.
         *
         * @returns {boolean}
         */
      }, {
        key: "isEmptyRender",
        value: /* @__PURE__ */ (function() {
          function isEmptyRender() {
            var nodes = this.getNodeInternal();
            return (0, _Utils.renderedDive)(nodes);
          }
          return isEmptyRender;
        })()
        /**
         * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
         * the provided predicate function.
         *
         * @param {Function} predicate
         * @returns {ReactWrapper}
         */
      }, {
        key: "filterWhere",
        value: /* @__PURE__ */ (function() {
          function filterWhere(predicate) {
            var _this14 = this;
            return filterWhereUnwrapped(this, function(n) {
              return predicate(_this14.wrap(n));
            });
          }
          return filterWhere;
        })()
        /**
         * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
         * the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {ReactWrapper}
         */
      }, {
        key: "filter",
        value: /* @__PURE__ */ (function() {
          function filter2(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return filterWhereUnwrapped(this, predicate);
          }
          return filter2;
        })()
        /**
         * Returns a new wrapper instance with only the nodes of the current wrapper that did not match
         * the provided selector. Essentially the inverse of `filter`.
         *
         * @param {EnzymeSelector} selector
         * @returns {ReactWrapper}
         */
      }, {
        key: "not",
        value: /* @__PURE__ */ (function() {
          function not2(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return filterWhereUnwrapped(this, function(n) {
              return !predicate(n);
            });
          }
          return not2;
        })()
        /**
         * Returns a string of the rendered text of the current render tree.  This function should be
         * looked at with skepticism if being used to test what the actual HTML output of the component
         * will be. If that is what you would like to test, use enzyme's `render` function instead.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {String}
         */
      }, {
        key: "text",
        value: /* @__PURE__ */ (function() {
          function text2() {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return this.single("text", function(n) {
              return (0, _RSTTraversal.getTextFromHostNodes)(n, adapter);
            });
          }
          return text2;
        })()
        /**
         * Returns the HTML of the node.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {String}
         */
      }, {
        key: "html",
        value: /* @__PURE__ */ (function() {
          function html2() {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return this.single("html", function(n) {
              return (0, _RSTTraversal.getHTMLFromHostNodes)(n, adapter);
            });
          }
          return html2;
        })()
        /**
         * Returns the current node rendered to HTML and wrapped in a CheerioWrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {CheerioWrapper}
         */
      }, {
        key: "render",
        value: /* @__PURE__ */ (function() {
          function render3() {
            var html2 = this.html();
            return (0, _Utils.loadCheerioRoot)(html2);
          }
          return render3;
        })()
        /**
         * Used to simulate events. Pass an eventname and (optionally) event arguments. This method of
         * testing events should be met with some skepticism.
         *
         * @param {String} event
         * @param {Object} mock (optional)
         * @returns {ReactWrapper}
         */
      }, {
        key: "simulate",
        value: /* @__PURE__ */ (function() {
          function simulate(event) {
            var _this15 = this;
            var mock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.single("simulate", function(n) {
              _this15[RENDERER].simulateEvent(n, event, mock);
              _this15[ROOT].update();
              return _this15;
            });
          }
          return simulate;
        })()
        /**
         * Used to simulate throwing a rendering error. Pass an error to throw.
         *
         * @param {String} error
         * @returns {ReactWrapper}
         */
      }, {
        key: "simulateError",
        value: /* @__PURE__ */ (function() {
          function simulateError(error) {
            var _this16 = this;
            if (this[ROOT] === this) {
              throw new Error("ReactWrapper::simulateError() may not be called on the root");
            }
            return this.single("simulateError", function(thisNode) {
              if (thisNode.nodeType === "host") {
                throw new Error("ReactWrapper::simulateError() can only be called on custom components");
              }
              var renderer = _this16[RENDERER];
              if (typeof renderer.simulateError !== "function") {
                throw new TypeError("your adapter does not support `simulateError`. Try upgrading it!");
              }
              var rootNode = getRootNodeInternal(_this16);
              var nodeHierarchy = [thisNode].concat(nodeParents(_this16, thisNode));
              renderer.simulateError(nodeHierarchy, rootNode, error);
              _this16[ROOT].update();
              return _this16;
            });
          }
          return simulateError;
        })()
        /**
         * Returns the props hash for the root node of the wrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {Object}
         */
      }, {
        key: "props",
        value: /* @__PURE__ */ (function() {
          function props() {
            return this.single("props", _RSTTraversal.propsOfNode);
          }
          return props;
        })()
        /**
         * Returns the state hash for the root node of the wrapper. Optionally pass in a prop name and it
         * will return just that value.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {String} name (optional)
         * @returns {*}
         */
      }, {
        key: "state",
        value: /* @__PURE__ */ (function() {
          function state(name) {
            var _this17 = this;
            var thisNode = this[ROOT] === this ? this[RENDERER].getNode() : this.getNodeInternal();
            if (this.instance() === null || thisNode.nodeType !== "class") {
              throw new Error("ReactWrapper::state() can only be called on class components");
            }
            var _state = this.single("state", function() {
              return _this17.instance().state;
            });
            if (typeof name !== "undefined") {
              if (_state == null) {
                throw new TypeError('ReactWrapper::state("' + String(name) + '") requires that `state` not be `null` or `undefined`');
              }
              return _state[name];
            }
            return _state;
          }
          return state;
        })()
        /**
         * Returns the context hash for the root node of the wrapper.
         * Optionally pass in a prop name and it will return just that value.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {String} name (optional)
         * @returns {*}
         */
      }, {
        key: "context",
        value: /* @__PURE__ */ (function() {
          function context(name) {
            var _this18 = this;
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::context() can only be called on the root");
            }
            var instance = this.single("context", function() {
              return _this18.instance();
            });
            if (instance === null) {
              throw new Error("ReactWrapper::context() can only be called on components with instances");
            }
            var _context = instance.context;
            if (typeof name !== "undefined") {
              return _context[name];
            }
            return _context;
          }
          return context;
        })()
        /**
         * Returns a new wrapper with all of the children of the current wrapper.
         *
         * @param {EnzymeSelector} [selector]
         * @returns {ReactWrapper}
         */
      }, {
        key: "children",
        value: /* @__PURE__ */ (function() {
          function children2(selector2) {
            var allChildren = this.flatMap(function(n) {
              return (0, _RSTTraversal.childrenOfNode)(n.getNodeInternal());
            });
            return selector2 ? allChildren.filter(selector2) : allChildren;
          }
          return children2;
        })()
        /**
         * Returns a new wrapper with a specific child
         *
         * @param {Number} [index]
         * @returns {ReactWrapper}
         */
      }, {
        key: "childAt",
        value: /* @__PURE__ */ (function() {
          function childAt(index2) {
            var _this19 = this;
            return this.single("childAt", function() {
              return _this19.children().at(index2);
            });
          }
          return childAt;
        })()
        /**
         * Returns a wrapper around all of the parents/ancestors of the wrapper. Does not include the node
         * in the current wrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {EnzymeSelector} [selector]
         * @returns {ReactWrapper}
         */
      }, {
        key: "parents",
        value: /* @__PURE__ */ (function() {
          function parents(selector2) {
            var _this20 = this;
            return this.single("parents", function(n) {
              var allParents = _this20.wrap(nodeParents(_this20, n));
              return selector2 ? allParents.filter(selector2) : allParents;
            });
          }
          return parents;
        })()
        /**
         * Returns a wrapper around the immediate parent of the current node.
         *
         * @returns {ReactWrapper}
         */
      }, {
        key: "parent",
        value: /* @__PURE__ */ (function() {
          function parent() {
            return this.flatMap(function(n) {
              return [n.parents().get(0)];
            });
          }
          return parent;
        })()
        /**
         *
         * @param {EnzymeSelector} selector
         * @returns {ReactWrapper}
         */
      }, {
        key: "closest",
        value: /* @__PURE__ */ (function() {
          function closest(selector2) {
            if (this.is(selector2)) {
              return this;
            }
            var matchingAncestors = this.parents().filter(selector2);
            return matchingAncestors.length > 0 ? matchingAncestors.first() : this.findWhere(function() {
              return false;
            });
          }
          return closest;
        })()
        /**
         * Returns the value of  prop with the given name of the root node.
         *
         * @param {String} propName
         * @returns {*}
         */
      }, {
        key: "prop",
        value: /* @__PURE__ */ (function() {
          function prop2(propName) {
            return this.props()[propName];
          }
          return prop2;
        })()
        /**
         * Used to invoke a function prop.
         * Will invoke an function prop and return its value.
         *
         * @param {String} propName
         * @returns {Any}
         */
      }, {
        key: "invoke",
        value: /* @__PURE__ */ (function() {
          function invoke(propName) {
            var _this21 = this;
            return this.single("invoke", function() {
              var handler = _this21.prop(propName);
              if (typeof handler !== "function") {
                throw new TypeError("ReactWrapper::invoke() requires the name of a prop whose value is a function");
              }
              return function() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }
                var response = typeof _this21[RENDERER].wrapInvoke === "function" ? _this21[RENDERER].wrapInvoke(function() {
                  return handler.apply(void 0, args);
                }) : handler.apply(void 0, args);
                _this21[ROOT].update();
                return response;
              };
            });
          }
          return invoke;
        })()
        /**
         * Returns a wrapper of the node rendered by the provided render prop.
         *
         * @param {String} propName
         * @returns {Function}
         */
      }, {
        key: "renderProp",
        value: /* @__PURE__ */ (function() {
          function renderProp(propName) {
            var _this22 = this;
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            if (typeof adapter.wrap !== "function") {
              throw new RangeError("your adapter does not support `wrap`. Try upgrading it!");
            }
            return this.single("renderProp", function(n) {
              if (n.nodeType === "host") {
                throw new TypeError("ReactWrapper::renderProp() can only be called on custom components");
              }
              if (typeof propName !== "string") {
                throw new TypeError("ReactWrapper::renderProp(): `propName` must be a string");
              }
              var props = _this22.props();
              if (!(0, _has2["default"])(props, propName)) {
                throw new Error("ReactWrapper::renderProp(): no prop called “" + String(propName) + "“ found");
              }
              var propValue = props[propName];
              if (typeof propValue !== "function") {
                throw new TypeError("ReactWrapper::renderProp(): expected prop “" + String(propName) + "“ to contain a function, but it holds “" + (typeof propValue === "undefined" ? "undefined" : _typeof2(propValue)) + "“");
              }
              return function() {
                var element = propValue.apply(void 0, arguments);
                var wrapped = adapter.wrap(element);
                return _this22.wrap(wrapped, null, _this22[OPTIONS]);
              };
            });
          }
          return renderProp;
        })()
        /**
         * Returns the key assigned to the current node.
         *
         * @returns {String}
         */
      }, {
        key: "key",
        value: /* @__PURE__ */ (function() {
          function key() {
            return this.single("key", function(n) {
              return n.key === void 0 ? null : n.key;
            });
          }
          return key;
        })()
        /**
         * Returns the type of the root node of this wrapper. If it's a composite component, this will be
         * the component constructor. If it's native DOM node, it will be a string.
         *
         * @returns {String|Function}
         */
      }, {
        key: "type",
        value: /* @__PURE__ */ (function() {
          function type2() {
            return this.single("type", function(n) {
              return (0, _Utils.typeOfNode)(n);
            });
          }
          return type2;
        })()
        /**
         * Returns the name of the root node of this wrapper.
         *
         * In order of precedence => type.displayName -> type.name -> type.
         *
         * @returns {String}
         */
      }, {
        key: "name",
        value: /* @__PURE__ */ (function() {
          function name() {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return this.single("name", function(n) {
              return adapter.displayNameOfNode ? adapter.displayNameOfNode(n) : (0, _Utils.displayNameOfNode)(n);
            });
          }
          return name;
        })()
        /**
         * Returns whether or not the current root node has the given class name or not.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {String} className
         * @returns {Boolean}
         */
      }, {
        key: "hasClass",
        value: /* @__PURE__ */ (function() {
          function hasClass2(className) {
            if (typeof className === "string" && className.indexOf(".") !== -1) {
              console.warn("It looks like you're calling `ReactWrapper::hasClass()` with a CSS selector. hasClass() expects a class name, not a CSS selector.");
            }
            return this.single("hasClass", function(n) {
              return (0, _RSTTraversal.hasClassName)(n, className);
            });
          }
          return hasClass2;
        })()
        /**
         * Iterates through each node of the current wrapper and executes the provided function with a
         * wrapper around the corresponding node passed in as the first argument.
         *
         * @param {Function} fn
         * @returns {ReactWrapper}
         */
      }, {
        key: "forEach",
        value: /* @__PURE__ */ (function() {
          function forEach2(fn) {
            var _this23 = this;
            this.getNodesInternal().forEach(function(n, i) {
              return fn.call(_this23, _this23.wrap(n), i);
            });
            return this;
          }
          return forEach2;
        })()
        /**
         * Maps the current array of nodes to another array. Each node is passed in as a `ReactWrapper`
         * to the map function.
         *
         * @param {Function} fn
         * @returns {Array}
         */
      }, {
        key: "map",
        value: /* @__PURE__ */ (function() {
          function map2(fn) {
            var _this24 = this;
            return this.getNodesInternal().map(function(n, i) {
              return fn.call(_this24, _this24.wrap(n), i);
            });
          }
          return map2;
        })()
        /**
         * Reduces the current array of nodes to another array.
         * Each node is passed in as a `ShallowWrapper` to the reducer function.
         *
         * @param {Function} fn - the reducer function
         * @param {*} initialValue - the initial value
         * @returns {*}
         */
      }, {
        key: "reduce",
        value: /* @__PURE__ */ (function() {
          function reduce2(fn) {
            var _this25 = this;
            var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (arguments.length > 1) {
              return this.getNodesInternal().reduce(function(accum, n, i) {
                return fn.call(_this25, accum, _this25.wrap(n), i);
              }, initialValue);
            }
            return this.getNodesInternal().reduce(function(accum, n, i) {
              return fn.call(_this25, i === 1 ? _this25.wrap(accum) : accum, _this25.wrap(n), i);
            });
          }
          return reduce2;
        })()
        /**
         * Reduces the current array of nodes to another array, from right to left. Each node is passed
         * in as a `ShallowWrapper` to the reducer function.
         *
         * @param {Function} fn - the reducer function
         * @param {*} initialValue - the initial value
         * @returns {*}
         */
      }, {
        key: "reduceRight",
        value: /* @__PURE__ */ (function() {
          function reduceRight(fn) {
            var _this26 = this;
            var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (arguments.length > 1) {
              return this.getNodesInternal().reduceRight(function(accum, n, i) {
                return fn.call(_this26, accum, _this26.wrap(n), i);
              }, initialValue);
            }
            return this.getNodesInternal().reduceRight(function(accum, n, i) {
              return fn.call(_this26, i === 1 ? _this26.wrap(accum) : accum, _this26.wrap(n), i);
            });
          }
          return reduceRight;
        })()
        /**
         * Returns a new wrapper with a subset of the nodes of the original wrapper, according to the
         * rules of `Array#slice`.
         *
         * @param {Number} begin
         * @param {Number} end
         * @returns {ShallowWrapper}
         */
      }, {
        key: "slice",
        value: /* @__PURE__ */ (function() {
          function slice2(begin, end2) {
            return this.wrap(this.getNodesInternal().slice(begin, end2));
          }
          return slice2;
        })()
        /**
         * Returns whether or not any of the nodes in the wrapper match the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {Boolean}
         */
      }, {
        key: "some",
        value: /* @__PURE__ */ (function() {
          function some2(selector2) {
            if (this[ROOT] === this) {
              throw new Error("ReactWrapper::some() can not be called on the root");
            }
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return this.getNodesInternal().some(predicate);
          }
          return some2;
        })()
        /**
         * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
         *
         * @param {Function} predicate
         * @returns {Boolean}
         */
      }, {
        key: "someWhere",
        value: /* @__PURE__ */ (function() {
          function someWhere(predicate) {
            var _this27 = this;
            return this.getNodesInternal().some(function(n, i) {
              return predicate.call(_this27, _this27.wrap(n), i);
            });
          }
          return someWhere;
        })()
        /**
         * Returns whether or not all of the nodes in the wrapper match the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {Boolean}
         */
      }, {
        key: "every",
        value: /* @__PURE__ */ (function() {
          function every2(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return this.getNodesInternal().every(predicate);
          }
          return every2;
        })()
        /**
         * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
         *
         * @param {Function} predicate
         * @returns {Boolean}
         */
      }, {
        key: "everyWhere",
        value: /* @__PURE__ */ (function() {
          function everyWhere(predicate) {
            var _this28 = this;
            return this.getNodesInternal().every(function(n, i) {
              return predicate.call(_this28, _this28.wrap(n), i);
            });
          }
          return everyWhere;
        })()
        /**
         * Utility method used to create new wrappers with a mapping function that returns an array of
         * nodes in response to a single node wrapper. The returned wrapper is a single wrapper around
         * all of the mapped nodes flattened (and de-duplicated).
         *
         * @param {Function} fn
         * @returns {ReactWrapper}
         */
      }, {
        key: "flatMap",
        value: /* @__PURE__ */ (function() {
          function flatMap(fn) {
            var _this29 = this;
            var nodes = this.getNodesInternal().map(function(n, i) {
              return fn.call(_this29, _this29.wrap(n), i);
            });
            var flattened = (0, _arrayPrototype2["default"])(nodes, 1);
            return this.wrap(flattened.filter(Boolean));
          }
          return flatMap;
        })()
        /**
         * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
         * function.
         *
         * @param {Function} predicate
         * @returns {ReactWrapper}
         */
      }, {
        key: "findWhere",
        value: /* @__PURE__ */ (function() {
          function findWhere(predicate) {
            var _this30 = this;
            return findWhereUnwrapped(this, function(n) {
              var node2 = _this30.wrap(n);
              return node2.length > 0 && predicate(node2);
            });
          }
          return findWhere;
        })()
        /**
         * Returns the node at a given index of the current wrapper.
         *
         * @param {Number} index
         * @returns {ReactElement}
         */
      }, {
        key: "get",
        value: /* @__PURE__ */ (function() {
          function get3(index2) {
            return this.getElements()[index2];
          }
          return get3;
        })()
        /**
         * Returns a wrapper around the node at a given index of the current wrapper.
         *
         * @param {Number} index
         * @returns {ReactWrapper}
         */
      }, {
        key: "at",
        value: /* @__PURE__ */ (function() {
          function at(index2) {
            var nodes = this.getNodesInternal();
            if (index2 < nodes.length) {
              return this.wrap(nodes[index2]);
            }
            return this.wrap([]);
          }
          return at;
        })()
        /**
         * Returns a wrapper around the first node of the current wrapper.
         *
         * @returns {ReactWrapper}
         */
      }, {
        key: "first",
        value: /* @__PURE__ */ (function() {
          function first() {
            return this.at(0);
          }
          return first;
        })()
        /**
         * Returns a wrapper around the last node of the current wrapper.
         *
         * @returns {ReactWrapper}
         */
      }, {
        key: "last",
        value: /* @__PURE__ */ (function() {
          function last() {
            return this.at(this.length - 1);
          }
          return last;
        })()
        /**
         * Delegates to exists()
         *
         * @returns {boolean}
         */
      }, {
        key: "isEmpty",
        value: /* @__PURE__ */ (function() {
          function isEmpty() {
            console.warn("Enzyme::Deprecated method isEmpty() called, use exists() instead.");
            return !this.exists();
          }
          return isEmpty;
        })()
        /**
         * Returns true if the current wrapper has nodes. False otherwise.
         * If called with a selector it returns `.find(selector).exists()` instead.
         *
         * @param {EnzymeSelector} selector (optional)
         * @returns {boolean}
         */
      }, {
        key: "exists",
        value: /* @__PURE__ */ (function() {
          function exists() {
            var selector2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            return arguments.length > 0 ? this.find(selector2).exists() : this.length > 0;
          }
          return exists;
        })()
        /**
         * Utility method that throws an error if the current instance has a length other than one.
         * This is primarily used to enforce that certain methods are only run on a wrapper when it is
         * wrapping a single node.
         *
         * @param {Function} fn
         * @returns {*}
         */
      }, {
        key: "single",
        value: /* @__PURE__ */ (function() {
          function single(name, fn) {
            var fnName = typeof name === "string" ? name : "unknown";
            var callback = typeof fn === "function" ? fn : name;
            if (this.length !== 1) {
              throw new Error("Method “" + fnName + "” is meant to be run on 1 node. " + String(this.length) + " found instead.");
            }
            return callback.call(this, this.getNodeInternal());
          }
          return single;
        })()
        /**
         * Helpful utility method to create a new wrapper with the same root as the current wrapper, with
         * any nodes passed in as the first parameter automatically wrapped.
         *
         * @param {ReactWrapper|ReactElement|Array<ReactElement>} node
         * @returns {ReactWrapper}
         */
      }, {
        key: "wrap",
        value: /* @__PURE__ */ (function() {
          function wrap2(node2) {
            var root2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[ROOT];
            if (node2 instanceof ReactWrapper22) {
              return node2;
            }
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }
            return new (Function.prototype.bind.apply(ReactWrapper22, [null].concat([node2, root2], args)))();
          }
          return wrap2;
        })()
        /**
         * Returns an HTML-like string of the shallow render for debugging purposes.
         *
         * @param {Object} [options] - Property bag of additional options.
         * @param {boolean} [options.ignoreProps] - if true, props are omitted from the string.
         * @param {boolean} [options.verbose] - if true, arrays and objects to be verbosely printed.
         * @returns {String}
         */
      }, {
        key: "debug",
        value: /* @__PURE__ */ (function() {
          function debug() {
            var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return (0, _Debug.debugNodes)(this.getNodesInternal(), options2);
          }
          return debug;
        })()
        /**
         * Invokes intercepter and returns itself. intercepter is called with itself.
         * This is helpful when debugging nodes in method chains.
         * @param fn
         * @returns {ReactWrapper}
         */
      }, {
        key: "tap",
        value: /* @__PURE__ */ (function() {
          function tap(intercepter) {
            intercepter(this);
            return this;
          }
          return tap;
        })()
        /**
         * Detaches the react tree from the DOM. Runs `ReactDOM.unmountComponentAtNode()` under the hood.
         *
         * This method will most commonly be used as a "cleanup" method if you decide to use the
         * `attachTo` option in `mount(node, options)`.
         *
         * The method is intentionally not "fluent" (in that it doesn't return `this`) because you should
         * not be doing anything with this wrapper after this method is called.
         */
      }, {
        key: "detach",
        value: /* @__PURE__ */ (function() {
          function detach() {
            if (this[ROOT] !== this) {
              throw new Error("ReactWrapper::detach() can only be called on the root");
            }
            if (!this[OPTIONS].attachTo) {
              throw new Error("ReactWrapper::detach() can only be called on when the `attachTo` option was passed into `mount()`.");
            }
            this[RENDERER].unmount();
          }
          return detach;
        })()
        /**
         * Strips out all the not host-nodes from the list of nodes
         *
         * This method is useful if you want to check for the presence of host nodes
         * (actually rendered HTML elements) ignoring the React nodes.
         */
      }, {
        key: "hostNodes",
        value: /* @__PURE__ */ (function() {
          function hostNodes() {
            return this.filterWhere(function(n) {
              return typeof n.type() === "string";
            });
          }
          return hostNodes;
        })()
      }]);
      return ReactWrapper22;
    })();
    var WrappingComponentWrapper = (function(_ReactWrapper) {
      _inherits2(WrappingComponentWrapper2, _ReactWrapper);
      function WrappingComponentWrapper2(root2, renderer) {
        _classCallCheck2(this, WrappingComponentWrapper2);
        var _this31 = _possibleConstructorReturn2(this, (WrappingComponentWrapper2.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2)).call(this, renderer.getNode(), root2));
        (0, _Utils.privateSet)(_this31, ROOT, _this31);
        (0, _Utils.privateSet)(_this31, RENDERER, renderer);
        _this31[LINKED_ROOTS].push(root2);
        return _this31;
      }
      _createClass2(WrappingComponentWrapper2, [{
        key: "getWrappingComponent",
        value: /* @__PURE__ */ (function() {
          function getWrappingComponent() {
            throw new TypeError("ReactWrapper::getWrappingComponent() can only be called on the root");
          }
          return getWrappingComponent;
        })()
      }]);
      return WrappingComponentWrapper2;
    })(ReactWrapper2);
    if (_Utils.ITERATOR_SYMBOL) {
      Object.defineProperty(ReactWrapper2.prototype, _Utils.ITERATOR_SYMBOL, {
        configurable: true,
        value: /* @__PURE__ */ (function() {
          function iterator() {
            var _ref;
            var iter = this[NODES][_Utils.ITERATOR_SYMBOL]();
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return _ref = {}, _defineProperty2(_ref, _Utils.ITERATOR_SYMBOL, function() {
              return this;
            }), _defineProperty2(_ref, "next", /* @__PURE__ */ (function() {
              function next() {
                var next2 = iter.next();
                if (next2.done) {
                  return {
                    done: true
                  };
                }
                return {
                  done: false,
                  value: adapter.nodeToElement(next2.value)
                };
              }
              return next;
            })()), _ref;
          }
          return iterator;
        })()
      });
    }
    function privateWarning(prop2, extraMessage) {
      Object.defineProperty(ReactWrapper2.prototype, prop2, {
        get: /* @__PURE__ */ (function() {
          function get3() {
            throw new Error("\n        Attempted to access ReactWrapper::" + String(prop2) + ", which was previously a private property on\n        Enzyme ReactWrapper instances, but is no longer and should not be relied upon.\n        " + String(extraMessage) + "\n      ");
          }
          return get3;
        })(),
        enumerable: false,
        configurable: false
      });
    }
    privateWarning("node", "Consider using the getElement() method instead.");
    privateWarning("nodes", "Consider using the getElements() method instead.");
    privateWarning("renderer", "");
    privateWarning("options", "");
    privateWarning("complexSelector", "");
    exports2["default"] = ReactWrapper2;
  })(ReactWrapper);
  return ReactWrapper;
}
var ShallowWrapper = {};
var hasRequiredShallowWrapper;
function requireShallowWrapper() {
  if (hasRequiredShallowWrapper) return ShallowWrapper;
  hasRequiredShallowWrapper = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    var _get2 = /* @__PURE__ */ (function() {
      function get3(object2, property2, receiver) {
        if (object2 === null) object2 = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object2, property2);
        if (desc === void 0) {
          var parent = Object.getPrototypeOf(object2);
          if (parent === null) {
            return void 0;
          } else {
            return get3(parent, property2, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;
          if (getter === void 0) {
            return void 0;
          }
          return getter.call(receiver);
        }
      }
      return get3;
    })();
    var _createClass2 = /* @__PURE__ */ (function() {
      function defineProperties(target2, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target2, descriptor.key, descriptor);
        }
      }
      return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    })();
    var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
      return typeof obj;
    } : function(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _object = requireObject_assign();
    var _object2 = _interopRequireDefault(_object);
    var _arrayPrototype = requireArray_prototype_flat();
    var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
    var _has = requireSrc$1();
    var _has2 = _interopRequireDefault(_has);
    var _enzymeShallowEqual = requireBuild$1();
    var _enzymeShallowEqual2 = _interopRequireDefault(_enzymeShallowEqual);
    var _Utils = requireUtils();
    var _getAdapter = requireGetAdapter();
    var _getAdapter2 = _interopRequireDefault(_getAdapter);
    var _Debug = requireDebug();
    var _RSTTraversal = requireRSTTraversal();
    var _selectors = requireSelectors();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function _possibleConstructorReturn2(self2, call) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self2;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var NODE = (0, _Utils.sym)("__node__");
    var NODES = (0, _Utils.sym)("__nodes__");
    var RENDERER = (0, _Utils.sym)("__renderer__");
    var UNRENDERED = (0, _Utils.sym)("__unrendered__");
    var ROOT = (0, _Utils.sym)("__root__");
    var OPTIONS = (0, _Utils.sym)("__options__");
    var SET_STATE = (0, _Utils.sym)("__setState__");
    var ROOT_NODES = (0, _Utils.sym)("__rootNodes__");
    var CHILD_CONTEXT = (0, _Utils.sym)("__childContext__");
    var WRAPPING_COMPONENT = (0, _Utils.sym)("__wrappingComponent__");
    var PRIMARY_WRAPPER = (0, _Utils.sym)("__primaryWrapper__");
    var ROOT_FINDER = (0, _Utils.sym)("__rootFinder__");
    var PROVIDER_VALUES = (0, _Utils.sym)("__providerValues__");
    function findWhereUnwrapped(wrapper, predicate) {
      var filter2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _RSTTraversal.treeFilter;
      return wrapper.flatMap(function(n) {
        return filter2(n.getNodeInternal(), predicate);
      });
    }
    function filterWhereUnwrapped(wrapper, predicate) {
      return wrapper.wrap(wrapper.getNodesInternal().filter(predicate).filter(Boolean));
    }
    function validateOptions(options2) {
      var lifecycleExperimental = options2.lifecycleExperimental, disableLifecycleMethods = options2.disableLifecycleMethods, enableComponentDidUpdateOnSetState = options2.enableComponentDidUpdateOnSetState, supportPrevContextArgumentOfComponentDidUpdate = options2.supportPrevContextArgumentOfComponentDidUpdate, lifecycles = options2.lifecycles;
      if (typeof lifecycleExperimental !== "undefined" && typeof lifecycleExperimental !== "boolean") {
        throw new Error("lifecycleExperimental must be either true or false if provided");
      }
      if (typeof disableLifecycleMethods !== "undefined" && typeof disableLifecycleMethods !== "boolean") {
        throw new Error("disableLifecycleMethods must be either true or false if provided");
      }
      if (lifecycleExperimental != null && disableLifecycleMethods != null && lifecycleExperimental === disableLifecycleMethods) {
        throw new Error("lifecycleExperimental and disableLifecycleMethods cannot be set to the same value");
      }
      if (typeof enableComponentDidUpdateOnSetState !== "undefined" && lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.onSetState !== enableComponentDidUpdateOnSetState) {
        throw new TypeError("the legacy enableComponentDidUpdateOnSetState option should be matched by `lifecycles: { componentDidUpdate: { onSetState: true } }`, for compatibility");
      }
      if (typeof supportPrevContextArgumentOfComponentDidUpdate !== "undefined" && lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.prevContext !== supportPrevContextArgumentOfComponentDidUpdate) {
        throw new TypeError("the legacy supportPrevContextArgumentOfComponentDidUpdate option should be matched by `lifecycles: { componentDidUpdate: { prevContext: true } }`, for compatibility");
      }
    }
    function getAdapterLifecycles(_ref) {
      var options2 = _ref.options;
      var _options$lifecycles = options2.lifecycles, lifecycles = _options$lifecycles === void 0 ? {} : _options$lifecycles, enableComponentDidUpdateOnSetState = options2.enableComponentDidUpdateOnSetState, supportPrevContextArgumentOfComponentDidUpdate = options2.supportPrevContextArgumentOfComponentDidUpdate;
      var hasLegacySetStateArg = typeof enableComponentDidUpdateOnSetState !== "undefined";
      var hasLegacyPrevContextArg = typeof supportPrevContextArgumentOfComponentDidUpdate !== "undefined";
      var componentDidUpdate = hasLegacySetStateArg || hasLegacyPrevContextArg ? (0, _object2["default"])({}, hasLegacySetStateArg && {
        onSetState: !!enableComponentDidUpdateOnSetState
      }, hasLegacyPrevContextArg && {
        prevContext: !!supportPrevContextArgumentOfComponentDidUpdate
      }) : null;
      var originalGDSFP = lifecycles.getDerivedStateFromProps;
      var getDerivedStateFromProps = originalGDSFP ? {
        hasShouldComponentUpdateBug: !!originalGDSFP.hasShouldComponentUpdateBug
      } : false;
      return (0, _object2["default"])({}, lifecycles, {
        setState: (0, _object2["default"])({}, lifecycles.setState),
        getChildContext: (0, _object2["default"])({
          calledByRenderer: true
        }, lifecycles.getChildContext)
      }, componentDidUpdate && {
        componentDidUpdate
      }, {
        getDerivedStateFromProps
      });
    }
    function getRootNode(node2) {
      if (node2.nodeType === "host") {
        return node2;
      }
      return node2.rendered;
    }
    function getRootNodeInternal(wrapper) {
      if (wrapper[ROOT].length !== 1) {
        throw new Error("getRootNodeInternal(wrapper) can only be called when wrapper wraps one node");
      }
      if (wrapper[ROOT] !== wrapper) {
        return wrapper[ROOT_NODES][0];
      }
      return wrapper[ROOT][NODE];
    }
    function nodeParents(wrapper, node2) {
      return (0, _RSTTraversal.parentsOfNode)(node2, getRootNodeInternal(wrapper));
    }
    function privateSetNodes(wrapper, nodes) {
      if (!Array.isArray(nodes)) {
        (0, _Utils.privateSet)(wrapper, NODE, nodes);
        (0, _Utils.privateSet)(wrapper, NODES, [nodes]);
      } else {
        (0, _Utils.privateSet)(wrapper, NODE, nodes[0]);
        (0, _Utils.privateSet)(wrapper, NODES, nodes);
      }
      (0, _Utils.privateSet)(wrapper, "length", wrapper[NODES].length);
    }
    function pureComponentShouldComponentUpdate(prevProps, props, prevState, state) {
      return !(0, _enzymeShallowEqual2["default"])(prevProps, props) || !(0, _enzymeShallowEqual2["default"])(prevState, state);
    }
    function isPureComponent(instance) {
      return instance && instance.isPureReactComponent;
    }
    function getChildContext(node2, hierarchy, renderer) {
      var instance = node2.instance, Component2 = node2.type;
      var componentName = (0, _Utils.displayNameOfNode)(node2);
      if (_typeof2(Component2.childContextTypes) !== "object") {
        console.warn(String(componentName) + ".getChildContext(): childContextTypes must be defined in order to use getChildContext().");
        return {};
      }
      var childContext = instance.getChildContext();
      Object.keys(childContext).forEach(function(key) {
        if (!(key in Component2.childContextTypes)) {
          throw new Error(String(componentName) + '.getChildContext(): key "' + String(key) + '" is not defined in childContextTypes.');
        }
      });
      if (typeof renderer.checkPropTypes === "function") {
        renderer.checkPropTypes(Component2.childContextTypes, childContext, "child context", hierarchy);
      }
      return childContext;
    }
    function spyOnGetChildContextInitialRender(nodes, adapter) {
      if (!(0, _Utils.isCustomComponentElement)(nodes, adapter) || !nodes.type.prototype || typeof nodes.type.prototype.getChildContext !== "function") {
        return null;
      }
      return (0, _Utils.spyMethod)(nodes.type.prototype, "getChildContext");
    }
    function privateSetChildContext(adapter, wrapper, instance, renderedNode, getChildContextSpy) {
      var renderer = wrapper[RENDERER];
      if (adapter.options.legacyContextMode !== "parent") {
        return;
      }
      if (getChildContextSpy) {
        (0, _Utils.privateSet)(wrapper, CHILD_CONTEXT, getChildContextSpy.getLastReturnValue());
        getChildContextSpy.restore();
      } else if (typeof instance.getChildContext === "function") {
        var nodeHierarchy = [wrapper[NODE]].concat(nodeParents(wrapper, wrapper[NODE]));
        var childContext = getChildContext(renderedNode, nodeHierarchy, renderer);
        (0, _Utils.privateSet)(wrapper, CHILD_CONTEXT, childContext);
      } else {
        (0, _Utils.privateSet)(wrapper, CHILD_CONTEXT, null);
      }
    }
    function mockSCUIfgDSFPReturnNonNull(node2, state) {
      var getDerivedStateFromProps = node2.type.getDerivedStateFromProps;
      if (typeof getDerivedStateFromProps === "function") {
        var instance = node2.instance;
        var _spyMethod = (0, _Utils.spyMethod)(instance, "shouldComponentUpdate", function(originalSCU) {
          return /* @__PURE__ */ (function() {
            function shouldComponentUpdate() {
              instance.state = state;
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              var sCUResult = originalSCU.apply(instance, args);
              var nextState = args[1];
              instance.state = nextState;
              restore();
              return sCUResult;
            }
            return shouldComponentUpdate;
          })();
        }), restore = _spyMethod.restore;
      }
    }
    function deepRender(wrapper, target2, adapter) {
      var node2 = wrapper[NODE];
      var element = node2 && adapter.nodeToElement(node2);
      if (wrapper.type() === target2) {
        return wrapper.dive();
      }
      if (element && (0, _Utils.isCustomComponentElement)(element, adapter)) {
        return deepRender(wrapper.dive(), target2, adapter);
      }
      var children2 = wrapper.children();
      for (var i = 0; i < children2.length; i += 1) {
        var found = deepRender(children2.at(i), target2, adapter);
        if (typeof found !== "undefined") {
          return found;
        }
      }
      return void 0;
    }
    function getContextFromWrappingComponent(wrapper, adapter) {
      var rootFinder = deepRender(wrapper, wrapper[ROOT_FINDER], adapter);
      if (!rootFinder) {
        throw new Error("`wrappingComponent` must render its children!");
      }
      return {
        legacyContext: rootFinder[OPTIONS].context,
        providerValues: rootFinder[PROVIDER_VALUES]
      };
    }
    function makeShallowOptions(nodes, root2, passedOptions, wrapper) {
      var options2 = (0, _Utils.makeOptions)(passedOptions);
      var adapter = (0, _getAdapter2["default"])(passedOptions);
      (0, _Utils.privateSet)(options2, PROVIDER_VALUES, passedOptions[PROVIDER_VALUES]);
      if (root2 || !(0, _Utils.isCustomComponent)(options2.wrappingComponent, adapter)) {
        return options2;
      }
      if (typeof adapter.wrapWithWrappingComponent !== "function") {
        throw new TypeError("your adapter does not support `wrappingComponent`. Try upgrading it!");
      }
      var _adapter$wrapWithWrap = adapter.wrapWithWrappingComponent(nodes, options2), wrappedNode = _adapter$wrapWithWrap.node, RootFinder = _adapter$wrapWithWrap.RootFinder;
      var wrappingComponent = new WrappingComponentWrapper(wrappedNode, wrapper, RootFinder);
      var _getContextFromWrappi = getContextFromWrappingComponent(wrappingComponent, adapter), wrappingComponentLegacyContext = _getContextFromWrappi.legacyContext, wrappingComponentProviderValues = _getContextFromWrappi.providerValues;
      (0, _Utils.privateSet)(wrapper, WRAPPING_COMPONENT, wrappingComponent);
      return (0, _object2["default"])({}, options2, _defineProperty2({
        context: (0, _object2["default"])({}, options2.context, wrappingComponentLegacyContext)
      }, PROVIDER_VALUES, wrappingComponentProviderValues));
    }
    function makeInheritedChildOptions(wrapper) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var childOptions = (0, _object2["default"])({}, wrapper[OPTIONS], options2, {
        context: options2.context || (0, _object2["default"])({}, wrapper[OPTIONS].context, wrapper[ROOT][CHILD_CONTEXT])
      });
      (0, _Utils.privateSet)(childOptions, PROVIDER_VALUES, wrapper[ROOT][PROVIDER_VALUES]);
      return childOptions;
    }
    var ShallowWrapper2 = (function() {
      function ShallowWrapper3(nodes, root2) {
        var _this = this;
        var passedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        _classCallCheck2(this, ShallowWrapper3);
        validateOptions(passedOptions);
        var options2 = makeShallowOptions(nodes, root2, passedOptions, this);
        var adapter = (0, _getAdapter2["default"])(options2);
        var lifecycles = getAdapterLifecycles(adapter);
        if (!root2) {
          if (!adapter.isValidElement(nodes)) {
            throw new TypeError("ShallowWrapper can only wrap valid elements");
          }
          var getChildContextSpy = lifecycles.getChildContext.calledByRenderer ? spyOnGetChildContextInitialRender(nodes, adapter) : null;
          (0, _Utils.privateSet)(this, ROOT, this);
          (0, _Utils.privateSet)(this, UNRENDERED, nodes);
          var renderer = adapter.createRenderer((0, _object2["default"])({
            mode: "shallow"
          }, options2));
          (0, _Utils.privateSet)(this, RENDERER, renderer);
          var providerValues = new Map(options2[PROVIDER_VALUES] || []);
          this[RENDERER].render(nodes, options2.context, {
            providerValues
          });
          var renderedNode = this[RENDERER].getNode();
          privateSetNodes(this, getRootNode(renderedNode));
          (0, _Utils.privateSet)(this, OPTIONS, options2);
          (0, _Utils.privateSet)(this, PROVIDER_VALUES, providerValues);
          var instance = renderedNode.instance;
          if (instance && !options2.disableLifecycleMethods) {
            if (lifecycles.componentDidUpdate.onSetState && !instance[SET_STATE]) {
              (0, _Utils.privateSet)(instance, SET_STATE, instance.setState);
              instance.setState = function(updater) {
                var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
                return _this.setState.apply(_this, _toConsumableArray(callback == null ? [updater] : [updater, callback]));
              };
            }
            if (typeof instance.componentDidMount === "function") {
              this[RENDERER].batchedUpdates(function() {
                instance.componentDidMount();
              });
            }
            privateSetChildContext(adapter, this, instance, renderedNode, getChildContextSpy);
          }
        } else {
          (0, _Utils.privateSet)(this, ROOT, root2);
          (0, _Utils.privateSet)(this, UNRENDERED, null);
          (0, _Utils.privateSet)(this, RENDERER, root2[RENDERER]);
          privateSetNodes(this, nodes);
          (0, _Utils.privateSet)(this, OPTIONS, root2[OPTIONS]);
          (0, _Utils.privateSet)(this, ROOT_NODES, root2[NODES]);
          (0, _Utils.privateSet)(this, PROVIDER_VALUES, null);
        }
      }
      _createClass2(ShallowWrapper3, [{
        key: "root",
        value: /* @__PURE__ */ (function() {
          function root2() {
            return this[ROOT];
          }
          return root2;
        })()
        /**
         * Returns the wrapped component.
         *
         * @return {ReactComponent}
         */
      }, {
        key: "getNodeInternal",
        value: /* @__PURE__ */ (function() {
          function getNodeInternal() {
            if (this.length !== 1) {
              throw new Error("ShallowWrapper::getNode() can only be called when wrapping one node");
            }
            if (this[ROOT] === this) {
              this.update();
            }
            return this[NODE];
          }
          return getNodeInternal;
        })()
        /**
         * Returns the the wrapped components.
         *
         * @return {Array<ReactComponent>}
         */
      }, {
        key: "getNodesInternal",
        value: /* @__PURE__ */ (function() {
          function getNodesInternal() {
            if (this[ROOT] === this && this.length === 1) {
              this.update();
            }
            return this[NODES];
          }
          return getNodesInternal;
        })()
        /**
         * Returns the wrapped ReactElement.
         *
         * @return {ReactElement}
         */
      }, {
        key: "getElement",
        value: /* @__PURE__ */ (function() {
          function getElement() {
            var _this2 = this;
            return this.single("getElement", function(n) {
              return (0, _getAdapter2["default"])(_this2[OPTIONS]).nodeToElement(n);
            });
          }
          return getElement;
        })()
        /**
         * Returns the wrapped ReactElements.
         *
         * @return {Array<ReactElement>}
         */
      }, {
        key: "getElements",
        value: /* @__PURE__ */ (function() {
          function getElements() {
            var _this3 = this;
            return this.getNodesInternal().map(function(n) {
              return (0, _getAdapter2["default"])(_this3[OPTIONS]).nodeToElement(n);
            });
          }
          return getElements;
        })()
        // eslint-disable-next-line class-methods-use-this
      }, {
        key: "getNode",
        value: /* @__PURE__ */ (function() {
          function getNode() {
            throw new Error("ShallowWrapper::getNode() is no longer supported. Use ShallowWrapper::getElement() instead");
          }
          return getNode;
        })()
        // eslint-disable-next-line class-methods-use-this
      }, {
        key: "getNodes",
        value: /* @__PURE__ */ (function() {
          function getNodes() {
            throw new Error("ShallowWrapper::getNodes() is no longer supported. Use ShallowWrapper::getElements() instead");
          }
          return getNodes;
        })()
        /**
         * Gets the instance of the component being rendered as the root node passed into `shallow()`.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * Example:
         * ```
         * const wrapper = shallow(<MyComponent />);
         * const inst = wrapper.instance();
         * expect(inst).to.be.instanceOf(MyComponent);
         * ```
         * @returns {ReactComponent}
         */
      }, {
        key: "instance",
        value: /* @__PURE__ */ (function() {
          function instance() {
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::instance() can only be called on the root");
            }
            return this[RENDERER].getNode().instance;
          }
          return instance;
        })()
        /**
         * If a `wrappingComponent` was passed in `options`, this methods returns a `ShallowWrapper`
         * around the rendered `wrappingComponent`. This `ShallowWrapper` can be used to update the
         * `wrappingComponent`'s props, state, etc.
         *
         * @returns ShallowWrapper
         */
      }, {
        key: "getWrappingComponent",
        value: /* @__PURE__ */ (function() {
          function getWrappingComponent() {
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::getWrappingComponent() can only be called on the root");
            }
            if (!this[OPTIONS].wrappingComponent) {
              throw new Error("ShallowWrapper::getWrappingComponent() can only be called on a wrapper that was originally passed a `wrappingComponent` option");
            }
            return this[WRAPPING_COMPONENT];
          }
          return getWrappingComponent;
        })()
        /**
         * Forces a re-render. Useful to run before checking the render output if something external
         * may be updating the state of the component somewhere.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @returns {ShallowWrapper}
         */
      }, {
        key: "update",
        value: /* @__PURE__ */ (function() {
          function update() {
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::update() can only be called on the root");
            }
            if (this.length !== 1) {
              throw new Error("ShallowWrapper::update() can only be called when wrapping one node");
            }
            privateSetNodes(this, getRootNode(this[RENDERER].getNode()));
            return this;
          }
          return update;
        })()
        /**
         * A method that unmounts the component. This can be used to simulate a component going through
         * and unmount/mount lifecycle.
         * @returns {ShallowWrapper}
         */
      }, {
        key: "unmount",
        value: /* @__PURE__ */ (function() {
          function unmount() {
            this[RENDERER].unmount();
            if (this[ROOT][WRAPPING_COMPONENT]) {
              this[ROOT][WRAPPING_COMPONENT].unmount();
            }
            return this;
          }
          return unmount;
        })()
        /**
         * A method is for re-render with new props and context.
         * This calls componentDidUpdate method if disableLifecycleMethods is not enabled.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} props
         * @param {Object} context
         * @returns {ShallowWrapper}
         */
      }, {
        key: "rerender",
        value: /* @__PURE__ */ (function() {
          function rerender(props, context) {
            var _this4 = this;
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            this.single("rerender", function() {
              (0, _Utils.withSetStateAllowed)(function() {
                var node2 = _this4[RENDERER].getNode();
                var instance = node2.instance || {};
                var type2 = node2.type || {};
                var state = instance.state;
                var prevProps = instance.props || _this4[UNRENDERED].props;
                var prevContext = instance.context || _this4[OPTIONS].context;
                var nextContext = context || prevContext;
                if (context) {
                  _this4[OPTIONS] = (0, _object2["default"])({}, _this4[OPTIONS], {
                    context: nextContext
                  });
                }
                _this4[RENDERER].batchedUpdates(function() {
                  var lifecycles = getAdapterLifecycles(adapter);
                  var shouldRender = true;
                  var shouldComponentUpdateSpy = void 0;
                  var getChildContextSpy = void 0;
                  if (!_this4[OPTIONS].disableLifecycleMethods && instance) {
                    if (typeof instance.shouldComponentUpdate === "function") {
                      var gDSFP = lifecycles.getDerivedStateFromProps;
                      if (gDSFP && gDSFP.hasShouldComponentUpdateBug) {
                        mockSCUIfgDSFPReturnNonNull(node2, state);
                      }
                      shouldComponentUpdateSpy = (0, _Utils.spyMethod)(instance, "shouldComponentUpdate");
                    }
                    if (lifecycles.getChildContext.calledByRenderer && typeof instance.getChildContext === "function") {
                      getChildContextSpy = (0, _Utils.spyMethod)(instance, "getChildContext");
                    }
                  }
                  if (!shouldComponentUpdateSpy && isPureComponent(instance)) {
                    shouldRender = pureComponentShouldComponentUpdate(prevProps, props, state, instance.state);
                  }
                  if (props) _this4[UNRENDERED] = (0, _Utils.cloneElement)(adapter, _this4[UNRENDERED], props);
                  _this4[RENDERER].render(_this4[UNRENDERED], nextContext, {
                    providerValues: _this4[PROVIDER_VALUES]
                  });
                  if (shouldComponentUpdateSpy) {
                    shouldRender = shouldComponentUpdateSpy.getLastReturnValue();
                    shouldComponentUpdateSpy.restore();
                  }
                  if (shouldRender && !_this4[OPTIONS].disableLifecycleMethods && instance) {
                    privateSetChildContext(adapter, _this4, instance, node2, getChildContextSpy);
                    if (lifecycles.getSnapshotBeforeUpdate) {
                      var snapshot = void 0;
                      if (typeof instance.getSnapshotBeforeUpdate === "function") {
                        snapshot = instance.getSnapshotBeforeUpdate(prevProps, state);
                      }
                      if (lifecycles.componentDidUpdate && typeof instance.componentDidUpdate === "function" && (!state || (0, _enzymeShallowEqual2["default"])(state, _this4.instance().state) || typeof type2.getDerivedStateFromProps === "function")) {
                        instance.componentDidUpdate(prevProps, state, snapshot);
                      }
                    } else if (lifecycles.componentDidUpdate && typeof instance.componentDidUpdate === "function") {
                      if (lifecycles.componentDidUpdate.prevContext) {
                        instance.componentDidUpdate(prevProps, state, prevContext);
                      } else if (!state || (0, _enzymeShallowEqual2["default"])(_this4.instance().state, state)) {
                        instance.componentDidUpdate(prevProps, state);
                      }
                    }
                  } else if (!(0, _enzymeShallowEqual2["default"])(props, instance.props)) {
                    instance.props = (Object.freeze || Object)((0, _object2["default"])({}, instance.props, props));
                  }
                  _this4.update();
                });
              });
            });
            return this;
          }
          return rerender;
        })()
        /**
         * A method that sets the props of the root component, and re-renders. Useful for when you are
         * wanting to test how the component behaves over time with changing props. Calling this, for
         * instance, will call the `componentWillReceiveProps` lifecycle method.
         *
         * Similar to `setState`, this method accepts a props object and will merge it in with the already
         * existing props.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} props object
         * @param {Function} cb - callback function
         * @returns {ShallowWrapper}
         */
      }, {
        key: "setProps",
        value: /* @__PURE__ */ (function() {
          function setProps(props) {
            var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::setProps() can only be called on the root");
            }
            if (arguments.length > 1 && typeof callback !== "function") {
              throw new TypeError("ReactWrapper::setProps() expects a function as its second argument");
            }
            this.rerender(props);
            if (callback) {
              callback();
            }
            return this;
          }
          return setProps;
        })()
        /**
         * A method to invoke `setState` on the root component instance similar to how you might in the
         * definition of the component, and re-renders.  This method is useful for testing your component
         * in hard to achieve states, however should be used sparingly. If possible, you should utilize
         * your component's external API in order to get it into whatever state you want to test, in order
         * to be as accurate of a test as possible. This is not always practical, however.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} state to merge
         * @param {Function} cb - callback function
         * @returns {ShallowWrapper}
         */
      }, {
        key: "setState",
        value: /* @__PURE__ */ (function() {
          function setState(state) {
            var _this5 = this;
            var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::setState() can only be called on the root");
            }
            if (this.instance() === null || this[RENDERER].getNode().nodeType !== "class") {
              throw new Error("ShallowWrapper::setState() can only be called on class components");
            }
            if (arguments.length > 1 && typeof callback !== "function") {
              throw new TypeError("ReactWrapper::setState() expects a function as its second argument");
            }
            this.single("setState", function() {
              (0, _Utils.withSetStateAllowed)(function() {
                var adapter = (0, _getAdapter2["default"])(_this5[OPTIONS]);
                var lifecycles = getAdapterLifecycles(adapter);
                var node2 = _this5[RENDERER].getNode();
                var instance = node2.instance;
                var prevProps = instance.props;
                var prevState = instance.state;
                var prevContext = instance.context;
                var statePayload = typeof state === "function" ? state.call(instance, prevState, prevProps) : state;
                var maybeHasUpdate = !lifecycles.setState.skipsComponentDidUpdateOnNullish || statePayload != null;
                var shouldComponentUpdateSpy = void 0;
                var getChildContextSpy = void 0;
                var shouldRender = true;
                if (!_this5[OPTIONS].disableLifecycleMethods && instance) {
                  if (lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.onSetState && typeof instance.shouldComponentUpdate === "function") {
                    var gDSFP = lifecycles.getDerivedStateFromProps;
                    if (gDSFP && gDSFP.hasShouldComponentUpdateBug) {
                      mockSCUIfgDSFPReturnNonNull(node2, state);
                    }
                    shouldComponentUpdateSpy = (0, _Utils.spyMethod)(instance, "shouldComponentUpdate");
                  }
                  if (lifecycles.getChildContext.calledByRenderer && typeof instance.getChildContext === "function") {
                    getChildContextSpy = (0, _Utils.spyMethod)(instance, "getChildContext");
                  }
                }
                if (!shouldComponentUpdateSpy && isPureComponent(instance)) {
                  shouldRender = pureComponentShouldComponentUpdate(prevProps, instance.props, prevState, (0, _object2["default"])({}, prevState, statePayload));
                }
                if (instance[SET_STATE]) {
                  instance[SET_STATE](statePayload);
                } else {
                  instance.setState(statePayload);
                }
                if (shouldComponentUpdateSpy) {
                  shouldRender = shouldComponentUpdateSpy.getLastReturnValue();
                  shouldComponentUpdateSpy.restore();
                }
                if (maybeHasUpdate && shouldRender && !_this5[OPTIONS].disableLifecycleMethods) {
                  privateSetChildContext(adapter, _this5, instance, node2, getChildContextSpy);
                  if (lifecycles.componentDidUpdate && lifecycles.componentDidUpdate.onSetState) {
                    if (lifecycles.getSnapshotBeforeUpdate && typeof instance.getSnapshotBeforeUpdate === "function") {
                      var snapshot = instance.getSnapshotBeforeUpdate(prevProps, prevState);
                      if (typeof instance.componentDidUpdate === "function") {
                        instance.componentDidUpdate(prevProps, prevState, snapshot);
                      }
                    } else if (typeof instance.componentDidUpdate === "function") {
                      if (lifecycles.componentDidUpdate.prevContext) {
                        instance.componentDidUpdate(prevProps, prevState, prevContext);
                      } else {
                        instance.componentDidUpdate(prevProps, prevState);
                      }
                    }
                  }
                }
                _this5.update();
                if (callback) {
                  if (adapter.invokeSetStateCallback) {
                    adapter.invokeSetStateCallback(instance, callback);
                  } else {
                    callback.call(instance);
                  }
                }
              });
            });
            return this;
          }
          return setState;
        })()
        /**
         * A method that sets the context of the root component, and re-renders. Useful for when you are
         * wanting to test how the component behaves over time with changing contexts.
         *
         * NOTE: can only be called on a wrapper instance that is also the root instance.
         *
         * @param {Object} context object
         * @returns {ShallowWrapper}
         */
      }, {
        key: "setContext",
        value: /* @__PURE__ */ (function() {
          function setContext(context) {
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::setContext() can only be called on the root");
            }
            if (!this[OPTIONS].context) {
              throw new Error("ShallowWrapper::setContext() can only be called on a wrapper that was originally passed a context option");
            }
            return this.rerender(null, context);
          }
          return setContext;
        })()
        /**
         * Whether or not a given react element exists in the shallow render tree.
         *
         * Example:
         * ```
         * const wrapper = shallow(<MyComponent />);
         * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
         * ```
         *
         * @param {ReactElement|Array<ReactElement>} nodeOrNodes
         * @returns {Boolean}
         */
      }, {
        key: "contains",
        value: /* @__PURE__ */ (function() {
          function contains2(nodeOrNodes) {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            if (!(0, _Utils.isReactElementAlike)(nodeOrNodes, adapter)) {
              throw new Error("ShallowWrapper::contains() can only be called with a ReactElement (or an array of them), a string, or a number as an argument.");
            }
            var predicate = Array.isArray(nodeOrNodes) ? function(other) {
              return (0, _Utils.containsChildrenSubArray)(_Utils.nodeEqual, other, nodeOrNodes.map(function(node2) {
                return adapter.elementToNode(node2);
              }));
            } : function(other) {
              return (0, _Utils.nodeEqual)(adapter.elementToNode(nodeOrNodes), other);
            };
            return findWhereUnwrapped(this, predicate).length > 0;
          }
          return contains2;
        })()
        /**
         * Whether or not a given react element exists in the shallow render tree.
         * Match is based on the expected element and not on wrappers element.
         * It will determine if one of the wrappers element "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrappers element and equals to each other.
         *
         * Example:
         * ```
         * // MyComponent outputs <div><div class="foo">Hello</div></div>
         * const wrapper = shallow(<MyComponent />);
         * expect(wrapper.containsMatchingElement(<div>Hello</div>)).to.equal(true);
         * ```
         *
         * @param {ReactElement} node
         * @returns {Boolean}
         */
      }, {
        key: "containsMatchingElement",
        value: /* @__PURE__ */ (function() {
          function containsMatchingElement(node2) {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            var rstNode = adapter.elementToNode(node2);
            var predicate = /* @__PURE__ */ (function() {
              function predicate2(other) {
                return (0, _Utils.nodeMatches)(rstNode, other, function(a, b) {
                  return a <= b;
                });
              }
              return predicate2;
            })();
            return findWhereUnwrapped(this, predicate).length > 0;
          }
          return containsMatchingElement;
        })()
        /**
         * Whether or not all the given react elements exist in the shallow render tree.
         * Match is based on the expected element and not on wrappers element.
         * It will determine if one of the wrappers element "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrappers element and equals to each other.
         *
         * Example:
         * ```
         * const wrapper = shallow(<MyComponent />);
         * expect(wrapper.containsAllMatchingElements([
         *   <div>Hello</div>,
         *   <div>Goodbye</div>,
         * ])).to.equal(true);
         * ```
         *
         * @param {Array<ReactElement>} nodes
         * @returns {Boolean}
         */
      }, {
        key: "containsAllMatchingElements",
        value: /* @__PURE__ */ (function() {
          function containsAllMatchingElements(nodes) {
            var _this6 = this;
            if (!Array.isArray(nodes)) {
              throw new TypeError("nodes should be an Array");
            }
            return nodes.every(function(node2) {
              return _this6.containsMatchingElement(node2);
            });
          }
          return containsAllMatchingElements;
        })()
        /**
         * Whether or not one of the given react elements exists in the shallow render tree.
         * Match is based on the expected element and not on wrappers element.
         * It will determine if one of the wrappers element "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrappers element and equals to each other.
         *
         * Example:
         * ```
         * const wrapper = shallow(<MyComponent />);
         * expect(wrapper.containsAnyMatchingElements([
         *   <div>Hello</div>,
         *   <div>Goodbye</div>,
         * ])).to.equal(true);
         * ```
         *
         * @param {Array<ReactElement>} nodes
         * @returns {Boolean}
         */
      }, {
        key: "containsAnyMatchingElements",
        value: /* @__PURE__ */ (function() {
          function containsAnyMatchingElements(nodes) {
            var _this7 = this;
            return Array.isArray(nodes) && nodes.some(function(node2) {
              return _this7.containsMatchingElement(node2);
            });
          }
          return containsAnyMatchingElements;
        })()
        /**
         * Whether or not a given react element exists in the render tree.
         *
         * Example:
         * ```
         * const wrapper = shallow(<MyComponent />);
         * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
         * ```
         *
         * @param {ReactElement} node
         * @returns {Boolean}
         */
      }, {
        key: "equals",
        value: /* @__PURE__ */ (function() {
          function equals2(node2) {
            var _this8 = this;
            return this.single("equals", function() {
              return (0, _Utils.nodeEqual)(_this8.getNodeInternal(), node2);
            });
          }
          return equals2;
        })()
        /**
         * Whether or not a given react element matches the render tree.
         * Match is based on the expected element and not on wrapper root node.
         * It will determine if the wrapper root node "looks like" the expected
         * element by checking if all props of the expected element are present
         * on the wrapper root node and equals to each other.
         *
         * Example:
         * ```
         * // MyComponent outputs <div class="foo">Hello</div>
         * const wrapper = shallow(<MyComponent />);
         * expect(wrapper.matchesElement(<div>Hello</div>)).to.equal(true);
         * ```
         *
         * @param {ReactElement} node
         * @returns {Boolean}
         */
      }, {
        key: "matchesElement",
        value: /* @__PURE__ */ (function() {
          function matchesElement(node2) {
            var _this9 = this;
            return this.single("matchesElement", function() {
              var adapter = (0, _getAdapter2["default"])(_this9[OPTIONS]);
              var rstNode = adapter.elementToNode(node2);
              return (0, _Utils.nodeMatches)(rstNode, _this9.getNodeInternal(), function(a, b) {
                return a <= b;
              });
            });
          }
          return matchesElement;
        })()
        /**
         * Finds every node in the render tree of the current wrapper that matches the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {ShallowWrapper}
         */
      }, {
        key: "find",
        value: /* @__PURE__ */ (function() {
          function find2(selector2) {
            return this.wrap((0, _selectors.reduceTreesBySelector)(selector2, this.getNodesInternal()));
          }
          return find2;
        })()
        /**
         * Returns whether or not current node matches a provided selector.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {EnzymeSelector} selector
         * @returns {boolean}
         */
      }, {
        key: "is",
        value: /* @__PURE__ */ (function() {
          function is(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return this.single("is", function(n) {
              return predicate(n);
            });
          }
          return is;
        })()
        /**
         * Returns true if the component rendered nothing, i.e., null or false.
         *
         * @returns {boolean}
         */
      }, {
        key: "isEmptyRender",
        value: /* @__PURE__ */ (function() {
          function isEmptyRender() {
            var nodes = this.getNodesInternal();
            return nodes.every(function(n) {
              return (0, _Utils.isEmptyValue)(n);
            });
          }
          return isEmptyRender;
        })()
        /**
         * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
         * the provided predicate function. The predicate should receive a wrapped node as its first
         * argument.
         *
         * @param {Function} predicate
         * @returns {ShallowWrapper}
         */
      }, {
        key: "filterWhere",
        value: /* @__PURE__ */ (function() {
          function filterWhere(predicate) {
            var _this10 = this;
            return filterWhereUnwrapped(this, function(n) {
              return predicate(_this10.wrap(n));
            });
          }
          return filterWhere;
        })()
        /**
         * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
         * the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {ShallowWrapper}
         */
      }, {
        key: "filter",
        value: /* @__PURE__ */ (function() {
          function filter2(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return filterWhereUnwrapped(this, predicate);
          }
          return filter2;
        })()
        /**
         * Returns a new wrapper instance with only the nodes of the current wrapper that did not match
         * the provided selector. Essentially the inverse of `filter`.
         *
         * @param {EnzymeSelector} selector
         * @returns {ShallowWrapper}
         */
      }, {
        key: "not",
        value: /* @__PURE__ */ (function() {
          function not2(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return filterWhereUnwrapped(this, function(n) {
              return !predicate(n);
            });
          }
          return not2;
        })()
        /**
         * Returns a string of the rendered text of the current render tree.  This function should be
         * looked at with skepticism if being used to test what the actual HTML output of the component
         * will be. If that is what you would like to test, use enzyme's `render` function instead.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {String}
         */
      }, {
        key: "text",
        value: /* @__PURE__ */ (function() {
          function text2() {
            return this.single("text", _RSTTraversal.getTextFromNode);
          }
          return text2;
        })()
        /**
         * Returns the HTML of the node.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {String}
         */
      }, {
        key: "html",
        value: /* @__PURE__ */ (function() {
          function html2() {
            var _this11 = this;
            return this.single("html", function(n) {
              if (_this11.type() === null) return null;
              var adapter = (0, _getAdapter2["default"])(_this11[OPTIONS]);
              var renderer = adapter.createRenderer((0, _object2["default"])({}, _this11[OPTIONS], {
                mode: "string"
              }));
              return renderer.render(adapter.nodeToElement(n));
            });
          }
          return html2;
        })()
        /**
         * Returns the current node rendered to HTML and wrapped in a CheerioWrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {CheerioWrapper}
         */
      }, {
        key: "render",
        value: /* @__PURE__ */ (function() {
          function render3() {
            var html2 = this.html();
            return (0, _Utils.loadCheerioRoot)(html2);
          }
          return render3;
        })()
        /**
         * Used to simulate events. Pass an eventname and (optionally) event arguments. This method of
         * testing events should be met with some skepticism.
         *
         * @param {String} event
         * @param {Array} args
         * @returns {ShallowWrapper}
         */
      }, {
        key: "simulate",
        value: /* @__PURE__ */ (function() {
          function simulate(event) {
            var _this12 = this;
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            return this.single("simulate", function(n) {
              var _RENDERER;
              (_RENDERER = _this12[RENDERER]).simulateEvent.apply(_RENDERER, [n, event].concat(args));
              _this12[ROOT].update();
              return _this12;
            });
          }
          return simulate;
        })()
        /**
         * Used to simulate throwing a rendering error. Pass an error to throw.
         *
         * @param {String} error
         * @returns {ShallowWrapper}
         */
      }, {
        key: "simulateError",
        value: /* @__PURE__ */ (function() {
          function simulateError(error) {
            var _this13 = this;
            return this.single("simulateError", function(thisNode) {
              if (thisNode.nodeType === "host") {
                throw new TypeError("ShallowWrapper::simulateError() can only be called on custom components");
              }
              var renderer = _this13[RENDERER];
              if (typeof renderer.simulateError !== "function") {
                throw new TypeError("your adapter does not support `simulateError`. Try upgrading it!");
              }
              var rootNode = getRootNodeInternal(_this13);
              var nodeHierarchy = [thisNode].concat(nodeParents(_this13, thisNode));
              renderer.simulateError(nodeHierarchy, rootNode, error);
              return _this13;
            });
          }
          return simulateError;
        })()
        /**
         * Returns the props hash for the current node of the wrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @returns {Object}
         */
      }, {
        key: "props",
        value: /* @__PURE__ */ (function() {
          function props() {
            return this.single("props", _RSTTraversal.propsOfNode);
          }
          return props;
        })()
        /**
         * Returns the state hash for the root node of the wrapper. Optionally pass in a prop name and it
         * will return just that value.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {String} name (optional)
         * @returns {*}
         */
      }, {
        key: "state",
        value: /* @__PURE__ */ (function() {
          function state(name) {
            var _this14 = this;
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::state() can only be called on the root");
            }
            if (this.instance() === null || this[RENDERER].getNode().nodeType !== "class") {
              throw new Error("ShallowWrapper::state() can only be called on class components");
            }
            var _state = this.single("state", function() {
              return _this14.instance().state;
            });
            if (typeof name !== "undefined") {
              if (_state == null) {
                throw new TypeError('ShallowWrapper::state("' + String(name) + '") requires that `state` not be `null` or `undefined`');
              }
              return _state[name];
            }
            return _state;
          }
          return state;
        })()
        /**
         * Returns the context hash for the root node of the wrapper.
         * Optionally pass in a prop name and it will return just that value.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {String} name (optional)
         * @returns {*}
         */
      }, {
        key: "context",
        value: /* @__PURE__ */ (function() {
          function context(name) {
            var _this15 = this;
            if (this[ROOT] !== this) {
              throw new Error("ShallowWrapper::context() can only be called on the root");
            }
            if (!this[OPTIONS].context) {
              throw new Error("ShallowWrapper::context() can only be called on a wrapper that was originally passed a context option");
            }
            if (this.instance() === null) {
              throw new Error("ShallowWrapper::context() can only be called on wrapped nodes that have a non-null instance");
            }
            var _context = this.single("context", function() {
              return _this15.instance().context;
            });
            if (name) {
              return _context[name];
            }
            return _context;
          }
          return context;
        })()
        /**
         * Returns a new wrapper with all of the children of the current wrapper.
         *
         * @param {EnzymeSelector} [selector]
         * @returns {ShallowWrapper}
         */
      }, {
        key: "children",
        value: /* @__PURE__ */ (function() {
          function children2(selector2) {
            var allChildren = this.flatMap(function(n) {
              return (0, _RSTTraversal.childrenOfNode)(n.getNodeInternal());
            });
            return selector2 ? allChildren.filter(selector2) : allChildren;
          }
          return children2;
        })()
        /**
         * Returns a new wrapper with a specific child
         *
         * @param {Number} [index]
         * @returns {ShallowWrapper}
         */
      }, {
        key: "childAt",
        value: /* @__PURE__ */ (function() {
          function childAt(index2) {
            var _this16 = this;
            return this.single("childAt", function() {
              return _this16.children().at(index2);
            });
          }
          return childAt;
        })()
        /**
         * Returns a wrapper around all of the parents/ancestors of the wrapper. Does not include the node
         * in the current wrapper.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param {EnzymeSelector} [selector]
         * @returns {ShallowWrapper}
         */
      }, {
        key: "parents",
        value: /* @__PURE__ */ (function() {
          function parents(selector2) {
            var _this17 = this;
            return this.single("parents", function(n) {
              var allParents = _this17.wrap(nodeParents(_this17, n));
              return selector2 ? allParents.filter(selector2) : allParents;
            });
          }
          return parents;
        })()
        /**
         * Returns a wrapper around the immediate parent of the current node.
         *
         * @returns {ShallowWrapper}
         */
      }, {
        key: "parent",
        value: /* @__PURE__ */ (function() {
          function parent() {
            return this.flatMap(function(n) {
              return [n.parents().get(0)];
            });
          }
          return parent;
        })()
        /**
         *
         * @param {EnzymeSelector} selector
         * @returns {ShallowWrapper}
         */
      }, {
        key: "closest",
        value: /* @__PURE__ */ (function() {
          function closest(selector2) {
            if (this.is(selector2)) {
              return this;
            }
            var matchingAncestors = this.parents().filter(selector2);
            return matchingAncestors.length > 0 ? matchingAncestors.first() : this.findWhere(function() {
              return false;
            });
          }
          return closest;
        })()
        /**
         * Shallow renders the current node and returns a shallow wrapper around it.
         *
         * NOTE: can only be called on wrapper of a single node.
         *
         * @param {Object} options
         * @returns {ShallowWrapper}
         */
      }, {
        key: "shallow",
        value: /* @__PURE__ */ (function() {
          function shallow2() {
            var _this18 = this;
            var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return this.single("shallow", function(n) {
              var childOptions = makeInheritedChildOptions(_this18, options2);
              return _this18.wrap((0, _getAdapter2["default"])(_this18[OPTIONS]).nodeToElement(n), null, childOptions);
            });
          }
          return shallow2;
        })()
        /**
         * Returns the value of prop with the given name of the current node.
         *
         * @param propName
         * @returns {*}
         */
      }, {
        key: "prop",
        value: /* @__PURE__ */ (function() {
          function prop2(propName) {
            return this.props()[propName];
          }
          return prop2;
        })()
        /**
         * Used to invoke a function prop.
         * Will invoke an function prop and return its value.
         *
         * @param {String} propName
         * @returns {Any}
         */
      }, {
        key: "invoke",
        value: /* @__PURE__ */ (function() {
          function invoke(propName) {
            var _this19 = this;
            return this.single("invoke", function() {
              var handler = _this19.prop(propName);
              if (typeof handler !== "function") {
                throw new TypeError("ShallowWrapper::invoke() requires the name of a prop whose value is a function");
              }
              return function() {
                var response = handler.apply(void 0, arguments);
                _this19[ROOT].update();
                return response;
              };
            });
          }
          return invoke;
        })()
        /**
         * Returns a wrapper of the node rendered by the provided render prop.
         *
         * @param {String} propName
         * @returns {Function}
         */
      }, {
        key: "renderProp",
        value: /* @__PURE__ */ (function() {
          function renderProp(propName) {
            var _this20 = this;
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            if (typeof adapter.wrap !== "function") {
              throw new RangeError("your adapter does not support `wrap`. Try upgrading it!");
            }
            return this.single("renderProp", function(n) {
              if (n.nodeType === "host") {
                throw new TypeError("ShallowWrapper::renderProp() can only be called on custom components");
              }
              if (typeof propName !== "string") {
                throw new TypeError("ShallowWrapper::renderProp(): `propName` must be a string");
              }
              var props = _this20.props();
              if (!(0, _has2["default"])(props, propName)) {
                throw new Error("ShallowWrapper::renderProp(): no prop called “" + String(propName) + "“ found");
              }
              var propValue = props[propName];
              if (typeof propValue !== "function") {
                throw new TypeError("ShallowWrapper::renderProp(): expected prop “" + String(propName) + "“ to contain a function, but it holds “" + (typeof propValue === "undefined" ? "undefined" : _typeof2(propValue)) + "“");
              }
              return function() {
                var element = propValue.apply(void 0, arguments);
                var wrapped = adapter.wrap(element);
                return _this20.wrap(wrapped, null, _this20[OPTIONS]);
              };
            });
          }
          return renderProp;
        })()
        /**
         * Returns the key assigned to the current node.
         *
         * @returns {String}
         */
      }, {
        key: "key",
        value: /* @__PURE__ */ (function() {
          function key() {
            return this.single("key", function(n) {
              return n.key === void 0 ? null : n.key;
            });
          }
          return key;
        })()
        /**
         * Returns the type of the current node of this wrapper. If it's a composite component, this will
         * be the component constructor. If it's a native DOM node, it will be a string of the tag name.
         * If it's null, it will be null.
         *
         * @returns {String|Function|null}
         */
      }, {
        key: "type",
        value: /* @__PURE__ */ (function() {
          function type2() {
            return this.single("type", function(n) {
              return (0, _Utils.typeOfNode)(n);
            });
          }
          return type2;
        })()
        /**
         * Returns the name of the current node of this wrapper.
         *
         * In order of precedence => type.displayName -> type.name -> type.
         *
         * @returns {String}
         */
      }, {
        key: "name",
        value: /* @__PURE__ */ (function() {
          function name() {
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return this.single("name", function(n) {
              return adapter.displayNameOfNode ? adapter.displayNameOfNode(n) : (0, _Utils.displayNameOfNode)(n);
            });
          }
          return name;
        })()
        /**
         * Returns whether or not the current node has the given class name or not.
         *
         * NOTE: can only be called on a wrapper of a single node.
         *
         * @param className
         * @returns {Boolean}
         */
      }, {
        key: "hasClass",
        value: /* @__PURE__ */ (function() {
          function hasClass2(className) {
            if (typeof className === "string" && className.indexOf(".") !== -1) {
              console.warn("It looks like you're calling `ShallowWrapper::hasClass()` with a CSS selector. hasClass() expects a class name, not a CSS selector.");
            }
            return this.single("hasClass", function(n) {
              return (0, _RSTTraversal.hasClassName)(n, className);
            });
          }
          return hasClass2;
        })()
        /**
         * Iterates through each node of the current wrapper and executes the provided function with a
         * wrapper around the corresponding node passed in as the first argument.
         *
         * @param {Function} fn
         * @returns {ShallowWrapper}
         */
      }, {
        key: "forEach",
        value: /* @__PURE__ */ (function() {
          function forEach2(fn) {
            var _this21 = this;
            this.getNodesInternal().forEach(function(n, i) {
              return fn.call(_this21, _this21.wrap(n), i);
            });
            return this;
          }
          return forEach2;
        })()
        /**
         * Maps the current array of nodes to another array. Each node is passed in as a `ShallowWrapper`
         * to the map function.
         *
         * @param {Function} fn
         * @returns {Array}
         */
      }, {
        key: "map",
        value: /* @__PURE__ */ (function() {
          function map2(fn) {
            var _this22 = this;
            return this.getNodesInternal().map(function(n, i) {
              return fn.call(_this22, _this22.wrap(n), i);
            });
          }
          return map2;
        })()
        /**
         * Reduces the current array of nodes to a value. Each node is passed in as a `ShallowWrapper`
         * to the reducer function.
         *
         * @param {Function} fn - the reducer function
         * @param {*} initialValue - the initial value
         * @returns {*}
         */
      }, {
        key: "reduce",
        value: /* @__PURE__ */ (function() {
          function reduce2(fn) {
            var _this23 = this;
            var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (arguments.length > 1) {
              return this.getNodesInternal().reduce(function(accum, n, i) {
                return fn.call(_this23, accum, _this23.wrap(n), i);
              }, initialValue);
            }
            return this.getNodesInternal().reduce(function(accum, n, i) {
              return fn.call(_this23, i === 1 ? _this23.wrap(accum) : accum, _this23.wrap(n), i);
            });
          }
          return reduce2;
        })()
        /**
         * Reduces the current array of nodes to another array, from right to left. Each node is passed
         * in as a `ShallowWrapper` to the reducer function.
         *
         * @param {Function} fn - the reducer function
         * @param {*} initialValue - the initial value
         * @returns {*}
         */
      }, {
        key: "reduceRight",
        value: /* @__PURE__ */ (function() {
          function reduceRight(fn) {
            var _this24 = this;
            var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
            if (arguments.length > 1) {
              return this.getNodesInternal().reduceRight(function(accum, n, i) {
                return fn.call(_this24, accum, _this24.wrap(n), i);
              }, initialValue);
            }
            return this.getNodesInternal().reduceRight(function(accum, n, i) {
              return fn.call(_this24, i === 1 ? _this24.wrap(accum) : accum, _this24.wrap(n), i);
            });
          }
          return reduceRight;
        })()
        /**
         * Returns a new wrapper with a subset of the nodes of the original wrapper, according to the
         * rules of `Array#slice`.
         *
         * @param {Number} begin
         * @param {Number} end
         * @returns {ShallowWrapper}
         */
      }, {
        key: "slice",
        value: /* @__PURE__ */ (function() {
          function slice2(begin, end2) {
            return this.wrap(this.getNodesInternal().slice(begin, end2));
          }
          return slice2;
        })()
        /**
         * Returns whether or not any of the nodes in the wrapper match the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {Boolean}
         */
      }, {
        key: "some",
        value: /* @__PURE__ */ (function() {
          function some2(selector2) {
            if (this[ROOT] === this) {
              throw new Error("ShallowWrapper::some() can not be called on the root");
            }
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return this.getNodesInternal().some(predicate);
          }
          return some2;
        })()
        /**
         * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
         *
         * @param {Function} predicate
         * @returns {Boolean}
         */
      }, {
        key: "someWhere",
        value: /* @__PURE__ */ (function() {
          function someWhere(predicate) {
            var _this25 = this;
            return this.getNodesInternal().some(function(n, i) {
              return predicate.call(_this25, _this25.wrap(n), i);
            });
          }
          return someWhere;
        })()
        /**
         * Returns whether or not all of the nodes in the wrapper match the provided selector.
         *
         * @param {EnzymeSelector} selector
         * @returns {Boolean}
         */
      }, {
        key: "every",
        value: /* @__PURE__ */ (function() {
          function every2(selector2) {
            var predicate = (0, _selectors.buildPredicate)(selector2);
            return this.getNodesInternal().every(predicate);
          }
          return every2;
        })()
        /**
         * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
         *
         * @param {Function} predicate
         * @returns {Boolean}
         */
      }, {
        key: "everyWhere",
        value: /* @__PURE__ */ (function() {
          function everyWhere(predicate) {
            var _this26 = this;
            return this.getNodesInternal().every(function(n, i) {
              return predicate.call(_this26, _this26.wrap(n), i);
            });
          }
          return everyWhere;
        })()
        /**
         * Utility method used to create new wrappers with a mapping function that returns an array of
         * nodes in response to a single node wrapper. The returned wrapper is a single wrapper around
         * all of the mapped nodes flattened (and de-duplicated).
         *
         * @param {Function} fn
         * @returns {ShallowWrapper}
         */
      }, {
        key: "flatMap",
        value: /* @__PURE__ */ (function() {
          function flatMap(fn) {
            var _this27 = this;
            var nodes = this.getNodesInternal().map(function(n, i) {
              return fn.call(_this27, _this27.wrap(n), i);
            });
            var flattened = (0, _arrayPrototype2["default"])(nodes, 1);
            return this.wrap(flattened.filter(Boolean));
          }
          return flatMap;
        })()
        /**
         * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
         * function. The predicate function will receive the nodes inside a ShallowWrapper as its
         * first argument.
         *
         * @param {Function} predicate
         * @returns {ShallowWrapper}
         */
      }, {
        key: "findWhere",
        value: /* @__PURE__ */ (function() {
          function findWhere(predicate) {
            var _this28 = this;
            return findWhereUnwrapped(this, function(n) {
              var node2 = _this28.wrap(n);
              return node2.length > 0 && predicate(node2);
            });
          }
          return findWhere;
        })()
        /**
         * Returns the node at a given index of the current wrapper.
         *
         * @param index
         * @returns {ReactElement}
         */
      }, {
        key: "get",
        value: /* @__PURE__ */ (function() {
          function get3(index2) {
            return this.getElements()[index2];
          }
          return get3;
        })()
        /**
         * Returns a wrapper around the node at a given index of the current wrapper.
         *
         * @param index
         * @returns {ShallowWrapper}
         */
      }, {
        key: "at",
        value: /* @__PURE__ */ (function() {
          function at(index2) {
            var nodes = this.getNodesInternal();
            if (index2 < nodes.length) {
              return this.wrap(nodes[index2]);
            }
            return this.wrap([]);
          }
          return at;
        })()
        /**
         * Returns a wrapper around the first node of the current wrapper.
         *
         * @returns {ShallowWrapper}
         */
      }, {
        key: "first",
        value: /* @__PURE__ */ (function() {
          function first() {
            return this.at(0);
          }
          return first;
        })()
        /**
         * Returns a wrapper around the last node of the current wrapper.
         *
         * @returns {ShallowWrapper}
         */
      }, {
        key: "last",
        value: /* @__PURE__ */ (function() {
          function last() {
            return this.at(this.length - 1);
          }
          return last;
        })()
        /**
         * Delegates to exists()
         *
         * @returns {boolean}
         */
      }, {
        key: "isEmpty",
        value: /* @__PURE__ */ (function() {
          function isEmpty() {
            console.warn("Enzyme::Deprecated method isEmpty() called, use exists() instead.");
            return !this.exists();
          }
          return isEmpty;
        })()
        /**
         * Returns true if the current wrapper has nodes. False otherwise.
         * If called with a selector it returns `.find(selector).exists()` instead.
         *
         * @param {EnzymeSelector} selector (optional)
         * @returns {boolean}
         */
      }, {
        key: "exists",
        value: /* @__PURE__ */ (function() {
          function exists() {
            var selector2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            return arguments.length > 0 ? this.find(selector2).exists() : this.length > 0;
          }
          return exists;
        })()
        /**
         * Utility method that throws an error if the current instance has a length other than one.
         * This is primarily used to enforce that certain methods are only run on a wrapper when it is
         * wrapping a single node.
         *
         * @param fn
         * @returns {*}
         */
      }, {
        key: "single",
        value: /* @__PURE__ */ (function() {
          function single(name, fn) {
            var fnName = typeof name === "string" ? name : "unknown";
            var callback = typeof fn === "function" ? fn : name;
            if (this.length !== 1) {
              throw new Error("Method “" + fnName + "” is meant to be run on 1 node. " + String(this.length) + " found instead.");
            }
            return callback.call(this, this.getNodeInternal());
          }
          return single;
        })()
        /**
         * Helpful utility method to create a new wrapper with the same root as the current wrapper, with
         * any nodes passed in as the first parameter automatically wrapped.
         *
         * @param node
         * @returns {ShallowWrapper}
         */
      }, {
        key: "wrap",
        value: /* @__PURE__ */ (function() {
          function wrap2(node2) {
            var root2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[ROOT];
            if (node2 instanceof ShallowWrapper3) {
              return node2;
            }
            for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
              args[_key3 - 2] = arguments[_key3];
            }
            return new (Function.prototype.bind.apply(ShallowWrapper3, [null].concat([node2, root2], args)))();
          }
          return wrap2;
        })()
        /**
         * Returns an HTML-like string of the shallow render for debugging purposes.
         *
         * @param {Object} [options] - Property bag of additional options.
         * @param {boolean} [options.ignoreProps] - if true, props are omitted from the string.
         * @param {boolean} [options.verbose] - if true, arrays and objects to be verbosely printed.
         * @returns {String}
         */
      }, {
        key: "debug",
        value: /* @__PURE__ */ (function() {
          function debug() {
            var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return (0, _Debug.debugNodes)(this.getNodesInternal(), options2);
          }
          return debug;
        })()
        /**
         * Invokes intercepter and returns itself. intercepter is called with itself.
         * This is helpful when debugging nodes in method chains.
         * @param fn
         * @returns {ShallowWrapper}
         */
      }, {
        key: "tap",
        value: /* @__PURE__ */ (function() {
          function tap(intercepter) {
            intercepter(this);
            return this;
          }
          return tap;
        })()
        /**
         * Primarily useful for HOCs (higher-order components), this method may only be
         * run on a single, non-DOM node, and will return the node, shallow-rendered.
         *
         * @param {Object} options
         * @returns {ShallowWrapper}
         */
      }, {
        key: "dive",
        value: /* @__PURE__ */ (function() {
          function dive() {
            var _this29 = this;
            var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            var name = "dive";
            return this.single(name, function(n) {
              if (n && n.nodeType === "host") {
                throw new TypeError("ShallowWrapper::" + name + "() can not be called on Host Components");
              }
              var el2 = (0, _getAdapter2["default"])(_this29[OPTIONS]).nodeToElement(n);
              if (!(0, _Utils.isCustomComponentElement)(el2, adapter)) {
                throw new TypeError("ShallowWrapper::" + name + "() can only be called on components");
              }
              var childOptions = makeInheritedChildOptions(_this29, options2);
              return _this29.wrap(el2, null, childOptions);
            });
          }
          return dive;
        })()
        /**
         * Strips out all the not host-nodes from the list of nodes
         *
         * This method is useful if you want to check for the presence of host nodes
         * (actually rendered HTML elements) ignoring the React nodes.
         */
      }, {
        key: "hostNodes",
        value: /* @__PURE__ */ (function() {
          function hostNodes() {
            return this.filterWhere(function(n) {
              return typeof n.type() === "string";
            });
          }
          return hostNodes;
        })()
      }]);
      return ShallowWrapper3;
    })();
    function updatePrimaryRootContext(wrappingComponent) {
      var adapter = (0, _getAdapter2["default"])(wrappingComponent[OPTIONS]);
      var primaryWrapper = wrappingComponent[PRIMARY_WRAPPER];
      var primaryRenderer = primaryWrapper[RENDERER];
      var primaryNode = primaryRenderer.getNode();
      var _getContextFromWrappi2 = getContextFromWrappingComponent(wrappingComponent, adapter), legacyContext = _getContextFromWrappi2.legacyContext, providerValues = _getContextFromWrappi2.providerValues;
      var prevProviderValues = primaryWrapper[PROVIDER_VALUES];
      primaryWrapper.setContext((0, _object2["default"])({}, wrappingComponent[PRIMARY_WRAPPER][OPTIONS].context, legacyContext));
      primaryWrapper[PROVIDER_VALUES] = new Map([].concat(_toConsumableArray(prevProviderValues), _toConsumableArray(providerValues)));
      if (typeof adapter.isContextConsumer === "function" && adapter.isContextConsumer(primaryNode.type)) {
        var Consumer2 = primaryNode.type;
        var Provider2 = adapter.getProviderFromConsumer(Consumer2);
        var newValue = providerValues.get(Provider2);
        var oldValue = prevProviderValues.get(Provider2);
        if (newValue !== oldValue) {
          primaryWrapper.rerender();
        }
      }
    }
    var WrappingComponentWrapper = (function(_ShallowWrapper) {
      _inherits2(WrappingComponentWrapper2, _ShallowWrapper);
      function WrappingComponentWrapper2(nodes, root2, RootFinder) {
        _classCallCheck2(this, WrappingComponentWrapper2);
        var _this30 = _possibleConstructorReturn2(this, (WrappingComponentWrapper2.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2)).call(this, nodes));
        (0, _Utils.privateSet)(_this30, PRIMARY_WRAPPER, root2);
        (0, _Utils.privateSet)(_this30, ROOT_FINDER, RootFinder);
        return _this30;
      }
      _createClass2(WrappingComponentWrapper2, [{
        key: "rerender",
        value: /* @__PURE__ */ (function() {
          function rerender() {
            var _get22;
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args[_key4] = arguments[_key4];
            }
            var result = (_get22 = _get2(WrappingComponentWrapper2.prototype.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2.prototype), "rerender", this)).call.apply(_get22, [this].concat(args));
            updatePrimaryRootContext(this);
            return result;
          }
          return rerender;
        })()
        /**
         * Like setState() on ShallowWrapper, except it also does a "full render" of
         * itself and updates the primary ShallowWrapper's context.
         */
      }, {
        key: "setState",
        value: /* @__PURE__ */ (function() {
          function setState() {
            var _get3;
            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              args[_key5] = arguments[_key5];
            }
            var result = (_get3 = _get2(WrappingComponentWrapper2.prototype.__proto__ || Object.getPrototypeOf(WrappingComponentWrapper2.prototype), "setState", this)).call.apply(_get3, [this].concat(args));
            updatePrimaryRootContext(this);
            return result;
          }
          return setState;
        })()
        // eslint-disable-next-line class-methods-use-this
      }, {
        key: "getWrappingComponent",
        value: /* @__PURE__ */ (function() {
          function getWrappingComponent() {
            throw new Error("ShallowWrapper::getWrappingComponent() can only be called on the root");
          }
          return getWrappingComponent;
        })()
      }]);
      return WrappingComponentWrapper2;
    })(ShallowWrapper2);
    if (_Utils.ITERATOR_SYMBOL) {
      Object.defineProperty(ShallowWrapper2.prototype, _Utils.ITERATOR_SYMBOL, {
        configurable: true,
        value: /* @__PURE__ */ (function() {
          function iterator() {
            var _ref2;
            var iter = this.getNodesInternal()[_Utils.ITERATOR_SYMBOL]();
            var adapter = (0, _getAdapter2["default"])(this[OPTIONS]);
            return _ref2 = {}, _defineProperty2(_ref2, _Utils.ITERATOR_SYMBOL, function() {
              return this;
            }), _defineProperty2(_ref2, "next", /* @__PURE__ */ (function() {
              function next() {
                var next2 = iter.next();
                if (next2.done) {
                  return {
                    done: true
                  };
                }
                return {
                  done: false,
                  value: adapter.nodeToElement(next2.value)
                };
              }
              return next;
            })()), _ref2;
          }
          return iterator;
        })()
      });
    }
    function privateWarning(prop2, extraMessage) {
      Object.defineProperty(ShallowWrapper2.prototype, prop2, {
        get: /* @__PURE__ */ (function() {
          function get3() {
            throw new Error("\n        Attempted to access ShallowWrapper::" + String(prop2) + ", which was previously a private property on\n        Enzyme ShallowWrapper instances, but is no longer and should not be relied upon.\n        " + String(extraMessage) + "\n      ");
          }
          return get3;
        })(),
        enumerable: false,
        configurable: false
      });
    }
    privateWarning("node", "Consider using the getElement() method instead.");
    privateWarning("nodes", "Consider using the getElements() method instead.");
    privateWarning("renderer", "");
    privateWarning("options", "");
    privateWarning("complexSelector", "");
    exports2["default"] = ShallowWrapper2;
  })(ShallowWrapper);
  return ShallowWrapper;
}
var mount = {};
var hasRequiredMount;
function requireMount() {
  if (hasRequiredMount) return mount;
  hasRequiredMount = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = mount2;
    var _ReactWrapper = requireReactWrapper();
    var _ReactWrapper2 = _interopRequireDefault(_ReactWrapper);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function mount2(node2, options2) {
      return new _ReactWrapper2["default"](node2, null, options2);
    }
  })(mount);
  return mount;
}
var shallow = {};
var hasRequiredShallow;
function requireShallow() {
  if (hasRequiredShallow) return shallow;
  hasRequiredShallow = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = shallow2;
    var _ShallowWrapper = requireShallowWrapper();
    var _ShallowWrapper2 = _interopRequireDefault(_ShallowWrapper);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function shallow2(node2, options2) {
      return new _ShallowWrapper2["default"](node2, null, options2);
    }
  })(shallow);
  return shallow;
}
var render$1 = {};
var hasRequiredRender;
function requireRender() {
  if (hasRequiredRender) return render$1;
  hasRequiredRender = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2["default"] = render3;
    var _object = requireObject_assign();
    var _object2 = _interopRequireDefault(_object);
    var _getAdapter = requireGetAdapter();
    var _getAdapter2 = _interopRequireDefault(_getAdapter);
    var _Utils = requireUtils();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function render3(node2) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var adapter = (0, _getAdapter2["default"])(options2);
      var renderer = adapter.createRenderer((0, _object2["default"])({
        mode: "string"
      }, options2));
      var html2 = renderer.render(node2, options2.context);
      return (0, _Utils.loadCheerioRoot)(html2);
    }
  })(render$1);
  return render$1;
}
var build;
var hasRequiredBuild;
function requireBuild() {
  if (hasRequiredBuild) return build;
  hasRequiredBuild = 1;
  var _ReactWrapper = requireReactWrapper();
  var _ReactWrapper2 = _interopRequireDefault(_ReactWrapper);
  var _ShallowWrapper = requireShallowWrapper();
  var _ShallowWrapper2 = _interopRequireDefault(_ShallowWrapper);
  var _EnzymeAdapter = requireEnzymeAdapter();
  var _EnzymeAdapter2 = _interopRequireDefault(_EnzymeAdapter);
  var _mount = requireMount();
  var _mount2 = _interopRequireDefault(_mount);
  var _shallow = requireShallow();
  var _shallow2 = _interopRequireDefault(_shallow);
  var _render = requireRender();
  var _render2 = _interopRequireDefault(_render);
  var _configuration = requireConfiguration();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  build = {
    render: _render2["default"],
    shallow: _shallow2["default"],
    mount: _mount2["default"],
    ShallowWrapper: _ShallowWrapper2["default"],
    ReactWrapper: _ReactWrapper2["default"],
    configure: _configuration.merge,
    EnzymeAdapter: _EnzymeAdapter2["default"]
  };
  return build;
}
var buildExports = requireBuild();
const containerRoots = /* @__PURE__ */ new WeakMap();
let _createRoot = null;
let _resolved = false;
if (typeof ReactDOM.createRoot === "function") {
  _createRoot = ReactDOM.createRoot;
  _resolved = true;
}
const _clientModuleId = "react-dom/client";
const _clientPromise = _resolved ? Promise.resolve() : import(
  /* @vite-ignore */
  /* webpackIgnore: true */
  _clientModuleId
).then((mod2) => {
  if (typeof mod2.createRoot === "function") {
    _createRoot = mod2.createRoot;
  }
}).catch(() => {
}).finally(() => {
  _resolved = true;
});
async function ensureReady() {
  if (!_resolved) await _clientPromise;
}
function renderToContainer(container, element) {
  if (_createRoot) {
    const root2 = _createRoot(container);
    root2.render(element);
    const handle2 = {
      unmount: () => root2.unmount()
    };
    containerRoots.set(container, handle2);
    return handle2;
  }
  ReactDOM.render(element, container);
  const handle = {
    unmount: () => ReactDOM.unmountComponentAtNode(container)
  };
  containerRoots.set(container, handle);
  return handle;
}
function unmountFromContainer(container) {
  const handle = containerRoots.get(container);
  if (handle) {
    handle.unmount();
    containerRoots.delete(container);
  } else if (typeof ReactDOM.unmountComponentAtNode === "function") {
    ReactDOM.unmountComponentAtNode(container);
  }
}
const TILE_LOADING_CHECK_INTERVAL = 100;
const changeOptions = (hgc, viewUid, trackUid, options2) => {
  for (const {
    viewId,
    trackId,
    track
  } of hgc.instance().iterateOverTracks()) {
    if (viewId === viewUid && trackId === trackUid) {
      track.options = {
        ...track.options,
        ...options2
      };
    }
  }
  hgc.setState(hgc.instance().state);
};
const areTransitionsActive = (hgc) => {
  for (const track of hgc.iterateOverTracks()) {
    const trackRenderer = getTrackRenderer(hgc, track.viewId);
    if (trackRenderer?.activeTransitions) return true;
  }
  return false;
};
const waitForTransitionsFinished = (hgc, callback) => {
  if (areTransitionsActive(hgc)) {
    setTimeout(() => {
      waitForTransitionsFinished(hgc, callback);
    }, TILE_LOADING_CHECK_INTERVAL);
  } else {
    callback();
  }
};
const waitForJsonComplete = (finished) => {
  if (requestsInFlight > 0) {
    setTimeout(() => waitForJsonComplete(finished), TILE_LOADING_CHECK_INTERVAL);
  } else {
    finished();
  }
};
const isWaitingOnTiles = (hgc) => {
  for (const track of hgc.iterateOverTracks()) {
    let trackObj = getTrackObjectFromHGC(hgc, track.viewId, track.trackId);
    if (!track.track.server && !track.track.tilesetUid && !(track.track.data && track.track.data.type === "divided") && !(track.track.data && track.track.data.type === "local-tiles")) {
      continue;
    }
    if (track.track.data && track.track.data.type === "divided" || track.track.server && track.track.tilesetUid || track.track.data && track.track.data.type === "local-tiles") {
      if (!trackObj) return true;
      if (trackObj.originalTrack) {
        trackObj = trackObj.originalTrack;
      }
      if (!(trackObj.tilesetInfo || trackObj.chromInfo)) {
        return true;
      }
      if (trackObj.fetching?.size) {
        return true;
      }
    } else {
      throw Error('"server" and "tilesetUid" belong together');
    }
  }
  return false;
};
const waitForTilesLoaded = (hgc, tilesLoadedCallback) => {
  if (isWaitingOnTiles(hgc)) {
    setTimeout(() => {
      waitForTilesLoaded(hgc, tilesLoadedCallback);
    }, TILE_LOADING_CHECK_INTERVAL);
  } else {
    tilesLoadedCallback();
  }
};
const mountHGComponent = (prevDiv, prevHgc, viewConf, done, options2 = {}) => {
  const {
    style = "width:800px; background-color: lightgreen;",
    bounded = false,
    extendedDelay = false
  } = options2;
  if (prevHgc) {
    prevHgc.unmount();
    prevHgc.detach();
  }
  if (prevDiv) {
    globalThis.document.body.removeChild(prevDiv);
  }
  const div2 = globalThis.document.createElement("div");
  globalThis.document.body.appendChild(div2);
  div2.setAttribute("style", style);
  div2.setAttribute("id", "simple-hg-component");
  const hgc = buildExports.mount(/* @__PURE__ */ React__default.createElement(HiGlassComponent, {
    options: {
      bounded
    },
    viewConfig: viewConf
  }), {
    attachTo: div2
  });
  hgc.update();
  waitForJsonComplete(() => {
    if (extendedDelay) {
      const doneWithDelay = () => setTimeout(() => {
        done();
      }, 1e3);
      waitForTilesLoaded(hgc.instance(), doneWithDelay);
    } else {
      waitForTilesLoaded(hgc.instance(), done);
    }
  });
  return (
    /** @type {const} */
    [div2, hgc]
  );
};
const removeHGComponent = (div2) => {
  if (!div2) return;
  unmountFromContainer(div2);
  document.body.removeChild(div2);
};
async function mountHGComponentAsync(prevDiv, prevHgc, viewConf, options2) {
  let res;
  await new Promise((resolve) => {
    res = mountHGComponent(prevDiv, prevHgc, viewConf, resolve, options2);
  });
  return res;
}
var noop$3 = {
  value: () => {
  }
};
function dispatch$1() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch$1(_);
}
function Dispatch$1(_) {
  this._ = _;
}
function parseTypenames$1(typenames, types2) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types2.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {
      type: t,
      name
    };
  });
}
Dispatch$1.prototype = dispatch$1.prototype = {
  constructor: Dispatch$1,
  on: function(typename, callback) {
    var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get$6(_[t], typename.name))) return t;
      return;
    }
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set$4(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set$4(_[t], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _ = this._;
    for (var t in _) copy2[t] = _[t].slice();
    return new Dispatch$1(copy2);
  },
  call: function(type2, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type2)) throw new Error("unknown type: " + type2);
    for (t = this._[type2], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type2, that, args) {
    if (!this._.hasOwnProperty(type2)) throw new Error("unknown type: " + type2);
    for (var t = this._[type2], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};
function get$6(type2, name) {
  for (var i = 0, n = type2.length, c; i < n; ++i) {
    if ((c = type2[i]).name === name) {
      return c.value;
    }
  }
}
function set$4(type2, name, callback) {
  for (var i = 0, n = type2.length; i < n; ++i) {
    if (type2[i].name === name) {
      type2[i] = noop$3, type2 = type2.slice(0, i).concat(type2.slice(i + 1));
      break;
    }
  }
  if (callback != null) type2.push({
    name,
    value: callback
  });
  return type2;
}
function nopropagation$2(event) {
  event.stopImmediatePropagation();
}
function noevent$2(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
function dragDisable(view) {
  var root2 = view.document.documentElement, selection2 = select(view).on("dragstart.drag", noevent$2, true);
  if ("onselectstart" in root2) {
    selection2.on("selectstart.drag", noevent$2, true);
  } else {
    root2.__noselect = root2.style.MozUserSelect;
    root2.style.MozUserSelect = "none";
  }
}
function yesdrag(view, noclick) {
  var root2 = view.document.documentElement, selection2 = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection2.on("click.drag", noevent$2, true);
    setTimeout(function() {
      selection2.on("click.drag", null);
    }, 0);
  }
  if ("onselectstart" in root2) {
    selection2.on("selectstart.drag", null);
  } else {
    root2.style.MozUserSelect = root2.__noselect;
    delete root2.__noselect;
  }
}
const constant$4 = (x) => () => x;
function DragEvent(type2, {
  sourceEvent: sourceEvent2,
  subject,
  target: target2,
  identifier,
  active: active2,
  x,
  y,
  dx,
  dy,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: {
      value: type2,
      enumerable: true,
      configurable: true
    },
    sourceEvent: {
      value: sourceEvent2,
      enumerable: true,
      configurable: true
    },
    subject: {
      value: subject,
      enumerable: true,
      configurable: true
    },
    target: {
      value: target2,
      enumerable: true,
      configurable: true
    },
    identifier: {
      value: identifier,
      enumerable: true,
      configurable: true
    },
    active: {
      value: active2,
      enumerable: true,
      configurable: true
    },
    x: {
      value: x,
      enumerable: true,
      configurable: true
    },
    y: {
      value: y,
      enumerable: true,
      configurable: true
    },
    dx: {
      value: dx,
      enumerable: true,
      configurable: true
    },
    dy: {
      value: dy,
      enumerable: true,
      configurable: true
    },
    _: {
      value: dispatch2
    }
  });
}
DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};
function defaultFilter$2(event) {
  return !event.ctrlKey && !event.button;
}
function defaultContainer() {
  return this.parentNode;
}
function defaultSubject(event, d) {
  return d == null ? {
    x: event.x,
    y: event.y
  } : d;
}
function defaultTouchable$2() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function drag() {
  var filter2 = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch$1("start", "drag", "end"), active2 = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
  function drag2(selection2) {
    selection2.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function mousedowned(event, d) {
    if (touchending || !filter2.call(this, event, d)) return;
    var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
    if (!gesture) return;
    select(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(event.view);
    nopropagation$2(event);
    mousemoving = false;
    mousedownx = event.clientX;
    mousedowny = event.clientY;
    gesture("start", event);
  }
  function mousemoved(event) {
    noevent$2(event);
    if (!mousemoving) {
      var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag", event);
  }
  function mouseupped(event) {
    select(event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(event.view, mousemoving);
    noevent$2(event);
    gestures.mouse("end", event);
  }
  function touchstarted(event, d) {
    if (!filter2.call(this, event, d)) return;
    var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
        nopropagation$2(event);
        gesture("start", event, touches[i]);
      }
    }
  }
  function touchmoved(event) {
    var touches = event.changedTouches, n = touches.length, i, gesture;
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        noevent$2(event);
        gesture("drag", event, touches[i]);
      }
    }
  }
  function touchended(event) {
    var touches = event.changedTouches, n = touches.length, i, gesture;
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, 500);
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        nopropagation$2(event);
        gesture("end", event, touches[i]);
      }
    }
  }
  function beforestart(that, container2, event, d, identifier, touch) {
    var dispatch2 = listeners.copy(), p = pointer(touch || event, container2), dx, dy, s;
    if ((s = subject.call(that, new DragEvent("beforestart", {
      sourceEvent: event,
      target: drag2,
      identifier,
      active: active2,
      x: p[0],
      y: p[1],
      dx: 0,
      dy: 0,
      dispatch: dispatch2
    }), d)) == null) return;
    dx = s.x - p[0] || 0;
    dy = s.y - p[1] || 0;
    return function gesture(type2, event2, touch2) {
      var p02 = p, n;
      switch (type2) {
        case "start":
          gestures[identifier] = gesture, n = active2++;
          break;
        case "end":
          delete gestures[identifier], --active2;
        // nobreak
        case "drag":
          p = pointer(touch2 || event2, container2), n = active2;
          break;
      }
      dispatch2.call(type2, that, new DragEvent(type2, {
        sourceEvent: event2,
        subject: s,
        target: drag2,
        identifier,
        active: n,
        x: p[0] + dx,
        y: p[1] + dy,
        dx: p[0] - p02[0],
        dy: p[1] - p02[1],
        dispatch: dispatch2
      }), d);
    };
  }
  drag2.filter = function(_) {
    return arguments.length ? (filter2 = typeof _ === "function" ? _ : constant$4(!!_), drag2) : filter2;
  };
  drag2.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$4(_), drag2) : container;
  };
  drag2.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$4(_), drag2) : subject;
  };
  drag2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$4(!!_), drag2) : touchable;
  };
  drag2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag2 : value;
  };
  drag2.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag2) : Math.sqrt(clickDistance2);
  };
  return drag2;
}
const d3Drag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  drag,
  dragDisable,
  dragEnable: yesdrag
}, Symbol.toStringTag, { value: "Module" }));
var frame$1 = 0, timeout$3 = 0, interval$1 = 0, pokeDelay$1 = 1e3, taskHead$1, taskTail$1, clockLast$1 = 0, clockNow$1 = 0, clockSkew$1 = 0, clock$1 = typeof performance === "object" && performance.now ? performance : Date, setFrame$1 = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
  setTimeout(f2, 17);
};
function now$2() {
  return clockNow$1 || (setFrame$1(clearNow$1), clockNow$1 = clock$1.now() + clockSkew$1);
}
function clearNow$1() {
  clockNow$1 = 0;
}
function Timer$1() {
  this._call = this._time = this._next = null;
}
Timer$1.prototype = timer$1.prototype = {
  constructor: Timer$1,
  restart: function(callback, delay, time2) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time2 = (time2 == null ? now$2() : +time2) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail$1 !== this) {
      if (taskTail$1) taskTail$1._next = this;
      else taskHead$1 = this;
      taskTail$1 = this;
    }
    this._call = callback;
    this._time = time2;
    sleep$1();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep$1();
    }
  }
};
function timer$1(callback, delay, time2) {
  var t = new Timer$1();
  t.restart(callback, delay, time2);
  return t;
}
function timerFlush$1() {
  now$2();
  ++frame$1;
  var t = taskHead$1, e;
  while (t) {
    if ((e = clockNow$1 - t._time) >= 0) t._call.call(void 0, e);
    t = t._next;
  }
  --frame$1;
}
function wake$1() {
  clockNow$1 = (clockLast$1 = clock$1.now()) + clockSkew$1;
  frame$1 = timeout$3 = 0;
  try {
    timerFlush$1();
  } finally {
    frame$1 = 0;
    nap$1();
    clockNow$1 = 0;
  }
}
function poke$2() {
  var now2 = clock$1.now(), delay = now2 - clockLast$1;
  if (delay > pokeDelay$1) clockSkew$1 -= delay, clockLast$1 = now2;
}
function nap$1() {
  var t02, t12 = taskHead$1, t22, time2 = Infinity;
  while (t12) {
    if (t12._call) {
      if (time2 > t12._time) time2 = t12._time;
      t02 = t12, t12 = t12._next;
    } else {
      t22 = t12._next, t12._next = null;
      t12 = t02 ? t02._next = t22 : taskHead$1 = t22;
    }
  }
  taskTail$1 = t02;
  sleep$1(time2);
}
function sleep$1(time2) {
  if (frame$1) return;
  if (timeout$3) timeout$3 = clearTimeout(timeout$3);
  var delay = time2 - clockNow$1;
  if (delay > 24) {
    if (time2 < Infinity) timeout$3 = setTimeout(wake$1, time2 - clock$1.now() - clockSkew$1);
    if (interval$1) interval$1 = clearInterval(interval$1);
  } else {
    if (!interval$1) clockLast$1 = clock$1.now(), interval$1 = setInterval(poke$2, pokeDelay$1);
    frame$1 = 1, setFrame$1(wake$1);
  }
}
function timeout$2(callback, delay, time2) {
  var t = new Timer$1();
  delay = delay == null ? 0 : +delay;
  t.restart((elapsed) => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time2);
  return t;
}
var emptyOn$1 = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween$1 = [];
var CREATED$1 = 0;
var SCHEDULED$1 = 1;
var STARTING$1 = 2;
var STARTED$1 = 3;
var RUNNING$1 = 4;
var ENDING$1 = 5;
var ENDED$1 = 6;
function schedule$1(node2, name, id2, index2, group2, timing) {
  var schedules = node2.__transition;
  if (!schedules) node2.__transition = {};
  else if (id2 in schedules) return;
  create$1(node2, id2, {
    name,
    index: index2,
    // For context during callback.
    group: group2,
    // For context during callback.
    on: emptyOn$1,
    tween: emptyTween$1,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED$1
  });
}
function init$1(node2, id2) {
  var schedule2 = get$5(node2, id2);
  if (schedule2.state > CREATED$1) throw new Error("too late; already scheduled");
  return schedule2;
}
function set$3(node2, id2) {
  var schedule2 = get$5(node2, id2);
  if (schedule2.state > STARTED$1) throw new Error("too late; already running");
  return schedule2;
}
function get$5(node2, id2) {
  var schedule2 = node2.__transition;
  if (!schedule2 || !(schedule2 = schedule2[id2])) throw new Error("transition not found");
  return schedule2;
}
function create$1(node2, id2, self2) {
  var schedules = node2.__transition, tween;
  schedules[id2] = self2;
  self2.timer = timer$1(schedule2, 0, self2.time);
  function schedule2(elapsed) {
    self2.state = SCHEDULED$1;
    self2.timer.restart(start2, self2.delay, self2.time);
    if (self2.delay <= elapsed) start2(elapsed - self2.delay);
  }
  function start2(elapsed) {
    var i, j, n, o;
    if (self2.state !== SCHEDULED$1) return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self2.name) continue;
      if (o.state === STARTED$1) return timeout$2(start2);
      if (o.state === RUNNING$1) {
        o.state = ENDED$1;
        o.timer.stop();
        o.on.call("interrupt", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED$1;
        o.timer.stop();
        o.on.call("cancel", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout$2(function() {
      if (self2.state === STARTED$1) {
        self2.state = RUNNING$1;
        self2.timer.restart(tick, self2.delay, self2.time);
        tick(elapsed);
      }
    });
    self2.state = STARTING$1;
    self2.on.call("start", node2, node2.__data__, self2.index, self2.group);
    if (self2.state !== STARTING$1) return;
    self2.state = STARTED$1;
    tween = new Array(n = self2.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self2.tween[i].value.call(node2, node2.__data__, self2.index, self2.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t = elapsed < self2.duration ? self2.ease.call(null, elapsed / self2.duration) : (self2.timer.restart(stop), self2.state = ENDING$1, 1), i = -1, n = tween.length;
    while (++i < n) {
      tween[i].call(node2, t);
    }
    if (self2.state === ENDING$1) {
      self2.on.call("end", node2, node2.__data__, self2.index, self2.group);
      stop();
    }
  }
  function stop() {
    self2.state = ENDED$1;
    self2.timer.stop();
    delete schedules[id2];
    for (var i in schedules) return;
    delete node2.__transition;
  }
}
function interrupt$1(node2, name) {
  var schedules = node2.__transition, schedule2, active2, empty2 = true, i;
  if (!schedules) return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule2 = schedules[i]).name !== name) {
      empty2 = false;
      continue;
    }
    active2 = schedule2.state > STARTING$1 && schedule2.state < ENDING$1;
    schedule2.state = ENDED$1;
    schedule2.timer.stop();
    schedule2.on.call(active2 ? "interrupt" : "cancel", node2, node2.__data__, schedule2.index, schedule2.group);
    delete schedules[i];
  }
  if (empty2) delete node2.__transition;
}
function selection_interrupt$1(name) {
  return this.each(function() {
    interrupt$1(this, name);
  });
}
function tweenRemove$1(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule2 = set$3(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule2.tween = tween1;
  };
}
function tweenFunction$1(id2, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error();
  return function() {
    var schedule2 = set$3(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {
        name,
        value
      }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }
    schedule2.tween = tween1;
  };
}
function transition_tween$1(name, value) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get$5(this.node(), id2).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }
  return this.each((value == null ? tweenRemove$1 : tweenFunction$1)(id2, name, value));
}
function tweenValue$1(transition2, name, value) {
  var id2 = transition2._id;
  transition2.each(function() {
    var schedule2 = set$3(this, id2);
    (schedule2.value || (schedule2.value = {}))[name] = value.apply(this, arguments);
  });
  return function(node2) {
    return get$5(node2, id2).value[name];
  };
}
function interpolate$2(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
}
function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant$1(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrConstantNS$1(fullname, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrFunction$1(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function attrFunctionNS$1(fullname, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function transition_attr$1(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$2;
  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue$1(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname) : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value));
}
function attrInterpolate$1(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}
function attrInterpolateNS$1(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}
function attrTweenNS$1(fullname, value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t02 = (i0 = i) && attrInterpolateNS$1(fullname, i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function attrTween$1(name, value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t02 = (i0 = i) && attrInterpolate$1(name, i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function transition_attrTween$1(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS$1 : attrTween$1)(fullname, value));
}
function delayFunction$1(id2, value) {
  return function() {
    init$1(this, id2).delay = +value.apply(this, arguments);
  };
}
function delayConstant$1(id2, value) {
  return value = +value, function() {
    init$1(this, id2).delay = value;
  };
}
function transition_delay$1(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? delayFunction$1 : delayConstant$1)(id2, value)) : get$5(this.node(), id2).delay;
}
function durationFunction$1(id2, value) {
  return function() {
    set$3(this, id2).duration = +value.apply(this, arguments);
  };
}
function durationConstant$1(id2, value) {
  return value = +value, function() {
    set$3(this, id2).duration = value;
  };
}
function transition_duration$1(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? durationFunction$1 : durationConstant$1)(id2, value)) : get$5(this.node(), id2).duration;
}
function easeConstant$1(id2, value) {
  if (typeof value !== "function") throw new Error();
  return function() {
    set$3(this, id2).ease = value;
  };
}
function transition_ease$1(value) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant$1(id2, value)) : get$5(this.node(), id2).ease;
}
function easeVarying$1(id2, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error();
    set$3(this, id2).ease = v;
  };
}
function transition_easeVarying$1(value) {
  if (typeof value !== "function") throw new Error();
  return this.each(easeVarying$1(this._id, value));
}
function transition_filter$1(match) {
  if (typeof match !== "function") match = matcher(match);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && match.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Transition$1(subgroups, this._parents, this._name, this._id);
}
function transition_merge$1(transition2) {
  if (transition2._id !== this._id) throw new Error();
  for (var groups0 = this._groups, groups1 = transition2._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition$1(merges, this._parents, this._name, this._id);
}
function start$2(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}
function onFunction$1(id2, name, listener) {
  var on0, on1, sit = start$2(name) ? init$1 : set$3;
  return function() {
    var schedule2 = sit(this, id2), on = schedule2.on;
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
    schedule2.on = on1;
  };
}
function transition_on$1(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get$5(this.node(), id2).on.on(name) : this.each(onFunction$1(id2, name, listener));
}
function removeFunction$1(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id2) return;
    if (parent) parent.removeChild(this);
  };
}
function transition_remove$1() {
  return this.on("end.remove", removeFunction$1(this._id));
}
function transition_select$1(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function") select2 = selector(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node2, subnode, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2) subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
        schedule$1(subgroup[i], name, id2, i, subgroup, get$5(node2, id2));
      }
    }
  }
  return new Transition$1(subgroups, this._parents, name, id2);
}
function transition_selectAll$1(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function") select2 = selectorAll(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        for (var children2 = select2.call(node2, node2.__data__, i, group2), child, inherit2 = get$5(node2, id2), k = 0, l = children2.length; k < l; ++k) {
          if (child = children2[k]) {
            schedule$1(child, name, id2, k, children2, inherit2);
          }
        }
        subgroups.push(children2);
        parents.push(node2);
      }
    }
  }
  return new Transition$1(subgroups, parents, name, id2);
}
var Selection$1 = selection.prototype.constructor;
function transition_selection$1() {
  return new Selection$1(this._groups, this._parents);
}
function styleNull$1(name, interpolate2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, string10 = string1);
  };
}
function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant$1(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function styleFunction$1(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function styleMaybeRemove$1(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove2;
  return function() {
    var schedule2 = set$3(this, id2), on = schedule2.on, listener = schedule2.value[key] == null ? remove2 || (remove2 = styleRemove$1(name)) : void 0;
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule2.on = on1;
  };
}
function transition_style$1(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$2;
  return value == null ? this.styleTween(name, styleNull$1(name, i)).on("end.style." + name, styleRemove$1(name)) : typeof value === "function" ? this.styleTween(name, styleFunction$1(name, i, tweenValue$1(this, "style." + name, value))).each(styleMaybeRemove$1(this._id, name)) : this.styleTween(name, styleConstant$1(name, i, value), priority).on("end.style." + name, null);
}
function styleInterpolate$1(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}
function styleTween$1(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate$1(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}
function transition_styleTween$1(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, styleTween$1(name, value, priority == null ? "" : priority));
}
function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction$1(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function transition_text$1(value) {
  return this.tween("text", typeof value === "function" ? textFunction$1(tweenValue$1(this, "text", value)) : textConstant$1(value == null ? "" : value + ""));
}
function textInterpolate$1(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}
function textTween$1(value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t02 = (i0 = i) && textInterpolate$1(i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function transition_textTween$1(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, textTween$1(value));
}
function transition_transition$1() {
  var name = this._name, id0 = this._id, id1 = newId$1();
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        var inherit2 = get$5(node2, id0);
        schedule$1(node2, name, id1, i, group2, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition$1(groups2, this._parents, name, id1);
}
function transition_end$1() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {
      value: reject
    }, end2 = {
      value: function() {
        if (--size === 0) resolve();
      }
    };
    that.each(function() {
      var schedule2 = set$3(this, id2), on = schedule2.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end2);
      }
      schedule2.on = on1;
    });
    if (size === 0) resolve();
  });
}
var id$1 = 0;
function Transition$1(groups2, parents, name, id2) {
  this._groups = groups2;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function transition(name) {
  return selection().transition(name);
}
function newId$1() {
  return ++id$1;
}
var selection_prototype$1 = selection.prototype;
Transition$1.prototype = transition.prototype = {
  constructor: Transition$1,
  select: transition_select$1,
  selectAll: transition_selectAll$1,
  selectChild: selection_prototype$1.selectChild,
  selectChildren: selection_prototype$1.selectChildren,
  filter: transition_filter$1,
  merge: transition_merge$1,
  selection: transition_selection$1,
  transition: transition_transition$1,
  call: selection_prototype$1.call,
  nodes: selection_prototype$1.nodes,
  node: selection_prototype$1.node,
  size: selection_prototype$1.size,
  empty: selection_prototype$1.empty,
  each: selection_prototype$1.each,
  on: transition_on$1,
  attr: transition_attr$1,
  attrTween: transition_attrTween$1,
  style: transition_style$1,
  styleTween: transition_styleTween$1,
  text: transition_text$1,
  textTween: transition_textTween$1,
  remove: transition_remove$1,
  tween: transition_tween$1,
  delay: transition_delay$1,
  duration: transition_duration$1,
  ease: transition_ease$1,
  easeVarying: transition_easeVarying$1,
  end: transition_end$1,
  [Symbol.iterator]: selection_prototype$1[Symbol.iterator]
};
function cubicInOut$1(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var defaultTiming$1 = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut$1
};
function inherit$1(node2, id2) {
  var timing;
  while (!(timing = node2.__transition) || !(timing = timing[id2])) {
    if (!(node2 = node2.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function selection_transition$1(name) {
  var id2, timing;
  if (name instanceof Transition$1) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId$1(), (timing = defaultTiming$1).time = now$2(), name = name == null ? null : name + "";
  }
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        schedule$1(node2, name, id2, i, group2, timing || inherit$1(node2, id2));
      }
    }
  }
  return new Transition$1(groups2, this._parents, name, id2);
}
selection.prototype.interrupt = selection_interrupt$1;
selection.prototype.transition = selection_transition$1;
var root$1 = [null];
function active$1(node2, name) {
  var schedules = node2.__transition, schedule2, i;
  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule2 = schedules[i]).state > SCHEDULED$1 && schedule2.name === name) {
        return new Transition$1([[node2]], root$1, name, +i);
      }
    }
  }
  return null;
}
const d3Transition = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  active: active$1,
  interrupt: interrupt$1,
  transition
}, Symbol.toStringTag, { value: "Module" }));
const constant$3 = (x) => () => x;
function ZoomEvent(type2, {
  sourceEvent: sourceEvent2,
  target: target2,
  transform: transform2,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: {
      value: type2,
      enumerable: true,
      configurable: true
    },
    sourceEvent: {
      value: sourceEvent2,
      enumerable: true,
      configurable: true
    },
    target: {
      value: target2,
      enumerable: true,
      configurable: true
    },
    transform: {
      value: transform2,
      enumerable: true,
      configurable: true
    },
    _: {
      value: dispatch2
    }
  });
}
function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}
Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point2) {
    return [point2[0] * this.k + this.x, point2[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var identity$4 = new Transform(1, 0, 0);
transform$1.prototype = Transform.prototype;
function transform$1(node2) {
  while (!node2.__zoom) if (!(node2 = node2.parentNode)) return identity$4;
  return node2.__zoom;
}
function nopropagation$1(event) {
  event.stopImmediatePropagation();
}
function noevent$1(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
function defaultFilter$1(event) {
  return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function defaultExtent$1() {
  var e = this;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    if (e.hasAttribute("viewBox")) {
      e = e.viewBox.baseVal;
      return [[e.x, e.y], [e.x + e.width, e.y + e.height]];
    }
    return [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]];
  }
  return [[0, 0], [e.clientWidth, e.clientHeight]];
}
function defaultTransform() {
  return this.__zoom || identity$4;
}
function defaultWheelDelta(event) {
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 2e-3) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable$1() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform2, extent2, translateExtent) {
  var dx0 = transform2.invertX(extent2[0][0]) - translateExtent[0][0], dx1 = transform2.invertX(extent2[1][0]) - translateExtent[1][0], dy0 = transform2.invertY(extent2[0][1]) - translateExtent[0][1], dy1 = transform2.invertY(extent2[1][1]) - translateExtent[1][1];
  return transform2.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function zoom() {
  var filter2 = defaultFilter$1, extent2 = defaultExtent$1, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable$1, scaleExtent = [0, Infinity], translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]], duration = 250, interpolate2 = interpolateZoom, listeners = dispatch$1("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
  function zoom2(selection2) {
    selection2.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
      passive: false
    }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  zoom2.transform = function(collection, transform2, point2, event) {
    var selection2 = collection.selection ? collection.selection() : collection;
    selection2.property("__zoom", defaultTransform);
    if (collection !== selection2) {
      schedule2(collection, transform2, point2, event);
    } else {
      selection2.interrupt().each(function() {
        gesture(this, arguments).event(event).start().zoom(null, typeof transform2 === "function" ? transform2.apply(this, arguments) : transform2).end();
      });
    }
  };
  zoom2.scaleBy = function(selection2, k, p, event) {
    zoom2.scaleTo(selection2, function() {
      var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    }, p, event);
  };
  zoom2.scaleTo = function(selection2, k, p, event) {
    zoom2.transform(selection2, function() {
      var e = extent2.apply(this, arguments), t02 = this.__zoom, p02 = p == null ? centroid2(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t02.invert(p02), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t02, k1), p02, p1), e, translateExtent);
    }, p, event);
  };
  zoom2.translateBy = function(selection2, x, y, event) {
    zoom2.transform(selection2, function() {
      return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent2.apply(this, arguments), translateExtent);
    }, null, event);
  };
  zoom2.translateTo = function(selection2, x, y, p, event) {
    zoom2.transform(selection2, function() {
      var e = extent2.apply(this, arguments), t = this.__zoom, p02 = p == null ? centroid2(e) : typeof p === "function" ? p.apply(this, arguments) : p;
      return constrain(identity$4.translate(p02[0], p02[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
    }, p, event);
  };
  function scale(transform2, k) {
    k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
    return k === transform2.k ? transform2 : new Transform(k, transform2.x, transform2.y);
  }
  function translate(transform2, p02, p1) {
    var x = p02[0] - p1[0] * transform2.k, y = p02[1] - p1[1] * transform2.k;
    return x === transform2.x && y === transform2.y ? transform2 : new Transform(transform2.k, x, y);
  }
  function centroid2(extent3) {
    return [(+extent3[0][0] + +extent3[1][0]) / 2, (+extent3[0][1] + +extent3[1][1]) / 2];
  }
  function schedule2(transition2, transform2, point2, event) {
    transition2.on("start.zoom", function() {
      gesture(this, arguments).event(event).start();
    }).on("interrupt.zoom end.zoom", function() {
      gesture(this, arguments).event(event).end();
    }).tween("zoom", function() {
      var that = this, args = arguments, g = gesture(that, args).event(event), e = extent2.apply(that, args), p = point2 == null ? centroid2(e) : typeof point2 === "function" ? point2.apply(that, args) : point2, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform2 === "function" ? transform2.apply(that, args) : transform2, i = interpolate2(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
      return function(t) {
        if (t === 1) t = b;
        else {
          var l = i(t), k = w / l[2];
          t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
        }
        g.zoom(null, t);
      };
    });
  }
  function gesture(that, args, clean) {
    return !clean && that.__zooming || new Gesture(that, args);
  }
  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.sourceEvent = null;
    this.extent = extent2.apply(that, args);
    this.taps = 0;
  }
  Gesture.prototype = {
    event: function(event) {
      if (event) this.sourceEvent = event;
      return this;
    },
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform2) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform2.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform2.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform2.invert(this.touch1[0]);
      this.that.__zoom = transform2;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type2) {
      var d = select(this.that).datum();
      listeners.call(type2, this.that, new ZoomEvent(type2, {
        sourceEvent: this.sourceEvent,
        target: zoom2,
        transform: this.that.__zoom,
        dispatch: listeners
      }), d);
    }
  };
  function wheeled(event, ...args) {
    if (!filter2.apply(this, arguments)) return;
    var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer(event);
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    } else if (t.k === k) return;
    else {
      g.mouse = [p, t.invert(p)];
      interrupt$1(this);
      g.start();
    }
    noevent$1(event);
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }
  function mousedowned(event, ...args) {
    if (touchending || !filter2.apply(this, arguments)) return;
    var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer(event, currentTarget), x02 = event.clientX, y02 = event.clientY;
    dragDisable(event.view);
    nopropagation$1(event);
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt$1(this);
    g.start();
    function mousemoved(event2) {
      noevent$1(event2);
      if (!g.moved) {
        var dx = event2.clientX - x02, dy = event2.clientY - y02;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.event(event2).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event2, currentTarget), g.mouse[1]), g.extent, translateExtent));
    }
    function mouseupped(event2) {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(event2.view, g.moved);
      noevent$1(event2);
      g.event(event2).end();
    }
  }
  function dblclicked(event, ...args) {
    if (!filter2.apply(this, arguments)) return;
    var t02 = this.__zoom, p02 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t02.invert(p02), k1 = t02.k * (event.shiftKey ? 0.5 : 2), t12 = constrain(translate(scale(t02, k1), p02, p1), extent2.apply(this, args), translateExtent);
    noevent$1(event);
    if (duration > 0) select(this).transition().duration(duration).call(schedule2, t12, p02, event);
    else select(this).call(zoom2.transform, t12, p02, event);
  }
  function touchstarted(event, ...args) {
    if (!filter2.apply(this, arguments)) return;
    var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
    nopropagation$1(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer(t, this);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
      else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
    }
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    if (started) {
      if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
        touchstarting = null;
      }, touchDelay);
      interrupt$1(this);
      g.start();
    }
  }
  function touchmoved(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
    noevent$1(event);
    for (i = 0; i < n; ++i) {
      t = touches[i], p = pointer(t, this);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p02 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p02[0]) * dp + (dp = p1[1] - p02[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p02[0] + p1[0]) / 2, (p02[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
  }
  function touchended(event, ...args) {
    if (!this.__zooming) return;
    var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
    nopropagation$1(event);
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else {
      g.end();
      if (g.taps === 2) {
        t = pointer(t, this);
        if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
          var p = select(this).on("dblclick.zoom");
          if (p) p.apply(this, arguments);
        }
      }
    }
  }
  zoom2.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant$3(+_), zoom2) : wheelDelta;
  };
  zoom2.filter = function(_) {
    return arguments.length ? (filter2 = typeof _ === "function" ? _ : constant$3(!!_), zoom2) : filter2;
  };
  zoom2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$3(!!_), zoom2) : touchable;
  };
  zoom2.extent = function(_) {
    return arguments.length ? (extent2 = typeof _ === "function" ? _ : constant$3([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom2) : extent2;
  };
  zoom2.scaleExtent = function(_) {
    return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom2) : [scaleExtent[0], scaleExtent[1]];
  };
  zoom2.translateExtent = function(_) {
    return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom2) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };
  zoom2.constrain = function(_) {
    return arguments.length ? (constrain = _, zoom2) : constrain;
  };
  zoom2.duration = function(_) {
    return arguments.length ? (duration = +_, zoom2) : duration;
  };
  zoom2.interpolate = function(_) {
    return arguments.length ? (interpolate2 = _, zoom2) : interpolate2;
  };
  zoom2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom2 : value;
  };
  zoom2.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom2) : Math.sqrt(clickDistance2);
  };
  zoom2.tapDistance = function(_) {
    return arguments.length ? (tapDistance = +_, zoom2) : tapDistance;
  };
  return zoom2;
}
const d3Zoom = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ZoomTransform: Transform,
  zoom,
  zoomIdentity: identity$4,
  zoomTransform: transform$1
}, Symbol.toStringTag, { value: "Module" }));
function _classCallCheck$1x(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1p(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1p(o.key), o);
  }
}
function _createClass$1x(e, r2, t) {
  return r2 && _defineProperties$1p(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1p(t) {
  var i = _toPrimitive$1p(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1p(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
const TICK_HEIGHT$1 = 40;
const TICK_MARGIN = 0;
const TICK_LENGTH = 5;
const TICK_LABEL_MARGIN = 4;
let AxisPixi = /* @__PURE__ */ (function() {
  function AxisPixi2(track) {
    _classCallCheck$1x(this, AxisPixi2);
    this.pAxis = new GLOBALS.PIXI.Graphics();
    this.track = track;
    this.axisTexts = [];
    this.axisTextFontFamily = "Arial";
    this.axisTextFontSize = 10;
  }
  return _createClass$1x(AxisPixi2, [{
    key: "startAxis",
    value: function startAxis(axisHeight) {
      const graphics = this.pAxis;
      graphics.clear();
      graphics.lineStyle(1, this.track.getTheme() === THEME_DARK ? colorToHex("#ffffff") : 0, 1);
      graphics.moveTo(0, 0);
      graphics.lineTo(0, axisHeight);
    }
  }, {
    key: "createAxisTexts",
    value: function createAxisTexts(valueScale, axisHeight) {
      this.tickValues = this.calculateAxisTickValues(valueScale, axisHeight);
      let i = 0;
      const color2 = this.track.getTheme() === THEME_DARK ? "white" : "black";
      if (!this.track.options || !this.track.options.axisLabelFormatting || this.track.options.axisLabelFormatting === "scientific") {
        this.tickFormat = format$1(".2");
      } else {
        this.tickFormat = (x) => x;
      }
      while (i < this.tickValues.length) {
        const tick = this.tickValues[i];
        while (this.axisTexts.length <= i) {
          const newText = new GLOBALS.PIXI.Text(tick, {
            fontSize: `${this.axisTextFontSize}px`,
            fontFamily: this.axisTextFontFamily,
            fill: color2
          });
          this.axisTexts.push(newText);
          this.pAxis.addChild(newText);
        }
        this.axisTexts[i].text = this.tickFormat(tick);
        this.axisTexts[i].anchor.y = 0.5;
        this.axisTexts[i].anchor.x = 0.5;
        i++;
      }
      while (this.axisTexts.length > this.tickValues.length) {
        const lastText = this.axisTexts.pop();
        this.pAxis.removeChild(lastText);
        lastText.destroy(true);
      }
    }
  }, {
    key: "calculateAxisTickValues",
    value: function calculateAxisTickValues(valueScale, axisHeight) {
      const tickCount = Math.max(Math.ceil(axisHeight / TICK_HEIGHT$1), 1);
      let tickValues = valueScale.ticks(tickCount);
      if (tickValues.length < 1) {
        tickValues = valueScale.ticks(tickCount + 1);
        if (tickValues.length > 1) {
          tickValues = [tickValues[0]];
        }
      }
      return tickValues;
    }
  }, {
    key: "drawAxisLeft",
    value: function drawAxisLeft(valueScale, axisHeight) {
      this.startAxis(axisHeight);
      this.createAxisTexts(valueScale, axisHeight);
      const graphics = this.pAxis;
      if (this.track.getTheme() === THEME_DARK) {
        graphics.lineStyle(graphics.lineWidth || graphics._lineStyle.width, colorToHex("#ffffff"));
      }
      graphics.moveTo(0, 0);
      graphics.lineTo(-5, 0);
      graphics.moveTo(0, axisHeight);
      graphics.lineTo(-5, axisHeight);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        this.axisTexts[i].x = -(TICK_MARGIN + TICK_LENGTH + TICK_LABEL_MARGIN + this.axisTexts[i].width / 2);
        this.axisTexts[i].y = valueScale(tick);
        graphics.moveTo(-TICK_MARGIN, valueScale(tick));
        graphics.lineTo(-5, valueScale(tick));
        if (this.track?.flipText) {
          this.axisTexts[i].scale.x = -1;
        }
      }
      this.hideOverlappingAxisLabels();
    }
  }, {
    key: "drawAxisRight",
    value: function drawAxisRight(valueScale, axisHeight) {
      this.startAxis(axisHeight);
      this.createAxisTexts(valueScale, axisHeight);
      const graphics = this.pAxis;
      if (this.track.getTheme() === THEME_DARK) {
        graphics.lineStyle(graphics.lineWidth || graphics._lineStyle.width, colorToHex("#ffffff"));
      }
      graphics.moveTo(0, 0);
      graphics.lineTo(TICK_MARGIN + TICK_LENGTH, 0);
      graphics.moveTo(0, axisHeight);
      graphics.lineTo(TICK_MARGIN + TICK_LENGTH, axisHeight);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        this.axisTexts[i].x = TICK_MARGIN + TICK_LENGTH + TICK_LABEL_MARGIN + this.axisTexts[i].width / 2;
        this.axisTexts[i].y = valueScale(tick);
        graphics.moveTo(TICK_MARGIN, valueScale(tick));
        graphics.lineTo(TICK_MARGIN + TICK_LENGTH, valueScale(tick));
        if (this.track?.flipText) {
          this.axisTexts[i].scale.x = -1;
        }
      }
      this.hideOverlappingAxisLabels();
    }
  }, {
    key: "hideOverlappingAxisLabels",
    value: function hideOverlappingAxisLabels() {
      for (let i = this.axisTexts.length - 1; i >= 0; i--) {
        this.axisTexts[i].visible = true;
      }
      for (let i = this.axisTexts.length - 1; i >= 0; i--) {
        if (!this.axisTexts[i].visible) {
          continue;
        }
        let j = i - 1;
        while (j >= 0) {
          if (this.axisTexts[i].y + this.axisTexts[i].height / 2 > this.axisTexts[j].y - this.axisTexts[j].height / 2) {
            this.axisTexts[j].visible = false;
          } else {
            break;
          }
          j -= 1;
        }
      }
    }
  }, {
    key: "exportVerticalAxis",
    value: function exportVerticalAxis(axisHeight) {
      const gAxis = document.createElement("g");
      gAxis.setAttribute("class", "axis-vertical");
      let stroke = "black";
      if (this.track?.options.lineStrokeColor) {
        stroke = this.track.options.lineStrokeColor;
      }
      if (this.track.getTheme() === THEME_DARK) stroke = "#cccccc";
      const line = document.createElement("path");
      line.setAttribute("fill", "transparent");
      line.setAttribute("stroke", stroke);
      line.setAttribute("id", "axis-line");
      line.setAttribute("d", `M0,0 L0,${axisHeight}`);
      gAxis.appendChild(line);
      return gAxis;
    }
  }, {
    key: "createAxisSVGLine",
    value: function createAxisSVGLine() {
      let stroke = "black";
      if (this.track?.options.lineStrokeColor) {
        stroke = this.track.options.lineStrokeColor;
      }
      if (this.track.getTheme() === THEME_DARK) stroke = "#cccccc";
      const line = document.createElement("path");
      line.setAttribute("id", "tick-mark");
      line.setAttribute("fill", "transparent");
      line.setAttribute("stroke", stroke);
      return line;
    }
  }, {
    key: "createAxisSVGText",
    value: function createAxisSVGText(text2) {
      const t = document.createElement("text");
      t.innerHTML = text2;
      t.setAttribute("id", "axis-text");
      t.setAttribute("text-anchor", "middle");
      t.setAttribute("font-family", this.axisTextFontFamily);
      t.setAttribute("font-size", this.axisTextFontSize);
      t.setAttribute("dy", this.axisTextFontSize / 2 - 2);
      return t;
    }
  }, {
    key: "exportAxisLeftSVG",
    value: function exportAxisLeftSVG(valueScale, axisHeight) {
      const gAxis = this.exportVerticalAxis(axisHeight);
      const topTickLine = this.createAxisSVGLine();
      gAxis.appendChild(topTickLine);
      topTickLine.setAttribute("d", `M0,0 L${5},0`);
      const bottomTickLine = this.createAxisSVGLine();
      gAxis.appendChild(bottomTickLine);
      bottomTickLine.setAttribute("d", `M0,${axisHeight} L${5},${axisHeight}`);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        const text2 = this.axisTexts[i];
        const tickLine = this.createAxisSVGLine();
        gAxis.appendChild(tickLine);
        tickLine.setAttribute("d", `M${+TICK_MARGIN},${valueScale(tick)} L${5},${valueScale(tick)}`);
        const g = document.createElement("g");
        gAxis.appendChild(g);
        if (text2.visible) {
          const t = this.createAxisSVGText(text2.text);
          g.appendChild(t);
        }
        g.setAttribute("transform", `translate(${text2.position.x},${text2.position.y})
             scale(${text2.scale.x},${text2.scale.y})`);
      }
      return gAxis;
    }
  }, {
    key: "exportAxisRightSVG",
    value: function exportAxisRightSVG(valueScale, axisHeight) {
      const gAxis = this.exportVerticalAxis(axisHeight);
      const topTickLine = this.createAxisSVGLine();
      gAxis.appendChild(topTickLine);
      topTickLine.setAttribute("d", `M0,0 L${-5},0`);
      const bottomTickLine = this.createAxisSVGLine();
      gAxis.appendChild(bottomTickLine);
      bottomTickLine.setAttribute("d", `M0,${axisHeight} L${-5},${axisHeight}`);
      for (let i = 0; i < this.axisTexts.length; i++) {
        const tick = this.tickValues[i];
        const text2 = this.axisTexts[i];
        const tickLine = this.createAxisSVGLine();
        gAxis.appendChild(tickLine);
        tickLine.setAttribute("d", `M${-TICK_MARGIN},${valueScale(tick)} L${-5},${valueScale(tick)}`);
        const g = document.createElement("g");
        gAxis.appendChild(g);
        if (text2.visible) {
          const t = this.createAxisSVGText(text2.text);
          g.appendChild(t);
        }
        g.setAttribute("transform", `translate(${text2.position.x},${text2.position.y})
             scale(${text2.scale.x},${text2.scale.y})`);
      }
      return gAxis;
    }
  }, {
    key: "clearAxis",
    value: function clearAxis() {
      const graphics = this.pAxis;
      while (this.axisTexts.length) {
        const axisText = this.axisTexts.pop();
        graphics.removeChild(axisText);
      }
      graphics.clear();
    }
  }]);
})();
const range$1 = (start2, end2) => {
  const values = [];
  for (let i = start2; i < end2; i++) {
    values.push(i);
  }
  return values;
};
const calculateZoomLevelFromResolutions$1 = (resolutions, scale) => {
  const sortedResolutions = resolutions.map((x) => +x).sort((a, b) => b - a);
  const trackWidth2 = scale.range()[1] - scale.range()[0];
  const binsDisplayed = sortedResolutions.map((r2) => (scale.domain()[1] - scale.domain()[0]) / r2);
  const binsPerPixel = binsDisplayed.map((b) => b / trackWidth2);
  const displayableBinsPerPixel = binsPerPixel.filter((b) => b < 1);
  if (displayableBinsPerPixel.length === 0) return 0;
  return binsPerPixel.indexOf(displayableBinsPerPixel[displayableBinsPerPixel.length - 1]);
};
const calculateZoomLevel$1 = (scale, minX, maxX, binsPerTile) => {
  const rangeWidth = scale.range()[1] - scale.range()[0];
  const zoomScale = Math.max((maxX - minX) / (scale.domain()[1] - scale.domain()[0]), 1);
  const VIEW_RESOLUTION = 384;
  const addedZoom = Math.max(0, Math.ceil(Math.log(rangeWidth / VIEW_RESOLUTION) / Math.LN2));
  let zoomLevel = Math.round(Math.log(zoomScale) / Math.LN2) + addedZoom;
  let binsPerTileCorrection = 0;
  if (binsPerTile) {
    binsPerTileCorrection = Math.floor(Math.log(256) / Math.log(2) - Math.log(binsPerTile) / Math.log(2));
  }
  zoomLevel += binsPerTileCorrection;
  return zoomLevel;
};
const calculate1DZoomLevel = (tilesetInfo, xScale, maxZoom) => {
  if (typeof maxZoom === "undefined") {
    maxZoom = Number.MAX_SAFE_INTEGER;
  }
  if (tilesetInfo.resolutions) {
    const zoomIndexX = calculateZoomLevelFromResolutions$1(tilesetInfo.resolutions, xScale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0] - 2);
    return zoomIndexX;
  }
  const xZoomLevel = calculateZoomLevel$1(xScale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0], tilesetInfo.bins_per_dimension || tilesetInfo.tile_size);
  const zoomLevel = Math.min(xZoomLevel, maxZoom);
  return Math.max(zoomLevel, 0);
};
const calculateTiles$1 = (zoomLevel, scale, minX, maxX, maxZoom, maxDim) => {
  const zoomLevelFinal = Math.min(zoomLevel, maxZoom);
  const tileWidth = maxDim / 2 ** zoomLevelFinal;
  const epsilon3 = 1e-7;
  return range$1(Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth)), Math.min(2 ** zoomLevelFinal, Math.ceil((scale.domain()[1] - minX - epsilon3) / tileWidth)));
};
const calculateTilesFromResolution$1 = (resolution, scale, minX, maxX = Number.MAX_VALUE, pixelsPerTile = 256) => {
  const epsilon3 = 1e-7;
  const tileWidth = resolution * pixelsPerTile;
  const MAX_TILES = 20;
  const lowerBound = Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth));
  const upperBound = Math.ceil(Math.min(maxX, scale.domain()[1] - minX - epsilon3) / tileWidth);
  let tileRange = range$1(lowerBound, upperBound);
  if (tileRange.length > MAX_TILES) {
    console.warn(`Too many visible tiles: ${tileRange.length} truncating to ${MAX_TILES}`);
    tileRange = tileRange.slice(0, MAX_TILES);
  }
  return tileRange;
};
const calculate1DVisibleTiles = (tilesetInfo, scale) => {
  if (!tilesetInfo) {
    return [];
  }
  const zoomLevel = calculate1DZoomLevel(tilesetInfo, scale, tilesetInfo.max_zoom);
  if (tilesetInfo.resolutions) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    const xTiles2 = calculateTilesFromResolution$1(sortedResolutions[zoomLevel], scale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0], tilesetInfo.bins_per_dimension || tilesetInfo.tile_size);
    const tiles2 = xTiles2.map((x) => [zoomLevel, x]);
    return tiles2;
  }
  const xTiles = calculateTiles$1(zoomLevel, scale, tilesetInfo.min_pos[0], tilesetInfo.max_pos[0], tilesetInfo.max_zoom, tilesetInfo.max_width);
  const tiles = xTiles.map((x) => [zoomLevel, x]);
  return tiles;
};
const drawAxis = (track, valueScale) => {
  if (!track.axis) {
    track.axis = new AxisPixi(track);
    track.pBase.addChild(track.axis.pAxis);
  }
  if (!track.options.axisPositionVertical && !track.options.axisPositionHorizontal) {
    track.axis.clearAxis();
    return;
  }
  if (track.options.axisPositionVertical && track.options.axisPositionVertical === "hidden") {
    track.axis.clearAxis();
    return;
  }
  if (track.options.axisPositionHorizontal && track.options.axisPositionHorizontal === "hidden") {
    track.axis.clearAxis();
    return;
  }
  const margin = track.options.axisMargin || 0;
  if (track.options.axisPositionHorizontal === "left" || track.options.axisPositionVertical === "top") {
    track.axis.pAxis.position.x = track.position[0] + margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisRight(valueScale, track.dimensions[1]);
  } else if (track.options.axisPositionHorizontal === "outsideLeft" || track.options.axisPositionVertical === "outsideTop") {
    track.axis.pAxis.position.x = track.position[0] + margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisLeft(valueScale, track.dimensions[1]);
  } else if (track.options.axisPositionHorizontal === "right" || track.options.axisPositionVertical === "bottom") {
    track.axis.pAxis.position.x = track.position[0] + track.dimensions[0] - margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisLeft(valueScale, track.dimensions[1]);
  } else if (track.options.axisPositionHorizontal === "outsideRight" || track.options.axisPositionVertical === "outsideBottom") {
    track.axis.pAxis.position.x = track.position[0] + track.dimensions[0] - margin;
    track.axis.pAxis.position.y = track.position[1];
    track.axis.drawAxisRight(valueScale, track.dimensions[1]);
  }
};
const movedY = (track, dY) => {
  const vst = track.valueScaleTransform;
  const {
    y,
    k
  } = vst;
  const height = track.dimensions[1];
  if (y + dY / k > -(k - 1) * height && y + dY / k < 0) {
    track.valueScaleTransform = vst.translate(0, dY / k);
  }
  Object.values(track.fetchedTiles).forEach((tile) => {
    tile.graphics.position.y = track.valueScaleTransform.y;
  });
  track.animate();
};
const zoomedY = (yPos, kMultiplier, transform2, height) => {
  const k0 = transform2.k;
  const t02 = transform2.y;
  const dp = (yPos - t02) / k0;
  const k1 = Math.max(k0 / kMultiplier, 1);
  let t12 = k0 * dp + t02 - k1 * dp;
  t12 = Math.max(t12, -(k1 - 1) * height);
  t12 = Math.min(t12, 0);
  return identity$4.translate(0, t12).scale(k1);
};
const getTilePosAndDimensions = (tilesetInfo, tileId) => {
  const zoomLevel = +tileId.split(".")[0];
  const xTilePos = +tileId.split(".")[1];
  const totalWidth = tilesetInfo.max_width;
  const minX = tilesetInfo.min_pos[0];
  const tileWidth = totalWidth / 2 ** zoomLevel;
  const tileX = minX + xTilePos * tileWidth;
  return {
    tileX,
    tileWidth
  };
};
function stretchRects(track, graphicsAccessors) {
  Object.values(track.fetchedTiles).forEach((tile) => {
    if (!tile.drawnAtScale) return;
    const dasRange = tile.drawnAtScale.range();
    const tRange = track._xScale.range();
    if (dasRange[0] !== tRange[0] || dasRange[1] !== tRange[1]) {
      track.renderTile(tile);
      return;
    }
    const tileK = (tile.drawnAtScale.domain()[1] - tile.drawnAtScale.domain()[0]) / (track._xScale.domain()[1] - track._xScale.domain()[0]);
    if (tileK > 2 || tileK < 0.5) {
      track.renderTile(tile);
    } else {
      const newRange = track._xScale.domain().map(tile.drawnAtScale);
      const posOffset = newRange[0];
      for (const graphicsAccessor of graphicsAccessors) {
        graphicsAccessor(tile).scale.x = tileK;
        graphicsAccessor(tile).x = -posOffset * tileK;
      }
    }
  });
}
const trackUtils = {
  calculate1DVisibleTiles,
  calculate1DZoomLevel,
  drawAxis,
  movedY,
  getTilePosAndDimensions,
  stretchRects,
  zoomedY
};
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DenseDataExtrema1D,
  DenseDataExtrema2D,
  IS_TRACK_RANGE_SELECTABLE,
  absToChr,
  accessorTransposition,
  addArrays,
  addClass,
  base64ToCanvas,
  changeOptions,
  chrToAbs,
  chromInfoBisector,
  cloneEvent,
  colorDomainToRgbaArray,
  colorToHex,
  colorToRgba,
  dataToGenomicLoci,
  debounce: debounce$1,
  decToHexStr,
  dictFromTuples,
  dictItems,
  dictKeys,
  dictValues,
  download,
  expandCombinedTracks,
  fillInMinWidths,
  flatten,
  forEach: forEach$2,
  forwardEvent,
  genomeLociToPixels,
  genomicRangeToChromosomeChunks,
  getAggregationFunction,
  getDefaultTrackForDatatype,
  getDefaultTracksForDatatype: getDefaultTracksForDatatype$1,
  getElementDim,
  getTiledPlot,
  getTrackByUid,
  getTrackConfFromHGC,
  getTrackObjById,
  getTrackObjectFromHGC,
  getTrackPositionByUid,
  getTrackRenderer,
  getXylofon,
  gradient,
  hasClass,
  hasParent,
  hexStrToInt,
  intoTheVoid,
  isTrackOrChildTrack,
  isWithin,
  latToY,
  lngToX,
  loadChromInfos,
  map: map$4,
  max: max$2,
  maxNonZero,
  min: min$2,
  minNonZero,
  mod,
  mountHGComponent,
  mountHGComponentAsync,
  ndarrayAssign,
  ndarrayFlatten,
  ndarrayToList,
  numericifyVersion,
  objVals,
  or: or$1,
  parseChromsizesRows,
  pixiTextToSvg,
  q,
  rangeQuery2d,
  reduce,
  relToAbsChromPos,
  removeClass,
  removeHGComponent,
  resetD3BrushStyle,
  rgbToHex: rgbToHex$1,
  scalesCenterAndK,
  scalesToGenomeLoci,
  segmentsToRows,
  selectedItemsToSize,
  showMousePosition: setupShowMousePosition,
  some,
  sum: sum$1,
  svgLine,
  throttleAndDebounce,
  tileToCanvas,
  timeout: timeout$4,
  toVoid,
  totalTrackPixelHeight,
  trackHeight,
  trackUtils,
  trackWidth,
  trimTrailingSlash,
  valueToColor,
  visitPositionedTracks,
  visitTracks,
  waitForJsonComplete,
  waitForTilesLoaded,
  waitForTransitionsFinished
}, Symbol.toStringTag, { value: "Module" }));
let isInit = false;
const listen = () => {
  if (isInit) return;
  const [o, x] = getXylofon();
  const a = "102117110099116105111110040041123115101108102046099111110115111108101046108111103040039";
  const b = "072";
  const c = "105";
  const d = "071";
  const e = "108097115115";
  const f2 = "032118";
  const g = "058032104116116112058047047104105103108097115115046105111039041125";
  const h = [String.fromCharCode(...a.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...b.match(/.{1,3}/g).map((y) => +y)), String.fromCharCode(...c.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...d.match(/.{1,3}/g).map((y) => +y)), String.fromCharCode(...e.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...f2.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...x.match(/.{1,3}/g).map((y) => +y)).toLowerCase(), String.fromCharCode(...g.match(/.{1,3}/g).map((y) => +y)).toLowerCase()].join("");
  const i = "085082076";
  const j = "066076079066";
  const k = "087111114107101114";
  const l = "099114101097116101079098106101099116085082076";
  const m = "114101118111107101079098106101099116085082076";
  const ca = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const cb = (s) => s.slice(0, 6) + s.charAt(6).toUpperCase() + s.slice(7, 12) + s.slice(12).toUpperCase();
  const ur = o[String.fromCharCode(...i.match(/.{1,3}/g).map((y) => +y))];
  const bl = o[ca(String.fromCharCode(...j.match(/.{1,3}/g).map((y) => +y)).toLowerCase())];
  const wo = o[ca(String.fromCharCode(...k.match(/.{1,3}/g).map((y) => +y)).toLowerCase())];
  const co = cb(String.fromCharCode(...l.match(/.{1,3}/g).map((y) => +y)).toLowerCase());
  const ro = cb(String.fromCharCode(...m.match(/.{1,3}/g).map((y) => +y)).toLowerCase());
  const bu = ur[co](new bl([`(${h})()`], {
    type: "application/javascript"
  }));
  new wo(bu);
  ur[ro](bu);
  isInit = true;
};
const ElementResizeListener = {
  listen
};
function setPixDataForSelectedRows(data2, shape, setPixData, selectedRows, selectedRowsAggregationMode, selectedRowsAggregationWithRelativeHeight, selectedRowsAggregationMethod) {
  let aggFunc;
  let aggFromDataFunc;
  if (selectedRowsAggregationMode) {
    const agg = getAggregationFunction(selectedRowsAggregationMode);
    aggFunc = agg;
    aggFromDataFunc = (colI2, rowIs) => agg(rowIs.map((rowI) => data2[rowI * shape[1] + colI2])) ?? 0;
  }
  let d;
  let pixRowI;
  let colI;
  let selectedRowI;
  let selectedRowGroupItemI;
  let selectedRow;
  for (colI = 0; colI < shape[1]; colI++) {
    pixRowI = 0;
    for (selectedRowI = 0; selectedRowI < selectedRows.length; selectedRowI++) {
      selectedRow = selectedRows[selectedRowI];
      if (aggFunc && selectedRowsAggregationMethod === "server") {
        d = data2[selectedRowI * shape[1] + colI];
      } else if (Array.isArray(selectedRow)) {
        if (!aggFromDataFunc) {
          throw new Error("row aggregation requires 'aggFromDataFunc'");
        }
        d = aggFromDataFunc(colI, selectedRow);
      } else {
        d = data2[selectedRow * shape[1] + colI];
      }
      if (selectedRowsAggregationWithRelativeHeight && Array.isArray(selectedRow)) {
        for (selectedRowGroupItemI = 0; selectedRowGroupItemI < selectedRow.length; selectedRowGroupItemI++) {
          setPixData(
            pixRowI * shape[1] + colI,
            // pixData index
            d
            // data point
          );
          pixRowI++;
        }
      } else {
        setPixData(
          pixRowI * shape[1] + colI,
          // pixData index
          d
          // data point
        );
        pixRowI++;
      }
    }
  }
}
function workerSetPix(size, data2, valueScaleType, valueScaleDomain, pseudocount, colorScale, ignoreUpperRight = false, ignoreLowerLeft = false, shape = null, zeroValueColor = null, selectedRowsOptions = null) {
  let valueScale;
  if (valueScaleType === "log") {
    valueScale = log$2().range([254, 0]).domain(valueScaleDomain);
  } else {
    if (valueScaleType !== "linear") {
      console.warn("Unknown value scale type:", valueScaleType, " Defaulting to linear");
    }
    valueScale = linear().range([254, 0]).domain(valueScaleDomain);
  }
  const {
    selectedRows,
    selectedRowsAggregationMode = "mean",
    selectedRowsAggregationWithRelativeHeight = false,
    selectedRowsAggregationMethod = "client"
  } = selectedRowsOptions ?? {};
  let filteredSize = size;
  if (shape && selectedRows) {
    filteredSize = selectedItemsToSize(selectedRows, selectedRowsAggregationWithRelativeHeight) * shape[1];
  }
  let rgb2;
  let rgbIdx = 0;
  const tileWidth = shape ? shape[1] : Math.sqrt(size);
  const pixData = new Uint8ClampedArray(filteredSize * 4);
  const dToRgbIdx = (x) => {
    const v = valueScale(x);
    if (Number.isNaN(v)) return 254;
    return Math.max(0, Math.min(254, Math.floor(v)));
  };
  const setPixData = (i, d2) => {
    rgbIdx = 255;
    if (
      // ignore the upper right portion of a tile because it's on the diagonal
      // and its mirror will fill in that space
      !(ignoreUpperRight && Math.floor(i / tileWidth) < i % tileWidth) && !(ignoreLowerLeft && Math.floor(i / tileWidth) > i % tileWidth) && // Ignore color if the value is invalid
      !Number.isNaN(+d2)
    ) {
      rgbIdx = dToRgbIdx(d2 + pseudocount);
    }
    if (rgbIdx < 0 || rgbIdx > 255) {
      console.warn("out of bounds rgbIdx:", rgbIdx, " (should be 0 <= rgbIdx <= 255)");
    }
    if (zeroValueColor && !Number.isNaN(+d2) && +d2 === 0) {
      rgb2 = zeroValueColor;
    } else {
      rgb2 = colorScale[rgbIdx];
    }
    pixData[i * 4] = rgb2[0];
    pixData[i * 4 + 1] = rgb2[1];
    pixData[i * 4 + 2] = rgb2[2];
    pixData[i * 4 + 3] = rgb2[3];
  };
  let d;
  try {
    if (selectedRows && shape) {
      setPixDataForSelectedRows(data2, shape, setPixData, selectedRows, selectedRowsAggregationMode, selectedRowsAggregationWithRelativeHeight, selectedRowsAggregationMethod);
    } else {
      for (let i = 0; i < data2.length; i++) {
        d = data2[i];
        setPixData(i, d);
      }
    }
  } catch (err) {
    console.warn("Odd datapoint");
    console.warn("d:", d);
    d = d ?? 0;
    console.warn("valueScale.domain():", valueScale.domain());
    console.warn("valueScale.range():", valueScale.range());
    console.warn("value:", valueScale(d + pseudocount));
    console.warn("pseudocount:", pseudocount);
    console.warn("rgbIdx:", rgbIdx, "d:", d, "ct:", valueScale(d));
    console.error("ERROR:", err);
    return pixData;
  }
  return pixData;
}
function float32(h) {
  let hExp = h & 31744;
  let hSig;
  let fExp;
  let fSig;
  const fSgn = (h & 32768) << 16;
  switch (hExp) {
    /* 0 or subnormal */
    case 0:
      hSig = h & 1023;
      if (hSig === 0) {
        return fSgn;
      }
      hSig <<= 1;
      while ((hSig & 1024) === 0) {
        hSig <<= 1;
        hExp++;
      }
      fExp = 127 - 15 - hExp << 23;
      fSig = (hSig & 1023) << 13;
      return fSgn + fExp + fSig;
    /* inf or NaN */
    case 31744:
      return fSgn + 2139095040 + ((h & 1023) << 13);
    default:
      return fSgn + ((h & 32767) + 114688 << 13);
  }
}
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}
function uint16ArrayToFloat32Array(uint16array) {
  const bytes = new Uint32Array(uint16array.length);
  for (let i = 0; i < uint16array.length; i++) {
    bytes[i] = float32(uint16array[i]);
  }
  const newBytes = new Float32Array(bytes.buffer);
  return newBytes;
}
function tileResponseToData(inputData, server, theseTileIds) {
  const data2 = inputData ?? {};
  for (const thisId of theseTileIds) {
    if (!(thisId in data2)) {
      data2[thisId] = {};
    }
    const key = thisId;
    const keyParts = key.split(".");
    data2[key].server = server;
    data2[key].tileId = key;
    data2[key].zoomLevel = +keyParts[1];
    const tilePos = keyParts.slice(2, keyParts.length).map((x) => +x).filter((x) => !Number.isNaN(x));
    data2[key].tilePos = tilePos;
    data2[key].tilesetUid = keyParts[0];
    if ("dense" in data2[key] && typeof data2[key].dense === "string") {
      const base64 = data2[key].dense;
      const arrayBuffer = base64ToArrayBuffer(base64);
      let a;
      if (data2[key].dtype === "float16") {
        const uint16Array = new Uint16Array(arrayBuffer);
        const newDense = uint16ArrayToFloat32Array(uint16Array);
        a = newDense;
      } else {
        a = new Float32Array(arrayBuffer);
      }
      const dde = tilePos.length === 2 ? new DenseDataExtrema2D(a) : new DenseDataExtrema1D(a);
      data2[key].dense = a;
      data2[key].denseDataExtrema = dde;
      data2[key].minNonZero = dde.minNonZeroInTile;
      data2[key].maxNonZero = dde.maxNonZeroInTile;
    }
  }
  return data2;
}
function workerFetchTiles(request2, options2) {
  const headers = {
    "content-type": "application/json"
  };
  if (options2.authHeader) headers.Authorization = options2.authHeader;
  const renderParams = request2.tileIds.map((x) => `d=${x}`).join("&");
  const url = `${request2.server}/tiles/?${renderParams}&s=${options2.sessionId}`;
  options2.pubSub?.publish("requestSent", url);
  return fetch(url, {
    credentials: "same-origin",
    headers,
    ...request2.body?.length > 0 ? {
      method: "POST",
      body: JSON.stringify(request2.body)
    } : {}
  }).then((response) => response.json()).then((data2) => {
    options2.pubSub?.publish("requestReceived", url);
    return tileResponseToData(data2, request2.server, request2.tileIds);
  }).catch((err) => console.warn("err:", err));
}
const MAX_FETCH_TILES = 15;
const sessionId = slugid.nice();
let requestsInFlight = 0;
let authHeader = null;
function* chunkIterable(iterable, size) {
  let chunk = [];
  for (const item of iterable) {
    chunk.push(item);
    if (chunk.length === size) {
      yield chunk;
      chunk = [];
    }
  }
  if (chunk.length) {
    yield chunk;
  }
}
function createBatchedExecutor({
  processBatch,
  interval: interval2,
  finalWait
}) {
  let timeout2 = void 0;
  let pending = [];
  let blockedCalls = 0;
  const reset = () => {
    timeout2 = void 0;
    pending = [];
  };
  const callFunc = (...args) => {
    processBatch(pending, ...args);
    reset();
  };
  const debounced = (...args) => {
    const later = () => {
      if (blockedCalls > 0) {
        callFunc(...args);
        blockedCalls = 0;
      }
    };
    clearTimeout(timeout2);
    timeout2 = setTimeout(later, finalWait);
  };
  let wait = false;
  const throttled = (value, ...args) => {
    const {
      promise,
      resolve,
      reject
    } = Promise.withResolvers();
    pending.push({
      value,
      resolve,
      reject
    });
    if (!wait) {
      callFunc(...args);
      debounced(...args);
      wait = true;
      blockedCalls = 0;
      setTimeout(() => {
        wait = false;
      }, interval2);
    } else {
      blockedCalls++;
    }
    return promise;
  };
  return throttled;
}
const setTileProxyAuthHeader = (newHeader) => {
  authHeader = newHeader;
};
const getTileProxyAuthHeader = () => authHeader;
function bundleRequestsById(requests) {
  const bundledRequests = [];
  const mapper = {};
  for (const request2 of requests) {
    if (mapper[request2.id] === void 0) {
      mapper[request2.id] = bundledRequests.length;
      bundledRequests.push({
        ...request2,
        tileIds: []
      });
    }
    const bundle = bundledRequests[mapper[request2.id]];
    bundle.tileIds = bundle.tileIds.concat(request2.tileIds);
  }
  return bundledRequests;
}
function bundleRequestsByServer(requests) {
  const bundle = [];
  const mapper = {};
  for (const request2 of requests) {
    if (mapper[request2.server] === void 0) {
      mapper[request2.server] = bundle.length;
      bundle.push({
        ...request2,
        tileIds: [],
        body: []
      });
    }
    const server = bundle[mapper[request2.server]];
    server.tileIds = server.tileIds.concat(request2.tileIds);
    for (const id2 of request2.tileIds) {
      if (request2.options) {
        const firstSepIndex = id2.indexOf(".");
        const tilesetUid = id2.substring(0, firstSepIndex);
        const tileId = id2.substring(firstSepIndex + 1);
        let tilesetObject = server.body.find((t) => t.tilesetUid === tilesetUid);
        if (!tilesetObject) {
          tilesetObject = {
            tilesetUid,
            tileIds: [],
            options: request2.options
          };
          server.body.push(tilesetObject);
        }
        tilesetObject.tileIds.push(tileId);
      }
    }
  }
  return bundle;
}
function* optimizeRequests(requests, {
  maxSize = MAX_FETCH_TILES
} = {}) {
  const byRequestId = bundleRequestsById(requests);
  const byServer = bundleRequestsByServer(byRequestId);
  for (const request2 of byServer) {
    for (const tileIds of chunkIterable(new Set(request2.tileIds), maxSize)) {
      yield {
        ...request2,
        tileIds
      };
    }
  }
}
function indexTiles(responses) {
  const tileMap = {};
  const keyFor = (server, tileId) => `${server}/${tileId}`;
  for (const response of responses) {
    if (!response) continue;
    for (const [tileId, tileData] of Object.entries(response)) {
      tileMap[keyFor(tileData.server, tileId)] = response[tileId];
    }
  }
  return {
    /**
     * Retrieve data for a specific request from the shared index.
     *
     * @param {{ server: string, tileIds: Array<string> }} request
     */
    resolveTileDataForRequest(request2) {
      const response = {};
      for (const tileId of request2.tileIds) {
        const entry = tileMap[keyFor(request2.server, tileId)];
        if (entry) response[tileId] = entry;
      }
      return response;
    }
  };
}
const fetchTilesDebounced = createBatchedExecutor({
  /**
   * Fetch and process a batch of tile requests.
   *
   * @param {Array<WithResolvers<TilesRequest, Record<string, TileData>>>} requests
   * @param {PubSub} pubSub
   */
  processBatch: async (requests, pubSub) => {
    const promises = Array.from(optimizeRequests(requests.map((r2) => r2.value)), (request2) => workerFetchTiles(request2, {
      authHeader,
      sessionId,
      pubSub
    }));
    const index2 = indexTiles(await Promise.all(promises));
    for (const request2 of requests) {
      request2.resolve(index2.resolveTileDataForRequest(request2.value));
    }
  },
  interval: TILE_FETCH_DEBOUNCE,
  finalWait: TILE_FETCH_DEBOUNCE
});
const calculateZoomLevelFromResolutions = (resolutions, scale) => {
  const sortedResolutions = resolutions.map((x) => +x).sort((a, b) => b - a);
  const trackWidth2 = scale.range()[1] - scale.range()[0];
  const binsDisplayed = sortedResolutions.map((r2) => (scale.domain()[1] - scale.domain()[0]) / r2);
  const binsPerPixel = binsDisplayed.map((b) => b / trackWidth2);
  const displayableBinsPerPixel = binsPerPixel.filter((b) => b < 1);
  if (displayableBinsPerPixel.length === 0) return 0;
  return binsPerPixel.indexOf(displayableBinsPerPixel[displayableBinsPerPixel.length - 1]);
};
const calculateResolution = (tilesetInfo, zoomLevel) => {
  if (isResolutionsTilesetInfo(tilesetInfo)) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    const resolution2 = sortedResolutions[zoomLevel];
    return resolution2;
  }
  const maxWidth = tilesetInfo.max_width;
  const binsPerDimension = +(tilesetInfo?.bins_per_dimension ?? 256);
  const resolution = maxWidth / (2 ** zoomLevel * binsPerDimension);
  return resolution;
};
const calculateZoomLevel = (scale, minX, maxX, binsPerTile) => {
  const rangeWidth = scale.range()[1] - scale.range()[0];
  const zoomScale = Math.max((maxX - minX) / (scale.domain()[1] - scale.domain()[0]), 1);
  const viewResolution = 384;
  const addedZoom = Math.max(0, Math.ceil(Math.log(rangeWidth / viewResolution) / Math.LN2));
  let zoomLevel = Math.round(Math.log(zoomScale) / Math.LN2) + addedZoom;
  let binsPerTileCorrection = 0;
  if (binsPerTile) {
    binsPerTileCorrection = Math.floor(Math.log(256) / Math.log(2) - Math.log(binsPerTile) / Math.log(2));
  }
  zoomLevel += binsPerTileCorrection;
  return zoomLevel;
};
function calculateTileAndPosInTile(tilesetInfo, maxDim, dataStartPos, zoomLevel, position) {
  let tileWidth = null;
  const pixelsPerTile = isLegacyTilesetInfo(tilesetInfo) ? tilesetInfo.bins_per_dimension ?? 256 : 256;
  if (!isLegacyTilesetInfo(tilesetInfo)) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    tileWidth = sortedResolutions[zoomLevel] * pixelsPerTile;
  } else {
    tileWidth = maxDim / 2 ** zoomLevel;
  }
  const tilePos = Math.floor((position - dataStartPos) / tileWidth);
  const posInTile = Math.floor(pixelsPerTile * (position - tilePos * tileWidth) / tileWidth);
  return [tilePos, posInTile];
}
const calculateTiles = (zoomLevel, scale, minX, _maxX, maxZoom, maxDim) => {
  const zoomLevelFinal = Math.min(zoomLevel, maxZoom);
  const tileWidth = maxDim / 2 ** zoomLevelFinal;
  const epsilon3 = 1e-7;
  return range$4(Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth)), Math.min(2 ** zoomLevelFinal, Math.ceil((scale.domain()[1] - minX - epsilon3) / tileWidth)));
};
const calculateTileWidth = (tilesetInfo, zoomLevel, binsPerTile) => {
  if (!isLegacyTilesetInfo(tilesetInfo)) {
    const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
    return sortedResolutions[zoomLevel] * binsPerTile;
  }
  return tilesetInfo.max_width / 2 ** zoomLevel;
};
const calculateTilesFromResolution = (resolution, scale, minX, maxX, pixelsPerTile) => {
  const epsilon3 = 1e-7;
  const PIXELS_PER_TILE = pixelsPerTile || 256;
  const tileWidth = resolution * PIXELS_PER_TILE;
  const MAX_TILES = 20;
  if (!maxX) {
    maxX = Number.MAX_VALUE;
  }
  const lowerBound = Math.max(0, Math.floor((scale.domain()[0] - minX) / tileWidth));
  const upperBound = Math.ceil(Math.min(maxX, scale.domain()[1] - minX - epsilon3) / tileWidth);
  let tileRange = range$4(lowerBound, upperBound);
  if (tileRange.length > MAX_TILES) {
    console.warn(`Too many visible tiles: ${tileRange.length} truncating to ${MAX_TILES}`);
    tileRange = tileRange.slice(0, MAX_TILES);
  }
  return tileRange;
};
const tileDataToPixData = (tile, valueScaleType, valueScaleDomain, pseudocount, colorScale, finished, ignoreUpperRight, ignoreLowerLeft, zeroValueColor, selectedRowsOptions) => {
  const {
    tileData
  } = tile;
  if (!tileData.dense) {
    finished(null);
    return;
  }
  if (tile.mirrored && // Data is already copied over
  !tile.isMirrored && tile.tileData.tilePos.length > 0 && tile.tileData.tilePos[0] === tile.tileData.tilePos[1]) {
    tile.tileData.dense = tile.tileData.dense.slice();
    const tileWidth = Math.floor(Math.sqrt(tile.tileData.dense.length));
    for (let row = 0; row < tileWidth; row++) {
      for (let col = row + 1; col < tileWidth; col++) {
        tile.tileData.dense[row * tileWidth + col] = tile.tileData.dense[col * tileWidth + row];
      }
    }
    if (ignoreLowerLeft) {
      for (let row = 0; row < tileWidth; row++) {
        for (let col = 0; col < row; col++) {
          tile.tileData.dense[row * tileWidth + col] = Number.NaN;
        }
      }
    }
    tile.isMirrored = true;
  }
  const pixData = workerSetPix(tileData.dense.length, tileData.dense, valueScaleType, valueScaleDomain, pseudocount, colorScale, ignoreUpperRight, ignoreLowerLeft, tile.tileData.shape, zeroValueColor, selectedRowsOptions);
  finished({
    pixData
  });
};
function fetchEither(url, callback, textOrJson, pubSub) {
  requestsInFlight += 1;
  pubSub.publish("requestSent", url);
  let mime = null;
  if (textOrJson === "text") {
    mime = null;
  } else if (textOrJson === "json") {
    mime = "application/json";
  } else {
    throw new Error(`fetch either "text" or "json", not "${textOrJson}"`);
  }
  const headers = {};
  if (mime) {
    headers["Content-Type"] = mime;
  }
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  return fetch(url, {
    credentials: "same-origin",
    headers
  }).then((rep) => {
    if (!rep.ok) {
      throw Error(rep.statusText);
    }
    return rep[textOrJson]();
  }).then((content) => {
    callback(void 0, content);
    return content;
  }).catch((error) => {
    console.error(`Could not fetch ${url}`, error);
    callback(error, void 0);
    return error;
  }).finally(() => {
    pubSub.publish("requestReceived", url);
    requestsInFlight -= 1;
  });
}
function text$1(url, callback, pubSub) {
  return fetchEither(url, callback, "text", pubSub);
}
async function json$1(url, callback, pubSub) {
  return fetchEither(url, callback, "json", pubSub);
}
const trackInfo = (server, tilesetUid, doneCb, errorCb, pubSub) => {
  const url = `${trimTrailingSlash(server)}/tileset_info/?d=${tilesetUid}&s=${sessionId}`;
  pubSub.publish("requestSent", url);
  json$1(url, (error, data2) => {
    pubSub.publish("requestReceived", url);
    if (error) {
      if (errorCb) {
        errorCb(`Error retrieving tilesetInfo from: ${server}`);
      } else {
        console.warn("Error retrieving: ", url);
      }
    } else {
      doneCb(data2);
    }
  }, pubSub);
};
const api = {
  calculateResolution,
  calculateTileAndPosInTile,
  calculateTiles,
  calculateTilesFromResolution,
  calculateTileWidth,
  calculateZoomLevel,
  calculateZoomLevelFromResolutions,
  fetchTilesDebounced,
  json: json$1,
  text: text$1,
  tileDataToPixData,
  trackInfo
};
const services = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ElementResizeListener,
  get authHeader() {
    return authHeader;
  },
  chromInfo: api$1,
  createDomEvent: domEvent,
  getTileProxyAuthHeader,
  get requestsInFlight() {
    return requestsInFlight;
  },
  setTileProxyAuthHeader,
  tileProxy: api,
  tileResponseToData
}, Symbol.toStringTag, { value: "Module" }));
const fakePubSub = {
  __fake__: true,
  publish: () => {
  },
  subscribe: () => ({
    event: "",
    handler: () => {
    }
  }),
  unsubscribe: () => {
  },
  clear: () => {
  }
};
function ChromosomeInfo(filepath, success, pubSub = fakePubSub) {
  const ret = {};
  ret.absToChr = (absPos) => ret.chrPositions ? absToChr(absPos, ret) : null;
  ret.chrToAbs = ([chrName, chrPos] = []) => ret.chrPositions ? chrToAbs(chrName, chrPos, ret) : null;
  return api.text(filepath, (error, chrInfoText) => {
    if (error) {
      if (success) success(null);
    } else {
      const data2 = tsvParseRows(chrInfoText);
      const chromInfo = parseChromsizesRows(data2);
      Object.keys(chromInfo).forEach((key) => {
        ret[key] = chromInfo[key];
      });
      if (success) success(ret);
    }
  }, pubSub).then(() => ret);
}
const button = "_button_1wnjn_1";
const classes$b = {
  button,
  "button-shortcut": "_button-shortcut_1wnjn_35"
};
const Button = /* @__PURE__ */ React__default.forwardRef(({
  onClick = () => {
  },
  styleName = "",
  children: children2,
  ...props
}, ref2) => /* @__PURE__ */ React__default.createElement("button", {
  ref: ref2,
  className: classes$b[styleName] ?? classes$b.button,
  disabled: props.disable,
  onBlur: props.onBlur,
  onClick,
  onMouseDown: props.onMouseDown,
  onMouseOut: props.onMouseOut,
  onMouseUp: props.onMouseUp,
  type: "button"
}, children2, props.shortcut && /* @__PURE__ */ React__default.createElement("span", {
  className: classes$b["button-shortcut"]
}, props.shortcut)));
Button.propTypes = {
  children: PropTypes.any,
  disable: PropTypes.bool,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseUp: PropTypes.func,
  shortcut: PropTypes.string,
  type: PropTypes.string,
  styleName: PropTypes.string
};
const cross = "_cross_2ke8w_1";
const classes$a = {
  cross
};
function Cross() {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: classes$a.cross
  });
}
const {
  Provider: Provider$2,
  Consumer: Consumer$2
} = /* @__PURE__ */ React__default.createContext({
  close: toVoid,
  open: toVoid
});
function withModal(Component2) {
  return /* @__PURE__ */ React__default.forwardRef((props, ref2) => /* @__PURE__ */ React__default.createElement(Consumer$2, null, (modal) => /* @__PURE__ */ React__default.createElement(Component2, {
    ref: ref2,
    ...props,
    modal
  })));
}
const classes$9 = {
  "modal-background": "_modal-background_zzhoe_1",
  "modal-hide": "_modal-hide_zzhoe_13",
  "modal-wrap": "_modal-wrap_zzhoe_17",
  "modal-window": "_modal-window_zzhoe_25",
  "modal-window-max-height": "_modal-window-max-height_zzhoe_38",
  "modal-content": "_modal-content_zzhoe_42"
};
function Modal({
  closeButton = true,
  hide = false,
  maxHeight = false,
  modal,
  onClose,
  children: children2
}) {
  const handleClose = () => {
    modal.close();
    if (onClose) onClose();
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: clsx$2(classes$9["modal-background"], {
      [classes$9["modal-hide"]]: hide
    })
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: classes$9["modal-wrap"]
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: clsx$2(classes$9["modal-window"], {
      [classes$9["modal-window-max-height"]]: maxHeight
    })
  }, closeButton && /* @__PURE__ */ React__default.createElement(Button, {
    onClick: handleClose
  }, /* @__PURE__ */ React__default.createElement(Cross, null)), /* @__PURE__ */ React__default.createElement("div", {
    className: classes$9["modal-content"]
  }, children2))));
}
Modal.propTypes = {
  children: PropTypes.element.isRequired,
  closeButton: PropTypes.bool,
  hide: PropTypes.bool,
  maxHeight: PropTypes.bool,
  modal: PropTypes.object.isRequired,
  onClose: PropTypes.func
};
const Modal$1 = withModal(Modal);
const classes$8 = {
  "dialog-header": "_dialog-header_wp50s_1",
  "dialog-main-max-height": "_dialog-main-max-height_wp50s_20",
  "dialog-footer": "_dialog-footer_wp50s_31",
  "dialog-footer-max-height": "_dialog-footer-max-height_wp50s_31"
};
function Dialog({
  cancelTitle = "Cancel",
  hide = false,
  maxHeight = false,
  okayOnly = false,
  okayTitle = "Ok",
  modal,
  onCancel,
  onOkay,
  title: title2,
  cancelShortcut,
  okayShortcut,
  children: children2
}) {
  const handleCancel = () => {
    modal.close();
    if (onCancel) onCancel();
  };
  const handleOkay = () => {
    modal.close();
    if (onOkay) onOkay();
  };
  return /* @__PURE__ */ React__default.createElement(Modal$1, {
    closeButton: false,
    hide,
    maxHeight
  }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("header", {
    className: classes$8["dialog-header"]
  }, /* @__PURE__ */ React__default.createElement("h3", null, title2), /* @__PURE__ */ React__default.createElement(Button, {
    onClick: handleCancel
  }, /* @__PURE__ */ React__default.createElement(Cross, null))), maxHeight ? /* @__PURE__ */ React__default.createElement("main", {
    className: clsx$2(maxHeight && classes$8["dialog-main-max-height"])
  }, children2) : /* @__PURE__ */ React__default.createElement("main", null, children2), /* @__PURE__ */ React__default.createElement("footer", {
    className: classes$8[maxHeight ? "dialog-footer-max-height" : "dialog-footer"]
  }, okayOnly ? /* @__PURE__ */ React__default.createElement("div", null) : /* @__PURE__ */ React__default.createElement(Button, {
    onClick: handleCancel,
    shortcut: cancelShortcut
  }, cancelTitle), /* @__PURE__ */ React__default.createElement(Button, {
    onClick: handleOkay,
    shortcut: okayShortcut
  }, okayTitle))));
}
Dialog.propTypes = {
  cancelShortcut: PropTypes.string,
  cancelTitle: PropTypes.string,
  children: PropTypes.object,
  hide: PropTypes.bool,
  maxHeight: PropTypes.bool,
  modal: PropTypes.object.isRequired,
  okayShortcut: PropTypes.string,
  okayTitle: PropTypes.string,
  okayOnly: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onOkay: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
const Dialog$1 = withModal(Dialog);
const classes$7 = {
  "export-link-dialog-wrapper": "_export-link-dialog-wrapper_p9gxw_1"
};
function _classCallCheck$1w(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1o(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1o(o.key), o);
  }
}
function _createClass$1w(e, r2, t) {
  return r2 && _defineProperties$1o(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1o(t) {
  var i = _toPrimitive$1o(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1o(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1g(t, o, e) {
  return o = _getPrototypeOf$1g(o), _possibleConstructorReturn$1o(t, _isNativeReflectConstruct$1g() ? Reflect.construct(o, e || [], _getPrototypeOf$1g(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1o(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1g(t);
}
function _assertThisInitialized$1g(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1g() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1g = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1g(t) {
  return _getPrototypeOf$1g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1g(t);
}
function _inherits$1o(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1g(t, e);
}
function _setPrototypeOf$1g(t, e) {
  return _setPrototypeOf$1g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1g(t, e);
}
let ExportLinkDialog = /* @__PURE__ */ (function(_React$Component) {
  function ExportLinkDialog2() {
    _classCallCheck$1w(this, ExportLinkDialog2);
    return _callSuper$1g(this, ExportLinkDialog2, arguments);
  }
  _inherits$1o(ExportLinkDialog2, _React$Component);
  return _createClass$1w(ExportLinkDialog2, [{
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement(Dialog$1, {
        okayOnly: true,
        okayTitle: "Done",
        onOkay: this.props.onDone,
        title: "Share view link"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: classes$7["export-link-dialog-wrapper"]
      }, /* @__PURE__ */ React__default.createElement("input", {
        ref: (element) => {
          if (!element) return;
          this.input = element;
          element.focus();
          element.select();
        },
        onClick: (event) => {
          event.target.select();
        },
        placeholder: "Generating the link...",
        readOnly: true,
        value: this.props.url
      }), /* @__PURE__ */ React__default.createElement(Button, {
        onClick: (event) => {
          this.input.select();
          document.execCommand("copy");
        }
      }, "Copy")));
    }
  }]);
})(React__default.Component);
ExportLinkDialog.defaultProps = {
  onDone: () => {
  },
  url: ""
};
ExportLinkDialog.propTypes = {
  onDone: PropTypes.func,
  url: PropTypes.string
};
var slice$1 = [].slice;
var noabort = {};
function Queue(size) {
  this._size = size;
  this._call = this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting = this._active = this._ended = this._start = 0;
}
Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = slice$1.call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke$1(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) {
      callback.apply(null, [error].concat(results));
    };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};
function poke$1(q2) {
  if (!q2._start) {
    try {
      start$1(q2);
    } catch (e) {
      if (q2._tasks[q2._ended + q2._active - 1]) abort(q2, e);
      else if (!q2._data) throw e;
    }
  }
}
function start$1(q2) {
  while (q2._start = q2._waiting && q2._active < q2._size) {
    var i = q2._ended + q2._active, t = q2._tasks[i], j = t.length - 1, c = t[j];
    t[j] = end(q2, i);
    --q2._waiting, ++q2._active;
    t = c.apply(null, t);
    if (!q2._tasks[i]) continue;
    q2._tasks[i] = t || noabort;
  }
}
function end(q2, i) {
  return function(e, r2) {
    if (!q2._tasks[i]) return;
    --q2._active, ++q2._ended;
    q2._tasks[i] = null;
    if (q2._error != null) return;
    if (e != null) {
      abort(q2, e);
    } else {
      q2._data[i] = r2;
      if (q2._waiting) poke$1(q2);
      else maybeNotify(q2);
    }
  };
}
function abort(q2, e) {
  var i = q2._tasks.length, t;
  q2._error = e;
  q2._data = void 0;
  q2._waiting = NaN;
  while (--i >= 0) {
    if (t = q2._tasks[i]) {
      q2._tasks[i] = null;
      if (t.abort) {
        try {
          t.abort();
        } catch (e3) {
        }
      }
    }
  }
  q2._active = NaN;
  maybeNotify(q2);
}
function maybeNotify(q2) {
  if (!q2._active && q2._call) {
    var d = q2._data;
    q2._data = void 0;
    q2._call(q2._error, d);
  }
}
function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}
const d3Queue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  queue
}, Symbol.toStringTag, { value: "Module" }));
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends$d.apply(null, arguments);
}
function _classCallCheck$1v(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1n(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1n(o.key), o);
  }
}
function _createClass$1v(e, r2, t) {
  return r2 && _defineProperties$1n(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1n(t) {
  var i = _toPrimitive$1n(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1n(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1f(t, o, e) {
  return o = _getPrototypeOf$1f(o), _possibleConstructorReturn$1n(t, _isNativeReflectConstruct$1f() ? Reflect.construct(o, e || [], _getPrototypeOf$1f(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1n(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1f(t);
}
function _assertThisInitialized$1f(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1f() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1f = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1f(t) {
  return _getPrototypeOf$1f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1f(t);
}
function _inherits$1n(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1f(t, e);
}
function _setPrototypeOf$1f(t, e) {
  return _setPrototypeOf$1f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1f(t, e);
}
const _debugStates = [];
let Autocomplete = /* @__PURE__ */ (function(_React$Component) {
  function Autocomplete2(props) {
    var _this;
    _classCallCheck$1v(this, Autocomplete2);
    _this = _callSuper$1f(this, Autocomplete2, [props]);
    _this.state = {
      highlightedIndex: null,
      menuTop: 0,
      menuLeft: 0,
      menuWidth: 0,
      isOpen: false
    };
    _this.itemRefs = {};
    _this.menuRef = null;
    _this.keyDownHandlers = {
      ArrowDown(event) {
        event.preventDefault();
        const itemsLength = this.getFilteredItems().length;
        if (!itemsLength) return;
        const {
          highlightedIndex
        } = this.state;
        const index2 = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? 0 : highlightedIndex + 1;
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index2,
          isOpen: true
        });
      },
      ArrowUp(event) {
        event.preventDefault();
        const itemsLength = this.getFilteredItems().length;
        if (!itemsLength) return;
        const {
          highlightedIndex
        } = this.state;
        const index2 = highlightedIndex === 0 || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1;
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index2,
          isOpen: true
        });
      },
      Enter(event) {
        if (this.state.isOpen === false) ;
        else if (this.state.highlightedIndex === null) {
          this.setState({
            isOpen: false
          }, () => {
            this.inputEl.select();
          });
        } else {
          event.preventDefault();
          const item = this.getFilteredItems()[this.state.highlightedIndex];
          const value = this.props.getItemValue(item);
          this.setState({
            isOpen: false,
            highlightedIndex: null
          }, () => {
            this.inputEl.setSelectionRange(value.length, value.length);
            this.props.onSelect(value, item);
          });
        }
      },
      Escape() {
        this.setState({
          highlightedIndex: null,
          isOpen: false
        });
      }
    };
    return _this;
  }
  _inherits$1n(Autocomplete2, _React$Component);
  return _createClass$1v(Autocomplete2, [{
    key: "getInitialState",
    value: function getInitialState2() {
      return {
        isOpen: false,
        highlightedIndex: null
      };
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this._ignoreBlur = false;
      this._performAutoCompleteOnUpdate = false;
      this._performAutoCompleteOnKeyUp = false;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this._performAutoCompleteOnUpdate = true;
      if (this.props.items !== nextProps.items || // The entries in `items` may have been changed even though the
      // object reference remains the same, double check by seeing
      // if `highlightedIndex` points to an existing item
      this.state.highlightedIndex >= nextProps.items.length) {
        this.setState({
          highlightedIndex: null
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isOpen === true && prevState.isOpen === false) {
        this.setMenuPositions();
      }
      if (this.state.isOpen && this._performAutoCompleteOnUpdate) {
        this._performAutoCompleteOnUpdate = false;
        this.maybeAutoCompleteText();
      }
      this.maybeScrollItemIntoView();
      if (prevState.isOpen !== this.state.isOpen) {
        this.props.onMenuVisibilityChange(this.state.isOpen, this.inputEl);
      }
    }
  }, {
    key: "maybeScrollItemIntoView",
    value: function maybeScrollItemIntoView() {
      if (this.state.isOpen === true && this.state.highlightedIndex !== null) {
        const itemNode = this.itemRefs[this.state.highlightedIndex];
        itemNode?.scrollIntoView({
          block: "nearest",
          behavior: "smooth"
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.keyDownHandlers[event.key]) {
        this.keyDownHandlers[event.key].call(this, event);
      } else {
        this.setState({
          highlightedIndex: null,
          isOpen: true
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this._performAutoCompleteOnKeyUp = true;
      this.props.onChange(event, event.target.value);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp() {
      if (this._performAutoCompleteOnKeyUp) {
        this._performAutoCompleteOnKeyUp = false;
        this.maybeAutoCompleteText();
      }
    }
  }, {
    key: "getFilteredItems",
    value: function getFilteredItems() {
      let items2 = this.props.items;
      if (this.props.shouldItemRender) {
        items2 = items2.filter((item) => this.props.shouldItemRender(item, this.props.value));
      }
      if (this.props.sortItems) {
        items2.sort((a, b) => this.props.sortItems(a, b, this.props.value));
      }
      return items2;
    }
  }, {
    key: "maybeAutoCompleteText",
    value: function maybeAutoCompleteText() {
      if (!this.props.autoHighlight || this.props.value === "") {
        return;
      }
      const {
        highlightedIndex
      } = this.state;
      const items2 = this.getFilteredItems();
      if (items2.length === 0) {
        return;
      }
      const matchedItem = highlightedIndex !== null ? items2[highlightedIndex] : items2[0];
      const itemValue = this.props.getItemValue(matchedItem);
      const itemValueDoesMatch = itemValue.toLowerCase().indexOf(this.props.value.toLowerCase()) === 0;
      if (itemValueDoesMatch && highlightedIndex === null) {
        this.setState({
          highlightedIndex: 0
        });
      }
    }
  }, {
    key: "setMenuPositions",
    value: function setMenuPositions() {
      const node2 = this.inputEl;
      const rect2 = node2.getBoundingClientRect();
      const computedStyle = globalThis.window.getComputedStyle(node2);
      const marginBottom = Number.parseInt(computedStyle.marginBottom, 10) || 0;
      const marginLeft = Number.parseInt(computedStyle.marginLeft, 10) || 0;
      const marginRight = Number.parseInt(computedStyle.marginRight, 10) || 0;
      this.setState({
        menuTop: rect2.bottom + marginBottom,
        menuLeft: rect2.left + marginLeft,
        menuWidth: rect2.width + marginLeft + marginRight
      });
    }
  }, {
    key: "highlightItemFromMouse",
    value: function highlightItemFromMouse(index2) {
      this.setState({
        highlightedIndex: index2
      });
    }
  }, {
    key: "selectItemFromMouse",
    value: function selectItemFromMouse(item) {
      const value = this.props.getItemValue(item);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, () => {
        this.props.onSelect(value, item);
        this.inputEl.focus();
      });
    }
  }, {
    key: "setIgnoreBlur",
    value: function setIgnoreBlur(ignore) {
      this._ignoreBlur = ignore;
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      const items2 = this.getFilteredItems().map((item, index2) => {
        const element = this.props.renderItem(item, this.state.highlightedIndex === index2, {
          cursor: "default"
        });
        return /* @__PURE__ */ React__default.cloneElement(element, {
          onMouseDown: () => this.setIgnoreBlur(true),
          // Ignore blur to prevent menu from de-rendering before we can process click
          onMouseEnter: () => this.highlightItemFromMouse(index2),
          onClick: () => this.selectItemFromMouse(item),
          ref: (el2) => {
            this.itemRefs[index2] = el2;
          }
        });
      });
      const style = {
        left: this.state.menuLeft,
        top: this.state.menuTop,
        minWidth: this.state.menuWidth
      };
      if (!items2.length) return null;
      const menu = this.props.renderMenu(items2, this.props.value, style);
      return /* @__PURE__ */ React__default.cloneElement(menu, {
        ref: (el2) => {
          this.menuRef = el2;
        }
      });
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      if (this.props.onFocus) {
        this.props.onFocus();
      }
      if (this._ignoreBlur) {
        return;
      }
      this.setState({
        isOpen: false,
        highlightedIndex: null
      });
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      if (this.props.onFocus) {
        this.props.onFocus(true);
      }
      if (this._ignoreBlur) {
        this.setIgnoreBlur(false);
        return;
      }
      this._ignoreClick = true;
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "isInputFocused",
    value: function isInputFocused() {
      return this.inputEl.ownerDocument && this.inputEl === this.inputEl.ownerDocument.activeElement;
    }
  }, {
    key: "handleInputClick",
    value: function handleInputClick() {
      if (this.isInputFocused() && this.state.isOpen === false) {
        this.setState({
          isOpen: true
        });
      } else if (this.state.highlightedIndex !== null && !this._ignoreClick) {
        this.selectItemFromMouse(this.getFilteredItems()[this.state.highlightedIndex]);
      }
      this._ignoreClick = false;
    }
  }, {
    key: "composeEventHandlers",
    value: function composeEventHandlers(internal, external) {
      return external ? (e) => {
        internal(e);
        external(e);
      } : internal;
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      if (this.props.debug) {
        _debugStates.push({
          id: _debugStates.length,
          state: this.state
        });
      }
      const {
        inputProps
      } = this.props;
      return /* @__PURE__ */ React__default.createElement("div", _extends$d({
        style: {
          ...this.props.wrapperStyle
        }
      }, this.props.wrapperProps), /* @__PURE__ */ React__default.createElement("input", _extends$d({}, inputProps, {
        ref: (el2) => {
          this.inputEl = el2;
        },
        "aria-autocomplete": "list",
        autoComplete: "off",
        onBlur: this.composeEventHandlers(this.handleInputBlur.bind(this), inputProps.onBlur?.bind(this)),
        onChange: this.handleChange.bind(this),
        onClick: this.composeEventHandlers(this.handleInputClick.bind(this), inputProps.onClick?.bind(this)),
        onFocus: this.composeEventHandlers(this.handleInputFocus.bind(this), inputProps.onFocus?.bind(this)),
        onKeyDown: this.composeEventHandlers(this.handleKeyDown.bind(this), inputProps.onKeyDown?.bind(this)),
        onKeyUp: this.composeEventHandlers(this.handleKeyUp.bind(this), inputProps.onKeyUp?.bind(this)),
        role: "combobox",
        value: this.props.value
      })), ("open" in this.props ? this.props.open : this.state.isOpen) && this.renderMenu(), this.props.debug && /* @__PURE__ */ React__default.createElement("pre", {
        style: {
          marginLeft: 300
        }
      }, JSON.stringify(_debugStates.slice(_debugStates.length - 5, _debugStates.length), null, 2)));
    }
  }]);
})(React__default.Component);
Autocomplete.defaultProps = {
  value: "",
  wrapperProps: {},
  wrapperStyle: {
    display: "inline-block"
  },
  inputProps: {},
  onChange() {
  },
  onSelect() {
  },
  renderMenu(items2, value, style) {
    return /* @__PURE__ */ React__default.createElement("div", {
      style: {
        ...style,
        ...this.menuStyle
      }
    }, items2);
  },
  shouldItemRender() {
    return true;
  },
  menuStyle: {
    borderRadius: "3px",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
    background: "rgba(255, 255, 255, 0.9)",
    padding: "2px 0",
    fontSize: "90%",
    position: "fixed",
    overflow: "auto",
    maxHeight: "50%"
    // TODO: don't cheat, let it flow to the bottom
  },
  autoHighlight: true,
  onMenuVisibilityChange() {
  }
};
Autocomplete.propTypes = {
  autoHighlight: PropTypes.bool,
  debug: PropTypes.bool,
  getItemValue: PropTypes.func.isRequired,
  inputProps: PropTypes.object,
  items: PropTypes.array,
  menuStyle: PropTypes.object,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onMenuVisibilityChange: PropTypes.func,
  onSelect: PropTypes.func,
  open: PropTypes.bool,
  renderItem: PropTypes.func.isRequired,
  renderMenu: PropTypes.func,
  shouldItemRender: PropTypes.func,
  sortItems: PropTypes.func,
  value: PropTypes.any,
  wrapperProps: PropTypes.object,
  wrapperStyle: PropTypes.object
};
function _classCallCheck$1u(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1m(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1m(o.key), o);
  }
}
function _createClass$1u(e, r2, t) {
  return r2 && _defineProperties$1m(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1m(t) {
  var i = _toPrimitive$1m(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1m(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1e(t, o, e) {
  return o = _getPrototypeOf$1e(o), _possibleConstructorReturn$1m(t, _isNativeReflectConstruct$1e() ? Reflect.construct(o, e || [], _getPrototypeOf$1e(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1m(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1e(t);
}
function _assertThisInitialized$1e(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1e() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1e = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1e(t) {
  return _getPrototypeOf$1e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1e(t);
}
function _inherits$1m(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1e(t, e);
}
function _setPrototypeOf$1e(t, e) {
  return _setPrototypeOf$1e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1e(t, e);
}
let PopupMenu = /* @__PURE__ */ (function(_React$Component) {
  function PopupMenu2(props) {
    var _this;
    _classCallCheck$1u(this, PopupMenu2);
    _this = _callSuper$1e(this, PopupMenu2, [props]);
    _this.popup = null;
    _this.clickHandlerBound = _this.clickHandler.bind(_this);
    _this.contextMenuHandlerBound = _this.contextMenuHandler.bind(_this);
    _this.resizeHandlerBound = _this.resizeHandler.bind(_this);
    return _this;
  }
  _inherits$1m(PopupMenu2, _React$Component);
  return _createClass$1u(PopupMenu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.popup = document.createElement("div");
      document.body.appendChild(this.popup);
      this.popup.style.zIndex = 99;
      this.popup.style.position = "absolute";
      this.popup.className = "hg-popup";
      document.addEventListener("click", this.clickHandlerBound, true);
      document.addEventListener("contextmenu", this.contextMenuHandlerBound, true);
      window.addEventListener("resize", this.resizeHandlerBound, true);
      this.forceUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.clickHandlerBound, true);
      document.removeEventListener("contextmenu", this.contextMenuHandlerBound, true);
      window.removeEventListener("resize", this.resizeHandlerBound, true);
      document.body.removeChild(this.popup);
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(event) {
      if (!this.popup.contains(event.target)) {
        if (this.props.onMenuClosed) this.props.onMenuClosed(event);
      }
    }
  }, {
    key: "contextMenuHandler",
    value: function contextMenuHandler(event) {
      if (event.altKey) return;
      event.preventDefault();
      this.clickHandler(event);
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      this.props.onMenuClosed(null);
    }
  }, {
    key: "render",
    value: function render3() {
      if (!this.popup) return null;
      return /* @__PURE__ */ ReactDOM.createPortal(this.props.children, this.popup);
    }
  }]);
})(React__default.Component);
PopupMenu.defaultProps = {
  onMenuClosed: intoTheVoid
};
PopupMenu.propTypes = {
  children: PropTypes.node.isRequired,
  onMenuClosed: PropTypes.func
};
function _classCallCheck$1t(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1l(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1l(o.key), o);
  }
}
function _createClass$1t(e, r2, t) {
  return r2 && _defineProperties$1l(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1l(t) {
  var i = _toPrimitive$1l(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1l(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let SearchField = /* @__PURE__ */ (function() {
  function SearchField2(chromInfo) {
    _classCallCheck$1t(this, SearchField2);
    this.chromInfo = chromInfo;
    this.chromInfoBisector = bisector((d) => d.pos).left;
  }
  return _createClass$1t(SearchField2, [{
    key: "scalesToPositionText",
    value: function scalesToPositionText(xScale, yScale, twoD = false) {
      if (this.chromInfo === null) {
        return "";
      }
      if (!xScale || !yScale) {
        return "";
      }
      const x12 = absToChr(xScale.domain()[0], this.chromInfo);
      const x2 = absToChr(xScale.domain()[1], this.chromInfo);
      const y12 = absToChr(yScale.domain()[0], this.chromInfo);
      const y2 = absToChr(yScale.domain()[1], this.chromInfo);
      let positionString = null;
      const stringFormat = format$1(",d");
      if (x12[0] !== x2[0]) {
        positionString = `${x12[0]}:${stringFormat(Math.floor(x12[1]))}-${x2[0]}:${stringFormat(Math.ceil(x2[1]))}`;
      } else {
        positionString = `${x12[0]}:${stringFormat(Math.floor(x12[1]))}-${stringFormat(Math.ceil(x2[1]))}`;
      }
      if (twoD) {
        if (y12[0] !== y2[0]) {
          positionString += ` & ${y12[0]}:${stringFormat(Math.floor(y12[1]))}-${y2[0]}:${stringFormat(Math.ceil(y2[1]))}`;
        } else {
          positionString += ` & ${y12[0]}:${stringFormat(Math.floor(y12[1]))}-${stringFormat(Math.ceil(y2[1]))}`;
        }
      }
      if (x12[2] <= 0 || x2[2] > 0 || twoD && (y12[2] <= 0 || y2[2] > 0)) {
        positionString += ` [offset ${x12[2]},${x2[2]}`;
        if (twoD) {
          positionString += `:${y12[2]},${y2[2]}`;
        }
        positionString += "]";
      }
      return positionString;
    }
  }, {
    key: "convertNumberNotation",
    value: function convertNumberNotation(numStr) {
      let newNumStr = numStr;
      if (!newNumStr.includes("M", newNumStr.length - 1) && !newNumStr.includes("K", newNumStr.length - 1)) {
        return newNumStr;
      }
      let numZerosToAdd = 0;
      let decPointPosFromEnd = 0;
      if (newNumStr.includes("M", newNumStr.length - 1)) {
        numZerosToAdd = 6;
        newNumStr = newNumStr.replace("M", "");
      } else {
        numZerosToAdd = 3;
        newNumStr = newNumStr.replace("K", "");
      }
      if (Number.isNaN(+newNumStr)) {
        return numStr;
      }
      newNumStr = (+newNumStr).toString();
      if (newNumStr.includes(".")) {
        decPointPosFromEnd = newNumStr.length - 1 - newNumStr.indexOf(".");
        newNumStr = (+newNumStr.replace(".", "")).toString();
      }
      const totalZerosToAdd = numZerosToAdd - decPointPosFromEnd;
      if (totalZerosToAdd < 0) {
        return numStr;
      }
      newNumStr += "0".repeat(totalZerosToAdd);
      return newNumStr;
    }
  }, {
    key: "parsePosition",
    value: function parsePosition(positionText, prevChr = null) {
      const positionParts = positionText.split(":");
      let chr = null;
      let pos = 0;
      if (positionParts.length > 1) {
        chr = positionParts[0];
        pos = +this.convertNumberNotation(positionParts[1].replace(/,/g, ""));
      } else if (positionParts[0] in this.chromInfo.chrPositions) {
        chr = positionParts[0];
        pos = 0;
        if (prevChr !== null) {
          pos = +this.chromInfo.chromLengths[chr];
        }
      } else {
        pos = +this.convertNumberNotation(positionParts[0].replace(/,/g, ""));
        chr = null;
        if (prevChr) chr = prevChr;
      }
      let retPos = null;
      if (chr === null) {
        chr = prevChr;
        retPos = pos;
      } else if (chr in this.chromInfo.chrPositions) {
        retPos = this.chromInfo.chrPositions[chr].pos + pos;
      }
      return [chr, pos, retPos];
    }
  }, {
    key: "matchRangesToLarger",
    value: function matchRangesToLarger(range1, range2) {
      if (range1[1] - range1[0] < range2[1] - range2[0]) {
        const toExpand2 = range2[1] - range2[0] - (range1[1] - range1[0]);
        return [[range1[0] - toExpand2 / 2, range1[1] + toExpand2 / 2], range2];
      }
      const toExpand = range1[1] - range1[0] - (range2[1] - range2[0]);
      return [range1, [range2[0] - toExpand / 2, range2[1] + toExpand / 2]];
    }
  }, {
    key: "getSearchRange",
    value: function getSearchRange(term) {
      if (term.length === 0) {
        return null;
      }
      let parts = term.split("-");
      parts = parts.filter((d) => d.length > 0);
      let range2 = null;
      if (parts[0].indexOf("-") === 0) {
        parts[0] = parts[0].slice(3, parts[0].length);
      }
      if (parts.length > 1) {
        let [chr1, chrPos1, genomePos1] = this.parsePosition(parts[0]);
        let [chr2, chrPos2, genomePos2] = this.parsePosition(parts[1], chr1);
        const tempRange1 = [genomePos1, genomePos2];
        [chr1, chrPos1, genomePos1] = this.parsePosition(parts[1]);
        [chr2, chrPos2, genomePos2] = this.parsePosition(parts[0], chr1);
        if (chr1 === null && chr2 !== null) {
          [chr1, chrPos1, genomePos1] = this.parsePosition(parts[1], chr2);
        }
        const tempRange2 = [genomePos1, genomePos2];
        if (tempRange2[1] - tempRange2[0] > tempRange1[1] - tempRange1[0]) return tempRange2;
        return tempRange1;
      }
      if (parts[0] in this.chromInfo.chrPositions) {
        const chromPosition = +this.chromInfo.chrPositions[parts[0]].pos;
        range2 = [chromPosition, chromPosition + +this.chromInfo.chromLengths[parts[0]]];
      } else {
        const [chr1, chrPos1, pos1] = this.parsePosition(parts[0]);
        range2 = [pos1 - 8e6, pos1 + 8e6];
      }
      if (range2[0] > range2[1]) {
        return [range2[1], range2[0]];
      }
      return range2;
    }
  }, {
    key: "parseOffset",
    value: function parseOffset(offsetText) {
      const parts = offsetText.split(":");
      if (parts.length === 0) {
        return [[0, 0], [0, 0]];
      }
      if (parts.length === 1) {
        const sparts = parts[0].split(",");
        return [[+sparts[0], +sparts[1]], [0, 0]];
      }
      const sparts0 = parts[0].split(",");
      const sparts1 = parts[1].split(",");
      return [[+sparts0[0], +sparts0[1]], [+sparts1[0], +sparts1[1]]];
    }
  }, {
    key: "searchPosition",
    value: function searchPosition(text2) {
      let range1 = null;
      let range2 = null;
      text2 = text2.trim();
      const offsetRe = /\[offset (.+?)\]/.exec(text2);
      let offset = [[0, 0], [0, 0]];
      if (offsetRe) {
        text2 = text2.replace(offsetRe[0], "");
        offset = this.parseOffset(offsetRe[1]);
      }
      const parts = text2.split(" & ");
      if (parts.length > 1) {
        range1 = this.getSearchRange(parts[0].split(" ")[0]);
        range2 = this.getSearchRange(parts[1].split(" ")[0]);
      } else {
        range1 = this.getSearchRange(parts[0]);
      }
      if (range1 !== null && range2 !== null) {
        [range1, range2] = this.matchRangesToLarger(range1, range2);
      }
      if (range1) {
        range1[0] += offset[0][0];
        range1[1] += offset[0][1];
      }
      if (range2) {
        range2[0] += offset[1][0];
        range2[1] += offset[1][1];
      }
      return [range1, range2];
    }
  }]);
})();
const {
  Provider: Provider$1,
  Consumer: Consumer$1
} = /* @__PURE__ */ React__default.createContext(fakePubSub);
function withPubSub(Component2) {
  return /* @__PURE__ */ React__default.forwardRef((props, ref2) => /* @__PURE__ */ React__default.createElement(Consumer$1, null, (pubSub) => /* @__PURE__ */ React__default.createElement(Component2, {
    ref: ref2,
    ...props,
    pubSub
  })));
}
const styles$5 = {
  "genome-position-search": "_genome-position-search_1l2sx_1",
  "genome-position-search-focus": "_genome-position-search-focus_1l2sx_2",
  "genome-position-search-bar": "_genome-position-search-bar_1l2sx_16",
  "genome-position-search-dark": "_genome-position-search-dark_1l2sx_34",
  "genome-position-search-bar-suggestions": "_genome-position-search-bar-suggestions_1l2sx_83"
};
function _classCallCheck$1s(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1k(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1k(o.key), o);
  }
}
function _createClass$1s(e, r2, t) {
  return r2 && _defineProperties$1k(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1k(t) {
  var i = _toPrimitive$1k(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1k(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1d(t, o, e) {
  return o = _getPrototypeOf$1d(o), _possibleConstructorReturn$1l(t, _isNativeReflectConstruct$1d() ? Reflect.construct(o, e || [], _getPrototypeOf$1d(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1l(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1d(t);
}
function _assertThisInitialized$1d(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1d() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1d = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1d(t) {
  return _getPrototypeOf$1d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1d(t);
}
function _inherits$1l(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1d(t, e);
}
function _setPrototypeOf$1d(t, e) {
  return _setPrototypeOf$1d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1d(t, e);
}
let GenomePositionSearchBox = /* @__PURE__ */ (function(_React$Component) {
  function GenomePositionSearchBox2(props) {
    var _this;
    _classCallCheck$1s(this, GenomePositionSearchBox2);
    _this = _callSuper$1d(this, GenomePositionSearchBox2, [props]);
    _this.mounted = false;
    _this.uid = slugid.nice();
    _this.chromInfo = null;
    _this.searchField = null;
    _this.autocompleteMenu = null;
    _this.xScale = null;
    _this.yScale = null;
    _this.prevParts = [];
    _this.props.registerViewportChangedListener(_this.scalesChanged.bind(_this));
    _this.menuPosition = {
      left: 0,
      top: 0
    };
    _this.currentChromInfoServer = _this.props.chromInfoServer;
    _this.currentChromInfoId = _this.props.chromInfoId;
    _this.positionText = props.error;
    _this.state = {
      value: _this.positionText,
      loading: false,
      menuPosition: [0, 0],
      genes: [],
      isFocused: false,
      menuOpened: false,
      availableAssemblies: [],
      selectedAssembly: null
    };
    _this.styles = {
      item: {
        padding: "2px 6px",
        cursor: "default"
      },
      highlightedItem: {
        color: "white",
        background: "hsl(200, 50%, 50%)",
        padding: "2px 6px",
        cursor: "default"
      },
      menu: {
        border: "solid 1px #ccc"
      }
    };
    return _this;
  }
  _inherits$1l(GenomePositionSearchBox2, _React$Component);
  return _createClass$1s(GenomePositionSearchBox2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      select(this.autocompleteMenu.inputEl).on("keypress", this.autocompleteKeyPress.bind(this));
      this.fetchChromInfo(this.props.chromInfoServer, this.props.chromInfoId);
      this.setPositionText();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.props.removeViewportChangedListener();
    }
    /**
     * The user has selected an assembly to use for the coordinate search box
     *
     * @param {string} chromInfoServer
     * @param {string} chromInfoId - The name of the chromosome info set to use
     *
     * @returns {void} Once the appropriate ChromInfo file is fetched, it is stored locally
     */
  }, {
    key: "fetchChromInfo",
    value: function fetchChromInfo(chromInfoServer, chromInfoId) {
      if (!chromInfoId) {
        this.positionText = "no chromosome track present";
        this.setState({
          value: this.positionText
        });
        return;
      }
      if (!this.mounted)
        return;
      this.setState({
        autocompleteServer: chromInfoServer
      });
      ChromosomeInfo(`${chromInfoServer}/chrom-sizes/?id=${chromInfoId}`, (newChromInfo) => {
        this.chromInfo = newChromInfo;
        this.searchField = new SearchField(this.chromInfo);
        this.setPositionText();
      });
    }
  }, {
    key: "scalesChanged",
    value: function scalesChanged(xScale, yScale) {
      this.xScale = xScale;
      this.yScale = yScale;
      this.setPositionText();
    }
  }, {
    key: "setPositionText",
    value: function setPositionText() {
      if (!this.mounted) {
        return;
      }
      if (!this.searchField) {
        return;
      }
      const positionString = this.searchField.scalesToPositionText(this.xScale, this.yScale, this.props.twoD);
      this.prevParts = positionString.split(/[ -]/);
      if (this.gpsbForm) {
        this.positionText = positionString;
        this.autocompleteMenu.inputEl.value = positionString;
      }
    }
  }, {
    key: "autocompleteKeyPress",
    value: function autocompleteKeyPress(event) {
      const ENTER_KEY_CODE = 13;
      if (event.keyCode === ENTER_KEY_CODE) {
        this.buttonClick();
      }
    }
  }, {
    key: "replaceGenesWithLoadedPositions",
    value: function replaceGenesWithLoadedPositions(genePositions) {
      const origSearchText = this.positionText;
      const spaceParts = origSearchText.split(" ");
      let foundGeneSymbol = false;
      for (let i = 0; i < spaceParts.length; i++) {
        const dashParts = spaceParts[i].split("-");
        let j = 0;
        let k = 0;
        let spacePart = "";
        while (j < dashParts.length) {
          k = dashParts.length;
          while (k > j) {
            const dashChunk = dashParts.slice(j, k).join("-");
            if (genePositions[dashChunk.toLowerCase()]) {
              const genePosition = genePositions[dashChunk.toLowerCase()];
              const extension = Math.floor((genePosition.txEnd - genePosition.txStart) / 4);
              if (j === 0 && k < dashParts.length) {
                spacePart = `${genePosition.chr}:${genePosition.txStart - extension}`;
              } else if (j === 0 && k === dashParts.length) {
                spacePart = `${genePosition.chr}:${genePosition.txStart - extension}-${genePosition.txEnd + extension}`;
              } else {
                spacePart += `- ${genePosition.chr}:${genePosition.txEnd + extension}`;
              }
              foundGeneSymbol = true;
              break;
            }
            if (k === j + 1) {
              if (spacePart.length) {
                spacePart += "-";
              }
              spacePart += dashChunk;
            }
            k -= 1;
          }
          j = k + 1;
        }
        spaceParts[i] = spacePart;
      }
      const newValue = spaceParts.join(" ");
      this.prevParts = newValue.split(/[ -]/);
      this.positionText = newValue;
      this.setState({
        value: newValue
      });
      return foundGeneSymbol ? origSearchText : null;
    }
  }, {
    key: "replaceGenesWithPositions",
    value: function replaceGenesWithPositions(finished) {
      const valueParts = this.positionText.split(/[ -]/);
      let q2 = queue();
      for (let i = 0; i < valueParts.length; i++) {
        if (valueParts[i].length === 0) {
          continue;
        }
        const [, , retPos] = this.searchField.parsePosition(valueParts[i]);
        if (retPos == null || Number.isNaN(retPos)) {
          const url = `${this.props.autocompleteServer}/suggest/?d=${this.props.autocompleteId}&ac=${valueParts[i].toLowerCase()}`;
          const fetchJson = (callback) => {
            api.json(url, callback, this.props.pubSub);
          };
          q2 = q2.defer(fetchJson);
        }
      }
      q2.awaitAll((error, files) => {
        if (files) {
          const genePositions = {};
          for (let i = 0; i < files.length; i++) {
            if (!files[i][0]) {
              continue;
            }
            for (let j = 0; j < files[i].length; j++) {
              genePositions[files[i][j].geneName.toLowerCase()] = files[i][j];
            }
          }
          this.replaceGenesWithLoadedPositions(genePositions);
          finished();
        }
      });
    }
  }, {
    key: "buttonClick",
    value: function buttonClick() {
      this.setState({
        genes: []
      });
      this.replaceGenesWithPositions(() => {
        const searchFieldValue = this.positionText;
        if (this.searchField != null) {
          let [range1, range2] = this.searchField.searchPosition(searchFieldValue);
          if (range1 && (Number.isNaN(range1[0]) || Number.isNaN(range1[1])) || range2 && (Number.isNaN(range2[0]) || Number.isNaN(range2[1]))) {
            return;
          }
          if (!range2) {
            range2 = range1;
          }
          const newXScale = this.xScale.copy();
          const newYScale = this.yScale.copy();
          if (range1) {
            newXScale.domain(range1);
            newYScale.domain(range1);
          }
          const [centerX, centerY, k] = scalesCenterAndK(newXScale, newYScale);
          this.props.setCenters(centerX, centerY, k, ZOOM_TRANSITION_DURATION);
        }
      });
    }
  }, {
    key: "searchFieldSubmit",
    value: function searchFieldSubmit() {
      this.buttonClick();
    }
  }, {
    key: "pathJoin",
    value: function pathJoin(parts, sep) {
      const separator = sep || "/";
      const replace = new RegExp(`${separator}{1,}`, "g");
      return parts.join(separator).replace(replace, separator);
    }
  }, {
    key: "onAutocompleteChange",
    value: function onAutocompleteChange(event, value) {
      this.positionText = value;
      this.setState({
        value,
        loading: true
      });
      const parts = value.split(/[ -]/);
      this.changedPart = null;
      for (let i = 0; i < parts.length; i++) {
        if (i === this.prevParts.length) {
          this.changedPart = i;
          break;
        }
        if (parts[i] !== this.prevParts[i]) {
          this.changedPart = i;
          break;
        }
      }
      this.prevParts = parts;
      if (!(this.props.autocompleteServer && this.props.autocompleteId)) {
        return;
      }
      if (this.changedPart != null) {
        this.setState({
          loading: true
        });
        const url = `${this.props.autocompleteServer}/suggest/?d=${this.props.autocompleteId}&ac=${parts[this.changedPart].toLowerCase()}`;
        api.json(url, (error, data2) => {
          if (error) {
            this.setState({
              loading: false,
              genes: []
            });
            return;
          }
          this.setState({
            loading: false,
            genes: data2
          });
        }, this.props.pubSub);
      }
    }
  }, {
    key: "geneSelected",
    value: function geneSelected(value, objct) {
      const parts = this.positionText.split(" ");
      let partCount = this.changedPart;
      for (let i = 0; i < parts.length; i++) {
        const dashParts = parts[i].split("-");
        if (partCount > dashParts.length - 1) {
          partCount -= dashParts.length;
        } else {
          dashParts[partCount] = objct.geneName;
          parts[i] = dashParts.join("-");
          break;
        }
      }
      this.prevParts = parts.join(" ").split(/[ -]/);
      this.positionText = parts.join(" ");
      this.setState({
        value: parts.join(" "),
        genes: []
      });
    }
  }, {
    key: "handleMenuVisibilityChange",
    value: function handleMenuVisibilityChange(isOpen, inputEl) {
      const box = inputEl.getBoundingClientRect();
      this.menuPosition = {
        left: box.left,
        top: box.top + box.height
      };
      this.setState({
        menuOpened: isOpen
      });
    }
  }, {
    key: "handleRenderMenu",
    value: function handleRenderMenu(items2) {
      return /* @__PURE__ */ React__default.createElement(PopupMenu, null, /* @__PURE__ */ React__default.createElement("div", {
        style: {
          left: this.menuPosition.left,
          top: this.menuPosition.top
        },
        className: styles$5["genome-position-search-bar-suggestions"]
      }, items2));
    }
  }, {
    key: "handleAssemblySelect",
    value: function handleAssemblySelect(evt) {
      this.fetchChromInfo(evt);
      this.setState({
        selectedAssembly: evt
      });
    }
  }, {
    key: "focusHandler",
    value: function focusHandler(isFocused) {
      this.setState({
        isFocused
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.chromInfoId !== this.currentChromInfoId || nextProps.chromInfoServer !== this.currentChromInfoServer) {
        this.currentChromInfoId = nextProps.chromInfoId;
        this.currentChromInfoServer = nextProps.chromInfoServer;
        this.fetchChromInfo(nextProps.chromInfoServer, nextProps.chromInfoId);
      }
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.gpsbForm = c;
        },
        className: clsx$2({
          [styles$5["genome-position-search-focus"]]: this.state.isFocused,
          [styles$5["genome-position-search"]]: !this.state.isFocused,
          [styles$5["genome-position-search-dark"]]: this.props.theme === THEME_DARK
        })
      }, /* @__PURE__ */ React__default.createElement(Autocomplete, {
        ref: (c) => {
          this.autocompleteMenu = c;
        },
        getItemValue: (item) => item.geneName,
        inputProps: {
          className: styles$5["genome-position-search-bar"]
        },
        items: this.state.genes,
        menuStyle: {
          position: "absolute",
          left: this.menuPosition.left,
          top: this.menuPosition.top,
          border: "1px solid black"
        },
        onChange: this.onAutocompleteChange.bind(this),
        onFocus: this.focusHandler.bind(this),
        onMenuVisibilityChange: this.handleMenuVisibilityChange.bind(this),
        onSelect: (value, objct) => this.geneSelected(value, objct),
        onSubmit: this.searchFieldSubmit.bind(this),
        renderItem: (item, isHighlighted) => /* @__PURE__ */ React__default.createElement("div", {
          key: item.geneName,
          id: item.geneName,
          style: isHighlighted ? this.styles.highlightedItem : this.styles.item
        }, item.geneName),
        renderMenu: this.handleRenderMenu.bind(this),
        value: this.props.error || this.positionText,
        wrapperStyle: {
          width: "100%"
        }
      }), /* @__PURE__ */ React__default.createElement(SearchIcon, {
        onClick: this.buttonClick.bind(this),
        theStyle: "multitrack-header-icon"
      }));
    }
  }]);
})(React__default.Component);
GenomePositionSearchBox.propTypes = {
  autocompleteId: PropTypes.string,
  autocompleteServer: PropTypes.string,
  chromInfoId: PropTypes.string,
  chromInfoServer: PropTypes.string,
  isFocused: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelectedAssemblyChanged: PropTypes.func,
  registerViewportChangedListener: PropTypes.func,
  removeViewportChangedListener: PropTypes.func,
  setCenters: PropTypes.func,
  theme: PropTypes.string,
  trackSourceServers: PropTypes.array,
  twoD: PropTypes.bool
};
const GenomePositionSearchBox$1 = withPubSub(GenomePositionSearchBox);
var frame = 0, timeout$1 = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
  setTimeout(f2, 17);
};
function now$1() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time2) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time2 = (time2 == null ? now$1() : +time2) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time2;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer(callback, delay, time2) {
  var t = new Timer();
  t.restart(callback, delay, time2);
  return t;
}
function timerFlush() {
  now$1();
  ++frame;
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t02, t12 = taskHead, t22, time2 = Infinity;
  while (t12) {
    if (t12._call) {
      if (time2 > t12._time) time2 = t12._time;
      t02 = t12, t12 = t12._next;
    } else {
      t22 = t12._next, t12._next = null;
      t12 = t02 ? t02._next = t22 : taskHead = t22;
    }
  }
  taskTail = t02;
  sleep(time2);
}
function sleep(time2) {
  if (frame) return;
  if (timeout$1) timeout$1 = clearTimeout(timeout$1);
  var delay = time2 - clockNow;
  if (delay > 24) {
    if (time2 < Infinity) timeout$1 = setTimeout(wake, time2 - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
function timeout(callback, delay, time2) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart((elapsed) => {
    t.stop();
    callback(elapsed + delay);
  }, delay, time2);
  return t;
}
var emptyOn = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function schedule(node2, name, id2, index2, group2, timing) {
  var schedules = node2.__transition;
  if (!schedules) node2.__transition = {};
  else if (id2 in schedules) return;
  create(node2, id2, {
    name,
    index: index2,
    // For context during callback.
    group: group2,
    // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}
function init(node2, id2) {
  var schedule2 = get$4(node2, id2);
  if (schedule2.state > CREATED) throw new Error("too late; already scheduled");
  return schedule2;
}
function set$2(node2, id2) {
  var schedule2 = get$4(node2, id2);
  if (schedule2.state > STARTED) throw new Error("too late; already running");
  return schedule2;
}
function get$4(node2, id2) {
  var schedule2 = node2.__transition;
  if (!schedule2 || !(schedule2 = schedule2[id2])) throw new Error("transition not found");
  return schedule2;
}
function create(node2, id2, self2) {
  var schedules = node2.__transition, tween;
  schedules[id2] = self2;
  self2.timer = timer(schedule2, 0, self2.time);
  function schedule2(elapsed) {
    self2.state = SCHEDULED;
    self2.timer.restart(start2, self2.delay, self2.time);
    if (self2.delay <= elapsed) start2(elapsed - self2.delay);
  }
  function start2(elapsed) {
    var i, j, n, o;
    if (self2.state !== SCHEDULED) return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self2.name) continue;
      if (o.state === STARTED) return timeout(start2);
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout(function() {
      if (self2.state === STARTED) {
        self2.state = RUNNING;
        self2.timer.restart(tick, self2.delay, self2.time);
        tick(elapsed);
      }
    });
    self2.state = STARTING;
    self2.on.call("start", node2, node2.__data__, self2.index, self2.group);
    if (self2.state !== STARTING) return;
    self2.state = STARTED;
    tween = new Array(n = self2.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self2.tween[i].value.call(node2, node2.__data__, self2.index, self2.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t = elapsed < self2.duration ? self2.ease.call(null, elapsed / self2.duration) : (self2.timer.restart(stop), self2.state = ENDING, 1), i = -1, n = tween.length;
    while (++i < n) {
      tween[i].call(node2, t);
    }
    if (self2.state === ENDING) {
      self2.on.call("end", node2, node2.__data__, self2.index, self2.group);
      stop();
    }
  }
  function stop() {
    self2.state = ENDED;
    self2.timer.stop();
    delete schedules[id2];
    for (var i in schedules) return;
    delete node2.__transition;
  }
}
function interrupt(node2, name) {
  var schedules = node2.__transition, schedule2, active2, empty2 = true, i;
  if (!schedules) return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule2 = schedules[i]).name !== name) {
      empty2 = false;
      continue;
    }
    active2 = schedule2.state > STARTING && schedule2.state < ENDING;
    schedule2.state = ENDED;
    schedule2.timer.stop();
    schedule2.on.call(active2 ? "interrupt" : "cancel", node2, node2.__data__, schedule2.index, schedule2.group);
    delete schedules[i];
  }
  if (empty2) delete node2.__transition;
}
function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}
function tweenRemove(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule2 = set$2(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule2.tween = tween1;
  };
}
function tweenFunction(id2, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error();
  return function() {
    var schedule2 = set$2(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {
        name,
        value
      }, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }
    schedule2.tween = tween1;
  };
}
function transition_tween(name, value) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get$4(this.node(), id2).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }
  return this.each((value == null ? tweenRemove : tweenFunction)(id2, name, value));
}
function tweenValue(transition2, name, value) {
  var id2 = transition2._id;
  transition2.each(function() {
    var schedule2 = set$2(this, id2);
    (schedule2.value || (schedule2.value = {}))[name] = value.apply(this, arguments);
  });
  return function(node2) {
    return get$4(node2, id2).value[name];
  };
}
function interpolate$1(a, b) {
  var c;
  return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
}
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrConstantNS(fullname, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrFunction(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function attrFunctionNS(fullname, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}
function attrInterpolate(name, i) {
  return function(t) {
    this.setAttribute(name, i.call(this, t));
  };
}
function attrInterpolateNS(fullname, i) {
  return function(t) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
  };
}
function attrTweenNS(fullname, value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t02 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function attrTween(name, value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t02 = (i0 = i) && attrInterpolate(name, i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}
function delayFunction(id2, value) {
  return function() {
    init(this, id2).delay = +value.apply(this, arguments);
  };
}
function delayConstant(id2, value) {
  return value = +value, function() {
    init(this, id2).delay = value;
  };
}
function transition_delay(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id2, value)) : get$4(this.node(), id2).delay;
}
function durationFunction(id2, value) {
  return function() {
    set$2(this, id2).duration = +value.apply(this, arguments);
  };
}
function durationConstant(id2, value) {
  return value = +value, function() {
    set$2(this, id2).duration = value;
  };
}
function transition_duration(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id2, value)) : get$4(this.node(), id2).duration;
}
function easeConstant(id2, value) {
  if (typeof value !== "function") throw new Error();
  return function() {
    set$2(this, id2).ease = value;
  };
}
function transition_ease(value) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant(id2, value)) : get$4(this.node(), id2).ease;
}
function easeVarying(id2, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (typeof v !== "function") throw new Error();
    set$2(this, id2).ease = v;
  };
}
function transition_easeVarying(value) {
  if (typeof value !== "function") throw new Error();
  return this.each(easeVarying(this._id, value));
}
function transition_filter(match) {
  if (typeof match !== "function") match = matcher(match);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && match.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Transition(subgroups, this._parents, this._name, this._id);
}
function transition_merge(transition2) {
  if (transition2._id !== this._id) throw new Error();
  for (var groups0 = this._groups, groups1 = transition2._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge2 = merges[j] = new Array(n), node2, i = 0; i < n; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition(merges, this._parents, this._name, this._id);
}
function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}
function onFunction(id2, name, listener) {
  var on0, on1, sit = start(name) ? init : set$2;
  return function() {
    var schedule2 = sit(this, id2), on = schedule2.on;
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
    schedule2.on = on1;
  };
}
function transition_on(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get$4(this.node(), id2).on.on(name) : this.each(onFunction(id2, name, listener));
}
function removeFunction(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id2) return;
    if (parent) parent.removeChild(this);
  };
}
function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}
function transition_select(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function") select2 = selector(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, subgroup = subgroups[j] = new Array(n), node2, subnode, i = 0; i < n; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2) subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id2, i, subgroup, get$4(node2, id2));
      }
    }
  }
  return new Transition(subgroups, this._parents, name, id2);
}
function transition_selectAll(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function") select2 = selectorAll(select2);
  for (var groups2 = this._groups, m = groups2.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        for (var children2 = select2.call(node2, node2.__data__, i, group2), child, inherit2 = get$4(node2, id2), k = 0, l = children2.length; k < l; ++k) {
          if (child = children2[k]) {
            schedule(child, name, id2, k, children2, inherit2);
          }
        }
        subgroups.push(children2);
        parents.push(node2);
      }
    }
  }
  return new Transition(subgroups, parents, name, id2);
}
var Selection = selection.prototype.constructor;
function transition_selection() {
  return new Selection(this._groups, this._parents);
}
function styleNull(name, interpolate2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, string10 = string1);
  };
}
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function styleFunction(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
    if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function styleMaybeRemove(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove2;
  return function() {
    var schedule2 = set$2(this, id2), on = schedule2.on, listener = schedule2.value[key] == null ? remove2 || (remove2 = styleRemove(name)) : void 0;
    if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule2.on = on1;
  };
}
function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
  return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
}
function styleInterpolate(name, i, priority) {
  return function(t) {
    this.style.setProperty(name, i.call(this, t), priority);
  };
}
function styleTween(name, value, priority) {
  var t, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
    return t;
  }
  tween._value = value;
  return tween;
}
function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function transition_text(value) {
  return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
}
function textInterpolate(i) {
  return function(t) {
    this.textContent = i.call(this, t);
  };
}
function textTween(value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0) t02 = (i0 = i) && textInterpolate(i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error();
  return this.tween(key, textTween(value));
}
function transition_transition() {
  var name = this._name, id0 = this._id, id1 = newId();
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        var inherit2 = get$4(node2, id0);
        schedule(node2, name, id1, i, group2, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition(groups2, this._parents, name, id1);
}
function transition_end() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = {
      value: reject
    }, end2 = {
      value: function() {
        if (--size === 0) resolve();
      }
    };
    that.each(function() {
      var schedule2 = set$2(this, id2), on = schedule2.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end2);
      }
      schedule2.on = on1;
    });
    if (size === 0) resolve();
  });
}
var id = 0;
function Transition(groups2, parents, name, id2) {
  this._groups = groups2;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function newId() {
  return ++id;
}
var selection_prototype = selection.prototype;
Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};
function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var defaultTiming = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};
function inherit(node2, id2) {
  var timing;
  while (!(timing = node2.__transition) || !(timing = timing[id2])) {
    if (!(node2 = node2.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function selection_transition(name) {
  var id2, timing;
  if (name instanceof Transition) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId(), (timing = defaultTiming).time = now$1(), name = name == null ? null : name + "";
  }
  for (var groups2 = this._groups, m = groups2.length, j = 0; j < m; ++j) {
    for (var group2 = groups2[j], n = group2.length, node2, i = 0; i < n; ++i) {
      if (node2 = group2[i]) {
        schedule(node2, name, id2, i, group2, timing || inherit(node2, id2));
      }
    }
  }
  return new Transition(groups2, this._parents, name, id2);
}
selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;
const constant$2 = (x) => () => x;
function BrushEvent(type2, {
  sourceEvent: sourceEvent2,
  target: target2,
  selection: selection2,
  mode,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: {
      value: type2,
      enumerable: true,
      configurable: true
    },
    sourceEvent: {
      value: sourceEvent2,
      enumerable: true,
      configurable: true
    },
    target: {
      value: target2,
      enumerable: true,
      configurable: true
    },
    selection: {
      value: selection2,
      enumerable: true,
      configurable: true
    },
    mode: {
      value: mode,
      enumerable: true,
      configurable: true
    },
    _: {
      value: dispatch2
    }
  });
}
function nopropagation(event) {
  event.stopImmediatePropagation();
}
function noevent(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
var MODE_DRAG = {
  name: "drag"
}, MODE_SPACE = {
  name: "space"
}, MODE_HANDLE = {
  name: "handle"
}, MODE_CENTER = {
  name: "center"
};
const {
  abs: abs$1,
  max,
  min
} = Math;
function number1(e) {
  return [+e[0], +e[1]];
}
function number2(e) {
  return [number1(e[0]), number1(e[1])];
}
var X = {
  name: "x",
  handles: ["w", "e"].map(type$4),
  input: function(x, e) {
    return x == null ? null : [[+x[0], e[0][1]], [+x[1], e[1][1]]];
  },
  output: function(xy) {
    return xy && [xy[0][0], xy[1][0]];
  }
};
var Y = {
  name: "y",
  handles: ["n", "s"].map(type$4),
  input: function(y, e) {
    return y == null ? null : [[e[0][0], +y[0]], [e[1][0], +y[1]]];
  },
  output: function(xy) {
    return xy && [xy[0][1], xy[1][1]];
  }
};
var XY = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type$4),
  input: function(xy) {
    return xy == null ? null : number2(xy);
  },
  output: function(xy) {
    return xy;
  }
};
var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};
var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};
var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};
var signsX = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
};
var signsY = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function type$4(t) {
  return {
    type: t
  };
}
function defaultFilter(event) {
  return !event.ctrlKey && !event.button;
}
function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  if (svg.hasAttribute("viewBox")) {
    svg = svg.viewBox.baseVal;
    return [[svg.x, svg.y], [svg.x + svg.width, svg.y + svg.height]];
  }
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}
function defaultTouchable() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function local(node2) {
  while (!node2.__brush) if (!(node2 = node2.parentNode)) return;
  return node2.__brush;
}
function empty(extent2) {
  return extent2[0][0] === extent2[1][0] || extent2[0][1] === extent2[1][1];
}
function brushSelection(node2) {
  var state = node2.__brush;
  return state ? state.dim.output(state.selection) : null;
}
function brushX() {
  return brush$1(X);
}
function brushY() {
  return brush$1(Y);
}
function brush() {
  return brush$1(XY);
}
function brush$1(dim) {
  var extent2 = defaultExtent, filter2 = defaultFilter, touchable = defaultTouchable, keys2 = true, listeners = dispatch$1("start", "brush", "end"), handleSize = 6, touchending;
  function brush2(group2) {
    var overlay = group2.property("__brush", initialize).selectAll(".overlay").data([type$4("overlay")]);
    overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
      var extent3 = local(this).extent;
      select(this).attr("x", extent3[0][0]).attr("y", extent3[0][1]).attr("width", extent3[1][0] - extent3[0][0]).attr("height", extent3[1][1] - extent3[0][1]);
    });
    group2.selectAll(".selection").data([type$4("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var handle = group2.selectAll(".handle").data(dim.handles, function(d) {
      return d.type;
    });
    handle.exit().remove();
    handle.enter().append("rect").attr("class", function(d) {
      return "handle handle--" + d.type;
    }).attr("cursor", function(d) {
      return cursors[d.type];
    });
    group2.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  brush2.move = function(group2, selection2) {
    if (group2.tween) {
      group2.on("start.brush", function(event) {
        emitter(this, arguments).beforestart().start(event);
      }).on("interrupt.brush end.brush", function(event) {
        emitter(this, arguments).end(event);
      }).tween("brush", function() {
        var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(this, arguments) : selection2, state.extent), i = interpolate$3(selection0, selection1);
        function tween(t) {
          state.selection = t === 1 && selection1 === null ? null : i(t);
          redraw.call(that);
          emit.brush();
        }
        return selection0 !== null && selection1 !== null ? tween : tween(1);
      });
    } else {
      group2.each(function() {
        var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(that, args) : selection2, state.extent), emit = emitter(that, args).beforestart();
        interrupt(that);
        state.selection = selection1 === null ? null : selection1;
        redraw.call(that);
        emit.start().brush().end();
      });
    }
  };
  brush2.clear = function(group2) {
    brush2.move(group2, null);
  };
  function redraw() {
    var group2 = select(this), selection2 = local(this).selection;
    if (selection2) {
      group2.selectAll(".selection").style("display", null).attr("x", selection2[0][0]).attr("y", selection2[0][1]).attr("width", selection2[1][0] - selection2[0][0]).attr("height", selection2[1][1] - selection2[0][1]);
      group2.selectAll(".handle").style("display", null).attr("x", function(d) {
        return d.type[d.type.length - 1] === "e" ? selection2[1][0] - handleSize / 2 : selection2[0][0] - handleSize / 2;
      }).attr("y", function(d) {
        return d.type[0] === "s" ? selection2[1][1] - handleSize / 2 : selection2[0][1] - handleSize / 2;
      }).attr("width", function(d) {
        return d.type === "n" || d.type === "s" ? selection2[1][0] - selection2[0][0] + handleSize : handleSize;
      }).attr("height", function(d) {
        return d.type === "e" || d.type === "w" ? selection2[1][1] - selection2[0][1] + handleSize : handleSize;
      });
    } else {
      group2.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
  }
  function emitter(that, args, clean) {
    var emit = that.__brush.emitter;
    return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
  }
  function Emitter(that, args, clean) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
    this.clean = clean;
  }
  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function(event, mode) {
      if (this.starting) this.starting = false, this.emit("start", event, mode);
      else this.emit("brush", event);
      return this;
    },
    brush: function(event, mode) {
      this.emit("brush", event, mode);
      return this;
    },
    end: function(event, mode) {
      if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
      return this;
    },
    emit: function(type2, event, mode) {
      var d = select(this.that).datum();
      listeners.call(type2, this.that, new BrushEvent(type2, {
        sourceEvent: event,
        target: brush2,
        selection: dim.output(this.state.selection),
        mode,
        dispatch: listeners
      }), d);
    }
  };
  function started(event) {
    if (touchending && !event.touches) return;
    if (!filter2.apply(this, arguments)) return;
    var that = this, type2 = event.target.__data__.type, mode = (keys2 && event.metaKey ? type2 = "overlay" : type2) === "selection" ? MODE_DRAG : keys2 && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type2], signY = dim === X ? null : signsY[type2], state = local(that), extent3 = state.extent, selection2 = state.selection, W = extent3[0][0], w0, w1, N = extent3[0][1], n0, n1, E2 = extent3[1][0], e0, e1, S = extent3[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys2 && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [event], (t) => {
      const i = t.identifier;
      t = pointer(t, that);
      t.point0 = t.slice();
      t.identifier = i;
      return t;
    });
    if (type2 === "overlay") {
      if (selection2) moving = true;
      const pts = [points[0], points[1] || points[0]];
      state.selection = selection2 = [[w0 = dim === Y ? W : min(pts[0][0], pts[1][0]), n0 = dim === X ? N : min(pts[0][1], pts[1][1])], [e0 = dim === Y ? E2 : max(pts[0][0], pts[1][0]), s0 = dim === X ? S : max(pts[0][1], pts[1][1])]];
      if (points.length > 1) move();
    } else {
      w0 = selection2[0][0];
      n0 = selection2[0][1];
      e0 = selection2[1][0];
      s0 = selection2[1][1];
    }
    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;
    var group2 = select(that).attr("pointer-events", "none");
    var overlay = group2.selectAll(".overlay").attr("cursor", cursors[type2]);
    interrupt(that);
    var emit = emitter(that, arguments, true).beforestart();
    if (event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
      if (keys2) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
      dragDisable(event.view);
    }
    redraw.call(that);
    emit.start(event, mode.name);
    function moved(event2) {
      for (const p of event2.changedTouches || [event2]) {
        for (const d of points) if (d.identifier === p.identifier) d.cur = pointer(p, that);
      }
      if (shifting && !lockX && !lockY && points.length === 1) {
        const point2 = points[0];
        if (abs$1(point2.cur[0] - point2[0]) > abs$1(point2.cur[1] - point2[1])) lockY = true;
        else lockX = true;
      }
      for (const point2 of points) if (point2.cur) point2[0] = point2.cur[0], point2[1] = point2.cur[1];
      moving = true;
      noevent(event2);
      move(event2);
    }
    function move(event2) {
      const point2 = points[0], point0 = point2.point0;
      var t;
      dx = point2[0] - point0[0];
      dy = point2[1] - point0[1];
      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = max(W - w0, min(E2 - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (points[1]) {
            if (signX) w1 = max(W, min(E2, points[0][0])), e1 = max(W, min(E2, points[1][0])), signX = 1;
            if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
          } else {
            if (signX < 0) dx = max(W - w0, min(E2 - w0, dx)), w1 = w0 + dx, e1 = e0;
            else if (signX > 0) dx = max(W - e0, min(E2 - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
            else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          }
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = max(W, min(E2, w0 - dx * signX)), e1 = max(W, min(E2, e0 + dx * signX));
          if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
          break;
        }
      }
      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type2 in flipX) overlay.attr("cursor", cursors[type2 = flipX[type2]]);
      }
      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type2 in flipY) overlay.attr("cursor", cursors[type2 = flipY[type2]]);
      }
      if (state.selection) selection2 = state.selection;
      if (lockX) w1 = selection2[0][0], e1 = selection2[1][0];
      if (lockY) n1 = selection2[0][1], s1 = selection2[1][1];
      if (selection2[0][0] !== w1 || selection2[0][1] !== n1 || selection2[1][0] !== e1 || selection2[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush(event2, mode.name);
      }
    }
    function ended(event2) {
      nopropagation(event2);
      if (event2.touches) {
        if (event2.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
          touchending = null;
        }, 500);
      } else {
        yesdrag(event2.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group2.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection2 = state.selection;
      if (empty(selection2)) state.selection = null, redraw.call(that);
      emit.end(event2, mode.name);
    }
    function keydowned(event2) {
      switch (event2.keyCode) {
        case 16: {
          shifting = signX && signY;
          break;
        }
        case 18: {
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: {
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx;
            else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy;
            else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default:
          return;
      }
      noevent(event2);
    }
    function keyupped(event2) {
      switch (event2.keyCode) {
        case 16: {
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: {
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1;
            else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1;
            else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: {
          if (mode === MODE_SPACE) {
            if (event2.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1;
              else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1;
              else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type2]);
            move();
          }
          break;
        }
        default:
          return;
      }
      noevent(event2);
    }
  }
  function touchmoved(event) {
    emitter(this, arguments).moved(event);
  }
  function touchended(event) {
    emitter(this, arguments).ended(event);
  }
  function initialize() {
    var state = this.__brush || {
      selection: null
    };
    state.extent = number2(extent2.apply(this, arguments));
    state.dim = dim;
    return state;
  }
  brush2.extent = function(_) {
    return arguments.length ? (extent2 = typeof _ === "function" ? _ : constant$2(number2(_)), brush2) : extent2;
  };
  brush2.filter = function(_) {
    return arguments.length ? (filter2 = typeof _ === "function" ? _ : constant$2(!!_), brush2) : filter2;
  };
  brush2.touchable = function(_) {
    return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$2(!!_), brush2) : touchable;
  };
  brush2.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush2) : handleSize;
  };
  brush2.keyModifiers = function(_) {
    return arguments.length ? (keys2 = !!_, brush2) : keys2;
  };
  brush2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush2 : value;
  };
  return brush2;
}
const d3Brush = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  brush,
  brushSelection,
  brushX,
  brushY
}, Symbol.toStringTag, { value: "Module" }));
function _classCallCheck$1r(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1j(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1j(o.key), o);
  }
}
function _createClass$1r(e, r2, t) {
  return r2 && _defineProperties$1j(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1j(t) {
  var i = _toPrimitive$1j(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1j(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1c(t, o, e) {
  return o = _getPrototypeOf$1c(o), _possibleConstructorReturn$1k(t, _isNativeReflectConstruct$1c() ? Reflect.construct(o, e || [], _getPrototypeOf$1c(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1k(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1c(t);
}
function _assertThisInitialized$1c(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1c() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1c = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1c(t) {
  return _getPrototypeOf$1c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1c(t);
}
function _inherits$1k(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1c(t, e);
}
function _setPrototypeOf$1c(t, e) {
  return _setPrototypeOf$1c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1c(t, e);
}
let PlotTypeChooser = /* @__PURE__ */ (function(_React$Component) {
  function PlotTypeChooser2(props) {
    var _this;
    _classCallCheck$1r(this, PlotTypeChooser2);
    _this = _callSuper$1c(this, PlotTypeChooser2, [props]);
    _this.DATATYPE_TO_TRACK_TYPE = DATATYPE_TO_TRACK_TYPE(_this.props.orientation);
    _this.AVAILABLE_TRACK_TYPES = AVAILABLE_TRACK_TYPES(_this.props.datatypes, _this.props.orientation);
    _this.state = {
      selectedPlotType: _this.AVAILABLE_TRACK_TYPES[0]
    };
    return _this;
  }
  _inherits$1k(PlotTypeChooser2, _React$Component);
  return _createClass$1r(PlotTypeChooser2, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.AVAILABLE_TRACK_TYPES = AVAILABLE_TRACK_TYPES(newProps.datatypes, this.props.orientation);
      if (!this.AVAILABLE_TRACK_TYPES) {
        return;
      }
      if (!newProps.allTracksSameDatatype) {
        return;
      }
      if (this.AVAILABLE_TRACK_TYPES.length > 0) {
        if (!this.AVAILABLE_TRACK_TYPES.includes(this.state.selectedPlotType)) {
          const defaultTrackType = getDefaultTrackForDatatype(newProps.datatypes[0][0], this.props.position, this.AVAILABLE_TRACK_TYPES);
          this.handlePlotTypeSelected(defaultTrackType);
        }
      }
    }
  }, {
    key: "handlePlotTypeSelected",
    value: function handlePlotTypeSelected(key) {
      this.setState({
        selectedPlotType: key
      });
      this.props.onPlotTypeSelected(key.type);
    }
  }, {
    key: "render",
    value: function render3() {
      let AVAILABLE_TRACK_TYPES_LIST = "No plot types available for track";
      const trackTypeToInfo = {};
      TRACKS_INFO.forEach((ti) => {
        trackTypeToInfo[ti.type] = ti;
      });
      if (this.AVAILABLE_TRACK_TYPES) {
        AVAILABLE_TRACK_TYPES_LIST = this.AVAILABLE_TRACK_TYPES.sort((a, b) => a.type < b.type).map((x) => {
          const thumbnail = trackTypeToInfo[x.type].thumbnail;
          const plotTypeClass = this.state.selectedPlotType.type === x.type ? "plot-type-item plot-type-selected" : "plot-type-item";
          const imgTag = trackTypeToInfo[x.type].thumbnail ? /* @__PURE__ */ React__default.createElement("div", {
            className: "track-thumbnail",
            dangerouslySetInnerHTML: {
              __html: thumbnail.outerHTML
            }
          }) : /* @__PURE__ */ React__default.createElement("div", {
            className: "track-thumbnail"
          }, /* @__PURE__ */ React__default.createElement("svg", {
            height: 20,
            width: 30
          }));
          return /* @__PURE__ */ React__default.createElement("li", {
            key: x.type,
            className: plotTypeClass,
            onClick: (e) => {
              this.setState({
                selectedPlotType: x
              });
              this.props.onPlotTypeSelected(x.type);
            },
            style: {
              listStyle: "none",
              paddingLeft: 5,
              paddingBottom: 0
            }
          }, imgTag, /* @__PURE__ */ React__default.createElement("span", {
            style: {
              verticalAlign: "middle"
            }
          }, x.type));
        });
      }
      return /* @__PURE__ */ React__default.createElement("div", null, AVAILABLE_TRACK_TYPES_LIST.length > 0 && this.props.allTracksSameDatatype && /* @__PURE__ */ React__default.createElement("div", {
        className: "plot-type-container"
      }, AVAILABLE_TRACK_TYPES_LIST), !this.props.allTracksSameDatatype && /* @__PURE__ */ React__default.createElement("div", {
        className: "plot-type-container-empty"
      }, "Datasets with multiple datatypes chosen. They will be added with their default track types."));
    }
  }]);
})(React__default.Component);
PlotTypeChooser.propTypes = {
  allTracksSameDatatype: PropTypes.bool,
  datatypes: PropTypes.array,
  orientation: PropTypes.string,
  onPlotTypeSelected: PropTypes.func,
  position: PropTypes.string
};
var index_browser = { exports: {} };
var hasRequiredIndex_browser;
function requireIndex_browser() {
  if (hasRequiredIndex_browser) return index_browser.exports;
  hasRequiredIndex_browser = 1;
  (function(module2, exports2) {
    !(function(e, t) {
      module2.exports = t(React__default);
    })(self, (e) => (() => {
      var t = {
        4184: (e22, t22) => {
          var r22;
          !(function() {
            var n2 = {}.hasOwnProperty;
            function o2() {
              for (var e3 = [], t32 = 0; t32 < arguments.length; t32++) {
                var r3 = arguments[t32];
                if (r3) {
                  var i = typeof r3;
                  if ("string" === i || "number" === i) e3.push(r3);
                  else if (Array.isArray(r3)) {
                    if (r3.length) {
                      var a = o2.apply(null, r3);
                      a && e3.push(a);
                    }
                  } else if ("object" === i) if (r3.toString === Object.prototype.toString) for (var c in r3) n2.call(r3, c) && r3[c] && e3.push(c);
                  else e3.push(r3.toString());
                }
              }
              return e3.join(" ");
            }
            e22.exports ? (o2.default = o2, e22.exports = o2) : void 0 === (r22 = (function() {
              return o2;
            }).apply(t22, [])) || (e22.exports = r22);
          })();
        },
        8552: (e22, t22, r22) => {
          var n2 = r22(852)(r22(5639), "DataView");
          e22.exports = n2;
        },
        1989: (e22, t22, r22) => {
          var n2 = r22(1789), o2 = r22(401), i = r22(7667), a = r22(1327), c = r22(1866);
          function s(e3) {
            var t32 = -1, r3 = null == e3 ? 0 : e3.length;
            for (this.clear(); ++t32 < r3; ) {
              var n3 = e3[t32];
              this.set(n3[0], n3[1]);
            }
          }
          s.prototype.clear = n2, s.prototype.delete = o2, s.prototype.get = i, s.prototype.has = a, s.prototype.set = c, e22.exports = s;
        },
        8407: (e22, t22, r22) => {
          var n2 = r22(7040), o2 = r22(4125), i = r22(2117), a = r22(7518), c = r22(4705);
          function s(e3) {
            var t32 = -1, r3 = null == e3 ? 0 : e3.length;
            for (this.clear(); ++t32 < r3; ) {
              var n3 = e3[t32];
              this.set(n3[0], n3[1]);
            }
          }
          s.prototype.clear = n2, s.prototype.delete = o2, s.prototype.get = i, s.prototype.has = a, s.prototype.set = c, e22.exports = s;
        },
        7071: (e22, t22, r22) => {
          var n2 = r22(852)(r22(5639), "Map");
          e22.exports = n2;
        },
        3369: (e22, t22, r22) => {
          var n2 = r22(4785), o2 = r22(1285), i = r22(6e3), a = r22(9916), c = r22(5265);
          function s(e3) {
            var t32 = -1, r3 = null == e3 ? 0 : e3.length;
            for (this.clear(); ++t32 < r3; ) {
              var n3 = e3[t32];
              this.set(n3[0], n3[1]);
            }
          }
          s.prototype.clear = n2, s.prototype.delete = o2, s.prototype.get = i, s.prototype.has = a, s.prototype.set = c, e22.exports = s;
        },
        3818: (e22, t22, r22) => {
          var n2 = r22(852)(r22(5639), "Promise");
          e22.exports = n2;
        },
        8525: (e22, t22, r22) => {
          var n2 = r22(852)(r22(5639), "Set");
          e22.exports = n2;
        },
        8668: (e22, t22, r22) => {
          var n2 = r22(3369), o2 = r22(619), i = r22(2385);
          function a(e3) {
            var t32 = -1, r3 = null == e3 ? 0 : e3.length;
            for (this.__data__ = new n2(); ++t32 < r3; ) this.add(e3[t32]);
          }
          a.prototype.add = a.prototype.push = o2, a.prototype.has = i, e22.exports = a;
        },
        6384: (e22, t22, r22) => {
          var n2 = r22(8407), o2 = r22(7465), i = r22(3779), a = r22(7599), c = r22(4758), s = r22(4309);
          function l(e3) {
            var t32 = this.__data__ = new n2(e3);
            this.size = t32.size;
          }
          l.prototype.clear = o2, l.prototype.delete = i, l.prototype.get = a, l.prototype.has = c, l.prototype.set = s, e22.exports = l;
        },
        2705: (e22, t22, r22) => {
          var n2 = r22(5639).Symbol;
          e22.exports = n2;
        },
        1149: (e22, t22, r22) => {
          var n2 = r22(5639).Uint8Array;
          e22.exports = n2;
        },
        577: (e22, t22, r22) => {
          var n2 = r22(852)(r22(5639), "WeakMap");
          e22.exports = n2;
        },
        4963: (e22) => {
          e22.exports = function(e3, t22) {
            for (var r22 = -1, n2 = null == e3 ? 0 : e3.length, o2 = 0, i = []; ++r22 < n2; ) {
              var a = e3[r22];
              t22(a, r22, e3) && (i[o2++] = a);
            }
            return i;
          };
        },
        4636: (e22, t22, r22) => {
          var n2 = r22(2545), o2 = r22(5694), i = r22(1469), a = r22(4144), c = r22(5776), s = r22(6719), l = Object.prototype.hasOwnProperty;
          e22.exports = function(e3, t32) {
            var r3 = i(e3), u = !r3 && o2(e3), p = !r3 && !u && a(e3), f2 = !r3 && !u && !p && s(e3), d = r3 || u || p || f2, h = d ? n2(e3.length, String) : [], y = h.length;
            for (var b in e3) !t32 && !l.call(e3, b) || d && ("length" == b || p && ("offset" == b || "parent" == b) || f2 && ("buffer" == b || "byteLength" == b || "byteOffset" == b) || c(b, y)) || h.push(b);
            return h;
          };
        },
        2488: (e22) => {
          e22.exports = function(e3, t22) {
            for (var r22 = -1, n2 = t22.length, o2 = e3.length; ++r22 < n2; ) e3[o2 + r22] = t22[r22];
            return e3;
          };
        },
        2908: (e22) => {
          e22.exports = function(e3, t22) {
            for (var r22 = -1, n2 = null == e3 ? 0 : e3.length; ++r22 < n2; ) if (t22(e3[r22], r22, e3)) return true;
            return false;
          };
        },
        8470: (e22, t22, r22) => {
          var n2 = r22(7813);
          e22.exports = function(e3, t32) {
            for (var r3 = e3.length; r3--; ) if (n2(e3[r3][0], t32)) return r3;
            return -1;
          };
        },
        8866: (e22, t22, r22) => {
          var n2 = r22(2488), o2 = r22(1469);
          e22.exports = function(e3, t32, r3) {
            var i = t32(e3);
            return o2(e3) ? i : n2(i, r3(e3));
          };
        },
        4239: (e22, t22, r22) => {
          var n2 = r22(2705), o2 = r22(9607), i = r22(2333), a = n2 ? n2.toStringTag : void 0;
          e22.exports = function(e3) {
            return null == e3 ? void 0 === e3 ? "[object Undefined]" : "[object Null]" : a && a in Object(e3) ? o2(e3) : i(e3);
          };
        },
        9454: (e22, t22, r22) => {
          var n2 = r22(4239), o2 = r22(7005);
          e22.exports = function(e3) {
            return o2(e3) && "[object Arguments]" == n2(e3);
          };
        },
        939: (e22, t22, r22) => {
          var n2 = r22(2492), o2 = r22(7005);
          e22.exports = function e3(t32, r3, i, a, c) {
            return t32 === r3 || (null == t32 || null == r3 || !o2(t32) && !o2(r3) ? t32 != t32 && r3 != r3 : n2(t32, r3, i, a, e3, c));
          };
        },
        2492: (e22, t22, r22) => {
          var n2 = r22(6384), o2 = r22(7114), i = r22(8351), a = r22(6096), c = r22(4160), s = r22(1469), l = r22(4144), u = r22(6719), p = "[object Arguments]", f2 = "[object Array]", d = "[object Object]", h = Object.prototype.hasOwnProperty;
          e22.exports = function(e3, t32, r3, y, b, v) {
            var g = s(e3), m = s(t32), x = g ? f2 : c(e3), O = m ? f2 : c(t32), k = (x = x == p ? d : x) == d, j = (O = O == p ? d : O) == d, _ = x == O;
            if (_ && l(e3)) {
              if (!l(t32)) return false;
              g = true, k = false;
            }
            if (_ && !k) return v || (v = new n2()), g || u(e3) ? o2(e3, t32, r3, y, b, v) : i(e3, t32, x, r3, y, b, v);
            if (!(1 & r3)) {
              var w = k && h.call(e3, "__wrapped__"), C2 = j && h.call(t32, "__wrapped__");
              if (w || C2) {
                var P = w ? e3.value() : e3, E2 = C2 ? t32.value() : t32;
                return v || (v = new n2()), b(P, E2, r3, y, v);
              }
            }
            return !!_ && (v || (v = new n2()), a(e3, t32, r3, y, b, v));
          };
        },
        8458: (e22, t22, r22) => {
          var n2 = r22(3560), o2 = r22(5346), i = r22(3218), a = r22(346), c = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, f2 = RegExp("^" + u.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
          e22.exports = function(e3) {
            return !(!i(e3) || o2(e3)) && (n2(e3) ? f2 : c).test(a(e3));
          };
        },
        8749: (e22, t22, r22) => {
          var n2 = r22(4239), o2 = r22(1780), i = r22(7005), a = {};
          a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = true, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = false, e22.exports = function(e3) {
            return i(e3) && o2(e3.length) && !!a[n2(e3)];
          };
        },
        280: (e22, t22, r22) => {
          var n2 = r22(5726), o2 = r22(6916), i = Object.prototype.hasOwnProperty;
          e22.exports = function(e3) {
            if (!n2(e3)) return o2(e3);
            var t32 = [];
            for (var r3 in Object(e3)) i.call(e3, r3) && "constructor" != r3 && t32.push(r3);
            return t32;
          };
        },
        2545: (e22) => {
          e22.exports = function(e3, t22) {
            for (var r22 = -1, n2 = Array(e3); ++r22 < e3; ) n2[r22] = t22(r22);
            return n2;
          };
        },
        1717: (e22) => {
          e22.exports = function(e3) {
            return function(t22) {
              return e3(t22);
            };
          };
        },
        4757: (e22) => {
          e22.exports = function(e3, t22) {
            return e3.has(t22);
          };
        },
        4429: (e22, t22, r22) => {
          var n2 = r22(5639)["__core-js_shared__"];
          e22.exports = n2;
        },
        7114: (e22, t22, r22) => {
          var n2 = r22(8668), o2 = r22(2908), i = r22(4757);
          e22.exports = function(e3, t32, r3, a, c, s) {
            var l = 1 & r3, u = e3.length, p = t32.length;
            if (u != p && !(l && p > u)) return false;
            var f2 = s.get(e3), d = s.get(t32);
            if (f2 && d) return f2 == t32 && d == e3;
            var h = -1, y = true, b = 2 & r3 ? new n2() : void 0;
            for (s.set(e3, t32), s.set(t32, e3); ++h < u; ) {
              var v = e3[h], g = t32[h];
              if (a) var m = l ? a(g, v, h, t32, e3, s) : a(v, g, h, e3, t32, s);
              if (void 0 !== m) {
                if (m) continue;
                y = false;
                break;
              }
              if (b) {
                if (!o2(t32, function(e4, t4) {
                  if (!i(b, t4) && (v === e4 || c(v, e4, r3, a, s))) return b.push(t4);
                })) {
                  y = false;
                  break;
                }
              } else if (v !== g && !c(v, g, r3, a, s)) {
                y = false;
                break;
              }
            }
            return s.delete(e3), s.delete(t32), y;
          };
        },
        8351: (e22, t22, r22) => {
          var n2 = r22(2705), o2 = r22(1149), i = r22(7813), a = r22(7114), c = r22(8776), s = r22(1814), l = n2 ? n2.prototype : void 0, u = l ? l.valueOf : void 0;
          e22.exports = function(e3, t32, r3, n3, l2, p, f2) {
            switch (r3) {
              case "[object DataView]":
                if (e3.byteLength != t32.byteLength || e3.byteOffset != t32.byteOffset) return false;
                e3 = e3.buffer, t32 = t32.buffer;
              case "[object ArrayBuffer]":
                return !(e3.byteLength != t32.byteLength || !p(new o2(e3), new o2(t32)));
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return i(+e3, +t32);
              case "[object Error]":
                return e3.name == t32.name && e3.message == t32.message;
              case "[object RegExp]":
              case "[object String]":
                return e3 == t32 + "";
              case "[object Map]":
                var d = c;
              case "[object Set]":
                var h = 1 & n3;
                if (d || (d = s), e3.size != t32.size && !h) return false;
                var y = f2.get(e3);
                if (y) return y == t32;
                n3 |= 2, f2.set(e3, t32);
                var b = a(d(e3), d(t32), n3, l2, p, f2);
                return f2.delete(e3), b;
              case "[object Symbol]":
                if (u) return u.call(e3) == u.call(t32);
            }
            return false;
          };
        },
        6096: (e22, t22, r22) => {
          var n2 = r22(8234), o2 = Object.prototype.hasOwnProperty;
          e22.exports = function(e3, t32, r3, i, a, c) {
            var s = 1 & r3, l = n2(e3), u = l.length;
            if (u != n2(t32).length && !s) return false;
            for (var p = u; p--; ) {
              var f2 = l[p];
              if (!(s ? f2 in t32 : o2.call(t32, f2))) return false;
            }
            var d = c.get(e3), h = c.get(t32);
            if (d && h) return d == t32 && h == e3;
            var y = true;
            c.set(e3, t32), c.set(t32, e3);
            for (var b = s; ++p < u; ) {
              var v = e3[f2 = l[p]], g = t32[f2];
              if (i) var m = s ? i(g, v, f2, t32, e3, c) : i(v, g, f2, e3, t32, c);
              if (!(void 0 === m ? v === g || a(v, g, r3, i, c) : m)) {
                y = false;
                break;
              }
              b || (b = "constructor" == f2);
            }
            if (y && !b) {
              var x = e3.constructor, O = t32.constructor;
              x == O || !("constructor" in e3) || !("constructor" in t32) || "function" == typeof x && x instanceof x && "function" == typeof O && O instanceof O || (y = false);
            }
            return c.delete(e3), c.delete(t32), y;
          };
        },
        1957: (e22, t22, r22) => {
          var n2 = "object" == typeof r22.g && r22.g && r22.g.Object === Object && r22.g;
          e22.exports = n2;
        },
        8234: (e22, t22, r22) => {
          var n2 = r22(8866), o2 = r22(9551), i = r22(3674);
          e22.exports = function(e3) {
            return n2(e3, i, o2);
          };
        },
        5050: (e22, t22, r22) => {
          var n2 = r22(7019);
          e22.exports = function(e3, t32) {
            var r3 = e3.__data__;
            return n2(t32) ? r3["string" == typeof t32 ? "string" : "hash"] : r3.map;
          };
        },
        852: (e22, t22, r22) => {
          var n2 = r22(8458), o2 = r22(7801);
          e22.exports = function(e3, t32) {
            var r3 = o2(e3, t32);
            return n2(r3) ? r3 : void 0;
          };
        },
        9607: (e22, t22, r22) => {
          var n2 = r22(2705), o2 = Object.prototype, i = o2.hasOwnProperty, a = o2.toString, c = n2 ? n2.toStringTag : void 0;
          e22.exports = function(e3) {
            var t32 = i.call(e3, c), r3 = e3[c];
            try {
              e3[c] = void 0;
              var n3 = true;
            } catch (e4) {
            }
            var o3 = a.call(e3);
            return n3 && (t32 ? e3[c] = r3 : delete e3[c]), o3;
          };
        },
        9551: (e22, t22, r22) => {
          var n2 = r22(4963), o2 = r22(479), i = Object.prototype.propertyIsEnumerable, a = Object.getOwnPropertySymbols, c = a ? function(e3) {
            return null == e3 ? [] : (e3 = Object(e3), n2(a(e3), function(t32) {
              return i.call(e3, t32);
            }));
          } : o2;
          e22.exports = c;
        },
        4160: (e22, t22, r22) => {
          var n2 = r22(8552), o2 = r22(7071), i = r22(3818), a = r22(8525), c = r22(577), s = r22(4239), l = r22(346), u = "[object Map]", p = "[object Promise]", f2 = "[object Set]", d = "[object WeakMap]", h = "[object DataView]", y = l(n2), b = l(o2), v = l(i), g = l(a), m = l(c), x = s;
          (n2 && x(new n2(new ArrayBuffer(1))) != h || o2 && x(new o2()) != u || i && x(i.resolve()) != p || a && x(new a()) != f2 || c && x(new c()) != d) && (x = function(e3) {
            var t32 = s(e3), r3 = "[object Object]" == t32 ? e3.constructor : void 0, n3 = r3 ? l(r3) : "";
            if (n3) switch (n3) {
              case y:
                return h;
              case b:
                return u;
              case v:
                return p;
              case g:
                return f2;
              case m:
                return d;
            }
            return t32;
          }), e22.exports = x;
        },
        7801: (e22) => {
          e22.exports = function(e3, t22) {
            return null == e3 ? void 0 : e3[t22];
          };
        },
        1789: (e22, t22, r22) => {
          var n2 = r22(4536);
          e22.exports = function() {
            this.__data__ = n2 ? n2(null) : {}, this.size = 0;
          };
        },
        401: (e22) => {
          e22.exports = function(e3) {
            var t22 = this.has(e3) && delete this.__data__[e3];
            return this.size -= t22 ? 1 : 0, t22;
          };
        },
        7667: (e22, t22, r22) => {
          var n2 = r22(4536), o2 = Object.prototype.hasOwnProperty;
          e22.exports = function(e3) {
            var t32 = this.__data__;
            if (n2) {
              var r3 = t32[e3];
              return "__lodash_hash_undefined__" === r3 ? void 0 : r3;
            }
            return o2.call(t32, e3) ? t32[e3] : void 0;
          };
        },
        1327: (e22, t22, r22) => {
          var n2 = r22(4536), o2 = Object.prototype.hasOwnProperty;
          e22.exports = function(e3) {
            var t32 = this.__data__;
            return n2 ? void 0 !== t32[e3] : o2.call(t32, e3);
          };
        },
        1866: (e22, t22, r22) => {
          var n2 = r22(4536);
          e22.exports = function(e3, t32) {
            var r3 = this.__data__;
            return this.size += this.has(e3) ? 0 : 1, r3[e3] = n2 && void 0 === t32 ? "__lodash_hash_undefined__" : t32, this;
          };
        },
        5776: (e22) => {
          var t22 = /^(?:0|[1-9]\d*)$/;
          e22.exports = function(e3, r22) {
            var n2 = typeof e3;
            return !!(r22 = null == r22 ? 9007199254740991 : r22) && ("number" == n2 || "symbol" != n2 && t22.test(e3)) && e3 > -1 && e3 % 1 == 0 && e3 < r22;
          };
        },
        7019: (e22) => {
          e22.exports = function(e3) {
            var t22 = typeof e3;
            return "string" == t22 || "number" == t22 || "symbol" == t22 || "boolean" == t22 ? "__proto__" !== e3 : null === e3;
          };
        },
        5346: (e22, t22, r22) => {
          var n2, o2 = r22(4429), i = (n2 = /[^.]+$/.exec(o2 && o2.keys && o2.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n2 : "";
          e22.exports = function(e3) {
            return !!i && i in e3;
          };
        },
        5726: (e22) => {
          var t22 = Object.prototype;
          e22.exports = function(e3) {
            var r22 = e3 && e3.constructor;
            return e3 === ("function" == typeof r22 && r22.prototype || t22);
          };
        },
        7040: (e22) => {
          e22.exports = function() {
            this.__data__ = [], this.size = 0;
          };
        },
        4125: (e22, t22, r22) => {
          var n2 = r22(8470), o2 = Array.prototype.splice;
          e22.exports = function(e3) {
            var t32 = this.__data__, r3 = n2(t32, e3);
            return !(r3 < 0 || (r3 == t32.length - 1 ? t32.pop() : o2.call(t32, r3, 1), --this.size, 0));
          };
        },
        2117: (e22, t22, r22) => {
          var n2 = r22(8470);
          e22.exports = function(e3) {
            var t32 = this.__data__, r3 = n2(t32, e3);
            return r3 < 0 ? void 0 : t32[r3][1];
          };
        },
        7518: (e22, t22, r22) => {
          var n2 = r22(8470);
          e22.exports = function(e3) {
            return n2(this.__data__, e3) > -1;
          };
        },
        4705: (e22, t22, r22) => {
          var n2 = r22(8470);
          e22.exports = function(e3, t32) {
            var r3 = this.__data__, o2 = n2(r3, e3);
            return o2 < 0 ? (++this.size, r3.push([e3, t32])) : r3[o2][1] = t32, this;
          };
        },
        4785: (e22, t22, r22) => {
          var n2 = r22(1989), o2 = r22(8407), i = r22(7071);
          e22.exports = function() {
            this.size = 0, this.__data__ = {
              hash: new n2(),
              map: new (i || o2)(),
              string: new n2()
            };
          };
        },
        1285: (e22, t22, r22) => {
          var n2 = r22(5050);
          e22.exports = function(e3) {
            var t32 = n2(this, e3).delete(e3);
            return this.size -= t32 ? 1 : 0, t32;
          };
        },
        6e3: (e22, t22, r22) => {
          var n2 = r22(5050);
          e22.exports = function(e3) {
            return n2(this, e3).get(e3);
          };
        },
        9916: (e22, t22, r22) => {
          var n2 = r22(5050);
          e22.exports = function(e3) {
            return n2(this, e3).has(e3);
          };
        },
        5265: (e22, t22, r22) => {
          var n2 = r22(5050);
          e22.exports = function(e3, t32) {
            var r3 = n2(this, e3), o2 = r3.size;
            return r3.set(e3, t32), this.size += r3.size == o2 ? 0 : 1, this;
          };
        },
        8776: (e22) => {
          e22.exports = function(e3) {
            var t22 = -1, r22 = Array(e3.size);
            return e3.forEach(function(e4, n2) {
              r22[++t22] = [n2, e4];
            }), r22;
          };
        },
        4536: (e22, t22, r22) => {
          var n2 = r22(852)(Object, "create");
          e22.exports = n2;
        },
        6916: (e22, t22, r22) => {
          var n2 = r22(5569)(Object.keys, Object);
          e22.exports = n2;
        },
        1167: (e22, t22, r22) => {
          e22 = r22.nmd(e22);
          var n2 = r22(1957), o2 = t22 && !t22.nodeType && t22, i = o2 && e22 && !e22.nodeType && e22, a = i && i.exports === o2 && n2.process, c = (function() {
            try {
              return i && i.require && i.require("util").types || a && a.binding && a.binding("util");
            } catch (e3) {
            }
          })();
          e22.exports = c;
        },
        2333: (e22) => {
          var t22 = Object.prototype.toString;
          e22.exports = function(e3) {
            return t22.call(e3);
          };
        },
        5569: (e22) => {
          e22.exports = function(e3, t22) {
            return function(r22) {
              return e3(t22(r22));
            };
          };
        },
        5639: (e22, t22, r22) => {
          var n2 = r22(1957), o2 = "object" == typeof self && self && self.Object === Object && self, i = n2 || o2 || Function("return this")();
          e22.exports = i;
        },
        619: (e22) => {
          e22.exports = function(e3) {
            return this.__data__.set(e3, "__lodash_hash_undefined__"), this;
          };
        },
        2385: (e22) => {
          e22.exports = function(e3) {
            return this.__data__.has(e3);
          };
        },
        1814: (e22) => {
          e22.exports = function(e3) {
            var t22 = -1, r22 = Array(e3.size);
            return e3.forEach(function(e4) {
              r22[++t22] = e4;
            }), r22;
          };
        },
        7465: (e22, t22, r22) => {
          var n2 = r22(8407);
          e22.exports = function() {
            this.__data__ = new n2(), this.size = 0;
          };
        },
        3779: (e22) => {
          e22.exports = function(e3) {
            var t22 = this.__data__, r22 = t22.delete(e3);
            return this.size = t22.size, r22;
          };
        },
        7599: (e22) => {
          e22.exports = function(e3) {
            return this.__data__.get(e3);
          };
        },
        4758: (e22) => {
          e22.exports = function(e3) {
            return this.__data__.has(e3);
          };
        },
        4309: (e22, t22, r22) => {
          var n2 = r22(8407), o2 = r22(7071), i = r22(3369);
          e22.exports = function(e3, t32) {
            var r3 = this.__data__;
            if (r3 instanceof n2) {
              var a = r3.__data__;
              if (!o2 || a.length < 199) return a.push([e3, t32]), this.size = ++r3.size, this;
              r3 = this.__data__ = new i(a);
            }
            return r3.set(e3, t32), this.size = r3.size, this;
          };
        },
        346: (e22) => {
          var t22 = Function.prototype.toString;
          e22.exports = function(e3) {
            if (null != e3) {
              try {
                return t22.call(e3);
              } catch (e4) {
              }
              try {
                return e3 + "";
              } catch (e4) {
              }
            }
            return "";
          };
        },
        7813: (e22) => {
          e22.exports = function(e3, t22) {
            return e3 === t22 || e3 != e3 && t22 != t22;
          };
        },
        5694: (e22, t22, r22) => {
          var n2 = r22(9454), o2 = r22(7005), i = Object.prototype, a = i.hasOwnProperty, c = i.propertyIsEnumerable, s = n2(/* @__PURE__ */ (function() {
            return arguments;
          })()) ? n2 : function(e3) {
            return o2(e3) && a.call(e3, "callee") && !c.call(e3, "callee");
          };
          e22.exports = s;
        },
        1469: (e22) => {
          var t22 = Array.isArray;
          e22.exports = t22;
        },
        8612: (e22, t22, r22) => {
          var n2 = r22(3560), o2 = r22(1780);
          e22.exports = function(e3) {
            return null != e3 && o2(e3.length) && !n2(e3);
          };
        },
        4144: (e22, t22, r22) => {
          e22 = r22.nmd(e22);
          var n2 = r22(5639), o2 = r22(5062), i = t22 && !t22.nodeType && t22, a = i && e22 && !e22.nodeType && e22, c = a && a.exports === i ? n2.Buffer : void 0, s = (c ? c.isBuffer : void 0) || o2;
          e22.exports = s;
        },
        8446: (e22, t22, r22) => {
          var n2 = r22(939);
          e22.exports = function(e3, t32) {
            return n2(e3, t32);
          };
        },
        3560: (e22, t22, r22) => {
          var n2 = r22(4239), o2 = r22(3218);
          e22.exports = function(e3) {
            if (!o2(e3)) return false;
            var t32 = n2(e3);
            return "[object Function]" == t32 || "[object GeneratorFunction]" == t32 || "[object AsyncFunction]" == t32 || "[object Proxy]" == t32;
          };
        },
        1780: (e22) => {
          e22.exports = function(e3) {
            return "number" == typeof e3 && e3 > -1 && e3 % 1 == 0 && e3 <= 9007199254740991;
          };
        },
        3218: (e22) => {
          e22.exports = function(e3) {
            var t22 = typeof e3;
            return null != e3 && ("object" == t22 || "function" == t22);
          };
        },
        7005: (e22) => {
          e22.exports = function(e3) {
            return null != e3 && "object" == typeof e3;
          };
        },
        6719: (e22, t22, r22) => {
          var n2 = r22(8749), o2 = r22(1717), i = r22(1167), a = i && i.isTypedArray, c = a ? o2(a) : n2;
          e22.exports = c;
        },
        3674: (e22, t22, r22) => {
          var n2 = r22(4636), o2 = r22(280), i = r22(8612);
          e22.exports = function(e3) {
            return i(e3) ? n2(e3) : o2(e3);
          };
        },
        8306: (e22, t22, r22) => {
          var n2 = r22(3369);
          function o2(e3, t32) {
            if ("function" != typeof e3 || null != t32 && "function" != typeof t32) throw new TypeError("Expected a function");
            var r3 = function() {
              var n3 = arguments, o3 = t32 ? t32.apply(this, n3) : n3[0], i = r3.cache;
              if (i.has(o3)) return i.get(o3);
              var a = e3.apply(this, n3);
              return r3.cache = i.set(o3, a) || i, a;
            };
            return r3.cache = new (o2.Cache || n2)(), r3;
          }
          o2.Cache = n2, e22.exports = o2;
        },
        479: (e22) => {
          e22.exports = function() {
            return [];
          };
        },
        5062: (e22) => {
          e22.exports = function() {
            return false;
          };
        },
        2703: (e22, t22, r22) => {
          var n2 = r22(414);
          function o2() {
          }
          function i() {
          }
          i.resetWarningCache = o2, e22.exports = function() {
            function e3(e4, t4, r4, o3, i2, a) {
              if (a !== n2) {
                var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw c.name = "Invariant Violation", c;
              }
            }
            function t32() {
              return e3;
            }
            e3.isRequired = e3;
            var r3 = {
              array: e3,
              bigint: e3,
              bool: e3,
              func: e3,
              number: e3,
              object: e3,
              string: e3,
              symbol: e3,
              any: e3,
              arrayOf: t32,
              element: e3,
              elementType: e3,
              instanceOf: t32,
              node: e3,
              objectOf: t32,
              oneOf: t32,
              oneOfType: t32,
              shape: t32,
              exact: t32,
              checkPropTypes: i,
              resetWarningCache: o2
            };
            return r3.PropTypes = r3, r3;
          };
        },
        5697: (e22, t22, r22) => {
          e22.exports = r22(2703)();
        },
        414: (e22) => {
          e22.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        9787: (t22) => {
          t22.exports = e;
        }
      }, r2 = {};
      function n(e22) {
        var o2 = r2[e22];
        if (void 0 !== o2) return o2.exports;
        var i = r2[e22] = {
          id: e22,
          loaded: false,
          exports: {}
        };
        return t[e22](i, i.exports, n), i.loaded = true, i.exports;
      }
      n.n = (e22) => {
        var t22 = e22 && e22.__esModule ? () => e22.default : () => e22;
        return n.d(t22, {
          a: t22
        }), t22;
      }, n.d = (e22, t22) => {
        for (var r22 in t22) n.o(t22, r22) && !n.o(e22, r22) && Object.defineProperty(e22, r22, {
          enumerable: true,
          get: t22[r22]
        });
      }, n.g = (function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (e22) {
          if ("object" == typeof window) return window;
        }
      })(), n.o = (e22, t22) => Object.prototype.hasOwnProperty.call(e22, t22), n.r = (e22) => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e22, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e22, "__esModule", {
          value: true
        });
      }, n.nmd = (e22) => (e22.paths = [], e22.children || (e22.children = []), e22);
      var o = {};
      return (() => {
        n.r(o), n.d(o, {
          default: () => xe,
          expandNodesToLevel: () => me
        });
        var e22 = n(4184), t22 = n.n(e22), r22 = n(8446), i = n.n(r22), a = n(8306), c = n.n(a);
        let s = (e3 = 21) => crypto.getRandomValues(new Uint8Array(e3)).reduce((e4, t32) => e4 + ((t32 &= 63) < 36 ? t32.toString(36) : t32 < 62 ? (t32 - 26).toString(36).toUpperCase() : t32 > 62 ? "-" : "_"), "");
        var l = n(5697), u = n.n(l), p = n(9787), f2 = n.n(p);
        function d(e3) {
          return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
            return typeof e4;
          } : function(e4) {
            return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
          }, d(e3);
        }
        var h = ["children", "title"];
        function y() {
          return y = Object.assign ? Object.assign.bind() : function(e3) {
            for (var t32 = 1; t32 < arguments.length; t32++) {
              var r3 = arguments[t32];
              for (var n2 in r3) Object.prototype.hasOwnProperty.call(r3, n2) && (e3[n2] = r3[n2]);
            }
            return e3;
          }, y.apply(this, arguments);
        }
        function b(e3, t32) {
          if (!(e3 instanceof t32)) throw new TypeError("Cannot call a class as a function");
        }
        function v(e3, t32) {
          for (var r3 = 0; r3 < t32.length; r3++) {
            var n2 = t32[r3];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
          }
        }
        function g(e3, t32) {
          return g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
            return e4.__proto__ = t4, e4;
          }, g(e3, t32);
        }
        function m(e3, t32) {
          if (t32 && ("object" === d(t32) || "function" == typeof t32)) return t32;
          if (void 0 !== t32) throw new TypeError("Derived constructors may only return object or undefined");
          return (function(e4) {
            if (void 0 === e4) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e4;
          })(e3);
        }
        function x(e3) {
          return x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
            return e4.__proto__ || Object.getPrototypeOf(e4);
          }, x(e3);
        }
        function O(e3, t32, r3) {
          return t32 in e3 ? Object.defineProperty(e3, t32, {
            value: r3,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e3[t32] = r3, e3;
        }
        var k = (function(e3) {
          !(function(e4, t4) {
            if ("function" != typeof t4 && null !== t4) throw new TypeError("Super expression must either be null or a function");
            e4.prototype = Object.create(t4 && t4.prototype, {
              constructor: {
                value: e4,
                writable: true,
                configurable: true
              }
            }), Object.defineProperty(e4, "prototype", {
              writable: false
            }), t4 && g(e4, t4);
          })(a2, e3);
          var t32, r3, n2, o2, i2 = (n2 = a2, o2 = (function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), true;
            } catch (e4) {
              return false;
            }
          })(), function() {
            var e4, t4 = x(n2);
            if (o2) {
              var r4 = x(this).constructor;
              e4 = Reflect.construct(t4, arguments, r4);
            } else e4 = t4.apply(this, arguments);
            return m(this, e4);
          });
          function a2() {
            return b(this, a2), i2.apply(this, arguments);
          }
          return t32 = a2, (r3 = [{
            key: "render",
            value: function() {
              var e4 = this.props, t4 = e4.children, r4 = e4.title, n3 = (function(e52, t5) {
                if (null == e52) return {};
                var r5, n4, o3 = (function(e6, t6) {
                  if (null == e6) return {};
                  var r6, n5, o4 = {}, i4 = Object.keys(e6);
                  for (n5 = 0; n5 < i4.length; n5++) r6 = i4[n5], t6.indexOf(r6) >= 0 || (o4[r6] = e6[r6]);
                  return o4;
                })(e52, t5);
                if (Object.getOwnPropertySymbols) {
                  var i3 = Object.getOwnPropertySymbols(e52);
                  for (n4 = 0; n4 < i3.length; n4++) r5 = i3[n4], t5.indexOf(r5) >= 0 || Object.prototype.propertyIsEnumerable.call(e52, r5) && (o3[r5] = e52[r5]);
                }
                return o3;
              })(e4, h);
              return f2().createElement("button", y({
                "aria-label": r4,
                title: r4,
                type: "button"
              }, n3), t4);
            }
          }]) && v(t32.prototype, r3), Object.defineProperty(t32, "prototype", {
            writable: false
          }), a2;
        })(f2().PureComponent);
        O(k, "propTypes", {
          children: u().node.isRequired,
          title: u().string
        }), O(k, "defaultProps", {
          title: null
        });
        const j = k, _ = {
          ALL: "all",
          PARENT: "parent",
          LEAF: "leaf"
        };
        function w(e3) {
          this.message = e3, this.stack = Error().stack;
        }
        w.prototype = Object.create(Error.prototype), w.prototype.name = "CheckboxTreeError";
        const C2 = w;
        function P(e3, t32) {
          var r3 = Object.keys(e3);
          if (Object.getOwnPropertySymbols) {
            var n2 = Object.getOwnPropertySymbols(e3);
            t32 && (n2 = n2.filter(function(t4) {
              return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
            })), r3.push.apply(r3, n2);
          }
          return r3;
        }
        function E2(e3, t32, r3) {
          return t32 in e3 ? Object.defineProperty(e3, t32, {
            value: r3,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e3[t32] = r3, e3;
        }
        function N(e3, t32) {
          if (!(e3 instanceof t32)) throw new TypeError("Cannot call a class as a function");
        }
        function A5(e3, t32) {
          for (var r3 = 0; r3 < t32.length; r3++) {
            var n2 = t32[r3];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
          }
        }
        var S = _;
        const T = (function() {
          function e3(t4) {
            var r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N(this, e3), this.props = t4, this.flatNodes = r4;
          }
          var t32, r3;
          return t32 = e3, r3 = [{
            key: "setProps",
            value: function(e4) {
              this.props = e4;
            }
          }, {
            key: "clone",
            value: function() {
              var t4 = this, r4 = {};
              return Object.keys(this.flatNodes).forEach(function(e4) {
                var n2 = t4.flatNodes[e4];
                r4[e4] = (function(e52) {
                  for (var t5 = 1; t5 < arguments.length; t5++) {
                    var r5 = null != arguments[t5] ? arguments[t5] : {};
                    t5 % 2 ? P(Object(r5), true).forEach(function(t6) {
                      E2(e52, t6, r5[t6]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e52, Object.getOwnPropertyDescriptors(r5)) : P(Object(r5)).forEach(function(t6) {
                      Object.defineProperty(e52, t6, Object.getOwnPropertyDescriptor(r5, t6));
                    });
                  }
                  return e52;
                })({}, n2);
              }), new e3(this.props, r4);
            }
          }, {
            key: "getNode",
            value: function(e4) {
              return this.flatNodes[e4];
            }
          }, {
            key: "reset",
            value: function() {
              this.flatNodes = {};
            }
          }, {
            key: "flattenNodes",
            value: function(e4) {
              var t4 = this, r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
              if (Array.isArray(e4) && 0 !== e4.length) {
                var o2 = this.props, i2 = o2.disabled, a2 = o2.noCascade;
                e4.forEach(function(e52, o3) {
                  var c2 = t4.nodeHasChildren(e52);
                  if (void 0 !== t4.flatNodes[e52.value]) throw new C2("Duplicate value '".concat(e52.value, "' detected. All node values must be unique."));
                  t4.flatNodes[e52.value] = {
                    label: e52.label,
                    value: e52.value,
                    children: e52.children,
                    parent: r4,
                    isChild: void 0 !== r4.value,
                    isParent: c2,
                    isLeaf: !c2,
                    showCheckbox: void 0 === e52.showCheckbox || e52.showCheckbox,
                    disabled: t4.getDisabledState(e52, r4, i2, a2),
                    treeDepth: n2,
                    index: o3
                  }, t4.flattenNodes(e52.children, e52, n2 + 1);
                });
              }
            }
          }, {
            key: "nodeHasChildren",
            value: function(e4) {
              return Array.isArray(e4.children);
            }
          }, {
            key: "getDisabledState",
            value: function(e4, t4, r4, n2) {
              return !!r4 || !(n2 || !t4.disabled) || Boolean(e4.disabled);
            }
          }, {
            key: "deserializeLists",
            value: function(e4) {
              var t4 = this, r4 = ["checked", "expanded"];
              Object.keys(this.flatNodes).forEach(function(e52) {
                r4.forEach(function(r5) {
                  t4.flatNodes[e52][r5] = false;
                });
              }), r4.forEach(function(r5) {
                e4[r5].forEach(function(e52) {
                  void 0 !== t4.flatNodes[e52] && (t4.flatNodes[e52][r5] = true);
                });
              });
            }
          }, {
            key: "serializeList",
            value: function(e4) {
              var t4 = this, r4 = [];
              return Object.keys(this.flatNodes).forEach(function(n2) {
                t4.flatNodes[n2][e4] && r4.push(n2);
              }), r4;
            }
          }, {
            key: "expandAllNodes",
            value: function(e4) {
              var t4 = this;
              return Object.keys(this.flatNodes).forEach(function(r4) {
                t4.flatNodes[r4].isParent && (t4.flatNodes[r4].expanded = e4);
              }), this;
            }
          }, {
            key: "toggleChecked",
            value: function(e4, t4, r4, n2) {
              var o2 = this, i2 = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], a2 = this.flatNodes[e4.value], c2 = [S.PARENT, S.ALL].indexOf(r4) > -1, s2 = [S.LEAF, S.ALL].indexOf(r4) > -1;
              if (a2.isLeaf || n2) {
                if (e4.disabled) return this;
                this.toggleNode(e4.value, "checked", t4);
              } else (c2 || 0 === a2.children.length) && this.toggleNode(e4.value, "checked", t4), s2 && a2.children.forEach(function(e52) {
                o2.toggleChecked(e52, t4, r4, n2, false);
              });
              return i2 && !n2 && a2.isChild && c2 && this.toggleParentStatus(a2.parent, r4), this;
            }
          }, {
            key: "toggleParentStatus",
            value: function(e4, t4) {
              var r4 = this.flatNodes[e4.value];
              r4.isChild ? (t4 === S.ALL && this.toggleNode(e4.value, "checked", this.isEveryChildChecked(r4)), this.toggleParentStatus(r4.parent, t4)) : this.toggleNode(e4.value, "checked", this.isEveryChildChecked(r4));
            }
          }, {
            key: "isEveryChildChecked",
            value: function(e4) {
              var t4 = this;
              return e4.children.every(function(e52) {
                return t4.getNode(e52.value).checked;
              });
            }
          }, {
            key: "toggleNode",
            value: function(e4, t4, r4) {
              return this.flatNodes[e4][t4] = r4, this;
            }
          }], r3 && A5(t32.prototype, r3), Object.defineProperty(t32, "prototype", {
            writable: false
          }), e3;
        })();
        function R(e3) {
          return R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
            return typeof e4;
          } : function(e4) {
            return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
          }, R(e3);
        }
        function L() {
          return L = Object.assign ? Object.assign.bind() : function(e3) {
            for (var t32 = 1; t32 < arguments.length; t32++) {
              var r3 = arguments[t32];
              for (var n2 in r3) Object.prototype.hasOwnProperty.call(r3, n2) && (e3[n2] = r3[n2]);
            }
            return e3;
          }, L.apply(this, arguments);
        }
        function D2(e3, t32) {
          var r3 = Object.keys(e3);
          if (Object.getOwnPropertySymbols) {
            var n2 = Object.getOwnPropertySymbols(e3);
            t32 && (n2 = n2.filter(function(t4) {
              return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
            })), r3.push.apply(r3, n2);
          }
          return r3;
        }
        function I(e3, t32) {
          if (!(e3 instanceof t32)) throw new TypeError("Cannot call a class as a function");
        }
        function z(e3, t32) {
          for (var r3 = 0; r3 < t32.length; r3++) {
            var n2 = t32[r3];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
          }
        }
        function q2(e3, t32) {
          return q2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
            return e4.__proto__ = t4, e4;
          }, q2(e3, t32);
        }
        function B2(e3, t32) {
          if (t32 && ("object" === R(t32) || "function" == typeof t32)) return t32;
          if (void 0 !== t32) throw new TypeError("Derived constructors may only return object or undefined");
          return (function(e4) {
            if (void 0 === e4) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e4;
          })(e3);
        }
        function F(e3) {
          return F = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
            return e4.__proto__ || Object.getPrototypeOf(e4);
          }, F(e3);
        }
        function M2(e3, t32, r3) {
          return t32 in e3 ? Object.defineProperty(e3, t32, {
            value: r3,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e3[t32] = r3, e3;
        }
        var U = (function(e3) {
          !(function(e4, t4) {
            if ("function" != typeof t4 && null !== t4) throw new TypeError("Super expression must either be null or a function");
            e4.prototype = Object.create(t4 && t4.prototype, {
              constructor: {
                value: e4,
                writable: true,
                configurable: true
              }
            }), Object.defineProperty(e4, "prototype", {
              writable: false
            }), t4 && q2(e4, t4);
          })(a2, e3);
          var t32, r3, n2, o2, i2 = (n2 = a2, o2 = (function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), true;
            } catch (e4) {
              return false;
            }
          })(), function() {
            var e4, t4 = F(n2);
            if (o2) {
              var r4 = F(this).constructor;
              e4 = Reflect.construct(t4, arguments, r4);
            } else e4 = t4.apply(this, arguments);
            return B2(this, e4);
          });
          function a2() {
            return I(this, a2), i2.apply(this, arguments);
          }
          return t32 = a2, r3 = [{
            key: "componentDidMount",
            value: function() {
              this.updateDeterminateProperty();
            }
          }, {
            key: "componentDidUpdate",
            value: function() {
              this.updateDeterminateProperty();
            }
          }, {
            key: "updateDeterminateProperty",
            value: function() {
              var e4 = this.props.indeterminate;
              this.checkbox.indeterminate = e4;
            }
          }, {
            key: "render",
            value: function() {
              var e4 = this, t4 = (function(e52) {
                for (var t5 = 1; t5 < arguments.length; t5++) {
                  var r4 = null != arguments[t5] ? arguments[t5] : {};
                  t5 % 2 ? D2(Object(r4), true).forEach(function(t6) {
                    M2(e52, t6, r4[t6]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e52, Object.getOwnPropertyDescriptors(r4)) : D2(Object(r4)).forEach(function(t6) {
                    Object.defineProperty(e52, t6, Object.getOwnPropertyDescriptor(r4, t6));
                  });
                }
                return e52;
              })({}, this.props);
              return delete t4.indeterminate, f2().createElement("input", L({}, t4, {
                ref: function(t5) {
                  e4.checkbox = t5;
                },
                type: "checkbox"
              }));
            }
          }], r3 && z(t32.prototype, r3), Object.defineProperty(t32, "prototype", {
            writable: false
          }), a2;
        })(f2().PureComponent);
        M2(U, "propTypes", {
          indeterminate: u().bool
        }), M2(U, "defaultProps", {
          indeterminate: false
        });
        const K2 = U, H = u().shape({
          check: u().node,
          uncheck: u().node,
          halfCheck: u().node,
          expandClose: u().node,
          expandOpen: u().node,
          expandAll: u().node,
          collapseAll: u().node,
          parentClose: u().node,
          parentOpen: u().node,
          leaf: u().node
        }), $ = u().shape({
          collapseAll: u().string.isRequired,
          expandAll: u().string.isRequired,
          toggle: u().string.isRequired
        });
        function V(e3) {
          return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
            return typeof e4;
          } : function(e4) {
            return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
          }, V(e3);
        }
        function W(e3, t32) {
          for (var r3 = 0; r3 < t32.length; r3++) {
            var n2 = t32[r3];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
          }
        }
        function J(e3, t32) {
          return J = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
            return e4.__proto__ = t4, e4;
          }, J(e3, t32);
        }
        function G(e3, t32) {
          if (t32 && ("object" === V(t32) || "function" == typeof t32)) return t32;
          if (void 0 !== t32) throw new TypeError("Derived constructors may only return object or undefined");
          return Y3(e3);
        }
        function Y3(e3) {
          if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e3;
        }
        function Q(e3) {
          return Q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
            return e4.__proto__ || Object.getPrototypeOf(e4);
          }, Q(e3);
        }
        function X3(e3, t32, r3) {
          return t32 in e3 ? Object.defineProperty(e3, t32, {
            value: r3,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e3[t32] = r3, e3;
        }
        var Z = (function(e3) {
          !(function(e4, t32) {
            if ("function" != typeof t32 && null !== t32) throw new TypeError("Super expression must either be null or a function");
            e4.prototype = Object.create(t32 && t32.prototype, {
              constructor: {
                value: e4,
                writable: true,
                configurable: true
              }
            }), Object.defineProperty(e4, "prototype", {
              writable: false
            }), t32 && J(e4, t32);
          })(c2, e3);
          var r3, n2, o2, i2, a2 = (o2 = c2, i2 = (function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), true;
            } catch (e4) {
              return false;
            }
          })(), function() {
            var e4, t32 = Q(o2);
            if (i2) {
              var r4 = Q(this).constructor;
              e4 = Reflect.construct(t32, arguments, r4);
            } else e4 = t32.apply(this, arguments);
            return G(this, e4);
          });
          function c2(e4) {
            var t32;
            return (function(e52, t4) {
              if (!(e52 instanceof t4)) throw new TypeError("Cannot call a class as a function");
            })(this, c2), (t32 = a2.call(this, e4)).onCheck = t32.onCheck.bind(Y3(t32)), t32.onCheckboxKeyPress = t32.onCheckboxKeyPress.bind(Y3(t32)), t32.onCheckboxKeyUp = t32.onCheckboxKeyUp.bind(Y3(t32)), t32.onClick = t32.onClick.bind(Y3(t32)), t32.onExpand = t32.onExpand.bind(Y3(t32)), t32;
          }
          return r3 = c2, (n2 = [{
            key: "onCheck",
            value: function() {
              var e4 = this.props, t32 = e4.value;
              (0, e4.onCheck)({
                value: t32,
                checked: this.getCheckState({
                  toggle: true
                })
              });
            }
          }, {
            key: "onCheckboxKeyPress",
            value: function(e4) {
              32 === e4.which && e4.preventDefault();
            }
          }, {
            key: "onCheckboxKeyUp",
            value: function(e4) {
              var t32 = e4.keyCode;
              [13, 32].includes(t32) && this.onCheck();
            }
          }, {
            key: "onClick",
            value: function() {
              var e4 = this.props, t32 = e4.expandOnClick, r4 = e4.isParent, n3 = e4.value, o3 = e4.onClick;
              r4 && t32 && this.onExpand(), o3({
                value: n3,
                checked: this.getCheckState({
                  toggle: false
                })
              });
            }
          }, {
            key: "onExpand",
            value: function() {
              var e4 = this.props, t32 = e4.expanded, r4 = e4.value;
              (0, e4.onExpand)({
                value: r4,
                expanded: !t32
              });
            }
          }, {
            key: "getCheckState",
            value: function(e4) {
              var t32 = e4.toggle, r4 = this.props, n3 = r4.checked, o3 = r4.optimisticToggle;
              return !(0 !== n3 || !t32) || 1 === n3 && !t32 || 2 === n3 && o3;
            }
          }, {
            key: "renderCollapseButton",
            value: function() {
              var e4 = this.props, t32 = e4.expandDisabled, r4 = e4.isLeaf, n3 = e4.lang;
              return r4 ? f2().createElement("span", {
                className: "rct-collapse"
              }, f2().createElement("span", {
                className: "rct-icon"
              })) : f2().createElement(j, {
                className: "rct-collapse rct-collapse-btn",
                disabled: t32,
                title: n3.toggle,
                onClick: this.onExpand
              }, this.renderCollapseIcon());
            }
          }, {
            key: "renderCollapseIcon",
            value: function() {
              var e4 = this.props, t32 = e4.expanded, r4 = e4.icons, n3 = r4.expandClose, o3 = r4.expandOpen;
              return t32 ? o3 : n3;
            }
          }, {
            key: "renderCheckboxIcon",
            value: function() {
              var e4 = this.props, t32 = e4.checked, r4 = e4.icons, n3 = r4.uncheck, o3 = r4.check, i3 = r4.halfCheck;
              return 0 === t32 ? n3 : 1 === t32 ? o3 : i3;
            }
          }, {
            key: "renderNodeIcon",
            value: function() {
              var e4 = this.props, t32 = e4.expanded, r4 = e4.icon, n3 = e4.icons, o3 = n3.leaf, i3 = n3.parentClose, a3 = n3.parentOpen, c3 = e4.isLeaf;
              return null !== r4 ? r4 : c3 ? o3 : t32 ? a3 : i3;
            }
          }, {
            key: "renderBareLabel",
            value: function(e4) {
              var t32 = this.props, r4 = t32.onClick, n3 = t32.title, o3 = null !== r4;
              return f2().createElement("span", {
                className: "rct-bare-label",
                title: n3
              }, o3 ? f2().createElement("span", {
                className: "rct-node-clickable",
                onClick: this.onClick,
                onKeyPress: this.onClick,
                role: "button",
                tabIndex: 0
              }, e4) : e4);
            }
          }, {
            key: "renderCheckboxLabel",
            value: function(e4) {
              var t32 = this.props, r4 = t32.checked, n3 = t32.disabled, o3 = t32.title, i3 = t32.treeId, a3 = t32.value, c3 = null !== t32.onClick, s2 = "".concat(i3, "-").concat(String(a3).split(" ").join("_")), l2 = [f2().createElement("label", {
                key: 0,
                htmlFor: s2,
                title: o3
              }, f2().createElement(K2, {
                checked: 1 === r4,
                disabled: n3,
                id: s2,
                indeterminate: 2 === r4,
                onClick: this.onCheck,
                onChange: function() {
                }
              }), f2().createElement("span", {
                "aria-checked": 1 === r4,
                "aria-disabled": n3,
                className: "rct-checkbox",
                role: "checkbox",
                tabIndex: 0,
                onKeyPress: this.onCheckboxKeyPress,
                onKeyUp: this.onCheckboxKeyUp
              }, this.renderCheckboxIcon()), c3 ? null : e4)];
              return c3 && l2.push(f2().createElement("span", {
                key: 1,
                className: "rct-node-clickable",
                onClick: this.onClick,
                onKeyPress: this.onClick,
                role: "link",
                tabIndex: 0
              }, e4)), l2;
            }
          }, {
            key: "renderLabel",
            value: function() {
              var e4 = this.props, t32 = e4.label, r4 = e4.showCheckbox, n3 = [e4.showNodeIcon ? f2().createElement("span", {
                key: 0,
                className: "rct-node-icon"
              }, this.renderNodeIcon()) : null, f2().createElement("span", {
                key: 1,
                className: "rct-title"
              }, t32)];
              return r4 ? this.renderCheckboxLabel(n3) : this.renderBareLabel(n3);
            }
          }, {
            key: "renderChildren",
            value: function() {
              return this.props.expanded ? this.props.children : null;
            }
          }, {
            key: "render",
            value: function() {
              var e4 = this.props, r4 = e4.className, n3 = e4.disabled, o3 = e4.expanded, i3 = e4.isLeaf, a3 = t22()({
                "rct-node": true,
                "rct-node-leaf": i3,
                "rct-node-parent": !i3,
                "rct-node-expanded": !i3 && o3,
                "rct-node-collapsed": !i3 && !o3,
                "rct-disabled": n3
              }, r4);
              return f2().createElement("li", {
                className: a3
              }, f2().createElement("span", {
                className: "rct-text"
              }, this.renderCollapseButton(), this.renderLabel()), this.renderChildren());
            }
          }]) && W(r3.prototype, n2), Object.defineProperty(r3, "prototype", {
            writable: false
          }), c2;
        })(f2().PureComponent);
        X3(Z, "propTypes", {
          checked: u().number.isRequired,
          disabled: u().bool.isRequired,
          expandDisabled: u().bool.isRequired,
          expanded: u().bool.isRequired,
          icons: H.isRequired,
          isLeaf: u().bool.isRequired,
          isParent: u().bool.isRequired,
          label: u().node.isRequired,
          lang: $.isRequired,
          optimisticToggle: u().bool.isRequired,
          showNodeIcon: u().bool.isRequired,
          treeId: u().string.isRequired,
          value: u().oneOfType([u().string, u().number]).isRequired,
          onCheck: u().func.isRequired,
          onExpand: u().func.isRequired,
          children: u().node,
          className: u().string,
          expandOnClick: u().bool,
          icon: u().node,
          showCheckbox: u().bool,
          title: u().string,
          onClick: u().func
        }), X3(Z, "defaultProps", {
          children: null,
          className: null,
          expandOnClick: false,
          icon: null,
          showCheckbox: true,
          title: null,
          onClick: function() {
          }
        });
        const ee2 = Z, te = u().oneOfType([u().arrayOf(u().string), u().arrayOf(u().number)]);
        function re2(e3, t32) {
          var r3 = Object.keys(e3);
          if (Object.getOwnPropertySymbols) {
            var n2 = Object.getOwnPropertySymbols(e3);
            t32 && (n2 = n2.filter(function(t4) {
              return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
            })), r3.push.apply(r3, n2);
          }
          return r3;
        }
        function ne2(e3) {
          for (var t32 = 1; t32 < arguments.length; t32++) {
            var r3 = null != arguments[t32] ? arguments[t32] : {};
            t32 % 2 ? re2(Object(r3), true).forEach(function(t4) {
              oe(e3, t4, r3[t4]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r3)) : re2(Object(r3)).forEach(function(t4) {
              Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(r3, t4));
            });
          }
          return e3;
        }
        function oe(e3, t32, r3) {
          return t32 in e3 ? Object.defineProperty(e3, t32, {
            value: r3,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e3[t32] = r3, e3;
        }
        var ie = {
          label: u().node.isRequired,
          value: u().oneOfType([u().string, u().number]).isRequired,
          disabled: u().bool,
          icon: u().node,
          showCheckbox: u().bool,
          title: u().string
        };
        const ae = u().oneOfType([u().shape(ie), u().shape(ne2(ne2({}, ie), {}, {
          children: u().arrayOf(ie).isRequired
        }))]);
        function ce(e3) {
          return ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
            return typeof e4;
          } : function(e4) {
            return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
          }, ce(e3);
        }
        function se(e3, t32) {
          var r3 = Object.keys(e3);
          if (Object.getOwnPropertySymbols) {
            var n2 = Object.getOwnPropertySymbols(e3);
            t32 && (n2 = n2.filter(function(t4) {
              return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
            })), r3.push.apply(r3, n2);
          }
          return r3;
        }
        function le2(e3) {
          for (var t32 = 1; t32 < arguments.length; t32++) {
            var r3 = null != arguments[t32] ? arguments[t32] : {};
            t32 % 2 ? se(Object(r3), true).forEach(function(t4) {
              ye(e3, t4, r3[t4]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(r3)) : se(Object(r3)).forEach(function(t4) {
              Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(r3, t4));
            });
          }
          return e3;
        }
        function ue(e3, t32) {
          for (var r3 = 0; r3 < t32.length; r3++) {
            var n2 = t32[r3];
            n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e3, n2.key, n2);
          }
        }
        function pe(e3, t32) {
          return pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t4) {
            return e4.__proto__ = t4, e4;
          }, pe(e3, t32);
        }
        function fe(e3, t32) {
          if (t32 && ("object" === ce(t32) || "function" == typeof t32)) return t32;
          if (void 0 !== t32) throw new TypeError("Derived constructors may only return object or undefined");
          return de(e3);
        }
        function de(e3) {
          if (void 0 === e3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e3;
        }
        function he(e3) {
          return he = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
            return e4.__proto__ || Object.getPrototypeOf(e4);
          }, he(e3);
        }
        function ye(e3, t32, r3) {
          return t32 in e3 ? Object.defineProperty(e3, t32, {
            value: r3,
            enumerable: true,
            configurable: true,
            writable: true
          }) : e3[t32] = r3, e3;
        }
        var be = (function(e3) {
          !(function(e4, t32) {
            if ("function" != typeof t32 && null !== t32) throw new TypeError("Super expression must either be null or a function");
            e4.prototype = Object.create(t32 && t32.prototype, {
              constructor: {
                value: e4,
                writable: true,
                configurable: true
              }
            }), Object.defineProperty(e4, "prototype", {
              writable: false
            }), t32 && pe(e4, t32);
          })(p2, e3);
          var r3, n2, o2, a2, l2, u2 = (a2 = p2, l2 = (function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if ("function" == typeof Proxy) return true;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), true;
            } catch (e4) {
              return false;
            }
          })(), function() {
            var e4, t32 = he(a2);
            if (l2) {
              var r4 = he(this).constructor;
              e4 = Reflect.construct(t32, arguments, r4);
            } else e4 = t32.apply(this, arguments);
            return fe(this, e4);
          });
          function p2(e4) {
            var t32;
            !(function(e52, t4) {
              if (!(e52 instanceof t4)) throw new TypeError("Cannot call a class as a function");
            })(this, p2), t32 = u2.call(this, e4);
            var r4 = new T(e4);
            return r4.flattenNodes(e4.nodes), r4.deserializeLists({
              checked: e4.checked,
              expanded: e4.expanded
            }), t32.state = {
              id: e4.id || "rct-".concat(s()),
              model: r4,
              prevProps: e4
            }, t32.onCheck = t32.onCheck.bind(de(t32)), t32.onExpand = t32.onExpand.bind(de(t32)), t32.onNodeClick = t32.onNodeClick.bind(de(t32)), t32.onExpandAll = t32.onExpandAll.bind(de(t32)), t32.onCollapseAll = t32.onCollapseAll.bind(de(t32)), t32.combineMemorized = c()(function(e52, t4) {
              return le2(le2({}, e52), t4);
            }).bind(de(t32)), t32;
          }
          return r3 = p2, n2 = [{
            key: "onCheck",
            value: function(e4) {
              var t32 = this.props, r4 = t32.checkModel, n3 = t32.noCascade, o3 = t32.onCheck, i2 = this.state.model.clone(), a3 = i2.getNode(e4.value);
              i2.toggleChecked(e4, e4.checked, r4, n3), o3(i2.serializeList("checked"), le2(le2({}, a3), e4));
            }
          }, {
            key: "onExpand",
            value: function(e4) {
              var t32 = this.props.onExpand, r4 = this.state.model.clone(), n3 = r4.getNode(e4.value);
              r4.toggleNode(e4.value, "expanded", e4.expanded), t32(r4.serializeList("expanded"), le2(le2({}, n3), e4));
            }
          }, {
            key: "onNodeClick",
            value: function(e4) {
              (0, this.props.onClick)(le2(le2({}, this.state.model.getNode(e4.value)), e4));
            }
          }, {
            key: "onExpandAll",
            value: function() {
              this.expandAllNodes();
            }
          }, {
            key: "onCollapseAll",
            value: function() {
              this.expandAllNodes(false);
            }
          }, {
            key: "expandAllNodes",
            value: function() {
              var e4 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], t32 = this.props.onExpand;
              t32(this.state.model.clone().expandAllNodes(e4).serializeList("expanded"));
            }
          }, {
            key: "determineShallowCheckState",
            value: function(e4, t32) {
              var r4 = this.state.model.getNode(e4.value);
              return r4.isLeaf || t32 || 0 === e4.children.length ? r4.checked ? 1 : 0 : this.isEveryChildChecked(e4) ? 1 : this.isSomeChildChecked(e4) ? 2 : 0;
            }
          }, {
            key: "isEveryChildChecked",
            value: function(e4) {
              var t32 = this;
              return e4.children.every(function(e52) {
                return 1 === t32.state.model.getNode(e52.value).checkState;
              });
            }
          }, {
            key: "isSomeChildChecked",
            value: function(e4) {
              var t32 = this;
              return e4.children.some(function(e52) {
                return t32.state.model.getNode(e52.value).checkState > 0;
              });
            }
          }, {
            key: "renderTreeNodes",
            value: function(e4) {
              var t32 = this, r4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n3 = this.props, o3 = n3.expandDisabled, i2 = n3.expandOnClick, a3 = n3.icons, c2 = n3.lang, s2 = n3.noCascade, l3 = n3.onClick, u3 = n3.onlyLeafCheckboxes, d2 = n3.optimisticToggle, h2 = n3.showNodeTitle, y2 = n3.showNodeIcon, b2 = this.state, v2 = b2.id, g2 = b2.model, m2 = p2.defaultProps.icons, x2 = e4.map(function(e52) {
                var n4 = e52.value, p3 = g2.getNode(e52.value), b3 = p3.isParent ? t32.renderTreeNodes(e52.children, e52) : null;
                p3.checkState = t32.determineShallowCheckState(e52, s2);
                var x3 = u3 ? p3.isLeaf : p3.showCheckbox;
                return !r4.value || g2.getNode(r4.value).expanded ? f2().createElement(ee2, {
                  key: n4,
                  checked: p3.checkState,
                  className: e52.className,
                  disabled: p3.disabled,
                  expandDisabled: o3,
                  expandOnClick: i2,
                  expanded: p3.expanded,
                  icon: e52.icon,
                  icons: t32.combineMemorized(m2, a3),
                  label: e52.label,
                  lang: c2,
                  optimisticToggle: d2,
                  isLeaf: p3.isLeaf,
                  isParent: p3.isParent,
                  showCheckbox: x3,
                  showNodeIcon: y2,
                  title: h2 ? e52.title || e52.label : e52.title,
                  treeId: v2,
                  value: e52.value,
                  onCheck: t32.onCheck,
                  onClick: l3 && t32.onNodeClick,
                  onExpand: t32.onExpand
                }, b3) : null;
              });
              return f2().createElement("ol", null, x2);
            }
          }, {
            key: "renderExpandAll",
            value: function() {
              var e4 = this.props, t32 = e4.icons, r4 = t32.expandAll, n3 = t32.collapseAll, o3 = e4.lang;
              return e4.showExpandAll ? f2().createElement("div", {
                className: "rct-options"
              }, f2().createElement(j, {
                className: "rct-option rct-option-expand-all",
                title: o3.expandAll,
                onClick: this.onExpandAll
              }, r4), f2().createElement(j, {
                className: "rct-option rct-option-collapse-all",
                title: o3.collapseAll,
                onClick: this.onCollapseAll
              }, n3)) : null;
            }
          }, {
            key: "renderHiddenInput",
            value: function() {
              var e4 = this.props, t32 = e4.name, r4 = e4.nameAsArray;
              return void 0 === t32 ? null : r4 ? this.renderArrayHiddenInput() : this.renderJoinedHiddenInput();
            }
          }, {
            key: "renderArrayHiddenInput",
            value: function() {
              var e4 = this.props, t32 = e4.checked, r4 = e4.name;
              return t32.map(function(e52) {
                var t4 = "".concat(r4, "[]");
                return f2().createElement("input", {
                  key: e52,
                  name: t4,
                  type: "hidden",
                  value: e52
                });
              });
            }
          }, {
            key: "renderJoinedHiddenInput",
            value: function() {
              var e4 = this.props, t32 = e4.checked, r4 = e4.name, n3 = t32.join(",");
              return f2().createElement("input", {
                name: r4,
                type: "hidden",
                value: n3
              });
            }
          }, {
            key: "render",
            value: function() {
              var e4, r4 = this.props, n3 = r4.direction, o3 = r4.disabled, i2 = r4.iconsClass, a3 = r4.nodes, c2 = r4.nativeCheckboxes, s2 = this.state.id, l3 = this.renderTreeNodes(a3), u3 = t22()((ye(e4 = {
                "react-checkbox-tree": true,
                "rct-disabled": o3
              }, "rct-icons-".concat(i2), true), ye(e4, "rct-native-display", c2), ye(e4, "rct-direction-rtl", "rtl" === n3), e4));
              return f2().createElement("div", {
                className: u3,
                id: s2
              }, this.renderExpandAll(), this.renderHiddenInput(), l3);
            }
          }], o2 = [{
            key: "getDerivedStateFromProps",
            value: function(e4, t32) {
              var r4 = t32.model, n3 = t32.prevProps, o3 = e4.disabled, a3 = e4.id, c2 = e4.nodes, s2 = le2(le2({}, t32), {}, {
                prevProps: e4
              });
              return r4.setProps(e4), i()(n3.nodes, c2) && n3.disabled === o3 || (r4.reset(), r4.flattenNodes(c2)), null !== a3 && (s2 = le2(le2({}, s2), {}, {
                id: a3
              })), r4.deserializeLists({
                checked: e4.checked,
                expanded: e4.expanded
              }), s2;
            }
          }], n2 && ue(r3.prototype, n2), o2 && ue(r3, o2), Object.defineProperty(r3, "prototype", {
            writable: false
          }), p2;
        })(f2().Component);
        function ve(e3) {
          return (function(e4) {
            if (Array.isArray(e4)) return ge2(e4);
          })(e3) || (function(e4) {
            if ("undefined" != typeof Symbol && null != e4[Symbol.iterator] || null != e4["@@iterator"]) return Array.from(e4);
          })(e3) || (function(e4, t32) {
            if (e4) {
              if ("string" == typeof e4) return ge2(e4, t32);
              var r3 = Object.prototype.toString.call(e4).slice(8, -1);
              return "Object" === r3 && e4.constructor && (r3 = e4.constructor.name), "Map" === r3 || "Set" === r3 ? Array.from(e4) : "Arguments" === r3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r3) ? ge2(e4, t32) : void 0;
            }
          })(e3) || (function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          })();
        }
        function ge2(e3, t32) {
          (null == t32 || t32 > e3.length) && (t32 = e3.length);
          for (var r3 = 0, n2 = new Array(t32); r3 < t32; r3++) n2[r3] = e3[r3];
          return n2;
        }
        function me(e3, t32) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
          if (r3 > t32) return [];
          var n2 = [];
          return e3.forEach(function(e4) {
            e4.children && (n2 = [].concat(ve(n2), [e4.value], ve(me(e4.children, t32, r3 + 1))));
          }), n2;
        }
        ye(be, "propTypes", {
          nodes: u().arrayOf(ae).isRequired,
          checkModel: u().oneOf([_.LEAF, _.ALL]),
          checked: te,
          direction: u().string,
          disabled: u().bool,
          expandDisabled: u().bool,
          expandOnClick: u().bool,
          expanded: te,
          icons: H,
          iconsClass: u().string,
          id: u().string,
          lang: $,
          name: u().string,
          nameAsArray: u().bool,
          nativeCheckboxes: u().bool,
          noCascade: u().bool,
          onlyLeafCheckboxes: u().bool,
          optimisticToggle: u().bool,
          showExpandAll: u().bool,
          showNodeIcon: u().bool,
          showNodeTitle: u().bool,
          onCheck: u().func,
          onClick: u().func,
          onExpand: u().func
        }), ye(be, "defaultProps", {
          checkModel: _.LEAF,
          checked: [],
          direction: "ltr",
          disabled: false,
          expandDisabled: false,
          expandOnClick: false,
          expanded: [],
          icons: {
            check: f2().createElement("span", {
              className: "rct-icon rct-icon-check"
            }),
            uncheck: f2().createElement("span", {
              className: "rct-icon rct-icon-uncheck"
            }),
            halfCheck: f2().createElement("span", {
              className: "rct-icon rct-icon-half-check"
            }),
            expandClose: f2().createElement("span", {
              className: "rct-icon rct-icon-expand-close"
            }),
            expandOpen: f2().createElement("span", {
              className: "rct-icon rct-icon-expand-open"
            }),
            expandAll: f2().createElement("span", {
              className: "rct-icon rct-icon-expand-all"
            }),
            collapseAll: f2().createElement("span", {
              className: "rct-icon rct-icon-collapse-all"
            }),
            parentClose: f2().createElement("span", {
              className: "rct-icon rct-icon-parent-close"
            }),
            parentOpen: f2().createElement("span", {
              className: "rct-icon rct-icon-parent-open"
            }),
            leaf: f2().createElement("span", {
              className: "rct-icon rct-icon-leaf"
            })
          },
          iconsClass: "fa4",
          id: null,
          lang: {
            collapseAll: "Collapse all",
            expandAll: "Expand all",
            toggle: "Toggle"
          },
          name: void 0,
          nameAsArray: false,
          nativeCheckboxes: false,
          noCascade: false,
          onlyLeafCheckboxes: false,
          optimisticToggle: true,
          showExpandAll: false,
          showNodeIcon: true,
          showNodeTitle: false,
          onCheck: function() {
          },
          onClick: null,
          onExpand: function() {
          }
        });
        const xe = be;
      })(), o;
    })());
  })(index_browser);
  return index_browser.exports;
}
var index_browserExports = requireIndex_browser();
const CheckboxTree = /* @__PURE__ */ getDefaultExportFromCjs(index_browserExports);
function _classCallCheck$1q(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1i(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1i(o.key), o);
  }
}
function _createClass$1q(e, r2, t) {
  return r2 && _defineProperties$1i(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1i(t) {
  var i = _toPrimitive$1i(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1i(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1b(t, o, e) {
  return o = _getPrototypeOf$1b(o), _possibleConstructorReturn$1j(t, _isNativeReflectConstruct$1b() ? Reflect.construct(o, e || [], _getPrototypeOf$1b(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1j(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1b(t);
}
function _assertThisInitialized$1b(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1b() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1b = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1b(t) {
  return _getPrototypeOf$1b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1b(t);
}
function _inherits$1j(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1b(t, e);
}
function _setPrototypeOf$1b(t, e) {
  return _setPrototypeOf$1b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1b(t, e);
}
let TilesetFinder = /* @__PURE__ */ (function(_React$Component) {
  function TilesetFinder2(props) {
    var _this;
    _classCallCheck$1q(this, TilesetFinder2);
    _this = _callSuper$1b(this, TilesetFinder2, [props]);
    _this.localTracks = TRACKS_INFO.filter((x) => x.local && !x.hidden).map((x) => {
      const y = {
        ...x
      };
      y.datatype = x.datatype[0];
      return y;
    });
    _this.augmentedTracksInfo = TRACKS_INFO;
    if (window.higlassTracksByType) {
      Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
        _this.augmentedTracksInfo.push(window.higlassTracksByType[pluginTrackType].config);
      });
    }
    if (props.datatype) {
      _this.localTracks = _this.localTracks.filter((x) => x.datatype[0] === props.datatype);
    } else {
      _this.localTracks = _this.localTracks.filter((x) => x.orientation === _this.props.orientation);
    }
    _this.localTracks.forEach((x) => {
      x.uuid = slugid.nice();
    });
    const newOptions = _this.prepareNewEntries("", _this.localTracks, {});
    const availableTilesetKeys = Object.keys(newOptions);
    const selectedUuid = availableTilesetKeys.length ? [availableTilesetKeys[0]] : null;
    _this.mounted = false;
    _this.state = {
      selectedUuid,
      options: newOptions,
      filter: "",
      checked: [],
      expanded: []
    };
    _this.requestTilesetLists();
    return _this;
  }
  _inherits$1j(TilesetFinder2, _React$Component);
  return _createClass$1q(TilesetFinder2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.requestTilesetLists();
      this.searchBox.focus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "prepareNewEntries",
    value: function prepareNewEntries(sourceServer, newEntries, existingOptions) {
      const newOptions = existingOptions;
      const entries = newEntries.map((ne2) => {
        const ane = {
          ...ne2,
          server: sourceServer,
          tilesetUid: ne2.uuid,
          serverUidKey: this.serverUidKey(sourceServer, ne2.uuid),
          datatype: ne2.datatype,
          name: ne2.name,
          uid: slugid.nice()
        };
        return ane;
      });
      entries.forEach((ne2) => {
        newOptions[ne2.serverUidKey] = ne2;
      });
      return newOptions;
    }
  }, {
    key: "serverUidKey",
    value: function serverUidKey(server, uid) {
      return `${server}/${uid}`;
    }
  }, {
    key: "requestTilesetLists",
    value: function requestTilesetLists() {
      let datatypesQuery = null;
      if (this.props.datatype) {
        datatypesQuery = `dt=${this.props.datatype}`;
      } else {
        const datatypes = new Set([].concat(...this.augmentedTracksInfo.filter((x) => x.datatype).filter((x) => {
          return x.orientation === this.props.orientation || this.props.orientation === "1d-vertical" && x.orientation === "1d-horizontal";
        }).map((x) => x.datatype)));
        datatypesQuery = [...datatypes].map((x) => `dt=${x}`).join("&");
      }
      if (!this.props.trackSourceServers) {
        console.warn("No track source servers specified in the viewconf");
        return;
      }
      this.props.trackSourceServers.forEach((sourceServer) => {
        api.json(`${sourceServer}/tilesets/?limit=10000&${datatypesQuery}`, (error, data2) => {
          if (error) {
            console.error("ERROR:", error);
          } else {
            const newOptions = this.prepareNewEntries(sourceServer, data2.results, this.state.options);
            const availableTilesetKeys = Object.keys(newOptions);
            let {
              selectedUuid
            } = this.state;
            if (!selectedUuid) {
              selectedUuid = availableTilesetKeys.length ? [availableTilesetKeys[0]] : null;
              const selectedTileset = this.state.options[selectedUuid[0]];
              this.props.selectedTilesetChanged([selectedTileset]);
            }
            if (this.mounted) {
              this.setState({
                selectedUuid,
                options: newOptions
              });
            }
          }
        }, this.props.pubSub);
      });
    }
    /**
     * Double clicked on an element. Should be selected
     * and this window will be closed.
     */
  }, {
    key: "handleOptionDoubleClick",
    value: function handleOptionDoubleClick(x) {
      const value = this.state.options[x.target.value];
      this.props.onDoubleClick(value);
    }
  }, {
    key: "handleSelectedOptions",
    value: function handleSelectedOptions(selectedOptions) {
      const selectedValues = [];
      const selectedTilesets = [];
      for (let i = 0; i < selectedOptions.length; i++) {
        selectedValues.push(selectedOptions[i]);
        selectedTilesets.push(this.state.options[selectedOptions[i]]);
      }
      this.props.selectedTilesetChanged(selectedTilesets);
      this.setState({
        selectedUuid: selectedValues
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect() {
      const {
        selectedOptions
      } = this.multiSelect;
      const selectedOptionsList = [];
      for (let i = 0; i < selectedOptions.length; i++) {
        const selectedOption = selectedOptions[i];
        selectedOptionsList.push(selectedOption.value);
      }
      this.handleSelectedOptions(selectedOptionsList);
    }
  }, {
    key: "handleSearchChange",
    value: function handleSearchChange() {
      const domElement = this.searchBox;
      this.setState({
        filter: domElement.value
      });
    }
    /*
     * Create the nested checkbox tree by partitioning the
     * list of available datasets according to their group
     *
     * @param {object} datasetsDict A dictionary of id -> tileset
     *  def mappings
     * @param {string} filter A string to filter the results by
     * @returns {array} A list of items that define the nested checkbox
     *  structure
     *  {
     *    'name': 'blah',
     *    'value': 'blah',
     *    'children': [],
     *  }
     */
  }, {
    key: "partitionByGroup",
    value: function partitionByGroup(datasetsDict, filter2) {
      const itemsByGroup = {
        "": {
          name: "",
          value: "",
          children: []
        }
      };
      for (const uuid of Object.keys(datasetsDict)) {
        const item = datasetsDict[uuid];
        if (!item.name.toLowerCase().includes(filter2)) {
          continue;
        }
        if ("project_name" in item) {
          const group2 = item.project_name;
          if (!(group2 in itemsByGroup)) {
            itemsByGroup[group2] = {
              value: group2,
              label: group2,
              children: []
            };
          }
          itemsByGroup[group2].children.push({
            label: item.name,
            value: uuid
          });
        } else {
          itemsByGroup[""].children.push({
            label: item.name,
            value: uuid
          });
        }
      }
      const allItems = itemsByGroup[""].children;
      for (const group2 of Object.keys(itemsByGroup)) {
        if (group2 !== "") {
          itemsByGroup[group2].children.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), "en"));
          allItems.push(itemsByGroup[group2]);
        }
      }
      allItems.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), "en"));
      return allItems;
    }
  }, {
    key: "handleChecked",
    value: function handleChecked(checked) {
      this.handleSelectedOptions(checked);
      this.setState({
        checked
      });
    }
  }, {
    key: "handleExpanded",
    value: function handleExpanded(expanded) {
      this.setState({
        expanded
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const optionsList = [];
      for (const key in this.state.options) {
        optionsList.push(this.state.options[key]);
      }
      const nestedItems = this.partitionByGroup(this.state.options, this.state.filter);
      const svgStyle = {
        width: 15,
        height: 15,
        top: 2,
        right: 2,
        position: "relative"
      };
      const halfSvgStyle = JSON.parse(JSON.stringify(svgStyle));
      halfSvgStyle.opacity = 0.5;
      const form = /* @__PURE__ */ React__default.createElement("form", {
        onSubmit: (evt) => {
          evt.preventDefault();
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "tileset-finder-search-bar"
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "tileset-finder-label"
      }, "Select tileset:"), /* @__PURE__ */ React__default.createElement("input", {
        ref: (c) => {
          this.searchBox = c;
        },
        className: "tileset-finder-search-box",
        onChange: this.handleSearchChange.bind(this),
        placeholder: "Search Term",
        type: "text"
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: "tileset-finder-checkbox-tree"
      }, /* @__PURE__ */ React__default.createElement(CheckboxTree, {
        checked: this.state.checked,
        expanded: this.state.expanded,
        icons: {
          uncheck: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Uncheck"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#square_o"
          })),
          check: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Check"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#check_square_o"
          })),
          halfCheck: /* @__PURE__ */ React__default.createElement("svg", {
            style: halfSvgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Half Check"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#check_square_o"
          })),
          leaf: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Leaf"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#file_o"
          })),
          expandClose: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Expand Close"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#chevron_right"
          })),
          expandOpen: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Expand Open "), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#chevron_down"
          })),
          parentClose: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Parent Close"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#folder_o"
          })),
          parentOpen: /* @__PURE__ */ React__default.createElement("svg", {
            style: svgStyle
          }, /* @__PURE__ */ React__default.createElement("title", null, "Parent Open"), /* @__PURE__ */ React__default.createElement("use", {
            xlinkHref: "#folder_open_o"
          }))
        },
        nodes: nestedItems,
        onCheck: this.handleChecked.bind(this),
        onExpand: this.handleExpanded.bind(this)
      })));
      return /* @__PURE__ */ React__default.createElement("div", null, form);
    }
  }]);
})(React__default.Component);
TilesetFinder.propTypes = {
  datatype: PropTypes.string,
  orientation: PropTypes.string,
  onDoubleClick: PropTypes.func,
  pubSub: PropTypes.object.isRequired,
  selectedTilesetChanged: PropTypes.func,
  trackSourceServers: PropTypes.array
};
const TilesetFinder$1 = withPubSub(TilesetFinder);
function _classCallCheck$1p(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1h(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1h(o.key), o);
  }
}
function _createClass$1p(e, r2, t) {
  return r2 && _defineProperties$1h(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1h(t) {
  var i = _toPrimitive$1h(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1h(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1a(t, o, e) {
  return o = _getPrototypeOf$1a(o), _possibleConstructorReturn$1i(t, _isNativeReflectConstruct$1a() ? Reflect.construct(o, e || [], _getPrototypeOf$1a(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1i(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1a(t);
}
function _assertThisInitialized$1a(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1a() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1a = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1a(t) {
  return _getPrototypeOf$1a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1a(t);
}
function _inherits$1i(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1a(t, e);
}
function _setPrototypeOf$1a(t, e) {
  return _setPrototypeOf$1a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1a(t, e);
}
let AddTrackDialog = /* @__PURE__ */ (function(_React$Component) {
  function AddTrackDialog2(props) {
    var _this;
    _classCallCheck$1p(this, AddTrackDialog2);
    _this = _callSuper$1a(this, AddTrackDialog2, [props]);
    _this.options = {};
    _this.state = {
      selectedTilesets: [{
        datatype: "none"
      }],
      allTracksSameDatatype: true
      // Do all selected tracks have the same datatype
    };
    _this.handleSubmitBound = _this.handleSubmit.bind(_this);
    _this.handleTilesetPickerDoubleClickBound = _this.handleTilesetPickerDoubleClick.bind(_this);
    _this.selectedTilesetsChangedBound = _this.selectedTilesetsChanged.bind(_this);
    return _this;
  }
  _inherits$1i(AddTrackDialog2, _React$Component);
  return _createClass$1p(AddTrackDialog2, [{
    key: "getOrientation",
    value: function getOrientation(position) {
      let orientation2 = null;
      if (position === "top" || position === "bottom") {
        orientation2 = "1d-horizontal";
      } else if (position === "left" || position === "right") {
        orientation2 = "1d-vertical";
      } else {
        orientation2 = "2d";
      }
      return orientation2;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(evt) {
      if (evt) evt.preventDefault();
      this.props.onTracksChosen(this.state.selectedTilesets, this.props.position, this.props.extent, this.props.host);
    }
    /**
     * The user double clicked a tileset in the tileset finder dialog.
     * This means that only one is selected.
     *
     * Arguments
     * ---------
     *  tileset: { uuid: 'CXCX', filetype: 'cooler' ....}
     */
  }, {
    key: "handleTilesetPickerDoubleClick",
    value: function handleTilesetPickerDoubleClick(tileset) {
      this.selectedTilesetsChanged([tileset]);
      this.props.onTracksChosen(this.state.selectedTilesets, this.props.position, this.props.extent, this.props.host);
    }
  }, {
    key: "handleOptionsChanged",
    value: function handleOptionsChanged(newOptions) {
      this.options = newOptions;
    }
  }, {
    key: "handlePlotTypeSelected",
    value: function handlePlotTypeSelected(newPlotType) {
      const {
        selectedTilesets
      } = this.state;
      for (const tileset of selectedTilesets) {
        tileset.type = newPlotType;
      }
      this.selectedPlotType = newPlotType;
      this.setState({
        selectedTilesets
      });
    }
  }, {
    key: "selectedTilesetsChanged",
    value: function selectedTilesetsChanged(selectedTilesetsIn) {
      let selectedTilesets = null;
      if (selectedTilesetsIn.length === 0) {
        selectedTilesets = [{
          datatype: "none"
        }];
      } else {
        selectedTilesets = selectedTilesetsIn;
      }
      let allTracksSameDatatype = true;
      const firstDatatype = selectedTilesets[0].datatype;
      for (const tileset of selectedTilesets) {
        if (tileset.datatype !== firstDatatype) {
          allTracksSameDatatype = false;
        }
      }
      if (allTracksSameDatatype) {
        for (const tileset of selectedTilesets) {
          tileset.type = this.selectedPlotType;
        }
      } else {
        for (const tileset of selectedTilesets) {
          let datatypes = [tileset.datatype];
          const orientation2 = this.getOrientation(this.props.position);
          if (tileset.filetype === "cooler") {
            datatypes = [tileset.datatype, "chromsizes"];
          }
          const availableTrackTypes = AVAILABLE_TRACK_TYPES([datatypes], orientation2);
          const defaultTrackType = getDefaultTrackForDatatype(datatypes[0], this.props.position, availableTrackTypes);
          tileset.type = defaultTrackType.type;
        }
      }
      this.setState({
        selectedTilesets,
        allTracksSameDatatype
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const orientation2 = this.getOrientation(this.props.position);
      const form = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(
        TilesetFinder$1,
        {
          ref: (c) => {
            this.tilesetFinder = c;
          },
          datatype: this.props.datatype,
          onDoubleClick: this.handleTilesetPickerDoubleClick.bind(this),
          onTracksChosen: (value) => this.props.onTracksChosen(value, this.props.position, this.props.extent),
          orientation: orientation2,
          selectedTilesetChanged: this.selectedTilesetsChanged.bind(this),
          trackSourceServers: this.props.trackSourceServers
        }
      ));
      return /* @__PURE__ */ React__default.createElement(Dialog$1, {
        maxHeight: true,
        okayTitle: "Submit",
        onCancel: this.props.onCancel,
        onOkay: this.handleSubmitBound,
        title: "Add Track"
      }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, form, /* @__PURE__ */ React__default.createElement(
        PlotTypeChooser,
        {
          ref: (c) => {
            this.plotTypeChooser = c;
          },
          allTracksSameDatatype: this.state.allTracksSameDatatype,
          datatypes: this.state.selectedTilesets.map((x) => {
            if (x.filetype === "cooler") {
              return [x.datatype, "chromsizes"];
            }
            return [x.datatype];
          }),
          onPlotTypeSelected: this.handlePlotTypeSelected.bind(this),
          orientation: orientation2,
          position: this.props.position
        }
      )));
    }
  }]);
})(React__default.Component);
AddTrackDialog.defaultProps = {
  position: "top"
};
AddTrackDialog.propTypes = {
  datatype: PropTypes.string,
  extent: PropTypes.string,
  host: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onTracksChosen: PropTypes.func.isRequired,
  position: PropTypes.string,
  trackSourceServers: PropTypes.array.isRequired
};
const {
  Provider,
  Consumer
} = /* @__PURE__ */ React__default.createContext(
  /** @type {Theme} */
  THEME_DEFAULT
);
function withTheme(Component2) {
  return /* @__PURE__ */ React__default.forwardRef((props, ref2) => /* @__PURE__ */ React__default.createElement(Consumer, null, (theme) => /* @__PURE__ */ React__default.createElement(Component2, {
    ref: ref2,
    ...props,
    theme
  })));
}
const classes$6 = {
  "track-control": "_track-control_w7hx2_1",
  "track-control-vertical": "_track-control-vertical_w7hx2_2",
  "track-control-dark": "_track-control-dark_w7hx2_15",
  "track-control-active": "_track-control-active_w7hx2_16 _track-control_w7hx2_1",
  "track-control-left": "_track-control-left_w7hx2_24",
  "track-control-padding-right": "_track-control-padding-right_w7hx2_48",
  "track-control-button": "_track-control-button_w7hx2_52",
  "track-control-button-vertical": "_track-control-button-vertical_w7hx2_81"
};
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends$c.apply(null, arguments);
}
const getClassName = (props) => clsx$2({
  [classes$6["track-control-active"]]: props.isVisible,
  [classes$6["track-control"]]: !props.isVisible,
  [classes$6["track-control-left"]]: props.isAlignLeft,
  [classes$6["track-control-vertical"]]: props.isVertical,
  [classes$6["track-control-padding-right"]]: props.paddingRight,
  [classes$6["track-control-dark"]]: props.theme === THEME_DARK
});
const getButtonClassName = (props) => clsx$2("no-zoom", classes$6["track-control-button"], {
  [classes$6["track-control-button-vertical"]]: props.isVertical
});
function TrackControl(props) {
  const {
    dragHandleProps
  } = props;
  let imgConfig;
  let imgClose;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: getClassName(props)
  }, props.isMoveable && /* @__PURE__ */ React__default.createElement("svg", _extends$c({
    className: getButtonClassName(props),
    draggable: false,
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleMove
    }
  }, dragHandleProps), /* @__PURE__ */ React__default.createElement("title", null, "Move track"), /* @__PURE__ */ React__default.createElement("use", {
    xlinkHref: "#move"
  })), props.expandCollapseAvailable && !props.isCollapsed && /* @__PURE__ */ React__default.createElement("svg", {
    ref: (c) => {
      imgConfig = c;
    },
    className: getButtonClassName(props),
    onClick: () => {
      props.onCollapseTrack(props.uid);
    },
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleSettings
    }
  }, /* @__PURE__ */ React__default.createElement("title", null, "Collapse track"), /* @__PURE__ */ React__default.createElement("use", {
    xlinkHref: "#collapse"
  })), props.expandCollapseAvailable && props.isCollapsed && /* @__PURE__ */ React__default.createElement("svg", {
    ref: (c) => {
      imgConfig = c;
    },
    className: getButtonClassName(props),
    onClick: () => {
      props.onExpandTrack(props.uid);
    },
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleSettings
    }
  }, /* @__PURE__ */ React__default.createElement("title", null, "Expand track"), /* @__PURE__ */ React__default.createElement("use", {
    xlinkHref: "#expand"
  })), /* @__PURE__ */ React__default.createElement("svg", {
    ref: (c) => {
      imgConfig = c;
    },
    className: getButtonClassName(props),
    onClick: () => {
      props.onConfigTrackMenuOpened(props.uid, imgConfig.getBoundingClientRect());
    },
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleSettings
    }
  }, /* @__PURE__ */ React__default.createElement("title", null, "Configure track"), /* @__PURE__ */ React__default.createElement("use", {
    xlinkHref: "#cog"
  })), props.onAddSeries && /* @__PURE__ */ React__default.createElement("svg", {
    className: getButtonClassName(props),
    onClick: () => props.onAddSeries(props.uid),
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleAdd
    }
  }, /* @__PURE__ */ React__default.createElement("title", null, "Add series"), /* @__PURE__ */ React__default.createElement("use", {
    xlinkHref: "#plus"
  })), /* @__PURE__ */ React__default.createElement("svg", {
    ref: (c) => {
      imgClose = c;
    },
    className: getButtonClassName(props),
    onClick: () => {
      props.onCloseTrackMenuOpened(props.uid, imgClose.getBoundingClientRect());
    },
    style: {
      height: "20px",
      width: "20px",
      ...props.imgStyleClose
    }
  }, /* @__PURE__ */ React__default.createElement("title", null, "Close track"), /* @__PURE__ */ React__default.createElement("use", {
    xlinkHref: "#cross"
  })));
}
TrackControl.propTypes = {
  imgStyleAdd: PropTypes.object,
  imgStyleClose: PropTypes.object,
  imgStyleMove: PropTypes.object,
  imgStyleSettings: PropTypes.object,
  isAlignLeft: PropTypes.bool,
  isMoveable: PropTypes.bool,
  isVertical: PropTypes.bool,
  isVisible: PropTypes.bool,
  onCollapseTrack: PropTypes.func,
  onExpandTrack: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onAddSeries: PropTypes.func,
  paddingRight: PropTypes.bool,
  theme: PropTypes.symbol.isRequired,
  uid: PropTypes.string
};
const TrackControl$1 = withTheme(TrackControl);
const stylesCenterTrack = {
  "center-track": "_center-track_fiu64_1",
  "center-track-container": "_center-track-container_fiu64_6"
};
const stylesTrack = {
  "track-range-selection": "_track-range-selection_5bcsr_1",
  "track-range-selection-active": "_track-range-selection-active_5bcsr_8 _track-range-selection_5bcsr_1",
  "track-range-selection-active-primary": "_track-range-selection-active-primary_5bcsr_14 _track-range-selection-active_5bcsr_8 _track-range-selection_5bcsr_1",
  "track-range-selection-active-secondary": "_track-range-selection-active-secondary_5bcsr_18 _track-range-selection-active_5bcsr_8 _track-range-selection_5bcsr_1",
  "track-range-selection-group-inactive": "_track-range-selection-group-inactive_5bcsr_22",
  "track-range-selection-group-brush-selection": "_track-range-selection-group-brush-selection_5bcsr_26"
};
function _classCallCheck$1o(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1g(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1g(o.key), o);
  }
}
function _createClass$1o(e, r2, t) {
  return r2 && _defineProperties$1g(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1g(t) {
  var i = _toPrimitive$1g(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1g(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$19(t, o, e) {
  return o = _getPrototypeOf$19(o), _possibleConstructorReturn$1h(t, _isNativeReflectConstruct$19() ? Reflect.construct(o, e || [], _getPrototypeOf$19(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1h(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$19(t);
}
function _assertThisInitialized$19(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$19() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$19 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$19(t) {
  return _getPrototypeOf$19 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$19(t);
}
function _inherits$1h(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$19(t, e);
}
function _setPrototypeOf$19(t, e) {
  return _setPrototypeOf$19 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$19(t, e);
}
const STYLES$3 = {
  pointerEvents: "all"
};
function sourceEvent$2(event) {
  return event?.sourceEvent;
}
let CenterTrack = /* @__PURE__ */ (function(_React$Component) {
  function CenterTrack2(props) {
    var _this;
    _classCallCheck$1o(this, CenterTrack2);
    _this = _callSuper$19(this, CenterTrack2, [props]);
    _this.state = {
      isVisible: false
    };
    _this.brushBehaviorX = brushX().on("brush", _this.brushedX.bind(_this)).on("end", _this.brushedXEnded.bind(_this));
    _this.brushBehaviorY = brushY().on("brush", _this.brushedY.bind(_this)).on("end", _this.brushedYEnded.bind(_this));
    _this.brushBehaviorXY = brush().on("start", _this.brushStarted.bind(_this)).on("brush", _this.brushedXY.bind(_this)).on("end", _this.brushedXYEnded.bind(_this));
    return _this;
  }
  _inherits$1h(CenterTrack2, _React$Component);
  return _createClass$1o(CenterTrack2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush2d();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.rangeSelectionTriggeredXY) {
        this.rangeSelectionTriggeredXY = false;
        if (this.rangeSelectionTriggeredXYEnd) {
          const dim1 = nextProps.rangeSelection[0] || null;
          this.moveBrushXY([dim1, nextProps.rangeSelection[1]], true);
          this.rangeSelectionTriggeredXYEnd = false;
        }
        return this.state !== nextState;
      }
      if (this.props.rangeSelection !== nextProps.rangeSelection) {
        const dim1 = nextProps.rangeSelection[0] || null;
        if (this.props.is1dRangeSelection) {
          if (!this.rangeSelectionTriggeredX) {
            this.moveBrushX(dim1, nextProps.rangeSelectionEnd);
          }
          if (this.rangeSelectionTriggeredXEnd) {
            this.moveBrushX(dim1, nextProps.rangeSelectionEnd, true);
          }
          if (!this.rangeSelectionTriggeredY) {
            this.moveBrushY(dim1, nextProps.rangeSelectionEnd);
          }
          if (this.rangeSelectionTriggeredYEnd) {
            this.moveBrushY(dim1, nextProps.rangeSelectionEnd, true);
          }
          this.rangeSelectionTriggeredX = false;
          this.rangeSelectionTriggeredXEnd = false;
          this.rangeSelectionTriggeredY = false;
          this.rangeSelectionTriggeredYEnd = false;
        } else {
          this.moveBrushXY([dim1, nextProps.rangeSelection[1]], nextProps.rangeSelectionEnd);
        }
        const isUnset = this.props.is1dRangeSelection && !nextProps.is1dRangeSelection && dim1 === null;
        return this.state !== nextState || isUnset;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush2d();
      } else {
        this.removeBrush1d();
        this.removeBrush2d();
      }
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "addBrush1d",
    value: function addBrush1d() {
      if (!this.brushElX || !this.brushElY || this.brushElXOld === this.brushElX && this.brushElYOld === this.brushElY) {
        return;
      }
      if (this.brushElXOld) {
        this.brushElXOld.on(".brush", null);
      }
      if (this.brushElYOld) {
        this.brushElYOld.on(".brush", null);
      }
      this.brushElX.call(this.brushBehaviorX);
      this.brushElY.call(this.brushBehaviorY);
      resetD3BrushStyle(this.brushElX, stylesTrack["track-range-selection-group-brush-selection"]);
      resetD3BrushStyle(this.brushElY, stylesTrack["track-range-selection-group-brush-selection"]);
      this.brushElXOld = this.brushElX;
      this.brushElYOld = this.brushElY;
      this.brushIs1dBound = true;
    }
  }, {
    key: "addBrush2d",
    value: function addBrush2d() {
      if (!this.brushElXY || this.brushElXYOld === this.brushElXY) {
        return;
      }
      if (this.brushElXYOld) {
        this.brushElXYOld.on(".brush", null);
      }
      this.brushElXY.call(this.brushBehaviorXY);
      this.brushElXYOld = this.brushElXY;
      this.brushIs2dBound = true;
      resetD3BrushStyle(this.brushElXY, stylesTrack["track-range-selection-group-brush-selection"]);
    }
  }, {
    key: "brushedX",
    value: function brushedX(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionX || !this.props.is1dRangeSelection || rangeSelectionMoved) return;
      this.rangeSelectionTriggeredX = true;
      this.props.onRangeSelectionX(event.selection);
    }
  }, {
    key: "brushedXEnded",
    value: function brushedXEnded(event) {
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionX || !this.props.is1dRangeSelection || rangeSelectionMovedEnd) return;
      this.rangeSelectionTriggeredX = true;
      this.rangeSelectionTriggeredXEnd = true;
      this.props.onRangeSelectionXEnd(event.selection);
    }
  }, {
    key: "brushedY",
    value: function brushedY(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionY || !this.props.is1dRangeSelection || rangeSelectionMoved) return;
      this.rangeSelectionTriggeredY = true;
      this.props.onRangeSelectionY(event.selection);
    }
  }, {
    key: "brushedYEnded",
    value: function brushedYEnded(event) {
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionY || !this.props.is1dRangeSelection || rangeSelectionMovedEnd) return;
      this.rangeSelectionTriggeredY = true;
      this.rangeSelectionTriggeredYEnd = true;
      this.props.onRangeSelectionYEnd(event.selection);
    }
  }, {
    key: "brushedXY",
    value: function brushedXY(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$2(event) || !this.props.onRangeSelectionXY || rangeSelectionMoved || this.props.is1dRangeSelection) return;
      this.rangeSelectionTriggeredXY = true;
      this.props.onRangeSelectionXY([[event.selection[0][0], event.selection[1][0]], [event.selection[0][1], event.selection[1][1]]]);
    }
  }, {
    key: "brushedXYEnded",
    value: function brushedXYEnded(event) {
      if (this.props.is1dRangeSelection) return;
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (event.selection && event.sourceEvent && this.props.onRangeSelectionXY && !rangeSelectionMovedEnd) {
        this.rangeSelectionTriggeredXY = true;
        this.rangeSelectionTriggeredXYEnd = true;
        this.props.onRangeSelectionXYEnd([[event.selection[0][0], event.selection[1][0]], [event.selection[0][1], event.selection[1][1]]]);
      }
      if (!event.selection) {
        this.rangeSelectionTriggeredXY = true;
        this.props.onRangeSelectionReset();
      }
    }
  }, {
    key: "brushStarted",
    value: function brushStarted(event) {
      if (!sourceEvent$2(event)) return;
      this.props.onRangeSelectionStart();
    }
  }, {
    key: "moveBrushX",
    value: function moveBrushX(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      if (this.brushIs2dBound) {
        this.removeBrush2d();
        this.addBrush1d();
      }
      const relRangeX = rangeSelection ? [this.props.scaleX(rangeSelection[0]), this.props.scaleX(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushElX.transition().call(this.brushBehaviorX.move, relRangeX);
      } else {
        this.brushElX.call(this.brushBehaviorX.move, relRangeX);
      }
    }
  }, {
    key: "moveBrushY",
    value: function moveBrushY(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      if (this.brushIs2dBound) {
        this.removeBrush2d();
        this.addBrush1d();
      }
      const relRangeY = rangeSelection ? [this.props.scaleY(rangeSelection[0]), this.props.scaleY(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushElY.transition().call(this.brushBehaviorY.move, relRangeY);
      } else {
        this.brushElY.call(this.brushBehaviorY.move, relRangeY);
      }
    }
  }, {
    key: "moveBrushXY",
    value: function moveBrushXY(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      const relRange = [[this.props.scaleX(rangeSelection[0][0]), this.props.scaleY(rangeSelection[1][0])], [this.props.scaleX(rangeSelection[0][1]), this.props.scaleY(rangeSelection[1][1])]];
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushElXY.transition().call(this.brushBehaviorXY.move, relRange);
      } else {
        this.brushElXY.call(this.brushBehaviorXY.move, relRange);
      }
    }
  }, {
    key: "mouseEnterHandler",
    value: function mouseEnterHandler() {
      if (this.props.isRangeSelectionActive) return;
      this.setState({
        isVisible: true
      });
    }
  }, {
    key: "mouseLeaveHandler",
    value: function mouseLeaveHandler() {
      this.setState({
        isVisible: false
      });
    }
  }, {
    key: "removeBrush1d",
    value: function removeBrush1d() {
      if (!this.brushIs1dBound) {
        return;
      }
      if (this.brushElX) {
        this.brushElX.call(this.brushBehaviorX.move, null);
        this.brushElX.on(".brush", null);
      }
      if (this.brushElY) {
        this.brushElY.call(this.brushBehaviorY.move, null);
        this.brushElY.on(".brush", null);
      }
      this.brushIs1dBound = false;
    }
  }, {
    key: "removeBrush2d",
    value: function removeBrush2d() {
      if (!this.brushIs2dBound) {
        return;
      }
      if (this.brushElXY) {
        this.brushElXY.call(this.brushBehaviorXY.move, null);
        this.brushElXY.on(".brush", null);
        this.brushElXYOld = void 0;
        this.brushIs2dBound = false;
        if (!this.props.is1dRangeSelection) this.props.onRangeSelectionReset();
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const isBrushable = this.props.tracks.map((track) => IS_TRACK_RANGE_SELECTABLE(track)).reduce(or$1, false);
      const menuClash = this.props.tracks.some((track) => {
        if (track.contents) {
          return track.contents.some((subTrack) => {
            if (subTrack.type === "heatmap") {
              return subTrack.options.colorbarPosition === "topRight";
            }
            return false;
          });
        }
        if (track.type === "heatmap") {
          return track.options.colorbarPosition === "topRight";
        }
        return false;
      });
      let rangeSelectorName = "track-range-selection";
      if (this.props.isRangeSelectionActive) {
        rangeSelectorName += this.props.is1dRangeSelection ? "-active-secondary" : "-active-primary";
      }
      const rangeSelectorGroup1dClass = clsx$2(!this.props.is1dRangeSelection && stylesTrack["track-range-selection-group-inactive"]);
      const rangeSelectorGroup2dClass = clsx$2(this.props.is1dRangeSelection && stylesTrack["track-range-selection-group-inactive"]);
      return /* @__PURE__ */ React__default.createElement("div", {
        className: clsx$2(this.props.className, stylesCenterTrack["center-track"]),
        onMouseEnter: this.mouseEnterHandler.bind(this),
        onMouseLeave: this.mouseLeaveHandler.bind(this),
        style: {
          height: this.props.height,
          width: this.props.width
        }
      }, isBrushable && /* @__PURE__ */ React__default.createElement("svg", {
        className: stylesTrack[rangeSelectorName],
        style: {
          height: this.props.height,
          width: this.props.width
        },
        xmlns: "http://www.w3.org/2000/svg"
      }, /* @__PURE__ */ React__default.createElement("title", null, "Range Selection Brush"), /* @__PURE__ */ React__default.createElement("g", {
        ref: (el2) => {
          this.brushElX = select(el2);
        },
        className: rangeSelectorGroup1dClass
      }), /* @__PURE__ */ React__default.createElement("g", {
        ref: (el2) => {
          this.brushElY = select(el2);
        },
        className: rangeSelectorGroup1dClass
      }), /* @__PURE__ */ React__default.createElement("g", {
        ref: (el2) => {
          this.brushElXY = select(el2);
        },
        className: rangeSelectorGroup2dClass
      })), this.props.editable && // show track controls if config menu is visible or
      // mouse is within the bounds of the track
      /* @__PURE__ */ React__default.createElement(
        TrackControl$1,
        {
          expandCollapseAvailable: false,
          imgStyleAdd: STYLES$3,
          imgStyleClose: STYLES$3,
          imgStyleMove: STYLES$3,
          imgStyleSettings: STYLES$3,
          isMoveable: false,
          isVisible: this.state.isVisible || this.props.uid === this.props.configTrackMenuId,
          onAddSeries: this.props.onAddSeries,
          onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
          onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
          paddingRight: menuClash,
          uid: this.props.uid
        }
      ));
    }
  }]);
})(React__default.Component);
CenterTrack.defaultProps = {
  className: "center-track",
  configTrackMenuId: null,
  is1dRangeSelection: false,
  rangeSelectionEnd: PropTypes.bool,
  isRangeSelectionActive: false,
  scaleX: (x) => x,
  scaleY: (x) => x
};
CenterTrack.propTypes = {
  className: PropTypes.string,
  configTrackMenuId: PropTypes.string,
  editable: PropTypes.bool,
  height: PropTypes.number.isRequired,
  is1dRangeSelection: PropTypes.bool,
  isRangeSelectionActive: PropTypes.bool,
  onAddSeries: PropTypes.func.isRequired,
  onCloseTrackMenuOpened: PropTypes.func.isRequired,
  onConfigTrackMenuOpened: PropTypes.func.isRequired,
  onRangeSelectionX: PropTypes.func.isRequired,
  onRangeSelectionXEnd: PropTypes.func.isRequired,
  onRangeSelectionY: PropTypes.func.isRequired,
  onRangeSelectionYEnd: PropTypes.func.isRequired,
  onRangeSelectionXY: PropTypes.func.isRequired,
  onRangeSelectionXYEnd: PropTypes.func.isRequired,
  onRangeSelectionReset: PropTypes.func.isRequired,
  onRangeSelectionStart: PropTypes.func.isRequired,
  rangeSelection: PropTypes.array.isRequired,
  rangeSelectionEnd: PropTypes.bool,
  scaleX: PropTypes.func,
  scaleY: PropTypes.func,
  tracks: PropTypes.array.isRequired,
  uid: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired
};
const classes$5 = {
  "context-menu": "_context-menu_18ock_1",
  "context-menu-dark": "_context-menu-dark_18ock_12",
  "context-menu-icon": "_context-menu-icon_18ock_17",
  "context-menu-item": "_context-menu-item_18ock_27",
  "context-menu-hr": "_context-menu-hr_18ock_38",
  "play-icon": "_play-icon_18ock_45",
  "context-menu-span": "_context-menu-span_18ock_52"
};
function ContextMenuItem({
  onMouseEnter = () => void 0,
  onMouseLeave = () => void 0,
  onClick,
  className,
  children: children2
}) {
  return /* @__PURE__ */ React__default.createElement("div", {
    "data-menu-item-for": typeof children2 === "string" ? children2 : null,
    className: clsx$2(classes$5["context-menu-item"], className),
    onClick: (e) => onClick(e),
    onMouseEnter: (e) => onMouseEnter(e),
    onMouseLeave: (e) => onMouseLeave(e),
    role: "button",
    tabIndex: 0
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: classes$5["context-menu-span"]
  }, children2));
}
ContextMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
const getAllTracksAndSubtracks = (tracks2) => {
  let series = [];
  for (const track of tracks2) {
    if (track.contents) {
      series = series.concat(track.contents);
    } else {
      series.push(track);
    }
  }
  return series;
};
const getSeriesItems = (tracks2, onItemMouseEnter, onItemMouseLeave, onItemClick) => {
  if (!tracks2) return null;
  if (window.higlassTracksByType) {
    Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
      TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
    });
  }
  return getAllTracksAndSubtracks(tracks2).map((x) => {
    const thumbnail = TRACKS_INFO_BY_TYPE[x.type] ? TRACKS_INFO_BY_TYPE[x.type].thumbnail : null;
    const imgTag = thumbnail ? /* @__PURE__ */ React__default.createElement("div", {
      className: classes$5["context-menu-icon"],
      dangerouslySetInnerHTML: {
        __html: thumbnail.outerHTML
      }
    }) : /* @__PURE__ */ React__default.createElement("div", {
      className: classes$5["context-menu-icon"]
    }, /* @__PURE__ */ React__default.createElement("svg", null));
    return /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
      key: x.uid,
      className: classes$5["context-menu-item"],
      onClick: () => {
        if (onItemClick) onItemClick(x.uid);
      },
      onMouseEnter: (e) => {
        if (onItemMouseEnter) onItemMouseEnter(e, x);
      },
      onMouseLeave: (e) => {
        if (onItemMouseLeave) onItemMouseLeave(e);
      }
    }, imgTag, /* @__PURE__ */ React__default.createElement("span", {
      className: classes$5["context-menu-span"]
    }, x.options?.name?.length ? x.options.name : x.type, onItemMouseEnter && onItemMouseLeave ? /* @__PURE__ */ React__default.createElement("svg", {
      className: classes$5["play-icon"]
    }, /* @__PURE__ */ React__default.createElement("title", null, "Play"), /* @__PURE__ */ React__default.createElement("use", {
      xlinkHref: "#play"
    })) : null));
  });
};
function CloseTrackMenu(props) {
  return /* @__PURE__ */ React__default.createElement("div", null, getSeriesItems(props.tracks, null, null, props.onCloseTrack), /* @__PURE__ */ React__default.createElement("hr", {
    className: classes$5["context-menu-hr"]
  }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
    onClick: () => props.onCloseTrack(props.tracks[0].uid)
  }, "Close all series"));
}
CloseTrackMenu.propTypes = {
  onCloseTrack: PropTypes.func.isRequired,
  tracks: PropTypes.array.isRequired
};
function _classCallCheck$1n(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1f(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1f(o.key), o);
  }
}
function _createClass$1n(e, r2, t) {
  return r2 && _defineProperties$1f(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1f(t) {
  var i = _toPrimitive$1f(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1f(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
const _appliedMixin = "__mixwith_appliedMixin";
const _wrappedMixin = "__mixwith_wrappedMixin";
const unwrap = (wrapper) => wrapper[_wrappedMixin] || wrapper;
const apply$1 = (superclass, mixin2) => {
  const application = mixin2(superclass);
  application.prototype[_appliedMixin] = unwrap(mixin2);
  return application;
};
const isApplicationOf = (proto2, mixin2) => (
  // biome-ignore lint/suspicious/noPrototypeBuiltins:
  proto2.hasOwnProperty(_appliedMixin) && proto2[_appliedMixin] === unwrap(mixin2)
);
const hasMixin = (o, mixin2) => {
  while (o !== null) {
    if (isApplicationOf(o, mixin2)) return true;
    o = Object.getPrototypeOf(o);
  }
  return false;
};
const wrap = (mixin2, wrapper) => {
  Object.setPrototypeOf(wrapper, mixin2);
  if (!mixin2[_wrappedMixin]) {
    mixin2[_wrappedMixin] = mixin2;
  }
  return wrapper;
};
const _cachedApplications = "__mixwith_cachedApplications";
const Cached = (mixin2) => wrap(mixin2, (superclass) => {
  let cachedApplications = superclass[_cachedApplications];
  if (!cachedApplications) {
    superclass[_cachedApplications] = /* @__PURE__ */ new Map();
    cachedApplications = superclass[_cachedApplications];
  }
  let application = cachedApplications.get(mixin2);
  if (!application) {
    application = mixin2(superclass);
    cachedApplications.set(mixin2, application);
  }
  return application;
});
const DeDupe = (mixin2) => wrap(mixin2, (superclass) => hasMixin(superclass.prototype, mixin2) ? superclass : mixin2(superclass));
const BareMixin = (mixin2) => wrap(mixin2, (s) => apply$1(s, mixin2));
const Mixin = (mixin2) => DeDupe(Cached(BareMixin(mixin2)));
let MixinBuilder = /* @__PURE__ */ (function() {
  function MixinBuilder2(superclass) {
    _classCallCheck$1n(this, MixinBuilder2);
    this.superclass = superclass || /* @__PURE__ */ _createClass$1n(function _class() {
      _classCallCheck$1n(this, _class);
    });
  }
  return _createClass$1n(MixinBuilder2, [{
    key: "with",
    value: function _with(...mixins) {
      return mixins.reduce((c, m) => m(c), this.superclass);
    }
  }]);
})();
const mix = (superclass) => new MixinBuilder(superclass);
function _classCallCheck$1m(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1e(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1e(o.key), o);
  }
}
function _createClass$1m(e, r2, t) {
  return r2 && _defineProperties$1e(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1e(t) {
  var i = _toPrimitive$1e(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1e(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$18(t, o, e) {
  return o = _getPrototypeOf$18(o), _possibleConstructorReturn$1g(t, _isNativeReflectConstruct$18() ? Reflect.construct(o, e || [], _getPrototypeOf$18(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1g(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$18(t);
}
function _assertThisInitialized$18(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$18() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$18 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$18(t) {
  return _getPrototypeOf$18 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$18(t);
}
function _inherits$1g(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$18(t, e);
}
function _setPrototypeOf$18(t, e) {
  return _setPrototypeOf$18 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$18(t, e);
}
const TRACK_CONTROL_HEIGHT = 20;
let ContextMenuContainer = /* @__PURE__ */ (function(_React$Component) {
  function ContextMenuContainer2(props) {
    var _this;
    _classCallCheck$1m(this, ContextMenuContainer2);
    _this = _callSuper$18(this, ContextMenuContainer2, [props]);
    _this.adjusted = false;
    _this.state = {
      orientation: _this.props.orientation ? _this.props.orientation : "right",
      left: _this.props.position.left,
      top: _this.props.position.top,
      submenuShown: null
    };
    return _this;
  }
  _inherits$1g(ContextMenuContainer2, _React$Component);
  return _createClass$1m(ContextMenuContainer2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateOrientation();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.adjusted = false;
      this.setState({
        left: newProps.position.left,
        top: newProps.position.top
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateOrientation();
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "handleItemMouseEnterWithRect",
    value: function handleItemMouseEnterWithRect(clientRect, series) {
      this.setState({
        submenuShown: series,
        submenuSourceBbox: clientRect
      });
    }
    /**
     * @param {React.MouseEvent} evt
     */
  }, {
    key: "handleItemMouseEnter",
    value: function handleItemMouseEnter(evt, series) {
      this.handleItemMouseEnterWithRect(evt.currentTarget.getBoundingClientRect(), series);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
    }
  }, {
    key: "handleOtherMouseEnter",
    value: function handleOtherMouseEnter() {
      this.setState({
        submenuShown: null
      });
    }
    /*
    handleSeriesMouseEnter(evt, uid) {
      let domNode = evt.currentTarget;
       this.setState({
        submenuShown: uid,
        submenuSourceBbox: domNode.getBoundingClientRect()
      });
    }
     handleMouseLeave(evt) {
      return;
    }
     handleOtherMouseEnter(evt) {
      this.setState({
        submenuShown: null
      });
    }
    */
  }, {
    key: "updateOrientation",
    value: function updateOrientation() {
      if (this.adjusted) return;
      this.adjusted = true;
      const bbox = this.div.getBoundingClientRect();
      const parentBbox = this.props.parentBbox ? this.props.parentBbox : {
        top: this.props.position.top,
        left: this.props.position.left,
        width: 0
      };
      let orientation2 = this.state.orientation;
      let topPosition = parentBbox.top;
      if (parentBbox.top + bbox.height > window.innerHeight) {
        if (parentBbox.top - bbox.height > 0) {
          topPosition = parentBbox.top - bbox.height + TRACK_CONTROL_HEIGHT;
        } else {
          topPosition = parentBbox.top - bbox.height + TRACK_CONTROL_HEIGHT;
          topPosition -= topPosition + bbox.height - window.innerHeight;
        }
      }
      if (this.state.orientation === "left") {
        let leftPosition = parentBbox.left - bbox.width;
        if (leftPosition < 0) {
          if (parentBbox.left + parentBbox.width + bbox.width > window.innerWidth) {
            leftPosition = 0;
          } else {
            leftPosition = parentBbox.left + parentBbox.width;
            orientation2 = "right";
          }
        }
        this.setState({
          left: leftPosition,
          top: topPosition,
          orientation: orientation2
        });
      } else {
        let leftPosition = parentBbox.left + parentBbox.width;
        if (parentBbox.left + parentBbox.width + bbox.width > window.innerWidth) {
          if (parentBbox.left - bbox.width < 0) {
            leftPosition = 0;
            orientation2 = "right";
          } else {
            leftPosition = parentBbox.left - bbox.width;
            orientation2 = "left";
          }
        }
        this.setState({
          left: leftPosition,
          top: topPosition,
          orientation: orientation2
        });
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const stylePosition = this.state.left ? {
        left: this.state.left
      } : {
        right: this.state.right
      };
      const otherStyle = {
        top: this.state.top
      };
      const wholeStyle = Object.assign(stylePosition, otherStyle);
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.div = c;
        },
        className: clsx$2("context-menu-item", classes$5["context-menu"], {
          [classes$5["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        style: wholeStyle
      }, this.props.children);
    }
  }]);
})(React__default.Component);
ContextMenuContainer.propTypes = {
  children: PropTypes.node,
  orientation: PropTypes.string,
  parentBbox: PropTypes.object,
  position: PropTypes.object,
  theme: PropTypes.symbol.isRequired
};
function _classCallCheck$1l(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1d(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1d(o.key), o);
  }
}
function _createClass$1l(e, r2, t) {
  return r2 && _defineProperties$1d(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1d(t) {
  var i = _toPrimitive$1d(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1d(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$17(t, o, e) {
  return o = _getPrototypeOf$17(o), _possibleConstructorReturn$1f(t, _isNativeReflectConstruct$17() ? Reflect.construct(o, e || [], _getPrototypeOf$17(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1f(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$17(t);
}
function _assertThisInitialized$17(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$17() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$17 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$17(t) {
  return _getPrototypeOf$17 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$17(t);
}
function _inherits$1f(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$17(t, e);
}
function _setPrototypeOf$17(t, e) {
  return _setPrototypeOf$17 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$17(t, e);
}
let NestedContextMenu = /* @__PURE__ */ (function(_ContextMenuContainer) {
  function NestedContextMenu2() {
    _classCallCheck$1l(this, NestedContextMenu2);
    return _callSuper$17(this, NestedContextMenu2, arguments);
  }
  _inherits$1f(NestedContextMenu2, _ContextMenuContainer);
  return _createClass$1l(NestedContextMenu2, [{
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        const position = this.state.orientation === "left" ? {
          left: this.state.left,
          top: bbox.top
        } : {
          left: this.state.left + bbox.width + 7,
          top: bbox.top
        };
        const menuItem = this.state.submenuShown;
        return /* @__PURE__ */ React__default.createElement(NestedContextMenu2, {
          menuItems: menuItem.children,
          orientation: this.state.orientation,
          parentBbox: bbox,
          position,
          theme: this.props.theme
        });
      }
      return /* @__PURE__ */ React__default.createElement("div", null);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
    }
  }, {
    key: "render",
    value: function render3() {
      const menuItems = [];
      for (const menuItemKey in this.props.menuItems) {
        const menuItem = this.props.menuItems[menuItemKey];
        menuItems.push(/* @__PURE__ */ React__default.createElement(ContextMenuItem, {
          key: menuItemKey,
          onClick: menuItem.handler ? menuItem.handler : () => null,
          onMouseEnter: menuItem.children ? (e) => this.handleItemMouseEnter(e, menuItem) : this.handleOtherMouseEnter.bind(this),
          onMouseLeave: this.handleMouseLeave
        }, menuItem.name, menuItem.children && /* @__PURE__ */ React__default.createElement("svg", {
          className: classes$5["play-icon"]
        }, /* @__PURE__ */ React__default.createElement("title", null, "Play"), /* @__PURE__ */ React__default.createElement("use", {
          xlinkHref: "#play"
        }))));
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.div = c;
        },
        className: clsx$2(classes$5["context-menu"], {
          [classes$5["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, menuItems, this.getSubmenu());
    }
  }]);
})(ContextMenuContainer);
var lib$1 = {};
var flattenNames = {};
var freeGlobal = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var Symbol$1 = root.Symbol;
var objectProto$f = Object.prototype;
var hasOwnProperty$c = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var isArray = Array.isArray;
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var stringTag$4 = "[object String]";
function isString(value) {
  return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag$4;
}
const isString$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: isString
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(isString$1);
function createBaseFor(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length2 = props.length;
    while (length2--) {
      var key = props[++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var baseFor = createBaseFor();
function baseTimes(n, iteratee) {
  var index2 = -1, result = Array(n);
  while (++index2 < n) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}
var objectProto$d = Object.prototype;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;
var isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$b.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$2 = moduleExports$2 ? root.Buffer : void 0;
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length2) {
  var type2 = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER$1 : length2;
  return !!length2 && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length2;
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$2 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$2] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = (function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
})();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var objectProto$c = Object.prototype;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$a.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$b = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto$b;
  return value === proto2;
}
function overArg(func, transform2) {
  return function(arg) {
    return func(transform2(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
var objectProto$a = Object.prototype;
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$9.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function isObject(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
function keys$1(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function baseForOwn(object2, iteratee) {
  return object2 && baseFor(object2, iteratee, keys$1);
}
function identity$3(value) {
  return value;
}
function castFunction(value) {
  return typeof value == "function" ? value : identity$3;
}
function forOwn(object2, iteratee) {
  return object2 && baseForOwn(object2, castFunction(iteratee));
}
const forOwn$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: forOwn
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(forOwn$1);
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectTag$3 = "[object Object]";
var funcProto$2 = Function.prototype, objectProto$9 = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto2 = getPrototype(value);
  if (proto2 === null) {
    return true;
  }
  var Ctor = hasOwnProperty$8.call(proto2, "constructor") && proto2.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
const isPlainObject$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: isPlainObject
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(isPlainObject$1);
function arrayMap(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function assocIndexOf(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
})();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$8 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern2 = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern2.test(toSource(value));
}
function getValue(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var Map$2 = getNative(root, "Map");
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function hashGet(key) {
  var data2 = this.__data__;
  if (nativeCreate) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data2, key) ? data2[key] : void 0;
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function hashHas(key) {
  var data2 = this.__data__;
  return nativeCreate ? data2[key] !== void 0 : hasOwnProperty$5.call(data2, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map2, key) {
  var data2 = map2.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data2 = getMapData(this, key), size = data2.size;
  data2.set(key, value);
  this.size += data2.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache) {
    var pairs2 = data2.__data__;
    if (!Map$2 || pairs2.length < LARGE_ARRAY_SIZE - 1) {
      pairs2.push([key, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache(pairs2);
  }
  data2.set(key, value);
  this.size = data2.size;
  return this;
}
function Stack(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index2 = -1, length2 = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array2);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array2, other);
  stack.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array2);
  stack["delete"](other);
  return result;
}
var Uint8Array$1 = root.Uint8Array;
function mapToArray(map2) {
  var index2 = -1, result = Array(map2.size);
  map2.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
function setToArray(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", mapTag$4 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$2 = "[object String]", symbolTag$3 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]";
var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$2:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$2:
    case dateTag$2:
    case numberTag$2:
      return eq(+object2, +other);
    case errorTag$1:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$2:
    case stringTag$2:
      return object2 == other + "";
    case mapTag$4:
      var convert = mapToArray;
    case setTag$4:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object2, other);
      var result = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object2) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
function arrayPush(array2, values) {
  var index2 = -1, length2 = values.length, offset = array2.length;
  while (++index2 < length2) {
    array2[offset + index2] = values[index2];
  }
  return array2;
}
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray(object2) ? result : arrayPush(result, symbolsFunc(object2));
}
function arrayFilter(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$5 = Object.prototype;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols(object2), function(symbol) {
    return propertyIsEnumerable.call(object2, symbol);
  });
};
function getAllKeys(object2) {
  return baseGetAllKeys(object2, keys$1, getSymbols);
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$4.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var DataView$1 = getNative(root, "DataView");
var Promise$1 = getNative(root, "Promise");
var Set$2 = getNative(root, "Set");
var WeakMap$1 = getNative(root, "WeakMap");
var mapTag$3 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$3 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", objectTag$1 = "[object Object]";
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object2), othIsArr = isArray(other), objTag = objIsArr ? arrayTag$1 : getTag(object2), othTag = othIsArr ? arrayTag$1 : getTag(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object2)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$3.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$3.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object2, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data2 = matchData[index2];
    if (data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (data2[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack = new Stack();
      var result;
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject(value);
}
function getMatchData(object2) {
  var result = keys$1(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object2[key];
    result[length2] = [key, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
var symbolTag$2 = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$2;
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object2) {
  if (isArray(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
var FUNC_ERROR_TEXT$2 = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match, number3, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number3 || match);
  });
  return result;
});
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
function castPath(value, object2) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object2) ? [value] : stringToPath(toString$1(value));
}
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function baseGet(object2, path) {
  path = castPath(path, object2);
  var index2 = 0, length2 = path.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey(path[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
function get$3(object2, path, defaultValue2) {
  var result = object2 == null ? void 0 : baseGet(object2, path);
  return result === void 0 ? defaultValue2 : result;
}
function baseHasIn(object2, key) {
  return object2 != null && key in Object(object2);
}
function hasPath(object2, path, hasFunc) {
  path = castPath(path, object2);
  var index2 = -1, length2 = path.length, result = false;
  while (++index2 < length2) {
    var key = toKey(path[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray(object2) || isArguments(object2));
}
function hasIn(object2, path) {
  return object2 != null && hasPath(object2, path, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object2) {
    var objValue = get$3(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
function basePropertyDeep(path) {
  return function(object2) {
    return baseGet(object2, path);
  };
}
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == "object") {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = -1, iterable = Object(collection);
    while (++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
function baseMap(collection, iteratee) {
  var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
function map$1(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}
const map$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: map$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(map$2);
var hasRequiredFlattenNames;
function requireFlattenNames() {
  if (hasRequiredFlattenNames) return flattenNames;
  hasRequiredFlattenNames = 1;
  Object.defineProperty(flattenNames, "__esModule", {
    value: true
  });
  flattenNames.flattenNames = void 0;
  var _isString2 = require$$0$1;
  var _isString3 = _interopRequireDefault(_isString2);
  var _forOwn2 = require$$0;
  var _forOwn3 = _interopRequireDefault(_forOwn2);
  var _isPlainObject2 = require$$2;
  var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
  var _map2 = require$$3;
  var _map3 = _interopRequireDefault(_map2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var flattenNames$1 = flattenNames.flattenNames = function flattenNames2() {
    var things = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var names2 = [];
    (0, _map3.default)(things, function(thing) {
      if (Array.isArray(thing)) {
        flattenNames2(thing).map(function(name) {
          return names2.push(name);
        });
      } else if ((0, _isPlainObject3.default)(thing)) {
        (0, _forOwn3.default)(thing, function(value, key) {
          value === true && names2.push(key);
          names2.push(key + "-" + value);
        });
      } else if ((0, _isString3.default)(thing)) {
        names2.push(thing);
      }
    });
    return names2;
  };
  flattenNames.default = flattenNames$1;
  return flattenNames;
}
var mergeClasses = {};
function arrayEach(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (iteratee(array2[index2], index2, array2) === false) {
      break;
    }
  }
  return array2;
}
var defineProperty = (function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
})();
function baseAssignValue(object2, key, value) {
  if (key == "__proto__" && defineProperty) {
    defineProperty(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function assignValue(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$2.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function copyObject(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length2 = props.length;
  while (++index2 < length2) {
    var key = props[index2];
    var newValue = void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object2, key, newValue);
    } else {
      assignValue(object2, key, newValue);
    }
  }
  return object2;
}
function nativeKeysIn(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$1.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer$1 = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(buffer2, isDeep) {
  if (isDeep) {
    return buffer2.slice();
  }
  var length2 = buffer2.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer2.constructor(length2);
  buffer2.copy(result);
  return result;
}
function copyArray(source, array2) {
  var index2 = -1, length2 = source.length;
  array2 || (array2 = Array(length2));
  while (++index2 < length2) {
    array2[index2] = source[index2];
  }
  return array2;
}
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function initCloneArray(array2) {
  var length2 = array2.length, result = new array2.constructor(length2);
  if (length2 && typeof array2[0] == "string" && hasOwnProperty.call(array2, "index")) {
    result.index = array2.index;
    result.input = array2.input;
  }
  return result;
}
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer2 = cloneArrayBuffer(dataView.buffer);
  return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
}
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object2, tag, isDeep) {
  var Ctor = object2.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object2);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object2);
    case dataViewTag$1:
      return cloneDataView(object2);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object2, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object2);
    case regexpTag$1:
      return cloneRegExp(object2);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object2);
  }
}
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ (function() {
  function object2() {
  }
  return function(proto2) {
    if (!isObject(proto2)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto2);
    }
    object2.prototype = proto2;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
})();
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
}
var mapTag$1 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag$1;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var setTag$1 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag$1;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var CLONE_DEEP_FLAG$1 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value, bitmask, customizer, key, object2, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$1;
  if (result !== void 0) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
  } else {
    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object2) {
      result = isFunc ? {} : initCloneObject(value);
    } else {
      if (!cloneableTags[tag]) {
        return object2 ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = getAllKeys;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
const cloneDeep$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cloneDeep
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(cloneDeep$1);
var hasRequiredMergeClasses;
function requireMergeClasses() {
  if (hasRequiredMergeClasses) return mergeClasses;
  hasRequiredMergeClasses = 1;
  Object.defineProperty(mergeClasses, "__esModule", {
    value: true
  });
  mergeClasses.mergeClasses = void 0;
  var _forOwn2 = require$$0;
  var _forOwn3 = _interopRequireDefault(_forOwn2);
  var _cloneDeep2 = require$$1;
  var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
  var _extends2 = Object.assign || function(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var mergeClasses$1 = mergeClasses.mergeClasses = function mergeClasses2(classes2) {
    var activeNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var styles2 = classes2.default && (0, _cloneDeep3.default)(classes2.default) || {};
    activeNames.map(function(name) {
      var toMerge = classes2[name];
      if (toMerge) {
        (0, _forOwn3.default)(toMerge, function(value, key) {
          if (!styles2[key]) {
            styles2[key] = {};
          }
          styles2[key] = _extends2({}, styles2[key], toMerge[key]);
        });
      }
      return name;
    });
    return styles2;
  };
  mergeClasses.default = mergeClasses$1;
  return mergeClasses;
}
var autoprefix = {};
var hasRequiredAutoprefix;
function requireAutoprefix() {
  if (hasRequiredAutoprefix) return autoprefix;
  hasRequiredAutoprefix = 1;
  Object.defineProperty(autoprefix, "__esModule", {
    value: true
  });
  autoprefix.autoprefix = void 0;
  var _forOwn2 = require$$0;
  var _forOwn3 = _interopRequireDefault(_forOwn2);
  var _extends2 = Object.assign || function(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var transforms = {
    borderRadius: function borderRadius(value) {
      return {
        msBorderRadius: value,
        MozBorderRadius: value,
        OBorderRadius: value,
        WebkitBorderRadius: value,
        borderRadius: value
      };
    },
    boxShadow: function boxShadow(value) {
      return {
        msBoxShadow: value,
        MozBoxShadow: value,
        OBoxShadow: value,
        WebkitBoxShadow: value,
        boxShadow: value
      };
    },
    userSelect: function userSelect(value) {
      return {
        WebkitTouchCallout: value,
        KhtmlUserSelect: value,
        MozUserSelect: value,
        msUserSelect: value,
        WebkitUserSelect: value,
        userSelect: value
      };
    },
    flex: function flex(value) {
      return {
        WebkitBoxFlex: value,
        MozBoxFlex: value,
        WebkitFlex: value,
        msFlex: value,
        flex: value
      };
    },
    flexBasis: function flexBasis(value) {
      return {
        WebkitFlexBasis: value,
        flexBasis: value
      };
    },
    justifyContent: function justifyContent(value) {
      return {
        WebkitJustifyContent: value,
        justifyContent: value
      };
    },
    transition: function transition2(value) {
      return {
        msTransition: value,
        MozTransition: value,
        OTransition: value,
        WebkitTransition: value,
        transition: value
      };
    },
    transform: function transform2(value) {
      return {
        msTransform: value,
        MozTransform: value,
        OTransform: value,
        WebkitTransform: value,
        transform: value
      };
    },
    absolute: function absolute(value) {
      var direction = value && value.split(" ");
      return {
        position: "absolute",
        top: direction && direction[0],
        right: direction && direction[1],
        bottom: direction && direction[2],
        left: direction && direction[3]
      };
    },
    extend: function extend2(name, otherElementStyles) {
      var otherStyle = otherElementStyles[name];
      if (otherStyle) {
        return otherStyle;
      }
      return {
        "extend": name
      };
    }
  };
  var autoprefix$1 = autoprefix.autoprefix = function autoprefix2(elements) {
    var prefixed = {};
    (0, _forOwn3.default)(elements, function(styles2, element) {
      var expanded = {};
      (0, _forOwn3.default)(styles2, function(value, key) {
        var transform2 = transforms[key];
        if (transform2) {
          expanded = _extends2({}, expanded, transform2(value));
        } else {
          expanded[key] = value;
        }
      });
      prefixed[element] = expanded;
    });
    return prefixed;
  };
  autoprefix.default = autoprefix$1;
  return autoprefix;
}
var hover = {};
var hasRequiredHover;
function requireHover() {
  if (hasRequiredHover) return hover;
  hasRequiredHover = 1;
  Object.defineProperty(hover, "__esModule", {
    value: true
  });
  hover.hover = void 0;
  var _extends2 = Object.assign || function(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var hover$1 = hover.hover = function hover2(Component2) {
    var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
    return (function(_React$Component) {
      _inherits2(Hover, _React$Component);
      function Hover() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck2(this, Hover);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn2(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          hover: false
        }, _this.handleMouseOver = function() {
          return _this.setState({
            hover: true
          });
        }, _this.handleMouseOut = function() {
          return _this.setState({
            hover: false
          });
        }, _this.render = function() {
          return _react2.default.createElement(Span, {
            onMouseOver: _this.handleMouseOver,
            onMouseOut: _this.handleMouseOut
          }, _react2.default.createElement(Component2, _extends2({}, _this.props, _this.state)));
        }, _temp), _possibleConstructorReturn2(_this, _ret);
      }
      return Hover;
    })(_react2.default.Component);
  };
  hover.default = hover$1;
  return hover;
}
var active = {};
var hasRequiredActive;
function requireActive() {
  if (hasRequiredActive) return active;
  hasRequiredActive = 1;
  Object.defineProperty(active, "__esModule", {
    value: true
  });
  active.active = void 0;
  var _extends2 = Object.assign || function(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var active$12 = active.active = function active2(Component2) {
    var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
    return (function(_React$Component) {
      _inherits2(Active, _React$Component);
      function Active() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck2(this, Active);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn2(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          active: false
        }, _this.handleMouseDown = function() {
          return _this.setState({
            active: true
          });
        }, _this.handleMouseUp = function() {
          return _this.setState({
            active: false
          });
        }, _this.render = function() {
          return _react2.default.createElement(Span, {
            onMouseDown: _this.handleMouseDown,
            onMouseUp: _this.handleMouseUp
          }, _react2.default.createElement(Component2, _extends2({}, _this.props, _this.state)));
        }, _temp), _possibleConstructorReturn2(_this, _ret);
      }
      return Active;
    })(_react2.default.Component);
  };
  active.default = active$12;
  return active;
}
var loop = {};
var hasRequiredLoop;
function requireLoop() {
  if (hasRequiredLoop) return loop;
  hasRequiredLoop = 1;
  Object.defineProperty(loop, "__esModule", {
    value: true
  });
  var loopable = function loopable2(i, length2) {
    var props = {};
    var setProp = function setProp2(name) {
      var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length2 - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
  };
  loop.default = loopable;
  return loop;
}
var hasRequiredLib$1;
function requireLib$1() {
  if (hasRequiredLib$1) return lib$1;
  hasRequiredLib$1 = 1;
  Object.defineProperty(lib$1, "__esModule", {
    value: true
  });
  lib$1.ReactCSS = lib$1.loop = lib$1.handleActive = lib$1.handleHover = lib$1.hover = void 0;
  var _flattenNames = requireFlattenNames();
  var _flattenNames2 = _interopRequireDefault(_flattenNames);
  var _mergeClasses = requireMergeClasses();
  var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
  var _autoprefix = requireAutoprefix();
  var _autoprefix2 = _interopRequireDefault(_autoprefix);
  var _hover2 = requireHover();
  var _hover3 = _interopRequireDefault(_hover2);
  var _active = requireActive();
  var _active2 = _interopRequireDefault(_active);
  var _loop2 = requireLoop();
  var _loop3 = _interopRequireDefault(_loop2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  lib$1.hover = _hover3.default;
  lib$1.handleHover = _hover3.default;
  lib$1.handleActive = _active2.default;
  lib$1.loop = _loop3.default;
  var ReactCSS = lib$1.ReactCSS = function ReactCSS2(classes2) {
    for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      activations[_key - 1] = arguments[_key];
    }
    var activeNames = (0, _flattenNames2.default)(activations);
    var merged = (0, _mergeClasses2.default)(classes2, activeNames);
    return (0, _autoprefix2.default)(merged);
  };
  lib$1.default = ReactCSS;
  return lib$1;
}
var libExports$1 = requireLib$1();
const reactCSS = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1);
var calculateChange$2 = function calculateChange(e, hsl2, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (direction === "vertical") {
    var a = void 0;
    if (top2 < 0) {
      a = 0;
    } else if (top2 > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top2 * 100 / containerHeight) / 100;
    }
    if (hsl2.a !== a) {
      return {
        h: hsl2.h,
        s: hsl2.s,
        l: hsl2.l,
        a,
        source: "rgb"
      };
    }
  } else {
    var _a = void 0;
    if (left2 < 0) {
      _a = 0;
    } else if (left2 > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left2 * 100 / containerWidth) / 100;
    }
    if (initialA !== _a) {
      return {
        h: hsl2.h,
        s: hsl2.s,
        l: hsl2.l,
        a: _a,
        source: "rgb"
      };
    }
  }
  return null;
};
var checkboardCache = {};
var render = function render2(c1, c2, size, serverCanvas) {
  if (typeof document === "undefined" && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    return null;
  }
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};
var get$2 = function get(c1, c2, size, serverCanvas) {
  var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
var _extends$b = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var Checkboard = function Checkboard2(_ref) {
  var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children2 = _ref.children;
  var styles2 = reactCSS({
    "default": {
      grid: {
        borderRadius,
        boxShadow,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get$2(white, grey, size, renderers.canvas) + ") center left"
      }
    }
  });
  return /* @__PURE__ */ isValidElement(children2) ? /* @__PURE__ */ React__default.cloneElement(children2, _extends$b({}, children2.props, {
    style: _extends$b({}, children2.props.style, styles2.grid)
  })) : /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.grid
  });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var _extends$a = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var _createClass$1k = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1e(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = (function(_ref) {
  _inherits$1e(Alpha2, _ref);
  function Alpha2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck$1k(this, Alpha2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$1e(this, (_ref2 = Alpha2.__proto__ || Object.getPrototypeOf(Alpha2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function(e) {
      var change = calculateChange$2(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function(e) {
      _this.handleChange(e);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleChange);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$1e(_this, _ret);
  }
  _createClass$1k(Alpha2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var rgb2 = this.props.rgb;
      var styles2 = reactCSS({
        "default": {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 0) 0%,\n           rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: rgb2.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 0) 0%,\n           rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: rgb2.a * 100 + "%"
          }
        },
        "overwrite": _extends$a({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: true
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.alpha
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.checkboard
      }, /* @__PURE__ */ React__default.createElement(Checkboard, {
        renderers: this.props.renderers
      })), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.gradient
      }), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.container,
        ref: function ref2(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.pointer
      }, this.props.pointer ? /* @__PURE__ */ React__default.createElement(this.props.pointer, this.props) : /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.slider
      }))));
    }
  }]);
  return Alpha2;
})(PureComponent || Component);
var _createClass$1j = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$1j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1d(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode2(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue2(value) {
  return Number(String(value).replace(/%/g, ""));
};
var idCounter = 1;
var EditableInput = (function(_ref) {
  _inherits$1d(EditableInput2, _ref);
  function EditableInput2(props) {
    _classCallCheck$1j(this, EditableInput2);
    var _this = _possibleConstructorReturn$1d(this, (EditableInput2.__proto__ || Object.getPrototypeOf(EditableInput2)).call(this));
    _this.handleBlur = function() {
      if (_this.state.blurValue) {
        _this.setState({
          value: _this.state.blurValue,
          blurValue: null
        });
      }
    };
    _this.handleChange = function(e) {
      _this.setUpdatedValue(e.target.value, e);
    };
    _this.handleKeyDown = function(e) {
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
        _this.setUpdatedValue(updatedValue, e);
      }
    };
    _this.handleDrag = function(e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };
    _this.handleMouseDown = function(e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener("mousemove", _this.handleDrag);
        window.addEventListener("mouseup", _this.handleMouseUp);
      }
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleDrag);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    };
    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    _this.inputId = "rc-editable-input-" + idCounter++;
    return _this;
  }
  _createClass$1j(EditableInput2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({
            blurValue: String(this.props.value).toUpperCase()
          });
        } else {
          this.setState({
            value: String(this.props.value).toUpperCase(),
            blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: "getArrowOffset",
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: "setUpdatedValue",
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);
      this.setState({
        value
      });
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var styles2 = reactCSS({
        "default": {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": true
      }, this.props);
      return /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.wrap
      }, /* @__PURE__ */ React__default.createElement("input", {
        id: this.inputId,
        style: styles2.input,
        ref: function ref2(input) {
          return _this2.input = input;
        },
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        placeholder: this.props.placeholder,
        spellCheck: "false"
      }), this.props.label && !this.props.hideLabel ? /* @__PURE__ */ React__default.createElement("label", {
        htmlFor: this.inputId,
        style: styles2.label,
        onMouseDown: this.handleMouseDown
      }, this.props.label) : null);
    }
  }]);
  return EditableInput2;
})(PureComponent || Component);
var calculateChange$1 = function calculateChange2(e, direction, hsl2, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (direction === "vertical") {
    var h = void 0;
    if (top2 < 0) {
      h = 359;
    } else if (top2 > containerHeight) {
      h = 0;
    } else {
      var percent = -(top2 * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }
    if (hsl2.h !== h) {
      return {
        h,
        s: hsl2.s,
        l: hsl2.l,
        a: hsl2.a,
        source: "hsl"
      };
    }
  } else {
    var _h = void 0;
    if (left2 < 0) {
      _h = 0;
    } else if (left2 > containerWidth) {
      _h = 359;
    } else {
      var _percent = left2 * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }
    if (hsl2.h !== _h) {
      return {
        h: _h,
        s: hsl2.s,
        l: hsl2.l,
        a: hsl2.a,
        source: "hsl"
      };
    }
  }
  return null;
};
var _createClass$1i = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1c(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = (function(_ref) {
  _inherits$1c(Hue2, _ref);
  function Hue2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck$1i(this, Hue2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$1c(this, (_ref2 = Hue2.__proto__ || Object.getPrototypeOf(Hue2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function(e) {
      var change = calculateChange$1(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function(e) {
      _this.handleChange(e);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$1c(_this, _ret);
  }
  _createClass$1i(Hue2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange);
      window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _props$direction = this.props.direction, direction = _props$direction === void 0 ? "horizontal" : _props$direction;
      var styles2 = reactCSS({
        "default": {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, {
        vertical: direction === "vertical"
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.hue
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "hue-" + direction,
        style: styles2.container,
        ref: function ref2(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /* @__PURE__ */ React__default.createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.pointer
      }, this.props.pointer ? /* @__PURE__ */ React__default.createElement(this.props.pointer, this.props) : /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.slider
      }))));
    }
  }]);
  return Hue2;
})(PureComponent || Component);
function assignMergeValue(object2, key, value) {
  if (value !== void 0 && !eq(object2[key], value) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
function safeGet(object2, key) {
  if (key === "constructor" && typeof object2[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object2[key];
}
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object2, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer, stack) {
  if (object2 === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object2, key, newValue);
    }
  }, keysIn);
}
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var nativeMax$1 = Math.max;
function overRest(func, start2, transform2) {
  start2 = nativeMax$1(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$1(args.length - start2, 0), array2 = Array(length2);
    while (++index2 < length2) {
      array2[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform2(array2);
    return apply(func, this, otherArgs);
  };
}
function constant$1(value) {
  return function() {
    return value;
  };
}
var baseSetToString = !defineProperty ? identity$3 : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant$1(string),
    "writable": true
  });
};
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count2 = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count2 >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count2 = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString);
function baseRest(func, start2) {
  return setToString(overRest(func, start2, identity$3), func + "");
}
function isIterateeCall(value, index2, object2) {
  if (!isObject(object2)) {
    return false;
  }
  var type2 = typeof index2;
  if (type2 == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type2 == "string" && index2 in object2) {
    return eq(object2[index2], value);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object2, sources) {
    var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : void 0, guard = length2 > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length2 < 3 ? void 0 : customizer;
      length2 = 1;
    }
    object2 = Object(object2);
    while (++index2 < length2) {
      var source = sources[index2];
      if (source) {
        assigner(object2, source, index2, customizer);
      }
    }
    return object2;
  });
}
var merge = createAssigner(function(object2, source, srcIndex) {
  baseMerge(object2, source, srcIndex);
});
var Raised = function Raised2(_ref) {
  var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children2 = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles;
  var styles2 = reactCSS(merge({
    "default": {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
        borderRadius: radius,
        background
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    "square": {
      bg: {
        borderRadius: "0"
      }
    },
    "circle": {
      bg: {
        borderRadius: "50%"
      }
    }
  }, passedStyles), {
    "zDepth-1": zDepth === 1
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.wrap
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.bg
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.content
  }, children2));
};
Raised.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var now = function() {
  return root.Date.now();
};
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options2) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time2 = now(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var FUNC_ERROR_TEXT = "Expected a function";
function throttle(func, wait, options2) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options2)) {
    leading = "leading" in options2 ? !!options2.leading : leading;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  return debounce(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var calculateChange3 = function calculateChange4(e, hsl2, container) {
  var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (left2 < 0) {
    left2 = 0;
  } else if (left2 > containerWidth) {
    left2 = containerWidth;
  }
  if (top2 < 0) {
    top2 = 0;
  } else if (top2 > containerHeight) {
    top2 = containerHeight;
  }
  var saturation = left2 / containerWidth;
  var bright = 1 - top2 / containerHeight;
  return {
    h: hsl2.h,
    s: saturation,
    v: bright,
    a: hsl2.a,
    source: "hsv"
  };
};
var _createClass$1h = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1h(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1b(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = (function(_ref) {
  _inherits$1b(Saturation2, _ref);
  function Saturation2(props) {
    _classCallCheck$1h(this, Saturation2);
    var _this = _possibleConstructorReturn$1b(this, (Saturation2.__proto__ || Object.getPrototypeOf(Saturation2)).call(this, props));
    _this.handleChange = function(e) {
      typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, calculateChange3(e, _this.props.hsl, _this.container), e);
    };
    _this.handleMouseDown = function(e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener("mousemove", _this.handleChange);
      renderWindow.addEventListener("mouseup", _this.handleMouseUp);
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.throttle = throttle(function(fn, data2, e) {
      fn(data2, e);
    }, 50);
    return _this;
  }
  _createClass$1h(Saturation2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function getContainerRenderWindow() {
      var container = this.container;
      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener("mousemove", this.handleChange);
      renderWindow.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _ref2 = this.props.style || {}, color2 = _ref2.color, white = _ref2.white, black = _ref2.black, pointer2 = _ref2.pointer, circle2 = _ref2.circle;
      var styles2 = reactCSS({
        "default": {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        "custom": {
          color: color2,
          white,
          black,
          pointer: pointer2,
          circle: circle2
        }
      }, {
        "custom": !!this.props.style
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.color,
        ref: function ref2(container) {
          return _this2.container = container;
        },
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, /* @__PURE__ */ React__default.createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.white,
        className: "saturation-white"
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.black,
        className: "saturation-black"
      }), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.pointer
      }, this.props.pointer ? /* @__PURE__ */ React__default.createElement(this.props.pointer, this.props) : /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.circle
      }))));
    }
  }]);
  return Saturation2;
})(PureComponent || Component);
function forEach$1(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color2, opts) {
  color2 = color2 ? color2 : "";
  opts = opts || {};
  if (color2 instanceof tinycolor) {
    return color2;
  }
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color2, opts);
  }
  var rgb2 = inputToRGB(color2);
  this._originalInput = color2, this._r = rgb2.r, this._g = rgb2.g, this._b = rgb2.b, this._a = rgb2.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb2.format;
  this._gradientType = opts.gradientType;
  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb2.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    var rgb2 = this.toRgb();
    return (rgb2.r * 299 + rgb2.g * 587 + rgb2.b * 114) / 1e3;
  },
  getLuminance: function getLuminance() {
    var rgb2 = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B2;
    RsRGB = rgb2.r / 255;
    GsRGB = rgb2.g / 255;
    BsRGB = rgb2.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;
    else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;
    else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B2 = BsRGB / 12.92;
    else B2 = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B2;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl2 = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl2.h * 360,
      s: hsl2.s,
      l: hsl2.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl2 = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl2.h * 360), s = Math.round(hsl2.s * 100), l = Math.round(hsl2.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format2) {
    var formatSet = !!format2;
    format2 = format2 || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format2 === "hex" || format2 === "hex6" || format2 === "hex3" || format2 === "hex4" || format2 === "hex8" || format2 === "name");
    if (needsAlphaFormat) {
      if (format2 === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format2 === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format2 === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format2 === "hex" || format2 === "hex6") {
      formattedString = this.toHexString();
    }
    if (format2 === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format2 === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format2 === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format2 === "name") {
      formattedString = this.toName();
    }
    if (format2 === "hsl") {
      formattedString = this.toHslString();
    }
    if (format2 === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color2 = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color2._r;
    this._g = color2._g;
    this._b = color2._b;
    this.setAlpha(color2._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement2() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(color2, opts) {
  if (_typeof(color2) == "object") {
    var newColor = {};
    for (var i in color2) {
      if (color2.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color2[i];
        } else {
          newColor[i] = convertToPercentage(color2[i]);
        }
      }
    }
    color2 = newColor;
  }
  return tinycolor(color2, opts);
};
function inputToRGB(color2) {
  var rgb2 = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format2 = false;
  if (typeof color2 == "string") {
    color2 = stringInputToObject(color2);
  }
  if (_typeof(color2) == "object") {
    if (isValidCSSUnit(color2.r) && isValidCSSUnit(color2.g) && isValidCSSUnit(color2.b)) {
      rgb2 = rgbToRgb(color2.r, color2.g, color2.b);
      ok = true;
      format2 = String(color2.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color2.h) && isValidCSSUnit(color2.s) && isValidCSSUnit(color2.v)) {
      s = convertToPercentage(color2.s);
      v = convertToPercentage(color2.v);
      rgb2 = hsvToRgb(color2.h, s, v);
      ok = true;
      format2 = "hsv";
    } else if (isValidCSSUnit(color2.h) && isValidCSSUnit(color2.s) && isValidCSSUnit(color2.l)) {
      s = convertToPercentage(color2.s);
      l = convertToPercentage(color2.l);
      rgb2 = hslToRgb(color2.h, s, l);
      ok = true;
      format2 = "hsl";
    }
    if (color2.hasOwnProperty("a")) {
      a = color2.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok,
    format: color2.format || format2,
    r: Math.min(255, Math.max(rgb2.r, 0)),
    g: Math.min(255, Math.max(rgb2.g, 0)),
    b: Math.min(255, Math.max(rgb2.b, 0)),
    a
  };
}
function rgbToRgb(r2, g, b) {
  return {
    r: bound01(r2, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}
function rgbToHsl(r2, g, b) {
  r2 = bound01(r2, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max2 = Math.max(r2, g, b), min2 = Math.min(r2, g, b);
  var h, s, l = (max2 + min2) / 2;
  if (max2 == min2) {
    h = s = 0;
  } else {
    var d = max2 - min2;
    s = l > 0.5 ? d / (2 - max2 - min2) : d / (max2 + min2);
    switch (max2) {
      case r2:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r2) / d + 2;
        break;
      case b:
        h = (r2 - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    l
  };
}
function hslToRgb(h, s, l) {
  var r2, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p2, q3, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p2 + (q3 - p2) * 6 * t;
    if (t < 1 / 2) return q3;
    if (t < 2 / 3) return p2 + (q3 - p2) * (2 / 3 - t) * 6;
    return p2;
  }
  if (s === 0) {
    r2 = g = b = l;
  } else {
    var q2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q2;
    r2 = hue2rgb(p, q2, h + 1 / 3);
    g = hue2rgb(p, q2, h);
    b = hue2rgb(p, q2, h - 1 / 3);
  }
  return {
    r: r2 * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHsv(r2, g, b) {
  r2 = bound01(r2, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max2 = Math.max(r2, g, b), min2 = Math.min(r2, g, b);
  var h, s, v = max2;
  var d = max2 - min2;
  s = max2 === 0 ? 0 : d / max2;
  if (max2 == min2) {
    h = 0;
  } else {
    switch (max2) {
      case r2:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r2) / d + 2;
        break;
      case b:
        h = (r2 - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s,
    v
  };
}
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h), f2 = h - i, p = v * (1 - s), q2 = v * (1 - f2 * s), t = v * (1 - (1 - f2) * s), mod2 = i % 6, r2 = [v, q2, p, p, t, v][mod2], g = [t, v, v, q2, p, p][mod2], b = [p, p, t, v, v, q2][mod2];
  return {
    r: r2 * 255,
    g: g * 255,
    b: b * 255
  };
}
function rgbToHex(r2, g, b, allow3Char) {
  var hex2 = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  if (allow3Char && hex2[0].charAt(0) == hex2[0].charAt(1) && hex2[1].charAt(0) == hex2[1].charAt(1) && hex2[2].charAt(0) == hex2[2].charAt(1)) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
  }
  return hex2.join("");
}
function rgbaToHex(r2, g, b, a, allow4Char) {
  var hex2 = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];
  if (allow4Char && hex2[0].charAt(0) == hex2[0].charAt(1) && hex2[1].charAt(0) == hex2[1].charAt(1) && hex2[2].charAt(0) == hex2[2].charAt(1) && hex2[3].charAt(0) == hex2[3].charAt(1)) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0) + hex2[3].charAt(0);
  }
  return hex2.join("");
}
function rgbaToArgbHex(r2, g, b, a) {
  var hex2 = [pad2(convertDecimalToHex(a)), pad2(Math.round(r2).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex2.join("");
}
tinycolor.equals = function(color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.s -= amount / 100;
  hsl2.s = clamp01(hsl2.s);
  return tinycolor(hsl2);
}
function _saturate(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.s += amount / 100;
  hsl2.s = clamp01(hsl2.s);
  return tinycolor(hsl2);
}
function _greyscale(color2) {
  return tinycolor(color2).desaturate(100);
}
function _lighten(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.l += amount / 100;
  hsl2.l = clamp01(hsl2.l);
  return tinycolor(hsl2);
}
function _brighten(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb2 = tinycolor(color2).toRgb();
  rgb2.r = Math.max(0, Math.min(255, rgb2.r - Math.round(255 * -(amount / 100))));
  rgb2.g = Math.max(0, Math.min(255, rgb2.g - Math.round(255 * -(amount / 100))));
  rgb2.b = Math.max(0, Math.min(255, rgb2.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb2);
}
function _darken(color2, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.l -= amount / 100;
  hsl2.l = clamp01(hsl2.l);
  return tinycolor(hsl2);
}
function _spin(color2, amount) {
  var hsl2 = tinycolor(color2).toHsl();
  var hue = (hsl2.h + amount) % 360;
  hsl2.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl2);
}
function _complement(color2) {
  var hsl2 = tinycolor(color2).toHsl();
  hsl2.h = (hsl2.h + 180) % 360;
  return tinycolor(hsl2);
}
function polyad(color2, number3) {
  if (isNaN(number3) || number3 <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl2 = tinycolor(color2).toHsl();
  var result = [tinycolor(color2)];
  var step = 360 / number3;
  for (var i = 1; i < number3; i++) {
    result.push(tinycolor({
      h: (hsl2.h + i * step) % 360,
      s: hsl2.s,
      l: hsl2.l
    }));
  }
  return result;
}
function _splitcomplement(color2) {
  var hsl2 = tinycolor(color2).toHsl();
  var h = hsl2.h;
  return [tinycolor(color2), tinycolor({
    h: (h + 72) % 360,
    s: hsl2.s,
    l: hsl2.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl2.s,
    l: hsl2.l
  })];
}
function _analogous(color2, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl2 = tinycolor(color2).toHsl();
  var part2 = 360 / slices;
  var ret = [tinycolor(color2)];
  for (hsl2.h = (hsl2.h - (part2 * results >> 1) + 720) % 360; --results; ) {
    hsl2.h = (hsl2.h + part2) % 360;
    ret.push(tinycolor(hsl2));
  }
  return ret;
}
function _monochromatic(color2, results) {
  results = results || 6;
  var hsv = tinycolor(color2).toHsv();
  var h = hsv.h, s = hsv.s, v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h,
      s,
      v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}
tinycolor.mix = function(color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba2 = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba2);
};
tinycolor.readability = function(color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};
tinycolor.mostReadable = function(baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level,
    size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
var hexNames = tinycolor.hexNames = flip(names);
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}
function bound01(n, max2) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max2, Math.max(0, parseFloat(n)));
  if (processPercent) {
    n = parseInt(n * max2, 10) / 100;
  }
  if (Math.abs(n - max2) < 1e-6) {
    return 1;
  }
  return n % max2 / parseFloat(max2);
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = (function() {
  var CSS_INTEGER = "[-\\+]?\\d+%?";
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
})();
function isValidCSSUnit(color2) {
  return !!matchers.CSS_UNIT.exec(color2);
}
function stringInputToObject(color2) {
  color2 = color2.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named2 = false;
  if (names[color2]) {
    color2 = names[color2];
    named2 = true;
  } else if (color2 == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }
  var match;
  if (match = matchers.rgb.exec(color2)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color2)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color2)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color2)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named2 ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color2)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named2 ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color2)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named2 ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color2)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named2 ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level,
    size
  };
}
var simpleCheckForValidColor = function simpleCheckForValidColor2(data2) {
  var keysToCheck = ["r", "g", "b", "a", "h", "s", "l", "v"];
  var checked = 0;
  var passed = 0;
  forEach$1(keysToCheck, function(letter) {
    if (data2[letter]) {
      checked += 1;
      if (!isNaN(data2[letter])) {
        passed += 1;
      }
      if (letter === "s" || letter === "l") {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data2[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data2 : false;
};
var toState = function toState2(data2, oldHue) {
  var color2 = data2.hex ? tinycolor(data2.hex) : tinycolor(data2);
  var hsl2 = color2.toHsl();
  var hsv = color2.toHsv();
  var rgb2 = color2.toRgb();
  var hex2 = color2.toHex();
  if (hsl2.s === 0) {
    hsl2.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex2 === "000000" && rgb2.a === 0;
  return {
    hsl: hsl2,
    hex: transparent ? "transparent" : "#" + hex2,
    rgb: rgb2,
    hsv,
    oldHue: data2.h || oldHue || hsl2.h,
    source: data2.source
  };
};
var isValidHex = function isValidHex2(hex2) {
  if (hex2 === "transparent") {
    return true;
  }
  var lh = String(hex2).charAt(0) === "#" ? 1 : 0;
  return hex2.length !== 4 + lh && hex2.length < 7 + lh && tinycolor(hex2).isValid();
};
var getContrastingColor = function getContrastingColor2(data2) {
  if (!data2) {
    return "#fff";
  }
  var col = toState(data2);
  if (col.hex === "transparent") {
    return "rgba(0,0,0,0.4)";
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1e3;
  return yiq >= 128 ? "#000" : "#fff";
};
var isvalidColorString = function isvalidColorString2(string, type2) {
  var stringWithoutDegree = string.replace("°", "");
  return tinycolor(type2 + " (" + stringWithoutDegree + ")")._ok;
};
var _extends$9 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var _createClass$1g = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1g(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1a(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap2(Picker) {
  var ColorPicker = (function(_ref) {
    _inherits$1a(ColorPicker2, _ref);
    function ColorPicker2(props) {
      _classCallCheck$1g(this, ColorPicker2);
      var _this = _possibleConstructorReturn$1a(this, (ColorPicker2.__proto__ || Object.getPrototypeOf(ColorPicker2)).call(this));
      _this.handleChange = function(data2, event) {
        var isValidColor = simpleCheckForValidColor(data2);
        if (isValidColor) {
          var colors = toState(data2, data2.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };
      _this.handleSwatchHover = function(data2, event) {
        var isValidColor = simpleCheckForValidColor(data2);
        if (isValidColor) {
          var colors = toState(data2, data2.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };
      _this.state = _extends$9({}, toState(props.color, 0));
      _this.debounce = debounce(function(fn, data2, event) {
        fn(data2, event);
      }, 100);
      return _this;
    }
    _createClass$1g(ColorPicker2, [{
      key: "render",
      value: function render3() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }
        return /* @__PURE__ */ React__default.createElement(Picker, _extends$9({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$9({}, toState(nextProps.color, state.oldHue));
      }
    }]);
    return ColorPicker2;
  })(PureComponent || Component);
  ColorPicker.propTypes = _extends$9({}, Picker.propTypes);
  ColorPicker.defaultProps = _extends$9({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  });
  return ColorPicker;
};
var _extends$8 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var _createClass$1f = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1f(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$19(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$19(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return (function(_React$Component) {
    _inherits$19(Focus, _React$Component);
    function Focus() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$1f(this, Focus);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$19(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        focus: false
      }, _this.handleFocus = function() {
        return _this.setState({
          focus: true
        });
      }, _this.handleBlur = function() {
        return _this.setState({
          focus: false
        });
      }, _temp), _possibleConstructorReturn$19(_this, _ret);
    }
    _createClass$1f(Focus, [{
      key: "render",
      value: function render3() {
        return /* @__PURE__ */ React__default.createElement(Span, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, /* @__PURE__ */ React__default.createElement(Component2, _extends$8({}, this.props, this.state)));
      }
    }]);
    return Focus;
  })(React__default.Component);
};
var _extends$7 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var ENTER = 13;
var Swatch = function Swatch2(_ref) {
  var color2 = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title2 = _ref$title === void 0 ? color2 : _ref$title, children2 = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === void 0 ? {} : _ref$focusStyle;
  var transparent = color2 === "transparent";
  var styles2 = reactCSS({
    default: {
      swatch: _extends$7({
        background: color2,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, style, focus ? focusStyle : {})
    }
  });
  var handleClick = function handleClick2(e) {
    return onClick(color2, e);
  };
  var handleKeyDown = function handleKeyDown2(e) {
    return e.keyCode === ENTER && onClick(color2, e);
  };
  var handleHover = function handleHover2(e) {
    return onHover(color2, e);
  };
  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }
  return /* @__PURE__ */ React__default.createElement("div", _extends$7({
    style: styles2.swatch,
    onClick: handleClick,
    title: title2,
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }, optionalEvents), children2, transparent && /* @__PURE__ */ React__default.createElement(Checkboard, {
    borderRadius: styles2.swatch.borderRadius,
    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
  }));
};
const Swatch$1 = handleFocus(Swatch);
var AlphaPointer = function AlphaPointer2(_ref) {
  var direction = _ref.direction;
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, {
    vertical: direction === "vertical"
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
var _extends$6 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var AlphaPicker = function AlphaPicker2(_ref) {
  var rgb2 = _ref.rgb, hsl2 = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer2 = _ref.pointer, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS({
    "default": {
      picker: {
        position: "relative",
        width,
        height
      },
      alpha: {
        radius: "2px",
        style
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker,
    className: "alpha-picker " + className
  }, /* @__PURE__ */ React__default.createElement(Alpha, _extends$6({}, styles2.alpha, {
    rgb: rgb2,
    hsl: hsl2,
    pointer: pointer2,
    renderers,
    onChange,
    direction
  })));
};
AlphaPicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker);
var BlockSwatches = function BlockSwatches2(_ref) {
  var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
  var styles2 = reactCSS({
    "default": {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatches
  }, map$1(colors, function(c) {
    return /* @__PURE__ */ React__default.createElement(Swatch$1, {
      key: c,
      color: c,
      style: styles2.swatch,
      onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: "0 0 4px " + c
      }
    });
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.clear
  }));
};
var Block = function Block2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex2 = _ref.hex, colors = _ref.colors, width = _ref.width, triangle2 = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var transparent = hex2 === "transparent";
  var handleChange = function handleChange2(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: "hex"
    }, e);
  };
  var styles2 = reactCSS(merge({
    "default": {
      card: {
        width,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: hex2,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: getContrastingColor(hex2),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + hex2 + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle2 === "hide"
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.card,
    className: "block-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.triangle
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.head
  }, transparent && /* @__PURE__ */ React__default.createElement(Checkboard, {
    borderRadius: "6px 6px 0 0"
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.label
  }, hex2)), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.body
  }, /* @__PURE__ */ React__default.createElement(BlockSwatches, {
    colors,
    onClick: handleChange,
    onSwatchHover
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input
    },
    value: hex2,
    onChange: handleChange
  })));
};
Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["top", "hide"]),
  styles: PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
ColorWrap(Block);
var red = {
  "100": "#ffcdd2",
  "300": "#e57373",
  "500": "#f44336",
  "700": "#d32f2f",
  "900": "#b71c1c"
};
var pink = {
  "100": "#f8bbd0",
  "300": "#f06292",
  "500": "#e91e63",
  "700": "#c2185b",
  "900": "#880e4f"
};
var purple = {
  "100": "#e1bee7",
  "300": "#ba68c8",
  "500": "#9c27b0",
  "700": "#7b1fa2",
  "900": "#4a148c"
};
var deepPurple = {
  "100": "#d1c4e9",
  "300": "#9575cd",
  "500": "#673ab7",
  "700": "#512da8",
  "900": "#311b92"
};
var indigo = {
  "100": "#c5cae9",
  "300": "#7986cb",
  "500": "#3f51b5",
  "700": "#303f9f",
  "900": "#1a237e"
};
var blue = {
  "100": "#bbdefb",
  "300": "#64b5f6",
  "500": "#2196f3",
  "700": "#1976d2",
  "900": "#0d47a1"
};
var lightBlue = {
  "100": "#b3e5fc",
  "300": "#4fc3f7",
  "500": "#03a9f4",
  "700": "#0288d1",
  "900": "#01579b"
};
var cyan = {
  "100": "#b2ebf2",
  "300": "#4dd0e1",
  "500": "#00bcd4",
  "700": "#0097a7",
  "900": "#006064"
};
var teal = {
  "100": "#b2dfdb",
  "300": "#4db6ac",
  "500": "#009688",
  "700": "#00796b",
  "900": "#004d40"
};
var green = {
  "100": "#c8e6c9",
  "300": "#81c784",
  "500": "#4caf50",
  "700": "#388e3c"
};
var lightGreen = {
  "100": "#dcedc8",
  "300": "#aed581",
  "500": "#8bc34a",
  "700": "#689f38",
  "900": "#33691e"
};
var lime = {
  "100": "#f0f4c3",
  "300": "#dce775",
  "500": "#cddc39",
  "700": "#afb42b",
  "900": "#827717"
};
var yellow = {
  "100": "#fff9c4",
  "300": "#fff176",
  "500": "#ffeb3b",
  "700": "#fbc02d",
  "900": "#f57f17"
};
var amber = {
  "100": "#ffecb3",
  "300": "#ffd54f",
  "500": "#ffc107",
  "700": "#ffa000",
  "900": "#ff6f00"
};
var orange = {
  "100": "#ffe0b2",
  "300": "#ffb74d",
  "500": "#ff9800",
  "700": "#f57c00",
  "900": "#e65100"
};
var deepOrange = {
  "100": "#ffccbc",
  "300": "#ff8a65",
  "500": "#ff5722",
  "700": "#e64a19",
  "900": "#bf360c"
};
var brown = {
  "100": "#d7ccc8",
  "300": "#a1887f",
  "500": "#795548",
  "700": "#5d4037",
  "900": "#3e2723"
};
var blueGrey = {
  "100": "#cfd8dc",
  "300": "#90a4ae",
  "500": "#607d8b",
  "700": "#455a64",
  "900": "#263238"
};
var CircleSwatch = function CircleSwatch2(_ref) {
  var color2 = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover2 = _ref.hover, active2 = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
  var styles2 = reactCSS({
    "default": {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color2,
        transition: "100ms box-shadow ease"
      }
    },
    "hover": {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    "active": {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + color2
      }
    }
  }, {
    hover: hover2,
    active: active2
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(Swatch$1, {
    style: styles2.Swatch,
    color: color2,
    onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: styles2.Swatch.boxShadow + ", 0 0 5px " + color2
    }
  }));
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const CircleSwatch$1 = libExports$1.handleHover(CircleSwatch);
var Circle = function Circle2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex2 = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      card: {
        width,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(hexCode, e) {
    return onChange({
      hex: hexCode,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.card,
    className: "circle-picker " + className
  }, map$1(colors, function(c) {
    return /* @__PURE__ */ React__default.createElement(CircleSwatch$1, {
      key: c,
      color: c,
      onClick: handleChange,
      onSwatchHover,
      active: hex2 === c.toLowerCase(),
      circleSize,
      circleSpacing
    });
  }));
};
Circle.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red["500"], pink["500"], purple["500"], deepPurple["500"], indigo["500"], blue["500"], lightBlue["500"], cyan["500"], teal["500"], green["500"], lightGreen["500"], lime["500"], yellow["500"], amber["500"], orange["500"], deepOrange["500"], brown["500"], blueGrey["500"]],
  styles: {}
};
ColorWrap(Circle);
function isUndefined(value) {
  return value === void 0;
}
var UnfoldMoreHorizontalIcon$1 = {};
var hasRequiredUnfoldMoreHorizontalIcon;
function requireUnfoldMoreHorizontalIcon() {
  if (hasRequiredUnfoldMoreHorizontalIcon) return UnfoldMoreHorizontalIcon$1;
  hasRequiredUnfoldMoreHorizontalIcon = 1;
  Object.defineProperty(UnfoldMoreHorizontalIcon$1, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _objectWithoutProperties(obj, keys2) {
    var target2 = {};
    for (var i in obj) {
      if (keys2.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target2[i] = obj[i];
    }
    return target2;
  }
  var DEFAULT_SIZE = 24;
  UnfoldMoreHorizontalIcon$1.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === void 0 ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, props = _objectWithoutProperties(_ref, ["fill", "width", "height", "style"]);
    return _react2.default.createElement("svg", _extends2({
      viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
      style: _extends2({
        fill,
        width,
        height
      }, style)
    }, props), _react2.default.createElement("path", {
      d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
  };
  return UnfoldMoreHorizontalIcon$1;
}
var UnfoldMoreHorizontalIconExports = requireUnfoldMoreHorizontalIcon();
const UnfoldMoreHorizontalIcon = /* @__PURE__ */ getDefaultExportFromCjs(UnfoldMoreHorizontalIconExports);
var _createClass$1e = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1e(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$18(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$18(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = (function(_React$Component) {
  _inherits$18(ChromeFields2, _React$Component);
  function ChromeFields2(props) {
    _classCallCheck$1e(this, ChromeFields2);
    var _this = _possibleConstructorReturn$18(this, (ChromeFields2.__proto__ || Object.getPrototypeOf(ChromeFields2)).call(this));
    _this.toggleViews = function() {
      if (_this.state.view === "hex") {
        _this.setState({
          view: "rgb"
        });
      } else if (_this.state.view === "rgb") {
        _this.setState({
          view: "hsl"
        });
      } else if (_this.state.view === "hsl") {
        if (_this.props.hsl.a === 1) {
          _this.setState({
            view: "hex"
          });
        } else {
          _this.setState({
            view: "rgb"
          });
        }
      }
    };
    _this.handleChange = function(data2, e) {
      if (data2.hex) {
        isValidHex(data2.hex) && _this.props.onChange({
          hex: data2.hex,
          source: "hex"
        }, e);
      } else if (data2.r || data2.g || data2.b) {
        _this.props.onChange({
          r: data2.r || _this.props.rgb.r,
          g: data2.g || _this.props.rgb.g,
          b: data2.b || _this.props.rgb.b,
          source: "rgb"
        }, e);
      } else if (data2.a) {
        if (data2.a < 0) {
          data2.a = 0;
        } else if (data2.a > 1) {
          data2.a = 1;
        }
        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data2.a * 100) / 100,
          source: "rgb"
        }, e);
      } else if (data2.h || data2.s || data2.l) {
        if (typeof data2.s === "string" && data2.s.includes("%")) {
          data2.s = data2.s.replace("%", "");
        }
        if (typeof data2.l === "string" && data2.l.includes("%")) {
          data2.l = data2.l.replace("%", "");
        }
        if (data2.s == 1) {
          data2.s = 0.01;
        } else if (data2.l == 1) {
          data2.l = 0.01;
        }
        _this.props.onChange({
          h: data2.h || _this.props.hsl.h,
          s: Number(!isUndefined(data2.s) ? data2.s : _this.props.hsl.s),
          l: Number(!isUndefined(data2.l) ? data2.l : _this.props.hsl.l),
          source: "hsl"
        }, e);
      }
    };
    _this.showHighlight = function(e) {
      e.currentTarget.style.background = "#eee";
    };
    _this.hideHighlight = function(e) {
      e.currentTarget.style.background = "transparent";
    };
    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }
  _createClass$1e(ChromeFields2, [{
    key: "render",
    value: function render3() {
      var _this2 = this;
      var styles2 = reactCSS({
        "default": {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        "disableAlpha": {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state);
      var fields = void 0;
      if (this.state.view === "hex") {
        fields = /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.fields,
          className: "flexbox-fix"
        }, /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "hex",
          value: this.props.hex,
          onChange: this.handleChange
        })));
      } else if (this.state.view === "rgb") {
        fields = /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.fields,
          className: "flexbox-fix"
        }, /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "r",
          value: this.props.rgb.r,
          onChange: this.handleChange
        })), /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "g",
          value: this.props.rgb.g,
          onChange: this.handleChange
        })), /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "b",
          value: this.props.rgb.b,
          onChange: this.handleChange
        })), /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.alpha
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "a",
          value: this.props.rgb.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      } else if (this.state.view === "hsl") {
        fields = /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.fields,
          className: "flexbox-fix"
        }, /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "h",
          value: Math.round(this.props.hsl.h),
          onChange: this.handleChange
        })), /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "s",
          value: Math.round(this.props.hsl.s * 100) + "%",
          onChange: this.handleChange
        })), /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.field
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "l",
          value: Math.round(this.props.hsl.l * 100) + "%",
          onChange: this.handleChange
        })), /* @__PURE__ */ React__default.createElement("div", {
          style: styles2.alpha
        }, /* @__PURE__ */ React__default.createElement(EditableInput, {
          style: {
            input: styles2.input,
            label: styles2.label
          },
          label: "a",
          value: this.props.hsl.a,
          arrowOffset: 0.01,
          onChange: this.handleChange
        })));
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.wrap,
        className: "flexbox-fix"
      }, fields, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.toggle
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.icon,
        onClick: this.toggleViews,
        ref: function ref2(icon) {
          return _this2.icon = icon;
        }
      }, /* @__PURE__ */ React__default.createElement(UnfoldMoreHorizontalIcon, {
        style: styles2.svg,
        onMouseOver: this.showHighlight,
        onMouseEnter: this.showHighlight,
        onMouseOut: this.hideHighlight
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === "hex") {
        return {
          view: "rgb"
        };
      }
      return null;
    }
  }]);
  return ChromeFields2;
})(React__default.Component);
ChromeFields.defaultProps = {
  view: "hex"
};
var ChromePointer = function ChromePointer2() {
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
var ChromePointerCircle = function ChromePointerCircle2() {
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
var Chrome = function Chrome2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hsv = _ref.hsv, hex2 = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, defaultView2 = _ref.defaultView;
  var styles2 = reactCSS(merge({
    "default": {
      picker: {
        width,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + rgb2.r + ", " + rgb2.g + ", " + rgb2.b + ", " + rgb2.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    "disableAlpha": {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, passedStyles), {
    disableAlpha
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker,
    className: "chrome-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.saturation
  }, /* @__PURE__ */ React__default.createElement(Saturation, {
    style: styles2.Saturation,
    hsl: hsl2,
    hsv,
    pointer: ChromePointerCircle,
    onChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.body
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.controls,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.color
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.active
  }), /* @__PURE__ */ React__default.createElement(Checkboard, {
    renderers
  }))), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.toggles
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React__default.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    pointer: ChromePointer,
    onChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.alpha
  }, /* @__PURE__ */ React__default.createElement(Alpha, {
    style: styles2.Alpha,
    rgb: rgb2,
    hsl: hsl2,
    pointer: ChromePointer,
    renderers,
    onChange
  })))), /* @__PURE__ */ React__default.createElement(ChromeFields, {
    rgb: rgb2,
    hsl: hsl2,
    hex: hex2,
    view: defaultView2,
    onChange,
    disableAlpha
  })));
};
Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};
ColorWrap(Chrome);
var CompactColor = function CompactColor2(_ref) {
  var color2 = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active2 = _ref.active;
  var styles2 = reactCSS({
    "default": {
      color: {
        background: color2,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: getContrastingColor(color2),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    "active": {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    "transparent": {
      dot: {
        background: "#000"
      }
    }
  }, {
    active: active2,
    "color-#FFFFFF": color2 === "#FFFFFF",
    "transparent": color2 === "transparent"
  });
  return /* @__PURE__ */ React__default.createElement(Swatch$1, {
    style: styles2.color,
    color: color2,
    onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: "0 0 4px " + color2
    }
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.dot
  }));
};
var CompactFields = function CompactFields2(_ref) {
  var hex2 = _ref.hex, rgb2 = _ref.rgb, onChange = _ref.onChange;
  var styles2 = reactCSS({
    "default": {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: hex2
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  });
  var handleChange = function handleChange2(data2, e) {
    if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        source: "rgb"
      }, e);
    } else {
      onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.fields,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.active
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.HEXwrap,
      input: styles2.HEXinput,
      label: styles2.HEXlabel
    },
    label: "hex",
    value: hex2,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange
  }));
};
var Compact = function Compact2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex2 = _ref.hex, rgb2 = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else {
      onChange(data2, e);
    }
  };
  return /* @__PURE__ */ React__default.createElement(Raised, {
    style: styles2.Compact,
    styles: passedStyles
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.compact,
    className: "compact-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", null, map$1(colors, function(c) {
    return /* @__PURE__ */ React__default.createElement(CompactColor, {
      key: c,
      color: c,
      active: c.toLowerCase() === hex2,
      onClick: handleChange,
      onSwatchHover
    });
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.clear
  })), /* @__PURE__ */ React__default.createElement(CompactFields, {
    hex: hex2,
    rgb: rgb2,
    onChange: handleChange
  })));
};
Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
ColorWrap(Compact);
var GithubSwatch = function GithubSwatch2(_ref) {
  var hover2 = _ref.hover, color2 = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
  var hoverSwatch = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  };
  var styles2 = reactCSS({
    "default": {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    "hover": {
      swatch: hoverSwatch
    }
  }, {
    hover: hover2
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(Swatch$1, {
    color: color2,
    onClick,
    onHover: onSwatchHover,
    focusStyle: hoverSwatch
  }));
};
const GithubSwatch$1 = libExports$1.handleHover(GithubSwatch);
var Github = function Github2(_ref) {
  var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle2 = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle2 === "hide",
    "top-left-triangle": triangle2 === "top-left",
    "top-right-triangle": triangle2 === "top-right",
    "bottom-left-triangle": triangle2 === "bottom-left",
    "bottom-right-triangle": triangle2 === "bottom-right"
  });
  var handleChange = function handleChange2(hex2, e) {
    return onChange({
      hex: hex2,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.card,
    className: "github-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.triangleShadow
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.triangle
  }), map$1(colors, function(c) {
    return /* @__PURE__ */ React__default.createElement(GithubSwatch$1, {
      color: c,
      key: c,
      onClick: handleChange,
      onSwatchHover
    });
  }));
};
Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Github);
var SliderPointer$1 = function SliderPointer(_ref) {
  var direction = _ref.direction;
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, {
    vertical: direction === "vertical"
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
var _extends$5 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var HuePicker = function HuePicker2(_ref) {
  var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl2 = _ref.hsl, direction = _ref.direction, pointer2 = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      picker: {
        position: "relative",
        width,
        height
      },
      hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2) {
    return onChange({
      a: 1,
      h: data2.h,
      l: 0.5,
      s: 1
    });
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker,
    className: "hue-picker " + className
  }, /* @__PURE__ */ React__default.createElement(Hue, _extends$5({}, styles2.hue, {
    hsl: hsl2,
    pointer: pointer2,
    onChange: handleChange,
    direction
  })));
};
HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);
var Material = function Material2(_ref) {
  var onChange = _ref.onChange, hex2 = _ref.hex, rgb2 = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + hex2,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        source: "rgb"
      }, e);
    }
  };
  return /* @__PURE__ */ React__default.createElement(Raised, {
    styles: passedStyles
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.material,
    className: "material-picker " + className
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.HEXwrap,
      input: styles2.HEXinput,
      label: styles2.HEXlabel
    },
    label: "hex",
    value: hex2,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.split,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.third
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.third
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.third
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange
  })))));
};
ColorWrap(Material);
var PhotoshopPicker = function PhotoshopPicker2(_ref) {
  var onChange = _ref.onChange, rgb2 = _ref.rgb, hsv = _ref.hsv, hex2 = _ref.hex;
  var styles2 = reactCSS({
    "default": {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  });
  var handleChange = function handleChange2(data2, e) {
    if (data2["#"]) {
      isValidHex(data2["#"]) && onChange({
        hex: data2["#"],
        source: "hex"
      }, e);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        source: "rgb"
      }, e);
    } else if (data2.h || data2.s || data2.v) {
      onChange({
        h: data2.h || hsv.h,
        s: data2.s || hsv.s,
        v: data2.v || hsv.v,
        source: "hsv"
      }, e);
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.fields
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "h",
    value: Math.round(hsv.h),
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "s",
    value: Math.round(hsv.s * 100),
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "v",
    value: Math.round(hsv.v * 100),
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.divider
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.RGBwrap,
      input: styles2.RGBinput,
      label: styles2.RGBlabel
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.divider
  }), /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      wrap: styles2.HEXwrap,
      input: styles2.HEXinput,
      label: styles2.HEXlabel
    },
    label: "#",
    value: hex2.replace("#", ""),
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.fieldSymbols
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.symbol
  }, "°"), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.symbol
  }, "%"), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.symbol
  }, "%")));
};
var PhotoshopPointerCircle$1 = function PhotoshopPointerCircle(_ref) {
  var hsl2 = _ref.hsl;
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, {
    "black-outline": hsl2.l > 0.5
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
var PhotoshopPointerCircle2 = function PhotoshopPointerCircle3() {
  var styles2 = reactCSS({
    "default": {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.pointer
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.left
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.leftInside
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.right
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.rightInside
  })));
};
var PhotoshopButton = function PhotoshopButton2(_ref) {
  var onClick = _ref.onClick, label = _ref.label, children2 = _ref.children, active2 = _ref.active;
  var styles2 = reactCSS({
    "default": {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    "active": {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, {
    active: active2
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.button,
    onClick
  }, label || children2);
};
var PhotoshopPreviews = function PhotoshopPreviews2(_ref) {
  var rgb2 = _ref.rgb, currentColor = _ref.currentColor;
  var styles2 = reactCSS({
    "default": {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + rgb2.r + "," + rgb2.g + ", " + rgb2.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: currentColor,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.label
  }, "new"), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatches
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.new
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.current
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.label
  }, "current"));
};
var _createClass$1d = /* @__PURE__ */ (function() {
  function defineProperties(target2, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target2, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
function _classCallCheck$1d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$17(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$17(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = (function(_React$Component) {
  _inherits$17(Photoshop2, _React$Component);
  function Photoshop2(props) {
    _classCallCheck$1d(this, Photoshop2);
    var _this = _possibleConstructorReturn$17(this, (Photoshop2.__proto__ || Object.getPrototypeOf(Photoshop2)).call(this));
    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }
  _createClass$1d(Photoshop2, [{
    key: "render",
    value: function render3() {
      var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === void 0 ? {} : _props$styles, _props$className = _props.className, className = _props$className === void 0 ? "" : _props$className;
      var styles2 = reactCSS(merge({
        "default": {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, passedStyles));
      return /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.picker,
        className: "photoshop-picker " + className
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.head
      }, this.props.header), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.body,
        className: "flexbox-fix"
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.saturation
      }, /* @__PURE__ */ React__default.createElement(Saturation, {
        hsl: this.props.hsl,
        hsv: this.props.hsv,
        pointer: PhotoshopPointerCircle$1,
        onChange: this.props.onChange
      })), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.hue
      }, /* @__PURE__ */ React__default.createElement(Hue, {
        direction: "vertical",
        hsl: this.props.hsl,
        pointer: PhotoshopPointerCircle2,
        onChange: this.props.onChange
      })), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.controls
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.top,
        className: "flexbox-fix"
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.previews
      }, /* @__PURE__ */ React__default.createElement(PhotoshopPreviews, {
        rgb: this.props.rgb,
        currentColor: this.state.currentColor
      })), /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.actions
      }, /* @__PURE__ */ React__default.createElement(PhotoshopButton, {
        label: "OK",
        onClick: this.props.onAccept,
        active: true
      }), /* @__PURE__ */ React__default.createElement(PhotoshopButton, {
        label: "Cancel",
        onClick: this.props.onCancel
      }), /* @__PURE__ */ React__default.createElement(PhotoshopPicker, {
        onChange: this.props.onChange,
        rgb: this.props.rgb,
        hsv: this.props.hsv,
        hex: this.props.hex
      }))))));
    }
  }]);
  return Photoshop2;
})(React__default.Component);
Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};
Photoshop.defaultProps = {
  header: "Color Picker",
  styles: {}
};
ColorWrap(Photoshop);
var SketchFields = function SketchFields2(_ref) {
  var onChange = _ref.onChange, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hex2 = _ref.hex, disableAlpha = _ref.disableAlpha;
  var styles2 = reactCSS({
    "default": {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    "disableAlpha": {
      alpha: {
        display: "none"
      }
    }
  }, {
    disableAlpha
  });
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb2.r,
        g: data2.g || rgb2.g,
        b: data2.b || rgb2.b,
        a: rgb2.a,
        source: "rgb"
      }, e);
    } else if (data2.a) {
      if (data2.a < 0) {
        data2.a = 0;
      } else if (data2.a > 100) {
        data2.a = 100;
      }
      data2.a /= 100;
      onChange({
        h: hsl2.h,
        s: hsl2.s,
        l: hsl2.l,
        a: data2.a,
        source: "rgb"
      }, e);
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.fields,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.double
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "hex",
    value: hex2.replace("#", ""),
    onChange: handleChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "r",
    value: rgb2.r,
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "255"
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "g",
    value: rgb2.g,
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "255"
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "b",
    value: rgb2.b,
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "255"
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.alpha
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "a",
    value: Math.round(rgb2.a * 100),
    onChange: handleChange,
    dragLabel: "true",
    dragMax: "100"
  })));
};
var _extends$4 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var SketchPresetColors = function SketchPresetColors2(_ref) {
  var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
  var styles2 = reactCSS({
    "default": {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !colors || !colors.length
  });
  var handleClick = function handleClick2(hex2, e) {
    onClick({
      hex: hex2,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.colors,
    className: "flexbox-fix"
  }, colors.map(function(colorObjOrString) {
    var c = typeof colorObjOrString === "string" ? {
      color: colorObjOrString
    } : colorObjOrString;
    var key = "" + c.color + (c.title || "");
    return /* @__PURE__ */ React__default.createElement("div", {
      key,
      style: styles2.swatchWrap
    }, /* @__PURE__ */ React__default.createElement(Swatch$1, _extends$4({}, c, {
      style: styles2.swatch,
      onClick: handleClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
      }
    })));
  }));
};
SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};
var _extends$3 = Object.assign || function(target2) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target2[key] = source[key];
      }
    }
  }
  return target2;
};
var Sketch = function Sketch2(_ref) {
  var width = _ref.width, rgb2 = _ref.rgb, hex2 = _ref.hex, hsv = _ref.hsv, hsl2 = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": _extends$3({
      picker: {
        width,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + rgb2.r + "," + rgb2.g + "," + rgb2.b + "," + rgb2.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, passedStyles),
    "disableAlpha": {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, passedStyles), {
    disableAlpha
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker,
    className: "sketch-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.saturation
  }, /* @__PURE__ */ React__default.createElement(Saturation, {
    style: styles2.Saturation,
    hsl: hsl2,
    hsv,
    onChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.controls,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.sliders
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React__default.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    onChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.alpha
  }, /* @__PURE__ */ React__default.createElement(Alpha, {
    style: styles2.Alpha,
    rgb: rgb2,
    hsl: hsl2,
    renderers,
    onChange
  }))), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.color
  }, /* @__PURE__ */ React__default.createElement(Checkboard, null), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.activeColor
  }))), /* @__PURE__ */ React__default.createElement(SketchFields, {
    rgb: rgb2,
    hsl: hsl2,
    hex: hex2,
    onChange,
    disableAlpha
  }), /* @__PURE__ */ React__default.createElement(SketchPresetColors, {
    colors: presetColors,
    onClick: onChange,
    onSwatchHover
  }));
};
Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
const SketchPicker = ColorWrap(Sketch);
var SliderSwatch = function SliderSwatch2(_ref) {
  var hsl2 = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, active2 = _ref.active, first = _ref.first, last = _ref.last;
  var styles2 = reactCSS({
    "default": {
      swatch: {
        height: "12px",
        background: "hsl(" + hsl2.h + ", 50%, " + offset * 100 + "%)",
        cursor: "pointer"
      }
    },
    "first": {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    "last": {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    "active": {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, {
    active: active2,
    first,
    last
  });
  var handleClick = function handleClick2(e) {
    return onClick({
      h: hsl2.h,
      s: 0.5,
      l: offset,
      source: "hsl"
    }, e);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch,
    onClick: handleClick
  });
};
var SliderSwatches = function SliderSwatches2(_ref) {
  var onClick = _ref.onClick, hsl2 = _ref.hsl;
  var styles2 = reactCSS({
    "default": {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  });
  var epsilon3 = 0.1;
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatches
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".80",
    active: Math.abs(hsl2.l - 0.8) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick,
    first: true
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".65",
    active: Math.abs(hsl2.l - 0.65) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".50",
    active: Math.abs(hsl2.l - 0.5) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".35",
    active: Math.abs(hsl2.l - 0.35) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }, /* @__PURE__ */ React__default.createElement(SliderSwatch, {
    hsl: hsl2,
    offset: ".20",
    active: Math.abs(hsl2.l - 0.2) < epsilon3 && Math.abs(hsl2.s - 0.5) < epsilon3,
    onClick,
    last: true
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.clear
  }));
};
var SliderPointer2 = function SliderPointer3() {
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
var Slider = function Slider2(_ref) {
  var hsl2 = _ref.hsl, onChange = _ref.onChange, pointer2 = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.wrap || {},
    className: "slider-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React__default.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    pointer: pointer2,
    onChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatches
  }, /* @__PURE__ */ React__default.createElement(SliderSwatches, {
    hsl: hsl2,
    onClick: onChange
  })));
};
Slider.propTypes = {
  styles: PropTypes.object
};
Slider.defaultProps = {
  pointer: SliderPointer2,
  styles: {}
};
ColorWrap(Slider);
var CheckIcon$1 = {};
var hasRequiredCheckIcon;
function requireCheckIcon() {
  if (hasRequiredCheckIcon) return CheckIcon$1;
  hasRequiredCheckIcon = 1;
  Object.defineProperty(CheckIcon$1, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target2) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target2[key] = source[key];
        }
      }
    }
    return target2;
  };
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _objectWithoutProperties(obj, keys2) {
    var target2 = {};
    for (var i in obj) {
      if (keys2.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target2[i] = obj[i];
    }
    return target2;
  }
  var DEFAULT_SIZE = 24;
  CheckIcon$1.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === void 0 ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, props = _objectWithoutProperties(_ref, ["fill", "width", "height", "style"]);
    return _react2.default.createElement("svg", _extends2({
      viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
      style: _extends2({
        fill,
        width,
        height
      }, style)
    }, props), _react2.default.createElement("path", {
      d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
  };
  return CheckIcon$1;
}
var CheckIconExports = requireCheckIcon();
const CheckIcon = /* @__PURE__ */ getDefaultExportFromCjs(CheckIconExports);
var SwatchesColor = function SwatchesColor2(_ref) {
  var color2 = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active2 = _ref.active;
  var styles2 = reactCSS({
    "default": {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: color2,
        marginBottom: "1px"
      },
      check: {
        color: getContrastingColor(color2),
        marginLeft: "8px",
        display: "none"
      }
    },
    "first": {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    "last": {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    "active": {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    "transparent": {
      check: {
        color: "#333"
      }
    }
  }, {
    first,
    last,
    active: active2,
    "color-#FFFFFF": color2 === "#FFFFFF",
    "transparent": color2 === "transparent"
  });
  return /* @__PURE__ */ React__default.createElement(Swatch$1, {
    color: color2,
    style: styles2.color,
    onClick,
    onHover: onSwatchHover,
    focusStyle: {
      boxShadow: "0 0 4px " + color2
    }
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.check
  }, /* @__PURE__ */ React__default.createElement(CheckIcon, null)));
};
var SwatchesGroup = function SwatchesGroup2(_ref) {
  var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group2 = _ref.group, active2 = _ref.active;
  var styles2 = reactCSS({
    "default": {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.group
  }, map$1(group2, function(color2, i) {
    return /* @__PURE__ */ React__default.createElement(SwatchesColor, {
      key: color2,
      color: color2,
      active: color2.toLowerCase() === active2,
      first: i === 0,
      last: i === group2.length - 1,
      onClick,
      onSwatchHover
    });
  }));
};
var Swatches = function Swatches2(_ref) {
  var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex2 = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      picker: {
        width,
        height
      },
      overflow: {
        height,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e) {
    return onChange({
      hex: data2,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker,
    className: "swatches-picker " + className
  }, /* @__PURE__ */ React__default.createElement(Raised, null, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.overflow
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.body
  }, map$1(colors, function(group2) {
    return /* @__PURE__ */ React__default.createElement(SwatchesGroup, {
      key: group2.toString(),
      group: group2,
      active: hex2,
      onClick: handleChange,
      onSwatchHover
    });
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.clear
  })))));
};
Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object
  /* eslint-disable max-len */
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red["900"], red["700"], red["500"], red["300"], red["100"]], [pink["900"], pink["700"], pink["500"], pink["300"], pink["100"]], [purple["900"], purple["700"], purple["500"], purple["300"], purple["100"]], [deepPurple["900"], deepPurple["700"], deepPurple["500"], deepPurple["300"], deepPurple["100"]], [indigo["900"], indigo["700"], indigo["500"], indigo["300"], indigo["100"]], [blue["900"], blue["700"], blue["500"], blue["300"], blue["100"]], [lightBlue["900"], lightBlue["700"], lightBlue["500"], lightBlue["300"], lightBlue["100"]], [cyan["900"], cyan["700"], cyan["500"], cyan["300"], cyan["100"]], [teal["900"], teal["700"], teal["500"], teal["300"], teal["100"]], ["#194D33", green["700"], green["500"], green["300"], green["100"]], [lightGreen["900"], lightGreen["700"], lightGreen["500"], lightGreen["300"], lightGreen["100"]], [lime["900"], lime["700"], lime["500"], lime["300"], lime["100"]], [yellow["900"], yellow["700"], yellow["500"], yellow["300"], yellow["100"]], [amber["900"], amber["700"], amber["500"], amber["300"], amber["100"]], [orange["900"], orange["700"], orange["500"], orange["300"], orange["100"]], [deepOrange["900"], deepOrange["700"], deepOrange["500"], deepOrange["300"], deepOrange["100"]], [brown["900"], brown["700"], brown["500"], brown["300"], brown["100"]], [blueGrey["900"], blueGrey["700"], blueGrey["500"], blueGrey["300"], blueGrey["100"]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
ColorWrap(Swatches);
var Twitter = function Twitter2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex2 = _ref.hex, colors = _ref.colors, width = _ref.width, triangle2 = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle2 === "hide",
    "top-left-triangle": triangle2 === "top-left",
    "top-right-triangle": triangle2 === "top-right"
  });
  var handleChange = function handleChange2(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: "hex"
    }, e);
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.card,
    className: "twitter-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.triangleShadow
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.triangle
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.body
  }, map$1(colors, function(c, i) {
    return /* @__PURE__ */ React__default.createElement(Swatch$1, {
      key: i,
      color: c,
      hex: c,
      style: styles2.swatch,
      onClick: handleChange,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: "0 0 4px " + c
      }
    });
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.hash
  }, "#"), /* @__PURE__ */ React__default.createElement(EditableInput, {
    label: null,
    style: {
      input: styles2.input
    },
    value: hex2.replace("#", ""),
    onChange: handleChange
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.clear
  })));
};
Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right"]),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Twitter);
var GooglePointerCircle = function GooglePointerCircle2(props) {
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.5
  }
};
var GooglePointer = function GooglePointer2(props) {
  var styles2 = reactCSS({
    "default": {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker
  });
};
GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: {
    a: 1,
    h: 249.94,
    l: 0.2,
    s: 0.5
  }
};
var GoogleFields = function GoogleFields2(_ref) {
  var onChange = _ref.onChange, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hex2 = _ref.hex, hsv = _ref.hsv;
  var handleChange = function handleChange2(data2, e) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e);
    } else if (data2.rgb) {
      var values = data2.rgb.split(",");
      isvalidColorString(data2.rgb, "rgb") && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: "rgb"
      }, e);
    } else if (data2.hsv) {
      var _values = data2.hsv.split(",");
      if (isvalidColorString(data2.hsv, "hsv")) {
        _values[2] = _values[2].replace("%", "");
        _values[1] = _values[1].replace("%", "");
        _values[0] = _values[0].replace("°", "");
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: "hsv"
        }, e);
      }
    } else if (data2.hsl) {
      var _values2 = data2.hsl.split(",");
      if (isvalidColorString(data2.hsl, "hsl")) {
        _values2[2] = _values2[2].replace("%", "");
        _values2[1] = _values2[1].replace("%", "");
        _values2[0] = _values2[0].replace("°", "");
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: "hsl"
        }, e);
      }
    }
  };
  var styles2 = reactCSS({
    "default": {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  });
  var rgbValue = rgb2.r + ", " + rgb2.g + ", " + rgb2.b;
  var hslValue = Math.round(hsl2.h) + "°, " + Math.round(hsl2.s * 100) + "%, " + Math.round(hsl2.l * 100) + "%";
  var hsvValue = Math.round(hsv.h) + "°, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.wrap,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.fields
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.double
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input,
      label: styles2.label
    },
    label: "hex",
    value: hex2,
    onChange: handleChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.column
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input2,
      label: styles2.label2
    },
    label: "rgb",
    value: rgbValue,
    onChange: handleChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input2,
      label: styles2.label2
    },
    label: "hsv",
    value: hsvValue,
    onChange: handleChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.single
  }, /* @__PURE__ */ React__default.createElement(EditableInput, {
    style: {
      input: styles2.input2,
      label: styles2.label2
    },
    label: "hsl",
    value: hslValue,
    onChange: handleChange
  })))));
};
var Google = function Google2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, rgb2 = _ref.rgb, hsl2 = _ref.hsl, hsv = _ref.hsv, hex2 = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = reactCSS(merge({
    "default": {
      picker: {
        width,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + rgb2.r + ", " + rgb2.g + ", " + rgb2.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  return /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.picker,
    className: "google-picker " + className
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.head
  }, header), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.swatch
  }), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.saturation
  }, /* @__PURE__ */ React__default.createElement(Saturation, {
    hsl: hsl2,
    hsv,
    pointer: GooglePointerCircle,
    onChange
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.body
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.controls,
    className: "flexbox-fix"
  }, /* @__PURE__ */ React__default.createElement("div", {
    style: styles2.hue
  }, /* @__PURE__ */ React__default.createElement(Hue, {
    style: styles2.Hue,
    hsl: hsl2,
    radius: "4px",
    pointer: GooglePointer,
    onChange
  }))), /* @__PURE__ */ React__default.createElement(GoogleFields, {
    rgb: rgb2,
    hsl: hsl2,
    hex: hex2,
    hsv,
    onChange
  })));
};
Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
ColorWrap(Google);
function _classCallCheck$1c(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1c(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1c(o.key), o);
  }
}
function _createClass$1c(e, r2, t) {
  return r2 && _defineProperties$1c(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1c(t) {
  var i = _toPrimitive$1c(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1c(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$16(t, o, e) {
  return o = _getPrototypeOf$16(o), _possibleConstructorReturn$16(t, _isNativeReflectConstruct$16() ? Reflect.construct(o, e || [], _getPrototypeOf$16(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$16(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$16(t);
}
function _assertThisInitialized$16(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$16() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$16 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$16(t) {
  return _getPrototypeOf$16 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$16(t);
}
function _inherits$16(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$16(t, e);
}
function _setPrototypeOf$16(t, e) {
  return _setPrototypeOf$16 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$16(t, e);
}
let SketchInlinePicker = /* @__PURE__ */ (function(_React$Component) {
  function SketchInlinePicker2(props) {
    var _this;
    _classCallCheck$1c(this, SketchInlinePicker2);
    _this = _callSuper$16(this, SketchInlinePicker2, [props]);
    const startColor = rgb(props.color);
    _this.state = {
      displayColorPicker: false,
      color: {
        r: startColor.r,
        g: startColor.g,
        b: startColor.b,
        a: startColor.opacity
      }
    };
    return _this;
  }
  _inherits$16(SketchInlinePicker2, _React$Component);
  return _createClass$1c(SketchInlinePicker2, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState((prevState) => ({
        displayColorPicker: !prevState.displayColorPicker
      }));
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        displayColorPicker: false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(color2) {
      const rgb2 = color2.rgb;
      const colorString = `rgba(${rgb2.r},${rgb2.g},${rgb2.b},${rgb2.a})`;
      this.props.onChange(colorString);
      this.setState({
        color: color2.rgb
      });
    }
  }, {
    key: "render",
    value: function render3() {
      const styles2 = reactCSS({
        default: {
          color: {
            width: "32px",
            height: "14px",
            borderRadius: "2px",
            background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`
          },
          swatch: {
            padding: "5px",
            background: "#fff",
            cursor: "pointer",
            borderRadius: "1px"
          },
          popover: {
            position: "absolute",
            zIndex: "2"
          },
          cover: {
            position: "fixed",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px"
          }
        }
      });
      return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
        onClick: this.handleClick.bind(this),
        style: styles2.swatch
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.color
      })), this.state.displayColorPicker ? /* @__PURE__ */ React__default.createElement("div", {
        style: styles2.popover
      }, /* @__PURE__ */ React__default.createElement("div", {
        onClick: this.handleClose.bind(this),
        style: styles2.cover
      }), /* @__PURE__ */ React__default.createElement(SketchPicker, {
        color: this.state.color,
        onChange: this.handleChange.bind(this)
      })) : null);
    }
  }]);
})(React__default.Component);
SketchInlinePicker.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func
};
function _classCallCheck$1b(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1b(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1b(o.key), o);
  }
}
function _createClass$1b(e, r2, t) {
  return r2 && _defineProperties$1b(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1b(t) {
  var i = _toPrimitive$1b(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1b(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$15(t, o, e) {
  return o = _getPrototypeOf$15(o), _possibleConstructorReturn$15(t, _isNativeReflectConstruct$15() ? Reflect.construct(o, e || [], _getPrototypeOf$15(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$15(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$15(t);
}
function _assertThisInitialized$15(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$15() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$15 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$15(t) {
  return _getPrototypeOf$15 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$15(t);
}
function _inherits$15(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$15(t, e);
}
function _setPrototypeOf$15(t, e) {
  return _setPrototypeOf$15 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$15(t, e);
}
let HeatmapOptions = /* @__PURE__ */ (function(_React$Component) {
  function HeatmapOptions2(props) {
    var _this;
    _classCallCheck$1b(this, HeatmapOptions2);
    _this = _callSuper$15(this, HeatmapOptions2, [props]);
    _this.state = {
      colors: props.track.options.colorRange.slice()
    };
    return _this;
  }
  _inherits$15(HeatmapOptions2, _React$Component);
  return _createClass$1b(HeatmapOptions2, [{
    key: "handleColorsChanged",
    value: function handleColorsChanged(newColors) {
      this.setState({
        colors: newColors
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      const options2 = this.props.track.options;
      options2.colorRange = this.state.colors;
      this.props.onSubmit(this.props.track.options);
    }
    /**
     * Add a color to the end
     */
  }, {
    key: "handleAddColor",
    value: function handleAddColor() {
      this.setState((prevState) => ({
        colors: prevState.colors.concat(prevState.colors[prevState.colors.length - 1])
      }));
    }
    /**
     * Remove one of the colors from the color map
     */
  }, {
    key: "handleRemoveColor",
    value: function handleRemoveColor(i) {
      this.setState((prevState) => ({
        colors: prevState.colors.slice(0, i).concat(prevState.colors.slice(i + 1))
      }));
    }
  }, {
    key: "render",
    value: function render3() {
      const track = JSON.parse(JSON.stringify(this.props.track));
      const centerTrack = Object.assign(track, {
        options: {
          colorRange: this.state.colors
        }
      });
      const mvConfig = {
        editable: false,
        zoomFixed: true,
        views: [{
          uid: `hmo-${this.props.track.uid}`,
          initialXDomain: this.props.xScale ? this.props.xScale.domain() : [0, 1],
          initialYDomain: this.props.yScale ? this.props.yScale.domain() : [0, 1],
          tracks: {
            center: [centerTrack]
          },
          layout: {
            x: 0,
            y: 0,
            h: 12,
            w: 12,
            i: `hmo-${this.props.track.id}`
          }
        }]
      };
      const colorFields = this.state.colors.map((x, i) => {
        const removeButton = this.state.colors.length > 2 && i === this.state.colors.length - 1 ? /* @__PURE__ */ React__default.createElement("div", {
          onClick: () => this.handleRemoveColor(i),
          style: {
            background: "white",
            position: "absolute",
            top: 0,
            right: 0,
            opacity: 1,
            width: 14,
            height: 14,
            borderRadius: 2,
            cursor: "pointer"
          }
        }, /* @__PURE__ */ React__default.createElement("svg", {
          height: "10px",
          style: {
            position: "absolute",
            top: 2,
            right: 2,
            opacity: 0.5,
            width: 10,
            height: 10
          }
        }, /* @__PURE__ */ React__default.createElement("title", null, "Remove"), /* @__PURE__ */ React__default.createElement("use", {
          xlinkHref: "#cross"
        }))) : null;
        return (
          // Colors may be repeated, so the array index is the best choice here.
          /* @__PURE__ */ React__default.createElement("div", {
            // biome-ignore lint/suspicious/noArrayIndexKey:
            key: `l${i}`,
            style: {
              borderRadius: "1px",
              boxShadow: "0 0 0 1px #E5E5E5",
              position: "relative",
              outline: "none"
            }
          }, removeButton, /* @__PURE__ */ React__default.createElement(
            SketchInlinePicker,
            {
              key: i,
              color: this.state.colors[i],
              onChange: (c) => {
                this.setState((prevState) => {
                  const colors = prevState.colors.slice();
                  colors[i] = c;
                  return {
                    colors
                  };
                }, () => {
                  this.handleColorsChanged(this.state.colors);
                });
              }
            }
          ))
        );
      }).reverse();
      const addButton = this.state.colors.length < 10 ? /* @__PURE__ */ React__default.createElement("div", {
        onClick: this.handleAddColor.bind(this),
        style: {
          position: "relative",
          outline: "none",
          height: "25px",
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px #E5E5E5",
          cursor: "pointer"
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: {
          textAlign: "center",
          width: "32px",
          height: "14px"
        }
      }, /* @__PURE__ */ React__default.createElement("svg", {
        height: "100%",
        style: {
          opacity: 0.5,
          margin: "auto",
          display: "block"
        },
        width: "10px"
      }, /* @__PURE__ */ React__default.createElement("title", null, "Add"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#plus"
      })))) : null;
      return /* @__PURE__ */ React__default.createElement(Dialog$1, {
        okayTitle: "Submit",
        onCancel: this.props.onCancel,
        onOkay: this.handleSubmit.bind(this),
        title: "Custom Color Map"
      }, /* @__PURE__ */ React__default.createElement("table", {
        className: "table-track-options"
      }, /* @__PURE__ */ React__default.createElement("thead", null), /* @__PURE__ */ React__default.createElement("tbody", {
        style: {
          verticalAlign: "top"
        }
      }, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
        className: "td-track-options"
      }, /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
        className: "td-track-options"
      }, "Preview")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
        className: "td-track-options",
        "aria-label": "Track options"
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: {
          width: 200
        }
      }, /* @__PURE__ */ React__default.createElement(HiGlassComponent, {
        options: {
          bounded: false
        },
        viewConfig: mvConfig
      }))))))), /* @__PURE__ */ React__default.createElement("td", {
        className: "td-track-options"
      }, /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
        className: "td-track-options"
      }, "Colors")), /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
        className: "td-track-options"
      }, addButton, /* @__PURE__ */ React__default.createElement("div", {
        style: {
          position: "relative"
        }
      }, colorFields))))))))));
    }
  }]);
})(React__default.Component);
HeatmapOptions.propTypes = {
  handleCancel: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  track: PropTypes.object,
  xScale: PropTypes.object,
  yScale: PropTypes.object
};
const valueColumnOptions = (track) => {
  if (!track.header) return [];
  const headerParts = track.header.split("	");
  const options2 = [];
  for (let i = 0; i < headerParts.length; i++) {
    options2.push({
      name: headerParts[i],
      value: i + 1
    });
  }
  return options2;
};
const sizesInPx = (sizes, unit2 = "", multiplier = 1) => sizes.reduce((sizeOption, size) => {
  sizeOption[size] = {
    name: `${size * multiplier}${unit2}`,
    value: size
  };
  return sizeOption;
}, {});
const YES_NO = {
  yes: {
    name: "Yes",
    value: true
  },
  no: {
    name: "No",
    value: false
  }
};
const AVAILABLE_COLORS = {
  black: {
    name: "Black",
    value: "black"
  },
  blue: {
    name: "Blue",
    value: "blue"
  },
  brown: {
    name: "Brown",
    value: "brown"
  },
  cyan: {
    name: "Cyan",
    value: "cyan"
  },
  green: {
    name: "Green",
    value: "green"
  },
  grey: {
    name: "Grey",
    value: "grey"
  },
  orange: {
    name: "Orange",
    value: "orange"
  },
  purple: {
    name: "Purple",
    value: "purple"
  },
  turquoise: {
    name: "Turquoise",
    value: "turquoise"
  },
  red: {
    name: "Red",
    value: "red"
  },
  white: {
    name: "White",
    value: "white"
  }
};
const SPECIAL_COLORS = {
  use_stroke: {
    name: "Glyph color",
    value: "[glyph-color]"
  }
};
const AVAILABLE_WIDTHS = sizesInPx([0, 1, 2, 3, 5, 8, 13, 21]);
const AVAILABLE_WIDTHS_AND_NONE = Object.assign(AVAILABLE_WIDTHS, {
  none: {
    name: "none",
    value: "none"
  }
});
const AVAILABLE_MARGIN = sizesInPx([0, 2, 4, 8, 16, 32, 64, 128, 256]);
const OPACITY_OPTIONS = sizesInPx([0, 0.2, 0.4, 0.6, 0.8, 1], "%", 100);
const OPACITY_OPTIONS_NO_ZERO = sizesInPx([0.2, 0.4, 0.6, 0.8, 1], "%", 100);
const OPTIONS_INFO = {
  axisLabelFormatting: {
    name: "Axis Label Formatting",
    inlineOptions: {
      normal: {
        name: "normal",
        value: "normal"
      },
      scientific: {
        name: "scientific",
        value: "scientific"
      }
    }
  },
  flipDiagonal: {
    name: "Flip Across Diagonal",
    inlineOptions: {
      none: {
        name: "No",
        value: "none"
      },
      yes: {
        name: "Yes",
        value: "yes"
      },
      copy: {
        name: "Copy",
        value: "copy"
      }
    }
  },
  heatmapValueScaling: {
    name: "Value Scaling",
    inlineOptions: {
      linear: {
        name: "Linear",
        value: "linear"
      },
      log: {
        name: "Log",
        value: "log"
      }
    }
  },
  valueScaling: {
    name: "Value Scaling",
    inlineOptions: {
      linear: {
        name: "Linear",
        value: "linear"
      },
      log: {
        name: "Log",
        value: "log"
      }
    }
  },
  extent: {
    name: "Extent",
    inlineOptions: {
      full: {
        name: "Full",
        value: "full"
      },
      upperRight: {
        name: "Upper Right",
        value: "upper-right"
      },
      lowerLeft: {
        name: "Lower Left",
        value: "lower-left"
      }
    }
  },
  labelLeftMargin: {
    name: "Label Left Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelRightMargin: {
    name: "Label Right Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelTopMargin: {
    name: "Label Top Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelBottomMargin: {
    name: "Label Bottom Margin",
    inlineOptions: AVAILABLE_MARGIN
  },
  labelShowResolution: {
    name: "Label Show Resolution",
    inlineOptions: YES_NO
  },
  labelShowAssembly: {
    name: "Label Show Assembly",
    inlineOptions: YES_NO
  },
  lineStrokeWidth: {
    name: "Stroke Width",
    inlineOptions: AVAILABLE_WIDTHS
  },
  strokeSingleSeries: {
    name: "Draw single series",
    generateOptions: (track) => {
      const inlineOptions = [];
      if (track.row_infos) {
        for (let i = 0; i < track.row_infos.length; i++) {
          inlineOptions.push({
            name: i + 1,
            value: i + 1
          });
        }
      }
      inlineOptions.push({
        name: "All",
        value: "all"
      });
      inlineOptions.push({
        name: "None",
        value: "none"
      });
      return inlineOptions;
    }
  },
  strokeWidthAndNone: {
    name: "Stroke Width",
    inlineOptions: AVAILABLE_WIDTHS_AND_NONE
  },
  trackBorderWidth: {
    name: "Track Border Width",
    inlineOptions: AVAILABLE_WIDTHS
  },
  separatePlusMinusStrands: {
    name: "Separate +/- strands",
    inlineOptions: YES_NO
  },
  sortLargestOnTop: {
    name: "Sort Largest On Top",
    inlineOptions: YES_NO
  },
  showTexts: {
    name: "Show texts",
    inlineOptions: YES_NO
  },
  staggered: {
    name: "Staggered",
    inlineOptions: YES_NO
  },
  minSquareSize: {
    name: "Minimum size",
    inlineOptions: AVAILABLE_WIDTHS_AND_NONE
  },
  pointSize: {
    name: "Point Size",
    inlineOptions: AVAILABLE_WIDTHS
  },
  pointColor: {
    name: "Point Color",
    inlineOptions: AVAILABLE_COLORS
  },
  trackBorderColor: {
    name: "Track Border Color",
    inlineOptions: AVAILABLE_COLORS
  },
  backgroundColor: {
    name: "Background Color",
    inlineOptions: {
      white: {
        name: "White",
        value: "white"
      },
      lightGrey: {
        name: "Light Grey",
        value: "#eeeeee"
      },
      grey: {
        name: "Grey",
        value: "#cccccc"
      },
      black: {
        name: "Black",
        value: "black"
      },
      transparent: {
        name: "Transparent",
        value: "transparent"
      }
    }
  },
  colorScale: {
    name: "Color Scale",
    inlineOptions: {
      epilogos: {
        name: "Epilogos",
        values: ["#FF0000", "#FF4500", "#32CD32", "#008000", "#006400", "#C2E105", "#FFFF00", "#66CDAA", "#8A91D0", "#CD5C5C", "#E9967A", "#BDB76B", "#808080", "#C0C0C0", "#FFFFFF"]
      },
      category10: {
        name: "D3 Category10",
        values: ["#1F77B4", "#FF7F0E", "#2CA02C", "#D62728", "#9467BD", "#8C564B", "#E377C2", "#7F7F7F", "#BCBD22", "#17BECF"]
      }
    }
  },
  minusStrandColor: {
    name: "- Strand Color",
    inlineOptions: AVAILABLE_COLORS
  },
  plusStrandColor: {
    name: "+ Strand Color",
    inlineOptions: AVAILABLE_COLORS
  },
  lineStrokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  projectionStrokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  projectionFillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  stroke: {
    name: "Stroke Color",
    inlineOptions: AVAILABLE_COLORS
  },
  strokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  fill: {
    name: "Fill Color",
    inlineOptions: AVAILABLE_COLORS
  },
  color: {
    name: "Color",
    inlineOptions: AVAILABLE_COLORS
  },
  fontColor: {
    name: "Font color",
    inlineOptions: AVAILABLE_COLORS
  },
  fillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barFillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barFillColorTop: {
    name: "Top Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barFillColorBottom: {
    name: "Bottom Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  barOpacity: {
    name: "Bar opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  viewNameOpacity: {
    name: "View name opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  zeroLineVisible: {
    name: "Zero line visible",
    inlineOptions: YES_NO
  },
  zeroLineColor: {
    name: "Zero line color",
    inlineOptions: AVAILABLE_COLORS
  },
  zeroLineOpacity: {
    name: "Zero line opacity",
    inlineOptions: OPACITY_OPTIONS_NO_ZERO
  },
  fillOpacity: {
    name: "Fill Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  strokeOpacity: {
    name: "Stroke Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  strokePos: {
    name: "Stroke Position",
    inlineOptions: {
      aroundInner: {
        name: "Around Inner",
        value: "around"
      },
      aroundCenter: {
        name: "Around Center",
        value: null
      },
      hidden: {
        name: "Hidden",
        value: "hidden"
      },
      top: {
        name: "Top",
        value: "top"
      },
      right: {
        name: "Right",
        value: "right"
      },
      bottom: {
        name: "Bottom",
        value: "bottom"
      },
      left: {
        name: "Left",
        value: "left"
      }
    }
  },
  barBorder: {
    name: "Bar border",
    inlineOptions: YES_NO
  },
  scaledHeight: {
    name: "Scaled height",
    inlineOptions: YES_NO
  },
  rectangleDomainStrokeColor: {
    name: "Stroke color",
    inlineOptions: AVAILABLE_COLORS
  },
  rectangleDomainFillColor: {
    name: "Fill color",
    inlineOptions: AVAILABLE_COLORS
  },
  rectangleDomainFillOpacity: {
    name: "Fill opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  rectangleDomainOpacity: {
    name: "Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  mapboxStyle: {
    name: "Map style",
    inlineOptions: {
      streets: {
        name: "streets",
        value: "mapbox.streets"
      },
      light: {
        name: "light",
        value: "mapbox.light"
      },
      dark: {
        name: "dark",
        value: "mapbox.dark"
      },
      satellite: {
        name: "satellite",
        value: "mapbox.satellite"
      },
      "streets-satellite": {
        name: "streets-satellite",
        value: "mapbox.streets-satellite"
      },
      wheatpaste: {
        name: "wheatpaste",
        value: "mapbox.wheatpaste"
      },
      "streets-basic": {
        name: "streets-basic",
        value: "mapbox.streets-basic"
      },
      comic: {
        name: "comic",
        value: "mapbox.comic"
      },
      outdoors: {
        name: "outdoors",
        value: "mapbox.outdoors"
      },
      "run-bike-hike": {
        name: "run-bike-hike",
        value: "mapbox.run-bike-hike"
      },
      pencil: {
        name: "pencil",
        value: "mapbox.pencil"
      },
      pirates: {
        name: "pirates",
        value: "mapbox.pirates"
      },
      emerald: {
        name: "emerald",
        value: "mapbox.emerald"
      },
      "high-contrast": {
        name: "high-contrast",
        value: "mapbox.high-contrast"
      }
    }
  },
  oneDHeatmapFlipped: {
    name: "Flip Heatmap",
    inlineOptions: {
      yes: {
        name: "Yes",
        value: "yes"
      },
      no: {
        name: "No",
        value: null
      }
    }
  },
  showMousePosition: {
    name: "Show Mouse Position",
    inlineOptions: YES_NO
  },
  showTooltip: {
    name: "Show Tooltip",
    inlineOptions: YES_NO
  },
  nanAsZero: {
    name: "NaN as Zero",
    inlineOptions: YES_NO
  },
  fontSize: {
    name: "Font Size",
    inlineOptions: sizesInPx([8, 9, 10, 11, 12, 14, 16, 18, 24], "px")
  },
  tickPositions: {
    name: "Tick Positions",
    inlineOptions: {
      even: {
        name: "Even",
        value: "even"
      },
      ends: {
        name: "Ends",
        value: "ends"
      }
    }
  },
  tickFormat: {
    name: "Tick Format",
    inlineOptions: {
      plain: {
        name: "Plain",
        value: "plain"
      },
      si: {
        name: "SI",
        value: "si"
      }
    }
  },
  colorEncoding: {
    name: "Color Encode Annotations",
    inlineOptions: {
      none: {
        name: "None",
        value: null
      },
      itemRgb: {
        name: "itemRgb",
        value: "itemRgb"
      }
    },
    generateOptions: valueColumnOptions
  },
  fontIsAligned: {
    name: "Left-Align Font",
    inlineOptions: YES_NO
  },
  axisPositionHorizontal: {
    name: "Axis Position",
    inlineOptions: {
      left: {
        name: "Left",
        value: "left"
      },
      outsideLeft: {
        name: "Outside left",
        value: "outsideLeft"
      },
      right: {
        name: "Right",
        value: "right"
      },
      outsideRight: {
        name: "Outside right",
        value: "outsideRight"
      },
      hidden: {
        name: "Hidden",
        value: null
      }
    }
  },
  axisPositionVertical: {
    name: "Axis Position",
    inlineOptions: {
      top: {
        name: "Top",
        value: "top"
      },
      outsideTop: {
        name: "Outside top",
        value: "outsideTop"
      },
      bottom: {
        name: "Bottom",
        value: "bottom"
      },
      outsideBottom: {
        name: "Outside bottom",
        value: "outsideBottom"
      },
      hidden: {
        name: "Hidden",
        value: null
      }
    }
  },
  axisMargin: {
    name: "Axis Margin",
    inlineOptions: sizesInPx([0, 10, 20, 30, 40, 50, 100, 200, 400], "px")
  },
  reverseAxis: {
    name: "Reverse Axis",
    inlineOptions: YES_NO
  },
  colorbarPosition: {
    name: "Colorbar Position",
    inlineOptions: {
      topLeft: {
        name: "Top Left",
        value: "topLeft"
      },
      topRight: {
        name: "Top Right",
        value: "topRight"
      },
      bottomLeft: {
        name: "Bottom Left",
        value: "bottomLeft"
      },
      bottomRight: {
        name: "Bottom Right",
        value: "bottomRight"
      },
      hidden: {
        name: "Hidden",
        value: null
      }
    }
  },
  colorbarBackgroundColor: {
    name: "Colorbar Background Color",
    inlineOptions: AVAILABLE_COLORS
  },
  colorbarBackgroundOpacity: {
    name: "Colorbar Background Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  /*
  colorbarOrientation: {
    name: 'Colorbar Orientation',
    inlineOptions: {
      'horizontal': { name: 'Horizontal', value: 'horizontal' },
      'vertical': { name: 'Vertical', value: 'vertical' },
    }
  },
  */
  // This will default to 'inside' if it's not set when colorbarPosition
  // is set
  colorbarLabelsPosition: {
    name: "Colorbar Labels Position",
    inlineOptions: {
      inside: {
        name: "Inside",
        value: "inside"
      },
      outside: {
        name: "Outside",
        value: "outside"
      }
    }
  },
  labelColor: {
    name: "Label Color",
    inlineOptions: {
      ...AVAILABLE_COLORS,
      ...SPECIAL_COLORS
    }
  },
  labelPosition: {
    name: "Label Position",
    inlineOptions: {
      l: {
        name: "Left",
        value: "left"
      },
      r: {
        name: "Right",
        value: "right"
      },
      ol: {
        name: "Outer left",
        value: "outerLeft"
      },
      or: {
        name: "Outer right",
        value: "outerRight"
      },
      t: {
        name: "Top",
        value: "top"
      },
      b: {
        name: "Bottom",
        value: "bottom"
      },
      ot: {
        name: "Outer top",
        value: "outerTop"
      },
      ob: {
        name: "Outer bottom",
        value: "outerBottom"
      },
      tl: {
        name: "Top left",
        value: "topLeft"
      },
      tr: {
        name: "Top right",
        value: "topRight"
      },
      bl: {
        name: "Bottom left",
        value: "bottomLeft"
      },
      br: {
        name: "Bottom right",
        value: "bottomRight"
      },
      hidden: {
        name: "Hidden",
        value: "hidden"
      }
    }
  },
  labelTextOpacity: {
    name: "Label Text Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  geneAnnotationHeight: {
    name: "Gene Annotation Height",
    inlineOptions: {
      8: {
        name: "8px",
        value: 8
      },
      10: {
        name: "10px",
        value: 10
      },
      12: {
        name: "12px",
        value: 12
      },
      16: {
        name: "16px",
        value: 16
      }
    }
  },
  annotationHeight: {
    name: "Annotation Height",
    inlineOptions: {
      5: {
        name: "5px",
        value: 5
      },
      8: {
        name: "8px",
        value: 8
      },
      10: {
        name: "10px",
        value: 10
      },
      12: {
        name: "12px",
        value: 12
      },
      16: {
        name: "16px",
        value: 16
      },
      20: {
        name: "20px",
        value: 20
      },
      scaled: {
        name: "scaled",
        value: "scaled"
      }
    }
  },
  maxAnnotationHeight: {
    name: "Max Annotation Height",
    inlineOptions: {
      5: {
        name: "5px",
        value: 5
      },
      8: {
        name: "8px",
        value: 8
      },
      10: {
        name: "10px",
        value: 10
      },
      12: {
        name: "12px",
        value: 12
      },
      16: {
        name: "16px",
        value: 16
      },
      20: {
        name: "20px",
        value: 20
      },
      none: {
        name: "none",
        value: null
      }
    }
  },
  annotationStyle: {
    name: "Annotation Style",
    inlineOptions: {
      box: {
        name: "Box",
        value: "box"
      },
      segment: {
        name: "Segment",
        value: "segment"
      }
    }
  },
  geneLabelPosition: {
    name: "Gene Label Position",
    inlineOptions: {
      inside: {
        name: "Inside",
        value: "inside"
      },
      outside: {
        name: "Outside",
        value: "outside"
      }
    }
  },
  geneStrandSpacing: {
    name: "Gene Strand Spacing",
    inlineOptions: {
      2: {
        name: "2px",
        value: 2
      },
      4: {
        name: "4px",
        value: 4
      },
      8: {
        name: "8px",
        value: 8
      }
    }
  },
  labelBackgroundColor: {
    name: "Label Background Color",
    inlineOptions: AVAILABLE_COLORS
  },
  labelBackgroundOpacity: {
    name: "Label Background Opacity",
    inlineOptions: OPACITY_OPTIONS
  },
  viewResolution: {
    name: "View Resolution",
    inlineOptions: {
      high: {
        name: "High",
        value: 384
      },
      medium: {
        name: "Medium",
        value: 1024
      },
      low: {
        name: "Low",
        value: 2048
      }
    }
  },
  // colormaps are mostly taken from here:
  // http://matplotlib.org/api/pyplot_summary.html?highlight=colormaps#matplotlib.pyplot.colormaps
  colorRange: {
    name: "Color map",
    inlineOptions: {
      afmhot: {
        name: "afmhot",
        value: ["rgba(0,0,0,1.0)", "rgba(128,0,0,1.0)", "rgba(256,129,1,1.0)", "rgba(256,256,129,1.0)", "rgba(256,256,256,1.0)"]
      },
      fall: {
        name: "fall",
        value: ["white", "rgba(245,166,35,1.0)", "rgba(208,2,27,1.0)", "black"]
      },
      hot: {
        name: "hot",
        value: ["rgba(10,0,0,1.0)", "rgba(179,0,0,1.0)", "rgba(256,91,0,1.0)", "rgba(256,256,6,1.0)", "rgba(256,256,256,1.0)"]
      },
      jet: {
        name: "jet",
        value: ["rgba(0,0,128,1.0)", "rgba(0,129,256,1.0)", "rgba(125,256,122,1.0)", "rgba(256,148,0,1.0)", "rgba(128,0,0,1.0)"]
      },
      bwr: {
        name: "bwr",
        value: ["rgba(0,0,256,1.0)", "rgba(128,128,256,1.0)", "rgba(256,254,254,1.0)", "rgba(256,126,126,1.0)", "rgba(256,0,0,1.0)"]
      },
      cubehelix: {
        name: "cubehelix",
        value: ["rgba(0,0,0,1.0)", "rgba(21,83,76,1.0)", "rgba(162,121,74,1.0)", "rgba(199,180,238,1.0)", "rgba(256,256,256,1.0)"]
      },
      rainbow: {
        name: "rainbow",
        value: ["rgba(128,0,256,1.0)", "rgba(0,181,236,1.0)", "rgba(129,255,180,1.0)", "rgba(256,179,96,1.0)", "rgba(256,0,0,1.0)"]
      },
      gray: {
        name: "greys",
        value: ["rgba(255,255,255,1)", "rgba(0,0,0,1)"]
      },
      red: {
        name: "White to red",
        value: ["rgba(255,255,255,1)", "rgba(255,0,0,1)"]
      },
      green: {
        name: "White to green",
        value: ["rgba(255,255,255,1)", "rgba(0,255,0,1)"]
      },
      blue: {
        name: "White to blue",
        value: ["rgba(255,255,255,1)", "rgba(0,0,255,1)"]
      },
      custard: {
        name: "custard",
        value: ["#FFFFFF", "#F8E71C", "rgba(245,166,35,1)", "rgba(0,0,0,1)"]
      },
      magma: {
        name: "magma",
        value: ["rgba(0,0,3,1)", "rgba(0,0,4,1)", "rgba(0,0,6,1)", "rgba(1,0,7,1)", "rgba(1,1,9,1)", "rgba(1,1,11,1)", "rgba(2,2,13,1)", "rgba(2,2,15,1)", "rgba(3,3,17,1)", "rgba(4,3,19,1)", "rgba(4,4,21,1)", "rgba(5,4,23,1)", "rgba(6,5,25,1)", "rgba(7,5,27,1)", "rgba(8,6,29,1)", "rgba(9,7,32,1)", "rgba(10,7,34,1)", "rgba(11,8,36,1)", "rgba(12,9,38,1)", "rgba(13,10,40,1)", "rgba(14,10,42,1)", "rgba(15,11,45,1)", "rgba(16,12,47,1)", "rgba(17,12,49,1)", "rgba(19,13,51,1)", "rgba(20,13,54,1)", "rgba(21,14,56,1)", "rgba(22,14,58,1)", "rgba(23,15,61,1)", "rgba(25,15,63,1)", "rgba(26,16,66,1)", "rgba(27,16,68,1)", "rgba(28,16,70,1)", "rgba(30,17,73,1)", "rgba(31,17,75,1)", "rgba(33,17,78,1)", "rgba(34,17,80,1)", "rgba(36,17,83,1)", "rgba(37,17,85,1)", "rgba(39,17,87,1)", "rgba(40,17,90,1)", "rgba(42,17,92,1)", "rgba(43,17,94,1)", "rgba(45,17,97,1)", "rgba(47,16,99,1)", "rgba(49,16,101,1)", "rgba(50,16,103,1)", "rgba(52,16,105,1)", "rgba(54,15,107,1)", "rgba(55,15,108,1)", "rgba(57,15,110,1)", "rgba(59,15,112,1)", "rgba(61,15,113,1)", "rgba(62,15,114,1)", "rgba(64,15,116,1)", "rgba(66,15,117,1)", "rgba(67,15,118,1)", "rgba(69,15,119,1)", "rgba(71,15,120,1)", "rgba(72,16,120,1)", "rgba(74,16,121,1)", "rgba(76,16,122,1)", "rgba(77,17,123,1)", "rgba(79,17,123,1)", "rgba(81,18,124,1)", "rgba(82,18,124,1)", "rgba(84,19,125,1)", "rgba(85,20,125,1)", "rgba(87,20,126,1)", "rgba(88,21,126,1)", "rgba(90,21,126,1)", "rgba(92,22,127,1)", "rgba(93,23,127,1)", "rgba(95,23,127,1)", "rgba(96,24,128,1)", "rgba(98,25,128,1)", "rgba(99,25,128,1)", "rgba(101,26,128,1)", "rgba(103,26,128,1)", "rgba(104,27,129,1)", "rgba(106,28,129,1)", "rgba(107,28,129,1)", "rgba(109,29,129,1)", "rgba(110,30,129,1)", "rgba(112,30,129,1)", "rgba(113,31,129,1)", "rgba(115,32,129,1)", "rgba(117,32,129,1)", "rgba(118,33,129,1)", "rgba(120,33,129,1)", "rgba(121,34,130,1)", "rgba(123,35,130,1)", "rgba(124,35,130,1)", "rgba(126,36,130,1)", "rgba(128,36,130,1)", "rgba(129,37,129,1)", "rgba(131,37,129,1)", "rgba(132,38,129,1)", "rgba(134,39,129,1)", "rgba(136,39,129,1)", "rgba(137,40,129,1)", "rgba(139,40,129,1)", "rgba(140,41,129,1)", "rgba(142,41,129,1)", "rgba(144,42,129,1)", "rgba(145,42,129,1)", "rgba(147,43,128,1)", "rgba(148,43,128,1)", "rgba(150,44,128,1)", "rgba(152,44,128,1)", "rgba(153,45,128,1)", "rgba(155,46,127,1)", "rgba(157,46,127,1)", "rgba(158,47,127,1)", "rgba(160,47,127,1)", "rgba(161,48,126,1)", "rgba(163,48,126,1)", "rgba(165,49,126,1)", "rgba(166,49,125,1)", "rgba(168,50,125,1)", "rgba(170,50,125,1)", "rgba(171,51,124,1)", "rgba(173,51,124,1)", "rgba(175,52,123,1)", "rgba(176,52,123,1)", "rgba(178,53,123,1)", "rgba(180,53,122,1)", "rgba(181,54,122,1)", "rgba(183,55,121,1)", "rgba(185,55,121,1)", "rgba(186,56,120,1)", "rgba(188,56,120,1)", "rgba(189,57,119,1)", "rgba(191,57,118,1)", "rgba(193,58,118,1)", "rgba(194,59,117,1)", "rgba(196,59,117,1)", "rgba(198,60,116,1)", "rgba(199,61,115,1)", "rgba(201,61,115,1)", "rgba(202,62,114,1)", "rgba(204,63,113,1)", "rgba(206,63,113,1)", "rgba(207,64,112,1)", "rgba(209,65,111,1)", "rgba(210,66,110,1)", "rgba(212,67,110,1)", "rgba(213,67,109,1)", "rgba(215,68,108,1)", "rgba(216,69,107,1)", "rgba(218,70,107,1)", "rgba(219,71,106,1)", "rgba(221,72,105,1)", "rgba(222,73,104,1)", "rgba(223,74,103,1)", "rgba(225,75,103,1)", "rgba(226,76,102,1)", "rgba(227,78,101,1)", "rgba(229,79,100,1)", "rgba(230,80,100,1)", "rgba(231,81,99,1)", "rgba(232,83,98,1)", "rgba(233,84,97,1)", "rgba(234,85,97,1)", "rgba(236,87,96,1)", "rgba(237,88,95,1)", "rgba(238,90,95,1)", "rgba(239,91,94,1)", "rgba(239,93,94,1)", "rgba(240,95,93,1)", "rgba(241,96,93,1)", "rgba(242,98,93,1)", "rgba(243,100,92,1)", "rgba(243,101,92,1)", "rgba(244,103,92,1)", "rgba(245,105,92,1)", "rgba(246,107,92,1)", "rgba(246,108,92,1)", "rgba(247,110,92,1)", "rgba(247,112,92,1)", "rgba(248,114,92,1)", "rgba(248,116,92,1)", "rgba(249,118,92,1)", "rgba(249,120,92,1)", "rgba(250,121,93,1)", "rgba(250,123,93,1)", "rgba(250,125,94,1)", "rgba(251,127,94,1)", "rgba(251,129,95,1)", "rgba(251,131,95,1)", "rgba(252,133,96,1)", "rgba(252,135,97,1)", "rgba(252,137,97,1)", "rgba(252,139,98,1)", "rgba(253,140,99,1)", "rgba(253,142,100,1)", "rgba(253,144,101,1)", "rgba(253,146,102,1)", "rgba(253,148,103,1)", "rgba(254,150,104,1)", "rgba(254,152,105,1)", "rgba(254,154,106,1)", "rgba(254,156,107,1)", "rgba(254,157,108,1)", "rgba(254,159,109,1)", "rgba(254,161,110,1)", "rgba(254,163,111,1)", "rgba(254,165,112,1)", "rgba(255,167,114,1)", "rgba(255,169,115,1)", "rgba(255,171,116,1)", "rgba(255,172,118,1)", "rgba(255,174,119,1)", "rgba(255,176,120,1)", "rgba(255,178,122,1)", "rgba(255,180,123,1)", "rgba(255,182,124,1)", "rgba(255,184,126,1)", "rgba(255,185,127,1)", "rgba(255,187,129,1)", "rgba(255,189,130,1)", "rgba(255,191,132,1)", "rgba(255,193,133,1)", "rgba(255,195,135,1)", "rgba(255,197,136,1)", "rgba(255,198,138,1)", "rgba(255,200,140,1)", "rgba(255,202,141,1)", "rgba(255,204,143,1)", "rgba(254,206,144,1)", "rgba(254,208,146,1)", "rgba(254,209,148,1)", "rgba(254,211,149,1)", "rgba(254,213,151,1)", "rgba(254,215,153,1)", "rgba(254,217,155,1)", "rgba(254,219,156,1)", "rgba(254,220,158,1)", "rgba(254,222,160,1)", "rgba(254,224,162,1)", "rgba(254,226,163,1)", "rgba(253,228,165,1)", "rgba(253,230,167,1)", "rgba(253,231,169,1)", "rgba(253,233,171,1)", "rgba(253,235,172,1)", "rgba(253,237,174,1)", "rgba(253,239,176,1)", "rgba(253,241,178,1)", "rgba(253,242,180,1)", "rgba(253,244,182,1)", "rgba(253,246,184,1)", "rgba(252,248,186,1)", "rgba(252,250,188,1)", "rgba(252,251,189,1)", "rgba(252,253,191,1)"]
      },
      viridis: {
        name: "viridis",
        value: ["rgba(68,1,84,1)", "rgba(68,2,85,1)", "rgba(69,3,87,1)", "rgba(69,5,88,1)", "rgba(69,6,90,1)", "rgba(70,8,91,1)", "rgba(70,9,93,1)", "rgba(70,11,94,1)", "rgba(70,12,96,1)", "rgba(71,14,97,1)", "rgba(71,15,98,1)", "rgba(71,17,100,1)", "rgba(71,18,101,1)", "rgba(71,20,102,1)", "rgba(72,21,104,1)", "rgba(72,22,105,1)", "rgba(72,24,106,1)", "rgba(72,25,108,1)", "rgba(72,26,109,1)", "rgba(72,28,110,1)", "rgba(72,29,111,1)", "rgba(72,30,112,1)", "rgba(72,32,113,1)", "rgba(72,33,115,1)", "rgba(72,34,116,1)", "rgba(72,36,117,1)", "rgba(72,37,118,1)", "rgba(72,38,119,1)", "rgba(72,39,120,1)", "rgba(71,41,121,1)", "rgba(71,42,121,1)", "rgba(71,43,122,1)", "rgba(71,44,123,1)", "rgba(71,46,124,1)", "rgba(70,47,125,1)", "rgba(70,48,126,1)", "rgba(70,49,126,1)", "rgba(70,51,127,1)", "rgba(69,52,128,1)", "rgba(69,53,129,1)", "rgba(69,54,129,1)", "rgba(68,56,130,1)", "rgba(68,57,131,1)", "rgba(68,58,131,1)", "rgba(67,59,132,1)", "rgba(67,60,132,1)", "rgba(67,62,133,1)", "rgba(66,63,133,1)", "rgba(66,64,134,1)", "rgba(65,65,134,1)", "rgba(65,66,135,1)", "rgba(65,67,135,1)", "rgba(64,69,136,1)", "rgba(64,70,136,1)", "rgba(63,71,136,1)", "rgba(63,72,137,1)", "rgba(62,73,137,1)", "rgba(62,74,137,1)", "rgba(61,75,138,1)", "rgba(61,77,138,1)", "rgba(60,78,138,1)", "rgba(60,79,138,1)", "rgba(59,80,139,1)", "rgba(59,81,139,1)", "rgba(58,82,139,1)", "rgba(58,83,139,1)", "rgba(57,84,140,1)", "rgba(57,85,140,1)", "rgba(56,86,140,1)", "rgba(56,87,140,1)", "rgba(55,88,140,1)", "rgba(55,89,140,1)", "rgba(54,91,141,1)", "rgba(54,92,141,1)", "rgba(53,93,141,1)", "rgba(53,94,141,1)", "rgba(52,95,141,1)", "rgba(52,96,141,1)", "rgba(51,97,141,1)", "rgba(51,98,141,1)", "rgba(51,99,141,1)", "rgba(50,100,142,1)", "rgba(50,101,142,1)", "rgba(49,102,142,1)", "rgba(49,103,142,1)", "rgba(48,104,142,1)", "rgba(48,105,142,1)", "rgba(47,106,142,1)", "rgba(47,107,142,1)", "rgba(47,108,142,1)", "rgba(46,109,142,1)", "rgba(46,110,142,1)", "rgba(45,111,142,1)", "rgba(45,112,142,1)", "rgba(45,112,142,1)", "rgba(44,113,142,1)", "rgba(44,114,142,1)", "rgba(43,115,142,1)", "rgba(43,116,142,1)", "rgba(43,117,142,1)", "rgba(42,118,142,1)", "rgba(42,119,142,1)", "rgba(41,120,142,1)", "rgba(41,121,142,1)", "rgba(41,122,142,1)", "rgba(40,123,142,1)", "rgba(40,124,142,1)", "rgba(40,125,142,1)", "rgba(39,126,142,1)", "rgba(39,127,142,1)", "rgba(38,128,142,1)", "rgba(38,129,142,1)", "rgba(38,130,142,1)", "rgba(37,131,142,1)", "rgba(37,131,142,1)", "rgba(37,132,142,1)", "rgba(36,133,142,1)", "rgba(36,134,142,1)", "rgba(35,135,142,1)", "rgba(35,136,142,1)", "rgba(35,137,142,1)", "rgba(34,138,141,1)", "rgba(34,139,141,1)", "rgba(34,140,141,1)", "rgba(33,141,141,1)", "rgba(33,142,141,1)", "rgba(33,143,141,1)", "rgba(32,144,141,1)", "rgba(32,145,140,1)", "rgba(32,146,140,1)", "rgba(32,147,140,1)", "rgba(31,147,140,1)", "rgba(31,148,140,1)", "rgba(31,149,139,1)", "rgba(31,150,139,1)", "rgba(31,151,139,1)", "rgba(30,152,139,1)", "rgba(30,153,138,1)", "rgba(30,154,138,1)", "rgba(30,155,138,1)", "rgba(30,156,137,1)", "rgba(30,157,137,1)", "rgba(30,158,137,1)", "rgba(30,159,136,1)", "rgba(30,160,136,1)", "rgba(31,161,136,1)", "rgba(31,162,135,1)", "rgba(31,163,135,1)", "rgba(31,163,134,1)", "rgba(32,164,134,1)", "rgba(32,165,134,1)", "rgba(33,166,133,1)", "rgba(33,167,133,1)", "rgba(34,168,132,1)", "rgba(35,169,131,1)", "rgba(35,170,131,1)", "rgba(36,171,130,1)", "rgba(37,172,130,1)", "rgba(38,173,129,1)", "rgba(39,174,129,1)", "rgba(40,175,128,1)", "rgba(41,175,127,1)", "rgba(42,176,127,1)", "rgba(43,177,126,1)", "rgba(44,178,125,1)", "rgba(46,179,124,1)", "rgba(47,180,124,1)", "rgba(48,181,123,1)", "rgba(50,182,122,1)", "rgba(51,183,121,1)", "rgba(53,183,121,1)", "rgba(54,184,120,1)", "rgba(56,185,119,1)", "rgba(57,186,118,1)", "rgba(59,187,117,1)", "rgba(61,188,116,1)", "rgba(62,189,115,1)", "rgba(64,190,114,1)", "rgba(66,190,113,1)", "rgba(68,191,112,1)", "rgba(70,192,111,1)", "rgba(72,193,110,1)", "rgba(73,194,109,1)", "rgba(75,194,108,1)", "rgba(77,195,107,1)", "rgba(79,196,106,1)", "rgba(81,197,105,1)", "rgba(83,198,104,1)", "rgba(85,198,102,1)", "rgba(88,199,101,1)", "rgba(90,200,100,1)", "rgba(92,201,99,1)", "rgba(94,201,98,1)", "rgba(96,202,96,1)", "rgba(98,203,95,1)", "rgba(101,204,94,1)", "rgba(103,204,92,1)", "rgba(105,205,91,1)", "rgba(108,206,90,1)", "rgba(110,206,88,1)", "rgba(112,207,87,1)", "rgba(115,208,85,1)", "rgba(117,208,84,1)", "rgba(119,209,82,1)", "rgba(122,210,81,1)", "rgba(124,210,79,1)", "rgba(127,211,78,1)", "rgba(129,212,76,1)", "rgba(132,212,75,1)", "rgba(134,213,73,1)", "rgba(137,213,72,1)", "rgba(139,214,70,1)", "rgba(142,215,68,1)", "rgba(144,215,67,1)", "rgba(147,216,65,1)", "rgba(149,216,63,1)", "rgba(152,217,62,1)", "rgba(155,217,60,1)", "rgba(157,218,58,1)", "rgba(160,218,57,1)", "rgba(163,219,55,1)", "rgba(165,219,53,1)", "rgba(168,220,51,1)", "rgba(171,220,50,1)", "rgba(173,221,48,1)", "rgba(176,221,46,1)", "rgba(179,221,45,1)", "rgba(181,222,43,1)", "rgba(184,222,41,1)", "rgba(187,223,39,1)", "rgba(189,223,38,1)", "rgba(192,223,36,1)", "rgba(195,224,35,1)", "rgba(197,224,33,1)", "rgba(200,225,32,1)", "rgba(203,225,30,1)", "rgba(205,225,29,1)", "rgba(208,226,28,1)", "rgba(211,226,27,1)", "rgba(213,226,26,1)", "rgba(216,227,25,1)", "rgba(219,227,24,1)", "rgba(221,227,24,1)", "rgba(224,228,24,1)", "rgba(226,228,24,1)", "rgba(229,228,24,1)", "rgba(232,229,25,1)", "rgba(234,229,25,1)", "rgba(237,229,26,1)", "rgba(239,230,27,1)", "rgba(242,230,28,1)", "rgba(244,230,30,1)", "rgba(247,230,31,1)", "rgba(249,231,33,1)", "rgba(251,231,35,1)", "rgba(254,231,36,1)"]
      },
      custom: {
        name: "Custom...",
        componentPickers: {
          heatmap: HeatmapOptions,
          "horizontal-heatmap": HeatmapOptions
        }
      }
    }
  },
  align: {
    name: "Align",
    inlineOptions: {
      white: {
        name: "Top",
        value: "top"
      },
      lightGrey: {
        name: "Bottom",
        value: "bottom"
      }
    }
  },
  colorRangeGradient: {
    name: "Color Gradient",
    inlineOptions: YES_NO
  },
  dataTransform: {
    name: "Transforms",
    inlineOptions: {
      default: {
        name: "Default",
        value: "default"
      },
      None: {
        name: "None",
        value: "None"
      }
    },
    generateOptions: (track) => {
      const inlineOptions = [];
      if (track.transforms) {
        for (const transform2 of track.transforms) {
          inlineOptions.push({
            name: transform2.name,
            value: transform2.value
          });
        }
      }
      return inlineOptions;
    }
  },
  aggregationMode: {
    name: "Aggregation Mode",
    inlineOptions: {},
    generateOptions: (track) => {
      const inlineOptions = [];
      if (track.aggregationModes) {
        Object.values(track.aggregationModes).forEach(({
          name,
          value
        }) => {
          inlineOptions.push({
            name,
            value
          });
        });
      } else {
        inlineOptions.push({
          name: "Default",
          value: "default"
        });
      }
      return inlineOptions;
    }
  },
  maxZoom: {
    name: "Zoom limit",
    inlineOptions: {
      none: {
        name: "None",
        value: null
      }
    },
    generateOptions: (track) => {
      if (track.maxZoom) {
        const inlineOptions = [];
        for (let i = 0; i <= track.maxZoom; i++) {
          const {
            maxWidth,
            binsPerDimension,
            maxZoom
          } = track;
          let maxResolutionSize = 1;
          let resolution = 1;
          if (track.resolutions) {
            const sortedResolutions = track.resolutions.map((x) => +x).sort((a, b) => b - a);
            [maxResolutionSize] = sortedResolutions;
            resolution = sortedResolutions[i];
          } else {
            resolution = track.maxWidth / (2 ** i * track.binsPerDimension);
            maxResolutionSize = maxWidth / (2 ** maxZoom * binsPerDimension);
          }
          const pp = precisionPrefix(maxResolutionSize, resolution);
          const f2 = formatPrefix(`.${pp}`, resolution);
          const formattedResolution = f2(resolution);
          inlineOptions.push({
            name: formattedResolution,
            value: i.toString()
          });
        }
        return inlineOptions;
      }
      return [];
    }
  },
  valueColumn: {
    name: "Value column",
    inlineOptions: {
      none: {
        name: "None",
        value: null
      }
    },
    generateOptions: valueColumnOptions
  },
  zeroValueColor: {
    name: "Zero Value Color",
    inlineOptions: AVAILABLE_COLORS
  }
};
function _classCallCheck$1a(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1a(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1a(o.key), o);
  }
}
function _createClass$1a(e, r2, t) {
  return r2 && _defineProperties$1a(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1a(t) {
  var i = _toPrimitive$1a(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1a(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$14(t, o, e) {
  return o = _getPrototypeOf$14(o), _possibleConstructorReturn$14(t, _isNativeReflectConstruct$14() ? Reflect.construct(o, e || [], _getPrototypeOf$14(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$14(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$14(t);
}
function _assertThisInitialized$14(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$14() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$14 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$14(t) {
  return _getPrototypeOf$14 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$14(t);
}
function _inherits$14(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$14(t, e);
}
function _setPrototypeOf$14(t, e) {
  return _setPrototypeOf$14 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$14(t, e);
}
function hasContextMenuItems(x) {
  return isObject$2(x) && "contextMenuItems" in x && typeof x.contextMenuItems === "function";
}
function findTrackContextMenuItems(track, trackRenderer, position) {
  let trackObj = trackRenderer.getTrackObject(track.uid);
  trackObj = trackObj?.originalTrack || trackObj;
  if (hasContextMenuItems(trackObj)) {
    let trackLeft = position.canvasLeft - trackObj.position[0];
    let trackTop = position.canvasTop - trackObj.position[1];
    if (trackObj.flipText) {
      const temp = trackLeft;
      trackLeft = trackTop;
      trackTop = temp;
    }
    const items2 = trackObj.contextMenuItems(trackLeft, trackTop);
    return items2 || [];
  }
  return [];
}
let SeriesListMenu = /* @__PURE__ */ (function(_ContextMenuContainer) {
  function SeriesListMenu2() {
    _classCallCheck$1a(this, SeriesListMenu2);
    return _callSuper$14(this, SeriesListMenu2, arguments);
  }
  _inherits$14(SeriesListMenu2, _ContextMenuContainer);
  return _createClass$1a(SeriesListMenu2, [{
    key: "getConfigureSeriesMenu",
    value: (
      /**
       * @param {unknown} position
       * @param {unknown} bbox
       * @param {{ type: string, options: Record<string, unknown>, uid: string, }} track
       */
      (function getConfigureSeriesMenu(position, bbox, track) {
        const menuItems = {};
        const pluginOptionsInfo = window.higlassTracksByType?.[track.type] && window.higlassTracksByType[track.type].config && window.higlassTracksByType[track.type].config.optionsInfo;
        if (pluginOptionsInfo) {
          for (const key of Object.keys(pluginOptionsInfo)) {
            OPTIONS_INFO[key] = pluginOptionsInfo[key];
          }
        }
        const trackinfo = TRACKS_INFO_BY_TYPE[track.type];
        if (!trackinfo?.availableOptions) {
          return null;
        }
        for (const optionType of trackinfo.availableOptions) {
          if (optionType in OPTIONS_INFO) {
            const optionInfo = OPTIONS_INFO[
              /** @type {keyof typeof OPTIONS_INFO} */
              optionType
            ];
            menuItems[optionType] = {
              name: optionInfo.name
            };
            if ("generateOptions" in optionInfo) {
              const generatedOptions = optionInfo.generateOptions(track);
              if (!menuItems[optionType].children) {
                menuItems[optionType].children = {};
              }
              for (const generatedOption of generatedOptions) {
                const optionSelectorSettings = {
                  name: generatedOption.name,
                  value: generatedOption.value,
                  handler: () => {
                    track.options[optionType] = generatedOption.value;
                    this.props.onTrackOptionsChanged(track.uid, track.options);
                    this.props.closeMenu();
                  }
                };
                menuItems[optionType].children[generatedOption.value] = optionSelectorSettings;
              }
            }
            if ("inlineOptions" in optionInfo) {
              for (const inlineOptionKey in optionInfo.inlineOptions) {
                const inlineOption = optionInfo.inlineOptions[inlineOptionKey];
                if (!menuItems[optionType].children) {
                  menuItems[optionType].children = {};
                }
                const optionSelectorSettings = {
                  name: inlineOption.name,
                  value: inlineOption.value,
                  // missing handler to be filled in below
                  handler: () => {
                  }
                };
                if (inlineOption.componentPickers && track.type in inlineOption.componentPickers) {
                  optionSelectorSettings.handler = () => {
                    this.props.onConfigureTrack(track, inlineOption.componentPickers[track.type]);
                    this.props.closeMenu();
                  };
                } else {
                  optionSelectorSettings.handler = () => {
                    track.options[optionType] = inlineOption.value;
                    this.props.onTrackOptionsChanged(track.uid, track.options);
                    this.props.closeMenu();
                  };
                }
                menuItems[optionType].children[inlineOptionKey] = optionSelectorSettings;
              }
            } else if (track.type in optionInfo.componentPickers) {
              menuItems[optionType].handler = () => {
                this.props.onConfigureTrack(
                  track,
                  // @ts-expect-error - mutated from a plugin
                  optionInfo.componentPickers[track.type]
                );
                this.props.closeMenu();
              };
            }
          }
        }
        return /* @__PURE__ */ React__default.createElement(NestedContextMenu, {
          key: "config-series-menu",
          closeMenu: this.props.closeMenu,
          menuItems,
          orientation: this.state.orientation,
          parentBbox: bbox,
          position,
          theme: this.props.theme
        });
      })
    )
    /**
     * Return a list of track types that can be used
     * with the data for this track
     *
     * @param {Object} position The position where to draw ths menu (e.g. {left: 42, top: 88})
     *
     * @param {Object} bbox
     *  The bounding box of the parent menu, used to determine whether
     *  to draw the child menu on the left or the right
     *
     * @param {{ uid: string, type: string, datatype: string }} track The track definition for this series (as in the viewconf)
     */
  }, {
    key: "getTrackTypeItems",
    value: function getTrackTypeItems(position, bbox, track) {
      if (window.higlassTracksByType) {
        for (const pluginTrackType of Object.keys(window.higlassTracksByType)) {
          TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
        }
      }
      let {
        datatype
      } = track;
      let orientation2 = null;
      if (track.type in TRACKS_INFO_BY_TYPE) {
        if (!datatype) {
          datatype = TRACKS_INFO_BY_TYPE[track.type].datatype[0];
        }
        ({
          orientation: orientation2
        } = TRACKS_INFO_BY_TYPE[track.type]);
      }
      const availableTrackTypes = Object.values(TRACKS_INFO_BY_TYPE).filter((x) => x.datatype).filter((x) => x.orientation).filter((x) => x.datatype.includes(datatype)).filter((x) => x.orientation === orientation2).map((x) => x.type);
      const menuItems = {};
      for (let i = 0; i < availableTrackTypes.length; i++) {
        menuItems[availableTrackTypes[i]] = {
          value: availableTrackTypes[i],
          name: availableTrackTypes[i],
          handler: () => {
            this.props.onChangeTrackType(track.uid, availableTrackTypes[i]);
          }
        };
      }
      return /* @__PURE__ */ React__default.createElement(NestedContextMenu, {
        key: "track-type-items",
        closeMenu: this.props.closeMenu,
        menuItems,
        orientation: this.state.orientation,
        parentBbox: bbox,
        position,
        theme: this.props.theme
      });
    }
  }, {
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        const position = this.state.orientation === "left" ? {
          left: this.state.left,
          top: bbox.top
        } : {
          left: this.state.left + bbox.width + 7,
          top: bbox.top
        };
        const subMenuData = this.state.submenuShown;
        const track = subMenuData.value;
        if (subMenuData.option === "track-type") {
          return this.getTrackTypeItems(position, bbox, track);
        }
        return this.getConfigureSeriesMenu(position, bbox, track);
      }
      return /* @__PURE__ */ React__default.createElement("div", null);
    }
  }, {
    key: "getDivideByMenuItem",
    value: function getDivideByMenuItem() {
      if (this.props.series.data && this.props.series.data.type === "divided") {
        const newData = {
          tilesetUid: this.props.series.data.children[0].tilesetUid,
          server: this.props.series.data.children[0].server
        };
        return /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
          className: classes$5["context-menu-item"],
          onClick: () => this.props.onChangeTrackData(this.props.series.uid, newData),
          onMouseEnter: (e) => this.handleOtherMouseEnter()
        }, /* @__PURE__ */ React__default.createElement("span", {
          className: classes$5["context-menu-span"]
        }, "Remove divisor"));
      }
      return /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        className: classes$5["context-menu-item"],
        onClick: () => this.props.onAddDivisor(this.props.series),
        onMouseEnter: (e) => this.handleOtherMouseEnter()
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: classes$5["context-menu-span"]
      }, "Divide by"));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
    }
  }, {
    key: "render",
    value: function render3() {
      let exportDataMenuItem = null;
      const trackContextMenuItems = findTrackContextMenuItems(this.props.track, this.props.trackRenderer, this.props.position);
      if (TRACKS_INFO_BY_TYPE[this.props.series.type] && TRACKS_INFO_BY_TYPE[this.props.series.type].exportable) {
        exportDataMenuItem = /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
          className: classes$5["context-menu-item"],
          onClick: () => this.props.onExportData(this.props.hostTrack.uid, this.props.track.uid),
          onMouseEnter: (e) => this.handleOtherMouseEnter()
        }, /* @__PURE__ */ React__default.createElement("span", {
          className: classes$5["context-menu-span"]
        }, "Export Data"));
      }
      const replaceSeriesItem = this.props.onAddSeries ? /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        className: classes$5["context-menu-item"],
        onClick: () => {
          this.props.onCloseTrack(this.props.series.uid);
          this.props.onAddSeries(this.props.hostTrack.uid);
        },
        onMouseEnter: (e) => this.handleOtherMouseEnter()
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: classes$5["context-menu-span"]
      }, "Replace Series")) : null;
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.div = c;
        },
        className: clsx$2(classes$5["context-menu"], {
          [classes$5["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "SeriesListMenu",
        onMouseLeave: this.props.handleMouseLeave,
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, trackContextMenuItems.map((x) => /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        key: x.label,
        onClick: (evt) => {
          x.onClick(evt, (newOptions) => {
            this.props.onTrackOptionsChanged(this.props.track.uid, {
              ...this.props.track.options,
              ...newOptions
            });
          });
          this.props.closeMenu();
        },
        onMouseEnter: (e) => this.handleOtherMouseEnter(),
        className: classes$5["context-menu-item"]
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: classes$5["context-menu-span"]
      }, x.label))), trackContextMenuItems.length > 0 && /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => {
        },
        onMouseEnter: (e) => this.handleItemMouseEnter(e, {
          option: "configure-series",
          value: this.props.track
        }),
        onMouseLeave: (e) => this.handleMouseLeave()
      }, "Configure Series", /* @__PURE__ */ React__default.createElement("svg", {
        className: classes$5["play-icon"]
      }, /* @__PURE__ */ React__default.createElement("title", null, "Play"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#play"
      }))), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        className: classes$5["context-menu-item"],
        onClick: () => {
        },
        onMouseEnter: (e) => this.handleItemMouseEnter(e, {
          option: "track-type",
          value: this.props.track
        }),
        onMouseLeave: (e) => this.handleMouseLeave()
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: classes$5["context-menu-span"]
      }, "Track Type", /* @__PURE__ */ React__default.createElement("svg", {
        className: classes$5["play-icon"]
      }, /* @__PURE__ */ React__default.createElement("title", null, "Play"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#play"
      })))), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        className: classes$5["context-menu-item"],
        onClick: () => {
          this.props.apiPublish("datasetInfo", this.props.track);
          this.props.closeMenu();
        },
        onMouseEnter: (e) => this.handleOtherMouseEnter()
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: classes$5["context-menu-span"]
      }, "Dataset Info")), exportDataMenuItem, this.getDivideByMenuItem(), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        className: classes$5["context-menu-item"],
        onClick: this.props.onCloseTrack,
        onMouseEnter: (e) => this.handleOtherMouseEnter()
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: classes$5["context-menu-span"]
      }, "Close Series")), replaceSeriesItem, this.getSubmenu());
    }
  }]);
})(ContextMenuContainer);
function _classCallCheck$19(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$19(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$19(o.key), o);
  }
}
function _createClass$19(e, r2, t) {
  return r2 && _defineProperties$19(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$19(t) {
  var i = _toPrimitive$19(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$19(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$13(t, o, e) {
  return o = _getPrototypeOf$13(o), _possibleConstructorReturn$13(t, _isNativeReflectConstruct$13() ? Reflect.construct(o, e || [], _getPrototypeOf$13(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$13(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$13(t);
}
function _assertThisInitialized$13(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$13() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$13 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$13(t) {
  return _getPrototypeOf$13 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$13(t);
}
function _inherits$13(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$13(t, e);
}
function _setPrototypeOf$13(t, e) {
  return _setPrototypeOf$13 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$13(t, e);
}
const SeriesListSubmenuMixin = Mixin((superclass) => /* @__PURE__ */ (function(_superclass) {
  function _class() {
    _classCallCheck$19(this, _class);
    return _callSuper$13(this, _class, arguments);
  }
  _inherits$13(_class, _superclass);
  return _createClass$19(_class, [{
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        let position = null;
        if (this.state.orientation === "left") {
          position = {
            left: this.state.left,
            top: bbox.top
          };
        } else {
          position = {
            left: this.state.left + bbox.width + 7,
            top: bbox.top
          };
        }
        position.canvasLeft = this.props.position.canvasLeft;
        position.canvasTop = this.props.position.canvasTop;
        const series = getAllTracksAndSubtracks(this.props.tracks);
        const selectedTrack = series.filter((t) => t.uid === this.state.submenuShown.uid)[0];
        const canBeReplaced = selectedTrack && !(selectedTrack.position === "whole");
        return /* @__PURE__ */ React__default.createElement(SeriesListMenu, {
          key: `series-list-menu-${selectedTrack.uid}`,
          ref: (c) => {
            this.seriesListMenu = c;
          },
          apiPublish: this.props.apiPublish,
          closeMenu: this.props.closeMenu,
          hostTrack: this.props.tracks[0],
          onAddDivisor: this.props.onAddDivisor,
          onAddSeries: canBeReplaced ? this.props.onAddSeries : null,
          onChangeTrackData: this.props.onChangeTrackData,
          onChangeTrackType: this.props.onChangeTrackType,
          onCloseTrack: () => this.props.onCloseTrack(this.state.submenuShown.uid),
          onConfigureTrack: this.props.onConfigureTrack,
          onDivideSeries: this.props.onDivideSeries,
          onExportData: this.props.onExportData,
          onLockScales: this.props.onLockScales,
          onTrackOptionsChanged: this.props.onTrackOptionsChanged,
          orientation: this.state.orientation,
          parentBbox: bbox,
          position,
          series: this.state.submenuShown,
          theme: this.props.theme,
          track: selectedTrack,
          trackOrientation: this.props.trackOrientation,
          trackRenderer: this.props.trackRenderer,
          trackSourceServers: this.props.trackSourceServers
        });
      }
      return /* @__PURE__ */ React__default.createElement("div", null);
    }
  }]);
})(superclass));
function _classCallCheck$18(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$18(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$18(o.key), o);
  }
}
function _createClass$18(e, r2, t) {
  return r2 && _defineProperties$18(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$18(t) {
  var i = _toPrimitive$18(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$18(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$12(t, o, e) {
  return o = _getPrototypeOf$12(o), _possibleConstructorReturn$12(t, _isNativeReflectConstruct$12() ? Reflect.construct(o, e || [], _getPrototypeOf$12(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$12(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$12(t);
}
function _assertThisInitialized$12(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$12() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$12 = function() {
    return !!t;
  })();
}
function _superPropGet$E(t, o, e, r2) {
  var p = _get$E(_getPrototypeOf$12(t.prototype), o, e);
  return "function" == typeof p ? function(t22) {
    return p.apply(e, t22);
  } : p;
}
function _get$E() {
  return _get$E = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$E(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$E.apply(null, arguments);
}
function _superPropBase$E(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$12(t)); ) ;
  return t;
}
function _getPrototypeOf$12(t) {
  return _getPrototypeOf$12 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$12(t);
}
function _inherits$12(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$12(t, e);
}
function _setPrototypeOf$12(t, e) {
  return _setPrototypeOf$12 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$12(t, e);
}
let ConfigTrackMenu = /* @__PURE__ */ (function(_mix$with) {
  function ConfigTrackMenu2(props) {
    var _this;
    _classCallCheck$18(this, ConfigTrackMenu2);
    _this = _callSuper$12(this, ConfigTrackMenu2, [props]);
    _this.seriesRefs = {};
    _this.seriesListMenu = null;
    return _this;
  }
  _inherits$12(ConfigTrackMenu2, _mix$with);
  return _createClass$18(ConfigTrackMenu2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _superPropGet$E(ConfigTrackMenu2, "componentDidMount", this)([]);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.div = c;
        },
        className: clsx$2(classes$5["context-menu"], {
          [classes$5["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "ConfigTrackMenu",
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, getSeriesItems(this.props.tracks, this.handleItemMouseEnter.bind(this), this.handleMouseLeave.bind(this), null), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        contextMenu: this,
        onClick: () => this.props.onLockValueScale(this.props.tracks[0].uid),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Lock Value Scale With"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        contextMenu: this,
        onClick: () => this.props.onUnlockValueScale(this.props.tracks[0].uid),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Unlock Value Scale"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        contextMenu: this,
        onClick: () => this.props.onAddSeries(this.props.tracks[0].uid),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Series"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onCloseTrack(this.props.tracks[0].uid)
      }, "Close Track"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => {
          this.props.onReplaceTrack(this.props.tracks[0].uid, this.props.trackOrientation);
        }
      }, "Replace Track"), this.getSubmenu());
    }
  }]);
})(mix(ContextMenuContainer).with(SeriesListSubmenuMixin));
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
function _classCallCheck$17(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$17(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$17(o.key), o);
  }
}
function _createClass$17(e, r2, t) {
  return r2 && _defineProperties$17(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$17(t) {
  var i = _toPrimitive$17(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$17(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$11(t, o, e) {
  return o = _getPrototypeOf$11(o), _possibleConstructorReturn$11(t, _isNativeReflectConstruct$11() ? Reflect.construct(o, e || [], _getPrototypeOf$11(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$11(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$11(t);
}
function _assertThisInitialized$11(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$11() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$11 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$11(t) {
  return _getPrototypeOf$11 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$11(t);
}
function _inherits$11(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$11(t, e);
}
function _setPrototypeOf$11(t, e) {
  return _setPrototypeOf$11 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$11(t, e);
}
let CustomTrackDialog = /* @__PURE__ */ (function(_React$PureComponent) {
  function CustomTrackDialog2() {
    _classCallCheck$17(this, CustomTrackDialog2);
    return _callSuper$11(this, CustomTrackDialog2, arguments);
  }
  _inherits$11(CustomTrackDialog2, _React$PureComponent);
  return _createClass$17(CustomTrackDialog2, [{
    key: "render",
    value: function render3() {
      const childrenWithProp = [];
      this.props.children.forEach((Child, i) => {
        const key = `customTrackDialog_${i}`;
        childrenWithProp.push(/* @__PURE__ */ React__default.createElement(Child, _extends$2({
          key
        }, this.props.bodyProps[i])));
      });
      return /* @__PURE__ */ React__default.createElement(Dialog$1, {
        maxHeight: true,
        okayOnly: true,
        okayTitle: "Close",
        onCancel: this.props.onCancel,
        onOkay: this.props.onCancel,
        title: this.props.title
      }, childrenWithProp);
    }
  }]);
})(React__default.PureComponent);
CustomTrackDialog.defaultProps = {};
CustomTrackDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  bodyProps: PropTypes.array,
  children: PropTypes.array
};
const classes$4 = {
  "drag-listening-div-active": "_drag-listening-div-active_19gkt_1"
};
function _classCallCheck$16(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$16(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$16(o.key), o);
  }
}
function _createClass$16(e, r2, t) {
  return r2 && _defineProperties$16(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$16(t) {
  var i = _toPrimitive$16(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$16(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$10(t, o, e) {
  return o = _getPrototypeOf$10(o), _possibleConstructorReturn$10(t, _isNativeReflectConstruct$10() ? Reflect.construct(o, e || [], _getPrototypeOf$10(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$10(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$10(t);
}
function _assertThisInitialized$10(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$10() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$10 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$10(t) {
  return _getPrototypeOf$10 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$10(t);
}
function _inherits$10(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$10(t, e);
}
function _setPrototypeOf$10(t, e) {
  return _setPrototypeOf$10 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$10(t, e);
}
let DragListeningDiv = /* @__PURE__ */ (function(_React$Component) {
  function DragListeningDiv2(props) {
    var _this;
    _classCallCheck$16(this, DragListeningDiv2);
    _this = _callSuper$10(this, DragListeningDiv2, [props]);
    _this.state = {
      dragOnTop: false
    };
    return _this;
  }
  _inherits$10(DragListeningDiv2, _React$Component);
  return _createClass$16(DragListeningDiv2, [{
    key: "handleDrop",
    value: function handleDrop() {
      if (!this.props.enabled) return;
      const evtJson = this.props.draggingHappening;
      const newTrack = {
        type: this.props.defaultTrackType,
        uid: slugid.nice()
      };
      if (evtJson.tilesetUid && evtJson.server) {
        newTrack.tilesetUid = evtJson.tilesetUid;
        newTrack.server = evtJson.server;
      }
      if (evtJson.data) {
        newTrack.data = evtJson.data;
      }
      this.props.onTrackDropped(newTrack);
      this.props.pubSub.publish("trackDropped", newTrack);
    }
  }, {
    key: "render",
    value: function render3() {
      let background = "red";
      if (this.props.enabled && this.state.dragOnTop) {
        background = "green";
      } else if (this.props.enabled) {
        background = "blue";
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: clsx$2("DragListeningDiv", {
          [classes$4["drag-listening-div-active"]]: this.props.enabled
        }),
        onClick: this.handleDrop.bind(this),
        onDragEnter: () => {
          this.setState({
            dragOnTop: true
          });
        },
        onDragLeave: () => {
          this.setState({
            dragOnTop: false
          });
        },
        onDragOver: (evt) => {
          evt.preventDefault();
        },
        onDrop: this.handleDrop.bind(this),
        onMouseEnter: () => {
          this.setState({
            dragOnTop: true
          });
        },
        onMouseLeave: () => {
          this.setState({
            dragOnTop: false
          });
        },
        style: {
          background,
          opacity: 0.6,
          ...this.props.style
        }
      });
    }
  }]);
})(React__default.Component);
DragListeningDiv.defaultProps = {
  enabled: false,
  style: {},
  draggingHappening: {},
  onTrackDropped: () => {
  }
};
DragListeningDiv.propTypes = {
  enabled: PropTypes.bool,
  style: PropTypes.object,
  defaultTrackType: PropTypes.object,
  draggingHappening: PropTypes.object,
  onTrackDropped: PropTypes.func,
  position: PropTypes.string.isRequired,
  pubSub: PropTypes.object.isRequired
};
const DragListeningDiv$1 = withPubSub(DragListeningDiv);
const styles$4 = {
  "gallery-tracks": "_gallery-tracks_fbxxi_1",
  "gallery-track": "_gallery-track_fbxxi_1",
  "gallery-sub-track": "_gallery-sub-track_fbxxi_18",
  "gallery-invisible-track": "_gallery-invisible-track_fbxxi_19"
};
const horizontalList = "_horizontalList_lzpdn_7";
const list = "_list_lzpdn_14";
const stylizedList = "_stylizedList_lzpdn_21";
const stylizedItem = "_stylizedItem_lzpdn_28";
const stylizedHelper = "_stylizedHelper_lzpdn_39";
const horizontalItem = "_horizontalItem_lzpdn_44";
const domain = "_domain_lzpdn_60";
const appear = "_appear_lzpdn_1";
const styles$3 = {
  "tiled-plot": "_tiled-plot_lzpdn_1",
  horizontalList,
  list,
  stylizedList,
  stylizedItem,
  stylizedHelper,
  horizontalItem,
  "resizable-track": "_resizable-track_lzpdn_55",
  domain,
  "tiled-plot-track-overlay-plain": "_tiled-plot-track-overlay-plain_lzpdn_64",
  "tiled-plot-track-overlay-animate": "_tiled-plot-track-overlay-animate_lzpdn_69",
  appear,
  "tiled-plot-track-overlay-selected": "_tiled-plot-track-overlay-selected_lzpdn_77"
};
function _classCallCheck$15(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$15(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$15(o.key), o);
  }
}
function _createClass$15(e, r2, t) {
  return r2 && _defineProperties$15(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$15(t) {
  var i = _toPrimitive$15(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$15(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$$(t, o, e) {
  return o = _getPrototypeOf$$(o), _possibleConstructorReturn$$(t, _isNativeReflectConstruct$$() ? Reflect.construct(o, e || [], _getPrototypeOf$$(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$$(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$$(t);
}
function _assertThisInitialized$$(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$$() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$$ = function() {
    return !!t;
  })();
}
function _getPrototypeOf$$(t) {
  return _getPrototypeOf$$ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$$(t);
}
function _inherits$$(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$$(t, e);
}
function _setPrototypeOf$$(t, e) {
  return _setPrototypeOf$$ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$$(t, e);
}
const STYLES$2 = {
  pointerEvents: "all"
};
let GalleryTracks = /* @__PURE__ */ (function(_React$Component) {
  function GalleryTracks2(props) {
    var _this;
    _classCallCheck$15(this, GalleryTracks2);
    _this = _callSuper$$(this, GalleryTracks2, [props]);
    _this.state = {
      hovering: false
    };
    return _this;
  }
  _inherits$$(GalleryTracks2, _React$Component);
  return _createClass$15(GalleryTracks2, [{
    key: "mouseEnterHandler",
    value: function mouseEnterHandler() {
      this.setState({
        hovering: true
      });
    }
  }, {
    key: "mouseLeaveHandler",
    value: function mouseLeaveHandler() {
      this.setState({
        hovering: false
      });
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: clsx$2("gallery-tracks", styles$4["gallery-tracks"])
      }, this.props.tracks?.map((track, index2) => /* @__PURE__ */ React__default.createElement("div", {
        key: track.uid || index2,
        className: styles$4["gallery-track"],
        onMouseLeave: this.mouseLeaveHandler.bind(this),
        style: {
          top: track.height * index2,
          right: track.height * index2,
          bottom: track.height * index2,
          left: track.height * index2
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: styles$4["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          top: 0,
          right: 0,
          left: 0,
          height: track.height
        }
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: styles$4["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          top: 0,
          right: 0,
          bottom: 0,
          width: track.height
        }
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: styles$4["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          right: 0,
          bottom: 0,
          left: 0,
          height: track.height
        }
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: styles$4["gallery-sub-track"],
        onMouseEnter: this.mouseEnterHandler.bind(this),
        style: {
          top: 0,
          bottom: 0,
          left: 0,
          width: track.height
        }
      }), /* @__PURE__ */ React__default.createElement("div", {
        className: styles$4["gallery-invisible-track"],
        onMouseLeave: this.mouseLeaveHandler.bind(this),
        style: {
          top: track.height,
          right: track.height,
          bottom: track.height,
          left: track.height
        }
      }), this.props.editable && /* @__PURE__ */ React__default.createElement(TrackControl$1, {
        configMenuVisible: true,
        imgStyleAdd: STYLES$2,
        imgStyleClose: STYLES$2,
        imgStyleMove: STYLES$2,
        imgStyleSettings: STYLES$2,
        isMoveable: false,
        isVisible: this.state.hovering,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        uid: track.uid || index2
      }))));
    }
  }]);
})(React__default.Component);
GalleryTracks.propTypes = {
  editable: PropTypes.bool,
  onCloseTrackMenuOpened: PropTypes.func.isRequired,
  onConfigTrackMenuOpened: PropTypes.func.isRequired,
  tracks: PropTypes.array
};
function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useMemo(
    () => (node2) => {
      refs.forEach((ref2) => ref2(node2));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
}
const canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function isWindow(element) {
  const elementString = Object.prototype.toString.call(element);
  return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
  elementString === "[object global]";
}
function isNode(node2) {
  return "nodeType" in node2;
}
function getWindow(target2) {
  var _target$ownerDocument, _target$ownerDocument2;
  if (!target2) {
    return window;
  }
  if (isWindow(target2)) {
    return target2;
  }
  if (!isNode(target2)) {
    return window;
  }
  return (_target$ownerDocument = (_target$ownerDocument2 = target2.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node2) {
  const {
    Document
  } = getWindow(node2);
  return node2 instanceof Document;
}
function isHTMLElement(node2) {
  if (isWindow(node2)) {
    return false;
  }
  return node2 instanceof getWindow(node2).HTMLElement;
}
function isSVGElement(node2) {
  return node2 instanceof getWindow(node2).SVGElement;
}
function getOwnerDocument(target2) {
  if (!target2) {
    return document;
  }
  if (isWindow(target2)) {
    return target2.document;
  }
  if (!isNode(target2)) {
    return document;
  }
  if (isDocument(target2)) {
    return target2;
  }
  if (isHTMLElement(target2) || isSVGElement(target2)) {
    return target2.ownerDocument;
  }
  return document;
}
const useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;
function useEvent(handler) {
  const handlerRef = useRef(handler);
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  });
  return useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return handlerRef.current == null ? void 0 : handlerRef.current(...args);
  }, []);
}
function useInterval() {
  const intervalRef = useRef(null);
  const set2 = useCallback((listener, duration) => {
    intervalRef.current = setInterval(listener, duration);
  }, []);
  const clear = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  return [set2, clear];
}
function useLatestValue(value, dependencies2) {
  if (dependencies2 === void 0) {
    dependencies2 = [value];
  }
  const valueRef = useRef(value);
  useIsomorphicLayoutEffect(() => {
    if (valueRef.current !== value) {
      valueRef.current = value;
    }
  }, dependencies2);
  return valueRef;
}
function useLazyMemo(callback, dependencies2) {
  const valueRef = useRef();
  return useMemo(
    () => {
      const newValue = callback(valueRef.current);
      valueRef.current = newValue;
      return newValue;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencies2]
  );
}
function useNodeRef(onChange) {
  const onChangeHandler = useEvent(onChange);
  const node2 = useRef(null);
  const setNodeRef = useCallback(
    (element) => {
      if (element !== node2.current) {
        onChangeHandler == null ? void 0 : onChangeHandler(element, node2.current);
      }
      node2.current = element;
    },
    //eslint-disable-next-line
    []
  );
  return [node2, setNodeRef];
}
function usePrevious(value) {
  const ref2 = useRef();
  useEffect(() => {
    ref2.current = value;
  }, [value]);
  return ref2.current;
}
let ids = {};
function useUniqueId(prefix2, value) {
  return useMemo(() => {
    if (value) {
      return value;
    }
    const id2 = ids[prefix2] == null ? 0 : ids[prefix2] + 1;
    ids[prefix2] = id2;
    return prefix2 + "-" + id2;
  }, [prefix2, value]);
}
function createAdjustmentFn(modifier) {
  return function(object2) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((accumulator, adjustment) => {
      const entries = Object.entries(adjustment);
      for (const [key, valueAdjustment] of entries) {
        const value = accumulator[key];
        if (value != null) {
          accumulator[key] = value + modifier * valueAdjustment;
        }
      }
      return accumulator;
    }, {
      ...object2
    });
  };
}
const add = /* @__PURE__ */ createAdjustmentFn(1);
const subtract = /* @__PURE__ */ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
  return "clientX" in event && "clientY" in event;
}
function isKeyboardEvent(event) {
  if (!event) {
    return false;
  }
  const {
    KeyboardEvent
  } = getWindow(event.target);
  return KeyboardEvent && event instanceof KeyboardEvent;
}
function isTouchEvent(event) {
  if (!event) {
    return false;
  }
  const {
    TouchEvent
  } = getWindow(event.target);
  return TouchEvent && event instanceof TouchEvent;
}
function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.touches[0];
      return {
        x,
        y
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.changedTouches[0];
      return {
        x,
        y
      };
    }
  }
  if (hasViewportRelativeCoordinates(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return null;
}
const CSS$1 = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(transform2) {
      if (!transform2) {
        return;
      }
      const {
        x,
        y
      } = transform2;
      return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(transform2) {
      if (!transform2) {
        return;
      }
      const {
        scaleX,
        scaleY
      } = transform2;
      return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
    }
  },
  Transform: {
    toString(transform2) {
      if (!transform2) {
        return;
      }
      return [CSS$1.Translate.toString(transform2), CSS$1.Scale.toString(transform2)].join(" ");
    }
  },
  Transition: {
    toString(_ref) {
      let {
        property: property2,
        duration,
        easing
      } = _ref;
      return property2 + " " + duration + "ms " + easing;
    }
  }
});
const SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(element) {
  if (element.matches(SELECTOR)) {
    return element;
  }
  return element.querySelector(SELECTOR);
}
const hiddenStyles = {
  display: "none"
};
function HiddenText(_ref) {
  let {
    id: id2,
    value
  } = _ref;
  return /* @__PURE__ */ React__default.createElement("div", {
    id: id2,
    style: hiddenStyles
  }, value);
}
function LiveRegion(_ref) {
  let {
    id: id2,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  const visuallyHidden = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    id: id2,
    style: visuallyHidden,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}
function useAnnouncement() {
  const [announcement, setAnnouncement] = useState("");
  const announce = useCallback((value) => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce,
    announcement
  };
}
function _superPropGet$D(t, o, e, r2) {
  var p = _get$D(_getPrototypeOf$_(t.prototype), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$D() {
  return _get$D = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$D(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$D.apply(null, arguments);
}
function _superPropBase$D(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$_(t)); ) ;
  return t;
}
function _wrapNativeSuper(t) {
  var r2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function(t4) {
    if (null === t4 || !_isNativeFunction(t4)) return t4;
    if ("function" != typeof t4) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r2) {
      if (r2.has(t4)) return r2.get(t4);
      r2.set(t4, Wrapper);
    }
    function Wrapper() {
      return _construct(t4, arguments, _getPrototypeOf$_(this).constructor);
    }
    return Wrapper.prototype = Object.create(t4.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }), _setPrototypeOf$_(Wrapper, t4);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r2) {
  if (_isNativeReflectConstruct$_()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r2 && _setPrototypeOf$_(p, r2.prototype), p;
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _callSuper$_(t, o, e) {
  return o = _getPrototypeOf$_(o), _possibleConstructorReturn$_(t, _isNativeReflectConstruct$_() ? Reflect.construct(o, e || [], _getPrototypeOf$_(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$_(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$_(t);
}
function _assertThisInitialized$_(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$_() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$_ = function() {
    return !!t;
  })();
}
function _getPrototypeOf$_(t) {
  return _getPrototypeOf$_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$_(t);
}
function _inherits$_(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$_(t, e);
}
function _setPrototypeOf$_(t, e) {
  return _setPrototypeOf$_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$_(t, e);
}
function _defineProperties$14(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$14(o.key), o);
  }
}
function _createClass$14(e, r2, t) {
  return r2 && _defineProperties$14(e.prototype, r2), t && _defineProperties$14(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$14(t) {
  var i = _toPrimitive$14(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$14(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _classCallCheck$14(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
const DndMonitorContext = /* @__PURE__ */ createContext(null);
function useDndMonitor(listener) {
  const registerListener = useContext(DndMonitorContext);
  useEffect(() => {
    if (!registerListener) {
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    }
    const unsubscribe = registerListener(listener);
    return unsubscribe;
  }, [listener, registerListener]);
}
function useDndMonitorProvider() {
  const [listeners] = useState(() => /* @__PURE__ */ new Set());
  const registerListener = useCallback((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, [listeners]);
  const dispatch2 = useCallback((_ref) => {
    let {
      type: type2,
      event
    } = _ref;
    listeners.forEach((listener) => {
      var _listener$type;
      return (_listener$type = listener[type2]) == null ? void 0 : _listener$type.call(listener, event);
    });
  }, [listeners]);
  return [dispatch2, registerListener];
}
const defaultScreenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
  onDragStart(_ref) {
    let {
      active: active2
    } = _ref;
    return "Picked up draggable item " + active2.id + ".";
  },
  onDragOver(_ref2) {
    let {
      active: active2,
      over
    } = _ref2;
    if (over) {
      return "Draggable item " + active2.id + " was moved over droppable area " + over.id + ".";
    }
    return "Draggable item " + active2.id + " is no longer over a droppable area.";
  },
  onDragEnd(_ref3) {
    let {
      active: active2,
      over
    } = _ref3;
    if (over) {
      return "Draggable item " + active2.id + " was dropped over droppable area " + over.id;
    }
    return "Draggable item " + active2.id + " was dropped.";
  },
  onDragCancel(_ref4) {
    let {
      active: active2
    } = _ref4;
    return "Dragging was cancelled. Draggable item " + active2.id + " was dropped.";
  }
};
function Accessibility(_ref) {
  let {
    announcements = defaultAnnouncements,
    container,
    hiddenTextDescribedById,
    screenReaderInstructions = defaultScreenReaderInstructions
  } = _ref;
  const {
    announce,
    announcement
  } = useAnnouncement();
  const liveRegionId = useUniqueId("DndLiveRegion");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  useDndMonitor(useMemo(() => ({
    onDragStart(_ref2) {
      let {
        active: active2
      } = _ref2;
      announce(announcements.onDragStart({
        active: active2
      }));
    },
    onDragMove(_ref3) {
      let {
        active: active2,
        over
      } = _ref3;
      if (announcements.onDragMove) {
        announce(announcements.onDragMove({
          active: active2,
          over
        }));
      }
    },
    onDragOver(_ref4) {
      let {
        active: active2,
        over
      } = _ref4;
      announce(announcements.onDragOver({
        active: active2,
        over
      }));
    },
    onDragEnd(_ref5) {
      let {
        active: active2,
        over
      } = _ref5;
      announce(announcements.onDragEnd({
        active: active2,
        over
      }));
    },
    onDragCancel(_ref6) {
      let {
        active: active2,
        over
      } = _ref6;
      announce(announcements.onDragCancel({
        active: active2,
        over
      }));
    }
  }), [announce, announcements]));
  if (!mounted) {
    return null;
  }
  const markup = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), /* @__PURE__ */ React__default.createElement(LiveRegion, {
    id: liveRegionId,
    announcement
  }));
  return container ? /* @__PURE__ */ createPortal(markup, container) : markup;
}
var Action;
(function(Action2) {
  Action2["DragStart"] = "dragStart";
  Action2["DragMove"] = "dragMove";
  Action2["DragEnd"] = "dragEnd";
  Action2["DragCancel"] = "dragCancel";
  Action2["DragOver"] = "dragOver";
  Action2["RegisterDroppable"] = "registerDroppable";
  Action2["SetDroppableDisabled"] = "setDroppableDisabled";
  Action2["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop$2() {
}
function useSensor(sensor, options2) {
  return useMemo(
    () => ({
      sensor,
      options: options2 != null ? options2 : {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sensor, options2]
  );
}
function useSensors() {
  for (var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++) {
    sensors[_key] = arguments[_key];
  }
  return useMemo(
    () => [...sensors].filter((sensor) => sensor != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...sensors]
  );
}
const defaultCoordinates = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function sortCollisionsAsc(_ref, _ref2) {
  let {
    data: {
      value: a
    }
  } = _ref;
  let {
    data: {
      value: b
    }
  } = _ref2;
  return a - b;
}
function sortCollisionsDesc(_ref3, _ref4) {
  let {
    data: {
      value: a
    }
  } = _ref3;
  let {
    data: {
      value: b
    }
  } = _ref4;
  return b - a;
}
function getFirstCollision(collisions, property2) {
  if (!collisions || collisions.length === 0) {
    return null;
  }
  const [firstCollision] = collisions;
  return firstCollision[property2];
}
function centerOfRectangle(rect2, left2, top2) {
  if (left2 === void 0) {
    left2 = rect2.left;
  }
  if (top2 === void 0) {
    top2 = rect2.top;
  }
  return {
    x: left2 + rect2.width * 0.5,
    y: top2 + rect2.height * 0.5
  };
}
const closestCenter = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id: id2
    } = droppableContainer;
    const rect2 = droppableRects.get(id2);
    if (rect2) {
      const distBetween = distanceBetween(centerOfRectangle(rect2), centerRect);
      collisions.push({
        id: id2,
        data: {
          droppableContainer,
          value: distBetween
        }
      });
    }
  }
  return collisions.sort(sortCollisionsAsc);
};
function getIntersectionRatio(entry, target2) {
  const top2 = Math.max(target2.top, entry.top);
  const left2 = Math.max(target2.left, entry.left);
  const right2 = Math.min(target2.left + target2.width, entry.left + entry.width);
  const bottom2 = Math.min(target2.top + target2.height, entry.top + entry.height);
  const width = right2 - left2;
  const height = bottom2 - top2;
  if (left2 < right2 && top2 < bottom2) {
    const targetArea = target2.width * target2.height;
    const entryArea = entry.width * entry.height;
    const intersectionArea = width * height;
    const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  }
  return 0;
}
const rectIntersection = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id: id2
    } = droppableContainer;
    const rect2 = droppableRects.get(id2);
    if (rect2) {
      const intersectionRatio = getIntersectionRatio(rect2, collisionRect);
      if (intersectionRatio > 0) {
        collisions.push({
          id: id2,
          data: {
            droppableContainer,
            value: intersectionRatio
          }
        });
      }
    }
  }
  return collisions.sort(sortCollisionsDesc);
};
function adjustScale(transform2, rect1, rect2) {
  return {
    ...transform2,
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  };
}
function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
  return function adjustClientRect(rect2) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((acc, adjustment) => ({
      ...acc,
      top: acc.top + modifier * adjustment.y,
      bottom: acc.bottom + modifier * adjustment.y,
      left: acc.left + modifier * adjustment.x,
      right: acc.right + modifier * adjustment.x
    }), {
      ...rect2
    });
  };
}
const getAdjustedRect = /* @__PURE__ */ createRectAdjustmentFn(1);
function parseTransform(transform2) {
  if (transform2.startsWith("matrix3d(")) {
    const transformArray = transform2.slice(9, -1).split(/, /);
    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5]
    };
  } else if (transform2.startsWith("matrix(")) {
    const transformArray = transform2.slice(7, -1).split(/, /);
    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3]
    };
  }
  return null;
}
function inverseTransform(rect2, transform2, transformOrigin) {
  const parsedTransform = parseTransform(transform2);
  if (!parsedTransform) {
    return rect2;
  }
  const {
    scaleX,
    scaleY,
    x: translateX2,
    y: translateY2
  } = parsedTransform;
  const x = rect2.left - translateX2 - (1 - scaleX) * parseFloat(transformOrigin);
  const y = rect2.top - translateY2 - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
  const w = scaleX ? rect2.width / scaleX : rect2.width;
  const h = scaleY ? rect2.height / scaleY : rect2.height;
  return {
    width: w,
    height: h,
    top: y,
    right: x + w,
    bottom: y + h,
    left: x
  };
}
const defaultOptions = {
  ignoreTransform: false
};
function getClientRect(element, options2) {
  if (options2 === void 0) {
    options2 = defaultOptions;
  }
  let rect2 = element.getBoundingClientRect();
  if (options2.ignoreTransform) {
    const {
      transform: transform2,
      transformOrigin
    } = getWindow(element).getComputedStyle(element);
    if (transform2) {
      rect2 = inverseTransform(rect2, transform2, transformOrigin);
    }
  }
  const {
    top: top2,
    left: left2,
    width,
    height,
    bottom: bottom2,
    right: right2
  } = rect2;
  return {
    top: top2,
    left: left2,
    width,
    height,
    bottom: bottom2,
    right: right2
  };
}
function getTransformAgnosticClientRect(element) {
  return getClientRect(element, {
    ignoreTransform: true
  });
}
function getWindowClientRect(element) {
  const width = element.innerWidth;
  const height = element.innerHeight;
  return {
    top: 0,
    left: 0,
    right: width,
    bottom: height,
    width,
    height
  };
}
function isFixed(node2, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(node2).getComputedStyle(node2);
  }
  return computedStyle.position === "fixed";
}
function isScrollable(element, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(element).getComputedStyle(element);
  }
  const overflowRegex = /(auto|scroll|overlay)/;
  const properties2 = ["overflow", "overflowX", "overflowY"];
  return properties2.some((property2) => {
    const value = computedStyle[property2];
    return typeof value === "string" ? overflowRegex.test(value) : false;
  });
}
function getScrollableAncestors(element, limit) {
  const scrollParents = [];
  function findScrollableAncestors(node2) {
    if (limit != null && scrollParents.length >= limit) {
      return scrollParents;
    }
    if (!node2) {
      return scrollParents;
    }
    if (isDocument(node2) && node2.scrollingElement != null && !scrollParents.includes(node2.scrollingElement)) {
      scrollParents.push(node2.scrollingElement);
      return scrollParents;
    }
    if (!isHTMLElement(node2) || isSVGElement(node2)) {
      return scrollParents;
    }
    if (scrollParents.includes(node2)) {
      return scrollParents;
    }
    const computedStyle = getWindow(element).getComputedStyle(node2);
    if (node2 !== element) {
      if (isScrollable(node2, computedStyle)) {
        scrollParents.push(node2);
      }
    }
    if (isFixed(node2, computedStyle)) {
      return scrollParents;
    }
    return findScrollableAncestors(node2.parentNode);
  }
  if (!element) {
    return scrollParents;
  }
  return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node2) {
  const [firstScrollableAncestor] = getScrollableAncestors(node2, 1);
  return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
  if (!canUseDOM || !element) {
    return null;
  }
  if (isWindow(element)) {
    return element;
  }
  if (!isNode(element)) {
    return null;
  }
  if (isDocument(element) || element === getOwnerDocument(element).scrollingElement) {
    return window;
  }
  if (isHTMLElement(element)) {
    return element;
  }
  return null;
}
function getScrollXCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollX;
  }
  return element.scrollLeft;
}
function getScrollYCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollY;
  }
  return element.scrollTop;
}
function getScrollCoordinates(element) {
  return {
    x: getScrollXCoordinate(element),
    y: getScrollYCoordinate(element)
  };
}
var Direction;
(function(Direction2) {
  Direction2[Direction2["Forward"] = 1] = "Forward";
  Direction2[Direction2["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
  if (!canUseDOM || !element) {
    return false;
  }
  return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
  const minScroll = {
    x: 0,
    y: 0
  };
  const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: scrollingContainer.clientHeight,
    width: scrollingContainer.clientWidth
  };
  const maxScroll = {
    x: scrollingContainer.scrollWidth - dimensions.width,
    y: scrollingContainer.scrollHeight - dimensions.height
  };
  const isTop = scrollingContainer.scrollTop <= minScroll.y;
  const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
  const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop,
    isLeft,
    isBottom,
    isRight,
    maxScroll,
    minScroll
  };
}
const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
  let {
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  } = _ref;
  if (acceleration === void 0) {
    acceleration = 10;
  }
  if (thresholdPercentage === void 0) {
    thresholdPercentage = defaultThreshold;
  }
  const {
    isTop,
    isBottom,
    isLeft,
    isRight
  } = getScrollPosition(scrollContainer);
  const direction = {
    x: 0,
    y: 0
  };
  const speed = {
    x: 0,
    y: 0
  };
  const threshold2 = {
    height: scrollContainerRect.height * thresholdPercentage.y,
    width: scrollContainerRect.width * thresholdPercentage.x
  };
  if (!isTop && top2 <= scrollContainerRect.top + threshold2.height) {
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold2.height - top2) / threshold2.height);
  } else if (!isBottom && bottom2 >= scrollContainerRect.bottom - threshold2.height) {
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold2.height - bottom2) / threshold2.height);
  }
  if (!isRight && right2 >= scrollContainerRect.right - threshold2.width) {
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold2.width - right2) / threshold2.width);
  } else if (!isLeft && left2 <= scrollContainerRect.left + threshold2.width) {
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold2.width - left2) / threshold2.width);
  }
  return {
    direction,
    speed
  };
}
function getScrollElementRect(element) {
  if (element === document.scrollingElement) {
    const {
      innerWidth,
      innerHeight
    } = window;
    return {
      top: 0,
      left: 0,
      right: innerWidth,
      bottom: innerHeight,
      width: innerWidth,
      height: innerHeight
    };
  }
  const {
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  } = element.getBoundingClientRect();
  return {
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2,
    width: element.clientWidth,
    height: element.clientHeight
  };
}
function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return add(acc, getScrollCoordinates(node2));
  }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return acc + getScrollXCoordinate(node2);
  }, 0);
}
function getScrollYOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return acc + getScrollYCoordinate(node2);
  }, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }
  if (!element) {
    return;
  }
  const {
    top: top2,
    left: left2,
    bottom: bottom2,
    right: right2
  } = measure(element);
  const firstScrollableAncestor = getFirstScrollableAncestor(element);
  if (!firstScrollableAncestor) {
    return;
  }
  if (bottom2 <= 0 || right2 <= 0 || top2 >= window.innerHeight || left2 >= window.innerWidth) {
    element.scrollIntoView({
      block: "center",
      inline: "center"
    });
  }
}
const properties$4 = [["x", ["left", "right"], getScrollXOffset], ["y", ["top", "bottom"], getScrollYOffset]];
let Rect = /* @__PURE__ */ _createClass$14(function Rect2(rect2, element) {
  _classCallCheck$14(this, Rect2);
  this.rect = void 0;
  this.width = void 0;
  this.height = void 0;
  this.top = void 0;
  this.bottom = void 0;
  this.right = void 0;
  this.left = void 0;
  const scrollableAncestors = getScrollableAncestors(element);
  const scrollOffsets = getScrollOffsets(scrollableAncestors);
  this.rect = {
    ...rect2
  };
  this.width = rect2.width;
  this.height = rect2.height;
  for (const [axis2, keys2, getScrollOffset] of properties$4) {
    for (const key of keys2) {
      Object.defineProperty(this, key, {
        get: () => {
          const currentOffsets = getScrollOffset(scrollableAncestors);
          const scrollOffsetsDeltla = scrollOffsets[axis2] - currentOffsets;
          return this.rect[key] + scrollOffsetsDeltla;
        },
        enumerable: true
      });
    }
  }
  Object.defineProperty(this, "rect", {
    enumerable: false
  });
});
let Listeners = /* @__PURE__ */ (function() {
  function Listeners2(target2) {
    _classCallCheck$14(this, Listeners2);
    this.target = void 0;
    this.listeners = [];
    this.removeAll = () => {
      this.listeners.forEach((listener) => {
        var _this$target;
        return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
      });
    };
    this.target = target2;
  }
  return _createClass$14(Listeners2, [{
    key: "add",
    value: function add2(eventName, handler, options2) {
      var _this$target2;
      (_this$target2 = this.target) == null ? void 0 : _this$target2.addEventListener(eventName, handler, options2);
      this.listeners.push([eventName, handler, options2]);
    }
  }]);
})();
function getEventListenerTarget(target2) {
  const {
    EventTarget
  } = getWindow(target2);
  return target2 instanceof EventTarget ? target2 : getOwnerDocument(target2);
}
function hasExceededDistance(delta2, measurement) {
  const dx = Math.abs(delta2.x);
  const dy = Math.abs(delta2.y);
  if (typeof measurement === "number") {
    return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
  }
  if ("x" in measurement && "y" in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }
  if ("x" in measurement) {
    return dx > measurement.x;
  }
  if ("y" in measurement) {
    return dy > measurement.y;
  }
  return false;
}
var EventName;
(function(EventName2) {
  EventName2["Click"] = "click";
  EventName2["DragStart"] = "dragstart";
  EventName2["Keydown"] = "keydown";
  EventName2["ContextMenu"] = "contextmenu";
  EventName2["Resize"] = "resize";
  EventName2["SelectionChange"] = "selectionchange";
  EventName2["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
  event.preventDefault();
}
function stopPropagation(event) {
  event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode2) {
  KeyboardCode2["Space"] = "Space";
  KeyboardCode2["Down"] = "ArrowDown";
  KeyboardCode2["Right"] = "ArrowRight";
  KeyboardCode2["Left"] = "ArrowLeft";
  KeyboardCode2["Up"] = "ArrowUp";
  KeyboardCode2["Esc"] = "Escape";
  KeyboardCode2["Enter"] = "Enter";
  KeyboardCode2["Tab"] = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter, KeyboardCode.Tab]
};
const defaultKeyboardCoordinateGetter = (event, _ref) => {
  let {
    currentCoordinates
  } = _ref;
  switch (event.code) {
    case KeyboardCode.Right:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x + 25
      };
    case KeyboardCode.Left:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x - 25
      };
    case KeyboardCode.Down:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y + 25
      };
    case KeyboardCode.Up:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y - 25
      };
  }
  return void 0;
};
let KeyboardSensor = /* @__PURE__ */ (function() {
  function KeyboardSensor2(props) {
    _classCallCheck$14(this, KeyboardSensor2);
    this.props = void 0;
    this.autoScrollEnabled = false;
    this.referenceCoordinates = void 0;
    this.listeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    const {
      event: {
        target: target2
      }
    } = props;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target2));
    this.windowListeners = new Listeners(getWindow(target2));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }
  return _createClass$14(KeyboardSensor2, [{
    key: "attach",
    value: function attach() {
      this.handleStart();
      this.windowListeners.add(EventName.Resize, this.handleCancel);
      this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
      setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
    }
  }, {
    key: "handleStart",
    value: function handleStart() {
      const {
        activeNode,
        onStart
      } = this.props;
      const node2 = activeNode.node.current;
      if (node2) {
        scrollIntoViewIfNeeded(node2);
      }
      onStart(defaultCoordinates);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (isKeyboardEvent(event)) {
        const {
          active: active2,
          context,
          options: options2
        } = this.props;
        const {
          keyboardCodes = defaultKeyboardCodes,
          coordinateGetter = defaultKeyboardCoordinateGetter,
          scrollBehavior = "smooth"
        } = options2;
        const {
          code
        } = event;
        if (keyboardCodes.end.includes(code)) {
          this.handleEnd(event);
          return;
        }
        if (keyboardCodes.cancel.includes(code)) {
          this.handleCancel(event);
          return;
        }
        const {
          collisionRect
        } = context.current;
        const currentCoordinates = collisionRect ? {
          x: collisionRect.left,
          y: collisionRect.top
        } : defaultCoordinates;
        if (!this.referenceCoordinates) {
          this.referenceCoordinates = currentCoordinates;
        }
        const newCoordinates = coordinateGetter(event, {
          active: active2,
          context: context.current,
          currentCoordinates
        });
        if (newCoordinates) {
          const coordinatesDelta = subtract(newCoordinates, currentCoordinates);
          const scrollDelta = {
            x: 0,
            y: 0
          };
          const {
            scrollableAncestors
          } = context.current;
          for (const scrollContainer of scrollableAncestors) {
            const direction = event.code;
            const {
              isTop,
              isRight,
              isLeft,
              isBottom,
              maxScroll,
              minScroll
            } = getScrollPosition(scrollContainer);
            const scrollElementRect = getScrollElementRect(scrollContainer);
            const clampedCoordinates = {
              x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
              y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
            };
            const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
            const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
            if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
              const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
              const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
              if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                scrollContainer.scrollTo({
                  left: newScrollCoordinates,
                  behavior: scrollBehavior
                });
                return;
              }
              if (canScrollToNewCoordinates) {
                scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
              } else {
                scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
              }
              if (scrollDelta.x) {
                scrollContainer.scrollBy({
                  left: -scrollDelta.x,
                  behavior: scrollBehavior
                });
              }
              break;
            } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
              const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
              const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
              if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                scrollContainer.scrollTo({
                  top: newScrollCoordinates,
                  behavior: scrollBehavior
                });
                return;
              }
              if (canScrollToNewCoordinates) {
                scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
              } else {
                scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
              }
              if (scrollDelta.y) {
                scrollContainer.scrollBy({
                  top: -scrollDelta.y,
                  behavior: scrollBehavior
                });
              }
              break;
            }
          }
          this.handleMove(event, add(subtract(newCoordinates, this.referenceCoordinates), scrollDelta));
        }
      }
    }
  }, {
    key: "handleMove",
    value: function handleMove(event, coordinates2) {
      const {
        onMove
      } = this.props;
      event.preventDefault();
      onMove(coordinates2);
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      const {
        onEnd
      } = this.props;
      event.preventDefault();
      this.detach();
      onEnd();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(event) {
      const {
        onCancel
      } = this.props;
      event.preventDefault();
      this.detach();
      onCancel();
    }
  }, {
    key: "detach",
    value: function detach() {
      this.listeners.removeAll();
      this.windowListeners.removeAll();
    }
  }]);
})();
KeyboardSensor.activators = [{
  eventName: "onKeyDown",
  handler: (event, _ref, _ref2) => {
    let {
      keyboardCodes = defaultKeyboardCodes,
      onActivation
    } = _ref;
    let {
      active: active2
    } = _ref2;
    const {
      code
    } = event.nativeEvent;
    if (keyboardCodes.start.includes(code)) {
      const activator = active2.activatorNode.current;
      if (activator && event.target !== activator) {
        return false;
      }
      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }
    return false;
  }
}];
function isDistanceConstraint(constraint) {
  return Boolean(constraint && "distance" in constraint);
}
function isDelayConstraint(constraint) {
  return Boolean(constraint && "delay" in constraint);
}
let AbstractPointerSensor = /* @__PURE__ */ (function() {
  function AbstractPointerSensor2(props, events2, listenerTarget) {
    _classCallCheck$14(this, AbstractPointerSensor2);
    var _getEventCoordinates;
    if (listenerTarget === void 0) {
      listenerTarget = getEventListenerTarget(props.event.target);
    }
    this.props = void 0;
    this.events = void 0;
    this.autoScrollEnabled = true;
    this.document = void 0;
    this.activated = false;
    this.initialCoordinates = void 0;
    this.timeoutId = null;
    this.listeners = void 0;
    this.documentListeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    this.events = events2;
    const {
      event
    } = props;
    const {
      target: target2
    } = event;
    this.props = props;
    this.events = events2;
    this.document = getOwnerDocument(target2);
    this.documentListeners = new Listeners(this.document);
    this.listeners = new Listeners(listenerTarget);
    this.windowListeners = new Listeners(getWindow(target2));
    this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.removeTextSelection = this.removeTextSelection.bind(this);
    this.attach();
  }
  return _createClass$14(AbstractPointerSensor2, [{
    key: "attach",
    value: function attach() {
      const {
        events: events2,
        props: {
          options: {
            activationConstraint,
            bypassActivationConstraint
          }
        }
      } = this;
      this.listeners.add(events2.move.name, this.handleMove, {
        passive: false
      });
      this.listeners.add(events2.end.name, this.handleEnd);
      if (events2.cancel) {
        this.listeners.add(events2.cancel.name, this.handleCancel);
      }
      this.windowListeners.add(EventName.Resize, this.handleCancel);
      this.windowListeners.add(EventName.DragStart, preventDefault);
      this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
      this.windowListeners.add(EventName.ContextMenu, preventDefault);
      this.documentListeners.add(EventName.Keydown, this.handleKeydown);
      if (activationConstraint) {
        if (bypassActivationConstraint != null && bypassActivationConstraint({
          event: this.props.event,
          activeNode: this.props.activeNode,
          options: this.props.options
        })) {
          return this.handleStart();
        }
        if (isDelayConstraint(activationConstraint)) {
          this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
          this.handlePending(activationConstraint);
          return;
        }
        if (isDistanceConstraint(activationConstraint)) {
          this.handlePending(activationConstraint);
          return;
        }
      }
      this.handleStart();
    }
  }, {
    key: "detach",
    value: function detach() {
      this.listeners.removeAll();
      this.windowListeners.removeAll();
      setTimeout(this.documentListeners.removeAll, 50);
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }
  }, {
    key: "handlePending",
    value: function handlePending(constraint, offset) {
      const {
        active: active2,
        onPending
      } = this.props;
      onPending(active2, constraint, this.initialCoordinates, offset);
    }
  }, {
    key: "handleStart",
    value: function handleStart() {
      const {
        initialCoordinates
      } = this;
      const {
        onStart
      } = this.props;
      if (initialCoordinates) {
        this.activated = true;
        this.documentListeners.add(EventName.Click, stopPropagation, {
          capture: true
        });
        this.removeTextSelection();
        this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
        onStart(initialCoordinates);
      }
    }
  }, {
    key: "handleMove",
    value: function handleMove(event) {
      var _getEventCoordinates2;
      const {
        activated,
        initialCoordinates,
        props
      } = this;
      const {
        onMove,
        options: {
          activationConstraint
        }
      } = props;
      if (!initialCoordinates) {
        return;
      }
      const coordinates2 = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
      const delta2 = subtract(initialCoordinates, coordinates2);
      if (!activated && activationConstraint) {
        if (isDistanceConstraint(activationConstraint)) {
          if (activationConstraint.tolerance != null && hasExceededDistance(delta2, activationConstraint.tolerance)) {
            return this.handleCancel();
          }
          if (hasExceededDistance(delta2, activationConstraint.distance)) {
            return this.handleStart();
          }
        }
        if (isDelayConstraint(activationConstraint)) {
          if (hasExceededDistance(delta2, activationConstraint.tolerance)) {
            return this.handleCancel();
          }
        }
        this.handlePending(activationConstraint, delta2);
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      onMove(coordinates2);
    }
  }, {
    key: "handleEnd",
    value: function handleEnd() {
      const {
        onAbort,
        onEnd
      } = this.props;
      this.detach();
      if (!this.activated) {
        onAbort(this.props.active);
      }
      onEnd();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      const {
        onAbort,
        onCancel
      } = this.props;
      this.detach();
      if (!this.activated) {
        onAbort(this.props.active);
      }
      onCancel();
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.code === KeyboardCode.Esc) {
        this.handleCancel();
      }
    }
  }, {
    key: "removeTextSelection",
    value: function removeTextSelection() {
      var _this$document$getSel;
      (_this$document$getSel = this.document.getSelection()) == null ? void 0 : _this$document$getSel.removeAllRanges();
    }
  }]);
})();
const events = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
let PointerSensor = /* @__PURE__ */ (function(_AbstractPointerSenso) {
  function PointerSensor2(props) {
    _classCallCheck$14(this, PointerSensor2);
    const {
      event
    } = props;
    const listenerTarget = getOwnerDocument(event.target);
    return _callSuper$_(this, PointerSensor2, [props, events, listenerTarget]);
  }
  _inherits$_(PointerSensor2, _AbstractPointerSenso);
  return _createClass$14(PointerSensor2);
})(AbstractPointerSensor);
PointerSensor.activators = [{
  eventName: "onPointerDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (!event.isPrimary || event.button !== 0) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
const events$1 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var MouseButton;
(function(MouseButton2) {
  MouseButton2[MouseButton2["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
let MouseSensor = /* @__PURE__ */ (function(_AbstractPointerSenso2) {
  function MouseSensor2(props) {
    _classCallCheck$14(this, MouseSensor2);
    return _callSuper$_(this, MouseSensor2, [props, events$1, getOwnerDocument(props.event.target)]);
  }
  _inherits$_(MouseSensor2, _AbstractPointerSenso2);
  return _createClass$14(MouseSensor2);
})(AbstractPointerSensor);
MouseSensor.activators = [{
  eventName: "onMouseDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (event.button === MouseButton.RightClick) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
const events$2 = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
let TouchSensor = /* @__PURE__ */ (function(_AbstractPointerSenso3) {
  function TouchSensor2(props) {
    _classCallCheck$14(this, TouchSensor2);
    return _callSuper$_(this, TouchSensor2, [props, events$2]);
  }
  _inherits$_(TouchSensor2, _AbstractPointerSenso3);
  return _createClass$14(TouchSensor2, null, [{
    key: "setup",
    value: function setup() {
      window.addEventListener(events$2.move.name, noop2, {
        capture: false,
        passive: false
      });
      return function teardown() {
        window.removeEventListener(events$2.move.name, noop2);
      };
      function noop2() {
      }
    }
  }]);
})(AbstractPointerSensor);
TouchSensor.activators = [{
  eventName: "onTouchStart",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    const {
      touches
    } = event;
    if (touches.length > 1) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
var AutoScrollActivator;
(function(AutoScrollActivator2) {
  AutoScrollActivator2[AutoScrollActivator2["Pointer"] = 0] = "Pointer";
  AutoScrollActivator2[AutoScrollActivator2["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder2) {
  TraversalOrder2[TraversalOrder2["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder2[TraversalOrder2["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
  let {
    acceleration,
    activator = AutoScrollActivator.Pointer,
    canScroll,
    draggingRect,
    enabled,
    interval: interval2 = 5,
    order: order2 = TraversalOrder.TreeOrder,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects,
    delta: delta2,
    threshold: threshold2
  } = _ref;
  const scrollIntent = useScrollIntent({
    delta: delta2,
    disabled: !enabled
  });
  const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
  const scrollSpeed = useRef({
    x: 0,
    y: 0
  });
  const scrollDirection = useRef({
    x: 0,
    y: 0
  });
  const rect2 = useMemo(() => {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
  }, [activator, draggingRect, pointerCoordinates]);
  const scrollContainerRef = useRef(null);
  const autoScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) {
      return;
    }
    const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer.scrollBy(scrollLeft, scrollTop);
  }, []);
  const sortedScrollableAncestors = useMemo(() => order2 === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order2, scrollableAncestors]);
  useEffect(
    () => {
      if (!enabled || !scrollableAncestors.length || !rect2) {
        clearAutoScrollInterval();
        return;
      }
      for (const scrollContainer of sortedScrollableAncestors) {
        if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) {
          continue;
        }
        const index2 = scrollableAncestors.indexOf(scrollContainer);
        const scrollContainerRect = scrollableAncestorRects[index2];
        if (!scrollContainerRect) {
          continue;
        }
        const {
          direction,
          speed
        } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect2, acceleration, threshold2);
        for (const axis2 of ["x", "y"]) {
          if (!scrollIntent[axis2][direction[axis2]]) {
            speed[axis2] = 0;
            direction[axis2] = 0;
          }
        }
        if (speed.x > 0 || speed.y > 0) {
          clearAutoScrollInterval();
          scrollContainerRef.current = scrollContainer;
          setAutoScrollInterval(autoScroll, interval2);
          scrollSpeed.current = speed;
          scrollDirection.current = direction;
          return;
        }
      }
      scrollSpeed.current = {
        x: 0,
        y: 0
      };
      scrollDirection.current = {
        x: 0,
        y: 0
      };
      clearAutoScrollInterval();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      acceleration,
      autoScroll,
      canScroll,
      clearAutoScrollInterval,
      enabled,
      interval2,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(rect2),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(scrollIntent),
      setAutoScrollInterval,
      scrollableAncestors,
      sortedScrollableAncestors,
      scrollableAncestorRects,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(threshold2)
    ]
  );
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  },
  y: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  }
};
function useScrollIntent(_ref2) {
  let {
    delta: delta2,
    disabled
  } = _ref2;
  const previousDelta = usePrevious(delta2);
  return useLazyMemo((previousIntent) => {
    if (disabled || !previousDelta || !previousIntent) {
      return defaultScrollIntent;
    }
    const direction = {
      x: Math.sign(delta2.x - previousDelta.x),
      y: Math.sign(delta2.y - previousDelta.y)
    };
    return {
      x: {
        [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
        [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
      },
      y: {
        [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
        [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
      }
    };
  }, [disabled, delta2, previousDelta]);
}
function useCachedNode(draggableNodes, id2) {
  const draggableNode = id2 != null ? draggableNodes.get(id2) : void 0;
  const node2 = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo((cachedNode) => {
    var _ref;
    if (id2 == null) {
      return null;
    }
    return (_ref = node2 != null ? node2 : cachedNode) != null ? _ref : null;
  }, [node2, id2]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
  return useMemo(() => sensors.reduce((accumulator, sensor) => {
    const {
      sensor: Sensor
    } = sensor;
    const sensorActivators = Sensor.activators.map((activator) => ({
      eventName: activator.eventName,
      handler: getSyntheticHandler(activator.handler, sensor)
    }));
    return [...accumulator, ...sensorActivators];
  }, []), [sensors, getSyntheticHandler]);
}
var MeasuringStrategy;
(function(MeasuringStrategy2) {
  MeasuringStrategy2[MeasuringStrategy2["Always"] = 0] = "Always";
  MeasuringStrategy2[MeasuringStrategy2["BeforeDragging"] = 1] = "BeforeDragging";
  MeasuringStrategy2[MeasuringStrategy2["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency2) {
  MeasuringFrequency2["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /* @__PURE__ */ new Map();
function useDroppableMeasuring(containers, _ref) {
  let {
    dragging,
    dependencies: dependencies2,
    config
  } = _ref;
  const [queue2, setQueue] = useState(null);
  const {
    frequency,
    measure,
    strategy
  } = config;
  const containersRef = useRef(containers);
  const disabled = isDisabled();
  const disabledRef = useLatestValue(disabled);
  const measureDroppableContainers = useCallback(function(ids2) {
    if (ids2 === void 0) {
      ids2 = [];
    }
    if (disabledRef.current) {
      return;
    }
    setQueue((value) => {
      if (value === null) {
        return ids2;
      }
      return value.concat(ids2.filter((id2) => !value.includes(id2)));
    });
  }, [disabledRef]);
  const timeoutId = useRef(null);
  const droppableRects = useLazyMemo((previousValue) => {
    if (disabled && !dragging) {
      return defaultValue;
    }
    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue2 != null) {
      const map2 = /* @__PURE__ */ new Map();
      for (let container of containers) {
        if (!container) {
          continue;
        }
        if (queue2 && queue2.length > 0 && !queue2.includes(container.id) && container.rect.current) {
          map2.set(container.id, container.rect.current);
          continue;
        }
        const node2 = container.node.current;
        const rect2 = node2 ? new Rect(measure(node2), node2) : null;
        container.rect.current = rect2;
        if (rect2) {
          map2.set(container.id, rect2);
        }
      }
      return map2;
    }
    return previousValue;
  }, [containers, queue2, dragging, disabled, measure]);
  useEffect(() => {
    containersRef.current = containers;
  }, [containers]);
  useEffect(
    () => {
      if (disabled) {
        return;
      }
      measureDroppableContainers();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dragging, disabled]
  );
  useEffect(
    () => {
      if (queue2 && queue2.length > 0) {
        setQueue(null);
      }
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(queue2)]
  );
  useEffect(
    () => {
      if (disabled || typeof frequency !== "number" || timeoutId.current !== null) {
        return;
      }
      timeoutId.current = setTimeout(() => {
        measureDroppableContainers();
        timeoutId.current = null;
      }, frequency);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [frequency, disabled, measureDroppableContainers, ...dependencies2]
  );
  return {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled: queue2 != null
  };
  function isDisabled() {
    switch (strategy) {
      case MeasuringStrategy.Always:
        return false;
      case MeasuringStrategy.BeforeDragging:
        return dragging;
      default:
        return !dragging;
    }
  }
}
function useInitialValue(value, computeFn) {
  return useLazyMemo((previousValue) => {
    if (!value) {
      return null;
    }
    if (previousValue) {
      return previousValue;
    }
    return typeof computeFn === "function" ? computeFn(value) : value;
  }, [computeFn, value]);
}
function useInitialRect(node2, measure) {
  return useInitialValue(node2, measure);
}
function useMutationObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleMutations = useEvent(callback);
  const mutationObserver = useMemo(() => {
    if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") {
      return void 0;
    }
    const {
      MutationObserver: MutationObserver2
    } = window;
    return new MutationObserver2(handleMutations);
  }, [handleMutations, disabled]);
  useEffect(() => {
    return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
  }, [mutationObserver]);
  return mutationObserver;
}
function useResizeObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleResize = useEvent(callback);
  const resizeObserver = useMemo(
    () => {
      if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") {
        return void 0;
      }
      const {
        ResizeObserver
      } = window;
      return new ResizeObserver(handleResize);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled]
  );
  useEffect(() => {
    return () => resizeObserver == null ? void 0 : resizeObserver.disconnect();
  }, [resizeObserver]);
  return resizeObserver;
}
function defaultMeasure(element) {
  return new Rect(getClientRect(element), element);
}
function useRect(element, measure, fallbackRect) {
  if (measure === void 0) {
    measure = defaultMeasure;
  }
  const [rect2, setRect] = useState(null);
  function measureRect() {
    setRect((currentRect) => {
      if (!element) {
        return null;
      }
      if (element.isConnected === false) {
        var _ref;
        return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
      }
      const newRect = measure(element);
      if (JSON.stringify(currentRect) === JSON.stringify(newRect)) {
        return currentRect;
      }
      return newRect;
    });
  }
  const mutationObserver = useMutationObserver({
    callback(records) {
      if (!element) {
        return;
      }
      for (const record of records) {
        const {
          type: type2,
          target: target2
        } = record;
        if (type2 === "childList" && target2 instanceof HTMLElement && target2.contains(element)) {
          measureRect();
          break;
        }
      }
    }
  });
  const resizeObserver = useResizeObserver({
    callback: measureRect
  });
  useIsomorphicLayoutEffect(() => {
    measureRect();
    if (element) {
      resizeObserver == null ? void 0 : resizeObserver.observe(element);
      mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }
  }, [element]);
  return rect2;
}
function useRectDelta(rect2) {
  const initialRect = useInitialValue(rect2);
  return getRectDelta(rect2, initialRect);
}
const defaultValue$1 = [];
function useScrollableAncestors(node2) {
  const previousNode = useRef(node2);
  const ancestors = useLazyMemo((previousValue) => {
    if (!node2) {
      return defaultValue$1;
    }
    if (previousValue && previousValue !== defaultValue$1 && node2 && previousNode.current && node2.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }
    return getScrollableAncestors(node2);
  }, [node2]);
  useEffect(() => {
    previousNode.current = node2;
  }, [node2]);
  return ancestors;
}
function useScrollOffsets(elements) {
  const [scrollCoordinates, setScrollCoordinates] = useState(null);
  const prevElements = useRef(elements);
  const handleScroll = useCallback((event) => {
    const scrollingElement = getScrollableElement(event.target);
    if (!scrollingElement) {
      return;
    }
    setScrollCoordinates((scrollCoordinates2) => {
      if (!scrollCoordinates2) {
        return null;
      }
      scrollCoordinates2.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates2);
    });
  }, []);
  useEffect(() => {
    const previousElements = prevElements.current;
    if (elements !== previousElements) {
      cleanup(previousElements);
      const entries = elements.map((element) => {
        const scrollableElement = getScrollableElement(element);
        if (scrollableElement) {
          scrollableElement.addEventListener("scroll", handleScroll, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }
        return null;
      }).filter((entry) => entry != null);
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }
    return () => {
      cleanup(elements);
      cleanup(previousElements);
    };
    function cleanup(elements2) {
      elements2.forEach((element) => {
        const scrollableElement = getScrollableElement(element);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener("scroll", handleScroll);
      });
    }
  }, [handleScroll, elements]);
  return useMemo(() => {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates2) => add(acc, coordinates2), defaultCoordinates) : getScrollOffsets(elements);
    }
    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies2) {
  if (dependencies2 === void 0) {
    dependencies2 = [];
  }
  const initialScrollOffsets = useRef(null);
  useEffect(
    () => {
      initialScrollOffsets.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies2
  );
  useEffect(() => {
    const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
    if (hasScrollOffsets && !initialScrollOffsets.current) {
      initialScrollOffsets.current = scrollOffsets;
    }
    if (!hasScrollOffsets && initialScrollOffsets.current) {
      initialScrollOffsets.current = null;
    }
  }, [scrollOffsets]);
  return initialScrollOffsets.current ? subtract(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
  useEffect(
    () => {
      if (!canUseDOM) {
        return;
      }
      const teardownFns = sensors.map((_ref) => {
        let {
          sensor
        } = _ref;
        return sensor.setup == null ? void 0 : sensor.setup();
      });
      return () => {
        for (const teardown of teardownFns) {
          teardown == null ? void 0 : teardown();
        }
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2) => {
      let {
        sensor
      } = _ref2;
      return sensor;
    })
  );
}
function useSyntheticListeners(listeners, id2) {
  return useMemo(() => {
    return listeners.reduce((acc, _ref) => {
      let {
        eventName,
        handler
      } = _ref;
      acc[eventName] = (event) => {
        handler(event, id2);
      };
      return acc;
    }, {});
  }, [listeners, id2]);
}
function useWindowRect(element) {
  return useMemo(() => element ? getWindowClientRect(element) : null, [element]);
}
const defaultValue$2 = [];
function useRects(elements, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }
  const [firstElement] = elements;
  const windowRect = useWindowRect(firstElement ? getWindow(firstElement) : null);
  const [rects, setRects] = useState(defaultValue$2);
  function measureRects() {
    setRects(() => {
      if (!elements.length) {
        return defaultValue$2;
      }
      return elements.map((element) => isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
    });
  }
  const resizeObserver = useResizeObserver({
    callback: measureRects
  });
  useIsomorphicLayoutEffect(() => {
    resizeObserver == null ? void 0 : resizeObserver.disconnect();
    measureRects();
    elements.forEach((element) => resizeObserver == null ? void 0 : resizeObserver.observe(element));
  }, [elements]);
  return rects;
}
function getMeasurableNode(node2) {
  if (!node2) {
    return null;
  }
  if (node2.children.length > 1) {
    return node2;
  }
  const firstChild = node2.children[0];
  return isHTMLElement(firstChild) ? firstChild : node2;
}
function useDragOverlayMeasuring(_ref) {
  let {
    measure
  } = _ref;
  const [rect2, setRect] = useState(null);
  const handleResize = useCallback((entries) => {
    for (const {
      target: target2
    } of entries) {
      if (isHTMLElement(target2)) {
        setRect((rect3) => {
          const newRect = measure(target2);
          return rect3 ? {
            ...rect3,
            width: newRect.width,
            height: newRect.height
          } : newRect;
        });
        break;
      }
    }
  }, [measure]);
  const resizeObserver = useResizeObserver({
    callback: handleResize
  });
  const handleNodeChange = useCallback((element) => {
    const node2 = getMeasurableNode(element);
    resizeObserver == null ? void 0 : resizeObserver.disconnect();
    if (node2) {
      resizeObserver == null ? void 0 : resizeObserver.observe(node2);
    }
    setRect(node2 ? measure(node2) : null);
  }, [measure, resizeObserver]);
  const [nodeRef, setRef] = useNodeRef(handleNodeChange);
  return useMemo(() => ({
    nodeRef,
    rect: rect2,
    setRef
  }), [rect2, nodeRef, setRef]);
}
const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
const defaultData = {
  current: {}
};
const defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect
  }
};
let DroppableContainersMap = /* @__PURE__ */ (function(_Map) {
  function DroppableContainersMap2() {
    _classCallCheck$14(this, DroppableContainersMap2);
    return _callSuper$_(this, DroppableContainersMap2, arguments);
  }
  _inherits$_(DroppableContainersMap2, _Map);
  return _createClass$14(DroppableContainersMap2, [{
    key: "get",
    value: function get3(id2) {
      var _super$get;
      return id2 != null ? (_super$get = _superPropGet$D(DroppableContainersMap2, "get", this, 3)([id2])) != null ? _super$get : void 0 : void 0;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this.values());
    }
  }, {
    key: "getEnabled",
    value: function getEnabled() {
      return this.toArray().filter((_ref) => {
        let {
          disabled
        } = _ref;
        return !disabled;
      });
    }
  }, {
    key: "getNodeFor",
    value: function getNodeFor(id2) {
      var _this$get$node$curren, _this$get;
      return (_this$get$node$curren = (_this$get = this.get(id2)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : void 0;
    }
  }]);
})(/* @__PURE__ */ _wrapNativeSuper(Map));
const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop$2
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop$2,
  windowRect: null,
  measuringScheduled: false
};
const defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: noop$2,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: noop$2
};
const InternalContext = /* @__PURE__ */ createContext(defaultInternalContext);
const PublicContext = /* @__PURE__ */ createContext(defaultPublicContext);
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          initialCoordinates: action.initialCoordinates,
          active: action.active
        }
      };
    case Action.DragMove:
      if (state.draggable.active == null) {
        return state;
      }
      return {
        ...state,
        draggable: {
          ...state.draggable,
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        }
      };
    case Action.DragEnd:
    case Action.DragCancel:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Action.RegisterDroppable: {
      const {
        element
      } = action;
      const {
        id: id2
      } = element;
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id2, element);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.SetDroppableDisabled: {
      const {
        id: id2,
        key,
        disabled
      } = action;
      const element = state.droppable.containers.get(id2);
      if (!element || key !== element.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id2, {
        ...element,
        disabled
      });
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.UnregisterDroppable: {
      const {
        id: id2,
        key
      } = action;
      const element = state.droppable.containers.get(id2);
      if (!element || key !== element.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.delete(id2);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    default: {
      return state;
    }
  }
}
function RestoreFocus(_ref) {
  let {
    disabled
  } = _ref;
  const {
    active: active2,
    activatorEvent,
    draggableNodes
  } = useContext(InternalContext);
  const previousActivatorEvent = usePrevious(activatorEvent);
  const previousActiveId = usePrevious(active2 == null ? void 0 : active2.id);
  useEffect(() => {
    if (disabled) {
      return;
    }
    if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
      if (!isKeyboardEvent(previousActivatorEvent)) {
        return;
      }
      if (document.activeElement === previousActivatorEvent.target) {
        return;
      }
      const draggableNode = draggableNodes.get(previousActiveId);
      if (!draggableNode) {
        return;
      }
      const {
        activatorNode,
        node: node2
      } = draggableNode;
      if (!activatorNode.current && !node2.current) {
        return;
      }
      requestAnimationFrame(() => {
        for (const element of [activatorNode.current, node2.current]) {
          if (!element) {
            continue;
          }
          const focusableNode = findFirstFocusableNode(element);
          if (focusableNode) {
            focusableNode.focus();
            break;
          }
        }
      });
    }
  }, [activatorEvent, disabled, draggableNodes, previousActiveId, previousActivatorEvent]);
  return null;
}
function applyModifiers(modifiers, _ref) {
  let {
    transform: transform2,
    ...args
  } = _ref;
  return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier) => {
    return modifier({
      transform: accumulator,
      ...args
    });
  }, transform2) : transform2;
}
function useMeasuringConfiguration(config) {
  return useMemo(
    () => ({
      draggable: {
        ...defaultMeasuringConfiguration.draggable,
        ...config == null ? void 0 : config.draggable
      },
      droppable: {
        ...defaultMeasuringConfiguration.droppable,
        ...config == null ? void 0 : config.droppable
      },
      dragOverlay: {
        ...defaultMeasuringConfiguration.dragOverlay,
        ...config == null ? void 0 : config.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config == null ? void 0 : config.draggable, config == null ? void 0 : config.droppable, config == null ? void 0 : config.dragOverlay]
  );
}
function useLayoutShiftScrollCompensation(_ref) {
  let {
    activeNode,
    measure,
    initialRect,
    config = true
  } = _ref;
  const initialized = useRef(false);
  const {
    x,
    y
  } = typeof config === "boolean" ? {
    x: config,
    y: config
  } : config;
  useIsomorphicLayoutEffect(() => {
    const disabled = !x && !y;
    if (disabled || !activeNode) {
      initialized.current = false;
      return;
    }
    if (initialized.current || !initialRect) {
      return;
    }
    const node2 = activeNode == null ? void 0 : activeNode.node.current;
    if (!node2 || node2.isConnected === false) {
      return;
    }
    const rect2 = measure(node2);
    const rectDelta = getRectDelta(rect2, initialRect);
    if (!x) {
      rectDelta.x = 0;
    }
    if (!y) {
      rectDelta.y = 0;
    }
    initialized.current = true;
    if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
      const firstScrollableAncestor = getFirstScrollableAncestor(node2);
      if (firstScrollableAncestor) {
        firstScrollableAncestor.scrollBy({
          top: rectDelta.y,
          left: rectDelta.x
        });
      }
    }
  }, [activeNode, x, y, initialRect, measure]);
}
const ActiveDraggableContext = /* @__PURE__ */ createContext({
  ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;
(function(Status2) {
  Status2[Status2["Uninitialized"] = 0] = "Uninitialized";
  Status2[Status2["Initializing"] = 1] = "Initializing";
  Status2[Status2["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /* @__PURE__ */ memo(function DndContext2(_ref) {
  var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
  let {
    id: id2,
    accessibility,
    autoScroll = true,
    children: children2,
    sensors = defaultSensors,
    collisionDetection = rectIntersection,
    measuring,
    modifiers,
    ...props
  } = _ref;
  const store = useReducer(reducer, void 0, getInitialState);
  const [state, dispatch2] = store;
  const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
  const [status, setStatus] = useState(Status.Uninitialized);
  const isInitialized = status === Status.Initialized;
  const {
    draggable: {
      active: activeId,
      nodes: draggableNodes,
      translate
    },
    droppable: {
      containers: droppableContainers
    }
  } = state;
  const node2 = activeId != null ? draggableNodes.get(activeId) : null;
  const activeRects = useRef({
    initial: null,
    translated: null
  });
  const active2 = useMemo(() => {
    var _node$data;
    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node2 == null ? void 0 : node2.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node2]);
  const activeRef = useRef(null);
  const [activeSensor, setActiveSensor] = useState(null);
  const [activatorEvent, setActivatorEvent] = useState(null);
  const latestProps = useLatestValue(props, Object.values(props));
  const draggableDescribedById = useUniqueId("DndDescribedBy", id2);
  const enabledDroppableContainers = useMemo(() => droppableContainers.getEnabled(), [droppableContainers]);
  const measuringConfiguration = useMeasuringConfiguration(measuring);
  const {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled
  } = useDroppableMeasuring(enabledDroppableContainers, {
    dragging: isInitialized,
    dependencies: [translate.x, translate.y],
    config: measuringConfiguration.droppable
  });
  const activeNode = useCachedNode(draggableNodes, activeId);
  const activationCoordinates = useMemo(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
  const autoScrollOptions = getAutoScrollerOptions();
  const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: activeId != null ? draggableNodes.get(activeId) : null,
    config: autoScrollOptions.layoutShiftCompensation,
    initialRect: initialActiveNodeRect,
    measure: measuringConfiguration.draggable.measure
  });
  const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
  const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
  const sensorContext = useRef({
    activatorEvent: null,
    active: null,
    activeNode,
    collisionRect: null,
    collisions: null,
    droppableRects,
    draggableNodes,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  });
  const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
  const dragOverlay = useDragOverlayMeasuring({
    measure: measuringConfiguration.dragOverlay.measure
  });
  const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
  const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
  const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect);
  const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect);
  const windowRect = useWindowRect(draggingNode ? getWindow(draggingNode) : null);
  const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
  const scrollableAncestorRects = useRects(scrollableAncestors);
  const modifiedTranslate = applyModifiers(modifiers, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent,
    active: active2,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect,
    over: sensorContext.current.over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  });
  const pointerCoordinates = activationCoordinates ? add(activationCoordinates, translate) : null;
  const scrollOffsets = useScrollOffsets(scrollableAncestors);
  const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets);
  const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
  const scrollAdjustedTranslate = add(modifiedTranslate, scrollAdjustment);
  const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
  const collisions = active2 && collisionRect ? collisionDetection({
    active: active2,
    collisionRect,
    droppableRects,
    droppableContainers: enabledDroppableContainers,
    pointerCoordinates
  }) : null;
  const overId = getFirstCollision(collisions, "id");
  const [over, setOver] = useState(null);
  const appliedTranslate = usesDragOverlay ? modifiedTranslate : add(modifiedTranslate, activeNodeScrollDelta);
  const transform2 = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
  const activeSensorRef = useRef(null);
  const instantiateSensor = useCallback(
    (event, _ref2) => {
      let {
        sensor: Sensor,
        options: options2
      } = _ref2;
      if (activeRef.current == null) {
        return;
      }
      const activeNode2 = draggableNodes.get(activeRef.current);
      if (!activeNode2) {
        return;
      }
      const activatorEvent2 = event.nativeEvent;
      const sensorInstance = new Sensor({
        active: activeRef.current,
        activeNode: activeNode2,
        event: activatorEvent2,
        options: options2,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: sensorContext,
        onAbort(id3) {
          const draggableNode = draggableNodes.get(id3);
          if (!draggableNode) {
            return;
          }
          const {
            onDragAbort
          } = latestProps.current;
          const event2 = {
            id: id3
          };
          onDragAbort == null ? void 0 : onDragAbort(event2);
          dispatchMonitorEvent({
            type: "onDragAbort",
            event: event2
          });
        },
        onPending(id3, constraint, initialCoordinates, offset) {
          const draggableNode = draggableNodes.get(id3);
          if (!draggableNode) {
            return;
          }
          const {
            onDragPending
          } = latestProps.current;
          const event2 = {
            id: id3,
            constraint,
            initialCoordinates,
            offset
          };
          onDragPending == null ? void 0 : onDragPending(event2);
          dispatchMonitorEvent({
            type: "onDragPending",
            event: event2
          });
        },
        onStart(initialCoordinates) {
          const id3 = activeRef.current;
          if (id3 == null) {
            return;
          }
          const draggableNode = draggableNodes.get(id3);
          if (!draggableNode) {
            return;
          }
          const {
            onDragStart
          } = latestProps.current;
          const event2 = {
            activatorEvent: activatorEvent2,
            active: {
              id: id3,
              data: draggableNode.data,
              rect: activeRects
            }
          };
          unstable_batchedUpdates(() => {
            onDragStart == null ? void 0 : onDragStart(event2);
            setStatus(Status.Initializing);
            dispatch2({
              type: Action.DragStart,
              initialCoordinates,
              active: id3
            });
            dispatchMonitorEvent({
              type: "onDragStart",
              event: event2
            });
            setActiveSensor(activeSensorRef.current);
            setActivatorEvent(activatorEvent2);
          });
        },
        onMove(coordinates2) {
          dispatch2({
            type: Action.DragMove,
            coordinates: coordinates2
          });
        },
        onEnd: createHandler(Action.DragEnd),
        onCancel: createHandler(Action.DragCancel)
      });
      activeSensorRef.current = sensorInstance;
      function createHandler(type2) {
        return async function handler() {
          const {
            active: active3,
            collisions: collisions2,
            over: over2,
            scrollAdjustedTranslate: scrollAdjustedTranslate2
          } = sensorContext.current;
          let event2 = null;
          if (active3 && scrollAdjustedTranslate2) {
            const {
              cancelDrop
            } = latestProps.current;
            event2 = {
              activatorEvent: activatorEvent2,
              active: active3,
              collisions: collisions2,
              delta: scrollAdjustedTranslate2,
              over: over2
            };
            if (type2 === Action.DragEnd && typeof cancelDrop === "function") {
              const shouldCancel = await Promise.resolve(cancelDrop(event2));
              if (shouldCancel) {
                type2 = Action.DragCancel;
              }
            }
          }
          activeRef.current = null;
          unstable_batchedUpdates(() => {
            dispatch2({
              type: type2
            });
            setStatus(Status.Uninitialized);
            setOver(null);
            setActiveSensor(null);
            setActivatorEvent(null);
            activeSensorRef.current = null;
            const eventName = type2 === Action.DragEnd ? "onDragEnd" : "onDragCancel";
            if (event2) {
              const handler2 = latestProps.current[eventName];
              handler2 == null ? void 0 : handler2(event2);
              dispatchMonitorEvent({
                type: eventName,
                event: event2
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes]
  );
  const bindActivatorToSensorInstantiator = useCallback((handler, sensor) => {
    return (event, active3) => {
      const nativeEvent = event.nativeEvent;
      const activeDraggableNode = draggableNodes.get(active3);
      if (
        // Another sensor is already instantiating
        activeRef.current !== null || // No active draggable
        !activeDraggableNode || // Event has already been captured
        nativeEvent.dndKit || nativeEvent.defaultPrevented
      ) {
        return;
      }
      const activationContext = {
        active: activeDraggableNode
      };
      const shouldActivate = handler(event, sensor.options, activationContext);
      if (shouldActivate === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active3;
        instantiateSensor(event, sensor);
      }
    };
  }, [draggableNodes, instantiateSensor]);
  const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useSensorSetup(sensors);
  useIsomorphicLayoutEffect(() => {
    if (activeNodeRect && status === Status.Initializing) {
      setStatus(Status.Initialized);
    }
  }, [activeNodeRect, status]);
  useEffect(
    () => {
      const {
        onDragMove
      } = latestProps.current;
      const {
        active: active3,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        over: over2
      } = sensorContext.current;
      if (!active3 || !activatorEvent2) {
        return;
      }
      const event = {
        active: active3,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate.x,
          y: scrollAdjustedTranslate.y
        },
        over: over2
      };
      unstable_batchedUpdates(() => {
        onDragMove == null ? void 0 : onDragMove(event);
        dispatchMonitorEvent({
          type: "onDragMove",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]
  );
  useEffect(
    () => {
      const {
        active: active3,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        droppableContainers: droppableContainers2,
        scrollAdjustedTranslate: scrollAdjustedTranslate2
      } = sensorContext.current;
      if (!active3 || activeRef.current == null || !activatorEvent2 || !scrollAdjustedTranslate2) {
        return;
      }
      const {
        onDragOver
      } = latestProps.current;
      const overContainer = droppableContainers2.get(overId);
      const over2 = overContainer && overContainer.rect.current ? {
        id: overContainer.id,
        rect: overContainer.rect.current,
        data: overContainer.data,
        disabled: overContainer.disabled
      } : null;
      const event = {
        active: active3,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate2.x,
          y: scrollAdjustedTranslate2.y
        },
        over: over2
      };
      unstable_batchedUpdates(() => {
        setOver(over2);
        onDragOver == null ? void 0 : onDragOver(event);
        dispatchMonitorEvent({
          type: "onDragOver",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [overId]
  );
  useIsomorphicLayoutEffect(() => {
    sensorContext.current = {
      activatorEvent,
      active: active2,
      activeNode,
      collisionRect,
      collisions,
      droppableRects,
      draggableNodes,
      draggingNode,
      draggingNodeRect,
      droppableContainers,
      over,
      scrollableAncestors,
      scrollAdjustedTranslate
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: collisionRect
    };
  }, [active2, activeNode, collisions, collisionRect, draggableNodes, draggingNode, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate]);
  useAutoScroller({
    ...autoScrollOptions,
    delta: translate,
    draggingRect: collisionRect,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects
  });
  const publicContext = useMemo(() => {
    const context = {
      active: active2,
      activeNode,
      activeNodeRect,
      activatorEvent,
      collisions,
      containerNodeRect,
      dragOverlay,
      draggableNodes,
      droppableContainers,
      droppableRects,
      over,
      measureDroppableContainers,
      scrollableAncestors,
      scrollableAncestorRects,
      measuringConfiguration,
      measuringScheduled,
      windowRect
    };
    return context;
  }, [active2, activeNode, activeNodeRect, activatorEvent, collisions, containerNodeRect, dragOverlay, draggableNodes, droppableContainers, droppableRects, over, measureDroppableContainers, scrollableAncestors, scrollableAncestorRects, measuringConfiguration, measuringScheduled, windowRect]);
  const internalContext = useMemo(() => {
    const context = {
      activatorEvent,
      activators,
      active: active2,
      activeNodeRect,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      dispatch: dispatch2,
      draggableNodes,
      over,
      measureDroppableContainers
    };
    return context;
  }, [activatorEvent, activators, active2, activeNodeRect, dispatch2, draggableDescribedById, draggableNodes, over, measureDroppableContainers]);
  return /* @__PURE__ */ React__default.createElement(DndMonitorContext.Provider, {
    value: registerMonitorListener
  }, /* @__PURE__ */ React__default.createElement(InternalContext.Provider, {
    value: internalContext
  }, /* @__PURE__ */ React__default.createElement(PublicContext.Provider, {
    value: publicContext
  }, /* @__PURE__ */ React__default.createElement(ActiveDraggableContext.Provider, {
    value: transform2
  }, children2)), /* @__PURE__ */ React__default.createElement(RestoreFocus, {
    disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
  })), /* @__PURE__ */ React__default.createElement(Accessibility, {
    ...accessibility,
    hiddenTextDescribedById: draggableDescribedById
  }));
  function getAutoScrollerOptions() {
    const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
    const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
    if (typeof autoScroll === "object") {
      return {
        ...autoScroll,
        enabled
      };
    }
    return {
      enabled
    };
  }
});
const NullContext = /* @__PURE__ */ createContext(null);
const defaultRole = "button";
const ID_PREFIX$1 = "Draggable";
function useDraggable(_ref) {
  let {
    id: id2,
    data: data2,
    disabled = false,
    attributes: attributes2
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1);
  const {
    activators,
    activatorEvent,
    active: active2,
    activeNodeRect,
    ariaDescribedById,
    draggableNodes,
    over
  } = useContext(InternalContext);
  const {
    role = defaultRole,
    roleDescription = "draggable",
    tabIndex = 0
  } = attributes2 != null ? attributes2 : {};
  const isDragging = (active2 == null ? void 0 : active2.id) === id2;
  const transform2 = useContext(isDragging ? ActiveDraggableContext : NullContext);
  const [node2, setNodeRef] = useNodeRef();
  const [activatorNode, setActivatorNodeRef] = useNodeRef();
  const listeners = useSyntheticListeners(activators, id2);
  const dataRef = useLatestValue(data2);
  useIsomorphicLayoutEffect(
    () => {
      draggableNodes.set(id2, {
        id: id2,
        key,
        node: node2,
        activatorNode,
        data: dataRef
      });
      return () => {
        const node3 = draggableNodes.get(id2);
        if (node3 && node3.key === key) {
          draggableNodes.delete(id2);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes, id2]
  );
  const memoizedAttributes = useMemo(() => ({
    role,
    tabIndex,
    "aria-disabled": disabled,
    "aria-pressed": isDragging && role === defaultRole ? true : void 0,
    "aria-roledescription": roleDescription,
    "aria-describedby": ariaDescribedById.draggable
  }), [disabled, role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active: active2,
    activatorEvent,
    activeNodeRect,
    attributes: memoizedAttributes,
    isDragging,
    listeners: disabled ? void 0 : listeners,
    node: node2,
    over,
    setNodeRef,
    setActivatorNodeRef,
    transform: transform2
  };
}
function useDndContext() {
  return useContext(PublicContext);
}
const ID_PREFIX$1$1 = "Droppable";
const defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(_ref) {
  let {
    data: data2,
    disabled = false,
    id: id2,
    resizeObserverConfig
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1$1);
  const {
    active: active2,
    dispatch: dispatch2,
    over,
    measureDroppableContainers
  } = useContext(InternalContext);
  const previous = useRef({
    disabled
  });
  const resizeObserverConnected = useRef(false);
  const rect2 = useRef(null);
  const callbackId = useRef(null);
  const {
    disabled: resizeObserverDisabled,
    updateMeasurementsFor,
    timeout: resizeObserverTimeout
  } = {
    ...defaultResizeObserverConfig,
    ...resizeObserverConfig
  };
  const ids2 = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id2);
  const handleResize = useCallback(
    () => {
      if (!resizeObserverConnected.current) {
        resizeObserverConnected.current = true;
        return;
      }
      if (callbackId.current != null) {
        clearTimeout(callbackId.current);
      }
      callbackId.current = setTimeout(() => {
        measureDroppableContainers(Array.isArray(ids2.current) ? ids2.current : [ids2.current]);
        callbackId.current = null;
      }, resizeObserverTimeout);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [resizeObserverTimeout]
  );
  const resizeObserver = useResizeObserver({
    callback: handleResize,
    disabled: resizeObserverDisabled || !active2
  });
  const handleNodeChange = useCallback((newElement, previousElement) => {
    if (!resizeObserver) {
      return;
    }
    if (previousElement) {
      resizeObserver.unobserve(previousElement);
      resizeObserverConnected.current = false;
    }
    if (newElement) {
      resizeObserver.observe(newElement);
    }
  }, [resizeObserver]);
  const [nodeRef, setNodeRef] = useNodeRef(handleNodeChange);
  const dataRef = useLatestValue(data2);
  useEffect(() => {
    if (!resizeObserver || !nodeRef.current) {
      return;
    }
    resizeObserver.disconnect();
    resizeObserverConnected.current = false;
    resizeObserver.observe(nodeRef.current);
  }, [nodeRef, resizeObserver]);
  useEffect(
    () => {
      dispatch2({
        type: Action.RegisterDroppable,
        element: {
          id: id2,
          key,
          disabled,
          node: nodeRef,
          rect: rect2,
          data: dataRef
        }
      });
      return () => dispatch2({
        type: Action.UnregisterDroppable,
        key,
        id: id2
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id2]
  );
  useEffect(() => {
    if (disabled !== previous.current.disabled) {
      dispatch2({
        type: Action.SetDroppableDisabled,
        id: id2,
        key,
        disabled
      });
      previous.current.disabled = disabled;
    }
  }, [id2, key, disabled, dispatch2]);
  return {
    active: active2,
    rect: rect2,
    isOver: (over == null ? void 0 : over.id) === id2,
    node: nodeRef,
    over,
    setNodeRef
  };
}
function arrayMove(array2, from, to) {
  const newArray = array2.slice();
  newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
  return newArray;
}
function getSortedRects(items2, rects) {
  return items2.reduce((accumulator, id2, index2) => {
    const rect2 = rects.get(id2);
    if (rect2) {
      accumulator[index2] = rect2;
    }
    return accumulator;
  }, Array(items2.length));
}
function isValidIndex(index2) {
  return index2 !== null && index2 >= 0;
}
function itemsEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
function normalizeDisabled(disabled) {
  if (typeof disabled === "boolean") {
    return {
      draggable: disabled,
      droppable: disabled
    };
  }
  return disabled;
}
const defaultScale = {
  scaleX: 1,
  scaleY: 1
};
const horizontalListSortingStrategy = (_ref) => {
  var _rects$activeIndex;
  let {
    rects,
    activeNodeRect: fallbackActiveRect,
    activeIndex,
    overIndex,
    index: index2
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
  if (!activeNodeRect) {
    return null;
  }
  const itemGap = getItemGap(rects, index2, activeIndex);
  if (index2 === activeIndex) {
    const newIndexRect = rects[overIndex];
    if (!newIndexRect) {
      return null;
    }
    return {
      x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
      y: 0,
      ...defaultScale
    };
  }
  if (index2 > activeIndex && index2 <= overIndex) {
    return {
      x: -activeNodeRect.width - itemGap,
      y: 0,
      ...defaultScale
    };
  }
  if (index2 < activeIndex && index2 >= overIndex) {
    return {
      x: activeNodeRect.width + itemGap,
      y: 0,
      ...defaultScale
    };
  }
  return {
    x: 0,
    y: 0,
    ...defaultScale
  };
};
function getItemGap(rects, index2, activeIndex) {
  const currentRect = rects[index2];
  const previousRect = rects[index2 - 1];
  const nextRect = rects[index2 + 1];
  if (!currentRect || !previousRect && !nextRect) {
    return 0;
  }
  if (activeIndex < index2) {
    return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
  }
  return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const rectSortingStrategy = (_ref) => {
  let {
    rects,
    activeIndex,
    overIndex,
    index: index2
  } = _ref;
  const newRects = arrayMove(rects, overIndex, activeIndex);
  const oldRect = rects[index2];
  const newRect = newRects[index2];
  if (!newRect || !oldRect) {
    return null;
  }
  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};
const defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
};
const verticalListSortingStrategy = (_ref) => {
  var _rects$activeIndex;
  let {
    activeIndex,
    activeNodeRect: fallbackActiveRect,
    index: index2,
    rects,
    overIndex
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
  if (!activeNodeRect) {
    return null;
  }
  if (index2 === activeIndex) {
    const overIndexRect = rects[overIndex];
    if (!overIndexRect) {
      return null;
    }
    return {
      x: 0,
      y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
      ...defaultScale$1
    };
  }
  const itemGap = getItemGap$1(rects, index2, activeIndex);
  if (index2 > activeIndex && index2 <= overIndex) {
    return {
      x: 0,
      y: -activeNodeRect.height - itemGap,
      ...defaultScale$1
    };
  }
  if (index2 < activeIndex && index2 >= overIndex) {
    return {
      x: 0,
      y: activeNodeRect.height + itemGap,
      ...defaultScale$1
    };
  }
  return {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};
function getItemGap$1(clientRects, index2, activeIndex) {
  const currentRect = clientRects[index2];
  const previousRect = clientRects[index2 - 1];
  const nextRect = clientRects[index2 + 1];
  if (!currentRect) {
    return 0;
  }
  if (activeIndex < index2) {
    return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
  }
  return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const ID_PREFIX = "Sortable";
const Context = /* @__PURE__ */ React__default.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX,
  disableTransforms: false,
  items: [],
  overIndex: -1,
  useDragOverlay: false,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: false,
    droppable: false
  }
});
function SortableContext(_ref) {
  let {
    children: children2,
    id: id2,
    items: userDefinedItems,
    strategy = rectSortingStrategy,
    disabled: disabledProp = false
  } = _ref;
  const {
    active: active2,
    dragOverlay,
    droppableRects,
    over,
    measureDroppableContainers
  } = useDndContext();
  const containerId = useUniqueId(ID_PREFIX, id2);
  const useDragOverlay = Boolean(dragOverlay.rect !== null);
  const items2 = useMemo(() => userDefinedItems.map((item) => typeof item === "object" && "id" in item ? item.id : item), [userDefinedItems]);
  const isDragging = active2 != null;
  const activeIndex = active2 ? items2.indexOf(active2.id) : -1;
  const overIndex = over ? items2.indexOf(over.id) : -1;
  const previousItemsRef = useRef(items2);
  const itemsHaveChanged = !itemsEqual(items2, previousItemsRef.current);
  const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
  const disabled = normalizeDisabled(disabledProp);
  useIsomorphicLayoutEffect(() => {
    if (itemsHaveChanged && isDragging) {
      measureDroppableContainers(items2);
    }
  }, [itemsHaveChanged, items2, isDragging, measureDroppableContainers]);
  useEffect(() => {
    previousItemsRef.current = items2;
  }, [items2]);
  const contextValue = useMemo(
    () => ({
      activeIndex,
      containerId,
      disabled,
      disableTransforms,
      items: items2,
      overIndex,
      useDragOverlay,
      sortedRects: getSortedRects(items2, droppableRects),
      strategy
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeIndex, containerId, disabled.draggable, disabled.droppable, disableTransforms, items2, overIndex, droppableRects, useDragOverlay, strategy]
  );
  return /* @__PURE__ */ React__default.createElement(Context.Provider, {
    value: contextValue
  }, children2);
}
const defaultNewIndexGetter = (_ref) => {
  let {
    id: id2,
    items: items2,
    activeIndex,
    overIndex
  } = _ref;
  return arrayMove(items2, activeIndex, overIndex).indexOf(id2);
};
const defaultAnimateLayoutChanges = (_ref2) => {
  let {
    containerId,
    isSorting,
    wasDragging,
    index: index2,
    items: items2,
    newIndex,
    previousItems,
    previousContainerId,
    transition: transition2
  } = _ref2;
  if (!transition2 || !wasDragging) {
    return false;
  }
  if (previousItems !== items2 && index2 === newIndex) {
    return false;
  }
  if (isSorting) {
    return true;
  }
  return newIndex !== index2 && containerId === previousContainerId;
};
const defaultTransition = {
  duration: 200,
  easing: "ease"
};
const transitionProperty = "transform";
const disabledTransition = /* @__PURE__ */ CSS$1.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: "linear"
});
const defaultAttributes = {
  roleDescription: "sortable"
};
function useDerivedTransform(_ref) {
  let {
    disabled,
    index: index2,
    node: node2,
    rect: rect2
  } = _ref;
  const [derivedTransform, setDerivedtransform] = useState(null);
  const previousIndex = useRef(index2);
  useIsomorphicLayoutEffect(() => {
    if (!disabled && index2 !== previousIndex.current && node2.current) {
      const initial = rect2.current;
      if (initial) {
        const current = getClientRect(node2.current, {
          ignoreTransform: true
        });
        const delta2 = {
          x: initial.left - current.left,
          y: initial.top - current.top,
          scaleX: initial.width / current.width,
          scaleY: initial.height / current.height
        };
        if (delta2.x || delta2.y) {
          setDerivedtransform(delta2);
        }
      }
    }
    if (index2 !== previousIndex.current) {
      previousIndex.current = index2;
    }
  }, [disabled, index2, node2, rect2]);
  useEffect(() => {
    if (derivedTransform) {
      setDerivedtransform(null);
    }
  }, [derivedTransform]);
  return derivedTransform;
}
function useSortable(_ref) {
  let {
    animateLayoutChanges = defaultAnimateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled: localDisabled,
    data: customData,
    getNewIndex = defaultNewIndexGetter,
    id: id2,
    strategy: localStrategy,
    resizeObserverConfig,
    transition: transition2 = defaultTransition
  } = _ref;
  const {
    items: items2,
    containerId,
    activeIndex,
    disabled: globalDisabled,
    disableTransforms,
    sortedRects,
    overIndex,
    useDragOverlay,
    strategy: globalStrategy
  } = useContext(Context);
  const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
  const index2 = items2.indexOf(id2);
  const data2 = useMemo(() => ({
    sortable: {
      containerId,
      index: index2,
      items: items2
    },
    ...customData
  }), [containerId, customData, index2, items2]);
  const itemsAfterCurrentSortable = useMemo(() => items2.slice(items2.indexOf(id2)), [items2, id2]);
  const {
    rect: rect2,
    node: node2,
    isOver,
    setNodeRef: setDroppableNodeRef
  } = useDroppable({
    id: id2,
    data: data2,
    disabled: disabled.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: itemsAfterCurrentSortable,
      ...resizeObserverConfig
    }
  });
  const {
    active: active2,
    activatorEvent,
    activeNodeRect,
    attributes: attributes2,
    setNodeRef: setDraggableNodeRef,
    listeners,
    isDragging,
    over,
    setActivatorNodeRef,
    transform: transform2
  } = useDraggable({
    id: id2,
    data: data2,
    attributes: {
      ...defaultAttributes,
      ...userDefinedAttributes
    },
    disabled: disabled.draggable
  });
  const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
  const isSorting = Boolean(active2);
  const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
  const shouldDisplaceDragSource = !useDragOverlay && isDragging;
  const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform2 : null;
  const strategy = localStrategy != null ? localStrategy : globalStrategy;
  const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
    rects: sortedRects,
    activeNodeRect,
    activeIndex,
    overIndex,
    index: index2
  }) : null;
  const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
    id: id2,
    items: items2,
    activeIndex,
    overIndex
  }) : index2;
  const activeId = active2 == null ? void 0 : active2.id;
  const previous = useRef({
    activeId,
    items: items2,
    newIndex,
    containerId
  });
  const itemsHaveChanged = items2 !== previous.current.items;
  const shouldAnimateLayoutChanges = animateLayoutChanges({
    active: active2,
    containerId,
    isDragging,
    isSorting,
    id: id2,
    index: index2,
    items: items2,
    newIndex: previous.current.newIndex,
    previousItems: previous.current.items,
    previousContainerId: previous.current.containerId,
    transition: transition2,
    wasDragging: previous.current.activeId != null
  });
  const derivedTransform = useDerivedTransform({
    disabled: !shouldAnimateLayoutChanges,
    index: index2,
    node: node2,
    rect: rect2
  });
  useEffect(() => {
    if (isSorting && previous.current.newIndex !== newIndex) {
      previous.current.newIndex = newIndex;
    }
    if (containerId !== previous.current.containerId) {
      previous.current.containerId = containerId;
    }
    if (items2 !== previous.current.items) {
      previous.current.items = items2;
    }
  }, [isSorting, newIndex, containerId, items2]);
  useEffect(() => {
    if (activeId === previous.current.activeId) {
      return;
    }
    if (activeId != null && previous.current.activeId == null) {
      previous.current.activeId = activeId;
      return;
    }
    const timeoutId = setTimeout(() => {
      previous.current.activeId = activeId;
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [activeId]);
  return {
    active: active2,
    activeIndex,
    attributes: attributes2,
    data: data2,
    rect: rect2,
    index: index2,
    newIndex,
    items: items2,
    isOver,
    isSorting,
    isDragging,
    listeners,
    node: node2,
    overIndex,
    over,
    setNodeRef,
    setActivatorNodeRef,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform: derivedTransform != null ? derivedTransform : finalTransform,
    transition: getTransition()
  };
  function getTransition() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
      itemsHaveChanged && previous.current.newIndex === index2
    ) {
      return disabledTransition;
    }
    if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition2) {
      return void 0;
    }
    if (isSorting || shouldAnimateLayoutChanges) {
      return CSS$1.Transition.toString({
        ...transition2,
        property: transitionProperty
      });
    }
    return void 0;
  }
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
  var _localDisabled$dragga, _localDisabled$droppa;
  if (typeof localDisabled === "boolean") {
    return {
      draggable: localDisabled,
      // Backwards compatibility
      droppable: false
    };
  }
  return {
    draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
    droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
  };
}
[KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
const classes$3 = {
  "top-right-handle": "_top-right-handle_cizw2_1",
  "bottom-right-handle": "_bottom-right-handle_cizw2_2",
  "top-left-handle": "_top-left-handle_cizw2_7",
  "bottom-left-handle": "_bottom-left-handle_cizw2_8",
  "top-draggable-handle": "_top-draggable-handle_cizw2_13",
  "bottom-draggable-handle": "_bottom-draggable-handle_cizw2_14",
  "left-draggable-handle": "_left-draggable-handle_cizw2_15",
  "right-draggable-handle": "_right-draggable-handle_cizw2_16",
  "draggable-div": "_draggable-div_cizw2_22",
  "top-draggable-handle-grabber": "_top-draggable-handle-grabber_cizw2_27",
  "bottom-draggable-handle-grabber": "_bottom-draggable-handle-grabber_cizw2_28",
  "left-draggable-handle-grabber": "_left-draggable-handle-grabber_cizw2_43",
  "right-draggable-handle-grabber": "_right-draggable-handle-grabber_cizw2_44"
};
function _classCallCheck$13(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$13(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$13(o.key), o);
  }
}
function _createClass$13(e, r2, t) {
  return r2 && _defineProperties$13(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$13(t) {
  var i = _toPrimitive$13(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$13(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$Z(t, o, e) {
  return o = _getPrototypeOf$Z(o), _possibleConstructorReturn$Z(t, _isNativeReflectConstruct$Z() ? Reflect.construct(o, e || [], _getPrototypeOf$Z(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$Z(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$Z(t);
}
function _assertThisInitialized$Z(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$Z() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$Z = function() {
    return !!t;
  })();
}
function _getPrototypeOf$Z(t) {
  return _getPrototypeOf$Z = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$Z(t);
}
function _inherits$Z(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$Z(t, e);
}
function _setPrototypeOf$Z(t, e) {
  return _setPrototypeOf$Z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$Z(t, e);
}
let DraggableDiv = /* @__PURE__ */ (function(_React$Component) {
  function DraggableDiv2(props) {
    var _this;
    _classCallCheck$13(this, DraggableDiv2);
    _this = _callSuper$Z(this, DraggableDiv2, [props]);
    _this.dragTopRight = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragTopRightFunc.bind(_this));
    _this.dragTopLeft = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragTopLeftFunc.bind(_this));
    _this.dragBottomRight = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragBottomRightFunc.bind(_this));
    _this.dragBottomLeft = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragBottomLeftFunc.bind(_this));
    _this.dragBottom = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragBottomFunc.bind(_this));
    _this.dragTop = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragTopFunc.bind(_this));
    _this.dragLeft = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragLeftFunc.bind(_this));
    _this.dragRight = drag().on("start", _this.dragStart.bind(_this)).on("drag", _this.dragRightFunc.bind(_this));
    _this.minWidth = 10;
    _this.minHeight = 10;
    _this.bottomHandleWidth = 20;
    _this.state = {
      uid: _this.props.uid,
      width: _this.props.width,
      height: _this.props.height,
      top: _this.props.top,
      left: _this.props.left
    };
    _this.domBody = select("body").node();
    return _this;
  }
  _inherits$Z(DraggableDiv2, _React$Component);
  return _createClass$13(DraggableDiv2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      select(this.bottomHandle).call(this.dragBottom);
      select(this.topHandle).call(this.dragTop);
      select(this.leftHandle).call(this.dragLeft);
      select(this.rightHandle).call(this.dragRight);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if ("width" in newProps) {
        this.setState({
          width: newProps.width
        });
      }
      if ("height" in newProps) {
        this.setState({
          height: newProps.height
        });
      }
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "dragBottomFunc",
    value: function dragBottomFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight + (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      this.setState({
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragLeftFunc",
    value: function dragLeftFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth - (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newLeft = this.dragStartLeft + ms[0] - this.dragStartMousePos[0];
      newLeft = newWidth > this.minWidth ? newLeft : this.dragStartLeft + this.dragStartWidth - this.minWidth;
      this.setState({
        left: newLeft,
        width: newWidth
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragTopFunc",
    value: function dragTopFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight - (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newTop = this.dragStartTop + ms[1] - this.dragStartMousePos[1];
      newTop = newHeight > this.minHeight ? newTop : this.dragStartTop + this.dragStartHeight - this.minHeight;
      this.setState({
        top: newTop,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragRightFunc",
    value: function dragRightFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth + (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      this.setState({
        width: newWidth
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragBottomLeftFunc",
    value: function dragBottomLeftFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight + (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newWidth = this.dragStartWidth - (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newLeft = this.dragStartLeft + ms[0] - this.dragStartMousePos[0];
      newLeft = newWidth > this.minWidth ? newLeft : this.dragStartLeft + this.dragStartWidth - this.minWidth;
      this.setState({
        left: newLeft,
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragBottomRightFunc",
    value: function dragBottomRightFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth + (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newHeight = this.dragStartHeight + (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      this.setState({
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragTopRightFunc",
    value: function dragTopRightFunc(event) {
      const ms = pointer(event, this.domBody);
      let newHeight = this.dragStartHeight - (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newTop = this.dragStartTop + ms[1] - this.dragStartMousePos[1];
      newTop = newHeight > this.minHeight ? newTop : this.dragStartTop + this.dragStartHeight - this.minHeight;
      let newWidth = this.dragStartWidth + (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      this.setState({
        top: newTop,
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragTopLeftFunc",
    value: function dragTopLeftFunc(event) {
      const ms = pointer(event, this.domBody);
      let newWidth = this.dragStartWidth - (ms[0] - this.dragStartMousePos[0]);
      newWidth = newWidth > this.minWidth ? newWidth : this.minWidth;
      let newLeft = this.dragStartLeft + ms[0] - this.dragStartMousePos[0];
      newLeft = newWidth > this.minWidth ? newLeft : this.dragStartLeft + this.dragStartWidth - this.minWidth;
      let newHeight = this.dragStartHeight - (ms[1] - this.dragStartMousePos[1]);
      newHeight = newHeight > this.minHeight ? newHeight : this.minHeight;
      let newTop = this.dragStartTop + ms[1] - this.dragStartMousePos[1];
      newTop = newHeight > this.minHeight ? newTop : this.dragStartTop + this.dragStartHeight - this.minHeight;
      this.setState({
        top: newTop,
        left: newLeft,
        width: newWidth,
        height: newHeight
      });
      event.sourceEvent.stopPropagation();
      this.sizeChanged();
    }
  }, {
    key: "dragStart",
    value: function dragStart(event) {
      this.dragStartMousePos = pointer(event, this.domBody);
      this.dragStartWidth = this.state.width;
      this.dragStartHeight = this.state.height;
      this.dragStartTop = this.state.top;
      this.dragStartLeft = this.state.left;
      event.sourceEvent.stopPropagation();
    }
  }, {
    key: "sizeChanged",
    value: function sizeChanged() {
      if (this.props.sizeChanged) {
        this.props.sizeChanged(this.state);
      }
    }
  }, {
    key: "rotateClicked",
    value: function rotateClicked() {
      this.props.trackRotated(this.state.uid);
    }
  }, {
    key: "closeClicked",
    value: function closeClicked() {
      this.props.trackClosed(this.state.uid);
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const dragColor = this.props.theme === THEME_DARK ? "white" : "black";
      const divStyle = {
        top: this.state.top,
        left: this.state.left,
        width: this.state.width,
        height: this.state.height,
        opacity: this.props.opacity
      };
      const resizeWidth = 24;
      const resizeHeight = 24;
      const horizStyle = {
        left: this.state.width / 2 - resizeWidth / 2,
        width: resizeWidth
      };
      const vertStyle = {
        top: this.state.height / 2 - resizeHeight / 2,
        height: resizeHeight
      };
      const styles2 = {
        bottom: {
          ...horizStyle,
          bottom: 1
        },
        top: {
          ...horizStyle,
          top: 1
        },
        left: {
          ...vertStyle,
          left: 1
        },
        right: {
          ...vertStyle,
          right: 1
        }
      };
      const resizeHandles = [...this.props.resizeHandles].map((x) => /* @__PURE__ */ React__default.createElement("div", {
        key: x,
        ref: (c) => {
          this[`${x}Handle`] = c;
        },
        className: classes$3[`${x}-draggable-handle`],
        style: styles2[x],
        title: "Resize track"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: classes$3[`${x}-draggable-handle-grabber`],
        style: {
          borderColor: dragColor
        }
      })));
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.divContainer = c;
        },
        className: clsx$2(this.props.className, classes$3["draggable-div"]),
        style: divStyle
      }, resizeHandles);
    }
  }]);
})(React__default.Component);
DraggableDiv.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  left: PropTypes.number,
  opacity: PropTypes.number,
  resizeHandles: PropTypes.object,
  sizeChanged: PropTypes.func,
  top: PropTypes.number,
  trackClosed: PropTypes.func,
  trackRotated: PropTypes.func,
  uid: PropTypes.string,
  width: PropTypes.number,
  theme: PropTypes.symbol
};
const DraggableDiv$1 = withTheme(DraggableDiv);
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _classCallCheck$12(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$12(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$12(o.key), o);
  }
}
function _createClass$12(e, r2, t) {
  return r2 && _defineProperties$12(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$12(t) {
  var i = _toPrimitive$12(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$12(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$Y(t, o, e) {
  return o = _getPrototypeOf$Y(o), _possibleConstructorReturn$Y(t, _isNativeReflectConstruct$Y() ? Reflect.construct(o, e || [], _getPrototypeOf$Y(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$Y(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$Y(t);
}
function _assertThisInitialized$Y(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$Y() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$Y = function() {
    return !!t;
  })();
}
function _getPrototypeOf$Y(t) {
  return _getPrototypeOf$Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$Y(t);
}
function _inherits$Y(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$Y(t, e);
}
function _setPrototypeOf$Y(t, e) {
  return _setPrototypeOf$Y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$Y(t, e);
}
let TrackArea = /* @__PURE__ */ (function(_React$Component) {
  function TrackArea2(props) {
    var _this;
    _classCallCheck$12(this, TrackArea2);
    _this = _callSuper$Y(this, TrackArea2, [props]);
    _this.state = {
      controlsVisible: false
    };
    return _this;
  }
  _inherits$Y(TrackArea2, _React$Component);
  return _createClass$12(TrackArea2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !this.resizing;
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        controlsVisible: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        controlsVisible: false
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.setState({
        controlsVisible: true
      });
    }
  }, {
    key: "getControls",
    value: function getControls() {
      const {
        dragHandleProps
      } = this.props;
      const handle = this.moveable ? /* @__PURE__ */ React__default.createElement("svg", _extends$1({
        className: "no-zoom",
        height: "10px",
        onClick: () => {
        },
        style: this.getMoveImgStyle(),
        width: "10px"
      }, dragHandleProps), /* @__PURE__ */ React__default.createElement("title", null, "Move"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#move"
      })) : /* @__PURE__ */ React__default.createElement("div", null);
      return /* @__PURE__ */ React__default.createElement("div", {
        style: {
          position: "absolute",
          backgroundColor: "rgba(255,255,255,0.7)",
          right: "3px",
          top: "3px",
          pointerEvents: "none",
          paddingLeft: "5px",
          paddingRight: "5px",
          borderRadius: "5px",
          border: "1px solid #dddddd"
        }
      }, handle, /* @__PURE__ */ React__default.createElement("svg", {
        ref: (c) => {
          this.imgConfig = c;
        },
        className: "no-zoom",
        height: "10px",
        onClick: () => {
          const bbox = this.imgConfig.getBoundingClientRect();
          this.props.onConfigTrackMenuOpened(this.props.uid, bbox);
        },
        style: this.getSettingsImgStyle(),
        width: "10px"
      }, /* @__PURE__ */ React__default.createElement("title", null, "No Zoom"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#cog"
      })), /* @__PURE__ */ React__default.createElement("svg", {
        ref: (c) => {
          this.imgAdd = c;
        },
        className: "no-zoom",
        height: "10px",
        onClick: () => this.props.onAddSeries(this.props.uid),
        style: this.getAddImgStyle(),
        width: "10px"
      }, /* @__PURE__ */ React__default.createElement("title", null, "Add"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#plus"
      })), /* @__PURE__ */ React__default.createElement("svg", {
        ref: (c) => {
          this.imgClose = c;
        },
        className: "no-zoom",
        height: "10px",
        onClick: () => {
          const bbox = this.imgClose.getBoundingClientRect();
          this.props.onCloseTrackMenuOpened(this.props.uid, bbox);
        },
        style: this.getCloseImgStyle(),
        width: "10px"
      }, /* @__PURE__ */ React__default.createElement("title", null, "Close"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#cross"
      })));
    }
  }]);
})(React__default.Component);
TrackArea.propTypes = {
  configMenuOpen: PropTypes.bool,
  onConfigTrackMenuOpened: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onAddSeries: PropTypes.func,
  uid: PropTypes.string
};
function _classCallCheck$11(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$11(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$11(o.key), o);
  }
}
function _createClass$11(e, r2, t) {
  return r2 && _defineProperties$11(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$11(t) {
  var i = _toPrimitive$11(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$11(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$X(t, o, e) {
  return o = _getPrototypeOf$X(o), _possibleConstructorReturn$X(t, _isNativeReflectConstruct$X() ? Reflect.construct(o, e || [], _getPrototypeOf$X(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$X(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$X(t);
}
function _assertThisInitialized$X(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$X() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$X = function() {
    return !!t;
  })();
}
function _getPrototypeOf$X(t) {
  return _getPrototypeOf$X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$X(t);
}
function _inherits$X(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$X(t, e);
}
function _setPrototypeOf$X(t, e) {
  return _setPrototypeOf$X = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$X(t, e);
}
let MoveableTrack = /* @__PURE__ */ (function(_TrackArea) {
  function MoveableTrack2(props) {
    var _this;
    _classCallCheck$11(this, MoveableTrack2);
    _this = _callSuper$X(this, MoveableTrack2, [props]);
    _this.moveable = true;
    return _this;
  }
  _inherits$X(MoveableTrack2, _TrackArea);
  return _createClass$11(MoveableTrack2, [{
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (r2) => {
          this.el = r2;
        },
        className: this.props.className,
        onMouseEnter: this.props.item.handleMouseEnter,
        onMouseLeave: this.props.item.handleMouseLeave,
        style: {
          height: this.props.height,
          width: this.props.width
        }
      }, /* @__PURE__ */ React__default.createElement(DraggableDiv$1, {
        key: this.props.uid,
        height: this.props.height,
        resizeHandles: this.props.editable ? this.props.resizeHandles : /* @__PURE__ */ new Set(),
        sizeChanged: (stuff) => this.props.handleResizeTrack(this.props.uid, stuff.width, stuff.height),
        style: {
          background: "transparent"
        },
        uid: this.props.uid,
        width: this.props.width
      }), this.props.editable && this.getControls(this.props.item.trackControlsVisible || this.props.item.configMenuVisible));
    }
  }]);
})(TrackArea);
MoveableTrack.propTypes = {
  className: PropTypes.string,
  uid: PropTypes.string,
  item: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number
};
function _classCallCheck$10(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$10(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$10(o.key), o);
  }
}
function _createClass$10(e, r2, t) {
  return r2 && _defineProperties$10(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$10(t) {
  var i = _toPrimitive$10(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$10(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$W(t, o, e) {
  return o = _getPrototypeOf$W(o), _possibleConstructorReturn$W(t, _isNativeReflectConstruct$W() ? Reflect.construct(o, e || [], _getPrototypeOf$W(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$W(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$W(t);
}
function _assertThisInitialized$W(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$W() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$W = function() {
    return !!t;
  })();
}
function _getPrototypeOf$W(t) {
  return _getPrototypeOf$W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$W(t);
}
function _inherits$W(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$W(t, e);
}
function _setPrototypeOf$W(t, e) {
  return _setPrototypeOf$W = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$W(t, e);
}
const STYLES$1 = {
  pointerEvents: "all"
};
let HorizontalTrack = /* @__PURE__ */ (function(_MoveableTrack) {
  function HorizontalTrack2() {
    _classCallCheck$10(this, HorizontalTrack2);
    return _callSuper$W(this, HorizontalTrack2, arguments);
  }
  _inherits$W(HorizontalTrack2, _MoveableTrack);
  return _createClass$10(HorizontalTrack2, [{
    key: "getControls",
    value: function getControls(isVisible) {
      return /* @__PURE__ */ React__default.createElement(
        TrackControl$1,
        {
          expandCollapseAvailable: true,
          configMenuVisible: this.props.item.configMenuVisible,
          dragHandleProps: this.props.dragHandleProps,
          imgStyleAdd: STYLES$1,
          imgStyleClose: STYLES$1,
          imgStyleMove: STYLES$1,
          imgStyleSettings: STYLES$1,
          isCollapsed: this.props.isCollapsed,
          isMoveable: this.moveable,
          isVisible,
          onAddSeries: this.props.onAddSeries,
          onCollapseTrack: this.props.onCollapseTrack,
          onExpandTrack: this.props.onExpandTrack,
          onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
          onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
          uid: this.props.uid
        }
      );
    }
  }]);
})(MoveableTrack);
function HorizontalItem(props) {
  const {
    attributes: attributes2,
    listeners,
    setNodeRef,
    transform: transform2,
    transition: transition2,
    isDragging
  } = useSortable({
    id: props.uid
  });
  const adjustedTransform = transform2 ? {
    ...transform2,
    x: 0
  } : transform2;
  const style = {
    transform: CSS$1.Transform.toString(adjustedTransform),
    transition: transition2,
    ...isDragging ? {
      zIndex: 10,
      background: "rgba(0, 0, 0, 0.1)",
      border: "2px dashed rgba(0, 0, 0, 0.3)",
      borderRadius: 4
    } : {}
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: setNodeRef,
    style
  }, /* @__PURE__ */ React__default.createElement(HorizontalTrack, {
    className: props.className,
    dragHandleProps: {
      ...attributes2,
      ...listeners
    },
    editable: props.editable,
    handleConfigTrack: props.handleConfigTrack,
    handleResizeTrack: props.handleResizeTrack,
    height: props.height,
    isCollapsed: props.isCollapsed,
    item: props.item,
    onAddSeries: props.onAddSeries,
    onCollapseTrack: props.onCollapseTrack,
    onExpandTrack: props.onExpandTrack,
    onCloseTrack: props.onCloseTrack,
    onCloseTrackMenuOpened: props.onCloseTrackMenuOpened,
    onConfigTrackMenuOpened: props.onConfigTrackMenuOpened,
    resizeHandles: props.resizeHandles,
    uid: props.uid,
    width: props.width
  }));
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _classCallCheck$$(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$$(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$$(o.key), o);
  }
}
function _createClass$$(e, r2, t) {
  return r2 && _defineProperties$$(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$$(t) {
  var i = _toPrimitive$$(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$$(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$V(t, o, e) {
  return o = _getPrototypeOf$V(o), _possibleConstructorReturn$V(t, _isNativeReflectConstruct$V() ? Reflect.construct(o, [], _getPrototypeOf$V(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$V(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$V(t);
}
function _assertThisInitialized$V(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$V() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$V = function() {
    return !!t;
  })();
}
function _getPrototypeOf$V(t) {
  return _getPrototypeOf$V = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$V(t);
}
function _inherits$V(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$V(t, e);
}
function _setPrototypeOf$V(t, e) {
  return _setPrototypeOf$V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$V(t, e);
}
let ListWrapper = /* @__PURE__ */ (function(_React$Component) {
  function ListWrapper2({
    items: items2
  }) {
    var _this;
    _classCallCheck$$(this, ListWrapper2);
    _this = _callSuper$V(this, ListWrapper2);
    _this.state = {
      items: items2,
      isSorting: false
    };
    return _this;
  }
  _inherits$V(ListWrapper2, _React$Component);
  return _createClass$$(ListWrapper2, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        items: nextProps.items
      });
    }
  }, {
    key: "onSortStart",
    value: function onSortStart({
      index: index2
    }) {
      const {
        onSortStart: onSortStart2
      } = this.props;
      this.setState({
        isSorting: true
      });
      if (onSortStart2) {
        onSortStart2(this.ref);
      }
      this.sortingIndex = index2;
    }
  }, {
    key: "onSortMove",
    value: function onSortMove() {
    }
  }, {
    key: "onSortEnd",
    value: function onSortEnd({
      oldIndex,
      newIndex
    }) {
      const {
        onSortEnd: onSortEnd2
      } = this.props;
      const {
        items: items2
      } = this.state;
      const sortedItems = arrayMove(items2, oldIndex, newIndex);
      this.setState({
        items: sortedItems,
        isSorting: false
      });
      if (onSortEnd2) {
        onSortEnd2(sortedItems);
      }
      this.sortingIndex = null;
    }
  }, {
    key: "render",
    value: function render3() {
      const Component2 = this.props.component;
      const {
        items: items2,
        isSorting
      } = this.state;
      const props = {
        isSorting,
        items: items2,
        onSortEnd: this.onSortEnd.bind(this),
        onSortStart: this.onSortStart.bind(this),
        onSortMove: this.onSortMove.bind(this)
      };
      return /* @__PURE__ */ React__default.createElement(Component2, _extends({}, this.props, props));
    }
  }]);
})(React__default.Component);
ListWrapper.propTypes = {
  axis: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.func,
  editable: PropTypes.bool,
  handleConfigTrack: PropTypes.func,
  handleResizeTrack: PropTypes.func,
  height: PropTypes.number,
  helperClass: PropTypes.string,
  itemClass: PropTypes.string,
  itemControlAlignLeft: PropTypes.bool,
  itemReactClass: PropTypes.func,
  items: PropTypes.array,
  onAddSeries: PropTypes.func,
  onCloseTrack: PropTypes.func,
  onCollapseTrack: PropTypes.func,
  onExpandTrack: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onSortEnd: PropTypes.func,
  onSortStart: PropTypes.func,
  referenceAncestor: PropTypes.string,
  resizeHandles: PropTypes.object,
  useDragHandle: PropTypes.bool,
  width: PropTypes.number
};
ListWrapper.defaultProps = {
  className: "list stylizedList",
  itemClass: "item stylizedItem",
  width: 400,
  height: 600
};
function SortableList({
  className,
  items: items2,
  itemClass,
  itemControlAlignLeft,
  sortingIndex,
  useDragHandle,
  sortableHandlers,
  height,
  width,
  onCloseTrack,
  onCollapseTrack,
  onExpandTrack,
  onCloseTrackMenuOpened,
  onConfigTrackMenuOpened,
  onAddSeries,
  handleConfigTrack,
  editable,
  itemReactClass,
  handleResizeTrack,
  resizeHandles,
  onSortEnd,
  onSortStart,
  onSortMove,
  axis: axis2
}) {
  const sensors = useSensors(useSensor(PointerSensor, {
    activationConstraint: {
      distance: 5
    }
  }));
  const handleDragStart = (event) => {
    const {
      active: active2
    } = event;
    const index2 = items2.findIndex((item) => item.uid === active2.id);
    if (onSortStart) {
      onSortStart({
        index: index2
      });
    }
  };
  const handleDragOver = (event) => {
    const {
      active: active2,
      over
    } = event;
    if (!over || active2.id === over.id) return;
    const oldIndex = items2.findIndex((item) => item.uid === active2.id);
    const newIndex = items2.findIndex((item) => item.uid === over.id);
    if (oldIndex !== -1 && newIndex !== -1) {
      onSortEnd({
        oldIndex,
        newIndex
      });
    }
  };
  const isHorizontalAxis = axis2 === "x";
  const strategy = isHorizontalAxis ? horizontalListSortingStrategy : verticalListSortingStrategy;
  const itemIds = items2.map((item) => item.uid);
  const itemElements = items2.map((item, index2) => /* @__PURE__ */ React__default.createElement(itemReactClass, {
    key: `sci-${item.uid}`,
    className: itemClass,
    controlAlignLeft: itemControlAlignLeft,
    sortingIndex,
    index: index2,
    uid: item.uid,
    height: item.height,
    width: item.width,
    isCollapsed: item.isCollapsed,
    item,
    useDragHandle,
    onCloseTrack,
    onCollapseTrack,
    onExpandTrack,
    onCloseTrackMenuOpened,
    onConfigTrackMenuOpened,
    onAddSeries,
    handleConfigTrack,
    editable,
    handleResizeTrack,
    resizeHandles
  }));
  return /* @__PURE__ */ React__default.createElement(DndContext, {
    sensors,
    collisionDetection: closestCenter,
    onDragStart: handleDragStart,
    onDragOver: handleDragOver,
    onDragEnd: () => {
    }
  }, /* @__PURE__ */ React__default.createElement(SortableContext, {
    items: itemIds,
    strategy
  }, /* @__PURE__ */ React__default.createElement("div", {
    className,
    style: {
      height,
      width,
      background: "transparent"
    }
  }, itemElements)));
}
const styles$2 = {
  "horizontal-tiled-plot": "_horizontal-tiled-plot_1bqkg_1"
};
function _classCallCheck$_(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$_(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$_(o.key), o);
  }
}
function _createClass$_(e, r2, t) {
  return r2 && _defineProperties$_(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$_(t) {
  var i = _toPrimitive$_(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$_(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$U(t, o, e) {
  return o = _getPrototypeOf$U(o), _possibleConstructorReturn$U(t, _isNativeReflectConstruct$U() ? Reflect.construct(o, e || [], _getPrototypeOf$U(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$U(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$U(t);
}
function _assertThisInitialized$U(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$U() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$U = function() {
    return !!t;
  })();
}
function _getPrototypeOf$U(t) {
  return _getPrototypeOf$U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$U(t);
}
function _inherits$U(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$U(t, e);
}
function _setPrototypeOf$U(t, e) {
  return _setPrototypeOf$U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$U(t, e);
}
function sourceEvent$1(event) {
  return event?.sourceEvent;
}
let HorizontalTiledPlot = /* @__PURE__ */ (function(_React$Component) {
  function HorizontalTiledPlot2(props) {
    var _this;
    _classCallCheck$_(this, HorizontalTiledPlot2);
    _this = _callSuper$U(this, HorizontalTiledPlot2, [props]);
    _this.brushBehavior = brushX().on("start", _this.brushStarted.bind(_this)).on("brush", _this.brushed.bind(_this)).on("end", _this.brushedEnded.bind(_this));
    _this.state = {
      // Track which track's controls are visible
      trackControlsVisible: null
    };
    return _this;
  }
  _inherits$U(HorizontalTiledPlot2, _React$Component);
  return _createClass$_(HorizontalTiledPlot2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.rangeSelectionTriggered) {
        this.rangeSelectionTriggered = false;
        if (this.rangeSelectionTriggeredEnd && this.props.rangeSelection !== nextProps.rangeSelection) {
          this.moveBrush(nextProps.rangeSelection[0] ? nextProps.rangeSelection[0] : null, true);
        }
        this.rangeSelectionTriggeredEnd = false;
        return this.state !== nextState;
      }
      if (this.props.rangeSelection !== nextProps.rangeSelection) {
        this.moveBrush(nextProps.rangeSelection[0] ? nextProps.rangeSelection[0] : null, nextProps.rangeSelectionEnd);
        return this.state !== nextState;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      } else {
        this.removeBrush();
      }
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "addBrush",
    value: function addBrush() {
      if (!this.brushEl || this.brushElAddedBefore === this.brushEl) {
        return;
      }
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.on(".brush", null);
      }
      this.brushEl.call(this.brushBehavior);
      this.brushElAddedBefore = this.brushEl;
      resetD3BrushStyle(this.brushEl, stylesTrack["track-range-selection-group-brush-selection"]);
    }
  }, {
    key: "brushed",
    value: function brushed(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent$1(event) || !this.props.onRangeSelection || rangeSelectionMoved) return;
      this.rangeSelectionTriggered = true;
      this.props.onRangeSelection(event.selection);
    }
  }, {
    key: "brushStarted",
    value: function brushStarted(event) {
      if (!sourceEvent$1(event) || !event.selection) return;
      this.props.onRangeSelectionStart();
    }
  }, {
    key: "brushedEnded",
    value: function brushedEnded(event) {
      if (!this.props.is1dRangeSelection) return;
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (event.selection && event.sourceEvent && this.props.onRangeSelection && !rangeSelectionMovedEnd) {
        this.rangeSelectionTriggered = true;
        this.rangeSelectionTriggeredEnd = true;
        this.props.onRangeSelectionEnd(event.selection);
      }
      if (!event.selection) {
        this.rangeSelectionTriggered = true;
        this.props.onRangeSelectionReset();
      }
    }
  }, {
    key: "moveBrush",
    value: function moveBrush(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      const relRange = rangeSelection ? [this.props.scale(rangeSelection[0]), this.props.scale(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushEl.transition().call(this.brushBehavior.move, relRange);
      } else {
        this.brushEl.call(this.brushBehavior.move, relRange);
      }
    }
  }, {
    key: "removeBrush",
    value: function removeBrush() {
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.call(this.brushBehavior.move, null);
        this.brushElAddedBefore.on(".brush", null);
        this.brushElAddedBefore = void 0;
        this.props.onRangeSelectionReset();
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const height = this.props.tracks.map((x) => x.height).reduce(sum$1, 0);
      const isBrushable = this.props.tracks.map((track) => IS_TRACK_RANGE_SELECTABLE(track)).reduce(or$1, false);
      const rangeSelectorClass = this.props.isRangeSelectionActive ? stylesTrack["track-range-selection-active"] : stylesTrack["track-range-selection"];
      return /* @__PURE__ */ React__default.createElement("div", {
        className: clsx$2("horizontal-tiled-plot", styles$2["horizontal-tiled-plot"])
      }, isBrushable && /* @__PURE__ */ React__default.createElement("svg", {
        ref: (el2) => {
          this.brushEl = select(el2);
        },
        className: rangeSelectorClass,
        style: {
          height,
          width: this.props.width
        },
        xmlns: "http://www.w3.org/2000/svg"
      }), /* @__PURE__ */ React__default.createElement(ListWrapper, {
        className: clsx$2(styles$3.list, styles$3.stylizedList),
        component: SortableList,
        editable: this.props.editable,
        handleConfigTrack: this.props.handleConfigTrack,
        handleResizeTrack: this.props.handleResizeTrack,
        height,
        helperClass: styles$3.stylizedHelper,
        itemClass: styles$3.stylizedItem,
        itemReactClass: HorizontalItem,
        items: this.props.tracks.map((d) => ({
          handleMouseEnter: () => {
            this.setState({
              trackControlsVisible: d.uid
            });
          },
          handleMouseLeave: () => {
            this.setState({
              trackControlsVisible: null
            });
          },
          trackControlsVisible: d.uid === this.state.trackControlsVisible,
          configMenuVisible: d.uid === this.props.configTrackMenuId,
          uid: d.uid || slugid.nice(),
          width: this.props.width,
          height: trackHeight(d),
          isCollapsed: d.options?.collapsed,
          value: d.value
        })),
        onAddSeries: this.props.onAddSeries,
        onCloseTrack: this.props.onCloseTrack,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onCollapseTrack: this.props.onCollapseTrack,
        onExpandTrack: this.props.onExpandTrack,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        onSortEnd: this.props.handleSortEnd,
        referenceAncestor: this.props.referenceAncestor,
        resizeHandles: this.props.resizeHandles,
        useDragHandle: true,
        width: this.props.width
      }));
    }
  }]);
})(React__default.Component);
HorizontalTiledPlot.propTypes = {
  configTrackMenuId: PropTypes.string,
  editable: PropTypes.bool,
  handleConfigTrack: PropTypes.func,
  handleResizeTrack: PropTypes.func,
  handleSortEnd: PropTypes.func,
  is1dRangeSelection: PropTypes.bool,
  isRangeSelectionActive: PropTypes.bool,
  onAddSeries: PropTypes.func,
  onCloseTrack: PropTypes.func,
  onCollapseTrack: PropTypes.func,
  onExpandTrack: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onRangeSelection: PropTypes.func,
  onRangeSelectionEnd: PropTypes.func,
  onRangeSelectionReset: PropTypes.func,
  onRangeSelectionStart: PropTypes.func,
  rangeSelection: PropTypes.array,
  rangeSelectionEnd: PropTypes.bool,
  referenceAncestor: PropTypes.func,
  resizeHandles: PropTypes.object,
  scale: PropTypes.func,
  tracks: PropTypes.array,
  width: PropTypes.number
};
var pool = {};
var twiddle = {};
var hasRequiredTwiddle;
function requireTwiddle() {
  if (hasRequiredTwiddle) return twiddle;
  hasRequiredTwiddle = 1;
  var INT_BITS = 32;
  twiddle.INT_BITS = INT_BITS;
  twiddle.INT_MAX = 2147483647;
  twiddle.INT_MIN = -1 << INT_BITS - 1;
  twiddle.sign = function(v) {
    return (v > 0) - (v < 0);
  };
  twiddle.abs = function(v) {
    var mask = v >> INT_BITS - 1;
    return (v ^ mask) - mask;
  };
  twiddle.min = function(x, y) {
    return y ^ (x ^ y) & -(x < y);
  };
  twiddle.max = function(x, y) {
    return x ^ (x ^ y) & -(x < y);
  };
  twiddle.isPow2 = function(v) {
    return !(v & v - 1) && !!v;
  };
  twiddle.log2 = function(v) {
    var r2, shift2;
    r2 = (v > 65535) << 4;
    v >>>= r2;
    shift2 = (v > 255) << 3;
    v >>>= shift2;
    r2 |= shift2;
    shift2 = (v > 15) << 2;
    v >>>= shift2;
    r2 |= shift2;
    shift2 = (v > 3) << 1;
    v >>>= shift2;
    r2 |= shift2;
    return r2 | v >> 1;
  };
  twiddle.log10 = function(v) {
    return v >= 1e9 ? 9 : v >= 1e8 ? 8 : v >= 1e7 ? 7 : v >= 1e6 ? 6 : v >= 1e5 ? 5 : v >= 1e4 ? 4 : v >= 1e3 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
  };
  twiddle.popCount = function(v) {
    v = v - (v >>> 1 & 1431655765);
    v = (v & 858993459) + (v >>> 2 & 858993459);
    return (v + (v >>> 4) & 252645135) * 16843009 >>> 24;
  };
  function countTrailingZeros(v) {
    var c = 32;
    v &= -v;
    if (v) c--;
    if (v & 65535) c -= 16;
    if (v & 16711935) c -= 8;
    if (v & 252645135) c -= 4;
    if (v & 858993459) c -= 2;
    if (v & 1431655765) c -= 1;
    return c;
  }
  twiddle.countTrailingZeros = countTrailingZeros;
  twiddle.nextPow2 = function(v) {
    v += v === 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
  };
  twiddle.prevPow2 = function(v) {
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v - (v >>> 1);
  };
  twiddle.parity = function(v) {
    v ^= v >>> 16;
    v ^= v >>> 8;
    v ^= v >>> 4;
    v &= 15;
    return 27030 >>> v & 1;
  };
  var REVERSE_TABLE = new Array(256);
  (function(tab) {
    for (var i = 0; i < 256; ++i) {
      var v = i, r2 = i, s = 7;
      for (v >>>= 1; v; v >>>= 1) {
        r2 <<= 1;
        r2 |= v & 1;
        --s;
      }
      tab[i] = r2 << s & 255;
    }
  })(REVERSE_TABLE);
  twiddle.reverse = function(v) {
    return REVERSE_TABLE[v & 255] << 24 | REVERSE_TABLE[v >>> 8 & 255] << 16 | REVERSE_TABLE[v >>> 16 & 255] << 8 | REVERSE_TABLE[v >>> 24 & 255];
  };
  twiddle.interleave2 = function(x, y) {
    x &= 65535;
    x = (x | x << 8) & 16711935;
    x = (x | x << 4) & 252645135;
    x = (x | x << 2) & 858993459;
    x = (x | x << 1) & 1431655765;
    y &= 65535;
    y = (y | y << 8) & 16711935;
    y = (y | y << 4) & 252645135;
    y = (y | y << 2) & 858993459;
    y = (y | y << 1) & 1431655765;
    return x | y << 1;
  };
  twiddle.deinterleave2 = function(v, n) {
    v = v >>> n & 1431655765;
    v = (v | v >>> 1) & 858993459;
    v = (v | v >>> 2) & 252645135;
    v = (v | v >>> 4) & 16711935;
    v = (v | v >>> 16) & 65535;
    return v << 16 >> 16;
  };
  twiddle.interleave3 = function(x, y, z) {
    x &= 1023;
    x = (x | x << 16) & 4278190335;
    x = (x | x << 8) & 251719695;
    x = (x | x << 4) & 3272356035;
    x = (x | x << 2) & 1227133513;
    y &= 1023;
    y = (y | y << 16) & 4278190335;
    y = (y | y << 8) & 251719695;
    y = (y | y << 4) & 3272356035;
    y = (y | y << 2) & 1227133513;
    x |= y << 1;
    z &= 1023;
    z = (z | z << 16) & 4278190335;
    z = (z | z << 8) & 251719695;
    z = (z | z << 4) & 3272356035;
    z = (z | z << 2) & 1227133513;
    return x | z << 2;
  };
  twiddle.deinterleave3 = function(v, n) {
    v = v >>> n & 1227133513;
    v = (v | v >>> 2) & 3272356035;
    v = (v | v >>> 4) & 251719695;
    v = (v | v >>> 8) & 4278190335;
    v = (v | v >>> 16) & 1023;
    return v << 22 >> 22;
  };
  twiddle.nextCombination = function(v) {
    var t = v | v - 1;
    return t + 1 | (~t & -~t) - 1 >>> countTrailingZeros(v) + 1;
  };
  return twiddle;
}
var dup;
var hasRequiredDup;
function requireDup() {
  if (hasRequiredDup) return dup;
  hasRequiredDup = 1;
  function dupe_array(count2, value, i) {
    var c = count2[i] | 0;
    if (c <= 0) {
      return [];
    }
    var result = new Array(c), j;
    if (i === count2.length - 1) {
      for (j = 0; j < c; ++j) {
        result[j] = value;
      }
    } else {
      for (j = 0; j < c; ++j) {
        result[j] = dupe_array(count2, value, i + 1);
      }
    }
    return result;
  }
  function dupe_number(count2, value) {
    var result, i;
    result = new Array(count2);
    for (i = 0; i < count2; ++i) {
      result[i] = value;
    }
    return result;
  }
  function dupe(count2, value) {
    if (typeof value === "undefined") {
      value = 0;
    }
    switch (typeof count2) {
      case "number":
        if (count2 > 0) {
          return dupe_number(count2 | 0, value);
        }
        break;
      case "object":
        if (typeof count2.length === "number") {
          return dupe_array(count2, value, 0);
        }
        break;
    }
    return [];
  }
  dup = dupe;
  return dup;
}
var buffer = {};
var base64Js = {};
var hasRequiredBase64Js;
function requireBase64Js() {
  if (hasRequiredBase64Js) return base64Js;
  hasRequiredBase64Js = 1;
  base64Js.byteLength = byteLength;
  base64Js.toByteArray = toByteArray;
  base64Js.fromByteArray = fromByteArray;
  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
  var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }
  revLookup["-".charCodeAt(0)] = 62;
  revLookup["_".charCodeAt(0)] = 63;
  function getLens(b64) {
    var len2 = b64.length;
    if (len2 % 4 > 0) {
      throw new Error("Invalid string. Length must be a multiple of 4");
    }
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len2;
    var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
    return [validLen, placeHoldersLen];
  }
  function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }
  function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
  }
  function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i2;
    for (i2 = 0; i2 < len2; i2 += 4) {
      tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
      arr[curByte++] = tmp >> 16 & 255;
      arr[curByte++] = tmp >> 8 & 255;
      arr[curByte++] = tmp & 255;
    }
    if (placeHoldersLen === 2) {
      tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
      arr[curByte++] = tmp & 255;
    }
    if (placeHoldersLen === 1) {
      tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
      arr[curByte++] = tmp >> 8 & 255;
      arr[curByte++] = tmp & 255;
    }
    return arr;
  }
  function tripletToBase64(num2) {
    return lookup[num2 >> 18 & 63] + lookup[num2 >> 12 & 63] + lookup[num2 >> 6 & 63] + lookup[num2 & 63];
  }
  function encodeChunk(uint8, start2, end2) {
    var tmp;
    var output = [];
    for (var i2 = start2; i2 < end2; i2 += 3) {
      tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
      output.push(tripletToBase64(tmp));
    }
    return output.join("");
  }
  function fromByteArray(uint8) {
    var tmp;
    var len2 = uint8.length;
    var extraBytes = len2 % 3;
    var parts = [];
    var maxChunkLength = 16383;
    for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
      parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
    }
    if (extraBytes === 1) {
      tmp = uint8[len2 - 1];
      parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
    } else if (extraBytes === 2) {
      tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
      parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
    }
    return parts.join("");
  }
  return base64Js;
}
var ieee754 = {};
var hasRequiredIeee754;
function requireIeee754() {
  if (hasRequiredIeee754) return ieee754;
  hasRequiredIeee754 = 1;
  ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer2[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer2[offset + i], i += d, nBits -= 8) {
    }
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer2[offset + i], i += d, nBits -= 8) {
    }
    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : (s ? -1 : 1) * Infinity;
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
  };
  ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }
      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }
    for (; mLen >= 8; buffer2[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
    }
    e = e << mLen | m;
    eLen += mLen;
    for (; eLen > 0; buffer2[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
    }
    buffer2[offset + i - d] |= s * 128;
  };
  return ieee754;
}
var hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  (function(exports2) {
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r2) {
      for (var t = 0; t < r2.length; t++) {
        var o = r2[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r2, t) {
      return r2 && _defineProperties2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _toPropertyKey2(t) {
      var i = _toPrimitive2(t, "string");
      return "symbol" == typeof i ? i : i + "";
    }
    function _toPrimitive2(t, r2) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r2);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(t);
    }
    function _callSuper2(t, o, e) {
      return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
    }
    function _possibleConstructorReturn2(t, e) {
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return _assertThisInitialized2(t);
    }
    function _assertThisInitialized2(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function _isNativeReflectConstruct2() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch (t4) {
      }
      return (_isNativeReflectConstruct2 = function() {
        return !!t;
      })();
    }
    function _getPrototypeOf2(t) {
      return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
        return t4.__proto__ || Object.getPrototypeOf(t4);
      }, _getPrototypeOf2(t);
    }
    function _inherits2(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
    }
    function _setPrototypeOf2(t, e) {
      return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
        return t4.__proto__ = e3, t4;
      }, _setPrototypeOf2(t, e);
    }
    const base64 = requireBase64Js();
    const ieee7542 = requireIeee754();
    const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports2.Buffer = Buffer2;
    exports2.SlowBuffer = SlowBuffer;
    exports2.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 2147483647;
    exports2.kMaxLength = K_MAX_LENGTH;
    Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto2 = {
          foo: function() {
            return 42;
          }
        };
        Object.setPrototypeOf(proto2, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto2);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer2.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this)) return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer2.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this)) return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length2) {
      if (length2 > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length2 + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length2);
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function Buffer2(arg, encodingOrOffset, length2) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError('The "string" argument must be of type string. Received type number');
        }
        return allocUnsafe2(arg);
      }
      return from(arg, encodingOrOffset, length2);
    }
    Buffer2.poolSize = 8192;
    function from(value, encodingOrOffset, length2) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length2);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length2);
      }
      if (typeof value === "number") {
        throw new TypeError('The "value" argument must not be of type number. Received type number');
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer2.from(valueOf, encodingOrOffset, length2);
      }
      const b = fromObject(value);
      if (b) return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length2);
      }
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    Buffer2.from = function(value, encodingOrOffset, length2) {
      return from(value, encodingOrOffset, length2);
    };
    Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer2, Uint8Array);
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
      }
    }
    function alloc(size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
      }
      return createBuffer(size);
    }
    Buffer2.alloc = function(size, fill, encoding) {
      return alloc(size, fill, encoding);
    };
    function allocUnsafe2(size) {
      assertSize(size);
      return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer2.allocUnsafe = function(size) {
      return allocUnsafe2(size);
    };
    Buffer2.allocUnsafeSlow = function(size) {
      return allocUnsafe2(size);
    };
    function fromString(string, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length2 = byteLength(string, encoding) | 0;
      let buf = createBuffer(length2);
      const actual = buf.write(string, encoding);
      if (actual !== length2) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array2) {
      const length2 = array2.length < 0 ? 0 : checked(array2.length) | 0;
      const buf = createBuffer(length2);
      for (let i = 0; i < length2; i += 1) {
        buf[i] = array2[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy2 = new Uint8Array(arrayView);
        return fromArrayBuffer(copy2.buffer, copy2.byteOffset, copy2.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array2, byteOffset, length2) {
      if (byteOffset < 0 || array2.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array2.byteLength < byteOffset + (length2 || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length2 === void 0) {
        buf = new Uint8Array(array2);
      } else if (length2 === void 0) {
        buf = new Uint8Array(array2, byteOffset);
      } else {
        buf = new Uint8Array(array2, byteOffset, length2);
      }
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer2.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length2) {
      if (length2 >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length2 | 0;
    }
    function SlowBuffer(length2) {
      if (+length2 != length2) {
        length2 = 0;
      }
      return Buffer2.alloc(+length2);
    }
    Buffer2.isBuffer = function isBuffer2(b) {
      return b != null && b._isBuffer === true && b !== Buffer2.prototype;
    };
    Buffer2.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array)) a = Buffer2.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array)) b = Buffer2.from(b, b.offset, b.byteLength);
      if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
        throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
      }
      if (a === b) return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    Buffer2.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer2.concat = function concat(list2, length2) {
      if (!Array.isArray(list2)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list2.length === 0) {
        return Buffer2.alloc(0);
      }
      let i;
      if (length2 === void 0) {
        length2 = 0;
        for (i = 0; i < list2.length; ++i) {
          length2 += list2[i].length;
        }
      }
      const buffer2 = Buffer2.allocUnsafe(length2);
      let pos = 0;
      for (i = 0; i < list2.length; ++i) {
        let buf = list2[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer2.length) {
            if (!Buffer2.isBuffer(buf)) buf = Buffer2.from(buf);
            buf.copy(buffer2, pos);
          } else {
            Uint8Array.prototype.set.call(buffer2, buf, pos);
          }
        } else if (!Buffer2.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer2, pos);
        }
        pos += buf.length;
      }
      return buffer2;
    };
    function byteLength(string, encoding) {
      if (Buffer2.isBuffer(string)) {
        return string.length;
      }
      if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
        return string.byteLength;
      }
      if (typeof string !== "string") {
        throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
      }
      const len = string.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0) return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.byteLength = byteLength;
    function slowToString(encoding, start2, end2) {
      let loweredCase = false;
      if (start2 === void 0 || start2 < 0) {
        start2 = 0;
      }
      if (start2 > this.length) {
        return "";
      }
      if (end2 === void 0 || end2 > this.length) {
        end2 = this.length;
      }
      if (end2 <= 0) {
        return "";
      }
      end2 >>>= 0;
      start2 >>>= 0;
      if (end2 <= start2) {
        return "";
      }
      if (!encoding) encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start2, end2);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start2, end2);
          case "ascii":
            return asciiSlice(this, start2, end2);
          case "latin1":
          case "binary":
            return latin1Slice(this, start2, end2);
          case "base64":
            return base64Slice(this, start2, end2);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start2, end2);
          default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.prototype._isBuffer = true;
    function swap2(b, n, m) {
      const i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer2.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap2(this, i, i + 1);
      }
      return this;
    };
    Buffer2.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap2(this, i, i + 3);
        swap2(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer2.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap2(this, i, i + 7);
        swap2(this, i + 1, i + 6);
        swap2(this, i + 2, i + 5);
        swap2(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer2.prototype.toString = function toString3() {
      const length2 = this.length;
      if (length2 === 0) return "";
      if (arguments.length === 0) return utf8Slice(this, 0, length2);
      return slowToString.apply(this, arguments);
    };
    Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
    Buffer2.prototype.equals = function equals2(b) {
      if (!Buffer2.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
      if (this === b) return true;
      return Buffer2.compare(this, b) === 0;
    };
    Buffer2.prototype.inspect = function inspect() {
      let str = "";
      const max2 = exports2.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max2) str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
    }
    Buffer2.prototype.compare = function compare(target2, start2, end2, thisStart, thisEnd) {
      if (isInstance(target2, Uint8Array)) {
        target2 = Buffer2.from(target2, target2.offset, target2.byteLength);
      }
      if (!Buffer2.isBuffer(target2)) {
        throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target2);
      }
      if (start2 === void 0) {
        start2 = 0;
      }
      if (end2 === void 0) {
        end2 = target2 ? target2.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start2 < 0 || end2 > target2.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start2 >= end2) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start2 >= end2) {
        return 1;
      }
      start2 >>>= 0;
      end2 >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target2) return 0;
      let x = thisEnd - thisStart;
      let y = end2 - start2;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target2.slice(start2, end2);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
      if (buffer2.length === 0) return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer2.length - 1;
      }
      if (byteOffset < 0) byteOffset = buffer2.length + byteOffset;
      if (byteOffset >= buffer2.length) {
        if (dir) return -1;
        else byteOffset = buffer2.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
      }
      if (typeof val === "string") {
        val = Buffer2.from(val, encoding);
      }
      if (Buffer2.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer2, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found) return i;
        }
      }
      return -1;
    }
    Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length2) {
      offset = Number(offset) || 0;
      const remaining = buf.length - offset;
      if (!length2) {
        length2 = remaining;
      } else {
        length2 = Number(length2);
        if (length2 > remaining) {
          length2 = remaining;
        }
      }
      const strLen = string.length;
      if (length2 > strLen / 2) {
        length2 = strLen / 2;
      }
      let i;
      for (i = 0; i < length2; ++i) {
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string, offset, length2) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length2);
    }
    function asciiWrite(buf, string, offset, length2) {
      return blitBuffer(asciiToBytes(string), buf, offset, length2);
    }
    function base64Write(buf, string, offset, length2) {
      return blitBuffer(base64ToBytes(string), buf, offset, length2);
    }
    function ucs2Write(buf, string, offset, length2) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length2);
    }
    Buffer2.prototype.write = function write(string, offset, length2, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length2 = this.length;
        offset = 0;
      } else if (length2 === void 0 && typeof offset === "string") {
        encoding = offset;
        length2 = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length2)) {
          length2 = length2 >>> 0;
          if (encoding === void 0) encoding = "utf8";
        } else {
          encoding = length2;
          length2 = void 0;
        }
      } else {
        throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      }
      const remaining = this.length - offset;
      if (length2 === void 0 || length2 > remaining) length2 = remaining;
      if (string.length > 0 && (length2 < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding) encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string, offset, length2);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string, offset, length2);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string, offset, length2);
          case "base64":
            return base64Write(this, string, offset, length2);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string, offset, length2);
          default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer2.prototype.toJSON = function toJSON2() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start2, end2) {
      if (start2 === 0 && end2 === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start2, end2));
      }
    }
    function utf8Slice(buf, start2, end2) {
      end2 = Math.min(buf.length, end2);
      const res = [];
      let i = start2;
      while (i < end2) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end2) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    const MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
      }
      return res;
    }
    function asciiSlice(buf, start2, end2) {
      let ret = "";
      end2 = Math.min(buf.length, end2);
      for (let i = start2; i < end2; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start2, end2) {
      let ret = "";
      end2 = Math.min(buf.length, end2);
      for (let i = start2; i < end2; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start2, end2) {
      const len = buf.length;
      if (!start2 || start2 < 0) start2 = 0;
      if (!end2 || end2 < 0 || end2 > len) end2 = len;
      let out = "";
      for (let i = start2; i < end2; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start2, end2) {
      const bytes = buf.slice(start2, end2);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer2.prototype.slice = function slice2(start2, end2) {
      const len = this.length;
      start2 = ~~start2;
      end2 = end2 === void 0 ? len : ~~end2;
      if (start2 < 0) {
        start2 += len;
        if (start2 < 0) start2 = 0;
      } else if (start2 > len) {
        start2 = len;
      }
      if (end2 < 0) {
        end2 += len;
        if (end2 < 0) end2 = 0;
      } else if (end2 > len) {
        end2 = len;
      }
      if (end2 < start2) end2 = start2;
      const newBuf = this.subarray(start2, end2);
      Object.setPrototypeOf(newBuf, Buffer2.prototype);
      return newBuf;
    };
    function checkOffset(offset, ext, length2) {
      if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
      if (offset + ext > length2) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset, byteLength2, this.length);
      }
      let val = this[offset + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset + --byteLength2] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
      const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      mul *= 128;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) checkOffset(offset, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
      }
      mul *= 128;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128)) return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 2, this.length);
      const val = this[offset] | this[offset + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 2, this.length);
      const val = this[offset + 1] | this[offset] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = (first << 24) + // Overflow
      this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
    });
    Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 4, this.length);
      return ieee7542.read(this, offset, true, 23, 4);
    };
    Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 4, this.length);
      return ieee7542.read(this, offset, false, 23, 4);
    };
    Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 8, this.length);
      return ieee7542.read(this, offset, true, 52, 8);
    };
    Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert) checkOffset(offset, 8, this.length);
      return ieee7542.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max2, min2) {
      if (!Buffer2.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max2 || value < min2) throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min2, max2) {
      checkIntBI(value, min2, max2, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min2, max2) {
      checkIntBI(value, min2, max2, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset + 7] = lo;
      lo = lo >> 8;
      buf[offset + 6] = lo;
      lo = lo >> 8;
      buf[offset + 5] = lo;
      lo = lo >> 8;
      buf[offset + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset + 3] = hi;
      hi = hi >> 8;
      buf[offset + 2] = hi;
      hi = hi >> 8;
      buf[offset + 1] = hi;
      hi = hi >> 8;
      buf[offset] = hi;
      return offset + 8;
    }
    Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub2 = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value < 0 && sub2 === 0 && this[offset + i - 1] !== 0) {
          sub2 = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub2 & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub2 = 0;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub2 === 0 && this[offset + i + 1] !== 0) {
          sub2 = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub2 & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
      if (value < 0) value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
      return offset + 4;
    };
    Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0) value = 4294967295 + value + 1;
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max2, min2) {
      if (offset + ext > buf.length) throw new RangeError("Index out of range");
      if (offset < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4);
      }
      ieee7542.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8);
      }
      ieee7542.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer2.prototype.copy = function copy2(target2, targetStart, start2, end2) {
      if (!Buffer2.isBuffer(target2)) throw new TypeError("argument should be a Buffer");
      if (!start2) start2 = 0;
      if (!end2 && end2 !== 0) end2 = this.length;
      if (targetStart >= target2.length) targetStart = target2.length;
      if (!targetStart) targetStart = 0;
      if (end2 > 0 && end2 < start2) end2 = start2;
      if (end2 === start2) return 0;
      if (target2.length === 0 || this.length === 0) return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start2 < 0 || start2 >= this.length) throw new RangeError("Index out of range");
      if (end2 < 0) throw new RangeError("sourceEnd out of bounds");
      if (end2 > this.length) end2 = this.length;
      if (target2.length - targetStart < end2 - start2) {
        end2 = target2.length - targetStart + start2;
      }
      const len = end2 - start2;
      if (this === target2 && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start2, end2);
      } else {
        Uint8Array.prototype.set.call(target2, this.subarray(start2, end2), targetStart);
      }
      return len;
    };
    Buffer2.prototype.fill = function fill(val, start2, end2, encoding) {
      if (typeof val === "string") {
        if (typeof start2 === "string") {
          encoding = start2;
          start2 = 0;
          end2 = this.length;
        } else if (typeof end2 === "string") {
          encoding = end2;
          end2 = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code = val.charCodeAt(0);
          if (encoding === "utf8" && code < 128 || encoding === "latin1") {
            val = code;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start2 < 0 || this.length < start2 || this.length < end2) {
        throw new RangeError("Out of range index");
      }
      if (end2 <= start2) {
        return this;
      }
      start2 = start2 >>> 0;
      end2 = end2 === void 0 ? this.length : end2 >>> 0;
      if (!val) val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start2; i < end2; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end2 - start2; ++i) {
          this[i + start2] = bytes[i % len];
        }
      }
      return this;
    };
    const errors = {};
    function E2(sym, getMessage, Base) {
      errors[sym] = /* @__PURE__ */ (function(_Base) {
        function NodeError() {
          var _this;
          _classCallCheck2(this, NodeError);
          _this = _callSuper2(this, NodeError);
          Object.defineProperty(_this, "message", {
            value: getMessage.apply(_this, arguments),
            writable: true,
            configurable: true
          });
          _this.name = `${_this.name} [${sym}]`;
          _this.stack;
          delete _this.name;
          return _this;
        }
        _inherits2(NodeError, _Base);
        return _createClass2(NodeError, [{
          key: "code",
          get: function() {
            return sym;
          },
          set: function(value) {
            Object.defineProperty(this, "code", {
              configurable: true,
              enumerable: true,
              value,
              writable: true
            });
          }
        }, {
          key: "toString",
          value: function toString3() {
            return `${this.name} [${sym}]: ${this.message}`;
          }
        }]);
      })(Base);
    }
    E2("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
      if (name) {
        return `${name} is outside of buffer bounds`;
      }
      return "Attempt to access memory outside buffer bounds";
    }, RangeError);
    E2("ERR_INVALID_ARG_TYPE", function(name, actual) {
      return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E2("ERR_OUT_OF_RANGE", function(str, range2, input) {
      let msg = `The value of "${str}" is out of range.`;
      let received = input;
      if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
        received = addNumericalSeparator(String(input));
      } else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
          received = addNumericalSeparator(received);
        }
        received += "n";
      }
      msg += ` It must be ${range2}. Received ${received}`;
      return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start2 = val[0] === "-" ? 1 : 0;
      for (; i >= start2 + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset, byteLength2) {
      validateNumber(offset, "offset");
      if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
        boundsError(offset, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value, min2, max2, buf, offset, byteLength2) {
      if (value > max2 || value < min2) {
        const n = typeof min2 === "bigint" ? "n" : "";
        let range2;
        {
          if (min2 === 0 || min2 === BigInt(0)) {
            range2 = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
          } else {
            range2 = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
          }
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
      }
      checkBounds(buf, offset, byteLength2);
    }
    function validateNumber(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length2, type2) {
      if (Math.floor(value) !== value) {
        validateNumber(value, type2);
        throw new errors.ERR_OUT_OF_RANGE("offset", "an integer", value);
      }
      if (length2 < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE("offset", `>= ${0} and <= ${length2}`, value);
    }
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2) return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string, units) {
      units = units || Infinity;
      let codePoint;
      const length2 = string.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length2; ++i) {
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1) bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length2) {
              if ((units -= 3) > -1) bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1) bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1) bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0) break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0) break;
          bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0) break;
          bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0) break;
          bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src2, dst, offset, length2) {
      let i;
      for (i = 0; i < length2; ++i) {
        if (i + offset >= dst.length || i >= src2.length) break;
        dst[i + offset] = src2[i];
      }
      return i;
    }
    function isInstance(obj, type2) {
      return obj instanceof type2 || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type2.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    const hexSliceLookupTable = (function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    })();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  })(buffer);
  return buffer;
}
var hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool;
  hasRequiredPool = 1;
  var bits = requireTwiddle();
  var dup2 = requireDup();
  var Buffer2 = requireBuffer().Buffer;
  if (!globalThis.__TYPEDARRAY_POOL) {
    globalThis.__TYPEDARRAY_POOL = {
      UINT8: dup2([32, 0]),
      UINT16: dup2([32, 0]),
      UINT32: dup2([32, 0]),
      BIGUINT64: dup2([32, 0]),
      INT8: dup2([32, 0]),
      INT16: dup2([32, 0]),
      INT32: dup2([32, 0]),
      BIGINT64: dup2([32, 0]),
      FLOAT: dup2([32, 0]),
      DOUBLE: dup2([32, 0]),
      DATA: dup2([32, 0]),
      UINT8C: dup2([32, 0]),
      BUFFER: dup2([32, 0])
    };
  }
  var hasUint8C = typeof Uint8ClampedArray !== "undefined";
  var hasBigUint64 = typeof BigUint64Array !== "undefined";
  var hasBigInt64 = typeof BigInt64Array !== "undefined";
  var POOL = globalThis.__TYPEDARRAY_POOL;
  if (!POOL.UINT8C) {
    POOL.UINT8C = dup2([32, 0]);
  }
  if (!POOL.BIGUINT64) {
    POOL.BIGUINT64 = dup2([32, 0]);
  }
  if (!POOL.BIGINT64) {
    POOL.BIGINT64 = dup2([32, 0]);
  }
  if (!POOL.BUFFER) {
    POOL.BUFFER = dup2([32, 0]);
  }
  var DATA = POOL.DATA, BUFFER = POOL.BUFFER;
  pool.free = function free(array2) {
    if (Buffer2.isBuffer(array2)) {
      BUFFER[bits.log2(array2.length)].push(array2);
    } else {
      if (Object.prototype.toString.call(array2) !== "[object ArrayBuffer]") {
        array2 = array2.buffer;
      }
      if (!array2) {
        return;
      }
      var n = array2.length || array2.byteLength;
      var log_n = bits.log2(n) | 0;
      DATA[log_n].push(array2);
    }
  };
  function freeArrayBuffer(buffer2) {
    if (!buffer2) {
      return;
    }
    var n = buffer2.length || buffer2.byteLength;
    var log_n = bits.log2(n);
    DATA[log_n].push(buffer2);
  }
  function freeTypedArray(array2) {
    freeArrayBuffer(array2.buffer);
  }
  pool.freeUint8 = pool.freeUint16 = pool.freeUint32 = pool.freeBigUint64 = pool.freeInt8 = pool.freeInt16 = pool.freeInt32 = pool.freeBigInt64 = pool.freeFloat32 = pool.freeFloat = pool.freeFloat64 = pool.freeDouble = pool.freeUint8Clamped = pool.freeDataView = freeTypedArray;
  pool.freeArrayBuffer = freeArrayBuffer;
  pool.freeBuffer = function freeBuffer(array2) {
    BUFFER[bits.log2(array2.length)].push(array2);
  };
  pool.malloc = function malloc(n, dtype) {
    if (dtype === void 0 || dtype === "arraybuffer") {
      return mallocArrayBuffer(n);
    } else {
      switch (dtype) {
        case "uint8":
          return mallocUint8(n);
        case "uint16":
          return mallocUint16(n);
        case "uint32":
          return mallocUint32(n);
        case "int8":
          return mallocInt8(n);
        case "int16":
          return mallocInt16(n);
        case "int32":
          return mallocInt32(n);
        case "float":
        case "float32":
          return mallocFloat(n);
        case "double":
        case "float64":
          return mallocDouble(n);
        case "uint8_clamped":
          return mallocUint8Clamped(n);
        case "bigint64":
          return mallocBigInt64(n);
        case "biguint64":
          return mallocBigUint64(n);
        case "buffer":
          return mallocBuffer(n);
        case "data":
        case "dataview":
          return mallocDataView(n);
        default:
          return null;
      }
    }
    return null;
  };
  function mallocArrayBuffer(n) {
    var n = bits.nextPow2(n);
    var log_n = bits.log2(n);
    var d = DATA[log_n];
    if (d.length > 0) {
      return d.pop();
    }
    return new ArrayBuffer(n);
  }
  pool.mallocArrayBuffer = mallocArrayBuffer;
  function mallocUint8(n) {
    return new Uint8Array(mallocArrayBuffer(n), 0, n);
  }
  pool.mallocUint8 = mallocUint8;
  function mallocUint16(n) {
    return new Uint16Array(mallocArrayBuffer(2 * n), 0, n);
  }
  pool.mallocUint16 = mallocUint16;
  function mallocUint32(n) {
    return new Uint32Array(mallocArrayBuffer(4 * n), 0, n);
  }
  pool.mallocUint32 = mallocUint32;
  function mallocInt8(n) {
    return new Int8Array(mallocArrayBuffer(n), 0, n);
  }
  pool.mallocInt8 = mallocInt8;
  function mallocInt16(n) {
    return new Int16Array(mallocArrayBuffer(2 * n), 0, n);
  }
  pool.mallocInt16 = mallocInt16;
  function mallocInt32(n) {
    return new Int32Array(mallocArrayBuffer(4 * n), 0, n);
  }
  pool.mallocInt32 = mallocInt32;
  function mallocFloat(n) {
    return new Float32Array(mallocArrayBuffer(4 * n), 0, n);
  }
  pool.mallocFloat32 = pool.mallocFloat = mallocFloat;
  function mallocDouble(n) {
    return new Float64Array(mallocArrayBuffer(8 * n), 0, n);
  }
  pool.mallocFloat64 = pool.mallocDouble = mallocDouble;
  function mallocUint8Clamped(n) {
    if (hasUint8C) {
      return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n);
    } else {
      return mallocUint8(n);
    }
  }
  pool.mallocUint8Clamped = mallocUint8Clamped;
  function mallocBigUint64(n) {
    if (hasBigUint64) {
      return new BigUint64Array(mallocArrayBuffer(8 * n), 0, n);
    } else {
      return null;
    }
  }
  pool.mallocBigUint64 = mallocBigUint64;
  function mallocBigInt64(n) {
    if (hasBigInt64) {
      return new BigInt64Array(mallocArrayBuffer(8 * n), 0, n);
    } else {
      return null;
    }
  }
  pool.mallocBigInt64 = mallocBigInt64;
  function mallocDataView(n) {
    return new DataView(mallocArrayBuffer(n), 0, n);
  }
  pool.mallocDataView = mallocDataView;
  function mallocBuffer(n) {
    n = bits.nextPow2(n);
    var log_n = bits.log2(n);
    var cache2 = BUFFER[log_n];
    if (cache2.length > 0) {
      return cache2.pop();
    }
    return new Buffer2(n);
  }
  pool.mallocBuffer = mallocBuffer;
  pool.clearCache = function clearCache() {
    for (var i = 0; i < 32; ++i) {
      POOL.UINT8[i].length = 0;
      POOL.UINT16[i].length = 0;
      POOL.UINT32[i].length = 0;
      POOL.INT8[i].length = 0;
      POOL.INT16[i].length = 0;
      POOL.INT32[i].length = 0;
      POOL.FLOAT[i].length = 0;
      POOL.DOUBLE[i].length = 0;
      POOL.BIGUINT64[i].length = 0;
      POOL.BIGINT64[i].length = 0;
      POOL.UINT8C[i].length = 0;
      DATA[i].length = 0;
      BUFFER[i].length = 0;
    }
  };
  return pool;
}
var sort;
var hasRequiredSort;
function requireSort() {
  if (hasRequiredSort) return sort;
  hasRequiredSort = 1;
  sort = wrapper;
  var INSERT_SORT_CUTOFF = 32;
  function wrapper(data2, n0) {
    if (n0 <= 4 * INSERT_SORT_CUTOFF) {
      insertionSort(0, n0 - 1, data2);
    } else {
      quickSort(0, n0 - 1, data2);
    }
  }
  function insertionSort(left2, right2, data2) {
    var ptr = 2 * (left2 + 1);
    for (var i = left2 + 1; i <= right2; ++i) {
      var a = data2[ptr++];
      var b = data2[ptr++];
      var j = i;
      var jptr = ptr - 2;
      while (j-- > left2) {
        var x = data2[jptr - 2];
        var y = data2[jptr - 1];
        if (x < a) {
          break;
        } else if (x === a && y < b) {
          break;
        }
        data2[jptr] = x;
        data2[jptr + 1] = y;
        jptr -= 2;
      }
      data2[jptr] = a;
      data2[jptr + 1] = b;
    }
  }
  function swap2(i, j, data2) {
    i *= 2;
    j *= 2;
    var x = data2[i];
    var y = data2[i + 1];
    data2[i] = data2[j];
    data2[i + 1] = data2[j + 1];
    data2[j] = x;
    data2[j + 1] = y;
  }
  function move(i, j, data2) {
    i *= 2;
    j *= 2;
    data2[i] = data2[j];
    data2[i + 1] = data2[j + 1];
  }
  function rotate(i, j, k, data2) {
    i *= 2;
    j *= 2;
    k *= 2;
    var x = data2[i];
    var y = data2[i + 1];
    data2[i] = data2[j];
    data2[i + 1] = data2[j + 1];
    data2[j] = data2[k];
    data2[j + 1] = data2[k + 1];
    data2[k] = x;
    data2[k + 1] = y;
  }
  function shufflePivot(i, j, px, py, data2) {
    i *= 2;
    j *= 2;
    data2[i] = data2[j];
    data2[j] = px;
    data2[i + 1] = data2[j + 1];
    data2[j + 1] = py;
  }
  function compare(i, j, data2) {
    i *= 2;
    j *= 2;
    var x = data2[i], y = data2[j];
    if (x < y) {
      return false;
    } else if (x === y) {
      return data2[i + 1] > data2[j + 1];
    }
    return true;
  }
  function comparePivot(i, y, b, data2) {
    i *= 2;
    var x = data2[i];
    if (x < y) {
      return true;
    } else if (x === y) {
      return data2[i + 1] < b;
    }
    return false;
  }
  function quickSort(left2, right2, data2) {
    var sixth = (right2 - left2 + 1) / 6 | 0, index1 = left2 + sixth, index5 = right2 - sixth, index3 = left2 + right2 >> 1, index2 = index3 - sixth, index4 = index3 + sixth, el1 = index1, el2 = index2, el3 = index3, el4 = index4, el5 = index5, less = left2 + 1, great = right2 - 1, tmp = 0;
    if (compare(el1, el2, data2)) {
      tmp = el1;
      el1 = el2;
      el2 = tmp;
    }
    if (compare(el4, el5, data2)) {
      tmp = el4;
      el4 = el5;
      el5 = tmp;
    }
    if (compare(el1, el3, data2)) {
      tmp = el1;
      el1 = el3;
      el3 = tmp;
    }
    if (compare(el2, el3, data2)) {
      tmp = el2;
      el2 = el3;
      el3 = tmp;
    }
    if (compare(el1, el4, data2)) {
      tmp = el1;
      el1 = el4;
      el4 = tmp;
    }
    if (compare(el3, el4, data2)) {
      tmp = el3;
      el3 = el4;
      el4 = tmp;
    }
    if (compare(el2, el5, data2)) {
      tmp = el2;
      el2 = el5;
      el5 = tmp;
    }
    if (compare(el2, el3, data2)) {
      tmp = el2;
      el2 = el3;
      el3 = tmp;
    }
    if (compare(el4, el5, data2)) {
      tmp = el4;
      el4 = el5;
      el5 = tmp;
    }
    var pivot1X = data2[2 * el2];
    var pivot1Y = data2[2 * el2 + 1];
    var pivot2X = data2[2 * el4];
    var pivot2Y = data2[2 * el4 + 1];
    var ptr0 = 2 * el1;
    var ptr2 = 2 * el3;
    var ptr4 = 2 * el5;
    var ptr5 = 2 * index1;
    var ptr6 = 2 * index3;
    var ptr7 = 2 * index5;
    for (var i1 = 0; i1 < 2; ++i1) {
      var x = data2[ptr0 + i1];
      var y = data2[ptr2 + i1];
      var z = data2[ptr4 + i1];
      data2[ptr5 + i1] = x;
      data2[ptr6 + i1] = y;
      data2[ptr7 + i1] = z;
    }
    move(index2, left2, data2);
    move(index4, right2, data2);
    for (var k = less; k <= great; ++k) {
      if (comparePivot(k, pivot1X, pivot1Y, data2)) {
        if (k !== less) {
          swap2(k, less, data2);
        }
        ++less;
      } else {
        if (!comparePivot(k, pivot2X, pivot2Y, data2)) {
          while (true) {
            if (!comparePivot(great, pivot2X, pivot2Y, data2)) {
              if (--great < k) {
                break;
              }
              continue;
            } else {
              if (comparePivot(great, pivot1X, pivot1Y, data2)) {
                rotate(k, less, great, data2);
                ++less;
                --great;
              } else {
                swap2(k, great, data2);
                --great;
              }
              break;
            }
          }
        }
      }
    }
    shufflePivot(left2, less - 1, pivot1X, pivot1Y, data2);
    shufflePivot(right2, great + 1, pivot2X, pivot2Y, data2);
    if (less - 2 - left2 <= INSERT_SORT_CUTOFF) {
      insertionSort(left2, less - 2, data2);
    } else {
      quickSort(left2, less - 2, data2);
    }
    if (right2 - (great + 2) <= INSERT_SORT_CUTOFF) {
      insertionSort(great + 2, right2, data2);
    } else {
      quickSort(great + 2, right2, data2);
    }
    if (great - less <= INSERT_SORT_CUTOFF) {
      insertionSort(less, great, data2);
    } else {
      quickSort(less, great, data2);
    }
  }
  return sort;
}
var sweep;
var hasRequiredSweep;
function requireSweep() {
  if (hasRequiredSweep) return sweep;
  hasRequiredSweep = 1;
  sweep = {
    init: sqInit,
    sweepBipartite,
    sweepComplete,
    scanBipartite,
    scanComplete
  };
  var pool2 = requirePool();
  var bits = requireTwiddle();
  var isort = requireSort();
  var BLUE_FLAG = 1 << 28;
  var INIT_CAPACITY = 1024;
  var RED_SWEEP_QUEUE = pool2.mallocInt32(INIT_CAPACITY);
  var RED_SWEEP_INDEX = pool2.mallocInt32(INIT_CAPACITY);
  var BLUE_SWEEP_QUEUE = pool2.mallocInt32(INIT_CAPACITY);
  var BLUE_SWEEP_INDEX = pool2.mallocInt32(INIT_CAPACITY);
  var COMMON_SWEEP_QUEUE = pool2.mallocInt32(INIT_CAPACITY);
  var COMMON_SWEEP_INDEX = pool2.mallocInt32(INIT_CAPACITY);
  var SWEEP_EVENTS = pool2.mallocDouble(INIT_CAPACITY * 8);
  function sqInit(count2) {
    var rcount = bits.nextPow2(count2);
    if (RED_SWEEP_QUEUE.length < rcount) {
      pool2.free(RED_SWEEP_QUEUE);
      RED_SWEEP_QUEUE = pool2.mallocInt32(rcount);
    }
    if (RED_SWEEP_INDEX.length < rcount) {
      pool2.free(RED_SWEEP_INDEX);
      RED_SWEEP_INDEX = pool2.mallocInt32(rcount);
    }
    if (BLUE_SWEEP_QUEUE.length < rcount) {
      pool2.free(BLUE_SWEEP_QUEUE);
      BLUE_SWEEP_QUEUE = pool2.mallocInt32(rcount);
    }
    if (BLUE_SWEEP_INDEX.length < rcount) {
      pool2.free(BLUE_SWEEP_INDEX);
      BLUE_SWEEP_INDEX = pool2.mallocInt32(rcount);
    }
    if (COMMON_SWEEP_QUEUE.length < rcount) {
      pool2.free(COMMON_SWEEP_QUEUE);
      COMMON_SWEEP_QUEUE = pool2.mallocInt32(rcount);
    }
    if (COMMON_SWEEP_INDEX.length < rcount) {
      pool2.free(COMMON_SWEEP_INDEX);
      COMMON_SWEEP_INDEX = pool2.mallocInt32(rcount);
    }
    var eventLength = 8 * rcount;
    if (SWEEP_EVENTS.length < eventLength) {
      pool2.free(SWEEP_EVENTS);
      SWEEP_EVENTS = pool2.mallocDouble(eventLength);
    }
  }
  function sqPop(queue2, index2, count2, item) {
    var idx = index2[item];
    var top2 = queue2[count2 - 1];
    queue2[idx] = top2;
    index2[top2] = idx;
  }
  function sqPush(queue2, index2, count2, item) {
    queue2[count2] = item;
    index2[item] = count2;
  }
  function sweepBipartite(d, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
    var ptr = 0;
    var elemSize = 2 * d;
    var istart = d - 1;
    var iend = elemSize - 1;
    for (var i = redStart; i < redEnd; ++i) {
      var idx = redIndex[i];
      var redOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
      SWEEP_EVENTS[ptr++] = -(idx + 1);
      SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
      SWEEP_EVENTS[ptr++] = idx;
    }
    for (var i = blueStart; i < blueEnd; ++i) {
      var idx = blueIndex[i] + BLUE_FLAG;
      var blueOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx;
      SWEEP_EVENTS[ptr++] = blue2[blueOffset + iend];
      SWEEP_EVENTS[ptr++] = idx;
    }
    var n = ptr >>> 1;
    isort(SWEEP_EVENTS, n);
    var redActive = 0;
    var blueActive = 0;
    for (var i = 0; i < n; ++i) {
      var e = SWEEP_EVENTS[2 * i + 1] | 0;
      if (e >= BLUE_FLAG) {
        e = e - BLUE_FLAG | 0;
        sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, e);
      } else if (e >= 0) {
        sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e);
      } else if (e <= -BLUE_FLAG) {
        e = -e - BLUE_FLAG | 0;
        for (var j = 0; j < redActive; ++j) {
          var retval = visit(RED_SWEEP_QUEUE[j], e);
          if (retval !== void 0) {
            return retval;
          }
        }
        sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, e);
      } else {
        e = -e - 1 | 0;
        for (var j = 0; j < blueActive; ++j) {
          var retval = visit(e, BLUE_SWEEP_QUEUE[j]);
          if (retval !== void 0) {
            return retval;
          }
        }
        sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, e);
      }
    }
  }
  function sweepComplete(d, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
    var ptr = 0;
    var elemSize = 2 * d;
    var istart = d - 1;
    var iend = elemSize - 1;
    for (var i = redStart; i < redEnd; ++i) {
      var idx = redIndex[i] + 1 << 1;
      var redOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx;
      SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
      SWEEP_EVENTS[ptr++] = idx;
    }
    for (var i = blueStart; i < blueEnd; ++i) {
      var idx = blueIndex[i] + 1 << 1;
      var blueOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx | 1;
      SWEEP_EVENTS[ptr++] = blue2[blueOffset + iend];
      SWEEP_EVENTS[ptr++] = idx | 1;
    }
    var n = ptr >>> 1;
    isort(SWEEP_EVENTS, n);
    var redActive = 0;
    var blueActive = 0;
    var commonActive = 0;
    for (var i = 0; i < n; ++i) {
      var e = SWEEP_EVENTS[2 * i + 1] | 0;
      var color2 = e & 1;
      if (i < n - 1 && e >> 1 === SWEEP_EVENTS[2 * i + 3] >> 1) {
        color2 = 2;
        i += 1;
      }
      if (e < 0) {
        var id2 = -(e >> 1) - 1;
        for (var j = 0; j < commonActive; ++j) {
          var retval = visit(COMMON_SWEEP_QUEUE[j], id2);
          if (retval !== void 0) {
            return retval;
          }
        }
        if (color2 !== 0) {
          for (var j = 0; j < redActive; ++j) {
            var retval = visit(RED_SWEEP_QUEUE[j], id2);
            if (retval !== void 0) {
              return retval;
            }
          }
        }
        if (color2 !== 1) {
          for (var j = 0; j < blueActive; ++j) {
            var retval = visit(BLUE_SWEEP_QUEUE[j], id2);
            if (retval !== void 0) {
              return retval;
            }
          }
        }
        if (color2 === 0) {
          sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, id2);
        } else if (color2 === 1) {
          sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, id2);
        } else if (color2 === 2) {
          sqPush(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive++, id2);
        }
      } else {
        var id2 = (e >> 1) - 1;
        if (color2 === 0) {
          sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, id2);
        } else if (color2 === 1) {
          sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, id2);
        } else if (color2 === 2) {
          sqPop(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive--, id2);
        }
      }
    }
  }
  function scanBipartite(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
    var ptr = 0;
    var elemSize = 2 * d;
    var istart = axis2;
    var iend = axis2 + d;
    var redShift = 1;
    var blueShift = 1;
    if (flip2) {
      blueShift = BLUE_FLAG;
    } else {
      redShift = BLUE_FLAG;
    }
    for (var i = redStart; i < redEnd; ++i) {
      var idx = i + redShift;
      var redOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx;
      SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
      SWEEP_EVENTS[ptr++] = idx;
    }
    for (var i = blueStart; i < blueEnd; ++i) {
      var idx = i + blueShift;
      var blueOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx;
    }
    var n = ptr >>> 1;
    isort(SWEEP_EVENTS, n);
    var redActive = 0;
    for (var i = 0; i < n; ++i) {
      var e = SWEEP_EVENTS[2 * i + 1] | 0;
      if (e < 0) {
        var idx = -e;
        var isRed = false;
        if (idx >= BLUE_FLAG) {
          isRed = !flip2;
          idx -= BLUE_FLAG;
        } else {
          isRed = !!flip2;
          idx -= 1;
        }
        if (isRed) {
          sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, idx);
        } else {
          var blueId = blueIndex[idx];
          var bluePtr = elemSize * idx;
          var b0 = blue2[bluePtr + axis2 + 1];
          var b1 = blue2[bluePtr + axis2 + 1 + d];
          red_loop: for (var j = 0; j < redActive; ++j) {
            var oidx = RED_SWEEP_QUEUE[j];
            var redPtr = elemSize * oidx;
            if (b1 < red2[redPtr + axis2 + 1] || red2[redPtr + axis2 + 1 + d] < b0) {
              continue;
            }
            for (var k = axis2 + 2; k < d; ++k) {
              if (blue2[bluePtr + k + d] < red2[redPtr + k] || red2[redPtr + k + d] < blue2[bluePtr + k]) {
                continue red_loop;
              }
            }
            var redId = redIndex[oidx];
            var retval;
            if (flip2) {
              retval = visit(blueId, redId);
            } else {
              retval = visit(redId, blueId);
            }
            if (retval !== void 0) {
              return retval;
            }
          }
        }
      } else {
        sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e - redShift);
      }
    }
  }
  function scanComplete(d, axis2, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex) {
    var ptr = 0;
    var elemSize = 2 * d;
    var istart = axis2;
    var iend = axis2 + d;
    for (var i = redStart; i < redEnd; ++i) {
      var idx = i + BLUE_FLAG;
      var redOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = red2[redOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx;
      SWEEP_EVENTS[ptr++] = red2[redOffset + iend];
      SWEEP_EVENTS[ptr++] = idx;
    }
    for (var i = blueStart; i < blueEnd; ++i) {
      var idx = i + 1;
      var blueOffset = elemSize * i;
      SWEEP_EVENTS[ptr++] = blue2[blueOffset + istart];
      SWEEP_EVENTS[ptr++] = -idx;
    }
    var n = ptr >>> 1;
    isort(SWEEP_EVENTS, n);
    var redActive = 0;
    for (var i = 0; i < n; ++i) {
      var e = SWEEP_EVENTS[2 * i + 1] | 0;
      if (e < 0) {
        var idx = -e;
        if (idx >= BLUE_FLAG) {
          RED_SWEEP_QUEUE[redActive++] = idx - BLUE_FLAG;
        } else {
          idx -= 1;
          var blueId = blueIndex[idx];
          var bluePtr = elemSize * idx;
          var b0 = blue2[bluePtr + axis2 + 1];
          var b1 = blue2[bluePtr + axis2 + 1 + d];
          red_loop: for (var j = 0; j < redActive; ++j) {
            var oidx = RED_SWEEP_QUEUE[j];
            var redId = redIndex[oidx];
            if (redId === blueId) {
              break;
            }
            var redPtr = elemSize * oidx;
            if (b1 < red2[redPtr + axis2 + 1] || red2[redPtr + axis2 + 1 + d] < b0) {
              continue;
            }
            for (var k = axis2 + 2; k < d; ++k) {
              if (blue2[bluePtr + k + d] < red2[redPtr + k] || red2[redPtr + k + d] < blue2[bluePtr + k]) {
                continue red_loop;
              }
            }
            var retval = visit(redId, blueId);
            if (retval !== void 0) {
              return retval;
            }
          }
        }
      } else {
        var idx = e - BLUE_FLAG;
        for (var j = redActive - 1; j >= 0; --j) {
          if (RED_SWEEP_QUEUE[j] === idx) {
            for (var k = j + 1; k < redActive; ++k) {
              RED_SWEEP_QUEUE[k - 1] = RED_SWEEP_QUEUE[k];
            }
            break;
          }
        }
        --redActive;
      }
    }
  }
  return sweep;
}
var brute = {};
var hasRequiredBrute;
function requireBrute() {
  if (hasRequiredBrute) return brute;
  hasRequiredBrute = 1;
  var DIMENSION = "d";
  var AXIS = "ax";
  var VISIT = "vv";
  var FLIP = "fp";
  var ELEM_SIZE = "es";
  var RED_START = "rs";
  var RED_END = "re";
  var RED_BOXES = "rb";
  var RED_INDEX = "ri";
  var RED_PTR = "rp";
  var BLUE_START = "bs";
  var BLUE_END = "be";
  var BLUE_BOXES = "bb";
  var BLUE_INDEX = "bi";
  var BLUE_PTR = "bp";
  var RETVAL = "rv";
  var INNER_LABEL = "Q";
  var ARGS = [DIMENSION, AXIS, VISIT, RED_START, RED_END, RED_BOXES, RED_INDEX, BLUE_START, BLUE_END, BLUE_BOXES, BLUE_INDEX];
  function generateBruteForce(redMajor, flip2, full) {
    var funcName = "bruteForce" + (redMajor ? "Red" : "Blue") + (flip2 ? "Flip" : "") + (full ? "Full" : "");
    var code = ["function ", funcName, "(", ARGS.join(), "){", "var ", ELEM_SIZE, "=2*", DIMENSION, ";"];
    var redLoop = "for(var i=" + RED_START + "," + RED_PTR + "=" + ELEM_SIZE + "*" + RED_START + ";i<" + RED_END + ";++i," + RED_PTR + "+=" + ELEM_SIZE + "){var x0=" + RED_BOXES + "[" + AXIS + "+" + RED_PTR + "],x1=" + RED_BOXES + "[" + AXIS + "+" + RED_PTR + "+" + DIMENSION + "],xi=" + RED_INDEX + "[i];";
    var blueLoop = "for(var j=" + BLUE_START + "," + BLUE_PTR + "=" + ELEM_SIZE + "*" + BLUE_START + ";j<" + BLUE_END + ";++j," + BLUE_PTR + "+=" + ELEM_SIZE + "){var y0=" + BLUE_BOXES + "[" + AXIS + "+" + BLUE_PTR + "]," + (full ? "y1=" + BLUE_BOXES + "[" + AXIS + "+" + BLUE_PTR + "+" + DIMENSION + "]," : "") + "yi=" + BLUE_INDEX + "[j];";
    if (redMajor) {
      code.push(redLoop, INNER_LABEL, ":", blueLoop);
    } else {
      code.push(blueLoop, INNER_LABEL, ":", redLoop);
    }
    if (full) {
      code.push("if(y1<x0||x1<y0)continue;");
    } else if (flip2) {
      code.push("if(y0<=x0||x1<y0)continue;");
    } else {
      code.push("if(y0<x0||x1<y0)continue;");
    }
    code.push("for(var k=" + AXIS + "+1;k<" + DIMENSION + ";++k){var r0=" + RED_BOXES + "[k+" + RED_PTR + "],r1=" + RED_BOXES + "[k+" + DIMENSION + "+" + RED_PTR + "],b0=" + BLUE_BOXES + "[k+" + BLUE_PTR + "],b1=" + BLUE_BOXES + "[k+" + DIMENSION + "+" + BLUE_PTR + "];if(r1<b0||b1<r0)continue " + INNER_LABEL + ";}var " + RETVAL + "=" + VISIT + "(");
    if (flip2) {
      code.push("yi,xi");
    } else {
      code.push("xi,yi");
    }
    code.push(");if(" + RETVAL + "!==void 0)return " + RETVAL + ";}}}");
    return {
      name: funcName,
      code: code.join("")
    };
  }
  function bruteForcePlanner(full) {
    var funcName = "bruteForce" + (full ? "Full" : "Partial");
    var prefix2 = [];
    var fargs = ARGS.slice();
    if (!full) {
      fargs.splice(3, 0, FLIP);
    }
    var code = ["function " + funcName + "(" + fargs.join() + "){"];
    function invoke(redMajor, flip2) {
      var res = generateBruteForce(redMajor, flip2, full);
      prefix2.push(res.code);
      code.push("return " + res.name + "(" + ARGS.join() + ");");
    }
    code.push("if(" + RED_END + "-" + RED_START + ">" + BLUE_END + "-" + BLUE_START + "){");
    if (full) {
      invoke(true, false);
      code.push("}else{");
      invoke(false, false);
    } else {
      code.push("if(" + FLIP + "){");
      invoke(true, true);
      code.push("}else{");
      invoke(true, false);
      code.push("}}else{if(" + FLIP + "){");
      invoke(false, true);
      code.push("}else{");
      invoke(false, false);
      code.push("}");
    }
    code.push("}}return " + funcName);
    var codeStr = prefix2.join("") + code.join("");
    var proc = new Function(codeStr);
    return proc();
  }
  brute.partial = bruteForcePlanner(false);
  brute.full = bruteForcePlanner(true);
  return brute;
}
var partition;
var hasRequiredPartition;
function requirePartition() {
  if (hasRequiredPartition) return partition;
  hasRequiredPartition = 1;
  partition = genPartition;
  var code = "for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m";
  function genPartition(predicate, args) {
    var fargs = "abcdef".split("").concat(args);
    var reads = [];
    if (predicate.indexOf("lo") >= 0) {
      reads.push("lo=e[k+n]");
    }
    if (predicate.indexOf("hi") >= 0) {
      reads.push("hi=e[k+o]");
    }
    fargs.push(code.replace("_", reads.join()).replace("$", predicate));
    return Function.apply(void 0, fargs);
  }
  return partition;
}
var median;
var hasRequiredMedian;
function requireMedian() {
  if (hasRequiredMedian) return median;
  hasRequiredMedian = 1;
  median = findMedian;
  var genPartition = requirePartition();
  var partitionStartLessThan = genPartition("lo<p0", ["p0"]);
  var PARTITION_THRESHOLD = 8;
  function insertionSort(d, axis2, start2, end2, boxes, ids2) {
    var elemSize = 2 * d;
    var boxPtr = elemSize * (start2 + 1) + axis2;
    for (var i = start2 + 1; i < end2; ++i, boxPtr += elemSize) {
      var x = boxes[boxPtr];
      for (var j = i, ptr = elemSize * (i - 1); j > start2 && boxes[ptr + axis2] > x; --j, ptr -= elemSize) {
        var aPtr = ptr;
        var bPtr = ptr + elemSize;
        for (var k = 0; k < elemSize; ++k, ++aPtr, ++bPtr) {
          var y = boxes[aPtr];
          boxes[aPtr] = boxes[bPtr];
          boxes[bPtr] = y;
        }
        var tmp = ids2[j];
        ids2[j] = ids2[j - 1];
        ids2[j - 1] = tmp;
      }
    }
  }
  function findMedian(d, axis2, start2, end2, boxes, ids2) {
    if (end2 <= start2 + 1) {
      return start2;
    }
    var lo = start2;
    var hi = end2;
    var mid2 = end2 + start2 >>> 1;
    var elemSize = 2 * d;
    var pivot = mid2;
    var value = boxes[elemSize * mid2 + axis2];
    while (lo < hi) {
      if (hi - lo < PARTITION_THRESHOLD) {
        insertionSort(d, axis2, lo, hi, boxes, ids2);
        value = boxes[elemSize * mid2 + axis2];
        break;
      }
      var count2 = hi - lo;
      var pivot0 = Math.random() * count2 + lo | 0;
      var value0 = boxes[elemSize * pivot0 + axis2];
      var pivot1 = Math.random() * count2 + lo | 0;
      var value1 = boxes[elemSize * pivot1 + axis2];
      var pivot2 = Math.random() * count2 + lo | 0;
      var value2 = boxes[elemSize * pivot2 + axis2];
      if (value0 <= value1) {
        if (value2 >= value1) {
          pivot = pivot1;
          value = value1;
        } else if (value0 >= value2) {
          pivot = pivot0;
          value = value0;
        } else {
          pivot = pivot2;
          value = value2;
        }
      } else {
        if (value1 >= value2) {
          pivot = pivot1;
          value = value1;
        } else if (value2 >= value0) {
          pivot = pivot0;
          value = value0;
        } else {
          pivot = pivot2;
          value = value2;
        }
      }
      var aPtr = elemSize * (hi - 1);
      var bPtr = elemSize * pivot;
      for (var i = 0; i < elemSize; ++i, ++aPtr, ++bPtr) {
        var x = boxes[aPtr];
        boxes[aPtr] = boxes[bPtr];
        boxes[bPtr] = x;
      }
      var y = ids2[hi - 1];
      ids2[hi - 1] = ids2[pivot];
      ids2[pivot] = y;
      pivot = partitionStartLessThan(d, axis2, lo, hi - 1, boxes, ids2, value);
      var aPtr = elemSize * (hi - 1);
      var bPtr = elemSize * pivot;
      for (var i = 0; i < elemSize; ++i, ++aPtr, ++bPtr) {
        var x = boxes[aPtr];
        boxes[aPtr] = boxes[bPtr];
        boxes[bPtr] = x;
      }
      var y = ids2[hi - 1];
      ids2[hi - 1] = ids2[pivot];
      ids2[pivot] = y;
      if (mid2 < pivot) {
        hi = pivot - 1;
        while (lo < hi && boxes[elemSize * (hi - 1) + axis2] === value) {
          hi -= 1;
        }
        hi += 1;
      } else if (pivot < mid2) {
        lo = pivot + 1;
        while (lo < hi && boxes[elemSize * lo + axis2] === value) {
          lo += 1;
        }
      } else {
        break;
      }
    }
    return partitionStartLessThan(d, axis2, start2, mid2, boxes, ids2, boxes[elemSize * mid2 + axis2]);
  }
  return median;
}
var intersect;
var hasRequiredIntersect;
function requireIntersect() {
  if (hasRequiredIntersect) return intersect;
  hasRequiredIntersect = 1;
  intersect = boxIntersectIter;
  var pool2 = requirePool();
  var bits = requireTwiddle();
  var bruteForce = requireBrute();
  var bruteForcePartial = bruteForce.partial;
  var bruteForceFull = bruteForce.full;
  var sweep2 = requireSweep();
  var findMedian = requireMedian();
  var genPartition = requirePartition();
  var BRUTE_FORCE_CUTOFF = 128;
  var SCAN_CUTOFF = 1 << 22;
  var SCAN_COMPLETE_CUTOFF = 1 << 22;
  var partitionInteriorContainsInterval = genPartition("!(lo>=p0)&&!(p1>=hi)", ["p0", "p1"]);
  var partitionStartEqual = genPartition("lo===p0", ["p0"]);
  var partitionStartLessThan = genPartition("lo<p0", ["p0"]);
  var partitionEndLessThanEqual = genPartition("hi<=p0", ["p0"]);
  var partitionContainsPoint = genPartition("lo<=p0&&p0<=hi", ["p0"]);
  var partitionContainsPointProper = genPartition("lo<p0&&p0<=hi", ["p0"]);
  var IFRAME_SIZE = 6;
  var DFRAME_SIZE = 2;
  var INIT_CAPACITY = 1024;
  var BOX_ISTACK = pool2.mallocInt32(INIT_CAPACITY);
  var BOX_DSTACK = pool2.mallocDouble(INIT_CAPACITY);
  function iterInit(d, count2) {
    var levels = 8 * bits.log2(count2 + 1) * (d + 1) | 0;
    var maxInts = bits.nextPow2(IFRAME_SIZE * levels);
    if (BOX_ISTACK.length < maxInts) {
      pool2.free(BOX_ISTACK);
      BOX_ISTACK = pool2.mallocInt32(maxInts);
    }
    var maxDoubles = bits.nextPow2(DFRAME_SIZE * levels);
    if (BOX_DSTACK.length < maxDoubles) {
      pool2.free(BOX_DSTACK);
      BOX_DSTACK = pool2.mallocDouble(maxDoubles);
    }
  }
  function iterPush(ptr, axis2, redStart, redEnd, blueStart, blueEnd, state, lo, hi) {
    var iptr = IFRAME_SIZE * ptr;
    BOX_ISTACK[iptr] = axis2;
    BOX_ISTACK[iptr + 1] = redStart;
    BOX_ISTACK[iptr + 2] = redEnd;
    BOX_ISTACK[iptr + 3] = blueStart;
    BOX_ISTACK[iptr + 4] = blueEnd;
    BOX_ISTACK[iptr + 5] = state;
    var dptr = DFRAME_SIZE * ptr;
    BOX_DSTACK[dptr] = lo;
    BOX_DSTACK[dptr + 1] = hi;
  }
  function onePointPartial(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueOffset, blue2, blueId) {
    var elemSize = 2 * d;
    var bluePtr = blueOffset * elemSize;
    var blueX = blue2[bluePtr + axis2];
    red_loop: for (var i = redStart, redPtr = redStart * elemSize; i < redEnd; ++i, redPtr += elemSize) {
      var r0 = red2[redPtr + axis2];
      var r1 = red2[redPtr + axis2 + d];
      if (blueX < r0 || r1 < blueX) {
        continue;
      }
      if (flip2 && blueX === r0) {
        continue;
      }
      var redId = redIndex[i];
      for (var j = axis2 + 1; j < d; ++j) {
        var r0 = red2[redPtr + j];
        var r1 = red2[redPtr + j + d];
        var b0 = blue2[bluePtr + j];
        var b1 = blue2[bluePtr + j + d];
        if (r1 < b0 || b1 < r0) {
          continue red_loop;
        }
      }
      var retval;
      if (flip2) {
        retval = visit(blueId, redId);
      } else {
        retval = visit(redId, blueId);
      }
      if (retval !== void 0) {
        return retval;
      }
    }
  }
  function onePointFull(d, axis2, visit, redStart, redEnd, red2, redIndex, blueOffset, blue2, blueId) {
    var elemSize = 2 * d;
    var bluePtr = blueOffset * elemSize;
    var blueX = blue2[bluePtr + axis2];
    red_loop: for (var i = redStart, redPtr = redStart * elemSize; i < redEnd; ++i, redPtr += elemSize) {
      var redId = redIndex[i];
      if (redId === blueId) {
        continue;
      }
      var r0 = red2[redPtr + axis2];
      var r1 = red2[redPtr + axis2 + d];
      if (blueX < r0 || r1 < blueX) {
        continue;
      }
      for (var j = axis2 + 1; j < d; ++j) {
        var r0 = red2[redPtr + j];
        var r1 = red2[redPtr + j + d];
        var b0 = blue2[bluePtr + j];
        var b1 = blue2[bluePtr + j + d];
        if (r1 < b0 || b1 < r0) {
          continue red_loop;
        }
      }
      var retval = visit(redId, blueId);
      if (retval !== void 0) {
        return retval;
      }
    }
  }
  function boxIntersectIter(d, visit, initFull, xSize, xBoxes, xIndex, ySize, yBoxes, yIndex) {
    iterInit(d, xSize + ySize);
    var top2 = 0;
    var elemSize = 2 * d;
    var retval;
    iterPush(top2++, 0, 0, xSize, 0, ySize, initFull ? 16 : 0, -Infinity, Infinity);
    if (!initFull) {
      iterPush(top2++, 0, 0, ySize, 0, xSize, 1, -Infinity, Infinity);
    }
    while (top2 > 0) {
      top2 -= 1;
      var iptr = top2 * IFRAME_SIZE;
      var axis2 = BOX_ISTACK[iptr];
      var redStart = BOX_ISTACK[iptr + 1];
      var redEnd = BOX_ISTACK[iptr + 2];
      var blueStart = BOX_ISTACK[iptr + 3];
      var blueEnd = BOX_ISTACK[iptr + 4];
      var state = BOX_ISTACK[iptr + 5];
      var dptr = top2 * DFRAME_SIZE;
      var lo = BOX_DSTACK[dptr];
      var hi = BOX_DSTACK[dptr + 1];
      var flip2 = state & 1;
      var full = !!(state & 16);
      var red2 = xBoxes;
      var redIndex = xIndex;
      var blue2 = yBoxes;
      var blueIndex = yIndex;
      if (flip2) {
        red2 = yBoxes;
        redIndex = yIndex;
        blue2 = xBoxes;
        blueIndex = xIndex;
      }
      if (state & 2) {
        redEnd = partitionStartLessThan(d, axis2, redStart, redEnd, red2, redIndex, hi);
        if (redStart >= redEnd) {
          continue;
        }
      }
      if (state & 4) {
        redStart = partitionEndLessThanEqual(d, axis2, redStart, redEnd, red2, redIndex, lo);
        if (redStart >= redEnd) {
          continue;
        }
      }
      var redCount = redEnd - redStart;
      var blueCount = blueEnd - blueStart;
      if (full) {
        if (d * redCount * (redCount + blueCount) < SCAN_COMPLETE_CUTOFF) {
          retval = sweep2.scanComplete(d, axis2, visit, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
          if (retval !== void 0) {
            return retval;
          }
          continue;
        }
      } else {
        if (d * Math.min(redCount, blueCount) < BRUTE_FORCE_CUTOFF) {
          retval = bruteForcePartial(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
          if (retval !== void 0) {
            return retval;
          }
          continue;
        } else if (d * redCount * blueCount < SCAN_CUTOFF) {
          retval = sweep2.scanBipartite(d, axis2, visit, flip2, redStart, redEnd, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
          if (retval !== void 0) {
            return retval;
          }
          continue;
        }
      }
      var red0 = partitionInteriorContainsInterval(d, axis2, redStart, redEnd, red2, redIndex, lo, hi);
      if (redStart < red0) {
        if (d * (red0 - redStart) < BRUTE_FORCE_CUTOFF) {
          retval = bruteForceFull(d, axis2 + 1, visit, redStart, red0, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
          if (retval !== void 0) {
            return retval;
          }
        } else if (axis2 === d - 2) {
          if (flip2) {
            retval = sweep2.sweepBipartite(d, visit, blueStart, blueEnd, blue2, blueIndex, redStart, red0, red2, redIndex);
          } else {
            retval = sweep2.sweepBipartite(d, visit, redStart, red0, red2, redIndex, blueStart, blueEnd, blue2, blueIndex);
          }
          if (retval !== void 0) {
            return retval;
          }
        } else {
          iterPush(top2++, axis2 + 1, redStart, red0, blueStart, blueEnd, flip2, -Infinity, Infinity);
          iterPush(top2++, axis2 + 1, blueStart, blueEnd, redStart, red0, flip2 ^ 1, -Infinity, Infinity);
        }
      }
      if (red0 < redEnd) {
        var blue0 = findMedian(d, axis2, blueStart, blueEnd, blue2, blueIndex);
        var mid2 = blue2[elemSize * blue0 + axis2];
        var blue1 = partitionStartEqual(d, axis2, blue0, blueEnd, blue2, blueIndex, mid2);
        if (blue1 < blueEnd) {
          iterPush(top2++, axis2, red0, redEnd, blue1, blueEnd, (flip2 | 4) + (full ? 16 : 0), mid2, hi);
        }
        if (blueStart < blue0) {
          iterPush(top2++, axis2, red0, redEnd, blueStart, blue0, (flip2 | 2) + (full ? 16 : 0), lo, mid2);
        }
        if (blue0 + 1 === blue1) {
          if (full) {
            retval = onePointFull(d, axis2, visit, red0, redEnd, red2, redIndex, blue0, blue2, blueIndex[blue0]);
          } else {
            retval = onePointPartial(d, axis2, visit, flip2, red0, redEnd, red2, redIndex, blue0, blue2, blueIndex[blue0]);
          }
          if (retval !== void 0) {
            return retval;
          }
        } else if (blue0 < blue1) {
          var red1;
          if (full) {
            red1 = partitionContainsPoint(d, axis2, red0, redEnd, red2, redIndex, mid2);
            if (red0 < red1) {
              var redX = partitionStartEqual(d, axis2, red0, red1, red2, redIndex, mid2);
              if (axis2 === d - 2) {
                if (red0 < redX) {
                  retval = sweep2.sweepComplete(d, visit, red0, redX, red2, redIndex, blue0, blue1, blue2, blueIndex);
                  if (retval !== void 0) {
                    return retval;
                  }
                }
                if (redX < red1) {
                  retval = sweep2.sweepBipartite(d, visit, redX, red1, red2, redIndex, blue0, blue1, blue2, blueIndex);
                  if (retval !== void 0) {
                    return retval;
                  }
                }
              } else {
                if (red0 < redX) {
                  iterPush(top2++, axis2 + 1, red0, redX, blue0, blue1, 16, -Infinity, Infinity);
                }
                if (redX < red1) {
                  iterPush(top2++, axis2 + 1, redX, red1, blue0, blue1, 0, -Infinity, Infinity);
                  iterPush(top2++, axis2 + 1, blue0, blue1, redX, red1, 1, -Infinity, Infinity);
                }
              }
            }
          } else {
            if (flip2) {
              red1 = partitionContainsPointProper(d, axis2, red0, redEnd, red2, redIndex, mid2);
            } else {
              red1 = partitionContainsPoint(d, axis2, red0, redEnd, red2, redIndex, mid2);
            }
            if (red0 < red1) {
              if (axis2 === d - 2) {
                if (flip2) {
                  retval = sweep2.sweepBipartite(d, visit, blue0, blue1, blue2, blueIndex, red0, red1, red2, redIndex);
                } else {
                  retval = sweep2.sweepBipartite(d, visit, red0, red1, red2, redIndex, blue0, blue1, blue2, blueIndex);
                }
              } else {
                iterPush(top2++, axis2 + 1, red0, red1, blue0, blue1, flip2, -Infinity, Infinity);
                iterPush(top2++, axis2 + 1, blue0, blue1, red0, red1, flip2 ^ 1, -Infinity, Infinity);
              }
            }
          }
        }
      }
    }
  }
  return intersect;
}
var boxIntersect_1;
var hasRequiredBoxIntersect;
function requireBoxIntersect() {
  if (hasRequiredBoxIntersect) return boxIntersect_1;
  hasRequiredBoxIntersect = 1;
  boxIntersect_1 = boxIntersectWrapper;
  var pool2 = requirePool();
  var sweep2 = requireSweep();
  var boxIntersectIter = requireIntersect();
  function boxEmpty(d, box) {
    for (var j = 0; j < d; ++j) {
      if (!(box[j] <= box[j + d])) {
        return true;
      }
    }
    return false;
  }
  function convertBoxes(boxes, d, data2, ids2) {
    var ptr = 0;
    var count2 = 0;
    for (var i = 0, n = boxes.length; i < n; ++i) {
      var b = boxes[i];
      if (boxEmpty(d, b)) {
        continue;
      }
      for (var j = 0; j < 2 * d; ++j) {
        data2[ptr++] = b[j];
      }
      ids2[count2++] = i;
    }
    return count2;
  }
  function boxIntersect2(red2, blue2, visit, full) {
    var n = red2.length;
    var m = blue2.length;
    if (n <= 0 || m <= 0) {
      return;
    }
    var d = red2[0].length >>> 1;
    if (d <= 0) {
      return;
    }
    var retval;
    var redList = pool2.mallocDouble(2 * d * n);
    var redIds = pool2.mallocInt32(n);
    n = convertBoxes(red2, d, redList, redIds);
    if (n > 0) {
      if (d === 1 && full) {
        sweep2.init(n);
        retval = sweep2.sweepComplete(d, visit, 0, n, redList, redIds, 0, n, redList, redIds);
      } else {
        var blueList = pool2.mallocDouble(2 * d * m);
        var blueIds = pool2.mallocInt32(m);
        m = convertBoxes(blue2, d, blueList, blueIds);
        if (m > 0) {
          sweep2.init(n + m);
          if (d === 1) {
            retval = sweep2.sweepBipartite(d, visit, 0, n, redList, redIds, 0, m, blueList, blueIds);
          } else {
            retval = boxIntersectIter(d, visit, full, n, redList, redIds, m, blueList, blueIds);
          }
          pool2.free(blueList);
          pool2.free(blueIds);
        }
      }
      pool2.free(redList);
      pool2.free(redIds);
    }
    return retval;
  }
  var RESULT;
  function appendItem(i, j) {
    RESULT.push([i, j]);
  }
  function intersectFullArray(x) {
    RESULT = [];
    boxIntersect2(x, x, appendItem, true);
    return RESULT;
  }
  function intersectBipartiteArray(x, y) {
    RESULT = [];
    boxIntersect2(x, y, appendItem, false);
    return RESULT;
  }
  function boxIntersectWrapper(arg0, arg1, arg2) {
    switch (arguments.length) {
      case 1:
        return intersectFullArray(arg0);
      case 2:
        if (typeof arg1 === "function") {
          return boxIntersect2(arg0, arg0, arg1, true);
        } else {
          return intersectBipartiteArray(arg0, arg1);
        }
      case 3:
        return boxIntersect2(arg0, arg1, arg2, false);
      default:
        throw new Error("box-intersect: Invalid arguments");
    }
  }
  return boxIntersect_1;
}
var boxIntersectExports = requireBoxIntersect();
const boxIntersect = /* @__PURE__ */ getDefaultExportFromCjs(boxIntersectExports);
var orientation = { exports: {} };
var twoProduct_1;
var hasRequiredTwoProduct;
function requireTwoProduct() {
  if (hasRequiredTwoProduct) return twoProduct_1;
  hasRequiredTwoProduct = 1;
  twoProduct_1 = twoProduct;
  var SPLITTER = +(Math.pow(2, 27) + 1);
  function twoProduct(a, b, result) {
    var x = a * b;
    var c = SPLITTER * a;
    var abig = c - a;
    var ahi = c - abig;
    var alo = a - ahi;
    var d = SPLITTER * b;
    var bbig = d - b;
    var bhi = d - bbig;
    var blo = b - bhi;
    var err1 = x - ahi * bhi;
    var err2 = err1 - alo * bhi;
    var err3 = err2 - ahi * blo;
    var y = alo * blo - err3;
    if (result) {
      result[0] = y;
      result[1] = x;
      return result;
    }
    return [y, x];
  }
  return twoProduct_1;
}
var robustSum;
var hasRequiredRobustSum;
function requireRobustSum() {
  if (hasRequiredRobustSum) return robustSum;
  hasRequiredRobustSum = 1;
  robustSum = linearExpansionSum;
  function scalarScalar(a, b) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    var y = ar + br;
    if (y) {
      return [y, x];
    }
    return [x];
  }
  function linearExpansionSum(e, f2) {
    var ne2 = e.length | 0;
    var nf = f2.length | 0;
    if (ne2 === 1 && nf === 1) {
      return scalarScalar(e[0], f2[0]);
    }
    var n = ne2 + nf;
    var g = new Array(n);
    var count2 = 0;
    var eptr = 0;
    var fptr = 0;
    var abs2 = Math.abs;
    var ei = e[eptr];
    var ea = abs2(ei);
    var fi = f2[fptr];
    var fa = abs2(fi);
    var a, b;
    if (ea < fa) {
      b = ei;
      eptr += 1;
      if (eptr < ne2) {
        ei = e[eptr];
        ea = abs2(ei);
      }
    } else {
      b = fi;
      fptr += 1;
      if (fptr < nf) {
        fi = f2[fptr];
        fa = abs2(fi);
      }
    }
    if (eptr < ne2 && ea < fa || fptr >= nf) {
      a = ei;
      eptr += 1;
      if (eptr < ne2) {
        ei = e[eptr];
        ea = abs2(ei);
      }
    } else {
      a = fi;
      fptr += 1;
      if (fptr < nf) {
        fi = f2[fptr];
        fa = abs2(fi);
      }
    }
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    var q0 = y;
    var q1 = x;
    var _x, _bv, _av, _br, _ar;
    while (eptr < ne2 && fptr < nf) {
      if (ea < fa) {
        a = ei;
        eptr += 1;
        if (eptr < ne2) {
          ei = e[eptr];
          ea = abs2(ei);
        }
      } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
          fi = f2[fptr];
          fa = abs2(fi);
        }
      }
      b = q0;
      x = a + b;
      bv = x - a;
      y = b - bv;
      if (y) {
        g[count2++] = y;
      }
      _x = q1 + x;
      _bv = _x - q1;
      _av = _x - _bv;
      _br = x - _bv;
      _ar = q1 - _av;
      q0 = _ar + _br;
      q1 = _x;
    }
    while (eptr < ne2) {
      a = ei;
      b = q0;
      x = a + b;
      bv = x - a;
      y = b - bv;
      if (y) {
        g[count2++] = y;
      }
      _x = q1 + x;
      _bv = _x - q1;
      _av = _x - _bv;
      _br = x - _bv;
      _ar = q1 - _av;
      q0 = _ar + _br;
      q1 = _x;
      eptr += 1;
      if (eptr < ne2) {
        ei = e[eptr];
      }
    }
    while (fptr < nf) {
      a = fi;
      b = q0;
      x = a + b;
      bv = x - a;
      y = b - bv;
      if (y) {
        g[count2++] = y;
      }
      _x = q1 + x;
      _bv = _x - q1;
      _av = _x - _bv;
      _br = x - _bv;
      _ar = q1 - _av;
      q0 = _ar + _br;
      q1 = _x;
      fptr += 1;
      if (fptr < nf) {
        fi = f2[fptr];
      }
    }
    if (q0) {
      g[count2++] = q0;
    }
    if (q1) {
      g[count2++] = q1;
    }
    if (!count2) {
      g[count2++] = 0;
    }
    g.length = count2;
    return g;
  }
  return robustSum;
}
var twoSum;
var hasRequiredTwoSum;
function requireTwoSum() {
  if (hasRequiredTwoSum) return twoSum;
  hasRequiredTwoSum = 1;
  twoSum = fastTwoSum;
  function fastTwoSum(a, b, result) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    if (result) {
      result[0] = ar + br;
      result[1] = x;
      return result;
    }
    return [ar + br, x];
  }
  return twoSum;
}
var robustScale;
var hasRequiredRobustScale;
function requireRobustScale() {
  if (hasRequiredRobustScale) return robustScale;
  hasRequiredRobustScale = 1;
  var twoProduct = requireTwoProduct();
  var twoSum2 = requireTwoSum();
  robustScale = scaleLinearExpansion;
  function scaleLinearExpansion(e, scale) {
    var n = e.length;
    if (n === 1) {
      var ts = twoProduct(e[0], scale);
      if (ts[0]) {
        return ts;
      }
      return [ts[1]];
    }
    var g = new Array(2 * n);
    var q2 = [0.1, 0.1];
    var t = [0.1, 0.1];
    var count2 = 0;
    twoProduct(e[0], scale, q2);
    if (q2[0]) {
      g[count2++] = q2[0];
    }
    for (var i = 1; i < n; ++i) {
      twoProduct(e[i], scale, t);
      var pq = q2[1];
      twoSum2(pq, t[0], q2);
      if (q2[0]) {
        g[count2++] = q2[0];
      }
      var a = t[1];
      var b = q2[1];
      var x = a + b;
      var bv = x - a;
      var y = b - bv;
      q2[1] = x;
      if (y) {
        g[count2++] = y;
      }
    }
    if (q2[1]) {
      g[count2++] = q2[1];
    }
    if (count2 === 0) {
      g[count2++] = 0;
    }
    g.length = count2;
    return g;
  }
  return robustScale;
}
var robustDiff;
var hasRequiredRobustDiff;
function requireRobustDiff() {
  if (hasRequiredRobustDiff) return robustDiff;
  hasRequiredRobustDiff = 1;
  robustDiff = robustSubtract;
  function scalarScalar(a, b) {
    var x = a + b;
    var bv = x - a;
    var av = x - bv;
    var br = b - bv;
    var ar = a - av;
    var y = ar + br;
    if (y) {
      return [y, x];
    }
    return [x];
  }
  function robustSubtract(e, f2) {
    var ne2 = e.length | 0;
    var nf = f2.length | 0;
    if (ne2 === 1 && nf === 1) {
      return scalarScalar(e[0], -f2[0]);
    }
    var n = ne2 + nf;
    var g = new Array(n);
    var count2 = 0;
    var eptr = 0;
    var fptr = 0;
    var abs2 = Math.abs;
    var ei = e[eptr];
    var ea = abs2(ei);
    var fi = -f2[fptr];
    var fa = abs2(fi);
    var a, b;
    if (ea < fa) {
      b = ei;
      eptr += 1;
      if (eptr < ne2) {
        ei = e[eptr];
        ea = abs2(ei);
      }
    } else {
      b = fi;
      fptr += 1;
      if (fptr < nf) {
        fi = -f2[fptr];
        fa = abs2(fi);
      }
    }
    if (eptr < ne2 && ea < fa || fptr >= nf) {
      a = ei;
      eptr += 1;
      if (eptr < ne2) {
        ei = e[eptr];
        ea = abs2(ei);
      }
    } else {
      a = fi;
      fptr += 1;
      if (fptr < nf) {
        fi = -f2[fptr];
        fa = abs2(fi);
      }
    }
    var x = a + b;
    var bv = x - a;
    var y = b - bv;
    var q0 = y;
    var q1 = x;
    var _x, _bv, _av, _br, _ar;
    while (eptr < ne2 && fptr < nf) {
      if (ea < fa) {
        a = ei;
        eptr += 1;
        if (eptr < ne2) {
          ei = e[eptr];
          ea = abs2(ei);
        }
      } else {
        a = fi;
        fptr += 1;
        if (fptr < nf) {
          fi = -f2[fptr];
          fa = abs2(fi);
        }
      }
      b = q0;
      x = a + b;
      bv = x - a;
      y = b - bv;
      if (y) {
        g[count2++] = y;
      }
      _x = q1 + x;
      _bv = _x - q1;
      _av = _x - _bv;
      _br = x - _bv;
      _ar = q1 - _av;
      q0 = _ar + _br;
      q1 = _x;
    }
    while (eptr < ne2) {
      a = ei;
      b = q0;
      x = a + b;
      bv = x - a;
      y = b - bv;
      if (y) {
        g[count2++] = y;
      }
      _x = q1 + x;
      _bv = _x - q1;
      _av = _x - _bv;
      _br = x - _bv;
      _ar = q1 - _av;
      q0 = _ar + _br;
      q1 = _x;
      eptr += 1;
      if (eptr < ne2) {
        ei = e[eptr];
      }
    }
    while (fptr < nf) {
      a = fi;
      b = q0;
      x = a + b;
      bv = x - a;
      y = b - bv;
      if (y) {
        g[count2++] = y;
      }
      _x = q1 + x;
      _bv = _x - q1;
      _av = _x - _bv;
      _br = x - _bv;
      _ar = q1 - _av;
      q0 = _ar + _br;
      q1 = _x;
      fptr += 1;
      if (fptr < nf) {
        fi = -f2[fptr];
      }
    }
    if (q0) {
      g[count2++] = q0;
    }
    if (q1) {
      g[count2++] = q1;
    }
    if (!count2) {
      g[count2++] = 0;
    }
    g.length = count2;
    return g;
  }
  return robustDiff;
}
var hasRequiredOrientation;
function requireOrientation() {
  if (hasRequiredOrientation) return orientation.exports;
  hasRequiredOrientation = 1;
  (function(module2) {
    var twoProduct = requireTwoProduct();
    var robustSum2 = requireRobustSum();
    var robustScale2 = requireRobustScale();
    var robustSubtract = requireRobustDiff();
    var NUM_EXPAND = 5;
    var EPSILON = 11102230246251565e-32;
    var ERRBOUND3 = (3 + 16 * EPSILON) * EPSILON;
    var ERRBOUND4 = (7 + 56 * EPSILON) * EPSILON;
    function orientation_3(sum2, prod2, scale, sub2) {
      return function orientation3Exact2(m0, m1, m2) {
        var p = sum2(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])));
        var n = sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0]));
        var d = sub2(p, n);
        return d[d.length - 1];
      };
    }
    function orientation_4(sum2, prod2, scale, sub2) {
      return function orientation4Exact2(m0, m1, m2, m3) {
        var p = sum2(sum2(scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), -m2[2]), scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m3[2]))), sum2(scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m3[2]))));
        var n = sum2(sum2(scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), -m2[2]), scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), m3[2]))), sum2(scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m2[2]))));
        var d = sub2(p, n);
        return d[d.length - 1];
      };
    }
    function orientation_5(sum2, prod2, scale, sub2) {
      return function orientation5Exact(m0, m1, m2, m3, m4) {
        var p = sum2(sum2(sum2(scale(sum2(scale(sum2(prod2(m3[1], m4[0]), prod2(-m4[1], m3[0])), m2[2]), sum2(scale(sum2(prod2(m2[1], m4[0]), prod2(-m4[1], m2[0])), -m3[2]), scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m4[2]))), m1[3]), sum2(scale(sum2(scale(sum2(prod2(m3[1], m4[0]), prod2(-m4[1], m3[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m4[0]), prod2(-m4[1], m1[0])), -m3[2]), scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum2(scale(sum2(prod2(m2[1], m4[0]), prod2(-m4[1], m2[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m4[0]), prod2(-m4[1], m1[0])), -m2[2]), scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m4[2]))), m3[3]))), sum2(scale(sum2(scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), -m2[2]), scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m3[2]))), -m4[3]), sum2(scale(sum2(scale(sum2(prod2(m3[1], m4[0]), prod2(-m4[1], m3[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m4[0]), prod2(-m4[1], m1[0])), -m3[2]), scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum2(scale(sum2(prod2(m3[1], m4[0]), prod2(-m4[1], m3[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m4[0]), prod2(-m4[1], m0[0])), -m3[2]), scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum2(sum2(scale(sum2(scale(sum2(prod2(m1[1], m4[0]), prod2(-m4[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m4[0]), prod2(-m4[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m4[2]))), m3[3]), sum2(scale(sum2(scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum2(scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), -m2[2]), scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m3[2]))), m0[3]))), sum2(scale(sum2(scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), -m2[2]), scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), m3[2]))), -m1[3]), sum2(scale(sum2(scale(sum2(prod2(m1[1], m3[0]), prod2(-m3[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum2(scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m2[2]))), -m3[3])))));
        var n = sum2(sum2(sum2(scale(sum2(scale(sum2(prod2(m3[1], m4[0]), prod2(-m4[1], m3[0])), m2[2]), sum2(scale(sum2(prod2(m2[1], m4[0]), prod2(-m4[1], m2[0])), -m3[2]), scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum2(scale(sum2(prod2(m3[1], m4[0]), prod2(-m4[1], m3[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m4[0]), prod2(-m4[1], m0[0])), -m3[2]), scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), m4[2]))), -m2[3])), sum2(scale(sum2(scale(sum2(prod2(m2[1], m4[0]), prod2(-m4[1], m2[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m4[0]), prod2(-m4[1], m0[0])), -m2[2]), scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum2(scale(sum2(prod2(m2[1], m3[0]), prod2(-m3[1], m2[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m3[0]), prod2(-m3[1], m0[0])), -m2[2]), scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum2(sum2(scale(sum2(scale(sum2(prod2(m2[1], m4[0]), prod2(-m4[1], m2[0])), m1[2]), sum2(scale(sum2(prod2(m1[1], m4[0]), prod2(-m4[1], m1[0])), -m2[2]), scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum2(scale(sum2(prod2(m2[1], m4[0]), prod2(-m4[1], m2[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m4[0]), prod2(-m4[1], m0[0])), -m2[2]), scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), m4[2]))), -m1[3])), sum2(scale(sum2(scale(sum2(prod2(m1[1], m4[0]), prod2(-m4[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m4[0]), prod2(-m4[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum2(scale(sum2(prod2(m1[1], m2[0]), prod2(-m2[1], m1[0])), m0[2]), sum2(scale(sum2(prod2(m0[1], m2[0]), prod2(-m2[1], m0[0])), -m1[2]), scale(sum2(prod2(m0[1], m1[0]), prod2(-m1[1], m0[0])), m2[2]))), -m4[3]))));
        var d = sub2(p, n);
        return d[d.length - 1];
      };
    }
    function orientation2(n) {
      var fn = n === 3 ? orientation_3 : n === 4 ? orientation_4 : orientation_5;
      return fn(robustSum2, twoProduct, robustScale2, robustSubtract);
    }
    var orientation3Exact = orientation2(3);
    var orientation4Exact = orientation2(4);
    var CACHED = [function orientation0() {
      return 0;
    }, function orientation1() {
      return 0;
    }, function orientation22(a, b) {
      return b[0] - a[0];
    }, function orientation3(a, b, c) {
      var l = (a[1] - c[1]) * (b[0] - c[0]);
      var r2 = (a[0] - c[0]) * (b[1] - c[1]);
      var det = l - r2;
      var s;
      if (l > 0) {
        if (r2 <= 0) {
          return det;
        } else {
          s = l + r2;
        }
      } else if (l < 0) {
        if (r2 >= 0) {
          return det;
        } else {
          s = -(l + r2);
        }
      } else {
        return det;
      }
      var tol = ERRBOUND3 * s;
      if (det >= tol || det <= -tol) {
        return det;
      }
      return orientation3Exact(a, b, c);
    }, function orientation4(a, b, c, d) {
      var adx = a[0] - d[0];
      var bdx = b[0] - d[0];
      var cdx = c[0] - d[0];
      var ady = a[1] - d[1];
      var bdy = b[1] - d[1];
      var cdy = c[1] - d[1];
      var adz = a[2] - d[2];
      var bdz = b[2] - d[2];
      var cdz = c[2] - d[2];
      var bdxcdy = bdx * cdy;
      var cdxbdy = cdx * bdy;
      var cdxady = cdx * ady;
      var adxcdy = adx * cdy;
      var adxbdy = adx * bdy;
      var bdxady = bdx * ady;
      var det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
      var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
      var tol = ERRBOUND4 * permanent;
      if (det > tol || -det > tol) {
        return det;
      }
      return orientation4Exact(a, b, c, d);
    }];
    function slowOrient(args) {
      var proc2 = CACHED[args.length];
      if (!proc2) {
        proc2 = CACHED[args.length] = orientation2(args.length);
      }
      return proc2.apply(void 0, args);
    }
    function proc(slow, o0, o1, o2, o3, o4, o5) {
      return function getOrientation(a0, a1, a2, a3, a4) {
        switch (arguments.length) {
          case 0:
          case 1:
            return 0;
          case 2:
            return o2(a0, a1);
          case 3:
            return o3(a0, a1, a2);
          case 4:
            return o4(a0, a1, a2, a3);
          case 5:
            return o5(a0, a1, a2, a3, a4);
        }
        var s = new Array(arguments.length);
        for (var i = 0; i < arguments.length; ++i) {
          s[i] = arguments[i];
        }
        return slow(s);
      };
    }
    function generateOrientationProc() {
      while (CACHED.length <= NUM_EXPAND) {
        CACHED.push(orientation2(CACHED.length));
      }
      module2.exports = proc.apply(void 0, [slowOrient].concat(CACHED));
      for (var i = 0; i <= NUM_EXPAND; ++i) {
        module2.exports[i] = CACHED[i];
      }
    }
    generateOrientationProc();
  })(orientation);
  return orientation.exports;
}
var robustPnp;
var hasRequiredRobustPnp;
function requireRobustPnp() {
  if (hasRequiredRobustPnp) return robustPnp;
  hasRequiredRobustPnp = 1;
  robustPnp = robustPointInPolygon;
  var orient = requireOrientation();
  function robustPointInPolygon(vs, point2) {
    var x = point2[0];
    var y = point2[1];
    var n = vs.length;
    var inside = 1;
    var lim = n;
    for (var i = 0, j = n - 1; i < lim; j = i++) {
      var a = vs[i];
      var b = vs[j];
      var yi = a[1];
      var yj = b[1];
      if (yj < yi) {
        if (yj < y && y < yi) {
          var s = orient(a, b, point2);
          if (s === 0) {
            return 0;
          } else {
            inside ^= 0 < s | 0;
          }
        } else if (y === yi) {
          var c = vs[(i + 1) % n];
          var yk = c[1];
          if (yi < yk) {
            var s = orient(a, b, point2);
            if (s === 0) {
              return 0;
            } else {
              inside ^= 0 < s | 0;
            }
          }
        }
      } else if (yi < yj) {
        if (yi < y && y < yj) {
          var s = orient(a, b, point2);
          if (s === 0) {
            return 0;
          } else {
            inside ^= s < 0 | 0;
          }
        } else if (y === yi) {
          var c = vs[(i + 1) % n];
          var yk = c[1];
          if (yk < yi) {
            var s = orient(a, b, point2);
            if (s === 0) {
              return 0;
            } else {
              inside ^= s < 0 | 0;
            }
          }
        }
      } else if (y === yi) {
        var x02 = Math.min(a[0], b[0]);
        var x12 = Math.max(a[0], b[0]);
        if (i === 0) {
          while (j > 0) {
            var k = (j + n - 1) % n;
            var p = vs[k];
            if (p[1] !== y) {
              break;
            }
            var px = p[0];
            x02 = Math.min(x02, px);
            x12 = Math.max(x12, px);
            j = k;
          }
          if (j === 0) {
            if (x02 <= x && x <= x12) {
              return 0;
            }
            return 1;
          }
          lim = j + 1;
        }
        var y02 = vs[(j + n - 1) % n][1];
        while (i + 1 < lim) {
          var p = vs[i + 1];
          if (p[1] !== y) {
            break;
          }
          var px = p[0];
          x02 = Math.min(x02, px);
          x12 = Math.max(x12, px);
          i += 1;
        }
        if (x02 <= x && x <= x12) {
          return 0;
        }
        var y12 = vs[(i + 1) % n][1];
        if (x < x02 && y02 < y !== y12 < y) {
          inside ^= 1;
        }
      }
    }
    return 2 * inside - 1;
  }
  return robustPnp;
}
var robustPnpExports = requireRobustPnp();
const classifyPoint = /* @__PURE__ */ getDefaultExportFromCjs(robustPnpExports);
function _classCallCheck$Z(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$Z(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$Z(o.key), o);
  }
}
function _createClass$Z(e, r2, t) {
  return r2 && _defineProperties$Z(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$Z(t) {
  var i = _toPrimitive$Z(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$Z(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let Track = /* @__PURE__ */ (function() {
  function Track2(context, options2) {
    _classCallCheck$Z(this, Track2);
    this.context = context;
    const {
      id: id2,
      pubSub,
      getTheme
    } = context;
    this.pubSub = pubSub ?? fakePubSub;
    this.id = id2;
    this._xScale = linear();
    this._yScale = linear();
    this._refXScale = linear();
    this._refYScale = linear();
    this.position = [0, 0];
    this.dimensions = [1, 1];
    this.options = options2;
    this.pubSubs = [];
    this.getTheme = getTheme ?? (() => void 0);
    this.pubSubs.push(this.pubSub.subscribe("app.mouseMove", this.defaultMouseMoveHandler.bind(this)));
    this.isLeftModified = false;
  }
  return _createClass$Z(Track2, [{
    key: "isWithin",
    value: function isWithin$1(x, y) {
      let xx = x;
      let yy = y;
      let left2 = this.position[0];
      let top2 = this.position[1];
      if (this.isLeftModified) {
        xx = y;
        yy = x;
        left2 = this.position[1];
        top2 = this.position[0];
      }
      return isWithin(xx, yy, left2, this.dimensions[0] + left2, top2, this.dimensions[1] + top2);
    }
    /**
     * Get a property from the track.
     * @template {keyof this} T
     * @param {T} prop - The property to get.
     * @return {() => this[T]}
     */
  }, {
    key: "getProp",
    value: function getProp(prop2) {
      return () => this[prop2];
    }
  }, {
    key: "getData",
    value: function getData2() {
    }
    /**
     * Capture click events. x and y are relative to the track position
     * @template T
     * @param {number} x - X position of the click event.
     * @param {number} y - Y position of the click event.
     * @param {T} evt - The event.
     * @return {{ type: 'generic', event: T, payload: null }}
     */
  }, {
    key: "click",
    value: function click(x, y, evt) {
      return {
        type: "generic",
        event: evt,
        payload: null
      };
    }
    /** There was a click event outside the track * */
  }, {
    key: "clickOutside",
    value: function clickOutside() {
    }
    /** @returns {[number, number]} */
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return this.dimensions;
    }
    /** @param {[number, number]} newDimensions */
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      this._xScale.range([0, this.dimensions[0]]);
      this._yScale.range([0, this.dimensions[1]]);
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the reference xScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "refXScale",
    value: function refXScale(scale) {
      if (!scale) return this._refXScale;
      this._refXScale = scale;
      return this;
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the reference yScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "refYScale",
    value: function refYScale(scale) {
      if (!scale) return this._refYScale;
      this._refYScale = scale;
      return this;
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the xScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "xScale",
    value: function xScale(scale) {
      if (!scale) return this._xScale;
      this._xScale = scale;
      return this;
    }
    /**
     * @overload
     * @return {import('./types').Scale}
     */
    /**
     * @overload
     * @param {import('./types').Scale} scale
     * @return {this}
     */
    /**
     * Either get or set the yScale
     *
     * @param {import('./types').Scale=} scale
     * @return {import('./types').Scale | this}
     */
  }, {
    key: "yScale",
    value: function yScale(scale) {
      if (!scale) return this._yScale;
      this._yScale = scale;
      return this;
    }
    /**
     * @param {import('./types').Scale} newXScale
     * @param {import('./types').Scale} newYScale
     * @returns {void}
     */
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
    }
    /**
     * @param {import('./types').Scale} refXScale
     * @param {import('./types').Scale} refYScale
     * @returns {void}
     */
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      this._refXScale = refXScale;
      this._refYScale = refYScale;
    }
    /** @returns {void} */
  }, {
    key: "draw",
    value: function draw() {
    }
    /** @returns {[number, number]} */
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this.position;
    }
    /**
     * @param {[number, number]} newPosition
     * @returns {void}
     */
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
    }
    /**
     * A blank handler for MouseMove / Zoom events. Should be overriden
     * by individual tracks to provide
     *
     * @param {{}} evt
     * @returns {void}
     */
  }, {
    key: "defaultMouseMoveHandler",
    value: function defaultMouseMoveHandler(evt) {
    }
    /** @returns {void} */
  }, {
    key: "remove",
    value: function remove2() {
      this.pubSubs.forEach((subscription) => this.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
    }
    /**
     * @param {Options} options
     * @returns {void}
     */
  }, {
    key: "rerender",
    value: function rerender(options2) {
    }
    /**
     * This function is for seeing whether this track should respond
     * to events at this mouse position. The difference to `isWithin()` is that it
     * can be overwritten if a track is inactive for example.
     *
     * @param {number} x - X position to be tested.
     * @param {number} y - Y position to be tested.
     * @returns {boolean}
     */
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition(x, y) {
      return this.isWithin(x, y);
    }
    /**
     * @param {number} trackY
     * @param {number} kMultiplier
     * @returns {void}
     */
  }, {
    key: "zoomedY",
    value: function zoomedY2(trackY, kMultiplier) {
    }
    /**
     * @param {number} dY
     * @returns {void}
     */
  }, {
    key: "movedY",
    value: function movedY2(dY) {
    }
  }]);
})();
function _classCallCheck$Y(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$Y(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$Y(o.key), o);
  }
}
function _createClass$Y(e, r2, t) {
  return r2 && _defineProperties$Y(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$Y(t) {
  var i = _toPrimitive$Y(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$Y(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$T(t, o, e) {
  return o = _getPrototypeOf$T(o), _possibleConstructorReturn$T(t, _isNativeReflectConstruct$T() ? Reflect.construct(o, e || [], _getPrototypeOf$T(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$T(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$T(t);
}
function _assertThisInitialized$T(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$T() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$T = function() {
    return !!t;
  })();
}
function _superPropGet$C(t, o, e, r2) {
  var p = _get$C(_getPrototypeOf$T(t.prototype), o, e);
  return "function" == typeof p ? function(t22) {
    return p.apply(e, t22);
  } : p;
}
function _get$C() {
  return _get$C = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$C(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$C.apply(null, arguments);
}
function _superPropBase$C(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$T(t)); ) ;
  return t;
}
function _getPrototypeOf$T(t) {
  return _getPrototypeOf$T = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$T(t);
}
function _inherits$T(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$T(t, e);
}
function _setPrototypeOf$T(t, e) {
  return _setPrototypeOf$T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$T(t, e);
}
function formatResolutionText(resolution, maxResolutionSize) {
  const pp = precisionPrefix(maxResolutionSize, resolution);
  const f2 = formatPrefix(`.${pp}`, resolution);
  const formattedResolution = f2(resolution);
  return formattedResolution;
}
function getResolutionBasedResolutionText(resolutions, zoomLevel) {
  const sortedResolutions = resolutions.map((x) => +x).sort((a, b) => b - a);
  const resolution = sortedResolutions[zoomLevel];
  const maxResolutionSize = sortedResolutions[sortedResolutions.length - 1];
  return formatResolutionText(resolution, maxResolutionSize);
}
function getWidthBasedResolutionText(zoomLevel, maxWidth, binsPerDimension, maxZoom) {
  const resolution = maxWidth / (2 ** zoomLevel * binsPerDimension);
  if (!Number.isNaN(resolution)) {
    const maxResolutionSize = maxWidth / (2 ** maxZoom * binsPerDimension);
    const pp = precisionPrefix(maxResolutionSize, resolution);
    const f2 = formatPrefix(`.${pp}`, resolution);
    const formattedResolution = f2(resolution);
    return formattedResolution;
  }
  console.warn("NaN resolution, screen is probably too small.");
  return "";
}
let PixiTrack = /* @__PURE__ */ (function(_Track) {
  function PixiTrack2(context, options2) {
    var _this;
    _classCallCheck$Y(this, PixiTrack2);
    _this = _callSuper$T(this, PixiTrack2, [context, options2]);
    const {
      scene
    } = context;
    _this.scene = scene;
    _this.delayDrawing = false;
    _this.pBase = new GLOBALS.PIXI.Graphics();
    _this.pMasked = new GLOBALS.PIXI.Graphics();
    _this.pMask = new GLOBALS.PIXI.Graphics();
    _this.pMain = new GLOBALS.PIXI.Graphics();
    _this.pBorder = new GLOBALS.PIXI.Graphics();
    _this.pBackground = new GLOBALS.PIXI.Graphics();
    _this.pForeground = new GLOBALS.PIXI.Graphics();
    _this.pLabel = new GLOBALS.PIXI.Graphics();
    _this.pMobile = new GLOBALS.PIXI.Graphics();
    _this.pAxis = new GLOBALS.PIXI.Graphics();
    _this.pMouseOver = new GLOBALS.PIXI.Graphics();
    _this.scene.addChild(_this.pBase);
    _this.pBase.addChild(_this.pMasked);
    _this.pMasked.addChild(_this.pBackground);
    _this.pMasked.addChild(_this.pMain);
    _this.pMasked.addChild(_this.pMask);
    _this.pMasked.addChild(_this.pMobile);
    _this.pMasked.addChild(_this.pBorder);
    _this.pMasked.addChild(_this.pLabel);
    _this.pMasked.addChild(_this.pForeground);
    _this.pMasked.addChild(_this.pMouseOver);
    _this.pBase.addChild(_this.pAxis);
    _this.pMasked.mask = _this.pMask;
    _this.prevOptions = "";
    _this.options = Object.assign(_this.options, options2);
    const labelTextText = _this.getName();
    _this.labelTextFontFamily = "Arial";
    _this.labelTextFontSize = 12;
    _this.labelXOffset = 0;
    _this.labelText = new GLOBALS.PIXI.Text(labelTextText, {
      fontSize: `${_this.labelTextFontSize}px`,
      fontFamily: _this.labelTextFontFamily,
      fill: "black"
    });
    _this.pLabel.addChild(_this.labelText);
    _this.errorText = new GLOBALS.PIXI.Text("", {
      fontSize: "12px",
      fontFamily: "Arial",
      fill: "red"
    });
    _this.errorText.anchor.x = 0.5;
    _this.errorText.anchor.y = 0.5;
    _this.pLabel.addChild(_this.errorText);
    _this.flipText = false;
    _this.tilesetInfo = void 0;
    _this.errorTexts = {};
    return _this;
  }
  _inherits$T(PixiTrack2, _Track);
  return _createClass$Y(PixiTrack2, [{
    key: "setLabelText",
    value: function setLabelText() {
    }
    /** @param {[number, number]} newPosition */
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      this.drawBorder();
      this.drawLabel();
      this.drawBackground();
      this.setMask(this.position, this.dimensions);
      this.setForeground();
    }
    /** @param {[number, number]} newDimensions */
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$C(PixiTrack2, "setDimensions", this)([newDimensions]);
      this.drawBorder();
      this.drawLabel();
      this.drawBackground();
      this.setMask(this.position, this.dimensions);
      this.setForeground();
    }
    /**
     * @param {[number, number]} position
     * @param {[number, number]} dimensions
     */
  }, {
    key: "setMask",
    value: function setMask(position, dimensions) {
      this.pMask.clear();
      this.pMask.beginFill();
      this.pMask.drawRect(position[0], position[1], dimensions[0], dimensions[1]);
      this.pMask.endFill();
    }
  }, {
    key: "setForeground",
    value: function setForeground() {
      this.pForeground.position.y = this.position[1];
      this.pForeground.position.x = this.position[0];
    }
    /**
     * We're going to destroy this object, so we need to detach its
     * graphics from the scene
     */
  }, {
    key: "remove",
    value: function remove2() {
      this.pBase.clear();
      this.scene.removeChild(this.pBase);
    }
    /**
     * Draw a border around each track.
     */
  }, {
    key: "drawBorder",
    value: function drawBorder() {
      const graphics = this.pBorder;
      graphics.clear();
      if (!this.options || !this.options.trackBorderWidth) return;
      const stroke = colorToHex(this.options.trackBorderColor ? this.options.trackBorderColor : "white");
      graphics.lineStyle(this.options.trackBorderWidth, stroke);
      graphics.drawRect(this.position[0], this.position[1], this.dimensions[0], this.dimensions[1]);
    }
    /** Set an error for this track.
     *
     * The error can be associated with a source so that multiple
     * components within the track can set their own independent errors
     * that will be displayed to the user without overlapping.
     *
     * @param {string} error The error text
     * @param {string} source The source of the error
     */
  }, {
    key: "setError",
    value: function setError(error, source) {
      this.errorTexts[source] = error;
      this.drawError();
    }
  }, {
    key: "drawError",
    value: function drawError() {
      this.errorText.x = this.position[0] + this.dimensions[0] / 2;
      this.errorText.y = this.position[1] + this.dimensions[1] / 2;
      const errorTextText = Object.values(this.errorTexts).filter((x) => x?.length).reduce((acc, x) => acc ? `${acc}
${x}` : x, "");
      this.errorText.text = errorTextText;
      this.errorText.alpha = 0.8;
      if (errorTextText?.length) {
        const graphics = this.pBorder;
        graphics.clear();
        graphics.lineStyle(1, colorToHex("red"));
        graphics.drawRect(this.position[0], this.position[1], this.dimensions[0], this.dimensions[1]);
      } else {
        this.pBorder.clear();
      }
    }
  }, {
    key: "drawBackground",
    value: function drawBackground() {
      const graphics = this.pBackground;
      graphics.clear();
      if (!this.options || !this.options.backgroundColor) {
        return;
      }
      let opacity = 1;
      let color2 = this.options.backgroundColor;
      if (this.options.backgroundColor === "transparent") {
        opacity = 0;
        color2 = "white";
      }
      const hexColor = colorToHex(color2);
      graphics.beginFill(hexColor, opacity);
      graphics.drawRect(this.position[0], this.position[1], this.dimensions[0], this.dimensions[1]);
    }
    /**
     * Determine the label color based on the number of options.
     *
     * @return {string} The color to use for the label.
     */
  }, {
    key: "getLabelColor",
    value: function getLabelColor() {
      if (this.options.labelColor && this.options.labelColor !== "[glyph-color]") {
        return this.options.labelColor;
      }
      return this.options.lineStrokeColor || this.options.barFillColor || "black";
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.options.name ? this.options.name : this.tilesetInfo?.name || "";
    }
  }, {
    key: "drawLabel",
    value: function drawLabel() {
      if (!this.labelText) return;
      const graphics = this.pLabel;
      graphics.clear();
      if (!this.options || !this.options.labelPosition || this.options.labelPosition === "hidden") {
        this.labelText.alpha = 0;
        return;
      }
      const {
        labelBackgroundColor = "white",
        labelBackgroundOpacity = 0.5
      } = this.options;
      graphics.beginFill(colorToHex(labelBackgroundColor), +labelBackgroundOpacity);
      const fontColor = colorToHex(this.getLabelColor());
      const labelBackgroundMargin = 2;
      if (this.dimensions[0] < 0) {
        return;
      }
      let labelTextText = this.options.labelShowAssembly && this.tilesetInfo && this.tilesetInfo.coordSystem ? `${this.tilesetInfo.coordSystem} | ` : "";
      labelTextText += this.getName();
      if (this.options.labelShowResolution && isLegacyTilesetInfo(this.tilesetInfo) && this.tilesetInfo.bins_per_dimension) {
        const formattedResolution = getWidthBasedResolutionText(this.calculateZoomLevel(), this.tilesetInfo.max_width, this.tilesetInfo.bins_per_dimension, this.tilesetInfo.max_zoom);
        labelTextText += `
[Current data resolution: ${formattedResolution}]`;
      } else if (this.options.labelShowResolution && isResolutionsTilesetInfo(this.tilesetInfo)) {
        const formattedResolution = getResolutionBasedResolutionText(this.tilesetInfo.resolutions, this.calculateZoomLevel());
        labelTextText += `
[Current data resolution: ${formattedResolution}]`;
      }
      if (this.options?.dataTransform) {
        let chosenTransform = null;
        if (this.tilesetInfo?.transforms) {
          for (const transform2 of this.tilesetInfo.transforms) {
            if (transform2.value === this.options.dataTransform) {
              chosenTransform = transform2;
            }
          }
        }
        if (chosenTransform) {
          labelTextText += `
[Transform: ${chosenTransform.name}]`;
        } else if (this.options.dataTransform === "None") {
          labelTextText += "\n[Transform: None ]";
        } else {
          labelTextText += "\n[Transform: Default ]";
        }
      }
      this.labelText.text = labelTextText;
      this.labelText.style = {
        fontSize: `${this.labelTextFontSize}px`,
        fontFamily: this.labelTextFontFamily,
        fill: fontColor
      };
      this.labelText.alpha = typeof this.options.labelTextOpacity !== "undefined" ? this.options.labelTextOpacity : 1;
      this.labelText.visible = true;
      if (this.flipText) {
        this.labelText.scale.x = -1;
      }
      const {
        labelLeftMargin = 0,
        labelRightMargin = 0,
        labelTopMargin = 0,
        labelBottomMargin = 0
      } = this.options;
      if (this.options.labelPosition === "topLeft") {
        this.labelText.x = this.position[0] + labelLeftMargin + this.labelXOffset;
        this.labelText.y = this.position[1] + labelTopMargin;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0;
        this.labelText.x += this.labelText.width / 2;
        graphics.drawRect(this.position[0] + labelLeftMargin + this.labelXOffset, this.position[1] + labelTopMargin, this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "bottomLeft" && !this.flipText || this.options.labelPosition === "topRight" && this.flipText) {
        this.labelText.x = this.position[0] + (labelLeftMargin || labelTopMargin);
        this.labelText.y = this.position[1] + this.dimensions[1] - (labelBottomMargin || labelRightMargin);
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 1;
        this.labelText.x += this.labelText.width / 2 + this.labelXOffset;
        graphics.drawRect(this.position[0] + (labelLeftMargin || labelTopMargin) + this.labelXOffset, this.position[1] + this.dimensions[1] - this.labelText.height - labelBackgroundMargin - (labelBottomMargin || labelRightMargin), this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "topRight" && !this.flipText || this.options.labelPosition === "bottomLeft" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0] - (labelRightMargin || labelBottomMargin);
        this.labelText.y = this.position[1] + (labelTopMargin || labelLeftMargin);
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0;
        this.labelText.x -= this.labelText.width / 2 + this.labelXOffset;
        graphics.drawRect(this.position[0] + this.dimensions[0] - this.labelText.width - labelBackgroundMargin - (labelRightMargin || labelBottomMargin) - this.labelXOffset, this.position[1] + (labelTopMargin || labelLeftMargin), this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "bottomRight") {
        this.labelText.x = this.position[0] + this.dimensions[0] - labelRightMargin;
        this.labelText.y = this.position[1] + this.dimensions[1] - labelBottomMargin;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 1;
        this.labelText.x -= this.labelText.width / 2 + this.labelXOffset;
        graphics.drawRect(this.position[0] + this.dimensions[0] - this.labelText.width - labelBackgroundMargin - labelRightMargin - this.labelXOffset, this.position[1] + this.dimensions[1] - this.labelText.height - labelBackgroundMargin - labelBottomMargin, this.labelText.width + labelBackgroundMargin, this.labelText.height + labelBackgroundMargin);
      } else if (this.options.labelPosition === "outerLeft" && !this.flipText || this.options.labelPosition === "outerTop" && this.flipText) {
        this.labelText.x = this.position[0];
        this.labelText.y = this.position[1] + this.dimensions[1] / 2;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.x -= this.labelText.width / 2 + 3;
      } else if (this.options.labelPosition === "outerTop" && !this.flipText || this.options.labelPosition === "outerLeft" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0] / 2;
        this.labelText.y = this.position[1];
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.y -= this.labelText.height / 2 + 3;
      } else if (this.options.labelPosition === "outerBottom" && !this.flipText || this.options.labelPosition === "outerRight" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0] / 2;
        this.labelText.y = this.position[1] + this.dimensions[1];
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.y += this.labelText.height / 2 + 3;
      } else if (this.options.labelPosition === "outerRight" && !this.flipText || this.options.labelPosition === "outerBottom" && this.flipText) {
        this.labelText.x = this.position[0] + this.dimensions[0];
        this.labelText.y = this.position[1] + this.dimensions[1] / 2;
        this.labelText.anchor.x = 0.5;
        this.labelText.anchor.y = 0.5;
        this.labelText.x += this.labelText.width / 2 + 3;
      } else {
        this.labelText.visible = false;
      }
      if (this.options.labelPosition === "outerLeft" || this.options.labelPosition === "outerRight" || this.options.labelPosition === "outerTop" || this.options.labelPosition === "outerBottom") {
        this.pLabel.setParent(this.pBase);
      } else {
        this.pLabel.setParent(this.pMasked);
      }
    }
    /** @param {Options} options */
  }, {
    key: "rerender",
    value: function rerender(options2) {
      this.options = options2;
      this.draw();
      this.drawBackground();
      this.drawLabel();
      this.drawError();
      this.drawBorder();
    }
    /**
     * Draw all the data associated with this track
     */
  }, {
    key: "draw",
    value: function draw() {
      this.drawError();
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {[HTMLElement, HTMLElement]} The two returned DOM nodes are both SVG
     * elements [base, track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      const gBase = document.createElement("g");
      const rectBackground = document.createElement("rect");
      rectBackground.setAttribute("x", `${this.position[0]}`);
      rectBackground.setAttribute("y", `${this.position[1]}`);
      rectBackground.setAttribute("width", `${this.dimensions[0]}`);
      rectBackground.setAttribute("height", `${this.dimensions[1]}`);
      if (this.options?.backgroundColor) {
        rectBackground.setAttribute("fill", this.options.backgroundColor);
      } else {
        rectBackground.setAttribute("fill-opacity", "0");
      }
      const gClipped = document.createElement("g");
      gClipped.setAttribute("class", "g-clipped");
      gBase.appendChild(gClipped);
      gClipped.appendChild(rectBackground);
      const gTrack = document.createElement("g");
      gClipped.setAttribute("class", "g-track");
      gClipped.appendChild(gTrack);
      const gLabels = document.createElement("g");
      gClipped.setAttribute("class", "g-labels");
      gClipped.appendChild(gLabels);
      const clipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
      gBase.appendChild(clipPath);
      const clipPolygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
      clipPath.appendChild(clipPolygon);
      clipPolygon.setAttribute("points", `${this.position[0]},${this.position[1]} ${this.position[0] + this.dimensions[0]},${this.position[1]} ${this.position[0] + this.dimensions[0]},${this.position[1] + this.dimensions[1]} ${this.position[0]},${this.position[1] + this.dimensions[1]} `);
      const clipPathId = slugid.nice();
      clipPath.setAttribute("id", clipPathId);
      gClipped.setAttribute("style", `clip-path:url(#${clipPathId});`);
      const lineParts = this.labelText.text.split("\n");
      let ddy = 0;
      const paddingBottom = 3;
      const labelTextHeight = (this.labelTextFontSize + 2) * lineParts.length + paddingBottom;
      if (this.labelText.anchor.y === 0.5) {
        ddy = labelTextHeight / 2;
      } else if (this.labelText.anchor.y === 1) {
        ddy = -labelTextHeight;
      }
      for (let i = 0; i < lineParts.length; i++) {
        const text2 = document.createElement("text");
        text2.setAttribute("font-family", this.labelTextFontFamily);
        text2.setAttribute("font-size", `${this.labelTextFontSize}px`);
        text2.innerText = lineParts[i];
        if (this.options.labelPosition === "topLeft" || this.options.labelPosition === "topRight") {
          const dy = ddy + (i + 1) * (this.labelTextFontSize + 2);
          text2.setAttribute("dy", String(dy));
        } else if (this.options.labelPosition === "bottomLeft" || this.options.labelPosition === "bottomRight") {
          text2.setAttribute("dy", String(ddy + i * (this.labelTextFontSize + 2)));
        }
        text2.setAttribute("fill", this.options.labelColor ?? "");
        if (this.labelText.anchor.x === 0.5) {
          text2.setAttribute("text-anchor", "middle");
        } else if (this.labelText.anchor.x === 1) {
          text2.setAttribute("text-anchor", "end");
        }
        gLabels.appendChild(text2);
      }
      gLabels.setAttribute("transform", `translate(${this.labelText.x},${this.labelText.y})scale(${this.labelText.scale.x},1)`);
      return [gBase, gTrack];
    }
    /**
     * @returns {number}
     */
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      throw new Error("Must be implemented by subclass");
    }
  }]);
})(Track);
function assert(expression, msg = "") {
  if (!expression) throw new Error(msg);
}
function _classCallCheck$X(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$X(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$X(o.key), o);
  }
}
function _createClass$X(e, r2, t) {
  return r2 && _defineProperties$X(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$X(t) {
  var i = _toPrimitive$X(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$X(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function isTuple(x) {
  return x.length === 2;
}
function createDefaultTileSource(pubSub) {
  return {
    async fetchTiles(request2) {
      const tileData = await fetchTilesDebounced(request2, pubSub);
      return tileData;
    },
    fetchTilesetInfo({
      server,
      tilesetUid
    }) {
      return new Promise((resolve, reject) => {
        trackInfo(server, tilesetUid, resolve, reject, pubSub);
      });
    },
    registerTileset({
      server,
      url,
      filetype,
      coordSystem
    }) {
      const serverUrl = `${trimTrailingSlash(server)}/register_url/`;
      const payload = {
        fileurl: url,
        filetype,
        coordSystem
      };
      return fetch(serverUrl, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
    }
  };
}
let DataFetcher = /* @__PURE__ */ (function() {
  function DataFetcher2(dataConfig, pubSub, tileSource) {
    _classCallCheck$X(this, DataFetcher2);
    this._tileSource = tileSource || createDefaultTileSource(pubSub);
    this.tilesetInfoLoading = true;
    if (!dataConfig) {
      console.error("No dataconfig provided");
      return;
    }
    this.dataConfig = JSON.parse(JSON.stringify(dataConfig));
    this.uuid = slugid.nice();
    this.pubSub = pubSub;
    if (dataConfig.children) {
      this.dataConfig.children = dataConfig.children.map((c) => new DataFetcher2(c, pubSub));
    }
  }
  return _createClass$X(DataFetcher2, [{
    key: "registerFileUrl",
    value: async function registerFileUrl({
      server,
      url,
      filetype,
      coordSystem
    }) {
      return this._tileSource.registerTileset({
        server,
        url,
        filetype,
        coordSystem
      });
    }
    /**
     * Obtain tileset infos for all of the tilesets listed
     * @param {HandleTilesetInfoFinished} finished - A callback that will be called
     */
  }, {
    key: "tilesetInfo",
    value: function tilesetInfo(finished) {
      const {
        server,
        url,
        filetype,
        coordSystem
      } = this.dataConfig;
      if (server && url && filetype) {
        return this.registerFileUrl({
          server,
          url,
          filetype,
          coordSystem
        }).then((data2) => data2.json()).then((data2) => {
          this.dataConfig.tilesetUid = data2.uid;
          this.tilesetInfoAfterRegister(finished);
        }).catch((rejected) => {
          console.error("Error registering url", rejected);
        });
      }
      return new Promise(() => {
        this.tilesetInfoAfterRegister(finished);
      });
    }
    /**
     * Obtain tileset infos for all of the tilesets listed
     *
     * If there is more than one tileset info, this function
     * should (not currently implemented) check if the tileset
     * infos have the same dimensions and then return a common
     * one.
     *
     * @param {HandleTilesetInfoFinished} finished - A callback that will be called
     *  when all tileset infos are loaded
     */
  }, {
    key: "tilesetInfoAfterRegister",
    value: function tilesetInfoAfterRegister(finished) {
      if (!this.dataConfig.children) {
        const {
          server,
          tilesetUid
        } = this.dataConfig;
        if (!server || !tilesetUid) {
          console.warn("No dataConfig children, server or tilesetUid:", this.dataConfig);
          finished(null);
        } else {
          this._tileSource.fetchTilesetInfo({
            server,
            tilesetUid
          }).then((tilesetInfo) => {
            this.dataConfig.tilesetInfo = tilesetInfo[tilesetUid];
            finished(tilesetInfo[tilesetUid], tilesetUid);
          }).catch((error) => {
            this.tilesetInfoLoading = false;
            finished({
              error
            });
          });
        }
      } else {
        const promises = this.dataConfig.children.map((x) => (
          /** @type {Promise<TilesetInfo>} */
          new Promise((resolve) => {
            x.tilesetInfo(resolve);
          })
        ));
        Promise.all(promises).then((values) => {
          finished(values[0]);
        });
      }
    }
    /**
     * @param {string} tilesetUid - Uid of the tileset on the server
     * @param {string} tileId - The tileId of the tile
     * @returns {string} The full tile id that the server will parse.
     *
     * @example
     * ```javascript
     * // returns 'xyxx.0.0.0'
     * fullTileId('xyxx', '0.0.0');
     * ```
     */
  }, {
    key: "fullTileId",
    value: function fullTileId(tilesetUid, tileId) {
      return `${tilesetUid}.${tileId}`;
    }
    /**
     * Fetch a set of tiles.
     *
     * Because the track shouldn't care about tileset ids, the tile ids
     * should just include positions and any necessary transforms.
     *
     * @param {(tiles: Record<string, DividedTile | Tile>) => void} receivedTiles - A function to call once the tiles have been fetched
     * @param {string[]} tileIds - The tile ids to fetch
     * @returns {Promise<Record<string, DividedTile | Tile>>}
     */
  }, {
    key: "fetchTilesDebounced",
    value: function fetchTilesDebounced2(receivedTiles, tileIds) {
      if (this.dataConfig.type === "horizontal-section") {
        return this.fetchHorizontalSection(receivedTiles, tileIds);
      }
      if (this.dataConfig.type === "vertical-section") {
        return this.fetchHorizontalSection(receivedTiles, tileIds, true);
      }
      if (!this.dataConfig.children && this.dataConfig.tilesetUid && this.dataConfig.server) {
        const promise = this._tileSource.fetchTiles({
          id: slugid.nice(),
          server: this.dataConfig.server,
          tileIds: tileIds.map((x) => `${this.dataConfig.tilesetUid}.${x}`),
          options: this.dataConfig.options
        });
        return (
          /** @type {Promise<Record<string, Tile>>} */
          promise.then((returnedTiles) => {
            const tilesetUid = dictValues(returnedTiles)[0].tilesetUid;
            const newTiles = {};
            for (let i = 0; i < tileIds.length; i++) {
              const fullTileId = this.fullTileId(tilesetUid, tileIds[i]);
              returnedTiles[fullTileId].tilePositionId = tileIds[i];
              newTiles[tileIds[i]] = returnedTiles[fullTileId];
            }
            receivedTiles(newTiles);
            return newTiles;
          })
        );
      }
      const promises = this.dataConfig.children?.map((x) => (
        /** @type {Promise<Record<string, Tile | DividedTile>>} */
        new Promise((resolve) => {
          x.fetchTilesDebounced(resolve, tileIds);
        })
      )) ?? [];
      return Promise.all(promises).then((returnedTiles) => {
        if (this.dataConfig.type === "divided" && isTuple(returnedTiles)) {
          const newTiles = this.makeDivided(returnedTiles, tileIds);
          receivedTiles(newTiles);
          return newTiles;
        }
        console.warn("Unimplemented dataConfig type. Returning first data source.", this.dataConfig);
        receivedTiles(returnedTiles[0]);
        return returnedTiles[0];
      });
    }
    /**
     * Return an array consisting of the division of the numerator
     * array by the denominator array
     *
     * @param {ArrayLike<number>} numeratorData - An array of numerical values
     * @param {ArrayLike<number>} denominatorData - An array of numerical values
     *
     * @returns {Float32Array} An array consisting of the division of the numerator by the denominator
     */
  }, {
    key: "divideData",
    value: function divideData(numeratorData, denominatorData) {
      const result = new Float32Array(numeratorData.length);
      for (let i = 0; i < result.length; i++) {
        if (denominatorData[i] === 0) result[i] = Number.NaN;
        else result[i] = numeratorData[i] / denominatorData[i];
      }
      return result;
    }
    /*
     * Take a horizontal slice across the returned tiles at the
     * given position.
     *
     * @param {list} returnedTiles: The tiles returned from a fetch request
     * @param {Number} sliceYPos: The y position across which to slice
     */
  }, {
    key: "horizontalSlice",
    value: function horizontalSlice() {
      return null;
    }
    /**
     * Extract a slice from a matrix at a given position.
     *
     * @param {Array<number> | Float32Array} inputData - An array containing a matrix stored row-wise
     * @param {Array<number>} arrayShape - The shape of the array, should be a
     *  two element array e.g. [256,256].
     * @param {number} sliceIndex - The index across which to take the slice
     * @param {number=} axis - The axis along which to take the slice
     * @returns {Array<number> | Float32Array} an array corresponding to a slice of this matrix
     */
  }, {
    key: "extractDataSlice",
    value: function extractDataSlice(inputData, arrayShape, sliceIndex, axis2) {
      if (!axis2) {
        return inputData.slice(arrayShape[1] * sliceIndex, arrayShape[1] * (sliceIndex + 1));
      }
      const returnArray = new Array(arrayShape[1]);
      for (let i = sliceIndex; i < inputData.length; i += arrayShape[0]) {
        returnArray[Math.floor(i / arrayShape[0])] = inputData[i];
      }
      return returnArray;
    }
    /**
     * Fetch a horizontal section of a 2D dataset
     * @param {(tiles: Record<string, Tile>) => void} receivedTiles - A function to call once the tiles have been fetched
     * @param {string[]} tileIds - The tile ids to fetch
     * @param {boolean=} vertical - Whether to fetch a vertical section
     * @returns {Promise<Record<string, Tile>>}
     */
  }, {
    key: "fetchHorizontalSection",
    value: function fetchHorizontalSection(receivedTiles, tileIds, vertical = false) {
      const newTileIds = [];
      const mirrored = [];
      const {
        slicePos,
        tilesetInfo,
        server
      } = this.dataConfig;
      assert(slicePos, "No slice position in dataConfig.");
      assert(server, "No server in dataConfig.");
      assert(tilesetInfo, "No tilesetInfo in dataConfig.");
      for (const tileId of tileIds) {
        const parts = tileId.split(".");
        const zoomLevel = +parts[0];
        const xTilePos = +parts[1];
        const scale = linear().domain([slicePos, slicePos]);
        let yTiles = [];
        if (isResolutionsTilesetInfo(tilesetInfo)) {
          const sortedResolutions = tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
          yTiles = calculateTilesFromResolution(sortedResolutions[zoomLevel], scale, tilesetInfo.min_pos[vertical ? 1 : 0], tilesetInfo.max_pos[vertical ? 1 : 0]);
        } else {
          yTiles = calculateTiles(zoomLevel, scale, tilesetInfo.min_pos[vertical ? 1 : 0], tilesetInfo.max_pos[vertical ? 1 : 0], tilesetInfo.max_zoom, tilesetInfo.max_width);
        }
        const sortedPosition = [xTilePos, yTiles[0]].sort((a, b) => a - b);
        if (sortedPosition[0] === xTilePos) {
          mirrored.push(false);
        } else {
          mirrored.push(true);
        }
        const newTileId = `${zoomLevel}.${sortedPosition[0]}.${sortedPosition[1]}`;
        newTileIds.push(newTileId);
      }
      const promise = this._tileSource.fetchTiles({
        id: slugid.nice(),
        server,
        tileIds: newTileIds.map((x) => `${this.dataConfig.tilesetUid}.${x}`)
      });
      return promise.then((returnedTiles) => {
        const tilesetUid = dictValues(returnedTiles)[0].tilesetUid;
        const newTiles = {};
        for (let i = 0; i < newTileIds.length; i++) {
          const parts = newTileIds[i].split(".");
          const zoomLevel = +parts[0];
          const xTilePos = +parts[1];
          const yTilePos = +parts[2];
          const sliceIndex = calculateTileAndPosInTile(
            tilesetInfo,
            // @ts-expect-error - This is undefined for legacy tilesets, but
            // `calculateTileAndPosInTile` ignores this argument with `resolutions`.
            // We should probably refactor `calculateTileAndPosInTile` to just take
            // the `tilesetInfo` object.
            tilesetInfo.max_width,
            tilesetInfo.min_pos[1],
            zoomLevel,
            +slicePos
          )[1];
          const fullTileId = this.fullTileId(tilesetUid, newTileIds[i]);
          const tile = returnedTiles[fullTileId];
          let dataSlice = null;
          if (xTilePos === yTilePos) {
            dataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex);
            const mirroredDataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex, 1);
            for (let j = 0; j < dataSlice.length; j++) {
              dataSlice[j] += mirroredDataSlice[j];
            }
          } else if (mirrored[i]) {
            dataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex, 1);
          } else {
            dataSlice = this.extractDataSlice(tile.dense, [256, 256], sliceIndex);
          }
          const newTile = {
            // @ts-expect-error - this is ok because float32 array can be spread as number[]
            min_value: Math.min.apply(null, dataSlice),
            // @ts-expect-error - this is ok because float32 array can be spread as number[]
            max_value: Math.max.apply(null, dataSlice),
            denseDataExtrema: new DenseDataExtrema1D(dataSlice),
            minNonZero: minNonZero(dataSlice),
            maxNonZero: maxNonZero(dataSlice),
            dense: dataSlice,
            dtype: tile.dtype,
            server: tile.server,
            tilePos: mirrored[i] ? [yTilePos] : [xTilePos],
            tilePositionId: tileIds[i],
            tilesetUid,
            zoomLevel: tile.zoomLevel
          };
          newTiles[tileIds[i]] = newTile;
        }
        receivedTiles(newTiles);
        return newTiles;
      });
    }
    /**
     * @typedef {{ zoomLevel: number, tilePos: number[], dense?: ArrayLike<number> }} Dividable
     * @param {[Record<string, Dividable>, Record<string, Dividable>]} returnedTiles
     * @param {string[]} tileIds
     * @returns {Record<string, DividedTile>}
     */
  }, {
    key: "makeDivided",
    value: function makeDivided(returnedTiles, tileIds) {
      if (returnedTiles.length < 2) {
        console.warn("Only one tileset specified for a divided datafetcher:", this.dataConfig);
      }
      const newTiles = {};
      for (let i = 0; i < tileIds.length; i++) {
        const zoomLevel = returnedTiles[0][tileIds[i]].zoomLevel;
        const tilePos = returnedTiles[0][tileIds[i]].tilePos;
        let newTile = {
          zoomLevel,
          tilePos,
          tilePositionId: tileIds[i]
        };
        const denseA = returnedTiles[0][tileIds[i]].dense;
        const denseB = returnedTiles[1][tileIds[i]].dense;
        if (denseA && denseB) {
          const newData = this.divideData(denseA, denseB);
          const dde = tilePos.length === 2 ? new DenseDataExtrema2D(newData) : new DenseDataExtrema1D(newData);
          newTile = {
            dense: newData,
            denseDataExtrema: dde,
            minNonZero: minNonZero(newData),
            maxNonZero: maxNonZero(newData),
            zoomLevel,
            tilePos,
            tilePositionId: tileIds[i]
          };
        }
        newTiles[tileIds[i]] = newTile;
      }
      return newTiles;
    }
  }]);
})();
var months;
var hasRequiredMonths;
function requireMonths() {
  if (hasRequiredMonths) return months;
  hasRequiredMonths = 1;
  months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  return months;
}
var src;
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src;
  hasRequiredSrc = 1;
  const MONTHS = requireMonths();
  function genbankToJson(sequence) {
    if (typeof sequence !== "string") {
      throw new TypeError("input must be a string");
    }
    let resultsArray = [];
    let result;
    let currentFeatureNote;
    let genbankAnnotationKey = {
      // Contains in order: locus name, sequence length, molecule type (e.g. DNA), genbank division (see 1-18 below), modification date
      // locus definition has changed with time, use accession number for a unique identifier
      LOCUS_TAG: "LOCUS",
      DEFINITION_TAG: "DEFINITION",
      // Accession tag
      // Example: Z78533
      ACCESSION_TAG: "ACCESSION",
      // The version tag contains 2 informations
      // The accession number with a revision
      // The GI (GenInfo Identifier), a ncbi sequential number
      // Example: Z78533.1  GI:2765658
      // Unicity garanteed with respect to sequence. If 1 nucleotide changes, the version is different.
      VERSION_TAG: "VERSION",
      KEYWORDS_TAG: "KEYWORDS",
      // SEGMENT_TAG:"SEGMENT"
      // Source is free text
      SOURCE_TAG: "SOURCE",
      ORGANISM_TAG: "ORGANISM",
      REFERENCE_TAG: "REFERENCE",
      FEATURES_TAG: "FEATURES",
      // CONTIG_TAG: "CONTIG"
      ORIGIN_TAG: "ORIGIN",
      END_SEQUENCE_TAG: "//"
    };
    let lines = sequence.split(/\r?\n/);
    let fieldName;
    let subFieldType;
    let featureLocationIndentation;
    let lastLineWasFeaturesTag;
    let lastLineWasLocation;
    let hasFoundLocus = false;
    for (let line of lines) {
      if (line === null) break;
      let lineFieldName = getLineFieldName(line);
      let val = getLineVal(line);
      let isSubKey = isSubKeyword(line);
      let isKey2 = isKeyword(line);
      if (lineFieldName === genbankAnnotationKey.END_SEQUENCE_TAG || isKey2) {
        fieldName = lineFieldName;
        subFieldType = null;
      } else if (isSubKey) {
        subFieldType = lineFieldName;
      }
      if (line.trim() === "" || lineFieldName === ";") {
        continue;
      }
      if (!hasFoundLocus && fieldName !== genbankAnnotationKey.LOCUS_TAG) {
        break;
      }
      switch (fieldName) {
        case genbankAnnotationKey.LOCUS_TAG:
          hasFoundLocus = true;
          parseLocus(line);
          break;
        case genbankAnnotationKey.FEATURES_TAG:
          parseFeatures(line, lineFieldName, val);
          break;
        case genbankAnnotationKey.ORIGIN_TAG:
          parseOrigin(line, lineFieldName);
          break;
        case genbankAnnotationKey.DEFINITION_TAG:
        case genbankAnnotationKey.ACCESSION_TAG:
        case genbankAnnotationKey.VERSION_TAG:
        case genbankAnnotationKey.KEYWORDS_TAG:
          parseMultiLineField(fieldName, line, fieldName.toLowerCase());
          break;
        case genbankAnnotationKey.SOURCE_TAG:
          if (subFieldType === genbankAnnotationKey.ORGANISM_TAG) {
            parseMultiLineField(subFieldType, line, "organism");
          } else {
            parseMultiLineField(lineFieldName, line, "source");
          }
          break;
        case genbankAnnotationKey.REFERENCE_TAG:
          if (lineFieldName === genbankAnnotationKey.REFERENCE_TAG) {
            const ref2 = result.references || [];
            result.references = ref2;
            ref2.push({});
          }
          parseReference(line, subFieldType);
          break;
        case genbankAnnotationKey.END_SEQUENCE_TAG:
          endSeq();
          break;
      }
    }
    if (resultsArray[resultsArray.length - 1] !== result) {
      endSeq();
    }
    return resultsArray;
    function endSeq() {
      postProcessCurSeq();
      resultsArray.push(result);
    }
    function getCurrentFeature() {
      return result.features[result.features.length - 1];
    }
    function postProcessCurSeq() {
      if (result && result.features) {
        for (let i = 0; i < result.features.length; i++) {
          result.features[i] = postProcessGenbankFeature(result.features[i]);
        }
      }
    }
    function parseOrigin(line, key) {
      if (key !== genbankAnnotationKey.ORIGIN_TAG) {
        let newLine = line.replace(/[\s]*[0-9]*/g, "");
        result.sequence += newLine;
      }
    }
    function parseLocus(line) {
      result = {
        features: [],
        name: "Untitled sequence",
        sequence: "",
        references: []
      };
      line = removeFieldName(genbankAnnotationKey.LOCUS_TAG, line);
      const m = line.match(/^([^\s]+)\s+(\d+)\s+bp\s+([^\s]+)\s+([^\s]+)\s+([^\s]+)\s*([^\s]+)?$/);
      let locusName = m[1];
      let size = +m[2];
      let moleculeType = m[3];
      let circular = m[4] === "circular";
      const seq = result;
      let dateStr = "";
      if (!m[6]) {
        dateStr = m[5];
      } else {
        seq.genbankDivision = m[5];
        dateStr = m[6];
      }
      seq.circular = circular;
      seq.moleculeType = moleculeType;
      const dateMatch = dateStr.match(/^(\d{2})-(.{3})-(\d{4})$/);
      const date2 = /* @__PURE__ */ new Date();
      date2.setFullYear(+dateMatch[3]);
      date2.setUTCMonth(MONTHS.indexOf(dateMatch[2].toUpperCase()));
      date2.setDate(+dateMatch[1]);
      date2.setUTCHours(12);
      date2.setMinutes(0);
      date2.setSeconds(0);
      date2.setMilliseconds(0);
      seq.date = date2.toISOString();
      seq.name = locusName;
      seq.size = size;
    }
    function removeFieldName(fName, line) {
      line = line.replace(/^\s*/, "");
      if (line.indexOf(fName) === 0) {
        line = line.replace(fName, "");
      }
      return line.trim();
    }
    function parseReference(line, subType) {
      const refs = result.references;
      let lastRef = refs[refs.length - 1];
      if (!subType) {
        parseMultiLineField(genbankAnnotationKey.REFERENCE_TAG, line, "description", lastRef);
      } else {
        parseMultiLineField(subType, line, subType.toLowerCase(), lastRef);
      }
    }
    function parseFeatures(line, key, val) {
      let strand;
      if (key === genbankAnnotationKey.FEATURES_TAG) {
        lastLineWasFeaturesTag = true;
        return;
      }
      if (lastLineWasFeaturesTag) {
        featureLocationIndentation = getLengthOfWhiteSpaceBeforeStartOfLetters(line);
        lastLineWasFeaturesTag = false;
      }
      if (isFeatureLineRunon(line, featureLocationIndentation)) {
        if (lastLineWasLocation) {
          parseFeatureLocation(line.trim());
          lastLineWasLocation = true;
        } else {
          if (currentFeatureNote) {
            currentFeatureNote[currentFeatureNote.length - 1] += line.trim().replace(/"/g, "");
          }
          lastLineWasLocation = false;
        }
      } else {
        if (isNote(line)) {
          if (getCurrentFeature()) {
            parseFeatureNote(line);
            lastLineWasLocation = false;
          }
        } else {
          if (val.match(/complement/g)) {
            strand = -1;
          } else {
            strand = 1;
          }
          newFeature();
          let feat = getCurrentFeature();
          feat.type = key;
          feat.strand = strand;
          parseFeatureLocation(val);
          lastLineWasLocation = true;
        }
      }
    }
    function newFeature() {
      result.features.push({
        notes: {}
      });
    }
    function isNote(line) {
      let qual = false;
      if (line.trim().charAt(0).match(/\//)) {
        qual = true;
      } else if (line.match(/^[\s]*\/[\w]+=[\S]+/)) {
        qual = true;
      }
      return qual;
    }
    function parseFeatureLocation(locStr) {
      locStr = locStr.trim();
      let locArr = [];
      locStr.replace(/(\d+)/g, function(string, match) {
        locArr.push(match);
      });
      let feat = getCurrentFeature();
      feat.start = +locArr[0];
      feat.end = locArr[1] === void 0 ? +locArr[0] : +locArr[1];
    }
    function parseFeatureNote(line) {
      let newLine, lineArr;
      newLine = line.trim();
      newLine = newLine.replace(/^\/|"$/g, "");
      lineArr = newLine.split(/="|=/);
      let val = lineArr[1];
      if (val) {
        val = val.replace(/\\/g, " ");
        if (line.match(/="/g)) {
          val = val.replace(/".*/g, "");
        } else if (val.match(/^\d+$/g)) {
          val = +val;
        }
      }
      let key = lineArr[0];
      let currentNotes = getCurrentFeature().notes;
      if (currentNotes[key]) {
        currentNotes[key].push(val);
      } else {
        currentNotes[key] = [val];
      }
      currentFeatureNote = currentNotes[key];
    }
    function getLineFieldName(line) {
      let arr;
      line = line.trim();
      arr = line.split(/[\s]+/);
      return arr[0];
    }
    function parseMultiLineField(fName, line, resultKey, r2) {
      r2 = r2 || result;
      let fieldValue = removeFieldName(fName, line);
      r2[resultKey] = r2[resultKey] ? `${r2[resultKey]} ` : "";
      r2[resultKey] += fieldValue;
    }
    function getLineVal(line) {
      let arr;
      if (line.indexOf("=") < 0) {
        line = line.replace(/^[\s]*[\S]+[\s]+|[\s]+$/, "");
        line = line.trim();
        return line;
      } else {
        arr = line.split(/=/);
        return arr[1];
      }
    }
    function isKeyword(line) {
      let isKey2 = false;
      if (line.substr(0, 10).match(/^[\S]+/)) {
        isKey2 = true;
      }
      return isKey2;
    }
    function isSubKeyword(line) {
      let isSubKey = false;
      if (line.substr(0, 10).match(/^[\s]+[\S]+/)) {
        isSubKey = true;
      }
      return isSubKey;
    }
    function postProcessGenbankFeature(feat) {
      if (feat.notes.label) {
        feat.name = feat.notes.label[0];
      } else if (feat.notes.gene) {
        feat.name = feat.notes.gene[0];
      } else if (feat.notes.ApEinfo_label) {
        feat.name = feat.notes.ApEinfo_label[0];
      } else if (feat.notes.name) {
        feat.name = feat.notes.name[0];
      } else if (feat.notes.organism) {
        feat.name = feat.notes.organism[0];
      } else if (feat.notes.locus_tag) {
        feat.name = feat.notes.locus_tag[0];
      } else if (feat.notes.note) {
        feat.name = feat.notes.note[0];
      } else {
        feat.name = "Untitled Feature";
      }
      feat.name = typeof feat.name === "string" ? feat.name : String(feat.name);
      return feat;
    }
  }
  function isFeatureLineRunon(line, featureLocationIndentation) {
    let indentationOfLine = getLengthOfWhiteSpaceBeforeStartOfLetters(line);
    if (featureLocationIndentation === indentationOfLine) {
      return false;
    }
    let trimmed = line.trim();
    if (trimmed.charAt(0).match(/\//)) {
      return false;
    }
    return true;
  }
  function getLengthOfWhiteSpaceBeforeStartOfLetters(string) {
    let match = /^\s*/.exec(string);
    if (match !== null) {
      return match[0].length;
    } else {
      return 0;
    }
  }
  src = genbankToJson;
  return src;
}
var srcExports = requireSrc();
const genbankParser = /* @__PURE__ */ getDefaultExportFromCjs(srcExports);
function decompress(data2, options2) {
  const {
    format: format2,
    signal
  } = options2;
  const response = data2 instanceof Response ? data2 : new Response(data2);
  assert(response.body, "Response does not include a body.");
  return new Response(response.body.pipeThrough(new DecompressionStream(format2), {
    signal
  }));
}
function _classCallCheck$W(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$W(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$W(o.key), o);
  }
}
function _createClass$W(e, r2, t) {
  return r2 && _defineProperties$W(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$W(t) {
  var i = _toPrimitive$W(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$W(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function collapse(segments, scale, strand) {
  const collapsed = [];
  const MAX_DIST_BETWEEN = 5;
  if (!segments.length) {
    return [];
  }
  let currStart = segments[0].start;
  let currEnd = segments[0].end;
  for (let i = 1; i < segments.length; i++) {
    if (segments[i].start < currEnd + MAX_DIST_BETWEEN * 1 / scale) {
      currEnd = Math.max(currEnd, segments[i].end);
    } else {
      collapsed.push({
        type: "filler",
        start: currStart,
        end: currEnd,
        strand
      });
      currStart = segments[i].start;
      currEnd = segments[i].end;
    }
  }
  collapsed.push({
    start: currStart,
    end: currEnd,
    type: "filler",
    strand
  });
  return collapsed;
}
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}
function isFillerSegment(x) {
  return x.type === "filler";
}
function genbankFeatureToHiGlassGeneAnnotation(gb) {
  const importance = gb.end - gb.start;
  const strand = gb.strand === 1 ? "+" : "-";
  const uid = slugid.nice();
  if (isFillerSegment(gb)) {
    return {
      xStart: gb.start,
      xEnd: gb.end,
      strand: gb.strand,
      fields: [],
      type: "filler",
      uid
    };
  }
  return {
    xStart: gb.start,
    xEnd: gb.end,
    strand,
    chrOffset: 0,
    importance: gb.end - gb.start,
    uid,
    type: gb.type,
    fields: ["chrom", gb.start, gb.end, gb.name, importance, strand, "", "", gb.type, gb.name, gb.start.toString(), gb.end.toString(), gb.start.toString(), gb.end.toString()]
  };
}
function gbToJsonAndFeatures(gbText) {
  const gbJson = genbankParser(gbText);
  const features = shuffle(gbJson[0].features.filter((f2) => f2.type !== "source").sort((a, b) => a.start - b.start));
  return {
    json: gbJson,
    features
  };
}
let GBKDataFetcher = /* @__PURE__ */ (function() {
  function GBKDataFetcher2(dataConfig) {
    _classCallCheck$W(this, GBKDataFetcher2);
    this.dataConfig = dataConfig;
    this.trackUid = slugid.nice();
    this.errorTxt = "";
    let textPromise;
    if (dataConfig.url) {
      const extension = dataConfig.url.slice(dataConfig.url.length - 3);
      textPromise = fetch(dataConfig.url, {
        mode: "cors",
        redirect: "follow",
        method: "GET"
      }).then((originalResponse) => {
        const normalizedResponse = extension === ".gz" ? decompress(originalResponse, {
          format: "gzip"
        }) : originalResponse;
        return normalizedResponse.text();
      });
    } else if (dataConfig.text) {
      textPromise = Promise.resolve(dataConfig.text);
    } else {
      throw new Error("No data or URL specified");
    }
    this.gbDataPromise = textPromise.then((text2) => gbToJsonAndFeatures(text2));
  }
  return _createClass$W(GBKDataFetcher2, [{
    key: "tilesetInfo",
    value: function tilesetInfo(callback) {
      this.tilesetInfoLoading = true;
      return this.gbDataPromise.then((gbData) => {
        this.tilesetInfoLoading = false;
        const TILE_SIZE = 1024;
        const retVal = {
          name: `genbank-${this.trackUid}`,
          tile_size: TILE_SIZE,
          max_zoom: Math.ceil(Math.log(gbData.json[0].size / TILE_SIZE) / Math.log(2)),
          max_width: gbData.json[0].size,
          min_pos: [0],
          max_pos: [gbData.json[0].size]
        };
        if (callback) {
          callback(retVal);
        }
        return retVal;
      }).catch((err) => {
        this.tilesetInfoLoading = false;
        if (callback) {
          callback({
            error: `Error parsing genbank: ${err}`
          });
        }
        return void 0;
      });
    }
    /**
     * @param {(tiles: Record<string, GenbankTile>) => void} receivedTiles
     * @param {string[]} tileIds
     * @returns {Promise<Record<string, GenbankTile>>}
     */
  }, {
    key: "fetchTilesDebounced",
    value: async function fetchTilesDebounced2(receivedTiles, tileIds) {
      const tiles = {};
      const validTileIds = [];
      const tilePromises = [];
      for (const tileId of tileIds) {
        const parts = tileId.split(".");
        const z = Number.parseInt(parts[0], 10);
        const x = Number.parseInt(parts[1], 10);
        if (Number.isNaN(x) || Number.isNaN(z)) {
          console.warn("Invalid tile zoom or position:", z, x);
          continue;
        }
        validTileIds.push(tileId);
        tilePromises.push(this.tile(z, x));
      }
      const values = await Promise.all(tilePromises);
      for (let i = 0; i < values.length; i++) {
        const validTileId = validTileIds[i];
        tiles[validTileId] = values[i];
        tiles[validTileId].tilePositionId = validTileId;
      }
      receivedTiles(tiles);
      return tiles;
    }
    /**
     * @param {number} z
     * @param {number} x
     * @returns {Promise<GeneAnnotation[]>}
     */
  }, {
    key: "tile",
    value: async function tile(z, x) {
      const [tsInfo, gbData] = await Promise.all([this.tilesetInfo(), this.gbDataPromise]);
      if (!tsInfo) {
        throw new Error("No tileset info");
      }
      const tileWidth = +tsInfo.max_width / 2 ** +z;
      const minX = tsInfo.min_pos[0] + x * tileWidth;
      const maxX = tsInfo.min_pos[0] + (x + 1) * tileWidth;
      const filtered = gbData.features.filter((v) => v.end > minX && v.start < maxX);
      const scaleFactor = 1024 / 2 ** (tsInfo.max_zoom - z);
      const collapsedPlus = collapse(filtered.filter((v) => v.strand === 1), scaleFactor, "+");
      const collapsedMinus = collapse(filtered.filter((v) => v.strand !== 1), scaleFactor, "-");
      const values = [];
      const TILE_CAPACITY = 20;
      for (let i = 0; i < gbData.features.length; i++) {
        if (values.length >= TILE_CAPACITY) {
          break;
        }
        if (gbData.features[i].end >= minX && gbData.features[i].start <= maxX) {
          values.push(gbData.features[i]);
        }
      }
      return [values, collapsedPlus, collapsedMinus].flatMap((v) => v.map(genbankFeatureToHiGlassGeneAnnotation));
    }
  }]);
})();
function _classCallCheck$V(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$V(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$V(o.key), o);
  }
}
function _createClass$V(e, r2, t) {
  return r2 && _defineProperties$V(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$V(t) {
  var i = _toPrimitive$V(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$V(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let LocalTileDataFetcher = /* @__PURE__ */ (function() {
  function LocalTileDataFetcher2(dataConfig) {
    _classCallCheck$V(this, LocalTileDataFetcher2);
    this.dataConfig = dataConfig;
    this.tilesetInfoData = Object.values(this.dataConfig.tilesetInfo)[0];
    this.tilesData = {};
    this.tilesetInfoLoading = true;
  }
  return _createClass$V(LocalTileDataFetcher2, [{
    key: "tilesetInfo",
    value: async function tilesetInfo(callback) {
      this.tilesetInfoLoading = false;
      await new Promise((resolve) => setTimeout(() => {
        callback(this.tilesetInfoData);
        resolve(true);
      }, 0));
      return this.tilesetInfoData;
    }
    /** We expect there to be a tilesetUid in the provided tilesetInfo
     * and tiles data since tileResponseToData needs it
     *
     * It is also easier for users to paste in request responses for debugging.
     *
     * @param {(tiles: Record<string, LocalTile>) => void} receivedTiles
     * @param {string[]} tileIds
     */
  }, {
    key: "fetchTilesDebounced",
    value: async function fetchTilesDebounced2(receivedTiles, tileIds) {
      this.tilesData = {};
      for (const key of Object.keys(this.dataConfig.tiles)) {
        const keyParts = key.split(".");
        const newKey = `localtile.${keyParts.slice(1).join(".")}`;
        this.tilesData[newKey] = this.dataConfig.tiles[key];
      }
      const ret = {};
      const newTileIds = tileIds.map((x) => `localtile.${x}`);
      tileResponseToData(this.tilesData, "", newTileIds);
      for (const tileId of tileIds) {
        ret[tileId] = this.tilesData[`localtile.${tileId}`];
        ret[tileId].tilePositionId = tileId;
      }
      receivedTiles(ret);
      return ret;
    }
    /**
     * @param {number} z
     * @param {number} x
     * @returns {void}
     */
  }, {
    key: "tile",
    value: function tile(z, x) {
    }
  }]);
})();
function _classCallCheck$U(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$U(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$U(o.key), o);
  }
}
function _createClass$U(e, r2, t) {
  return r2 && _defineProperties$U(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$U(t) {
  var i = _toPrimitive$U(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$U(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function isNullDataTask(task) {
  return task.data === null;
}
let BackgroundTaskScheduler = /* @__PURE__ */ (function() {
  function BackgroundTaskScheduler2() {
    _classCallCheck$U(this, BackgroundTaskScheduler2);
    this.taskList = [];
    this.taskHandle = null;
    this.requestIdleCallbackTimeout = 300;
  }
  return _createClass$U(BackgroundTaskScheduler2, [{
    key: "enqueueTask",
    value: function enqueueTask(taskHandler, taskData, trackId = null) {
      if (trackId === null) {
        this.taskList.push({
          handler: taskHandler,
          data: taskData
        });
      } else {
        this.taskList = this.taskList.filter((task) => task.trackId !== trackId);
        this.taskList.push({
          handler: taskHandler,
          data: taskData,
          trackId
        });
      }
      if (!this.taskHandle) {
        this.taskHandle = requestIdleCallback(this.runTaskQueue.bind(this), {
          timeout: this.requestIdleCallbackTimeout
        });
      }
    }
    /**
     * @param {{ timeRemaining(): number, didTimeout: boolean }} deadline
     */
  }, {
    key: "runTaskQueue",
    value: function runTaskQueue(deadline) {
      while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.taskList.length) {
        const task = this.taskList.shift();
        if (task && isNullDataTask(task)) {
          task.handler();
        } else if (task) {
          task.handler(task.data);
        }
      }
      if (this.taskList.length) {
        this.taskHandle = requestIdleCallback(this.runTaskQueue.bind(this), {
          timeout: this.requestIdleCallbackTimeout
        });
      } else {
        this.taskHandle = 0;
      }
    }
  }]);
})();
const backgroundTaskScheduler = new BackgroundTaskScheduler();
function _classCallCheck$T(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$T(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$T(o.key), o);
  }
}
function _createClass$T(e, r2, t) {
  return r2 && _defineProperties$T(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$T(t) {
  var i = _toPrimitive$T(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$T(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$S(t, o, e) {
  return o = _getPrototypeOf$S(o), _possibleConstructorReturn$S(t, _isNativeReflectConstruct$S() ? Reflect.construct(o, e || [], _getPrototypeOf$S(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$S(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$S(t);
}
function _assertThisInitialized$S(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$S() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$S = function() {
    return !!t;
  })();
}
function _superPropGet$B(t, o, e, r2) {
  var p = _get$B(_getPrototypeOf$S(t.prototype), o, e);
  return "function" == typeof p ? function(t22) {
    return p.apply(e, t22);
  } : p;
}
function _get$B() {
  return _get$B = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$B(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$B.apply(null, arguments);
}
function _superPropBase$B(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$S(t)); ) ;
  return t;
}
function _getPrototypeOf$S(t) {
  return _getPrototypeOf$S = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$S(t);
}
function _inherits$S(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$S(t, e);
}
function _setPrototypeOf$S(t, e) {
  return _setPrototypeOf$S = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$S(t, e);
}
function getValueScale(scalingType, minValue, pseudocountIn, maxValue, defaultScaling) {
  const scalingTypeToUse = scalingType;
  const pseudocount = 0;
  if (scalingTypeToUse === "log" && minValue > 0) {
    return ["log", log$2().range([254, 0]).domain([minValue + pseudocount, maxValue + pseudocount])];
  }
  return ["linear", linear().range([254, 0]).domain([minValue, maxValue])];
}
let TiledPixiTrack = /* @__PURE__ */ (function(_PixiTrack) {
  function TiledPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$T(this, TiledPixiTrack2);
    _this = _callSuper$S(this, TiledPixiTrack2, [context, options2]);
    const {
      pubSub,
      dataConfig,
      handleTilesetInfoReceived,
      animate,
      onValueScaleChanged
    } = context;
    _this.renderVersion = 1;
    _this.visibleTiles = [];
    _this.visibleTileIds = /* @__PURE__ */ new Set();
    _this.renderingTiles = /* @__PURE__ */ new Set();
    _this.fetching = /* @__PURE__ */ new Set();
    _this.scale = {};
    _this.fetchedTiles = {};
    _this.tileGraphics = {};
    _this.maxZoom = 0;
    _this.medianVisibleValue = null;
    _this.backgroundTaskScheduler = backgroundTaskScheduler;
    _this.continuousScaling = "requestIdleCallback" in window;
    _this.valueScaleMin = null;
    _this.fixedValueScaleMin = null;
    _this.valueScaleMax = null;
    _this.fixedValueScaleMax = null;
    _this.listeners = {};
    _this.pubSub = pubSub;
    _this.animate = animate;
    _this.onValueScaleChanged = onValueScaleChanged;
    _this.prevValueScale = null;
    if (!context.dataFetcher) {
      _this.dataFetcher = new DataFetcher(dataConfig, _this.pubSub);
    } else {
      _this.dataFetcher = context.dataFetcher;
    }
    _this.tilesetInfo = null;
    _this.tilesetInfoError = null;
    _this.uuid = slugid.nice();
    _this.trackNotFoundText = new GLOBALS.PIXI.Text("", {
      fontSize: "12px",
      fontFamily: "Arial",
      fill: "black"
    });
    _this.pLabel.addChild(_this.trackNotFoundText);
    _this.refreshTilesDebounced = throttleAndDebounce(_this.refreshTiles.bind(_this), ZOOM_DEBOUNCE, ZOOM_DEBOUNCE);
    _this.dataFetcher.tilesetInfo((tilesetInfo, tilesetUid) => {
      if (!tilesetInfo) return;
      if (isTilesetInfo(tilesetInfo)) {
        _this.tilesetInfo = tilesetInfo;
        if (_this.tilesetInfo.chromsizes) {
          _this.chromInfo = parseChromsizesRows(_this.tilesetInfo.chromsizes);
        }
      } else {
        console.warn("Error retrieving tilesetInfo:", dataConfig, tilesetInfo.error);
        if (tilesetInfo.error) {
          _this.setError(tilesetInfo.error, "dataFetcher.tilesetInfo");
        }
        _this.tilesetInfo = void 0;
        return;
      }
      if (!_this.dataFetcher.dataConfig.tilesetUid) {
        _this.dataFetcher.dataConfig.tilesetUid = tilesetUid;
      }
      _this.tilesetUid = _this.dataFetcher.dataConfig.tilesetUid;
      _this.server = _this.dataFetcher.dataConfig.server || "unknown";
      if (_this.tilesetInfo?.chromsizes) {
        _this.chromInfo = parseChromsizesRows(_this.tilesetInfo.chromsizes);
      }
      if (isResolutionsTilesetInfo(_this.tilesetInfo)) {
        _this.maxZoom = _this.tilesetInfo.resolutions.length;
      } else {
        _this.maxZoom = +_this.tilesetInfo.max_zoom;
      }
      if (_this.options?.maxZoom) {
        if (_this.options.maxZoom >= 0) {
          _this.maxZoom = Math.min(_this.options.maxZoom, _this.maxZoom);
        } else {
          console.error("Invalid maxZoom on track:", _this);
        }
      }
      _this.refreshTiles();
      _this.tilesetInfoReceived();
      handleTilesetInfoReceived?.(_this.tilesetInfo);
      _this.options ??= {};
      _this.options.name = _this.options.name || _this.tilesetInfo.name;
      _this.checkValueScaleLimits();
      _this.draw();
      _this.drawLabel();
      _this.animate();
    });
    return _this;
  }
  _inherits$S(TiledPixiTrack2, _PixiTrack);
  return _createClass$T(TiledPixiTrack2, [{
    key: "setError",
    value: function setError(error, source) {
      this.errorTexts[source] = error;
      this.drawError();
    }
    /** @param {number | string} value */
  }, {
    key: "setFixedValueScaleMin",
    value: function setFixedValueScaleMin(value) {
      if (!Number.isNaN(+value)) this.fixedValueScaleMin = +value;
      else this.fixedValueScaleMin = null;
    }
    /** @param {number | string} value */
  }, {
    key: "setFixedValueScaleMax",
    value: function setFixedValueScaleMax(value) {
      if (!Number.isNaN(+value)) this.fixedValueScaleMax = +value;
      else this.fixedValueScaleMax = null;
    }
  }, {
    key: "checkValueScaleLimits",
    value: function checkValueScaleLimits() {
      this.valueScaleMin = typeof this.options.valueScaleMin !== "undefined" ? +this.options.valueScaleMin : null;
      if (this.fixedValueScaleMin !== null) {
        this.valueScaleMin = this.fixedValueScaleMin;
      }
      this.valueScaleMax = typeof this.options.valueScaleMax !== "undefined" ? +this.options.valueScaleMax : null;
      if (this.fixedValueScaleMax !== null) {
        this.valueScaleMax = this.fixedValueScaleMax;
      }
    }
    /**
     * Register an event listener for track events. Currently, the only supported
     * event is ``dataChanged``.
     *
     * @param {string} event The event to listen for
     * @param {Function} callback The callback to call when the event occurs. The
     *  parameters for the event depend on the event called.
     *
     * @example
     *
     *  trackObj.on('dataChanged', (newData) => {
     *   console.log('newData:', newData)
     *  });
     */
  }, {
    key: "on",
    value: function on(event, callback) {
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event].push(callback);
    }
    /**
     * @param {string} event The event to listen for
     * @param {Function} callback The callback to call when the event occurs. The
     *  parameters for the event depend on the event called.
     */
  }, {
    key: "off",
    value: function off(event, callback) {
      const id2 = this.listeners[event].indexOf(callback);
      if (id2 === -1 || id2 >= this.listeners[event].length) return;
      this.listeners[event].splice(id2, 1);
    }
    /** @param {Options} options */
  }, {
    key: "rerender",
    value: function rerender(options2) {
      _superPropGet$B(TiledPixiTrack2, "rerender", this)([options2]);
      this.renderVersion += 1;
      if (!this.tilesetInfo) {
        return;
      }
      this.checkValueScaleLimits();
      if (isResolutionsTilesetInfo(this.tilesetInfo)) {
        this.maxZoom = this.tilesetInfo.resolutions.length;
      } else {
        this.maxZoom = +this.tilesetInfo.max_zoom;
      }
      if (this.options?.maxZoom) {
        if (this.options.maxZoom >= 0) {
          this.maxZoom = Math.min(this.options.maxZoom, this.maxZoom);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
    }
    /** Called when tileset info is received. The actual tileset info
     * can be found in this.tilesetInfo.
     *
     * Child tracks can implement this method.
     */
  }, {
    key: "tilesetInfoReceived",
    value: function tilesetInfoReceived() {
    }
    /**
     * Return the set of ids of all tiles which are both visible and fetched.
     */
  }, {
    key: "visibleAndFetchedIds",
    value: function visibleAndFetchedIds() {
      return Object.keys(this.fetchedTiles).filter((x) => this.visibleTileIds.has(x));
    }
  }, {
    key: "visibleAndFetchedTiles",
    value: function visibleAndFetchedTiles() {
      return this.visibleAndFetchedIds().map((x) => this.fetchedTiles[x]);
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param {Array<TilePositionArrayObject>} tilePositions - A set of tiles which will be considered the currently visible tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        // @ts-expect-error Classes which extend TiledPixiTrack have this
        tileId: this.tileToLocalId(x),
        // @ts-expect-error Classes which extend TiledPixiTrack have this
        remoteId: this.tileToRemoteId(x),
        mirrored: x.mirrored
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "removeOldTiles",
    value: function removeOldTiles() {
      this.calculateVisibleTiles();
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const toRemove = [...fetchedTileIDs].filter((x) => !this.visibleTileIds.has(x));
      this.removeTiles(toRemove);
    }
  }, {
    key: "refreshTiles",
    value: function refreshTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.calculateVisibleTiles();
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const toFetch = [...this.visibleTiles].filter((x) => !this.fetching.has(x.remoteId) && !fetchedTileIDs.has(x.tileId));
      for (let i = 0; i < toFetch.length; i++) {
        this.fetching.add(toFetch[i].remoteId);
      }
      this.removeOldTiles();
      this.fetchNewTiles(toFetch);
    }
    /** @param {Tile} tile */
  }, {
    key: "parentInFetched",
    value: function parentInFetched(tile) {
      const uid = tile.tileData.tilesetUid;
      let zl = tile.tileData.zoomLevel;
      let pos = tile.tileData.tilePos;
      while (zl > 0) {
        zl -= 1;
        pos = pos.map((x) => Math.floor(x / 2));
        const parentId = `${uid}.${zl}.${pos.join(".")}`;
        if (parentId in this.fetchedTiles) {
          return true;
        }
      }
      return false;
    }
    /** @param {Tile} tile */
  }, {
    key: "parentTileId",
    value: function parentTileId(tile) {
      const parentZoomLevel = tile.tileData.zoomLevel - 1;
      const parentPos = tile.tileData.tilePos.map((x) => Math.floor(x / 2));
      const parentUid = tile.tileData.tilesetUid;
      return `${parentUid}.${parentZoomLevel}.${parentPos.join(".")}`;
    }
    /**
     * Remove obsolete tiles
     *
     * @param {Array<string>} toRemoveIds: An array of tile ids to remove from the list of fetched tiles.
     */
  }, {
    key: "removeTiles",
    value: function removeTiles(toRemoveIds) {
      if (!toRemoveIds.length || !this.areAllVisibleTilesLoaded() || this.renderingTiles.size) {
        return;
      }
      toRemoveIds.forEach((x) => {
        const tileIdStr = x;
        this.destroyTile(this.fetchedTiles[tileIdStr]);
        if (tileIdStr in this.tileGraphics) {
          this.pMain.removeChild(this.tileGraphics[tileIdStr]);
          delete this.tileGraphics[tileIdStr];
        }
        delete this.fetchedTiles[tileIdStr];
      });
      this.synchronizeTilesAndGraphics();
      this.draw();
    }
    /**
     * @param {t.Scale} newXScale
     * @param {t.Scale} newYScale
     */
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k = 1, tx = 0, ty = 0) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTilesDebounced();
      this.pMobile.position.x = tx;
      this.pMobile.position.y = this.position[1];
      this.pMobile.scale.x = k;
      this.pMobile.scale.y = 1;
    }
    /** @param {[number, number]} newPosition */
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$B(TiledPixiTrack2, "setPosition", this)([newPosition]);
    }
    /** @param {[number, number]} newDimensions */
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$B(TiledPixiTrack2, "setDimensions", this)([newDimensions]);
    }
    /**
     * Check to see if all the visible tiles are loaded.
     *
     * If they are, remove all other tiles.
     */
  }, {
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const visibleTileIdsList = [...this.visibleTileIds];
      for (let i = 0; i < visibleTileIdsList.length; i++) {
        if (!fetchedTileIDs.has(visibleTileIdsList[i])) {
          return false;
        }
      }
      return true;
    }
    /**
     * Function is called when all tiles that should be visible have
     * been received.
     */
  }, {
    key: "allTilesLoaded",
    value: function allTilesLoaded() {
    }
    /** @param {number} [_] - Optional value to set */
  }, {
    key: "minValue",
    value: function minValue(_) {
      if (_) {
        this.scale.minValue = _;
        return this;
      }
      return this.valueScaleMin !== null ? this.valueScaleMin : this.scale.minValue;
    }
    /** @param {number} [_] - Optional value to set */
  }, {
    key: "maxValue",
    value: function maxValue(_) {
      if (_) {
        this.scale.maxValue = _;
        return this;
      }
      return this.valueScaleMax !== null ? this.valueScaleMax : this.scale.maxValue;
    }
  }, {
    key: "minRawValue",
    value: function minRawValue() {
      return this.scale.minRawValue;
    }
  }, {
    key: "maxRawValue",
    value: function maxRawValue() {
      return this.scale.maxRawValue;
    }
    /** @param {Tile} tile */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      if (!tile.tileData?.dense) {
        return;
      }
      this.scale.minRawValue = this.continuousScaling ? this.minVisibleValue() : this.minVisibleValueInTiles();
      this.scale.maxRawValue = this.continuousScaling ? this.maxVisibleValue() : this.maxVisibleValueInTiles();
      this.scale.minValue = this.scale.minRawValue;
      this.scale.maxValue = this.scale.maxRawValue;
    }
    /** @param {Tile} tile */
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
    /** @param {Tile} tile */
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
    }
  }, {
    key: "addMissingGraphics",
    value: function addMissingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      this.renderVersion += 1;
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        if (!(fetchedTileIDs[i] in this.tileGraphics)) {
          const newGraphics = new GLOBALS.PIXI.Graphics();
          this.pMain.addChild(newGraphics);
          this.fetchedTiles[fetchedTileIDs[i]].graphics = newGraphics;
          this.initTile(this.fetchedTiles[fetchedTileIDs[i]]);
          this.tileGraphics[fetchedTileIDs[i]] = newGraphics;
        }
      }
    }
    /**
     * Change the graphics for existing tiles
     */
  }, {
    key: "updateExistingGraphics",
    value: function updateExistingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        const tile = this.fetchedTiles[fetchedTileIDs[i]];
        this.updateTile(tile);
      }
    }
  }, {
    key: "synchronizeTilesAndGraphics",
    value: function synchronizeTilesAndGraphics() {
      this.addMissingGraphics();
      this.removeOldTiles();
      this.updateExistingGraphics();
      if (this.listeners.dataChanged) {
        for (const callback of this.listeners.dataChanged) {
          callback(this.visibleAndFetchedTiles().map((x) => x.tileData));
        }
      }
    }
    /**
     * @typedef TiledAreaTile
     * @property {string} tileId
     * @property {string} type
     * @property {unknown} data
     */
    /**
     *
     * @param {TiledAreaTile} tile A tile returned by a TiledArea.
     * @param {function} dataLoader A function for extracting drawable data from a tile. This
     * usually means differentiating the between dense and sparse tiles and putting the data into an array.
     * @returns
     */
  }, {
    key: "loadTileData",
    value: function loadTileData(tile, dataLoader) {
      let loadedTileData = this.lruCache.get(tile.tileId);
      if (!loadedTileData) {
        loadedTileData = dataLoader(tile.data, tile.type);
        this.lruCache.put(tile.tileId, loadedTileData);
      }
      return loadedTileData;
    }
    /** @param {Pick<Tile,'remoteId'>[]} toFetch */
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      this._checkForErrors();
      this.draw();
      if (toFetch.length > 0) {
        const toFetchList = [...new Set(toFetch.map((x) => x.remoteId))];
        this.dataFetcher.fetchTilesDebounced(this.receivedTiles.bind(this), toFetchList);
      }
    }
    /**
     * We've gotten a bunch of tiles from the server in
     * response to a request from fetchTiles.
     * @param {Object<string, import('./data-fetchers/DataFetcher').DividedTile | Tile | TilePositionArrayObject>} loadedTiles
     */
  }, {
    key: "receivedTiles",
    value: function receivedTiles(loadedTiles) {
      for (let i = 0; i < this.visibleTiles.length; i++) {
        const {
          tileId
        } = this.visibleTiles[i];
        if (!loadedTiles[this.visibleTiles[i].remoteId]) continue;
        if (this.visibleTiles[i].remoteId in loadedTiles) {
          if (!(tileId in this.fetchedTiles)) {
            this.fetchedTiles[tileId] = this.visibleTiles[i];
          }
          if (Array.isArray(loadedTiles[this.visibleTiles[i].remoteId])) {
            const tileData = loadedTiles[this.visibleTiles[i].remoteId];
            this.fetchedTiles[tileId].tileData = [...tileData];
            Object.keys(tileData).filter((key) => Number.isNaN(+key)).forEach((key) => {
              this.fetchedTiles[tileId].tileData[key] = tileData[key];
            });
          } else {
            this.fetchedTiles[tileId].tileData = {
              ...loadedTiles[this.visibleTiles[i].remoteId]
            };
          }
          if (this.fetchedTiles[tileId].tileData.error) {
            console.warn("Error in loaded tile", tileId, this.fetchedTiles[tileId].tileData);
          }
        }
      }
      for (const key in loadedTiles) {
        if (loadedTiles[key]) {
          const tileId = loadedTiles[key].tilePositionId;
          if (this.fetching.has(tileId)) {
            this.fetching.delete(tileId);
          }
        }
      }
      this.synchronizeTilesAndGraphics();
      this.draw();
      this.drawLabel();
      if (this.valueScale) {
        if (!this.prevValueScale || // @ts-expect-error This is defined by classes which extend this one
        JSON.stringify(this.valueScale.domain()) !== JSON.stringify(this.prevValueScale.domain())) {
          this.prevValueScale = this.valueScale.copy();
          if (this.onValueScaleChanged) {
            this.onValueScaleChanged();
          }
        }
      }
      this.animate();
      if (this.areAllVisibleTilesLoaded()) {
        this.pubSub?.publish("TiledPixiTrack.tilesLoaded", {
          uuid: this.uuid
        });
      }
    }
  }, {
    key: "_checkForErrors",
    value: function _checkForErrors() {
      const errors = Object.values(this.fetchedTiles).map((x) => x.tileData?.error && `${x.tileId}: ${x.tileData.error}`).filter((x) => x);
      if (errors.length) {
        this.errorTexts.TiledPixiTrack = errors.join("\n");
      } else {
        this.errorTexts.TiledPixiTrack = "";
      }
      if (this.tilesetInfoError) {
        this.errorTexts.TiledPixiTrack = this.tilesetInfoError;
        errors.push(this.tilesetInfoError);
      }
      return errors;
    }
  }, {
    key: "draw",
    value: function draw() {
      if (this.delayDrawing) return;
      if (!this.tilesetInfo) {
        if (this.dataFetcher.tilesetInfoLoading) {
          this.trackNotFoundText.text = "Loading...";
        } else {
          const server = this.dataFetcher.dataConfig.server || "unknown";
          const tilesetUid = this.dataFetcher.dataConfig.tilesetUid;
          this.trackNotFoundText.text = `Tileset info not found. Server: [${server}] tilesetUid: [${tilesetUid}]`;
        }
        [this.trackNotFoundText.x, this.trackNotFoundText.y] = this.position;
        this.trackNotFoundText.visible = true;
      } else {
        this.trackNotFoundText.visible = false;
      }
      this.pubSub?.publish("TiledPixiTrack.tilesDrawnStart", {
        uuid: this.uuid
      });
      this._checkForErrors();
      _superPropGet$B(TiledPixiTrack2, "draw", this)([]);
      Object.keys(this.fetchedTiles).forEach((tilesetUid) => {
        this.drawTile(this.fetchedTiles[tilesetUid]);
      });
      this.pubSub?.publish("TiledPixiTrack.tilesDrawnEnd", {
        uuid: this.uuid
      });
    }
    /**
     * Draw a tile on some graphics
     * @param {Tile} tile
     */
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
    }
  }, {
    key: "calculateMedianVisibleValue",
    value: function calculateMedianVisibleValue() {
      if (this.areAllVisibleTilesLoaded()) {
        this.allTilesLoaded();
      }
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const values = (
        /** @type {Array<number>} */
        [].concat(...visibleAndFetchedIds.filter((x) => this.fetchedTiles[x].tileData.dense).map((x) => Array.from(this.fetchedTiles[x].tileData.dense))).filter((x) => x > 0)
      );
      this.medianVisibleValue = median$1(values);
      return this.medianVisibleValue;
    }
  }, {
    key: "allVisibleValues",
    value: function allVisibleValues() {
      return (
        /** @type {Array<number>} */
        [].concat(...this.visibleAndFetchedIds().map((x) => Array.from(this.fetchedTiles[x].tileData.dense)))
      );
    }
    // Should be overwriten by child clases to get the true minimal
    // visible value in the currently viewed area
  }, {
    key: "minVisibleValue",
    value: function minVisibleValue(ignoreFixedScale = false) {
      return this.minVisibleValueInTiles(ignoreFixedScale);
    }
  }, {
    key: "minVisibleValueInTiles",
    value: function minVisibleValueInTiles(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let min2 = Math.min(...visibleAndFetchedIds.map((x) => this.fetchedTiles[x].tileData.minNonZero));
      if (min2 === Number.MAX_SAFE_INTEGER) {
        min2 = null;
      }
      if (ignoreFixedScale) return min2;
      return this.valueScaleMin !== null ? this.valueScaleMin : min2;
    }
    // Should be overwriten by child clases to get the true maximal
    // visible value in the currently viewed area
  }, {
    key: "maxVisibleValue",
    value: function maxVisibleValue(ignoreFixedScale = false) {
      return this.maxVisibleValueInTiles(ignoreFixedScale);
    }
  }, {
    key: "maxVisibleValueInTiles",
    value: function maxVisibleValueInTiles(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let max2 = Math.max(...visibleAndFetchedIds.map((x) => this.fetchedTiles[x].tileData.maxNonZero));
      if (max2 === Number.MIN_SAFE_INTEGER) {
        max2 = null;
      }
      if (ignoreFixedScale) return max2;
      return this.valueScaleMax !== null ? this.valueScaleMax : max2;
    }
    /** @typedef {import('d3-scale').ScaleQuantile<number, never> & { ticks?: (count: number) => number[] }} ScaleQuantile */
    /**
     * Create a value scale that will be used to position values
     * along the y axis.
     * @param {number} minValue The minimum value of the data
     * @param {number} medianValue The median value of the data. Potentially used for adding a pseudocount
     * @param {number} maxValue The maximum value of the data
     * @param {number} [inMargin] A number of pixels to be left free on the top and bottom
     *    of the track. For example if the glyphs have a certain
     *    width and we want all of them to fit into the space
     * @returns {[t.Scale | ScaleQuantile, number]}
     */
  }, {
    key: "makeValueScale",
    value: function makeValueScale(minValue, medianValue, maxValue, inMargin) {
      let valueScale = null;
      let offsetValue = 0;
      let margin = inMargin;
      if (margin === null || typeof margin === "undefined") {
        margin = 6;
      }
      let minDimension = Math.min(this.dimensions[1] - margin, margin);
      let maxDimension = Math.max(this.dimensions[1] - margin, margin);
      if (this.dimensions[1] - margin < margin) {
        minDimension = this.dimensions[1] / 2;
        maxDimension = this.dimensions[1] / 2;
      }
      if (this.options.valueScaling === "log") {
        offsetValue = medianValue;
        if (!offsetValue) {
          offsetValue = minValue;
        }
        valueScale = log$2().domain([offsetValue, maxValue + offsetValue]).range([maxDimension, minDimension]);
      } else if (this.options.valueScaling === "quantile") {
        const start2 = this.dimensions[1] - margin;
        const end2 = margin;
        const quantScale = quantile().domain(this.allVisibleValues()).range(range$4(start2, end2, (end2 - start2) / 256));
        quantScale.ticks = (n) => ticks(start2, end2, n);
        return [quantScale, 0];
      } else if (this.options.valueScaling === "setquantile") {
        const start2 = this.dimensions[1] - margin;
        const end2 = margin;
        const s = new Set(this.allVisibleValues());
        const quantScale = quantile().domain([...s]).range(range$4(start2, end2, (end2 - start2) / 256));
        quantScale.ticks = (n) => ticks(start2, end2, n);
        return [quantScale, 0];
      } else {
        valueScale = linear().domain([minValue, maxValue]).range([maxDimension, minDimension]);
      }
      return [valueScale, offsetValue];
    }
  }]);
})(PixiTrack);
function _classCallCheck$S(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$S(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$S(o.key), o);
  }
}
function _createClass$S(e, r2, t) {
  return r2 && _defineProperties$S(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$S(t) {
  var i = _toPrimitive$S(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$S(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$R(t, o, e) {
  return o = _getPrototypeOf$R(o), _possibleConstructorReturn$R(t, _isNativeReflectConstruct$R() ? Reflect.construct(o, e || [], _getPrototypeOf$R(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$R(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$R(t);
}
function _assertThisInitialized$R(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$R() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$R = function() {
    return !!t;
  })();
}
function _superPropGet$A(t, o, e, r2) {
  var p = _get$A(_getPrototypeOf$R(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$A() {
  return _get$A = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$A(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$A.apply(null, arguments);
}
function _superPropBase$A(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$R(t)); ) ;
  return t;
}
function _getPrototypeOf$R(t) {
  return _getPrototypeOf$R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$R(t);
}
function _inherits$R(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$R(t, e);
}
function _setPrototypeOf$R(t, e) {
  return _setPrototypeOf$R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$R(t, e);
}
const BINS_PER_TILE$1 = 1024;
let Tiled1DPixiTrack = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function Tiled1DPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$S(this, Tiled1DPixiTrack2);
    _this = _callSuper$R(this, Tiled1DPixiTrack2, [context, options2]);
    const {
      onMouseMoveZoom,
      isValueScaleLocked,
      getLockGroupExtrema
    } = context;
    _this.onMouseMoveZoom = onMouseMoveZoom;
    _this.isValueScaleLocked = isValueScaleLocked;
    _this.getLockGroupExtrema = getLockGroupExtrema;
    if (_this.onMouseMoveZoom) {
      _this.pubSubs.push(_this.pubSub.subscribe("app.mouseMove", _this.mouseMoveHandler.bind(_this)));
    }
    return _this;
  }
  _inherits$R(Tiled1DPixiTrack2, _TiledPixiTrack);
  return _createClass$S(Tiled1DPixiTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      _superPropGet$A(Tiled1DPixiTrack2, "initTile", this)([tile]);
    }
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "relevantScale",
    value: function relevantScale() {
      return null;
    }
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        const xTiles2 = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
        const tiles2 = xTiles2.map((x) => [this.zoomLevel, x]);
        this.setVisibleTiles(tiles2);
        return;
      }
      const xTiles = api.calculateTiles(this.zoomLevel, this.relevantScale(), this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const tiles = xTiles.map((x) => [this.zoomLevel, x]);
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "getTilePosAndDimensions",
    value: function getTilePosAndDimensions2(zoomLevel, tilePos, binsPerTileIn) {
      const xTilePos = tilePos[0];
      const yTilePos = tilePos[0];
      if (this.tilesetInfo.resolutions) {
        const binsPerTile = binsPerTileIn || BINS_PER_TILE$1;
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        const chosenResolution = sortedResolutions[zoomLevel];
        const tileWidth2 = chosenResolution * binsPerTile;
        const tileHeight2 = tileWidth2;
        const tileX2 = chosenResolution * binsPerTile * tilePos[0];
        const tileY2 = chosenResolution * binsPerTile * tilePos[1];
        return {
          tileX: tileX2,
          tileY: tileY2,
          tileWidth: tileWidth2,
          tileHeight: tileHeight2
        };
      }
      const totalWidth = this.tilesetInfo.max_width;
      const totalHeight = this.tilesetInfo.max_width;
      const minX = this.tilesetInfo.min_pos[0];
      const minY = this.tilesetInfo.min_pos[1];
      const tileWidth = totalWidth / 2 ** zoomLevel;
      const tileHeight = totalHeight / 2 ** zoomLevel;
      const tileX = minX + xTilePos * tileWidth;
      const tileY = minY + yTilePos * tileHeight;
      return {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      };
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
  }, {
    key: "scheduleRerender",
    value: function scheduleRerender() {
      this.backgroundTaskScheduler.enqueueTask(this.handleRerender.bind(this), null, this.uuid);
    }
  }, {
    key: "handleRerender",
    value: function handleRerender() {
      this.rerender(this.options, false);
    }
  }, {
    key: "getIndicesOfVisibleDataInTile",
    value: function getIndicesOfVisibleDataInTile(tile) {
      const visible = this._xScale.range();
      if (!this.tilesetInfo) return [null, null];
      if (!tile.tileData.dense) {
        console.warn(`No dense data in tile: ${tile.tileData.tilePos}`);
        return [null, null];
      }
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size || tile.tileData.dense.length);
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension || tile.tileData.dense.length]).range([tileX, tileX + tileWidth]);
      const start2 = Math.max(0, Math.round(tileXScale.invert(this._xScale.invert(visible[0]))));
      const end2 = Math.min(tile.tileData.dense.length, Math.round(tileXScale.invert(this._xScale.invert(visible[1]))));
      return [start2, end2];
    }
    /**
     * Returns the minimum in the visible area (not visible tiles)
     */
  }, {
    key: "minVisibleValue",
    value: function minVisibleValue(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const minimumsPerTile = visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((tile) => tile.tileData.dense).map((tile) => {
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMinNonZeroInSubset(ind);
      });
      const min2 = Math.min(...minimumsPerTile);
      if (ignoreFixedScale) return min2;
      return this.valueScaleMin !== null ? this.valueScaleMin : min2;
    }
    /**
     * Returns the maximum in the visible area (not visible tiles)
     */
  }, {
    key: "maxVisibleValue",
    value: function maxVisibleValue(ignoreFixedScale = false) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const maximumsPerTile = visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((tile) => tile.tileData.dense).map((tile) => {
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMaxNonZeroInSubset(ind);
      });
      const max2 = Math.max(...maximumsPerTile);
      if (ignoreFixedScale) return max2;
      return this.valueScaleMax !== null ? this.valueScaleMax : max2;
    }
    /**
     * Return an aggregated visible value. For example, the minimum or maximum.
     *
     * @description
     *   The difference to `minVisibleValueInTiles`
     *   is that the truly visible min or max value is returned instead of the
     *   min or max value of the tile. The latter is not necessarily visible.
     *
     *   For 'min' and 'max' this is identical to minVisibleValue and maxVisibleValue
     *
     * @param  {string} aggregator Aggregation method. Currently supports `min`
     *   and `max` only.
     * @return {number} The aggregated value.
     */
  }, {
    key: "getAggregatedVisibleValue",
    value: function getAggregatedVisibleValue(aggregator = "max") {
      const aggregate = aggregator === "min" ? Math.min : Math.max;
      const limit = aggregator === "min" ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const visible = this._xScale.range();
      return visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).map((tile) => {
        if (!tile.tileData.tilePos) {
          return aggregator === "min" ? this.minVisibleValue() : this.maxVisibleValue();
        }
        const {
          tileX,
          tileWidth
        } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
        const tileXScale = linear().domain([0, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension]).range([tileX, tileX + tileWidth]);
        const start2 = Math.max(0, Math.round(tileXScale.invert(this._xScale.invert(visible[0]))));
        const end2 = Math.min(tile.tileData.dense.length, Math.round(tileXScale.invert(this._xScale.invert(visible[1]))));
        return tile.tileData.dense.slice(start2, end2);
      }).reduce((smallest, current) => aggregate(smallest, ...current), limit);
    }
    /**
     * Get the data value at a relative pixel position
     * @param   {number}  relPos  Relative pixel position, where 0 indicates the
     *   start of the track
     * @return  {number}  The data value at `relPos`
     */
  }, {
    key: "getDataAtPos",
    value: function getDataAtPos(relPos) {
      let value;
      if (!this.tilesetInfo) return value;
      const zoomLevel = this.calculateZoomLevel();
      const tileWidth = api.calculateTileWidth(this.tilesetInfo, zoomLevel, this.tilesetInfo.tile_size);
      const tilePos = this._xScale.invert(relPos) / tileWidth;
      const tileId = this.tileToLocalId([zoomLevel, Math.floor(tilePos)]);
      const fetchedTile = this.fetchedTiles[tileId];
      if (!fetchedTile) return value;
      const posInTileX = this.tilesetInfo.tile_size * (tilePos - Math.floor(tilePos));
      if (fetchedTile.tileData.dense) {
        return fetchedTile.tileData.dense[Math.floor(posInTileX)];
      }
      return null;
    }
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler({
      x,
      y
    } = {}) {
      if (!this.isWithin(x, y)) return;
      this.mouseX = x;
      this.mouseY = y;
      this.mouseMoveZoomHandler();
    }
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler() {
    }
  }, {
    key: "zoomed",
    value: function zoomed(...args) {
      _superPropGet$A(Tiled1DPixiTrack2, "zoomed", this)(args);
      this.mouseMoveZoomHandler();
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$R(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$R(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$R(o.key), o);
  }
}
function _createClass$R(e, r2, t) {
  return r2 && _defineProperties$R(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$R(t) {
  var i = _toPrimitive$R(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$R(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$Q(t, o, e) {
  return o = _getPrototypeOf$Q(o), _possibleConstructorReturn$Q(t, _isNativeReflectConstruct$Q() ? Reflect.construct(o, e || [], _getPrototypeOf$Q(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$Q(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$Q(t);
}
function _assertThisInitialized$Q(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$Q() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$Q = function() {
    return !!t;
  })();
}
function _superPropGet$z(t, o, e, r2) {
  var p = _get$z(_getPrototypeOf$Q(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$z() {
  return _get$z = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$z(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$z.apply(null, arguments);
}
function _superPropBase$z(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$Q(t)); ) ;
  return t;
}
function _getPrototypeOf$Q(t) {
  return _getPrototypeOf$Q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$Q(t);
}
function _inherits$Q(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$Q(t, e);
}
function _setPrototypeOf$Q(t, e) {
  return _setPrototypeOf$Q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$Q(t, e);
}
let HorizontalTiled1DPixiTrack = /* @__PURE__ */ (function(_Tiled1DPixiTrack) {
  function HorizontalTiled1DPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$R(this, HorizontalTiled1DPixiTrack2);
    _this = _callSuper$Q(this, HorizontalTiled1DPixiTrack2, [context, options2]);
    const {
      animate,
      isShowGlobalMousePosition
    } = context;
    _this.constIndicator = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.constIndicator);
    _this.axis = new AxisPixi(_this);
    _this.pBase.addChild(_this.axis.pAxis);
    _this.animate = animate;
    _this.options = options2;
    _this.isShowGlobalMousePosition = isShowGlobalMousePosition;
    _this.pubSubs = [];
    if (_this.options.showMousePosition && !_this.hideMousePosition) {
      _this.hideMousePosition = setupShowMousePosition(_this, _this.is2d, _this.isShowGlobalMousePosition());
    }
    return _this;
  }
  _inherits$Q(HorizontalTiled1DPixiTrack2, _Tiled1DPixiTrack);
  return _createClass$R(HorizontalTiled1DPixiTrack2, [{
    key: "rerender",
    value: function rerender(options2, force) {
      const strOptions = JSON.stringify(options2);
      if (!force && strOptions === this.prevOptions) return;
      _superPropGet$z(HorizontalTiled1DPixiTrack2, "rerender", this, 3)([options2, force]);
      this.prevOptions = strOptions;
      this.options = options2;
      if (this.options.showMousePosition && !this.hideMousePosition) {
        this.hideMousePosition = setupShowMousePosition(this, this.is2d, this.isShowGlobalMousePosition());
      }
      if (!this.options.showMousePosition && this.hideMousePosition) {
        this.hideMousePosition();
        this.hideMousePosition = void 0;
      }
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      if (this.tilesetInfo.resolutions) {
        const zoomIndexX = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0] - 2);
        return zoomIndexX;
      }
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.bins_per_dimension || this.tilesetInfo.tile_size);
      let zoomLevel = Math.min(xZoomLevel, this.maxZoom);
      zoomLevel = Math.max(zoomLevel, 0);
      return zoomLevel;
    }
    /**
     * Which scale should we use for calculating tile positions?
     *
     * Horizontal tracks should use the xScale and vertical tracks
     * should use the yScale
     *
     * This function should be overwritten by HorizontalTiled1DPixiTrack.js
     * and VerticalTiled1DPixiTrack.js
     */
  }, {
    key: "relevantScale",
    value: function relevantScale() {
      return this._xScale;
    }
  }, {
    key: "draw",
    value: function draw() {
      _superPropGet$z(HorizontalTiled1DPixiTrack2, "draw", this, 3)([]);
      this.drawConstIndicator();
    }
  }, {
    key: "drawAxis",
    value: function drawAxis2(valueScale) {
      if (!this.options.axisPositionVertical && !this.options.axisPositionHorizontal) {
        this.axis.clearAxis();
        return;
      }
      if (this.options.axisPositionVertical && this.options.axisPositionVertical === "hidden") {
        this.axis.clearAxis();
        return;
      }
      if (this.options.axisPositionHorizontal && this.options.axisPositionHorizontal === "hidden") {
        this.axis.clearAxis();
        return;
      }
      const margin = this.options.axisMargin || 0;
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        this.axis.pAxis.position.x = this.position[0] + margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisRight(valueScale, this.dimensions[1]);
      } else if (this.options.axisPositionHorizontal === "outsideLeft" || this.options.axisPositionVertical === "outsideTop") {
        this.axis.pAxis.position.x = this.position[0] + margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisLeft(valueScale, this.dimensions[1]);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        this.axis.pAxis.position.x = this.position[0] + this.dimensions[0] - margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisLeft(valueScale, this.dimensions[1]);
      } else if (this.options.axisPositionHorizontal === "outsideRight" || this.options.axisPositionVertical === "outsideBottom") {
        this.axis.pAxis.position.x = this.position[0] + this.dimensions[0] - margin;
        this.axis.pAxis.position.y = this.position[1];
        this.axis.drawAxisRight(valueScale, this.dimensions[1]);
      }
    }
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler(absX = this.mouseX, absY = this.mouseY) {
      if (typeof absX === "undefined" || !this.areAllVisibleTilesLoaded() || !this.tilesetInfo) return;
      let dataPosX = 0;
      let dataPosY = 0;
      let orientation2 = "1d-horizontal";
      if (this.isLeftModified) {
        dataPosX = absY - this.position[1];
        dataPosY = absX - this.position[0];
        orientation2 = "1d-vertical";
      } else {
        dataPosX = absX - this.position[0];
        dataPosY = absY - this.position[1];
      }
      const relX = absX - this.position[0];
      const relY = absY - this.position[1];
      const dataX = this._xScale.invert(dataPosX);
      const dataY = this._yScale.invert(dataPosY);
      const data2 = this.getDataAtPos(dataPosX);
      if (!data2) return;
      this.onMouseMoveZoom({
        trackId: this.id,
        data: data2,
        absX,
        absY,
        relX,
        relY,
        dataX,
        dataY,
        orientation: orientation2
      });
    }
  }, {
    key: "drawConstIndicator",
    value: function drawConstIndicator() {
      if (!this.constIndicator) {
        return;
      }
      this.constIndicator.clear();
      while (this.constIndicator.children[0]) {
        this.constIndicator.removeChild(this.constIndicator.children[0]);
      }
      if (!this.options.constIndicators || !this.valueScale) return;
      this.options.constIndicators.forEach(({
        color: color2 = "black",
        opacity = 1,
        label = null,
        labelColor = "black",
        labelOpacity = 1,
        labelPosition = "leftTop",
        labelSize = 12,
        value = 0
      } = {}) => {
        const colorHex = colorToHex(color2);
        const labelColorHex = colorToHex(labelColor);
        this.constIndicator.beginFill(colorHex, opacity);
        const y = this.valueScale(value);
        let xOffset = 0;
        let widthOffset = 0;
        if (label) {
          const labelG = new GLOBALS.PIXI.Text(label, {
            fontFamily: "Arial",
            fontSize: labelSize,
            fill: labelColorHex
          });
          labelG.alpha = labelOpacity;
          switch (labelPosition) {
            case "right":
              labelG.anchor.x = 1;
              labelG.anchor.y = 0.5;
              labelG.x = this.position[0] + this.dimensions[0] - 6;
              labelG.y = y;
              widthOffset = labelG.width + 8;
              break;
            case "rightBottom":
              labelG.anchor.x = 1;
              labelG.anchor.y = 0;
              labelG.x = this.position[0] + this.dimensions[0] - 6;
              labelG.y = y;
              break;
            case "rightTop":
              labelG.anchor.x = 1;
              labelG.anchor.y = 1;
              labelG.x = this.position[0] + this.dimensions[0] - 6;
              labelG.y = y;
              break;
            case "left":
              labelG.anchor.x = 0;
              labelG.anchor.y = 0.5;
              labelG.x = this.position[0] + 2;
              labelG.y = y;
              xOffset = labelG.width + 4;
              break;
            case "leftBottom":
              labelG.anchor.x = 0;
              labelG.anchor.y = 0;
              labelG.x = this.position[0] + 2;
              labelG.y = y;
              break;
            // case 'leftTop':
            default:
              labelG.anchor.x = 0;
              labelG.anchor.y = 1;
              labelG.x = this.position[0] + 2;
              labelG.y = y;
              break;
          }
          this.constIndicator.addChild(labelG);
        }
        this.constIndicator.drawRect(this.position[0] + xOffset, y, this.dimensions[0] - widthOffset, 1);
      });
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$z(HorizontalTiled1DPixiTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$z(HorizontalTiled1DPixiTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      base.setAttribute("class", "horizontal-tiled-1d-track");
      const output = document.createElement("g");
      track.appendChild(output);
      if (this.options.constIndicators) {
        this.options.constIndicators.forEach(({
          color: color2 = "black",
          opacity = 1,
          label = null,
          labelColor = "black",
          labelOpacity = 1,
          labelPosition = "leftTop",
          labelSize = 12,
          value = 0
        } = {}) => {
          const y = this.valueScale(value);
          if (label) {
            const labelEl = document.createElement("text");
            labelEl.textContent = label;
            labelEl.setAttribute("x", this.position[0]);
            labelEl.setAttribute("y", y);
            labelEl.setAttribute("style", `font-family: 'Arial'; font-size: ${labelSize}px; fill: ${labelColor}; fill-opacity: ${labelOpacity};`);
            switch (labelPosition) {
              case "rightBottom":
                labelEl.setAttribute("x", this.position[0] + this.dimensions[0] - 6);
                labelEl.setAttribute("y", y + labelSize + 2);
                labelEl.setAttribute("text-anchor", "end");
                break;
              case "right":
              case "rightTop":
                labelEl.setAttribute("x", this.position[0] + this.dimensions[0] - 6);
                labelEl.setAttribute("y", y - 2);
                labelEl.setAttribute("text-anchor", "end");
                break;
              case "leftBottom":
                labelEl.setAttribute("x", this.position[0] + 2);
                labelEl.setAttribute("y", y + labelSize + 2);
                break;
              // case 'left':
              // case 'leftTop':
              default:
                labelEl.setAttribute("x", this.position[0] + 2);
                labelEl.setAttribute("y", y - 2);
                break;
            }
            output.appendChild(labelEl);
          }
          const line = document.createElement("line");
          line.setAttribute("x1", this.position[0]);
          line.setAttribute("y1", y);
          line.setAttribute("x2", this.dimensions[0]);
          line.setAttribute("y2", y);
          line.setAttribute("stroke", color2);
          line.setAttribute("stroke-opacity", opacity);
          output.appendChild(line);
        });
      }
      return [base, track];
    }
  }]);
})(Tiled1DPixiTrack);
function _callSuper$P(t, o, e) {
  return o = _getPrototypeOf$P(o), _possibleConstructorReturn$P(t, _isNativeReflectConstruct$P() ? Reflect.construct(o, e || [], _getPrototypeOf$P(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$P(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$P(t);
}
function _assertThisInitialized$P(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$P() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$P = function() {
    return !!t;
  })();
}
function _superPropGet$y(t, o, e, r2) {
  var p = _get$y(_getPrototypeOf$P(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$y() {
  return _get$y = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$y(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$y.apply(null, arguments);
}
function _superPropBase$y(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$P(t)); ) ;
  return t;
}
function _getPrototypeOf$P(t) {
  return _getPrototypeOf$P = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$P(t);
}
function _inherits$P(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$P(t, e);
}
function _setPrototypeOf$P(t, e) {
  return _setPrototypeOf$P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$P(t, e);
}
function _classCallCheck$Q(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$Q(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$Q(o.key), o);
  }
}
function _createClass$Q(e, r2, t) {
  return r2 && _defineProperties$Q(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$Q(t) {
  var i = _toPrimitive$Q(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$Q(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
const GENE_RECT_HEIGHT$1 = 16;
const MAX_TEXTS$1 = 50;
const MAX_TILE_ENTRIES = 5e3;
const STAGGERED_OFFSET = 5;
const FONT_SIZE$1 = 14;
const TEXT_STYLE = {
  align: "center",
  fontSize: `${FONT_SIZE$1}px`,
  fontFamily: "Arial",
  stroke: "white",
  strokeThickness: 2,
  fontWeight: 400,
  dropShadow: true,
  dropShadowColor: "white",
  dropShadowDistance: 0,
  dropShadowBlur: 2
};
const polyToPoly = (poly, kx, px, ky, py) => {
  const newArr = [];
  while (poly.length) {
    const [x, y] = poly.splice(0, 2);
    newArr.push([x * kx + px, y * ky + py]);
  }
  return newArr;
};
const hashFunc = (s) => {
  let hash = 0;
  if (s.length === 0) {
    return hash;
  }
  for (let i = 0; i < s.length; i++) {
    const char = s.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash;
  }
  return hash;
};
const scaleScalableGraphics = (graphics, xScale, drawnAtScale) => {
  const tileK = (drawnAtScale.domain()[1] - drawnAtScale.domain()[0]) / (xScale.domain()[1] - xScale.domain()[0]);
  const newRange = xScale.domain().map(drawnAtScale);
  const posOffset = newRange[0];
  graphics.scale.x = tileK;
  graphics.position.x = -posOffset * tileK;
};
const uniqueify = (elements) => {
  const byUid = {};
  for (let i = 0; i < elements.length; i++) {
    byUid[elements[i].uid] = elements[i];
  }
  return Object.values(byUid);
};
let TextManager = /* @__PURE__ */ (function() {
  function TextManager2(track) {
    _classCallCheck$Q(this, TextManager2);
    this.track = track;
    this.texts = {};
    this.textsList = [];
    this.textWidths = {};
    this.textHeights = {};
    this.textGraphics = new GLOBALS.PIXI.Graphics();
    this.track.pMain.addChild(this.textGraphics);
    this.fontSize = 9;
  }
  return _createClass$Q(TextManager2, [{
    key: "hideOverlaps",
    value: function hideOverlaps() {
      const [allBoxes, allTexts] = [this.allBoxes, this.allTexts];
      boxIntersect(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          if (allTexts[i].text.visible) {
            allTexts[j].text.visible = false;
          }
        } else if (allTexts[j].text.visible) {
          allTexts[i].text.visible = false;
        }
      });
    }
  }, {
    key: "startDraw",
    value: function startDraw() {
      this.allBoxes = [];
      this.allTexts = [];
    }
  }, {
    key: "lightUpdateSingleText",
    value: function lightUpdateSingleText(td, xMiddle, yMiddle, textInfo) {
      if (!this.texts[td.uid]) return;
      if (!this.track.options.showTexts) return;
      const text2 = this.texts[td.uid];
      const TEXT_MARGIN = 3;
      text2.position.x = xMiddle;
      text2.position.y = yMiddle;
      text2.visible = true;
      this.allBoxes.push([text2.position.x - TEXT_MARGIN, text2.position.y - this.textHeights[td.uid] / 2, text2.position.x + this.textWidths[td.uid] + TEXT_MARGIN, text2.position.y + this.textHeights[td.uid] / 2]);
      this.allTexts.push({
        text: text2,
        ...textInfo
      });
    }
  }, {
    key: "updateSingleText",
    value: function updateSingleText(td, xMiddle, yMiddle, textText) {
      if (!this.texts[td.uid]) return;
      const text2 = this.texts[td.uid];
      text2.position.x = xMiddle;
      text2.position.y = yMiddle;
      text2.nominalY = yMiddle;
      const fontColor = this.track.options.fontColor !== void 0 ? colorToHex(this.track.options.fontColor) : "black";
      const newFontSize = +this.track.options.fontSize || TEXT_STYLE.fontSize;
      if (newFontSize !== this.fontSize) {
        this.fontSize = newFontSize;
        this.textWidths = {};
        this.textHeights = {};
      }
      text2.style = {
        ...TEXT_STYLE,
        fill: fontColor,
        fontSize: this.fontSize
      };
      text2.text = textText;
      if (!(td.uid in this.textWidths)) {
        text2.updateTransform();
        const textWidth = text2.getBounds().width;
        const textHeight = text2.getBounds().height;
        const TEXT_SIZE_ADJUSTMENT = 5;
        this.textWidths[td.uid] = textWidth;
        this.textHeights[td.uid] = textHeight - TEXT_SIZE_ADJUSTMENT;
      }
    }
  }, {
    key: "updateTexts",
    value: function updateTexts() {
      if (this.track.options.showTexts) {
        this.texts = {};
        let yRange = [(0 - this.track.vertY) / (this.track.vertK * this.track.prevK), (this.track.dimensions[1] - this.track.vertY) / (this.track.vertK * this.track.prevK)];
        const yRangeWidth = yRange[1] - yRange[0];
        yRange = [yRange[0] - yRangeWidth * 0.8, yRange[1] + yRangeWidth * 0.8];
        const relevantSegments = this.track.uniqueSegments.filter((x) => !x.yMiddle || x.yMiddle > yRange[0] && x.yMiddle < yRange[1]);
        relevantSegments.forEach((td, i) => {
          if (i >= (+this.track.options.maxTexts || MAX_TEXTS$1)) {
            return;
          }
          let text2 = this.textsList[i];
          if (!text2) {
            text2 = new GLOBALS.PIXI.Text();
            this.textsList.push(text2);
            this.textGraphics.addChild(text2);
          }
          text2.style = {
            ...TEXT_STYLE,
            fontSize: +this.track.options.fontSize || TEXT_STYLE.fontSize
          };
          if (this.track.isLeftModified) {
            text2.scale.x = -1;
          }
          text2.anchor.x = 0.5;
          text2.anchor.y = 0.5;
          this.texts[td.uid] = text2;
        });
        while (this.textsList.length > Math.min(relevantSegments.length, +this.track.options.maxTexts || MAX_TEXTS$1)) {
          const text2 = this.textsList.pop();
          this.textGraphics.removeChild(text2);
        }
      }
    }
  }]);
})();
let BedLikeTrack = /* @__PURE__ */ (function(_HorizontalTiled1DPix) {
  function BedLikeTrack2(context, options2) {
    var _this;
    _classCallCheck$Q(this, BedLikeTrack2);
    _this = _callSuper$P(this, BedLikeTrack2, [context, options2]);
    _this.valueScaleTransform = identity$4;
    _this.textManager = new TextManager(_this);
    _this.vertY = 1;
    _this.vertK = 0;
    _this.prevY = 0;
    _this.prevK = 1;
    _this.minRawValue = null;
    _this.maxRawValue = null;
    _this.rectGraphics = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.rectGraphics);
    _this.selectedRect = null;
    _this.uniqueSegments = [];
    return _this;
  }
  _inherits$P(BedLikeTrack2, _HorizontalTiled1DPix);
  return _createClass$Q(BedLikeTrack2, [{
    key: "initialize",
    value: function initialize() {
      if (this.initialized) return;
      [this.prevK, this.vertK, this.vertY] = [1, 1, 0];
      if (!this.drawnRects) {
        this.drawnRects = {};
      }
      if (!this.colorScale) {
        if (this.options.colorRange) {
          this.colorScale = colorDomainToRgbaArray(this.options.colorRange);
        } else {
          this.colorScale = HEATED_OBJECT_MAP;
        }
      }
      this.initialized = true;
    }
  }, {
    key: "updateExistingGraphics",
    value: function updateExistingGraphics() {
      const errors = this._checkForErrors();
      let plusStrandRows = [];
      let minusStrandRows = [];
      if (errors.length > 0) {
        this.draw();
        return;
      }
      this.uniqueSegments = uniqueify(Object.values(this.fetchedTiles).filter((x) => x.tileData.length).flatMap((x) => x.tileData));
      this.uniqueSegments.forEach((td) => {
        if (!td.importance) {
          td.importance = hashFunc(td.uid.toString());
        }
      });
      this.uniqueSegments.sort((a, b) => b.importance - a.importance);
      if (!this.options || !this.options.valueColumn) {
        const segments = this.uniqueSegments.map((x) => {
          const chrOffset = +x.chrOffset;
          return {
            from: +x.fields[1] + chrOffset,
            to: +x.fields[2] + chrOffset,
            value: x,
            text: x.fields[3],
            strand: x.fields.length >= 6 && x.fields[5] === "-" ? "-" : "+"
          };
        });
        plusStrandRows = segmentsToRows(segments.filter((x) => x.strand === "+"));
        minusStrandRows = segmentsToRows(segments.filter((x) => x.strand === "-"));
      } else {
        plusStrandRows = [this.uniqueSegments.map((x) => ({
          value: x
        }))];
      }
      this.plusStrandRows = plusStrandRows;
      this.minusStrandRows = minusStrandRows;
      this.textManager.updateTexts();
      this.render();
    }
  }, {
    key: "selectRect",
    value: function selectRect(uid) {
      this.selectedRect = uid;
      this.render();
      this.animate();
    }
    /** There was a click outside the track so unselect the
     * the current selection */
  }, {
    key: "clickOutside",
    value: function clickOutside() {
      this.selectRect(null);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
    }
    /**
     * Remove the tile's rectangles from the list of drawnRects so that they
     * can be drawn again.
     */
    // removeTileRects(tile) {
    //   const zoomLevel = +tile.tileId.split('.')[0];
    //   tile.rectGraphics.clear();
    //   tile.rendered = false;
    //   if (tile.tileData && tile.tileData.length) {
    //     tile.tileData.forEach((td, i) => {
    //       if (this.drawnRects[zoomLevel] && this.drawnRects[zoomLevel][td.uid]) {
    //         if (this.drawnRects[zoomLevel][td.uid][2] === tile.tileId) {
    //           // this was the tile that drew that rectangle
    //           delete this.drawnRects[zoomLevel][td.uid];
    //         }
    //       }
    //     });
    //   }
    // }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
    }
  }, {
    key: "removeTiles",
    value: function removeTiles(toRemoveIds) {
      _superPropGet$y(BedLikeTrack2, "removeTiles", this, 3)([toRemoveIds]);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (this.options?.valueColumn) {
        if (this.valueScale) this.drawAxis(this.valueScale);
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      _superPropGet$y(BedLikeTrack2, "rerender", this, 3)([options2, force]);
      this.valueScale = null;
      this.drawnRects = {};
      if (this.options.colorRange) {
        this.colorScale = colorDomainToRgbaArray(this.options.colorRange);
      } else {
        this.colorScale = HEATED_OBJECT_MAP;
      }
      this.updateExistingGraphics();
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
    /**
     * Use this only when there's one row
     *
     * @return {[type]} [description]
     */
  }, {
    key: "allVisibleRects",
    value: function allVisibleRects() {
      const allRects = {};
      Object.values(this.fetchedTiles).forEach((x) => {
        if (!x.plusStrandRows) return;
        for (const row of x.plusStrandRows[0]) {
          if (!allRects[row.value.uid]) {
            allRects[row.value.uid] = row;
          }
        }
      });
      const sortedRows = Object.values(allRects).sort((a, b) => a.from - b.from);
      let startPos = 0;
      let startStaggered = 0;
      for (let i = 0; i < sortedRows.length; i++) {
        if (sortedRows[i].staggeredStartPosition !== void 0) {
          startPos = i;
          startStaggered = sortedRows[i].staggeredStartPosition;
          break;
        }
      }
      for (let i = startPos; i < sortedRows.length; i++) {
        sortedRows[i].staggeredStartPosition = (startStaggered + i - startPos) % 2;
      }
      for (let i = startPos; i >= 0 && sortedRows.length; i--) {
        sortedRows[i].staggeredStartPosition = (startStaggered + startPos - i) % 2;
      }
      return allRects;
    }
  }, {
    key: "drawSegmentStyle",
    value: function drawSegmentStyle(xStartPos, xEndPos, rectY, rectHeight, strand) {
      const hw = 0.1;
      const centerY = rectY + rectHeight / 2;
      const poly = [
        xStartPos,
        rectY,
        // upper left
        xStartPos + 2 * hw,
        rectY,
        // upper right
        xStartPos + 2 * hw,
        centerY - hw,
        xEndPos - 2 * hw,
        centerY - hw,
        xEndPos - 2 * hw,
        rectY,
        xEndPos,
        rectY,
        xEndPos,
        rectY + rectHeight,
        xEndPos - 2 * hw,
        rectY + rectHeight,
        xEndPos - 2 * hw,
        centerY + hw,
        xStartPos + 2 * hw,
        centerY + hw,
        xStartPos + 2 * hw,
        rectY + rectHeight,
        xStartPos,
        rectY + rectHeight
      ];
      this.rectGraphics.drawPolygon(poly);
      return poly;
    }
  }, {
    key: "drawPoly",
    value: function drawPoly(xStartPos, xEndPos, rectY, rectHeight, strand) {
      let drawnPoly = null;
      if (this.options.annotationStyle === "segment") {
        return this.drawSegmentStyle(xStartPos, xEndPos, rectY, rectHeight, strand);
      }
      if ((strand === "+" || strand === "-") && xEndPos - xStartPos < GENE_RECT_HEIGHT$1 / 2) {
        drawnPoly = [
          xStartPos,
          rectY,
          // top
          xStartPos + rectHeight / 2,
          rectY + rectHeight / 2,
          // right point
          xStartPos,
          rectY + rectHeight
          // bottom
        ];
        if (strand === "+") {
          this.rectGraphics.drawPolygon(drawnPoly);
        } else {
          drawnPoly = [
            xEndPos,
            rectY,
            // top
            xEndPos - rectHeight / 2,
            rectY + rectHeight / 2,
            // left point
            xEndPos,
            rectY + rectHeight
            // bottom
          ];
          this.rectGraphics.drawPolygon(drawnPoly);
        }
      } else {
        if (strand === "+") {
          drawnPoly = [
            xStartPos,
            rectY,
            // left top
            xEndPos - rectHeight / 2,
            rectY,
            // right top
            xEndPos,
            rectY + rectHeight / 2,
            xEndPos - rectHeight / 2,
            rectY + rectHeight,
            // right bottom
            xStartPos,
            rectY + rectHeight
            // left bottom
          ];
        } else if (strand === "-") {
          drawnPoly = [
            xStartPos + rectHeight / 2,
            rectY,
            // left top
            xEndPos,
            rectY,
            // right top
            xEndPos,
            rectY + rectHeight,
            // right bottom
            xStartPos + rectHeight / 2,
            rectY + rectHeight,
            // left bottom
            xStartPos,
            rectY + rectHeight / 2
          ];
        } else {
          drawnPoly = [
            xStartPos,
            rectY,
            // left top
            xEndPos,
            rectY,
            // right top
            xEndPos,
            rectY + rectHeight,
            // right bottom
            xStartPos,
            rectY + rectHeight
            // left bottom
          ];
        }
        this.rectGraphics.drawPolygon(drawnPoly);
      }
      return drawnPoly;
    }
    /** The value scale is used to arrange annotations vertically
        based on a value */
  }, {
    key: "setValueScale",
    value: function setValueScale() {
      this.valueScale = null;
      if (this.options?.valueColumn) {
        const min2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[0] : this.minVisibleValueInTiles(+this.options.valueColumn);
        const max2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[1] : this.maxVisibleValueInTiles(+this.options.valueColumn);
        if (this.options.valueColumn) {
          [this.valueScale] = this.makeValueScale(min2, this.calculateMedianVisibleValue(+this.options.valueColumn), max2);
        }
      }
    }
    /** The color value scale is used to map some value to a coloring */
  }, {
    key: "setColorValueScale",
    value: function setColorValueScale() {
      this.colorValueScale = null;
      if (this.options?.colorEncoding && this.options.colorEncoding !== "itemRgb") {
        const min2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[0] : this.minVisibleValueInTiles(+this.options.colorEncoding);
        const max2 = this.options.colorEncodingRange ? +this.options.colorEncodingRange[1] : this.maxVisibleValueInTiles(+this.options.colorEncoding);
        this.colorValueScale = linear().domain([min2, max2]).range([0, 255]);
      }
    }
  }, {
    key: "renderRows",
    value: function renderRows(rows, maxRows, startY, endY, fill) {
      this.initialize();
      const rowScale = band().domain(range$4(maxRows)).range([startY, endY]);
      this.allVisibleRects();
      let allRects = null;
      if (this.options.staggered) {
        allRects = this.allVisibleRects();
      }
      for (let j = 0; j < rows.length; j++) {
        for (let i = 0; i < rows[j].length; i++) {
          const td = rows[j][i].value;
          const geneInfo = td.fields;
          const txStart = +td.xStart;
          const txEnd = +td.xEnd;
          const txMiddle = (txStart + txEnd) / 2;
          let yMiddle = rowScale(j) + rowScale.bandwidth() / 2;
          let rectHeight = this.options.annotationHeight || "scaled";
          if (rectHeight === "scaled") {
            rectHeight = rowScale.bandwidth();
            if (this.options.maxAnnotationHeight) {
              rectHeight = Math.min(rectHeight, +this.options.maxAnnotationHeight);
            }
          }
          if (this.options && this.options.colorEncoding === "itemRgb" && td.fields[8]) {
            let parts = [];
            try {
              parts = td.fields[8].split(",");
            } catch {
            }
            if (parts.length === 3) {
              const color2 = `rgb(${td.fields[8]})`;
              fill = color2;
            }
          } else if (this.colorValueScale) {
            const rgb2 = valueToColor(
              this.colorValueScale,
              this.colorScale,
              0,
              // pseudocounts
              -Number.MIN_VALUE
            )(+geneInfo[+this.options.colorEncoding - 1]);
            fill = `rgba(${rgb2.join(",")})`;
          } else if (this.options && this.options.colorEncoding === "itemRgb" && td.fields[8]) {
            const parts = td.fields[8].split(",");
            if (parts.length === 3) {
              const color2 = `rgb(${td.fields[8]})`;
              fill = color2;
            }
          }
          if (this.valueScale) {
            const value = +geneInfo[+this.options.valueColumn - 1];
            yMiddle = this.valueScale(value);
          }
          const opacity = this.options.fillOpacity || 0.3;
          if (this.selectedRect === td.uid) {
            this.rectGraphics.lineStyle(3, 0, 0.75);
          } else {
            this.rectGraphics.lineStyle(1, colorToHex(fill), opacity);
          }
          this.rectGraphics.beginFill(colorToHex(fill), opacity);
          let rectY = yMiddle - rectHeight / 2;
          const xStartPos = this._xScale(txStart);
          const xEndPos = this._xScale(txEnd);
          if (this.options.staggered) {
            const rect2 = allRects[td.uid];
            if (rect2.staggeredStartPosition) {
              rectY -= STAGGERED_OFFSET / 2;
            } else {
              rectY += STAGGERED_OFFSET / 2;
            }
          }
          const drawnPoly = this.drawPoly(xStartPos, xEndPos, rectY * this.prevK, rectHeight * this.prevK, geneInfo[5]);
          this.drawnRects[td.uid] = [drawnPoly, {
            start: txStart,
            end: txEnd,
            value: td,
            fill
          }];
          td.yMiddle = yMiddle;
          if (!this.options.showTexts) {
            continue;
          }
          if (i >= (+this.options.maxTexts || MAX_TEXTS$1)) continue;
          this.textManager.updateSingleText(td, this._xScale(txMiddle), rectY + rectHeight / 2, td.fields[3]);
        }
      }
      this.textManager.updateTexts();
    }
  }, {
    key: "render",
    value: function render3() {
      const maxPlusRows = this.plusStrandRows ? this.plusStrandRows.length : 1;
      const maxMinusRows = this.minusStrandRows ? this.minusStrandRows.length : 1;
      this.prevVertY = this.vertY;
      const oldRectGraphics = this.rectGraphics;
      this.rectGraphics = new GLOBALS.PIXI.Graphics();
      this.drawnAtScale = this._xScale.copy();
      this.setValueScale();
      this.setColorValueScale();
      const fill = this.options.plusStrandColor || this.options.fillColor || "blue";
      const minusStrandFill = this.options.minusStrandColor || this.options.fillColor || "purple";
      const MIDDLE_SPACE = 0;
      let plusHeight = 0;
      if (this.options.separatePlusMinusStrands) {
        plusHeight = maxPlusRows * this.dimensions[1] / (maxPlusRows + maxMinusRows) - MIDDLE_SPACE / 2;
      } else {
        plusHeight = this.dimensions[1];
      }
      this.renderRows(this.plusStrandRows, maxPlusRows, 0, plusHeight, fill);
      this.renderRows(this.minusStrandRows, maxMinusRows, this.options.separatePlusMinusStrands ? plusHeight + MIDDLE_SPACE / 2 : 0, this.dimensions[1], minusStrandFill);
      this.pMain.removeChild(oldRectGraphics);
      this.pMain.addChild(this.rectGraphics);
      scaleScalableGraphics(this.rectGraphics, this._xScale, this.drawnAtScale);
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      let zoomLevel = Math.min(xZoomLevel, this.maxZoom);
      zoomLevel = Math.max(zoomLevel, 0);
      return zoomLevel;
    }
  }, {
    key: "minVisibleValueInTiles",
    value: function minVisibleValueInTiles(valueColumn) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let min2 = Math.min.apply(null, visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((x) => x.tileData?.length).map((x) => Math.min.apply(null, x.tileData.sort((a, b) => b.importance - a.importance).slice(0, MAX_TILE_ENTRIES).map((y) => +y.fields[valueColumn - 1]).filter((y) => !Number.isNaN(y)))));
      if (min2 === Number.MAX_SAFE_INTEGER) {
        min2 = null;
      }
      return min2;
    }
  }, {
    key: "maxVisibleValueInTiles",
    value: function maxVisibleValueInTiles(valueColumn) {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      let max2 = Math.max.apply(null, visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((x) => x.tileData?.length).map((x) => Math.max.apply(null, x.tileData.sort((a, b) => b.importance - a.importance).slice(0, MAX_TILE_ENTRIES).map((y) => +y.fields[valueColumn - 1]).filter((y) => !Number.isNaN(y)))));
      if (max2 === Number.MIN_SAFE_INTEGER) {
        max2 = null;
      }
      return max2;
    }
  }, {
    key: "calculateMedianVisibleValue",
    value: function calculateMedianVisibleValue(valueColumn) {
      if (this.areAllVisibleTilesLoaded()) {
        this.allTilesLoaded();
      }
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const values = [].concat(...visibleAndFetchedIds.map((x) => this.fetchedTiles[x]).filter((x) => x.tileData?.length).map((x) => x.tileData.sort((a, b) => b.importance - a.importance).slice(0, MAX_TILE_ENTRIES).map((y) => +y.fields[valueColumn - 1]))).filter((x) => x > 0);
      this.medianVisibleValue = median$1(values);
    }
  }, {
    key: "draw",
    value: function draw() {
      _superPropGet$y(BedLikeTrack2, "draw", this, 3)([]);
      this.textManager.startDraw();
      this.rectGraphics.scale.y = this.vertK;
      this.rectGraphics.position.y = this.vertY;
      if (!this.drawnAtScale) {
        return;
      }
      scaleScalableGraphics(this.rectGraphics, this._xScale, this.drawnAtScale);
      if (this.uniqueSegments?.length) {
        this.uniqueSegments.forEach((td) => {
          const geneInfo = td.fields;
          const geneName = geneInfo[3];
          const xMiddle = this._xScale((td.xStart + td.xEnd) / 2);
          if (this.textManager.texts[td.uid]) {
            const yMiddle = this.textManager.texts[td.uid].nominalY * (this.vertK * this.prevK) + this.vertY;
            this.textManager.lightUpdateSingleText(td, xMiddle, yMiddle, {
              importance: td.importance,
              caption: geneName,
              strand: geneInfo[5]
            });
          }
        });
      }
      this.textManager.hideOverlaps();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$y(BedLikeTrack2, "setPosition", this, 3)([newPosition]);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$y(BedLikeTrack2, "setDimensions", this, 3)([newDimensions]);
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$y(BedLikeTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$y(BedLikeTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const rectOutput = document.createElement("g");
      const textOutput = document.createElement("g");
      output.appendChild(rectOutput);
      output.appendChild(textOutput);
      this.uniqueSegments.forEach((td) => {
        const gTile = document.createElement("g");
        gTile.setAttribute("transform", `translate(${this.rectGraphics.position.x},${this.rectGraphics.position.y})scale(${this.rectGraphics.scale.x},${this.rectGraphics.scale.y})`);
        rectOutput.appendChild(gTile);
        if (this.drawnRects && td.uid in this.drawnRects) {
          const rect2 = this.drawnRects[td.uid][0];
          const r2 = document.createElement("path");
          let d = `M ${rect2[0]} ${rect2[1]}`;
          for (let i = 2; i < rect2.length; i += 2) {
            d += ` L ${rect2[i]} ${rect2[i + 1]}`;
          }
          const fill = this.drawnRects[td.uid][1].fill;
          const fontColor = this.options.fontColor !== void 0 ? colorToHex(this.options.fontColor) : fill;
          r2.setAttribute("d", d);
          r2.setAttribute("fill", fill);
          r2.setAttribute("opacity", 0.3);
          r2.style.stroke = fill;
          r2.style.strokeWidth = "1px";
          gTile.appendChild(r2);
          if (this.textManager.texts[td.uid]) {
            const text2 = this.textManager.texts[td.uid];
            if (!text2.visible) {
              return;
            }
            const g = document.createElement("g");
            const t = document.createElement("text");
            textOutput.appendChild(g);
            g.appendChild(t);
            g.setAttribute("transform", `translate(${text2.x},${text2.y})scale(${text2.scale.x},1)`);
            t.setAttribute("text-anchor", "middle");
            t.setAttribute("font-family", TEXT_STYLE.fontFamily);
            t.setAttribute("font-size", +this.options.fontSize || TEXT_STYLE.fontSize);
            t.setAttribute("font-weight", "bold");
            t.setAttribute("dy", "5px");
            t.setAttribute("fill", fontColor);
            t.setAttribute("stroke", TEXT_STYLE.stroke);
            t.setAttribute("stroke-width", "0.4");
            t.setAttribute("text-shadow", "0px 0px 2px grey");
            t.innerHTML = text2.text;
          }
        }
      });
      return [base, base];
    }
    /** Move event for the y-axis */
  }, {
    key: "movedY",
    value: function movedY2(dY) {
      const vst = this.valueScaleTransform;
      const {
        y,
        k
      } = vst;
      const height = this.dimensions[1];
      if (y + dY / k > -(k - 1) * height && y + dY / k < 0) {
        this.valueScaleTransform = vst.translate(0, dY / k);
      }
      this.rectGraphics.position.y = this.valueScaleTransform.y;
      this.vertY = this.valueScaleTransform.y;
      this.animate();
      if (this.vertY - this.prevVertY > this.dimensions[1] / 2) {
        this.render();
      }
    }
    /** Zoomed along the y-axis */
  }, {
    key: "zoomedY",
    value: function zoomedY2(yPos, kMultiplier) {
      const newTransform = trackUtils.zoomedY(yPos, kMultiplier, this.valueScaleTransform, this.dimensions[1]);
      this.valueScaleTransform = newTransform;
      let k1 = newTransform.k;
      const t12 = newTransform.y;
      let toStretch = false;
      k1 /= this.prevK;
      if (k1 > 1.5 || k1 < 1 / 1.5) {
        this.prevK *= k1;
        k1 = 1;
        toStretch = true;
      }
      this.vertK = k1;
      this.vertY = t12;
      if (toStretch) {
        this.render();
      }
      this.rectGraphics.scale.y = k1;
      this.rectGraphics.position.y = t12;
      this.draw();
      this.animate();
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY) {
      if (!this.tilesetInfo) {
        return "";
      }
      if (!this.drawnRects) {
        return "";
      }
      const closestText = "";
      const point2 = [trackX, trackY];
      const visibleRects = Object.values(this.drawnRects);
      for (let i = 0; i < visibleRects.length; i++) {
        const rect2 = visibleRects[i][0].slice(0);
        const newArr = polyToPoly(rect2, this.rectGraphics.scale.x, this.rectGraphics.position.x, this.rectGraphics.scale.y, this.rectGraphics.position.y);
        const pc = classifyPoint(newArr, point2);
        if (pc === -1) {
          const parts = visibleRects[i][1].value.fields;
          return parts.join(" ");
        }
      }
      return closestText;
    }
  }]);
})(HorizontalTiled1DPixiTrack);
function _classCallCheck$P(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$P(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$P(o.key), o);
  }
}
function _createClass$P(e, r2, t) {
  return r2 && _defineProperties$P(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$P(t) {
  var i = _toPrimitive$P(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$P(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$O(t, o, e) {
  return o = _getPrototypeOf$O(o), _possibleConstructorReturn$O(t, _isNativeReflectConstruct$O() ? Reflect.construct(o, e || [], _getPrototypeOf$O(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$O(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$O(t);
}
function _assertThisInitialized$O(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$O() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$O = function() {
    return !!t;
  })();
}
function _superPropGet$x(t, o, e, r2) {
  var p = _get$x(_getPrototypeOf$O(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t22) {
    return p.apply(e, t22);
  } : p;
}
function _get$x() {
  return _get$x = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$x(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$x.apply(null, arguments);
}
function _superPropBase$x(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$O(t)); ) ;
  return t;
}
function _getPrototypeOf$O(t) {
  return _getPrototypeOf$O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$O(t);
}
function _inherits$O(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$O(t, e);
}
function _setPrototypeOf$O(t, e) {
  return _setPrototypeOf$O = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$O(t, e);
}
const COLORBAR_MAX_HEIGHT = 200;
const COLORBAR_WIDTH = 10;
const COLORBAR_LABELS_WIDTH = 40;
const COLORBAR_MARGIN = 10;
const BRUSH_WIDTH = COLORBAR_MARGIN;
const BRUSH_HEIGHT = 4;
const BRUSH_COLORBAR_GAP = 1;
const BRUSH_MARGIN = 4;
const SCALE_LIMIT_PRECISION = 5;
const BINS_PER_TILE = 256;
const COLORBAR_AREA_WIDTH = COLORBAR_WIDTH + COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN + BRUSH_COLORBAR_GAP + BRUSH_WIDTH + BRUSH_MARGIN;
let HeatmapTiledPixiTrack = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function HeatmapTiledPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$P(this, HeatmapTiledPixiTrack2);
    const newContext = {
      ...context
    };
    newContext.onValueScaleChanged = () => {
      context.onValueScaleChanged();
      _this.drawColorbar();
    };
    _this = _callSuper$O(this, HeatmapTiledPixiTrack2, [newContext, options2]);
    const {
      pubSub,
      animate,
      svgElement,
      onTrackOptionsChanged,
      onMouseMoveZoom,
      isShowGlobalMousePosition,
      isValueScaleLocked
    } = context;
    _this.pubSub = pubSub;
    _this.is2d = true;
    _this.animate = animate;
    _this.uid = slugid.nice();
    _this.scaleBrush = brushY();
    _this.onTrackOptionsChanged = onTrackOptionsChanged;
    _this.isShowGlobalMousePosition = isShowGlobalMousePosition;
    _this.isValueScaleLocked = isValueScaleLocked;
    _this.pColorbarArea = new GLOBALS.PIXI.Graphics();
    _this.pMasked.addChild(_this.pColorbarArea);
    _this.pColorbar = new GLOBALS.PIXI.Graphics();
    _this.pColorbarArea.addChild(_this.pColorbar);
    _this.axis = new AxisPixi(_this);
    _this.pColorbarArea.addChild(_this.axis.pAxis);
    _this.colorScale = HEATED_OBJECT_MAP;
    if (options2?.colorRange) {
      _this.colorScale = colorDomainToRgbaArray(options2.colorRange);
    }
    _this.gBase = select(svgElement).append("g");
    _this.gMain = _this.gBase.append("g");
    _this.gColorscaleBrush = _this.gMain.append("g");
    _this.brushing = false;
    _this.prevOptions = "";
    _this.prevIndUpperLeftTile = "";
    _this.onMouseMoveZoom = onMouseMoveZoom;
    _this.setDataLensSize(11);
    _this.dataLens = new Float32Array(_this.dataLensSize ** 2);
    _this.mouseMoveHandlerBound = _this.mouseMoveHandler.bind(_this);
    if (_this.onMouseMoveZoom) {
      _this.pubSubs.push(_this.pubSub.subscribe("app.mouseMove", _this.mouseMoveHandlerBound));
    }
    if (_this.options?.showMousePosition && !_this.hideMousePosition) {
      _this.hideMousePosition = setupShowMousePosition(_this, _this.is2d, _this.isShowGlobalMousePosition());
    }
    _this.prevOptions = JSON.stringify(options2);
    return _this;
  }
  _inherits$O(HeatmapTiledPixiTrack2, _TiledPixiTrack);
  return _createClass$P(HeatmapTiledPixiTrack2, [{
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(e) {
      if (!this.isWithin(e.x, e.y)) return;
      this.mouseX = e.x;
      this.mouseY = e.y;
      this.mouseMoveZoomHandler();
    }
    /**
     * Mouse move and zoom handler. Is triggered on both events.
     *
     * @param  {Number}  absX  Absolute X coordinate.
     * @param  {Number}  absY  Absolute Y coordinate
     */
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler(absX = this.mouseX, absY = this.mouseY) {
      if (typeof absX === "undefined" || typeof absY === "undefined" || !this.areAllVisibleTilesLoaded()) return;
      if (!this.tilesetInfo) {
        return;
      }
      const relX = absX - this.position[0];
      const relY = absY - this.position[1];
      let data2;
      let dataLens;
      try {
        dataLens = this.getVisibleRectangleData(relX - this.dataLensPadding, relY - this.dataLensPadding, this.dataLensSize, this.dataLensSize);
        data2 = dataLens.get(this.dataLensPadding, this.dataLensPadding);
      } catch (e) {
        return;
      }
      const dim = this.dataLensSize;
      let toRgb2;
      try {
        toRgb2 = valueToColor(this.limitedValueScale, this.colorScale, this.valueScale.domain()[0]);
      } catch (err) {
        return;
      }
      if (!toRgb2) return;
      const dataX = Math.round(this._xScale.invert(relX));
      const dataY = Math.round(this._yScale.invert(relY));
      let center2 = [dataX, dataY];
      let xRange = [Math.round(this._xScale.invert(relX - this.dataLensPadding)), Math.round(this._xScale.invert(relX + this.dataLensPadding))];
      let yRange = [Math.round(this._yScale.invert(relY - this.dataLensPadding)), Math.round(this._yScale.invert(relY + this.dataLensPadding))];
      if (this.chromInfo) {
        center2 = center2.map((pos) => absToChr(pos, this.chromInfo).slice(0, 2));
        xRange = xRange.map((pos) => absToChr(pos, this.chromInfo).slice(0, 2));
        yRange = yRange.map((pos) => absToChr(pos, this.chromInfo).slice(0, 2));
      }
      this.onMouseMoveZoom({
        trackId: this.id,
        data: data2,
        absX,
        absY,
        relX,
        relY,
        dataX,
        dataY,
        orientation: "2d",
        // Specific to 2D matrices
        dataLens,
        dim,
        toRgb: toRgb2,
        center: center2,
        xRange,
        yRange,
        isGenomicCoords: !!this.chromInfo
      });
    }
  }, {
    key: "scheduleRerender",
    value: function scheduleRerender() {
      this.backgroundTaskScheduler.enqueueTask(this.handleRerender.bind(this), null, this.uuid);
    }
  }, {
    key: "handleRerender",
    value: function handleRerender() {
      this.rerender(this.options, true);
    }
    /**
     * Get absolute (i.e., display) tile dimension and position.
     *
     * @param {Number}  zoomLevel  Current zoom level.
     * @param {Array}  tilePos  Tile position.
     * @return {Object}  Object holding the absolute x, y, width, and height.
     */
  }, {
    key: "getAbsTileDim",
    value: function getAbsTileDim(zoomLevel, tilePos, mirrored) {
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(zoomLevel, tilePos);
      const dim = {};
      dim.width = this._refXScale(tileX + tileWidth) - this._refXScale(tileX);
      dim.height = this._refYScale(tileY + tileHeight) - this._refYScale(tileY);
      if (mirrored) {
        dim.x = this._refXScale(tileY);
        dim.y = this._refYScale(tileX);
      } else {
        dim.x = this._refXScale(tileX);
        dim.y = this._refYScale(tileY);
      }
      return dim;
    }
  }, {
    key: "updateValueScale",
    value: function updateValueScale() {
      let minValue = this.minValue();
      let maxValue = this.maxValue();
      const epsilon3 = 1e-6;
      if (minValue !== void 0 && minValue !== null && maxValue !== void 0 && maxValue !== null && Math.abs(minValue - maxValue) < epsilon3) {
        const offset = 1e-3;
        minValue = Math.max(epsilon3, minValue - offset);
        maxValue += offset;
      }
      const [scaleType, valueScale] = getValueScale(this.options?.heatmapValueScaling || "log", minValue, this.medianVisibleValue, maxValue);
      this.valueScale = valueScale;
      this.limitedValueScale = this.valueScale.copy();
      if (this.options && typeof this.options.scaleStartPercent !== "undefined" && typeof this.options.scaleEndPercent !== "undefined") {
        this.limitedValueScale.domain([this.valueScale.domain()[0] + (this.valueScale.domain()[1] - this.valueScale.domain()[0]) * this.options.scaleStartPercent, this.valueScale.domain()[0] + (this.valueScale.domain()[1] - this.valueScale.domain()[0]) * this.options.scaleEndPercent]);
      }
      return [scaleType, valueScale];
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "rerender", this, 3)([options2, force]);
      this.updateValueScale();
      const strOptions = JSON.stringify(options2);
      this.drawColorbar();
      if (!force && strOptions === this.prevOptions) return;
      this.prevOptions = strOptions;
      this.options = options2;
      _superPropGet$x(HeatmapTiledPixiTrack2, "rerender", this, 3)([options2, force]);
      this.calculateVisibleTiles();
      if (options2?.colorRange) {
        this.colorScale = colorDomainToRgbaArray(options2.colorRange);
      }
      this.visibleAndFetchedTiles().forEach((tile) => this.renderTile(tile));
      if (this.hideMousePosition) {
        this.hideMousePosition();
        this.hideMousePosition = void 0;
      }
      if (this.options?.showMousePosition && !this.hideMousePosition) {
        this.hideMousePosition = setupShowMousePosition(this, this.is2d, this.isShowGlobalMousePosition());
      }
    }
  }, {
    key: "drawLabel",
    value: function drawLabel() {
      if (this.options.labelPosition === this.options.colorbarPosition) {
        this.labelXOffset = COLORBAR_AREA_WIDTH;
      } else {
        this.labelXOffset = 0;
      }
      _superPropGet$x(HeatmapTiledPixiTrack2, "drawLabel", this, 3)([]);
    }
  }, {
    key: "tileDataToCanvas",
    value: function tileDataToCanvas(pixData) {
      const canvas = document.createElement("canvas");
      canvas.width = this.binsPerTile();
      canvas.height = this.binsPerTile();
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const pix = new ImageData(pixData, canvas.width, canvas.height);
      ctx.putImageData(pix, 0, 0);
      return canvas;
    }
  }, {
    key: "exportData",
    value: function exportData() {
      if (this.tilesetInfo) {
        const data2 = this.getVisibleRectangleData(0, 0, this.dimensions[0], this.dimensions[1]);
        const output = {
          bounds: [this._xScale.domain(), this._yScale.domain()],
          dimensions: data2.shape,
          data: ndarrayFlatten(data2)
        };
        download("data.json", JSON.stringify(output));
      }
    }
    /**
     * Position sprite (the rendered tile)
     *
     * @param  {Object}  sprite  PIXI sprite object.
     * @param  {Number}  zoomLevel  Current zoom level.
     * @param  {Array}  tilePos  X,Y position of tile.
     * @param  {Boolean}  mirrored  If `true` tile is mirrored.
     */
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos, mirrored) {
      const dim = this.getAbsTileDim(zoomLevel, tilePos, mirrored);
      sprite.width = dim.width;
      sprite.height = dim.height;
      sprite.x = dim.x;
      sprite.y = dim.y;
      if (mirrored && tilePos[0] !== tilePos[1]) {
        sprite.rotation = -Math.PI / 2;
        sprite.scale.x = Math.abs(sprite.scale.x) * -1;
      }
    }
  }, {
    key: "refXScale",
    value: function refXScale(_) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "refXScale", this, 3)([_]);
      this.draw();
    }
  }, {
    key: "refYScale",
    value: function refYScale(_) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "refYScale", this, 3)([_]);
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      _superPropGet$x(HeatmapTiledPixiTrack2, "draw", this, 3)([]);
    }
  }, {
    key: "newBrushOptions",
    value: function newBrushOptions(selection2) {
      const newOptions = JSON.parse(JSON.stringify(this.options));
      const axisValueScale = this.valueScale.copy().range([this.colorbarHeight, 0]);
      const endDomain = axisValueScale.invert(selection2[0]);
      const startDomain = axisValueScale.invert(selection2[1]);
      const startPercent = (startDomain - axisValueScale.domain()[0]) / (axisValueScale.domain()[1] - axisValueScale.domain()[0]);
      const endPercent = (endDomain - axisValueScale.domain()[0]) / (axisValueScale.domain()[1] - axisValueScale.domain()[0]);
      newOptions.scaleStartPercent = startPercent.toFixed(SCALE_LIMIT_PRECISION);
      newOptions.scaleEndPercent = endPercent.toFixed(SCALE_LIMIT_PRECISION);
      return newOptions;
    }
  }, {
    key: "brushStart",
    value: function brushStart() {
      this.brushing = true;
    }
  }, {
    key: "brushMoved",
    value: function brushMoved(event) {
      if (!event.selection) {
        return;
      }
      const newOptions = this.newBrushOptions(event.selection);
      const strOptions = JSON.stringify(newOptions);
      this.gColorscaleBrush.selectAll(".handle--custom").attr("y", (d) => d.type === "n" ? event.selection[0] : event.selection[1] - BRUSH_HEIGHT / 2);
      if (strOptions === this.prevOptions) return;
      this.prevOptions = strOptions;
      this.rerender(newOptions, true);
      this.onTrackOptionsChanged(newOptions);
      if (this.isValueScaleLocked()) {
        this.onValueScaleChanged();
      }
    }
  }, {
    key: "brushEnd",
    value: function brushEnd() {
      this.brushing = false;
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "setPosition", this, 3)([newPosition]);
      this.drawColorbar();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "setDimensions", this, 3)([newDimensions]);
      this.drawColorbar();
    }
  }, {
    key: "removeColorbar",
    value: function removeColorbar() {
      this.pColorbarArea.visible = false;
      if (this.scaleBrush.on(".brush")) {
        this.gColorscaleBrush.call(this.scaleBrush.move, null);
      }
      this.gColorscaleBrush.on(".brush", null);
      this.gColorscaleBrush.selectAll("rect").remove();
    }
  }, {
    key: "drawColorbar",
    value: function drawColorbar() {
      this.pColorbar.clear();
      if (!this.options || !this.options.colorbarPosition || this.options.colorbarPosition === "hidden") {
        this.removeColorbar();
        return;
      }
      this.pColorbarArea.visible = true;
      if (!this.valueScale) {
        return;
      }
      if (Number.isNaN(+this.valueScale.domain()[0]) || Number.isNaN(+this.valueScale.domain()[1])) {
        return;
      }
      const colorbarAreaHeight = Math.min(this.dimensions[1] / 2, COLORBAR_MAX_HEIGHT);
      this.colorbarHeight = colorbarAreaHeight - 2 * COLORBAR_MARGIN;
      if (this.colorbarHeight < 0) {
        this.removeColorbar();
        return;
      }
      if (this.valueScale.domain()[1] === this.valueScale.domain()[0]) {
        this.removeColorbar();
        return;
      }
      const axisValueScale = this.valueScale.copy().range([this.colorbarHeight, 0]);
      if (this.options.colorbarPosition === "topLeft" || this.options.colorbarPosition === "bottomLeft") {
        this.scaleBrush.extent([[BRUSH_MARGIN, 0], [BRUSH_WIDTH, this.colorbarHeight]]);
      } else {
        this.scaleBrush.extent([[0, 0], [BRUSH_WIDTH - BRUSH_MARGIN, this.colorbarHeight]]);
      }
      if (this.options.colorbarPosition === "topLeft") {
        [this.pColorbarArea.x, this.pColorbarArea.y] = this.position;
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP + COLORBAR_WIDTH;
        this.pColorbar.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + BRUSH_MARGIN},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      if (this.options.colorbarPosition === "topRight") {
        this.pColorbarArea.x = this.position[0] + this.dimensions[0] - COLORBAR_AREA_WIDTH;
        this.pColorbarArea.y = this.position[1];
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.pColorbar.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + this.pColorbar.x + COLORBAR_WIDTH + 2},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      if (this.options.colorbarPosition === "bottomRight") {
        this.pColorbarArea.x = this.position[0] + this.dimensions[0] - COLORBAR_AREA_WIDTH;
        this.pColorbarArea.y = this.position[1] + this.dimensions[1] - colorbarAreaHeight;
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.pColorbar.x = COLORBAR_LABELS_WIDTH + COLORBAR_MARGIN;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + this.pColorbar.x + COLORBAR_WIDTH + BRUSH_COLORBAR_GAP},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      if (this.options.colorbarPosition === "bottomLeft") {
        this.pColorbarArea.x = this.position[0];
        this.pColorbarArea.y = this.position[1] + this.dimensions[1] - colorbarAreaHeight;
        this.pColorbar.y = COLORBAR_MARGIN;
        this.axis.pAxis.y = COLORBAR_MARGIN;
        this.axis.pAxis.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP + COLORBAR_WIDTH;
        this.pColorbar.x = BRUSH_MARGIN + BRUSH_WIDTH + BRUSH_COLORBAR_GAP;
        this.gColorscaleBrush.attr("transform", `translate(${this.pColorbarArea.x + 2},${this.pColorbarArea.y + this.pColorbar.y - 1})`);
      }
      this.pColorbarArea.clear();
      this.pColorbarArea.beginFill(colorToHex(this.options.colorbarBackgroundColor || "white"), +this.options.colorbarBackgroundOpacity >= 0 ? +this.options.colorbarBackgroundOpacity : 0.6);
      this.pColorbarArea.drawRect(0, 0, COLORBAR_AREA_WIDTH, colorbarAreaHeight);
      if (!this.options) {
        this.options = {
          scaleStartPercent: 0,
          scaleEndPercent: 1
        };
      } else {
        if (!this.options.scaleStartPercent) {
          this.options.scaleStartPercent = 0;
        }
        if (!this.options.scaleEndPercent) {
          this.options.scaleEndPercent = 1;
        }
      }
      const domainWidth = axisValueScale.domain()[1] - axisValueScale.domain()[0];
      const startBrush = axisValueScale(this.options.scaleStartPercent * domainWidth + axisValueScale.domain()[0]);
      const endBrush = axisValueScale(this.options.scaleEndPercent * domainWidth + axisValueScale.domain()[0]);
      if (!this.brushing) {
        this.scaleBrush.on("start", this.brushStart.bind(this)).on("brush", this.brushMoved.bind(this)).on("end", this.brushEnd.bind(this)).handleSize(0);
        this.gColorscaleBrush.on(".brush", null);
        this.gColorscaleBrush.call(this.scaleBrush);
        this.northHandle = this.gColorscaleBrush.selectAll(".handle--custom").data([{
          type: "n"
        }, {
          type: "s"
        }]).enter().append("rect").classed("handle--custom", true).attr("cursor", "ns-resize").attr("width", BRUSH_WIDTH).attr("height", BRUSH_HEIGHT).style("fill", "#666").style("stroke", "white");
        if (this.flipText) {
          this.northHandle.attr("cursor", "ew-resize");
        }
        this.gColorscaleBrush.call(this.scaleBrush.move, [endBrush, startBrush]);
      }
      const posScale = linear().domain([0, 255]).range([0, this.colorbarHeight]);
      for (let i = 0; i < this.colorbarHeight; i++) {
        const value = this.limitedValueScale(axisValueScale.invert(i));
        const rgbIdx = Math.max(0, Math.min(254, Math.floor(value)));
        this.pColorbar.beginFill(colorToHex(`rgb(${this.colorScale[rgbIdx][0]},${this.colorScale[rgbIdx][1]},${this.colorScale[rgbIdx][2]})`));
        this.pColorbar.drawRect(0, i, COLORBAR_WIDTH, 1);
      }
      this.pAxis.position.x = COLORBAR_WIDTH;
      this.pAxis.position.y = posScale(0);
      if (this.options.colorbarPosition === "topLeft" || this.options.colorbarPosition === "bottomLeft") {
        this.axis.drawAxisRight(axisValueScale, this.colorbarHeight);
      } else if (this.options.colorbarPosition === "topRight" || this.options.colorbarPosition === "bottomRight") {
        this.axis.drawAxisLeft(axisValueScale, this.colorbarHeight);
      }
    }
  }, {
    key: "exportColorBarSVG",
    value: function exportColorBarSVG() {
      const gColorbarArea = document.createElement("g");
      gColorbarArea.setAttribute("class", "color-bar");
      if (!this.options.colorbarPosition || this.options.colorbarPosition === "hidden") {
        return gColorbarArea;
      }
      if (!this.valueScale) return gColorbarArea;
      gColorbarArea.setAttribute("transform", `translate(${this.pColorbarArea.x}, ${this.pColorbarArea.y})`);
      const rectColorbarArea = document.createElement("rect");
      gColorbarArea.appendChild(rectColorbarArea);
      const gColorbar = document.createElement("g");
      gColorbarArea.appendChild(gColorbar);
      gColorbar.setAttribute("transform", `translate(${this.pColorbar.x}, ${this.pColorbar.y})`);
      const colorbarAreaHeight = Math.min(this.dimensions[1] / 2, COLORBAR_MAX_HEIGHT);
      this.colorbarHeight = colorbarAreaHeight - 2 * COLORBAR_MARGIN;
      rectColorbarArea.setAttribute("x", 0);
      rectColorbarArea.setAttribute("y", 0);
      rectColorbarArea.setAttribute("width", COLORBAR_AREA_WIDTH);
      rectColorbarArea.setAttribute("height", colorbarAreaHeight);
      rectColorbarArea.setAttribute("style", "fill: white; stroke-width: 0; opacity: 0.7");
      const barsToDraw = 256;
      const posScale = linear().domain([0, barsToDraw - 1]).range([0, this.colorbarHeight]);
      const colorHeight = this.colorbarHeight / barsToDraw;
      for (let i = 0; i < barsToDraw; i++) {
        const rectColor = document.createElement("rect");
        gColorbar.appendChild(rectColor);
        rectColor.setAttribute("x", 0);
        rectColor.setAttribute("y", posScale(i));
        rectColor.setAttribute("width", COLORBAR_WIDTH);
        rectColor.setAttribute("height", colorHeight);
        rectColor.setAttribute("class", "color-rect");
        const limitedIndex = Math.min(this.colorScale.length - 1, Math.max(0, Math.floor(this.limitedValueScale(this.valueScale.invert(i)))));
        const color2 = this.colorScale[limitedIndex];
        if (color2) {
          rectColor.setAttribute("style", `fill: rgb(${color2[0]}, ${color2[1]}, ${color2[2]})`);
        } else {
          rectColor.setAttribute("style", "fill: rgb(255,255,255,0)");
        }
      }
      const gAxisHolder = document.createElement("g");
      gColorbarArea.appendChild(gAxisHolder);
      gAxisHolder.setAttribute("transform", `translate(${this.axis.pAxis.position.x},${this.axis.pAxis.position.y})`);
      let gAxis = null;
      const axisValueScale = this.valueScale.copy().range([this.colorbarHeight, 0]);
      if (this.options.colorbarPosition === "topLeft" || this.options.colorbarPosition === "bottomLeft") {
        gAxis = this.axis.exportAxisRightSVG(axisValueScale, this.colorbarHeight);
      } else if (this.options.colorbarPosition === "topRight" || this.options.colorbarPosition === "bottomRight") {
        gAxis = this.axis.exportAxisLeftSVG(axisValueScale, this.colorbarHeight);
      }
      gAxisHolder.appendChild(gAxis);
      return gColorbarArea;
    }
    /**
     * Set data lens size
     *
     * @param  {Integer}  newDataLensSize  New data lens size. Needs to be an odd
     *   integer.
     */
  }, {
    key: "setDataLensSize",
    value: function setDataLensSize(newDataLensSize) {
      this.dataLensPadding = Math.max(0, Math.floor((newDataLensSize - 1) / 2));
      this.dataLensSize = this.dataLensPadding * 2 + 1;
    }
  }, {
    key: "binsPerTile",
    value: function binsPerTile() {
      return this.tilesetInfo.bins_per_dimension || BINS_PER_TILE;
    }
    /**
     * Get the data in the visible rectangle
     *
     * The parameter coordinates are in pixel coordinates
     *
     * @param {int} x: The upper left corner of the rectangle in pixel coordinates
     * @param {int} y: The upper left corner of the rectangle in pixel coordinates
     * @param {int} width: The width of the rectangle (pixels)
     * @param {int} height: The height of the rectangle (pixels)
     *
     * @returns {Array} A numjs array containing the data in the visible region
     *
     */
  }, {
    key: "getVisibleRectangleData",
    value: function getVisibleRectangleData(x, y, width, height) {
      let zoomLevel = this.calculateZoomLevel();
      zoomLevel = this.tilesetInfo.max_zoom ? Math.min(this.tilesetInfo.max_zoom, zoomLevel) : zoomLevel;
      const calculatedWidth = calculateTileWidth(this.tilesetInfo, zoomLevel, this.binsPerTile());
      const tileRes = calculatedWidth / this.binsPerTile();
      const xDomain = [this._xScale.invert(x), this._xScale.invert(x + width)];
      const yDomain = [this._yScale.invert(y), this._yScale.invert(y + height)];
      const limitedXDomain = [Math.max(xDomain[0], this.tilesetInfo.min_pos[0]), Math.min(xDomain[1], this.tilesetInfo.max_pos[0])];
      const limitedYDomain = [Math.max(yDomain[0], this.tilesetInfo.min_pos[1]), Math.min(yDomain[1], this.tilesetInfo.max_pos[1])];
      const leftXBin = Math.floor(limitedXDomain[0] / tileRes);
      const leftYBin = Math.floor(limitedYDomain[0] / tileRes);
      const binWidth = Math.max(0, Math.ceil((limitedXDomain[1] - limitedXDomain[0]) / tileRes));
      const binHeight = Math.max(0, Math.ceil((limitedYDomain[1] - limitedYDomain[0]) / tileRes));
      const out = ndarray(new Array(binHeight * binWidth).fill(Number.NaN), [binHeight, binWidth]);
      this.visibleAndFetchedTiles().forEach((tile) => {
        const tilePos = tile.mirrored ? [tile.tileData.tilePos[1], tile.tileData.tilePos[0]] : tile.tileData.tilePos;
        const {
          tileX,
          tileY,
          tileWidth,
          tileHeight
        } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tilePos, this.binsPerTile());
        const tileXStartBin = Math.floor(tileX / tileRes);
        const tileXEndBin = Math.floor((tileX + tileWidth) / tileRes);
        const tileYStartBin = Math.floor(tileY / tileRes);
        const tileYEndBin = Math.floor((tileY + tileHeight) / tileRes);
        let tileSliceXStart = Math.max(leftXBin, tileXStartBin) - tileXStartBin;
        let tileSliceYStart = Math.max(leftYBin, tileYStartBin) - tileYStartBin;
        const tileSliceXEnd = Math.min(leftXBin + binWidth, tileXEndBin) - tileXStartBin;
        const tileSliceYEnd = Math.min(leftYBin + binHeight, tileYEndBin) - tileYStartBin;
        const tileXOffset = Math.max(tileXStartBin - leftXBin, 0);
        const tileYOffset = Math.max(tileYStartBin - leftYBin, 0);
        const tileSliceWidth = tileSliceXEnd - tileSliceXStart;
        const tileSliceHeight = tileSliceYEnd - tileSliceYStart;
        if (tileSliceWidth < 0 || tileSliceHeight < 0) return;
        if (tile.mirrored && tileSliceXStart > tileSliceYStart) {
          const tmp = tileSliceXStart;
          tileSliceXStart = tileSliceYStart;
          tileSliceYStart = tmp;
        }
        ndarrayAssign(out.hi(tileYOffset + tileSliceHeight, tileXOffset + tileSliceWidth).lo(tileYOffset, tileXOffset), tile.dataArray.hi(tileSliceYStart + tileSliceHeight, tileSliceXStart + tileSliceWidth).lo(tileSliceYStart, tileSliceXStart));
      });
      return out;
    }
    /**
     * Convert the raw tile data to a rendered array of values which can be represented as a sprite.
     *
     * @param tile: The data structure containing all the tile information. Relevant to
     *              this function are tile.tileData = \{'dense': [...], ...\}
     *              and tile.graphics
     */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "initTile", this, 3)([tile]);
      if (tile.tileData.dense.length === this.binsPerTile() ** 2) {
        tile.dataArray = ndarray(Array.from(tile.tileData.dense), [this.binsPerTile(), this.binsPerTile()]);
        if (this.continuousScaling && tile.tileData.tilePos[0] === tile.tileData.tilePos[1] && tile.mirrored) {
          tile.tileData.denseDataExtrema.mirrorPrecomputedExtrema();
          _superPropGet$x(HeatmapTiledPixiTrack2, "initTile", this, 3)([tile]);
        }
      }
      if (this.scale.minValue === null || this.scale.maxValue === null) {
        return;
      }
      this.renderTile(tile);
    }
    // /**
    //  * Draw a border around tiles
    //  *
    //  * @param  {Array}  pixData  Pixel data to be adjusted
    //  */
    // addBorder(pixData) {
    //   for (let i = 0; i < 256; i++) {
    //     if (i === 0) {
    //       const prefix = i * 256 * 4;
    //       for (let j = 0; j < 255; j++) {
    //         pixData[prefix + (j * 4)] = 0;
    //         pixData[prefix + (j * 4) + 1] = 0;
    //         pixData[prefix + (j * 4) + 2] = 255;
    //         pixData[prefix + (j * 4) + 3] = 255;
    //       }
    //     }
    //     pixData[(i * 256 * 4)] = 0;
    //     pixData[(i * 256 * 4) + 1] = 0;
    //     pixData[(i * 256 * 4) + 2] = 255;
    //     pixData[(i * 256 * 4) + 3] = 255;
    //   }
    // }
    //
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
      if (tile.scale && this.scale && this.scale.minValue === tile.scale.minValue && this.scale.maxValue === tile.scale.maxValue) ;
      else {
        this.renderTile(tile);
        this.drawColorbar();
      }
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.sprite.destroy(true);
      tile.canvas = null;
      tile.sprite = null;
      tile.texture = null;
    }
  }, {
    key: "pixDataFunction",
    value: function pixDataFunction(tile, pixData) {
      if (pixData) {
        const {
          graphics
        } = tile;
        const canvas = this.tileDataToCanvas(pixData.pixData);
        if (tile.sprite) {
          tile.sprite.destroy(true);
        }
        const texture = GLOBALS.PIXI.VERSION[0] === "4" ? GLOBALS.PIXI.Texture.fromCanvas(canvas, GLOBALS.PIXI.SCALE_MODES.NEAREST) : GLOBALS.PIXI.Texture.from(canvas, {
          scaleMode: GLOBALS.PIXI.SCALE_MODES.NEAREST
        });
        const sprite = new GLOBALS.PIXI.Sprite(texture);
        tile.sprite = sprite;
        tile.texture = texture;
        tile.canvas = canvas;
        this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored);
        graphics.removeChildren();
        graphics.addChild(tile.sprite);
      }
      this.renderingTiles.delete(tile.tileId);
    }
    /**
     * Render / draw a tile.
     *
     * @param {Object}  tile  Tile data to be rendered.
     */
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      const [scaleType] = this.updateValueScale();
      const pseudocount = 0;
      this.renderingTiles.add(tile.tileId);
      if (this.tilesetInfo.tile_size) {
        if (tile.tileData.dense?.length < this.tilesetInfo.tile_size) {
          const newArray = new Float32Array(this.tilesetInfo.tile_size);
          newArray.fill(Number.NaN);
          newArray.set(tile.tileData.dense);
          tile.tileData.dense = newArray;
        }
      }
      tileDataToPixData(
        tile,
        scaleType,
        this.limitedValueScale.domain(),
        pseudocount,
        // used as a pseudocount to prevent taking the log of 0
        this.colorScale,
        (pixData) => this.pixDataFunction(tile, pixData),
        this.mirrorTiles() && !tile.mirrored && tile.tileData.tilePos[0] === tile.tileData.tilePos[1],
        this.options.extent === "upper-right" && tile.tileData.tilePos[0] === tile.tileData.tilePos[1],
        this.options.zeroValueColor ? colorToRgba(this.options.zeroValueColor) : void 0,
        {
          selectedRows: this.options.selectRows,
          selectedRowsAggregationMode: this.options.selectRowsAggregationMode,
          selectedRowsAggregationWithRelativeHeight: this.options.selectRowsAggregationWithRelativeHeight,
          selectedRowsAggregationMethod: this.options.selectRowsAggregationMethod
        }
      );
    }
    /**
     * Remove this track from the view
     */
  }, {
    key: "remove",
    value: function remove2() {
      this.gMain.remove();
      this.gMain = null;
      _superPropGet$x(HeatmapTiledPixiTrack2, "remove", this, 3)([]);
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _superPropGet$x(HeatmapTiledPixiTrack2, "refScalesChanged", this, 3)([refXScale, refYScale]);
      objVals(this.fetchedTiles).filter((tile) => tile.sprite).forEach((tile) => this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored));
    }
    /**
     * Bypass this track's exportSVG function
     */
  }, {
    key: "superSVG",
    value: function superSVG() {
      return _superPropGet$x(HeatmapTiledPixiTrack2, "exportSVG", this, 3)([]);
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$x(HeatmapTiledPixiTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$x(HeatmapTiledPixiTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.pMain.position.x},${this.pMain.position.y}) scale(${this.pMain.scale.x},${this.pMain.scale.y})`);
      for (const tile of this.visibleAndFetchedTiles()) {
        const rotation2 = tile.sprite.rotation * 180 / Math.PI;
        const g = document.createElement("g");
        g.setAttribute("transform", `translate(${tile.sprite.x},${tile.sprite.y}) rotate(${rotation2}) scale(${tile.sprite.scale.x},${tile.sprite.scale.y})`);
        const image2 = document.createElement("image");
        image2.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", tile.canvas.toDataURL());
        image2.setAttribute("width", tile.canvas.width);
        image2.setAttribute("height", tile.canvas.height);
        image2.setAttribute("style", "image-rendering: pixelated");
        g.appendChild(image2);
        output.appendChild(g);
      }
      const gColorbar = this.exportColorBarSVG();
      track.appendChild(gColorbar);
      return [base, base];
    }
    // This function gets the indices of the visible part of the upper left tile.
    // The indices are 'rounded' to the grid used by the DenseDataExrema module.
    // It is used to determine if we should check for a new value scale in
    // the case of continuous scaling
  }, {
    key: "getVisiblePartOfUppLeftTile",
    value: function getVisiblePartOfUppLeftTile() {
      const tilePositions = this.visibleAndFetchedTiles().map((tile) => {
        const tilePos = tile.mirrored ? [tile.tileData.tilePos[1], tile.tileData.tilePos[0]] : tile.tileData.tilePos;
        return [tilePos[0], tilePos[1], tile.tileId];
      });
      if (tilePositions.length === 0) return null;
      let minTilePosition = tilePositions[0];
      for (let i = 0; i < tilePositions.length; i++) {
        const curPos = tilePositions[i];
        if (curPos[0] < minTilePosition[0] || curPos[1] < minTilePosition[1]) {
          minTilePosition = curPos;
        }
      }
      const numSubsets = Math.min(NUM_PRECOMP_SUBSETS_PER_2D_TTILE, this.binsPerTile());
      const subsetSize = this.binsPerTile() / numSubsets;
      const upperLeftTile = this.visibleAndFetchedTiles().filter((tile) => tile.tileId === minTilePosition[2])[0];
      const upperLeftTileInd = this.getIndicesOfVisibleDataInTile(upperLeftTile);
      const startX = upperLeftTileInd[0];
      const startY = upperLeftTileInd[1];
      const startXadjusted = startX - startX % subsetSize;
      const startYadjusted = startY - startY % subsetSize;
      return [upperLeftTile.tileId, startXadjusted, startYadjusted];
    }
  }, {
    key: "getIndicesOfVisibleDataInTile",
    value: function getIndicesOfVisibleDataInTile(tile) {
      const visibleX = this._xScale.range();
      const visibleY = this._yScale.range();
      const tilePos = tile.mirrored ? [tile.tileData.tilePos[1], tile.tileData.tilePos[0]] : tile.tileData.tilePos;
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tilePos, this.binsPerTile());
      const tileXScale = linear().domain([0, this.binsPerTile()]).range([tileX, tileX + tileWidth]);
      const startX = Math.max(0, Math.round(tileXScale.invert(this._xScale.invert(visibleX[0]))) - 1);
      const endX = Math.min(this.binsPerTile(), Math.round(tileXScale.invert(this._xScale.invert(visibleX[1]))));
      const tileYScale = linear().domain([0, this.binsPerTile()]).range([tileY, tileY + tileHeight]);
      const startY = Math.max(0, Math.round(tileYScale.invert(this._yScale.invert(visibleY[0]))) - 1);
      const endY = Math.min(this.binsPerTile(), Math.round(tileYScale.invert(this._yScale.invert(visibleY[1]))));
      const result = tile.mirrored && tilePos[0] !== tilePos[1] ? [startY, startX, endY, endX] : [startX, startY, endX, endY];
      return result;
    }
  }, {
    key: "minVisibleValue",
    value: function minVisibleValue(ignoreFixedScale = false) {
      const minimumsPerTile = this.visibleAndFetchedTiles().map((tile) => {
        if (tile.tileData.denseDataExtrema === void 0) {
          return null;
        }
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMinNonZeroInSubset(ind);
      });
      if (minimumsPerTile.length === 0 && this.valueScaleMax === null) {
        return null;
      }
      const min2 = Math.min.apply(null, minimumsPerTile);
      if (min2 === Number.MAX_SAFE_INTEGER) {
        return _superPropGet$x(HeatmapTiledPixiTrack2, "minVisibleValue", this, 3)([ignoreFixedScale]);
      }
      if (ignoreFixedScale) return min2;
      return this.valueScaleMin !== null ? this.valueScaleMin : min2;
    }
  }, {
    key: "maxVisibleValue",
    value: function maxVisibleValue(ignoreFixedScale = false) {
      const maximumsPerTile = this.visibleAndFetchedTiles().map((tile) => {
        if (tile.tileData.denseDataExtrema === void 0) {
          return null;
        }
        const ind = this.getIndicesOfVisibleDataInTile(tile);
        return tile.tileData.denseDataExtrema.getMaxNonZeroInSubset(ind);
      });
      if (maximumsPerTile.length === 0 && this.valueScaleMax === null) {
        return null;
      }
      const max2 = Math.max.apply(null, maximumsPerTile);
      if (max2 === Number.MIN_SAFE_INTEGER) {
        return _superPropGet$x(HeatmapTiledPixiTrack2, "maxVisibleValue", this, 3)([ignoreFixedScale]);
      }
      if (ignoreFixedScale) return max2;
      return this.valueScaleMax !== null ? this.valueScaleMax : max2;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      if (this.brushing) {
        return;
      }
      _superPropGet$x(HeatmapTiledPixiTrack2, "zoomed", this, 3)([newXScale, newYScale]);
      this.pMain.position.x = tx;
      this.pMain.position.y = ty;
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      const isValueScaleLocked = this.isValueScaleLocked();
      if (this.continuousScaling && this.minValue() !== void 0 && this.maxValue() !== void 0) {
        const indUpperLeftTile = JSON.stringify(this.getVisiblePartOfUppLeftTile());
        if (this.valueScaleMin === null && this.valueScaleMax === null && !isValueScaleLocked && // syncs the recomputation with the grid used in the DenseDataExtrema module
        indUpperLeftTile !== this.prevIndUpperLeftTile) {
          const newMin = this.minVisibleValue();
          const newMax = this.maxVisibleValue();
          const epsilon3 = 1e-6;
          if (newMin !== null && // can happen if tiles haven't loaded
          newMax !== null && (Math.abs(this.minValue() - newMin) > epsilon3 || Math.abs(this.maxValue() - newMax) > epsilon3)) {
            this.minValue(newMin);
            this.maxValue(newMax);
            this.scheduleRerender();
          }
          this.prevIndUpperLeftTile = indUpperLeftTile;
        }
        if (isValueScaleLocked) {
          this.onValueScaleChanged();
        }
      }
      this.mouseMoveZoomHandler();
    }
    /**
     * Helper method for adding a tile ID in place. Used by `tilesToId()`.
     *
     * @param  {Array}  tiles  Array tile ID should be added to.
     * @param  {Integer}  zoomLevel  Zoom level.
     * @param  {Integer}  row  Column ID, i.e., y.
     * @param  {Integer}  column  Column ID, i.e., x.
     * @param  {Objwect}  dataTransform  ??
     * @param  {Boolean}  mirrored  If `true` tile is mirrored.
     */
  }, {
    key: "addTileId",
    value: function addTileId(tiles, zoomLevel, row, column, dataTransform, mirrored = false) {
      const newTile = [zoomLevel, row, column];
      newTile.mirrored = mirrored;
      newTile.dataTransform = dataTransform;
      tiles.push(newTile);
    }
    /**
     * Convert tile positions to tile IDs
     *
     * @param  {Array}  xTiles  X positions of tiles
     * @param  {Array}  yTiles  Y positions of tiles
     * @param  {Array}  zoomLevel  Current zoom level
     * @return  {Array}  List of tile IDs
     */
  }, {
    key: "tilesToId",
    value: function tilesToId(xTiles, yTiles, zoomLevel) {
      const rows = xTiles;
      const cols = yTiles;
      const dataTransform = this.options?.dataTransform || "default";
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          if (this.mirrorTiles()) {
            if (rows[i] >= cols[j]) {
              if (this.options.extent !== "lower-left") {
                this.addTileId(tiles, zoomLevel, cols[j], rows[i], dataTransform, true);
              }
            } else if (this.options.extent !== "upper-right") {
              this.addTileId(tiles, zoomLevel, rows[i], cols[j], dataTransform);
            }
            if (rows[i] === cols[j] && this.options.extent === "lower-left") {
              this.addTileId(tiles, zoomLevel, rows[i], cols[j], dataTransform);
            }
          } else {
            this.addTileId(tiles, zoomLevel, rows[i], cols[j], dataTransform);
          }
        }
      }
      return tiles;
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        this.xTiles = calculateTilesFromResolution(sortedResolutions[this.zoomLevel], this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        this.yTiles = calculateTilesFromResolution(sortedResolutions[this.zoomLevel], this._yScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      } else {
        this.xTiles = calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
        this.yTiles = calculateTiles(this.zoomLevel, this._yScale, this.options.reverseYAxis ? -this.tilesetInfo.max_pos[1] : this.tilesetInfo.min_pos[1], this.options.reverseYAxis ? -this.tilesetInfo.min_pos[1] : this.tilesetInfo.max_pos[1], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width1 || this.tilesetInfo.max_width);
      }
      this.setVisibleTiles(this.tilesToId(this.xTiles, this.yTiles, this.zoomLevel));
    }
  }, {
    key: "mirrorTiles",
    value: function mirrorTiles() {
      return !(this.tilesetInfo.mirror_tiles && (this.tilesetInfo.mirror_tiles === false || this.tilesetInfo.mirror_tiles === "false"));
    }
  }, {
    key: "contextMenuItems",
    value: function contextMenuItems(trackX, trackY) {
      return [];
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY) {
      if (!this.options || !this.options.showTooltip) {
        return "";
      }
      if (!this.tilesetInfo) {
        return "";
      }
      const currentResolution = calculateResolution(this.tilesetInfo, this.zoomLevel);
      const maxWidth = Math.max(this.tilesetInfo.max_pos[1] - this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[0] - this.tilesetInfo.min_pos[0]);
      const formatResolution = Math.ceil(Math.log(maxWidth / currentResolution) / Math.log(10));
      this.setDataLensSize(1);
      const dataX = this._xScale.invert(trackX);
      const dataY = this._yScale.invert(trackY);
      let positionText = "<b>Position:</b> ";
      if (this.chromInfo) {
        const atcX = absToChr(dataX, this.chromInfo);
        const atcY = absToChr(dataY, this.chromInfo);
        const f2 = (n) => format$1(`.${formatResolution}s`)(n);
        positionText += `${atcX[0]}:${f2(atcX[1])} & ${atcY[0]}:${f2(atcY[1])}`;
        positionText += "<br/>";
      }
      let data2 = null;
      try {
        data2 = this.getVisibleRectangleData(trackX, trackY, 1, 1).get(0, 0);
      } catch (err) {
        return "";
      }
      if (this.options && this.options.heatmapValueScaling === "log") {
        if (data2 > 0) {
          return `${positionText}<b>Value:</b> 1e${format$1(".3f")(Math.log(data2) / Math.log(10))}`;
        }
        if (data2 === 0) {
          return `${positionText}<b>Value:</b> 0`;
        }
        return `${positionText}<b>Value:</b> N/A`;
      }
      return `${positionText}<b>Value:</b> ${format$1(".3f")(data2)}`;
    }
    /**
     * Get the tile's position in its coordinate system.
     *
     * @description
     * Normally the absolute coordinate system are the genome basepair positions
     */
  }, {
    key: "getTilePosAndDimensions",
    value: function getTilePosAndDimensions2(zoomLevel, tilePos, binsPerTileIn) {
      const binsPerTile = binsPerTileIn || this.binsPerTile();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        const chosenResolution = sortedResolutions[zoomLevel];
        const tileWidth2 = chosenResolution * binsPerTile;
        const tileHeight2 = tileWidth2;
        const tileX2 = chosenResolution * binsPerTile * tilePos[0];
        const tileY2 = chosenResolution * binsPerTile * tilePos[1];
        return {
          tileX: tileX2,
          tileY: tileY2,
          tileWidth: tileWidth2,
          tileHeight: tileHeight2
        };
      }
      const xTilePos = tilePos[0];
      const yTilePos = tilePos[1];
      const minX = this.tilesetInfo.min_pos[0];
      const minY = this.options.reverseYAxis ? -this.tilesetInfo.max_pos[1] : this.tilesetInfo.min_pos[1];
      const tileWidth = this.tilesetInfo.max_width / 2 ** zoomLevel;
      const tileHeight = this.tilesetInfo.max_width / 2 ** zoomLevel;
      const tileX = minX + xTilePos * tileWidth;
      const tileY = minY + yTilePos * tileHeight;
      return {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      };
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel$12() {
      this.tilesetInfo.min_pos[0];
      this.tilesetInfo.max_pos[0];
      this.tilesetInfo.min_pos[1];
      this.tilesetInfo.max_pos[1];
      let zoomLevel = null;
      if (this.tilesetInfo.resolutions) {
        const zoomIndexX = calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale);
        const zoomIndexY = calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._yScale);
        zoomLevel = Math.min(zoomIndexX, zoomIndexY);
      } else {
        const xZoomLevel = calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.binsPerTile());
        const yZoomLevel = calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1], this.binsPerTile());
        zoomLevel = Math.max(xZoomLevel, yZoomLevel);
        zoomLevel = Math.min(zoomLevel, this.maxZoom);
      }
      if (this.options?.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
    /**
     * The local tile identifier
     *
     * @param {array}  tile  Tile definition array to be converted to id. Tile
     *   array must contain `[zoomLevel, xPos, yPos]` and two props `mirrored` and
     *   `dataTransform`.
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      if (tile.dataTransform && tile.dataTransform !== "default") {
        return `${tile.join(".")}.${tile.mirrored}.${tile.dataTransform}`;
      }
      return `${tile.join(".")}.${tile.mirrored}`;
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      if (tile.dataTransform && tile.dataTransform !== "default") {
        return `${tile.join(".")}.${tile.dataTransform}`;
      }
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$O(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$O(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$O(o.key), o);
  }
}
function _createClass$O(e, r2, t) {
  return r2 && _defineProperties$O(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$O(t) {
  var i = _toPrimitive$O(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$O(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$N(t, o, e) {
  return o = _getPrototypeOf$N(o), _possibleConstructorReturn$N(t, _isNativeReflectConstruct$N() ? Reflect.construct(o, e || [], _getPrototypeOf$N(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$N(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$N(t);
}
function _assertThisInitialized$N(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$N() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$N = function() {
    return !!t;
  })();
}
function _getPrototypeOf$N(t) {
  return _getPrototypeOf$N = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$N(t);
}
function _inherits$N(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$N(t, e);
}
function _setPrototypeOf$N(t, e) {
  return _setPrototypeOf$N = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$N(t, e);
}
function _drawTile(tile) {
  if (!tile.graphics) {
    return;
  }
  const graphics = tile.graphics;
  const {
    tileX,
    tileY,
    tileWidth
  } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
  tile.drawnAtScale = this._xScale.copy();
  const tSX = 1 / ((this._xScale(1) - this._xScale(0)) / (this._refXScale(1) - this._refXScale(0)));
  const tSY = 1 / ((this._yScale(1) - this._yScale(0)) / (this._refYScale(1) - this._refYScale(0)));
  tile.text.scale.x = tSX;
  tile.text.scale.y = tSY;
  const tilePixelWidth = this._xScale(tileWidth) - this._xScale(0);
  tile.textGraphics.scale.x = tilePixelWidth / 256;
  tile.textGraphics.scale.y = tilePixelWidth / 256;
  graphics.clear();
  graphics.lineStyle(4 * tSX, 255, 1);
  graphics.beginFill(16740363, 0.4);
  graphics.alpha = 0.5;
  if (tile.mirrored) {
    const tileScaledWidth = this._refXScale(tileY + tileWidth) - this._refXScale(tileY);
    const tileScaledHeight = this._refYScale(tileX + tileWidth) - this._refYScale(tileX);
    tile.textGraphics.position.x = this._refXScale(tileY) + tileScaledWidth / 2;
    tile.textGraphics.position.y = this._refYScale(tileX) + tileScaledHeight / 2;
    graphics.drawRect(this._refXScale(tileY), this._refYScale(tileX), tileScaledWidth, tileScaledHeight);
  } else {
    const tileScaledWidth = this._refXScale(tileX + tileWidth) - this._refXScale(tileX);
    const tileScaledHeight = this._refYScale(tileY + tileWidth) - this._refYScale(tileY);
    tile.textGraphics.position.x = this._refXScale(tileX) + tileScaledWidth / 2;
    tile.textGraphics.position.y = this._refYScale(tileY) + tileScaledHeight / 2;
    graphics.drawRect(this._refXScale(tileX), this._refYScale(tileY), tileScaledWidth, tileScaledHeight);
  }
}
function _initTile(tile) {
  const graphics = tile.graphics;
  tile.textGraphics = new GLOBALS.PIXI.Graphics();
  if (tile.mirrored) {
    tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${[tile.tileData.tilePos[1], tile.tileData.tilePos[0]].join("/")}`, {
      fontFamily: "Arial",
      fontSize: 24,
      fill: 16715792,
      align: "center"
    });
  } else {
    tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${tile.tileData.tilePos.join("/")}`, {
      fontFamily: "Arial",
      fontSize: 24,
      fill: 16715792,
      align: "center"
    });
  }
  tile.textGraphics.addChild(tile.text);
  tile.text.anchor.x = 0.5;
  tile.text.anchor.y = 0.5;
  graphics.addChild(tile.textGraphics);
}
let Id2DTiledPixiTrack = /* @__PURE__ */ (function(_HeatmapTiledPixiTrac) {
  function Id2DTiledPixiTrack2() {
    _classCallCheck$O(this, Id2DTiledPixiTrack2);
    return _callSuper$N(this, Id2DTiledPixiTrack2, arguments);
  }
  _inherits$N(Id2DTiledPixiTrack2, _HeatmapTiledPixiTrac);
  return _createClass$O(Id2DTiledPixiTrack2, [{
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _initTile.bind(this)(tile);
      this.drawTile(tile);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _drawTile.bind(this)(tile);
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      toFetch.forEach((x) => {
        const key = x.remoteId;
        const keyParts = key.split(".");
        const data2 = {
          zoomLevel: keyParts[0],
          tilePos: keyParts.slice(1, keyParts.length).map((keyPart) => +keyPart)
        };
        this.fetchedTiles[x.tileId] = x;
        this.fetchedTiles[x.tileId].tileData = data2;
        if (this.fetching.has(x.remoteId)) {
          this.fetching.delete(x.remoteId);
        }
      });
      this.synchronizeTilesAndGraphics();
    }
  }]);
})(HeatmapTiledPixiTrack);
function _classCallCheck$N(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$N(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$N(o.key), o);
  }
}
function _createClass$N(e, r2, t) {
  return r2 && _defineProperties$N(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$N(t) {
  var i = _toPrimitive$N(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$N(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$M(t, o, e) {
  return o = _getPrototypeOf$M(o), _possibleConstructorReturn$M(t, _isNativeReflectConstruct$M() ? Reflect.construct(o, e || [], _getPrototypeOf$M(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$M(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$M(t);
}
function _assertThisInitialized$M(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$M() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$M = function() {
    return !!t;
  })();
}
function _superPropGet$w(t, o, e, r2) {
  var p = _get$w(_getPrototypeOf$M(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$w() {
  return _get$w = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$w(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$w.apply(null, arguments);
}
function _superPropBase$w(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$M(t)); ) ;
  return t;
}
function _getPrototypeOf$M(t) {
  return _getPrototypeOf$M = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$M(t);
}
function _inherits$M(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$M(t, e);
}
function _setPrototypeOf$M(t, e) {
  return _setPrototypeOf$M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$M(t, e);
}
let IdHorizontal1DTiledPixiTrack = /* @__PURE__ */ (function(_HorizontalTiled1DPix) {
  function IdHorizontal1DTiledPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$N(this, IdHorizontal1DTiledPixiTrack2);
    _this = _callSuper$M(this, IdHorizontal1DTiledPixiTrack2, [context, options2]);
    _this.pMain = _this.pMobile;
    return _this;
  }
  _inherits$M(IdHorizontal1DTiledPixiTrack2, _HorizontalTiled1DPix);
  return _createClass$N(IdHorizontal1DTiledPixiTrack2, [{
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      const graphics = tile.graphics;
      tile.textGraphics = new GLOBALS.PIXI.Graphics();
      tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${tile.tileData.tilePos.join("/")}`, {
        fontFamily: "Arial",
        fontSize: 32,
        fill: 16715792,
        align: "center"
      });
      tile.textGraphics.addChild(tile.text);
      tile.text.anchor.x = 0.5;
      tile.text.anchor.y = 0.5;
      graphics.addChild(tile.textGraphics);
      this.drawTile(tile);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _superPropGet$w(IdHorizontal1DTiledPixiTrack2, "drawTile", this)([tile]);
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tSX = 1 / ((this._xScale(1) - this._xScale(0)) / (this._refXScale(1) - this._refXScale(0)));
      tile.text.scale.x = tSX;
      graphics.clear();
      const tileScaledHeight = this.dimensions[1];
      const tileScaledWidth = this._refXScale(tileX + tileWidth) - this._refXScale(tileX);
      tile.textGraphics.position.x = this._refXScale(tileX) + tileScaledWidth / 2;
      tile.textGraphics.position.y = tileScaledHeight / 2;
      const rectX = this._refXScale(tileX);
      graphics.lineStyle(4 * tSX, 255, 1);
      graphics.beginFill(16740363, 0.4);
      graphics.alpha = 0.5;
      graphics.moveTo(rectX, 0);
      graphics.lineTo(rectX, tileScaledHeight);
      graphics.moveTo(rectX + tileScaledWidth, 0);
      graphics.lineTo(rectX + tileScaledWidth, tileScaledHeight);
      graphics.lineStyle(0, 255, 1);
      graphics.drawRect(rectX, 0, tileScaledWidth, tileScaledHeight);
    }
  }]);
})(HorizontalTiled1DPixiTrack);
function _classCallCheck$M(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$M(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$M(o.key), o);
  }
}
function _createClass$M(e, r2, t) {
  return r2 && _defineProperties$M(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$M(t) {
  var i = _toPrimitive$M(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$M(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$L(t, o, e) {
  return o = _getPrototypeOf$L(o), _possibleConstructorReturn$L(t, _isNativeReflectConstruct$L() ? Reflect.construct(o, e || [], _getPrototypeOf$L(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$L(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$L(t);
}
function _assertThisInitialized$L(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$L() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$L = function() {
    return !!t;
  })();
}
function _superPropGet$v(t, o, e, r2) {
  var p = _get$v(_getPrototypeOf$L(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$v() {
  return _get$v = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$v(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$v.apply(null, arguments);
}
function _superPropBase$v(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$L(t)); ) ;
  return t;
}
function _getPrototypeOf$L(t) {
  return _getPrototypeOf$L = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$L(t);
}
function _inherits$L(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$L(t, e);
}
function _setPrototypeOf$L(t, e) {
  return _setPrototypeOf$L = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$L(t, e);
}
let VerticalTiled1DPixiTrack = /* @__PURE__ */ (function(_Tiled1DPixiTrack) {
  function VerticalTiled1DPixiTrack2() {
    _classCallCheck$M(this, VerticalTiled1DPixiTrack2);
    return _callSuper$L(this, VerticalTiled1DPixiTrack2, arguments);
  }
  _inherits$L(VerticalTiled1DPixiTrack2, _Tiled1DPixiTrack);
  return _createClass$M(VerticalTiled1DPixiTrack2, [{
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const yZoomLevel = api.calculateZoomLevel(this._yScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const zoomLevel = Math.min(yZoomLevel, this.maxZoom);
      return zoomLevel;
    }
  }, {
    key: "relevantScale",
    value: function relevantScale() {
      return this._yScale;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _superPropGet$v(VerticalTiled1DPixiTrack2, "zoomed", this)([newXScale, newYScale]);
      const scaleX = 1;
      const scaleY = (newYScale(1) - newYScale(0)) / (this._refYScale(1) - this._refYScale(0));
      const translateX2 = this.position[0];
      const translateY2 = newYScale(0) + this.position[1] - this._refYScale(1) * scaleY;
      this.pMain.position.x = translateX2;
      this.pMain.position.y = translateY2;
      this.pMain.scale.x = scaleX;
      this.pMain.scale.y = scaleY;
    }
  }]);
})(Tiled1DPixiTrack);
function _classCallCheck$L(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$L(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$L(o.key), o);
  }
}
function _createClass$L(e, r2, t) {
  return r2 && _defineProperties$L(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$L(t) {
  var i = _toPrimitive$L(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$L(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$K(t, o, e) {
  return o = _getPrototypeOf$K(o), _possibleConstructorReturn$K(t, _isNativeReflectConstruct$K() ? Reflect.construct(o, e || [], _getPrototypeOf$K(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$K(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$K(t);
}
function _assertThisInitialized$K(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$K() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$K = function() {
    return !!t;
  })();
}
function _superPropGet$u(t, o, e, r2) {
  var p = _get$u(_getPrototypeOf$K(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$u() {
  return _get$u = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$u(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$u.apply(null, arguments);
}
function _superPropBase$u(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$K(t)); ) ;
  return t;
}
function _getPrototypeOf$K(t) {
  return _getPrototypeOf$K = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$K(t);
}
function _inherits$K(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$K(t, e);
}
function _setPrototypeOf$K(t, e) {
  return _setPrototypeOf$K = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$K(t, e);
}
let IdVertical1DTiledPixiTrack = /* @__PURE__ */ (function(_VerticalTiled1DPixiT) {
  function IdVertical1DTiledPixiTrack2() {
    _classCallCheck$L(this, IdVertical1DTiledPixiTrack2);
    return _callSuper$K(this, IdVertical1DTiledPixiTrack2, arguments);
  }
  _inherits$K(IdVertical1DTiledPixiTrack2, _VerticalTiled1DPixiT);
  return _createClass$L(IdVertical1DTiledPixiTrack2, [{
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      const graphics = tile.graphics;
      tile.textGraphics = new GLOBALS.PIXI.Graphics();
      tile.text = new GLOBALS.PIXI.Text(`${tile.tileData.zoomLevel}/${tile.tileData.tilePos.join("/")}`, {
        fontFamily: "Arial",
        fontSize: 32,
        fill: 16715792,
        align: "center"
      });
      tile.textGraphics.addChild(tile.text);
      tile.text.anchor.x = 0.5;
      tile.text.anchor.y = 0.5;
      tile.text.rotation = -Math.PI / 2;
      graphics.addChild(tile.textGraphics);
      this.drawTile(tile, graphics);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _superPropGet$u(IdVertical1DTiledPixiTrack2, "drawTile", this)([tile]);
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileY,
        tileHeight
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tSY = 1 / ((this._yScale(1) - this._yScale(0)) / (this._refYScale(1) - this._refYScale(0)));
      tile.text.scale.x = tSY;
      graphics.clear();
      graphics.lineStyle(4 * tSY, 255, 1);
      graphics.beginFill(16740363, 0.4);
      graphics.alpha = 0.5;
      const tileScaledWidth = this.dimensions[0];
      const tileScaledHeight = this._refYScale(tileY + tileHeight) - this._refYScale(tileY);
      tile.textGraphics.position.x = tileScaledWidth / 2;
      tile.textGraphics.position.y = this._refYScale(tileY) + tileScaledHeight / 2;
      graphics.drawRect(0, this._refYScale(tileY), tileScaledWidth, tileScaledHeight);
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      toFetch.forEach((x) => {
        const key = x.remoteId;
        const keyParts = key.split(".");
        const data2 = {
          zoomLevel: keyParts[1],
          tilePos: keyParts.slice(2, keyParts.length).map((keyPart) => +keyPart)
        };
        this.fetchedTiles[x.tileId] = x;
        this.fetchedTiles[x.tileId].tileData = data2;
        if (this.fetching.has(x.remoteId)) {
          this.fetching.delete(x.remoteId);
        }
      });
      this.synchronizeTilesAndGraphics();
    }
  }]);
})(VerticalTiled1DPixiTrack);
var slice = Array.prototype.slice;
function identity$2(x) {
  return x;
}
var top = 1, right = 2, bottom = 3, left = 4, epsilon$1 = 1e-6;
function translateX(x) {
  return "translate(" + x + ",0)";
}
function translateY(y) {
  return "translate(0," + y + ")";
}
function number(scale) {
  return (d) => +scale(d);
}
function center(scale, offset) {
  offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
  if (scale.round()) offset = Math.round(offset);
  return (d) => +scale(d) + offset;
}
function entering() {
  return !this.__axis;
}
function axis(orient, scale) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform2 = orient === top || orient === bottom ? translateX : translateY;
  function axis2(context) {
    var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$2 : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range2 = scale.range(), range0 = +range2[0] + offset, range1 = +range2[range2.length - 1] + offset, position = (scale.bandwidth ? center : number)(scale.copy(), offset), selection2 = context.selection ? context.selection() : context, path = selection2.selectAll(".domain").data([null]), tick = selection2.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text2 = tick.select("text");
    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
    text2 = text2.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
    if (context !== selection2) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text2 = text2.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon$1).attr("transform", function(d) {
        return isFinite(d = position(d)) ? transform2(d + offset) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon$1).attr("transform", function(d) {
        var p = this.parentNode.__axis;
        return transform2((p && isFinite(p = p(d)) ? p : position(d)) + offset);
      });
    }
    tickExit.remove();
    path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d) {
      return transform2(position(d) + offset);
    });
    line.attr(x + "2", k * tickSizeInner);
    text2.attr(x, k * spacing).text(format2);
    selection2.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
    selection2.each(function() {
      this.__axis = position;
    });
  }
  axis2.scale = function(_) {
    return arguments.length ? (scale = _, axis2) : scale;
  };
  axis2.ticks = function() {
    return tickArguments = slice.call(arguments), axis2;
  };
  axis2.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_) {
    return arguments.length ? (tickFormat2 = _, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis2) : tickPadding;
  };
  axis2.offset = function(_) {
    return arguments.length ? (offset = +_, axis2) : offset;
  };
  return axis2;
}
function axisTop(scale) {
  return axis(top, scale);
}
function axisRight(scale) {
  return axis(right, scale);
}
function axisBottom(scale) {
  return axis(bottom, scale);
}
function axisLeft(scale) {
  return axis(left, scale);
}
const d3Axis = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  axisBottom,
  axisLeft,
  axisRight,
  axisTop
}, Symbol.toStringTag, { value: "Module" }));
function _classCallCheck$K(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$K(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$K(o.key), o);
  }
}
function _createClass$K(e, r2, t) {
  return r2 && _defineProperties$K(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$K(t) {
  var i = _toPrimitive$K(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$K(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$J(t, o, e) {
  return o = _getPrototypeOf$J(o), _possibleConstructorReturn$J(t, _isNativeReflectConstruct$J() ? Reflect.construct(o, e || [], _getPrototypeOf$J(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$J(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$J(t);
}
function _assertThisInitialized$J(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$J() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$J = function() {
    return !!t;
  })();
}
function _getPrototypeOf$J(t) {
  return _getPrototypeOf$J = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$J(t);
}
function _inherits$J(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$J(t, e);
}
function _setPrototypeOf$J(t, e) {
  return _setPrototypeOf$J = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$J(t, e);
}
let SVGTrack = /* @__PURE__ */ (function(_Track) {
  function SVGTrack2(context, options2) {
    var _this;
    _classCallCheck$K(this, SVGTrack2);
    _this = _callSuper$J(this, SVGTrack2, [context, options2]);
    const {
      svgElement
    } = context;
    _this.gMain = select(svgElement).append("g");
    _this.clipUid = slugid.nice();
    _this.clipRect = _this.gMain.append("clipPath").attr("id", `track-bounds-${_this.clipUid}`).append("rect");
    _this.gMain.attr("clip-path", `url(#track-bounds-${_this.clipUid})`);
    return _this;
  }
  _inherits$J(SVGTrack2, _Track);
  return _createClass$K(SVGTrack2, [{
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      this.gMain.attr("transform", `translate(${this.position[0]},${this.position[1]})`);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      this._xScale.range([0, this.dimensions[0]]);
      this._yScale.range([0, this.dimensions[1]]);
      if (newDimensions[0] >= 0 && newDimensions[1] >= 0) {
        this.clipRect.attr("width", newDimensions[0]);
        this.clipRect.attr("height", newDimensions[1]);
      } else {
        this.clipRect.attr("width", 0);
        this.clipRect.attr("height", 0);
      }
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove2() {
      this.gMain.remove();
      this.gMain = null;
    }
  }, {
    key: "draw",
    value: function draw() {
      return this;
    }
  }]);
})(Track);
function _classCallCheck$J(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$J(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$J(o.key), o);
  }
}
function _createClass$J(e, r2, t) {
  return r2 && _defineProperties$J(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$J(t) {
  var i = _toPrimitive$J(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$J(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$I(t, o, e) {
  return o = _getPrototypeOf$I(o), _possibleConstructorReturn$I(t, _isNativeReflectConstruct$I() ? Reflect.construct(o, e || [], _getPrototypeOf$I(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$I(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$I(t);
}
function _assertThisInitialized$I(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$I() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$I = function() {
    return !!t;
  })();
}
function _superPropGet$t(t, o, e, r2) {
  var p = _get$t(_getPrototypeOf$I(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$t() {
  return _get$t = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$t(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$t.apply(null, arguments);
}
function _superPropBase$t(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$I(t)); ) ;
  return t;
}
function _getPrototypeOf$I(t) {
  return _getPrototypeOf$I = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$I(t);
}
function _inherits$I(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$I(t, e);
}
function _setPrototypeOf$I(t, e) {
  return _setPrototypeOf$I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$I(t, e);
}
let LeftAxisTrack = /* @__PURE__ */ (function(_SVGTrack) {
  function LeftAxisTrack2(context, options2) {
    var _this;
    _classCallCheck$J(this, LeftAxisTrack2);
    _this = _callSuper$I(this, LeftAxisTrack2, [context, options2]);
    _this.axis = axisLeft(_this._yScale);
    _this.gAxis = _this.gMain.append("g");
    _this.tilesetInfo = true;
    return _this;
  }
  _inherits$I(LeftAxisTrack2, _SVGTrack);
  return _createClass$J(LeftAxisTrack2, [{
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$t(LeftAxisTrack2, "setDimensions", this)([newDimensions]);
      this.axis.ticks(Math.ceil(this.dimensions[1] / 150));
      this.gAxis.attr("transform", `translate(${newDimensions[0]},0)`);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.axis.scale(this._yScale);
      if (this.options.reverseAxis === "yes" || this.options.reverseAxis === true) {
        const defaultFormat = format$1(",");
        this.axis.tickFormat((d) => defaultFormat(-d));
      } else {
        this.axis.tickFormat(null);
      }
      this.gAxis.call(this.axis);
      return this;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _superPropGet$t(LeftAxisTrack2, "zoomed", this)([newXScale, newYScale]);
      this.draw();
    }
  }]);
})(SVGTrack);
function _classCallCheck$I(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$I(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$I(o.key), o);
  }
}
function _createClass$I(e, r2, t) {
  return r2 && _defineProperties$I(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$I(t) {
  var i = _toPrimitive$I(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$I(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$H(t, o, e) {
  return o = _getPrototypeOf$H(o), _possibleConstructorReturn$H(t, _isNativeReflectConstruct$H() ? Reflect.construct(o, e || [], _getPrototypeOf$H(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$H(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$H(t);
}
function _assertThisInitialized$H(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$H() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$H = function() {
    return !!t;
  })();
}
function _superPropGet$s(t, o, e, r2) {
  var p = _get$s(_getPrototypeOf$H(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$s() {
  return _get$s = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$s(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$s.apply(null, arguments);
}
function _superPropBase$s(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$H(t)); ) ;
  return t;
}
function _getPrototypeOf$H(t) {
  return _getPrototypeOf$H = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$H(t);
}
function _inherits$H(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$H(t, e);
}
function _setPrototypeOf$H(t, e) {
  return _setPrototypeOf$H = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$H(t, e);
}
const drawRectOnGraphics = (x, y, width, height, graphics) => {
  graphics.drawRect(x, y, width, height);
};
const drawRectOnSvg = (x, y, width, height, svg, {
  fill = 0,
  fillOpacity = 0,
  stroke = 0,
  strokeWidth = 0,
  strokeOpacity = 0
} = {}) => {
  const r2 = document.createElement("rect");
  r2.setAttribute("x", x);
  r2.setAttribute("y", y);
  r2.setAttribute("width", width);
  r2.setAttribute("height", height);
  r2.setAttribute("fill", `#${decToHexStr(fill)}`);
  r2.setAttribute("fill-opacity", fillOpacity);
  r2.setAttribute("stroke", `#${decToHexStr(stroke)}`);
  r2.setAttribute("stroke-opacity", strokeOpacity);
  r2.setAttribute("stroke-width", strokeWidth);
  svg.appendChild(r2);
};
const drawRect = (x, y, width, height, target2, options2) => {
  if (target2 instanceof HTMLElement) drawRectOnSvg(x, y, width, height, target2, options2);
  else drawRectOnGraphics(x, y, width, height, target2);
};
const drawRectWithPositionedBorder = (graphics, xPos, yPos, width, height, fill, stroke, outline, {
  isVertical = false,
  svg = null
} = {}) => {
  let finalXPos = xPos;
  let finalYPos = yPos;
  let finalWidth = width;
  let finalHeight = height;
  const outlineWidth = outline.width * 2 > width ? width / 2 : outline.width;
  const outlineHeight = outline.width * 2 > height ? height / 2 : outline.width;
  const target2 = svg || graphics;
  const colors = {
    fill: 0,
    fillOpacity: 0,
    stroke: 0,
    strokeOpacity: 0,
    strokeWidth: 1
  };
  if (outline.positions?.length) {
    graphics.lineStyle(1, 0, 0);
    graphics.beginFill(outline.color, outline.opacity);
    colors.fill = outline.color;
    colors.fillOpacity = outline.opacity;
    colors.stroke = 0;
    colors.strokeOpacity = 0;
    colors.strokeWidth = 1;
    outline.positions.forEach((pos) => {
      if (pos === "top" && !isVertical || pos === "left" && isVertical) {
        drawRect(xPos - outlineWidth, yPos - outlineHeight, width + outlineWidth * 2, outlineHeight, target2, colors);
      } else if (pos === "bottom" && !isVertical || pos === "right" && isVertical) {
        drawRect(xPos - outlineWidth, yPos + height, width + outlineWidth * 2, outlineHeight, target2, colors);
      } else if (pos === "left" && !isVertical || pos === "top" && isVertical) {
        drawRect(xPos - outlineWidth, yPos - outlineHeight, outlineWidth, height + outlineHeight * 2, target2, colors);
      } else if (pos === "right" && !isVertical || pos === "bottom" && isVertical) {
        drawRect(xPos + width, yPos - outlineHeight, outlineWidth, height + outlineHeight * 2, target2, colors);
      }
    });
  } else if (outline.width > 0 && outline.opacity > 0) {
    graphics.lineStyle(outline.width, outline.color, outline.opacity);
    graphics.beginFill(0, 0);
    colors.fill = 0;
    colors.fillOpacity = 0;
    colors.stroke = outline.color;
    colors.strokeOpacity = outline.opacity;
    colors.strokeWidth = outline.width;
    drawRect(xPos - outlineWidth, yPos - outlineHeight, width + outlineWidth * 2, height + outlineHeight * 2, target2, colors);
  }
  if (stroke.positions?.length) {
    graphics.lineStyle(1, 0, 0);
    graphics.beginFill(stroke.color, stroke.opacity);
    const strokeWidth = stroke.width * 2 > width ? width / 2 : stroke.width;
    const strokeHeight = stroke.width * 2 > height ? height / 2 : stroke.width;
    colors.fill = stroke.color;
    colors.fillOpacity = stroke.opacity;
    colors.stroke = 0;
    colors.strokeOpacity = 0;
    colors.strokeWidth = 1;
    stroke.positions.forEach((pos) => {
      if (pos === "top" && !isVertical || pos === "left" && isVertical) {
        drawRect(xPos, yPos, width, strokeHeight, target2, colors);
        finalYPos += strokeHeight;
        finalHeight -= strokeHeight;
      } else if (pos === "bottom" && !isVertical || pos === "right" && isVertical) {
        drawRect(xPos, yPos + height - strokeHeight, width, strokeHeight, target2, colors);
        finalHeight -= strokeHeight;
      } else if (pos === "left" && !isVertical || pos === "top" && isVertical) {
        drawRect(xPos, yPos, strokeWidth, height, target2, colors);
        finalXPos += strokeWidth;
        finalWidth -= strokeWidth;
      } else if (pos === "right" && !isVertical || pos === "bottom" && isVertical) {
        drawRect(xPos + width - strokeWidth, yPos, strokeWidth, height, target2, colors);
        finalWidth -= strokeWidth;
      }
    });
  } else {
    graphics.lineStyle(stroke.width, stroke.color, stroke.opacity);
    colors.stroke = stroke.color;
    colors.strokeOpacity = stroke.opacity;
    colors.strokeWidth = stroke.width;
  }
  graphics.beginFill(fill.color, fill.opacity);
  colors.fill = fill.color;
  colors.fillOpacity = fill.opacity;
  drawRect(finalXPos, finalYPos, finalWidth, finalHeight, target2, colors);
};
let OverlayTrack = /* @__PURE__ */ (function(_PixiTrack) {
  function OverlayTrack2(context, options2) {
    var _this;
    _classCallCheck$I(this, OverlayTrack2);
    _this = _callSuper$H(this, OverlayTrack2, [context, options2]);
    _this.options = options2 || {};
    _this.drawnRects = {};
    return _this;
  }
  _inherits$H(OverlayTrack2, _PixiTrack);
  return _createClass$I(OverlayTrack2, [{
    key: "drawHorizontalOverlay",
    value: function drawHorizontalOverlay(graphics, position, extent2, minWidth = 0, fill, stroke, outline, options2) {
      if (!extent2 || extent2.length < 2) return;
      let xPos = this.position[0] + position.left + this._xScale(extent2[0]);
      const yPos = this.position[1] + position.top;
      const height = position.height;
      let width = this._xScale(extent2[1]) - this._xScale(extent2[0]);
      if (width < minWidth) {
        xPos -= (minWidth - width) / 2;
        width = minWidth;
      }
      drawRectWithPositionedBorder(graphics, xPos, yPos, width, height, fill, stroke, outline, options2);
    }
  }, {
    key: "drawVerticalOverlay",
    value: function drawVerticalOverlay(graphics, position, extent2, minHeight = 0, fill, stroke, outline, options2 = {}) {
      if (!extent2 || extent2.length < 2) return;
      const xPos = this.position[0] + position.left;
      let yPos = this.position[1] + position.top + this._yScale(extent2.length >= 4 ? extent2[2] : extent2[0]);
      const topPosition = this.position[1] + position.top;
      const bottomPosition = this.position[1] + position.top + position.height;
      if (yPos > bottomPosition) {
        return;
      }
      if (yPos < topPosition) {
        yPos = topPosition;
      }
      const width = position.width;
      let height = this._yScale(extent2.length >= 4 ? extent2[3] : extent2[1]) - yPos + position.top + this.position[1];
      if (height < 0) {
        return;
      }
      if (yPos + height > bottomPosition) {
        height += bottomPosition - (yPos + height);
      }
      if (height < minHeight) {
        yPos -= (minHeight - height) / 2;
        height = minHeight;
      }
      options2.isVertical = true;
      drawRectWithPositionedBorder(graphics, xPos, yPos, width, height, fill, stroke, outline, options2);
    }
  }, {
    key: "draw",
    value: function draw(options2) {
      _superPropGet$s(OverlayTrack2, "draw", this, 3)([]);
      const graphics = this.pMain;
      const fill = {
        color: colorToHex(this.options.fill || this.options.fillColor || "blue"),
        opacity: Number.isNaN(+this.options.fillOpacity) ? 0.3 : +this.options.fillOpacity
      };
      const stroke = {
        color: colorToHex(this.options.stroke || "blue"),
        opacity: +this.options.strokeOpacity || 1,
        width: +this.options.strokeWidth || 0,
        positions: !this.options.strokePos || Array.isArray(this.options.strokePos) ? this.options.strokePos : [this.options.strokePos]
      };
      const outline = {
        color: colorToHex(this.options.outline || "white"),
        opacity: +this.options.outlineOpacity || 1,
        width: +this.options.outlineWidth || 0,
        positions: !this.options.outlinePos || Array.isArray(this.options.outlinePos) ? this.options.outlinePos : [this.options.outlinePos]
      };
      if (!options2 || !options2.svg) graphics.clear();
      graphics.lineStyle(stroke.width, stroke, +!stroke.positions * stroke.opacity);
      graphics.beginFill(fill.color, fill.opacity);
      const minWidth = Math.max(0, +this.options.minWidth || 0);
      const minHeight = Math.max(0, +this.options.minHeight || 0);
      if (Array.isArray(this.options.extent)) {
        this.options.orientationsAndPositions.forEach((op) => {
          if (op.orientation === "1d-horizontal" || op.orientation === "2d") {
            this.options.extent.forEach((extent2) => this.drawHorizontalOverlay(graphics, op.position, extent2, minWidth, fill, stroke, outline, options2));
          }
          if (op.orientation === "1d-vertical" || op.orientation === "2d") {
            this.options.extent.forEach((extent2) => this.drawVerticalOverlay(graphics, op.position, extent2, minHeight, fill, stroke, outline, options2));
          }
        });
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$s(OverlayTrack2, "setPosition", this, 3)([newPosition]);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$s(OverlayTrack2, "setDimensions", this, 3)([newDimensions]);
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$s(OverlayTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$s(OverlayTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      track.appendChild(output);
      this.draw({
        svg: output
      });
      return [base, track];
    }
  }]);
})(PixiTrack);
function _classCallCheck$H(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$H(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$H(o.key), o);
  }
}
function _createClass$H(e, r2, t) {
  return r2 && _defineProperties$H(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$H(t) {
  var i = _toPrimitive$H(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$H(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$G(t, o, e) {
  return o = _getPrototypeOf$G(o), _possibleConstructorReturn$G(t, _isNativeReflectConstruct$G() ? Reflect.construct(o, e || [], _getPrototypeOf$G(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$G(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$G(t);
}
function _assertThisInitialized$G(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$G() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$G = function() {
    return !!t;
  })();
}
function _superPropGet$r(t, o, e, r2) {
  var p = _get$r(_getPrototypeOf$G(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$r() {
  return _get$r = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$r(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$r.apply(null, arguments);
}
function _superPropBase$r(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$G(t)); ) ;
  return t;
}
function _getPrototypeOf$G(t) {
  return _getPrototypeOf$G = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$G(t);
}
function _inherits$G(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$G(t, e);
}
function _setPrototypeOf$G(t, e) {
  return _setPrototypeOf$G = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$G(t, e);
}
let TopAxisTrack = /* @__PURE__ */ (function(_SVGTrack) {
  function TopAxisTrack2(context, options2) {
    var _this;
    _classCallCheck$H(this, TopAxisTrack2);
    _this = _callSuper$G(this, TopAxisTrack2, [context, options2]);
    _this.axis = axisTop(_this._xScale);
    _this.gAxis = _this.gMain.append("g");
    _this.tilesetInfo = true;
    return _this;
  }
  _inherits$G(TopAxisTrack2, _SVGTrack);
  return _createClass$H(TopAxisTrack2, [{
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$r(TopAxisTrack2, "setDimensions", this)([newDimensions]);
      this.axis.ticks(Math.ceil(this.dimensions[0] / 150));
      this.gAxis.attr("transform", `translate(0,${newDimensions[1]})`);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.axis.scale(this._xScale);
      this.gAxis.call(this.axis);
      return this;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _superPropGet$r(TopAxisTrack2, "zoomed", this)([newXScale, newYScale]);
      this.draw();
    }
  }]);
})(SVGTrack);
function _classCallCheck$G(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$G(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$G(o.key), o);
  }
}
function _createClass$G(e, r2, t) {
  return r2 && _defineProperties$G(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$G(t) {
  var i = _toPrimitive$G(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$G(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$F(t, o, e) {
  return o = _getPrototypeOf$F(o), _possibleConstructorReturn$F(t, _isNativeReflectConstruct$F() ? Reflect.construct(o, e || [], _getPrototypeOf$F(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$F(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$F(t);
}
function _assertThisInitialized$F(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$F() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$F = function() {
    return !!t;
  })();
}
function _superPropGet$q(t, o, e, r2) {
  var p = _get$q(_getPrototypeOf$F(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$q() {
  return _get$q = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$q(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$q.apply(null, arguments);
}
function _superPropBase$q(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$F(t)); ) ;
  return t;
}
function _getPrototypeOf$F(t) {
  return _getPrototypeOf$F = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$F(t);
}
function _inherits$F(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$F(t, e);
}
function _setPrototypeOf$F(t, e) {
  return _setPrototypeOf$F = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$F(t, e);
}
let HorizontalLine1DPixiTrack = /* @__PURE__ */ (function(_HorizontalTiled1DPix) {
  function HorizontalLine1DPixiTrack2() {
    _classCallCheck$G(this, HorizontalLine1DPixiTrack2);
    return _callSuper$F(this, HorizontalLine1DPixiTrack2, arguments);
  }
  _inherits$F(HorizontalLine1DPixiTrack2, _HorizontalTiled1DPix);
  return _createClass$G(HorizontalLine1DPixiTrack2, [{
    key: "stopHover",
    value: function stopHover() {
      this.pMouseOver.clear();
      this.animate();
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX) {
      if (!this.tilesetInfo || !this.options.showTooltip || !this.valueScale) return "";
      const value = this.getDataAtPos(trackX);
      let textValue = "";
      if (value) textValue = format$1(".3f")(value);
      const graphics = this.pMouseOver;
      const colorHex = 0;
      const yPos = this.valueScale(value);
      graphics.clear();
      graphics.beginFill(colorHex, 0.5);
      graphics.lineStyle(1, colorHex, 1);
      const markerWidth = 4;
      graphics.drawRect(trackX - markerWidth / 2, yPos - markerWidth / 2, markerWidth, markerWidth);
      this.animate();
      return `${textValue}`;
    }
    /**
     * Create whatever is needed to draw this tile.
     */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _superPropGet$q(HorizontalLine1DPixiTrack2, "initTile", this, 3)([tile]);
      if (!tile.tileData || !tile.tileData.dense) {
        console.warn("emptyTile:", tile);
        return;
      }
      tile.xValues = new Array(tile.tileData.dense.length);
      tile.yValues = new Array(tile.tileData.dense.length);
      if (this.isValueScaleLocked()) {
        const glge = this.getLockGroupExtrema();
        if (glge !== null) {
          this.minValue(glge[0]);
          this.maxValue(glge[1]);
        }
      }
      this.drawTile(tile);
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      _superPropGet$q(HorizontalLine1DPixiTrack2, "rerender", this, 3)([options2, force]);
      this.options = options2;
      _superPropGet$q(HorizontalLine1DPixiTrack2, "draw", this, 3)([]);
      this.visibleAndFetchedTiles().forEach((tile) => {
        this.renderTile(tile);
      });
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      this.drawTile(tile);
      if (this.valueScale) {
        this.drawAxis(this.valueScale);
      }
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _superPropGet$q(HorizontalLine1DPixiTrack2, "drawTile", this, 3)([tile]);
      if (!tile.graphics) {
        return;
      }
      if (!tile.tileData || !tile.tileData.dense) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) {
        return;
      }
      const [vs, offsetValue] = this.makeValueScale(this.minValue(), this.medianVisibleValue, this.maxValue());
      this.valueScale = vs;
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      if (!this.tilesetInfo.tile_size && !this.tilesetInfo.bins_per_dimension) {
        console.warn("No tileset_info.tile_size or tileset_info.bins_per_dimension", this.tilesetInfo);
      }
      const tileSize = this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension;
      const tileXScale = linear().domain([0, tileSize]).range([tileX, tileX + tileWidth]);
      const strokeWidth = this.options.lineStrokeWidth ? this.options.lineStrokeWidth : 1;
      graphics.lineStyle(strokeWidth, stroke, 1);
      tile.segments = [];
      let currentSegment = [];
      for (let i = 0; i < tileValues.length; i++) {
        const xPos = this._xScale(tileXScale(i));
        const yPos = this.valueScale(tileValues[i] + offsetValue);
        if (this.options.valueScaling === "log" && tileValues[i] === 0 || Number.isNaN(yPos)) {
          if (currentSegment.length > 1) {
            tile.segments.push(currentSegment);
          }
          currentSegment = [];
          continue;
        }
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        currentSegment.push([xPos, yPos]);
      }
      if (currentSegment.length > 1) {
        tile.segments.push(currentSegment);
      }
      for (const segment of tile.segments) {
        const first = segment[0];
        const rest = segment.slice(1);
        graphics.moveTo(first[0], first[1]);
        for (const point2 of rest) {
          graphics.lineTo(point2[0], point2[1]);
        }
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$q(HorizontalLine1DPixiTrack2, "setPosition", this, 3)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
      this.pMouseOver.position.y = this.position[1];
      this.pMouseOver.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
      const isValueScaleLocked = this.isValueScaleLocked();
      if (this.continuousScaling && this.minValue() !== void 0 && this.maxValue() !== void 0) {
        if (this.valueScaleMin === null && this.valueScaleMax === null && !isValueScaleLocked) {
          const newMin = this.minVisibleValue();
          const newMax = this.maxVisibleValue();
          const epsilon3 = 1e-6;
          if (newMin !== null && newMax !== null && (Math.abs(this.minValue() - newMin) > epsilon3 || Math.abs(this.maxValue() - newMax) > epsilon3)) {
            this.minValue(newMin);
            this.maxValue(newMax);
            this.scheduleRerender();
          }
        }
        if (isValueScaleLocked) {
          this.onValueScaleChanged();
        }
      }
    }
  }, {
    key: "superSVG",
    value: function superSVG() {
      return _superPropGet$q(HorizontalLine1DPixiTrack2, "exportSVG", this, 3)([]);
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$q(HorizontalLine1DPixiTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$q(HorizontalLine1DPixiTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      base.setAttribute("class", "exported-line-track");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      const stroke = this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue";
      this.visibleAndFetchedTiles().forEach((tile) => {
        const g = document.createElement("path");
        g.setAttribute("fill", "transparent");
        g.setAttribute("stroke", stroke);
        let d = "";
        for (const segment of tile.segments) {
          const first = segment[0];
          const rest = segment.slice(1);
          d += `M${first[0]} ${first[1]}`;
          for (const point2 of rest) {
            d += `L${point2[0]} ${point2[1]}`;
          }
        }
        g.setAttribute("d", d);
        output.appendChild(g);
      });
      const gAxis = document.createElement("g");
      gAxis.setAttribute("id", "axis");
      base.appendChild(gAxis);
      gAxis.setAttribute("transform", `translate(${this.axis.pAxis.position.x}, ${this.axis.pAxis.position.y})`);
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        const gDrawnAxis = this.axis.exportAxisLeftSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        const gDrawnAxis = this.axis.exportAxisRightSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      }
      return [base, track];
    }
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      if (this.options.aggregationMode && this.options.aggregationMode !== "mean") {
        return `${tile.join(".")}.${this.options.aggregationMode}`;
      }
      return `${tile.join(".")}`;
    }
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return this.tileToLocalId(tile);
    }
  }]);
})(HorizontalTiled1DPixiTrack);
function _classCallCheck$F(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$F(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$F(o.key), o);
  }
}
function _createClass$F(e, r2, t) {
  return r2 && _defineProperties$F(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$F(t) {
  var i = _toPrimitive$F(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$F(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$E(t, o, e) {
  return o = _getPrototypeOf$E(o), _possibleConstructorReturn$E(t, _isNativeReflectConstruct$E() ? Reflect.construct(o, e || [], _getPrototypeOf$E(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$E(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$E(t);
}
function _assertThisInitialized$E(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$E() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$E = function() {
    return !!t;
  })();
}
function _superPropGet$p(t, o, e, r2) {
  var p = _get$p(_getPrototypeOf$E(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$p() {
  return _get$p = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$p(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$p.apply(null, arguments);
}
function _superPropBase$p(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$E(t)); ) ;
  return t;
}
function _getPrototypeOf$E(t) {
  return _getPrototypeOf$E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$E(t);
}
function _inherits$E(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$E(t, e);
}
function _setPrototypeOf$E(t, e) {
  return _setPrototypeOf$E = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$E(t, e);
}
const HEX_WHITE = colorToHex("#FFFFFF");
let BarTrack = /* @__PURE__ */ (function(_HorizontalLine1DPixi) {
  function BarTrack2(...args) {
    var _this;
    _classCallCheck$F(this, BarTrack2);
    _this = _callSuper$E(this, BarTrack2, [...args]);
    _this.zeroLine = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.zeroLine);
    _this.valueScaleTransform = identity$4;
    if (_this.options?.colorRange) {
      if (_this.options.colorRangeGradient) {
        _this.setColorGradient(_this.options.colorRange);
      } else {
        _this.setColorScale(_this.options.colorRange);
      }
    }
    _this.initialized = true;
    return _this;
  }
  _inherits$E(BarTrack2, _HorizontalLine1DPixi);
  return _createClass$F(BarTrack2, [{
    key: "setColorScale",
    value: function setColorScale(colorRange) {
      if (!colorRange) return;
      this.colorScale = colorDomainToRgbaArray(colorRange);
      this.colorScale = this.colorScale.map((rgb2) => rgb2.map((channel) => channel / 255));
    }
  }, {
    key: "setColorGradient",
    value: function setColorGradient(colorGradient) {
      if (!colorGradient) return;
      const N = colorGradient.length - 1;
      this.colorGradientColors = this.options.align === "bottom" ? colorGradient.slice().reverse().map((color2, i) => ({
        from: i / N,
        color: color2
      })) : colorGradient.map((color2, i) => ({
        from: i / N,
        color: color2
      }));
    }
    /**
     * Create whatever is needed to draw this tile.
     */
  }, {
    key: "initTile",
    value: function initTile(tile) {
      if (!this.initialized) return;
      _superPropGet$p(BarTrack2, "initTile", this)([tile]);
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
      if (!tile.valueScale || !this.scale || this.scale.minValue !== tile.scale.minValue || this.scale.maxValue !== tile.scale.maxValue) {
        this.renderTile(tile);
      }
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      if (!this.initialized) return;
      _superPropGet$p(BarTrack2, "renderTile", this)([tile]);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) return;
      if (!tile.tileData || !tile.tileData.dense) {
        return;
      }
      const {
        graphics
      } = tile;
      const numBins = this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension || tile.tileData.dense.length;
      tile.svgData = void 0;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, numBins);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) return;
      const [valueScale, pseudocount] = this.makeValueScale(this.minValue(), this.medianVisibleValue, this.maxValue(), 0);
      if (!valueScale) return;
      valueScale.clamp(true);
      this.valueScale = valueScale;
      const colorScale = valueScale.copy();
      colorScale.range([254, 0]).clamp(true);
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor || "blue");
      const tileXScale = linear().domain([0, numBins]).range([tileX, tileX + tileWidth]);
      const strokeWidth = 0;
      graphics.lineStyle(strokeWidth, stroke, 1);
      const color2 = this.options.barFillColor || "grey";
      const colorHex = colorToHex(color2);
      const opacity = "barOpacity" in this.options ? this.options.barOpacity : 1;
      graphics.beginFill(colorHex, opacity);
      tile.drawnAtScale = this._xScale.copy();
      const isTopAligned = this.options.align === "top";
      let xPos;
      let width;
      let yPos;
      let height;
      let barMask;
      let barSprite;
      if (this.colorGradientColors) {
        barMask = new GLOBALS.PIXI.Graphics();
        barMask.beginFill(HEX_WHITE, 1);
        const canvas = gradient(
          this.colorGradientColors,
          1,
          this.dimensions[1],
          // width, height
          0,
          0,
          0,
          this.dimensions[1]
          // fromX, fromY, toX, toY
        );
        barSprite = new GLOBALS.PIXI.Sprite(GLOBALS.PIXI.Texture.fromCanvas(canvas, GLOBALS.PIXI.SCALE_MODES.NEAREST));
        barSprite.x = this._xScale(tileX);
        barSprite.width = this._xScale(tileX + tileWidth) - barSprite.x;
      }
      for (let i = 0; i < tileValues.length; i++) {
        xPos = this._xScale(tileXScale(i));
        yPos = this.valueScale(tileValues[i] + pseudocount);
        width = this._xScale(tileXScale(i + 1)) - xPos;
        height = this.dimensions[1] - yPos;
        if (isTopAligned) yPos = 0;
        if (Number.isNaN(height) || height < 0 || yPos < 0) continue;
        this.addSVGInfo(tile, xPos, yPos, width, height, color2);
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) break;
        if (this.colorScale && !this.options.colorRangeGradient) {
          const rgbIdx = Math.round(colorScale(tileValues[i] + pseudocount));
          const rgb2 = this.colorScale[rgbIdx];
          const hex2 = GLOBALS.PIXI.utils.rgb2hex(rgb2);
          graphics.beginFill(hex2, opacity);
        }
        (barMask || graphics).drawRect(xPos, yPos, width, height);
      }
      if (this.colorGradientColors) {
        barSprite.mask = barMask;
        graphics.removeChildren();
        graphics.addChild(barSprite, barMask);
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      if (options2?.colorRange) {
        if (options2.colorRangeGradient) {
          this.setColorGradient(options2.colorRange);
        } else {
          this.setColorScale(options2.colorRange);
        }
      }
      _superPropGet$p(BarTrack2, "rerender", this)([options2, force]);
    }
  }, {
    key: "drawZeroLine",
    value: function drawZeroLine() {
      this.zeroLine.clear();
      const color2 = colorToHex(this.options.barFillColor || "grey");
      const opacity = +this.options.barOpacity || 1;
      const demarcationColor = this.options.zeroLineColor ? colorToHex(this.options.zeroLineColor) : color2;
      const demarcationOpacity = Number.isNaN(+this.options.zeroLineOpacity) ? opacity : +this.options.zeroLineOpacity;
      this.zeroLine.beginFill(demarcationColor, demarcationOpacity);
      this.zeroLine.drawRect(0, this.dimensions[1] - 1, this.dimensions[0], 1);
    }
  }, {
    key: "drawZeroLineSvg",
    value: function drawZeroLineSvg(output) {
      const zeroLine = document.createElement("rect");
      zeroLine.setAttribute("id", "zero-line");
      zeroLine.setAttribute("x", 0);
      zeroLine.setAttribute("y", this.dimensions[1] - 1);
      zeroLine.setAttribute("height", 1);
      zeroLine.setAttribute("width", this.dimensions[0]);
      zeroLine.setAttribute("fill", this.options.zeroLineColor || this.options.barFillColor);
      zeroLine.setAttribute("fill-opacity", this.options.zeroLineOpacity || this.options.barOpacity);
      output.appendChild(zeroLine);
    }
  }, {
    key: "getXScaleAndOffset",
    value: function getXScaleAndOffset(drawnAtScale) {
      const dA = drawnAtScale.domain();
      const dB = this._xScale.domain();
      const tileK = (dA[1] - dA[0]) / (dB[1] - dB[0]);
      const newRange = this._xScale.domain().map(drawnAtScale);
      const posOffset = newRange[0];
      return [tileK, -posOffset * tileK];
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.initialized) return;
      _superPropGet$p(BarTrack2, "draw", this)([]);
      if (this.options.zeroLineVisible) this.drawZeroLine();
      else this.zeroLine.clear();
      Object.values(this.fetchedTiles).forEach((tile) => {
        if (!tile.drawnAtScale) return;
        const [graphicsXScale, graphicsXPos] = this.getXScaleAndOffset(tile.drawnAtScale);
        tile.graphics.scale.x = graphicsXScale;
        tile.graphics.position.x = graphicsXPos;
      });
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _superPropGet$p(BarTrack2, "zoomed", this)([newXScale, newYScale]);
    }
  }, {
    key: "movedY",
    value: function movedY2(dY) {
    }
  }, {
    key: "zoomedY",
    value: function zoomedY2(yPos, kMultiplier) {
    }
    /**
     * Adds information to recreate the track in SVG to the tile
     *
     * @param tile
     * @param x x value of bar
     * @param y y value of bar
     * @param width width of bar
     * @param height height of bar
     * @param color color of bar (not converted to hex)
     */
  }, {
    key: "addSVGInfo",
    value: function addSVGInfo(tile, x, y, width, height, color2) {
      if (tile.svgData) {
        tile.svgData.barXValues.push(x);
        tile.svgData.barYValues.push(y);
        tile.svgData.barWidths.push(width);
        tile.svgData.barHeights.push(height);
        tile.svgData.barColors.push(color2);
      } else {
        tile.svgData = {
          barXValues: [x],
          barYValues: [y],
          barWidths: [width],
          barHeights: [height],
          barColors: [color2]
        };
      }
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      [base, track] = _superPropGet$p(BarTrack2, "superSVG", this)([]);
      base.setAttribute("class", "exported-line-track");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      if (this.options.zeroLine) this.drawZeroLineSvg(output);
      this.visibleAndFetchedTiles().filter((tile) => tile.svgData?.barXValues).forEach((tile) => {
        const data2 = tile.svgData;
        for (let i = 0; i < data2.barXValues.length; i++) {
          const rect2 = document.createElement("rect");
          rect2.setAttribute("fill", data2.barColors[i]);
          rect2.setAttribute("stroke", data2.barColors[i]);
          rect2.setAttribute("x", data2.barXValues[i]);
          rect2.setAttribute("y", data2.barYValues[i]);
          rect2.setAttribute("height", data2.barHeights[i]);
          rect2.setAttribute("width", data2.barWidths[i]);
          if (tile.barBorders) {
            rect2.setAttribute("stroke-width", "0.1");
            rect2.setAttribute("stroke", "black");
          }
          output.appendChild(rect2);
        }
      });
      const gAxis = document.createElement("g");
      gAxis.setAttribute("id", "axis");
      base.appendChild(gAxis);
      gAxis.setAttribute("transform", `translate(${this.axis.pAxis.position.x}, ${this.axis.pAxis.position.y})`);
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        const gDrawnAxis = this.axis.exportAxisLeftSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        const gDrawnAxis = this.axis.exportAxisRightSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      }
      return [base, track];
    }
  }]);
})(HorizontalLine1DPixiTrack);
function _classCallCheck$E(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$E(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$E(o.key), o);
  }
}
function _createClass$E(e, r2, t) {
  return r2 && _defineProperties$E(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$E(t) {
  var i = _toPrimitive$E(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$E(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$D(t, o, e) {
  return o = _getPrototypeOf$D(o), _possibleConstructorReturn$D(t, _isNativeReflectConstruct$D() ? Reflect.construct(o, e || [], _getPrototypeOf$D(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$D(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$D(t);
}
function _assertThisInitialized$D(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$D() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$D = function() {
    return !!t;
  })();
}
function _getPrototypeOf$D(t) {
  return _getPrototypeOf$D = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$D(t);
}
function _inherits$D(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$D(t, e);
}
function _setPrototypeOf$D(t, e) {
  return _setPrototypeOf$D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$D(t, e);
}
let DivergentBarTrack = /* @__PURE__ */ (function(_BarTrack) {
  function DivergentBarTrack2() {
    _classCallCheck$E(this, DivergentBarTrack2);
    return _callSuper$D(this, DivergentBarTrack2, arguments);
  }
  _inherits$D(DivergentBarTrack2, _BarTrack);
  return _createClass$E(DivergentBarTrack2, [{
    key: "drawTile",
    value: function drawTile(tile) {
      this.renderTile(tile);
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos, this.tilesetInfo.tile_size || this.tilesetInfo.bins_per_dimension);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) {
        return;
      }
      let pseudocount = 0;
      this.valueScale = null;
      if (this.options.valueScaling === "log") {
        let offsetValue = this.medianVisibleValue;
        if (!this.medianVisibleValue) {
          offsetValue = this.minValue();
        }
        this.valueScale = log$2().domain([offsetValue, this.maxValue() + offsetValue]).range([this.dimensions[1], 0]);
        pseudocount = offsetValue;
      } else {
        this.valueScale = linear().domain([this.minValue(), this.maxValue()]).range([this.dimensions[1], 0]);
      }
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size]).range([tileX, tileX + tileWidth]);
      const strokeWidth = 0;
      graphics.lineStyle(strokeWidth, stroke, 1);
      const topColor = this.options.barFillColorTop ? this.options.barFillColorTop : "green";
      const bottomColor = this.options.barFillColorBottom ? this.options.barFillColorBottom : "red";
      const topColorHex = colorToHex(topColor);
      const bottomColorHex = colorToHex(bottomColor);
      const opacity = "barOpacity" in this.options ? this.options.barOpacity : 1;
      tile.drawnAtScale = this._xScale.copy();
      let baseline = 0;
      if (this.options.valueScaling === "log") {
        baseline = this.valueScale(1);
      } else {
        baseline = this.valueScale(0);
      }
      delete tile.svgData;
      for (let i = 0; i < tileValues.length; i++) {
        const xPos = this._xScale(tileXScale(i));
        const yPos = this.valueScale(tileValues[i] + pseudocount);
        const width = this._xScale(tileXScale(i + 1)) - xPos;
        if (yPos > baseline) {
          graphics.beginFill(bottomColorHex, opacity);
          this.addSVGInfo(tile, xPos, baseline, width, yPos - baseline, bottomColor);
        } else {
          graphics.beginFill(topColorHex, opacity);
          this.addSVGInfo(tile, xPos, yPos, width, baseline - yPos, topColor);
        }
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        graphics.drawRect(xPos, tile.svgData.barYValues[i], width, tile.svgData.barHeights[i]);
      }
    }
  }]);
})(BarTrack);
function _classCallCheck$D(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$D(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$D(o.key), o);
  }
}
function _createClass$D(e, r2, t) {
  return r2 && _defineProperties$D(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$D(t) {
  var i = _toPrimitive$D(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$D(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$C(t, o, e) {
  return o = _getPrototypeOf$C(o), _possibleConstructorReturn$C(t, _isNativeReflectConstruct$C() ? Reflect.construct(o, e || [], _getPrototypeOf$C(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$C(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$C(t);
}
function _assertThisInitialized$C(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$C() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$C = function() {
    return !!t;
  })();
}
function _superPropGet$o(t, o, e, r2) {
  var p = _get$o(_getPrototypeOf$C(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$o() {
  return _get$o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$o(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$o.apply(null, arguments);
}
function _superPropBase$o(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$C(t)); ) ;
  return t;
}
function _getPrototypeOf$C(t) {
  return _getPrototypeOf$C = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$C(t);
}
function _inherits$C(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$C(t, e);
}
function _setPrototypeOf$C(t, e) {
  return _setPrototypeOf$C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$C(t, e);
}
let Horizontal1dHeatmapTrack = /* @__PURE__ */ (function(_HorizontalLine1DPixi) {
  function Horizontal1dHeatmapTrack2(context, options2) {
    var _this;
    _classCallCheck$D(this, Horizontal1dHeatmapTrack2);
    _this = _callSuper$C(this, Horizontal1dHeatmapTrack2, [context, options2]);
    _this.setColorScale(options2.colorRange);
    _this.opacity = options2.opacity || 1;
    return _this;
  }
  _inherits$C(Horizontal1dHeatmapTrack2, _HorizontalLine1DPixi);
  return _createClass$D(Horizontal1dHeatmapTrack2, [{
    key: "setColorScale",
    value: function setColorScale(colorRange) {
      this.colorScale = colorRange ? colorDomainToRgbaArray(colorRange) : HEATED_OBJECT_MAP;
      this.colorScale = this.colorScale.map((rgb2) => rgb2.map((channel) => channel / 255));
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
      if (options2?.colorRange) {
        this.setColorScale(options2.colorRange);
      }
      this.opacity = options2.opacity || 1;
      _superPropGet$o(Horizontal1dHeatmapTrack2, "rerender", this)([options2]);
    }
  }, {
    key: "drawAxis",
    value: function drawAxis2() {
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics || !tile.tileData || !tile.tileData.dense) return;
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) return;
      const [valueScale, pseudocount] = this.makeValueScale(this.minValue(), this.medianVisibleValue, this.maxValue());
      valueScale.range([254, 0]).clamp(true);
      this.valueScale = valueScale;
      graphics.clear();
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size]).range([tileX, tileX + tileWidth]);
      graphics.lineStyle(0, 0, 0);
      for (let i = 0; i < tileValues.length; i++) {
        if (Number.isNaN(tileValues[i])) continue;
        const rgbIdx = Math.round(this.valueScale(tileValues[i] + pseudocount));
        if (Number.isNaN(+rgbIdx)) continue;
        const xPos = this._xScale(tileXScale(i));
        const width = this._xScale(tileXScale(i + 1)) - xPos;
        const height = this.dimensions[1];
        tile.xValues[i] = xPos;
        tile.yValues[i] = rgbIdx;
        const rgb2 = this.colorScale[rgbIdx];
        const hex2 = GLOBALS.PIXI.utils.rgb2hex(rgb2);
        graphics.beginFill(hex2, this.opacity);
        if (i === 0) continue;
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        if (tileValues[i] !== 0) {
          graphics.drawRect(xPos, 0, width, height);
        }
      }
    }
  }]);
})(HorizontalLine1DPixiTrack);
function cumsum(values) {
  let sum2 = 0;
  const result = [];
  values.forEach((v) => {
    sum2 += +v || 0;
    result.push(sum2);
  });
  return Float64Array.from(result);
}
const selectedItemsToCumWeights = (selectedItems, withRelativeSize) => {
  const totalLength = selectedItemsToSize(selectedItems, withRelativeSize);
  return cumsum(selectedItems.map((d) => (Array.isArray(d) && withRelativeSize ? d.length : 1) / totalLength));
};
function _classCallCheck$C(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$C(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$C(o.key), o);
  }
}
function _createClass$C(e, r2, t) {
  return r2 && _defineProperties$C(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$C(t) {
  var i = _toPrimitive$C(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$C(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$B(t, o, e) {
  return o = _getPrototypeOf$B(o), _possibleConstructorReturn$B(t, _isNativeReflectConstruct$B() ? Reflect.construct(o, e || [], _getPrototypeOf$B(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$B(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$B(t);
}
function _assertThisInitialized$B(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$B() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$B = function() {
    return !!t;
  })();
}
function _superPropGet$n(t, o, e, r2) {
  var p = _get$n(_getPrototypeOf$B(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$n() {
  return _get$n = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$n(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$n.apply(null, arguments);
}
function _superPropBase$n(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$B(t)); ) ;
  return t;
}
function _getPrototypeOf$B(t) {
  return _getPrototypeOf$B = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$B(t);
}
function _inherits$B(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$B(t, e);
}
function _setPrototypeOf$B(t, e) {
  return _setPrototypeOf$B = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$B(t, e);
}
let HorizontalMultivecTrack = /* @__PURE__ */ (function(_HeatmapTiledPixiTrac) {
  function HorizontalMultivecTrack2(context, options2) {
    var _this;
    _classCallCheck$C(this, HorizontalMultivecTrack2);
    _this = _callSuper$B(this, HorizontalMultivecTrack2, [context, options2]);
    _this.pMain = _this.pMobile;
    _this.continuousScaling = false;
    _this.updateDataFetcher(options2);
    return _this;
  }
  _inherits$B(HorizontalMultivecTrack2, _HeatmapTiledPixiTrac);
  return _createClass$C(HorizontalMultivecTrack2, [{
    key: "updateDataFetcher",
    value: function updateDataFetcher(options2) {
      if (options2?.selectRows && options2.selectRowsAggregationMethod === "server") {
        const {
          pubSub,
          dataFetcher: prevDataFetcher
        } = this;
        const prevDataConfigOptions = prevDataFetcher.dataConfig.options;
        const nextDataConfigOptions = {
          aggGroups: options2.selectRows,
          aggFunc: options2.selectRowsAggregationMode
        };
        if (JSON.stringify(prevDataConfigOptions) !== JSON.stringify(nextDataConfigOptions)) {
          const newDataConfig = {
            ...prevDataFetcher.dataConfig,
            options: nextDataConfigOptions
          };
          this.dataFetcher = new prevDataFetcher.constructor(newDataConfig, pubSub);
          if (this.dataFetcher.dataConfig.tilesetUid) {
            this.fetchNewTiles(Object.keys(this.fetchedTiles).map((x) => ({
              tileId: x,
              remoteId: x
            })));
          }
        }
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      this.updateDataFetcher(options2);
      _superPropGet$n(HorizontalMultivecTrack2, "rerender", this)([options2, force]);
      if (options2.selectRows) {
        this.selectRowsCumWeights = selectedItemsToCumWeights(options2.selectRows, options2.selectRowsAggregationWithRelativeHeight);
      }
    }
  }, {
    key: "tileDataToCanvas",
    value: function tileDataToCanvas(pixData) {
      const canvas = document.createElement("canvas");
      if (this.options.selectRows && this.tilesetInfo.shape) {
        canvas.width = this.tilesetInfo.shape[0];
        canvas.height = selectedItemsToSize(this.options.selectRows, this.options.selectRowsAggregationWithRelativeHeight);
      } else if (this.tilesetInfo.shape) {
        canvas.width = this.tilesetInfo.shape[0];
        canvas.height = this.tilesetInfo.shape[1];
      } else {
        canvas.width = this.tilesetInfo.tile_size;
        canvas.height = 1;
      }
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      if (pixData.length !== 0 && pixData.length === 4 * canvas.width * canvas.height) {
        const pix = new ImageData(pixData, canvas.width, canvas.height);
        ctx.putImageData(pix, 0, 0);
      } else {
        console.warn("HorizontalMultivecTrack: pixData has an incorrect length.");
      }
      return canvas;
    }
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos) {
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(zoomLevel, tilePos, this.tilesetInfo.tile_size);
      const tileEndX = tileX + tileWidth;
      sprite.width = this._refXScale(tileEndX) - this._refXScale(tileX);
      sprite.height = this.dimensions[1];
      sprite.x = this._refXScale(tileX);
      sprite.y = 0;
    }
  }, {
    key: "leftTrackZoomed",
    value: function leftTrackZoomed(newXScale, newYScale, k, tx, ty) {
      const offset = this._xScale(0) - k * this._refXScale(0);
      this.pMobile.position.x = offset + this.position[0];
      this.pMobile.position.y = this.position[1];
      this.pMobile.scale.x = k;
      this.pMobile.scale.y = 1;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx) {
      _superPropGet$n(HorizontalMultivecTrack2, "zoomed", this)([newXScale, newYScale]);
      this.pMain.position.x = tx;
      this.pMain.position.y = this.position[1];
      this.pMain.scale.x = k;
      this.pMain.scale.y = 1;
      this.drawColorbar();
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        this.xTiles = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], this._xScale, this.tilesetInfo.min_pos[0], null, this.tilesetInfo.tile_size);
      } else {
        this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      }
      const tiles = this.xTiles.map((x) => [this.zoomLevel, x]);
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      if (!this.tilesetInfo) return void 0;
      const minX = this.tilesetInfo.min_pos[0];
      let zoomIndexX = null;
      if (this.tilesetInfo.resolutions) {
        zoomIndexX = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, minX);
      } else {
        zoomIndexX = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      }
      return zoomIndexX;
    }
    /**
     * Create the local tile identifier, which be used with the
     * tile stores in TiledPixiTrack
     *
     * @param {array} tile: [zoomLevel, xPos]
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return tile.join(".");
    }
    /**
     * Create the remote tile identifier, which will be used to identify the
     * tile on the server
     *
     * @param {array} tile: [zoomLevel, xPos]
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return tile.join(".");
    }
    /**
     * Calculate the tile position at the given track position
     *
     * @param {Number} trackX: The track's X position
     * @param {Number} trackY: The track's Y position
     *
     * @return {array} [zoomLevel, tilePos]
     */
  }, {
    key: "getTilePosAtPosition",
    value: function getTilePosAtPosition(trackX, trackY) {
      if (!this.tilesetInfo) return void 0;
      const zoomLevel = this.calculateZoomLevel();
      const tileWidth = api.calculateTileWidth(this.tilesetInfo, zoomLevel, this.tilesetInfo.tile_size);
      const tilePos = this._xScale.invert(trackX) / tileWidth;
      return [zoomLevel, Math.floor(tilePos)];
    }
    /**
     * Return the data currently visible at position X and Y
     *
     * @param {Number} trackX: The x position relative to the track's start and end
     * @param {Number} trakcY: The y position relative to the track's start and end
     */
  }, {
    key: "getVisibleData",
    value: function getVisibleData(trackX, trackY) {
      const zoomLevel = this.calculateZoomLevel();
      const tileWidth = api.calculateTileWidth(this.tilesetInfo, zoomLevel, this.tilesetInfo.tile_size);
      const tilePos = this._xScale.invert(trackX) / tileWidth;
      let numRows = this.tilesetInfo.shape ? this.tilesetInfo.shape[1] : 1;
      if (this.options.selectRows) {
        numRows = selectedItemsToSize(this.options.selectRows, this.options.selectRowsAggregationWithRelativeHeight);
      }
      let posInTileX = this.tilesetInfo.tile_size * (tilePos - Math.floor(tilePos));
      const posInTileYNormalized = trackY / this.dimensions[1];
      const posInTileY = posInTileYNormalized * numRows;
      let selectedRowIndex = Math.floor(posInTileY);
      let selectedRowItem;
      if (this.options.selectRows) {
        if (this.options.selectRowsAggregationWithRelativeHeight) {
          selectedRowIndex = this.selectRowsCumWeights.findIndex((weight, i) => posInTileYNormalized <= weight && (i === this.selectRowsCumWeights.length - 1 || this.selectRowsCumWeights[i + 1] >= posInTileYNormalized));
        }
        selectedRowItem = this.options.selectRows[selectedRowIndex];
      }
      const tileId = this.tileToLocalId([zoomLevel, Math.floor(tilePos)]);
      const fetchedTile = this.fetchedTiles[tileId];
      let value = "";
      if (fetchedTile) {
        if (!this.tilesetInfo.shape) {
          posInTileX = fetchedTile.tileData.dense.length * (tilePos - Math.floor(tilePos));
        }
        let index2 = null;
        if (this.tilesetInfo.shape) {
          if (Array.isArray(selectedRowItem) && this.options.selectRowsAggregationMethod === "client") {
            index2 = selectedRowItem.map((rowI) => this.tilesetInfo.shape[0] * rowI + Math.floor(posInTileX));
          } else if (selectedRowItem && this.options.selectRowsAggregationMethod === "client") {
            index2 = this.tilesetInfo.shape[0] * selectedRowItem + Math.floor(posInTileX);
          } else {
            index2 = this.tilesetInfo.shape[0] * selectedRowIndex + Math.floor(posInTileX);
          }
        } else {
          index2 = fetchedTile.tileData.dense.length * selectedRowIndex + Math.floor(posInTileX);
        }
        if (Array.isArray(index2)) {
          const aggFunc = getAggregationFunction(this.options.selectRowsAggregationMode);
          const values = index2.map((i) => fetchedTile.tileData.dense[i]);
          value = format$1(".3f")(aggFunc(values));
          value += "<br/>";
          value += `${index2.length}-item ${this.options.selectRowsAggregationMode}`;
        } else {
          value = format$1(".3f")(fetchedTile.tileData.dense[index2]);
          if (Array.isArray(selectedRowItem)) {
            value += "<br/>";
            value += `${selectedRowItem.length}-item ${this.options.selectRowsAggregationMode}`;
          }
        }
      }
      if (this.tilesetInfo.row_infos) {
        value += "<br/>";
        let rowInfo = "";
        if (this.options.selectRows && !Array.isArray(selectedRowItem)) {
          rowInfo = this.tilesetInfo.row_infos[selectedRowItem];
        } else if (selectedRowIndex >= 0 && selectedRowIndex < this.tilesetInfo.row_infos.length) {
          rowInfo = this.tilesetInfo.row_infos[selectedRowIndex];
        }
        if (typeof rowInfo === "object") {
          value += Object.values(rowInfo).join("	");
        } else {
          value += rowInfo;
        }
      }
      return `${value}`;
    }
    /**
     * Get some information to display when the mouse is over this
     * track
     *
     * @param {Number} trackX: the x position of the mouse over the track
     * @param {Number} trackY: the y position of the mouse over the track
     *
     * @return {string}: A HTML string containing the information to display
     *
     */
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY) {
      if (!this.tilesetInfo) return "";
      const tilePos = this.getTilePosAtPosition(trackX, trackY);
      let output = "";
      if (this.options?.heatmapValueScaling && this.options.heatmapValueScaling === "categorical" && this.options.colorRange) {
        const visibleData = this.getVisibleData(trackX, trackY);
        const elements = visibleData.split("<br/>");
        const color2 = this.options.colorRange[Number.parseInt(elements[0], 10) - 1];
        const label = elements[1];
        if (Number.isNaN(color2) || color2 === "NaN" || typeof color2 === "undefined" || color2 === "undefined") return "";
        output = `<svg width="10" height="10" style="position:relative;bottom:1px"><rect width="10" height="10" rx="2" ry="2"
                 style="fill:${color2};stroke:black;stroke-width:2;"></svg> ${label}`;
      } else {
        output += `Data value: ${this.getVisibleData(trackX, trackY)}</br>`;
        output += `Zoom level: ${tilePos[0]} tile position: ${tilePos[1]}`;
      }
      return output;
    }
  }]);
})(HeatmapTiledPixiTrack);
function _classCallCheck$B(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$B(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$B(o.key), o);
  }
}
function _createClass$B(e, r2, t) {
  return r2 && _defineProperties$B(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$B(t) {
  var i = _toPrimitive$B(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$B(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$A(t, o, e) {
  return o = _getPrototypeOf$A(o), _possibleConstructorReturn$A(t, _isNativeReflectConstruct$A() ? Reflect.construct(o, e || [], _getPrototypeOf$A(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$A(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$A(t);
}
function _assertThisInitialized$A(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$A() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$A = function() {
    return !!t;
  })();
}
function _superPropGet$m(t, o, e, r2) {
  var p = _get$m(_getPrototypeOf$A(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$m() {
  return _get$m = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$m(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$m.apply(null, arguments);
}
function _superPropBase$m(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$A(t)); ) ;
  return t;
}
function _getPrototypeOf$A(t) {
  return _getPrototypeOf$A = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$A(t);
}
function _inherits$A(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$A(t, e);
}
function _setPrototypeOf$A(t, e) {
  return _setPrototypeOf$A = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$A(t, e);
}
let HorizontalPoint1DPixiTrack = /* @__PURE__ */ (function(_HorizontalLine1DPixi) {
  function HorizontalPoint1DPixiTrack2() {
    _classCallCheck$B(this, HorizontalPoint1DPixiTrack2);
    return _callSuper$A(this, HorizontalPoint1DPixiTrack2, arguments);
  }
  _inherits$A(HorizontalPoint1DPixiTrack2, _HorizontalLine1DPixi);
  return _createClass$B(HorizontalPoint1DPixiTrack2, [{
    key: "initTile",
    value: (
      /**
       * Create whatever is needed to draw this tile.
       */
      function initTile(tile) {
        tile.barXValues = new Array(tile.tileData.dense.length);
        tile.barYValues = new Array(tile.tileData.dense.length);
        tile.barWidths = new Array(tile.tileData.dense.length);
        tile.barHeights = new Array(tile.tileData.dense.length);
        _superPropGet$m(HorizontalPoint1DPixiTrack2, "initTile", this)([tile]);
      }
    )
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      if (!tile.tileData || !tile.tileData.dense) {
        return;
      }
      const graphics = tile.graphics;
      const {
        tileX,
        tileWidth
      } = this.getTilePosAndDimensions(tile.tileData.zoomLevel, tile.tileData.tilePos);
      const tileValues = tile.tileData.dense;
      if (tileValues.length === 0) {
        return;
      }
      let pseudocount = 0;
      this.valueScale = null;
      if (this.options.valueScaling === "log") {
        let offsetValue = this.medianVisibleValue;
        if (!this.medianVisibleValue) {
          offsetValue = this.minValue();
        }
        this.valueScale = log$2().domain([offsetValue, this.maxValue() + offsetValue]).range([this.dimensions[1], 0]);
        pseudocount = offsetValue;
      } else {
        this.valueScale = linear().domain([this.minValue(), this.maxValue()]).range([this.dimensions[1], 0]);
      }
      graphics.clear();
      this.drawAxis(this.valueScale);
      if (this.options.valueScaling === "log" && this.valueScale.domain()[1] < 0) {
        console.warn("Negative values present when using a log scale", this.valueScale.domain());
        return;
      }
      const stroke = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      const tileXScale = linear().domain([0, this.tilesetInfo.tile_size]).range([tileX, tileX + tileWidth]);
      const strokeWidth = 0;
      graphics.lineStyle(strokeWidth, stroke, 1);
      const squareSide = this.options.pointSize ? this.options.pointSize : 3;
      const pointColor = colorToHex(this.options.pointColor ? this.options.pointColor : "red");
      graphics.beginFill(pointColor, 1);
      tile.drawnAtScale = this._xScale.copy();
      for (let i = 0; i < tileValues.length; i++) {
        const xPos = this._xScale(tileXScale(i));
        const yPos = this.valueScale(tileValues[i] + pseudocount);
        tile.barXValues[i] = xPos - squareSide / 2 / this.pMain.scale.x;
        tile.barYValues[i] = yPos - squareSide / 2 / this.pMain.scale.y;
        tile.barWidths[i] = squareSide / this.pMain.scale.x;
        tile.barHeights[i] = squareSide / this.pMain.scale.y;
        if (tileXScale(i) > this.tilesetInfo.max_pos[0]) {
          break;
        }
        graphics.drawRect(xPos - squareSide / 2 / this.pMain.scale.x, yPos - squareSide / 2 / this.pMain.scale.y, squareSide / this.pMain.scale.x, squareSide / this.pMain.scale.y);
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      _superPropGet$m(HorizontalPoint1DPixiTrack2, "draw", this)([]);
      for (const tile of dictValues(this.fetchedTiles)) {
        const tileK = (tile.drawnAtScale.domain()[1] - tile.drawnAtScale.domain()[0]) / (this._xScale.domain()[1] - this._xScale.domain()[0]);
        const newRange = this._xScale.domain().map(tile.drawnAtScale);
        const posOffset = newRange[0];
        tile.graphics.scale.x = tileK;
        tile.graphics.position.x = -posOffset * tileK;
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _superPropGet$m(HorizontalPoint1DPixiTrack2, "zoomed", this)([newXScale, newYScale]);
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      [base, track] = _superPropGet$m(HorizontalPoint1DPixiTrack2, "superSVG", this)([]);
      base.setAttribute("class", "exported-line-track");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      for (const tile of this.visibleAndFetchedTiles()) {
        for (let i = 0; i < tile.barXValues.length; i++) {
          const rect2 = document.createElement("rect");
          const strokeColor = this.options.lineStrokeColor || "blue";
          const pointColor = this.options.pointColor || "red";
          rect2.setAttribute("fill", pointColor);
          rect2.setAttribute("stroke", strokeColor);
          rect2.setAttribute("stroke-width", 0);
          rect2.setAttribute("x", tile.barXValues[i]);
          rect2.setAttribute("y", tile.barYValues[i]);
          rect2.setAttribute("height", tile.barHeights[i]);
          rect2.setAttribute("width", tile.barWidths[i]);
          output.appendChild(rect2);
        }
      }
      const gAxis = document.createElement("g");
      gAxis.setAttribute("id", "axis");
      base.appendChild(gAxis);
      gAxis.setAttribute("transform", `translate(${this.axis.pAxis.position.x}, ${this.axis.pAxis.position.y})`);
      if (this.options.axisPositionHorizontal === "left" || this.options.axisPositionVertical === "top") {
        const gDrawnAxis = this.axis.exportAxisLeftSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      } else if (this.options.axisPositionHorizontal === "right" || this.options.axisPositionVertical === "bottom") {
        const gDrawnAxis = this.axis.exportAxisRightSVG(this.valueScale, this.dimensions[1]);
        gAxis.appendChild(gDrawnAxis);
      }
      return [base, track];
    }
  }]);
})(HorizontalLine1DPixiTrack);
var areaPolygon;
var hasRequiredAreaPolygon;
function requireAreaPolygon() {
  if (hasRequiredAreaPolygon) return areaPolygon;
  hasRequiredAreaPolygon = 1;
  areaPolygon = function(points, signed) {
    var l = points.length;
    var det = 0;
    var isSigned = signed || false;
    points = points.map(normalize2);
    if (points[0] != points[points.length - 1]) points = points.concat(points[0]);
    for (var i = 0; i < l; i++) det += points[i].x * points[i + 1].y - points[i].y * points[i + 1].x;
    if (isSigned) return det / 2;
    else return Math.abs(det) / 2;
  };
  function normalize2(point2) {
    if (Array.isArray(point2)) return {
      x: point2[0],
      y: point2[1]
    };
    else return point2;
  }
  return areaPolygon;
}
var areaPolygonExports = requireAreaPolygon();
const polygonArea = /* @__PURE__ */ getDefaultExportFromCjs(areaPolygonExports);
function _classCallCheck$A(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$A(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$A(o.key), o);
  }
}
function _createClass$A(e, r2, t) {
  return r2 && _defineProperties$A(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$A(t) {
  var i = _toPrimitive$A(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$A(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$z(t, o, e) {
  return o = _getPrototypeOf$z(o), _possibleConstructorReturn$z(t, _isNativeReflectConstruct$z() ? Reflect.construct(o, e || [], _getPrototypeOf$z(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$z(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$z(t);
}
function _assertThisInitialized$z(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$z() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$z = function() {
    return !!t;
  })();
}
function _superPropGet$l(t, o, e, r2) {
  var p = _get$l(_getPrototypeOf$z(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$l() {
  return _get$l = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$l(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$l.apply(null, arguments);
}
function _superPropBase$l(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$z(t)); ) ;
  return t;
}
function _getPrototypeOf$z(t) {
  return _getPrototypeOf$z = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$z(t);
}
function _inherits$z(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$z(t, e);
}
function _setPrototypeOf$z(t, e) {
  return _setPrototypeOf$z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$z(t, e);
}
const rectsAtPoint = (track, x, y) => {
  const drawnRects = Object.values(track.drawnRects);
  const point2 = [x, y];
  const payloads = [];
  const g = track.rectGraphics;
  for (const drawnRect of drawnRects) {
    const rect2 = drawnRect[0].slice(0);
    const poly = polyToPoly(rect2, g.scale.x, g.position.x, g.scale.y, g.position.y);
    const area2 = polygonArea(poly);
    if (classifyPoint(poly, point2) === -1) {
      const payload = drawnRect[1];
      payload.area = area2;
      payloads.push(payload);
    }
  }
  return payloads;
};
let Annotations1dTrack = /* @__PURE__ */ (function(_BedLikeTrack) {
  function Annotations1dTrack2(context, options2, isVertical) {
    _classCallCheck$A(this, Annotations1dTrack2);
    return _callSuper$z(this, Annotations1dTrack2, [context, options2]);
  }
  _inherits$z(Annotations1dTrack2, _BedLikeTrack);
  return _createClass$A(Annotations1dTrack2, [{
    key: "rerender",
    value: function rerender(options2, force) {
      if (options2 && options2.projectUid !== this.options.projectUid) {
        this.options = options2;
        this.fetchedTiles = {};
        this.refreshTiles();
        return;
      }
      _superPropGet$l(Annotations1dTrack2, "rerender", this)([options2, force]);
    }
    /*
     * The local tile identifier
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return this.tileToRemoteId(tile);
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      let tileId = `${tile.join(".")}`;
      if (this.options.projectUid) {
        tileId = `${tileId}.ui=${this.options.projectUid}`;
      }
      return tileId;
    }
    /**
     * @param  {x} x position of the evt relative to the track
     * @param  {y} y position of the evt relative to the track
     */
  }, {
    key: "click",
    value: function click(x, y) {
      const rects = rectsAtPoint(this, x, y);
      if (!rects.length) {
        this.selectRect(null);
      } else {
        this.selectRect(rects[0].value.uid);
      }
      return {
        type: "1d-annotations",
        event: null,
        payload: rects
      };
    }
  }, {
    key: "render",
    value: function render3() {
      _superPropGet$l(Annotations1dTrack2, "render", this)([]);
    }
  }]);
})(BedLikeTrack);
function _classCallCheck$z(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$z(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$z(o.key), o);
  }
}
function _createClass$z(e, r2, t) {
  return r2 && _defineProperties$z(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$z(t) {
  var i = _toPrimitive$z(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$z(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$y(t, o, e) {
  return o = _getPrototypeOf$y(o), _possibleConstructorReturn$y(t, _isNativeReflectConstruct$y() ? Reflect.construct(o, e || [], _getPrototypeOf$y(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$y(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$y(t);
}
function _assertThisInitialized$y(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$y() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$y = function() {
    return !!t;
  })();
}
function _superPropGet$k(t, o, e, r2) {
  var p = _get$k(_getPrototypeOf$y(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$k() {
  return _get$k = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$k(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$k.apply(null, arguments);
}
function _superPropBase$k(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$y(t)); ) ;
  return t;
}
function _getPrototypeOf$y(t) {
  return _getPrototypeOf$y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$y(t);
}
function _inherits$y(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$y(t, e);
}
function _setPrototypeOf$y(t, e) {
  return _setPrototypeOf$y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$y(t, e);
}
const MOUSE_CLICK_TIME = 250;
let Annotations2dTrack = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function Annotations2dTrack2(context, options2) {
    var _this;
    _classCallCheck$z(this, Annotations2dTrack2);
    _this = _callSuper$y(this, Annotations2dTrack2, [context, options2]);
    const {
      pubSub
    } = context;
    _this.drawnAnnotations = {};
    _this.drawnAnnoGfx = {};
    _this.selectedAnno = null;
    _this.options.minSquareSize = +_this.options.minSquareSize;
    const {
      publish,
      subscribe,
      unsubscribe
    } = createPubSub();
    _this.publish = publish;
    _this.subscribe = subscribe;
    _this.unsubscribe = unsubscribe;
    _this.sT = 0;
    _this.annoSelectedBound = _this.annoSelected.bind(_this);
    _this.pubSubs.push(pubSub.subscribe("annoSelected", _this.annoSelectedBound));
    return _this;
  }
  _inherits$y(Annotations2dTrack2, _TiledPixiTrack);
  return _createClass$z(Annotations2dTrack2, [{
    key: "minX",
    get: function() {
      return this.tilesetInfo?.min_pos ? this.tilesetInfo.min_pos[0] : 0;
    }
  }, {
    key: "maxX",
    get: function() {
      return this.tilesetInfo?.max_pos ? this.tilesetInfo.max_pos[0] : this.tilesetInfo.max_width || this.tilesetInfo.max_size;
    }
  }, {
    key: "minY",
    get: function() {
      return this.minX;
    }
  }, {
    key: "maxY",
    get: function() {
      return this.maxX;
    }
  }, {
    key: "maxSize",
    get: function() {
      const maxSize = this.tilesetInfo.max_pos && Math.max(this.tilesetInfo.max_pos[0] - this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[1] - this.tilesetInfo.min_pos[1]);
      if (maxSize) return maxSize;
      if (this.tilesetInfo.max_size) return this.tilesetInfo.max_size;
      return 0;
    }
    /**
     * Point projection from the data to the view (pixel) coordinates
     * @param   {number}  x  Data X coordinate
     * @param   {number}  y  Data Y coordinate
     * @return  {array}  Tuple [x,y] containing the translated view coordinates.
     */
  }, {
    key: "projection",
    value: function projection2([x, y]) {
      return [this._xScale(x), this._yScale(y)];
    }
    /**
     * The local tile identifier
     *
     * @param  {Array}  tile  Array containing [zoomLevel, xPos, yPos]
     * @return  {String}  Joined ID string
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
    /**
     * The tile identifier used on the server
     *
     * @param  {Array}  tile  Array containing [zoomLevel, xPos, yPos]
     * @return  {String}  Joined ID string
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.minX, this.maxX);
      const yZoomLevel = api.calculateZoomLevel(this._yScale, this.minY, this.maxY);
      return min$2(max$2(xZoomLevel, yZoomLevel), this.maxZoom);
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) return;
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.minX, this.maxX, this.tilesetInfo.max_zoom, this.maxSize);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.minY, this.maxY, this.tilesetInfo.max_zoom, this.maxSize);
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < this.xTiles.length; i++) {
        for (let j = 0; j < this.yTiles.length; j++) {
          tiles.push([zoomLevel, this.xTiles[i], this.yTiles[j]]);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.drawnAnnotations = {};
      _superPropGet$k(Annotations2dTrack2, "draw", this, 3)([]);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile, force = false, silent = false) {
      if (!tile.graphics) return;
      tile.graphics.__tile__ = tile;
      const graphics = tile.graphics;
      graphics.clear();
      this.setBorderStyle(graphics);
      this.setFill(graphics);
      graphics.alpha = +this.options.rectangleDomainOpacity;
      if (!tile.tileData.length) return;
      tile.tileData.filter((td) => !(td.uid in this.drawnAnnotations) || force).forEach((td) => {
        const [startX, startY] = this.projection([td.xStart, td.yStart]);
        const [endX, endY] = this.projection([td.xEnd, td.yEnd]);
        if (this.options.exclude && this.options.exclude.indexOf(td.uid) >= 0) {
          return;
        }
        this.drawAnnotation(this.prepAnnotation(graphics, td.uid, startX, startY, endX - startX, endY - startY, td), silent);
      });
    }
  }, {
    key: "prepAnnotation",
    value: function prepAnnotation(graphics, uid, startX, startY, width, height, td) {
      let info;
      try {
        info = JSON.parse(td.fields);
      } catch (e) {
      }
      return {
        graphics,
        id: td.id,
        uid,
        annotation: {
          x: startX,
          y: startY,
          width,
          height
        },
        dataPos: [td.xStart, td.xEnd, td.yStart, td.yEnd],
        importance: td.importance,
        info
      };
    }
  }, {
    key: "drawAnnotation",
    value: function drawAnnotation2({
      graphics,
      id: id2,
      uid,
      annotation,
      dataPos,
      importance,
      info
    }, silent) {
      if (this.options.minSquareSize) {
        if (annotation.width < this.options.minSquareSize || annotation.height < this.options.minSquareSize) {
          annotation.x = (annotation.x + annotation.width) / 2;
          annotation.y = (annotation.y + annotation.height) / 2;
          annotation.width = this.options.minSquareSize;
          annotation.height = this.options.minSquareSize;
        }
      }
      this.drawnAnnotations[uid] = annotation;
      const viewPos = [annotation.x, annotation.y, annotation.width, annotation.height];
      let rectGfx = this.drawnAnnoGfx[uid];
      if (!rectGfx) {
        rectGfx = new GLOBALS.PIXI.Graphics();
        this.drawnAnnoGfx[uid] = rectGfx;
      }
      if (graphics.children.indexOf(rectGfx) === -1) {
        graphics.addChild(rectGfx);
      }
      this._drawRect(rectGfx, viewPos, uid);
      graphics.interactive = true;
      rectGfx.interactive = true;
      rectGfx.buttonMode = true;
      const payload = {
        id: id2,
        uid,
        dataPos,
        importance,
        info,
        viewPos: [
          annotation.x,
          annotation.y,
          // To have the same format as `dataPos`, i.e.:
          // a quadruple of [x0, y0, x1, y1]
          annotation.x + annotation.width,
          annotation.y + annotation.height
        ]
      };
      rectGfx.mouseover = () => this.hover(rectGfx, viewPos, uid);
      rectGfx.mouseout = () => this.blur(rectGfx, viewPos, uid);
      rectGfx.mousedown = () => this.mouseDown();
      rectGfx.mouseup = (event) => this.mouseUp(rectGfx, viewPos, uid, event, payload);
      if (!silent) {
        this.publish("annotationDrawn", {
          trackUuids: this.uuid,
          annotationUuid: uid,
          annotationId: id2,
          viewPos,
          dataPos,
          importance,
          info
        });
      }
    }
  }, {
    key: "_drawRect",
    value: function _drawRect(graphics, viewPos, uid) {
      let stroke = this.options.rectangleDomainStrokeColor;
      let strokeWidth = this.options.rectangleDomainStrokeWidth;
      let strokeAlpha = this.options.rectangleDomainStrokeOpacity;
      let fill = this.options.rectangleDomainFillColor;
      let fillAlpha = this.options.rectangleDomainFillOpacity;
      if (this.hoveredAnno === uid) {
        stroke = this.options.hoverColor;
        strokeWidth = this.options.rectangleDomainStrokeWidth + 1 || 2;
        strokeAlpha = 1;
        fill = this.options.hoverColor;
        fillAlpha = this.options.rectangleDomainFillOpacity;
      }
      if (this.selectedAnno && this.selectedAnno.uid === uid) {
        stroke = this.options.selectColor;
        strokeWidth = this.options.rectangleDomainStrokeWidth + 1 || 2;
        strokeAlpha = 1;
        fill = this.options.selectColor;
        fillAlpha = max$2(0.33, this.options.rectangleDomainFillOpacity);
      }
      graphics.clear();
      if (this.options.trackBorderBgWidth) {
        this.setBorderStyle(graphics, this.options.trackBorderBgColor, this.options.trackBorderBgWidth, this.options.trackBorderBgAlpha);
        this.setFill(graphics, fill, 0);
        graphics.drawRect(...viewPos);
      }
      this.setBorderStyle(graphics, stroke, strokeWidth, strokeAlpha);
      this.setFill(graphics, fill, fillAlpha);
      graphics.drawRect(...viewPos);
      graphics.__viewPos__ = viewPos;
    }
  }, {
    key: "context",
    value: function context(graphics, viewPos, uid) {
      return (proc) => proc(graphics, viewPos, uid);
    }
  }, {
    key: "click",
    value: function click(graphics, viewPos, uid, event, payload) {
      this.select(graphics, viewPos, uid);
      this.pubSub.publish("app.click", {
        type: "annotation",
        event,
        payload
      });
    }
  }, {
    key: "mouseDown",
    value: function mouseDown() {
      this.sT = performance.now();
    }
  }, {
    key: "mouseUp",
    value: function mouseUp(graphics, viewPos, uid, event, payload) {
      if (performance.now() - this.sT <= MOUSE_CLICK_TIME) {
        this.click(graphics, viewPos, uid, event, payload);
      }
    }
  }, {
    key: "hover",
    value: function hover2(graphics, viewPos, uid) {
      this.hoveredAnno = uid;
      this._drawRect(graphics, viewPos, uid);
      this.animate();
    }
  }, {
    key: "focus",
    value: function focus(graphics, viewPos, uid) {
      this._drawRect(graphics, viewPos, uid);
      this.animate();
    }
  }, {
    key: "blur",
    value: function blur(graphics, viewPos, uid) {
      this.hoveredAnno = null;
      this._drawRect(graphics, viewPos, uid);
      this.animate();
    }
  }, {
    key: "select",
    value: function select2(graphics, viewPos, uid, silent = false) {
      let prevGfx = null;
      let prevUid = null;
      if (this.selectedAnno) {
        prevGfx = this.selectedAnno.graphics;
        prevUid = this.selectedAnno.uid;
      }
      this.selectedAnno = {
        graphics,
        uid
      };
      this.focus(graphics, viewPos, uid);
      if (this.options.onSelect && !silent) {
        window[this.options.onSelect](uid);
        this.pubSub.publish("annoSelected", uid);
      }
      if (prevGfx && prevUid) {
        this.blur(prevGfx, prevGfx.__viewPos__, prevUid);
      }
    }
  }, {
    key: "unselect",
    value: function unselect() {
      const gfx = this.selectedAnno.graphics;
      const uid = this.selectedAnno.uid;
      this.selectedAnno = null;
      this.blur(gfx, gfx.__viewPos__, uid);
    }
  }, {
    key: "annoSelected",
    value: function annoSelected(uid) {
      if (!this.selectedAnno || this.selectedAnno.uid !== uid) {
        if (this.selectedAnno) this.unselect();
        const gfx = this.drawnAnnoGfx[uid];
        if (gfx) this.select(gfx, gfx.__viewPos__, uid, true);
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$k(Annotations2dTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$k(Annotations2dTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      this.visibleAndFetchedTiles().filter((tile) => tile.tileData?.length).map((tile) => ({
        graphics: tile.graphics,
        td: tile.tileData
      })).forEach(({
        td,
        graphics
      }) => {
        const gTile = document.createElement("g");
        gTile.setAttribute("transform", `translate(${graphics.position.x},${graphics.position.y})scale(${graphics.scale.x},${graphics.scale.y})`);
        output.appendChild(gTile);
        if (td.uid in this.drawnAnnotations) {
          const rect2 = this.drawnAnnotations[td.uid];
          const r2 = document.createElement("rect");
          r2.setAttribute("x", rect2.x);
          r2.setAttribute("y", rect2.y);
          r2.setAttribute("width", rect2.width);
          r2.setAttribute("height", rect2.height);
          r2.setAttribute("fill", this.options.fillColor || "grey");
          r2.setAttribute("opacity", 0.3);
          r2.style.stroke = this.options.fillColor || "grey";
          r2.style.strokeWidth = "1px";
          gTile.appendChild(r2);
        }
      });
      return [base, base];
    }
  }, {
    key: "setBorderStyle",
    value: function setBorderStyle(graphics, color2 = this.options.rectangleDomainStrokeColor, width = this.options.rectangleDomainStrokeWidth, alpha2 = this.options.rectangleDomainStrokeOpacity) {
      graphics.lineStyle(typeof width !== "undefined" ? width : 1, colorToHex(color2 || "black"), typeof alpha2 !== "undefined" ? alpha2 : 1);
    }
  }, {
    key: "setFill",
    value: function setFill(graphics, color2 = this.options.rectangleDomainFillColor, alpha2 = this.options.rectangleDomainFillOpacity) {
      graphics.beginFill(colorToHex(color2 || "grey"), typeof alpha2 !== "undefined" ? alpha2 : 0.4);
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$k(Annotations2dTrack2, "setPosition", this, 3)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$y(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$y(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$y(o.key), o);
  }
}
function _createClass$y(e, r2, t) {
  return r2 && _defineProperties$y(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$y(t) {
  var i = _toPrimitive$y(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$y(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$x(t, o, e) {
  return o = _getPrototypeOf$x(o), _possibleConstructorReturn$x(t, _isNativeReflectConstruct$x() ? Reflect.construct(o, e || [], _getPrototypeOf$x(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$x(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$x(t);
}
function _assertThisInitialized$x(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$x() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$x = function() {
    return !!t;
  })();
}
function _superPropGet$j(t, o, e, r2) {
  var p = _get$j(_getPrototypeOf$x(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$j() {
  return _get$j = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$j(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$j.apply(null, arguments);
}
function _superPropBase$j(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$x(t)); ) ;
  return t;
}
function _getPrototypeOf$x(t) {
  return _getPrototypeOf$x = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$x(t);
}
function _inherits$x(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$x(t, e);
}
function _setPrototypeOf$x(t, e) {
  return _setPrototypeOf$x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$x(t, e);
}
function drawAnnotation(track, graphics, td, minSquareSize, xMin, xMax, yMin, yMax, minThres, flipDiagonal) {
  const startX = flipDiagonal ? track._xScale(td.yStart) : track._xScale(td.xStart);
  const endX = flipDiagonal ? track._xScale(td.yEnd) : track._xScale(td.xEnd);
  const startY = flipDiagonal ? track._yScale(td.xStart) : track._yScale(td.yStart);
  const endY = flipDiagonal ? track._yScale(td.xEnd) : track._yScale(td.yEnd);
  const uid = td.uid + flipDiagonal;
  const width = endX - startX;
  const height = endY - startY;
  let drawnRect = {
    x: startX,
    y: startY,
    width,
    height
  };
  if (minSquareSize) {
    if (width < minSquareSize || height < minSquareSize) {
      drawnRect = {
        x: startX - minSquareSize / 2,
        y: startY - minSquareSize / 2,
        width: minSquareSize,
        height: minSquareSize
      };
    }
  }
  track.drawnRects[uid] = drawnRect;
  const dRxMax = drawnRect.x + drawnRect.width;
  const dRyMax = drawnRect.y + drawnRect.height;
  if (drawnRect.x > xMin && drawnRect.x < xMax || dRxMax > xMin && dRxMax < xMax || drawnRect.y > yMin && drawnRect.y < yMax || dRyMax > yMin && dRyMax < yMax) {
    if (drawnRect.width > minThres || drawnRect.height > minThres) {
      graphics.drawRect(drawnRect.x, drawnRect.y, drawnRect.width, drawnRect.height);
      track.publish("annotationDrawn", {
        trackUuid: track.uuid,
        annotationUuid: uid,
        viewPos: [drawnRect.x, drawnRect.y, drawnRect.width, drawnRect.height],
        dataPos: [td.xStart, td.xEnd, td.yStart, td.yEnd],
        importance: td.importance,
        info: {
          patternType: track.options.patternType
        }
      });
    }
  }
}
let ArrowheadDomainsTrack = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function ArrowheadDomainsTrack2(...args) {
    var _this;
    _classCallCheck$y(this, ArrowheadDomainsTrack2);
    _this = _callSuper$x(this, ArrowheadDomainsTrack2, [...args]);
    _this.drawnRects = {};
    const {
      publish,
      subscribe,
      unsubscribe
    } = createPubSub();
    _this.publish = publish;
    _this.subscribe = subscribe;
    _this.unsubscribe = unsubscribe;
    return _this;
  }
  _inherits$x(ArrowheadDomainsTrack2, _TiledPixiTrack);
  return _createClass$y(ArrowheadDomainsTrack2, [{
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
      let zoomLevel = Math.max(xZoomLevel, yZoomLevel);
      zoomLevel = Math.min(zoomLevel, this.maxZoom);
      return zoomLevel;
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.remoteId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          const newTile = [zoomLevel, rows[i], cols[j]];
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
    /**
     * Create whatever is needed to draw this tile.
     */
  }, {
    key: "initTile",
    value: function initTile() {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile() {
    }
  }, {
    key: "draw",
    value: function draw() {
      this.drawnRects = {};
      _superPropGet$j(ArrowheadDomainsTrack2, "draw", this, 3)([]);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      const graphics = tile.graphics;
      if (!graphics) {
        return;
      }
      graphics.clear();
      const stroke = colorToHex(this.options.rectangleDomainStrokeColor || "black");
      const fill = colorToHex(this.options.rectangleDomainFillColor || "grey");
      graphics.lineStyle(typeof this.options.rectangleDomainStrokeWidth !== "undefined" ? this.options.rectangleDomainStrokeWidth : 1, stroke, typeof this.options.rectangleDomainStrokeOpacity !== "undefined" ? this.options.rectangleDomainStrokeOpacity : 1);
      graphics.beginFill(fill, typeof this.options.rectangleDomainFillOpacity !== "undefined" ? this.options.rectangleDomainFillOpacity : 0.4);
      graphics.alpha = this.options.rectangleDomainOpacity || 0.5;
      const minSquareSize = this.options.minSquareSize && this.options.minSquareSize !== "none" ? +this.options.minSquareSize : 0;
      const minThres = this.options.rectangleMinSize ? +this.options.rectangleMinSize : 0;
      const xMin = this._xScale.range()[0];
      const xMax = this._xScale.range()[1];
      const yMin = this._yScale.range()[0];
      const yMax = this._yScale.range()[1];
      if (!tile.tileData.length) return;
      tile.tileData.filter((td) => !(td.uid in this.drawnRects)).forEach((td) => {
        drawAnnotation(this, graphics, td, minSquareSize, xMin, xMax, yMin, yMax, minThres, this.options.flipDiagonal === "yes");
        if (this.options.flipDiagonal && this.options.flipDiagonal === "copy") {
          drawAnnotation(this, graphics, td, minSquareSize, xMin, xMax, yMin, yMax, minThres, true);
        }
      });
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$j(ArrowheadDomainsTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$j(ArrowheadDomainsTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      for (const flipDiagonal of [true, false]) {
        for (const tile of this.visibleAndFetchedTiles()) {
          if (!tile.tileData || !tile.tileData.length) continue;
          tile.tileData.forEach((td) => {
            const uid = td.uid + flipDiagonal;
            const gTile = document.createElement("g");
            gTile.setAttribute("transform", `translate(${tile.graphics.position.x},${tile.graphics.position.y})scale(${tile.graphics.scale.x},${tile.graphics.scale.y})`);
            output.appendChild(gTile);
            if (uid in this.drawnRects) {
              const rect2 = this.drawnRects[uid];
              const r2 = document.createElement("rect");
              r2.setAttribute("x", rect2.x);
              r2.setAttribute("y", rect2.y);
              r2.setAttribute("width", rect2.width);
              r2.setAttribute("height", rect2.height);
              r2.setAttribute("fill", this.options.rectangleDomainFillColor ? this.options.rectangleDomainFillColor : "grey");
              r2.setAttribute("opacity", 0.3);
              r2.style.stroke = "black";
              r2.style.strokeWidth = "1px";
              gTile.appendChild(r2);
            }
          });
        }
      }
      return [base, base];
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$j(ArrowheadDomainsTrack2, "setPosition", this, 3)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      if (this.xScale().domain()[0] === newXScale.domain()[0] && this.xScale().domain()[1] === newXScale.domain()[1] && this.yScale().domain()[0] === newYScale.domain()[0] && this.yScale().domain()[1] === newYScale.domain()[1]) return;
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }, {
    key: "leftTrackDraw",
    value: function leftTrackDraw() {
      this.draw();
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$x(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$x(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$x(o.key), o);
  }
}
function _createClass$x(e, r2, t) {
  return r2 && _defineProperties$x(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$x(t) {
  var i = _toPrimitive$x(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$x(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$w(t, o, e) {
  return o = _getPrototypeOf$w(o), _possibleConstructorReturn$w(t, _isNativeReflectConstruct$w() ? Reflect.construct(o, e || [], _getPrototypeOf$w(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$w(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$w(t);
}
function _assertThisInitialized$w(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$w() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$w = function() {
    return !!t;
  })();
}
function _getPrototypeOf$w(t) {
  return _getPrototypeOf$w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$w(t);
}
function _inherits$w(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$w(t, e);
}
function _setPrototypeOf$w(t, e) {
  return _setPrototypeOf$w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$w(t, e);
}
let CNVIntervalTrack = /* @__PURE__ */ (function(_HorizontalTiled1DPix) {
  function CNVIntervalTrack2(context, options2) {
    var _this;
    _classCallCheck$x(this, CNVIntervalTrack2);
    _this = _callSuper$w(this, CNVIntervalTrack2, [context, options2]);
    _this.seen = /* @__PURE__ */ new Set();
    _this.pMain = _this.pMobile;
    _this.rows = [];
    return _this;
  }
  _inherits$w(CNVIntervalTrack2, _HorizontalTiled1DPix);
  return _createClass$x(CNVIntervalTrack2, [{
    key: "uid",
    value: function uid(item) {
      return item[item.length - 2];
    }
  }, {
    key: "segmentOverlap",
    value: function segmentOverlap(segment1, segment2) {
    }
  }, {
    key: "drawAll",
    value: function drawAll(allTileData) {
      this.pMain.clear();
      const seen = /* @__PURE__ */ new Set();
      const segments = allTileData.map((x) => {
        if (seen.has(this.uid(x))) {
          return null;
        }
        seen.add(this.uid(x));
        return {
          from: +x[1],
          to: +x[2],
          type: x[4],
          uid: this.uid(x)
        };
      }).filter((x) => x);
      const rows = segmentsToRows(segments);
      this.rows = rows;
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      const rows = this.rows;
      if (!rows) {
        return;
      }
      const valueScale = band().range([0, this.dimensions[1]]).padding(0.1).domain(range$4(0, this.maxRows()));
      const graphics = this.pMain;
      graphics.clear();
      graphics.lineStyle(1, 255, 0);
      graphics.beginFill(16740363, 0.8);
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < rows[i].length; j++) {
          const interval2 = rows[i][j];
          const x12 = this._refXScale(interval2.from);
          const x2 = this._refXScale(interval2.to);
          const y12 = valueScale(i);
          const y2 = y12 + valueScale.bandwidth();
          const width = x2 - x12;
          const height = y2 - y12;
          graphics.drawRect(x12, y12, width, height);
        }
      }
    }
  }, {
    key: "allTilesLoaded",
    value: function allTilesLoaded() {
      const visibleAndFetchedIds = this.visibleAndFetchedIds();
      const tileDatas = visibleAndFetchedIds.map((x) => this.fetchedTiles[x].tileData.discrete);
      const allTileData = [].concat(...tileDatas);
      this.drawAll(allTileData);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
    }
  }, {
    key: "maxRows",
    value: function maxRows() {
      return this.rows.length;
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.tileData.discrete.forEach((x) => {
        const uid = x[x.length - 2];
        if (this.seen.has(uid)) {
          this.seen.delete(uid);
        }
      });
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
    }
  }]);
})(HorizontalTiled1DPixiTrack);
function _classCallCheck$w(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$w(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$w(o.key), o);
  }
}
function _createClass$w(e, r2, t) {
  return r2 && _defineProperties$w(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$w(t) {
  var i = _toPrimitive$w(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$w(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$v(t, o, e) {
  return o = _getPrototypeOf$v(o), _possibleConstructorReturn$v(t, _isNativeReflectConstruct$v() ? Reflect.construct(o, e || [], _getPrototypeOf$v(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$v(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$v(t);
}
function _assertThisInitialized$v(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$v() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$v = function() {
    return !!t;
  })();
}
function _superPropGet$i(t, o, e, r2) {
  var p = _get$i(_getPrototypeOf$v(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$i() {
  return _get$i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$i(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$i.apply(null, arguments);
}
function _superPropBase$i(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$v(t)); ) ;
  return t;
}
function _getPrototypeOf$v(t) {
  return _getPrototypeOf$v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$v(t);
}
function _inherits$v(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$v(t, e);
}
function _setPrototypeOf$v(t, e) {
  return _setPrototypeOf$v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$v(t, e);
}
const FONT_SIZE = 11;
const FONT_FAMILY = "Arial";
const GENE_LABEL_POS = "outside";
const GENE_RECT_HEIGHT = 10;
const GENE_STRAND_SPACING = 4;
const MAX_TEXTS = 20;
const WHITE_HEX = colorToHex("#ffffff");
const EXON_LINE_HEIGHT = 2;
const EXON_HEIGHT = 2 * GENE_RECT_HEIGHT / 3;
const GENE_MINI_TRIANGLE_HEIGHT = 2 * EXON_HEIGHT / 3;
const MAX_GENE_ENTRIES = 50;
const MAX_FILLER_ENTRIES = 5e3;
const DEFAULT_PLUS_STRAND_COLOR = "blue";
const DEFAULT_MINUS_STRAND_COLOR = "red";
const geneClickFunc = (event, track, payload) => {
  if (payload.type === "filler") return;
  track.pubSub.publish("app.click", {
    type: "gene-annotation",
    event,
    payload
  });
};
const flagOverlappingFillers = (genes, fillers) => {
  const regions = genes.concat(fillers);
  const boxes = regions.map((x) => [x.xStart, 1, x.xEnd, 1]);
  boxIntersect(boxes, (i, j) => {
    let filler = null;
    let gene = null;
    if (regions[i].type === "filler") {
      filler = regions[i];
    } else {
      gene = regions[i];
    }
    if (regions[j].type === "filler") {
      if (filler) return;
      filler = regions[j];
    } else {
      if (!filler) return;
      gene = regions[j];
    }
    if (filler.xStart >= gene.xStart && filler.xEnd <= gene.xEnd) {
      filler.hide = true;
    }
  });
};
function externalInitTile(track, tile, options2) {
  const {
    flipText,
    fontSize,
    fontFamily,
    plusStrandColor,
    minusStrandColor,
    maxGeneEntries,
    maxFillerEntries,
    maxTexts
  } = options2;
  tile.texts = {};
  tile.rectGraphics = new GLOBALS.PIXI.Graphics();
  tile.textBgGraphics = new GLOBALS.PIXI.Graphics();
  tile.textGraphics = new GLOBALS.PIXI.Graphics();
  tile.rectMaskGraphics = new GLOBALS.PIXI.Graphics();
  tile.graphics.addChild(tile.rectGraphics);
  tile.graphics.addChild(tile.textBgGraphics);
  tile.graphics.addChild(tile.textGraphics);
  tile.graphics.addChild(tile.rectMaskGraphics);
  tile.rectGraphics.mask = tile.rectMaskGraphics;
  if (!tile.tileData.sort) return;
  tile.tileData.sort((a, b) => b.importance - a.importance);
  const geneEntries = tile.tileData.filter((td) => td.type !== "filler").slice(0, maxGeneEntries);
  const fillerEntries = tile.tileData.filter((td) => td.type === "filler").slice(0, maxFillerEntries);
  tile.tileData = geneEntries.concat(fillerEntries);
  tile.tileData.forEach((td, i) => {
    if (td.type === "filler") {
      return;
    }
    const geneInfo = td.fields;
    const geneName = geneInfo[3];
    const geneId = track.geneId(geneInfo, td.type);
    const strand = td.strand || geneInfo[5];
    td.strand = td.strand || strand;
    let fill = plusStrandColor || DEFAULT_PLUS_STRAND_COLOR;
    if (strand === "-") {
      fill = minusStrandColor || DEFAULT_MINUS_STRAND_COLOR;
    }
    tile.textWidths = {};
    tile.textHeights = {};
    if (i >= maxTexts) return;
    const text2 = new GLOBALS.PIXI.Text(geneName, {
      fontSize: `${fontSize}px`,
      fontFamily,
      fill: colorToHex(fill)
    });
    text2.interactive = true;
    if (flipText) text2.scale.x = -1;
    text2.anchor.x = 0.5;
    text2.anchor.y = 1;
    tile.texts[geneId] = text2;
    tile.texts[geneId].strand = strand;
    tile.textGraphics.addChild(text2);
  });
  tile.initialized = true;
}
function renderRects(rects, track, tile, someGraphics, xScale, color2, alpha2, centerY, height) {
  const topY = centerY - height / 2;
  const FILLER_PADDING = 0;
  rects.forEach((td) => {
    const graphics = new GLOBALS.PIXI.Graphics();
    tile.rectGraphics.addChild(graphics);
    graphics.beginFill(color2, 0.1);
    graphics.lineStyle(0, color2);
    const poly = [xScale(td.xStart) - FILLER_PADDING, topY, xScale(td.xEnd) + FILLER_PADDING, topY, xScale(td.xEnd) + FILLER_PADDING, topY + height, xScale(td.xStart) - FILLER_PADDING, topY + height, xScale(td.xStart) - FILLER_PADDING, topY];
    graphics.interactive = true;
    graphics.buttonMode = true;
    graphics.mouseup = (event) => geneClickFunc(event, track, td);
    graphics.drawPolygon(poly);
    tile.allRects.push([poly, td.strand, td]);
  });
}
function drawExons(track, graphics, txStart, txEnd, exonStarts, exonEnds, chrOffset, centerY, height, strand) {
  const topY = centerY - height / 2;
  const exonOffsetStarts = exonStarts.split(",").map((x) => +x + chrOffset);
  const exonOffsetEnds = exonEnds.split(",").map((x) => +x + chrOffset);
  const xStartPos = track._xScale(txStart);
  const xEndPos = track._xScale(txEnd);
  const width = xEndPos - xStartPos;
  const yMiddle = centerY;
  const polys = [];
  let poly = [xStartPos, yMiddle - EXON_LINE_HEIGHT / 2, xStartPos + width, yMiddle - EXON_LINE_HEIGHT / 2, xStartPos + width, yMiddle + EXON_LINE_HEIGHT / 2, xStartPos, yMiddle + EXON_LINE_HEIGHT / 2];
  graphics.drawPolygon(poly);
  polys.push(poly);
  const triangleInterval = 2 * height;
  for (let j = Math.max(track.position[0], xStartPos) + triangleInterval; j < Math.min(track.position[0] + track.dimensions[0], xStartPos + width); j += triangleInterval) {
    if (strand === "+") {
      poly = [j, yMiddle - GENE_MINI_TRIANGLE_HEIGHT / 2, j + GENE_MINI_TRIANGLE_HEIGHT / 2, yMiddle, j, yMiddle + GENE_MINI_TRIANGLE_HEIGHT / 2];
    } else {
      poly = [j, yMiddle - GENE_MINI_TRIANGLE_HEIGHT / 2, j - GENE_MINI_TRIANGLE_HEIGHT / 2, yMiddle, j, yMiddle + GENE_MINI_TRIANGLE_HEIGHT / 2];
    }
    polys.push(poly);
    graphics.drawPolygon(poly);
  }
  for (let j = 0; j < exonOffsetStarts.length; j++) {
    const exonStart = exonOffsetStarts[j];
    const exonEnd = exonOffsetEnds[j];
    const xStart = track._xScale(exonStart);
    const localWidth = Math.max(1, track._xScale(exonEnd) - track._xScale(exonStart));
    let minX = xStartPos;
    let maxX = xEndPos;
    const pointerWidth = track.geneRectHeight / 2;
    let localPoly = null;
    if (strand === "+") {
      maxX = xEndPos - pointerWidth;
      localPoly = [Math.min(xStart, maxX), topY, Math.min(xStart + localWidth, maxX), topY, Math.min(xStart + localWidth, maxX), topY + height, Math.min(xStart, maxX), topY + height, Math.min(xStart, maxX), topY];
    } else {
      minX = xStartPos + pointerWidth;
      localPoly = [Math.max(xStart, minX), topY, Math.max(xStart + localWidth, minX), topY, Math.max(xStart + localWidth, minX), topY + height, Math.max(xStart, minX), topY + height, Math.max(xStart, minX), topY];
    }
    polys.push(localPoly);
    graphics.drawPolygon(localPoly);
  }
  return polys;
}
function renderGeneSymbols(genes, track, tile, oldGraphics, xScale, color2, alpha2, centerY, height) {
  const topY = centerY - height / 2;
  genes.forEach((gene) => {
    const xStart = track._xScale(gene.xStart);
    const xEnd = track._xScale(gene.xEnd);
    const graphics = new GLOBALS.PIXI.Graphics();
    tile.rectGraphics.addChild(graphics);
    graphics.beginFill(color2, alpha2);
    graphics.interactive = true;
    graphics.buttonMode = true;
    graphics.mouseup = (evt) => geneClickFunc(evt, track, gene);
    const pointerWidth = track.geneRectHeight / 2;
    let poly = [];
    if (gene.strand === "+" || gene.fields[5] === "+") {
      const pointerStart = Math.max(xStart, xEnd - pointerWidth);
      const pointerEnd = pointerStart + pointerWidth;
      poly = [pointerStart, topY, pointerEnd, topY + track.geneRectHeight / 2, pointerStart, topY + track.geneRectHeight];
    } else {
      const pointerStart = Math.min(xEnd, xStart + pointerWidth);
      const pointerEnd = pointerStart - pointerWidth;
      poly = [pointerStart, topY, pointerEnd, topY + track.geneRectHeight / 2, pointerStart, topY + track.geneRectHeight];
    }
    graphics.drawPolygon(poly);
    tile.allRects.push([poly, gene.strand, gene]);
  });
}
function renderGeneExons(genes, track, tile, rectGraphics, xScale, color2, alpha2, centerY, height) {
  genes.forEach((gene) => {
    const geneInfo = gene.fields;
    const chrOffset = +gene.chrOffset;
    const exonStarts = geneInfo[12];
    const exonEnds = geneInfo[13];
    const graphics = new GLOBALS.PIXI.Graphics();
    tile.rectGraphics.addChild(graphics);
    graphics.beginFill(color2, alpha2);
    graphics.interactive = true;
    graphics.buttonMode = true;
    graphics.mouseup = (evt) => geneClickFunc(evt, track, gene);
    tile.allRects = tile.allRects.concat(drawExons(
      track,
      graphics,
      gene.xStart,
      gene.xEnd,
      exonStarts,
      exonEnds,
      chrOffset,
      // not used for now because we have just one chromosome
      centerY,
      height,
      gene.strand || gene.fields[5]
    ).map((x) => [x, gene.strand, gene]));
  });
}
function renderGenes(genes, track, tile, graphics, xScale, color2, alpha2, centerY, height) {
  renderGeneSymbols(genes, track, tile, graphics, xScale, color2, alpha2, centerY, height);
  renderGeneExons(genes, track, tile, graphics, xScale, color2, alpha2, centerY, height);
}
function renderMask(track, tile) {
  const {
    tileX,
    tileWidth
  } = trackUtils.getTilePosAndDimensions(track.tilesetInfo, tile.tileId);
  tile.rectMaskGraphics.clear();
  const randomColor = Math.floor(Math.random() * 16 ** 6);
  tile.rectMaskGraphics.beginFill(randomColor, 0.3);
  const x = track._xScale(tileX);
  const y = 0;
  const width = track._xScale(tileX + tileWidth) - track._xScale(tileX);
  const height = track.dimensions[1];
  tile.rectMaskGraphics.drawRect(x, y, width, height);
}
let HorizontalGeneAnnotationsTrack = /* @__PURE__ */ (function(_HorizontalTiled1DPix) {
  function HorizontalGeneAnnotationsTrack2(context, options2) {
    var _this;
    _classCallCheck$w(this, HorizontalGeneAnnotationsTrack2);
    _this = _callSuper$v(this, HorizontalGeneAnnotationsTrack2, [context, options2]);
    const {
      animate
    } = context;
    _this.animate = animate;
    _this.options = options2;
    _this.fontSize = +_this.options.fontSize || FONT_SIZE;
    _this.geneLabelPos = _this.options.geneLabelPosition || GENE_LABEL_POS;
    _this.geneRectHeight = +_this.options.geneAnnotationHeight || GENE_RECT_HEIGHT;
    _this.geneRectHeight -= 2;
    _this.geneStrandSpacing = +_this.options.geneStrandSpacing || GENE_STRAND_SPACING;
    _this.geneStrandHSpacing = _this.geneStrandSpacing / 2;
    _this.geneRectHHeight = _this.geneRectHeight / 2;
    return _this;
  }
  _inherits$v(HorizontalGeneAnnotationsTrack2, _HorizontalTiled1DPix);
  return _createClass$w(HorizontalGeneAnnotationsTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      externalInitTile(this, tile, {
        flipText: this.flipText,
        fontSize: this.fontSize,
        fontFamily: FONT_FAMILY,
        plusStrandColor: this.options.plusStrandColor,
        minusStrandColor: this.options.minusStrandColor,
        maxGeneEntries: MAX_GENE_ENTRIES,
        maxFillerEntries: MAX_FILLER_ENTRIES,
        maxTexts: MAX_TEXTS
      });
      this.renderTile(tile);
    }
    /** cleanup */
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
      tile.rectGraphics.destroy();
      tile.rectMaskGraphics.destroy();
      tile.textGraphics.destroy();
      tile.textBgGraphics.destroy();
      tile.graphics.destroy();
    }
    /*
     * Redraw the track because the options
     * changed
     */
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      const strOptions = JSON.stringify(options2);
      if (!force && strOptions === this.prevOptions) return;
      _superPropGet$i(HorizontalGeneAnnotationsTrack2, "rerender", this, 3)([options2, force]);
      this.fontSize = +this.options.fontSize || FONT_SIZE;
      this.geneLabelPos = this.options.geneLabelPosition || GENE_LABEL_POS;
      this.geneRectHeight = +this.options.geneAnnotationHeight || GENE_RECT_HEIGHT;
      this.geneStrandHSpacing = this.geneStrandSpacing / 2;
      this.geneRectHHeight = this.geneRectHeight / 2;
      this.prevOptions = strOptions;
      this.visibleAndFetchedTiles().forEach((tile) => {
        this.renderTile(tile);
      });
    }
  }, {
    key: "drawTile",
    value: function drawTile() {
    }
  }, {
    key: "geneId",
    value: function geneId(geneInfo, type2) {
      return `${type2}_${geneInfo[0]}_${geneInfo[1]}_${geneInfo[2]}_${geneInfo[3]}`;
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      if (!tile.initialized) return;
      tile.allRects = [];
      tile.drawnAtScale = this._xScale.copy();
      tile.rectGraphics.removeChildren();
      tile.rectGraphics.clear();
      tile.textBgGraphics.clear();
      const fill = {};
      const FILLER_RECT_ALPHA = 0.3;
      const GENE_ALPHA = 0.3;
      fill["+"] = colorToHex(this.options.plusStrandColor || DEFAULT_PLUS_STRAND_COLOR);
      fill["-"] = colorToHex(this.options.minusStrandColor || DEFAULT_MINUS_STRAND_COLOR);
      let plusFillerRects = tile.tileData.filter((td) => td.type === "filler" && td.strand === "+");
      let minusFillerRects = tile.tileData.filter((td) => td.type === "filler" && td.strand === "-");
      const plusGenes = tile.tileData.filter((td) => td.type !== "filler" && (td.strand === "+" || td.fields[5] === "+"));
      const minusGenes = tile.tileData.filter((td) => td.type !== "filler" && (td.strand === "-" || td.fields[5] === "-"));
      flagOverlappingFillers(plusGenes, plusFillerRects);
      flagOverlappingFillers(minusGenes, minusFillerRects);
      plusFillerRects = plusFillerRects.filter((x) => !x.hide);
      minusFillerRects = minusFillerRects.filter((x) => !x.hide);
      const yMiddle = this.dimensions[1] / 2;
      const plusStrandCenterY = yMiddle - this.geneRectHeight / 2 - this.geneStrandSpacing / 2;
      const minusStrandCenterY = yMiddle + this.geneRectHeight / 2 + this.geneStrandSpacing / 2;
      const plusRenderContext = [this, tile, tile.rectGraphics, this._xScale, fill["+"], FILLER_RECT_ALPHA, plusStrandCenterY, this.geneRectHeight];
      const minusRenderContext = [this, tile, tile.rectGraphics, this._xScale, fill["-"], FILLER_RECT_ALPHA, minusStrandCenterY, this.geneRectHeight];
      renderRects(plusFillerRects, ...plusRenderContext);
      renderRects(minusFillerRects, ...minusRenderContext);
      plusRenderContext[5] = GENE_ALPHA;
      minusRenderContext[5] = GENE_ALPHA;
      renderGenes(plusGenes, ...plusRenderContext);
      renderGenes(minusGenes, ...minusRenderContext);
      renderMask(this, tile);
      trackUtils.stretchRects(this, [(x) => x.rectGraphics, (x) => x.rectMaskGraphics]);
      for (const text2 of Object.values(tile.texts)) {
        text2.style = {
          fontSize: `${this.fontSize}px`,
          FONT_FAMILY,
          fill: colorToHex(text2.strand === "-" ? this.options.minusStrandColor || DEFAULT_MINUS_STRAND_COLOR : this.options.plusStrandColor || DEFAULT_PLUS_STRAND_COLOR)
        };
      }
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      let zoomLevel = Math.min(xZoomLevel, this.maxZoom);
      zoomLevel = Math.max(zoomLevel, 0);
      return zoomLevel;
    }
  }, {
    key: "draw",
    value: function draw() {
      _superPropGet$i(HorizontalGeneAnnotationsTrack2, "draw", this, 3)([]);
      this.allTexts = [];
      this.allBoxes = [];
      const allTiles = [];
      this.geneAreaHeight = this.geneRectHeight;
      const fontSizeHalf = this.fontSize / 2;
      trackUtils.stretchRects(this, [(x) => x.rectGraphics, (x) => x.rectMaskGraphics]);
      Object.values(this.fetchedTiles).filter((tile) => tile.drawnAtScale).forEach((tile) => {
        tile.textBgGraphics.clear();
        tile.textBgGraphics.beginFill(typeof this.options.labelBackgroundColor !== "undefined" ? colorToHex(this.options.labelBackgroundColor) : WHITE_HEX);
        const parentInFetched = this.parentInFetched(tile);
        if (!tile.initialized) return;
        tile.tileData.forEach((td) => {
          if (!tile.texts) return;
          if (td.type === "filler") return;
          const geneInfo = td.fields;
          const geneName = geneInfo[3];
          const geneId = this.geneId(geneInfo, td.type);
          const text2 = tile.texts[geneId];
          if (!text2) return;
          const chrOffset = +td.chrOffset;
          const txStart = +geneInfo[1] + chrOffset;
          const txEnd = +geneInfo[2] + chrOffset;
          const txMiddle = (txStart + txEnd) / 2;
          let textYMiddle = this.dimensions[1] / 2;
          const fontRectPadding = (this.geneAreaHeight - this.fontSize) / 2;
          if (geneInfo[5] === "+") {
            textYMiddle -= this.geneLabelPos === "inside" ? fontRectPadding + this.geneStrandSpacing - 2 : this.fontSize / 2 + this.geneAreaHeight - 2;
          } else {
            textYMiddle += this.geneLabelPos === "inside" ? this.fontSize + this.geneStrandSpacing / 2 + fontRectPadding + 1 : 1.5 * this.fontSize + this.geneAreaHeight + 2;
          }
          text2.position.x = this._xScale(txMiddle);
          text2.position.y = textYMiddle;
          if (!tile.textWidths[geneId]) {
            const textWidth = text2.getBounds().width;
            const textHeight = text2.getBounds().height;
            tile.textHeights[geneId] = textHeight;
            tile.textWidths[geneId] = textWidth;
          }
          if (!parentInFetched) {
            text2.visible = true;
            const TEXT_MARGIN = 2;
            if (this.flipText) {
              this.allBoxes.push([text2.position.x - tile.textHeights[geneId] / 2 - TEXT_MARGIN, textYMiddle - fontSizeHalf - 1, text2.position.x + tile.textHeights[geneId] / 2 + TEXT_MARGIN, textYMiddle + fontSizeHalf - 1, geneName]);
            } else {
              this.allBoxes.push([text2.position.x - tile.textWidths[geneId] / 2 - TEXT_MARGIN, textYMiddle - fontSizeHalf - 1, text2.position.x + tile.textWidths[geneId] / 2 + TEXT_MARGIN, textYMiddle + fontSizeHalf - 1, geneName]);
            }
            this.allTexts.push({
              importance: +geneInfo[4],
              text: text2,
              caption: geneName,
              strand: geneInfo[5]
            });
            allTiles.push(tile.textBgGraphics);
          } else {
            text2.visible = false;
          }
        });
      });
      this.hideOverlaps(this.allBoxes, this.allTexts);
      this.renderTextBg(this.allBoxes, this.allTexts, allTiles);
    }
  }, {
    key: "renderTextBg",
    value: function renderTextBg(allBoxes, allTexts, allTiles) {
      allTexts.forEach((text2, i) => {
        if (text2.text.visible && allBoxes[i] && allTiles[i]) {
          const [minX, minY, maxX, maxY] = allBoxes[i];
          const width = maxX - minX;
          const height = maxY - minY;
          allTiles[i].drawRect(minX - width / 2, minY - height / 2, width, height);
        }
      });
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allBoxes, allTexts) {
      boxIntersect(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          allTexts[j].text.visible = false;
        } else {
          allTexts[i].text.visible = false;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$i(HorizontalGeneAnnotationsTrack2, "setPosition", this, 3)([newPosition]);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$i(HorizontalGeneAnnotationsTrack2, "setDimensions", this, 3)([newDimensions]);
      this.halfRectHHeight = this.dimensions[1] / 2;
      this.visibleAndFetchedTiles().forEach((tile) => {
        this.renderTile(tile);
      });
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY) {
      if (!this.tilesetInfo) {
        return "";
      }
      const point2 = [trackX, trackY];
      for (const tile of this.visibleAndFetchedTiles()) {
        for (let i = 0; i < tile.allRects.length; i++) {
          if (tile.allRects[i][2].type === "filler") {
            continue;
          }
          const rect2 = tile.allRects[i][0].slice(0);
          const newArr = [];
          while (rect2.length) {
            const newPoint = rect2.splice(0, 2);
            newPoint[0] = newPoint[0] * tile.rectGraphics.scale.x + tile.rectGraphics.position.x;
            newPoint[1] = newPoint[1] * tile.rectGraphics.scale.y + tile.rectGraphics.position.y;
            newArr.push(newPoint);
          }
          const pc = classifyPoint(newArr, point2);
          if (pc === -1) {
            const gene = tile.allRects[i][2];
            return `
            <div>
              <b>${gene.fields[3]}</b><br>
              <b>Position:</b> ${gene.fields[0]}:${gene.fields[1]}-${gene.fields[2]}<br>
              <b>Strand:</b> ${gene.fields[5]}
            </div>
          `;
          }
        }
      }
      return "";
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$i(HorizontalGeneAnnotationsTrack2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$i(HorizontalGeneAnnotationsTrack2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      this.visibleAndFetchedTiles().filter((tile) => tile.allRects).forEach((tile) => {
        const gTile = document.createElement("g");
        gTile.setAttribute("transform", `translate(${tile.rectGraphics.position.x},
          ${tile.rectGraphics.position.y})
          scale(${tile.rectGraphics.scale.x},
          ${tile.rectGraphics.scale.y})`);
        tile.allRects.forEach((rect2) => {
          const r2 = document.createElement("path");
          const poly = rect2[0];
          let d = `M ${poly[0]} ${poly[1]}`;
          for (let i = 2; i < poly.length; i += 2) {
            d += ` L ${poly[i]} ${poly[i + 1]}`;
          }
          r2.setAttribute("d", d);
          if (rect2[1] === "+") {
            r2.setAttribute("fill", this.options.plusStrandColor);
          } else {
            r2.setAttribute("fill", this.options.minusStrandColor);
          }
          r2.setAttribute("opacity", "0.3");
          gTile.appendChild(r2);
        });
        output.appendChild(gTile);
      });
      this.allTexts.filter((text2) => text2.text.visible).forEach((text2) => {
        const g = document.createElement("g");
        const t = document.createElement("text");
        t.setAttribute("text-anchor", "middle");
        t.setAttribute("font-family", FONT_FAMILY);
        t.setAttribute("font-size", `${this.fontSize}px`);
        t.setAttribute("dy", "-.2em");
        g.setAttribute("transform", `scale(${text2.text.scale.x},1)`);
        if (text2.strand === "+") {
          t.setAttribute("fill", this.options.plusStrandColor);
        } else {
          t.setAttribute("fill", this.options.minusStrandColor);
        }
        t.innerHTML = text2.text.text;
        g.appendChild(t);
        g.setAttribute("transform", `translate(${text2.text.x},${text2.text.y})scale(${text2.text.scale.x},1)`);
        output.appendChild(g);
      });
      return [base, base];
    }
  }]);
})(HorizontalTiled1DPixiTrack);
function _classCallCheck$v(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$v(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$v(o.key), o);
  }
}
function _createClass$v(e, r2, t) {
  return r2 && _defineProperties$v(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$v(t) {
  var i = _toPrimitive$v(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$v(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
let LeftTrackModifier = /* @__PURE__ */ (function() {
  function LeftTrackModifier2(originalTrack) {
    _classCallCheck$v(this, LeftTrackModifier2);
    this.scene = originalTrack.scene;
    this.originalTrack = originalTrack;
    this.pBase = new GLOBALS.PIXI.Graphics();
    this.scene.removeChild(originalTrack.pBase);
    this.scene.addChild(this.pBase);
    this.moveToOrigin = new GLOBALS.PIXI.Graphics();
    this.moveToOrigin.addChild(originalTrack.pBase);
    this.pBase.addChild(this.moveToOrigin);
    this.moveToOrigin.rotation = Math.PI / 2;
    originalTrack.isLeftModified = true;
    originalTrack.flipText = true;
    this.svgOutput = null;
    if (originalTrack.gBase && originalTrack.gMain) {
      this.originalTrack.gBase.attr("transform", `translate(${this.moveToOrigin.position.x},${this.moveToOrigin.position.y})
                             rotate(90)
                             scale(${this.moveToOrigin.scale.x},${this.moveToOrigin.scale.y})`);
      this.originalTrack.gMain.attr("transform", `translate(${this.originalTrack.pBase.position.x},${this.originalTrack.pBase.position.y})`);
    }
  }
  return _createClass$v(LeftTrackModifier2, [{
    key: "remove",
    value: function remove2() {
      this.originalTrack.remove();
      this.pBase.clear();
      this.scene.removeChild(this.pBase);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      this.dimensions = newDimensions;
      const reversedDimensions = [newDimensions[1], newDimensions[0]];
      this.originalTrack.setDimensions(reversedDimensions);
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      this.position = newPosition;
      this.originalTrack.setPosition(newPosition);
      this.originalTrack.pBase.position.x = -this.originalTrack.position[0];
      this.originalTrack.pBase.position.y = -this.originalTrack.position[1];
      this.moveToOrigin.scale.y = -1;
      this.moveToOrigin.scale.x = 1;
      this.moveToOrigin.position.x = this.originalTrack.position[0];
      this.moveToOrigin.position.y = this.originalTrack.position[1];
      if (this.originalTrack.gMain) {
        this.originalTrack.gBase.attr("transform", `translate(${this.moveToOrigin.position.x},${this.moveToOrigin.position.y})
                                 rotate(90)
                                 scale(${this.moveToOrigin.scale.x},${this.moveToOrigin.scale.y})`);
        this.originalTrack.gMain.attr("transform", `translate(${this.originalTrack.pBase.position.x},${this.originalTrack.pBase.position.y})`);
      }
    }
  }, {
    key: "refXScale",
    value: function refXScale(_) {
      if (!arguments.length) {
        return this.originalTrack._refYScale;
      }
      this.originalTrack._refXScale = _;
      return this;
    }
  }, {
    key: "refYScale",
    value: function refYScale(_) {
      if (!arguments.length) {
        return this.originalTrack._refXScale;
      }
      this.originalTrack._refYScale = _;
      return this;
    }
  }, {
    key: "xScale",
    value: function xScale(_) {
      if (!arguments.length) {
        return this.originalTrack._xScale;
      }
      this.originalTrack._yScale = _;
      return this;
    }
  }, {
    key: "yScale",
    value: function yScale(_) {
      if (!arguments.length) {
        return this.originalTrack._yScale;
      }
      this.originalTrack._xScale = _;
      return this;
    }
  }, {
    key: "getMouseOverHtml",
    value: function getMouseOverHtml(trackX, trackY) {
      return this.originalTrack.getMouseOverHtml(trackY, trackX);
    }
  }, {
    key: "clickOutside",
    value: function clickOutside() {
      this.originalTrack.clickOutside();
    }
  }, {
    key: "click",
    value: function click(...args) {
      this.originalTrack.click(...args);
    }
  }, {
    key: "draw",
    value: function draw() {
      this.originalTrack.draw();
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k = 1, tx = 0, ty = 0, xPositionOffset = 0, yPositionOffset = 0) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      if (this.originalTrack.leftTrackZoomed) {
        if (this.originalTrack.refreshTiles) {
          this.originalTrack.refreshTiles();
        }
        this.originalTrack.leftTrackZoomed(newXScale, newYScale, k, tx, ty);
        this.originalTrack.draw();
        return;
      }
      const offset = this.originalTrack._xScale(0) - k * this.originalTrack._refXScale(0);
      this.originalTrack.pMobile.position.x = offset + this.originalTrack.position[0];
      this.originalTrack.pMobile.position.y = this.originalTrack.position[1] + this.originalTrack.dimensions[1];
      this.originalTrack.pMobile.scale.x = k;
      this.originalTrack.pMobile.scale.y = k;
      if (this.originalTrack.options.oneDHeatmapFlipped) {
        this.originalTrack.pMobile.scale.y = -k;
        this.originalTrack.pMobile.position.y = this.originalTrack.position[1];
      }
      if (this.originalTrack.leftTrackDraw) {
        if (this.originalTrack.refreshTiles) {
          this.originalTrack.refreshTiles();
        }
        this.originalTrack.leftTrackDraw();
        return;
      }
      this.originalTrack.zoomed(this.xScale(), this.yScale());
    }
  }, {
    key: "zoomedY",
    value: function zoomedY2(yPos, kMultiplier) {
      this.originalTrack.zoomedY(yPos, kMultiplier);
    }
  }, {
    key: "movedY",
    value: function movedY2(dY) {
      this.originalTrack.movedY(dY);
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      this.originalTrack.refScalesChanged(refYScale, refXScale);
    }
  }, {
    key: "rerender",
    value: function rerender(options2) {
      this.originalTrack.rerender(options2);
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      const output = document.createElement("g");
      output.setAttribute("transform", `translate(${this.moveToOrigin.position.x},${this.moveToOrigin.position.y})
                             rotate(90)
                             scale(${this.moveToOrigin.scale.x},${this.moveToOrigin.scale.y})`);
      if (this.originalTrack.exportSVG) {
        const g = document.createElement("g");
        g.setAttribute("transform", `translate(${this.originalTrack.pBase.position.x}, ${this.originalTrack.pBase.position.y})`);
        g.appendChild(this.originalTrack.exportSVG()[0]);
        output.appendChild(g);
      }
      return [output, output];
    }
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition(x, y) {
      return x >= this.position[0] && x <= this.dimensions[0] + this.position[0] && y >= this.position[1] && y <= this.dimensions[1] + this.position[1];
    }
  }]);
})();
function _classCallCheck$u(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$u(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$u(o.key), o);
  }
}
function _createClass$u(e, r2, t) {
  return r2 && _defineProperties$u(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$u(t) {
  var i = _toPrimitive$u(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$u(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$u(t, o, e) {
  return o = _getPrototypeOf$u(o), _possibleConstructorReturn$u(t, _isNativeReflectConstruct$u() ? Reflect.construct(o, e || [], _getPrototypeOf$u(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$u(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$u(t);
}
function _assertThisInitialized$u(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$u() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$u = function() {
    return !!t;
  })();
}
function _superPropGet$h(t, o, e, r2) {
  var p = _get$h(_getPrototypeOf$u(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$h() {
  return _get$h = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$h(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$h.apply(null, arguments);
}
function _superPropBase$h(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$u(t)); ) ;
  return t;
}
function _getPrototypeOf$u(t) {
  return _getPrototypeOf$u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$u(t);
}
function _inherits$u(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$u(t, e);
}
function _setPrototypeOf$u(t, e) {
  return _setPrototypeOf$u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$u(t, e);
}
let Horizontal2DDomainsTrack = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function Horizontal2DDomainsTrack2(context, options2) {
    var _this;
    _classCallCheck$u(this, Horizontal2DDomainsTrack2);
    _this = _callSuper$u(this, Horizontal2DDomainsTrack2, [context, options2]);
    _this.drawnRects = /* @__PURE__ */ new Set();
    _this.pMain = _this.pMobile;
    return _this;
  }
  _inherits$u(Horizontal2DDomainsTrack2, _TiledPixiTrack);
  return _createClass$u(Horizontal2DDomainsTrack2, [{
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
      let zoomLevel = Math.max(xZoomLevel, yZoomLevel);
      zoomLevel = Math.min(zoomLevel, this.maxZoom);
      if (this.options?.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      const expandedXScale = this._xScale.copy();
      expandedXScale.domain([this._xScale.invert(this._xScale.range()[0] - this.dimensions[1] * Math.sqrt(2)), this._xScale.invert(this._xScale.range()[1] + this.dimensions[1] * Math.sqrt(2))]);
      this.xTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      this.yTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const maxWidth = this.tilesetInfo.max_width;
      const tileWidth = maxWidth / 2 ** zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = i; j < cols.length; j++) {
          const tileBottomPosition = (j - i - 2) * (this._xScale(tileWidth) - this._xScale(0)) * Math.sqrt(2) / 2;
          if (tileBottomPosition > this.dimensions[1]) {
            continue;
          }
          const newTile = [zoomLevel, rows[i], cols[j]];
          newTile.mirrored = false;
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      _superPropGet$h(Horizontal2DDomainsTrack2, "initTile", this)([tile]);
      this.drawTile(tile);
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.delayDrawing) {
        this.drawnRects.clear();
      }
      _superPropGet$h(Horizontal2DDomainsTrack2, "draw", this)([]);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      graphics.clear();
      const stroke = colorToHex(this.options.rectangleDomainStrokeColor ? this.options.rectangleDomainStrokeColor : "black");
      const fill = colorToHex(this.options.rectangleDomainFillColor ? this.options.rectangleDomainFillColor : "grey");
      graphics.lineStyle(1 / this.pMain.scale.x, stroke, 1);
      graphics.beginFill(fill, 0.4);
      graphics.alpha = this.options.rectangleDomainOpacity ? this.options.rectangleDomainOpacity : 0.5;
      if (!tile.tileData.sort) return;
      for (const td of tile.tileData) {
        const startX = this._refXScale(td.xStart);
        const endX = this._refXScale(td.xEnd);
        const startY = this._refYScale(td.yStart);
        const endY = this._refYScale(td.yEnd);
        const uid = td.uid;
        if (this.drawnRects.has(uid)) {
          continue;
        }
        this.drawnRects.add(uid);
        graphics.drawRect(startX, startY, endX - startX, endY - startY);
        graphics.pivot.x = this._refXScale(0);
        graphics.pivot.y = this._refYScale(0);
        graphics.scale.x = -1 / Math.sqrt(2);
        graphics.rotation = -3 * Math.PI / 4;
        graphics.scale.y = 1 / Math.sqrt(2);
        graphics.position.x = this._refXScale(0);
        graphics.position.y = 0;
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$h(Horizontal2DDomainsTrack2, "setPosition", this)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _superPropGet$h(Horizontal2DDomainsTrack2, "refScalesChanged", this)([refXScale, refYScale]);
      for (const uid in this.fetchedTiles) {
        const tile = this.fetchedTiles[uid];
        if (tile.sprite) {
          const graphics = tile.graphics;
          graphics.pivot.x = this._refXScale(0);
          graphics.pivot.y = this._refYScale(0);
          graphics.scale.x = -1 / Math.sqrt(2);
          graphics.rotation = -3 * Math.PI / 4;
          graphics.scale.y = 1 / Math.sqrt(2);
          graphics.position.x = this._refXScale(0);
          graphics.position.y = 0;
        }
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _superPropGet$h(Horizontal2DDomainsTrack2, "zoomed", this)([newXScale, newYScale, k, tx, ty]);
      this.pMain.position.x = tx;
      this.pMain.position.y = this.position[1] + this.dimensions[1];
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      if (this.options.oneDHeatmapFlipped) {
        this.pMain.scale.y = -k;
        this.pMain.position.y = this.position[1];
      }
      this.draw();
    }
  }, {
    key: "leftTrackDraw",
    value: function leftTrackDraw() {
      this.draw();
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$t(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$t(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$t(o.key), o);
  }
}
function _createClass$t(e, r2, t) {
  return r2 && _defineProperties$t(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$t(t) {
  var i = _toPrimitive$t(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$t(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$t(t, o, e) {
  return o = _getPrototypeOf$t(o), _possibleConstructorReturn$t(t, _isNativeReflectConstruct$t() ? Reflect.construct(o, e || [], _getPrototypeOf$t(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$t(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$t(t);
}
function _assertThisInitialized$t(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$t = function() {
    return !!t;
  })();
}
function _superPropGet$g(t, o, e, r2) {
  var p = _get$g(_getPrototypeOf$t(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$g() {
  return _get$g = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$g(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$g.apply(null, arguments);
}
function _superPropBase$g(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$t(t)); ) ;
  return t;
}
function _getPrototypeOf$t(t) {
  return _getPrototypeOf$t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$t(t);
}
function _inherits$t(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$t(t, e);
}
function _setPrototypeOf$t(t, e) {
  return _setPrototypeOf$t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$t(t, e);
}
const MAX_CLICK_DELAY = 300;
let Chromosome2DAnnotations = /* @__PURE__ */ (function(_PixiTrack) {
  function Chromosome2DAnnotations2(context, options2) {
    var _this;
    _classCallCheck$t(this, Chromosome2DAnnotations2);
    _this = _callSuper$t(this, Chromosome2DAnnotations2, [context, options2]);
    const {
      chromInfoPath,
      pubSub
    } = context;
    _this.pubSub = pubSub;
    _this.rects = {};
    ChromosomeInfo(chromInfoPath, (newChromInfo) => {
      _this.chromInfo = newChromInfo;
      _this.draw();
    }, _this.pubSub);
    return _this;
  }
  _inherits$t(Chromosome2DAnnotations2, _PixiTrack);
  return _createClass$t(Chromosome2DAnnotations2, [{
    key: "draw",
    value: function draw() {
      if (!this.chromInfo) {
        return;
      }
      const minRectWidth = this.options.minRectWidth ? this.options.minRectWidth : 10;
      const minRectHeight = this.options.minRectWidth ? this.options.minRectHeight : 10;
      _superPropGet$g(Chromosome2DAnnotations2, "draw", this)([]);
      const graphics = this.pMain;
      graphics.clear();
      const timeStamp = performance.now();
      this.options.regions.forEach((region) => {
        const id2 = region.slice(0, 6).join("-");
        if (!this.rects[id2]) {
          this.rects[id2] = {
            graphics: new GLOBALS.PIXI.Graphics()
          };
          graphics.addChild(this.rects[id2].graphics);
        }
        this.rects[id2].timeStamp = timeStamp;
        const colorFill = color(region[6]);
        let colorLine = color(region[7]);
        if (!colorLine) {
          colorLine = colorFill;
        }
        const colorFillHex = GLOBALS.PIXI.utils.rgb2hex([colorFill.r / 255, colorFill.g / 255, colorFill.b / 255]);
        const colorLineHex = GLOBALS.PIXI.utils.rgb2hex([colorLine.r / 255, colorLine.g / 255, colorLine.b / 255]);
        graphics.lineStyle(1, colorLineHex, colorLine.opacity);
        graphics.beginFill(colorFillHex, colorFill.opacity);
        let startX = this._xScale(this.chromInfo.chrPositions[region[0]].pos + +region[1]);
        const endX = this._xScale(this.chromInfo.chrPositions[region[0]].pos + +region[2]);
        let startY = this._yScale(this.chromInfo.chrPositions[region[3]].pos + +region[4]);
        const endY = this._yScale(this.chromInfo.chrPositions[region[3]].pos + +region[5]);
        let width = endX - startX;
        let height = endY - startY;
        const _minRectWidth = typeof region[8] !== "undefined" ? region[8] : minRectWidth;
        const _minRectHeight = typeof region[9] !== "undefined" ? region[9] : minRectHeight;
        if (width < _minRectWidth) {
          startX = (startX + endX) / 2 - _minRectWidth / 2;
          width = _minRectWidth;
        }
        if (height < _minRectHeight) {
          startY = (startY + endY) / 2 - _minRectHeight / 2;
          height = _minRectHeight;
        }
        graphics.drawRect(startX, startY, width, height);
        this.rects[id2].graphics.clear();
        this.rects[id2].graphics.interactive = true;
        this.rects[id2].graphics.buttonMode = true;
        this.rects[id2].graphics.hitArea = new GLOBALS.PIXI.Rectangle(startX, startY, width, height);
        this.rects[id2].graphics.mousedown = () => {
          this.rects[id2].mouseDownTime = performance.now();
        };
        this.rects[id2].graphics.mouseup = (event) => {
          if (performance.now() - this.rects[id2].mouseDownTime < MAX_CLICK_DELAY) {
            this.pubSub.publish("app.click", {
              type: "annotation",
              event,
              payload: region
            });
          }
        };
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$g(Chromosome2DAnnotations2, "setPosition", this)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }]);
})(PixiTrack);
function _classCallCheck$s(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$s(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$s(o.key), o);
  }
}
function _createClass$s(e, r2, t) {
  return r2 && _defineProperties$s(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$s(t) {
  var i = _toPrimitive$s(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$s(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$s(t, o, e) {
  return o = _getPrototypeOf$s(o), _possibleConstructorReturn$s(t, _isNativeReflectConstruct$s() ? Reflect.construct(o, e || [], _getPrototypeOf$s(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$s(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$s(t);
}
function _assertThisInitialized$s(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$s() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$s = function() {
    return !!t;
  })();
}
function _superPropGet$f(t, o, e, r2) {
  var p = _get$f(_getPrototypeOf$s(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$f() {
  return _get$f = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$f(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$f.apply(null, arguments);
}
function _superPropBase$f(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$s(t)); ) ;
  return t;
}
function _getPrototypeOf$s(t) {
  return _getPrototypeOf$s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$s(t);
}
function _inherits$s(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$s(t, e);
}
function _setPrototypeOf$s(t, e) {
  return _setPrototypeOf$s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$s(t, e);
}
let Chromosome2DLabels = /* @__PURE__ */ (function(_PixiTrack) {
  function Chromosome2DLabels2(context, options2) {
    var _this;
    _classCallCheck$s(this, Chromosome2DLabels2);
    _this = _callSuper$s(this, Chromosome2DLabels2, [context, options2]);
    const {
      dataConfig,
      animate,
      pubSub
    } = context;
    _this.searchField = null;
    _this.chromInfo = null;
    _this.animate = animate;
    const server = dataConfig.server;
    const uid = dataConfig.tilesetUid;
    const chromSizesPath = `${server}/chrom-sizes/?id=${uid}`;
    ChromosomeInfo(chromSizesPath, (newChromInfo) => {
      _this.chromInfo = newChromInfo;
      _this.searchField = new SearchField(_this.chromInfo);
      _this.draw();
      _this.texts = [];
      for (let i = 0; i < _this.chromInfo.cumPositions.length; i++) {
        const thisTexts = [];
        for (let j = 0; j < _this.chromInfo.cumPositions.length; j++) {
          const textStr = `${_this.chromInfo.cumPositions[i].chr}/${_this.chromInfo.cumPositions[j].chr}`;
          const text2 = new GLOBALS.PIXI.Text(textStr, {
            fontSize: "14px",
            fontFamily: "Arial",
            fill: "red"
          });
          text2.anchor.x = 0.5;
          text2.anchor.y = 0.5;
          text2.visible = false;
          text2.hashValue = Math.random();
          thisTexts.push(text2);
          _this.pMain.addChild(text2);
        }
        _this.texts.push(thisTexts);
      }
      _this.draw();
      _this.animate();
    }, pubSub);
    return _this;
  }
  _inherits$s(Chromosome2DLabels2, _PixiTrack);
  return _createClass$s(Chromosome2DLabels2, [{
    key: "draw",
    value: function draw() {
      const allTexts = [];
      if (!this.texts) {
        return;
      }
      if (!this.searchField) {
        return;
      }
      const x12 = absToChr(this._xScale.domain()[0], this.chromInfo);
      const x2 = absToChr(this._xScale.domain()[1], this.chromInfo);
      const y12 = absToChr(this._yScale.domain()[0], this.chromInfo);
      const y2 = absToChr(this._yScale.domain()[1], this.chromInfo);
      for (let i = 0; i < this.texts.length; i++) {
        for (let j = 0; j < this.texts.length; j++) {
          this.texts[i][j].visible = false;
        }
      }
      for (let i = x12[3]; i <= x2[3]; i++) {
        for (let j = y12[3]; j <= y2[3]; j++) {
          const xCumPos = this.chromInfo.cumPositions[i];
          const yCumPos = this.chromInfo.cumPositions[j];
          const midX = xCumPos.pos + this.chromInfo.chromLengths[xCumPos.chr] / 2;
          const midY = yCumPos.pos + this.chromInfo.chromLengths[yCumPos.chr] / 2;
          const viewportMidX = this._xScale(midX);
          const viewportMidY = this._yScale(midY);
          const text2 = this.texts[i][j];
          text2.x = viewportMidX;
          text2.y = viewportMidY;
          text2.updateTransform();
          const bbox = text2.getBounds();
          const bwh = bbox.width / 2;
          const bhh = bbox.height / 2;
          if (viewportMidX + bwh > this.dimensions[0]) {
            text2.x -= viewportMidX + bwh - this.dimensions[0];
          } else if (viewportMidX - bwh < 0) {
            text2.x -= viewportMidX - bwh;
          }
          if (viewportMidY + bhh > this.dimensions[1]) {
            text2.y -= viewportMidY + bhh - this.dimensions[1];
          } else if (viewportMidY - bhh < 0) {
            text2.y -= viewportMidY - bhh;
          }
          text2.visible = true;
          allTexts.push({
            importance: this.texts[i][j].hashValue,
            text: this.texts[i][j],
            caption: null
          });
        }
      }
      this.hideOverlaps(allTexts);
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allTexts) {
      let allBoxes = [];
      allBoxes = allTexts.map((val) => {
        const text2 = val.text;
        text2.updateTransform();
        const b = text2.getBounds();
        const box = [b.x, b.y, b.x + b.width, b.y + b.height];
        return box;
      });
      boxIntersect(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          allTexts[j].text.visible = 0;
        } else {
          allTexts[i].text.visible = 0;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$f(Chromosome2DLabels2, "setPosition", this)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }]);
})(PixiTrack);
function _classCallCheck$r(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$r(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$r(o.key), o);
  }
}
function _createClass$r(e, r2, t) {
  return r2 && _defineProperties$r(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$r(t) {
  var i = _toPrimitive$r(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$r(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$r(t, o, e) {
  return o = _getPrototypeOf$r(o), _possibleConstructorReturn$r(t, _isNativeReflectConstruct$r() ? Reflect.construct(o, e || [], _getPrototypeOf$r(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$r(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$r(t);
}
function _assertThisInitialized$r(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$r() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$r = function() {
    return !!t;
  })();
}
function _superPropGet$e(t, o, e, r2) {
  var p = _get$e(_getPrototypeOf$r(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$e() {
  return _get$e = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$e(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$e.apply(null, arguments);
}
function _superPropBase$e(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$r(t)); ) ;
  return t;
}
function _getPrototypeOf$r(t) {
  return _getPrototypeOf$r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$r(t);
}
function _inherits$r(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$r(t, e);
}
function _setPrototypeOf$r(t, e) {
  return _setPrototypeOf$r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$r(t, e);
}
let ChromosomeGrid = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function ChromosomeGrid2(context, options2) {
    var _this;
    _classCallCheck$r(this, ChromosomeGrid2);
    _this = _callSuper$r(this, ChromosomeGrid2, [context, options2]);
    const {
      chromInfoPath,
      dataConfig,
      animate,
      pubSub,
      orientation: orientation2 = "2d",
      isOverlay = false
    } = context;
    _this.chromInfo = null;
    _this.animate = animate;
    _this.orientation = orientation2;
    _this.isOverlay = isOverlay;
    if (chromInfoPath) {
      ChromosomeInfo(chromInfoPath, (newChromInfo) => {
        _this.chromInfo = newChromInfo;
        _this.tilesetInfoReceived();
      }, _this.pubSub);
    }
    return _this;
  }
  _inherits$r(ChromosomeGrid2, _TiledPixiTrack);
  return _createClass$r(ChromosomeGrid2, [{
    key: "tilesetInfoReceived",
    value: function tilesetInfoReceived() {
      this.texts = [];
      this.lineGraphics = new GLOBALS.PIXI.Graphics();
      this.lineGraphics1dH = new GLOBALS.PIXI.Graphics();
      this.lineGraphics1dV = new GLOBALS.PIXI.Graphics();
      this.lineGraphics2d = new GLOBALS.PIXI.Graphics();
      this.mask1dH = new GLOBALS.PIXI.Graphics();
      this.mask1dV = new GLOBALS.PIXI.Graphics();
      this.mask2d = new GLOBALS.PIXI.Graphics();
      this.lineGraphics.addChild(this.lineGraphics1dH);
      this.lineGraphics1dH.addChild(this.mask1dH);
      this.lineGraphics.addChild(this.lineGraphics1dV);
      this.lineGraphics1dV.addChild(this.mask1dV);
      this.lineGraphics.addChild(this.lineGraphics2d);
      this.lineGraphics2d.addChild(this.mask2d);
      this.pMain.addChild(this.lineGraphics);
      this.draw();
      this.animate();
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      return [];
    }
  }, {
    key: "drawLines",
    value: function drawLines(orientation2 = this.orientation, left2 = 0, top2 = 0) {
      let graphics = this.lineGraphics;
      if (this.isOverlay && orientation2 === "1d-horizontal") {
        graphics = this.lineGraphics1dH;
      }
      if (this.isOverlay && orientation2 === "1d-vertical") {
        graphics = this.lineGraphics1dV;
      }
      if (this.isOverlay && orientation2 === "2d") {
        graphics = this.lineGraphics2d;
      }
      const strokeColor = colorToHex(this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue");
      const strokeWidth = this.options.lineStrokeWidth ? this.options.lineStrokeWidth : 1;
      graphics.lineStyle(strokeWidth, strokeColor, 1);
      if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
        graphics.moveTo(this._xScale(0) + left2, top2);
        graphics.lineTo(this._xScale(0) + left2, this.dimensions[1] + top2);
      }
      if (orientation2 === "2d" || orientation2 === "1d-vertical") {
        graphics.moveTo(left2, this._yScale(0) + top2);
        graphics.lineTo(this.dimensions[0] + left2, this._yScale(0) + top2);
      }
      for (let i = 0; i < this.chromInfo.cumPositions.length; i++) {
        const chrPos = this.chromInfo.cumPositions[i];
        const chrEnd = chrPos.pos + +this.chromInfo.chromLengths[chrPos.chr] + 1;
        if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
          graphics.moveTo(this._xScale(chrEnd) + left2, top2);
          graphics.lineTo(this._xScale(chrEnd) + left2, this.dimensions[1] + top2);
        }
        if (orientation2 === "2d" || orientation2 === "1d-vertical") {
          graphics.moveTo(left2, this._yScale(chrEnd) + top2);
          graphics.lineTo(this.dimensions[0] + left2, this._yScale(chrEnd) + top2);
        }
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.texts) {
        return;
      }
      if (!this.tilesetInfo) {
        return;
      }
      this.lineGraphics.clear();
      if (this.isOverlay) {
        this.lineGraphics1dH.clear();
        this.lineGraphics1dV.clear();
        this.lineGraphics2d.clear();
        this.mask1dH.clear();
        this.mask1dV.clear();
        this.mask2d.clear();
        this.mask1dH.beginFill(16777215);
        this.mask1dV.beginFill(16777215);
        this.mask2d.beginFill(16711680);
        for (let i = 0; i < this.options.orientationsAndPositions.length; i++) {
          const orientation2 = this.options.orientationsAndPositions[i].orientation;
          const {
            left: left2,
            top: top2,
            width,
            height
          } = this.options.orientationsAndPositions[i].position;
          if (orientation2 === "1d-horizontal") {
            this.mask1dH.drawRect(left2, top2, width, height);
          }
          if (orientation2 === "1d-vertical") {
            this.mask1dV.drawRect(left2, top2, width, height);
          }
          if (orientation2 === "2d") {
            this.mask2d.drawRect(left2, top2, width, height);
          }
          this.drawLines(orientation2, left2, top2);
        }
        this.lineGraphics1dH.mask = this.mask1dH;
        this.lineGraphics1dV.mask = this.mask1dV;
        this.lineGraphics2d.mask = this.mask2d;
      } else {
        this.drawLines();
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$e(ChromosomeGrid2, "setPosition", this, 3)([newPosition]);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "createSvgLine",
    value: function createSvgLine(x12, x2, y12, y2, stroke, strokeWidth) {
      const line = document.createElement("line");
      line.setAttribute("x1", x12);
      line.setAttribute("x2", x2);
      line.setAttribute("y1", y12);
      line.setAttribute("y2", y2);
      line.setAttribute("stroke", stroke);
      line.setAttribute("stroke-width", strokeWidth);
      return line;
    }
  }, {
    key: "drawLinesSvg",
    value: function drawLinesSvg(output, orientation2, width, height, left2 = 0, top2 = 0) {
      const strokeColor = this.options.lineStrokeColor ? this.options.lineStrokeColor : "blue";
      const strokeWidth = this.options.lineStrokeWidth;
      if (orientation2 === "2d" || orientation2 === "1d-vertical") {
        const y = this._yScale(0);
        if (y > 0 && y < top2 + height) {
          output.appendChild(this.createSvgLine(left2, width + left2, y + top2, y + top2, strokeColor, strokeWidth));
        }
      }
      if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
        const x = this._xScale(0);
        if (x > 0 && x < left2 + width) {
          output.appendChild(this.createSvgLine(x + left2, x + left2, top2, height + top2, strokeColor, strokeWidth));
        }
      }
      for (let i = 0; i < this.chromInfo.cumPositions.length; i++) {
        const chrPos = this.chromInfo.cumPositions[i];
        const chrEnd = chrPos.pos + +this.chromInfo.chromLengths[chrPos.chr] + 1;
        if (orientation2 === "2d" || orientation2 === "1d-vertical") {
          const y = this._yScale(chrEnd);
          if (y > 0 && y < top2 + height) {
            output.appendChild(this.createSvgLine(left2, width + left2, y + top2, y + top2, strokeColor, strokeWidth));
          }
        }
        if (orientation2 === "2d" || orientation2 === "1d-horizontal") {
          const x = this._xScale(chrEnd);
          if (x > 0 && x < left2 + width) {
            output.appendChild(this.createSvgLine(x + left2, x + left2, top2, height + top2, strokeColor, strokeWidth));
          }
        }
      }
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$e(ChromosomeGrid2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$e(ChromosomeGrid2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      track.appendChild(output);
      base.setAttribute("id", "ChromosomeGrid");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      if (!this.chromInfo) {
        return [base, track];
      }
      if (this.isOverlay) {
        for (let i = 0; i < this.options.orientationsAndPositions.length; i++) {
          const orientation2 = this.options.orientationsAndPositions[i].orientation;
          const {
            left: left2,
            top: top2,
            width,
            height
          } = this.options.orientationsAndPositions[i].position;
          this.drawLinesSvg(output, orientation2, width, height, left2, top2);
        }
      } else {
        this.drawLinesSvg(output, this.orientation, ...this.dimensions);
      }
      return [base, track];
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$q(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$q(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$q(o.key), o);
  }
}
function _createClass$q(e, r2, t) {
  return r2 && _defineProperties$q(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$q(t) {
  var i = _toPrimitive$q(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$q(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$q(t, o, e) {
  return o = _getPrototypeOf$q(o), _possibleConstructorReturn$q(t, _isNativeReflectConstruct$q() ? Reflect.construct(o, e || [], _getPrototypeOf$q(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$q(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$q(t);
}
function _assertThisInitialized$q(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$q() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$q = function() {
    return !!t;
  })();
}
function _superPropGet$d(t, o, e, r2) {
  var p = _get$d(_getPrototypeOf$q(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$d() {
  return _get$d = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$d(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$d.apply(null, arguments);
}
function _superPropBase$d(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$q(t)); ) ;
  return t;
}
function _getPrototypeOf$q(t) {
  return _getPrototypeOf$q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$q(t);
}
function _inherits$q(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$q(t, e);
}
function _setPrototypeOf$q(t, e) {
  return _setPrototypeOf$q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$q(t, e);
}
const TICK_WIDTH = 200;
const TICK_HEIGHT = 6;
const TICK_TEXT_SEPARATION = 2;
const TICK_COLOR = 7829367;
let HorizontalChromosomeLabels = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function HorizontalChromosomeLabels2(context, options2) {
    var _this;
    _classCallCheck$q(this, HorizontalChromosomeLabels2);
    _this = _callSuper$q(this, HorizontalChromosomeLabels2, [context, options2]);
    const {
      dataConfig,
      animate,
      chromInfoPath,
      isShowGlobalMousePosition
    } = context;
    _this.chromInfo = null;
    _this.dataConfig = dataConfig;
    _this.pTicks = new GLOBALS.PIXI.Graphics();
    _this.pMain.addChild(_this.pTicks);
    _this.gTicks = {};
    _this.tickTexts = {};
    _this.options = options2;
    _this.isShowGlobalMousePosition = isShowGlobalMousePosition;
    _this.textFontSize = 12;
    _this.textFontFamily = "Arial";
    _this.textFontColor = "#808080";
    _this.textStrokeColor = _this.getTheme() === THEME_DARK ? "#000000" : "#ffffff";
    _this.pixiTextConfig = {
      fontSize: +_this.options.fontSize ? `${+_this.options.fontSize}px` : `${_this.textFontSize}px`,
      fontFamily: _this.textFontFamily,
      fill: _this.options.color || _this.textFontColor,
      lineJoin: "round",
      stroke: _this.options.stroke || _this.textStrokeColor,
      strokeThickness: 2
    };
    _this.stroke = colorToHex(_this.pixiTextConfig.stroke);
    _this.tickWidth = TICK_WIDTH;
    _this.tickHeight = TICK_HEIGHT;
    _this.tickTextSeparation = TICK_TEXT_SEPARATION;
    _this.tickColor = _this.options.tickColor ? colorToHex(_this.options.tickColor) : TICK_COLOR;
    _this.animate = animate;
    _this.pubSubs = [];
    if (_this.options.showMousePosition && !_this.hideMousePosition) {
      _this.hideMousePosition = setupShowMousePosition(_this, _this.is2d, _this.isShowGlobalMousePosition());
    }
    if (chromInfoPath) {
      ChromosomeInfo(chromInfoPath, (newChromInfo) => {
        _this.chromInfo = newChromInfo;
        _this.tilesetInfoReceived();
      }, _this.pubSub);
    }
    return _this;
  }
  _inherits$q(HorizontalChromosomeLabels2, _TiledPixiTrack);
  return _createClass$q(HorizontalChromosomeLabels2, [{
    key: "tilesetInfoReceived",
    value: function tilesetInfoReceived() {
      this.rerender(this.options, true);
      this.draw();
      this.animate();
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      return [];
    }
  }, {
    key: "initBoundsTicks",
    value: function initBoundsTicks() {
      if (this.pTicks) {
        this.pMain.removeChild(this.pTicks);
        this.pTicks = null;
      }
      if (!this.gBoundTicks) {
        this.gBoundTicks = new GLOBALS.PIXI.Graphics();
        this.leftBoundTick = new GLOBALS.PIXI.Text("", this.pixiTextConfig);
        this.rightBoundTick = new GLOBALS.PIXI.Text("", this.pixiTextConfig);
        this.gBoundTicks.addChild(this.leftBoundTick);
        this.gBoundTicks.addChild(this.rightBoundTick);
        this.pMain.addChild(this.gBoundTicks);
      }
      this.texts = [];
    }
  }, {
    key: "initChromLabels",
    value: function initChromLabels() {
      if (!this.chromInfo) return;
      if (this.gBoundTicks) {
        this.pMain.removeChild(this.gBoundTicks);
        this.gBoundTicks = null;
      }
      if (!this.pTicks) {
        this.pTicks = new GLOBALS.PIXI.Graphics();
        this.pMain.addChild(this.pTicks);
      }
      this.texts = [];
      this.pTicks.removeChildren();
      for (let i = 0; i < this.chromInfo.cumPositions.length; i++) {
        const chromName = this.chromInfo.cumPositions[i].chr;
        this.gTicks[chromName] = new GLOBALS.PIXI.Graphics();
        if (!this.tickTexts[chromName]) this.tickTexts[chromName] = [];
        const text2 = new GLOBALS.PIXI.Text(chromName, this.pixiTextConfig);
        text2.hashValue = Math.random();
        this.pTicks.addChild(text2);
        this.pTicks.addChild(this.gTicks[chromName]);
        this.texts.push(text2);
      }
    }
  }, {
    key: "rerender",
    value: function rerender(options2, force) {
      const strOptions = JSON.stringify(options2);
      if (!force && strOptions === this.prevOptions) return;
      this.prevOptions = strOptions;
      this.options = options2;
      this.tickTexts = {};
      this.pixiTextConfig.fontSize = +this.options.fontSize ? `${+this.options.fontSize}px` : this.pixiTextConfig.fontSize;
      this.pixiTextConfig.fill = this.options.color || this.pixiTextConfig.fill;
      this.pixiTextConfig.stroke = this.options.stroke || this.pixiTextConfig.stroke;
      this.stroke = colorToHex(this.pixiTextConfig.stroke);
      this.tickColor = this.options.tickColor ? colorToHex(this.options.tickColor) : TICK_COLOR;
      if (this.options.tickPositions === "ends") {
        this.initBoundsTicks();
      } else {
        this.initChromLabels();
      }
      _superPropGet$d(HorizontalChromosomeLabels2, "rerender", this, 3)([options2, force]);
      if (this.options.showMousePosition && !this.hideMousePosition) {
        this.hideMousePosition = setupShowMousePosition(this, this.is2d, this.isShowGlobalMousePosition());
      }
      if (!this.options.showMousePosition && this.hideMousePosition) {
        this.hideMousePosition();
        this.hideMousePosition = void 0;
      }
    }
  }, {
    key: "formatTick",
    value: function formatTick(pos) {
      const domain2 = this._xScale.domain();
      const viewWidth = domain2[1] - domain2[0];
      const p = precisionPrefix(pos, viewWidth);
      const fPlain = format$1(",");
      const fPrecision = formatPrefix(`,.${p}`, viewWidth);
      let f2 = fPlain;
      if (this.options.tickFormat === "si") {
        f2 = fPrecision;
      } else if (this.options.tickFormat === "plain") {
        f2 = fPlain;
      } else if (this.options.tickPositions === "ends") {
        f2 = fPrecision;
      }
      return f2(pos);
    }
  }, {
    key: "drawBoundsTicks",
    value: function drawBoundsTicks(x12, x2) {
      const graphics = this.gBoundTicks;
      graphics.clear();
      graphics.lineStyle(1, 0);
      const lineYStart = this.options.reverseOrientation ? 0 : this.dimensions[1];
      const lineYEnd = this.options.reverseOrientation ? this.tickHeight : this.dimensions[1] - this.tickHeight;
      graphics.moveTo(1, lineYStart);
      graphics.lineTo(1, lineYEnd);
      graphics.moveTo(this.dimensions[0] - 1, lineYStart);
      graphics.lineTo(this.dimensions[0] - 1, lineYEnd);
      this.leftBoundTick.x = 0;
      this.leftBoundTick.y = this.options.reverseOrientation ? lineYEnd + this.tickTextSeparation : lineYEnd - this.tickTextSeparation;
      this.leftBoundTick.text = `${x12[0]}: ${this.formatTick(x12[1])}`;
      this.leftBoundTick.anchor.y = this.options.reverseOrientation ? 0 : 1;
      this.rightBoundTick.x = this.dimensions[0];
      this.rightBoundTick.text = `${x2[0]}: ${this.formatTick(x2[1])}`;
      this.rightBoundTick.y = this.options.reverseOrientation ? lineYEnd + this.tickTextSeparation : lineYEnd - this.tickTextSeparation;
      this.rightBoundTick.anchor.y = this.options.reverseOrientation ? 0 : 1;
      this.rightBoundTick.anchor.x = 1;
      if (this.flipText) {
        this.leftBoundTick.scale.x = -1;
        this.leftBoundTick.anchor.x = 1;
        this.rightBoundTick.scale.x = -1;
        this.rightBoundTick.anchor.x = 0;
      }
      this.leftBoundTick.tickLine = [1, this.dimensions[1], 1, this.dimensions[1] - this.tickHeight];
      this.rightBoundTick.tickLine = [this.dimensions[0] - 1, this.dimensions[1], this.dimensions[0] - 1, this.dimensions[1] - this.tickHeight];
      this.tickTexts = {};
      this.tickTexts.all = [this.leftBoundTick, this.rightBoundTick];
    }
  }, {
    key: "drawTicks",
    value: function drawTicks(cumPos) {
      const graphics = this.gTicks[cumPos.chr];
      graphics.visible = true;
      graphics.clear();
      const chromLen = +this.chromInfo.chromLengths[cumPos.chr];
      const vpLeft = Math.max(this._xScale(cumPos.pos), 0);
      const vpRight = Math.min(this._xScale(cumPos.pos + chromLen), this.dimensions[0]);
      const numTicks = (vpRight - vpLeft) / this.tickWidth;
      const xScale = linear().domain([Math.max(1, this._xScale.invert(0) - cumPos.pos), Math.min(chromLen, this._xScale.invert(this.dimensions[0]) - cumPos.pos)]).range(vpLeft, vpRight);
      const ticks2 = xScale.ticks(numTicks).filter((tick) => Number.isInteger(tick));
      const tickTexts = this.tickTexts[cumPos.chr];
      const tickHeight = this.options.fontIsLeftAligned ? (+this.options.fontSize || this.textFontSize) / 2 : this.tickHeight;
      const flipTextSign = this.flipText ? -1 : 1;
      const xPadding = this.options.fontIsLeftAligned ? flipTextSign * 4 : 0;
      let yPadding = this.options.fontIsLeftAligned ? 0 : tickHeight + this.tickTextSeparation;
      if (this.options.reverseOrientation) {
        yPadding = this.dimensions[1] - yPadding;
      }
      while (tickTexts.length < ticks2.length) {
        const newText = new GLOBALS.PIXI.Text("", this.pixiTextConfig);
        tickTexts.push(newText);
        this.gTicks[cumPos.chr].addChild(newText);
      }
      while (tickTexts.length > ticks2.length) {
        const text2 = tickTexts.pop();
        this.gTicks[cumPos.chr].removeChild(text2);
      }
      let i = 0;
      while (i < ticks2.length) {
        tickTexts[i].visible = true;
        tickTexts[i].anchor.x = this.options.fontIsLeftAligned ? 0 : 0.5;
        tickTexts[i].anchor.y = this.options.reverseOrientation ? 0 : 1;
        if (this.flipText) tickTexts[i].scale.x = -1;
        tickTexts[i].x = this._xScale(cumPos.pos + ticks2[i]) + xPadding;
        tickTexts[i].y = this.dimensions[1] - yPadding;
        tickTexts[i].text = ticks2[i] === 0 ? `${cumPos.chr}: 1` : `${cumPos.chr}: ${this.formatTick(ticks2[i])}`;
        const x = this._xScale(cumPos.pos + ticks2[i]);
        tickTexts[i].tickLine = [x - 1, this.dimensions[1], x - 1, this.dimensions[1] - tickHeight - 1];
        const lineYStart = this.options.reverseOrientation ? 0 : this.dimensions[1];
        const lineYEnd = this.options.reverseOrientation ? tickHeight : this.dimensions[1] - tickHeight;
        graphics.lineStyle(1, this.stroke);
        graphics.moveTo(x - 1, lineYStart);
        graphics.lineTo(x - 1, lineYEnd - 1);
        if (this.options.fontIsLeftAligned) {
          graphics.lineTo(x + 2 * flipTextSign + 1 * flipTextSign, lineYEnd - 1);
          graphics.lineTo(x + 2 * flipTextSign + 1 * flipTextSign, lineYEnd + 1);
          graphics.lineTo(x + 1, lineYEnd + 1);
        } else {
          graphics.lineTo(x + 1, lineYEnd - 1);
        }
        graphics.lineTo(x + 1, lineYStart);
        graphics.lineStyle(1, this.tickColor);
        graphics.moveTo(x, lineYStart);
        graphics.lineTo(x, lineYEnd);
        if (this.options.fontIsLeftAligned) {
          graphics.lineTo(x + 2 * flipTextSign, lineYEnd);
        }
        i += 1;
      }
      while (i < tickTexts.length) {
        tickTexts[i].visible = false;
        i += 1;
      }
      return ticks2.length;
    }
  }, {
    key: "draw",
    value: function draw() {
      this.allTexts = [];
      if (!this.texts) return;
      const x12 = absToChr(this._xScale.domain()[0], this.chromInfo);
      const x2 = absToChr(this._xScale.domain()[1], this.chromInfo);
      if (!x12 || !x2) {
        console.warn("Empty chromInfo:", this.dataConfig, this.chromInfo);
        return;
      }
      if (this.options.tickPositions === "ends") {
        if (!this.gBoundTicks) return;
        this.gBoundTicks.visible = true;
        this.drawBoundsTicks(x12, x2);
        return;
      }
      if (!this.pTicks) {
        return;
      }
      for (let i = 0; i < this.texts.length; i++) {
        this.texts[i].visible = false;
        this.gTicks[this.chromInfo.cumPositions[i].chr].visible = false;
      }
      let yPadding = this.options.fontIsLeftAligned ? 0 : this.tickHeight + this.tickTextSeparation;
      if (this.options.reverseOrientation) {
        yPadding = this.dimensions[1] - yPadding;
      }
      Object.keys(this.chromInfo.chrPositions).forEach((chrom) => {
        if (this.tickTexts[chrom]) {
          for (let j = 0; j < this.tickTexts[chrom].length; j++) {
            this.tickTexts[chrom][j].visible = false;
          }
        }
      });
      for (let i = x12[3]; i <= x2[3]; i++) {
        const xCumPos = this.chromInfo.cumPositions[i];
        const midX = xCumPos.pos + this.chromInfo.chromLengths[xCumPos.chr] / 2;
        const viewportMidX = this._xScale(midX);
        const text2 = this.texts[i];
        text2.anchor.x = this.options.fontIsLeftAligned ? 0 : 0.5;
        text2.anchor.y = this.options.reverseOrientation ? 0 : 1;
        text2.x = viewportMidX;
        text2.y = this.dimensions[1] - yPadding;
        text2.updateTransform();
        if (this.flipText) text2.scale.x = -1;
        const numTicksDrawn = this.drawTicks(xCumPos);
        text2.visible = numTicksDrawn <= 0;
        this.allTexts.push({
          importance: text2.hashValue,
          text: text2,
          caption: null
        });
      }
      this.hideOverlaps(this.allTexts);
    }
  }, {
    key: "hideOverlaps",
    value: function hideOverlaps(allTexts) {
      let allBoxes = [];
      allBoxes = allTexts.map(({
        text: text2
      }, i) => {
        text2.updateTransform();
        const b = text2.getBounds();
        const box = [b.x, b.y, b.x + b.width, b.y + b.height];
        return box;
      });
      boxIntersect(allBoxes, (i, j) => {
        if (allTexts[i].importance > allTexts[j].importance) {
          allTexts[j].text.visible = false;
        } else {
          allTexts[i].text.visible = false;
        }
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$d(HorizontalChromosomeLabels2, "setPosition", this, 3)([newPosition]);
      [this.pMain.position.x, this.pMain.position.y] = this.position;
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$d(HorizontalChromosomeLabels2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$d(HorizontalChromosomeLabels2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      base.setAttribute("class", "chromosome-labels");
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      this.allTexts.filter((text2) => text2.text.visible).forEach((text2) => {
        const g = pixiTextToSvg(text2.text);
        output.appendChild(g);
      });
      Object.values(this.tickTexts).forEach((texts) => {
        texts.filter((x) => x.visible).forEach((text2) => {
          let g = pixiTextToSvg(text2);
          output.appendChild(g);
          g = svgLine(text2.x, this.options.reverseOrientation ? 0 : this.dimensions[1], text2.x, this.options.reverseOrientation ? this.tickHeight : this.dimensions[1] - this.tickHeight, 1, this.tickColor);
          const line = document.createElement("line");
          line.setAttribute("x1", text2.tickLine[0]);
          line.setAttribute("y1", text2.tickLine[1]);
          line.setAttribute("x2", text2.tickLine[2]);
          line.setAttribute("y2", text2.tickLine[3]);
          line.setAttribute("style", "stroke: grey");
          output.appendChild(g);
          output.appendChild(line);
        });
      });
      return [base, track];
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$p(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$p(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$p(o.key), o);
  }
}
function _createClass$p(e, r2, t) {
  return r2 && _defineProperties$p(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$p(t) {
  var i = _toPrimitive$p(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$p(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$p(t, o, e) {
  return o = _getPrototypeOf$p(o), _possibleConstructorReturn$p(t, _isNativeReflectConstruct$p() ? Reflect.construct(o, e || [], _getPrototypeOf$p(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$p(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$p(t);
}
function _assertThisInitialized$p(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$p() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$p = function() {
    return !!t;
  })();
}
function _superPropGet$c(t, o, e, r2) {
  var p = _get$c(_getPrototypeOf$p(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$c() {
  return _get$c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$c(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$c.apply(null, arguments);
}
function _superPropBase$c(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$p(t)); ) ;
  return t;
}
function _getPrototypeOf$p(t) {
  return _getPrototypeOf$p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$p(t);
}
function _inherits$p(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$p(t, e);
}
function _setPrototypeOf$p(t, e) {
  return _setPrototypeOf$p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$p(t, e);
}
let SquareMarkersTrack = /* @__PURE__ */ (function(_TiledPixiTrack) {
  function SquareMarkersTrack2(context, options2) {
    var _this;
    _classCallCheck$p(this, SquareMarkersTrack2);
    _this = _callSuper$p(this, SquareMarkersTrack2, [context, options2]);
    _this.drawnRects = /* @__PURE__ */ new Set();
    return _this;
  }
  _inherits$p(SquareMarkersTrack2, _TiledPixiTrack);
  return _createClass$p(SquareMarkersTrack2, [{
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return `${tile.join(".")}`;
    }
    /**
     * The tile identifier used on the server
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return `${tile.join(".")}`;
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
      let zoomLevel = Math.max(xZoomLevel, yZoomLevel);
      zoomLevel = Math.min(zoomLevel, this.maxZoom);
      return zoomLevel;
    }
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x)
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles(mirrorTiles = true) {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          const newTile = [zoomLevel, rows[i], cols[j]];
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile, graphics) {
    }
  }, {
    key: "draw",
    value: function draw() {
      this.drawnRects.clear();
      _superPropGet$c(SquareMarkersTrack2, "draw", this)([]);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      graphics.clear();
      const fill = colorToHex("green");
      graphics.lineStyle(1, 255, 1);
      graphics.beginFill(fill, 0.8);
      graphics.alpha = 0.5;
      for (const td of tile.tileData) {
        const startX = this._xScale(td.xStart);
        const endX = this._xScale(td.xEnd);
        const startY = this._yScale(td.yStart);
        const endY = this._yScale(td.yEnd);
        const uid = td.uid;
        if (this.drawnRects.has(uid)) {
          continue;
        }
        this.drawnRects.add(uid);
        const MIN_WIDTH = 6;
        const MIN_HEIGHT = 6;
        let width = endY - startY;
        let height = endX - startX;
        const centerX = (startX + endX) / 2;
        const centerY = (startY + endY) / 2;
        if (width < MIN_WIDTH) {
          width = MIN_WIDTH;
        }
        if (height < MIN_HEIGHT) {
          height = MIN_HEIGHT;
        }
        graphics.drawRect(centerX - width / 2, centerY - height / 2, width, height);
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$c(SquareMarkersTrack2, "setPosition", this)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.refreshTiles();
      this.draw();
    }
  }]);
})(TiledPixiTrack);
function _classCallCheck$o(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$o(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$o(o.key), o);
  }
}
function _createClass$o(e, r2, t) {
  return r2 && _defineProperties$o(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$o(t) {
  var i = _toPrimitive$o(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$o(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$o(t, o, e) {
  return o = _getPrototypeOf$o(o), _possibleConstructorReturn$o(t, _isNativeReflectConstruct$o() ? Reflect.construct(o, e || [], _getPrototypeOf$o(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$o(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$o(t);
}
function _assertThisInitialized$o(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$o() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$o = function() {
    return !!t;
  })();
}
function _superPropGet$b(t, o, e, r2) {
  var p = _get$b(_getPrototypeOf$o(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$b() {
  return _get$b = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$b(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$b.apply(null, arguments);
}
function _superPropBase$b(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$o(t)); ) ;
  return t;
}
function _getPrototypeOf$o(t) {
  return _getPrototypeOf$o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$o(t);
}
function _inherits$o(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$o(t, e);
}
function _setPrototypeOf$o(t, e) {
  return _setPrototypeOf$o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$o(t, e);
}
let HorizontalHeatmapTrack = /* @__PURE__ */ (function(_HeatmapTiledPixiTrac) {
  function HorizontalHeatmapTrack2(context, options2) {
    var _this;
    _classCallCheck$o(this, HorizontalHeatmapTrack2);
    _this = _callSuper$o(this, HorizontalHeatmapTrack2, [context, options2]);
    const {
      animate
    } = context;
    _this.pMain = _this.pMobile;
    _this.colorScale = HEATED_OBJECT_MAP;
    _this.continuousScaling = false;
    if (options2?.colorRange) {
      _this.colorScale = colorDomainToRgbaArray(options2.colorRange);
    }
    _this.animate = animate;
    _this.options = options2;
    _this.pubSubs = [];
    return _this;
  }
  _inherits$o(HorizontalHeatmapTrack2, _HeatmapTiledPixiTrac);
  return _createClass$o(HorizontalHeatmapTrack2, [{
    key: "rerender",
    value: function rerender(options2, force) {
      _superPropGet$b(HorizontalHeatmapTrack2, "rerender", this)([options2, force]);
      this.zoomed(this.xScale(), this.yScale(), this.pMain.scale.x, this.pMain.position.x, this.pMain.position.y);
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      let zoomLevel = null;
      if (this.tilesetInfo.resolutions) {
        const zoomIndexX = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        const zoomIndexY = api.calculateZoomLevelFromResolutions(this.tilesetInfo.resolutions, this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
        zoomLevel = Math.min(zoomIndexX, zoomIndexY);
      } else {
        const xZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        const yZoomLevel = api.calculateZoomLevel(this._xScale, this.tilesetInfo.min_pos[1], this.tilesetInfo.max_pos[1]);
        zoomLevel = Math.max(xZoomLevel, yZoomLevel);
        zoomLevel = Math.min(zoomLevel, this.maxZoom);
      }
      if (this.options?.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      if (!this.tilesetInfo) {
        return;
      }
      this.zoomLevel = this.calculateZoomLevel();
      const expandedXScale = this._xScale.copy();
      expandedXScale.domain([this._xScale.invert(this._xScale.range()[0] - this.dimensions[1] * Math.sqrt(2)), this._xScale.invert(this._xScale.range()[1] + this.dimensions[1] * Math.sqrt(2))]);
      if (this.tilesetInfo.resolutions) {
        const sortedResolutions = this.tilesetInfo.resolutions.map((x) => +x).sort((a, b) => b - a);
        this.xTiles = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
        this.yTiles = api.calculateTilesFromResolution(sortedResolutions[this.zoomLevel], expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0]);
      } else {
        this.xTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
        this.yTiles = api.calculateTiles(this.zoomLevel, expandedXScale, this.tilesetInfo.min_pos[0], this.tilesetInfo.max_pos[0], this.tilesetInfo.max_zoom, this.tilesetInfo.max_width);
      }
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const maxWidth = this.tilesetInfo.max_width;
      const tileWidth = maxWidth / 2 ** zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = i; j < cols.length; j++) {
          const tileBottomPosition = (j - i - 2) * (this._xScale(tileWidth) - this._xScale(0)) * Math.sqrt(2) / 2;
          if (tileBottomPosition > this.dimensions[1]) {
            continue;
          }
          const newTile = [zoomLevel, rows[i], cols[j]];
          newTile.mirrored = false;
          newTile.dataTransform = this.options.dataTransform ? this.options.dataTransform : "default";
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "tileDataToCanvas",
    value: function tileDataToCanvas(pixData) {
      const canvas = document.createElement("canvas");
      canvas.width = 256;
      canvas.height = 256;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const pix = new ImageData(pixData, canvas.width, canvas.height);
      ctx.putImageData(pix, 0, 0);
      return canvas;
    }
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos, mirrored) {
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(zoomLevel, tilePos);
      const tileEndX = tileX + tileWidth;
      const tileEndY = tileY + tileHeight;
      sprite.width = this._refXScale(tileEndX) - this._refXScale(tileX);
      sprite.height = this._refYScale(tileEndY) - this._refYScale(tileY);
      sprite.x = this._refXScale(tileX);
      sprite.y = this._refYScale(tileY);
    }
  }, {
    key: "pixDataFunction",
    value: function pixDataFunction(tile, pixData) {
      if (pixData) {
        const graphics = tile.graphics;
        const canvas = this.tileDataToCanvas(pixData.pixData);
        const texture = GLOBALS.PIXI.VERSION[0] === "4" ? GLOBALS.PIXI.Texture.fromCanvas(canvas, GLOBALS.PIXI.SCALE_MODES.NEAREST) : GLOBALS.PIXI.Texture.from(canvas, {
          scaleMode: GLOBALS.PIXI.SCALE_MODES.NEAREST
        });
        tile.sprite = new GLOBALS.PIXI.Sprite(texture);
        tile.canvas = canvas;
        this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored);
        graphics.pivot.x = this._refXScale(0);
        graphics.pivot.y = this._refYScale(0);
        graphics.scale.x = -1 / Math.sqrt(2);
        graphics.rotation = -3 * Math.PI / 4;
        graphics.scale.y = 1 / Math.sqrt(2);
        graphics.position.x = this._refXScale(0);
        graphics.position.y = 0;
        graphics.removeChildren();
        graphics.addChild(tile.sprite);
      }
      this.renderingTiles.delete(tile.tileId);
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _superPropGet$b(HorizontalHeatmapTrack2, "refScalesChanged", this)([refXScale, refYScale]);
      for (const uid in this.fetchedTiles) {
        const tile = this.fetchedTiles[uid];
        if (tile.sprite) {
          this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos, tile.mirrored);
          const graphics = tile.graphics;
          graphics.pivot.x = this._refXScale(0);
          graphics.pivot.y = this._refYScale(0);
          graphics.scale.x = -1 / Math.sqrt(2);
          graphics.rotation = -3 * Math.PI / 4;
          graphics.scale.y = 1 / Math.sqrt(2);
          graphics.position.x = this._refXScale(0);
          graphics.position.y = 0;
        }
      }
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _superPropGet$b(HorizontalHeatmapTrack2, "zoomed", this)([newXScale, newYScale, k, tx, ty]);
      _superPropGet$b(HorizontalHeatmapTrack2, "draw", this)([]);
      this.pMain.position.x = tx;
      this.pMain.position.y = this.position[1] + this.dimensions[1];
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      if (this.options.oneDHeatmapFlipped) {
        this.pMain.scale.y = -k;
        this.pMain.position.y = this.position[1];
      }
    }
  }, {
    key: "leftTrackDraw",
    value: function leftTrackDraw() {
      this.draw();
    }
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      [base, track] = _superPropGet$b(HorizontalHeatmapTrack2, "superSVG", this)([]);
      const output = document.createElement("g");
      track.appendChild(output);
      output.setAttribute("transform", `translate(${this.pMain.position.x},${this.pMain.position.y}) scale(${this.pMain.scale.x},${this.pMain.scale.y})`);
      for (const tile of this.visibleAndFetchedTiles()) {
        const gGraphics = document.createElement("g");
        const graphics = tile.graphics;
        const graphicsRotation = graphics.rotation * 180 / Math.PI;
        const transformText = `translate(${graphics.position.x},${graphics.position.y}) rotate(${graphicsRotation}) scale(${graphics.scale.x},${graphics.scale.y}) translate(${-graphics.pivot.x},${-graphics.pivot.y})`;
        gGraphics.setAttribute("transform", transformText);
        const rotation2 = tile.sprite.rotation * 180 / Math.PI;
        const g = document.createElement("g");
        g.setAttribute("transform", `translate(${tile.sprite.x},${tile.sprite.y}) rotate(${rotation2}) scale(${tile.sprite.scale.x},${tile.sprite.scale.y})`);
        const image2 = document.createElement("image");
        image2.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", tile.canvas.toDataURL());
        image2.setAttribute("width", 256);
        image2.setAttribute("height", 256);
        g.appendChild(image2);
        gGraphics.appendChild(g);
        output.appendChild(gGraphics);
      }
      const gColorbar = this.exportColorBarSVG();
      track.appendChild(gColorbar);
      return [base, base];
    }
  }]);
})(HeatmapTiledPixiTrack);
function _classCallCheck$n(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$n(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$n(o.key), o);
  }
}
function _createClass$n(e, r2, t) {
  return r2 && _defineProperties$n(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$n(t) {
  var i = _toPrimitive$n(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$n(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$n(t, o, e) {
  return o = _getPrototypeOf$n(o), _possibleConstructorReturn$n(t, _isNativeReflectConstruct$n() ? Reflect.construct(o, e || [], _getPrototypeOf$n(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$n(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$n(t);
}
function _assertThisInitialized$n(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$n() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$n = function() {
    return !!t;
  })();
}
function _getPrototypeOf$n(t) {
  return _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$n(t);
}
function _inherits$n(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$n(t, e);
}
function _setPrototypeOf$n(t, e) {
  return _setPrototypeOf$n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$n(t, e);
}
let UnknownPixiTrack = /* @__PURE__ */ (function(_PixiTrack) {
  function UnknownPixiTrack2(context, options2) {
    var _this;
    _classCallCheck$n(this, UnknownPixiTrack2);
    _this = _callSuper$n(this, UnknownPixiTrack2, [context, options2]);
    _this.tilesetInfo = {};
    _this.setError(`Unknown track type: ${options2.type}`);
    return _this;
  }
  _inherits$n(UnknownPixiTrack2, _PixiTrack);
  return _createClass$n(UnknownPixiTrack2, [{
    key: "zoomed",
    value: function zoomed() {
      this.draw();
    }
  }]);
})(PixiTrack);
function _classCallCheck$m(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$m(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$m(o.key), o);
  }
}
function _createClass$m(e, r2, t) {
  return r2 && _defineProperties$m(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$m(t) {
  var i = _toPrimitive$m(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$m(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$m(t, o, e) {
  return o = _getPrototypeOf$m(o), _possibleConstructorReturn$m(t, _isNativeReflectConstruct$m() ? Reflect.construct(o, e || [], _getPrototypeOf$m(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$m(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$m(t);
}
function _assertThisInitialized$m(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$m() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$m = function() {
    return !!t;
  })();
}
function _getPrototypeOf$m(t) {
  return _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$m(t);
}
function _inherits$m(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$m(t, e);
}
function _setPrototypeOf$m(t, e) {
  return _setPrototypeOf$m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$m(t, e);
}
let ValueIntervalTrack = /* @__PURE__ */ (function(_HorizontalLine1DPixi) {
  function ValueIntervalTrack2(context, options2) {
    var _this;
    _classCallCheck$m(this, ValueIntervalTrack2);
    _this = _callSuper$m(this, ValueIntervalTrack2, [context, options2]);
    _this.axis = new AxisPixi(_this);
    _this.pBase.addChild(_this.axis.pAxis);
    return _this;
  }
  _inherits$m(ValueIntervalTrack2, _HorizontalLine1DPixi);
  return _createClass$m(ValueIntervalTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      this.scale.minRawValue = this.minVisibleValueInTiles();
      this.scale.maxRawValue = this.minVisibleValueInTiles();
      this.scale.minValue = this.scale.minRawValue;
      this.scale.maxValue = this.scale.maxRawValue;
      this.drawTile(tile);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      if (!tile.graphics) {
        return;
      }
      const graphics = tile.graphics;
      const RECT_HEIGHT = 6;
      const MIN_RECT_WIDTH = 4;
      graphics.clear();
      this.valueScale = log$2().domain([this.minValue() + 0.01, this.maxValue()]).range([this.dimensions[1] - RECT_HEIGHT / 2, RECT_HEIGHT / 2]);
      const fill = colorToHex("black");
      graphics.lineStyle(1, fill, 0.3);
      graphics.beginFill(fill, 0.3);
      this.drawAxis(this.valueScale);
      tile.tileData.forEach((td) => {
        const fields = td.fields;
        const chrOffset = +td.chrOffset;
        const genomeStart = +fields[1] + chrOffset;
        const genomeEnd = +fields[2] + chrOffset;
        const value = +fields[3];
        const startPos = this._xScale(genomeStart);
        const endPos = this._xScale(genomeEnd);
        const width = Math.max(endPos - startPos, MIN_RECT_WIDTH);
        const midY = this.valueScale(value);
        const midX = (endPos + startPos) / 2;
        graphics.drawRect(midX - width / 2, midY - RECT_HEIGHT / 2, width, RECT_HEIGHT);
      });
    }
  }, {
    key: "minVisibleValueInTiles",
    value: function minVisibleValueInTiles() {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const min2 = Math.min.apply(null, visibleAndFetchedIds.map((x) => +Math.min(...this.fetchedTiles[x].tileData.filter((y) => !Number.isNaN(y.fields[3])).map((y) => +y.fields[3]))));
      return min2;
    }
  }, {
    key: "maxVisibleValueInTiles",
    value: function maxVisibleValueInTiles() {
      let visibleAndFetchedIds = this.visibleAndFetchedIds();
      if (visibleAndFetchedIds.length === 0) {
        visibleAndFetchedIds = Object.keys(this.fetchedTiles);
      }
      const max2 = Math.max.apply(null, visibleAndFetchedIds.map((x) => +Math.max(...this.fetchedTiles[x].tileData.filter((y) => !Number.isNaN(y.fields[3])).map((y) => +y.fields[3]))));
      return max2;
    }
  }]);
})(HorizontalLine1DPixiTrack);
function _classCallCheck$l(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$l(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$l(o.key), o);
  }
}
function _createClass$l(e, r2, t) {
  return r2 && _defineProperties$l(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$l(t) {
  var i = _toPrimitive$l(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$l(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$l(t, o, e) {
  return o = _getPrototypeOf$l(o), _possibleConstructorReturn$l(t, _isNativeReflectConstruct$l() ? Reflect.construct(o, e || [], _getPrototypeOf$l(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$l(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$l(t);
}
function _assertThisInitialized$l(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$l() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$l = function() {
    return !!t;
  })();
}
function _superPropGet$a(t, o, e, r2) {
  var p = _get$a(_getPrototypeOf$l(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$a() {
  return _get$a = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$a(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$a.apply(null, arguments);
}
function _superPropBase$a(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$l(t)); ) ;
  return t;
}
function _getPrototypeOf$l(t) {
  return _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$l(t);
}
function _inherits$l(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$l(t, e);
}
function _setPrototypeOf$l(t, e) {
  return _setPrototypeOf$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$l(t, e);
}
let ViewportTracker2D$1 = /* @__PURE__ */ (function(_SVGTrack) {
  function ViewportTracker2D2(context, options2) {
    var _this;
    _classCallCheck$l(this, ViewportTracker2D2);
    _this = _callSuper$l(this, ViewportTracker2D2, [context, options2]);
    const {
      registerViewportChanged,
      removeViewportChanged,
      setDomainsCallback
    } = context;
    const uid = slugid.nice();
    _this.uid = uid;
    _this.options = options2;
    _this.hasFromView = !context.projectionXDomain || !context.projectionYDomain;
    _this.removeViewportChanged = removeViewportChanged;
    _this.setDomainsCallback = setDomainsCallback;
    _this.viewportXDomain = _this.hasFromView ? null : context.projectionXDomain;
    _this.viewportYDomain = _this.hasFromView ? null : context.projectionYDomain;
    _this.brush = brush().on("brush", _this.brushed.bind(_this));
    _this.gBrush = _this.gMain.append("g").attr("id", `brush-${_this.uid}`).call(_this.brush);
    _this.gBrush.selectAll(".overlay").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--n").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--s").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--w").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--e").style("pointer-events", "none");
    registerViewportChanged(uid, _this.viewportChanged.bind(_this));
    _this.rerender();
    _this.draw();
    return _this;
  }
  _inherits$l(ViewportTracker2D2, _SVGTrack);
  return _createClass$l(ViewportTracker2D2, [{
    key: "brushed",
    value: function brushed(event) {
      const s = event.selection;
      if (!this._xScale || !this._yScale) {
        return;
      }
      const xDomain = [this._xScale.invert(s[0][0]), this._xScale.invert(s[1][0])];
      const yDomain = [this._yScale.invert(s[0][1]), this._yScale.invert(s[1][1])];
      if (!this.hasFromView) {
        this.viewportXDomain = xDomain;
        this.viewportYDomain = yDomain;
      }
      this.setDomainsCallback(xDomain, yDomain);
    }
  }, {
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove2() {
      this.removeViewportChanged(this.uid);
      _superPropGet$a(ViewportTracker2D2, "remove", this)([]);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.gBrush.selectAll(".selection").attr("fill", this.options.projectionFillColor).attr("stroke", this.options.projectionStrokeColor).attr("fill-opacity", this.options.projectionFillOpacity).attr("stroke-opacity", this.options.projectionStrokeOpacity).attr("stroke-width", this.options.strokeWidth);
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this._xScale || !this.yScale) {
        return;
      }
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      const x02 = this._xScale(this.viewportXDomain[0]);
      const y02 = this._yScale(this.viewportYDomain[0]);
      const x12 = this._xScale(this.viewportXDomain[1]);
      const y12 = this._yScale(this.viewportYDomain[1]);
      const dest = [[x02, y02], [x12, y12]];
      this.brush.on("brush", null);
      this.gBrush.call(this.brush.move, dest);
      this.brush.on("brush", this.brushed.bind(this));
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$a(ViewportTracker2D2, "setPosition", this)([newPosition]);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$a(ViewportTracker2D2, "setDimensions", this)([newDimensions]);
      const xRange = this._xScale.range();
      const yRange = this._yScale.range();
      const xDiff = xRange[1] - xRange[0];
      const yDiff = yRange[1] - yRange[0];
      this.brush.extent([[xRange[0] - xDiff, yRange[0] - yDiff], [xRange[1] + xDiff, yRange[1] + yDiff]]);
      this.gBrush.call(this.brush);
      this.draw();
    }
  }]);
})(SVGTrack);
function _classCallCheck$k(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$k(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$k(o.key), o);
  }
}
function _createClass$k(e, r2, t) {
  return r2 && _defineProperties$k(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$k(t) {
  var i = _toPrimitive$k(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$k(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$k(t, o, e) {
  return o = _getPrototypeOf$k(o), _possibleConstructorReturn$k(t, _isNativeReflectConstruct$k() ? Reflect.construct(o, e || [], _getPrototypeOf$k(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$k(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$k(t);
}
function _assertThisInitialized$k(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$k() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$k = function() {
    return !!t;
  })();
}
function _superPropGet$9(t, o, e, r2) {
  var p = _get$9(_getPrototypeOf$k(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$9() {
  return _get$9 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$9(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$9.apply(null, arguments);
}
function _superPropBase$9(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$k(t)); ) ;
  return t;
}
function _getPrototypeOf$k(t) {
  return _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$k(t);
}
function _inherits$k(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$k(t, e);
}
function _setPrototypeOf$k(t, e) {
  return _setPrototypeOf$k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$k(t, e);
}
let ViewportTrackerHorizontal = /* @__PURE__ */ (function(_SVGTrack) {
  function ViewportTrackerHorizontal2(context, options2) {
    var _this;
    _classCallCheck$k(this, ViewportTrackerHorizontal2);
    _this = _callSuper$k(this, ViewportTrackerHorizontal2, [context, options2]);
    const {
      registerViewportChanged,
      removeViewportChanged,
      setDomainsCallback
    } = context;
    const uid = slugid.nice();
    _this.uid = uid;
    _this.options = options2;
    _this.hasFromView = !context.projectionXDomain;
    _this.removeViewportChanged = removeViewportChanged;
    _this.setDomainsCallback = setDomainsCallback;
    _this.viewportXDomain = _this.hasFromView ? null : context.projectionXDomain;
    _this.viewportYDomain = _this.hasFromView ? null : [0, 0];
    _this.brush = brushX().on("brush", _this.brushed.bind(_this));
    _this.gBrush = _this.gMain.append("g").attr("id", `brush-${_this.uid}`).call(_this.brush);
    _this.gBrush.selectAll(".overlay").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--ne").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--nw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--sw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--se").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--n").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--s").style("pointer-events", "none");
    registerViewportChanged(uid, _this.viewportChanged.bind(_this));
    _this.rerender();
    _this.draw();
    return _this;
  }
  _inherits$k(ViewportTrackerHorizontal2, _SVGTrack);
  return _createClass$k(ViewportTrackerHorizontal2, [{
    key: "brushed",
    value: function brushed(event) {
      const s = event.selection;
      if (!this._xScale || !this._yScale) {
        return;
      }
      const xDomain = [this._xScale.invert(s[0]), this._xScale.invert(s[1])];
      const yDomain = this.viewportYDomain;
      if (!this.hasFromView) {
        this.viewportXDomain = xDomain;
      }
      this.setDomainsCallback(xDomain, yDomain);
    }
  }, {
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale, update = true) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove2() {
      this.removeViewportChanged(this.uid);
      _superPropGet$9(ViewportTrackerHorizontal2, "remove", this)([]);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.gBrush.selectAll(".selection").attr("fill", this.options.projectionFillColor).attr("stroke", this.options.projectionStrokeColor).attr("fill-opacity", this.options.projectionFillOpacity).attr("stroke-opacity", this.options.projectionStrokeOpacity).attr("stroke-width", this.options.strokeWidth);
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this._xScale || !this.yScale) {
        return;
      }
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      const x02 = this._xScale(this.viewportXDomain[0]);
      const x12 = this._xScale(this.viewportXDomain[1]);
      const dest = [x02, x12];
      this.brush.on("brush", null);
      this.gBrush.call(this.brush.move, dest);
      this.brush.on("brush", this.brushed.bind(this));
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$9(ViewportTrackerHorizontal2, "setPosition", this)([newPosition]);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$9(ViewportTrackerHorizontal2, "setDimensions", this)([newDimensions]);
      const xRange = this._xScale.range();
      const yRange = this._yScale.range();
      const xDiff = xRange[1] - xRange[0];
      this.brush.extent([[xRange[0] - xDiff, yRange[0]], [xRange[1] + xDiff, yRange[1]]]);
      this.gBrush.call(this.brush);
      this.draw();
    }
  }]);
})(SVGTrack);
function _classCallCheck$j(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$j(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$j(o.key), o);
  }
}
function _createClass$j(e, r2, t) {
  return r2 && _defineProperties$j(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$j(t) {
  var i = _toPrimitive$j(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$j(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$j(t, o, e) {
  return o = _getPrototypeOf$j(o), _possibleConstructorReturn$j(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf$j(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$j(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$j(t);
}
function _assertThisInitialized$j(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$j() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$j = function() {
    return !!t;
  })();
}
function _superPropGet$8(t, o, e, r2) {
  var p = _get$8(_getPrototypeOf$j(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$8() {
  return _get$8 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$8(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$8.apply(null, arguments);
}
function _superPropBase$8(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$j(t)); ) ;
  return t;
}
function _getPrototypeOf$j(t) {
  return _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$j(t);
}
function _inherits$j(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$j(t, e);
}
function _setPrototypeOf$j(t, e) {
  return _setPrototypeOf$j = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$j(t, e);
}
let ViewportTrackerVertical = /* @__PURE__ */ (function(_SVGTrack) {
  function ViewportTrackerVertical2(context, options2) {
    var _this;
    _classCallCheck$j(this, ViewportTrackerVertical2);
    _this = _callSuper$j(this, ViewportTrackerVertical2, [context, options2]);
    const {
      registerViewportChanged,
      removeViewportChanged,
      setDomainsCallback
    } = context;
    const uid = slugid.nice();
    _this.uid = uid;
    _this.options = options2;
    _this.hasFromView = !context.projectionYDomain;
    _this.removeViewportChanged = removeViewportChanged;
    _this.setDomainsCallback = setDomainsCallback;
    _this.viewportXDomain = _this.hasFromView ? null : [0, 0];
    _this.viewportYDomain = _this.hasFromView ? null : context.projectionYDomain;
    _this.brush = brushY().on("brush", _this.brushed.bind(_this));
    _this.gBrush = _this.gMain.append("g").attr("id", `brush-${_this.uid}`).call(_this.brush);
    _this.gBrush.selectAll(".overlay").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--ne").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--nw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--sw").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--se").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--e").style("pointer-events", "none");
    _this.gBrush.selectAll(".handle--w").style("pointer-events", "none");
    registerViewportChanged(uid, _this.viewportChanged.bind(_this));
    _this.rerender();
    _this.draw();
    return _this;
  }
  _inherits$j(ViewportTrackerVertical2, _SVGTrack);
  return _createClass$j(ViewportTrackerVertical2, [{
    key: "brushed",
    value: function brushed(event) {
      const s = event.selection;
      if (!this._xScale || !this._yScale) {
        return;
      }
      const xDomain = this.viewportXDomain;
      const yDomain = [this._yScale.invert(s[0]), this._yScale.invert(s[1])];
      if (!this.hasFromView) {
        this.viewportYDomain = yDomain;
      }
      this.setDomainsCallback(xDomain, yDomain);
    }
  }, {
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale, update = true) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "remove",
    value: function remove2() {
      this.removeViewportChanged(this.uid);
      _superPropGet$8(ViewportTrackerVertical2, "remove", this)([]);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.gBrush.selectAll(".selection").attr("fill", this.options.projectionFillColor).attr("stroke", this.options.projectionStrokeColor).attr("fill-opacity", this.options.projectionFillOpacity).attr("stroke-opacity", this.options.projectionStrokeOpacity).attr("stroke-width", this.options.strokeWidth);
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this._xScale || !this.yScale) {
        return;
      }
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      const y02 = this._yScale(this.viewportYDomain[0]);
      const y12 = this._yScale(this.viewportYDomain[1]);
      const dest = [y02, y12];
      this.brush.on("brush", null);
      this.gBrush.call(this.brush.move, dest);
      this.brush.on("brush", this.brushed.bind(this));
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$8(ViewportTrackerVertical2, "setPosition", this)([newPosition]);
      this.draw();
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$8(ViewportTrackerVertical2, "setDimensions", this)([newDimensions]);
      const xRange = this._xScale.range();
      const yRange = this._yScale.range();
      const yDiff = yRange[1] - yRange[0];
      this.brush.extent([[xRange[0], yRange[0] - yDiff], [xRange[1], yRange[1] + yDiff]]);
      this.gBrush.call(this.brush);
      this.draw();
    }
  }]);
})(SVGTrack);
function _classCallCheck$i(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$i(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$i(o.key), o);
  }
}
function _createClass$i(e, r2, t) {
  return r2 && _defineProperties$i(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$i(t) {
  var i = _toPrimitive$i(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$i(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$i(t, o, e) {
  return o = _getPrototypeOf$i(o), _possibleConstructorReturn$i(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf$i(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$i(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$i(t);
}
function _assertThisInitialized$i(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$i() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$i = function() {
    return !!t;
  })();
}
function _superPropGet$7(t, o, e, r2) {
  var p = _get$7(_getPrototypeOf$i(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$7() {
  return _get$7 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$7(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$7.apply(null, arguments);
}
function _superPropBase$7(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$i(t)); ) ;
  return t;
}
function _getPrototypeOf$i(t) {
  return _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$i(t);
}
function _inherits$i(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$i(t, e);
}
function _setPrototypeOf$i(t, e) {
  return _setPrototypeOf$i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$i(t, e);
}
const RuleMixin = Mixin((superclass) => /* @__PURE__ */ (function(_superclass) {
  function _class(context, options2) {
    var _this;
    _classCallCheck$i(this, _class);
    _this = _callSuper$i(this, _class, [context, options2]);
    const {
      animate
    } = context;
    _this.highlighted = false;
    _this.animate = animate;
    _this.MOUSEOVER_RADIUS = 4;
    _this.pubSub = context.pubSub;
    _this.pubSubs.push(_this.pubSub.subscribe("app.mouseMove", _this.mouseMoveHandler.bind(_this)));
    return _this;
  }
  _inherits$i(_class, _superclass);
  return _createClass$i(_class, [{
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$7(_class, "setPosition", this)([newPosition]);
      this.pMain.position.x = this.position[0];
      this.pMain.position.y = this.position[1];
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      _superPropGet$7(_class, "zoomed", this)([newXScale, newYScale]);
      this.draw();
    }
  }, {
    key: "respondsToPosition",
    value: function respondsToPosition() {
      return this.highlighted;
    }
  }]);
})(superclass));
function _superPropGet$6(t, o, e, r2) {
  var p = _get$6(_getPrototypeOf$h(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$6() {
  return _get$6 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$6(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$6.apply(null, arguments);
}
function _superPropBase$6(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$h(t)); ) ;
  return t;
}
function _classCallCheck$h(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$h(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$h(o.key), o);
  }
}
function _createClass$h(e, r2, t) {
  return r2 && _defineProperties$h(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$h(t) {
  var i = _toPrimitive$h(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$h(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$h(t, o, e) {
  return o = _getPrototypeOf$h(o), _possibleConstructorReturn$h(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf$h(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$h(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$h(t);
}
function _assertThisInitialized$h(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$h() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$h = function() {
    return !!t;
  })();
}
function _getPrototypeOf$h(t) {
  return _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$h(t);
}
function _inherits$h(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$h(t, e);
}
function _setPrototypeOf$h(t, e) {
  return _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$h(t, e);
}
const VerticalRuleMixin = Mixin((superclass) => /* @__PURE__ */ (function(_superclass) {
  function _class() {
    _classCallCheck$h(this, _class);
    return _callSuper$h(this, _class, arguments);
  }
  _inherits$h(_class, _superclass);
  return _createClass$h(_class, [{
    key: "drawVerticalRule",
    value: function drawVerticalRule(graphics) {
      let stroke = colorToHex(this.options.color || "black");
      if (this.highlighted) {
        stroke = colorToHex("red");
      }
      graphics.lineStyle(this.strokeWidth, stroke, this.strokeOpacity);
      let pos = 0;
      while (pos < this.dimensions[1]) {
        graphics.moveTo(this._xScale(this.xPosition), pos);
        graphics.lineTo(this._xScale(this.xPosition), pos + this.dashLength);
        pos += this.dashLength + this.dashGap;
      }
    }
  }, {
    key: "isMouseOverVerticalLine",
    value: function isMouseOverVerticalLine(mousePos) {
      return Math.abs(mousePos.x - this.position[0] - this._xScale(this.xPosition)) < this.MOUSEOVER_RADIUS;
    }
  }]);
})(superclass));
let VerticalRule = /* @__PURE__ */ (function(_mix$with) {
  function VerticalRule2(context, options2) {
    var _this;
    _classCallCheck$h(this, VerticalRule2);
    _this = _callSuper$h(this, VerticalRule2, [context, options2]);
    _this.xPosition = context.xPosition;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.dashLength = 5;
    _this.dashGap = 3;
    return _this;
  }
  _inherits$h(VerticalRule2, _mix$with);
  return _createClass$h(VerticalRule2, [{
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      graphics.clear();
      this.drawVerticalRule(graphics);
      this.animate();
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$6(VerticalRule2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$6(VerticalRule2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("class", "vertical-rule");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const stroke = this.options.color || "black";
      const line = document.createElement("line");
      line.setAttribute("stroke", stroke);
      line.setAttribute("stroke-width", this.strokeWidth);
      line.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      line.setAttribute("x1", this._xScale(this.xPosition));
      line.setAttribute("y1", 0);
      line.setAttribute("x2", this._xScale(this.xPosition));
      line.setAttribute("y2", this.dimensions[1]);
      output.appendChild(line);
      return [base, track];
    }
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(mousePos) {
      this.highlighted = this.isWithin(mousePos.x, mousePos.y) && this.isMouseOverVerticalLine(mousePos);
      this.draw();
    }
  }]);
})(mix(PixiTrack).with(RuleMixin, VerticalRuleMixin));
function _classCallCheck$g(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$g(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$g(o.key), o);
  }
}
function _createClass$g(e, r2, t) {
  return r2 && _defineProperties$g(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$g(t) {
  var i = _toPrimitive$g(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$g(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$g(t, o, e) {
  return o = _getPrototypeOf$g(o), _possibleConstructorReturn$g(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf$g(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$g(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$g(t);
}
function _assertThisInitialized$g(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$g() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$g = function() {
    return !!t;
  })();
}
function _superPropGet$5(t, o, e, r2) {
  var p = _get$5(_getPrototypeOf$g(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$5() {
  return _get$5 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$5(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$5.apply(null, arguments);
}
function _superPropBase$5(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$g(t)); ) ;
  return t;
}
function _getPrototypeOf$g(t) {
  return _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$g(t);
}
function _inherits$g(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$g(t, e);
}
function _setPrototypeOf$g(t, e) {
  return _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$g(t, e);
}
let CrossRule = /* @__PURE__ */ (function(_mix$with) {
  function CrossRule2(context, options2) {
    var _this;
    _classCallCheck$g(this, CrossRule2);
    _this = _callSuper$g(this, CrossRule2, [context, options2]);
    const {
      x,
      y
    } = context;
    _this.xPosition = x;
    _this.yPosition = y;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.dashLength = 5;
    _this.dashGap = 3;
    return _this;
  }
  _inherits$g(CrossRule2, _mix$with);
  return _createClass$g(CrossRule2, [{
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      graphics.clear();
      this.drawHorizontalRule(graphics);
      this.drawVerticalRule(graphics);
    }
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(mousePos) {
      this.highlighted = this.isWithin(mousePos.x, mousePos.y) && (this.isMouseOverHorizontalLine(mousePos) || this.isMouseOverVerticalLine(mousePos));
      this.draw();
    }
  }, {
    key: "drawHorizontalRule",
    value: function drawHorizontalRule(graphics) {
      let stroke = colorToHex(this.options.color || "black");
      if (this.highlighted) {
        stroke = colorToHex("red");
      }
      graphics.lineStyle(this.strokeWidth, stroke, this.strokeOpacity);
      let pos = 0;
      while (pos < this.dimensions[0]) {
        graphics.moveTo(pos, this._yScale(this.yPosition));
        graphics.lineTo(pos + this.dashLength, this._yScale(this.yPosition));
        pos += this.dashLength + this.dashGap;
      }
    }
  }, {
    key: "isMouseOverHorizontalLine",
    value: function isMouseOverHorizontalLine(mousePos) {
      return Math.abs(mousePos.y - this.position[1] - this._yScale(this.yPosition)) < this.MOUSEOVER_RADIUS;
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$5(CrossRule2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$5(CrossRule2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("class", "cross-rule");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const stroke = this.options.color || "black";
      const verticalLine = document.createElement("line");
      verticalLine.setAttribute("stroke", stroke);
      verticalLine.setAttribute("stroke-width", this.strokeWidth);
      verticalLine.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      verticalLine.setAttribute("x1", this._xScale(this.xPosition));
      verticalLine.setAttribute("y1", 0);
      verticalLine.setAttribute("x2", this._xScale(this.xPosition));
      verticalLine.setAttribute("y2", this.dimensions[1]);
      const horizontalLine = document.createElement("line");
      horizontalLine.setAttribute("stroke", stroke);
      horizontalLine.setAttribute("stroke-width", this.strokeWidth);
      horizontalLine.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      horizontalLine.setAttribute("x1", 0);
      horizontalLine.setAttribute("y1", this._yScale(this.yPosition));
      horizontalLine.setAttribute("x2", this.dimensions[0]);
      horizontalLine.setAttribute("y2", this._yScale(this.yPosition));
      output.appendChild(verticalLine);
      output.appendChild(horizontalLine);
      return [base, track];
    }
  }]);
})(mix(PixiTrack).with(RuleMixin, VerticalRuleMixin));
function _superPropGet$4(t, o, e, r2) {
  var p = _get$4(_getPrototypeOf$f(1 & r2 ? t.prototype : t), o, e);
  return 2 & r2 && "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$4() {
  return _get$4 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$4(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$4.apply(null, arguments);
}
function _superPropBase$4(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$f(t)); ) ;
  return t;
}
function _classCallCheck$f(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$f(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$f(o.key), o);
  }
}
function _createClass$f(e, r2, t) {
  return r2 && _defineProperties$f(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$f(t) {
  var i = _toPrimitive$f(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$f(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$f(t, o, e) {
  return o = _getPrototypeOf$f(o), _possibleConstructorReturn$f(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf$f(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$f(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$f(t);
}
function _assertThisInitialized$f(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$f() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$f = function() {
    return !!t;
  })();
}
function _getPrototypeOf$f(t) {
  return _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$f(t);
}
function _inherits$f(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$f(t, e);
}
function _setPrototypeOf$f(t, e) {
  return _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$f(t, e);
}
const HorizontalRuleMixin = Mixin((superclass) => /* @__PURE__ */ (function(_superclass) {
  function _class() {
    _classCallCheck$f(this, _class);
    return _callSuper$f(this, _class, arguments);
  }
  _inherits$f(_class, _superclass);
  return _createClass$f(_class, [{
    key: "drawHorizontalRule",
    value: function drawHorizontalRule(graphics) {
      let stroke = colorToHex(this.options.color || "black");
      if (this.highlighted) {
        stroke = colorToHex("red");
      }
      graphics.lineStyle(this.strokeWidth, stroke, this.strokeOpacity);
      let pos = 0;
      while (pos < this.dimensions[0]) {
        graphics.moveTo(pos, this._yScale(this.yPosition));
        graphics.lineTo(pos + this.dashLength, this._yScale(this.yPosition));
        pos += this.dashLength + this.dashGap;
      }
    }
  }, {
    key: "isMouseOverHorizontalLine",
    value: function isMouseOverHorizontalLine(mousePos) {
      if (Math.abs(mousePos.y - this.position[1] - this._yScale(this.yPosition)) < this.MOUSEOVER_RADIUS) {
        return true;
      }
      return false;
    }
  }]);
})(superclass));
let HorizontalRule = /* @__PURE__ */ (function(_mix$with) {
  function HorizontalRule2(context, options2) {
    var _this;
    _classCallCheck$f(this, HorizontalRule2);
    _this = _callSuper$f(this, HorizontalRule2, [context, options2]);
    _this.yPosition = context.yPosition;
    _this.strokeWidth = 2;
    _this.strokeOpacity = 1;
    _this.dashLength = 5;
    _this.dashGap = 3;
    return _this;
  }
  _inherits$f(HorizontalRule2, _mix$with);
  return _createClass$f(HorizontalRule2, [{
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(mousePos) {
      if (this.isWithin(mousePos.x, mousePos.y) && this.isMouseOverHorizontalLine(mousePos)) {
        this.highlighted = true;
        this.draw();
        return;
      }
      this.highlighted = false;
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      graphics.clear();
      this.drawHorizontalRule(graphics);
      this.animate();
    }
    /**
     * Export an SVG representation of this track
     *
     * @returns {Array} The two returned DOM nodes are both SVG
     * elements [base,track]. Base is a parent which contains track as a
     * child. Track is clipped with a clipping rectangle contained in base.
     *
     */
  }, {
    key: "exportSVG",
    value: function exportSVG() {
      let track = null;
      let base = null;
      if (_superPropGet$4(HorizontalRule2, "exportSVG", this, 1)) {
        [base, track] = _superPropGet$4(HorizontalRule2, "exportSVG", this, 3)([]);
      } else {
        base = document.createElement("g");
        track = base;
      }
      const output = document.createElement("g");
      output.setAttribute("class", "horizontal-rule");
      output.setAttribute("transform", `translate(${this.position[0]},${this.position[1]})`);
      track.appendChild(output);
      const stroke = this.options.color || "black";
      const line = document.createElement("line");
      line.setAttribute("stroke", stroke);
      line.setAttribute("stroke-width", this.strokeWidth);
      line.setAttribute("stroke-dasharray", `${this.dashLength} ${this.dashGap}`);
      line.setAttribute("x1", 0);
      line.setAttribute("y1", this._yScale(this.yPosition));
      line.setAttribute("x2", this.dimensions[0]);
      line.setAttribute("y2", this._yScale(this.yPosition));
      output.appendChild(line);
      return [base, track];
    }
  }]);
})(mix(PixiTrack).with(RuleMixin, HorizontalRuleMixin));
function _classCallCheck$e(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$e(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$e(o.key), o);
  }
}
function _createClass$e(e, r2, t) {
  return r2 && _defineProperties$e(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$e(t) {
  var i = _toPrimitive$e(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$e(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$e(t, o, e) {
  return o = _getPrototypeOf$e(o), _possibleConstructorReturn$e(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf$e(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$e(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$e(t);
}
function _assertThisInitialized$e(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$e() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$e = function() {
    return !!t;
  })();
}
function _superPropGet$3(t, o, e, r2) {
  var p = _get$3(_getPrototypeOf$e(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$3() {
  return _get$3 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$3(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$3.apply(null, arguments);
}
function _superPropBase$3(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$e(t)); ) ;
  return t;
}
function _getPrototypeOf$e(t) {
  return _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$e(t);
}
function _inherits$e(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$e(t, e);
}
function _setPrototypeOf$e(t, e) {
  return _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$e(t, e);
}
let OSMTilesTrack = /* @__PURE__ */ (function(_PixiTrack) {
  function OSMTilesTrack2(context, options2) {
    var _this;
    _classCallCheck$e(this, OSMTilesTrack2);
    _this = _callSuper$e(this, OSMTilesTrack2, [context, options2]);
    const {
      animate
    } = context;
    _this.visibleTiles = /* @__PURE__ */ new Set();
    _this.visibleTileIds = /* @__PURE__ */ new Set();
    _this.fetching = /* @__PURE__ */ new Set();
    _this.fetchedTiles = {};
    _this.tileGraphics = {};
    _this.minX = typeof _this.options.minPos !== "undefined" && !Number.isNaN(+_this.options.minPos) ? +_this.options.minPos : -180;
    _this.maxX = +_this.options.maxPos || 180;
    _this.maxX = typeof _this.options.maxPos !== "undefined" && !Number.isNaN(+_this.options.maxPos) ? +_this.options.maxPos : 180;
    _this.minY = _this.options.minY || _this.minX;
    _this.maxY = _this.options.maxY || _this.maxX;
    _this.maxZoom = 19;
    _this.maxWidth = _this.maxX - _this.minX;
    _this.animate = animate;
    _this.uuid = slugid.nice();
    _this.refreshTilesDebounced = debounce$1(_this.refreshTiles.bind(_this), ZOOM_DEBOUNCE);
    return _this;
  }
  _inherits$e(OSMTilesTrack2, _PixiTrack);
  return _createClass$e(OSMTilesTrack2, [{
    key: "visibleAndFetchedIds",
    value: function visibleAndFetchedIds() {
      return Object.keys(this.fetchedTiles).filter((x) => this.visibleTileIds.has(x));
    }
  }, {
    key: "visibleAndFetchedTiles",
    value: function visibleAndFetchedTiles() {
      return this.visibleAndFetchedIds().map((x) => this.fetchedTiles[x]);
    }
    /**
     * Set which tiles are visible right now.
     *
     * @param tiles: A set of tiles which will be considered the currently visible
     * tile positions.
     */
  }, {
    key: "setVisibleTiles",
    value: function setVisibleTiles(tilePositions) {
      this.visibleTiles = tilePositions.map((x) => ({
        tileId: this.tileToLocalId(x),
        remoteId: this.tileToRemoteId(x),
        mirrored: x.mirrored
      }));
      this.visibleTileIds = new Set(this.visibleTiles.map((x) => x.tileId));
    }
  }, {
    key: "removeAllTiles",
    value: function removeAllTiles() {
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      this.removeTiles([...fetchedTileIDs]);
    }
  }, {
    key: "refreshTiles",
    value: function refreshTiles() {
      this.calculateVisibleTiles();
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const toFetch = [...this.visibleTiles].filter((x) => !this.fetching.has(x.remoteId) && !fetchedTileIDs.has(x.tileId));
      for (let i = 0; i < toFetch.length; i++) {
        this.fetching.add(toFetch[i].remoteId);
      }
      const toRemove = [...fetchedTileIDs].filter((x) => !this.visibleTileIds.has(x));
      this.removeTiles(toRemove);
      this.fetchNewTiles(toFetch);
    }
    /**
     * Remove obsolete tiles
     *
     * @param toRemoveIds: An array of tile ids to remove from the list of fetched tiles.
     */
  }, {
    key: "removeTiles",
    value: function removeTiles(toRemoveIds) {
      if (!toRemoveIds.length) {
        return;
      }
      if (!this.areAllVisibleTilesLoaded()) {
        return;
      }
      toRemoveIds.forEach((x) => {
        const tileIdStr = x;
        this.destroyTile(this.fetchedTiles[tileIdStr]);
        if (tileIdStr in this.tileGraphics) {
          this.pMain.removeChild(this.tileGraphics[tileIdStr]);
          delete this.tileGraphics[tileIdStr];
        }
        delete this.fetchedTiles[tileIdStr];
      });
      this.synchronizeTilesAndGraphics();
      this.draw();
    }
    /*
     * The local tile identifier.
     * @param  {array}  tile  Contains `[zoomLevel, xPos, yPos]`.
     * @return  {string}  Remote ID string
     */
  }, {
    key: "tileToLocalId",
    value: function tileToLocalId(tile) {
      return tile.join(".");
    }
    /**
     * The tile identifier used on the server.
     * @param   {array}  tile  Contains `[zoomLevel, xPos, yPos]`.
     * @return  {string}  Remote ID string
     */
  }, {
    key: "tileToRemoteId",
    value: function tileToRemoteId(tile) {
      return tile.join(".");
    }
  }, {
    key: "localToRemoteId",
    value: function localToRemoteId(remoteId) {
      const idParts = remoteId.split(".");
      return idParts.slice(0, idParts.length - 1).join(".");
    }
  }, {
    key: "calculateZoomLevel",
    value: function calculateZoomLevel2() {
      const xZoomLevel = api.calculateZoomLevel(this._xScale, this.minX, this.maxX);
      const yZoomLevel = api.calculateZoomLevel(this._xScale, this.minY, this.maxY);
      let zoomLevel = Math.min(Math.max(xZoomLevel, yZoomLevel), this.maxZoom);
      if (this.options.maxZoom) {
        if (this.options.maxZoom >= 0) {
          zoomLevel = Math.min(this.options.maxZoom, zoomLevel);
        } else {
          console.error("Invalid maxZoom on track:", this);
        }
      }
      return zoomLevel;
    }
  }, {
    key: "calculateVisibleTiles",
    value: function calculateVisibleTiles() {
      this.zoomLevel = this.calculateZoomLevel();
      this.xTiles = api.calculateTiles(this.zoomLevel, this._xScale, this.minX, this.maxX, this.maxZoom, this.maxWidth);
      this.yTiles = api.calculateTiles(this.zoomLevel, this._yScale, this.minY, this.maxY, this.maxZoom, this.maxWidth);
      const rows = this.xTiles;
      const cols = this.yTiles;
      const zoomLevel = this.zoomLevel;
      const tiles = [];
      for (let i = 0; i < rows.length; i++) {
        for (let j = 0; j < cols.length; j++) {
          const newTile = [zoomLevel, rows[i], cols[j]];
          tiles.push(newTile);
        }
      }
      this.setVisibleTiles(tiles);
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale, k, tx, ty) {
      _superPropGet$3(OSMTilesTrack2, "zoomed", this)([newXScale, newYScale]);
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.pMain.position.x = tx;
      this.pMain.position.y = ty;
      this.pMain.scale.x = k;
      this.pMain.scale.y = k;
      this.refreshTilesDebounced();
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet$3(OSMTilesTrack2, "setPosition", this)([newPosition]);
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(newDimensions) {
      _superPropGet$3(OSMTilesTrack2, "setDimensions", this)([newDimensions]);
    }
    /**
     * Check to see if all the visible tiles are loaded.
     *
     * If they are, remove all other tiles.
     */
  }, {
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      const fetchedTileIDs = new Set(Object.keys(this.fetchedTiles));
      const visibleTileIdsList = [...this.visibleTileIds];
      for (let i = 0; i < visibleTileIdsList.length; i++) {
        if (!fetchedTileIDs.has(visibleTileIdsList[i])) {
          return false;
        }
      }
      return true;
    }
    /**
     * Function is called when all tiles that should be visible have
     * been received.
     */
  }, {
    key: "allTilesLoaded",
    value: function allTilesLoaded() {
    }
  }, {
    key: "minValue",
    value: function minValue(_) {
      if (_) {
        this.scale.minValue = _;
      }
      return this.scale.minValue;
    }
  }, {
    key: "maxValue",
    value: function maxValue(_) {
      if (_) {
        this.scale.maxValue = _;
      }
      return this.scale.maxValue;
    }
  }, {
    key: "minRawValue",
    value: function minRawValue() {
      return this.scale.minRawValue;
    }
  }, {
    key: "maxRawValue",
    value: function maxRawValue() {
      return this.scale.maxRawValue;
    }
    /**
     * Get the tile's position in its coordinate system.
     */
  }, {
    key: "getTilePosAndDimensions",
    value: function getTilePosAndDimensions2(zoomLevel, tilePos) {
      const tileWidth = this.maxWidth / 2 ** zoomLevel;
      const tileHeight = tileWidth;
      const tileX = this.minX + tilePos[0] * tileWidth;
      const tileY = this.minY + tilePos[1] * tileHeight;
      return {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      };
    }
  }, {
    key: "setSpriteProperties",
    value: function setSpriteProperties(sprite, zoomLevel, tilePos) {
      const {
        tileX,
        tileY,
        tileWidth,
        tileHeight
      } = this.getTilePosAndDimensions(zoomLevel, tilePos);
      sprite.x = this._refXScale(tileX);
      sprite.y = this._refYScale(tileY);
      const tileEndX = tileX + tileWidth;
      const tileEndY = tileY + tileHeight;
      sprite.width = this._refXScale(tileEndX) - this._refXScale(tileX);
      sprite.height = this._refYScale(tileEndY) - this._refYScale(tileY);
    }
  }, {
    key: "initTile",
    value: function initTile(tile) {
      const texture = new GLOBALS.PIXI.Texture(new GLOBALS.PIXI.BaseTexture(tile.tileData.img));
      const sprite = new GLOBALS.PIXI.Sprite(texture);
      const graphics = tile.graphics;
      tile.sprite = sprite;
      this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos);
      graphics.removeChildren();
      graphics.addChild(tile.sprite);
    }
  }, {
    key: "updateTile",
    value: function updateTile(tile) {
    }
  }, {
    key: "destroyTile",
    value: function destroyTile(tile) {
    }
    /**
     * Add graphics for tiles that have no graphics
     */
  }, {
    key: "addMissingGraphics",
    value: function addMissingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        if (!(fetchedTileIDs[i] in this.tileGraphics)) {
          const newGraphics = new GLOBALS.PIXI.Graphics();
          this.pMain.addChild(newGraphics);
          this.fetchedTiles[fetchedTileIDs[i]].graphics = newGraphics;
          this.initTile(this.fetchedTiles[fetchedTileIDs[i]]);
          this.tileGraphics[fetchedTileIDs[i]] = newGraphics;
        }
      }
    }
    /**
     * Change the graphics for existing tiles
     */
  }, {
    key: "updateExistingGraphics",
    value: function updateExistingGraphics() {
      const fetchedTileIDs = Object.keys(this.fetchedTiles);
      for (let i = 0; i < fetchedTileIDs.length; i++) {
        this.updateTile(this.fetchedTiles[fetchedTileIDs[i]]);
      }
    }
    /**
     * Make sure that we have a one to one mapping between tiles
     * and graphics objects
     */
  }, {
    key: "synchronizeTilesAndGraphics",
    value: function synchronizeTilesAndGraphics() {
      this.addMissingGraphics();
      this.updateExistingGraphics();
    }
    /**
     * Extract drawable data from a tile loaded by a generic tile loader
     *
     * @param tile: A tile returned by a TiledArea.
     * @param dataLoader: A function for extracting drawable data from a tile. This
     *                    usually means differentiating the between dense and sparse
     *                    tiles and putting the data into an array.
     */
  }, {
    key: "loadTileData",
    value: function loadTileData(tile, dataLoader) {
      let loadedTileData = this.lruCache.get(tile.tileId);
      if (!loadedTileData) {
        loadedTileData = dataLoader(tile.data, tile.type);
        this.lruCache.put(tile.tileId, loadedTileData);
      }
      return loadedTileData;
    }
    /**
     * Get the url used to fetch the tile data
     */
  }, {
    key: "getTileUrl",
    value: function getTileUrl(tileZxy) {
      const serverPrefixes = ["a", "b", "c"];
      const serverPrefixIndex = Math.floor(Math.random() * serverPrefixes.length);
      const src2 = `https://${serverPrefixes[serverPrefixIndex]}.tile.openstreetmap.org/${tileZxy[0]}/${tileZxy[1]}/${tileZxy[2]}.png`;
      return src2;
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      if (toFetch.length > 0) {
        const toFetchList = [...new Set(toFetch.map((x) => x.remoteId))];
        for (const tileId of toFetchList) {
          const parts = tileId.split(".");
          const src2 = this.getTileUrl(parts);
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.src = src2;
          img.onload = () => {
            const loadedTiles = {};
            loadedTiles[tileId] = {
              tileId,
              img,
              zoomLevel: +parts[0],
              tilePos: [+parts[1], +parts[2]],
              tileSrc: src2
            };
            this.receivedTiles(loadedTiles);
          };
        }
      }
    }
    /**
     * We've gotten a bunch of tiles from the server in
     * response to a request from fetchTiles.
     */
  }, {
    key: "receivedTiles",
    value: function receivedTiles(loadedTiles) {
      for (let i = 0; i < this.visibleTiles.length; i++) {
        const tileId = this.visibleTiles[i].tileId;
        if (!loadedTiles[this.visibleTiles[i].remoteId]) continue;
        if (this.visibleTiles[i].remoteId in loadedTiles) {
          if (!(tileId in this.fetchedTiles)) {
            this.fetchedTiles[tileId] = this.visibleTiles[i];
          }
          this.fetchedTiles[tileId].tileData = loadedTiles[this.visibleTiles[i].remoteId];
        }
      }
      for (const key in loadedTiles) {
        if (loadedTiles[key]) {
          if (this.fetching.has(key)) {
            this.fetching.delete(key);
          }
        }
      }
      this.synchronizeTilesAndGraphics();
      this.refreshTiles();
      this.draw();
      this.animate();
    }
  }, {
    key: "draw",
    value: function draw() {
      if (this.delayDrawing) return;
      _superPropGet$3(OSMTilesTrack2, "draw", this)([]);
    }
    /**
     * Draw a tile on some graphics
     */
  }, {
    key: "drawTile",
    value: function drawTile() {
    }
  }, {
    key: "refScalesChanged",
    value: function refScalesChanged(refXScale, refYScale) {
      _superPropGet$3(OSMTilesTrack2, "refScalesChanged", this)([refXScale, refYScale]);
      for (const uid in this.fetchedTiles) {
        const tile = this.fetchedTiles[uid];
        if (tile.sprite) {
          this.setSpriteProperties(tile.sprite, tile.tileData.zoomLevel, tile.tileData.tilePos);
        }
      }
    }
  }]);
})(PixiTrack);
function _classCallCheck$d(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$d(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$d(o.key), o);
  }
}
function _createClass$d(e, r2, t) {
  return r2 && _defineProperties$d(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$d(t) {
  var i = _toPrimitive$d(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$d(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$d(t, o, e) {
  return o = _getPrototypeOf$d(o), _possibleConstructorReturn$d(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf$d(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$d(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$d(t);
}
function _assertThisInitialized$d(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$d() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$d = function() {
    return !!t;
  })();
}
function _superPropGet$2(t, o, e, r2) {
  var p = _get$2(_getPrototypeOf$d(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$2() {
  return _get$2 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$2(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$2.apply(null, arguments);
}
function _superPropBase$2(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$d(t)); ) ;
  return t;
}
function _getPrototypeOf$d(t) {
  return _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$d(t);
}
function _inherits$d(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$d(t, e);
}
function _setPrototypeOf$d(t, e) {
  return _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$d(t, e);
}
let MapboxTilesTrack = /* @__PURE__ */ (function(_OSMTilesTrack) {
  function MapboxTilesTrack2(context, options2) {
    var _this;
    _classCallCheck$d(this, MapboxTilesTrack2);
    _this = _callSuper$d(this, MapboxTilesTrack2, [context, options2]);
    _this.style = options2.style;
    if (!_this.options.accessToken) {
      _this.setError("No access token provided in the viewconf's track options ('accessToken' option).");
      _this.drawError();
    }
    return _this;
  }
  _inherits$d(MapboxTilesTrack2, _OSMTilesTrack);
  return _createClass$d(MapboxTilesTrack2, [{
    key: "rerender",
    value: function rerender(newOptions) {
      _superPropGet$2(MapboxTilesTrack2, "rerender", this)([newOptions]);
      if (newOptions.style === this.style) return;
      this.style = newOptions.style;
      this.removeAllTiles();
      this.refreshTiles();
    }
    /**
     * Get the url used to fetch the tile data
     */
  }, {
    key: "getTileUrl",
    value: function getTileUrl(tileZxy) {
      const mapStyle = this.options?.style ? this.options.style : "streets-v10";
      const tileSize = this.options && +this.options.tileSize ? +this.options.tileSize : 256;
      return `https://api.mapbox.com/styles/v1/mapbox/${mapStyle}/tiles/${tileSize}/${tileZxy[0]}/${tileZxy[1]}/${tileZxy[2]}?access_token=${this.options.accessToken}`;
    }
  }]);
})(OSMTilesTrack);
function _classCallCheck$c(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$c(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$c(o.key), o);
  }
}
function _createClass$c(e, r2, t) {
  return r2 && _defineProperties$c(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$c(t) {
  var i = _toPrimitive$c(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$c(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$c(t, o, e) {
  return o = _getPrototypeOf$c(o), _possibleConstructorReturn$c(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf$c(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$c(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$c(t);
}
function _assertThisInitialized$c(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$c() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$c = function() {
    return !!t;
  })();
}
function _superPropGet$1(t, o, e, r2) {
  var p = _get$1(_getPrototypeOf$c(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get$1() {
  return _get$1 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase$1(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get$1.apply(null, arguments);
}
function _superPropBase$1(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$c(t)); ) ;
  return t;
}
function _getPrototypeOf$c(t) {
  return _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$c(t);
}
function _inherits$c(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$c(t, e);
}
function _setPrototypeOf$c(t, e) {
  return _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$c(t, e);
}
let OSMTileIdsTrack = /* @__PURE__ */ (function(_OSMTilesTrack) {
  function OSMTileIdsTrack2() {
    _classCallCheck$c(this, OSMTileIdsTrack2);
    return _callSuper$c(this, OSMTileIdsTrack2, arguments);
  }
  _inherits$c(OSMTileIdsTrack2, _OSMTilesTrack);
  return _createClass$c(OSMTileIdsTrack2, [{
    key: "initTile",
    value: function initTile(tile) {
      _initTile.bind(this)(tile);
      this.drawTile(tile);
    }
  }, {
    key: "drawTile",
    value: function drawTile(tile) {
      _drawTile.bind(this)(tile);
    }
  }, {
    key: "areAllVisibleTilesLoaded",
    value: function areAllVisibleTilesLoaded() {
      return true;
    }
  }, {
    key: "fetchNewTiles",
    value: function fetchNewTiles(toFetch) {
      toFetch.forEach((x) => {
        const key = x.remoteId;
        const keyParts = key.split(".");
        const data2 = {
          zoomLevel: keyParts[0],
          tilePos: keyParts.slice(1, keyParts.length).map((keyPart) => +keyPart)
        };
        this.fetchedTiles[x.tileId] = x;
        this.fetchedTiles[x.tileId].tileData = data2;
        if (this.fetching.has(x.remoteId)) {
          this.fetching.delete(x.remoteId);
        }
      });
      this.synchronizeTilesAndGraphics();
      this.draw();
      this.animate();
    }
  }, {
    key: "draw",
    value: function draw() {
      _superPropGet$1(OSMTileIdsTrack2, "draw", this)([]);
    }
  }]);
})(OSMTilesTrack);
function _classCallCheck$b(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$b(o.key), o);
  }
}
function _createClass$b(e, r2, t) {
  return r2 && _defineProperties$b(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$b(t) {
  var i = _toPrimitive$b(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$b(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$b(t, o, e) {
  return o = _getPrototypeOf$b(o), _possibleConstructorReturn$b(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf$b(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$b(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$b(t);
}
function _assertThisInitialized$b(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$b() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$b = function() {
    return !!t;
  })();
}
function _getPrototypeOf$b(t) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$b(t);
}
function _inherits$b(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$b(t, e);
}
function _setPrototypeOf$b(t, e) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$b(t, e);
}
let RasterTilesTrack = /* @__PURE__ */ (function(_OSMTilesTrack) {
  function RasterTilesTrack2(context, options2) {
    var _this;
    _classCallCheck$b(this, RasterTilesTrack2);
    _this = _callSuper$b(this, RasterTilesTrack2, [context, options2]);
    _this.style = options2.style;
    if (!_this.options.tileSource) {
      _this.setError("No tile source string provided in the options. It should be in the form of http://a.com/{z}/{x}/{y}");
      _this.drawError();
    }
    return _this;
  }
  _inherits$b(RasterTilesTrack2, _OSMTilesTrack);
  return _createClass$b(RasterTilesTrack2, [{
    key: "getTileUrl",
    value: function getTileUrl(tileZxy) {
      let newUrl = this.options.tileSource.replace("{z}", tileZxy[0]);
      newUrl = newUrl.replace("{x}", tileZxy[1]);
      newUrl = newUrl.replace("{y}", tileZxy[2]);
      return newUrl;
    }
  }]);
})(OSMTilesTrack);
const getDataFetcher$1 = (dataConfig, pubSub, pluginDataFetchers, availableForPlugins = AVAILABLE_FOR_PLUGINS) => {
  const pluginDataFetcher = pluginDataFetchers[dataConfig.type];
  if (pluginDataFetcher) {
    return new pluginDataFetcher.dataFetcher(availableForPlugins, dataConfig, pubSub);
  }
  if (dataConfig.type === "genbank") {
    return new GBKDataFetcher(dataConfig, pubSub);
  }
  if (dataConfig.type === "local-tiles") {
    return new LocalTileDataFetcher(dataConfig, pubSub);
  }
  return new DataFetcher(dataConfig, pubSub);
};
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
  return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
  return (x = sin(x / 2)) * x;
}
function noop$1() {
}
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}
var streamObjectType = {
  Feature: function(object2, stream) {
    streamGeometry(object2.geometry, stream);
  },
  FeatureCollection: function(object2, stream) {
    var features = object2.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};
var streamGeometryType = {
  Sphere: function(object2, stream) {
    stream.sphere();
  },
  Point: function(object2, stream) {
    object2 = object2.coordinates;
    stream.point(object2[0], object2[1], object2[2]);
  },
  MultiPoint: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n) object2 = coordinates2[i], stream.point(object2[0], object2[1], object2[2]);
  },
  LineString: function(object2, stream) {
    streamLine(object2.coordinates, stream, 0);
  },
  MultiLineString: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n) streamLine(coordinates2[i], stream, 0);
  },
  Polygon: function(object2, stream) {
    streamPolygon(object2.coordinates, stream);
  },
  MultiPolygon: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n) streamPolygon(coordinates2[i], stream);
  },
  GeometryCollection: function(object2, stream) {
    var geometries = object2.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};
function streamLine(coordinates2, stream, closed) {
  var i = -1, n = coordinates2.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates2[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}
function streamPolygon(coordinates2, stream) {
  var i = -1, n = coordinates2.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates2[i], stream, 1);
  stream.polygonEnd();
}
function geoStream(object2, stream) {
  if (object2 && streamObjectType.hasOwnProperty(object2.type)) {
    streamObjectType[object2.type](object2, stream);
  } else {
    streamGeometry(object2, stream);
  }
}
var areaRingSum$1 = new Adder();
var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
var areaStream$1 = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaRingSum$1 = new Adder();
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum$1;
    areaSum$1.add(areaRing < 0 ? tau + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$1;
  },
  sphere: function() {
    areaSum$1.add(tau);
  }
};
function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}
function areaRingEnd$1() {
  areaPoint$1(lambda00$2, phi00$2);
}
function areaPointFirst$1(lambda3, phi2) {
  areaStream$1.point = areaPoint$1;
  lambda00$2 = lambda3, phi00$2 = phi2;
  lambda3 *= radians, phi2 *= radians;
  lambda0$2 = lambda3, cosPhi0$1 = cos(phi2 = phi2 / 2 + quarterPi), sinPhi0$1 = sin(phi2);
}
function areaPoint$1(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  phi2 = phi2 / 2 + quarterPi;
  var dLambda = lambda3 - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos(phi2), sinPhi = sin(phi2), k = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k * cos(adLambda), v = k * sdLambda * sin(adLambda);
  areaRingSum$1.add(atan2(v, u));
  lambda0$2 = lambda3, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
}
function area(object2) {
  areaSum$1 = new Adder();
  geoStream(object2, areaStream$1);
  return areaSum$1 * 2;
}
function spherical(cartesian2) {
  return [atan2(cartesian2[1], cartesian2[0]), asin(cartesian2[2])];
}
function cartesian(spherical2) {
  var lambda3 = spherical2[0], phi2 = spherical2[1], cosPhi = cos(phi2);
  return [cosPhi * cos(lambda3), cosPhi * sin(lambda3), sin(phi2)];
}
function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}
var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream$1.point = boundsRingPoint;
    boundsStream$1.lineStart = boundsRingStart;
    boundsStream$1.lineEnd = boundsRingEnd;
    deltaSum = new Adder();
    areaStream$1.polygonStart();
  },
  polygonEnd: function() {
    areaStream$1.polygonEnd();
    boundsStream$1.point = boundsPoint$1;
    boundsStream$1.lineStart = boundsLineStart;
    boundsStream$1.lineEnd = boundsLineEnd;
    if (areaRingSum$1 < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon) phi1 = 90;
    else if (deltaSum < -epsilon) phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  },
  sphere: function() {
    lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};
function boundsPoint$1(lambda3, phi2) {
  ranges.push(range = [lambda0$1 = lambda3, lambda1 = lambda3]);
  if (phi2 < phi0) phi0 = phi2;
  if (phi2 > phi1) phi1 = phi2;
}
function linePoint(lambda3, phi2) {
  var p = cartesian([lambda3 * radians, phi2 * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p), equatorial = [normal[1], -normal[0], 0], inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta2 = lambda3 - lambda2, sign2 = delta2 > 0 ? 1 : -1, lambdai = inflection[0] * degrees * sign2, phii, antimeridian = abs(delta2) > 180;
    if (antimeridian ^ (sign2 * lambda2 < lambdai && lambdai < sign2 * lambda3)) {
      phii = inflection[1] * degrees;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign2 * lambda2 < lambdai && lambdai < sign2 * lambda3)) {
      phii = -inflection[1] * degrees;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi2 < phi0) phi0 = phi2;
      if (phi2 > phi1) phi1 = phi2;
    }
    if (antimeridian) {
      if (lambda3 < lambda2) {
        if (angle(lambda0$1, lambda3) > angle(lambda0$1, lambda1)) lambda1 = lambda3;
      } else {
        if (angle(lambda3, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda3;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda3 < lambda0$1) lambda0$1 = lambda3;
        if (lambda3 > lambda1) lambda1 = lambda3;
      } else {
        if (lambda3 > lambda2) {
          if (angle(lambda0$1, lambda3) > angle(lambda0$1, lambda1)) lambda1 = lambda3;
        } else {
          if (angle(lambda3, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda3;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda3, lambda1 = lambda3]);
  }
  if (phi2 < phi0) phi0 = phi2;
  if (phi2 > phi1) phi1 = phi2;
  p0 = p, lambda2 = lambda3;
}
function boundsLineStart() {
  boundsStream$1.point = linePoint;
}
function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream$1.point = boundsPoint$1;
  p0 = null;
}
function boundsRingPoint(lambda3, phi2) {
  if (p0) {
    var delta2 = lambda3 - lambda2;
    deltaSum.add(abs(delta2) > 180 ? delta2 + (delta2 > 0 ? 360 : -360) : delta2);
  } else {
    lambda00$1 = lambda3, phi00$1 = phi2;
  }
  areaStream$1.point(lambda3, phi2);
  linePoint(lambda3, phi2);
}
function boundsRingStart() {
  areaStream$1.lineStart();
}
function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream$1.lineEnd();
  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}
function angle(lambda02, lambda12) {
  return (lambda12 -= lambda02) < 0 ? lambda12 + 360 : lambda12;
}
function rangeCompare(a, b) {
  return a[0] - b[0];
}
function rangeContains(range2, x) {
  return range2[0] <= range2[1] ? range2[0] <= x && x <= range2[1] : x < range2[0] || range2[1] < x;
}
function bounds(feature) {
  var i, n, a, b, merged, deltaMax, delta2;
  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream$1);
  if (n = ranges.length) {
    ranges.sort(rangeCompare);
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta2 = angle(a[1], b[0])) > deltaMax) deltaMax = delta2, lambda0$1 = b[0], lambda1 = a[1];
    }
  }
  ranges = range = null;
  return lambda0$1 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0$1, phi0], [lambda1, phi1]];
}
var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0;
var centroidStream$1 = {
  sphere: noop$1,
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  }
};
function centroidPoint$1(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  var cosPhi = cos(phi2);
  centroidPointCartesian(cosPhi * cos(lambda3), cosPhi * sin(lambda3), sin(phi2));
}
function centroidPointCartesian(x, y, z) {
  ++W0;
  X0$1 += (x - X0$1) / W0;
  Y0$1 += (y - Y0$1) / W0;
  Z0$1 += (z - Z0$1) / W0;
}
function centroidLineStart$1() {
  centroidStream$1.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  var cosPhi = cos(phi2);
  x0$4 = cosPhi * cos(lambda3);
  y0$4 = cosPhi * sin(lambda3);
  z0 = sin(phi2);
  centroidStream$1.point = centroidLinePoint;
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLinePoint(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  var cosPhi = cos(phi2), x = cosPhi * cos(lambda3), y = cosPhi * sin(lambda3), z = sin(phi2), w = atan2(sqrt((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
  W1 += w;
  X1$1 += w * (x0$4 + (x0$4 = x));
  Y1$1 += w * (y0$4 + (y0$4 = y));
  Z1$1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingStart$1() {
  centroidStream$1.point = centroidRingPointFirst;
}
function centroidRingEnd$1() {
  centroidRingPoint(lambda00, phi00);
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingPointFirst(lambda3, phi2) {
  lambda00 = lambda3, phi00 = phi2;
  lambda3 *= radians, phi2 *= radians;
  centroidStream$1.point = centroidRingPoint;
  var cosPhi = cos(phi2);
  x0$4 = cosPhi * cos(lambda3);
  y0$4 = cosPhi * sin(lambda3);
  z0 = sin(phi2);
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidRingPoint(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  var cosPhi = cos(phi2), x = cosPhi * cos(lambda3), y = cosPhi * sin(lambda3), z = sin(phi2), cx = y0$4 * z - z0 * y, cy = z0 * x - x0$4 * z, cz = x0$4 * y - y0$4 * x, m = hypot(cx, cy, cz), w = asin(m), v = m && -w / m;
  X2$1.add(v * cx);
  Y2$1.add(v * cy);
  Z2$1.add(v * cz);
  W1 += w;
  X1$1 += w * (x0$4 + (x0$4 = x));
  Y1$1 += w * (y0$4 + (y0$4 = y));
  Z1$1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroid(object2) {
  W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
  X2$1 = new Adder();
  Y2$1 = new Adder();
  Z2$1 = new Adder();
  geoStream(object2, centroidStream$1);
  var x = +X2$1, y = +Y2$1, z = +Z2$1, m = hypot(x, y, z);
  if (m < epsilon2) {
    x = X1$1, y = Y1$1, z = Z1$1;
    if (W1 < epsilon) x = X0$1, y = Y0$1, z = Z0$1;
    m = hypot(x, y, z);
    if (m < epsilon2) return [NaN, NaN];
  }
  return [atan2(y, x) * degrees, asin(z / m) * degrees];
}
function constant(x) {
  return function() {
    return x;
  };
}
function compose(a, b) {
  function compose2(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }
  if (a.invert && b.invert) compose2.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };
  return compose2;
}
function rotationIdentity(lambda3, phi2) {
  return [abs(lambda3) > pi ? lambda3 + Math.round(-lambda3 / tau) * tau : lambda3, phi2];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function(lambda3, phi2) {
    return lambda3 += deltaLambda, [lambda3 > pi ? lambda3 - tau : lambda3 < -pi ? lambda3 + tau : lambda3, phi2];
  };
}
function rotationLambda(deltaLambda) {
  var rotation2 = forwardRotationLambda(deltaLambda);
  rotation2.invert = forwardRotationLambda(-deltaLambda);
  return rotation2;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos(deltaPhi), sinDeltaPhi = sin(deltaPhi), cosDeltaGamma = cos(deltaGamma), sinDeltaGamma = sin(deltaGamma);
  function rotation2(lambda3, phi2) {
    var cosPhi = cos(phi2), x = cos(lambda3) * cosPhi, y = sin(lambda3) * cosPhi, z = sin(phi2), k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi), asin(k * cosDeltaGamma + y * sinDeltaGamma)];
  }
  rotation2.invert = function(lambda3, phi2) {
    var cosPhi = cos(phi2), x = cos(lambda3) * cosPhi, y = sin(lambda3) * cosPhi, z = sin(phi2), k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi), asin(k * cosDeltaPhi - x * sinDeltaPhi)];
  };
  return rotation2;
}
function rotation(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
  function forward(coordinates2) {
    coordinates2 = rotate(coordinates2[0] * radians, coordinates2[1] * radians);
    return coordinates2[0] *= degrees, coordinates2[1] *= degrees, coordinates2;
  }
  forward.invert = function(coordinates2) {
    coordinates2 = rotate.invert(coordinates2[0] * radians, coordinates2[1] * radians);
    return coordinates2[0] *= degrees, coordinates2[1] *= degrees, coordinates2;
  };
  return forward;
}
function circleStream(stream, radius, delta2, direction, t02, t12) {
  if (!delta2) return;
  var cosRadius = cos(radius), sinRadius = sin(radius), step = direction * delta2;
  if (t02 == null) {
    t02 = radius + direction * tau;
    t12 = radius - step / 2;
  } else {
    t02 = circleRadius(cosRadius, t02);
    t12 = circleRadius(cosRadius, t12);
    if (direction > 0 ? t02 < t12 : t02 > t12) t02 += direction * tau;
  }
  for (var point2, t = t02; direction > 0 ? t > t12 : t < t12; t -= step) {
    point2 = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
    stream.point(point2[0], point2[1]);
  }
}
function circleRadius(cosRadius, point2) {
  point2 = cartesian(point2), point2[0] -= cosRadius;
  cartesianNormalizeInPlace(point2);
  var radius = acos(-point2[1]);
  return ((-point2[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
}
function circle$1() {
  var center2 = constant([0, 0]), radius = constant(90), precision = constant(6), ring2, rotate, stream = {
    point: point2
  };
  function point2(x, y) {
    ring2.push(x = rotate(x, y));
    x[0] *= degrees, x[1] *= degrees;
  }
  function circle2() {
    var c = center2.apply(this, arguments), r2 = radius.apply(this, arguments) * radians, p = precision.apply(this, arguments) * radians;
    ring2 = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r2, p, 1);
    c = {
      type: "Polygon",
      coordinates: [ring2]
    };
    ring2 = rotate = null;
    return c;
  }
  circle2.center = function(_) {
    return arguments.length ? (center2 = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle2) : center2;
  };
  circle2.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle2) : radius;
  };
  circle2.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle2) : precision;
  };
  return circle2;
}
function clipBuffer() {
  var lines = [], line;
  return {
    point: function(x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$1,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}
function pointEqual(a, b) {
  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
}
function Intersection(point2, points, other, entry) {
  this.x = point2;
  this.z = points;
  this.o = other;
  this.e = entry;
  this.v = false;
  this.n = this.p = null;
}
function clipRejoin(segments, compareIntersection2, startInside, interpolate2, stream) {
  var subject = [], clip2 = [], i, n;
  segments.forEach(function(segment) {
    if ((n2 = segment.length - 1) <= 0) return;
    var n2, p02 = segment[0], p1 = segment[n2], x;
    if (pointEqual(p02, p1)) {
      if (!p02[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n2; ++i) stream.point((p02 = segment[i])[0], p02[1]);
        stream.lineEnd();
        return;
      }
      p1[0] += 2 * epsilon;
    }
    subject.push(x = new Intersection(p02, segment, null, true));
    clip2.push(x.o = new Intersection(p02, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip2.push(x.o = new Intersection(p1, null, x, true));
  });
  if (!subject.length) return;
  clip2.sort(compareIntersection2);
  link(subject);
  link(clip2);
  for (i = 0, n = clip2.length; i < n; ++i) {
    clip2[i].e = startInside = !startInside;
  }
  var start2 = subject[0], points, point2;
  while (1) {
    var current = start2, isSubject = true;
    while (current.v) if ((current = current.n) === start2) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point2 = points[i])[0], point2[1]);
        } else {
          interpolate2(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point2 = points[i])[0], point2[1]);
        } else {
          interpolate2(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}
function link(array2) {
  if (!(n = array2.length)) return;
  var n, i = 0, a = array2[0], b;
  while (++i < n) {
    a.n = b = array2[i];
    b.p = a;
    a = b;
  }
  a.n = b = array2[0];
  b.p = a;
}
function longitude(point2) {
  if (abs(point2[0]) <= pi) return point2[0];
  else return sign(point2[0]) * ((abs(point2[0]) + pi) % tau - pi);
}
function polygonContains(polygon, point2) {
  var lambda3 = longitude(point2), phi2 = point2[1], sinPhi = sin(phi2), normal = [sin(lambda3), -cos(lambda3), 0], angle2 = 0, winding = 0;
  var sum2 = new Adder();
  if (sinPhi === 1) phi2 = halfPi + epsilon;
  else if (sinPhi === -1) phi2 = -halfPi - epsilon;
  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring2 = polygon[i]).length)) continue;
    var ring2, m, point0 = ring2[m - 1], lambda02 = longitude(point0), phi02 = point0[1] / 2 + quarterPi, sinPhi02 = sin(phi02), cosPhi02 = cos(phi02);
    for (var j = 0; j < m; ++j, lambda02 = lambda12, sinPhi02 = sinPhi1, cosPhi02 = cosPhi1, point0 = point1) {
      var point1 = ring2[j], lambda12 = longitude(point1), phi12 = point1[1] / 2 + quarterPi, sinPhi1 = sin(phi12), cosPhi1 = cos(phi12), delta2 = lambda12 - lambda02, sign2 = delta2 >= 0 ? 1 : -1, absDelta = sign2 * delta2, antimeridian = absDelta > pi, k = sinPhi02 * sinPhi1;
      sum2.add(atan2(k * sign2 * sin(absDelta), cosPhi02 * cosPhi1 + k * cos(absDelta)));
      angle2 += antimeridian ? delta2 + sign2 * tau : delta2;
      if (antimeridian ^ lambda02 >= lambda3 ^ lambda12 >= lambda3) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection2 = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection2);
        var phiArc = (antimeridian ^ delta2 >= 0 ? -1 : 1) * asin(intersection2[2]);
        if (phi2 > phiArc || phi2 === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta2 >= 0 ? 1 : -1;
        }
      }
    }
  }
  return (angle2 < -epsilon || angle2 < epsilon && sum2 < -epsilon2) ^ winding & 1;
}
function clip(pointVisible, clipLine2, interpolate2, start2) {
  return function(sink) {
    var line = clipLine2(sink), ringBuffer = clipBuffer(), ringSink = clipLine2(ringBuffer), polygonStarted = false, polygon, segments, ring2;
    var clip2 = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart: function() {
        clip2.point = pointRing;
        clip2.lineStart = ringStart;
        clip2.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip2.point = point2;
        clip2.lineStart = lineStart;
        clip2.lineEnd = lineEnd;
        segments = merge$2(segments);
        var startInside = polygonContains(polygon, start2);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipRejoin(segments, compareIntersection, startInside, interpolate2, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate2(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate2(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point2(lambda3, phi2) {
      if (pointVisible(lambda3, phi2)) sink.point(lambda3, phi2);
    }
    function pointLine(lambda3, phi2) {
      line.point(lambda3, phi2);
    }
    function lineStart() {
      clip2.point = pointLine;
      line.lineStart();
    }
    function lineEnd() {
      clip2.point = point2;
      line.lineEnd();
    }
    function pointRing(lambda3, phi2) {
      ring2.push([lambda3, phi2]);
      ringSink.point(lambda3, phi2);
    }
    function ringStart() {
      ringSink.lineStart();
      ring2 = [];
    }
    function ringEnd() {
      pointRing(ring2[0][0], ring2[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point3;
      ring2.pop();
      polygon.push(ring2);
      ring2 = null;
      if (!n) return;
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point3 = segment[i])[0], point3[1]);
          sink.lineEnd();
        }
        return;
      }
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip2;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
}
const clipAntimeridian = clip(function() {
  return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [-pi, -halfPi]);
function clipAntimeridianLine(stream) {
  var lambda02 = NaN, phi02 = NaN, sign0 = NaN, clean;
  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda12, phi12) {
      var sign1 = lambda12 > 0 ? pi : -pi, delta2 = abs(lambda12 - lambda02);
      if (abs(delta2 - pi) < epsilon) {
        stream.point(lambda02, phi02 = (phi02 + phi12) / 2 > 0 ? halfPi : -halfPi);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        stream.point(lambda12, phi02);
        clean = 0;
      } else if (sign0 !== sign1 && delta2 >= pi) {
        if (abs(lambda02 - sign0) < epsilon) lambda02 -= sign0 * epsilon;
        if (abs(lambda12 - sign1) < epsilon) lambda12 -= sign1 * epsilon;
        phi02 = clipAntimeridianIntersect(lambda02, phi02, lambda12, phi12);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        clean = 0;
      }
      stream.point(lambda02 = lambda12, phi02 = phi12);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda02 = phi02 = NaN;
    },
    clean: function() {
      return 2 - clean;
    }
  };
}
function clipAntimeridianIntersect(lambda02, phi02, lambda12, phi12) {
  var cosPhi02, cosPhi1, sinLambda0Lambda1 = sin(lambda02 - lambda12);
  return abs(sinLambda0Lambda1) > epsilon ? atan((sin(phi02) * (cosPhi1 = cos(phi12)) * sin(lambda12) - sin(phi12) * (cosPhi02 = cos(phi02)) * sin(lambda02)) / (cosPhi02 * cosPhi1 * sinLambda0Lambda1)) : (phi02 + phi12) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi2;
  if (from == null) {
    phi2 = direction * halfPi;
    stream.point(-pi, phi2);
    stream.point(0, phi2);
    stream.point(pi, phi2);
    stream.point(pi, 0);
    stream.point(pi, -phi2);
    stream.point(0, -phi2);
    stream.point(-pi, -phi2);
    stream.point(-pi, 0);
    stream.point(-pi, phi2);
  } else if (abs(from[0] - to[0]) > epsilon) {
    var lambda3 = from[0] < to[0] ? pi : -pi;
    phi2 = direction * lambda3 / 2;
    stream.point(-lambda3, phi2);
    stream.point(0, phi2);
    stream.point(lambda3, phi2);
  } else {
    stream.point(to[0], to[1]);
  }
}
function clipCircle(radius) {
  var cr = cos(radius), delta2 = 6 * radians, smallRadius = cr > 0, notHemisphere = abs(cr) > epsilon;
  function interpolate2(from, to, direction, stream) {
    circleStream(stream, radius, delta2, direction, from, to);
  }
  function visible(lambda3, phi2) {
    return cos(lambda3) * cos(phi2) > cr;
  }
  function clipLine2(stream) {
    var point0, c0, v0, v00, clean;
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda3, phi2) {
        var point1 = [lambda3, phi2], point2, v = visible(lambda3, phi2), c = smallRadius ? v ? 0 : code(lambda3, phi2) : v ? code(lambda3 + (lambda3 < 0 ? pi : -pi), phi2) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        if (v !== v0) {
          point2 = intersect2(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            stream.lineStart();
            point2 = intersect2(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            point2 = intersect2(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          if (!(c & c0) && (t = intersect2(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | (v00 && v0) << 1;
      }
    };
  }
  function intersect2(a, b, two) {
    var pa = cartesian(a), pb = cartesian(b);
    var n1 = [1, 0, 0], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
    if (!determinant) return !two && a;
    var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A5 = cartesianScale(n1, c1), B2 = cartesianScale(n2, c2);
    cartesianAddInPlace(A5, B2);
    var u = n1xn2, w = cartesianDot(A5, u), uu = cartesianDot(u, u), t22 = w * w - uu * (cartesianDot(A5, A5) - 1);
    if (t22 < 0) return;
    var t = sqrt(t22), q2 = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q2, A5);
    q2 = spherical(q2);
    if (!two) return q2;
    var lambda02 = a[0], lambda12 = b[0], phi02 = a[1], phi12 = b[1], z;
    if (lambda12 < lambda02) z = lambda02, lambda02 = lambda12, lambda12 = z;
    var delta3 = lambda12 - lambda02, polar = abs(delta3 - pi) < epsilon, meridian = polar || delta3 < epsilon;
    if (!polar && phi12 < phi02) z = phi02, phi02 = phi12, phi12 = z;
    if (meridian ? polar ? phi02 + phi12 > 0 ^ q2[1] < (abs(q2[0] - lambda02) < epsilon ? phi02 : phi12) : phi02 <= q2[1] && q2[1] <= phi12 : delta3 > pi ^ (lambda02 <= q2[0] && q2[0] <= lambda12)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A5);
      return [q2, spherical(q1)];
    }
  }
  function code(lambda3, phi2) {
    var r2 = smallRadius ? radius : pi - radius, code2 = 0;
    if (lambda3 < -r2) code2 |= 1;
    else if (lambda3 > r2) code2 |= 2;
    if (phi2 < -r2) code2 |= 4;
    else if (phi2 > r2) code2 |= 8;
    return code2;
  }
  return clip(visible, clipLine2, interpolate2, smallRadius ? [0, -radius] : [-pi, radius - pi]);
}
function clipLine(a, b, x02, y02, x12, y12) {
  var ax = a[0], ay = a[1], bx = b[0], by = b[1], t02 = 0, t12 = 1, dx = bx - ax, dy = by - ay, r2;
  r2 = x02 - ax;
  if (!dx && r2 > 0) return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 < t02) return;
    if (r2 < t12) t12 = r2;
  } else if (dx > 0) {
    if (r2 > t12) return;
    if (r2 > t02) t02 = r2;
  }
  r2 = x12 - ax;
  if (!dx && r2 < 0) return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 > t12) return;
    if (r2 > t02) t02 = r2;
  } else if (dx > 0) {
    if (r2 < t02) return;
    if (r2 < t12) t12 = r2;
  }
  r2 = y02 - ay;
  if (!dy && r2 > 0) return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 < t02) return;
    if (r2 < t12) t12 = r2;
  } else if (dy > 0) {
    if (r2 > t12) return;
    if (r2 > t02) t02 = r2;
  }
  r2 = y12 - ay;
  if (!dy && r2 < 0) return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 > t12) return;
    if (r2 > t02) t02 = r2;
  } else if (dy > 0) {
    if (r2 < t02) return;
    if (r2 < t12) t12 = r2;
  }
  if (t02 > 0) a[0] = ax + t02 * dx, a[1] = ay + t02 * dy;
  if (t12 < 1) b[0] = ax + t12 * dx, b[1] = ay + t12 * dy;
  return true;
}
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x02, y02, x12, y12) {
  function visible(x, y) {
    return x02 <= x && x <= x12 && y02 <= y && y <= y12;
  }
  function interpolate2(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
      do
        stream.point(a === 0 || a === 3 ? x02 : x12, a > 1 ? y12 : y02);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }
  function corner(p, direction) {
    return abs(p[0] - x02) < epsilon ? direction > 0 ? 0 : 3 : abs(p[0] - x12) < epsilon ? direction > 0 ? 2 : 1 : abs(p[1] - y02) < epsilon ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
  }
  function compareIntersection2(a, b) {
    return comparePoint(a.x, b.x);
  }
  function comparePoint(a, b) {
    var ca = corner(a, 1), cb = corner(b, 1);
    return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
  }
  return function(stream) {
    var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring2, x__, y__, v__, x_, y_, v_, first, clean;
    var clipStream = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart,
      polygonEnd
    };
    function point2(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }
    function polygonInside() {
      var winding = 0;
      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring3 = polygon[i], j = 1, m = ring3.length, point3 = ring3[0], a0, a1, b0 = point3[0], b1 = point3[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point3 = ring3[j], b0 = point3[0], b1 = point3[1];
          if (a1 <= y12) {
            if (b1 > y12 && (b0 - a0) * (y12 - a1) > (b1 - a1) * (x02 - a0)) ++winding;
          } else {
            if (b1 <= y12 && (b0 - a0) * (y12 - a1) < (b1 - a1) * (x02 - a0)) --winding;
          }
        }
      }
      return winding;
    }
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(), cleanInside = clean && startInside, visible2 = (segments = merge$2(segments)).length;
      if (cleanInside || visible2) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate2(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible2) {
          clipRejoin(segments, compareIntersection2, startInside, interpolate2, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring2 = null;
    }
    function lineStart() {
      clipStream.point = linePoint2;
      if (polygon) polygon.push(ring2 = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }
    function lineEnd() {
      if (segments) {
        linePoint2(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point2;
      if (v_) activeStream.lineEnd();
    }
    function linePoint2(x, y) {
      var v = visible(x, y);
      if (polygon) ring2.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))], b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x02, y02, x12, y12)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }
    return clipStream;
  };
}
function extent() {
  var x02 = 0, y02 = 0, x12 = 960, y12 = 500, cache2, cacheStream, clip2;
  return clip2 = {
    stream: function(stream) {
      return cache2 && cacheStream === stream ? cache2 : cache2 = clipRectangle(x02, y02, x12, y12)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1], cache2 = cacheStream = null, clip2) : [[x02, y02], [x12, y12]];
    }
  };
}
var lengthSum$1, lambda0, sinPhi0, cosPhi0;
var lengthStream$1 = {
  sphere: noop$1,
  point: noop$1,
  lineStart: lengthLineStart,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1
};
function lengthLineStart() {
  lengthStream$1.point = lengthPointFirst$1;
  lengthStream$1.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
  lengthStream$1.point = lengthStream$1.lineEnd = noop$1;
}
function lengthPointFirst$1(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  lambda0 = lambda3, sinPhi0 = sin(phi2), cosPhi0 = cos(phi2);
  lengthStream$1.point = lengthPoint$1;
}
function lengthPoint$1(lambda3, phi2) {
  lambda3 *= radians, phi2 *= radians;
  var sinPhi = sin(phi2), cosPhi = cos(phi2), delta2 = abs(lambda3 - lambda0), cosDelta = cos(delta2), sinDelta = sin(delta2), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum$1.add(atan2(sqrt(x * x + y * y), z));
  lambda0 = lambda3, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}
function length(object2) {
  lengthSum$1 = new Adder();
  geoStream(object2, lengthStream$1);
  return +lengthSum$1;
}
var coordinates = [null, null], object = {
  type: "LineString",
  coordinates
};
function distance(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length(object);
}
var containsObjectType = {
  Feature: function(object2, point2) {
    return containsGeometry(object2.geometry, point2);
  },
  FeatureCollection: function(object2, point2) {
    var features = object2.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point2)) return true;
    return false;
  }
};
var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object2, point2) {
    return containsPoint(object2.coordinates, point2);
  },
  MultiPoint: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n) if (containsPoint(coordinates2[i], point2)) return true;
    return false;
  },
  LineString: function(object2, point2) {
    return containsLine(object2.coordinates, point2);
  },
  MultiLineString: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n) if (containsLine(coordinates2[i], point2)) return true;
    return false;
  },
  Polygon: function(object2, point2) {
    return containsPolygon(object2.coordinates, point2);
  },
  MultiPolygon: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n = coordinates2.length;
    while (++i < n) if (containsPolygon(coordinates2[i], point2)) return true;
    return false;
  },
  GeometryCollection: function(object2, point2) {
    var geometries = object2.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point2)) return true;
    return false;
  }
};
function containsGeometry(geometry, point2) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point2) : false;
}
function containsPoint(coordinates2, point2) {
  return distance(coordinates2, point2) === 0;
}
function containsLine(coordinates2, point2) {
  var ao, bo, ab;
  for (var i = 0, n = coordinates2.length; i < n; i++) {
    bo = distance(coordinates2[i], point2);
    if (bo === 0) return true;
    if (i > 0) {
      ab = distance(coordinates2[i], coordinates2[i - 1]);
      if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab) return true;
    }
    ao = bo;
  }
  return false;
}
function containsPolygon(coordinates2, point2) {
  return !!polygonContains(coordinates2.map(ringRadians), pointRadians(point2));
}
function ringRadians(ring2) {
  return ring2 = ring2.map(pointRadians), ring2.pop(), ring2;
}
function pointRadians(point2) {
  return [point2[0] * radians, point2[1] * radians];
}
function contains$1(object2, point2) {
  return (object2 && containsObjectType.hasOwnProperty(object2.type) ? containsObjectType[object2.type] : containsGeometry)(object2, point2);
}
function graticuleX(y02, y12, dy) {
  var y = range$4(y02, y12 - epsilon, dy).concat(y12);
  return function(x) {
    return y.map(function(y2) {
      return [x, y2];
    });
  };
}
function graticuleY(x02, x12, dx) {
  var x = range$4(x02, x12 - epsilon, dx).concat(x12);
  return function(y) {
    return x.map(function(x2) {
      return [x2, y];
    });
  };
}
function graticule() {
  var x12, x02, X12, X02, y12, y02, Y12, Y02, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X3, Y3, precision = 2.5;
  function graticule2() {
    return {
      type: "MultiLineString",
      coordinates: lines()
    };
  }
  function lines() {
    return range$4(ceil(X02 / DX) * DX, X12, DX).map(X3).concat(range$4(ceil(Y02 / DY) * DY, Y12, DY).map(Y3)).concat(range$4(ceil(x02 / dx) * dx, x12, dx).filter(function(x2) {
      return abs(x2 % DX) > epsilon;
    }).map(x)).concat(range$4(ceil(y02 / dy) * dy, y12, dy).filter(function(y2) {
      return abs(y2 % DY) > epsilon;
    }).map(y));
  }
  graticule2.lines = function() {
    return lines().map(function(coordinates2) {
      return {
        type: "LineString",
        coordinates: coordinates2
      };
    });
  };
  graticule2.outline = function() {
    return {
      type: "Polygon",
      coordinates: [X3(X02).concat(Y3(Y12).slice(1), X3(X12).reverse().slice(1), Y3(Y02).reverse().slice(1))]
    };
  };
  graticule2.extent = function(_) {
    if (!arguments.length) return graticule2.extentMinor();
    return graticule2.extentMajor(_).extentMinor(_);
  };
  graticule2.extentMajor = function(_) {
    if (!arguments.length) return [[X02, Y02], [X12, Y12]];
    X02 = +_[0][0], X12 = +_[1][0];
    Y02 = +_[0][1], Y12 = +_[1][1];
    if (X02 > X12) _ = X02, X02 = X12, X12 = _;
    if (Y02 > Y12) _ = Y02, Y02 = Y12, Y12 = _;
    return graticule2.precision(precision);
  };
  graticule2.extentMinor = function(_) {
    if (!arguments.length) return [[x02, y02], [x12, y12]];
    x02 = +_[0][0], x12 = +_[1][0];
    y02 = +_[0][1], y12 = +_[1][1];
    if (x02 > x12) _ = x02, x02 = x12, x12 = _;
    if (y02 > y12) _ = y02, y02 = y12, y12 = _;
    return graticule2.precision(precision);
  };
  graticule2.step = function(_) {
    if (!arguments.length) return graticule2.stepMinor();
    return graticule2.stepMajor(_).stepMinor(_);
  };
  graticule2.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule2;
  };
  graticule2.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule2;
  };
  graticule2.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y02, y12, 90);
    y = graticuleY(x02, x12, precision);
    X3 = graticuleX(Y02, Y12, 90);
    Y3 = graticuleY(X02, X12, precision);
    return graticule2;
  };
  return graticule2.extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]]).extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
}
function graticule10() {
  return graticule()();
}
function interpolate(a, b) {
  var x02 = a[0] * radians, y02 = a[1] * radians, x12 = b[0] * radians, y12 = b[1] * radians, cy0 = cos(y02), sy0 = sin(y02), cy1 = cos(y12), sy1 = sin(y12), kx0 = cy0 * cos(x02), ky0 = cy0 * sin(x02), kx1 = cy1 * cos(x12), ky1 = cy1 * sin(x12), d = 2 * asin(sqrt(haversin(y12 - y02) + cy0 * cy1 * haversin(x12 - x02))), k = sin(d);
  var interpolate2 = d ? function(t) {
    var B2 = sin(t *= d) / k, A5 = sin(d - t) / k, x = A5 * kx0 + B2 * kx1, y = A5 * ky0 + B2 * ky1, z = A5 * sy0 + B2 * sy1;
    return [atan2(y, x) * degrees, atan2(z, sqrt(x * x + y * y)) * degrees];
  } : function() {
    return [x02 * degrees, y02 * degrees];
  };
  interpolate2.distance = d;
  return interpolate2;
}
const identity$1 = (x) => x;
var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
    areaSum.add(abs(areaRingSum));
    areaRingSum = new Adder();
  },
  result: function() {
    var area2 = areaSum / 2;
    areaSum = new Adder();
    return area2;
  }
};
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00$2 = x0$3 = x, y00$2 = y0$3 = y;
}
function areaPoint(x, y) {
  areaRingSum.add(y0$3 * x - x0$3 * y);
  x0$3 = x, y0$3 = y;
}
function areaRingEnd() {
  areaPoint(x00$2, y00$2);
}
var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
var boundsStream = {
  point: boundsPoint,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function() {
    var bounds2 = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds2;
  }
};
function boundsPoint(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid2 = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
    X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
    return centroid2;
  }
};
function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}
function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function centroidPointLine(x, y) {
  var dx = x - x0$1, dy = y - y0$1, z = sqrt(dx * dx + dy * dy);
  X1 += z * (x0$1 + x) / 2;
  Y1 += z * (y0$1 + y) / 2;
  Z1 += z;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
  centroidPointRing(x00$1, y00$1);
}
function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
}
function centroidPointRing(x, y) {
  var dx = x - x0$1, dy = y - y0$1, z = sqrt(dx * dx + dy * dy);
  X1 += z * (x0$1 + x) / 2;
  Y1 += z * (y0$1 + y) / 2;
  Z1 += z;
  z = y0$1 * x - x0$1 * y;
  X2 += z * (x0$1 + x);
  Y2 += z * (y0$1 + y);
  Z2 += z * 3;
  centroidPoint(x0$1 = x, y0$1 = y);
}
function PathContext(context) {
  this._context = context;
}
PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau);
        break;
      }
    }
  },
  result: noop$1
};
var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
  point: noop$1,
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = noop$1;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length2 = +lengthSum;
    lengthSum = new Adder();
    return length2;
  }
};
function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(sqrt(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}
function PathString() {
  this._string = [];
}
PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};
function circle(radius) {
  return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}
function index(projection2, context) {
  var pointRadius = 4.5, projectionStream, contextStream;
  function path(object2) {
    if (object2) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object2, projectionStream(contextStream));
    }
    return contextStream.result();
  }
  path.area = function(object2) {
    geoStream(object2, projectionStream(areaStream));
    return areaStream.result();
  };
  path.measure = function(object2) {
    geoStream(object2, projectionStream(lengthStream));
    return lengthStream.result();
  };
  path.bounds = function(object2) {
    geoStream(object2, projectionStream(boundsStream));
    return boundsStream.result();
  };
  path.centroid = function(object2) {
    geoStream(object2, projectionStream(centroidStream));
    return centroidStream.result();
  };
  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection2 = null, identity$1) : (projection2 = _).stream, path) : projection2;
  };
  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString()) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };
  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };
  return path.projection(projection2).context(context);
}
function transform(methods) {
  return {
    stream: transformer(methods)
  };
}
function transformer(methods) {
  return function(stream) {
    var s = new TransformStream();
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}
function TransformStream() {
}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) {
    this.stream.point(x, y);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function fit(projection2, fitBounds, object2) {
  var clip2 = projection2.clipExtent && projection2.clipExtent();
  projection2.scale(150).translate([0, 0]);
  if (clip2 != null) projection2.clipExtent(null);
  geoStream(object2, projection2.stream(boundsStream));
  fitBounds(boundsStream.result());
  if (clip2 != null) projection2.clipExtent(clip2);
  return projection2;
}
function fitExtent(projection2, extent2, object2) {
  return fit(projection2, function(b) {
    var w = extent2[1][0] - extent2[0][0], h = extent2[1][1] - extent2[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent2[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent2[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection2.scale(150 * k).translate([x, y]);
  }, object2);
}
function fitSize(projection2, size, object2) {
  return fitExtent(projection2, [[0, 0], size], object2);
}
function fitWidth(projection2, width, object2) {
  return fit(projection2, function(b) {
    var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
    projection2.scale(150 * k).translate([x, y]);
  }, object2);
}
function fitHeight(projection2, height, object2) {
  return fit(projection2, function(b) {
    var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection2.scale(150 * k).translate([x, y]);
  }, object2);
}
var maxDepth = 16, cosMinDistance = cos(30 * radians);
function resample(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
}
function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}
function resample$1(project, delta2) {
  function resampleLineTo(x02, y02, lambda02, a0, b0, c0, x12, y12, lambda12, a1, b1, c1, depth, stream) {
    var dx = x12 - x02, dy = y12 - y02, d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = sqrt(a * a + b * b + c * c), phi2 = asin(c /= m), lambda22 = abs(abs(c) - 1) < epsilon || abs(lambda02 - lambda12) < epsilon ? (lambda02 + lambda12) / 2 : atan2(b, a), p = project(lambda22, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x02, dy2 = y2 - y02, dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
        resampleLineTo(x02, y02, lambda02, a0, b0, c0, x2, y2, lambda22, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda22, a, b, c, x12, y12, lambda12, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda002, x002, y002, a00, b00, c00, lambda02, x02, y02, a0, b0, c0;
    var resampleStream = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart: function() {
        stream.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function() {
        stream.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point2(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }
    function lineStart() {
      x02 = NaN;
      resampleStream.point = linePoint2;
      stream.lineStart();
    }
    function linePoint2(lambda3, phi2) {
      var c = cartesian([lambda3, phi2]), p = project(lambda3, phi2);
      resampleLineTo(x02, y02, lambda02, a0, b0, c0, x02 = p[0], y02 = p[1], lambda02 = lambda3, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x02, y02);
    }
    function lineEnd() {
      resampleStream.point = point2;
      stream.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda3, phi2) {
      linePoint2(lambda002 = lambda3, phi2), x002 = x02, y002 = y02, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint2;
    }
    function ringEnd() {
      resampleLineTo(x02, y02, lambda02, a0, b0, c0, x002, y002, lambda002, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}
var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});
function transformRotate(rotate) {
  return transformer({
    point: function(x, y) {
      var r2 = rotate(x, y);
      return this.stream.point(r2[0], r2[1]);
    }
  });
}
function scaleTranslate(k, dx, dy, sx, sy) {
  function transform2(x, y) {
    x *= sx;
    y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform2.invert = function(x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform2;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha2) {
  if (!alpha2) return scaleTranslate(k, dx, dy, sx, sy);
  var cosAlpha = cos(alpha2), sinAlpha = sin(alpha2), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform2(x, y) {
    x *= sx;
    y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform2.invert = function(x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform2;
}
function projection(project) {
  return projectionMutator(function() {
    return project;
  })();
}
function projectionMutator(projectAt) {
  var project, k = 150, x = 480, y = 250, lambda3 = 0, phi2 = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha2 = 0, sx = 1, sy = 1, theta2 = null, preclip = clipAntimeridian, x02 = null, y02, x12, y12, postclip = identity$1, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache2, cacheStream;
  function projection2(point2) {
    return projectRotateTransform(point2[0] * radians, point2[1] * radians);
  }
  function invert(point2) {
    point2 = projectRotateTransform.invert(point2[0], point2[1]);
    return point2 && [point2[0] * degrees, point2[1] * degrees];
  }
  projection2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };
  projection2.preclip = function(_) {
    return arguments.length ? (preclip = _, theta2 = void 0, reset()) : preclip;
  };
  projection2.postclip = function(_) {
    return arguments.length ? (postclip = _, x02 = y02 = x12 = y12 = null, reset()) : postclip;
  };
  projection2.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta2 = _ * radians) : (theta2 = null, clipAntimeridian), reset()) : theta2 * degrees;
  };
  projection2.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x02 = y02 = x12 = y12 = null, identity$1) : clipRectangle(x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reset()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };
  projection2.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };
  projection2.center = function(_) {
    return arguments.length ? (lambda3 = _[0] % 360 * radians, phi2 = _[1] % 360 * radians, recenter()) : [lambda3 * degrees, phi2 * degrees];
  };
  projection2.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
  };
  projection2.angle = function(_) {
    return arguments.length ? (alpha2 = _ % 360 * radians, recenter()) : alpha2 * degrees;
  };
  projection2.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };
  projection2.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };
  projection2.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width, object2) {
    return fitWidth(projection2, width, object2);
  };
  projection2.fitHeight = function(height, object2) {
    return fitHeight(projection2, height, object2);
  };
  function recenter() {
    var center2 = scaleTranslateRotate(k, 0, 0, sx, sy, alpha2).apply(null, project(lambda3, phi2)), transform2 = scaleTranslateRotate(k, x - center2[0], y - center2[1], sx, sy, alpha2);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform2);
    projectRotateTransform = compose(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }
  function reset() {
    cache2 = cacheStream = null;
    return projection2;
  }
  return function() {
    project = projectAt.apply(this, arguments);
    projection2.invert = project.invert && invert;
    return recenter();
  };
}
function conicProjection(projectAt) {
  var phi02 = 0, phi12 = pi / 3, m = projectionMutator(projectAt), p = m(phi02, phi12);
  p.parallels = function(_) {
    return arguments.length ? m(phi02 = _[0] * radians, phi12 = _[1] * radians) : [phi02 * degrees, phi12 * degrees];
  };
  return p;
}
function cylindricalEqualAreaRaw(phi02) {
  var cosPhi02 = cos(phi02);
  function forward(lambda3, phi2) {
    return [lambda3 * cosPhi02, sin(phi2) / cosPhi02];
  }
  forward.invert = function(x, y) {
    return [x / cosPhi02, asin(y * cosPhi02)];
  };
  return forward;
}
function conicEqualAreaRaw(y02, y12) {
  var sy0 = sin(y02), n = (sy0 + sin(y12)) / 2;
  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y02);
  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
  function project(x, y) {
    var r2 = sqrt(c - 2 * n * sin(y)) / n;
    return [r2 * sin(x *= n), r0 - r2 * cos(x)];
  }
  project.invert = function(x, y) {
    var r0y = r0 - y, l = atan2(x, abs(r0y)) * sign(r0y);
    if (r0y * n < 0) l -= pi * sign(x) * sign(r0y);
    return [l / n, asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };
  return project;
}
function conicEqualArea() {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}
function albers() {
  return conicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) {
      var i = -1;
      while (++i < n) streams[i].point(x, y);
    },
    sphere: function() {
      var i = -1;
      while (++i < n) streams[i].sphere();
    },
    lineStart: function() {
      var i = -1;
      while (++i < n) streams[i].lineStart();
    },
    lineEnd: function() {
      var i = -1;
      while (++i < n) streams[i].lineEnd();
    },
    polygonStart: function() {
      var i = -1;
      while (++i < n) streams[i].polygonStart();
    },
    polygonEnd: function() {
      var i = -1;
      while (++i < n) streams[i].polygonEnd();
    }
  };
}
function albersUsa() {
  var cache2, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, point2, pointStream = {
    point: function(x, y) {
      point2 = [x, y];
    }
  };
  function albersUsa2(coordinates2) {
    var x = coordinates2[0], y = coordinates2[1];
    return point2 = null, (lower48Point.point(x, y), point2) || (alaskaPoint.point(x, y), point2) || (hawaiiPoint.point(x, y), point2);
  }
  albersUsa2.invert = function(coordinates2) {
    var k = lower48.scale(), t = lower48.translate(), x = (coordinates2[0] - t[0]) / k, y = (coordinates2[1] - t[1]) / k;
    return (y >= 0.12 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates2);
  };
  albersUsa2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };
  albersUsa2.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };
  albersUsa2.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa2.translate(lower48.translate());
  };
  albersUsa2.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];
    lower48Point = lower48.translate(_).clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]]).stream(pointStream);
    alaskaPoint = alaska.translate([x - 0.307 * k, y + 0.201 * k]).clipExtent([[x - 0.425 * k + epsilon, y + 0.12 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
    hawaiiPoint = hawaii.translate([x - 0.205 * k, y + 0.212 * k]).clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]]).stream(pointStream);
    return reset();
  };
  albersUsa2.fitExtent = function(extent2, object2) {
    return fitExtent(albersUsa2, extent2, object2);
  };
  albersUsa2.fitSize = function(size, object2) {
    return fitSize(albersUsa2, size, object2);
  };
  albersUsa2.fitWidth = function(width, object2) {
    return fitWidth(albersUsa2, width, object2);
  };
  albersUsa2.fitHeight = function(height, object2) {
    return fitHeight(albersUsa2, height, object2);
  };
  function reset() {
    cache2 = cacheStream = null;
    return albersUsa2;
  }
  return albersUsa2.scale(1070);
}
function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos(x), cy = cos(y), k = scale(cx * cy);
    if (k === Infinity) return [2, 0];
    return [k * cy * sin(x), k * sin(y)];
  };
}
function azimuthalInvert(angle2) {
  return function(x, y) {
    var z = sqrt(x * x + y * y), c = angle2(z), sc2 = sin(c), cc = cos(c);
    return [atan2(x * sc2, z * cc), asin(z && y * sc2 / z)];
  };
}
var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});
function azimuthalEqualArea() {
  return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
}
var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin(c);
});
azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});
function azimuthalEquidistant() {
  return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}
function mercatorRaw(lambda3, phi2) {
  return [lambda3, log(tan((halfPi + phi2) / 2))];
}
mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi];
};
function mercator() {
  return mercatorProjection(mercatorRaw).scale(961 / tau);
}
function mercatorProjection(project) {
  var m = projection(project), center2 = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x02 = null, y02, x12, y12;
  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };
  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };
  m.center = function(_) {
    return arguments.length ? (center2(_), reclip()) : center2();
  };
  m.clipExtent = function(_) {
    return arguments.length ? (_ == null ? x02 = y02 = x12 = y12 = null : (x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reclip()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  function reclip() {
    var k = pi * scale(), t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x02 == null ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw ? [[Math.max(t[0] - k, x02), y02], [Math.min(t[0] + k, x12), y12]] : [[x02, Math.max(t[1] - k, y02)], [x12, Math.min(t[1] + k, y12)]]);
  }
  return reclip();
}
function tany(y) {
  return tan((halfPi + y) / 2);
}
function conicConformalRaw(y02, y12) {
  var cy0 = cos(y02), n = y02 === y12 ? sin(y02) : log(cy0 / cos(y12)) / log(tany(y12) / tany(y02)), f2 = cy0 * pow(tany(y02), n) / n;
  if (!n) return mercatorRaw;
  function project(x, y) {
    if (f2 > 0) {
      if (y < -halfPi + epsilon) y = -halfPi + epsilon;
    } else {
      if (y > halfPi - epsilon) y = halfPi - epsilon;
    }
    var r2 = f2 / pow(tany(y), n);
    return [r2 * sin(n * x), f2 - r2 * cos(n * x)];
  }
  project.invert = function(x, y) {
    var fy = f2 - y, r2 = sign(n) * sqrt(x * x + fy * fy), l = atan2(x, abs(fy)) * sign(fy);
    if (fy * n < 0) l -= pi * sign(x) * sign(fy);
    return [l / n, 2 * atan(pow(f2 / r2, 1 / n)) - halfPi];
  };
  return project;
}
function conicConformal() {
  return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
}
function equirectangularRaw(lambda3, phi2) {
  return [lambda3, phi2];
}
equirectangularRaw.invert = equirectangularRaw;
function equirectangular() {
  return projection(equirectangularRaw).scale(152.63);
}
function conicEquidistantRaw(y02, y12) {
  var cy0 = cos(y02), n = y02 === y12 ? sin(y02) : (cy0 - cos(y12)) / (y12 - y02), g = cy0 / n + y02;
  if (abs(n) < epsilon) return equirectangularRaw;
  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin(nx), g - gy * cos(nx)];
  }
  project.invert = function(x, y) {
    var gy = g - y, l = atan2(x, abs(gy)) * sign(gy);
    if (gy * n < 0) l -= pi * sign(x) * sign(gy);
    return [l / n, g - sign(n) * sqrt(x * x + gy * gy)];
  };
  return project;
}
function conicEquidistant() {
  return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
}
var A1 = 1.340264, A2 = -0.081106, A3 = 893e-6, A4 = 3796e-6, M = sqrt(3) / 2, iterations = 12;
function equalEarthRaw(lambda3, phi2) {
  var l = asin(M * sin(phi2)), l2 = l * l, l6 = l2 * l2 * l2;
  return [lambda3 * cos(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))), l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))];
}
equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta2, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta2 = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (abs(delta2) < epsilon2) break;
  }
  return [M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos(l), asin(sin(l) / M)];
};
function equalEarth() {
  return projection(equalEarthRaw).scale(177.158);
}
function gnomonicRaw(x, y) {
  var cy = cos(y), k = cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}
gnomonicRaw.invert = azimuthalInvert(atan);
function gnomonic() {
  return projection(gnomonicRaw).scale(144.049).clipAngle(60);
}
function identity() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha2 = 0, ca, sa, x02 = null, y02, x12, y12, kx = 1, ky = 1, transform2 = transformer({
    point: function(x, y) {
      var p = projection2([x, y]);
      this.stream.point(p[0], p[1]);
    }
  }), postclip = identity$1, cache2, cacheStream;
  function reset() {
    kx = k * sx;
    ky = k * sy;
    cache2 = cacheStream = null;
    return projection2;
  }
  function projection2(p) {
    var x = p[0] * kx, y = p[1] * ky;
    if (alpha2) {
      var t = y * ca - x * sa;
      x = x * ca + y * sa;
      y = t;
    }
    return [x + tx, y + ty];
  }
  projection2.invert = function(p) {
    var x = p[0] - tx, y = p[1] - ty;
    if (alpha2) {
      var t = y * ca + x * sa;
      x = x * ca - y * sa;
      y = t;
    }
    return [x / kx, y / ky];
  };
  projection2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = transform2(postclip(cacheStream = stream));
  };
  projection2.postclip = function(_) {
    return arguments.length ? (postclip = _, x02 = y02 = x12 = y12 = null, reset()) : postclip;
  };
  projection2.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x02 = y02 = x12 = y12 = null, identity$1) : clipRectangle(x02 = +_[0][0], y02 = +_[0][1], x12 = +_[1][0], y12 = +_[1][1]), reset()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_) {
    return arguments.length ? (k = +_, reset()) : k;
  };
  projection2.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
  };
  projection2.angle = function(_) {
    return arguments.length ? (alpha2 = _ % 360 * radians, sa = sin(alpha2), ca = cos(alpha2), reset()) : alpha2 * degrees;
  };
  projection2.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
  };
  projection2.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width, object2) {
    return fitWidth(projection2, width, object2);
  };
  projection2.fitHeight = function(height, object2) {
    return fitHeight(projection2, height, object2);
  };
  return projection2;
}
function naturalEarth1Raw(lambda3, phi2) {
  var phi22 = phi2 * phi2, phi4 = phi22 * phi22;
  return [lambda3 * (0.8707 - 0.131979 * phi22 + phi4 * (-0.013791 + phi4 * (3971e-6 * phi22 - 1529e-6 * phi4))), phi2 * (1.007226 + phi22 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi22 - 5916e-6 * phi4)))];
}
naturalEarth1Raw.invert = function(x, y) {
  var phi2 = y, i = 25, delta2;
  do {
    var phi22 = phi2 * phi2, phi4 = phi22 * phi22;
    phi2 -= delta2 = (phi2 * (1.007226 + phi22 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi22 - 5916e-6 * phi4))) - y) / (1.007226 + phi22 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi22 - 5916e-6 * 11 * phi4)));
  } while (abs(delta2) > epsilon && --i > 0);
  return [x / (0.8707 + (phi22 = phi2 * phi2) * (-0.131979 + phi22 * (-0.013791 + phi22 * phi22 * phi22 * (3971e-6 - 1529e-6 * phi22)))), phi2];
};
function naturalEarth1() {
  return projection(naturalEarth1Raw).scale(175.295);
}
function orthographicRaw(x, y) {
  return [cos(y) * sin(x), sin(y)];
}
orthographicRaw.invert = azimuthalInvert(asin);
function orthographic() {
  return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon);
}
function stereographicRaw(x, y) {
  var cy = cos(y), k = 1 + cos(x) * cy;
  return [cy * sin(x) / k, sin(y) / k];
}
stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});
function stereographic() {
  return projection(stereographicRaw).scale(250).clipAngle(142);
}
function transverseMercatorRaw(lambda3, phi2) {
  return [log(tan((halfPi + phi2) / 2)), -lambda3];
}
transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi];
};
function transverseMercator() {
  var m = mercatorProjection(transverseMercatorRaw), center2 = m.center, rotate = m.rotate;
  m.center = function(_) {
    return arguments.length ? center2([-_[1], _[0]]) : (_ = center2(), [_[1], -_[0]]);
  };
  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };
  return rotate([0, 0, 90]).scale(159.155);
}
const d3Geo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  geoAlbers: albers,
  geoAlbersUsa: albersUsa,
  geoArea: area,
  geoAzimuthalEqualArea: azimuthalEqualArea,
  geoAzimuthalEqualAreaRaw: azimuthalEqualAreaRaw,
  geoAzimuthalEquidistant: azimuthalEquidistant,
  geoAzimuthalEquidistantRaw: azimuthalEquidistantRaw,
  geoBounds: bounds,
  geoCentroid: centroid,
  geoCircle: circle$1,
  geoClipAntimeridian: clipAntimeridian,
  geoClipCircle: clipCircle,
  geoClipExtent: extent,
  geoClipRectangle: clipRectangle,
  geoConicConformal: conicConformal,
  geoConicConformalRaw: conicConformalRaw,
  geoConicEqualArea: conicEqualArea,
  geoConicEqualAreaRaw: conicEqualAreaRaw,
  geoConicEquidistant: conicEquidistant,
  geoConicEquidistantRaw: conicEquidistantRaw,
  geoContains: contains$1,
  geoDistance: distance,
  geoEqualEarth: equalEarth,
  geoEqualEarthRaw: equalEarthRaw,
  geoEquirectangular: equirectangular,
  geoEquirectangularRaw: equirectangularRaw,
  geoGnomonic: gnomonic,
  geoGnomonicRaw: gnomonicRaw,
  geoGraticule: graticule,
  geoGraticule10: graticule10,
  geoIdentity: identity,
  geoInterpolate: interpolate,
  geoLength: length,
  geoMercator: mercator,
  geoMercatorRaw: mercatorRaw,
  geoNaturalEarth1: naturalEarth1,
  geoNaturalEarth1Raw: naturalEarth1Raw,
  geoOrthographic: orthographic,
  geoOrthographicRaw: orthographicRaw,
  geoPath: index,
  geoProjection: projection,
  geoProjectionMutator: projectionMutator,
  geoRotation: rotation,
  geoStereographic: stereographic,
  geoStereographicRaw: stereographicRaw,
  geoStream,
  geoTransform: transform,
  geoTransverseMercator: transverseMercator,
  geoTransverseMercatorRaw: transverseMercatorRaw
}, Symbol.toStringTag, { value: "Module" }));
var prefix = "$";
function Map$1() {
}
Map$1.prototype = map.prototype = {
  constructor: Map$1,
  has: function(key) {
    return prefix + key in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property2 = prefix + key;
    return property2 in this && delete this[property2];
  },
  clear: function() {
    for (var property2 in this) if (property2[0] === prefix) delete this[property2];
  },
  keys: function() {
    var keys2 = [];
    for (var property2 in this) if (property2[0] === prefix) keys2.push(property2.slice(1));
    return keys2;
  },
  values: function() {
    var values = [];
    for (var property2 in this) if (property2[0] === prefix) values.push(this[property2]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property2 in this) if (property2[0] === prefix) entries.push({
      key: property2.slice(1),
      value: this[property2]
    });
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property2 in this) if (property2[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property2 in this) if (property2[0] === prefix) return false;
    return true;
  },
  each: function(f2) {
    for (var property2 in this) if (property2[0] === prefix) f2(this[property2], property2.slice(1), this);
  }
};
function map(object2, f2) {
  var map2 = new Map$1();
  if (object2 instanceof Map$1) object2.each(function(value, key2) {
    map2.set(key2, value);
  });
  else if (Array.isArray(object2)) {
    var i = -1, n = object2.length, o;
    if (f2 == null) while (++i < n) map2.set(i, object2[i]);
    else while (++i < n) map2.set(f2(o = object2[i], i, object2), o);
  } else if (object2) for (var key in object2) map2.set(key, object2[key]);
  return map2;
}
function Set$1() {
}
var proto = map.prototype;
Set$1.prototype = {
  constructor: Set$1,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};
var noop = {
  value: function() {
  }
};
function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}
function Dispatch(_) {
  this._ = _;
}
function parseTypenames(typenames, types2) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types2.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {
      type: t,
      name
    };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
      return;
    }
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set$1(_[t], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _ = this._;
    for (var t in _) copy2[t] = _[t].slice();
    return new Dispatch(copy2);
  },
  call: function(type2, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type2)) throw new Error("unknown type: " + type2);
    for (t = this._[type2], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type2, that, args) {
    if (!this._.hasOwnProperty(type2)) throw new Error("unknown type: " + type2);
    for (var t = this._[type2], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};
function get$1(type2, name) {
  for (var i = 0, n = type2.length, c; i < n; ++i) {
    if ((c = type2[i]).name === name) {
      return c.value;
    }
  }
}
function set$1(type2, name, callback) {
  for (var i = 0, n = type2.length; i < n; ++i) {
    if (type2[i].name === name) {
      type2[i] = noop, type2 = type2.slice(0, i).concat(type2.slice(i + 1));
      break;
    }
  }
  if (callback != null) type2.push({
    name,
    value: callback
  });
  return type2;
}
function request(url, callback) {
  var request2, event = dispatch("beforesend", "progress", "load", "error"), mimeType, headers = map(), xhr = new XMLHttpRequest(), user = null, password = null, response, responseType, timeout2 = 0;
  if (typeof XDomainRequest !== "undefined" && !("withCredentials" in xhr) && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest();
  "onload" in xhr ? xhr.onload = xhr.onerror = xhr.ontimeout = respond : xhr.onreadystatechange = function(o) {
    xhr.readyState > 3 && respond(o);
  };
  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr) || status >= 200 && status < 300 || status === 304) {
      if (response) {
        try {
          result = response.call(request2, xhr);
        } catch (e) {
          event.call("error", request2, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request2, result);
    } else {
      event.call("error", request2, o);
    }
  }
  xhr.onprogress = function(e) {
    event.call("progress", request2, e);
  };
  request2 = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request2;
    },
    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request2;
    },
    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request2;
    },
    timeout: function(value) {
      if (!arguments.length) return timeout2;
      timeout2 = +value;
      return request2;
    },
    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request2);
    },
    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request2);
    },
    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request2;
    },
    // Alias for send("GET", …).
    get: function(data2, callback2) {
      return request2.send("GET", data2, callback2);
    },
    // Alias for send("POST", …).
    post: function(data2, callback2) {
      return request2.send("POST", data2, callback2);
    },
    // If callback is non-null, it will be used for error and load events.
    send: function(method, data2, callback2) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) {
        xhr.setRequestHeader(name, value);
      });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout2 > 0) xhr.timeout = timeout2;
      if (callback2 == null && typeof data2 === "function") callback2 = data2, data2 = null;
      if (callback2 != null && callback2.length === 1) callback2 = fixCallback(callback2);
      if (callback2 != null) request2.on("error", callback2).on("load", function(xhr2) {
        callback2(null, xhr2);
      });
      event.call("beforesend", request2, xhr);
      xhr.send(data2 == null ? null : data2);
      return request2;
    },
    abort: function() {
      xhr.abort();
      return request2;
    },
    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request2 : value;
    }
  };
  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request2.get(callback);
  }
  return request2;
}
function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}
function hasResponse(xhr) {
  var type2 = xhr.responseType;
  return type2 && type2 !== "text" ? xhr.response : xhr.responseText;
}
function type$3(defaultMimeType, response) {
  return function(url, callback) {
    var r2 = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r2.get(callback);
    }
    return r2;
  };
}
const html = type$3("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});
const json = type$3("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});
const text = type$3("text/plain", function(xhr) {
  return xhr.responseText;
});
const xml = type$3("application/xml", function(xhr) {
  var xml2 = xhr.responseXML;
  if (!xml2) throw new Error("parse error");
  return xml2;
});
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter(columns, f2) {
  var object2 = objectConverter(columns);
  return function(row, i) {
    return f2(object2(row), i, columns);
  };
}
function inferColumns(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });
  return columns;
}
function pad(value, width) {
  var s = value + "", length2 = s.length;
  return length2 < width ? new Array(width - length2 + 1).join(0) + s : s;
}
function formatYear(year) {
  return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date2) {
  var hours = date2.getUTCHours(), minutes = date2.getUTCMinutes(), seconds = date2.getUTCSeconds(), milliseconds = date2.getUTCMilliseconds();
  return isNaN(date2) ? "Invalid Date" : formatYear(date2.getUTCFullYear()) + "-" + pad(date2.getUTCMonth() + 1, 2) + "-" + pad(date2.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}
function dsv$1(delimiter) {
  var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
  function parse2(text2, f2) {
    var convert, columns, rows = parseRows(text2, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f2 ? customConverter(row, f2) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text2, f2) {
    var rows = [], N = text2.length, I = 0, n = 0, t, eof = N <= 0, eol = false;
    if (text2.charCodeAt(N - 1) === NEWLINE) --N;
    if (text2.charCodeAt(N - 1) === RETURN) --N;
    function token() {
      if (eof) return EOF;
      if (eol) return eol = false, EOL;
      var i, j = I, c;
      if (text2.charCodeAt(j) === QUOTE) {
        while (I++ < N && text2.charCodeAt(I) !== QUOTE || text2.charCodeAt(++I) === QUOTE) ;
        if ((i = I) >= N) eof = true;
        else if ((c = text2.charCodeAt(I++)) === NEWLINE) eol = true;
        else if (c === RETURN) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE) ++I;
        }
        return text2.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c = text2.charCodeAt(i = I++)) === NEWLINE) eol = true;
        else if (c === RETURN) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE) ++I;
        } else if (c !== DELIMITER) continue;
        return text2.slice(j, i);
      }
      return eof = true, text2.slice(j, N);
    }
    while ((t = token()) !== EOF) {
      var row = [];
      while (t !== EOL && t !== EOF) row.push(t), t = token();
      if (f2 && (row = f2(row, n++)) == null) continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    });
  }
  function format2(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }
  function formatValue(value) {
    return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
  }
  return {
    parse: parse2,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var csv$1 = dsv$1(",");
var csvParse = csv$1.parse;
var tsv$1 = dsv$1("	");
var tsvParse = tsv$1.parse;
function dsv(defaultMimeType, parse2) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r2 = request(url).mimeType(defaultMimeType);
    r2.row = function(_) {
      return arguments.length ? r2.response(responseOf(parse2, row = _)) : row;
    };
    r2.row(row);
    return callback ? r2.get(callback) : r2;
  };
}
function responseOf(parse2, row) {
  return function(request2) {
    return parse2(request2.responseText, row);
  };
}
const csv = dsv("text/csv", csvParse);
const tsv = dsv("text/tab-separated-values", tsvParse);
const d3Request = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  csv,
  html,
  json,
  request,
  text,
  tsv,
  xml
}, Symbol.toStringTag, { value: "Module" }));
function _classCallCheck$a(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$a(o.key), o);
  }
}
function _createClass$a(e, r2, t) {
  return r2 && _defineProperties$a(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$a(t) {
  var i = _toPrimitive$a(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$a(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$a(t, o, e) {
  return o = _getPrototypeOf$a(o), _possibleConstructorReturn$a(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf$a(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$a(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(t);
}
function _assertThisInitialized$a(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$a() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$a = function() {
    return !!t;
  })();
}
function _getPrototypeOf$a(t) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$a(t);
}
function _inherits$a(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$a(t, e);
}
function _setPrototypeOf$a(t, e) {
  return _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$a(t, e);
}
const STYLES = {
  pointerEvents: "all"
};
let VerticalTrack = /* @__PURE__ */ (function(_MoveableTrack) {
  function VerticalTrack2() {
    _classCallCheck$a(this, VerticalTrack2);
    return _callSuper$a(this, VerticalTrack2, arguments);
  }
  _inherits$a(VerticalTrack2, _MoveableTrack);
  return _createClass$a(VerticalTrack2, [{
    key: "getControls",
    value: function getControls(isVisible) {
      return /* @__PURE__ */ React__default.createElement(
        TrackControl$1,
        {
          expandCollapseAvailable: true,
          dragHandleProps: this.props.dragHandleProps,
          imgStyleAdd: STYLES,
          imgStyleClose: STYLES,
          imgStyleMove: STYLES,
          imgStyleSettings: STYLES,
          isAlignLeft: this.props.controlAlignLeft,
          isCollapsed: this.props.isCollapsed,
          isMoveable: this.moveable,
          isVertical: true,
          isVisible,
          onAddSeries: this.props.onAddSeries,
          onCollapseTrack: this.props.onCollapseTrack,
          onExpandTrack: this.props.onExpandTrack,
          onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
          onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
          uid: this.props.uid
        }
      );
    }
  }]);
})(MoveableTrack);
function _classCallCheck$9(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$9(o.key), o);
  }
}
function _createClass$9(e, r2, t) {
  return r2 && _defineProperties$9(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$9(t) {
  var i = _toPrimitive$9(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$9(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$9(t, o, e) {
  return o = _getPrototypeOf$9(o), _possibleConstructorReturn$9(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf$9(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$9(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(t);
}
function _assertThisInitialized$9(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$9() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct$9 = function() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r2) {
  var p = _get(_getPrototypeOf$9(t.prototype), o, e);
  return "function" == typeof p ? function(t4) {
    return p.apply(e, t4);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r2) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r2) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf$9(t)); ) ;
  return t;
}
function _getPrototypeOf$9(t) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf$9(t);
}
function _inherits$9(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$9(t, e);
}
function _setPrototypeOf$9(t, e) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e3) {
    return t4.__proto__ = e3, t4;
  }, _setPrototypeOf$9(t, e);
}
let ViewportTracker2D = /* @__PURE__ */ (function(_PixiTrack) {
  function ViewportTracker2D2(context, options2) {
    var _this;
    _classCallCheck$9(this, ViewportTracker2D2);
    _this = _callSuper$9(this, ViewportTracker2D2, [context, options2]);
    const {
      registerViewportChanged,
      removeViewportChanged
    } = context;
    const uid = slugid.nice();
    _this.uid = uid;
    _this.removeViewportChanged = removeViewportChanged;
    _this.viewportXDomain = null;
    _this.viewportYDomain = null;
    registerViewportChanged(uid, _this.viewportChanged.bind(_this));
    return _this;
  }
  _inherits$9(ViewportTracker2D2, _PixiTrack);
  return _createClass$9(ViewportTracker2D2, [{
    key: "viewportChanged",
    value: function viewportChanged(viewportXScale, viewportYScale) {
      const viewportXDomain = viewportXScale.domain();
      const viewportYDomain = viewportYScale.domain();
      this.viewportXDomain = viewportXDomain;
      this.viewportYDomain = viewportYDomain;
      this.draw();
    }
  }, {
    key: "draw",
    value: function draw() {
      const graphics = this.pMain;
      if (!this.viewportXDomain || !this.viewportYDomain) {
        return;
      }
      graphics.clear();
      graphics.lineStyle(1, 255, 1);
      graphics.beginFill(16740363, 1);
      const x = this._xScale(this.viewportXDomain[0]);
      const y = this._yScale(this.viewportYDomain[0]);
      const width = this._xScale(this.viewportXDomain[1]) - this._xScale(this.viewportXDomain[0]);
      const height = this._yScale(this.viewportYDomain[1]) - this._yScale(this.viewportYDomain[0]);
      this.pMain.drawRect(x, y, width, height);
    }
  }, {
    key: "zoomed",
    value: function zoomed(newXScale, newYScale) {
      this.xScale(newXScale);
      this.yScale(newYScale);
      this.draw();
    }
  }, {
    key: "setPosition",
    value: function setPosition(newPosition) {
      _superPropGet(ViewportTracker2D2, "setPosition", this)([newPosition]);
      this.pMain.position.y = this.position[1];
      this.pMain.position.x = this.position[0];
      this.draw();
    }
  }]);
})(PixiTrack);
function LruCache(limit) {
  this.size = 0;
  this.limit = limit;
  this._keymap = {};
}
function put(key, value) {
  const entry = {
    key,
    value
  };
  this._keymap[key] = entry;
  if (this.tail) {
    this.tail.newer = entry;
    entry.older = this.tail;
  } else {
    this.head = entry;
  }
  this.tail = entry;
  if (this.size === this.limit) {
    return this.shift();
  }
  this.size += 1;
  return void 0;
}
function shift() {
  const entry = this.head;
  if (entry) {
    if (this.head.newer) {
      this.head = this.head.newer;
      this.head.older = void 0;
    } else {
      this.head = void 0;
      this.tail = void 0;
    }
    entry.newer = void 0;
    entry.older = void 0;
    delete this._keymap[entry.key];
    this.size -= 1;
  }
  return entry;
}
function get2(key, returnEntry) {
  const entry = this._keymap[key];
  if (entry === void 0) return void 0;
  if (entry === this.tail) {
    return returnEntry ? entry : entry.value;
  }
  if (entry.newer) {
    if (entry === this.head) this.head = entry.newer;
    entry.newer.older = entry.older;
  }
  if (entry.older) entry.older.newer = entry.newer;
  entry.newer = void 0;
  entry.older = this.tail;
  if (this.tail) this.tail.newer = entry;
  this.tail = entry;
  return returnEntry ? entry : entry.value;
}
function find(key) {
  return this._keymap[key];
}
function set(key, value) {
  const entry = this.get(key, true);
  let oldvalue;
  if (entry) {
    oldvalue = entry.value;
    entry.value = value;
  } else {
    oldvalue = this.put(key, value);
    if (oldvalue) oldvalue = oldvalue.value;
  }
  return oldvalue;
}
function remove(key) {
  const entry = this._keymap[key];
  if (!entry) return void 0;
  delete this._keymap[entry.key];
  if (entry.newer && entry.older) {
    entry.older.newer = entry.newer;
    entry.newer.older = entry.older;
  } else if (entry.newer) {
    entry.newer.older = void 0;
    this.head = entry.newer;
  } else if (entry.older) {
    entry.older.newer = void 0;
    this.tail = entry.older;
  } else {
    this.head = void 0;
    this.tail = void 0;
  }
  this.size -= 1;
  return entry.value;
}
function removeAll() {
  this.head = void 0;
  this.tail = void 0;
  this.size = 0;
  this._keymap = {};
}
function keys() {
  return Object.keys(this._keymap);
}
function forEach(fun, context, desc) {
  let entry;
  if (context === true) {
    desc = true;
    context = void 0;
  } else if (typeof context !== "object") {
    context = this;
  }
  if (desc) {
    entry = this.tail;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.older;
    }
  } else {
    entry = this.head;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.newer;
    }
  }
}
function toJSON() {
  const s = [];
  let entry = this.head;
  while (entry) {
    s.push({
      key: entry.key.toJSON(),
      value: entry.value.toJSON()
    });
    entry = entry.newer;
  }
  return s;
}
function toString2() {
  let s = "";
  let entry = this.head;
  while (entry) {
    s += `${String(entry.key)}:${entry.value}`;
    entry = entry.newer;
    if (entry) s += " < ";
  }
  return s;
}
Object.assign(LruCache.prototype, {
  put,
  get: get2,
  find,
  keys,
  set,
  shift,
  remove,
  removeAll,
  forEach,
  toJSON,
  toString: toString2
});
const version = "2.3.4";
const configs = {
  ..._configs,
  IS_TRACK_RANGE_SELECTABLE,
  OPTIONS_INFO
};
const libraries = {
  d3Array,
  d3Axis,
  d3Brush,
  d3Color,
  d3Drag,
  d3Dsv,
  d3Format,
  d3Geo,
  d3Queue,
  d3Request,
  d3Scale,
  d3Selection,
  d3Transition,
  d3Zoom,
  PIXI: configs.GLOBALS.PIXI,
  mix,
  slugid
};
const tracks$1 = {
  Annotations1dTrack,
  Annotations2dTrack,
  ArrowheadDomainsTrack,
  BarTrack,
  BedLikeTrack,
  CNVIntervalTrack,
  Chromosome2DAnnotations,
  Chromosome2DLabels,
  ChromosomeGrid,
  CombinedTrack,
  CrossRule,
  DivergentBarTrack,
  HeatmapTiledPixiTrack,
  Horizontal1dHeatmapTrack,
  Horizontal2DDomainsTrack,
  HorizontalChromosomeLabels,
  HorizontalGeneAnnotationsTrack,
  HorizontalHeatmapTrack,
  HorizontalLine1DPixiTrack,
  HorizontalMultivecTrack,
  HorizontalPoint1DPixiTrack,
  HorizontalRule,
  HorizontalTiled1DPixiTrack,
  HorizontalTiledPlot,
  HorizontalTrack,
  Id2DTiledPixiTrack,
  IdHorizontal1DTiledPixiTrack,
  IdVertical1DTiledPixiTrack,
  LeftAxisTrack,
  MapboxTilesTrack,
  MoveableTrack,
  OSMTileIdsTrack,
  OSMTilesTrack,
  OverlayTrack,
  PixiTrack,
  RasterTilesTrack,
  SVGTrack,
  SquareMarkersTrack,
  Tiled1DPixiTrack,
  TiledPixiTrack,
  TopAxisTrack,
  Track,
  ValueIntervalTrack,
  VerticalRule,
  VerticalTiled1DPixiTrack,
  VerticalTrack,
  ViewportTracker2D: ViewportTracker2D$1,
  ViewportTracker2DPixi: ViewportTracker2D,
  ViewportTrackerHorizontal,
  ViewportTrackerVertical
};
const factories = {
  ContextMenuItem,
  DataFetcher,
  LruCache
};
const chromosomes = {
  ChromosomeInfo,
  SearchField
};
const dataFetchers = {
  DataFetcher,
  GBKDataFetcher,
  LocalDataFetcher: LocalTileDataFetcher,
  getDataFetcher: getDataFetcher$1
};
const AVAILABLE_FOR_PLUGINS = {
  chromosomes,
  libraries,
  tracks: tracks$1,
  dataFetchers,
  factories,
  services,
  utils,
  configs,
  VERSION: version
};
const classes$2 = {
  "track-renderer": "_track-renderer_11dwb_1",
  "track-renderer-element": "_track-renderer-element_11dwb_5",
  "track-renderer-events": "_track-renderer-events_11dwb_6"
};
function _classCallCheck$8(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$8(o.key), o);
  }
}
function _createClass$8(e, r2, t) {
  return r2 && _defineProperties$8(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$8(t) {
  var i = _toPrimitive$8(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$8(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$8(t, o, e) {
  return o = _getPrototypeOf$8(o), _possibleConstructorReturn$8(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf$8(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$8(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(t);
}
function _assertThisInitialized$8(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$8() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$8 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$8(t) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$8(t);
}
function _inherits$8(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$8(t, e);
}
function _setPrototypeOf$8(t, e) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$8(t, e);
}
const {
  getDataFetcher
} = AVAILABLE_FOR_PLUGINS.dataFetchers;
const SCROLL_TIMEOUT = 100;
let TrackRenderer = /* @__PURE__ */ (function(_React$Component) {
  function TrackRenderer2(props) {
    var _this;
    _classCallCheck$8(this, TrackRenderer2);
    _this = _callSuper$8(this, TrackRenderer2, [props]);
    _this.dragging = false;
    _this.element = null;
    _this.eventTracker = null;
    _this.eventTrackerOld = null;
    _this.closing = false;
    _this.yPositionOffset = 0;
    _this.xPositionOffset = 0;
    _this.scrollTop = 0;
    _this.scrollTimeout = null;
    _this.activeTransitions = 0;
    _this.zoomTransform = identity$4;
    _this.windowScrolledBound = _this.windowScrolled.bind(_this);
    _this.zoomStartedBound = _this.zoomStarted.bind(_this);
    _this.zoomedBound = _this.zoomed.bind(_this);
    _this.zoomEndedBound = _this.zoomEnded.bind(_this);
    _this.uid = slugid.nice();
    _this.viewUid = _this.props.uid;
    _this.availableForPlugins = {
      ...AVAILABLE_FOR_PLUGINS,
      services: {
        ...AVAILABLE_FOR_PLUGINS.services,
        pubSub: _this.props.pubSub,
        pixiRenderer: _this.props.pixiRenderer
      }
    };
    _this.mounted = false;
    _this.emptyZoomBehavior = zoom();
    _this.currentProps = props;
    _this.prevPropsStr = "";
    _this.zoomBehavior = /** @type {import("d3-zoom").ZoomBehavior<HTMLElement, any>} */
    zoom().filter((event) => {
      if (event.target.classList.contains("no-zoom")) {
        return false;
      }
      if (event.target.classList.contains("react-resizable-handle")) {
        return false;
      }
      return true;
    }).on("start", _this.zoomStartedBound).on("zoom", _this.zoomedBound).on("end", _this.zoomEndedBound);
    _this.zoomTransform = identity$4;
    _this.prevZoomTransform = identity$4;
    _this.initialXDomain = [0, 1];
    _this.initialYDomain = [0, 1];
    _this.xDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER];
    _this.yDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER];
    _this.zoomLimits = [0, Number.MAX_SAFE_INTEGER];
    _this.prevCenterX = _this.currentProps.paddingLeft + _this.currentProps.leftWidth + _this.currentProps.centerWidth / 2;
    _this.prevCenterY = _this.currentProps.paddingTop + _this.currentProps.topHeight + _this.currentProps.centerHeight / 2;
    _this.cumCenterXOffset = 0;
    _this.cumCenterYOffset = 0;
    _this.setUpInitialScales(_this.currentProps.initialXDomain, _this.currentProps.initialYDomain, _this.currentProps.xDomainLimits, _this.currentProps.yDomainLimits, _this.currentProps.zoomLimits);
    _this.setUpScales();
    _this.trackDefObjects = {};
    _this.metaTracks = {};
    _this.pubSubs = [];
    if (window.higlassTracksByType) {
      for (const pluginTrackType in window.higlassTracksByType) {
        TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
      }
    }
    _this.boundForwardEvent = _this.forwardEvent.bind(_this);
    _this.boundScrollEvent = _this.scrollEvent.bind(_this);
    _this.boundForwardContextMenu = _this.forwardContextMenu.bind(_this);
    _this.dispatchEventBound = _this.dispatchEvent.bind(_this);
    _this.zoomToDataPosHandlerBound = _this.zoomToDataPosHandler.bind(_this);
    _this.onScrollHandlerBound = _this.onScrollHandler.bind(_this);
    _this.elementPos = {
      height: 0,
      width: 0,
      left: 0,
      top: 0
    };
    _this.elementSelection = null;
    return _this;
  }
  _inherits$8(TrackRenderer2, _React$Component);
  return _createClass$8(TrackRenderer2, [{
    key: "xScale",
    get: function() {
      if (!this._xScale) {
        throw new Error("xScale is not defined");
      }
      return this._xScale;
    }
  }, {
    key: "yScale",
    get: function() {
      if (!this._yScale) {
        throw new Error("yScale is not defined");
      }
      return this._yScale;
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.pubSubs = [];
      this.pubSubs.push(this.props.pubSub.subscribe("scroll", this.windowScrolledBound));
      this.pubSubs.push(this.props.pubSub.subscribe("app.event", this.dispatchEventBound));
      this.pubSubs.push(this.props.pubSub.subscribe("zoomToDataPos", this.zoomToDataPosHandlerBound));
      this.pubSubs.push(this.props.pubSub.subscribe("app.scroll", this.onScrollHandlerBound));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.element) {
        throw new Error("Component did not mount, this.element is not defined.");
      }
      this.elementPos = this.element.getBoundingClientRect();
      this.elementSelection = select(this.element);
      this.pStage = new GLOBALS.PIXI.Graphics();
      this.pMask = new GLOBALS.PIXI.Graphics();
      this.pOutline = new GLOBALS.PIXI.Graphics();
      this.pBackground = new GLOBALS.PIXI.Graphics();
      this.pStage.addChild(this.pMask);
      this.pStage.addChild(this.pOutline);
      this.currentProps.pixiStage.addChild(this.pStage);
      this.pStage.mask = this.pMask;
      if (!this.props.isRangeSelection) this.addZoom();
      if (!this.currentProps.svgElement || !this.currentProps.canvasElement) {
        return;
      }
      this.svgElement = this.currentProps.svgElement;
      this.syncTrackObjects(this.currentProps.positionedTracks);
      this.syncMetaTracks(this.currentProps.metaTracks);
      this.currentProps.setCentersFunction(this.setCenter.bind(this));
      this.currentProps.registerDraggingChangedListener(this.draggingChanged.bind(this));
      this.draggingChanged(true);
      this.addEventTracker();
      const transExt = [[this.xScale(this.xDomainLimits[0]), this.yScale(this.yDomainLimits[0])], [this.xScale(this.xDomainLimits[1]), this.yScale(this.yDomainLimits[1])]];
      const svgBBox = this.svgElement.getBoundingClientRect();
      const ext = [[Math.max(transExt[0][0], 0), Math.max(transExt[0][1], 0)], [Math.min(transExt[1][0], svgBBox.width), Math.min(transExt[1][1], svgBBox.height)]];
      this.zoomBehavior.extent(ext).translateExtent(transExt).scaleExtent(this.zoomLimits);
    }
    /** @param {TrackRendererProps} nextProps */
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!nextProps.svgElement || !nextProps.canvasElement) {
        return;
      }
      const nextPropsStr = this.updatablePropsToString(nextProps);
      this.currentProps = nextProps;
      if (this.prevPropsStr === nextPropsStr) return;
      this.setBackground();
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        track.delayDrawing = true;
      }
      this.prevPropsStr = nextPropsStr;
      this.setUpInitialScales(nextProps.initialXDomain, nextProps.initialYDomain, nextProps.xDomainLimits, nextProps.yDomainLimits, nextProps.zoomLimits);
      this.setUpScales(nextProps.width !== this.props.width || nextProps.height !== this.props.height);
      this.svgElement = nextProps.svgElement;
      const transExt = [[this.xScale(this.xDomainLimits[0]), this.yScale(this.yDomainLimits[0])], [this.xScale(this.xDomainLimits[1]), this.yScale(this.yDomainLimits[1])]];
      const svgBBox = this.svgElement.getBoundingClientRect();
      const ext = [[Math.max(transExt[0][0], 0), Math.max(transExt[0][1], 0)], [Math.min(transExt[1][0], svgBBox.width), Math.min(transExt[1][1], svgBBox.height)]];
      this.zoomBehavior.extent(ext).translateExtent(transExt).scaleExtent(this.zoomLimits);
      this.syncTrackObjects(nextProps.positionedTracks);
      this.syncMetaTracks(nextProps.metaTracks);
      for (const track of nextProps.positionedTracks) {
        const options2 = track.track.options;
        const trackObject = this.trackDefObjects[track.track.uid].trackObject;
        trackObject.rerender(options2);
        if (isCombinedTrackConfig(track.track)) {
          const ctDefs = {};
          for (const ct of track.track.contents) {
            ctDefs[ct.uid] = ct;
          }
          for (const uid in trackObject.createdTracks) {
            trackObject.createdTracks[uid].rerender(ctDefs[uid].options);
          }
        }
      }
      this.props.onNewTilesLoaded();
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        track.delayDrawing = false;
        track.draw();
      }
    }
    /** @param {TrackRendererProps} prevProps */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.initialXDomain[0] !== prevProps.initialXDomain[0] || this.props.initialXDomain[1] !== prevProps.initialXDomain[1] || this.props.initialYDomain[0] !== prevProps.initialYDomain[0] || this.props.initialYDomain[1] !== prevProps.initialYDomain[1]) {
        if (this.element) this.element.__zoom = identity$4;
      }
      if (prevProps.isRangeSelection !== this.props.isRangeSelection) {
        if (this.props.isRangeSelection) {
          this.removeZoom();
        } else {
          this.addZoom();
        }
      }
      if (prevProps.zoomable !== this.props.zoomable) {
        if (this.props.zoomable) {
          this.addZoom();
        } else {
          this.removeZoom();
        }
      }
      this.addEventTracker();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.removeTracks(Object.keys(this.trackDefObjects));
      this.removeMetaTracks(Object.keys(this.metaTracks));
      this.currentProps.removeDraggingChangedListener(this.draggingChanged);
      if (this.pStage) this.currentProps.pixiStage.removeChild(this.pStage);
      this.pMask?.destroy(true);
      this.pStage?.destroy(true);
      this.pubSubs.forEach((subscription) => this.props.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
      this.removeEventTracker();
    }
    /* --------------------------- Custom Methods ----------------------------- */
    /**
     * Dispatch a forwarded event on the main DOM element
     *
     * @param  {Event & { sourceUid: string, type: string }} event Event to be dispatched.
     */
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent2(event) {
      if (event.sourceUid === this.uid && event.type !== "contextmenu") {
        if (this.element) forwardEvent(event, this.element);
      }
    }
    /**
     * Check of a view position (i.e., pixel coords) is within this view
     *
     * @param {number} x - X position to be tested.
     * @param {number} y - Y position to be tested.
     * @return {boolean} If `true` position is within this view.
     */
  }, {
    key: "isWithin",
    value: function isWithin2(x, y) {
      const withinX = x >= this.elementPos.left && x <= this.elementPos.width + this.elementPos.left;
      const withinY = y >= this.elementPos.top && y <= this.elementPos.height + this.elementPos.top;
      return withinX && withinY;
    }
    /** @param {{ pos: [number, number, number, number], animateTime: number }} opts */
  }, {
    key: "zoomToDataPosHandler",
    value: function zoomToDataPosHandler({
      pos,
      animateTime
    }) {
      this.zoomToDataPos(...pos, animateTime);
    }
  }, {
    key: "addZoom",
    value: function addZoom() {
      if (!this.elementSelection || !this.currentProps.zoomable) return;
      this.elementSelection.call(this.zoomBehavior);
      this.zoomBehavior.transform(this.elementSelection, this.zoomTransform);
    }
  }, {
    key: "removeZoom",
    value: function removeZoom() {
      if (this.elementSelection) {
        this.zoomEnded();
        this.elementSelection.on(".zoom", null);
      }
    }
    /*
     * Add a mask to make sure that the tracks displayed in this view
     * don't overflow its bounds.
     */
  }, {
    key: "setMask",
    value: function setMask() {
      this.pMask?.clear();
      this.pMask?.beginFill();
      this.pMask?.drawRect(this.xPositionOffset, this.yPositionOffset, this.currentProps.width, this.currentProps.height);
      this.pMask?.endFill();
    }
  }, {
    key: "setBackground",
    value: function setBackground() {
      const defBgColor = this.props.theme === THEME_DARK ? "black" : "white";
      const bgColor = colorToHex(this.currentProps.viewOptions?.backgroundColor ?? defBgColor);
      this.pBackground?.clear();
      this.pBackground?.beginFill(bgColor);
      this.pBackground?.drawRect(this.xPositionOffset, this.yPositionOffset, this.currentProps.width, this.currentProps.height);
      this.pBackground?.endFill();
    }
  }, {
    key: "windowScrolled",
    value: function windowScrolled() {
      this.removeZoom();
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = setTimeout(() => {
        this.addZoom();
      }, SCROLL_TIMEOUT);
    }
    /**
     * @param {[number, number]} initialXDomain
     * @param {[number, number]} initialYDomain
     * @param {[number, number]} xDomainLimits
     * @param {[number, number]} yDomainLimits
     * @param {[number, number]} zoomLimits
     */
  }, {
    key: "setUpInitialScales",
    value: function setUpInitialScales(initialXDomain = [0, 1], initialYDomain = [0, 1], xDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER], yDomainLimits = [-Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER], zoomLimits = [0, Number.MAX_SAFE_INTEGER]) {
      zoomLimits[0] = zoomLimits[0] === null ? 0 : zoomLimits[0];
      zoomLimits[1] = zoomLimits[1] === null ? Number.POSITIVE_INFINITY : zoomLimits[1];
      const xWidth = initialXDomain[1] - initialXDomain[0];
      const yCenter = (initialYDomain[0] + initialYDomain[1]) / 2;
      initialYDomain[0] = yCenter - xWidth / 2;
      initialYDomain[1] = yCenter + xWidth / 2;
      if (initialXDomain[0] === this.initialXDomain[0] && initialXDomain[1] === this.initialXDomain[1] && initialYDomain[0] === this.initialYDomain[0] && initialYDomain[1] === this.initialYDomain[1] && xDomainLimits[0] === this.xDomainLimits[0] && xDomainLimits[1] === this.xDomainLimits[1] && yDomainLimits[0] === this.yDomainLimits[0] && yDomainLimits[1] === this.yDomainLimits[1] && zoomLimits[0] === this.zoomLimits[0] && zoomLimits[1] === this.zoomLimits[1]) return;
      this.initialXDomain = initialXDomain;
      this.initialYDomain = initialYDomain;
      this.xDomainLimits = xDomainLimits;
      this.yDomainLimits = yDomainLimits;
      this.zoomLimits = zoomLimits;
      this.zoomTransform = identity$4;
      this.prevZoomTransform = identity$4;
      this.cumCenterYOffset = 0;
      this.cumCenterXOffset = 0;
      this.drawableToDomainX = linear().domain([this.currentProps.paddingLeft + this.currentProps.leftWidth, this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth]).range([initialXDomain[0], initialXDomain[1]]);
      let startY;
      let endY;
      if (this.currentProps.centerWidth === 0) {
        startY = this.currentProps.paddingTop + this.currentProps.topHeight;
        endY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight;
      } else {
        startY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2 - this.currentProps.centerWidth / 2;
        endY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2 + this.currentProps.centerWidth / 2;
      }
      this.drawableToDomainY = linear().domain([startY, endY]).range([initialYDomain[0], initialYDomain[1]]);
      this.prevCenterX = this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth / 2;
      this.prevCenterY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2;
    }
    /** @param {TrackRendererProps} props */
  }, {
    key: "updatablePropsToString",
    value: function updatablePropsToString(props) {
      return JSON.stringify({
        positionedTracks: props.positionedTracks,
        initialXDomain: props.initialXDomain,
        initialYDomain: props.initialYDomain,
        width: props.width,
        height: props.height,
        paddingLeft: props.paddingLeft,
        paddingTop: props.paddingTop,
        leftWidth: props.leftWidth,
        topHeight: props.topHeight,
        dragging: props.dragging,
        viewOptions: props.viewOptions
      });
    }
    /** @param {boolean} draggingStatus */
  }, {
    key: "draggingChanged",
    value: function draggingChanged(draggingStatus) {
      this.dragging = draggingStatus;
      this.timedUpdatePositionAndDimensions();
    }
  }, {
    key: "setUpScales",
    value: function setUpScales(notify = false) {
      const currentCenterX = this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth / 2;
      const currentCenterY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2;
      if (!this.drawableToDomainX || !this.drawableToDomainY) {
        return;
      }
      const centerDomainXOffset = (this.drawableToDomainX(currentCenterX) - this.drawableToDomainX(this.prevCenterX)) / this.zoomTransform.k;
      const centerDomainYOffset = (this.drawableToDomainY(currentCenterY) - this.drawableToDomainY(this.prevCenterY)) / this.zoomTransform.k;
      this.cumCenterYOffset += centerDomainYOffset;
      this.cumCenterXOffset += centerDomainXOffset;
      this.prevCenterY = currentCenterY;
      this.prevCenterX = currentCenterX;
      const visibleXDomain = [this.drawableToDomainX(0) - this.cumCenterXOffset, this.drawableToDomainX(this.currentProps.width) - this.cumCenterXOffset];
      const visibleYDomain = [this.drawableToDomainY(0) - this.cumCenterYOffset, this.drawableToDomainY(this.currentProps.height) - this.cumCenterYOffset];
      this._xScale = linear().domain(visibleXDomain).range([0, this.currentProps.width]);
      this._yScale = linear().domain(visibleYDomain).range([0, this.currentProps.height]);
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        track.refScalesChanged(this.xScale, this.yScale);
      }
      this.applyZoomTransform(notify);
    }
    /**
     * Get a track's viewconf definition by its object
     *
     * @param {TrackObject} trackObjectIn
     */
  }, {
    key: "getTrackDef",
    value: function getTrackDef(trackObjectIn) {
      const trackDefItems = dictItems(this.trackDefObjects);
      for (const [, {
        trackDef,
        trackObject
      }] of trackDefItems) {
        if (trackObject === trackObjectIn) {
          return trackDef.track;
        }
        if (isCombinedTrackConfig(trackDef.track)) {
          for (const subTrackDef of trackDef.track.contents) {
            if (trackObject.createdTracks[subTrackDef.uid] === trackObjectIn) {
              return subTrackDef;
            }
          }
        }
      }
      return null;
    }
    /**
     * Fetch the trackObject for a track with a given ID
     *
     * @param {string} trackId
     * @return {TrackObject | undefined}
     */
  }, {
    key: "getTrackObject",
    value: function getTrackObject(trackId) {
      const trackDefItems = dictItems(this.trackDefObjects);
      for (let i = 0; i < trackDefItems.length; i++) {
        const uid = trackDefItems[i][0];
        const trackObject = trackDefItems[i][1].trackObject;
        if (uid === trackId) {
          return trackObject;
        }
        if (trackObject.createdTracks) {
          const createdTrackItems = dictItems(trackObject.createdTracks);
          for (let j = 0; j < createdTrackItems.length; j++) {
            const createdTrackUid = createdTrackItems[j][0];
            const createdTrackObject = createdTrackItems[j][1];
            if (createdTrackUid === trackId) {
              return createdTrackObject;
            }
          }
        }
      }
      return void 0;
    }
  }, {
    key: "timedUpdatePositionAndDimensions",
    value: function timedUpdatePositionAndDimensions() {
      if (this.closing || !this.element) return;
      this.elementPos = this.element.getBoundingClientRect();
      if (this.dragging) {
        this.yPositionOffset = this.element.getBoundingClientRect().top - this.currentProps.canvasElement.getBoundingClientRect().top + this.scrollTop;
        this.xPositionOffset = this.element.getBoundingClientRect().left - this.currentProps.canvasElement.getBoundingClientRect().left;
        this.setMask();
        this.setBackground();
        const updated = this.updateTrackPositions();
        if (updated) {
          this.applyZoomTransform(true);
        }
        requestAnimationFrame(this.timedUpdatePositionAndDimensions.bind(this));
      }
    }
    /**
     * @param {Array<TrackConfig>} trackDefinitions
     */
  }, {
    key: "syncMetaTracks",
    value: function syncMetaTracks(trackDefinitions) {
      const knownMetaTrackIds = Object.keys(this.metaTracks);
      const newMetaTracks = new Set(trackDefinitions.map((def) => def.uid));
      this.addMetaTracks(trackDefinitions.filter((def) => !this.metaTracks[def.uid]));
      this.updateMetaTracks(trackDefinitions.filter((def) => this.metaTracks[def.uid]));
      this.removeMetaTracks(knownMetaTrackIds.filter((def) => !newMetaTracks.has(def)));
    }
    /**
     * @param {Array<TrackDefinition>} trackDefinitions
     */
  }, {
    key: "syncTrackObjects",
    value: function syncTrackObjects(trackDefinitions) {
      this.prevTrackDefinitions = JSON.stringify(trackDefinitions);
      const receivedTracksDict = {};
      for (let i = 0; i < trackDefinitions.length; i++) {
        receivedTracksDict[trackDefinitions[i].track.uid] = trackDefinitions[i];
      }
      const knownTracks = new Set(Object.keys(this.trackDefObjects));
      const receivedTracks = new Set(Object.keys(receivedTracksDict));
      const enterTrackDefs = new Set([...receivedTracks].filter((x) => !knownTracks.has(x)));
      const exitTracks = new Set([...knownTracks].filter((x) => !receivedTracks.has(x)));
      const updateTrackDefs = new Set([...receivedTracks].filter((x) => knownTracks.has(x)));
      this.updateExistingTrackDefs([...updateTrackDefs].map((x) => receivedTracksDict[x]));
      this.addNewTracks([...enterTrackDefs].map((x) => receivedTracksDict[x]));
      this.updateExistingTrackDefs([...enterTrackDefs].map((x) => receivedTracksDict[x]));
      this.removeTracks([...exitTracks]);
    }
    /**
     * Add new meta tracks
     *
     * @param {Array<TrackConfig>} metaTrackDefs  Definitions of meta tracks to be added.
     */
  }, {
    key: "addMetaTracks",
    value: function addMetaTracks(metaTrackDefs) {
      metaTrackDefs.filter((metaTrackDef) => !this.metaTracks[metaTrackDef.uid]).forEach((metaTrackDef) => {
        this.metaTracks[metaTrackDef.uid] = {
          trackDef: metaTrackDef,
          trackObject: this.createMetaTrack(metaTrackDef)
        };
      });
    }
    /**
     * @param {Array<TrackDefinition>} newTrackDefinitions
     */
  }, {
    key: "addNewTracks",
    value: function addNewTracks(newTrackDefinitions) {
      if (!this.currentProps.pixiStage) {
        return;
      }
      for (let i = 0; i < newTrackDefinitions.length; i++) {
        const newTrackDef = newTrackDefinitions[i];
        const newTrackObj = this.createTrackObject(newTrackDef.track);
        newTrackObj.refScalesChanged(this.xScale, this.yScale);
        this.trackDefObjects[newTrackDef.track.uid] = {
          trackDef: newTrackDef,
          trackObject: newTrackObj
        };
        const zoomedXScale = this.zoomTransform.rescaleX(this.xScale);
        const zoomedYScale = this.zoomTransform.rescaleY(this.yScale);
        newTrackObj.setDimensions([newTrackDef.width, newTrackDef.height]);
        newTrackObj.zoomed(zoomedXScale, zoomedYScale);
      }
      this.applyZoomTransform(false);
    }
    /** @param {unknown} _unused */
  }, {
    key: "updateMetaTracks",
    value: function updateMetaTracks(_unused) {
    }
    /** @param {Array<TrackDefinition>} newTrackDefs */
  }, {
    key: "updateExistingTrackDefs",
    value: function updateExistingTrackDefs(newTrackDefs) {
      for (const trackDef of newTrackDefs) {
        const ref2 = this.trackDefObjects[trackDef.track.uid];
        ref2.trackDef = trackDef;
        if (isCombinedTrackConfig(trackDef.track)) {
          ref2.trackObject.updateContents(trackDef.track.contents, this.createTrackObject.bind(this)).refScalesChanged(this.xScale, this.yScale);
        }
      }
      const updated = this.updateTrackPositions();
      if (updated) {
        this.applyZoomTransform(false);
      }
    }
  }, {
    key: "updateTrackPositions",
    value: function updateTrackPositions() {
      let updated = false;
      for (const uid in this.trackDefObjects) {
        const trackDef = this.trackDefObjects[uid].trackDef;
        const trackObject = this.trackDefObjects[uid].trackObject;
        const prevPosition = trackObject.position;
        const prevDimensions = trackObject.dimensions;
        const newPosition = [this.xPositionOffset + trackDef.left, this.yPositionOffset + trackDef.top];
        const newDimensions = [trackDef.width, trackDef.height];
        if (!prevPosition || newPosition[0] !== prevPosition[0] || newPosition[1] !== prevPosition[1]) {
          trackObject.setPosition(newPosition);
          updated = true;
        }
        if (!prevDimensions || newDimensions[0] !== prevDimensions[0] || newDimensions[1] !== prevDimensions[1]) {
          trackObject.setDimensions(newDimensions);
          updated = true;
        }
      }
      return updated;
    }
    /** @param {string[]} trackIds */
  }, {
    key: "removeMetaTracks",
    value: function removeMetaTracks(trackIds) {
      trackIds.forEach((id2) => {
        this.metaTracks[id2].trackObject.remove();
        this.metaTracks[id2] = void 0;
        delete this.metaTracks[id2];
      });
    }
    /** @param {string[]} trackUids */
  }, {
    key: "removeTracks",
    value: function removeTracks(trackUids) {
      for (let i = 0; i < trackUids.length; i++) {
        this.trackDefObjects[trackUids[i]].trackObject.remove();
        delete this.trackDefObjects[trackUids[i]];
      }
    }
    /**
     * Set the center of this view to a paticular X and Y coordinate
     * @param  {number}  centerX  Centeral X data? position.
     * @param  {number}  centerY  Central Y data? position.
     * @param  {number}  sourceK  Source zoom level? @Pete what's the source?
     * @param  {boolean}  notify  If `true` notify listeners that the scales
     *   have changed. This can be turned off to prevent circular updates when
     *   scales are locked.
     * @param  {number}  animateTime  Animation time in milliseconds. Only used
     *   when `animate` is true.
     * @param  {Scale}  xScale  The scale to use for the X axis.
     * @param  {Scale}  yScale  The scale to use for the Y axis.
     */
  }, {
    key: "setCenter",
    value: function setCenter(centerX, centerY, sourceK, notify = false, animateTime = 0, xScale = this.xScale, yScale = this.yScale) {
      const refK = this.xScale.invert(1) - this.xScale.invert(0);
      const k = refK / sourceK;
      const middleViewX = this.currentProps.paddingLeft + this.currentProps.leftWidth + this.currentProps.centerWidth / 2;
      const middleViewY = this.currentProps.paddingTop + this.currentProps.topHeight + this.currentProps.centerHeight / 2;
      const translateX2 = middleViewX - xScale(centerX) * k;
      const translateY2 = middleViewY - yScale(centerY) * k;
      let last;
      const setZoom = () => {
        const newTransform = identity$4.translate(translateX2, translateY2).scale(k);
        this.zoomTransform = newTransform;
        if (this.elementSelection) {
          this.emptyZoomBehavior.transform(this.elementSelection, newTransform);
        }
        last = this.applyZoomTransform(notify);
      };
      if (animateTime && this.elementSelection) {
        let selection2 = this.elementSelection;
        this.activeTransitions += 1;
        if (!document.hidden) {
          selection2 = selection2.transition().duration(animateTime);
        }
        selection2.call(this.zoomBehavior.transform, identity$4.translate(translateX2, translateY2).scale(k)).on("end", () => {
          setZoom();
          this.activeTransitions -= 1;
        });
      } else {
        setZoom();
      }
      return last;
    }
    /** @param {number} movement */
  }, {
    key: "valueScaleMove",
    value: function valueScaleMove(movement) {
      if (!this.zoomStartPos) {
        return;
      }
      for (const track of this.getTracksAtPosition(...this.zoomStartPos)) {
        track.movedY(movement);
      }
      if (this.zoomStartTransform) this.zoomTransform = this.zoomStartTransform;
    }
    /**
     * @param {{ sourceEvent: Event }} event
     * @param {string | null} orientation
     */
  }, {
    key: "valueScaleZoom",
    value: function valueScaleZoom(event, orientation2) {
      if (!isWheelEvent(event.sourceEvent)) {
        return;
      }
      const mdy = event.sourceEvent.deltaY || event.sourceEvent.deltaX;
      const mdm = event.sourceEvent.deltaMode;
      const myWheelDelta = (dy, dm) => dy * (dm ? 120 : 1) / 500;
      const mwd = myWheelDelta(mdy, mdm);
      const cp = pointer(event.sourceEvent, this.props.canvasElement);
      for (const track of this.getTracksAtPosition(...cp)) {
        const yPos = orientation2 === "1d-horizontal" ? cp[1] - track.position[1] : cp[0] - track.position[0];
        track.zoomedY(yPos, 2 ** mwd);
      }
      if (this.zoomStartTransform) this.zoomTransform = this.zoomStartTransform;
    }
    /**
     * Respond to a zoom event.
     *
     * We need to update our local record of the zoom transform and apply it
     * to all the tracks.
     *
     * @param {import("d3-zoom").D3ZoomEvent<HTMLElement, unknown> & { shiftKey?: boolean }} event
     */
  }, {
    key: "zoomed",
    value: function zoomed(event) {
      let trackOrientation = null;
      if (this.zoomStartPos) {
        const tracksAtZoomStart = this.getTracksAtPosition(...this.zoomStartPos);
        if (tracksAtZoomStart.length) {
          const trackAtZoomStart = tracksAtZoomStart[0];
          const trackDef = this.getTrackDef(trackAtZoomStart);
          if (!trackDef) {
            return;
          }
          if (TRACKS_INFO_BY_TYPE[trackDef.type]?.orientation) {
            trackOrientation = TRACKS_INFO_BY_TYPE[trackDef.type].orientation;
          }
          if (trackAtZoomStart instanceof LeftTrackModifier) {
            trackOrientation = "1d-vertical";
          }
        }
      }
      if (trackOrientation && event.sourceEvent) {
        if (event.shiftKey || this.valueScaleZooming || event.sourceEvent?.shiftKey) {
          if (event.sourceEvent.deltaY !== void 0) {
            this.valueScaleZoom(event, trackOrientation);
            return;
          }
          if (trackOrientation === "1d-horizontal") {
            this.valueScaleMove(event.sourceEvent.movementY);
          } else if (trackOrientation === "1d-vertical") {
            this.valueScaleMove(event.sourceEvent.movementX);
          }
        }
        if (trackOrientation === "1d-horizontal" && event.sourceEvent.movementY) {
          this.valueScaleMove(event.sourceEvent.movementY);
        } else if (trackOrientation === "1d-vertical" && event.sourceEvent.movementX) {
          this.valueScaleMove(event.sourceEvent.movementX);
        }
      }
      this.zoomTransform = !this.currentProps.zoomable ? identity$4 : event.transform;
      const zooming = this.prevZoomTransform.k !== this.zoomTransform.k;
      if (!zooming) {
        if (trackOrientation === "1d-horizontal") {
          this.zoomTransform = identity$4.translate(this.zoomTransform.x, this.prevZoomTransform.y).scale(this.zoomTransform.k);
        } else if (trackOrientation === "1d-vertical") {
          this.zoomTransform = identity$4.translate(this.prevZoomTransform.x, this.zoomTransform.y).scale(this.zoomTransform.k);
        }
        if (this.element) this.element.__zoom = this.zoomTransform;
      }
      this.applyZoomTransform(true);
      this.prevZoomTransform = this.zoomTransform;
      this.props.pubSub.publish("app.zoom", event);
      if (event.sourceEvent) {
        event.sourceEvent.stopPropagation();
        event.sourceEvent.preventDefault();
      }
    }
    /**
     * Return a list of tracks under this position.
     *
     * The position should be relative to this.props.canvasElement.
     *
     * @param {number} x The query x position
     * @param {number} y The query y position
     * @return {Array<TrackObject>}  An array of tracks at this position
     */
  }, {
    key: "getTracksAtPosition",
    value: function getTracksAtPosition(x, y) {
      const foundTracks = [];
      let tracksToVisit = [];
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        if (track.childTracks) {
          tracksToVisit = tracksToVisit.concat(track.childTracks);
        } else {
          tracksToVisit.push(track);
        }
      }
      for (const track of tracksToVisit) {
        const withinX = track.position[0] <= x && x <= track.position[0] + track.dimensions[0];
        const withinY = track.position[1] <= y && y <= track.position[1] + track.dimensions[1];
        if (withinX && withinY) {
          foundTracks.push(track);
        }
      }
      return foundTracks;
    }
    /** @param {import('d3-zoom').D3ZoomEvent<HTMLElement, unknown>=} event */
  }, {
    key: "zoomStarted",
    value: function zoomStarted(event) {
      this.zooming = true;
      if (event?.sourceEvent) {
        this.zoomStartPos = pointer(event.sourceEvent, this.props.canvasElement);
        if (event.sourceEvent.shiftKey) {
          this.valueScaleZooming = true;
        }
      }
      this.zoomStartTransform = this.zoomTransform;
      this.props.pubSub.publish("app.zoomStart");
    }
  }, {
    key: "zoomEnded",
    value: function zoomEnded() {
      this.zooming = false;
      this.zoomStartPos = null;
      if (this.valueScaleZooming) {
        this.valueScaleZooming = false;
        if (this.element) this.element.__zoom = this.zoomStartTransform;
      }
      this.props.pubSub.publish("app.zoomEnd");
    }
    /**
     * @param {boolean=} notify
     * @returns {[Scale, Scale] | undefined}
     */
  }, {
    key: "applyZoomTransform",
    value: function applyZoomTransform(notify = true) {
      const props = this.currentProps;
      const paddingleft = props.paddingLeft + props.leftWidth;
      const paddingTop = props.paddingTop + props.topHeight;
      if (!this.xScale || !this.yScale) {
        return void 0;
      }
      this.zoomedXScale = this.zoomTransform.rescaleX(this.xScale);
      this.zoomedYScale = this.zoomTransform.rescaleY(this.yScale);
      const newXScale = linear().domain([paddingleft, paddingleft + props.centerWidth].map(this.zoomedXScale.invert)).range([0, props.centerWidth]);
      const newYScale = linear().domain([paddingTop, paddingTop + props.centerHeight].map(this.zoomedYScale.invert)).range([0, props.centerHeight]);
      for (const uid in this.trackDefObjects) {
        const track = this.trackDefObjects[uid].trackObject;
        const trackDef = this.trackDefObjects[uid].trackDef;
        let orientation2 = "unknown";
        if (TRACKS_INFO_BY_TYPE[trackDef.track.type]) {
          orientation2 = TRACKS_INFO_BY_TYPE[trackDef.track.type].orientation;
        }
        if (orientation2 === "whole") {
          const trackXScale = linear().domain([props.paddingLeft, props.width - props.paddingLeft].map(this.zoomedXScale.invert)).range([0, props.width - 2 * props.paddingLeft]);
          const trackYScale = linear().domain([props.paddingTop, props.height - props.paddingTop].map(this.zoomedYScale.invert)).range([0, props.height - 2 * props.paddingTop]);
          track.zoomed(trackXScale, trackYScale);
          continue;
        }
        if (this.trackDefObjects[uid].trackDef.track.position === "gallery") {
          const trackXScale = linear().domain([props.paddingLeft + props.leftWidthNoGallery, props.paddingLeft + props.leftWidth + props.centerWidth + props.galleryDim].map(this.zoomedXScale.invert)).range([0, props.centerWidth + 2 * props.galleryDim]);
          const trackYScale = linear().domain([props.paddingTop + props.topHeightNoGallery, props.paddingTop + props.topHeight + props.centerHeight + props.galleryDim].map(this.zoomedYScale.invert)).range([0, props.centerHeight - 2 * props.galleryDim]);
          track.zoomed(trackXScale.copy(), trackYScale.copy(), this.zoomTransform.k);
          continue;
        }
        track.zoomed(newXScale.copy(), newYScale.copy(), this.zoomTransform.k, this.zoomTransform.x + this.xPositionOffset, this.zoomTransform.y + this.yPositionOffset, props.paddingLeft + props.leftWidth, props.paddingTop + props.topHeight);
      }
      this.currentXScale = newXScale;
      this.currentYScale = newYScale;
      if (notify) {
        this.currentProps.onScalesChanged(newXScale, newYScale);
      }
      return [newXScale, newYScale];
    }
    /** @param {TrackConfig} track */
  }, {
    key: "createMetaTrack",
    value: function createMetaTrack(track) {
      switch (track.type) {
        default: {
          const pluginTrack = this.props.pluginTracks[track.type];
          if (pluginTrack?.isMetaTrack) {
            const context = {
              getTrackObject: this.getTrackObject.bind(this),
              onNewTilesLoaded: () => {
                this.currentProps.onNewTilesLoaded(track.uid);
              },
              definition: track
            };
            try {
              return new pluginTrack.track(this.availableForPlugins, context, track.options ?? {});
            } catch (e) {
              console.error("Plugin meta track", track.type, "failed to instantiate.", e);
            }
          }
          console.warn(`Unknown meta track of type: ${track.type}`);
          return new UnknownPixiTrack(this.pStage, {
            name: "Unknown Track Type",
            type: track.type
          });
        }
      }
    }
    /** @param {TrackConfig} track */
  }, {
    key: "createTrackObject",
    value: function createTrackObject(track) {
      const trackObject = this.createLocationAgnosticTrackObject(track);
      if (track.position === "left" || track.position === "right") {
        if (TRACKS_INFO_BY_TYPE[track.type].orientation === "1d-horizontal") {
          return new LeftTrackModifier(trackObject);
        }
      }
      return trackObject;
    }
    /** @param {TrackConfig} track */
  }, {
    key: "createLocationAgnosticTrackObject",
    value: function createLocationAgnosticTrackObject(track) {
      let dataConfig = track.data;
      if (!dataConfig) {
        dataConfig = {
          server: trimTrailingSlash(track.server ?? ""),
          tilesetUid: track.tilesetUid
        };
      }
      if (track.coordSystem) {
        dataConfig.coordSystem = track.coordSystem;
      }
      const dataFetcher = getDataFetcher(dataConfig, this.props.pubSub, this.props.pluginDataFetchers, this.availableForPlugins);
      if (!this.pStage || !this.svgElement) {
        throw new Error("No PIXI stage or svg element");
      }
      const context = {
        id: track.uid,
        trackUid: track.uid,
        trackType: track.type,
        viewUid: this.viewUid,
        pubSub: this.props.pubSub,
        scene: this.pStage,
        dataConfig,
        dataFetcher,
        getLockGroupExtrema: () => this.currentProps.getLockGroupExtrema(track.uid),
        handleTilesetInfoReceived: (tilesetInfo) => {
          this.currentProps.onTilesetInfoReceived(track.uid, tilesetInfo);
        },
        animate: () => {
          this.currentProps.onNewTilesLoaded(track.uid);
        },
        svgElement: this.svgElement,
        isValueScaleLocked: () => this.currentProps.isValueScaleLocked(track.uid),
        onValueScaleChanged: () => {
          this.currentProps.onValueScaleChanged(track.uid);
        },
        onTrackOptionsChanged: (newOptions) => {
          this.currentProps.onTrackOptionsChanged(track.uid, newOptions);
        },
        onMouseMoveZoom: this.props.onMouseMoveZoom,
        chromInfoPath: track.chromInfoPath,
        isShowGlobalMousePosition: () => this.props.isShowGlobalMousePosition,
        getTheme: () => this.props.theme
      };
      if (track.y) {
        context.yPosition = track.y;
      }
      if (track.x) {
        context.xPosition = track.x;
      }
      if (track.projectionXDomain) {
        context.projectionXDomain = track.projectionXDomain;
      }
      if (track.projectionYDomain) {
        context.projectionYDomain = track.projectionYDomain;
      }
      switch (track.type) {
        case "left-axis":
          return new LeftAxisTrack(context, track.options);
        case "top-axis":
          return new TopAxisTrack(context, track.options);
        case "heatmap":
          return new HeatmapTiledPixiTrack(context, track.options);
        case "multivec":
        case "vector-heatmap":
        case "horizontal-multivec":
        // legacy, included for backwards compatiblity
        case "horizontal-vector-heatmap":
        // legacy, included for backwards compatiblity
        case "vertical-multivec":
        // legacy, included for backwards compatiblity
        case "vertical-vector-heatmap":
          return new HorizontalMultivecTrack(context, track.options);
        case "1d-heatmap":
        case "horizontal-1d-heatmap":
        // legacy, included for backwards compatiblity
        case "vertical-1d-heatmap":
          return new Horizontal1dHeatmapTrack(context, track.options);
        case "line":
        case "horizontal-line":
        // legacy, included for backwards compatiblity
        case "vertical-line":
          return new HorizontalLine1DPixiTrack(context, track.options);
        case "point":
        case "horizontal-point":
        // legacy, included for backwards compatiblity
        case "vertical-point":
          return new HorizontalPoint1DPixiTrack(context, track.options);
        case "bar":
        case "horizontal-bar":
        // legacy, included for backwards compatiblity
        case "vertical-bar":
          return new BarTrack(context, track.options);
        case "divergent-bar":
        case "horizontal-divergent-bar":
        // legacy, included for backwards compatiblity
        case "vertical-divergent-bar":
          return new DivergentBarTrack(context, track.options);
        case "horizontal-1d-tiles":
          return new IdHorizontal1DTiledPixiTrack(context, track.options);
        case "vertical-1d-tiles":
          return new IdVertical1DTiledPixiTrack(context, track.options);
        case "2d-tiles":
          return new Id2DTiledPixiTrack(context, track.options);
        case "stacked-interval":
        case "top-stacked-interval":
        // legacy, included for backwards compatiblity
        case "left-stacked-interval":
          return new CNVIntervalTrack(context, track.options);
        case "viewport-projection-center":
          if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
            context.registerViewportChanged = track.registerViewportChanged;
            context.removeViewportChanged = track.removeViewportChanged;
            context.setDomainsCallback = track.setDomainsCallback;
            return new ViewportTracker2D$1(context, track.options);
          }
          return new Track(context, {});
        case "viewport-projection-horizontal":
          if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
            context.registerViewportChanged = track.registerViewportChanged;
            context.removeViewportChanged = track.removeViewportChanged;
            context.setDomainsCallback = track.setDomainsCallback;
            return new ViewportTrackerHorizontal(context, track.options);
          }
          return new Track(context, {});
        case "viewport-projection-vertical":
          if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
            context.registerViewportChanged = track.registerViewportChanged;
            context.removeViewportChanged = track.removeViewportChanged;
            context.setDomainsCallback = track.setDomainsCallback;
            return new ViewportTrackerVertical(context, track.options);
          }
          return new Track(context, {});
        case "gene-annotations":
        case "horizontal-gene-annotations":
        // legacy, included for backwards compatiblity
        case "vertical-gene-annotations":
          return new HorizontalGeneAnnotationsTrack(context, track.options);
        case "2d-rectangle-domains":
        case "arrowhead-domains":
          return new ArrowheadDomainsTrack(context, track.options);
        case "1d-annotations":
        case "horizontal-1d-annotations":
        case "vertical-1d-annotations":
          return new Annotations1dTrack(context, track.options, true);
        case "2d-annotations":
          return new Annotations2dTrack(context, track.options);
        case "linear-2d-rectangle-domains":
        case "horizontal-2d-rectangle-domains":
        // legacy, included for backwards compatiblity
        case "vertical-2d-rectangle-domains":
          return new Horizontal2DDomainsTrack(context, track.options);
        case "square-markers":
          return new SquareMarkersTrack(context, track.options);
        case "combined":
          context.tracks = track.contents;
          context.createTrackObject = this.createTrackObject.bind(this);
          return new CombinedTrack(context);
        case "2d-chromosome-labels":
          return new Chromosome2DLabels(context, track.options);
        case "horizontal-chromosome-grid":
          context.orientation = "1d-horizontal";
          return new ChromosomeGrid(context, track.options);
        case "vertical-chromosome-grid":
          context.orientation = "1d-vertical";
          return new ChromosomeGrid(context, track.options);
        case "2d-chromosome-grid":
          return new ChromosomeGrid(context, track.options);
        case "chromosome-labels":
        case "horizontal-chromosome-labels":
        // legacy, included for backwards compatiblity
        case "vertical-chromosome-labels":
          return new HorizontalChromosomeLabels(context, track.options);
        case "linear-heatmap":
        case "horizontal-heatmap":
        // legacy, included for backwards compatiblity
        case "vertical-heatmap":
          return new HorizontalHeatmapTrack(context, track.options);
        case "2d-chromosome-annotations":
          return new Chromosome2DAnnotations(context, track.options);
        case "1d-value-interval":
        case "horizontal-1d-value-interval":
        // legacy, included for backwards compatiblity
        case "vertical-1d-value-interval":
          return new ValueIntervalTrack(context, track.options);
        case "osm":
        case "osm-tiles":
          return new OSMTilesTrack(context, track.options);
        case "osm-2d-tile-ids":
          return new OSMTileIdsTrack(context, track.options);
        case "mapbox":
        case "mapbox-tiles":
          return new MapboxTilesTrack(context, track.options);
        case "raster-tiles":
          return new RasterTilesTrack(context, track.options);
        case "bedlike":
        case "vertical-bedlike":
          return new BedLikeTrack(context, track.options);
        case "overlay-track":
          return new OverlayTrack(context, track.options);
        case "overlay-chromosome-grid-track":
          context.isOverlay = true;
          return new ChromosomeGrid(context, track.options);
        case "horizontal-rule":
          return new HorizontalRule(context, track.options);
        case "vertical-rule":
          return new VerticalRule(context, track.options);
        case "cross-rule":
          context.x = track.x;
          context.y = track.y;
          return new CrossRule(context, track.options);
        case "simple-svg":
          return new SVGTrack(context, track.options);
        case "empty": {
          const options2 = track.options;
          return new PixiTrack(context, options2);
        }
        default: {
          const pluginTrack = this.props.pluginTracks[track.type];
          if (pluginTrack && !pluginTrack.isMetaTrack) {
            context.AVAILABLE_FOR_PLUGINS = this.availableForPlugins;
            context.baseEl = this.baseEl;
            context.definition = track;
            if (track.registerViewportChanged && track.removeViewportChanged && track.setDomainsCallback) {
              context.registerViewportChanged = track.registerViewportChanged;
              context.removeViewportChanged = track.removeViewportChanged;
              context.setDomainsCallback = track.setDomainsCallback;
            }
            try {
              return new pluginTrack.track(this.availableForPlugins, context, track.options ?? {});
            } catch (e) {
              console.error("Plugin track", track.type, "failed to instantiate.", e);
            }
          }
          console.warn("Unknown track type:", track.type);
          return new UnknownPixiTrack(context, {
            name: "Unknown Track Type",
            type: track.type
          });
        }
      }
    }
    /**
     * Zoom to a location given the data coordinates
     * @param   {number}  dataXStart  Data start X coordinate.
     * @param   {number}  dataXEnd  Data end X coordinate.
     * @param   {number}  dataYStart  Data start Y coordinate.
     * @param   {number}  dataYEnd  Data end Y coordinate.
     * @param   {number}  animateTime  Animation time in milliseconds.
     * @param   {ProjectorFunction | null}  projector  If not `null` a projector function that
     *   provides adjusted x and y scales.
     */
  }, {
    key: "zoomToDataPos",
    value: function zoomToDataPos(dataXStart, dataXEnd, dataYStart, dataYEnd, animateTime = 3e3, projector = null) {
      const [centerX, centerY, k] = scalesCenterAndK(this.xScale.copy().domain([dataXStart, dataXEnd]), this.yScale.copy().domain([dataYStart, dataYEnd]));
      const projectedScales = projector ? projector(this.xScale, this.yScale) : [this.xScale, this.yScale];
      this.setCenter(centerX, centerY, k, false, animateTime, projectedScales[0], projectedScales[1]);
    }
    /**
     * @param {{ altKey: boolean, preventDefault: () => void }} e
     */
  }, {
    key: "forwardContextMenu",
    value: function forwardContextMenu(e) {
      if (this.props.disableTrackMenu || e.altKey) return;
      e.preventDefault();
      setTimeout(() => {
        this.props.pubSub.publish("contextmenu", e);
      }, 0);
    }
  }, {
    key: "addEventTracker",
    value: function addEventTracker() {
      if (!this.eventTracker || this.eventTracker === this.eventTrackerOld) return;
      if (!this.eventTrackerOld) this.eventTrackerOld = this.eventTracker;
      this.eventTracker = this.eventTrackerOld;
      this.eventTracker.addEventListener("click", this.boundForwardEvent);
      this.eventTracker.addEventListener("contextmenu", this.boundForwardContextMenu);
      this.eventTracker.addEventListener("dblclick", this.boundForwardEvent);
      this.eventTracker.addEventListener("wheel", this.boundForwardEvent);
      this.eventTracker.addEventListener("dragstart", this.boundForwardEvent);
      this.eventTracker.addEventListener("selectstart", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseover", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseenter", this.boundForwardEvent);
      this.eventTracker.addEventListener("mousedown", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseup", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseout", this.boundForwardEvent);
      this.eventTracker.addEventListener("mouseleave", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchstart", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchend", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchmove", this.boundForwardEvent);
      this.eventTracker.addEventListener("touchcancel", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerover", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerenter", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerdown", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerup", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointercancel", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerout", this.boundForwardEvent);
      this.eventTracker.addEventListener("pointerleave", this.boundForwardEvent);
      window.addEventListener("scroll", this.boundScrollEvent);
    }
  }, {
    key: "removeEventTracker",
    value: function removeEventTracker() {
      if (!this.eventTracker) return;
      this.eventTracker.removeEventListener("click", this.boundForwardEvent);
      this.eventTracker.removeEventListener("contextmenu", this.boundForwardContextMenu);
      this.eventTracker.removeEventListener("dblclick", this.boundForwardEvent);
      this.eventTracker.removeEventListener("wheel", this.boundForwardEvent);
      this.eventTracker.removeEventListener("dragstart", this.boundForwardEvent);
      this.eventTracker.removeEventListener("selectstart", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseover", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseenter", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mousedown", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseup", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseout", this.boundForwardEvent);
      this.eventTracker.removeEventListener("mouseleave", this.boundForwardEvent);
      this.eventTracker.removeEventListener("touchstart", this.boundForwardEvent);
      this.eventTracker.removeEventListener("touchend", this.boundForwardEvent);
      this.eventTracker.removeEventListener("touchcancel", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerover", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerenter", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerdown", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerup", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointercancel", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerout", this.boundForwardEvent);
      this.eventTracker.removeEventListener("pointerleave", this.boundForwardEvent);
      window.removeEventListener("scroll", this.boundScrollEvent);
    }
  }, {
    key: "scrollEvent",
    value: function scrollEvent() {
      if (!this.element) return;
      this.elementPos = this.element.getBoundingClientRect();
    }
    /**
     * Publishes an event to the pubSub channel, first overriding the
     * sourceUid to be the uid of this track renderer.
     *
     * @template {Event} T
     * @param {T & { sourceUid?: string; forwarded?: boolean }} event
     */
  }, {
    key: "forwardEvent",
    value: function forwardEvent2(event) {
      event.sourceUid = this.uid;
      event.forwarded = true;
      this.props.pubSub.publish("app.event", event);
    }
    /** @param {number} scrollTop */
  }, {
    key: "onScrollHandler",
    value: function onScrollHandler(scrollTop) {
      this.scrollTop = scrollTop;
    }
    /* ------------------------------- Render ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.baseEl = c;
        },
        className: clsx$2("track-renderer-div", classes$2["track-renderer"]),
        style: {
          height: this.currentProps.height,
          width: this.currentProps.width
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.element = c;
        },
        className: clsx$2("track-renderer-element", classes$2["track-renderer-element"])
      }), /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.eventTracker = c;
        },
        className: clsx$2("track-renderer-events", classes$2["track-renderer-events"])
      }, this.currentProps.children));
    }
  }]);
})(React__default.Component);
TrackRenderer.defaultProps = {
  pluginDataFetchers: {},
  pluginTracks: {},
  canvasElement: null,
  centerHeight: 0,
  centerWidth: 0,
  children: [],
  galleryDim: 0,
  height: 0,
  initialXDomain: [],
  initialYDomain: [],
  isShowGlobalMousePosition: false,
  isRangeSelection: false,
  leftWidth: 0,
  leftWidthNoGallery: 0,
  paddingLeft: 0,
  paddingTop: 0,
  positionedTracks: [],
  topHeight: 0,
  topHeightNoGallery: 0,
  width: 0,
  metaTracks: []
};
TrackRenderer.propTypes = {
  canvasElement: PropTypes.object,
  centerHeight: PropTypes.number,
  centerWidth: PropTypes.number,
  children: PropTypes.array,
  disableTrackMenu: PropTypes.bool,
  galleryDim: PropTypes.number,
  height: PropTypes.number,
  initialXDomain: PropTypes.array,
  initialYDomain: PropTypes.array,
  isShowGlobalMousePosition: PropTypes.bool,
  isRangeSelection: PropTypes.bool,
  leftWidth: PropTypes.number,
  leftWidthNoGallery: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingTop: PropTypes.number,
  metaTracks: PropTypes.array,
  onMouseMoveZoom: PropTypes.func,
  onNewTilesLoaded: PropTypes.func.isRequired,
  onScalesChanged: PropTypes.func.isRequired,
  pixiRenderer: PropTypes.object.isRequired,
  pixiStage: PropTypes.object.isRequired,
  pluginDataFetchers: PropTypes.object,
  pluginTracks: PropTypes.object,
  positionedTracks: PropTypes.array,
  pubSub: PropTypes.object.isRequired,
  setCentersFunction: PropTypes.func,
  svgElement: PropTypes.object.isRequired,
  theme: PropTypes.symbol.isRequired,
  topHeight: PropTypes.number,
  topHeightNoGallery: PropTypes.number,
  viewOptions: PropTypes.object,
  width: PropTypes.number,
  xDomainLimits: PropTypes.array,
  yDomainLimits: PropTypes.array,
  valueScaleZoom: PropTypes.bool,
  zoomable: PropTypes.bool.isRequired,
  zoomDomain: PropTypes.array,
  uid: PropTypes.string,
  zoomLimits: PropTypes.array
};
const TrackRenderer$1 = withPubSub(withTheme(TrackRenderer));
function VerticalItem(props) {
  const {
    attributes: attributes2,
    listeners,
    setNodeRef,
    transform: transform2,
    transition: transition2,
    isDragging
  } = useSortable({
    id: props.uid
  });
  const adjustedTransform = transform2 ? {
    ...transform2,
    y: 0
  } : transform2;
  const style = {
    transform: CSS$1.Transform.toString(adjustedTransform),
    transition: transition2,
    ...isDragging ? {
      zIndex: 10,
      background: "rgba(0, 0, 0, 0.1)",
      border: "2px dashed rgba(0, 0, 0, 0.3)",
      borderRadius: 4
    } : {}
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    ref: setNodeRef,
    style
  }, /* @__PURE__ */ React__default.createElement(VerticalTrack, {
    className: props.className,
    controlAlignLeft: props.controlAlignLeft,
    dragHandleProps: {
      ...attributes2,
      ...listeners
    },
    editable: props.editable,
    handleConfigTrack: props.handleConfigTrack,
    handleResizeTrack: props.handleResizeTrack,
    height: props.height,
    isCollapsed: props.isCollapsed,
    item: props.item,
    onAddSeries: props.onAddSeries,
    onCollapseTrack: props.onCollapseTrack,
    onExpandTrack: props.onExpandTrack,
    onCloseTrack: props.onCloseTrack,
    onCloseTrackMenuOpened: props.onCloseTrackMenuOpened,
    onConfigTrackMenuOpened: props.onConfigTrackMenuOpened,
    resizeHandles: props.resizeHandles,
    uid: props.uid,
    width: props.width
  }));
}
const styles$1 = {
  "vertical-tiled-plot": "_vertical-tiled-plot_f3ho8_1"
};
function _classCallCheck$7(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$7(o.key), o);
  }
}
function _createClass$7(e, r2, t) {
  return r2 && _defineProperties$7(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$7(t) {
  var i = _toPrimitive$7(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$7(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$7(t, o, e) {
  return o = _getPrototypeOf$7(o), _possibleConstructorReturn$7(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf$7(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$7(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(t);
}
function _assertThisInitialized$7(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$7() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$7 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$7(t) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$7(t);
}
function _inherits$7(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$7(t, e);
}
function _setPrototypeOf$7(t, e) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$7(t, e);
}
function sourceEvent(event) {
  return event?.sourceEvent;
}
let VerticalTiledPlot = /* @__PURE__ */ (function(_React$Component) {
  function VerticalTiledPlot2(props) {
    var _this;
    _classCallCheck$7(this, VerticalTiledPlot2);
    _this = _callSuper$7(this, VerticalTiledPlot2, [props]);
    _this.brushBehavior = brushY().on("start", _this.brushStarted.bind(_this)).on("brush", _this.brushed.bind(_this)).on("end", _this.brushedEnded.bind(_this));
    _this.state = {
      // Track which track's controls are visible
      trackControlsVisible: null
    };
    return _this;
  }
  _inherits$7(VerticalTiledPlot2, _React$Component);
  return _createClass$7(VerticalTiledPlot2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.rangeSelectionTriggered) {
        this.rangeSelectionTriggered = false;
        if (this.rangeSelectionTriggeredEnd && this.props.rangeSelection !== nextProps.rangeSelection) {
          this.moveBrush(nextProps.rangeSelection[0] ? nextProps.rangeSelection[0] : null, true);
        }
        this.rangeSelectionTriggeredEnd = false;
        return this.state !== nextState;
      }
      if (this.props.rangeSelection !== nextProps.rangeSelection) {
        const accessor = this.props.is1dRangeSelection ? 0 : 1;
        this.moveBrush(nextProps.rangeSelection[accessor] ? nextProps.rangeSelection[accessor] : null, nextProps.rangeSelectionEnd);
        return this.state !== nextState;
      }
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isRangeSelectionActive) {
        this.addBrush();
      } else {
        this.removeBrush();
      }
    }
    /* --------------------------- Getter / Setter ---------------------------- */
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "addBrush",
    value: function addBrush() {
      if (!this.brushEl || this.brushElAddedBefore === this.brushEl) {
        return;
      }
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.on(".brush", null);
      }
      this.brushEl.call(this.brushBehavior);
      this.brushElAddedBefore = this.brushEl;
      resetD3BrushStyle(this.brushEl, stylesTrack["track-range-selection-group-brush-selection"]);
    }
  }, {
    key: "brushed",
    value: function brushed(event) {
      const rangeSelectionMoved = this.rangeSelectionMoved;
      this.rangeSelectionMoved = false;
      if (!sourceEvent(event) || !this.props.onRangeSelection || rangeSelectionMoved) return;
      this.rangeSelectionTriggered = true;
      this.props.onRangeSelection(event.selection);
    }
  }, {
    key: "brushStarted",
    value: function brushStarted(event) {
      if (!sourceEvent(event) || !event.selection) return;
      this.props.onRangeSelectionStart();
    }
  }, {
    key: "brushedEnded",
    value: function brushedEnded(event) {
      if (!this.props.is1dRangeSelection) return;
      const rangeSelectionMovedEnd = this.rangeSelectionMovedEnd;
      this.rangeSelectionMovedEnd = false;
      if (event.selection && event.sourceEvent && this.props.onRangeSelection && !rangeSelectionMovedEnd) {
        this.rangeSelectionTriggered = true;
        this.rangeSelectionTriggeredEnd = true;
        this.props.onRangeSelectionEnd(event.selection);
      }
      if (!event.selection) {
        this.rangeSelectionTriggered = true;
        this.props.onRangeSelectionReset();
      }
    }
  }, {
    key: "moveBrush",
    value: function moveBrush(rangeSelection, animate = false) {
      if (!this.brushEl) {
        return;
      }
      const relRange = rangeSelection ? [this.props.scale(rangeSelection[0]), this.props.scale(rangeSelection[1])] : null;
      this.rangeSelectionMoved = true;
      this.rangeSelectionMovedEnd = true;
      if (animate) {
        this.brushEl.transition().call(this.brushBehavior.move, relRange);
      } else {
        this.brushEl.call(this.brushBehavior.move, relRange);
      }
    }
  }, {
    key: "removeBrush",
    value: function removeBrush() {
      if (this.brushElAddedBefore) {
        this.brushElAddedBefore.call(this.brushBehavior.move, null);
        this.brushElAddedBefore.on(".brush", null);
        this.brushElAddedBefore = void 0;
        this.props.onRangeSelectionReset();
      }
    }
    /* ------------------------------ Rendering ------------------------------- */
  }, {
    key: "render",
    value: function render3() {
      const width = this.props.tracks.map((x) => x.width).reduce(sum$1, 0);
      const isBrushable = this.props.tracks.map((track) => IS_TRACK_RANGE_SELECTABLE(track)).reduce(or$1, false);
      const rangeSelectorClass = stylesTrack[this.props.isRangeSelectionActive ? "track-range-selection-active" : "track-range-selection"];
      return /* @__PURE__ */ React__default.createElement("div", {
        className: styles$1["vertical-tiled-plot"]
      }, isBrushable && /* @__PURE__ */ React__default.createElement("svg", {
        ref: (el2) => {
          this.brushEl = select(el2);
        },
        className: rangeSelectorClass,
        style: {
          height: this.props.height,
          width
        },
        xmlns: "http://www.w3.org/2000/svg"
      }), /* @__PURE__ */ React__default.createElement(ListWrapper, {
        axis: "x",
        className: clsx$2(styles$3.list, styles$3.stylizedList, styles$3.horizontalList),
        component: SortableList,
        editable: this.props.editable,
        handleConfigTrack: this.props.handleConfigTrack,
        handleResizeTrack: this.props.handleResizeTrack,
        height: this.props.height,
        helperClass: styles$3.stylizedHelper,
        itemClass: clsx$2(styles$3.stylizedItem, styles$3.horizontalItem),
        itemControlAlignLeft: this.props.tracksControlAlignLeft,
        itemReactClass: VerticalItem,
        items: this.props.tracks.map((d) => ({
          handleMouseEnter: () => {
            this.setState({
              trackControlsVisible: d.uid
            });
          },
          handleMouseLeave: () => {
            this.setState({
              trackControlsVisible: null
            });
          },
          trackControlsVisible: d.uid === this.state.trackControlsVisible,
          configMenuVisible: d.uid === this.props.configTrackMenuId,
          uid: d.uid || slugid.nice(),
          height: this.props.height,
          width: trackWidth(d),
          isCollapsed: d.options?.collapsed,
          value: d.value
        })),
        onAddSeries: this.props.onAddSeries,
        onCloseTrack: this.props.onCloseTrack,
        onCollapseTrack: this.props.onCollapseTrack,
        onExpandTrack: this.props.onExpandTrack,
        onCloseTrackMenuOpened: this.props.onCloseTrackMenuOpened,
        onConfigTrackMenuOpened: this.props.onConfigTrackMenuOpened,
        onSortEnd: this.props.handleSortEnd,
        referenceAncestor: this.props.referenceAncestor,
        resizeHandles: this.props.resizeHandles,
        useDragHandle: true,
        width
      }));
    }
  }]);
})(React__default.Component);
VerticalTiledPlot.propTypes = {
  configTrackMenuId: PropTypes.string,
  editable: PropTypes.bool,
  handleConfigTrack: PropTypes.func,
  handleResizeTrack: PropTypes.func,
  handleSortEnd: PropTypes.func,
  is1dRangeSelection: PropTypes.bool,
  isRangeSelectionActive: PropTypes.bool,
  height: PropTypes.number,
  onAddSeries: PropTypes.func,
  onCloseTrack: PropTypes.func,
  onCollapseTrack: PropTypes.func,
  onExpandTrack: PropTypes.func,
  onCloseTrackMenuOpened: PropTypes.func,
  onConfigTrackMenuOpened: PropTypes.func,
  onRangeSelection: PropTypes.func,
  onRangeSelectionEnd: PropTypes.func,
  onRangeSelectionReset: PropTypes.func,
  onRangeSelectionStart: PropTypes.func,
  rangeSelection: PropTypes.array,
  rangeSelectionEnd: PropTypes.bool,
  referenceAncestor: PropTypes.func,
  resizeHandles: PropTypes.object,
  scale: PropTypes.func,
  tracks: PropTypes.array,
  tracksControlAlignLeft: PropTypes.bool
};
function fallbackCopyTextToClipboard(text2) {
  const textArea = document.createElement("textarea");
  textArea.value = text2;
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    document.execCommand("copy");
  } catch (err) {
  }
  document.body.removeChild(textArea);
}
function copyTextToClipboard(text2) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text2);
    return;
  }
  navigator.clipboard.writeText(text2).then(() => {
  }, (err) => {
  });
}
function _classCallCheck$6(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$6(o.key), o);
  }
}
function _createClass$6(e, r2, t) {
  return r2 && _defineProperties$6(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$6(t) {
  var i = _toPrimitive$6(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$6(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$6(t, o, e) {
  return o = _getPrototypeOf$6(o), _possibleConstructorReturn$6(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf$6(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$6(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(t);
}
function _assertThisInitialized$6(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$6() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$6 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$6(t) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$6(t);
}
function _inherits$6(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$6(t, e);
}
function _setPrototypeOf$6(t, e) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$6(t, e);
}
let ViewContextMenu = /* @__PURE__ */ (function(_mix$with) {
  function ViewContextMenu2() {
    _classCallCheck$6(this, ViewContextMenu2);
    return _callSuper$6(this, ViewContextMenu2, arguments);
  }
  _inherits$6(ViewContextMenu2, _mix$with);
  return _createClass$6(ViewContextMenu2, [{
    key: "render",
    value: function render3() {
      const seriesItems = getSeriesItems(this.props.tracks, this.handleItemMouseEnter.bind(this), this.handleMouseLeave.bind(this));
      const customItemsWrapped = this.props.customItems ? React__default.Children.map(this.props.customItems, (child) => /* @__PURE__ */ React__default.cloneElement(child, {
        onMouseEnter: (e) => {
          this.handleOtherMouseEnter(e);
        }
      })) : null;
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.div = c;
        },
        className: clsx$2(classes$5["context-menu"], {
          [classes$5["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "ViewContextMenu",
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, customItemsWrapped, customItemsWrapped && /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), seriesItems, seriesItems && /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), this.props.genomePositionSearchBox && /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.copyLocationToClipboard.bind(this),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Copy location under cursor"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onAddTrack({
          type: "horizontal-rule",
          y: this.props.coords[1],
          position: "whole"
        }),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Horizontal Rule"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onAddTrack({
          type: "vertical-rule",
          x: this.props.coords[0],
          position: "whole"
        }),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Vertical Rule"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onAddTrack({
          type: "cross-rule",
          x: this.props.coords[0],
          y: this.props.coords[1],
          position: "whole"
        }),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Cross Rule"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), this.hasMatrixTrack(this.props.tracks) && /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.handleAddHorizontalSection.bind(this),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Horizontal Cross Section"), this.hasMatrixTrack(this.props.tracks) && /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.handleAddVerticalSection.bind(this),
        onMouseEnter: (e) => this.handleOtherMouseEnter(e)
      }, "Add Vertical Cross Section"), this.getSubmenu());
    }
  }, {
    key: "hasMatrixTrack",
    value: function hasMatrixTrack(tracks2) {
      const trackList = expandCombinedTracks(this.props.tracks);
      return trackList.filter((track) => track.type === "heatmap").length > 0;
    }
  }, {
    key: "handleAddHorizontalSection",
    value: function handleAddHorizontalSection() {
      const trackList = expandCombinedTracks(this.props.tracks);
      const matrixTrack = trackList.filter((track) => track.type === "heatmap")[0];
      this.props.onAddTrack({
        type: "horizontal-rule",
        y: this.props.coords[1],
        position: "whole"
      });
      this.props.onAddTrack({
        data: {
          type: "horizontal-section",
          server: matrixTrack.server,
          tilesetUid: matrixTrack.tilesetUid,
          slicePos: this.props.coords[1]
        },
        options: {
          valueScaling: "log"
        },
        type: "horizontal-bar",
        height: 30,
        position: "top"
      });
    }
  }, {
    key: "copyLocationToClipboard",
    value: function copyLocationToClipboard() {
      const is2d = this.props.tracks[0] && this.props.tracks[0].position === "center";
      const chromInfo = this.props.genomePositionSearchBox?.searchField?.chromInfo;
      if (!chromInfo) {
        console.warn("There needs to be a genome position search box present to copy the location");
        this.props.closeMenu();
        return;
      }
      const xAbsCoord = this.props.coords[0];
      const yAbsCoord = this.props.coords[1];
      const xChr = absToChr(xAbsCoord, chromInfo);
      const stringFormat = format$1(",d");
      let locationText = `${xChr[0]}:${stringFormat(xChr[1])}`;
      if (is2d) {
        const yChr = absToChr(yAbsCoord, chromInfo);
        locationText = `${locationText} & ${yChr[0]}:${stringFormat(yChr[1])}`;
        copyTextToClipboard(locationText);
      } else {
        copyTextToClipboard(locationText);
      }
      this.props.closeMenu();
    }
  }, {
    key: "handleAddVerticalSection",
    value: function handleAddVerticalSection() {
      const trackList = expandCombinedTracks(this.props.tracks);
      const matrixTrack = trackList.filter((track) => track.type === "heatmap")[0];
      this.props.onAddTrack({
        type: "vertical-rule",
        x: this.props.coords[0],
        position: "whole"
      });
      this.props.onAddTrack({
        data: {
          type: "vertical-section",
          server: matrixTrack.server,
          tilesetUid: matrixTrack.tilesetUid,
          slicePos: this.props.coords[0]
        },
        options: {
          valueScaling: "log"
        },
        type: "vertical-bar",
        height: 30,
        position: "left"
      });
    }
  }]);
})(mix(ContextMenuContainer).with(SeriesListSubmenuMixin));
ViewContextMenu.propTypes = {
  // the data coordinates where this context menu was initiated
  coords: PropTypes.array,
  customItems: PropTypes.array
};
function getDefaultTracksForDatatype(datatype, otherDefaultTracks) {
  if (window.higlassTracksByType) {
    Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
      TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
    });
  }
  if (!(datatype in DEFAULT_TRACKS_FOR_DATATYPE) && !otherDefaultTracks) {
    console.warn("unknown data type:", datatype);
    return void 0;
  }
  const orientationToPositions = {
    "1d-horizontal": ["top", "bottom", "left", "right"],
    "2d": ["center"],
    "1d-vertical": ["left", "right"]
  };
  const defaultTracks = DEFAULT_TRACKS_FOR_DATATYPE[datatype] || {};
  if (otherDefaultTracks) {
    for (const trackType of otherDefaultTracks) {
      if (!TRACKS_INFO_BY_TYPE[trackType]) {
        console.warn("unknown track type", trackType);
      } else {
        for (const position of orientationToPositions[TRACKS_INFO_BY_TYPE[trackType].orientation]) {
          defaultTracks[position] = trackType;
        }
      }
    }
  }
  return defaultTracks;
}
function _classCallCheck$5(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$5(o.key), o);
  }
}
function _createClass$5(e, r2, t) {
  return r2 && _defineProperties$5(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$5(t) {
  var i = _toPrimitive$5(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$5(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$5(t, o, e) {
  return o = _getPrototypeOf$5(o), _possibleConstructorReturn$5(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf$5(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$5(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(t);
}
function _assertThisInitialized$5(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$5 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$5(t) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$5(t);
}
function _inherits$5(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$5(t, e);
}
function _setPrototypeOf$5(t, e) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$5(t, e);
}
let TiledPlot = /* @__PURE__ */ (function(_React$Component) {
  function TiledPlot2(props) {
    var _this;
    _classCallCheck$5(this, TiledPlot2);
    _this = _callSuper$5(this, TiledPlot2, [props]);
    _this.closing = false;
    _this.brushX = brushX();
    const {
      tracks: tracks2
    } = _this.props;
    _this.canvasElement = null;
    _this.tracksByUidInit = {};
    [..._this.props.tracks.top || [], ..._this.props.tracks.right || [], ..._this.props.tracks.bottom || [], ..._this.props.tracks.left || [], ..._this.props.tracks.gallery || [], ..._this.props.tracks.center || []].forEach((track) => {
      if (track.type === "combined") {
        track.contents.forEach((track2) => {
          _this.tracksByUidInit[track2.uid] = false;
        });
      } else {
        _this.tracksByUidInit[track.uid] = false;
      }
    });
    _this.annotationUid = null;
    _this.annotationCreatedNotified = false;
    _this.xScale = null;
    _this.yScale = null;
    _this.addUidsToTracks(tracks2);
    _this.trackToReplace = null;
    _this.trackRenderer = null;
    _this.brushSelection = null;
    _this.configTrackMenu = null;
    _this.state = {
      sizeMeasured: false,
      height: 10,
      width: 10,
      tracks: tracks2,
      init: false,
      addTrackExtent: null,
      addTrackPosition: null,
      customDialog: null,
      mouseOverOverlayUid: null,
      // trackOptions: null
      // trackOptions: trackOptions
      forceUpdate: 0,
      // a random value that will be assigned by
      // crucial functions to force an update
      rangeSelection: [null, null],
      rangeSelectionEnd: false,
      chromInfo: null,
      defaultChromSizes: null,
      contextMenuCustomItems: null,
      contextMenuPosition: null,
      addDivisorDialog: null
    };
    _this.reset = true;
    if (window.higlassTracksByType) {
      Object.keys(window.higlassTracksByType).forEach((pluginTrackType) => {
        TRACKS_INFO_BY_TYPE[pluginTrackType] = window.higlassTracksByType[pluginTrackType].config;
      });
    }
    _this.topHeight = 0;
    _this.bottomHeight = 0;
    _this.leftWidth = 0;
    _this.rightWidth = 0;
    _this.centerHeight = 0;
    _this.centerWidth = 0;
    _this.dragTimeout = null;
    _this.previousPropsStr = "";
    _this.brushesCreated = {};
    _this.appZoomedBound = _this.appZoomed.bind(_this);
    _this.handleClickBound = _this.handleClick.bind(_this);
    _this.contextMenuHandlerBound = _this.contextMenuHandler.bind(_this);
    _this.handleNoTrackAddedBound = _this.handleNoTrackAdded.bind(_this);
    _this.handleTracksAddedBound = _this.handleTracksAdded.bind(_this);
    _this.closeMenusBound = _this.closeMenus.bind(_this);
    _this.handleAddDivisorBound = _this.handleAddDivisor.bind(_this);
    _this.handleAddSeriesBound = _this.handleAddSeries.bind(_this);
    _this.handleChangeTrackDataBound = _this.handleChangeTrackData.bind(_this);
    _this.handleChangeTrackTypeBound = _this.handleChangeTrackType.bind(_this);
    _this.handleCloseTrackBound = _this.handleCloseTrack.bind(_this);
    _this.handleConfigureTrackBound = _this.handleConfigureTrack.bind(_this);
    _this.handleExportTrackDataBound = _this.handleExportTrackData.bind(_this);
    _this.handleLockValueScaleBound = _this.handleLockValueScale.bind(_this);
    _this.handleReplaceTrackBound = _this.handleReplaceTrack.bind(_this);
    _this.handleTrackOptionsChangedBound = _this.handleTrackOptionsChanged.bind(_this);
    _this.handleUnlockValueScaleBound = _this.handleUnlockValueScale.bind(_this);
    _this.onAddTrack = _this.handleAddTrack.bind(_this);
    return _this;
  }
  _inherits$5(TiledPlot2, _React$Component);
  return _createClass$5(TiledPlot2, [{
    key: "waitForDOMAttachment",
    value: function waitForDOMAttachment(callback) {
      if (!this.mounted) return;
      const thisElement = this.divTiledPlot;
      if (thisElement?.getRootNode().contains(thisElement)) {
        callback();
      } else {
        requestAnimationFrame(() => this.waitForDOMAttachment(callback));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.element = this.divTiledPlot;
      this.waitForDOMAttachment(() => {
        cssElementQueriesExports.ElementQueries.listen();
        this.resizeSensor = new cssElementQueriesExports.ResizeSensor(this.element.parentNode, this.measureSize.bind(this));
        this.measureSize();
      });
      this.addEventListeners();
      this.pubSubs = [];
      this.pubSubs.push(this.props.pubSub.subscribe("contextmenu", this.contextMenuHandlerBound));
    }
    /** Get the data in the selection */
  }, {
    key: "getTracksData",
    value: function getTracksData(positionedTracks, extent2) {
      let tracks2 = [];
      const allTrackObjs = this.listAllTrackObjects();
      for (const track of positionedTracks) {
        if (track.track.contents) {
          tracks2 = [...tracks2, ...track.track.contents];
        } else {
          tracks2 = [...tracks2, track.track];
        }
      }
      const trackDatas = [];
      for (const track of tracks2) {
        if (track.type === "heatmap") {
          const trackObj = allTrackObjs.filter((x) => x.id === track.uid)[0];
          const x12 = trackObj._xScale(extent2[0][0]);
          const x2 = trackObj._xScale(extent2[1][0]);
          const y12 = trackObj._yScale(extent2[0][1]);
          const y2 = trackObj._yScale(extent2[1][1]);
          const height = y2 - y12;
          const width = x2 - x12;
          const data2 = trackObj.getVisibleRectangleData(x12, y12, height, width);
          const sumValue = data2.data.reduce((a, b) => a + b, 0);
          const mean2 = sumValue / data2.data.length;
          trackDatas.push({
            name: track.options.name,
            mean: mean2,
            trackUid: track.uid
          });
        }
      }
      return trackDatas;
    }
  }, {
    key: "appZoomed",
    value: function appZoomed() {
      if (this.brushCurrent && this.brushEl) {
        if (this.brushType === "horizontal") {
          const newSelection = [this.xScale(this.brushSelection[0]) + this.brushTrack.left, this.xScale(this.brushSelection[1]) + this.brushTrack.left];
          this.brushEl.call(this.brushCurrent.move, newSelection);
        }
        if (this.brushType === "vertical") {
          const newSelection = [this.yScale(this.brushSelection[0]) + this.brushTrack.top, this.yScale(this.brushSelection[1]) + this.brushTrack.top];
          this.brushEl.call(this.brushCurrent.move, newSelection);
        }
        if (this.brushType === "2d") {
          const newSelection = [[this.xScale(this.brushSelection[0][0]) + this.brushTrack.left, this.yScale(this.brushSelection[0][1]) + this.brushTrack.top], [this.xScale(this.brushSelection[1][0]) + this.brushTrack.left, this.yScale(this.brushSelection[1][1]) + this.brushTrack.top]];
          this.brushEl.call(this.brushCurrent.move, newSelection);
        }
      }
    }
  }, {
    key: "clearOtherBrushes",
    value: function clearOtherBrushes(myBrush) {
      for (const aBrush of Object.values(this.brushes)) {
        aBrush.on("brush", null);
      }
      for (const trackUid in this.brushes) {
        const otherBrush = this.brushes[trackUid];
        if (otherBrush !== myBrush) {
          this.brushEls[trackUid].call(otherBrush.move, null);
        }
      }
      for (const aBrush of Object.values(this.brushes)) {
        aBrush.on("brush", () => this.clearOtherBrushes(aBrush));
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(evt) {
      const pos = pointer(evt, this.divTiledPlot);
      let inside = false;
      if (this.brushEl) {
        const selection2 = this.brushSelectionRaw;
        const track = this.brushTrack;
        if (this.brushType === "2d") {
          if (pos[0] >= selection2[0][0] && pos[0] <= selection2[1][0] && pos[1] >= selection2[0][1] && pos[1] <= selection2[1][1]) {
            inside = true;
          }
        } else if (this.brushType === "horizontal") {
          if (pos[0] >= selection2[0] && pos[0] <= selection2[1] && pos[1] >= track.top && pos[1] <= track.top + trackHeight(track.track)) {
            inside = true;
          }
        } else if (this.brushType === "vertical") {
          if (pos[1] >= selection2[0] && pos[1] <= selection2[1] && pos[0] >= track.left && pos[0] <= track.left + trackWidth(track.track)) {
            inside = true;
          }
        }
        if (!inside) {
          this.cancelBrushes();
        }
      }
    }
  }, {
    key: "cancelBrushes",
    value: function cancelBrushes() {
      this.brushEl.call(this.brushCurrent.move, null);
      this.brushEl = null;
      this.props.apiPublish("annotationRemoved", this.annotationUid);
      this.annotationUid = null;
      this.annotationCreatedNotified = false;
      this.removeBrushText();
    }
  }, {
    key: "removeBrushText",
    value: function removeBrushText() {
      select(this.divTiledPlot).selectAll(".brush-svg").selectAll(".data-values").remove();
    }
  }, {
    key: "enableBrushes",
    value: function enableBrushes() {
      const overlays = select(this.divTiledPlot).selectAll(".brush-svg").selectAll(".overlay");
      overlays.style("pointer-events", "all");
    }
  }, {
    key: "disableBrushes",
    value: function disableBrushes() {
      select(this.divTiledPlot).selectAll(".overlay").attr("pointer-events", "none");
      select(this.divTiledPlot).selectAll(".brush-rect").attr("pointer-events", "none");
      select(this.divTiledPlot).selectAll(".selection").attr("pointer-events", "all");
      select(this.divTiledPlot).selectAll(".brush-svg").attr("pointer-events", "none");
    }
  }, {
    key: "createBrushes",
    value: function createBrushes(positionedTracks) {
      const brushes = {};
      this.brushCurrent = null;
      const apiPublish = this.props.apiPublish;
      const tiledPlot = this;
      for (const track of positionedTracks) {
        if (brushes[track.track.uid]) continue;
        let myBrush = null;
        if (["top", "bottom"].includes(track.track.position)) {
          myBrush = brushX();
          myBrush.on("brush", (event) => {
            if (!event.selection) {
              return;
            }
            this.brushCurrent = myBrush;
            this.brushType = "horizontal";
            this.brushTrack = track;
            this.brushSelectionRaw = event.selection;
            this.brushSelection = [this.xScale.invert(event.selection[0] - track.left), this.xScale.invert(event.selection[1] - track.left)];
            apiPublish("annotationChanged", {
              annotationUid: this.annotationUid,
              viewUid: this.props.uid,
              track: track.track,
              extent: [this.brushSelection, [null, null]]
            });
          });
          myBrush.on("end", (evt) => {
            if (!this.annotationCreatedNotified) {
              apiPublish("annotationCreated", {
                annotationUid: tiledPlot.annotationUid,
                track: track.track,
                viewUid: this.props.uid,
                extent: [this.brushSelection, [null, null]]
              });
            }
          });
        } else if (["left", "right"].includes(track.track.position)) {
          myBrush = brushY();
          myBrush.on("brush", (event) => {
            if (!event.selection) {
              return;
            }
            this.brushCurrent = myBrush;
            this.brushType = "vertical";
            this.brushTrack = track;
            this.brushSelectionRaw = event.selection;
            this.brushSelection = [this.yScale.invert(event.selection[0] - track.top), this.yScale.invert(event.selection[1] - track.top)];
            apiPublish("annotationChanged", {
              annotationUid: this.annotationUid,
              track: track.track,
              viewUid: this.props.uid,
              extent: [[null, null], this.brushSelection]
            });
          });
          myBrush.on("end", (evt) => {
            if (!this.annotationCreatedNotified) {
              apiPublish("annotationCreated", {
                annotationUid: tiledPlot.annotationUid,
                track: track.track,
                viewUid: this.props.uid,
                extent: [[null, null], this.brushSelection]
              });
            }
          });
        } else {
          myBrush = brush();
          myBrush.on("brush", (event) => {
            if (!event.selection) {
              return;
            }
            this.brushCurrent = myBrush;
            this.brushType = "2d";
            this.brushTrack = track;
            this.brushSelectionRaw = event.selection;
            this.brushSelection = [[this.xScale.invert(event.selection[0][0] - track.left), this.yScale.invert(event.selection[0][1] - track.top)], [this.xScale.invert(event.selection[1][0] - track.left), this.yScale.invert(event.selection[1][1] - track.top)]];
            const tracksData = this.getTracksData(positionedTracks.filter((t) => t.track.position === "center"), this.brushSelection);
            const dataValues = Object.values(tracksData).filter((x) => x.mean !== void 0).map((x) => x.mean);
            if (dataValues.length) {
              const selection2 = select(this.divTiledPlot).selectAll(".brush-svg").selectAll(".data-values").data(dataValues);
              selection2.enter().append("text").classed("data-values", true);
              const numFormat = format$1(".3f");
              select(this.divTiledPlot).selectAll(".data-values").attr("x", event.selection[0][0]).attr("y", event.selection[0][1]).text((x) => `mean: ${numFormat(x)}`);
            }
            apiPublish("annotationChanged", {
              annotationUid: this.annotationUid,
              extent: this.brushSelection,
              data: tracksData,
              track: track.track,
              viewUid: this.props.uid
            });
          });
          myBrush.on("end", (evt) => {
            let tracksData = {};
            if (this.brushSelection?.[0].length) {
              tracksData = this.getTracksData(positionedTracks.filter((t) => t.track.position === "center"), this.brushSelection);
            }
            if (!this.annotationCreatedNotified) {
              apiPublish("annotationCreated", {
                annotationUid: tiledPlot.annotationUid,
                track: track.track,
                viewUid: this.props.uid,
                extent: this.brushSelection,
                data: tracksData
              });
              this.annotationCreatedNotified = true;
            } else if (!evt.selection) {
              this.removeBrushText();
            }
          });
        }
        myBrush.keyModifiers(false);
        myBrush.extent([[track.left, track.top], [track.left + trackWidth(track.track), track.top + trackHeight(track.track)]]);
        myBrush.on("start", function(event) {
          if (!tiledPlot.annotationUid) {
            tiledPlot.annotationUid = slugid.nice();
            track.annotationUid = tiledPlot.annotationUid;
          }
          tiledPlot.brushEl = select(this);
        });
        brushes[track.track.uid] = myBrush;
      }
      return brushes;
    }
  }, {
    key: "removeBrushes",
    value: function removeBrushes() {
      select(this.divTiledPlot).selectAll(".brush-svg").remove();
    }
  }, {
    key: "addBrushes",
    value: function addBrushes() {
      if (this.annotationUid) {
        return;
      }
      const positionedTracks = this.positionedTracks().filter((x) => x.track.position !== "whole");
      const brushes = this.createBrushes(positionedTracks);
      this.brushes = brushes;
      const brushEls = {};
      this.brushEls = brushEls;
      select(this.divTiledPlot).selectAll(".brush").remove();
      select(this.divTiledPlot).selectAll(".brush-svg").data([1]).enter().append("svg").classed("brush-svg", true).style("position", "absolute").style("left", 0).style("top", 0).style("z-index", 101);
      const brushG = select(this.divTiledPlot).select(".brush-svg").selectAll(".brush").data(positionedTracks, (d) => d.track.uid).enter().append("g").attr("class", "brush");
      select(this.divTiledPlot).selectAll(".brush-svg").attr("width", this.state.width).attr("height", this.state.height);
      select(this.divTiledPlot).selectAll(".brush-rect").attr("x", (d) => d.left).attr("y", (d) => d.top).style("stroke", "1px solid black").style("fill", "transparent").attr("width", (d) => d.width).attr("height", (d) => d.height);
      brushG.each(function(d) {
        brushEls[d.track.uid] = select(this);
        brushEls[d.track.uid].call(brushes[d.track.uid]);
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.addUidsToTracks(newProps.tracks);
      this.setState({
        tracks: newProps.tracks
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      const thisPropsStr = this.previousPropsStr;
      const nextPropsStr = this.updatablePropsToString(nextProps);
      const thisStateStr = JSON.stringify(this.state);
      const nextStateStr = JSON.stringify(nextState);
      const toUpdate = thisPropsStr !== nextPropsStr || thisStateStr !== nextStateStr || this.props.chooseTrackHandler !== nextProps.chooseTrackHandler || this.props.customDialog !== nextProps.customDialog;
      if (toUpdate) this.previousPropsStr = nextPropsStr;
      const numPrevTracks = this.numTracks;
      this.numTracks = 0;
      visitPositionedTracks(this.props.tracks, () => this.numTracks++);
      this.reset = this.reset || numPrevTracks === 0 && this.numTracks > 0;
      if (!this.numTracks) this.tracksByUidInit = {};
      if (nextProps.mouseTool === MOUSE_TOOL_TRACK_SELECT) {
        this.addBrushes();
      } else {
        this.disableBrushes();
      }
      return toUpdate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.rangeSelection !== this.state.rangeSelection) {
        let genomicRange = [null, null];
        if (this.state.defaultChromSizes && this.state.rangeSelection.every((range2) => range2?.length)) {
          genomicRange = this.state.rangeSelection.map((range2) => dataToGenomicLoci(...range2, this.state.defaultChromSizes));
        }
        this.props.onRangeSelection({
          dataRange: this.state.rangeSelection,
          genomicRange
        });
      }
      if (this.state.customDialog || this.props.customDialog) {
        const dialogData = this.state.customDialog || this.props.customDialog;
        if (dialogData.length > 0) {
          const componentArray = [];
          const bodyPropsArray = [];
          dialogData.forEach((dd2) => {
            componentArray.push(dd2.bodyComponent);
            bodyPropsArray.push(dd2.bodyProps);
          });
          this.props.modal.open(/* @__PURE__ */ React__default.createElement(
            CustomTrackDialog,
            {
              children: componentArray,
              bodyProps: bodyPropsArray,
              onCancel: this.props.closeCustomDialog,
              title: dialogData[0].title
            }
          ));
        }
      }
      if (prevProps.tracks.center !== this.props.tracks.center) ;
      if (this.state.addTrackPosition || this.props.addTrackPosition) {
        this.props.modal.open(/* @__PURE__ */ React__default.createElement(AddTrackDialog, {
          extent: this.state.addTrackExtent || this.props.addTrackExtent,
          host: this.state.addTrackHost,
          onCancel: this.handleNoTrackAddedBound,
          onTracksChosen: this.handleTracksAddedBound,
          position: this.state.addTrackPosition || this.props.addTrackPosition,
          trackSourceServers: this.props.trackSourceServers
        }));
      }
      if (this.state.addDivisorDialog) {
        const series = this.state.addDivisorDialog;
        this.props.modal.open(/* @__PURE__ */ React__default.createElement(AddTrackDialog, {
          datatype: TRACKS_INFO_BY_TYPE[series.type].datatype[0],
          host: this.state.addTrackHost,
          onCancel: () => {
            this.setState({
              addDivisorDialog: null
            });
          },
          onTracksChosen: (newTrack) => {
            this.handleDivisorChosen(series, newTrack);
          },
          trackSourceServers: this.props.trackSourceServers
        }));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.closing = true;
      this.removeEventListeners();
      this.pubSubs.forEach((subscription) => this.props.pubSub.unsubscribe(subscription));
    }
  }, {
    key: "addUidsToTracks",
    value: function addUidsToTracks(positionedTracks) {
      Object.keys(positionedTracks).forEach((position) => {
        positionedTracks[position].forEach((track) => {
          track.uid = track.uid || slugid.nice();
        });
      });
    }
    /*
    getDefaultChromSizes() {
      try {
        const centralHeatmap = this.findCentralHeatmapTrack(
          this.props.tracks.center
        );
        this.getChromInfo = chromInfo
          .get(`${centralHeatmap.server}/chrom-sizes/?id=${centralHeatmap.tilesetUid}`)
          .then(defaultChromSizes => this.setState({ defaultChromSizes }));
      } catch (err) {  }
    }
    */
  }, {
    key: "contextMenuHandler",
    value: function contextMenuHandler(e) {
      if (!this.divTiledPlot) return;
      const bBox = this.divTiledPlot.getBoundingClientRect();
      const isClickWithin = isWithin(e.clientX, e.clientY, bBox.left, bBox.left + bBox.width, bBox.top, bBox.top + bBox.height);
      if (!isClickWithin) return;
      const mousePos = [e.clientX, e.clientY];
      const canvasMousePos = pointer(e, this.divTiledPlot);
      const xVal = this.trackRenderer.zoomedXScale.invert(canvasMousePos[0]);
      const yVal = this.trackRenderer.zoomedYScale.invert(canvasMousePos[1]);
      let contextMenuCustomItems = null;
      if (e.hgCustomItems) {
        contextMenuCustomItems = e.hgCustomItems.map((item) => /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
          key: item.key,
          onClick: item.onClick
        }, item.text));
      }
      this.setState({
        contextMenuCustomItems,
        contextMenuPosition: {
          left: mousePos[0],
          top: mousePos[1],
          canvasLeft: canvasMousePos[0] + this.trackRenderer.xPositionOffset,
          canvasTop: canvasMousePos[1] + this.trackRenderer.yPositionOffset
        },
        contextMenuDataX: xVal,
        contextMenuDataY: yVal
      });
    }
  }, {
    key: "measureSize",
    value: function measureSize() {
      if (this.element.clientWidth > 0 && this.element.clientHeight > 0) {
        this.setState({
          sizeMeasured: true,
          width: this.element.clientWidth,
          height: this.element.clientHeight
        });
      }
    }
  }, {
    key: "handleTrackOptionsChanged",
    value: function handleTrackOptionsChanged(trackUid, newOptions) {
      return this.props.onTrackOptionsChanged(trackUid, newOptions);
    }
  }, {
    key: "handleCollapseTrack",
    value: function handleCollapseTrack(trackUid) {
      this.handleTrackOptionsChanged(trackUid, {
        collapsed: true
      });
    }
  }, {
    key: "handleExpandTrack",
    value: function handleExpandTrack(trackUid) {
      this.handleTrackOptionsChanged(trackUid, {
        collapsed: false
      });
    }
  }, {
    key: "handleScalesChanged",
    value: function handleScalesChanged(x, y) {
      this.xScale = x;
      this.yScale = y;
      this.appZoomed();
      this.props.onScalesChanged(x, y);
    }
    /**
     * We've received information about a tileset from the server. Register it
     * with the track definition.
     * @param trackUid (string): The identifier for the track
     * @param tilesetInfo (object): Information about the track (hopefully including
     *                              its name.
     */
  }, {
    key: "handleTilesetInfoReceived",
    value: function handleTilesetInfoReceived(trackUid, tilesetInfo) {
      const track = getTrackByUid(this.props.tracks, trackUid);
      if (!track) {
        console.warn("Strange, track not found:", trackUid);
        return;
      }
      this.tracksByUidInit[track.uid] = true;
      this.checkAllTilesetInfoReceived();
      if (!track.options) {
        track.options = {};
      }
      track.name = tilesetInfo.name;
      track.maxWidth = tilesetInfo.max_width;
      track.transforms = tilesetInfo.transforms;
      track.aggregationModes = tilesetInfo.aggregation_modes;
      track.header = tilesetInfo.header;
      track.binsPerDimension = tilesetInfo.bins_per_dimension;
      if (tilesetInfo.resolutions) {
        track.maxZoom = tilesetInfo.resolutions.length - 1;
        track.resolutions = tilesetInfo.resolutions;
      } else {
        track.maxZoom = tilesetInfo.max_zoom;
      }
      if (tilesetInfo.row_infos) {
        track.row_infos = tilesetInfo.row_infos;
      }
      track.coordSystem = tilesetInfo.coordSystem;
      track.datatype = tilesetInfo.datatype;
    }
    /**
     * Check if all track which are expecting a tileset info have been loaded.
     */
  }, {
    key: "checkAllTilesetInfoReceived",
    value: function checkAllTilesetInfoReceived() {
      if (this.state.init && !this.reset || !this.trackRenderer || !this.props.zoomToDataExtentOnInit()) {
        return;
      }
      const allTracksWithTilesetInfos = Object.keys(this.trackRenderer.trackDefObjects).map((trackUuid) => {
        const track = this.trackRenderer.trackDefObjects[trackUuid].trackObject;
        if (track.childTracks) return track.childTracks;
        return track;
      }).reduce((a, b) => a.concat(b), []).filter(({
        tilesetInfo
      }) => typeof tilesetInfo !== "undefined" && tilesetInfo !== true);
      const loadedTilesetInfos = Object.values(this.tracksByUidInit).filter((x) => x).length;
      if (allTracksWithTilesetInfos.length === loadedTilesetInfos) {
        this.setState({
          init: true
        });
        this.reset = false;
        this.handleZoomToData();
      }
    }
  }, {
    key: "handleOverlayMouseEnter",
    value: function handleOverlayMouseEnter(uid) {
      this.setState({
        mouseOverOverlayUid: uid
      });
      this.props.setOverTrackChooser(true);
    }
  }, {
    key: "handleOverlayMouseLeave",
    value: function handleOverlayMouseLeave(uid) {
      if (uid === this.state.mouseOverOverlayUid) {
        this.setState({
          mouseOverOverlayUid: null
        });
      }
      this.props.setOverTrackChooser(false);
    }
  }, {
    key: "handleTrackPositionChosen",
    value: function handleTrackPositionChosen(pTrack, evt) {
      this.setState({
        mouseOverOverlayUid: null
      });
      this.props.chooseTrackHandler(pTrack.track.uid, evt);
    }
  }, {
    key: "handleNoTrackAdded",
    value: function handleNoTrackAdded() {
      this.trackToReplace = null;
      this.props.onNoTrackAdded();
      this.setState({
        addTrackExtent: null,
        addTrackPosition: null,
        addTrackHost: null
      });
    }
  }, {
    key: "handleAddDivisor",
    value: function handleAddDivisor(series) {
      this.setState({
        addDivisorDialog: series
      });
    }
    /**
     * The user has selected a track that they wish to use to normalize another
     * track.
     */
  }, {
    key: "handleDivisorChosen",
    value: function handleDivisorChosen(series, newTrack) {
      this.setState({
        addDivisorDialog: null
      });
      const numerator = series.data ? {
        server: series.data.server,
        tilesetUid: series.data.tilesetUid
      } : {
        server: series.server,
        tilesetUid: series.tilesetUid
      };
      const denominator = {
        server: newTrack[0].server,
        tilesetUid: newTrack[0].uuid
      };
      this.handleChangeTrackData(series.uid, {
        type: "divided",
        children: [numerator, denominator]
      });
    }
  }, {
    key: "handleDivideSeries",
    value: function handleDivideSeries(seriesUid) {
    }
  }, {
    key: "handleAddSeries",
    value: function handleAddSeries(trackUid) {
      const trackPosition = getTrackPositionByUid(this.props.tracks, trackUid);
      const track = getTrackByUid(this.props.tracks, trackUid);
      this.setState({
        addTrackPosition: trackPosition,
        addTrackHost: track
      });
    }
  }, {
    key: "handleReplaceTrack",
    value: function handleReplaceTrack(uid, orientation2) {
      this.trackToReplace = uid;
      this.handleAddTrack(orientation2);
    }
  }, {
    key: "handleAddTrack",
    value: function handleAddTrack(position, extent2) {
      this.setState({
        addTrackExtent: extent2,
        addTrackPosition: position,
        addTrackHost: null
      });
    }
  }, {
    key: "handleResizeTrack",
    value: function handleResizeTrack(uid, width, height) {
      const {
        tracks: tracks2
      } = this.state;
      for (const trackType in tracks2) {
        const theseTracks = tracks2[trackType];
        const filteredTracks = theseTracks.filter((d) => d.uid === uid);
        if (filteredTracks.length > 0) {
          filteredTracks[0].width = width;
          filteredTracks[0].height = height;
        }
      }
      this.setState({
        tracks: tracks2,
        forceUpdate: Math.random()
      });
      this.props.onResizeTrack();
    }
  }, {
    key: "closeMenus",
    value: function closeMenus() {
      this.setState({
        closeTrackMenuId: null,
        configTrackMenuId: null,
        contextMenuPosition: null,
        contextMenuCustomItems: null
      });
    }
  }, {
    key: "handleLockValueScale",
    value: function handleLockValueScale(uid) {
      this.closeMenus();
      this.props.onLockValueScale(uid);
    }
  }, {
    key: "handleUnlockValueScale",
    value: function handleUnlockValueScale(uid) {
      this.closeMenus();
      this.props.onUnlockValueScale(uid);
    }
  }, {
    key: "handleCloseTrack",
    value: function handleCloseTrack(uid) {
      this.closeMenus();
      this.props.onCloseTrack(uid);
    }
  }, {
    key: "handleChangeTrackType",
    value: function handleChangeTrackType(uid, newType) {
      this.closeMenus();
      this.props.onChangeTrackType(uid, newType);
    }
    /**
     * Change this tracks data section so that it
     * is either of type "divided" or the "divided"
     * type is removed
     */
  }, {
    key: "handleChangeTrackData",
    value: function handleChangeTrackData(uid, newData) {
      this.closeMenus();
      this.props.onChangeTrackData(uid, newData);
    }
  }, {
    key: "handleTracksAdded",
    value: function handleTracksAdded(newTracks, position, extent2, host) {
      if (this.trackToReplace) {
        this.handleCloseTrack(this.trackToReplace);
        this.trackToReplace = null;
      }
      this.props.onTracksAdded(newTracks, position, extent2, host);
      this.setState({
        addTrackExtent: null,
        addTrackPosition: null,
        addTrackHost: null
      });
      return newTracks;
    }
  }, {
    key: "handleCloseTrackMenuOpened",
    value: function handleCloseTrackMenuOpened(uid, clickPosition) {
      this.setState({
        closeTrackMenuId: uid,
        closeTrackMenuLocation: clickPosition
      });
    }
  }, {
    key: "handleCloseContextMenu",
    value: function handleCloseContextMenu() {
      this.setState({
        contextMenuCustomItems: null,
        contextMenuPosition: null,
        contextMenuDataX: null,
        contextMenuDataY: null
      });
    }
  }, {
    key: "handleCloseTrackMenuClosed",
    value: function handleCloseTrackMenuClosed() {
      this.setState({
        closeTrackMenuId: null
      });
    }
  }, {
    key: "handleConfigTrackMenuOpened",
    value: function handleConfigTrackMenuOpened(uid, clickPosition) {
      this.closeMenus();
      this.setState({
        configTrackMenuId: uid,
        configTrackMenuLocation: clickPosition
      });
    }
  }, {
    key: "handleConfigureTrack",
    value: function handleConfigureTrack(track, configComponent) {
      this.setState({
        configTrackMenuId: null,
        trackOptions: {
          track,
          configComponent
        }
      });
      this.closeMenus();
    }
  }, {
    key: "handleSortEnd",
    value: function handleSortEnd(sortedTracks) {
      this.setState((prevState) => {
        const tracks2 = prevState.tracks;
        const positions = {};
        for (let i = 0; i < sortedTracks.length; i++) {
          positions[sortedTracks[i].uid] = i;
        }
        for (const trackType in tracks2) {
          const theseTracks = tracks2[trackType];
          if (!theseTracks.length) {
            continue;
          }
          if (theseTracks[0].uid in positions) {
            const newTracks = new Array(theseTracks.length);
            for (let i = 0; i < theseTracks.length; i++) {
              newTracks[positions[theseTracks[i].uid]] = theseTracks[i];
            }
            tracks2[trackType] = newTracks;
          }
        }
        return {
          tracks: tracks2,
          forceUpdate: Math.random()
        };
      });
    }
  }, {
    key: "createTracksAndLocations",
    value: function createTracksAndLocations() {
      const tracksAndLocations = [];
      const {
        tracks: tracks2
      } = this.state;
      TRACK_LOCATIONS.forEach((location) => {
        if (tracks2[location]) {
          tracks2[location].forEach((track) => {
            if (track.contents) {
              track.contents.forEach((content) => {
                content.position = location;
              });
            }
            track.position = location;
            tracksAndLocations.push({
              track,
              location
            });
          });
        }
      });
      return tracksAndLocations;
    }
    /**
     * Calculate where a track is absoluately positioned within the drawing area
     *
     * @param track: The track object (with members, e.g. track.uid, track.width,
     *   track.height)
     * @param location: Where it's being plotted (e.g. 'top', 'bottom')
     * @return: The position of the track and it's height and width
     *          (e.g. {left: 10, top: 20, width: 30, height: 40}
     */
  }, {
    key: "calculateTrackPosition",
    value: function calculateTrackPosition(track, location) {
      let top2 = this.props.paddingTop;
      let bottom2 = this.props.paddingBottom;
      let left2 = this.props.paddingLeft;
      let right2 = this.props.paddingRight;
      let width = this.centerWidth;
      let height = trackHeight(track);
      let offsetX = 0;
      let offsetY = 0;
      switch (location) {
        case "top":
          left2 += this.leftWidth;
          for (let i = 0; i < this.state.tracks.top.length; i++) {
            if (this.state.tracks.top[i].uid === track.uid) {
              break;
            }
            top2 += trackHeight(this.state.tracks.top[i]);
          }
          break;
        case "bottom":
          left2 += this.leftWidth;
          top2 += this.topHeight + this.centerHeight + this.galleryDim;
          for (let i = 0; i < this.state.tracks.bottom.length; i++) {
            if (this.state.tracks.bottom[i].uid === track.uid) {
              break;
            }
            top2 += trackHeight(this.state.tracks.bottom[i]);
          }
          break;
        case "left":
          top2 += this.topHeight;
          width = trackWidth(track);
          height = this.centerHeight;
          for (let i = 0; i < this.state.tracks.left.length; i++) {
            if (this.state.tracks.left[i].uid === track.uid) {
              break;
            }
            left2 += trackWidth(this.state.tracks.left[i]);
          }
          break;
        case "right":
          left2 += this.leftWidth + this.centerWidth + this.galleryDim;
          top2 += this.topHeight;
          width = trackWidth(track);
          height = this.centerHeight;
          for (let i = 0; i < this.state.tracks.right.length; i++) {
            if (this.state.tracks.right[i].uid === track.uid) {
              break;
            }
            left2 += trackWidth(this.state.tracks.right[i]);
          }
          break;
        case "center":
          left2 += this.leftWidth;
          top2 += this.topHeight;
          height = this.centerHeight;
          break;
        case "gallery":
          left2 += this.leftWidthNoGallery;
          top2 += this.topHeightNoGallery;
          width = this.state.width - this.leftWidthNoGallery - this.rightWidthNoGallery - this.props.paddingLeft;
          height = this.state.height - this.topHeightNoGallery - this.bottomHeightNoGallery - this.props.paddingTop;
          offsetX = this.galleryDim;
          offsetY = this.galleryDim;
          for (let i = 0; i < this.state.tracks.gallery.length; i++) {
            if (this.state.tracks.gallery[i].uid === track.uid) {
              break;
            }
            width -= 2 * this.state.tracks.gallery[i].height;
            height -= 2 * this.state.tracks.gallery[i].height;
            left2 += this.state.tracks.gallery[i].height;
            top2 += this.state.tracks.gallery[i].height;
            offsetX -= this.state.tracks.gallery[i].height;
            offsetY -= this.state.tracks.gallery[i].height;
          }
          for (let i = 0; i < this.state.tracks.right.length; i++) {
            right2 += this.state.tracks.right[i].width;
          }
          for (let i = 0; i < this.state.tracks.bottom.length; i++) {
            bottom2 += this.state.tracks.bottom[i].height;
          }
          track.offsetX = offsetX;
          track.offsetY = offsetY;
          track.offsetTop = top2;
          track.offsetRight = right2;
          track.offsetBottom = bottom2;
          track.offsetLeft = left2;
          break;
        default:
          width = this.leftWidth + this.centerWidth + this.rightWidth;
          height = this.topHeight + this.centerHeight + this.bottomHeight;
      }
      if (TRACK_LOCATIONS.indexOf(location) === -1) {
        console.warn("Track with unknown position present:", location, track);
      }
      return {
        left: left2,
        top: top2,
        width,
        height,
        track
      };
    }
    /**
     * Find a central heatmap track among all displayed tracks
     *
     * @param  {Array}  tracks  Tracks to be searched.
     * @return  {Object}  The first central heatmap track or `undefined`.
     */
  }, {
    key: "findCentralHeatmapTrack",
    value: function findCentralHeatmapTrack(tracks2) {
      for (let i = 0; i < tracks2.length; i++) {
        if (tracks2[i].type === "combined") {
          return this.findCentralHeatmapTrack(tracks2[i].contents);
        }
        if (tracks2[i].type === "heatmap") return tracks2[i];
      }
      return void 0;
    }
  }, {
    key: "trackUuidToOrientation",
    value: function trackUuidToOrientation(trackUuid) {
    }
  }, {
    key: "overlayTracks",
    value: function overlayTracks(positionedTracks) {
      if (this.props.overlays) {
        const overlayDefs = this.props.overlays.filter((overlayTrack) => overlayTrack.includes?.length).map((overlayTrack) => {
          const type2 = overlayTrack.type ? `overlay-${overlayTrack.type}-track` : "overlay-track";
          const overlayDef = {
            ...overlayTrack,
            uid: overlayTrack.uid || slugid.nice(),
            includes: overlayTrack.includes,
            type: type2,
            options: Object.assign(overlayTrack.options, {
              orientationsAndPositions: overlayTrack.includes.map((trackUuid) => {
                const includedTrack = getTrackByUid(this.props.tracks, trackUuid);
                if (!includedTrack) {
                  console.warn(`OverlayTrack included uid (${trackUuid}) not found in the track list`);
                  return null;
                }
                const trackPos = getTrackPositionByUid(this.props.tracks, includedTrack.uid);
                let orientation2;
                if (trackPos === "top" || trackPos === "bottom") {
                  orientation2 = "1d-horizontal";
                }
                if (trackPos === "left" || trackPos === "right") {
                  orientation2 = "1d-vertical";
                }
                if (trackPos === "center") {
                  orientation2 = "2d";
                }
                if (!orientation2) {
                  console.warn("Only top, bottom, left, right, or center tracks can be overlaid at the moment");
                  return null;
                }
                const positionedTrack = positionedTracks.filter((track) => track.track.uid === trackUuid);
                if (!positionedTrack.length) {
                  return null;
                }
                const position = {
                  left: positionedTrack[0].left - this.props.paddingLeft,
                  top: positionedTrack[0].top - this.props.paddingTop,
                  width: positionedTrack[0].width,
                  height: positionedTrack[0].height
                };
                return {
                  orientation: orientation2,
                  position
                };
              }).filter((x) => x)
              // filter out null entries
            })
          };
          return {
            top: this.props.paddingTop,
            left: this.props.paddingLeft,
            width: this.leftWidth + this.centerWidth + this.rightWidth,
            height: this.topHeight + this.centerHeight + this.bottomHeight + this.props.marginTop + this.props.marginBottom,
            track: overlayDef
          };
        });
        return overlayDefs;
      }
      return [];
    }
  }, {
    key: "positionedTracks",
    value: function positionedTracks() {
      const tracksAndLocations = this.createTracksAndLocations().map(({
        track,
        location
      }) => this.calculateTrackPosition(track, location));
      return tracksAndLocations;
    }
  }, {
    key: "createTrackPositionTexts",
    value: function createTrackPositionTexts() {
      const positionedTracks = this.positionedTracks();
      this.createTracksAndLocations();
      const trackElements = positionedTracks.map((trackPosition) => {
        const {
          track
        } = trackPosition;
        return /* @__PURE__ */ React__default.createElement("div", {
          key: track.uid,
          style: {
            left: trackPosition.left,
            top: trackPosition.top,
            width: trackWidth(trackPosition.track),
            height: trackHeight(trackPosition.track),
            position: "absolute"
          }
        }, track.uid.slice(0, 2));
      });
      return trackElements;
    }
  }, {
    key: "handleExportTrackData",
    value: function handleExportTrackData(hostTrackUid, trackUid) {
      const track = getTrackByUid(this.props.tracks, trackUid);
      let trackObject = null;
      if (hostTrackUid !== trackUid) {
        trackObject = this.trackRenderer.trackDefObjects[hostTrackUid].trackObject.createdTracks[track.uid];
      } else {
        ({
          trackObject
        } = this.trackRenderer.trackDefObjects[hostTrackUid]);
      }
      trackObject.exportData();
      this.closeMenus();
    }
    /**
     * List all the tracks that are under this mouse position
     */
  }, {
    key: "listTracksAtPosition",
    value: function listTracksAtPosition(x, y, isReturnTrackObj = false) {
      const trackObjectsAtPosition = [];
      if (!this.trackRenderer) return [];
      for (const uid in this.trackRenderer.trackDefObjects) {
        const trackObj = this.trackRenderer.trackDefObjects[uid].trackObject;
        if (trackObj.respondsToPosition(x, y)) {
          if (isReturnTrackObj) {
            if (this.props.tracks.center) {
              if (this.props.tracks.center.contents) {
                for (let i = 0; i < this.props.tracks.center.contents.length; i++) {
                  if (this.props.tracks.center.contents[i].uid === uid) {
                    trackObj.is2d = true;
                  }
                }
              } else if (this.props.tracks.center?.length && this.props.tracks.center[0].uid === uid) {
                trackObj.is2d = true;
              }
            }
            trackObjectsAtPosition.push(trackObj);
          } else {
            trackObjectsAtPosition.push(this.trackRenderer.trackDefObjects[uid].trackDef.track);
          }
        }
      }
      return trackObjectsAtPosition;
    }
  }, {
    key: "listAllTrackObjects",
    value: function listAllTrackObjects() {
      const trackObjectsToCheck = [];
      for (const uid in this.trackRenderer.trackDefObjects) {
        const tdo = this.trackRenderer.trackDefObjects[uid];
        if (tdo.trackObject.createdTracks) {
          for (const uid1 in tdo.trackObject.createdTracks) {
            const trackObject = tdo.trackObject.createdTracks[uid1];
            trackObjectsToCheck.push(trackObject);
          }
        } else {
          trackObjectsToCheck.push(tdo.trackObject);
        }
      }
      return trackObjectsToCheck;
    }
  }, {
    key: "handleZoomToData",
    value: function handleZoomToData() {
      const maxSafeInt = Number.MAX_SAFE_INTEGER;
      const minSafeInt = Number.MIN_SAFE_INTEGER;
      const minPos = [maxSafeInt, maxSafeInt];
      const maxPos = [minSafeInt, minSafeInt];
      const trackObjectsToCheck = this.listAllTrackObjects();
      for (const trackObject of trackObjectsToCheck) {
        if (trackObject.tilesetInfo) {
          if (trackObject.tilesetInfo.min_pos) {
            for (let j = 0; j < trackObject.tilesetInfo.min_pos.length; j++) {
              if (trackObject.tilesetInfo.min_pos[j] < minPos[j]) {
                minPos[j] = trackObject.tilesetInfo.min_pos[j];
              }
              if (trackObject.tilesetInfo.max_pos[j] > maxPos[j]) {
                maxPos[j] = trackObject.tilesetInfo.max_pos[j];
              }
            }
          }
        }
      }
      const left2 = this.trackRenderer.currentProps.paddingLeft + this.trackRenderer.currentProps.leftWidth;
      let newXDomain = [left2, left2 + this.trackRenderer.currentProps.centerWidth].map(this.trackRenderer.zoomTransform.rescaleX(this.trackRenderer.xScale).invert);
      const top2 = this.trackRenderer.currentProps.paddingTop + this.trackRenderer.currentProps.topHeight;
      let newYDomain = [top2, top2 + this.trackRenderer.currentProps.centerHeight].map(this.trackRenderer.zoomTransform.rescaleY(this.trackRenderer.yScale).invert);
      this.trackRenderer.zoomTransform.k = 1;
      this.trackRenderer.zoomTransform.x = 0;
      this.trackRenderer.zoomTransform.y = 0;
      this.trackRenderer.applyZoomTransform();
      if (minPos[0] < Number.MAX_SAFE_INTEGER && maxPos[0] > Number.MIN_SAFE_INTEGER) {
        newXDomain = [minPos[0], maxPos[0]];
      }
      if (minPos[1] < Number.MAX_SAFE_INTEGER && maxPos[1] > Number.MIN_SAFE_INTEGER) {
        newYDomain = [minPos[1], maxPos[1]];
      }
      this.props.onDataDomainChanged(newXDomain, newYDomain);
    }
  }, {
    key: "resetViewport",
    value: function resetViewport() {
      this.trackRenderer.zoomTransform.k = 1;
      this.trackRenderer.zoomTransform.x = 0;
      this.trackRenderer.zoomTransform.y = 0;
      this.trackRenderer.applyZoomTransform();
      this.props.onDataDomainChanged(this.props.initialXDomain, this.props.initialYDomain);
    }
  }, {
    key: "updatablePropsToString",
    value: function updatablePropsToString(props) {
      return JSON.stringify({
        tracks: props.tracks,
        overlays: props.overlays,
        viewOptions: props.viewOptions,
        uid: props.uid,
        addTrackExtent: props.addTrackExtent,
        addTrackPosition: props.addTrackPosition,
        editable: props.editable,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        paddingTop: props.paddingTop,
        paddingBottom: props.paddingBottom,
        paddingLeft: props.paddingLeft,
        paddingRight: props.paddingRight,
        mouseTool: props.mouseTool,
        initialXDomain: props.initialXDomain,
        initialYDomain: props.initialYDomain,
        trackSourceServers: props.trackSourceServers,
        zoomable: props.zoomable,
        draggingHappening: props.draggingHappening
      });
    }
  }, {
    key: "getXYScales",
    value: function getXYScales() {
      if (this.trackRenderer) {
        this.xScale = this.trackRenderer.currentXScale;
        this.yScale = this.trackRenderer.currentYScale;
      }
    }
    /**
     * Translate view to data location.
     *
     * @description
     * The view location is in pixels relative to the browser window. The data
     * location is given by the scaling relative to the initial x and y domains.
     * And the genomic location depends on the chrom sizes.
     *
     * @method  rangeViewToDataLoci
     * @author  Fritz Lekschas
     * @date    2018-01-14
     * @param  {Array}  range  Selected view range
     * @param  {Function}  scale  View to data scaling
     * @return  {Array}  2D array of data locations
     */
  }, {
    key: "rangeViewToDataLoci",
    value: function rangeViewToDataLoci(range2, scale) {
      if (!scale) return [null, null];
      return [Number.parseInt(scale.invert(range2[0]), 10), Number.parseInt(scale.invert(range2[1]), 10)];
    }
  }, {
    key: "rangeSelectionResetHandler",
    value: function rangeSelectionResetHandler() {
      if (this.state.rangeSelectionMaster) {
        this.setState({
          is1dRangeSelection: null,
          rangeSelection: [null, null],
          rangeSelectionMaster: null,
          rangeSelectionEnd: false
        });
      }
    }
  }, {
    key: "rangeSelection1dEndHandler",
    value: function rangeSelection1dEndHandler(axis2) {
      if (!this.xScale || !this.yScale) {
        this.getXYScales();
      }
      const scale = axis2 === "x" ? this.xScale : this.yScale;
      return (range2) => {
        this.setState((prevState) => {
          const newRangeSelection = prevState.is1dRangeSelection ? [null, null] : prevState.rangeSelection.slice();
          const accessor = !this.state.is1dRangeSelection && axis2 === "y" ? 1 : 0;
          let dataPos = this.rangeViewToDataLoci(range2, scale);
          const size = dataPos[1] - dataPos[0];
          if (this.props.rangeSelection1dSize[0] > size) {
            const center2 = dataPos[0] + size / 2;
            dataPos = [center2 - this.props.rangeSelection1dSize[0] / 2, center2 + this.props.rangeSelection1dSize[0] / 2];
          } else if (this.props.rangeSelection1dSize[1] < size) {
            const center2 = dataPos[0] + size / 2;
            dataPos = [center2 - this.props.rangeSelection1dSize[1] / 2, center2 + this.props.rangeSelection1dSize[1] / 2];
          }
          newRangeSelection[accessor] = dataPos;
          if (this.props.rangeSelectionToInt) {
            newRangeSelection[accessor] = newRangeSelection[accessor].map((x) => Math.round(x));
          }
          return {
            rangeSelection: newRangeSelection,
            rangeSelectionEnd: true
          };
        });
      };
    }
  }, {
    key: "rangeSelection1dHandler",
    value: function rangeSelection1dHandler(axis2) {
      if (!this.xScale || !this.yScale) this.getXYScales();
      const scale = axis2 === "x" ? this.xScale : this.yScale;
      return (range2) => {
        this.setState((prevState) => {
          const newRangeSelection = prevState.is1dRangeSelection ? [null, null] : prevState.rangeSelection.slice();
          const accessor = !prevState.is1dRangeSelection && axis2 === "y" ? 1 : 0;
          newRangeSelection[accessor] = this.rangeViewToDataLoci(range2, scale);
          return {
            rangeSelection: newRangeSelection,
            rangeSelectionEnd: false
          };
        });
      };
    }
  }, {
    key: "rangeSelection1dStartHandler",
    value: function rangeSelection1dStartHandler() {
      if (!this.state.rangeSelectionMaster) {
        this.setState({
          is1dRangeSelection: true,
          rangeSelectionMaster: true,
          rangeSelectionEnd: false
        });
      }
    }
  }, {
    key: "rangeSelection2dHandler",
    value: function rangeSelection2dHandler(range2) {
      if (!this.xScale || !this.yScale) this.getXYScales();
      this.setState({
        rangeSelection: [this.rangeViewToDataLoci(range2[0], this.xScale), this.rangeViewToDataLoci(range2[1], this.yScale)],
        rangeSelectionEnd: false
      });
    }
  }, {
    key: "rangeSelection2dStartHandler",
    value: function rangeSelection2dStartHandler() {
      if (!this.state.rangeSelectionMaster) {
        this.setState({
          is1dRangeSelection: false,
          rangeSelectionMaster: true,
          rangeSelectionEnd: false
        });
      }
    }
  }, {
    key: "rangeSelection2dEndHandler",
    value: function rangeSelection2dEndHandler(range2) {
      if (!this.xScale || !this.yScale) this.getXYScales();
      const dataPosX = this.rangeViewToDataLoci(range2[0], this.xScale);
      const dataPosY = this.rangeViewToDataLoci(range2[1], this.yScale);
      let dataPos = [dataPosX, dataPosY];
      const sizeX = dataPosX[1] - dataPosX[0];
      const sizeY = dataPosY[1] - dataPosY[0];
      const size = [sizeX, sizeY];
      dataPos.forEach((pos, i) => {
        if (this.props.rangeSelection1dSize[0] > size[i]) {
          const center2 = pos[0] + Math.round(size[i] / 2);
          pos[0] = center2 - this.props.rangeSelection1dSize[0] / 2;
          pos[1] = center2 + this.props.rangeSelection1dSize[0] / 2;
        } else if (this.props.rangeSelection1dSize[1] < size[i]) {
          const center2 = pos[0] + Math.round(size[i] / 2);
          pos[0] = center2 - this.props.rangeSelection1dSize[1] / 2;
          pos[1] = center2 + this.props.rangeSelection1dSize[1] / 2;
        }
      });
      if (this.props.rangeSelectionToInt) {
        dataPos = dataPos.map((x) => x.map((y) => Math.round(y)));
      }
      this.setState({
        rangeSelection: dataPos,
        rangeSelectionEnd: true
      });
    }
  }, {
    key: "getContextMenu",
    value: function getContextMenu() {
      if (this.state.contextMenuPosition) {
        const relevantTracks = this.listTracksAtPosition(this.state.contextMenuPosition.canvasLeft, this.state.contextMenuPosition.canvasTop);
        return /* @__PURE__ */ React__default.createElement(PopupMenu, {
          onMenuClosed: this.closeMenusBound
        }, /* @__PURE__ */ React__default.createElement(ViewContextMenu, {
          apiPublish: this.props.apiPublish,
          closeMenu: this.closeMenusBound,
          coords: [this.state.contextMenuDataX, this.state.contextMenuDataY],
          customItems: this.state.contextMenuCustomItems,
          genomePositionSearchBox: this.props.genomePositionSearchBox,
          onAddDivisor: this.handleAddDivisorBound,
          onAddSeries: this.handleAddSeriesBound,
          onAddTrack: (newTrack) => {
            this.props.onTracksAdded([newTrack], newTrack.position, null, null);
            this.handleCloseContextMenu();
          },
          onChangeTrackData: this.handleChangeTrackDataBound,
          onChangeTrackType: this.handleChangeTrackTypeBound,
          onCloseTrack: this.handleCloseTrackBound,
          onConfigureTrack: this.handleConfigureTrackBound,
          onExportData: this.handleExportTrackDataBound,
          onLockValueScale: this.handleLockValueScaleBound,
          onReplaceTrack: this.handleReplaceTrackBound,
          onTrackOptionsChanged: this.handleTrackOptionsChangedBound,
          onUnlockValueScale: this.handleUnlockValueScaleBound,
          orientation: "right",
          position: this.state.contextMenuPosition,
          theme: this.props.theme,
          trackRenderer: this.trackRenderer,
          tracks: relevantTracks,
          trackSourceServers: this.props.trackSourceServers
        }));
      }
      return null;
    }
    /**
     * Draw an overlay that shows the positions of all the different
     * track areas
     */
  }, {
    key: "getIdealizedTrackPositionsOverlay",
    value: function getIdealizedTrackPositionsOverlay() {
      const evtJson = this.props.draggingHappening;
      const {
        datatype
      } = evtJson;
      const defaultTracks = getDefaultTracksForDatatype(datatype, evtJson.defaultTracks);
      if (!defaultTracks) {
        return null;
      }
      const presentTracks = new Set(["top", "left", "right", "center", "bottom"].filter((x) => x in this.state.tracks && this.state.tracks[x].length));
      const topAllowed = "top" in defaultTracks;
      const leftAllowed = "left" in defaultTracks;
      const rightAllowed = "right" in defaultTracks;
      const bottomAllowed = "bottom" in defaultTracks;
      const centerAllowed = "center" in defaultTracks;
      const hasVerticalComponent = "center" in defaultTracks || presentTracks.has("left") || presentTracks.has("right") || presentTracks.has("center");
      const topDisplayed = "top" in defaultTracks;
      const bottomDisplayed = "bottom" in defaultTracks && hasVerticalComponent;
      const leftDisplayed = "left" in defaultTracks && hasVerticalComponent;
      const rightDisplayed = "right" in defaultTracks && hasVerticalComponent;
      const centerDisplayed = Object.keys(defaultTracks).length && ("center" in defaultTracks || hasVerticalComponent);
      const topLeftDiv = /* @__PURE__ */ React__default.createElement("div", {
        style: {
          flexGrow: 1
        }
      });
      const topRightDiv = /* @__PURE__ */ React__default.cloneElement(topLeftDiv);
      const topDiv = /* @__PURE__ */ React__default.createElement("div", {
        style: {
          display: "flex",
          flexGrow: 1
        }
      }, topDisplayed && (centerDisplayed || leftDisplayed) ? topLeftDiv : null, /* @__PURE__ */ React__default.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.top,
        draggingHappening: this.props.draggingHappening,
        enabled: topAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "top"),
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      }), topDisplayed && (centerDisplayed || leftDisplayed) ? topRightDiv : null);
      const bottomDiv = /* @__PURE__ */ React__default.createElement("div", {
        style: {
          display: "flex",
          flexGrow: 1
        }
      }, topDisplayed && (centerDisplayed || leftDisplayed) ? topLeftDiv : null, /* @__PURE__ */ React__default.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.bottom,
        draggingHappening: this.props.draggingHappening,
        enabled: bottomAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "bottom"),
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      }), topDisplayed && (centerDisplayed || leftDisplayed) ? topRightDiv : null);
      const leftDiv = /* @__PURE__ */ React__default.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.left,
        draggingHappening: this.props.draggingHappening,
        enabled: leftAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "left"),
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      });
      const centerDiv = /* @__PURE__ */ React__default.createElement(DragListeningDiv$1, {
        defaultTrackType: defaultTracks.center,
        draggingHappening: this.props.draggingHappening,
        enabled: centerAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "center"),
        position: "center",
        style: {
          border: "1px solid black",
          flexGrow: 1
        }
      });
      const rightDiv = /* @__PURE__ */ React__default.cloneElement(leftDiv, {
        defaultTrackType: defaultTracks.right,
        enabled: rightAllowed,
        onTrackDropped: (track) => this.handleTracksAdded([track], "right")
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        style: {
          position: "absolute",
          left: "0px",
          top: "0px",
          width: this.state.width,
          height: this.state.height
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        style: {
          position: "absolute",
          width: this.state.width,
          height: this.state.height,
          background: "white",
          opacity: 0.4
        }
      }), /* @__PURE__ */ React__default.createElement("div", {
        style: {
          width: this.state.width,
          height: this.state.height,
          position: "absolute",
          display: "flex",
          flexDirection: "column"
        }
      }, topDisplayed ? topDiv : null, hasVerticalComponent && /* @__PURE__ */ React__default.createElement("div", {
        style: {
          display: "flex",
          height: topDisplayed || bottomDisplayed ? "40%" : "100%",
          width: "100%"
        }
      }, leftDisplayed ? leftDiv : null, centerDisplayed ? centerDiv : null, rightDisplayed ? rightDiv : null), bottomDisplayed ? bottomDiv : null));
    }
  }, {
    key: "render",
    value: function render3() {
      this.galleryDim = this.props.tracks.gallery ? this.props.tracks.gallery.map((x) => trackHeight(x)).reduce(sum$1, 0) : 0;
      this.topHeightNoGallery = this.props.tracks.top.map((x) => trackHeight(x)).reduce(sum$1, 0);
      this.topHeight = this.topHeightNoGallery + this.galleryDim;
      this.bottomHeightNoGallery = this.props.tracks.bottom.map((x) => trackHeight(x)).reduce(sum$1, 0);
      this.bottomHeight = this.bottomHeightNoGallery + this.galleryDim;
      this.leftWidthNoGallery = this.props.tracks.left.map((x) => trackWidth(x)).reduce(sum$1, 0);
      this.leftWidth = this.leftWidthNoGallery + this.galleryDim;
      this.rightWidthNoGallery = this.props.tracks.right.map((x) => trackWidth(x)).reduce(sum$1, 0);
      this.rightWidth = this.rightWidthNoGallery + this.galleryDim;
      const verticalPadding = this.props.paddingTop + this.props.paddingBottom;
      const horizontalPadding = this.props.paddingLeft + this.props.paddingRight;
      this.centerHeight = Math.max(1, this.state.height - this.topHeight - this.bottomHeight - verticalPadding);
      this.centerWidth = Math.max(1, this.state.width - this.leftWidth - this.rightWidth - horizontalPadding);
      const trackOutline = "none";
      const topTracks = /* @__PURE__ */ React__default.createElement("div", {
        className: "top-track-container",
        style: {
          left: this.leftWidth + this.props.paddingLeft,
          top: this.props.paddingTop,
          width: this.centerWidth,
          height: this.topHeightNoGallery,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React__default.createElement(HorizontalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onCollapseTrack: this.handleCollapseTrack.bind(this),
        onExpandTrack: this.handleExpandTrack.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("x").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("x").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["bottom"]),
        scale: this.xScale,
        tracks: this.props.tracks.top,
        width: this.centerWidth
      }));
      const leftTracks = /* @__PURE__ */ React__default.createElement("div", {
        className: "left-track-container",
        style: {
          left: this.props.paddingLeft,
          top: this.topHeight + this.props.paddingTop,
          width: this.leftWidthNoGallery,
          height: this.centerHeight,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React__default.createElement(VerticalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        height: this.centerHeight,
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onCollapseTrack: this.handleCollapseTrack.bind(this),
        onExpandTrack: this.handleExpandTrack.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("y").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("y").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["right"]),
        scale: this.yScale,
        tracks: this.props.tracks.left
      }));
      const rightTracks = /* @__PURE__ */ React__default.createElement("div", {
        className: "right-track-container",
        style: {
          right: this.props.paddingRight,
          top: this.topHeight + this.props.paddingTop,
          width: this.rightWidthNoGallery,
          height: this.centerHeight,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React__default.createElement(VerticalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        height: this.centerHeight,
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onCollapseTrack: this.handleCollapseTrack.bind(this),
        onExpandTrack: this.handleExpandTrack.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("y").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("y").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["left"]),
        scale: this.yScale,
        tracks: this.props.tracks.right,
        tracksControlAlignLeft: true
      }));
      const bottomTracks = /* @__PURE__ */ React__default.createElement("div", {
        className: "bottom-track-container",
        style: {
          left: this.leftWidth + this.props.paddingLeft,
          bottom: this.props.paddingBottom,
          width: this.centerWidth,
          height: this.bottomHeightNoGallery,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React__default.createElement(HorizontalTiledPlot, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        handleConfigTrack: this.handleConfigTrackMenuOpened.bind(this),
        handleResizeTrack: this.handleResizeTrack.bind(this),
        handleSortEnd: this.handleSortEnd.bind(this),
        is1dRangeSelection: this.state.is1dRangeSelection,
        isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onCollapseTrack: this.handleCollapseTrack.bind(this),
        onExpandTrack: this.handleExpandTrack.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        onRangeSelection: this.rangeSelection1dHandler("x").bind(this),
        onRangeSelectionEnd: this.rangeSelection1dEndHandler("x").bind(this),
        onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
        onRangeSelectionStart: this.rangeSelection1dStartHandler.bind(this),
        rangeSelection: this.state.rangeSelection,
        rangeSelectionEnd: this.state.rangeSelectionEnd,
        resizeHandles: /* @__PURE__ */ new Set(["top"]),
        scale: this.xScale,
        tracks: this.props.tracks.bottom,
        width: this.centerWidth
      }));
      const galleryTracks = /* @__PURE__ */ React__default.createElement("div", {
        key: "galleryTracksDiv",
        className: "gallery-track-container",
        style: {
          left: this.leftWidthNoGallery + this.props.paddingLeft,
          top: this.topHeightNoGallery + this.props.paddingTop,
          width: this.centerWidth + 2 * this.galleryDim,
          height: this.centerHeight + 2 * this.galleryDim,
          outline: trackOutline,
          position: "absolute"
        }
      }, /* @__PURE__ */ React__default.createElement(GalleryTracks, {
        configTrackMenuId: this.state.configTrackMenuId,
        editable: this.props.editable,
        height: this.centerHeight + 2 * this.galleryDim,
        onAddSeries: this.handleAddSeries.bind(this),
        onCloseTrack: this.handleCloseTrack.bind(this),
        onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
        onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
        tracks: this.props.tracks.gallery,
        width: this.centerWidth + 2 * this.galleryDim
      }));
      let centerTrack = /* @__PURE__ */ React__default.createElement("div", {
        className: clsx$2("center-track-container", stylesCenterTrack["center-track-container"]),
        style: {
          left: this.leftWidth + this.props.paddingLeft,
          top: this.topHeight + this.props.paddingTop,
          width: this.centerWidth,
          height: this.bottomHeight,
          outline: trackOutline
        }
      });
      if (this.props.tracks.center.length) {
        centerTrack = /* @__PURE__ */ React__default.createElement("div", {
          className: clsx$2("center-track-container", stylesCenterTrack["center-track-container"]),
          style: {
            left: this.leftWidth + this.props.paddingLeft,
            top: this.topHeight + this.props.paddingTop,
            width: this.centerWidth,
            height: this.centerHeight,
            outline: trackOutline
          }
        }, /* @__PURE__ */ React__default.createElement(CenterTrack, {
          configTrackMenuId: this.state.configTrackMenuId,
          editable: this.props.editable,
          height: this.centerHeight,
          is1dRangeSelection: this.state.is1dRangeSelection,
          isRangeSelectionActive: this.props.mouseTool === MOUSE_TOOL_SELECT,
          onAddSeries: this.handleAddSeries.bind(this),
          onCloseTrackMenuOpened: this.handleCloseTrackMenuOpened.bind(this),
          onConfigTrackMenuOpened: this.handleConfigTrackMenuOpened.bind(this),
          onRangeSelectionReset: this.rangeSelectionResetHandler.bind(this),
          onRangeSelectionStart: this.rangeSelection2dStartHandler.bind(this),
          onRangeSelectionX: this.rangeSelection1dHandler("x").bind(this),
          onRangeSelectionXEnd: this.rangeSelection1dEndHandler("x").bind(this),
          onRangeSelectionXY: this.rangeSelection2dHandler.bind(this),
          onRangeSelectionXYEnd: this.rangeSelection2dEndHandler.bind(this),
          onRangeSelectionY: this.rangeSelection1dHandler("y").bind(this),
          onRangeSelectionYEnd: this.rangeSelection1dEndHandler("y").bind(this),
          rangeSelection: this.state.rangeSelection,
          rangeSelectionEnd: this.state.rangeSelectionEnd,
          scaleX: this.xScale,
          scaleY: this.yScale,
          tracks: this.props.tracks.center,
          uid: this.props.tracks.center[0].uid,
          width: this.centerWidth
        }));
      }
      this.createTrackPositionTexts();
      let positionedTracks = this.positionedTracks();
      positionedTracks = positionedTracks.concat(this.overlayTracks(positionedTracks));
      let trackRenderer = null;
      if (this.state.sizeMeasured) {
        trackRenderer = /* @__PURE__ */ React__default.createElement(
          TrackRenderer$1,
          {
            ref: (c) => {
              this.trackRenderer = c;
              this.checkAllTilesetInfoReceived();
            },
            canvasElement: this.props.canvasElement,
            centerHeight: this.centerHeight,
            centerWidth: this.centerWidth,
            disableTrackMenu: this.props.disableTrackMenu,
            dragging: this.props.dragging,
            galleryDim: this.galleryDim,
            getLockGroupExtrema: this.props.getLockGroupExtrema,
            height: this.state.height,
            initialXDomain: this.props.initialXDomain,
            initialYDomain: this.props.initialYDomain,
            isRangeSelection: this.props.mouseTool === MOUSE_TOOL_SELECT,
            isShowGlobalMousePosition: this.props.isShowGlobalMousePosition,
            isValueScaleLocked: this.props.isValueScaleLocked,
            leftWidth: this.leftWidth,
            leftWidthNoGallery: this.leftWidthNoGallery,
            metaTracks: this.props.metaTracks,
            onMouseMoveZoom: this.props.onMouseMoveZoom,
            onNewTilesLoaded: this.props.onNewTilesLoaded,
            onScalesChanged: this.handleScalesChanged.bind(this),
            onTilesetInfoReceived: this.handleTilesetInfoReceived.bind(this),
            onTrackOptionsChanged: this.handleTrackOptionsChanged.bind(this),
            onValueScaleChanged: this.props.onValueScaleChanged,
            paddingLeft: this.props.paddingLeft,
            paddingTop: this.props.paddingTop,
            pixiRenderer: this.props.pixiRenderer,
            pixiStage: this.props.pixiStage,
            pluginDataFetchers: this.props.pluginDataFetchers,
            pluginTracks: this.props.pluginTracks,
            positionedTracks,
            registerDraggingChangedListener: this.props.registerDraggingChangedListener,
            removeDraggingChangedListener: this.props.removeDraggingChangedListener,
            setCentersFunction: this.props.setCentersFunction,
            svgElement: this.props.svgElement,
            topHeight: this.topHeight,
            topHeightNoGallery: this.topHeightNoGallery,
            uid: this.props.uid,
            viewOptions: this.props.viewOptions,
            width: this.state.width,
            xDomainLimits: this.props.xDomainLimits,
            yDomainLimits: this.props.yDomainLimits,
            zoomable: this.props.zoomable,
            zoomLimits: this.props.zoomLimits
          },
          topTracks,
          leftTracks,
          rightTracks,
          bottomTracks,
          galleryTracks,
          centerTrack
        );
      }
      let configTrackMenu = null;
      let closeTrackMenu = null;
      if (this.state.configTrackMenuId) {
        configTrackMenu = /* @__PURE__ */ React__default.createElement(PopupMenu, {
          onMenuClosed: this.closeMenusBound
        }, /* @__PURE__ */ React__default.createElement(ConfigTrackMenu, {
          ref: (c) => {
            this.configTrackMenu = c;
          },
          apiPublish: this.props.apiPublish,
          closeMenu: this.closeMenusBound,
          onAddDivisor: this.handleAddDivisorBound,
          onAddSeries: this.handleAddSeriesBound,
          onAddTrack: this.handleAddTrackBound,
          onChangeTrackType: this.handleChangeTrackTypeBound,
          onCloseTrack: this.handleCloseTrackBound,
          onConfigureTrack: this.handleConfigureTrackBound,
          onExportData: this.handleExportTrackDataBound,
          onLockValueScale: this.handleLockValueScaleBound,
          onReplaceTrack: this.handleReplaceTrackBound,
          onTrackOptionsChanged: this.handleTrackOptionsChangedBound,
          onUnlockValueScale: this.handleUnlockValueScaleBound,
          position: this.state.configTrackMenuLocation,
          theme: this.props.theme,
          trackOrientation: getTrackPositionByUid(this.props.tracks, this.state.configTrackMenuId),
          trackRenderer: this.trackRenderer,
          tracks: [getTrackByUid(this.props.tracks, this.state.configTrackMenuId)]
        }));
      }
      if (this.state.closeTrackMenuId) {
        closeTrackMenu = /* @__PURE__ */ React__default.createElement(PopupMenu, {
          onMenuClosed: this.handleCloseTrackMenuClosed.bind(this)
        }, /* @__PURE__ */ React__default.createElement(ContextMenuContainer, {
          position: this.state.closeTrackMenuLocation,
          theme: this.props.theme
        }, /* @__PURE__ */ React__default.createElement(CloseTrackMenu, {
          onCloseTrack: this.handleCloseTrack.bind(this),
          tracks: [getTrackByUid(this.props.tracks, this.state.closeTrackMenuId)]
        })));
      }
      let overlays = null;
      if (this.props.chooseTrackHandler) {
        overlays = positionedTracks.filter((pTrack) => pTrack.track.position !== "whole").map((pTrack) => {
          let className = "tiled-plot-track-overlay-animate";
          if (this.state.mouseOverOverlayUid || this.props.overTrackChooser) {
            className = "tiled-plot-track-overlay-plain";
          }
          if (this.state.mouseOverOverlayUid === pTrack.track.uid) {
            className = "tiled-plot-track-overlay-selected";
          }
          return /* @__PURE__ */ React__default.createElement("div", {
            className: styles$3[className],
            key: pTrack.track.uid,
            onClick: (evt) => this.handleTrackPositionChosen(pTrack, evt),
            onDragEnter: (evt) => {
              this.handleOverlayMouseEnter(pTrack.track.uid);
              evt.preventDefault();
            },
            onDragLeave: () => this.handleOverlayMouseLeave(pTrack.track.uid),
            onDragOver: (evt) => evt.preventDefault(),
            onDrop: () => this.handleTrackPositionChosen(pTrack),
            onMouseEnter: () => this.handleOverlayMouseEnter(pTrack.track.uid),
            onMouseLeave: () => this.handleOverlayMouseLeave(pTrack.track.uid),
            style: {
              position: "absolute",
              left: pTrack.left,
              top: pTrack.top,
              width: trackWidth(pTrack),
              height: trackHeight(pTrack),
              zIndex: 1
            }
          });
        });
      }
      let trackOptionsElement = null;
      if (this.xScale && this.yScale && this.props.editable && this.state.trackOptions) {
        const configComponent = this.state.trackOptions.configComponent;
        const track = this.state.trackOptions.track;
        trackOptionsElement = /* @__PURE__ */ React__default.createElement(configComponent, {
          track,
          xScale: this.xScale,
          yScale: this.yScale,
          onCancel: () => {
            this.setState({
              trackOptions: null
            });
          },
          onTrackOptionsChanged: (newOptions) => newOptions,
          onSubmit: (newOptions) => {
            this.handleTrackOptionsChanged(this.state.trackOptions.track.uid, newOptions);
            this.setState({
              trackOptions: null
            });
          }
        });
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.divTiledPlot = c;
        },
        className: clsx$2("tiled-plot-div", styles$3["tiled-plot"]),
        onClick: this.handleClickBound,
        style: {
          marginBottom: this.props.marginBottom,
          marginLeft: this.props.marginLeft,
          marginRight: this.props.marginRight,
          marginTop: this.props.marginTop
        }
      }, trackRenderer, overlays, configTrackMenu, closeTrackMenu, trackOptionsElement, this.getContextMenu(), this.props.draggingHappening && this.getIdealizedTrackPositionsOverlay());
    }
    /* -------------------- Custom Methods -----------------------*/
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      this.eventListeners = [];
      this.eventListeners.forEach((event) => document.addEventListener(event.name, event.callback, false));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach((event) => document.removeEventListener(event.name, event.callback));
    }
  }]);
})(React__default.Component);
TiledPlot.defaultProps = {
  isShowGlobalMousePosition: false,
  pluginTracks: {},
  metaTracks: [],
  zoomable: true
};
TiledPlot.propTypes = {
  addTrackExtent: PropTypes.string,
  addTrackPosition: PropTypes.string,
  canvasElement: PropTypes.object,
  chooseTrackHandler: PropTypes.func,
  chromInfoPath: PropTypes.string,
  customDialog: PropTypes.array,
  closeCustomDialog: PropTypes.func,
  disableTrackMenu: PropTypes.bool,
  dragging: PropTypes.bool,
  draggingHappening: PropTypes.bool,
  editable: PropTypes.bool,
  getLockGroupExtrema: PropTypes.func,
  initialXDomain: PropTypes.array,
  initialYDomain: PropTypes.array,
  isShowGlobalMousePosition: PropTypes.bool,
  isValueScaleLocked: PropTypes.func,
  marginBottom: PropTypes.number.isRequired,
  marginLeft: PropTypes.number.isRequired,
  marginRight: PropTypes.number.isRequired,
  marginTop: PropTypes.number.isRequired,
  paddingBottom: PropTypes.number.isRequired,
  paddingLeft: PropTypes.number.isRequired,
  paddingRight: PropTypes.number.isRequired,
  paddingTop: PropTypes.number.isRequired,
  metaTracks: PropTypes.array,
  modal: PropTypes.object,
  mouseTool: PropTypes.string,
  onCloseTrack: PropTypes.func,
  onChangeTrackData: PropTypes.func,
  onChangeTrackType: PropTypes.func,
  onDataDomainChanged: PropTypes.func,
  onLockValueScale: PropTypes.func,
  onMouseMoveZoom: PropTypes.func,
  onNewTilesLoaded: PropTypes.func,
  onNoTrackAdded: PropTypes.func,
  onRangeSelection: PropTypes.func.isRequired,
  onScalesChanged: PropTypes.func,
  onTrackOptionsChanged: PropTypes.func,
  onTrackPositionChosen: PropTypes.func,
  onTracksAdded: PropTypes.func,
  onUnlockValueScale: PropTypes.func,
  onValueScaleChanged: PropTypes.func,
  onResizeTrack: PropTypes.func,
  overlays: PropTypes.array,
  openModal: PropTypes.func,
  pixiRenderer: PropTypes.object,
  pixiStage: PropTypes.object,
  pluginTracks: PropTypes.object,
  pubSub: PropTypes.object.isRequired,
  rangeSelection1dSize: PropTypes.array,
  rangeSelectionToInt: PropTypes.bool,
  registerDraggingChangedListener: PropTypes.func,
  removeDraggingChangedListener: PropTypes.func,
  setCentersFunction: PropTypes.func,
  svgElement: PropTypes.object,
  theme: PropTypes.symbol.isRequired,
  tracks: PropTypes.object,
  trackSourceServers: PropTypes.array,
  uid: PropTypes.string,
  viewOptions: PropTypes.object,
  xDomainLimits: PropTypes.array,
  yDomainLimits: PropTypes.array,
  zoomable: PropTypes.bool,
  zoomLimits: PropTypes.array,
  zoomToDataExtentOnInit: PropTypes.func
};
const TiledPlot$1 = withPubSub(withModal(withTheme(TiledPlot)));
var prismCore = { exports: {} };
var hasRequiredPrismCore;
function requirePrismCore() {
  if (hasRequiredPrismCore) return prismCore.exports;
  hasRequiredPrismCore = 1;
  (function(module2) {
    var _self = typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self : {};
    var Prism2 = (function(_self2) {
      var lang2 = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
      var uniqueId = 0;
      var plainTextGrammar = {};
      var _ = {
        /**
         * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
         * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
         * additional languages or plugins yourself.
         *
         * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
         *
         * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.manual = true;
         * // add a new <script> to load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        manual: _self2.Prism && _self2.Prism.manual,
        /**
         * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
         * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
         * own worker, you don't want it to do this.
         *
         * By setting this value to `true`, Prism will not add its own listeners to the worker.
         *
         * You obviously have to change this value before Prism executes. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.disableWorkerMessageHandler = true;
         * // Load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        disableWorkerMessageHandler: _self2.Prism && _self2.Prism.disableWorkerMessageHandler,
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function encode2(tokens) {
            if (tokens instanceof Token) {
              return new Token(tokens.type, encode2(tokens.content), tokens.alias);
            } else if (Array.isArray(tokens)) {
              return tokens.map(encode2);
            } else {
              return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            }
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(o) {
            return Object.prototype.toString.call(o).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(obj) {
            if (!obj["__id"]) {
              Object.defineProperty(obj, "__id", {
                value: ++uniqueId
              });
            }
            return obj["__id"];
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function deepClone(o, visited) {
            visited = visited || {};
            var clone2;
            var id2;
            switch (_.util.type(o)) {
              case "Object":
                id2 = _.util.objId(o);
                if (visited[id2]) {
                  return visited[id2];
                }
                clone2 = /** @type {Record<string, any>} */
                {};
                visited[id2] = clone2;
                for (var key in o) {
                  if (o.hasOwnProperty(key)) {
                    clone2[key] = deepClone(o[key], visited);
                  }
                }
                return (
                  /** @type {any} */
                  clone2
                );
              case "Array":
                id2 = _.util.objId(o);
                if (visited[id2]) {
                  return visited[id2];
                }
                clone2 = [];
                visited[id2] = clone2;
                o.forEach(function(v, i) {
                  clone2[i] = deepClone(v, visited);
                });
                return (
                  /** @type {any} */
                  clone2
                );
              default:
                return o;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(element) {
            while (element) {
              var m = lang2.exec(element.className);
              if (m) {
                return m[1].toLowerCase();
              }
              element = element.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(element, language) {
            element.className = element.className.replace(RegExp(lang2, "gi"), "");
            element.classList.add("language-" + language);
          },
          /**
           * Returns the script element that is currently executing.
           *
           * This does __not__ work for line script element.
           *
           * @returns {HTMLScriptElement | null}
           */
          currentScript: function() {
            if (typeof document === "undefined") {
              return null;
            }
            if (document.currentScript && document.currentScript.tagName === "SCRIPT" && 1 < 2) {
              return (
                /** @type {any} */
                document.currentScript
              );
            }
            try {
              throw new Error();
            } catch (err) {
              var src2 = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
              if (src2) {
                var scripts = document.getElementsByTagName("script");
                for (var i in scripts) {
                  if (scripts[i].src == src2) {
                    return scripts[i];
                  }
                }
              }
              return null;
            }
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(element, className, defaultActivation) {
            var no = "no-" + className;
            while (element) {
              var classList2 = element.classList;
              if (classList2.contains(className)) {
                return true;
              }
              if (classList2.contains(no)) {
                return false;
              }
              element = element.parentElement;
            }
            return !!defaultActivation;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: plainTextGrammar,
          plaintext: plainTextGrammar,
          text: plainTextGrammar,
          txt: plainTextGrammar,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(id2, redef) {
            var lang22 = _.util.clone(_.languages[id2]);
            for (var key in redef) {
              lang22[key] = redef[key];
            }
            return lang22;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(inside, before, insert, root2) {
            root2 = root2 || /** @type {any} */
            _.languages;
            var grammar2 = root2[inside];
            var ret = {};
            for (var token in grammar2) {
              if (grammar2.hasOwnProperty(token)) {
                if (token == before) {
                  for (var newToken in insert) {
                    if (insert.hasOwnProperty(newToken)) {
                      ret[newToken] = insert[newToken];
                    }
                  }
                }
                if (!insert.hasOwnProperty(token)) {
                  ret[token] = grammar2[token];
                }
              }
            }
            var old = root2[inside];
            root2[inside] = ret;
            _.languages.DFS(_.languages, function(key, value) {
              if (value === old && key != inside) {
                this[key] = ret;
              }
            });
            return ret;
          },
          // Traverse a language definition with Depth First Search
          DFS: function DFS(o, callback, type2, visited) {
            visited = visited || {};
            var objId = _.util.objId;
            for (var i in o) {
              if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type2 || i);
                var property2 = o[i];
                var propertyType = _.util.type(property2);
                if (propertyType === "Object" && !visited[objId(property2)]) {
                  visited[objId(property2)] = true;
                  DFS(property2, callback, null, visited);
                } else if (propertyType === "Array" && !visited[objId(property2)]) {
                  visited[objId(property2)] = true;
                  DFS(property2, callback, i, visited);
                }
              }
            }
          }
        },
        plugins: {},
        /**
         * This is the most high-level function in Prism’s API.
         * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
         * each one of them.
         *
         * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
         *
         * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
         * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
         * @memberof Prism
         * @public
         */
        highlightAll: function(async2, callback) {
          _.highlightAllUnder(document, async2, callback);
        },
        /**
         * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
         * {@link Prism.highlightElement} on each one of them.
         *
         * The following hooks will be run:
         * 1. `before-highlightall`
         * 2. `before-all-elements-highlight`
         * 3. All hooks of {@link Prism.highlightElement} for each element.
         *
         * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
         * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
         * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
         * @memberof Prism
         * @public
         */
        highlightAllUnder: function(container, async2, callback) {
          var env = {
            callback,
            container,
            selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
          };
          _.hooks.run("before-highlightall", env);
          env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
          _.hooks.run("before-all-elements-highlight", env);
          for (var i = 0, element; element = env.elements[i++]; ) {
            _.highlightElement(element, async2 === true, env.callback);
          }
        },
        /**
         * Highlights the code inside a single element.
         *
         * The following hooks will be run:
         * 1. `before-sanity-check`
         * 2. `before-highlight`
         * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
         * 4. `before-insert`
         * 5. `after-highlight`
         * 6. `complete`
         *
         * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
         * the element's language.
         *
         * @param {Element} element The element containing the code.
         * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
         * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
         * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
         * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
         *
         * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
         * asynchronous highlighting to work. You can build your own bundle on the
         * [Download page](https://prismjs.com/download.html).
         * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
         * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
         * @memberof Prism
         * @public
         */
        highlightElement: function(element, async2, callback) {
          var language = _.util.getLanguage(element);
          var grammar2 = _.languages[language];
          _.util.setLanguage(element, language);
          var parent = element.parentElement;
          if (parent && parent.nodeName.toLowerCase() === "pre") {
            _.util.setLanguage(parent, language);
          }
          var code = element.textContent;
          var env = {
            element,
            language,
            grammar: grammar2,
            code
          };
          function insertHighlightedCode(highlightedCode) {
            env.highlightedCode = highlightedCode;
            _.hooks.run("before-insert", env);
            env.element.innerHTML = env.highlightedCode;
            _.hooks.run("after-highlight", env);
            _.hooks.run("complete", env);
            callback && callback.call(env.element);
          }
          _.hooks.run("before-sanity-check", env);
          parent = env.element.parentElement;
          if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) {
            parent.setAttribute("tabindex", "0");
          }
          if (!env.code) {
            _.hooks.run("complete", env);
            callback && callback.call(env.element);
            return;
          }
          _.hooks.run("before-highlight", env);
          if (!env.grammar) {
            insertHighlightedCode(_.util.encode(env.code));
            return;
          }
          if (async2 && _self2.Worker) {
            var worker = new Worker(_.filename);
            worker.onmessage = function(evt) {
              insertHighlightedCode(evt.data);
            };
            worker.postMessage(JSON.stringify({
              language: env.language,
              code: env.code,
              immediateClose: true
            }));
          } else {
            insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
          }
        },
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(text2, grammar2, language) {
          var env = {
            code: text2,
            grammar: grammar2,
            language
          };
          _.hooks.run("before-tokenize", env);
          if (!env.grammar) {
            throw new Error('The language "' + env.language + '" has no grammar.');
          }
          env.tokens = _.tokenize(env.code, env.grammar);
          _.hooks.run("after-tokenize", env);
          return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(text2, grammar2) {
          var rest = grammar2.rest;
          if (rest) {
            for (var token in rest) {
              grammar2[token] = rest[token];
            }
            delete grammar2.rest;
          }
          var tokenList = new LinkedList();
          addAfter(tokenList, tokenList.head, text2);
          matchGrammar(text2, tokenList, grammar2, tokenList.head, 0);
          return toArray(tokenList);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(name, callback) {
            var hooks = _.hooks.all;
            hooks[name] = hooks[name] || [];
            hooks[name].push(callback);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(name, env) {
            var callbacks = _.hooks.all[name];
            if (!callbacks || !callbacks.length) {
              return;
            }
            for (var i = 0, callback; callback = callbacks[i++]; ) {
              callback(env);
            }
          }
        },
        Token
      };
      _self2.Prism = _;
      function Token(type2, content, alias, matchedStr) {
        this.type = type2;
        this.content = content;
        this.alias = alias;
        this.length = (matchedStr || "").length | 0;
      }
      Token.stringify = function stringify2(o, language) {
        if (typeof o == "string") {
          return o;
        }
        if (Array.isArray(o)) {
          var s = "";
          o.forEach(function(e) {
            s += stringify2(e, language);
          });
          return s;
        }
        var env = {
          type: o.type,
          content: stringify2(o.content, language),
          tag: "span",
          classes: ["token", o.type],
          attributes: {},
          language
        };
        var aliases2 = o.alias;
        if (aliases2) {
          if (Array.isArray(aliases2)) {
            Array.prototype.push.apply(env.classes, aliases2);
          } else {
            env.classes.push(aliases2);
          }
        }
        _.hooks.run("wrap", env);
        var attributes2 = "";
        for (var name in env.attributes) {
          attributes2 += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        }
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes2 + ">" + env.content + "</" + env.tag + ">";
      };
      function matchPattern(pattern2, pos, text2, lookbehind) {
        pattern2.lastIndex = pos;
        var match = pattern2.exec(text2);
        if (match && lookbehind && match[1]) {
          var lookbehindLength = match[1].length;
          match.index += lookbehindLength;
          match[0] = match[0].slice(lookbehindLength);
        }
        return match;
      }
      function matchGrammar(text2, tokenList, grammar2, startNode, startPos, rematch) {
        for (var token in grammar2) {
          if (!grammar2.hasOwnProperty(token) || !grammar2[token]) {
            continue;
          }
          var patterns = grammar2[token];
          patterns = Array.isArray(patterns) ? patterns : [patterns];
          for (var j = 0; j < patterns.length; ++j) {
            if (rematch && rematch.cause == token + "," + j) {
              return;
            }
            var patternObj = patterns[j];
            var inside = patternObj.inside;
            var lookbehind = !!patternObj.lookbehind;
            var greedy = !!patternObj.greedy;
            var alias = patternObj.alias;
            if (greedy && !patternObj.pattern.global) {
              var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
              patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
            }
            var pattern2 = patternObj.pattern || patternObj;
            for (var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next) {
              if (rematch && pos >= rematch.reach) {
                break;
              }
              var str = currentNode.value;
              if (tokenList.length > text2.length) {
                return;
              }
              if (str instanceof Token) {
                continue;
              }
              var removeCount = 1;
              var match;
              if (greedy) {
                match = matchPattern(pattern2, pos, text2, lookbehind);
                if (!match || match.index >= text2.length) {
                  break;
                }
                var from = match.index;
                var to = match.index + match[0].length;
                var p = pos;
                p += currentNode.value.length;
                while (from >= p) {
                  currentNode = currentNode.next;
                  p += currentNode.value.length;
                }
                p -= currentNode.value.length;
                pos = p;
                if (currentNode.value instanceof Token) {
                  continue;
                }
                for (var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next) {
                  removeCount++;
                  p += k.value.length;
                }
                removeCount--;
                str = text2.slice(pos, p);
                match.index -= pos;
              } else {
                match = matchPattern(pattern2, 0, str, lookbehind);
                if (!match) {
                  continue;
                }
              }
              var from = match.index;
              var matchStr = match[0];
              var before = str.slice(0, from);
              var after = str.slice(from + matchStr.length);
              var reach = pos + str.length;
              if (rematch && reach > rematch.reach) {
                rematch.reach = reach;
              }
              var removeFrom = currentNode.prev;
              if (before) {
                removeFrom = addAfter(tokenList, removeFrom, before);
                pos += before.length;
              }
              removeRange(tokenList, removeFrom, removeCount);
              var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
              currentNode = addAfter(tokenList, removeFrom, wrapped);
              if (after) {
                addAfter(tokenList, currentNode, after);
              }
              if (removeCount > 1) {
                var nestedRematch = {
                  cause: token + "," + j,
                  reach
                };
                matchGrammar(text2, tokenList, grammar2, currentNode.prev, pos, nestedRematch);
                if (rematch && nestedRematch.reach > rematch.reach) {
                  rematch.reach = nestedRematch.reach;
                }
              }
            }
          }
        }
      }
      function LinkedList() {
        var head = {
          value: null,
          prev: null,
          next: null
        };
        var tail = {
          value: null,
          prev: head,
          next: null
        };
        head.next = tail;
        this.head = head;
        this.tail = tail;
        this.length = 0;
      }
      function addAfter(list2, node2, value) {
        var next = node2.next;
        var newNode = {
          value,
          prev: node2,
          next
        };
        node2.next = newNode;
        next.prev = newNode;
        list2.length++;
        return newNode;
      }
      function removeRange(list2, node2, count2) {
        var next = node2.next;
        for (var i = 0; i < count2 && next !== list2.tail; i++) {
          next = next.next;
        }
        node2.next = next;
        next.prev = node2;
        list2.length -= i;
      }
      function toArray(list2) {
        var array2 = [];
        var node2 = list2.head.next;
        while (node2 !== list2.tail) {
          array2.push(node2.value);
          node2 = node2.next;
        }
        return array2;
      }
      if (!_self2.document) {
        if (!_self2.addEventListener) {
          return _;
        }
        if (!_.disableWorkerMessageHandler) {
          _self2.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang22 = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self2.postMessage(_.highlight(code, _.languages[lang22], lang22));
            if (immediateClose) {
              _self2.close();
            }
          }, false);
        }
        return _;
      }
      var script = _.util.currentScript();
      if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) {
          _.manual = true;
        }
      }
      function highlightAutomaticallyCallback() {
        if (!_.manual) {
          _.highlightAll();
        }
      }
      if (!_.manual) {
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) {
          document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        } else {
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(highlightAutomaticallyCallback);
          } else {
            window.setTimeout(highlightAutomaticallyCallback, 16);
          }
        }
      }
      return _;
    })(_self);
    if (module2.exports) {
      module2.exports = Prism2;
    }
    if (typeof globalThis !== "undefined") {
      globalThis.Prism = Prism2;
    }
  })(prismCore);
  return prismCore.exports;
}
var prismCoreExports = requirePrismCore();
var lib = {};
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1;
  var __extends2 = lib && lib.__extends || /* @__PURE__ */ (function() {
    var extendStatics2 = function(d, b) {
      extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
      };
      return extendStatics2(d, b);
    };
    return function(d, b) {
      if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics2(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  })();
  var __assign2 = lib && lib.__assign || function() {
    __assign2 = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign2.apply(this, arguments);
  };
  var __createBinding2 = lib && lib.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function() {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = lib && lib.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = lib && lib.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule) return mod2;
    var result = {};
    if (mod2 != null) {
      for (var k in mod2) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k)) __createBinding2(result, mod2, k);
    }
    __setModuleDefault2(result, mod2);
    return result;
  };
  var __rest2 = lib && lib.__rest || function(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  Object.defineProperty(lib, "__esModule", {
    value: true
  });
  var React2 = __importStar2(React__default);
  var KEYCODE_ENTER = 13;
  var KEYCODE_TAB = 9;
  var KEYCODE_BACKSPACE = 8;
  var KEYCODE_Y = 89;
  var KEYCODE_Z = 90;
  var KEYCODE_M = 77;
  var KEYCODE_PARENS = 57;
  var KEYCODE_BRACKETS = 219;
  var KEYCODE_QUOTE = 222;
  var KEYCODE_BACK_QUOTE = 192;
  var KEYCODE_ESCAPE = 27;
  var HISTORY_LIMIT = 100;
  var HISTORY_TIME_GAP = 3e3;
  var isWindows = typeof window !== "undefined" && "navigator" in window && /Win/i.test(navigator.platform);
  var isMacLike = typeof window !== "undefined" && "navigator" in window && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  var className = "npm__react-simple-code-editor__textarea";
  var cssText = (
    /* CSS */
    "\n/**\n * Reset the text fill color so that placeholder is visible\n */\n.".concat(className, ":empty {\n  -webkit-text-fill-color: inherit !important;\n}\n\n/**\n * Hack to apply on some CSS on IE10 and IE11\n */\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /**\n    * IE doesn't support '-webkit-text-fill-color'\n    * So we use 'color: transparent' to make the text transparent on IE\n    * Unlike other browsers, it doesn't affect caret color in IE\n    */\n  .").concat(className, " {\n    color: transparent !important;\n  }\n\n  .").concat(className, "::selection {\n    background-color: #accef7 !important;\n    color: transparent !important;\n  }\n}\n")
  );
  var Editor2 = (
    /** @class */
    (function(_super) {
      __extends2(Editor3, _super);
      function Editor3() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
          capture: true
        };
        _this._recordCurrentState = function() {
          var input = _this._input;
          if (!input) return;
          var value = input.value, selectionStart = input.selectionStart, selectionEnd = input.selectionEnd;
          _this._recordChange({
            value,
            selectionStart,
            selectionEnd
          });
        };
        _this._getLines = function(text2, position) {
          return text2.substring(0, position).split("\n");
        };
        _this._recordChange = function(record, overwrite) {
          var _a, _b, _c;
          if (overwrite === void 0) {
            overwrite = false;
          }
          var _d = _this._history, stack = _d.stack, offset = _d.offset;
          if (stack.length && offset > -1) {
            _this._history.stack = stack.slice(0, offset + 1);
            var count2 = _this._history.stack.length;
            if (count2 > HISTORY_LIMIT) {
              var extras = count2 - HISTORY_LIMIT;
              _this._history.stack = stack.slice(extras, count2);
              _this._history.offset = Math.max(_this._history.offset - extras, 0);
            }
          }
          var timestamp = Date.now();
          if (overwrite) {
            var last = _this._history.stack[_this._history.offset];
            if (last && timestamp - last.timestamp < HISTORY_TIME_GAP) {
              var re2 = /[^a-z0-9]([a-z0-9]+)$/i;
              var previous = (_a = _this._getLines(last.value, last.selectionStart).pop()) === null || _a === void 0 ? void 0 : _a.match(re2);
              var current = (_b = _this._getLines(record.value, record.selectionStart).pop()) === null || _b === void 0 ? void 0 : _b.match(re2);
              if ((previous === null || previous === void 0 ? void 0 : previous[1]) && ((_c = current === null || current === void 0 ? void 0 : current[1]) === null || _c === void 0 ? void 0 : _c.startsWith(previous[1]))) {
                _this._history.stack[_this._history.offset] = __assign2(__assign2({}, record), {
                  timestamp
                });
                return;
              }
            }
          }
          _this._history.stack.push(__assign2(__assign2({}, record), {
            timestamp
          }));
          _this._history.offset++;
        };
        _this._updateInput = function(record) {
          var input = _this._input;
          if (!input) return;
          input.value = record.value;
          input.selectionStart = record.selectionStart;
          input.selectionEnd = record.selectionEnd;
          _this.props.onValueChange(record.value);
        };
        _this._applyEdits = function(record) {
          var input = _this._input;
          var last = _this._history.stack[_this._history.offset];
          if (last && input) {
            _this._history.stack[_this._history.offset] = __assign2(__assign2({}, last), {
              selectionStart: input.selectionStart,
              selectionEnd: input.selectionEnd
            });
          }
          _this._recordChange(record);
          _this._updateInput(record);
        };
        _this._undoEdit = function() {
          var _a = _this._history, stack = _a.stack, offset = _a.offset;
          var record = stack[offset - 1];
          if (record) {
            _this._updateInput(record);
            _this._history.offset = Math.max(offset - 1, 0);
          }
        };
        _this._redoEdit = function() {
          var _a = _this._history, stack = _a.stack, offset = _a.offset;
          var record = stack[offset + 1];
          if (record) {
            _this._updateInput(record);
            _this._history.offset = Math.min(offset + 1, stack.length - 1);
          }
        };
        _this._handleKeyDown = function(e) {
          var _a = _this.props, tabSize = _a.tabSize, insertSpaces = _a.insertSpaces, ignoreTabKey = _a.ignoreTabKey, onKeyDown = _a.onKeyDown;
          if (onKeyDown) {
            onKeyDown(e);
            if (e.defaultPrevented) {
              return;
            }
          }
          if (e.keyCode === KEYCODE_ESCAPE) {
            e.currentTarget.blur();
          }
          var _b = e.currentTarget, value = _b.value, selectionStart = _b.selectionStart, selectionEnd = _b.selectionEnd;
          var tabCharacter = (insertSpaces ? " " : "	").repeat(tabSize);
          if (e.keyCode === KEYCODE_TAB && !ignoreTabKey && _this.state.capture) {
            e.preventDefault();
            if (e.shiftKey) {
              var linesBeforeCaret = _this._getLines(value, selectionStart);
              var startLine_1 = linesBeforeCaret.length - 1;
              var endLine_1 = _this._getLines(value, selectionEnd).length - 1;
              var nextValue = value.split("\n").map(function(line2, i) {
                if (i >= startLine_1 && i <= endLine_1 && line2.startsWith(tabCharacter)) {
                  return line2.substring(tabCharacter.length);
                }
                return line2;
              }).join("\n");
              if (value !== nextValue) {
                var startLineText = linesBeforeCaret[startLine_1];
                _this._applyEdits({
                  value: nextValue,
                  // Move the start cursor if first line in selection was modified
                  // It was modified only if it started with a tab
                  selectionStart: (startLineText === null || startLineText === void 0 ? void 0 : startLineText.startsWith(tabCharacter)) ? selectionStart - tabCharacter.length : selectionStart,
                  // Move the end cursor by total number of characters removed
                  selectionEnd: selectionEnd - (value.length - nextValue.length)
                });
              }
            } else if (selectionStart !== selectionEnd) {
              var linesBeforeCaret = _this._getLines(value, selectionStart);
              var startLine_2 = linesBeforeCaret.length - 1;
              var endLine_2 = _this._getLines(value, selectionEnd).length - 1;
              var startLineText = linesBeforeCaret[startLine_2];
              _this._applyEdits({
                value: value.split("\n").map(function(line2, i) {
                  if (i >= startLine_2 && i <= endLine_2) {
                    return tabCharacter + line2;
                  }
                  return line2;
                }).join("\n"),
                // Move the start cursor by number of characters added in first line of selection
                // Don't move it if it there was no text before cursor
                selectionStart: startLineText && /\S/.test(startLineText) ? selectionStart + tabCharacter.length : selectionStart,
                // Move the end cursor by total number of characters added
                selectionEnd: selectionEnd + tabCharacter.length * (endLine_2 - startLine_2 + 1)
              });
            } else {
              var updatedSelection = selectionStart + tabCharacter.length;
              _this._applyEdits({
                // Insert tab character at caret
                value: value.substring(0, selectionStart) + tabCharacter + value.substring(selectionEnd),
                // Update caret position
                selectionStart: updatedSelection,
                selectionEnd: updatedSelection
              });
            }
          } else if (e.keyCode === KEYCODE_BACKSPACE) {
            var hasSelection = selectionStart !== selectionEnd;
            var textBeforeCaret = value.substring(0, selectionStart);
            if (textBeforeCaret.endsWith(tabCharacter) && !hasSelection) {
              e.preventDefault();
              var updatedSelection = selectionStart - tabCharacter.length;
              _this._applyEdits({
                // Remove tab character at caret
                value: value.substring(0, selectionStart - tabCharacter.length) + value.substring(selectionEnd),
                // Update caret position
                selectionStart: updatedSelection,
                selectionEnd: updatedSelection
              });
            }
          } else if (e.keyCode === KEYCODE_ENTER) {
            if (selectionStart === selectionEnd) {
              var line = _this._getLines(value, selectionStart).pop();
              var matches = line === null || line === void 0 ? void 0 : line.match(/^\s+/);
              if (matches === null || matches === void 0 ? void 0 : matches[0]) {
                e.preventDefault();
                var indent = "\n" + matches[0];
                var updatedSelection = selectionStart + indent.length;
                _this._applyEdits({
                  // Insert indentation character at caret
                  value: value.substring(0, selectionStart) + indent + value.substring(selectionEnd),
                  // Update caret position
                  selectionStart: updatedSelection,
                  selectionEnd: updatedSelection
                });
              }
            }
          } else if (e.keyCode === KEYCODE_PARENS || e.keyCode === KEYCODE_BRACKETS || e.keyCode === KEYCODE_QUOTE || e.keyCode === KEYCODE_BACK_QUOTE) {
            var chars = void 0;
            if (e.keyCode === KEYCODE_PARENS && e.shiftKey) {
              chars = ["(", ")"];
            } else if (e.keyCode === KEYCODE_BRACKETS) {
              if (e.shiftKey) {
                chars = ["{", "}"];
              } else {
                chars = ["[", "]"];
              }
            } else if (e.keyCode === KEYCODE_QUOTE) {
              if (e.shiftKey) {
                chars = ['"', '"'];
              } else {
                chars = ["'", "'"];
              }
            } else if (e.keyCode === KEYCODE_BACK_QUOTE && !e.shiftKey) {
              chars = ["`", "`"];
            }
            if (selectionStart !== selectionEnd && chars) {
              e.preventDefault();
              _this._applyEdits({
                value: value.substring(0, selectionStart) + chars[0] + value.substring(selectionStart, selectionEnd) + chars[1] + value.substring(selectionEnd),
                // Update caret position
                selectionStart,
                selectionEnd: selectionEnd + 2
              });
            }
          } else if ((isMacLike ? (
            // Trigger undo with ⌘+Z on Mac
            e.metaKey && e.keyCode === KEYCODE_Z
          ) : (
            // Trigger undo with Ctrl+Z on other platforms
            e.ctrlKey && e.keyCode === KEYCODE_Z
          )) && !e.shiftKey && !e.altKey) {
            e.preventDefault();
            _this._undoEdit();
          } else if ((isMacLike ? (
            // Trigger redo with ⌘+Shift+Z on Mac
            e.metaKey && e.keyCode === KEYCODE_Z && e.shiftKey
          ) : isWindows ? (
            // Trigger redo with Ctrl+Y on Windows
            e.ctrlKey && e.keyCode === KEYCODE_Y
          ) : (
            // Trigger redo with Ctrl+Shift+Z on other platforms
            e.ctrlKey && e.keyCode === KEYCODE_Z && e.shiftKey
          )) && !e.altKey) {
            e.preventDefault();
            _this._redoEdit();
          } else if (e.keyCode === KEYCODE_M && e.ctrlKey && (isMacLike ? e.shiftKey : true)) {
            e.preventDefault();
            _this.setState(function(state) {
              return {
                capture: !state.capture
              };
            });
          }
        };
        _this._handleChange = function(e) {
          var _a = e.currentTarget, value = _a.value, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
          _this._recordChange({
            value,
            selectionStart,
            selectionEnd
          }, true);
          _this.props.onValueChange(value);
        };
        _this._history = {
          stack: [],
          offset: -1
        };
        _this._input = null;
        return _this;
      }
      Editor3.prototype.componentDidMount = function() {
        this._recordCurrentState();
      };
      Object.defineProperty(Editor3.prototype, "session", {
        get: function() {
          return {
            history: this._history
          };
        },
        set: function(session) {
          this._history = session.history;
        },
        enumerable: false,
        configurable: true
      });
      Editor3.prototype.render = function() {
        var _this = this;
        var _a = this.props, value = _a.value, style = _a.style, padding = _a.padding, highlight = _a.highlight, textareaId = _a.textareaId, textareaClassName = _a.textareaClassName, autoFocus = _a.autoFocus, disabled = _a.disabled, form = _a.form, maxLength = _a.maxLength, minLength = _a.minLength, name = _a.name, placeholder = _a.placeholder, readOnly = _a.readOnly, required2 = _a.required, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyUp = _a.onKeyUp;
        _a.onKeyDown;
        _a.onValueChange;
        _a.tabSize;
        _a.insertSpaces;
        _a.ignoreTabKey;
        var preClassName = _a.preClassName, rest = __rest2(_a, ["value", "style", "padding", "highlight", "textareaId", "textareaClassName", "autoFocus", "disabled", "form", "maxLength", "minLength", "name", "placeholder", "readOnly", "required", "onClick", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onValueChange", "tabSize", "insertSpaces", "ignoreTabKey", "preClassName"]);
        var contentStyle = {
          paddingTop: typeof padding === "object" ? padding.top : padding,
          paddingRight: typeof padding === "object" ? padding.right : padding,
          paddingBottom: typeof padding === "object" ? padding.bottom : padding,
          paddingLeft: typeof padding === "object" ? padding.left : padding
        };
        var highlighted = highlight(value);
        return React2.createElement("div", __assign2({}, rest, {
          style: __assign2(__assign2({}, styles2.container), style)
        }), React2.createElement("pre", __assign2({
          className: preClassName,
          "aria-hidden": "true",
          style: __assign2(__assign2(__assign2({}, styles2.editor), styles2.highlight), contentStyle)
        }, typeof highlighted === "string" ? {
          dangerouslySetInnerHTML: {
            __html: highlighted + "<br />"
          }
        } : {
          children: highlighted
        })), React2.createElement("textarea", {
          ref: function(c) {
            return _this._input = c;
          },
          style: __assign2(__assign2(__assign2({}, styles2.editor), styles2.textarea), contentStyle),
          className: className + (textareaClassName ? " ".concat(textareaClassName) : ""),
          id: textareaId,
          value,
          onChange: this._handleChange,
          onKeyDown: this._handleKeyDown,
          onClick,
          onKeyUp,
          onFocus,
          onBlur,
          disabled,
          form,
          maxLength,
          minLength,
          name,
          placeholder,
          readOnly,
          required: required2,
          autoFocus,
          autoCapitalize: "off",
          autoComplete: "off",
          autoCorrect: "off",
          spellCheck: false,
          "data-gramm": false
        }), React2.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: cssText
          }
        }));
      };
      Editor3.defaultProps = {
        tabSize: 2,
        insertSpaces: true,
        ignoreTabKey: false,
        padding: 0
      };
      return Editor3;
    })(React2.Component)
  );
  lib.default = Editor2;
  var styles2 = {
    container: {
      position: "relative",
      textAlign: "left",
      boxSizing: "border-box",
      padding: 0,
      overflow: "hidden"
    },
    textarea: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      width: "100%",
      resize: "none",
      color: "inherit",
      overflow: "hidden",
      MozOsxFontSmoothing: "grayscale",
      WebkitFontSmoothing: "antialiased",
      WebkitTextFillColor: "transparent"
    },
    highlight: {
      position: "relative",
      pointerEvents: "none"
    },
    editor: {
      margin: 0,
      border: 0,
      background: "none",
      boxSizing: "inherit",
      display: "inherit",
      fontFamily: "inherit",
      fontSize: "inherit",
      fontStyle: "inherit",
      fontVariantLigatures: "inherit",
      fontWeight: "inherit",
      letterSpacing: "inherit",
      lineHeight: "inherit",
      tabSize: "inherit",
      textIndent: "inherit",
      textRendering: "inherit",
      textTransform: "inherit",
      whiteSpace: "pre-wrap",
      wordBreak: "keep-all",
      overflowWrap: "break-word"
    }
  };
  return lib;
}
var libExports = requireLib();
const Editor = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
Prism.languages.json = {
  "property": {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    lookbehind: true,
    greedy: true
  },
  "string": {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
    lookbehind: true,
    greedy: true
  },
  "comment": {
    pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: true
  },
  "number": /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
  "punctuation": /[{}[\],]/,
  "operator": /:/,
  "boolean": /\b(?:false|true)\b/,
  "null": {
    pattern: /\bnull\b/,
    alias: "keyword"
  }
};
Prism.languages.webmanifest = Prism.languages.json;
var uri_all$1 = { exports: {} };
var uri_all = uri_all$1.exports;
var hasRequiredUri_all;
function requireUri_all() {
  if (hasRequiredUri_all) return uri_all$1.exports;
  hasRequiredUri_all = 1;
  (function(module2, exports2) {
    (function(global, factory) {
      factory(exports2);
    })(uri_all, function(exports22) {
      function merge2() {
        for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
          sets[_key] = arguments[_key];
        }
        if (sets.length > 1) {
          sets[0] = sets[0].slice(0, -1);
          var xl = sets.length - 1;
          for (var x = 1; x < xl; ++x) {
            sets[x] = sets[x].slice(1, -1);
          }
          sets[xl] = sets[xl].slice(1);
          return sets.join("");
        } else {
          return sets[0];
        }
      }
      function subexp(str) {
        return "(?:" + str + ")";
      }
      function typeOf(o) {
        return o === void 0 ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
      }
      function toUpperCase(str) {
        return str.toUpperCase();
      }
      function toArray(obj) {
        return obj !== void 0 && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
      }
      function assign(target2, source) {
        var obj = target2;
        if (source) {
          for (var key in source) {
            obj[key] = source[key];
          }
        }
        return obj;
      }
      function buildExps(isIRI2) {
        var ALPHA$$ = "[A-Za-z]", DIGIT$$ = "[0-9]", HEXDIG$$2 = merge2(DIGIT$$, "[A-Fa-f]"), PCT_ENCODED$2 = subexp(subexp("%[EFef]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%" + HEXDIG$$2 + HEXDIG$$2)), GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge2(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI2 ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", IPRIVATE$$ = isIRI2 ? "[\\uE000-\\uF8FF]" : "[]", UNRESERVED$$2 = merge2(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$);
        subexp(ALPHA$$ + merge2(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*");
        subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]")) + "*");
        var DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$2 + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$2 + "|" + PCT_ENCODED$2) + "+");
        subexp("[vV]" + HEXDIG$$2 + "+\\." + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]") + "+");
        subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$)) + "*");
        var PCHAR$ = subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@]"));
        subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\@]")) + "+");
        subexp(subexp(PCHAR$ + "|" + merge2("[\\/\\?]", IPRIVATE$$)) + "*");
        return {
          NOT_SCHEME: new RegExp(merge2("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
          NOT_USERINFO: new RegExp(merge2("[^\\%\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_HOST: new RegExp(merge2("[^\\%\\[\\]\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_PATH: new RegExp(merge2("[^\\%\\/\\:\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_PATH_NOSCHEME: new RegExp(merge2("[^\\%\\/\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_QUERY: new RegExp(merge2("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
          NOT_FRAGMENT: new RegExp(merge2("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
          ESCAPE: new RegExp(merge2("[^]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          UNRESERVED: new RegExp(UNRESERVED$$2, "g"),
          OTHER_CHARS: new RegExp(merge2("[^\\%]", UNRESERVED$$2, RESERVED$$), "g"),
          PCT_ENCODED: new RegExp(PCT_ENCODED$2, "g"),
          IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
          IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$2 + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$")
          //RFC 6874, with relaxed parsing rules
        };
      }
      var URI_PROTOCOL = buildExps(false);
      var IRI_PROTOCOL = buildExps(true);
      var slicedToArray = /* @__PURE__ */ (function() {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = void 0;
          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);
              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }
          return _arr;
        }
        return function(arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      })();
      var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
          return arr2;
        } else {
          return Array.from(arr);
        }
      };
      var maxInt = 2147483647;
      var base = 36;
      var tMin = 1;
      var tMax = 26;
      var skew = 38;
      var damp = 700;
      var initialBias = 72;
      var initialN = 128;
      var delimiter = "-";
      var regexPunycode = /^xn--/;
      var regexNonASCII = /[^\0-\x7E]/;
      var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
      var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      };
      var baseMinusTMin = base - tMin;
      var floor2 = Math.floor;
      var stringFromCharCode = String.fromCharCode;
      function error$1(type2) {
        throw new RangeError(errors[type2]);
      }
      function map2(array2, fn) {
        var result = [];
        var length2 = array2.length;
        while (length2--) {
          result[length2] = fn(array2[length2]);
        }
        return result;
      }
      function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
          result = parts[0] + "@";
          string = parts[1];
        }
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map2(labels, fn).join(".");
        return result + encoded;
      }
      function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length2 = string.length;
        while (counter < length2) {
          var value = string.charCodeAt(counter++);
          if (value >= 55296 && value <= 56319 && counter < length2) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 64512) == 56320) {
              output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
            } else {
              output.push(value);
              counter--;
            }
          } else {
            output.push(value);
          }
        }
        return output;
      }
      var ucs2encode = function ucs2encode2(array2) {
        return String.fromCodePoint.apply(String, toConsumableArray(array2));
      };
      var basicToDigit = function basicToDigit2(codePoint) {
        if (codePoint - 48 < 10) {
          return codePoint - 22;
        }
        if (codePoint - 65 < 26) {
          return codePoint - 65;
        }
        if (codePoint - 97 < 26) {
          return codePoint - 97;
        }
        return base;
      };
      var digitToBasic = function digitToBasic2(digit, flag) {
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
      };
      var adapt = function adapt2(delta2, numPoints, firstTime) {
        var k = 0;
        delta2 = firstTime ? floor2(delta2 / damp) : delta2 >> 1;
        delta2 += floor2(delta2 / numPoints);
        for (
          ;
          /* no initialization */
          delta2 > baseMinusTMin * tMax >> 1;
          k += base
        ) {
          delta2 = floor2(delta2 / baseMinusTMin);
        }
        return floor2(k + (baseMinusTMin + 1) * delta2 / (delta2 + skew));
      };
      var decode2 = function decode22(input) {
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) {
          basic = 0;
        }
        for (var j = 0; j < basic; ++j) {
          if (input.charCodeAt(j) >= 128) {
            error$1("not-basic");
          }
          output.push(input.charCodeAt(j));
        }
        for (var index2 = basic > 0 ? basic + 1 : 0; index2 < inputLength; ) {
          var oldi = i;
          for (
            var w = 1, k = base;
            ;
            /* no condition */
            k += base
          ) {
            if (index2 >= inputLength) {
              error$1("invalid-input");
            }
            var digit = basicToDigit(input.charCodeAt(index2++));
            if (digit >= base || digit > floor2((maxInt - i) / w)) {
              error$1("overflow");
            }
            i += digit * w;
            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (digit < t) {
              break;
            }
            var baseMinusT = base - t;
            if (w > floor2(maxInt / baseMinusT)) {
              error$1("overflow");
            }
            w *= baseMinusT;
          }
          var out = output.length + 1;
          bias = adapt(i - oldi, out, oldi == 0);
          if (floor2(i / out) > maxInt - n) {
            error$1("overflow");
          }
          n += floor2(i / out);
          i %= out;
          output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
      };
      var encode2 = function encode22(input) {
        var output = [];
        input = ucs2decode(input);
        var inputLength = input.length;
        var n = initialN;
        var delta2 = 0;
        var bias = initialBias;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = void 0;
        try {
          for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _currentValue2 = _step.value;
            if (_currentValue2 < 128) {
              output.push(stringFromCharCode(_currentValue2));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        if (basicLength) {
          output.push(delimiter);
        }
        while (handledCPCount < inputLength) {
          var m = maxInt;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = void 0;
          try {
            for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var currentValue = _step2.value;
              if (currentValue >= n && currentValue < m) {
                m = currentValue;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
          var handledCPCountPlusOne = handledCPCount + 1;
          if (m - n > floor2((maxInt - delta2) / handledCPCountPlusOne)) {
            error$1("overflow");
          }
          delta2 += (m - n) * handledCPCountPlusOne;
          n = m;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = void 0;
          try {
            for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _currentValue = _step3.value;
              if (_currentValue < n && ++delta2 > maxInt) {
                error$1("overflow");
              }
              if (_currentValue == n) {
                var q2 = delta2;
                for (
                  var k = base;
                  ;
                  /* no condition */
                  k += base
                ) {
                  var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                  if (q2 < t) {
                    break;
                  }
                  var qMinusT = q2 - t;
                  var baseMinusT = base - t;
                  output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                  q2 = floor2(qMinusT / baseMinusT);
                }
                output.push(stringFromCharCode(digitToBasic(q2, 0)));
                bias = adapt(delta2, handledCPCountPlusOne, handledCPCount == basicLength);
                delta2 = 0;
                ++handledCPCount;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
          ++delta2;
          ++n;
        }
        return output.join("");
      };
      var toUnicode = function toUnicode2(input) {
        return mapDomain(input, function(string) {
          return regexPunycode.test(string) ? decode2(string.slice(4).toLowerCase()) : string;
        });
      };
      var toASCII = function toASCII2(input) {
        return mapDomain(input, function(string) {
          return regexNonASCII.test(string) ? "xn--" + encode2(string) : string;
        });
      };
      var punycode = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        "version": "2.1.0",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        "ucs2": {
          "decode": ucs2decode,
          "encode": ucs2encode
        },
        "decode": decode2,
        "encode": encode2,
        "toASCII": toASCII,
        "toUnicode": toUnicode
      };
      var SCHEMES = {};
      function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
      }
      function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while (i < il) {
          var c = parseInt(str.substr(i + 1, 2), 16);
          if (c < 128) {
            newStr += String.fromCharCode(c);
            i += 3;
          } else if (c >= 194 && c < 224) {
            if (il - i >= 6) {
              var c2 = parseInt(str.substr(i + 4, 2), 16);
              newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
            } else {
              newStr += str.substr(i, 6);
            }
            i += 6;
          } else if (c >= 224) {
            if (il - i >= 9) {
              var _c = parseInt(str.substr(i + 4, 2), 16);
              var c3 = parseInt(str.substr(i + 7, 2), 16);
              newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
            } else {
              newStr += str.substr(i, 9);
            }
            i += 9;
          } else {
            newStr += str.substr(i, 3);
            i += 3;
          }
        }
        return newStr;
      }
      function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved2(str) {
          var decStr = pctDecChars(str);
          return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== void 0) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== void 0) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== void 0) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== void 0) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== void 0) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
      }
      function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
      }
      function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) {
          return address.split(".").map(_stripLeadingZeros).join(".");
        } else {
          return host;
        }
      }
      function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
          var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
          var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
          var lastFields = last.split(":").map(_stripLeadingZeros);
          var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
          var fieldCount = isLastFieldIPv4Address ? 7 : 8;
          var lastFieldsStart = lastFields.length - fieldCount;
          var fields = Array(fieldCount);
          for (var x = 0; x < fieldCount; ++x) {
            fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
          }
          if (isLastFieldIPv4Address) {
            fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
          }
          var allZeroFields = fields.reduce(function(acc, field, index2) {
            if (!field || field === "0") {
              var lastLongest = acc[acc.length - 1];
              if (lastLongest && lastLongest.index + lastLongest.length === index2) {
                lastLongest.length++;
              } else {
                acc.push({
                  index: index2,
                  length: 1
                });
              }
            }
            return acc;
          }, []);
          var longestZeroFields = allZeroFields.sort(function(a, b) {
            return b.length - a.length;
          })[0];
          var newHost = void 0;
          if (longestZeroFields && longestZeroFields.length > 1) {
            var newFirst = fields.slice(0, longestZeroFields.index);
            var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
            newHost = newFirst.join(":") + "::" + newLast.join(":");
          } else {
            newHost = fields.join(":");
          }
          if (zone) {
            newHost += "%" + zone;
          }
          return newHost;
        } else {
          return host;
        }
      }
      var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
      var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === void 0;
      function parse2(uriString) {
        var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var components = {};
        var protocol = options2.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options2.reference === "suffix") uriString = (options2.scheme ? options2.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
          if (NO_MATCH_IS_UNDEFINED) {
            components.scheme = matches[1];
            components.userinfo = matches[3];
            components.host = matches[4];
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = matches[7];
            components.fragment = matches[8];
            if (isNaN(components.port)) {
              components.port = matches[5];
            }
          } else {
            components.scheme = matches[1] || void 0;
            components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : void 0;
            components.host = uriString.indexOf("//") !== -1 ? matches[4] : void 0;
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = uriString.indexOf("?") !== -1 ? matches[7] : void 0;
            components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : void 0;
            if (isNaN(components.port)) {
              components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : void 0;
            }
          }
          if (components.host) {
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
          }
          if (components.scheme === void 0 && components.userinfo === void 0 && components.host === void 0 && components.port === void 0 && !components.path && components.query === void 0) {
            components.reference = "same-document";
          } else if (components.scheme === void 0) {
            components.reference = "relative";
          } else if (components.fragment === void 0) {
            components.reference = "absolute";
          } else {
            components.reference = "uri";
          }
          if (options2.reference && options2.reference !== "suffix" && options2.reference !== components.reference) {
            components.error = components.error || "URI is not a " + options2.reference + " reference.";
          }
          var schemeHandler = SCHEMES[(options2.scheme || components.scheme || "").toLowerCase()];
          if (!options2.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            if (components.host && (options2.domainHost || schemeHandler && schemeHandler.domainHost)) {
              try {
                components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
              } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
              }
            }
            _normalizeComponentEncoding(components, URI_PROTOCOL);
          } else {
            _normalizeComponentEncoding(components, protocol);
          }
          if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(components, options2);
          }
        } else {
          components.error = components.error || "URI can not be parsed.";
        }
        return components;
      }
      function _recomposeAuthority(components, options2) {
        var protocol = options2.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== void 0) {
          uriTokens.push(components.userinfo);
          uriTokens.push("@");
        }
        if (components.host !== void 0) {
          uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
          }));
        }
        if (typeof components.port === "number" || typeof components.port === "string") {
          uriTokens.push(":");
          uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : void 0;
      }
      var RDS1 = /^\.\.?\//;
      var RDS2 = /^\/\.(\/|$)/;
      var RDS3 = /^\/\.\.(\/|$)/;
      var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
      function removeDotSegments(input) {
        var output = [];
        while (input.length) {
          if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
          } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
          } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output.pop();
          } else if (input === "." || input === "..") {
            input = "";
          } else {
            var im = input.match(RDS5);
            if (im) {
              var s = im[0];
              input = input.slice(s.length);
              output.push(s);
            } else {
              throw new Error("Unexpected dot segment condition");
            }
          }
        }
        return output.join("");
      }
      function serialize(components) {
        var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var protocol = options2.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        var schemeHandler = SCHEMES[(options2.scheme || components.scheme || "").toLowerCase()];
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options2);
        if (components.host) {
          if (protocol.IPV6ADDRESS.test(components.host)) ;
          else if (options2.domainHost || schemeHandler && schemeHandler.domainHost) {
            try {
              components.host = !options2.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
              components.error = components.error || "Host's domain name can not be converted to " + (!options2.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
          }
        }
        _normalizeComponentEncoding(components, protocol);
        if (options2.reference !== "suffix" && components.scheme) {
          uriTokens.push(components.scheme);
          uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options2);
        if (authority !== void 0) {
          if (options2.reference !== "suffix") {
            uriTokens.push("//");
          }
          uriTokens.push(authority);
          if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
          }
        }
        if (components.path !== void 0) {
          var s = components.path;
          if (!options2.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s = removeDotSegments(s);
          }
          if (authority === void 0) {
            s = s.replace(/^\/\//, "/%2F");
          }
          uriTokens.push(s);
        }
        if (components.query !== void 0) {
          uriTokens.push("?");
          uriTokens.push(components.query);
        }
        if (components.fragment !== void 0) {
          uriTokens.push("#");
          uriTokens.push(components.fragment);
        }
        return uriTokens.join("");
      }
      function resolveComponents(base2, relative) {
        var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target2 = {};
        if (!skipNormalization) {
          base2 = parse2(serialize(base2, options2), options2);
          relative = parse2(serialize(relative, options2), options2);
        }
        options2 = options2 || {};
        if (!options2.tolerant && relative.scheme) {
          target2.scheme = relative.scheme;
          target2.userinfo = relative.userinfo;
          target2.host = relative.host;
          target2.port = relative.port;
          target2.path = removeDotSegments(relative.path || "");
          target2.query = relative.query;
        } else {
          if (relative.userinfo !== void 0 || relative.host !== void 0 || relative.port !== void 0) {
            target2.userinfo = relative.userinfo;
            target2.host = relative.host;
            target2.port = relative.port;
            target2.path = removeDotSegments(relative.path || "");
            target2.query = relative.query;
          } else {
            if (!relative.path) {
              target2.path = base2.path;
              if (relative.query !== void 0) {
                target2.query = relative.query;
              } else {
                target2.query = base2.query;
              }
            } else {
              if (relative.path.charAt(0) === "/") {
                target2.path = removeDotSegments(relative.path);
              } else {
                if ((base2.userinfo !== void 0 || base2.host !== void 0 || base2.port !== void 0) && !base2.path) {
                  target2.path = "/" + relative.path;
                } else if (!base2.path) {
                  target2.path = relative.path;
                } else {
                  target2.path = base2.path.slice(0, base2.path.lastIndexOf("/") + 1) + relative.path;
                }
                target2.path = removeDotSegments(target2.path);
              }
              target2.query = relative.query;
            }
            target2.userinfo = base2.userinfo;
            target2.host = base2.host;
            target2.port = base2.port;
          }
          target2.scheme = base2.scheme;
        }
        target2.fragment = relative.fragment;
        return target2;
      }
      function resolve(baseURI, relativeURI, options2) {
        var schemelessOptions = assign({
          scheme: "null"
        }, options2);
        return serialize(resolveComponents(parse2(baseURI, schemelessOptions), parse2(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
      }
      function normalize2(uri2, options2) {
        if (typeof uri2 === "string") {
          uri2 = serialize(parse2(uri2, options2), options2);
        } else if (typeOf(uri2) === "object") {
          uri2 = parse2(serialize(uri2, options2), options2);
        }
        return uri2;
      }
      function equal(uriA, uriB, options2) {
        if (typeof uriA === "string") {
          uriA = serialize(parse2(uriA, options2), options2);
        } else if (typeOf(uriA) === "object") {
          uriA = serialize(uriA, options2);
        }
        if (typeof uriB === "string") {
          uriB = serialize(parse2(uriB, options2), options2);
        } else if (typeOf(uriB) === "object") {
          uriB = serialize(uriB, options2);
        }
        return uriA === uriB;
      }
      function escapeComponent(str, options2) {
        return str && str.toString().replace(!options2 || !options2.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
      }
      function unescapeComponent(str, options2) {
        return str && str.toString().replace(!options2 || !options2.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
      }
      var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse22(components, options2) {
          if (!components.host) {
            components.error = components.error || "HTTP URIs must have a host.";
          }
          return components;
        },
        serialize: function serialize2(components, options2) {
          var secure = String(components.scheme).toLowerCase() === "https";
          if (components.port === (secure ? 443 : 80) || components.port === "") {
            components.port = void 0;
          }
          if (!components.path) {
            components.path = "/";
          }
          return components;
        }
      };
      var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
      };
      function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
      }
      var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse22(components, options2) {
          var wsComponents = components;
          wsComponents.secure = isSecure(wsComponents);
          wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
          wsComponents.path = void 0;
          wsComponents.query = void 0;
          return wsComponents;
        },
        serialize: function serialize2(wsComponents, options2) {
          if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
            wsComponents.port = void 0;
          }
          if (typeof wsComponents.secure === "boolean") {
            wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
            wsComponents.secure = void 0;
          }
          if (wsComponents.resourceName) {
            var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
            wsComponents.path = path && path !== "/" ? path : void 0;
            wsComponents.query = query;
            wsComponents.resourceName = void 0;
          }
          wsComponents.fragment = void 0;
          return wsComponents;
        }
      };
      var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
      };
      var O = {};
      var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]";
      var HEXDIG$$ = "[0-9A-Fa-f]";
      var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$));
      var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
      var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
      var VCHAR$$ = merge2(QTEXT$$, '[\\"\\\\]');
      var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
      var UNRESERVED = new RegExp(UNRESERVED$$, "g");
      var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
      var NOT_LOCAL_PART = new RegExp(merge2("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
      var NOT_HFNAME = new RegExp(merge2("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
      var NOT_HFVALUE = NOT_HFNAME;
      function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
      }
      var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options2) {
          var mailtoComponents = components;
          var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
          mailtoComponents.path = void 0;
          if (mailtoComponents.query) {
            var unknownHeaders = false;
            var headers = {};
            var hfields = mailtoComponents.query.split("&");
            for (var x = 0, xl = hfields.length; x < xl; ++x) {
              var hfield = hfields[x].split("=");
              switch (hfield[0]) {
                case "to":
                  var toAddrs = hfield[1].split(",");
                  for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                    to.push(toAddrs[_x]);
                  }
                  break;
                case "subject":
                  mailtoComponents.subject = unescapeComponent(hfield[1], options2);
                  break;
                case "body":
                  mailtoComponents.body = unescapeComponent(hfield[1], options2);
                  break;
                default:
                  unknownHeaders = true;
                  headers[unescapeComponent(hfield[0], options2)] = unescapeComponent(hfield[1], options2);
                  break;
              }
            }
            if (unknownHeaders) mailtoComponents.headers = headers;
          }
          mailtoComponents.query = void 0;
          for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
            var addr = to[_x2].split("@");
            addr[0] = unescapeComponent(addr[0]);
            if (!options2.unicodeSupport) {
              try {
                addr[1] = punycode.toASCII(unescapeComponent(addr[1], options2).toLowerCase());
              } catch (e) {
                mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
              }
            } else {
              addr[1] = unescapeComponent(addr[1], options2).toLowerCase();
            }
            to[_x2] = addr.join("@");
          }
          return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options2) {
          var components = mailtoComponents;
          var to = toArray(mailtoComponents.to);
          if (to) {
            for (var x = 0, xl = to.length; x < xl; ++x) {
              var toAddr = String(to[x]);
              var atIdx = toAddr.lastIndexOf("@");
              var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
              var domain2 = toAddr.slice(atIdx + 1);
              try {
                domain2 = !options2.iri ? punycode.toASCII(unescapeComponent(domain2, options2).toLowerCase()) : punycode.toUnicode(domain2);
              } catch (e) {
                components.error = components.error || "Email address's domain name can not be converted to " + (!options2.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
              }
              to[x] = localPart + "@" + domain2;
            }
            components.path = to.join(",");
          }
          var headers = mailtoComponents.headers = mailtoComponents.headers || {};
          if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
          if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
          var fields = [];
          for (var name in headers) {
            if (headers[name] !== O[name]) {
              fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            }
          }
          if (fields.length) {
            components.query = fields.join("&");
          }
          return components;
        }
      };
      var URN_PARSE = /^([^\:]+)\:(.*)/;
      var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options2) {
          var matches = components.path && components.path.match(URN_PARSE);
          var urnComponents = components;
          if (matches) {
            var scheme = options2.scheme || urnComponents.scheme || "urn";
            var nid = matches[1].toLowerCase();
            var nss = matches[2];
            var urnScheme = scheme + ":" + (options2.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            urnComponents.nid = nid;
            urnComponents.nss = nss;
            urnComponents.path = void 0;
            if (schemeHandler) {
              urnComponents = schemeHandler.parse(urnComponents, options2);
            }
          } else {
            urnComponents.error = urnComponents.error || "URN can not be parsed.";
          }
          return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options2) {
          var scheme = options2.scheme || urnComponents.scheme || "urn";
          var nid = urnComponents.nid;
          var urnScheme = scheme + ":" + (options2.nid || nid);
          var schemeHandler = SCHEMES[urnScheme];
          if (schemeHandler) {
            urnComponents = schemeHandler.serialize(urnComponents, options2);
          }
          var uriComponents = urnComponents;
          var nss = urnComponents.nss;
          uriComponents.path = (nid || options2.nid) + ":" + nss;
          return uriComponents;
        }
      };
      var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
      var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse22(urnComponents, options2) {
          var uuidComponents = urnComponents;
          uuidComponents.uuid = uuidComponents.nss;
          uuidComponents.nss = void 0;
          if (!options2.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
            uuidComponents.error = uuidComponents.error || "UUID is not valid.";
          }
          return uuidComponents;
        },
        serialize: function serialize2(uuidComponents, options2) {
          var urnComponents = uuidComponents;
          urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
          return urnComponents;
        }
      };
      SCHEMES[handler.scheme] = handler;
      SCHEMES[handler$1.scheme] = handler$1;
      SCHEMES[handler$2.scheme] = handler$2;
      SCHEMES[handler$3.scheme] = handler$3;
      SCHEMES[handler$4.scheme] = handler$4;
      SCHEMES[handler$5.scheme] = handler$5;
      SCHEMES[handler$6.scheme] = handler$6;
      exports22.SCHEMES = SCHEMES;
      exports22.pctEncChar = pctEncChar;
      exports22.pctDecChars = pctDecChars;
      exports22.parse = parse2;
      exports22.removeDotSegments = removeDotSegments;
      exports22.serialize = serialize;
      exports22.resolveComponents = resolveComponents;
      exports22.resolve = resolve;
      exports22.normalize = normalize2;
      exports22.equal = equal;
      exports22.escapeComponent = escapeComponent;
      exports22.unescapeComponent = unescapeComponent;
      Object.defineProperty(exports22, "__esModule", {
        value: true
      });
    });
  })(uri_all$1, uri_all$1.exports);
  return uri_all$1.exports;
}
var fastDeepEqual;
var hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  if (hasRequiredFastDeepEqual) return fastDeepEqual;
  hasRequiredFastDeepEqual = 1;
  fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
      if (a.constructor !== b.constructor) return false;
      var length2, i, keys2;
      if (Array.isArray(a)) {
        length2 = a.length;
        if (length2 != b.length) return false;
        for (i = length2; i-- !== 0; ) if (!equal(a[i], b[i])) return false;
        return true;
      }
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
      keys2 = Object.keys(a);
      length2 = keys2.length;
      if (length2 !== Object.keys(b).length) return false;
      for (i = length2; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(b, keys2[i])) return false;
      for (i = length2; i-- !== 0; ) {
        var key = keys2[i];
        if (!equal(a[key], b[key])) return false;
      }
      return true;
    }
    return a !== a && b !== b;
  };
  return fastDeepEqual;
}
var ucs2length;
var hasRequiredUcs2length;
function requireUcs2length() {
  if (hasRequiredUcs2length) return ucs2length;
  hasRequiredUcs2length = 1;
  ucs2length = function ucs2length2(str) {
    var length2 = 0, len = str.length, pos = 0, value;
    while (pos < len) {
      length2++;
      value = str.charCodeAt(pos++);
      if (value >= 55296 && value <= 56319 && pos < len) {
        value = str.charCodeAt(pos);
        if ((value & 64512) == 56320) pos++;
      }
    }
    return length2;
  };
  return ucs2length;
}
var util;
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  util = {
    copy: copy2,
    checkDataType,
    checkDataTypes,
    coerceToTypes,
    toHash,
    getProperty,
    escapeQuotes,
    equal: requireFastDeepEqual(),
    ucs2length: requireUcs2length(),
    varOccurences,
    varReplace,
    schemaHasRules,
    schemaHasRulesExcept,
    schemaUnknownRules,
    toQuotedString,
    getPathExpr,
    getPath,
    getData: getData2,
    unescapeFragment,
    unescapeJsonPointer,
    escapeFragment,
    escapeJsonPointer
  };
  function copy2(o, to) {
    to = to || {};
    for (var key in o) to[key] = o[key];
    return to;
  }
  function checkDataType(dataType, data2, strictNumbers, negate) {
    var EQUAL = negate ? " !== " : " === ", AND = negate ? " || " : " && ", OK = negate ? "!" : "", NOT = negate ? "" : "!";
    switch (dataType) {
      case "null":
        return data2 + EQUAL + "null";
      case "array":
        return OK + "Array.isArray(" + data2 + ")";
      case "object":
        return "(" + OK + data2 + AND + "typeof " + data2 + EQUAL + '"object"' + AND + NOT + "Array.isArray(" + data2 + "))";
      case "integer":
        return "(typeof " + data2 + EQUAL + '"number"' + AND + NOT + "(" + data2 + " % 1)" + AND + data2 + EQUAL + data2 + (strictNumbers ? AND + OK + "isFinite(" + data2 + ")" : "") + ")";
      case "number":
        return "(typeof " + data2 + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + "isFinite(" + data2 + ")" : "") + ")";
      default:
        return "typeof " + data2 + EQUAL + '"' + dataType + '"';
    }
  }
  function checkDataTypes(dataTypes, data2, strictNumbers) {
    switch (dataTypes.length) {
      case 1:
        return checkDataType(dataTypes[0], data2, strictNumbers, true);
      default:
        var code = "";
        var types2 = toHash(dataTypes);
        if (types2.array && types2.object) {
          code = types2.null ? "(" : "(!" + data2 + " || ";
          code += "typeof " + data2 + ' !== "object")';
          delete types2.null;
          delete types2.array;
          delete types2.object;
        }
        if (types2.number) delete types2.integer;
        for (var t in types2) code += (code ? " && " : "") + checkDataType(t, data2, strictNumbers, true);
        return code;
    }
  }
  var COERCE_TO_TYPES = toHash(["string", "number", "integer", "boolean", "null"]);
  function coerceToTypes(optionCoerceTypes, dataTypes) {
    if (Array.isArray(dataTypes)) {
      var types2 = [];
      for (var i = 0; i < dataTypes.length; i++) {
        var t = dataTypes[i];
        if (COERCE_TO_TYPES[t]) types2[types2.length] = t;
        else if (optionCoerceTypes === "array" && t === "array") types2[types2.length] = t;
      }
      if (types2.length) return types2;
    } else if (COERCE_TO_TYPES[dataTypes]) {
      return [dataTypes];
    } else if (optionCoerceTypes === "array" && dataTypes === "array") {
      return ["array"];
    }
  }
  function toHash(arr) {
    var hash = {};
    for (var i = 0; i < arr.length; i++) hash[arr[i]] = true;
    return hash;
  }
  var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
  var SINGLE_QUOTE = /'|\\/g;
  function getProperty(key) {
    return typeof key == "number" ? "[" + key + "]" : IDENTIFIER.test(key) ? "." + key : "['" + escapeQuotes(key) + "']";
  }
  function escapeQuotes(str) {
    return str.replace(SINGLE_QUOTE, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
  }
  function varOccurences(str, dataVar) {
    dataVar += "[^0-9]";
    var matches = str.match(new RegExp(dataVar, "g"));
    return matches ? matches.length : 0;
  }
  function varReplace(str, dataVar, expr) {
    dataVar += "([^0-9])";
    expr = expr.replace(/\$/g, "$$$$");
    return str.replace(new RegExp(dataVar, "g"), expr + "$1");
  }
  function schemaHasRules(schema2, rules2) {
    if (typeof schema2 == "boolean") return !schema2;
    for (var key in schema2) if (rules2[key]) return true;
  }
  function schemaHasRulesExcept(schema2, rules2, exceptKeyword) {
    if (typeof schema2 == "boolean") return !schema2 && exceptKeyword != "not";
    for (var key in schema2) if (key != exceptKeyword && rules2[key]) return true;
  }
  function schemaUnknownRules(schema2, rules2) {
    if (typeof schema2 == "boolean") return;
    for (var key in schema2) if (!rules2[key]) return key;
  }
  function toQuotedString(str) {
    return "'" + escapeQuotes(str) + "'";
  }
  function getPathExpr(currentPath, expr, jsonPointers, isNumber) {
    var path = jsonPointers ? "'/' + " + expr + (isNumber ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : isNumber ? "'[' + " + expr + " + ']'" : "'[\\'' + " + expr + " + '\\']'";
    return joinPaths(currentPath, path);
  }
  function getPath(currentPath, prop2, jsonPointers) {
    var path = jsonPointers ? toQuotedString("/" + escapeJsonPointer(prop2)) : toQuotedString(getProperty(prop2));
    return joinPaths(currentPath, path);
  }
  var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
  var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
  function getData2($data, lvl, paths) {
    var up, jsonPointer, data2, matches;
    if ($data === "") return "rootData";
    if ($data[0] == "/") {
      if (!JSON_POINTER.test($data)) throw new Error("Invalid JSON-pointer: " + $data);
      jsonPointer = $data;
      data2 = "rootData";
    } else {
      matches = $data.match(RELATIVE_JSON_POINTER);
      if (!matches) throw new Error("Invalid JSON-pointer: " + $data);
      up = +matches[1];
      jsonPointer = matches[2];
      if (jsonPointer == "#") {
        if (up >= lvl) throw new Error("Cannot access property/index " + up + " levels up, current level is " + lvl);
        return paths[lvl - up];
      }
      if (up > lvl) throw new Error("Cannot access data " + up + " levels up, current level is " + lvl);
      data2 = "data" + (lvl - up || "");
      if (!jsonPointer) return data2;
    }
    var expr = data2;
    var segments = jsonPointer.split("/");
    for (var i = 0; i < segments.length; i++) {
      var segment = segments[i];
      if (segment) {
        data2 += getProperty(unescapeJsonPointer(segment));
        expr += " && " + data2;
      }
    }
    return expr;
  }
  function joinPaths(a, b) {
    if (a == '""') return b;
    return (a + " + " + b).replace(/([^\\])' \+ '/g, "$1");
  }
  function unescapeFragment(str) {
    return unescapeJsonPointer(decodeURIComponent(str));
  }
  function escapeFragment(str) {
    return encodeURIComponent(escapeJsonPointer(str));
  }
  function escapeJsonPointer(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  function unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
  }
  return util;
}
var schema_obj;
var hasRequiredSchema_obj;
function requireSchema_obj() {
  if (hasRequiredSchema_obj) return schema_obj;
  hasRequiredSchema_obj = 1;
  var util2 = requireUtil();
  schema_obj = SchemaObject;
  function SchemaObject(obj) {
    util2.copy(obj, this);
  }
  return schema_obj;
}
var jsonSchemaTraverse = { exports: {} };
var hasRequiredJsonSchemaTraverse;
function requireJsonSchemaTraverse() {
  if (hasRequiredJsonSchemaTraverse) return jsonSchemaTraverse.exports;
  hasRequiredJsonSchemaTraverse = 1;
  var traverse = jsonSchemaTraverse.exports = function(schema2, opts, cb) {
    if (typeof opts == "function") {
      cb = opts;
      opts = {};
    }
    cb = opts.cb || cb;
    var pre2 = typeof cb == "function" ? cb : cb.pre || function() {
    };
    var post = cb.post || function() {
    };
    _traverse(opts, pre2, post, schema2, "", schema2);
  };
  traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true
  };
  traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
  };
  traverse.propsKeywords = {
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
  };
  traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
  };
  function _traverse(opts, pre2, post, schema2, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema2 && typeof schema2 == "object" && !Array.isArray(schema2)) {
      pre2(schema2, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
      for (var key in schema2) {
        var sch = schema2[key];
        if (Array.isArray(sch)) {
          if (key in traverse.arrayKeywords) {
            for (var i = 0; i < sch.length; i++) _traverse(opts, pre2, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema2, i);
          }
        } else if (key in traverse.propsKeywords) {
          if (sch && typeof sch == "object") {
            for (var prop2 in sch) _traverse(opts, pre2, post, sch[prop2], jsonPtr + "/" + key + "/" + escapeJsonPtr(prop2), rootSchema, jsonPtr, key, schema2, prop2);
          }
        } else if (key in traverse.keywords || opts.allKeys && !(key in traverse.skipKeywords)) {
          _traverse(opts, pre2, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema2);
        }
      }
      post(schema2, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
  }
  function escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  return jsonSchemaTraverse.exports;
}
var resolve_1;
var hasRequiredResolve;
function requireResolve() {
  if (hasRequiredResolve) return resolve_1;
  hasRequiredResolve = 1;
  var URI = requireUri_all(), equal = requireFastDeepEqual(), util2 = requireUtil(), SchemaObject = requireSchema_obj(), traverse = requireJsonSchemaTraverse();
  resolve_1 = resolve;
  resolve.normalizeId = normalizeId;
  resolve.fullPath = getFullPath;
  resolve.url = resolveUrl;
  resolve.ids = resolveIds;
  resolve.inlineRef = inlineRef;
  resolve.schema = resolveSchema;
  function resolve(compile2, root2, ref2) {
    var refVal = this._refs[ref2];
    if (typeof refVal == "string") {
      if (this._refs[refVal]) refVal = this._refs[refVal];
      else return resolve.call(this, compile2, root2, refVal);
    }
    refVal = refVal || this._schemas[ref2];
    if (refVal instanceof SchemaObject) {
      return inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
    }
    var res = resolveSchema.call(this, root2, ref2);
    var schema2, v, baseId;
    if (res) {
      schema2 = res.schema;
      root2 = res.root;
      baseId = res.baseId;
    }
    if (schema2 instanceof SchemaObject) {
      v = schema2.validate || compile2.call(this, schema2.schema, root2, void 0, baseId);
    } else if (schema2 !== void 0) {
      v = inlineRef(schema2, this._opts.inlineRefs) ? schema2 : compile2.call(this, schema2, root2, void 0, baseId);
    }
    return v;
  }
  function resolveSchema(root2, ref2) {
    var p = URI.parse(ref2), refPath = _getFullPath(p), baseId = getFullPath(this._getId(root2.schema));
    if (Object.keys(root2.schema).length === 0 || refPath !== baseId) {
      var id2 = normalizeId(refPath);
      var refVal = this._refs[id2];
      if (typeof refVal == "string") {
        return resolveRecursive.call(this, root2, refVal, p);
      } else if (refVal instanceof SchemaObject) {
        if (!refVal.validate) this._compile(refVal);
        root2 = refVal;
      } else {
        refVal = this._schemas[id2];
        if (refVal instanceof SchemaObject) {
          if (!refVal.validate) this._compile(refVal);
          if (id2 == normalizeId(ref2)) return {
            schema: refVal,
            root: root2,
            baseId
          };
          root2 = refVal;
        } else {
          return;
        }
      }
      if (!root2.schema) return;
      baseId = getFullPath(this._getId(root2.schema));
    }
    return getJsonPointer.call(this, p, baseId, root2.schema, root2);
  }
  function resolveRecursive(root2, ref2, parsedRef) {
    var res = resolveSchema.call(this, root2, ref2);
    if (res) {
      var schema2 = res.schema;
      var baseId = res.baseId;
      root2 = res.root;
      var id2 = this._getId(schema2);
      if (id2) baseId = resolveUrl(baseId, id2);
      return getJsonPointer.call(this, parsedRef, baseId, schema2, root2);
    }
  }
  var PREVENT_SCOPE_CHANGE = util2.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
  function getJsonPointer(parsedRef, baseId, schema2, root2) {
    parsedRef.fragment = parsedRef.fragment || "";
    if (parsedRef.fragment.slice(0, 1) != "/") return;
    var parts = parsedRef.fragment.split("/");
    for (var i = 1; i < parts.length; i++) {
      var part2 = parts[i];
      if (part2) {
        part2 = util2.unescapeFragment(part2);
        schema2 = schema2[part2];
        if (schema2 === void 0) break;
        var id2;
        if (!PREVENT_SCOPE_CHANGE[part2]) {
          id2 = this._getId(schema2);
          if (id2) baseId = resolveUrl(baseId, id2);
          if (schema2.$ref) {
            var $ref = resolveUrl(baseId, schema2.$ref);
            var res = resolveSchema.call(this, root2, $ref);
            if (res) {
              schema2 = res.schema;
              root2 = res.root;
              baseId = res.baseId;
            }
          }
        }
      }
    }
    if (schema2 !== void 0 && schema2 !== root2.schema) return {
      schema: schema2,
      root: root2,
      baseId
    };
  }
  var SIMPLE_INLINED = util2.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
  function inlineRef(schema2, limit) {
    if (limit === false) return false;
    if (limit === void 0 || limit === true) return checkNoRef(schema2);
    else if (limit) return countKeys(schema2) <= limit;
  }
  function checkNoRef(schema2) {
    var item;
    if (Array.isArray(schema2)) {
      for (var i = 0; i < schema2.length; i++) {
        item = schema2[i];
        if (typeof item == "object" && !checkNoRef(item)) return false;
      }
    } else {
      for (var key in schema2) {
        if (key == "$ref") return false;
        item = schema2[key];
        if (typeof item == "object" && !checkNoRef(item)) return false;
      }
    }
    return true;
  }
  function countKeys(schema2) {
    var count2 = 0, item;
    if (Array.isArray(schema2)) {
      for (var i = 0; i < schema2.length; i++) {
        item = schema2[i];
        if (typeof item == "object") count2 += countKeys(item);
        if (count2 == Infinity) return Infinity;
      }
    } else {
      for (var key in schema2) {
        if (key == "$ref") return Infinity;
        if (SIMPLE_INLINED[key]) {
          count2++;
        } else {
          item = schema2[key];
          if (typeof item == "object") count2 += countKeys(item) + 1;
          if (count2 == Infinity) return Infinity;
        }
      }
    }
    return count2;
  }
  function getFullPath(id2, normalize2) {
    if (normalize2 !== false) id2 = normalizeId(id2);
    var p = URI.parse(id2);
    return _getFullPath(p);
  }
  function _getFullPath(p) {
    return URI.serialize(p).split("#")[0] + "#";
  }
  var TRAILING_SLASH_HASH = /#\/?$/;
  function normalizeId(id2) {
    return id2 ? id2.replace(TRAILING_SLASH_HASH, "") : "";
  }
  function resolveUrl(baseId, id2) {
    id2 = normalizeId(id2);
    return URI.resolve(baseId, id2);
  }
  function resolveIds(schema2) {
    var schemaId = normalizeId(this._getId(schema2));
    var baseIds = {
      "": schemaId
    };
    var fullPaths = {
      "": getFullPath(schemaId, false)
    };
    var localRefs = {};
    var self2 = this;
    traverse(schema2, {
      allKeys: true
    }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
      if (jsonPtr === "") return;
      var id2 = self2._getId(sch);
      var baseId = baseIds[parentJsonPtr];
      var fullPath = fullPaths[parentJsonPtr] + "/" + parentKeyword;
      if (keyIndex !== void 0) fullPath += "/" + (typeof keyIndex == "number" ? keyIndex : util2.escapeFragment(keyIndex));
      if (typeof id2 == "string") {
        id2 = baseId = normalizeId(baseId ? URI.resolve(baseId, id2) : id2);
        var refVal = self2._refs[id2];
        if (typeof refVal == "string") refVal = self2._refs[refVal];
        if (refVal && refVal.schema) {
          if (!equal(sch, refVal.schema)) throw new Error('id "' + id2 + '" resolves to more than one schema');
        } else if (id2 != normalizeId(fullPath)) {
          if (id2[0] == "#") {
            if (localRefs[id2] && !equal(sch, localRefs[id2])) throw new Error('id "' + id2 + '" resolves to more than one schema');
            localRefs[id2] = sch;
          } else {
            self2._refs[id2] = fullPath;
          }
        }
      }
      baseIds[jsonPtr] = baseId;
      fullPaths[jsonPtr] = fullPath;
    });
    return localRefs;
  }
  return resolve_1;
}
var error_classes;
var hasRequiredError_classes;
function requireError_classes() {
  if (hasRequiredError_classes) return error_classes;
  hasRequiredError_classes = 1;
  var resolve = requireResolve();
  error_classes = {
    Validation: errorSubclass(ValidationError),
    MissingRef: errorSubclass(MissingRefError)
  };
  function ValidationError(errors) {
    this.message = "validation failed";
    this.errors = errors;
    this.ajv = this.validation = true;
  }
  MissingRefError.message = function(baseId, ref2) {
    return "can't resolve reference " + ref2 + " from id " + baseId;
  };
  function MissingRefError(baseId, ref2, message) {
    this.message = message || MissingRefError.message(baseId, ref2);
    this.missingRef = resolve.url(baseId, ref2);
    this.missingSchema = resolve.normalizeId(resolve.fullPath(this.missingRef));
  }
  function errorSubclass(Subclass) {
    Subclass.prototype = Object.create(Error.prototype);
    Subclass.prototype.constructor = Subclass;
    return Subclass;
  }
  return error_classes;
}
var fastJsonStableStringify;
var hasRequiredFastJsonStableStringify;
function requireFastJsonStableStringify() {
  if (hasRequiredFastJsonStableStringify) return fastJsonStableStringify;
  hasRequiredFastJsonStableStringify = 1;
  fastJsonStableStringify = function(data2, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
      cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && /* @__PURE__ */ (function(f2) {
      return function(node2) {
        return function(a, b) {
          var aobj = {
            key: a,
            value: node2[a]
          };
          var bobj = {
            key: b,
            value: node2[b]
          };
          return f2(aobj, bobj);
        };
      };
    })(opts.cmp);
    var seen = [];
    return (function stringify2(node2) {
      if (node2 && node2.toJSON && typeof node2.toJSON === "function") {
        node2 = node2.toJSON();
      }
      if (node2 === void 0) return;
      if (typeof node2 == "number") return isFinite(node2) ? "" + node2 : "null";
      if (typeof node2 !== "object") return JSON.stringify(node2);
      var i, out;
      if (Array.isArray(node2)) {
        out = "[";
        for (i = 0; i < node2.length; i++) {
          if (i) out += ",";
          out += stringify2(node2[i]) || "null";
        }
        return out + "]";
      }
      if (node2 === null) return "null";
      if (seen.indexOf(node2) !== -1) {
        if (cycles) return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var seenIndex = seen.push(node2) - 1;
      var keys2 = Object.keys(node2).sort(cmp && cmp(node2));
      out = "";
      for (i = 0; i < keys2.length; i++) {
        var key = keys2[i];
        var value = stringify2(node2[key]);
        if (!value) continue;
        if (out) out += ",";
        out += JSON.stringify(key) + ":" + value;
      }
      seen.splice(seenIndex, 1);
      return "{" + out + "}";
    })(data2);
  };
  return fastJsonStableStringify;
}
var validate;
var hasRequiredValidate;
function requireValidate() {
  if (hasRequiredValidate) return validate;
  hasRequiredValidate = 1;
  validate = function generate_validate(it2, $keyword, $ruleType) {
    var out = "";
    var $async = it2.schema.$async === true, $refKeywords = it2.util.schemaHasRulesExcept(it2.schema, it2.RULES.all, "$ref"), $id2 = it2.self._getId(it2.schema);
    if (it2.opts.strictKeywords) {
      var $unknownKwd = it2.util.schemaUnknownRules(it2.schema, it2.RULES.keywords);
      if ($unknownKwd) {
        var $keywordsMsg = "unknown keyword: " + $unknownKwd;
        if (it2.opts.strictKeywords === "log") it2.logger.warn($keywordsMsg);
        else throw new Error($keywordsMsg);
      }
    }
    if (it2.isTop) {
      out += " var validate = ";
      if ($async) {
        it2.async = true;
        out += "async ";
      }
      out += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ";
      if ($id2 && (it2.opts.sourceCode || it2.opts.processCode)) {
        out += " " + ("/*# sourceURL=" + $id2 + " */") + " ";
      }
    }
    if (typeof it2.schema == "boolean" || !($refKeywords || it2.schema.$ref)) {
      var $keyword = "false schema";
      var $lvl = it2.level;
      var $dataLvl = it2.dataLevel;
      var $schema2 = it2.schema[$keyword];
      var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
      var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
      var $breakOnError = !it2.opts.allErrors;
      var $errorKeyword;
      var $data = "data" + ($dataLvl || "");
      var $valid = "valid" + $lvl;
      if (it2.schema === false) {
        if (it2.isTop) {
          $breakOnError = true;
        } else {
          out += " var " + $valid + " = false; ";
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it2.createErrors !== false) {
          out += " { keyword: '" + ($errorKeyword || "false schema") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: {} ";
          if (it2.opts.messages !== false) {
            out += " , message: 'boolean schema is false' ";
          }
          if (it2.opts.verbose) {
            out += " , schema: false , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it2.compositeRule && $breakOnError) {
          if (it2.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
      } else {
        if (it2.isTop) {
          if ($async) {
            out += " return data; ";
          } else {
            out += " validate.errors = null; return true; ";
          }
        } else {
          out += " var " + $valid + " = true; ";
        }
      }
      if (it2.isTop) {
        out += " }; return validate; ";
      }
      return out;
    }
    if (it2.isTop) {
      var $top = it2.isTop, $lvl = it2.level = 0, $dataLvl = it2.dataLevel = 0, $data = "data";
      it2.rootId = it2.resolve.fullPath(it2.self._getId(it2.root.schema));
      it2.baseId = it2.baseId || it2.rootId;
      delete it2.isTop;
      it2.dataPathArr = [""];
      if (it2.schema.default !== void 0 && it2.opts.useDefaults && it2.opts.strictDefaults) {
        var $defaultMsg = "default is ignored in the schema root";
        if (it2.opts.strictDefaults === "log") it2.logger.warn($defaultMsg);
        else throw new Error($defaultMsg);
      }
      out += " var vErrors = null; ";
      out += " var errors = 0;     ";
      out += " if (rootData === undefined) rootData = data; ";
    } else {
      var $lvl = it2.level, $dataLvl = it2.dataLevel, $data = "data" + ($dataLvl || "");
      if ($id2) it2.baseId = it2.resolve.url(it2.baseId, $id2);
      if ($async && !it2.async) throw new Error("async schema in sync schema");
      out += " var errs_" + $lvl + " = errors;";
    }
    var $valid = "valid" + $lvl, $breakOnError = !it2.opts.allErrors, $closingBraces1 = "", $closingBraces2 = "";
    var $errorKeyword;
    var $typeSchema = it2.schema.type, $typeIsArray = Array.isArray($typeSchema);
    if ($typeSchema && it2.opts.nullable && it2.schema.nullable === true) {
      if ($typeIsArray) {
        if ($typeSchema.indexOf("null") == -1) $typeSchema = $typeSchema.concat("null");
      } else if ($typeSchema != "null") {
        $typeSchema = [$typeSchema, "null"];
        $typeIsArray = true;
      }
    }
    if ($typeIsArray && $typeSchema.length == 1) {
      $typeSchema = $typeSchema[0];
      $typeIsArray = false;
    }
    if (it2.schema.$ref && $refKeywords) {
      if (it2.opts.extendRefs == "fail") {
        throw new Error('$ref: validation keywords used in schema at path "' + it2.errSchemaPath + '" (see option extendRefs)');
      } else if (it2.opts.extendRefs !== true) {
        $refKeywords = false;
        it2.logger.warn('$ref: keywords ignored in schema at path "' + it2.errSchemaPath + '"');
      }
    }
    if (it2.schema.$comment && it2.opts.$comment) {
      out += " " + it2.RULES.all.$comment.code(it2, "$comment");
    }
    if ($typeSchema) {
      if (it2.opts.coerceTypes) {
        var $coerceToTypes = it2.util.coerceToTypes(it2.opts.coerceTypes, $typeSchema);
      }
      var $rulesGroup = it2.RULES.types[$typeSchema];
      if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
        var $schemaPath = it2.schemaPath + ".type", $errSchemaPath = it2.errSchemaPath + "/type";
        var $schemaPath = it2.schemaPath + ".type", $errSchemaPath = it2.errSchemaPath + "/type", $method = $typeIsArray ? "checkDataTypes" : "checkDataType";
        out += " if (" + it2.util[$method]($typeSchema, $data, it2.opts.strictNumbers, true) + ") { ";
        if ($coerceToTypes) {
          var $dataType = "dataType" + $lvl, $coerced = "coerced" + $lvl;
          out += " var " + $dataType + " = typeof " + $data + "; var " + $coerced + " = undefined; ";
          if (it2.opts.coerceTypes == "array") {
            out += " if (" + $dataType + " == 'object' && Array.isArray(" + $data + ") && " + $data + ".length == 1) { " + $data + " = " + $data + "[0]; " + $dataType + " = typeof " + $data + "; if (" + it2.util.checkDataType(it2.schema.type, $data, it2.opts.strictNumbers) + ") " + $coerced + " = " + $data + "; } ";
          }
          out += " if (" + $coerced + " !== undefined) ; ";
          var arr1 = $coerceToTypes;
          if (arr1) {
            var $type, $i = -1, l1 = arr1.length - 1;
            while ($i < l1) {
              $type = arr1[$i += 1];
              if ($type == "string") {
                out += " else if (" + $dataType + " == 'number' || " + $dataType + " == 'boolean') " + $coerced + " = '' + " + $data + "; else if (" + $data + " === null) " + $coerced + " = ''; ";
              } else if ($type == "number" || $type == "integer") {
                out += " else if (" + $dataType + " == 'boolean' || " + $data + " === null || (" + $dataType + " == 'string' && " + $data + " && " + $data + " == +" + $data + " ";
                if ($type == "integer") {
                  out += " && !(" + $data + " % 1)";
                }
                out += ")) " + $coerced + " = +" + $data + "; ";
              } else if ($type == "boolean") {
                out += " else if (" + $data + " === 'false' || " + $data + " === 0 || " + $data + " === null) " + $coerced + " = false; else if (" + $data + " === 'true' || " + $data + " === 1) " + $coerced + " = true; ";
              } else if ($type == "null") {
                out += " else if (" + $data + " === '' || " + $data + " === 0 || " + $data + " === false) " + $coerced + " = null; ";
              } else if (it2.opts.coerceTypes == "array" && $type == "array") {
                out += " else if (" + $dataType + " == 'string' || " + $dataType + " == 'number' || " + $dataType + " == 'boolean' || " + $data + " == null) " + $coerced + " = [" + $data + "]; ";
              }
            }
          }
          out += " else {   ";
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it2.createErrors !== false) {
            out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { type: '";
            if ($typeIsArray) {
              out += "" + $typeSchema.join(",");
            } else {
              out += "" + $typeSchema;
            }
            out += "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: 'should be ";
              if ($typeIsArray) {
                out += "" + $typeSchema.join(",");
              } else {
                out += "" + $typeSchema;
              }
              out += "' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it2.compositeRule && $breakOnError) {
            if (it2.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
          out += " } if (" + $coerced + " !== undefined) {  ";
          var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it2.dataPathArr[$dataLvl] : "parentDataProperty";
          out += " " + $data + " = " + $coerced + "; ";
          if (!$dataLvl) {
            out += "if (" + $parentData + " !== undefined)";
          }
          out += " " + $parentData + "[" + $parentDataProperty + "] = " + $coerced + "; } ";
        } else {
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it2.createErrors !== false) {
            out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { type: '";
            if ($typeIsArray) {
              out += "" + $typeSchema.join(",");
            } else {
              out += "" + $typeSchema;
            }
            out += "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: 'should be ";
              if ($typeIsArray) {
                out += "" + $typeSchema.join(",");
              } else {
                out += "" + $typeSchema;
              }
              out += "' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it2.compositeRule && $breakOnError) {
            if (it2.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
        }
        out += " } ";
      }
    }
    if (it2.schema.$ref && !$refKeywords) {
      out += " " + it2.RULES.all.$ref.code(it2, "$ref") + " ";
      if ($breakOnError) {
        out += " } if (errors === ";
        if ($top) {
          out += "0";
        } else {
          out += "errs_" + $lvl;
        }
        out += ") { ";
        $closingBraces2 += "}";
      }
    } else {
      var arr2 = it2.RULES;
      if (arr2) {
        var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
        while (i2 < l2) {
          $rulesGroup = arr2[i2 += 1];
          if ($shouldUseGroup($rulesGroup)) {
            if ($rulesGroup.type) {
              out += " if (" + it2.util.checkDataType($rulesGroup.type, $data, it2.opts.strictNumbers) + ") { ";
            }
            if (it2.opts.useDefaults) {
              if ($rulesGroup.type == "object" && it2.schema.properties) {
                var $schema2 = it2.schema.properties, $schemaKeys = Object.keys($schema2);
                var arr3 = $schemaKeys;
                if (arr3) {
                  var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                  while (i3 < l3) {
                    $propertyKey = arr3[i3 += 1];
                    var $sch = $schema2[$propertyKey];
                    if ($sch.default !== void 0) {
                      var $passData = $data + it2.util.getProperty($propertyKey);
                      if (it2.compositeRule) {
                        if (it2.opts.strictDefaults) {
                          var $defaultMsg = "default is ignored for: " + $passData;
                          if (it2.opts.strictDefaults === "log") it2.logger.warn($defaultMsg);
                          else throw new Error($defaultMsg);
                        }
                      } else {
                        out += " if (" + $passData + " === undefined ";
                        if (it2.opts.useDefaults == "empty") {
                          out += " || " + $passData + " === null || " + $passData + " === '' ";
                        }
                        out += " ) " + $passData + " = ";
                        if (it2.opts.useDefaults == "shared") {
                          out += " " + it2.useDefault($sch.default) + " ";
                        } else {
                          out += " " + JSON.stringify($sch.default) + " ";
                        }
                        out += "; ";
                      }
                    }
                  }
                }
              } else if ($rulesGroup.type == "array" && Array.isArray(it2.schema.items)) {
                var arr4 = it2.schema.items;
                if (arr4) {
                  var $sch, $i = -1, l4 = arr4.length - 1;
                  while ($i < l4) {
                    $sch = arr4[$i += 1];
                    if ($sch.default !== void 0) {
                      var $passData = $data + "[" + $i + "]";
                      if (it2.compositeRule) {
                        if (it2.opts.strictDefaults) {
                          var $defaultMsg = "default is ignored for: " + $passData;
                          if (it2.opts.strictDefaults === "log") it2.logger.warn($defaultMsg);
                          else throw new Error($defaultMsg);
                        }
                      } else {
                        out += " if (" + $passData + " === undefined ";
                        if (it2.opts.useDefaults == "empty") {
                          out += " || " + $passData + " === null || " + $passData + " === '' ";
                        }
                        out += " ) " + $passData + " = ";
                        if (it2.opts.useDefaults == "shared") {
                          out += " " + it2.useDefault($sch.default) + " ";
                        } else {
                          out += " " + JSON.stringify($sch.default) + " ";
                        }
                        out += "; ";
                      }
                    }
                  }
                }
              }
            }
            var arr5 = $rulesGroup.rules;
            if (arr5) {
              var $rule, i5 = -1, l5 = arr5.length - 1;
              while (i5 < l5) {
                $rule = arr5[i5 += 1];
                if ($shouldUseRule($rule)) {
                  var $code = $rule.code(it2, $rule.keyword, $rulesGroup.type);
                  if ($code) {
                    out += " " + $code + " ";
                    if ($breakOnError) {
                      $closingBraces1 += "}";
                    }
                  }
                }
              }
            }
            if ($breakOnError) {
              out += " " + $closingBraces1 + " ";
              $closingBraces1 = "";
            }
            if ($rulesGroup.type) {
              out += " } ";
              if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
                out += " else { ";
                var $schemaPath = it2.schemaPath + ".type", $errSchemaPath = it2.errSchemaPath + "/type";
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = "";
                if (it2.createErrors !== false) {
                  out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                  if ($typeIsArray) {
                    out += "" + $typeSchema.join(",");
                  } else {
                    out += "" + $typeSchema;
                  }
                  out += "' } ";
                  if (it2.opts.messages !== false) {
                    out += " , message: 'should be ";
                    if ($typeIsArray) {
                      out += "" + $typeSchema.join(",");
                    } else {
                      out += "" + $typeSchema;
                    }
                    out += "' ";
                  }
                  if (it2.opts.verbose) {
                    out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
                  }
                  out += " } ";
                } else {
                  out += " {} ";
                }
                var __err = out;
                out = $$outStack.pop();
                if (!it2.compositeRule && $breakOnError) {
                  if (it2.async) {
                    out += " throw new ValidationError([" + __err + "]); ";
                  } else {
                    out += " validate.errors = [" + __err + "]; return false; ";
                  }
                } else {
                  out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                }
                out += " } ";
              }
            }
            if ($breakOnError) {
              out += " if (errors === ";
              if ($top) {
                out += "0";
              } else {
                out += "errs_" + $lvl;
              }
              out += ") { ";
              $closingBraces2 += "}";
            }
          }
        }
      }
    }
    if ($breakOnError) {
      out += " " + $closingBraces2 + " ";
    }
    if ($top) {
      if ($async) {
        out += " if (errors === 0) return data;           ";
        out += " else throw new ValidationError(vErrors); ";
      } else {
        out += " validate.errors = vErrors; ";
        out += " return errors === 0;       ";
      }
      out += " }; return validate;";
    } else {
      out += " var " + $valid + " = errors === errs_" + $lvl + ";";
    }
    function $shouldUseGroup($rulesGroup2) {
      var rules2 = $rulesGroup2.rules;
      for (var i = 0; i < rules2.length; i++) if ($shouldUseRule(rules2[i])) return true;
    }
    function $shouldUseRule($rule2) {
      return it2.schema[$rule2.keyword] !== void 0 || $rule2.implements && $ruleImplementsSomeKeyword($rule2);
    }
    function $ruleImplementsSomeKeyword($rule2) {
      var impl = $rule2.implements;
      for (var i = 0; i < impl.length; i++) if (it2.schema[impl[i]] !== void 0) return true;
    }
    return out;
  };
  return validate;
}
var compile_1;
var hasRequiredCompile;
function requireCompile() {
  if (hasRequiredCompile) return compile_1;
  hasRequiredCompile = 1;
  var resolve = requireResolve(), util2 = requireUtil(), errorClasses = requireError_classes(), stableStringify = requireFastJsonStableStringify();
  var validateGenerator = requireValidate();
  var ucs2length2 = util2.ucs2length;
  var equal = requireFastDeepEqual();
  var ValidationError = errorClasses.Validation;
  compile_1 = compile2;
  function compile2(schema2, root2, localRefs, baseId) {
    var self2 = this, opts = this._opts, refVal = [void 0], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
    root2 = root2 || {
      schema: schema2,
      refVal,
      refs
    };
    var c = checkCompiling.call(this, schema2, root2, baseId);
    var compilation = this._compilations[c.index];
    if (c.compiling) return compilation.callValidate = callValidate;
    var formats = this._formats;
    var RULES = this.RULES;
    try {
      var v = localCompile(schema2, root2, localRefs, baseId);
      compilation.validate = v;
      var cv = compilation.callValidate;
      if (cv) {
        cv.schema = v.schema;
        cv.errors = null;
        cv.refs = v.refs;
        cv.refVal = v.refVal;
        cv.root = v.root;
        cv.$async = v.$async;
        if (opts.sourceCode) cv.source = v.source;
      }
      return v;
    } finally {
      endCompiling.call(this, schema2, root2, baseId);
    }
    function callValidate() {
      var validate2 = compilation.validate;
      var result = validate2.apply(this, arguments);
      callValidate.errors = validate2.errors;
      return result;
    }
    function localCompile(_schema, _root, localRefs2, baseId2) {
      var isRoot = !_root || _root && _root.schema == _schema;
      if (_root.schema != root2.schema) return compile2.call(self2, _schema, _root, localRefs2, baseId2);
      var $async = _schema.$async === true;
      var sourceCode = validateGenerator({
        isTop: true,
        schema: _schema,
        isRoot,
        baseId: baseId2,
        root: _root,
        schemaPath: "",
        errSchemaPath: "#",
        errorPath: '""',
        MissingRefError: errorClasses.MissingRef,
        RULES,
        validate: validateGenerator,
        util: util2,
        resolve,
        resolveRef,
        usePattern,
        useDefault,
        useCustomRule,
        opts,
        formats,
        logger: self2.logger,
        self: self2
      });
      sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode) + vars(defaults, defaultCode) + vars(customRules, customRuleCode) + sourceCode;
      if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
      var validate2;
      try {
        var makeValidate = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", sourceCode);
        validate2 = makeValidate(self2, RULES, formats, root2, refVal, defaults, customRules, equal, ucs2length2, ValidationError);
        refVal[0] = validate2;
      } catch (e) {
        self2.logger.error("Error compiling schema, function code:", sourceCode);
        throw e;
      }
      validate2.schema = _schema;
      validate2.errors = null;
      validate2.refs = refs;
      validate2.refVal = refVal;
      validate2.root = isRoot ? validate2 : _root;
      if ($async) validate2.$async = true;
      if (opts.sourceCode === true) {
        validate2.source = {
          code: sourceCode,
          patterns,
          defaults
        };
      }
      return validate2;
    }
    function resolveRef(baseId2, ref2, isRoot) {
      ref2 = resolve.url(baseId2, ref2);
      var refIndex = refs[ref2];
      var _refVal, refCode;
      if (refIndex !== void 0) {
        _refVal = refVal[refIndex];
        refCode = "refVal[" + refIndex + "]";
        return resolvedRef(_refVal, refCode);
      }
      if (!isRoot && root2.refs) {
        var rootRefId = root2.refs[ref2];
        if (rootRefId !== void 0) {
          _refVal = root2.refVal[rootRefId];
          refCode = addLocalRef(ref2, _refVal);
          return resolvedRef(_refVal, refCode);
        }
      }
      refCode = addLocalRef(ref2);
      var v2 = resolve.call(self2, localCompile, root2, ref2);
      if (v2 === void 0) {
        var localSchema = localRefs && localRefs[ref2];
        if (localSchema) {
          v2 = resolve.inlineRef(localSchema, opts.inlineRefs) ? localSchema : compile2.call(self2, localSchema, root2, localRefs, baseId2);
        }
      }
      if (v2 === void 0) {
        removeLocalRef(ref2);
      } else {
        replaceLocalRef(ref2, v2);
        return resolvedRef(v2, refCode);
      }
    }
    function addLocalRef(ref2, v2) {
      var refId = refVal.length;
      refVal[refId] = v2;
      refs[ref2] = refId;
      return "refVal" + refId;
    }
    function removeLocalRef(ref2) {
      delete refs[ref2];
    }
    function replaceLocalRef(ref2, v2) {
      var refId = refs[ref2];
      refVal[refId] = v2;
    }
    function resolvedRef(refVal2, code) {
      return typeof refVal2 == "object" || typeof refVal2 == "boolean" ? {
        code,
        schema: refVal2,
        inline: true
      } : {
        code,
        $async: refVal2 && !!refVal2.$async
      };
    }
    function usePattern(regexStr) {
      var index2 = patternsHash[regexStr];
      if (index2 === void 0) {
        index2 = patternsHash[regexStr] = patterns.length;
        patterns[index2] = regexStr;
      }
      return "pattern" + index2;
    }
    function useDefault(value) {
      switch (typeof value) {
        case "boolean":
        case "number":
          return "" + value;
        case "string":
          return util2.toQuotedString(value);
        case "object":
          if (value === null) return "null";
          var valueStr = stableStringify(value);
          var index2 = defaultsHash[valueStr];
          if (index2 === void 0) {
            index2 = defaultsHash[valueStr] = defaults.length;
            defaults[index2] = value;
          }
          return "default" + index2;
      }
    }
    function useCustomRule(rule, schema3, parentSchema, it2) {
      if (self2._opts.validateSchema !== false) {
        var deps = rule.definition.dependencies;
        if (deps && !deps.every(function(keyword2) {
          return Object.prototype.hasOwnProperty.call(parentSchema, keyword2);
        })) throw new Error("parent schema must have all required keywords: " + deps.join(","));
        var validateSchema = rule.definition.validateSchema;
        if (validateSchema) {
          var valid = validateSchema(schema3);
          if (!valid) {
            var message = "keyword schema is invalid: " + self2.errorsText(validateSchema.errors);
            if (self2._opts.validateSchema == "log") self2.logger.error(message);
            else throw new Error(message);
          }
        }
      }
      var compile3 = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
      var validate2;
      if (compile3) {
        validate2 = compile3.call(self2, schema3, parentSchema, it2);
      } else if (macro) {
        validate2 = macro.call(self2, schema3, parentSchema, it2);
        if (opts.validateSchema !== false) self2.validateSchema(validate2, true);
      } else if (inline) {
        validate2 = inline.call(self2, it2, rule.keyword, schema3, parentSchema);
      } else {
        validate2 = rule.definition.validate;
        if (!validate2) return;
      }
      if (validate2 === void 0) throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
      var index2 = customRules.length;
      customRules[index2] = validate2;
      return {
        code: "customRule" + index2,
        validate: validate2
      };
    }
  }
  function checkCompiling(schema2, root2, baseId) {
    var index2 = compIndex.call(this, schema2, root2, baseId);
    if (index2 >= 0) return {
      index: index2,
      compiling: true
    };
    index2 = this._compilations.length;
    this._compilations[index2] = {
      schema: schema2,
      root: root2,
      baseId
    };
    return {
      index: index2,
      compiling: false
    };
  }
  function endCompiling(schema2, root2, baseId) {
    var i = compIndex.call(this, schema2, root2, baseId);
    if (i >= 0) this._compilations.splice(i, 1);
  }
  function compIndex(schema2, root2, baseId) {
    for (var i = 0; i < this._compilations.length; i++) {
      var c = this._compilations[i];
      if (c.schema == schema2 && c.root == root2 && c.baseId == baseId) return i;
    }
    return -1;
  }
  function patternCode(i, patterns) {
    return "var pattern" + i + " = new RegExp(" + util2.toQuotedString(patterns[i]) + ");";
  }
  function defaultCode(i) {
    return "var default" + i + " = defaults[" + i + "];";
  }
  function refValCode(i, refVal) {
    return refVal[i] === void 0 ? "" : "var refVal" + i + " = refVal[" + i + "];";
  }
  function customRuleCode(i) {
    return "var customRule" + i + " = customRules[" + i + "];";
  }
  function vars(arr, statement) {
    if (!arr.length) return "";
    var code = "";
    for (var i = 0; i < arr.length; i++) code += statement(i, arr);
    return code;
  }
  return compile_1;
}
var cache = { exports: {} };
var hasRequiredCache;
function requireCache() {
  if (hasRequiredCache) return cache.exports;
  hasRequiredCache = 1;
  var Cache = cache.exports = function Cache2() {
    this._cache = {};
  };
  Cache.prototype.put = function Cache_put(key, value) {
    this._cache[key] = value;
  };
  Cache.prototype.get = function Cache_get(key) {
    return this._cache[key];
  };
  Cache.prototype.del = function Cache_del(key) {
    delete this._cache[key];
  };
  Cache.prototype.clear = function Cache_clear() {
    this._cache = {};
  };
  return cache.exports;
}
var formats_1;
var hasRequiredFormats;
function requireFormats() {
  if (hasRequiredFormats) return formats_1;
  hasRequiredFormats = 1;
  var util2 = requireUtil();
  var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
  var DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
  var HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
  var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
  var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
  var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
  var URL2 = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
  var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
  var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
  var JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
  var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
  formats_1 = formats;
  function formats(mode) {
    mode = mode == "full" ? "full" : "fast";
    return util2.copy(formats[mode]);
  }
  formats.fast = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
    "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    "uri-template": URITEMPLATE,
    url: URL2,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    hostname: HOSTNAME,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: UUID,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": JSON_POINTER,
    "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": RELATIVE_JSON_POINTER
  };
  formats.full = {
    date: date2,
    time: time2,
    "date-time": date_time,
    uri: uri2,
    "uri-reference": URIREF,
    "uri-template": URITEMPLATE,
    url: URL2,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: HOSTNAME,
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex,
    uuid: UUID,
    "json-pointer": JSON_POINTER,
    "json-pointer-uri-fragment": JSON_POINTER_URI_FRAGMENT,
    "relative-json-pointer": RELATIVE_JSON_POINTER
  };
  function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  }
  function date2(str) {
    var matches = str.match(DATE);
    if (!matches) return false;
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
  }
  function time2(str, full) {
    var matches = str.match(TIME);
    if (!matches) return false;
    var hour = matches[1];
    var minute = matches[2];
    var second2 = matches[3];
    var timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second2 <= 59 || hour == 23 && minute == 59 && second2 == 60) && (!full || timeZone);
  }
  var DATE_TIME_SEPARATOR = /t|\s/i;
  function date_time(str) {
    var dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && date2(dateTime[0]) && time2(dateTime[1], true);
  }
  var NOT_URI_FRAGMENT = /\/|:/;
  function uri2(str) {
    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
  }
  var Z_ANCHOR = /[^\\]\\Z/;
  function regex(str) {
    if (Z_ANCHOR.test(str)) return false;
    try {
      new RegExp(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  return formats_1;
}
var ref;
var hasRequiredRef;
function requireRef() {
  if (hasRequiredRef) return ref;
  hasRequiredRef = 1;
  ref = function generate_ref(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $async, $refCode;
    if ($schema2 == "#" || $schema2 == "#/") {
      if (it2.isRoot) {
        $async = it2.async;
        $refCode = "validate";
      } else {
        $async = it2.root.schema.$async === true;
        $refCode = "root.refVal[0]";
      }
    } else {
      var $refVal = it2.resolveRef(it2.baseId, $schema2, it2.isRoot);
      if ($refVal === void 0) {
        var $message = it2.MissingRefError.message(it2.baseId, $schema2);
        if (it2.opts.missingRefs == "fail") {
          it2.logger.error($message);
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it2.createErrors !== false) {
            out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { ref: '" + it2.util.escapeQuotes($schema2) + "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: 'can\\'t resolve reference " + it2.util.escapeQuotes($schema2) + "' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: " + it2.util.toQuotedString($schema2) + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it2.compositeRule && $breakOnError) {
            if (it2.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
          if ($breakOnError) {
            out += " if (false) { ";
          }
        } else if (it2.opts.missingRefs == "ignore") {
          it2.logger.warn($message);
          if ($breakOnError) {
            out += " if (true) { ";
          }
        } else {
          throw new it2.MissingRefError(it2.baseId, $schema2, $message);
        }
      } else if ($refVal.inline) {
        var $it = it2.util.copy(it2);
        $it.level++;
        var $nextValid = "valid" + $it.level;
        $it.schema = $refVal.schema;
        $it.schemaPath = "";
        $it.errSchemaPath = $schema2;
        var $code = it2.validate($it).replace(/validate\.schema/g, $refVal.code);
        out += " " + $code + " ";
        if ($breakOnError) {
          out += " if (" + $nextValid + ") { ";
        }
      } else {
        $async = $refVal.$async === true || it2.async && $refVal.$async !== false;
        $refCode = $refVal.code;
      }
    }
    if ($refCode) {
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it2.opts.passContext) {
        out += " " + $refCode + ".call(this, ";
      } else {
        out += " " + $refCode + "( ";
      }
      out += " " + $data + ", (dataPath || '')";
      if (it2.errorPath != '""') {
        out += " + " + it2.errorPath;
      }
      var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it2.dataPathArr[$dataLvl] : "parentDataProperty";
      out += " , " + $parentData + " , " + $parentDataProperty + ", rootData)  ";
      var __callValidate = out;
      out = $$outStack.pop();
      if ($async) {
        if (!it2.async) throw new Error("async schema referenced by sync schema");
        if ($breakOnError) {
          out += " var " + $valid + "; ";
        }
        out += " try { await " + __callValidate + "; ";
        if ($breakOnError) {
          out += " " + $valid + " = true; ";
        }
        out += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ";
        if ($breakOnError) {
          out += " " + $valid + " = false; ";
        }
        out += " } ";
        if ($breakOnError) {
          out += " if (" + $valid + ") { ";
        }
      } else {
        out += " if (!" + __callValidate + ") { if (vErrors === null) vErrors = " + $refCode + ".errors; else vErrors = vErrors.concat(" + $refCode + ".errors); errors = vErrors.length; } ";
        if ($breakOnError) {
          out += " else { ";
        }
      }
    }
    return out;
  };
  return ref;
}
var allOf;
var hasRequiredAllOf;
function requireAllOf() {
  if (hasRequiredAllOf) return allOf;
  hasRequiredAllOf = 1;
  allOf = function generate_allOf(it2, $keyword, $ruleType) {
    var out = " ";
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
    var arr1 = $schema2;
    if (arr1) {
      var $sch, $i = -1, l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if (it2.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it2.util.schemaHasRules($sch, it2.RULES.all)) {
          $allSchemasEmpty = false;
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + "[" + $i + "]";
          $it.errSchemaPath = $errSchemaPath + "/" + $i;
          out += "  " + it2.validate($it) + " ";
          $it.baseId = $currentBaseId;
          if ($breakOnError) {
            out += " if (" + $nextValid + ") { ";
            $closingBraces += "}";
          }
        }
      }
    }
    if ($breakOnError) {
      if ($allSchemasEmpty) {
        out += " if (true) { ";
      } else {
        out += " " + $closingBraces.slice(0, -1) + " ";
      }
    }
    return out;
  };
  return allOf;
}
var anyOf;
var hasRequiredAnyOf;
function requireAnyOf() {
  if (hasRequiredAnyOf) return anyOf;
  hasRequiredAnyOf = 1;
  anyOf = function generate_anyOf(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $noEmptySchema = $schema2.every(function($sch2) {
      return it2.opts.strictKeywords ? typeof $sch2 == "object" && Object.keys($sch2).length > 0 || $sch2 === false : it2.util.schemaHasRules($sch2, it2.RULES.all);
    });
    if ($noEmptySchema) {
      var $currentBaseId = $it.baseId;
      out += " var " + $errs + " = errors; var " + $valid + " = false;  ";
      var $wasComposite = it2.compositeRule;
      it2.compositeRule = $it.compositeRule = true;
      var arr1 = $schema2;
      if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while ($i < l1) {
          $sch = arr1[$i += 1];
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + "[" + $i + "]";
          $it.errSchemaPath = $errSchemaPath + "/" + $i;
          out += "  " + it2.validate($it) + " ";
          $it.baseId = $currentBaseId;
          out += " " + $valid + " = " + $valid + " || " + $nextValid + "; if (!" + $valid + ") { ";
          $closingBraces += "}";
        }
      }
      it2.compositeRule = $it.compositeRule = $wasComposite;
      out += " " + $closingBraces + " if (!" + $valid + ") {   var err =   ";
      if (it2.createErrors !== false) {
        out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it2.opts.messages !== false) {
          out += " , message: 'should match some schema in anyOf' ";
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError(vErrors); ";
        } else {
          out += " validate.errors = vErrors; return false; ";
        }
      }
      out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
      if (it2.opts.allErrors) {
        out += " } ";
      }
    } else {
      if ($breakOnError) {
        out += " if (true) { ";
      }
    }
    return out;
  };
  return anyOf;
}
var comment;
var hasRequiredComment;
function requireComment() {
  if (hasRequiredComment) return comment;
  hasRequiredComment = 1;
  comment = function generate_comment(it2, $keyword, $ruleType) {
    var out = " ";
    var $schema2 = it2.schema[$keyword];
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    !it2.opts.allErrors;
    var $comment = it2.util.toQuotedString($schema2);
    if (it2.opts.$comment === true) {
      out += " console.log(" + $comment + ");";
    } else if (typeof it2.opts.$comment == "function") {
      out += " self._opts.$comment(" + $comment + ", " + it2.util.toQuotedString($errSchemaPath) + ", validate.root.schema);";
    }
    return out;
  };
  return comment;
}
var _const;
var hasRequired_const;
function require_const() {
  if (hasRequired_const) return _const;
  hasRequired_const = 1;
  _const = function generate_const(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it2.opts.$data && $schema2 && $schema2.$data;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
    }
    if (!$isData) {
      out += " var schema" + $lvl + " = validate.schema" + $schemaPath + ";";
    }
    out += "var " + $valid + " = equal(" + $data + ", schema" + $lvl + "); if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { allowedValue: schema" + $lvl + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should be equal to constant' ";
      }
      if (it2.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " }";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return _const;
}
var contains;
var hasRequiredContains;
function requireContains() {
  if (hasRequiredContains) return contains;
  hasRequiredContains = 1;
  contains = function generate_contains(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it2.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it2.baseId, $nonEmptySchema = it2.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it2.util.schemaHasRules($schema2, it2.RULES.all);
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if ($nonEmptySchema) {
      var $wasComposite = it2.compositeRule;
      it2.compositeRule = $it.compositeRule = true;
      $it.schema = $schema2;
      $it.schemaPath = $schemaPath;
      $it.errSchemaPath = $errSchemaPath;
      out += " var " + $nextValid + " = false; for (var " + $idx + " = 0; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
      $it.errorPath = it2.util.getPathExpr(it2.errorPath, $idx, it2.opts.jsonPointers, true);
      var $passData = $data + "[" + $idx + "]";
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it2.validate($it);
      $it.baseId = $currentBaseId;
      if (it2.util.varOccurences($code, $nextData) < 2) {
        out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
      } else {
        out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
      }
      out += " if (" + $nextValid + ") break; }  ";
      it2.compositeRule = $it.compositeRule = $wasComposite;
      out += " " + $closingBraces + " if (!" + $nextValid + ") {";
    } else {
      out += " if (" + $data + ".length == 0) {";
    }
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: {} ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should contain a valid item' ";
      }
      if (it2.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " } else { ";
    if ($nonEmptySchema) {
      out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
    }
    if (it2.opts.allErrors) {
      out += " } ";
    }
    return out;
  };
  return contains;
}
var dependencies;
var hasRequiredDependencies;
function requireDependencies() {
  if (hasRequiredDependencies) return dependencies;
  hasRequiredDependencies = 1;
  dependencies = function generate_dependencies(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it2.opts.ownProperties;
    for ($property in $schema2) {
      if ($property == "__proto__") continue;
      var $sch = $schema2[$property];
      var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
      $deps[$property] = $sch;
    }
    out += "var " + $errs + " = errors;";
    var $currentErrorPath = it2.errorPath;
    out += "var missing" + $lvl + ";";
    for (var $property in $propertyDeps) {
      $deps = $propertyDeps[$property];
      if ($deps.length) {
        out += " if ( " + $data + it2.util.getProperty($property) + " !== undefined ";
        if ($ownProperties) {
          out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($property) + "') ";
        }
        if ($breakOnError) {
          out += " && ( ";
          var arr1 = $deps;
          if (arr1) {
            var $propertyKey, $i = -1, l1 = arr1.length - 1;
            while ($i < l1) {
              $propertyKey = arr1[$i += 1];
              if ($i) {
                out += " || ";
              }
              var $prop = it2.util.getProperty($propertyKey), $useData = $data + $prop;
              out += " ( ( " + $useData + " === undefined ";
              if ($ownProperties) {
                out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
              }
              out += ") && (missing" + $lvl + " = " + it2.util.toQuotedString(it2.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
            }
          }
          out += ")) {  ";
          var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
          if (it2.opts._errorDataPathProperty) {
            it2.errorPath = it2.opts.jsonPointers ? it2.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
          }
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it2.createErrors !== false) {
            out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it2.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it2.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: 'should have ";
              if ($deps.length == 1) {
                out += "property " + it2.util.escapeQuotes($deps[0]);
              } else {
                out += "properties " + it2.util.escapeQuotes($deps.join(", "));
              }
              out += " when property " + it2.util.escapeQuotes($property) + " is present' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it2.compositeRule && $breakOnError) {
            if (it2.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
        } else {
          out += " ) { ";
          var arr2 = $deps;
          if (arr2) {
            var $propertyKey, i2 = -1, l2 = arr2.length - 1;
            while (i2 < l2) {
              $propertyKey = arr2[i2 += 1];
              var $prop = it2.util.getProperty($propertyKey), $missingProperty = it2.util.escapeQuotes($propertyKey), $useData = $data + $prop;
              if (it2.opts._errorDataPathProperty) {
                it2.errorPath = it2.util.getPath($currentErrorPath, $propertyKey, it2.opts.jsonPointers);
              }
              out += " if ( " + $useData + " === undefined ";
              if ($ownProperties) {
                out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
              }
              out += ") {  var err =   ";
              if (it2.createErrors !== false) {
                out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it2.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it2.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
                if (it2.opts.messages !== false) {
                  out += " , message: 'should have ";
                  if ($deps.length == 1) {
                    out += "property " + it2.util.escapeQuotes($deps[0]);
                  } else {
                    out += "properties " + it2.util.escapeQuotes($deps.join(", "));
                  }
                  out += " when property " + it2.util.escapeQuotes($property) + " is present' ";
                }
                if (it2.opts.verbose) {
                  out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
                }
                out += " } ";
              } else {
                out += " {} ";
              }
              out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
          }
        }
        out += " }   ";
        if ($breakOnError) {
          $closingBraces += "}";
          out += " else { ";
        }
      }
    }
    it2.errorPath = $currentErrorPath;
    var $currentBaseId = $it.baseId;
    for (var $property in $schemaDeps) {
      var $sch = $schemaDeps[$property];
      if (it2.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it2.util.schemaHasRules($sch, it2.RULES.all)) {
        out += " " + $nextValid + " = true; if ( " + $data + it2.util.getProperty($property) + " !== undefined ";
        if ($ownProperties) {
          out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($property) + "') ";
        }
        out += ") { ";
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + it2.util.getProperty($property);
        $it.errSchemaPath = $errSchemaPath + "/" + it2.util.escapeFragment($property);
        out += "  " + it2.validate($it) + " ";
        $it.baseId = $currentBaseId;
        out += " }  ";
        if ($breakOnError) {
          out += " if (" + $nextValid + ") { ";
          $closingBraces += "}";
        }
      }
    }
    if ($breakOnError) {
      out += "   " + $closingBraces + " if (" + $errs + " == errors) {";
    }
    return out;
  };
  return dependencies;
}
var _enum;
var hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1;
  _enum = function generate_enum(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it2.opts.$data && $schema2 && $schema2.$data;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
    }
    var $i = "i" + $lvl, $vSchema = "schema" + $lvl;
    if (!$isData) {
      out += " var " + $vSchema + " = validate.schema" + $schemaPath + ";";
    }
    out += "var " + $valid + ";";
    if ($isData) {
      out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
    }
    out += "" + $valid + " = false;for (var " + $i + "=0; " + $i + "<" + $vSchema + ".length; " + $i + "++) if (equal(" + $data + ", " + $vSchema + "[" + $i + "])) { " + $valid + " = true; break; }";
    if ($isData) {
      out += "  }  ";
    }
    out += " if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { allowedValues: schema" + $lvl + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should be equal to one of the allowed values' ";
      }
      if (it2.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " }";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return _enum;
}
var format;
var hasRequiredFormat;
function requireFormat() {
  if (hasRequiredFormat) return format;
  hasRequiredFormat = 1;
  format = function generate_format(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    if (it2.opts.format === false) {
      if ($breakOnError) {
        out += " if (true) { ";
      }
      return out;
    }
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    var $unknownFormats = it2.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
    if ($isData) {
      var $format = "format" + $lvl, $isObject = "isObject" + $lvl, $formatType = "formatType" + $lvl;
      out += " var " + $format + " = formats[" + $schemaValue + "]; var " + $isObject + " = typeof " + $format + " == 'object' && !(" + $format + " instanceof RegExp) && " + $format + ".validate; var " + $formatType + " = " + $isObject + " && " + $format + ".type || 'string'; if (" + $isObject + ") { ";
      if (it2.async) {
        out += " var async" + $lvl + " = " + $format + ".async; ";
      }
      out += " " + $format + " = " + $format + ".validate; } if (  ";
      if ($isData) {
        out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
      }
      out += " (";
      if ($unknownFormats != "ignore") {
        out += " (" + $schemaValue + " && !" + $format + " ";
        if ($allowUnknown) {
          out += " && self._opts.unknownFormats.indexOf(" + $schemaValue + ") == -1 ";
        }
        out += ") || ";
      }
      out += " (" + $format + " && " + $formatType + " == '" + $ruleType + "' && !(typeof " + $format + " == 'function' ? ";
      if (it2.async) {
        out += " (async" + $lvl + " ? await " + $format + "(" + $data + ") : " + $format + "(" + $data + ")) ";
      } else {
        out += " " + $format + "(" + $data + ") ";
      }
      out += " : " + $format + ".test(" + $data + "))))) {";
    } else {
      var $format = it2.formats[$schema2];
      if (!$format) {
        if ($unknownFormats == "ignore") {
          it2.logger.warn('unknown format "' + $schema2 + '" ignored in schema at path "' + it2.errSchemaPath + '"');
          if ($breakOnError) {
            out += " if (true) { ";
          }
          return out;
        } else if ($allowUnknown && $unknownFormats.indexOf($schema2) >= 0) {
          if ($breakOnError) {
            out += " if (true) { ";
          }
          return out;
        } else {
          throw new Error('unknown format "' + $schema2 + '" is used in schema at path "' + it2.errSchemaPath + '"');
        }
      }
      var $isObject = typeof $format == "object" && !($format instanceof RegExp) && $format.validate;
      var $formatType = $isObject && $format.type || "string";
      if ($isObject) {
        var $async = $format.async === true;
        $format = $format.validate;
      }
      if ($formatType != $ruleType) {
        if ($breakOnError) {
          out += " if (true) { ";
        }
        return out;
      }
      if ($async) {
        if (!it2.async) throw new Error("async format in sync schema");
        var $formatRef = "formats" + it2.util.getProperty($schema2) + ".validate";
        out += " if (!(await " + $formatRef + "(" + $data + "))) { ";
      } else {
        out += " if (! ";
        var $formatRef = "formats" + it2.util.getProperty($schema2);
        if ($isObject) $formatRef += ".validate";
        if (typeof $format == "function") {
          out += " " + $formatRef + "(" + $data + ") ";
        } else {
          out += " " + $formatRef + ".test(" + $data + ") ";
        }
        out += ") { ";
      }
    }
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { format:  ";
      if ($isData) {
        out += "" + $schemaValue;
      } else {
        out += "" + it2.util.toQuotedString($schema2);
      }
      out += "  } ";
      if (it2.opts.messages !== false) {
        out += ` , message: 'should match format "`;
        if ($isData) {
          out += "' + " + $schemaValue + " + '";
        } else {
          out += "" + it2.util.escapeQuotes($schema2);
        }
        out += `"' `;
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + it2.util.toQuotedString($schema2);
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " } ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return format;
}
var _if;
var hasRequired_if;
function require_if() {
  if (hasRequired_if) return _if;
  hasRequired_if = 1;
  _if = function generate_if(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $thenSch = it2.schema["then"], $elseSch = it2.schema["else"], $thenPresent = $thenSch !== void 0 && (it2.opts.strictKeywords ? typeof $thenSch == "object" && Object.keys($thenSch).length > 0 || $thenSch === false : it2.util.schemaHasRules($thenSch, it2.RULES.all)), $elsePresent = $elseSch !== void 0 && (it2.opts.strictKeywords ? typeof $elseSch == "object" && Object.keys($elseSch).length > 0 || $elseSch === false : it2.util.schemaHasRules($elseSch, it2.RULES.all)), $currentBaseId = $it.baseId;
    if ($thenPresent || $elsePresent) {
      var $ifClause;
      $it.createErrors = false;
      $it.schema = $schema2;
      $it.schemaPath = $schemaPath;
      $it.errSchemaPath = $errSchemaPath;
      out += " var " + $errs + " = errors; var " + $valid + " = true;  ";
      var $wasComposite = it2.compositeRule;
      it2.compositeRule = $it.compositeRule = true;
      out += "  " + it2.validate($it) + " ";
      $it.baseId = $currentBaseId;
      $it.createErrors = true;
      out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }  ";
      it2.compositeRule = $it.compositeRule = $wasComposite;
      if ($thenPresent) {
        out += " if (" + $nextValid + ") {  ";
        $it.schema = it2.schema["then"];
        $it.schemaPath = it2.schemaPath + ".then";
        $it.errSchemaPath = it2.errSchemaPath + "/then";
        out += "  " + it2.validate($it) + " ";
        $it.baseId = $currentBaseId;
        out += " " + $valid + " = " + $nextValid + "; ";
        if ($thenPresent && $elsePresent) {
          $ifClause = "ifClause" + $lvl;
          out += " var " + $ifClause + " = 'then'; ";
        } else {
          $ifClause = "'then'";
        }
        out += " } ";
        if ($elsePresent) {
          out += " else { ";
        }
      } else {
        out += " if (!" + $nextValid + ") { ";
      }
      if ($elsePresent) {
        $it.schema = it2.schema["else"];
        $it.schemaPath = it2.schemaPath + ".else";
        $it.errSchemaPath = it2.errSchemaPath + "/else";
        out += "  " + it2.validate($it) + " ";
        $it.baseId = $currentBaseId;
        out += " " + $valid + " = " + $nextValid + "; ";
        if ($thenPresent && $elsePresent) {
          $ifClause = "ifClause" + $lvl;
          out += " var " + $ifClause + " = 'else'; ";
        } else {
          $ifClause = "'else'";
        }
        out += " } ";
      }
      out += " if (!" + $valid + ") {   var err =   ";
      if (it2.createErrors !== false) {
        out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { failingKeyword: " + $ifClause + " } ";
        if (it2.opts.messages !== false) {
          out += ` , message: 'should match "' + ` + $ifClause + ` + '" schema' `;
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError(vErrors); ";
        } else {
          out += " validate.errors = vErrors; return false; ";
        }
      }
      out += " }   ";
      if ($breakOnError) {
        out += " else { ";
      }
    } else {
      if ($breakOnError) {
        out += " if (true) { ";
      }
    }
    return out;
  };
  return _if;
}
var items;
var hasRequiredItems;
function requireItems() {
  if (hasRequiredItems) return items;
  hasRequiredItems = 1;
  items = function generate_items(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it2.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it2.baseId;
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if (Array.isArray($schema2)) {
      var $additionalItems = it2.schema.additionalItems;
      if ($additionalItems === false) {
        out += " " + $valid + " = " + $data + ".length <= " + $schema2.length + "; ";
        var $currErrSchemaPath = $errSchemaPath;
        $errSchemaPath = it2.errSchemaPath + "/additionalItems";
        out += "  if (!" + $valid + ") {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it2.createErrors !== false) {
          out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schema2.length + " } ";
          if (it2.opts.messages !== false) {
            out += " , message: 'should NOT have more than " + $schema2.length + " items' ";
          }
          if (it2.opts.verbose) {
            out += " , schema: false , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it2.compositeRule && $breakOnError) {
          if (it2.async) {
            out += " throw new ValidationError([" + __err + "]); ";
          } else {
            out += " validate.errors = [" + __err + "]; return false; ";
          }
        } else {
          out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        out += " } ";
        $errSchemaPath = $currErrSchemaPath;
        if ($breakOnError) {
          $closingBraces += "}";
          out += " else { ";
        }
      }
      var arr1 = $schema2;
      if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while ($i < l1) {
          $sch = arr1[$i += 1];
          if (it2.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it2.util.schemaHasRules($sch, it2.RULES.all)) {
            out += " " + $nextValid + " = true; if (" + $data + ".length > " + $i + ") { ";
            var $passData = $data + "[" + $i + "]";
            $it.schema = $sch;
            $it.schemaPath = $schemaPath + "[" + $i + "]";
            $it.errSchemaPath = $errSchemaPath + "/" + $i;
            $it.errorPath = it2.util.getPathExpr(it2.errorPath, $i, it2.opts.jsonPointers, true);
            $it.dataPathArr[$dataNxt] = $i;
            var $code = it2.validate($it);
            $it.baseId = $currentBaseId;
            if (it2.util.varOccurences($code, $nextData) < 2) {
              out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
            } else {
              out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
            }
            out += " }  ";
            if ($breakOnError) {
              out += " if (" + $nextValid + ") { ";
              $closingBraces += "}";
            }
          }
        }
      }
      if (typeof $additionalItems == "object" && (it2.opts.strictKeywords ? typeof $additionalItems == "object" && Object.keys($additionalItems).length > 0 || $additionalItems === false : it2.util.schemaHasRules($additionalItems, it2.RULES.all))) {
        $it.schema = $additionalItems;
        $it.schemaPath = it2.schemaPath + ".additionalItems";
        $it.errSchemaPath = it2.errSchemaPath + "/additionalItems";
        out += " " + $nextValid + " = true; if (" + $data + ".length > " + $schema2.length + ") {  for (var " + $idx + " = " + $schema2.length + "; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
        $it.errorPath = it2.util.getPathExpr(it2.errorPath, $idx, it2.opts.jsonPointers, true);
        var $passData = $data + "[" + $idx + "]";
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it2.validate($it);
        $it.baseId = $currentBaseId;
        if (it2.util.varOccurences($code, $nextData) < 2) {
          out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
        } else {
          out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        }
        if ($breakOnError) {
          out += " if (!" + $nextValid + ") break; ";
        }
        out += " } }  ";
        if ($breakOnError) {
          out += " if (" + $nextValid + ") { ";
          $closingBraces += "}";
        }
      }
    } else if (it2.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it2.util.schemaHasRules($schema2, it2.RULES.all)) {
      $it.schema = $schema2;
      $it.schemaPath = $schemaPath;
      $it.errSchemaPath = $errSchemaPath;
      out += "  for (var " + $idx + " = 0; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
      $it.errorPath = it2.util.getPathExpr(it2.errorPath, $idx, it2.opts.jsonPointers, true);
      var $passData = $data + "[" + $idx + "]";
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it2.validate($it);
      $it.baseId = $currentBaseId;
      if (it2.util.varOccurences($code, $nextData) < 2) {
        out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
      } else {
        out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
      }
      if ($breakOnError) {
        out += " if (!" + $nextValid + ") break; ";
      }
      out += " }";
    }
    if ($breakOnError) {
      out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    }
    return out;
  };
  return items;
}
var _limit;
var hasRequired_limit;
function require_limit() {
  if (hasRequired_limit) return _limit;
  hasRequired_limit = 1;
  _limit = function generate__limit(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    var $isMax = $keyword == "maximum", $exclusiveKeyword = $isMax ? "exclusiveMaximum" : "exclusiveMinimum", $schemaExcl = it2.schema[$exclusiveKeyword], $isDataExcl = it2.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? "<" : ">", $notOp = $isMax ? ">" : "<", $errorKeyword = void 0;
    if (!($isData || typeof $schema2 == "number" || $schema2 === void 0)) {
      throw new Error($keyword + " must be number");
    }
    if (!($isDataExcl || $schemaExcl === void 0 || typeof $schemaExcl == "number" || typeof $schemaExcl == "boolean")) {
      throw new Error($exclusiveKeyword + " must be number or boolean");
    }
    if ($isDataExcl) {
      var $schemaValueExcl = it2.util.getData($schemaExcl.$data, $dataLvl, it2.dataPathArr), $exclusive = "exclusive" + $lvl, $exclType = "exclType" + $lvl, $exclIsNumber = "exclIsNumber" + $lvl, $opExpr = "op" + $lvl, $opStr = "' + " + $opExpr + " + '";
      out += " var schemaExcl" + $lvl + " = " + $schemaValueExcl + "; ";
      $schemaValueExcl = "schemaExcl" + $lvl;
      out += " var " + $exclusive + "; var " + $exclType + " = typeof " + $schemaValueExcl + "; if (" + $exclType + " != 'boolean' && " + $exclType + " != 'undefined' && " + $exclType + " != 'number') { ";
      var $errorKeyword = $exclusiveKeyword;
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it2.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it2.opts.messages !== false) {
          out += " , message: '" + $exclusiveKeyword + " should be boolean' ";
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError([" + __err + "]); ";
        } else {
          out += " validate.errors = [" + __err + "]; return false; ";
        }
      } else {
        out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
      out += " } else if ( ";
      if ($isData) {
        out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
      }
      out += " " + $exclType + " == 'number' ? ( (" + $exclusive + " = " + $schemaValue + " === undefined || " + $schemaValueExcl + " " + $op + "= " + $schemaValue + ") ? " + $data + " " + $notOp + "= " + $schemaValueExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) : ( (" + $exclusive + " = " + $schemaValueExcl + " === true) ? " + $data + " " + $notOp + "= " + $schemaValue + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { var op" + $lvl + " = " + $exclusive + " ? '" + $op + "' : '" + $op + "='; ";
      if ($schema2 === void 0) {
        $errorKeyword = $exclusiveKeyword;
        $errSchemaPath = it2.errSchemaPath + "/" + $exclusiveKeyword;
        $schemaValue = $schemaValueExcl;
        $isData = $isDataExcl;
      }
    } else {
      var $exclIsNumber = typeof $schemaExcl == "number", $opStr = $op;
      if ($exclIsNumber && $isData) {
        var $opExpr = "'" + $opStr + "'";
        out += " if ( ";
        if ($isData) {
          out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
        }
        out += " ( " + $schemaValue + " === undefined || " + $schemaExcl + " " + $op + "= " + $schemaValue + " ? " + $data + " " + $notOp + "= " + $schemaExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { ";
      } else {
        if ($exclIsNumber && $schema2 === void 0) {
          $exclusive = true;
          $errorKeyword = $exclusiveKeyword;
          $errSchemaPath = it2.errSchemaPath + "/" + $exclusiveKeyword;
          $schemaValue = $schemaExcl;
          $notOp += "=";
        } else {
          if ($exclIsNumber) $schemaValue = Math[$isMax ? "min" : "max"]($schemaExcl, $schema2);
          if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
            $exclusive = true;
            $errorKeyword = $exclusiveKeyword;
            $errSchemaPath = it2.errSchemaPath + "/" + $exclusiveKeyword;
            $notOp += "=";
          } else {
            $exclusive = false;
            $opStr += "=";
          }
        }
        var $opExpr = "'" + $opStr + "'";
        out += " if ( ";
        if ($isData) {
          out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
        }
        out += " " + $data + " " + $notOp + " " + $schemaValue + " || " + $data + " !== " + $data + ") { ";
      }
    }
    $errorKeyword = $errorKeyword || $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: '" + ($errorKeyword || "_limit") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { comparison: " + $opExpr + ", limit: " + $schemaValue + ", exclusive: " + $exclusive + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should be " + $opStr + " ";
        if ($isData) {
          out += "' + " + $schemaValue;
        } else {
          out += "" + $schemaValue + "'";
        }
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + $schema2;
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += " } ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return _limit;
}
var _limitItems;
var hasRequired_limitItems;
function require_limitItems() {
  if (hasRequired_limitItems) return _limitItems;
  hasRequired_limitItems = 1;
  _limitItems = function generate__limitItems(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    if (!($isData || typeof $schema2 == "number")) {
      throw new Error($keyword + " must be number");
    }
    var $op = $keyword == "maxItems" ? ">" : "<";
    out += "if ( ";
    if ($isData) {
      out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    }
    out += " " + $data + ".length " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: '" + ($errorKeyword || "_limitItems") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should NOT have ";
        if ($keyword == "maxItems") {
          out += "more";
        } else {
          out += "fewer";
        }
        out += " than ";
        if ($isData) {
          out += "' + " + $schemaValue + " + '";
        } else {
          out += "" + $schema2;
        }
        out += " items' ";
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + $schema2;
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += "} ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return _limitItems;
}
var _limitLength;
var hasRequired_limitLength;
function require_limitLength() {
  if (hasRequired_limitLength) return _limitLength;
  hasRequired_limitLength = 1;
  _limitLength = function generate__limitLength(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    if (!($isData || typeof $schema2 == "number")) {
      throw new Error($keyword + " must be number");
    }
    var $op = $keyword == "maxLength" ? ">" : "<";
    out += "if ( ";
    if ($isData) {
      out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    }
    if (it2.opts.unicode === false) {
      out += " " + $data + ".length ";
    } else {
      out += " ucs2length(" + $data + ") ";
    }
    out += " " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: '" + ($errorKeyword || "_limitLength") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should NOT be ";
        if ($keyword == "maxLength") {
          out += "longer";
        } else {
          out += "shorter";
        }
        out += " than ";
        if ($isData) {
          out += "' + " + $schemaValue + " + '";
        } else {
          out += "" + $schema2;
        }
        out += " characters' ";
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + $schema2;
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += "} ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return _limitLength;
}
var _limitProperties;
var hasRequired_limitProperties;
function require_limitProperties() {
  if (hasRequired_limitProperties) return _limitProperties;
  hasRequired_limitProperties = 1;
  _limitProperties = function generate__limitProperties(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    if (!($isData || typeof $schema2 == "number")) {
      throw new Error($keyword + " must be number");
    }
    var $op = $keyword == "maxProperties" ? ">" : "<";
    out += "if ( ";
    if ($isData) {
      out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    }
    out += " Object.keys(" + $data + ").length " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: '" + ($errorKeyword || "_limitProperties") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should NOT have ";
        if ($keyword == "maxProperties") {
          out += "more";
        } else {
          out += "fewer";
        }
        out += " than ";
        if ($isData) {
          out += "' + " + $schemaValue + " + '";
        } else {
          out += "" + $schema2;
        }
        out += " properties' ";
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + $schema2;
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += "} ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return _limitProperties;
}
var multipleOf;
var hasRequiredMultipleOf;
function requireMultipleOf() {
  if (hasRequiredMultipleOf) return multipleOf;
  hasRequiredMultipleOf = 1;
  multipleOf = function generate_multipleOf(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    if (!($isData || typeof $schema2 == "number")) {
      throw new Error($keyword + " must be number");
    }
    out += "var division" + $lvl + ";if (";
    if ($isData) {
      out += " " + $schemaValue + " !== undefined && ( typeof " + $schemaValue + " != 'number' || ";
    }
    out += " (division" + $lvl + " = " + $data + " / " + $schemaValue + ", ";
    if (it2.opts.multipleOfPrecision) {
      out += " Math.abs(Math.round(division" + $lvl + ") - division" + $lvl + ") > 1e-" + it2.opts.multipleOfPrecision + " ";
    } else {
      out += " division" + $lvl + " !== parseInt(division" + $lvl + ") ";
    }
    out += " ) ";
    if ($isData) {
      out += "  )  ";
    }
    out += " ) {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { multipleOf: " + $schemaValue + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should be multiple of ";
        if ($isData) {
          out += "' + " + $schemaValue;
        } else {
          out += "" + $schemaValue + "'";
        }
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + $schema2;
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += "} ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return multipleOf;
}
var not;
var hasRequiredNot;
function requireNot() {
  if (hasRequiredNot) return not;
  hasRequiredNot = 1;
  not = function generate_not(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    $it.level++;
    var $nextValid = "valid" + $it.level;
    if (it2.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it2.util.schemaHasRules($schema2, it2.RULES.all)) {
      $it.schema = $schema2;
      $it.schemaPath = $schemaPath;
      $it.errSchemaPath = $errSchemaPath;
      out += " var " + $errs + " = errors;  ";
      var $wasComposite = it2.compositeRule;
      it2.compositeRule = $it.compositeRule = true;
      $it.createErrors = false;
      var $allErrorsOption;
      if ($it.opts.allErrors) {
        $allErrorsOption = $it.opts.allErrors;
        $it.opts.allErrors = false;
      }
      out += " " + it2.validate($it) + " ";
      $it.createErrors = true;
      if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
      it2.compositeRule = $it.compositeRule = $wasComposite;
      out += " if (" + $nextValid + ") {   ";
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it2.createErrors !== false) {
        out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it2.opts.messages !== false) {
          out += " , message: 'should NOT be valid' ";
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError([" + __err + "]); ";
        } else {
          out += " validate.errors = [" + __err + "]; return false; ";
        }
      } else {
        out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
      out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
      if (it2.opts.allErrors) {
        out += " } ";
      }
    } else {
      out += "  var err =   ";
      if (it2.createErrors !== false) {
        out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it2.opts.messages !== false) {
          out += " , message: 'should NOT be valid' ";
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      if ($breakOnError) {
        out += " if (false) { ";
      }
    }
    return out;
  };
  return not;
}
var oneOf;
var hasRequiredOneOf;
function requireOneOf() {
  if (hasRequiredOneOf) return oneOf;
  hasRequiredOneOf = 1;
  oneOf = function generate_oneOf(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $currentBaseId = $it.baseId, $prevValid = "prevValid" + $lvl, $passingSchemas = "passingSchemas" + $lvl;
    out += "var " + $errs + " = errors , " + $prevValid + " = false , " + $valid + " = false , " + $passingSchemas + " = null; ";
    var $wasComposite = it2.compositeRule;
    it2.compositeRule = $it.compositeRule = true;
    var arr1 = $schema2;
    if (arr1) {
      var $sch, $i = -1, l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if (it2.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it2.util.schemaHasRules($sch, it2.RULES.all)) {
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + "[" + $i + "]";
          $it.errSchemaPath = $errSchemaPath + "/" + $i;
          out += "  " + it2.validate($it) + " ";
          $it.baseId = $currentBaseId;
        } else {
          out += " var " + $nextValid + " = true; ";
        }
        if ($i) {
          out += " if (" + $nextValid + " && " + $prevValid + ") { " + $valid + " = false; " + $passingSchemas + " = [" + $passingSchemas + ", " + $i + "]; } else { ";
          $closingBraces += "}";
        }
        out += " if (" + $nextValid + ") { " + $valid + " = " + $prevValid + " = true; " + $passingSchemas + " = " + $i + "; }";
      }
    }
    it2.compositeRule = $it.compositeRule = $wasComposite;
    out += "" + $closingBraces + "if (!" + $valid + ") {   var err =   ";
    if (it2.createErrors !== false) {
      out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { passingSchemas: " + $passingSchemas + " } ";
      if (it2.opts.messages !== false) {
        out += " , message: 'should match exactly one schema in oneOf' ";
      }
      if (it2.opts.verbose) {
        out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError(vErrors); ";
      } else {
        out += " validate.errors = vErrors; return false; ";
      }
    }
    out += "} else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }";
    if (it2.opts.allErrors) {
      out += " } ";
    }
    return out;
  };
  return oneOf;
}
var pattern;
var hasRequiredPattern;
function requirePattern() {
  if (hasRequiredPattern) return pattern;
  hasRequiredPattern = 1;
  pattern = function generate_pattern(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    var $regexp = $isData ? "(new RegExp(" + $schemaValue + "))" : it2.usePattern($schema2);
    out += "if ( ";
    if ($isData) {
      out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
    }
    out += " !" + $regexp + ".test(" + $data + ") ) {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = "";
    if (it2.createErrors !== false) {
      out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { pattern:  ";
      if ($isData) {
        out += "" + $schemaValue;
      } else {
        out += "" + it2.util.toQuotedString($schema2);
      }
      out += "  } ";
      if (it2.opts.messages !== false) {
        out += ` , message: 'should match pattern "`;
        if ($isData) {
          out += "' + " + $schemaValue + " + '";
        } else {
          out += "" + it2.util.escapeQuotes($schema2);
        }
        out += `"' `;
      }
      if (it2.opts.verbose) {
        out += " , schema:  ";
        if ($isData) {
          out += "validate.schema" + $schemaPath;
        } else {
          out += "" + it2.util.toQuotedString($schema2);
        }
        out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
      }
      out += " } ";
    } else {
      out += " {} ";
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it2.compositeRule && $breakOnError) {
      if (it2.async) {
        out += " throw new ValidationError([" + __err + "]); ";
      } else {
        out += " validate.errors = [" + __err + "]; return false; ";
      }
    } else {
      out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    }
    out += "} ";
    if ($breakOnError) {
      out += " else { ";
    }
    return out;
  };
  return pattern;
}
var properties$3;
var hasRequiredProperties;
function requireProperties() {
  if (hasRequiredProperties) return properties$3;
  hasRequiredProperties = 1;
  properties$3 = function generate_properties(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $key = "key" + $lvl, $idx = "idx" + $lvl, $dataNxt = $it.dataLevel = it2.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl;
    var $schemaKeys = Object.keys($schema2 || {}).filter(notProto), $pProperties = it2.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it2.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == "object" && Object.keys($aProperties).length, $removeAdditional = it2.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it2.opts.ownProperties, $currentBaseId = it2.baseId;
    var $required = it2.schema.required;
    if ($required && !(it2.opts.$data && $required.$data) && $required.length < it2.opts.loopRequired) {
      var $requiredHash = it2.util.toHash($required);
    }
    function notProto(p) {
      return p !== "__proto__";
    }
    out += "var " + $errs + " = errors;var " + $nextValid + " = true;";
    if ($ownProperties) {
      out += " var " + $dataProperties + " = undefined;";
    }
    if ($checkAdditional) {
      if ($ownProperties) {
        out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
      } else {
        out += " for (var " + $key + " in " + $data + ") { ";
      }
      if ($someProperties) {
        out += " var isAdditional" + $lvl + " = !(false ";
        if ($schemaKeys.length) {
          if ($schemaKeys.length > 8) {
            out += " || validate.schema" + $schemaPath + ".hasOwnProperty(" + $key + ") ";
          } else {
            var arr1 = $schemaKeys;
            if (arr1) {
              var $propertyKey, i1 = -1, l1 = arr1.length - 1;
              while (i1 < l1) {
                $propertyKey = arr1[i1 += 1];
                out += " || " + $key + " == " + it2.util.toQuotedString($propertyKey) + " ";
              }
            }
          }
        }
        if ($pPropertyKeys.length) {
          var arr2 = $pPropertyKeys;
          if (arr2) {
            var $pProperty, $i = -1, l2 = arr2.length - 1;
            while ($i < l2) {
              $pProperty = arr2[$i += 1];
              out += " || " + it2.usePattern($pProperty) + ".test(" + $key + ") ";
            }
          }
        }
        out += " ); if (isAdditional" + $lvl + ") { ";
      }
      if ($removeAdditional == "all") {
        out += " delete " + $data + "[" + $key + "]; ";
      } else {
        var $currentErrorPath = it2.errorPath;
        var $additionalProperty = "' + " + $key + " + '";
        if (it2.opts._errorDataPathProperty) {
          it2.errorPath = it2.util.getPathExpr(it2.errorPath, $key, it2.opts.jsonPointers);
        }
        if ($noAdditional) {
          if ($removeAdditional) {
            out += " delete " + $data + "[" + $key + "]; ";
          } else {
            out += " " + $nextValid + " = false; ";
            var $currErrSchemaPath = $errSchemaPath;
            $errSchemaPath = it2.errSchemaPath + "/additionalProperties";
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = "";
            if (it2.createErrors !== false) {
              out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { additionalProperty: '" + $additionalProperty + "' } ";
              if (it2.opts.messages !== false) {
                out += " , message: '";
                if (it2.opts._errorDataPathProperty) {
                  out += "is an invalid additional property";
                } else {
                  out += "should NOT have additional properties";
                }
                out += "' ";
              }
              if (it2.opts.verbose) {
                out += " , schema: false , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
              }
              out += " } ";
            } else {
              out += " {} ";
            }
            var __err = out;
            out = $$outStack.pop();
            if (!it2.compositeRule && $breakOnError) {
              if (it2.async) {
                out += " throw new ValidationError([" + __err + "]); ";
              } else {
                out += " validate.errors = [" + __err + "]; return false; ";
              }
            } else {
              out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            }
            $errSchemaPath = $currErrSchemaPath;
            if ($breakOnError) {
              out += " break; ";
            }
          }
        } else if ($additionalIsSchema) {
          if ($removeAdditional == "failing") {
            out += " var " + $errs + " = errors;  ";
            var $wasComposite = it2.compositeRule;
            it2.compositeRule = $it.compositeRule = true;
            $it.schema = $aProperties;
            $it.schemaPath = it2.schemaPath + ".additionalProperties";
            $it.errSchemaPath = it2.errSchemaPath + "/additionalProperties";
            $it.errorPath = it2.opts._errorDataPathProperty ? it2.errorPath : it2.util.getPathExpr(it2.errorPath, $key, it2.opts.jsonPointers);
            var $passData = $data + "[" + $key + "]";
            $it.dataPathArr[$dataNxt] = $key;
            var $code = it2.validate($it);
            $it.baseId = $currentBaseId;
            if (it2.util.varOccurences($code, $nextData) < 2) {
              out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
            } else {
              out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
            }
            out += " if (!" + $nextValid + ") { errors = " + $errs + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + $data + "[" + $key + "]; }  ";
            it2.compositeRule = $it.compositeRule = $wasComposite;
          } else {
            $it.schema = $aProperties;
            $it.schemaPath = it2.schemaPath + ".additionalProperties";
            $it.errSchemaPath = it2.errSchemaPath + "/additionalProperties";
            $it.errorPath = it2.opts._errorDataPathProperty ? it2.errorPath : it2.util.getPathExpr(it2.errorPath, $key, it2.opts.jsonPointers);
            var $passData = $data + "[" + $key + "]";
            $it.dataPathArr[$dataNxt] = $key;
            var $code = it2.validate($it);
            $it.baseId = $currentBaseId;
            if (it2.util.varOccurences($code, $nextData) < 2) {
              out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
            } else {
              out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
            }
            if ($breakOnError) {
              out += " if (!" + $nextValid + ") break; ";
            }
          }
        }
        it2.errorPath = $currentErrorPath;
      }
      if ($someProperties) {
        out += " } ";
      }
      out += " }  ";
      if ($breakOnError) {
        out += " if (" + $nextValid + ") { ";
        $closingBraces += "}";
      }
    }
    var $useDefaults = it2.opts.useDefaults && !it2.compositeRule;
    if ($schemaKeys.length) {
      var arr3 = $schemaKeys;
      if (arr3) {
        var $propertyKey, i3 = -1, l3 = arr3.length - 1;
        while (i3 < l3) {
          $propertyKey = arr3[i3 += 1];
          var $sch = $schema2[$propertyKey];
          if (it2.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it2.util.schemaHasRules($sch, it2.RULES.all)) {
            var $prop = it2.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== void 0;
            $it.schema = $sch;
            $it.schemaPath = $schemaPath + $prop;
            $it.errSchemaPath = $errSchemaPath + "/" + it2.util.escapeFragment($propertyKey);
            $it.errorPath = it2.util.getPath(it2.errorPath, $propertyKey, it2.opts.jsonPointers);
            $it.dataPathArr[$dataNxt] = it2.util.toQuotedString($propertyKey);
            var $code = it2.validate($it);
            $it.baseId = $currentBaseId;
            if (it2.util.varOccurences($code, $nextData) < 2) {
              $code = it2.util.varReplace($code, $nextData, $passData);
              var $useData = $passData;
            } else {
              var $useData = $nextData;
              out += " var " + $nextData + " = " + $passData + "; ";
            }
            if ($hasDefault) {
              out += " " + $code + " ";
            } else {
              if ($requiredHash && $requiredHash[$propertyKey]) {
                out += " if ( " + $useData + " === undefined ";
                if ($ownProperties) {
                  out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
                }
                out += ") { " + $nextValid + " = false; ";
                var $currentErrorPath = it2.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it2.util.escapeQuotes($propertyKey);
                if (it2.opts._errorDataPathProperty) {
                  it2.errorPath = it2.util.getPath($currentErrorPath, $propertyKey, it2.opts.jsonPointers);
                }
                $errSchemaPath = it2.errSchemaPath + "/required";
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = "";
                if (it2.createErrors !== false) {
                  out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                  if (it2.opts.messages !== false) {
                    out += " , message: '";
                    if (it2.opts._errorDataPathProperty) {
                      out += "is a required property";
                    } else {
                      out += "should have required property \\'" + $missingProperty + "\\'";
                    }
                    out += "' ";
                  }
                  if (it2.opts.verbose) {
                    out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
                  }
                  out += " } ";
                } else {
                  out += " {} ";
                }
                var __err = out;
                out = $$outStack.pop();
                if (!it2.compositeRule && $breakOnError) {
                  if (it2.async) {
                    out += " throw new ValidationError([" + __err + "]); ";
                  } else {
                    out += " validate.errors = [" + __err + "]; return false; ";
                  }
                } else {
                  out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                }
                $errSchemaPath = $currErrSchemaPath;
                it2.errorPath = $currentErrorPath;
                out += " } else { ";
              } else {
                if ($breakOnError) {
                  out += " if ( " + $useData + " === undefined ";
                  if ($ownProperties) {
                    out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
                  }
                  out += ") { " + $nextValid + " = true; } else { ";
                } else {
                  out += " if (" + $useData + " !== undefined ";
                  if ($ownProperties) {
                    out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
                  }
                  out += " ) { ";
                }
              }
              out += " " + $code + " } ";
            }
          }
          if ($breakOnError) {
            out += " if (" + $nextValid + ") { ";
            $closingBraces += "}";
          }
        }
      }
    }
    if ($pPropertyKeys.length) {
      var arr4 = $pPropertyKeys;
      if (arr4) {
        var $pProperty, i4 = -1, l4 = arr4.length - 1;
        while (i4 < l4) {
          $pProperty = arr4[i4 += 1];
          var $sch = $pProperties[$pProperty];
          if (it2.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it2.util.schemaHasRules($sch, it2.RULES.all)) {
            $it.schema = $sch;
            $it.schemaPath = it2.schemaPath + ".patternProperties" + it2.util.getProperty($pProperty);
            $it.errSchemaPath = it2.errSchemaPath + "/patternProperties/" + it2.util.escapeFragment($pProperty);
            if ($ownProperties) {
              out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
            } else {
              out += " for (var " + $key + " in " + $data + ") { ";
            }
            out += " if (" + it2.usePattern($pProperty) + ".test(" + $key + ")) { ";
            $it.errorPath = it2.util.getPathExpr(it2.errorPath, $key, it2.opts.jsonPointers);
            var $passData = $data + "[" + $key + "]";
            $it.dataPathArr[$dataNxt] = $key;
            var $code = it2.validate($it);
            $it.baseId = $currentBaseId;
            if (it2.util.varOccurences($code, $nextData) < 2) {
              out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
            } else {
              out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
            }
            if ($breakOnError) {
              out += " if (!" + $nextValid + ") break; ";
            }
            out += " } ";
            if ($breakOnError) {
              out += " else " + $nextValid + " = true; ";
            }
            out += " }  ";
            if ($breakOnError) {
              out += " if (" + $nextValid + ") { ";
              $closingBraces += "}";
            }
          }
        }
      }
    }
    if ($breakOnError) {
      out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    }
    return out;
  };
  return properties$3;
}
var propertyNames;
var hasRequiredPropertyNames;
function requirePropertyNames() {
  if (hasRequiredPropertyNames) return propertyNames;
  hasRequiredPropertyNames = 1;
  propertyNames = function generate_propertyNames(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it2.util.copy(it2);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    out += "var " + $errs + " = errors;";
    if (it2.opts.strictKeywords ? typeof $schema2 == "object" && Object.keys($schema2).length > 0 || $schema2 === false : it2.util.schemaHasRules($schema2, it2.RULES.all)) {
      $it.schema = $schema2;
      $it.schemaPath = $schemaPath;
      $it.errSchemaPath = $errSchemaPath;
      var $key = "key" + $lvl, $idx = "idx" + $lvl, $i = "i" + $lvl, $invalidName = "' + " + $key + " + '", $dataNxt = $it.dataLevel = it2.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl, $ownProperties = it2.opts.ownProperties, $currentBaseId = it2.baseId;
      if ($ownProperties) {
        out += " var " + $dataProperties + " = undefined; ";
      }
      if ($ownProperties) {
        out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
      } else {
        out += " for (var " + $key + " in " + $data + ") { ";
      }
      out += " var startErrs" + $lvl + " = errors; ";
      var $passData = $key;
      var $wasComposite = it2.compositeRule;
      it2.compositeRule = $it.compositeRule = true;
      var $code = it2.validate($it);
      $it.baseId = $currentBaseId;
      if (it2.util.varOccurences($code, $nextData) < 2) {
        out += " " + it2.util.varReplace($code, $nextData, $passData) + " ";
      } else {
        out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
      }
      it2.compositeRule = $it.compositeRule = $wasComposite;
      out += " if (!" + $nextValid + ") { for (var " + $i + "=startErrs" + $lvl + "; " + $i + "<errors; " + $i + "++) { vErrors[" + $i + "].propertyName = " + $key + "; }   var err =   ";
      if (it2.createErrors !== false) {
        out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { propertyName: '" + $invalidName + "' } ";
        if (it2.opts.messages !== false) {
          out += " , message: 'property name \\'" + $invalidName + "\\' is invalid' ";
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError(vErrors); ";
        } else {
          out += " validate.errors = vErrors; return false; ";
        }
      }
      if ($breakOnError) {
        out += " break; ";
      }
      out += " } }";
    }
    if ($breakOnError) {
      out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    }
    return out;
  };
  return propertyNames;
}
var required$2;
var hasRequiredRequired;
function requireRequired() {
  if (hasRequiredRequired) return required$2;
  hasRequiredRequired = 1;
  required$2 = function generate_required(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it2.opts.$data && $schema2 && $schema2.$data;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
    }
    var $vSchema = "schema" + $lvl;
    if (!$isData) {
      if ($schema2.length < it2.opts.loopRequired && it2.schema.properties && Object.keys(it2.schema.properties).length) {
        var $required = [];
        var arr1 = $schema2;
        if (arr1) {
          var $property, i1 = -1, l1 = arr1.length - 1;
          while (i1 < l1) {
            $property = arr1[i1 += 1];
            var $propertySch = it2.schema.properties[$property];
            if (!($propertySch && (it2.opts.strictKeywords ? typeof $propertySch == "object" && Object.keys($propertySch).length > 0 || $propertySch === false : it2.util.schemaHasRules($propertySch, it2.RULES.all)))) {
              $required[$required.length] = $property;
            }
          }
        }
      } else {
        var $required = $schema2;
      }
    }
    if ($isData || $required.length) {
      var $currentErrorPath = it2.errorPath, $loopRequired = $isData || $required.length >= it2.opts.loopRequired, $ownProperties = it2.opts.ownProperties;
      if ($breakOnError) {
        out += " var missing" + $lvl + "; ";
        if ($loopRequired) {
          if (!$isData) {
            out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
          }
          var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
          if (it2.opts._errorDataPathProperty) {
            it2.errorPath = it2.util.getPathExpr($currentErrorPath, $propertyPath, it2.opts.jsonPointers);
          }
          out += " var " + $valid + " = true; ";
          if ($isData) {
            out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
          }
          out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { " + $valid + " = " + $data + "[" + $vSchema + "[" + $i + "]] !== undefined ";
          if ($ownProperties) {
            out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
          }
          out += "; if (!" + $valid + ") break; } ";
          if ($isData) {
            out += "  }  ";
          }
          out += "  if (!" + $valid + ") {   ";
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it2.createErrors !== false) {
            out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: '";
              if (it2.opts._errorDataPathProperty) {
                out += "is a required property";
              } else {
                out += "should have required property \\'" + $missingProperty + "\\'";
              }
              out += "' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it2.compositeRule && $breakOnError) {
            if (it2.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
          out += " } else { ";
        } else {
          out += " if ( ";
          var arr2 = $required;
          if (arr2) {
            var $propertyKey, $i = -1, l2 = arr2.length - 1;
            while ($i < l2) {
              $propertyKey = arr2[$i += 1];
              if ($i) {
                out += " || ";
              }
              var $prop = it2.util.getProperty($propertyKey), $useData = $data + $prop;
              out += " ( ( " + $useData + " === undefined ";
              if ($ownProperties) {
                out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
              }
              out += ") && (missing" + $lvl + " = " + it2.util.toQuotedString(it2.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
            }
          }
          out += ") {  ";
          var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
          if (it2.opts._errorDataPathProperty) {
            it2.errorPath = it2.opts.jsonPointers ? it2.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
          }
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = "";
          if (it2.createErrors !== false) {
            out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: '";
              if (it2.opts._errorDataPathProperty) {
                out += "is a required property";
              } else {
                out += "should have required property \\'" + $missingProperty + "\\'";
              }
              out += "' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it2.compositeRule && $breakOnError) {
            if (it2.async) {
              out += " throw new ValidationError([" + __err + "]); ";
            } else {
              out += " validate.errors = [" + __err + "]; return false; ";
            }
          } else {
            out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          }
          out += " } else { ";
        }
      } else {
        if ($loopRequired) {
          if (!$isData) {
            out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
          }
          var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
          if (it2.opts._errorDataPathProperty) {
            it2.errorPath = it2.util.getPathExpr($currentErrorPath, $propertyPath, it2.opts.jsonPointers);
          }
          if ($isData) {
            out += " if (" + $vSchema + " && !Array.isArray(" + $vSchema + ")) {  var err =   ";
            if (it2.createErrors !== false) {
              out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
              if (it2.opts.messages !== false) {
                out += " , message: '";
                if (it2.opts._errorDataPathProperty) {
                  out += "is a required property";
                } else {
                  out += "should have required property \\'" + $missingProperty + "\\'";
                }
                out += "' ";
              }
              if (it2.opts.verbose) {
                out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
              }
              out += " } ";
            } else {
              out += " {} ";
            }
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + $vSchema + " !== undefined) { ";
          }
          out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { if (" + $data + "[" + $vSchema + "[" + $i + "]] === undefined ";
          if ($ownProperties) {
            out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
          }
          out += ") {  var err =   ";
          if (it2.createErrors !== false) {
            out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
            if (it2.opts.messages !== false) {
              out += " , message: '";
              if (it2.opts._errorDataPathProperty) {
                out += "is a required property";
              } else {
                out += "should have required property \\'" + $missingProperty + "\\'";
              }
              out += "' ";
            }
            if (it2.opts.verbose) {
              out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
          } else {
            out += " {} ";
          }
          out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ";
          if ($isData) {
            out += "  }  ";
          }
        } else {
          var arr3 = $required;
          if (arr3) {
            var $propertyKey, i3 = -1, l3 = arr3.length - 1;
            while (i3 < l3) {
              $propertyKey = arr3[i3 += 1];
              var $prop = it2.util.getProperty($propertyKey), $missingProperty = it2.util.escapeQuotes($propertyKey), $useData = $data + $prop;
              if (it2.opts._errorDataPathProperty) {
                it2.errorPath = it2.util.getPath($currentErrorPath, $propertyKey, it2.opts.jsonPointers);
              }
              out += " if ( " + $useData + " === undefined ";
              if ($ownProperties) {
                out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it2.util.escapeQuotes($propertyKey) + "') ";
              }
              out += ") {  var err =   ";
              if (it2.createErrors !== false) {
                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                if (it2.opts.messages !== false) {
                  out += " , message: '";
                  if (it2.opts._errorDataPathProperty) {
                    out += "is a required property";
                  } else {
                    out += "should have required property \\'" + $missingProperty + "\\'";
                  }
                  out += "' ";
                }
                if (it2.opts.verbose) {
                  out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
                }
                out += " } ";
              } else {
                out += " {} ";
              }
              out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
          }
        }
      }
      it2.errorPath = $currentErrorPath;
    } else if ($breakOnError) {
      out += " if (true) {";
    }
    return out;
  };
  return required$2;
}
var uniqueItems;
var hasRequiredUniqueItems;
function requireUniqueItems() {
  if (hasRequiredUniqueItems) return uniqueItems;
  hasRequiredUniqueItems = 1;
  uniqueItems = function generate_uniqueItems(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    if (($schema2 || $isData) && it2.opts.uniqueItems !== false) {
      if ($isData) {
        out += " var " + $valid + "; if (" + $schemaValue + " === false || " + $schemaValue + " === undefined) " + $valid + " = true; else if (typeof " + $schemaValue + " != 'boolean') " + $valid + " = false; else { ";
      }
      out += " var i = " + $data + ".length , " + $valid + " = true , j; if (i > 1) { ";
      var $itemType = it2.schema.items && it2.schema.items.type, $typeIsArray = Array.isArray($itemType);
      if (!$itemType || $itemType == "object" || $itemType == "array" || $typeIsArray && ($itemType.indexOf("object") >= 0 || $itemType.indexOf("array") >= 0)) {
        out += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + $data + "[i], " + $data + "[j])) { " + $valid + " = false; break outer; } } } ";
      } else {
        out += " var itemIndices = {}, item; for (;i--;) { var item = " + $data + "[i]; ";
        var $method = "checkDataType" + ($typeIsArray ? "s" : "");
        out += " if (" + it2.util[$method]($itemType, "item", it2.opts.strictNumbers, true) + ") continue; ";
        if ($typeIsArray) {
          out += ` if (typeof item == 'string') item = '"' + item; `;
        }
        out += " if (typeof itemIndices[item] == 'number') { " + $valid + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
      }
      out += " } ";
      if ($isData) {
        out += "  }  ";
      }
      out += " if (!" + $valid + ") {   ";
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it2.createErrors !== false) {
        out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { i: i, j: j } ";
        if (it2.opts.messages !== false) {
          out += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' ";
        }
        if (it2.opts.verbose) {
          out += " , schema:  ";
          if ($isData) {
            out += "validate.schema" + $schemaPath;
          } else {
            out += "" + $schema2;
          }
          out += "         , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError([" + __err + "]); ";
        } else {
          out += " validate.errors = [" + __err + "]; return false; ";
        }
      } else {
        out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
      out += " } ";
      if ($breakOnError) {
        out += " else { ";
      }
    } else {
      if ($breakOnError) {
        out += " if (true) { ";
      }
    }
    return out;
  };
  return uniqueItems;
}
var dotjs;
var hasRequiredDotjs;
function requireDotjs() {
  if (hasRequiredDotjs) return dotjs;
  hasRequiredDotjs = 1;
  dotjs = {
    "$ref": requireRef(),
    allOf: requireAllOf(),
    anyOf: requireAnyOf(),
    "$comment": requireComment(),
    const: require_const(),
    contains: requireContains(),
    dependencies: requireDependencies(),
    "enum": require_enum(),
    format: requireFormat(),
    "if": require_if(),
    items: requireItems(),
    maximum: require_limit(),
    minimum: require_limit(),
    maxItems: require_limitItems(),
    minItems: require_limitItems(),
    maxLength: require_limitLength(),
    minLength: require_limitLength(),
    maxProperties: require_limitProperties(),
    minProperties: require_limitProperties(),
    multipleOf: requireMultipleOf(),
    not: requireNot(),
    oneOf: requireOneOf(),
    pattern: requirePattern(),
    properties: requireProperties(),
    propertyNames: requirePropertyNames(),
    required: requireRequired(),
    uniqueItems: requireUniqueItems(),
    validate: requireValidate()
  };
  return dotjs;
}
var rules;
var hasRequiredRules;
function requireRules() {
  if (hasRequiredRules) return rules;
  hasRequiredRules = 1;
  var ruleModules = requireDotjs(), toHash = requireUtil().toHash;
  rules = function rules2() {
    var RULES = [{
      type: "number",
      rules: [{
        "maximum": ["exclusiveMaximum"]
      }, {
        "minimum": ["exclusiveMinimum"]
      }, "multipleOf", "format"]
    }, {
      type: "string",
      rules: ["maxLength", "minLength", "pattern", "format"]
    }, {
      type: "array",
      rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"]
    }, {
      type: "object",
      rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", {
        "properties": ["additionalProperties", "patternProperties"]
      }]
    }, {
      rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"]
    }];
    var ALL = ["type", "$comment"];
    var KEYWORDS = ["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"];
    var TYPES = ["number", "integer", "string", "array", "object", "boolean", "null"];
    RULES.all = toHash(ALL);
    RULES.types = toHash(TYPES);
    RULES.forEach(function(group2) {
      group2.rules = group2.rules.map(function(keyword2) {
        var implKeywords;
        if (typeof keyword2 == "object") {
          var key = Object.keys(keyword2)[0];
          implKeywords = keyword2[key];
          keyword2 = key;
          implKeywords.forEach(function(k) {
            ALL.push(k);
            RULES.all[k] = true;
          });
        }
        ALL.push(keyword2);
        var rule = RULES.all[keyword2] = {
          keyword: keyword2,
          code: ruleModules[keyword2],
          implements: implKeywords
        };
        return rule;
      });
      RULES.all.$comment = {
        keyword: "$comment",
        code: ruleModules.$comment
      };
      if (group2.type) RULES.types[group2.type] = group2;
    });
    RULES.keywords = toHash(ALL.concat(KEYWORDS));
    RULES.custom = {};
    return RULES;
  };
  return rules;
}
var data;
var hasRequiredData;
function requireData() {
  if (hasRequiredData) return data;
  hasRequiredData = 1;
  var KEYWORDS = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"];
  data = function(metaSchema, keywordsJsonPointers) {
    for (var i = 0; i < keywordsJsonPointers.length; i++) {
      metaSchema = JSON.parse(JSON.stringify(metaSchema));
      var segments = keywordsJsonPointers[i].split("/");
      var keywords = metaSchema;
      var j;
      for (j = 1; j < segments.length; j++) keywords = keywords[segments[j]];
      for (j = 0; j < KEYWORDS.length; j++) {
        var key = KEYWORDS[j];
        var schema2 = keywords[key];
        if (schema2) {
          keywords[key] = {
            anyOf: [schema2, {
              $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
            }]
          };
        }
      }
    }
    return metaSchema;
  };
  return data;
}
var async;
var hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var MissingRefError = requireError_classes().MissingRef;
  async = compileAsync;
  function compileAsync(schema2, meta, callback) {
    var self2 = this;
    if (typeof this._opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
    if (typeof meta == "function") {
      callback = meta;
      meta = void 0;
    }
    var p = loadMetaSchemaOf(schema2).then(function() {
      var schemaObj = self2._addSchema(schema2, void 0, meta);
      return schemaObj.validate || _compileAsync(schemaObj);
    });
    if (callback) {
      p.then(function(v) {
        callback(null, v);
      }, callback);
    }
    return p;
    function loadMetaSchemaOf(sch) {
      var $schema2 = sch.$schema;
      return $schema2 && !self2.getSchema($schema2) ? compileAsync.call(self2, {
        $ref: $schema2
      }, true) : Promise.resolve();
    }
    function _compileAsync(schemaObj) {
      try {
        return self2._compile(schemaObj);
      } catch (e) {
        if (e instanceof MissingRefError) return loadMissingSchema(e);
        throw e;
      }
      function loadMissingSchema(e) {
        var ref2 = e.missingSchema;
        if (added(ref2)) throw new Error("Schema " + ref2 + " is loaded but " + e.missingRef + " cannot be resolved");
        var schemaPromise = self2._loadingSchemas[ref2];
        if (!schemaPromise) {
          schemaPromise = self2._loadingSchemas[ref2] = self2._opts.loadSchema(ref2);
          schemaPromise.then(removePromise, removePromise);
        }
        return schemaPromise.then(function(sch) {
          if (!added(ref2)) {
            return loadMetaSchemaOf(sch).then(function() {
              if (!added(ref2)) self2.addSchema(sch, ref2, void 0, meta);
            });
          }
        }).then(function() {
          return _compileAsync(schemaObj);
        });
        function removePromise() {
          delete self2._loadingSchemas[ref2];
        }
        function added(ref22) {
          return self2._refs[ref22] || self2._schemas[ref22];
        }
      }
    }
  }
  return async;
}
var custom;
var hasRequiredCustom;
function requireCustom() {
  if (hasRequiredCustom) return custom;
  hasRequiredCustom = 1;
  custom = function generate_custom(it2, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it2.level;
    var $dataLvl = it2.dataLevel;
    var $schema2 = it2.schema[$keyword];
    var $schemaPath = it2.schemaPath + it2.util.getProperty($keyword);
    var $errSchemaPath = it2.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it2.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $isData = it2.opts.$data && $schema2 && $schema2.$data, $schemaValue;
    if ($isData) {
      out += " var schema" + $lvl + " = " + it2.util.getData($schema2.$data, $dataLvl, it2.dataPathArr) + "; ";
      $schemaValue = "schema" + $lvl;
    } else {
      $schemaValue = $schema2;
    }
    var $rule = this, $definition = "definition" + $lvl, $rDef = $rule.definition, $closingBraces = "";
    var $compile, $inline, $macro, $ruleValidate, $validateCode;
    if ($isData && $rDef.$data) {
      $validateCode = "keywordValidate" + $lvl;
      var $validateSchema = $rDef.validateSchema;
      out += " var " + $definition + " = RULES.custom['" + $keyword + "'].definition; var " + $validateCode + " = " + $definition + ".validate;";
    } else {
      $ruleValidate = it2.useCustomRule($rule, $schema2, it2.schema, it2);
      if (!$ruleValidate) return;
      $schemaValue = "validate.schema" + $schemaPath;
      $validateCode = $ruleValidate.code;
      $compile = $rDef.compile;
      $inline = $rDef.inline;
      $macro = $rDef.macro;
    }
    var $ruleErrs = $validateCode + ".errors", $i = "i" + $lvl, $ruleErr = "ruleErr" + $lvl, $asyncKeyword = $rDef.async;
    if ($asyncKeyword && !it2.async) throw new Error("async keyword in sync schema");
    if (!($inline || $macro)) {
      out += "" + $ruleErrs + " = null;";
    }
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if ($isData && $rDef.$data) {
      $closingBraces += "}";
      out += " if (" + $schemaValue + " === undefined) { " + $valid + " = true; } else { ";
      if ($validateSchema) {
        $closingBraces += "}";
        out += " " + $valid + " = " + $definition + ".validateSchema(" + $schemaValue + "); if (" + $valid + ") { ";
      }
    }
    if ($inline) {
      if ($rDef.statements) {
        out += " " + $ruleValidate.validate + " ";
      } else {
        out += " " + $valid + " = " + $ruleValidate.validate + "; ";
      }
    } else if ($macro) {
      var $it = it2.util.copy(it2);
      var $closingBraces = "";
      $it.level++;
      var $nextValid = "valid" + $it.level;
      $it.schema = $ruleValidate.validate;
      $it.schemaPath = "";
      var $wasComposite = it2.compositeRule;
      it2.compositeRule = $it.compositeRule = true;
      var $code = it2.validate($it).replace(/validate\.schema/g, $validateCode);
      it2.compositeRule = $it.compositeRule = $wasComposite;
      out += " " + $code;
    } else {
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      out += "  " + $validateCode + ".call( ";
      if (it2.opts.passContext) {
        out += "this";
      } else {
        out += "self";
      }
      if ($compile || $rDef.schema === false) {
        out += " , " + $data + " ";
      } else {
        out += " , " + $schemaValue + " , " + $data + " , validate.schema" + it2.schemaPath + " ";
      }
      out += " , (dataPath || '')";
      if (it2.errorPath != '""') {
        out += " + " + it2.errorPath;
      }
      var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it2.dataPathArr[$dataLvl] : "parentDataProperty";
      out += " , " + $parentData + " , " + $parentDataProperty + " , rootData )  ";
      var def_callRuleValidate = out;
      out = $$outStack.pop();
      if ($rDef.errors === false) {
        out += " " + $valid + " = ";
        if ($asyncKeyword) {
          out += "await ";
        }
        out += "" + def_callRuleValidate + "; ";
      } else {
        if ($asyncKeyword) {
          $ruleErrs = "customErrors" + $lvl;
          out += " var " + $ruleErrs + " = null; try { " + $valid + " = await " + def_callRuleValidate + "; } catch (e) { " + $valid + " = false; if (e instanceof ValidationError) " + $ruleErrs + " = e.errors; else throw e; } ";
        } else {
          out += " " + $ruleErrs + " = null; " + $valid + " = " + def_callRuleValidate + "; ";
        }
      }
    }
    if ($rDef.modifying) {
      out += " if (" + $parentData + ") " + $data + " = " + $parentData + "[" + $parentDataProperty + "];";
    }
    out += "" + $closingBraces;
    if ($rDef.valid) {
      if ($breakOnError) {
        out += " if (true) { ";
      }
    } else {
      out += " if ( ";
      if ($rDef.valid === void 0) {
        out += " !";
        if ($macro) {
          out += "" + $nextValid;
        } else {
          out += "" + $valid;
        }
      } else {
        out += " " + !$rDef.valid + " ";
      }
      out += ") { ";
      $errorKeyword = $rule.keyword;
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = "";
      if (it2.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
        if (it2.opts.messages !== false) {
          out += ` , message: 'should pass "` + $rule.keyword + `" keyword validation' `;
        }
        if (it2.opts.verbose) {
          out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
      } else {
        out += " {} ";
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it2.compositeRule && $breakOnError) {
        if (it2.async) {
          out += " throw new ValidationError([" + __err + "]); ";
        } else {
          out += " validate.errors = [" + __err + "]; return false; ";
        }
      } else {
        out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
      var def_customError = out;
      out = $$outStack.pop();
      if ($inline) {
        if ($rDef.errors) {
          if ($rDef.errors != "full") {
            out += "  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it2.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
            if (it2.opts.verbose) {
              out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
            }
            out += " } ";
          }
        } else {
          if ($rDef.errors === false) {
            out += " " + def_customError + " ";
          } else {
            out += " if (" + $errs + " == errors) { " + def_customError + " } else {  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it2.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
            if (it2.opts.verbose) {
              out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
            }
            out += " } } ";
          }
        }
      } else if ($macro) {
        out += "   var err =   ";
        if (it2.createErrors !== false) {
          out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it2.errorPath + " , schemaPath: " + it2.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
          if (it2.opts.messages !== false) {
            out += ` , message: 'should pass "` + $rule.keyword + `" keyword validation' `;
          }
          if (it2.opts.verbose) {
            out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it2.schemaPath + " , data: " + $data + " ";
          }
          out += " } ";
        } else {
          out += " {} ";
        }
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it2.compositeRule && $breakOnError) {
          if (it2.async) {
            out += " throw new ValidationError(vErrors); ";
          } else {
            out += " validate.errors = vErrors; return false; ";
          }
        }
      } else {
        if ($rDef.errors === false) {
          out += " " + def_customError + " ";
        } else {
          out += " if (Array.isArray(" + $ruleErrs + ")) { if (vErrors === null) vErrors = " + $ruleErrs + "; else vErrors = vErrors.concat(" + $ruleErrs + "); errors = vErrors.length;  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it2.errorPath + ";  " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
          if (it2.opts.verbose) {
            out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
          }
          out += " } } else { " + def_customError + " } ";
        }
      }
      out += " } ";
      if ($breakOnError) {
        out += " else { ";
      }
    }
    return out;
  };
  return custom;
}
const $schema$2 = "http://json-schema.org/draft-07/schema#";
const $id$2 = "http://json-schema.org/draft-07/schema#";
const title$2 = "Core schema meta-schema";
const definitions$1 = { "schemaArray": { "type": "array", "minItems": 1, "items": { "$ref": "#" } }, "nonNegativeInteger": { "type": "integer", "minimum": 0 }, "nonNegativeIntegerDefault0": { "allOf": [{ "$ref": "#/definitions/nonNegativeInteger" }, { "default": 0 }] }, "simpleTypes": { "enum": ["array", "boolean", "integer", "null", "number", "object", "string"] }, "stringArray": { "type": "array", "items": { "type": "string" }, "uniqueItems": true, "default": [] } };
const type$2 = ["object", "boolean"];
const properties$2 = { "$id": { "type": "string", "format": "uri-reference" }, "$schema": { "type": "string", "format": "uri" }, "$ref": { "type": "string", "format": "uri-reference" }, "$comment": { "type": "string" }, "title": { "type": "string" }, "description": { "type": "string" }, "default": true, "readOnly": { "type": "boolean", "default": false }, "examples": { "type": "array", "items": true }, "multipleOf": { "type": "number", "exclusiveMinimum": 0 }, "maximum": { "type": "number" }, "exclusiveMaximum": { "type": "number" }, "minimum": { "type": "number" }, "exclusiveMinimum": { "type": "number" }, "maxLength": { "$ref": "#/definitions/nonNegativeInteger" }, "minLength": { "$ref": "#/definitions/nonNegativeIntegerDefault0" }, "pattern": { "type": "string", "format": "regex" }, "additionalItems": { "$ref": "#" }, "items": { "anyOf": [{ "$ref": "#" }, { "$ref": "#/definitions/schemaArray" }], "default": true }, "maxItems": { "$ref": "#/definitions/nonNegativeInteger" }, "minItems": { "$ref": "#/definitions/nonNegativeIntegerDefault0" }, "uniqueItems": { "type": "boolean", "default": false }, "contains": { "$ref": "#" }, "maxProperties": { "$ref": "#/definitions/nonNegativeInteger" }, "minProperties": { "$ref": "#/definitions/nonNegativeIntegerDefault0" }, "required": { "$ref": "#/definitions/stringArray" }, "additionalProperties": { "$ref": "#" }, "definitions": { "type": "object", "additionalProperties": { "$ref": "#" }, "default": {} }, "properties": { "type": "object", "additionalProperties": { "$ref": "#" }, "default": {} }, "patternProperties": { "type": "object", "additionalProperties": { "$ref": "#" }, "propertyNames": { "format": "regex" }, "default": {} }, "dependencies": { "type": "object", "additionalProperties": { "anyOf": [{ "$ref": "#" }, { "$ref": "#/definitions/stringArray" }] } }, "propertyNames": { "$ref": "#" }, "const": true, "enum": { "type": "array", "items": true, "minItems": 1, "uniqueItems": true }, "type": { "anyOf": [{ "$ref": "#/definitions/simpleTypes" }, { "type": "array", "items": { "$ref": "#/definitions/simpleTypes" }, "minItems": 1, "uniqueItems": true }] }, "format": { "type": "string" }, "contentMediaType": { "type": "string" }, "contentEncoding": { "type": "string" }, "if": { "$ref": "#" }, "then": { "$ref": "#" }, "else": { "$ref": "#" }, "allOf": { "$ref": "#/definitions/schemaArray" }, "anyOf": { "$ref": "#/definitions/schemaArray" }, "oneOf": { "$ref": "#/definitions/schemaArray" }, "not": { "$ref": "#" } };
const require$$13 = {
  $schema: $schema$2,
  $id: $id$2,
  title: title$2,
  definitions: definitions$1,
  type: type$2,
  properties: properties$2,
  "default": true
};
var definition_schema;
var hasRequiredDefinition_schema;
function requireDefinition_schema() {
  if (hasRequiredDefinition_schema) return definition_schema;
  hasRequiredDefinition_schema = 1;
  var metaSchema = require$$13;
  definition_schema = {
    $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
    definitions: {
      simpleTypes: metaSchema.definitions.simpleTypes
    },
    type: "object",
    dependencies: {
      schema: ["validate"],
      $data: ["validate"],
      statements: ["inline"],
      valid: {
        not: {
          required: ["macro"]
        }
      }
    },
    properties: {
      type: metaSchema.properties.type,
      schema: {
        type: "boolean"
      },
      statements: {
        type: "boolean"
      },
      dependencies: {
        type: "array",
        items: {
          type: "string"
        }
      },
      metaSchema: {
        type: "object"
      },
      modifying: {
        type: "boolean"
      },
      valid: {
        type: "boolean"
      },
      $data: {
        type: "boolean"
      },
      async: {
        type: "boolean"
      },
      errors: {
        anyOf: [{
          type: "boolean"
        }, {
          const: "full"
        }]
      }
    }
  };
  return definition_schema;
}
var keyword;
var hasRequiredKeyword;
function requireKeyword() {
  if (hasRequiredKeyword) return keyword;
  hasRequiredKeyword = 1;
  var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
  var customRuleCode = requireCustom();
  var definitionSchema = requireDefinition_schema();
  keyword = {
    add: addKeyword,
    get: getKeyword,
    remove: removeKeyword,
    validate: validateKeyword
  };
  function addKeyword(keyword2, definition) {
    var RULES = this.RULES;
    if (RULES.keywords[keyword2]) throw new Error("Keyword " + keyword2 + " is already defined");
    if (!IDENTIFIER.test(keyword2)) throw new Error("Keyword " + keyword2 + " is not a valid identifier");
    if (definition) {
      this.validateKeyword(definition, true);
      var dataType = definition.type;
      if (Array.isArray(dataType)) {
        for (var i = 0; i < dataType.length; i++) _addRule(keyword2, dataType[i], definition);
      } else {
        _addRule(keyword2, dataType, definition);
      }
      var metaSchema = definition.metaSchema;
      if (metaSchema) {
        if (definition.$data && this._opts.$data) {
          metaSchema = {
            anyOf: [metaSchema, {
              "$ref": "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
            }]
          };
        }
        definition.validateSchema = this.compile(metaSchema, true);
      }
    }
    RULES.keywords[keyword2] = RULES.all[keyword2] = true;
    function _addRule(keyword3, dataType2, definition2) {
      var ruleGroup;
      for (var i2 = 0; i2 < RULES.length; i2++) {
        var rg = RULES[i2];
        if (rg.type == dataType2) {
          ruleGroup = rg;
          break;
        }
      }
      if (!ruleGroup) {
        ruleGroup = {
          type: dataType2,
          rules: []
        };
        RULES.push(ruleGroup);
      }
      var rule = {
        keyword: keyword3,
        definition: definition2,
        custom: true,
        code: customRuleCode,
        implements: definition2.implements
      };
      ruleGroup.rules.push(rule);
      RULES.custom[keyword3] = rule;
    }
    return this;
  }
  function getKeyword(keyword2) {
    var rule = this.RULES.custom[keyword2];
    return rule ? rule.definition : this.RULES.keywords[keyword2] || false;
  }
  function removeKeyword(keyword2) {
    var RULES = this.RULES;
    delete RULES.keywords[keyword2];
    delete RULES.all[keyword2];
    delete RULES.custom[keyword2];
    for (var i = 0; i < RULES.length; i++) {
      var rules2 = RULES[i].rules;
      for (var j = 0; j < rules2.length; j++) {
        if (rules2[j].keyword == keyword2) {
          rules2.splice(j, 1);
          break;
        }
      }
    }
    return this;
  }
  function validateKeyword(definition, throwError) {
    validateKeyword.errors = null;
    var v = this._validateKeyword = this._validateKeyword || this.compile(definitionSchema, true);
    if (v(definition)) return true;
    validateKeyword.errors = v.errors;
    if (throwError) throw new Error("custom keyword definition is invalid: " + this.errorsText(v.errors));
    else return false;
  }
  return keyword;
}
const $schema$1 = "http://json-schema.org/draft-07/schema#";
const $id$1 = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#";
const description = "Meta-schema for $data reference (JSON Schema extension proposal)";
const type$1 = "object";
const required$1 = ["$data"];
const properties$1 = { "$data": { "type": "string", "anyOf": [{ "format": "relative-json-pointer" }, { "format": "json-pointer" }] } };
const additionalProperties$1 = false;
const require$$12 = {
  $schema: $schema$1,
  $id: $id$1,
  description,
  type: type$1,
  required: required$1,
  properties: properties$1,
  additionalProperties: additionalProperties$1
};
var ajv;
var hasRequiredAjv;
function requireAjv() {
  if (hasRequiredAjv) return ajv;
  hasRequiredAjv = 1;
  var compileSchema = requireCompile(), resolve = requireResolve(), Cache = requireCache(), SchemaObject = requireSchema_obj(), stableStringify = requireFastJsonStableStringify(), formats = requireFormats(), rules2 = requireRules(), $dataMetaSchema = requireData(), util2 = requireUtil();
  ajv = Ajv2;
  Ajv2.prototype.validate = validate2;
  Ajv2.prototype.compile = compile2;
  Ajv2.prototype.addSchema = addSchema;
  Ajv2.prototype.addMetaSchema = addMetaSchema;
  Ajv2.prototype.validateSchema = validateSchema;
  Ajv2.prototype.getSchema = getSchema;
  Ajv2.prototype.removeSchema = removeSchema;
  Ajv2.prototype.addFormat = addFormat;
  Ajv2.prototype.errorsText = errorsText;
  Ajv2.prototype._addSchema = _addSchema;
  Ajv2.prototype._compile = _compile;
  Ajv2.prototype.compileAsync = requireAsync();
  var customKeyword = requireKeyword();
  Ajv2.prototype.addKeyword = customKeyword.add;
  Ajv2.prototype.getKeyword = customKeyword.get;
  Ajv2.prototype.removeKeyword = customKeyword.remove;
  Ajv2.prototype.validateKeyword = customKeyword.validate;
  var errorClasses = requireError_classes();
  Ajv2.ValidationError = errorClasses.Validation;
  Ajv2.MissingRefError = errorClasses.MissingRef;
  Ajv2.$dataMetaSchema = $dataMetaSchema;
  var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
  var META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"];
  var META_SUPPORT_DATA = ["/properties"];
  function Ajv2(opts) {
    if (!(this instanceof Ajv2)) return new Ajv2(opts);
    opts = this._opts = util2.copy(opts) || {};
    setLogger(this);
    this._schemas = {};
    this._refs = {};
    this._fragments = {};
    this._formats = formats(opts.format);
    this._cache = opts.cache || new Cache();
    this._loadingSchemas = {};
    this._compilations = [];
    this.RULES = rules2();
    this._getId = chooseGetId(opts);
    opts.loopRequired = opts.loopRequired || Infinity;
    if (opts.errorDataPath == "property") opts._errorDataPathProperty = true;
    if (opts.serialize === void 0) opts.serialize = stableStringify;
    this._metaOpts = getMetaSchemaOptions(this);
    if (opts.formats) addInitialFormats(this);
    if (opts.keywords) addInitialKeywords(this);
    addDefaultMetaSchema(this);
    if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
    if (opts.nullable) this.addKeyword("nullable", {
      metaSchema: {
        type: "boolean"
      }
    });
    addInitialSchemas(this);
  }
  function validate2(schemaKeyRef, data2) {
    var v;
    if (typeof schemaKeyRef == "string") {
      v = this.getSchema(schemaKeyRef);
      if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
    } else {
      var schemaObj = this._addSchema(schemaKeyRef);
      v = schemaObj.validate || this._compile(schemaObj);
    }
    var valid = v(data2);
    if (v.$async !== true) this.errors = v.errors;
    return valid;
  }
  function compile2(schema2, _meta) {
    var schemaObj = this._addSchema(schema2, void 0, _meta);
    return schemaObj.validate || this._compile(schemaObj);
  }
  function addSchema(schema2, key, _skipValidation, _meta) {
    if (Array.isArray(schema2)) {
      for (var i = 0; i < schema2.length; i++) this.addSchema(schema2[i], void 0, _skipValidation, _meta);
      return this;
    }
    var id2 = this._getId(schema2);
    if (id2 !== void 0 && typeof id2 != "string") throw new Error("schema id must be string");
    key = resolve.normalizeId(key || id2);
    checkUnique(this, key);
    this._schemas[key] = this._addSchema(schema2, _skipValidation, _meta, true);
    return this;
  }
  function addMetaSchema(schema2, key, skipValidation) {
    this.addSchema(schema2, key, skipValidation, true);
    return this;
  }
  function validateSchema(schema2, throwOrLogError) {
    var $schema2 = schema2.$schema;
    if ($schema2 !== void 0 && typeof $schema2 != "string") throw new Error("$schema must be a string");
    $schema2 = $schema2 || this._opts.defaultMeta || defaultMeta(this);
    if (!$schema2) {
      this.logger.warn("meta-schema not available");
      this.errors = null;
      return true;
    }
    var valid = this.validate($schema2, schema2);
    if (!valid && throwOrLogError) {
      var message = "schema is invalid: " + this.errorsText();
      if (this._opts.validateSchema == "log") this.logger.error(message);
      else throw new Error(message);
    }
    return valid;
  }
  function defaultMeta(self2) {
    var meta = self2._opts.meta;
    self2._opts.defaultMeta = typeof meta == "object" ? self2._getId(meta) || meta : self2.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : void 0;
    return self2._opts.defaultMeta;
  }
  function getSchema(keyRef) {
    var schemaObj = _getSchemaObj(this, keyRef);
    switch (typeof schemaObj) {
      case "object":
        return schemaObj.validate || this._compile(schemaObj);
      case "string":
        return this.getSchema(schemaObj);
      case "undefined":
        return _getSchemaFragment(this, keyRef);
    }
  }
  function _getSchemaFragment(self2, ref2) {
    var res = resolve.schema.call(self2, {
      schema: {}
    }, ref2);
    if (res) {
      var schema2 = res.schema, root2 = res.root, baseId = res.baseId;
      var v = compileSchema.call(self2, schema2, root2, void 0, baseId);
      self2._fragments[ref2] = new SchemaObject({
        ref: ref2,
        fragment: true,
        schema: schema2,
        root: root2,
        baseId,
        validate: v
      });
      return v;
    }
  }
  function _getSchemaObj(self2, keyRef) {
    keyRef = resolve.normalizeId(keyRef);
    return self2._schemas[keyRef] || self2._refs[keyRef] || self2._fragments[keyRef];
  }
  function removeSchema(schemaKeyRef) {
    if (schemaKeyRef instanceof RegExp) {
      _removeAllSchemas(this, this._schemas, schemaKeyRef);
      _removeAllSchemas(this, this._refs, schemaKeyRef);
      return this;
    }
    switch (typeof schemaKeyRef) {
      case "undefined":
        _removeAllSchemas(this, this._schemas);
        _removeAllSchemas(this, this._refs);
        this._cache.clear();
        return this;
      case "string":
        var schemaObj = _getSchemaObj(this, schemaKeyRef);
        if (schemaObj) this._cache.del(schemaObj.cacheKey);
        delete this._schemas[schemaKeyRef];
        delete this._refs[schemaKeyRef];
        return this;
      case "object":
        var serialize = this._opts.serialize;
        var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
        this._cache.del(cacheKey);
        var id2 = this._getId(schemaKeyRef);
        if (id2) {
          id2 = resolve.normalizeId(id2);
          delete this._schemas[id2];
          delete this._refs[id2];
        }
    }
    return this;
  }
  function _removeAllSchemas(self2, schemas, regex) {
    for (var keyRef in schemas) {
      var schemaObj = schemas[keyRef];
      if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
        self2._cache.del(schemaObj.cacheKey);
        delete schemas[keyRef];
      }
    }
  }
  function _addSchema(schema2, skipValidation, meta, shouldAddSchema) {
    if (typeof schema2 != "object" && typeof schema2 != "boolean") throw new Error("schema should be object or boolean");
    var serialize = this._opts.serialize;
    var cacheKey = serialize ? serialize(schema2) : schema2;
    var cached = this._cache.get(cacheKey);
    if (cached) return cached;
    shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
    var id2 = resolve.normalizeId(this._getId(schema2));
    if (id2 && shouldAddSchema) checkUnique(this, id2);
    var willValidate = this._opts.validateSchema !== false && !skipValidation;
    var recursiveMeta;
    if (willValidate && !(recursiveMeta = id2 && id2 == resolve.normalizeId(schema2.$schema))) this.validateSchema(schema2, true);
    var localRefs = resolve.ids.call(this, schema2);
    var schemaObj = new SchemaObject({
      id: id2,
      schema: schema2,
      localRefs,
      cacheKey,
      meta
    });
    if (id2[0] != "#" && shouldAddSchema) this._refs[id2] = schemaObj;
    this._cache.put(cacheKey, schemaObj);
    if (willValidate && recursiveMeta) this.validateSchema(schema2, true);
    return schemaObj;
  }
  function _compile(schemaObj, root2) {
    if (schemaObj.compiling) {
      schemaObj.validate = callValidate;
      callValidate.schema = schemaObj.schema;
      callValidate.errors = null;
      callValidate.root = root2 ? root2 : callValidate;
      if (schemaObj.schema.$async === true) callValidate.$async = true;
      return callValidate;
    }
    schemaObj.compiling = true;
    var currentOpts;
    if (schemaObj.meta) {
      currentOpts = this._opts;
      this._opts = this._metaOpts;
    }
    var v;
    try {
      v = compileSchema.call(this, schemaObj.schema, root2, schemaObj.localRefs);
    } catch (e) {
      delete schemaObj.validate;
      throw e;
    } finally {
      schemaObj.compiling = false;
      if (schemaObj.meta) this._opts = currentOpts;
    }
    schemaObj.validate = v;
    schemaObj.refs = v.refs;
    schemaObj.refVal = v.refVal;
    schemaObj.root = v.root;
    return v;
    function callValidate() {
      var _validate = schemaObj.validate;
      var result = _validate.apply(this, arguments);
      callValidate.errors = _validate.errors;
      return result;
    }
  }
  function chooseGetId(opts) {
    switch (opts.schemaId) {
      case "auto":
        return _get$IdOrId;
      case "id":
        return _getId;
      default:
        return _get$Id;
    }
  }
  function _getId(schema2) {
    if (schema2.$id) this.logger.warn("schema $id ignored", schema2.$id);
    return schema2.id;
  }
  function _get$Id(schema2) {
    if (schema2.id) this.logger.warn("schema id ignored", schema2.id);
    return schema2.$id;
  }
  function _get$IdOrId(schema2) {
    if (schema2.$id && schema2.id && schema2.$id != schema2.id) throw new Error("schema $id is different from id");
    return schema2.$id || schema2.id;
  }
  function errorsText(errors, options2) {
    errors = errors || this.errors;
    if (!errors) return "No errors";
    options2 = options2 || {};
    var separator = options2.separator === void 0 ? ", " : options2.separator;
    var dataVar = options2.dataVar === void 0 ? "data" : options2.dataVar;
    var text2 = "";
    for (var i = 0; i < errors.length; i++) {
      var e = errors[i];
      if (e) text2 += dataVar + e.dataPath + " " + e.message + separator;
    }
    return text2.slice(0, -separator.length);
  }
  function addFormat(name, format2) {
    if (typeof format2 == "string") format2 = new RegExp(format2);
    this._formats[name] = format2;
    return this;
  }
  function addDefaultMetaSchema(self2) {
    var $dataSchema;
    if (self2._opts.$data) {
      $dataSchema = require$$12;
      self2.addMetaSchema($dataSchema, $dataSchema.$id, true);
    }
    if (self2._opts.meta === false) return;
    var metaSchema = require$$13;
    if (self2._opts.$data) metaSchema = $dataMetaSchema(metaSchema, META_SUPPORT_DATA);
    self2.addMetaSchema(metaSchema, META_SCHEMA_ID, true);
    self2._refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
  }
  function addInitialSchemas(self2) {
    var optsSchemas = self2._opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) self2.addSchema(optsSchemas);
    else for (var key in optsSchemas) self2.addSchema(optsSchemas[key], key);
  }
  function addInitialFormats(self2) {
    for (var name in self2._opts.formats) {
      var format2 = self2._opts.formats[name];
      self2.addFormat(name, format2);
    }
  }
  function addInitialKeywords(self2) {
    for (var name in self2._opts.keywords) {
      var keyword2 = self2._opts.keywords[name];
      self2.addKeyword(name, keyword2);
    }
  }
  function checkUnique(self2, id2) {
    if (self2._schemas[id2] || self2._refs[id2]) throw new Error('schema with key or id "' + id2 + '" already exists');
  }
  function getMetaSchemaOptions(self2) {
    var metaOpts = util2.copy(self2._opts);
    for (var i = 0; i < META_IGNORE_OPTIONS.length; i++) delete metaOpts[META_IGNORE_OPTIONS[i]];
    return metaOpts;
  }
  function setLogger(self2) {
    var logger = self2._opts.logger;
    if (logger === false) {
      self2.logger = {
        log: noop2,
        warn: noop2,
        error: noop2
      };
    } else {
      if (logger === void 0) logger = console;
      if (!(typeof logger == "object" && logger.log && logger.warn && logger.error)) throw new Error("logger must implement log, warn and error methods");
      self2.logger = logger;
    }
  }
  function noop2() {
  }
  return ajv;
}
var ajvExports = requireAjv();
const Ajv = /* @__PURE__ */ getDefaultExportFromCjs(ajvExports);
const $schema = "http://json-schema.org/draft-07/schema#";
const $id = "https://higlass.io/#viewconf";
const title$1 = "HiGlass viewconf";
const type = "object";
const additionalProperties = false;
const required = [];
const properties = { "editable": { "type": "boolean", "default": true }, "viewEditable": { "type": "boolean", "default": true }, "tracksEditable": { "type": "boolean", "default": true }, "zoomFixed": { "type": "boolean" }, "compactLayout": { "type": "boolean" }, "exportViewUrl": { "type": "string" }, "trackSourceServers": { "type": "array", "items": { "type": "string" }, "minLength": 1 }, "zoomLocks": { "$ref": "#/definitions/locks/zoomLocks" }, "locationLocks": { "$ref": "#/definitions/locks/locationLocks" }, "valueScaleLocks": { "$ref": "#/definitions/locks/valueScaleLocks" }, "views": { "type": "array", "items": { "$ref": "#/definitions/view" }, "minLength": 1 }, "chromInfoPath": { "type": "string" } };
const definitions = { "data": { "type": "object", "properties": { "url": { "type": "string" }, "server": { "type": "string" }, "filetype": { "type": "string" }, "type": { "type": "string" }, "tilesetInfo": { "type": "object" }, "children": { "type": "array" }, "tiles": { "type": "object" } } }, "locks": { "slug": { "type": "string" }, "locksByViewUid": { "type": "object", "additionalProperties": false, "patternProperties": { ".": { "$ref": "#/definitions/locks/slug" } } }, "axisSpecificLocks": { "additionalProperties": false, "properties": { "axis": { "enum": ["x", "y"], "type": "string" }, "lock": { "type": "string" } }, "required": ["lock", "axis"], "type": "object" }, "locationLocksByViewUid": { "type": "object", "additionalProperties": false, "patternProperties": { ".": { "anyOf": [{ "type": "string" }, { "additionalProperties": false, "properties": { "x": { "$ref": "#/definitions/locks/axisSpecificLocks" }, "y": { "$ref": "#/definitions/locks/axisSpecificLocks" } }, "type": "object" }] } } }, "zoomLocks": { "type": "object", "additionalProperties": false, "required": [], "properties": { "locksByViewUid": { "$ref": "#/definitions/locks/locksByViewUid" }, "locksDict": { "type": "object", "additionalProperties": false, "patternProperties": { ".": { "type": "object", "additionalProperties": false, "properties": { "uid": { "$ref": "#/definitions/locks/slug" } }, "patternProperties": { "^(?!uid).": { "type": "array", "minLength": 3, "maxLength": 3, "items": { "type": "number" } } } } } } } }, "locationLocks": { "type": "object", "additionalProperties": false, "required": [], "properties": { "locksByViewUid": { "$ref": "#/definitions/locks/locationLocksByViewUid" }, "locksDict": { "type": "object", "additionalProperties": false, "patternProperties": { ".": { "type": "object", "additionalProperties": false, "properties": { "uid": { "$ref": "#/definitions/locks/slug" } }, "patternProperties": { "^(?!uid).": { "type": "array", "minLength": 3, "maxLength": 3, "items": { "type": "number" } } } } } } } }, "valueScaleLocks": { "type": "object", "additionalProperties": false, "required": ["locksByViewUid", "locksDict"], "properties": { "locksByViewUid": { "$ref": "#/definitions/locks/locksByViewUid" }, "locksDict": { "type": "object", "additionalProperties": false, "patternProperties": { ".": { "type": "object", "additionalProperties": false, "properties": { "uid": { "$ref": "#/definitions/locks/slug" }, "ignoreOffScreenValues": { "type": "boolean" } }, "patternProperties": { "^(?!(uid|ignoreOffScreenValues)).": { "type": "object", "additionalProperties": false, "required": ["view", "track"], "properties": { "view": { "type": "string" }, "track": { "$ref": "#/definitions/locks/slug" } } } } } } } } } }, "view": { "type": "object", "additionalProperties": false, "required": ["tracks", "layout"], "properties": { "autocompleteSource": { "type": "string" }, "chromInfoPath": { "type": "string" }, "genomePositionSearchBox": { "$ref": "#/definitions/viewProperties/genomePositionSearchBox" }, "genomePositionSearchBoxVisible": { "type": "boolean" }, "initialXDomain": { "$ref": "#/definitions/viewProperties/domain" }, "initialYDomain": { "$ref": "#/definitions/viewProperties/domain" }, "layout": { "$ref": "#/definitions/viewProperties/layout" }, "overlays": { "type": "array", "items": { "$ref": "#/definitions/viewProperties/overlay" } }, "selectionView": { "type": "boolean" }, "tracks": { "$ref": "#/definitions/viewProperties/tracks_object" }, "uid": { "type": "string" }, "zoomFixed": { "type": "boolean" }, "zoomLimits": { "type": "array", "minLength": 2, "maxLength": 2, "default": [1, null] } } }, "viewProperties": { "genomePositionSearchBox": { "type": "object", "title": "The Genome Position Search Box Schema", "required": ["chromInfoServer", "chromInfoId"], "properties": { "autocompleteServer": { "type": "string", "title": "The Autocomplete Server URL", "default": "", "examples": ["//higlass.io/api/v1"], "pattern": "^(.*)$" }, "autocompleteId": { "type": "string", "title": "The Autocomplete ID", "default": "", "examples": ["OHJakQICQD6gTD7skx4EWA"], "pattern": "^(.*)$" }, "chromInfoServer": { "type": "string", "title": "The Chrominfo Server URL", "default": "", "examples": ["//higlass.io/api/v1"], "pattern": "^(.*)$" }, "chromInfoId": { "type": "string", "title": "The Chromosome Info ID", "default": "", "examples": ["hg19"], "pattern": "^(.*)$" }, "visible": { "type": "boolean", "title": "The Visible Schema", "default": false } } }, "overlay": { "type": "object", "additionalProperties": false, "properties": { "chromInfoPath": { "type": "string" }, "includes": { "type": "array" }, "options": { "type": "object", "properties": { "extent": { "type": "array" }, "minWidth": { "type": "number" }, "fill": { "type": "string" }, "fillOpacity": { "type": "number" }, "stroke": { "type": "string" }, "strokeOpacity": { "type": "number" }, "strokeWidth": { "type": "number" }, "strokePos": { "type": ["string", "array"] }, "outline": { "type": "string" }, "outlineOpacity": { "type": "number" }, "outlineWidth": { "type": "number" }, "outlinePos": { "type": ["string", "array"] } } }, "type": { "type": "string" }, "uid": { "type": "string" } } }, "layout": { "type": "object", "additionalProperties": false, "required": ["w", "h", "x", "y"], "properties": { "x": { "type": "integer", "title": "The X Position", "default": 0 }, "y": { "type": "integer", "title": "The Y Position", "default": 0 }, "w": { "type": "integer", "title": "Width", "default": 12 }, "h": { "type": "integer", "title": "Height", "default": 12 }, "moved": { "type": "boolean" }, "static": { "type": "boolean" } } }, "tracks_object": { "type": "object", "additionalProperties": false, "properties": { "left": { "$ref": "#/definitions/viewProperties/tracks_array" }, "right": { "$ref": "#/definitions/viewProperties/tracks_array" }, "top": { "$ref": "#/definitions/viewProperties/tracks_array" }, "bottom": { "$ref": "#/definitions/viewProperties/tracks_array" }, "center": { "$ref": "#/definitions/viewProperties/tracks_array" }, "whole": { "$ref": "#/definitions/viewProperties/tracks_array" }, "gallery": { "$ref": "#/definitions/viewProperties/tracks_array" } } }, "tracks_array": { "type": "array", "items": { "oneOf": [{ "$ref": "#/definitions/tracks/enum_track" }, { "$ref": "#/definitions/tracks/combined_track" }, { "$ref": "#/definitions/tracks/heatmap_track" }, { "$ref": "#/definitions/tracks/independent_viewport_projection_track" }] } }, "domain": { "type": "array", "items": { "type": "number" }, "maxItems": 2, "minItems": 2 } }, "tracks": { "heatmap_track": { "type": "object", "additionalProperties": false, "required": [], "properties": { "uid": { "type": "string" }, "type": { "const": "heatmap" }, "data": { "$ref": "#/definitions/data" }, "height": { "type": "number" }, "options": { "type": "object" }, "position": { "type": "string" }, "server": { "type": "string" }, "tilesetUid": { "type": "string" }, "width": { "type": "number" }, "transforms": { "type": "array" } } }, "combined_track": { "type": "object", "additionalProperties": false, "required": ["contents"], "properties": { "contents": { "$ref": "#/definitions/viewProperties/tracks_array" }, "height": { "type": "number" }, "options": {}, "position": { "type": "string" }, "type": { "const": "combined" }, "uid": { "type": "string" }, "width": { "type": "number" } } }, "enum_track": { "type": "object", "additionalProperties": false, "required": ["type"], "properties": { "server": { "type": "string" }, "tilesetUid": { "type": "string" }, "data": { "$ref": "#/definitions/data" }, "uid": { "type": "string" }, "type": { "enum": ["multivec", "1d-heatmap", "line", "point", "bar", "divergent-bar", "stacked-interval", "gene-annotations", "linear-2d-rectangle-domains", "chromosome-labels", "linear-heatmap", "1d-value-interval", "2d-annotations", "2d-chromosome-annotations", "2d-chromosome-grid", "2d-chromosome-labels", "2d-rectangle-domains", "2d-tiles", "arrowhead-domains", "bedlike", "cross-rule", "dummy", "horizontal-1d-annotations", "horizontal-1d-heatmap", "horizontal-1d-tiles", "horizontal-1d-value-interval", "horizontal-2d-rectangle-domains", "horizontal-bar", "horizontal-chromosome-grid", "horizontal-chromosome-labels", "horizontal-divergent-bar", "horizontal-gene-annotations", "horizontal-heatmap", "horizontal-line", "horizontal-multivec", "horizontal-point", "horizontal-rule", "horizontal-vector-heatmap", "image-tiles", "left-axis", "left-stacked-interval", "mapbox-tiles", "osm-2d-tile-ids", "osm-tiles", "raster-tiles", "simple-svg", "square-markers", "top-axis", "top-stacked-interval", "vertical-1d-annotations", "vertical-1d-heatmap", "vertical-1d-tiles", "vertical-1d-value-interval", "vertical-2d-rectangle-domains", "vertical-bar", "vertical-bedlike", "vertical-chromosome-grid", "vertical-chromosome-labels", "vertical-gene-annotations", "vertical-heatmap", "vertical-line", "vertical-multivec", "vertical-point", "vertical-rule", "vertical-vector-heatmap", "viewport-projection-center", "viewport-projection-horizontal", "viewport-projection-vertical"] }, "chromInfoPath": { "type": "string" }, "fromViewUid": { "type": "string" }, "height": { "type": "number" }, "options": { "type": "object" }, "width": { "type": "number" }, "x": { "type": "number" }, "y": { "type": "number" } } }, "independent_viewport_projection_track": { "type": "object", "additionalProperties": false, "properties": { "uid": { "type": "string" }, "type": { "enum": ["viewport-projection-horizontal", "viewport-projection-vertical", "viewport-projection-center"] }, "fromViewUid": { "type": "null" }, "projectionXDomain": { "$ref": "#/definitions/viewProperties/domain" }, "projectionYDomain": { "$ref": "#/definitions/viewProperties/domain" }, "options": { "type": "object" }, "transforms": { "type": "array" }, "width": { "type": "number" }, "x": { "type": "number" }, "y": { "type": "number" } } } } };
const schema = {
  $schema,
  $id,
  title: title$1,
  type,
  additionalProperties,
  required,
  properties,
  definitions
};
const title = "_title_1hlm6_70";
const Warning = "_Warning_1hlm6_76";
const Success = "_Success_1hlm6_79";
const classes$1 = {
  "view-config-editor-header": "_view-config-editor-header_1hlm6_1",
  "view-config-editor": "_view-config-editor_1hlm6_1",
  "view-config-log": "_view-config-log_1hlm6_34",
  "view-config-log-header": "_view-config-log-header_1hlm6_46",
  "view-config-log-msg": "_view-config-log-msg_1hlm6_60",
  title,
  Warning,
  Success,
  "Error": "_Error_1hlm6_82"
};
function _classCallCheck$4(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$4(o.key), o);
  }
}
function _createClass$4(e, r2, t) {
  return r2 && _defineProperties$4(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$4(t) {
  var i = _toPrimitive$4(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$4(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$4(t, o, e) {
  return o = _getPrototypeOf$4(o), _possibleConstructorReturn$4(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf$4(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$4(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(t);
}
function _assertThisInitialized$4(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$4() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$4 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$4(t) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$4(t);
}
function _inherits$4(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$4(t, e);
}
function _setPrototypeOf$4(t, e) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$4(t, e);
}
let ViewConfigEditor = /* @__PURE__ */ (function(_React$Component) {
  function ViewConfigEditor2(props) {
    var _this;
    _classCallCheck$4(this, ViewConfigEditor2);
    _this = _callSuper$4(this, ViewConfigEditor2, [props]);
    _this.state = {
      code: props.viewConfig,
      hide: false,
      showLog: false,
      logMsgs: _this.getLogMsgs(props.viewConfig)
    };
    _this.handleChangeBound = _this.handleChange.bind(_this);
    _this.handleKeyDownBound = _this.handleKeyDown.bind(_this);
    _this.handleKeyUpBound = _this.handleKeyUp.bind(_this);
    _this.handleSubmitBound = _this.handleSubmit.bind(_this);
    _this.hideBound = _this.hide.bind(_this);
    _this.showBound = _this.show.bind(_this);
    _this.toggleLogBound = _this.toggleLog.bind(_this);
    _this.pubSubs = [];
    _this.pubSubs.push(_this.props.pubSub.subscribe("keydown", _this.handleKeyDownBound));
    _this.pubSubs.push(_this.props.pubSub.subscribe("keyup", _this.handleKeyUpBound));
    return _this;
  }
  _inherits$4(ViewConfigEditor2, _React$Component);
  return _createClass$4(ViewConfigEditor2, [{
    key: "componentDidMount",
    value: async function componentDidMount() {
      if (this.editor) {
        this.editor._input.focus();
        this.editor._input.setSelectionRange(0, 0);
        await timeout$4(0);
        if (this.editorWrap) {
          this.editorWrap.scrollTop = 0;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.pubSubs.forEach((subscription) => this.props.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
    }
  }, {
    key: "handleChange",
    value: function handleChange(code) {
      const logMsgs = this.getLogMsgs(code);
      this.setState({
        code,
        logMsgs
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.key === "s" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        this.props.onChange(this.state.code);
      }
      if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        this.props.onChange(this.state.code);
        this.props.modal.close();
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      this.setState({
        hide: false
      });
      if (event.key === "Escape") {
        event.preventDefault();
        this.props.modal.close();
        this.props.onCancel();
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      if (event) event.preventDefault();
      this.props.onSave(this.state.code);
    }
  }, {
    key: "getLogMsgs",
    value: function getLogMsgs(code) {
      const logMsgs = [];
      let viewConfig;
      try {
        viewConfig = JSON.parse(code);
      } catch (e) {
        console.warn(e);
        logMsgs.push({
          type: "Error",
          msg: e.toString()
        });
        return logMsgs;
      }
      const validate2 = new Ajv().compile(schema);
      const valid = validate2(viewConfig);
      if (!valid) {
        console.warn("Invalid viewconf");
        logMsgs.push({
          type: "Warning",
          msg: "Invalid viewconf"
        });
      }
      if (validate2.errors) {
        console.warn(JSON.stringify(validate2.errors, null, 2));
        validate2.errors.forEach((e) => {
          logMsgs.push({
            type: "Warning",
            msg: JSON.stringify(e, null, 2)
          });
        });
      }
      if (logMsgs.length === 0) {
        logMsgs.push({
          type: "Success",
          msg: "No error or warnings"
        });
      }
      return logMsgs;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        hide: true
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        hide: false
      });
    }
  }, {
    key: "hideLog",
    value: function hideLog() {
      this.setState({
        showLog: false
      });
    }
  }, {
    key: "showLog",
    value: function showLog() {
      this.setState({
        showLog: true
      });
    }
  }, {
    key: "toggleLog",
    value: function toggleLog() {
      if (this.state.showLog) {
        this.hideLog();
      } else {
        this.showLog();
      }
    }
  }, {
    key: "render",
    value: function render3() {
      const logMessages = this.state.logMsgs.map((d, i) => {
        const key = `${i}-${d.msg}`;
        return /* @__PURE__ */ React__default.createElement("tr", {
          key
        }, /* @__PURE__ */ React__default.createElement("td", {
          className: clsx$2(classes$1.title, classes$1[d.type])
        }, `[${i}] ${d.type}`), /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("pre", null, d.msg)));
      });
      return /* @__PURE__ */ React__default.createElement(Dialog$1, {
        cancelShortcut: "ESC",
        cancelTitle: "Discard Changes",
        hide: this.state.hide,
        maxHeight: true,
        okayShortcut: "⌘+Enter",
        okayTitle: "Save and Close",
        onCancel: this.props.onCancel,
        onOkay: this.handleSubmitBound,
        title: "Edit View Config"
      }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("header", {
        className: classes$1["view-config-editor-header"]
      }, /* @__PURE__ */ React__default.createElement(Button, {
        onBlur: this.showBound,
        onMouseDown: this.hideBound,
        onMouseOut: this.showBound,
        onMouseUp: this.showBound
      }, "Hide While Mousedown"), /* @__PURE__ */ React__default.createElement(Button, {
        onClick: () => {
          this.props.onChange(this.state.code);
        },
        shortcut: "⌘+S"
      }, "Save")), /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.editorWrap = c;
        },
        className: classes$1["view-config-editor"]
      }, /* @__PURE__ */ React__default.createElement(Editor, {
        ref: (c) => {
          this.editor = c;
        },
        highlight: (code) => prismCoreExports.highlight(code, prismCoreExports.languages.json),
        onValueChange: this.handleChangeBound,
        padding: 10,
        style: {
          fontFamily: '"Fira code", "Fira Mono", monospace',
          fontSize: "inherit"
        },
        value: this.state.code
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: classes$1["view-config-log"],
        style: {
          height: this.state.showLog ? "50%" : "30px"
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: classes$1["view-config-log-header"],
        onClick: () => this.toggleLogBound()
      }, `Log Messages (${this.state.logMsgs.filter((d) => d.type !== "Success").length})`), /* @__PURE__ */ React__default.createElement("div", {
        className: classes$1["view-config-log-msg"],
        style: {
          padding: this.state.showLog ? "10px" : 0
        }
      }, /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("tbody", null, logMessages))))));
    }
  }]);
})(React__default.Component);
ViewConfigEditor.propTypes = {
  modal: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  pubSub: PropTypes.object.isRequired,
  viewConfig: PropTypes.string.isRequired
};
const ViewConfigEditor$1 = withPubSub(withModal(ViewConfigEditor));
const classes = {
  "add-track-position-table": "_add-track-position-table_egwog_1",
  "add-track-position-table-dark": "_add-track-position-table-dark_egwog_7",
  "add-track-position-other": "_add-track-position-other_egwog_11",
  "add-track-position-top-center": "_add-track-position-top-center_egwog_15",
  "add-track-position-middle-left": "_add-track-position-middle-left_egwog_30",
  "add-track-position-middle-right": "_add-track-position-middle-right_egwog_45",
  "add-track-position-middle-middle": "_add-track-position-middle-middle_egwog_60",
  "add-track-position-middle-middle-full": "_add-track-position-middle-middle-full_egwog_72",
  "add-track-position-middle-middle-upper-right": "_add-track-position-middle-middle-upper-right_egwog_80",
  "add-track-position-middle-middle-lower-left": "_add-track-position-middle-middle-lower-left_egwog_94",
  "add-track-position-bottom-middle": "_add-track-position-bottom-middle_egwog_108",
  "add-track-position-span": "_add-track-position-span_egwog_123"
};
function AddTrackPositionMenu(props) {
  return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("div", {
    className: classes["add-track-position-span"]
  }, "Add Track..."), /* @__PURE__ */ React__default.createElement("table", {
    className: clsx$2(classes["add-track-position-table"], {
      [classes["add-track-position-table-dark"]]: props.theme === THEME_DARK
    })
  }, /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", {
    style: {
      height: "30px"
    }
  }, /* @__PURE__ */ React__default.createElement("td", {
    "aria-hidden": "true",
    className: classes["add-track-position-other"]
  }), /* @__PURE__ */ React__default.createElement("td", {
    className: classes["add-track-position-top-center"],
    onClick: () => props.onTrackPositionChosen("top")
  }, "top"), /* @__PURE__ */ React__default.createElement("td", {
    "aria-hidden": "true",
    className: classes["add-track-position-other"]
  })), /* @__PURE__ */ React__default.createElement("tr", {
    style: {
      height: "80px"
    }
  }, /* @__PURE__ */ React__default.createElement("td", {
    className: classes["add-track-position-middle-left"],
    onClick: () => props.onTrackPositionChosen("left")
  }, "left"), /* @__PURE__ */ React__default.createElement("td", {
    className: classes["add-track-position-middle-middle"]
  }, /* @__PURE__ */ React__default.createElement("span", {
    onClick: () => props.onTrackPositionChosen("center"),
    className: classes["add-track-position-middle-middle-full"],
    "data-testid": "add-track-center"
  }, "center"), /* @__PURE__ */ React__default.createElement("span", {
    onClick: () => props.onTrackPositionChosen("center", "upper-right"),
    className: classes["add-track-position-middle-middle-upper-right"],
    "data-testid": "add-track-upper-right"
  }), /* @__PURE__ */ React__default.createElement("span", {
    onClick: () => props.onTrackPositionChosen("center", "lower-left"),
    className: classes["add-track-position-middle-middle-lower-left"],
    "data-testid": "add-track-lower-left"
  })), /* @__PURE__ */ React__default.createElement("td", {
    className: classes["add-track-position-middle-right"],
    onClick: () => props.onTrackPositionChosen("right")
  }, "right")), /* @__PURE__ */ React__default.createElement("tr", {
    style: {
      height: "30px"
    }
  }, /* @__PURE__ */ React__default.createElement("td", {
    "aria-hidden": "true",
    className: classes["add-track-position-other"]
  }), /* @__PURE__ */ React__default.createElement("td", {
    className: classes["add-track-position-bottom-middle"],
    onClick: () => props.onTrackPositionChosen("bottom")
  }, "bottom"), /* @__PURE__ */ React__default.createElement("td", {
    "aria-hidden": "true",
    className: classes["add-track-position-other"]
  })))));
}
AddTrackPositionMenu.propTypes = {
  onTrackPositionChosen: PropTypes.func.isRequired,
  theme: PropTypes.symbol.isRequired
};
const AddTrackPositionMenu$1 = withTheme(AddTrackPositionMenu);
function _classCallCheck$3(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$3(o.key), o);
  }
}
function _createClass$3(e, r2, t) {
  return r2 && _defineProperties$3(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$3(t) {
  var i = _toPrimitive$3(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$3(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$3(t, o, e) {
  return o = _getPrototypeOf$3(o), _possibleConstructorReturn$3(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf$3(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$3(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(t);
}
function _assertThisInitialized$3(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$3() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$3 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$3(t) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$3(t);
}
function _inherits$3(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$3(t, e);
}
function _setPrototypeOf$3(t, e) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$3(t, e);
}
let ConfigViewMenu = /* @__PURE__ */ (function(_ContextMenuContainer) {
  function ConfigViewMenu2(props) {
    var _this;
    _classCallCheck$3(this, ConfigViewMenu2);
    _this = _callSuper$3(this, ConfigViewMenu2, [props]);
    _this.state = {
      submenuShown: false
    };
    return _this;
  }
  _inherits$3(ConfigViewMenu2, _ContextMenuContainer);
  return _createClass$3(ConfigViewMenu2, [{
    key: "getConfigureViewMenu",
    value: function getConfigureViewMenu(position, bbox) {
      const availableOptions = ["backgroundColor"];
      const menuItems = {};
      const newOptions = {};
      for (const optionType of availableOptions) {
        if (optionType in Object.keys(OPTIONS_INFO)) {
          menuItems[optionType] = {
            name: OPTIONS_INFO[optionType].name
          };
          if (OPTIONS_INFO[optionType].inlineOptions) {
            for (const inlineOptionKey in OPTIONS_INFO[optionType].inlineOptions) {
              const inlineOption = OPTIONS_INFO[optionType].inlineOptions[inlineOptionKey];
              if (!menuItems[optionType].children) {
                menuItems[optionType].children = {};
              }
              const optionSelectorSettings = {
                name: inlineOption.name,
                value: inlineOption.value
                // missing handler to be filled in below
              };
              optionSelectorSettings.handler = () => {
                newOptions[optionType] = inlineOption.value;
                this.props.onOptionsChanged(newOptions);
              };
              menuItems[optionType].children[inlineOptionKey] = optionSelectorSettings;
            }
          }
        }
      }
      return /* @__PURE__ */ React__default.createElement(NestedContextMenu, {
        key: "config-series-menu",
        closeMenu: this.props.closeMenu,
        menuItems,
        orientation: this.state.orientation,
        parentBbox: bbox,
        position,
        theme: this.props.theme
      });
    }
  }, {
    key: "getSubmenu",
    value: function getSubmenu() {
      if (this.state.submenuShown) {
        const bbox = this.state.submenuSourceBbox;
        const position = this.state.orientation === "left" ? {
          left: this.state.left,
          top: bbox.top
        } : {
          left: this.state.left + bbox.width + 7,
          top: bbox.top
        };
        const subMenuData = this.state.submenuShown;
        if (subMenuData.option === "options") {
          return this.getConfigureViewMenu(position, bbox);
        }
        return /* @__PURE__ */ React__default.createElement("div", null);
      }
      return /* @__PURE__ */ React__default.createElement("div", null);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.div = c;
        },
        className: clsx$2(classes$5["context-menu"], {
          [classes$5["context-menu-dark"]]: this.props.theme === THEME_DARK
        }),
        "data-menu-type": "ConfigViewMenu",
        style: {
          left: this.state.left,
          top: this.state.top
        }
      }, /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onTogglePositionSearchBox(e)
      }, "Toggle position search box"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onZoomToData(e)
      }, "Zoom to data extent"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onClearView(e)
      }, "Clear View"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onYankZoom(e)
      }, "Take zoom from"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onYankLocation(e)
      }, "Take location from"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onYankZoomAndLocation(e)
      }, "Take zoom and location from"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.props.onLockZoom
      }, "Lock zoom with"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.props.onLockLocation
      }, "Lock location with"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.props.onLockZoomAndLocation
      }, "Lock zoom and location with"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: this.props.onTakeAndLockZoomAndLocation
      }, "Take and lock zoom and location with"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onUnlockZoom(e)
      }, "Unlock zoom"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onUnlockLocation(e)
      }, "Unlock location"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onUnlockZoomAndLocation(e)
      }, "Unlock zoom and location"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onProjectViewport(e)
      }, "Show this viewport on"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: (e) => this.props.onEditViewConfig(e)
      }, "Edit view config"), /* @__PURE__ */ React__default.createElement("hr", {
        className: classes$5["context-menu-hr"]
      }), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportSVG()
      }, "Export views as SVG"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportPNG()
      }, "Export views as PNG"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportViewAsJSON()
      }, "Export views as JSON"), /* @__PURE__ */ React__default.createElement(ContextMenuItem, {
        onClick: () => this.props.onExportViewAsLink()
      }, "Export views as Link"), this.getSubmenu());
    }
  }]);
})(ContextMenuContainer);
ConfigViewMenu.propTypes = {
  onEditViewConfig: PropTypes.func.isRequired,
  onExportSVG: PropTypes.func,
  onExportPNG: PropTypes.func,
  onExportViewAsJSON: PropTypes.func,
  onExportViewAsLink: PropTypes.func,
  onLockLocation: PropTypes.func,
  onLockZoom: PropTypes.func,
  onLockZoomAndLocation: PropTypes.func,
  onProjectViewport: PropTypes.func,
  onTakeAndLockZoomAndLocation: PropTypes.func,
  onTogglePositionSearchBox: PropTypes.func,
  onUnlockLocation: PropTypes.func,
  onUnlockZoom: PropTypes.func,
  onUnlockZoomAndLocation: PropTypes.func,
  onYankLocation: PropTypes.func,
  onYankZoom: PropTypes.func,
  onYankZoomAndLocation: PropTypes.func,
  onZoomToData: PropTypes.func,
  theme: PropTypes.symbol
};
function _classCallCheck$2(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$2(o.key), o);
  }
}
function _createClass$2(e, r2, t) {
  return r2 && _defineProperties$2(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$2(t) {
  var i = _toPrimitive$2(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$2(t, o, e) {
  return o = _getPrototypeOf$2(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$2(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(t);
}
function _assertThisInitialized$2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$2 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$2(t) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$2(t);
}
function _inherits$2(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$2(t, e);
}
function _setPrototypeOf$2(t, e) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$2(t, e);
}
let ViewHeader = /* @__PURE__ */ (function(_React$Component) {
  function ViewHeader2(props) {
    var _this;
    _classCallCheck$2(this, ViewHeader2);
    _this = _callSuper$2(this, ViewHeader2, [props]);
    _this.configImg = null;
    _this.plusImg = null;
    _this.state = {
      addTrackPositionMenuUid: null,
      addTrackPositionMenuPosition: null,
      configMenuUid: null,
      configMenuPosition: null,
      isFocused: false,
      width: -1
    };
    _this.handleTrackPositionChosenBound = _this.handleTrackPositionChosen.bind(_this);
    return _this;
  }
  _inherits$2(ViewHeader2, _React$Component);
  return _createClass$2(ViewHeader2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        width: this.el.clientWidth
      });
    }
  }, {
    key: "checkWidth",
    value: function checkWidth() {
      const width = this.el.clientWidth;
      if (width !== this.state.width) this.setState({
        width
      });
    }
    /**
     * The user clicked on the `cog` of the menu so we need to open
     * it.
     */
  }, {
    key: "handleConfigMenuOpened",
    value: function handleConfigMenuOpened(uid) {
      this.setState({
        configMenuUid: uid,
        configMenuPosition: this.configImg.getBoundingClientRect()
      });
    }
    /**
     * The user has clicked on the 'plus' sign at the top of a TiledPlot
     * so we need to open the Track Position Chooser dialog
     */
  }, {
    key: "handleAddTrackPositionMenuOpened",
    value: function handleAddTrackPositionMenuOpened(uid) {
      this.setState({
        addTrackPositionMenuUid: uid,
        addTrackPositionMenuPosition: this.plusImg.getBoundingClientRect()
      });
    }
    /**
     * The user has chosen a position for the new track. The actual
     * track selection will be handled by TiledPlot
     *
     * We just need to close the menu here.
     */
  }, {
    key: "handleTrackPositionChosen",
    value: function handleTrackPositionChosen(position, extent2) {
      this.props.onTrackPositionChosen(position, extent2);
      this.setState({
        addTrackPositionMenuUid: null,
        addTrackPositionMenuPosition: null
      });
    }
  }, {
    key: "render",
    value: function render3() {
      let configMenu = null;
      let addTrackPositionMenu = null;
      if (this.state.addTrackPositionMenuPosition) {
        addTrackPositionMenu = /* @__PURE__ */ React__default.createElement(PopupMenu, {
          onMenuClosed: () => {
            this.setState({
              addTrackPositionMenuUid: null,
              addTrackPositionMenuPosition: null
            });
          }
        }, /* @__PURE__ */ React__default.createElement(ContextMenuContainer, {
          orientation: "left",
          position: this.state.addTrackPositionMenuPosition,
          theme: this.props.theme
        }, /* @__PURE__ */ React__default.createElement(AddTrackPositionMenu$1, {
          onTrackPositionChosen: this.handleTrackPositionChosenBound
        })));
      }
      if (this.state.configMenuUid) {
        configMenu = /* @__PURE__ */ React__default.createElement(PopupMenu, {
          onMenuClosed: () => this.setState({
            configMenuUid: null
          })
        }, /* @__PURE__ */ React__default.createElement(ConfigViewMenu, {
          onClearView: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onClearView();
          },
          onEditViewConfig: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onEditViewConfig(this.state.configMenuUid);
          },
          onExportPNG: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportPNG();
          },
          onExportSVG: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportSVG();
          },
          onExportViewAsJSON: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportViewsAsJSON();
          },
          onExportViewAsLink: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onExportViewsAsLink();
          },
          onLockLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onLockLocation(this.state.configMenuUid);
          },
          onLockZoom: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onLockZoom(this.state.configMenuUid);
          },
          onLockZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onLockZoomAndLocation(this.state.configMenuUid);
          },
          onOptionsChanged: (newOptions) => {
            this.props.onViewOptionsChanged(newOptions);
            this.setState({
              configMenuUid: null
            });
          },
          onProjectViewport: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onProjectViewport(this.state.configMenuUid);
          },
          onTakeAndLockZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onTakeAndLockZoomAndLocation(this.state.configMenuUid);
          },
          onTogglePositionSearchBox: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onTogglePositionSearchBox(this.state.configMenuUid);
          },
          onUnlockLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onUnlockLocation(this.state.configMenuUid);
          },
          onUnlockZoom: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onUnlockZoom(this.state.configMenuUid);
          },
          onUnlockZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onUnlockZoomAndLocation(this.state.configMenuUid);
          },
          onYankLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onYankLocation(this.state.configMenuUid);
          },
          onYankZoom: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onYankZoom(this.state.configMenuUid);
          },
          onYankZoomAndLocation: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onYankZoomAndLocation(this.state.configMenuUid);
          },
          onZoomToData: () => {
            this.setState({
              configMenuUid: null
            });
            this.props.onZoomToData(this.state.configMenuUid);
          },
          orientation: "left",
          position: this.state.configMenuPosition,
          theme: this.props.theme
        }));
      }
      const GenomePositionSearchBox2 = this.props.getGenomePositionSearchBox(this.state.isFocused, (focus) => {
        this.setState({
          isFocused: focus
        });
      });
      const className = clsx$2(this.state.isFocused ? stylesMTHeader["multitrack-header-focus"] : stylesMTHeader["multitrack-header"], {
        [stylesMTHeader["multitrack-header-dark"]]: this.props.theme === THEME_DARK
      });
      const classNameIcon = this.state.width <= VIEW_HEADER_MED_WIDTH_SEARCH_BAR ? stylesMTHeader["multitrack-header-icon-squeazed"] : stylesMTHeader["multitrack-header-icon"];
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.el = c;
        },
        className
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: stylesMTHeader["multitrack-header-left"]
      }, this.props.mouseTool === MOUSE_TOOL_SELECT && /* @__PURE__ */ React__default.createElement("svg", {
        className: clsx$2(stylesMTHeader["mouse-tool-selection"], classNameIcon)
      }, /* @__PURE__ */ React__default.createElement("title", null, "Selection tool active"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#select"
      })), /* @__PURE__ */ React__default.createElement("div", {
        className: stylesMTHeader["multitrack-header-grabber"],
        title: "Drag to move the view"
      }, /* @__PURE__ */ React__default.createElement("div", null), /* @__PURE__ */ React__default.createElement("div", null), /* @__PURE__ */ React__default.createElement("div", null)), this.state.width > VIEW_HEADER_MIN_WIDTH_SEARCH_BAR && /* @__PURE__ */ React__default.createElement("div", {
        className: stylesMTHeader["multitrack-header-search"]
      }, this.props.isGenomePositionSearchBoxVisible && GenomePositionSearchBox2)), /* @__PURE__ */ React__default.createElement("nav", {
        className: stylesMTHeader["multitrack-header-nav-list"]
      }, /* @__PURE__ */ React__default.createElement("svg", {
        className: classNameIcon,
        onClick: this.props.onAddView
      }, /* @__PURE__ */ React__default.createElement("title", null, "Add new view (clone this view)"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#copy"
      })), /* @__PURE__ */ React__default.createElement("svg", {
        ref: (c) => {
          this.configImg = c;
        },
        className: classNameIcon,
        onClick: () => this.handleConfigMenuOpened(this.props.viewUid)
      }, /* @__PURE__ */ React__default.createElement("title", null, "Configure this view"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#cog"
      })), /* @__PURE__ */ React__default.createElement("svg", {
        ref: (c) => {
          this.plusImg = c;
        },
        className: classNameIcon,
        onClick: () => this.handleAddTrackPositionMenuOpened(this.props.viewUid),
        "data-testid": "add-track"
      }, /* @__PURE__ */ React__default.createElement("title", null, "Add Track"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#plus"
      })), /* @__PURE__ */ React__default.createElement("svg", {
        className: classNameIcon,
        onClick: this.props.onCloseView
      }, /* @__PURE__ */ React__default.createElement("title", null, "Close View"), /* @__PURE__ */ React__default.createElement("use", {
        xlinkHref: "#cross"
      }))), configMenu, addTrackPositionMenu);
    }
  }]);
})(React__default.Component);
ViewHeader.defaultProps = {
  isGenomePositionSearchBoxVisible: false
};
ViewHeader.propTypes = {
  getGenomePositionSearchBox: PropTypes.func.isRequired,
  isGenomePositionSearchBoxVisible: PropTypes.bool,
  mouseTool: PropTypes.string.isRequired,
  onAddView: PropTypes.func.isRequired,
  onClearView: PropTypes.func.isRequired,
  onCloseView: PropTypes.func.isRequired,
  onEditViewConfig: PropTypes.func.isRequired,
  onExportSVG: PropTypes.func.isRequired,
  onExportPNG: PropTypes.func.isRequired,
  onExportViewsAsJSON: PropTypes.func.isRequired,
  onExportViewsAsLink: PropTypes.func.isRequired,
  onLockLocation: PropTypes.func.isRequired,
  onLockZoom: PropTypes.func.isRequired,
  onLockZoomAndLocation: PropTypes.func.isRequired,
  onProjectViewport: PropTypes.func.isRequired,
  onTakeAndLockZoomAndLocation: PropTypes.func.isRequired,
  onTogglePositionSearchBox: PropTypes.func.isRequired,
  onTrackPositionChosen: PropTypes.func.isRequired,
  onUnlockLocation: PropTypes.func.isRequired,
  onUnlockZoom: PropTypes.func.isRequired,
  onUnlockZoomAndLocation: PropTypes.func.isRequired,
  onViewOptionsChanged: PropTypes.func.isRequired,
  onYankLocation: PropTypes.func.isRequired,
  onYankZoom: PropTypes.func.isRequired,
  onYankZoomAndLocation: PropTypes.func.isRequired,
  onZoomToData: PropTypes.func.isRequired,
  theme: PropTypes.symbol.isRequired,
  viewUid: PropTypes.string.isRequired
};
const ViewHeader$1 = withTheme(ViewHeader);
const forceUpdate = (self2) => {
  self2.setState(self2.state);
};
const createApi = function api2(context, pubSub) {
  const self2 = context;
  let pubSubs = [];
  const apiPubSub = createPubSub();
  const destroy = () => {
    pubSubs.forEach((subscription) => pubSub.unsubscribe(subscription));
    pubSubs = [];
  };
  return {
    destroy,
    publish: apiPubSub.publish,
    // Stack: mapping of callback names to arrays of callbacks, useful
    // to determine how many callbacks exist for a particular event.
    stack: apiPubSub.stack,
    // Public API
    public: {
      /**
       * HiGlass version
       * @return {string} Version number
       */
      get version() {
        return version;
      },
      /**
       * Enable or disable broadcasting the mouse position globally
       * @param {boolean} isBroadcastMousePositionGlobally - If `true` the mouse
       *   position will be broadcasted globally.
       */
      setBroadcastMousePositionGlobally(isBroadcastMousePositionGlobally = false) {
        self2.setBroadcastMousePositionGlobally(isBroadcastMousePositionGlobally);
      },
      /**
       * Enable or disable showing the global mouse position
       * @param {boolean} isShowGlobalMousePosition - If `true` the global mouse
       *   position will be shown for any track that has
       *   `options.showMousePosition = true`.
       */
      setShowGlobalMousePosition(isShowGlobalMousePosition = false) {
        self2.setShowGlobalMousePosition(isShowGlobalMousePosition);
      },
      /**
       * Convenience function to enable / disable the global mouse position
       * @description This function is equivalent to calling
       *   `setBroadcastMousePositionGlobally()` and
       *   `setShowGlobalMousePosition()`.
       * @param {boolean} isGlobalMousePosition - If `true` the global mouse
       *   position will be shown and broadcasted.
       */
      setGlobalMousePosition(isGlobalMousePosition = false) {
        self2.setBroadcastMousePositionGlobally(isGlobalMousePosition);
        self2.setShowGlobalMousePosition(isGlobalMousePosition);
      },
      /**
       * Set an auth header to be included with all tile requests.
       *
       * @param {string} newHeader The contensts of the header to be included.
       * Example: ``hgapi.setAuthHeader('JWT xyz')``
       */
      setAuthHeader(newHeader) {
        setTileProxyAuthHeader(newHeader);
        self2.reload();
      },
      /**
       * Get the currently set auth header
       */
      getAuthHeader() {
        return getTileProxyAuthHeader();
      },
      /**
       * Get a reference to the React HiGlassComponent
       *
       * @returns {HiGlassComponent}
       */
      getComponent() {
        return self2;
      },
      /**
       * Reload all or specific tiles for viewId/trackId
       *
       * @param {array} target Should be an array of type
       *                       ({ viewId: string, trackId: string } | string).
       *                       If the array is just strings, it's interpreted
       *                       as a list of views whose tracks to reload.
       */
      reload(target2) {
        let tracks2;
        if (!target2) {
          tracks2 = self2.iterateOverTracks();
        } else {
          tracks2 = target2.flatMap((d) => typeof d === "string" ? self2.iterateOverTracksInView(d) : d);
        }
        for (const {
          viewId,
          trackId
        } of tracks2) {
          const selectedTrack = self2.getTrackObject(viewId, trackId);
          for (const track of selectedTrack.childTracks || [selectedTrack]) {
            if (track.fetchedTiles) {
              track.removeTiles(Object.keys(track.fetchedTiles));
              track.fetching.clear();
              track.refreshTiles();
            }
            track.rerender(track.options, true);
          }
        }
      },
      /**
       * Destroy HiGlass instance
       */
      destroy() {
        destroy();
        const container = self2.topDivRef.current?.parentNode;
        if (container) {
          unmountFromContainer(container);
        }
      },
      /**
       * Force integer range selections.
       *
       * @example
       *
       * hgv.activateTool('select'); // Activate select tool
       * hgv.setRangeSelectionToFloat(); // Allow float range selections
       */
      setRangeSelectionToInt() {
        self2.setState({
          rangeSelectionToInt: true
        });
      },
      /**
       * Force float range selections.
       *
       * @example
       *
       * hgv.activateTool('select'); // Activate select tool
       * hgv.setRangeSelectionToFloat(); // Allow float range selections
       */
      setRangeSelectionToFloat() {
        self2.setState({
          rangeSelectionToInt: false
        });
      },
      /**
       *
       *  The following enpoint restricts the size of range selection equally for 1D or
       *  2D tracks to a certain length (specified in absolute coordinates).
       *
       * @param {Number} [minSize = 0]  Minimum range selection.
       *   ``undefined`` unsets the value.
       * @param {Number} [maxSize = Infinity] Maximum range selection.
       *   ``undefined`` unsets the value.
       * @example
       *
       * hgv.activateTool('select'); // Activate select tool
       * hgv.setRangeSelection1dSize(5000, 10000); // Force selections to be between 5 and 10 Kb
       */
      setRangeSelection1dSize(minSize = 0, maxSize = Number.POSITIVE_INFINITY) {
        self2.setState({
          rangeSelection1dSize: [minSize, maxSize]
        });
      },
      /**
       * Set a new view config to define the layout and data
       * of this component
       *
       * @param {obj} newViewConfig A JSON object that defines
       *    the state of the HiGlassComponent
       * @param {boolean} resolveImmediately If true, the returned promise resolves immediately
       *    even if not all data has loaded. This should be set to true, if the new viewconf does not request new data. Default: false.
       * @example
       *
       * const p = hgv.setViewConfig(newViewConfig);
       * p.then(() => {
       *   // the initial set of tiles has been loaded
       * });
       *
       * @return {Promise} dataLoaded A promise that resolves when
       *   all of the data for this viewconfig is loaded. If `resolveImmediately` is set to true,
       * the promise resolves without waiting for the data to be loaded.
       */
      setViewConfig(newViewConfig, resolveImmediately = false) {
        const viewsByUid = self2.processViewConfig(newViewConfig);
        const p = new Promise((resolve) => {
          this.requestsInFlight = 0;
          pubSubs.push(pubSub.subscribe("requestSent", () => {
            this.requestsInFlight += 1;
          }));
          pubSubs.push(pubSub.subscribe("requestReceived", () => {
            this.requestsInFlight -= 1;
            if (this.requestsInFlight === 0) {
              resolve();
            }
          }));
          self2.setState({
            viewConfig: newViewConfig,
            views: viewsByUid
          }, () => {
            if (resolveImmediately) {
              resolve();
            }
          });
        });
        return p;
      },
      /**
       * Retrieve the visible viewconf.
       *
       * @returns (Object) A JSON object describing the visible views
       */
      getViewConfig() {
        return self2.getViewsAsJson();
      },
      /**
       * Validate a viewconf.
       *
       * @returns (Boolean) A JSON object describing the visible views
       */
      validateViewConfig(viewConfig, {
        verbose = false
      } = {}) {
        const validate2 = new Ajv().compile(schema);
        const valid = validate2(viewConfig);
        if (verbose && validate2.errors) {
          console.warn(JSON.stringify(validate2.errors, null, 2));
        }
        return valid;
      },
      /**
       * Get the minimum and maximum visible values for a given track.
       *
       * @param {string} viewId The id of the view containing the track.
       * @param {string} trackId The id of the track to query.
       * @param {bool} [ignoreOffScreenValues=false] If ``true`` only truly visible values
       *  are considered. Otherwise the values of visible tiles are used. Not that
       *  considering only the truly visible
       *  values results in a roughly 10x slowdown (from 0.1 to 1 millisecond).
       * @param {bool} [ignoreFixedScale=false]  If ``true`` potentially fixed scaled values are
       *  ignored. I.e., if the
       *  absolute range is ``[1, 18]`` but you have fixed the output range to
       *  ``[4, 5]`` you would normally retrieve ``[4, 5]``. Having this option set to
       *  ``true`` retrieves the absolute ``[1, 18]`` range.
       * @example
       * const [minVal, maxVal] = hgv.getMinMaxValue('myView', 'myTrack');
       * @returns {Array} The minimum and maximum value
       */
      getMinMaxValue(viewId, trackId, ignoreOffScreenValues = false, ignoreFixedScale = false) {
        return self2.getMinMaxValue(viewId, trackId, ignoreOffScreenValues, ignoreFixedScale);
      },
      /**
       * Generate a sharable link to the current view config. The `url` parameter should contain
       * the API endpoint used to export the view link (e.g. 'http://localhost:8989/api/v1/viewconfs').
       * If it is not provided, the value is taken from the `exportViewUrl` value of the viewconf.
       *
       * @param {string}  url  Custom URL that should point to a higlass server's
       *   view config endpoint, i.e.,
       *   `http://my-higlass-server.com/api/v1/viewconfs/`.
       * @returns {Object}  Promise resolving to the link ID and URL.
       * @example
       * hgv.shareViewConfigAsLink('http://localhost:8989/api/v1/viewconfs')
       * .then((sharedViewConfig) => {
       *   const { id, url } = sharedViewConfig;
       *   console.log(`Shared view config (ID: ${id}) is available at ${url}`)
       * })
       * .catch((err) => { console.error('Something did not work. Sorry', err); })
       */
      shareViewConfigAsLink(url) {
        return self2.handleExportViewsAsLink(url, true);
      },
      /**
       * Show overlays where this track can be positioned. This
       * function will take a track definition and display red,
       * blue or green overlays highlighting where the track can
       * be placed on the view. Blue indicates that a track can
       * be placed in that region, red that it can't and green that
       * the mouse is currently over the given region.
       *
       * @param {obj} track { server, tilesetUid, datatype }
       *
       * @example
       *
       *  let lineTrack = {
       *   "server": "http://higlass.io/api/v1",
       *   "tilesetUid": "WtBJUYawQzS9M2WVIIHnlA",
       *   "datatype": "multivec",
       *   "defaultTracks": ['horizontal-stacked-bar']
       * }
       *
       * window.hgApi.showAvailableTrackPositions(lineTrack);
       */
      showAvailableTrackPositions(track) {
        self2.setState({
          draggingHappening: track
        });
      },
      /**
       * Hide the overlay showing where a track can be positioned
       */
      hideAvailableTrackPositions() {
        self2.setState({
          draggingHappening: null
        });
      },
      measureSize() {
        self2.measureSize();
        for (const tiledPlot of Object.values(self2.tiledPlots)) {
          if (tiledPlot) {
            tiledPlot.measureSize();
          }
        }
      },
      /**
       * Show the track chooser which highlights tracks
       * when the mouse is over them.
       *
       * @param  {Function} callback (toViewUid, toTrackUid) =>: A function
       *                             to be called when a track is chosen.
       * @return {[type]}            [description]
       */
      showTrackChooser(callback) {
        self2.setState({
          chooseTrackHandler: (...args) => {
            self2.setState({
              chooseTrackHandler: null
            });
            callback(...args);
          }
        });
      },
      /**
       * Hide the track chooser.
       */
      hideTrackChooser() {
        self2.setState({
          chooseTrackHandler: null
        });
      },
      /**
       *
       * When comparing different 1D tracks it can be desirable to fix their y or value
       * scale
       *
       * @param {string} [viewId=''] The view identifier. If you only have one view this
       * parameter can be omitted.
       *
       * @param {string} [trackId=null] The track identifier.
       * @param [Number] [minValue=null] Minimum value used for scaling the track.
       * @param [Number] [maxValue=null] Maximum value used for scaling the track.
       *
       * @example
       *
       * hgv.setTrackValueScale(myView, myTrack, 0, 100); // Sets the scaling to [0, 100]
       * hgv.setTrackValueScale(myView, myTrack); // Unsets the fixed scaling, i.e., enables
       * dynamic scaling again.
       */
      setTrackValueScaleLimits(viewId, trackId, minValue, maxValue) {
        self2.setTrackValueScaleLimits(viewId, trackId, minValue, maxValue);
      },
      /**
       * Choose a theme.
       * @deprecated since version 1.6.6. Use `setTheme()` instead.
       */
      setDarkTheme(darkTheme) {
        console.warn('`setDarkTheme(true)` is deprecated. Please use `setTheme("dark")`.');
        const theme = darkTheme ? "dark" : "light";
        self2.setTheme(theme);
      },
      /**
       * Choose a theme.
       */
      setTheme(theme) {
        console.warn("Please note that theming is still in beta!");
        self2.setTheme(theme);
      },
      /**
       * Change the current view port to a certain data location.
       * When ``animateTime`` is greater than 0, animate the transition.
        * If working with genomic data, a chromosome info file will need to be used in
       * order to calculate "data" coordinates from chromosome coordinates. "Data"
       * coordinates are simply the coordinates as if the chromosomes were placed next
       * to each other.
       *
       * @param {string} viewUid The identifier of the view to zoom
       * @param {Number} start1Abs The x start position
       * @param {Number} end1Abs The x end position
       * @param {Number} start2Abs (optional) The y start position. If not specified
       *    start1Abs will be used.
       * @param {Number} end2Abs (optional) The y end position. If not specified
       *    end1Abs will be used
       * @param {Number} animateTime The time to spend zooming to the specified location
       * @example
       *    // Absolute coordinates
       * hgApi.zoomTo('view1', 1000000, 1100000, 2000000, 2100000, 500);
       * // Chromosomal coordinates
       * hglib
       *   // Pass in the URL of your chrom sizes
       *   .ChromosomeInfo('//s3.amazonaws.com/pkerp/data/hg19/chromSizes.tsv')
       *   // Now we can use the chromInfo object to convert
       *   .then((chromInfo) => {
       *     // Go to PTEN
       *     hgApi.zoomTo(
       *       viewConfig.views[0].uid,
       *       chromInfo.chrToAbs(['chr10', 89596071]),
       *       chromInfo.chrToAbs(['chr10', 89758810]),
       *       chromInfo.chrToAbs(['chr10', 89596071]),
       *       chromInfo.chrToAbs(['chr10', 89758810]),
       *       2500  // Animation time
       *     );
       *   });
       *   // Just in case, let us catch errors
       *   .catch(error => console.error('Oh boy...', error))
       * // Using getLocation() for coordinates
       * let firstViewLoc = hgApi.getLocation(oldViewUid);
       * hgApi.zoomTo(
       *  viewUid,
       *  firstViewLoc["xDomain"][0],
       *  firstViewLoc["xDomain"][1],
       *  firstViewLoc["yDomain"][0],
       *  firstViewLoc["yDomain"][1]
       * );
       */
      zoomTo(viewUid, start1Abs, end1Abs, start2Abs, end2Abs, animateTime = 0) {
        self2.zoomTo(viewUid, start1Abs, end1Abs, start2Abs, end2Abs, animateTime);
      },
      /**
       * Change the current view port to a location near the gene of interest.
       * When ``animateTime`` is greater than 0, animate the transition.
       *
       * @param {string} viewUid The identifier of the view to zoom
       * @param {string} geneName The name of gene symbol to search
       * @param {string} padding The padding (base pairs) around a given gene for the navigation
       * @param {Number} animateTime The time to spend zooming to the specified location
       * @example
       * // Zoom to the location near 'MYC'
       * hgApi.zoomToGene('view1', 'MYC', 100, 2000);
       */
      zoomToGene(viewUid, geneName, padding = 0, animateTime = 0) {
        self2.zoomToGene(viewUid, geneName, padding, animateTime);
      },
      /**
       * Get the list of genes of top match for a given keyword.
       *
       * @param {string} viewUid The id of the view containing the track.
       * @param {string} keyword The substring of gene name to search.
       * @param {function} callback A function to be called upon gene list search.
       * @example
       * hgv.suggestGene('view1', 'MY', (suggestions) => {
       *    if(suggestions && suggestions.length > 0) {
       *      console.log('Gene suggested', suggestions[0].geneName);
       *      console.log('Chromosome', suggestions[0].chr);
       *      console.log('Start position', suggestions[0].txStart);
       *      console.log('End position', suggestions[0].txEnd);
       *    }
       * });
       */
      suggestGene(viewUid, keyword2, callback) {
        return self2.suggestGene(viewUid, keyword2, callback);
      },
      /**
       * Zoom so that the entirety of all the datasets in a view
       * are visible.
       * The passed in ``viewUid`` should refer to a view which is present. If it
       * doesn't, an exception will be thrown. Note that if this function is invoked
       * directly after a HiGlass component is created, the information about the
       * visible tilesets will not have been retrieved from the server and
       * ``zoomToDataExtent`` will not work as expected. To ensure that the
       * visible data has been loaded from the server, use the ``setViewConfig``
       * function and place ``zoomToDataExtent`` in the promise resolution.
       *
       * @param {string} viewUid The view uid of the view to zoom
       * @example
       *
       * const p = hgv.setViewConfig(newViewConfig);
       * p.then(() => {
       *     hgv.zoomToDataExtent('viewUid');
       * });
       */
      zoomToDataExtent(viewUid) {
        self2.handleZoomToData(viewUid);
      },
      /**
       * The endpoint allows you to reset the viewport to the initially defined X and Y
       * domains of your view config.
       *
       * @param {string} viewId The view identifier. If you have only one view you can
       * omit this parameter.
       *
       * @example
       *
       * hgv.resetViewport(); // Resets the first view
       */
      resetViewport(viewId) {
        self2.resetViewport(viewId);
      },
      /**
       * Some tools needs conflicting mouse events such as mousedown or mousemove. To
       * avoid complicated triggers for certain actions HiGlass supports different mouse
       * tools for different interactions. The default mouse tool enables pan&zoom. The
       * only other mouse tool available right now is ``select``, which lets you brush
       * on to a track to select a range for annotating regions.
       *
       * @param {string} [mouseTool='']  Select a mouse tool to use. Currently there
       * only 'default' and 'select' are available.
       *
       * @example
       *
       * hgv.activateTool('select'); // Select tool is active
       * hgv.activateTool(); // Default pan&zoom tool is active
       */
      activateTool(tool) {
        switch (tool) {
          case "track-select":
            self2.setMouseTool(MOUSE_TOOL_TRACK_SELECT);
            break;
          case "select":
            self2.setMouseTool(MOUSE_TOOL_SELECT);
            break;
          default:
            self2.setMouseTool(MOUSE_TOOL_MOVE);
            break;
        }
      },
      /**
       * Set the size mode for the higlass container
       *
       * @param {string sizeMode The size mode for the container.
       *                         The vailable options are 'default',
       *                         'bounded', 'overflow' and 'scroll'
       */
      setSizeMode(sizeMode) {
        switch (sizeMode) {
          case "bounded":
            self2.setSizeMode(SIZE_MODE_BOUNDED);
            break;
          case "overflow":
            self2.setSizeMode(SIZE_MODE_OVERFLOW);
            break;
          case "bounded-overflow":
            self2.setSizeMode(SIZE_MODE_BOUNDED_OVERFLOW);
            break;
          case "scroll":
            self2.setSizeMode(SIZE_MODE_SCROLL);
            break;
          default:
            self2.setSizeMode(SIZE_MODE_DEFAULT);
            break;
        }
      },
      /**
       * Get a Promise which returns a Blob containing a PNG for the current view.
       * It's possible to get string of the PNG bytes from that:
       *
       * @example
       * hgApi.exportAsPngBlobPromise().then(function(blob) {
       *   var reader = new FileReader();
       *   reader.addEventListener("loadend", function() {
       *     var array = new Uint8Array(reader.result.slice(0,8));
       *     console.log(array);
       *     console.log(new TextDecoder("iso-8859-2").decode(array));
       *   });
       *   reader.readAsArrayBuffer(blob);
       * });
       *
       * @returns {promise}
       */
      exportAsPngBlobPromise() {
        return self2.createPNGBlobPromise();
      },
      /**
       * Get the current view as an SVG. Relies on all the tracks implementing
       * their respective exportAsSVG methods.
       *
       * @returns {string} An SVG string of the current view.
       */
      exportAsSvg() {
        return self2.createSVGString();
      },
      /**
       * Export the current view as a Viewconf.
       *
       * @returns {string} A stringified version of the current viewconf
       */
      exportAsViewConfString() {
        return self2.getViewsAsString();
      },
      /**
       * Get the current range selection
       *
       * @return {Array} The current range selection
       */
      getRangeSelection() {
        return self2.rangeSelection;
      },
      /**
       * Get the current location for a view.
       *
       * @param {string} [viewId=null] The id of the view to get the location for
       * @returns {obj} A an object containing four arrays representing the domains and ranges of
       *  the x and y scales of the view.
       * @example
       *
       * const {xDomain, yDomain, xRange, yRange} = hgv.getLocation('viewId');
       */
      getLocation(viewId) {
        const wurstId = viewId ? self2.xScales[viewId] && self2.yScales[viewId] && viewId : Object.values(self2.tiledPlots)[0]?.props.uid;
        if (!wurstId) {
          return "Please provide a valid view UUID sweetheart 😙";
        }
        return {
          xDomain: self2.xScales[wurstId].domain(),
          yDomain: self2.yScales[wurstId].domain(),
          xRange: self2.xScales[wurstId].range(),
          yRange: self2.yScales[wurstId].range()
        };
      },
      /**
       * Return the track's javascript object. This is useful for subscribing to
       * data events (dataChanged)
       *
       * @param {string} viewId The id of the view containing the track
       * @param {string} trackId The id of the track within the view
       * @return {obj} The HiGlass track object for this track
       */
      getTrackObject(viewId, trackId) {
        let newViewId = viewId;
        let newTrackId = trackId;
        if (!trackId) {
          newViewId = Object.values(self2.state.views)[0].uid;
          newTrackId = viewId;
        }
        return getTrackObjectFromHGC(self2, newViewId, newTrackId);
      },
      /**
       * Set or get an option.
       * @param   {string}  key  The name of the option you want get or set
       * @param   {*}  value  If not `undefined`, `key` will be set to `value`
       * @return  {obj}  When `value` is `undefined` the current value of
       *   `key` will be returned.
       */
      option(key, value) {
        if (typeof value === "undefined") return self2.props.options[key];
        switch (key) {
          case "sizeMode":
            self2.props.options[key] = value;
            forceUpdate(self2);
            break;
          default:
            console.warn(`This option "${key}" is either unknown or not settable.`);
        }
        return void 0;
      },
      /**
       * Cancel a subscription.
       *
       * @param {string} event One of the available events
       * @param {function} listener The function to unsubscribe
       * @param {string} viewId The viewId to unsubscribe it from (not strictly necessary)
       * The variables used in the following examples are coming from the examples of ``on()``.
       *
       * @example
       *
       * hgv.off('location', listener, 'viewId1');
       * hgv.off('rangeSelection', rangeListener);
       * hgv.off('viewConfig', viewConfigListener);
       * hgv.off('mouseMoveZoom', mmz);
       * hgv.off('wheel', wheelListener);
       * hgv.off('createSVG');
       * hgv.off('click');
       * hgv.off('geneSearch', geneSearchListener);
       */
      off(event, listenerId, viewId) {
        const callback = typeof listenerId === "object" ? listenerId.callback : listenerId;
        switch (event) {
          case "annotationCreated":
            apiPubSub.unsubscribe("annotationCreated", callback);
            break;
          case "annotationChanged":
            apiPubSub.unsubscribe("annotationChanged", callback);
            break;
          case "annotationRemoved":
            apiPubSub.unsubscribe("annotationRemoved", callback);
            break;
          case "click":
            apiPubSub.unsubscribe("click", callback);
            break;
          case "cursorLocation":
            apiPubSub.unsubscribe("cursorLocation", callback);
            break;
          case "datasetInfo":
            apiPubSub.unsubscribe("datasetInfo", callback);
            break;
          case "location":
            self2.offLocationChange(viewId, listenerId);
            break;
          case "mouseMoveZoom":
            apiPubSub.unsubscribe("mouseMoveZoom", callback);
            break;
          case "wheel":
            apiPubSub.unsubscribe("wheel", callback);
            break;
          case "rangeSelection":
            apiPubSub.unsubscribe("rangeSelection", callback);
            break;
          case "viewConfig":
            self2.offViewChange(listenerId);
            break;
          case "createSVG":
            self2.offPostCreateSVG();
            break;
          case "geneSearch":
            apiPubSub.unsubscribe("geneSearch", callback);
            break;
        }
      },
      /**
       * Subscribe to events
       *
       *
       * HiGlass exposes the following event, which one can subscribe to via this method:
       *
       * - location
       * - rangeSelection
       * - viewConfig
       * - mouseMoveZoom
       *
       * **Event types**
       *
       * ``click``: Returns clicked objects. (Currently only clicks on 1D annotations are captured.)
       *
       * .. code-block:: javascript
       *
       *     [
       *      {
       *       event: {
       *          type: 'annotation',
       *          event: { ... },
       *          payload: [230000000, 561000000]
       *        },
       *       trackType: '1d-annotation',
       *       trackUid: 'xyz',
       *       viewUid: 'abc'
       *      }
       *     ]
       *
       * ``cursorLocation:`` Returns an object describing the location under the cursor
       *
       * .. code-block:: javascript
       *
       *    {
       *        absX: 100,
       *        absY: 200,
       *        relX: 50,
       *        relY: 150,
       *        relTrackX: 50,
       *        relTrackY: 100,
       *        dataX: 10000,
       *        dataY: 123456,
       *        isFrom2dTrack: false,
       *        isFromVerticalTrack: false,
       *    }
       *
       * ``location:`` Returns an object describing the visible region
       *
       * .. code-block:: javascript
       *
       *    {
       *        xDomain: [1347750580.3773856, 1948723324.787681],
       *        xRange: [0, 346],
       *        yDomain: [1856870481.5391564, 2407472678.0075483],
       *        yRange: [0, 317]
       *    }
       *
       * ``rangeSelection:`` Returns a BED- (1D) or BEDPE (1d) array of the selected data and
       * genomic range (if chrom-sizes are available)
       *
       * .. code-block:: javascript
       *
       *  // Global output
       *  {
       *    dataRange: [...]
       *    genomicRange: [...]
       *  }
       *
       *  // 1D data range
       *  [[1218210862, 1528541001], null]
       *
       *  // 2D data range
       *  [[1218210862, 1528541001], [1218210862, 1528541001]]
       *
       *  // 1D or BED-like array
       *  [["chr1", 249200621, "chrM", 50000], null]
       *
       *  // 2D or BEDPE-like array
       *  [["chr1", 249200621, "chr2", 50000], ["chr3", 197972430, "chr4", 50000]]
       *
       * ``viewConfig:`` Returns the current view config (as a string).
       *  This event is published upon interactions including:
       *  - Saving in the view config editor modal.
       *  - Panning and zooming in views, which update view object ``initialXDomain`` and ``initialYDomain`` values.
       *  - Brushing in ``viewport-projection-`` tracks containing null ``fromViewUid`` fields, which update track object ``projectionXDomain`` and ``projectionYDomain`` values.
       *
       * ``mouseMoveZoom:`` Returns the location and data at the mouse cursor's
       * screen location.
       *
       * .. code-block:: javascript
       *
       *  {
       *    // Float value of the hovering track
       *    data,
       *    // Absolute x screen position of the cursor in px
       *    absX,
       *    // Absolute y screen position of the cursor in px
       *    absY,
       *    // X screen position of the cursor in px relative to the track extent.
       *    relX,
       *    // Y screen position of the cursor in px relative to the track extent.
       *    relY,
       *    // Data x position of the cursor relative to the track's data.
       *    dataX,
       *    // Data y position of the cursor relative to the track's data.
       *    dataY,
       *    // Track orientation, i.e., '1d-horizontal', '1d-vertical', or '2d'
       *    orientation: '1d-horizontal',
       *
       *    // The following properties are only returned when hovering 2D tracks:
       *    // Raw Float32Array
       *    dataLens,
       *    // Dimension of the lens, e.g., 3 (the lens is squared so `3` corresponds
       *    // to a 3x3 matrix represented by an array of length 9)
       *    dim,
       *    // Function for converting the raw data values to rgb values
       *    toRgb,
       *    // Center position of the data or genomic position (as a BED array)
       *    center,
       *    // Range of the x data or genomic position (as a BEDPE array)
       *    xRange,
       *    // Range of the y data or genomic position (as a BEDPE array)
       *    yRange,
       *    // If `true` `center`, `xRange`, and `yRange` are given in genomic positions
       *    isGenomicCoords
       *  }
       *
       * ``createSVG:`` Set a callback to obtain the current exported SVG DOM node,
       *                and potentially return a manipulated SVG DOM node.
       *
       * @param {string} event One of the events described below
       *
       * @param {function} callback A callback to be called when the event occurs
       *
       * @param {string} viewId The view ID to listen to events
       *
       * @example
       *
       * let locationListenerId;
       * hgv.on(
       *   'location',
       *   location => console.log('Here we are:', location),
       *   'viewId1',
       *   listenerId => locationListenerId = listenerId
       * );
       *
       * const rangeListenerId = hgv.on(
       *   'rangeSelection',
       *   range => console.log('Selected', range)
       * );
       *
       * const viewConfigListenerId = hgv.on(
       *   'viewConfig',
       *   range => console.log('Selected', range)
       * );
       *
       * const mmz = event => console.log('Moved', event);
       * hgv.on('mouseMoveZoom', mmz);
       *
       * const wheelListener = event => console.log('Wheel', event);
       * hgv.on('wheel', wheelListener);
       *
       * hgv.on('createSVG', (svg) => {
       *    const circle = document.createElement('circle');
       *    circle.setAttribute('cx', 100);
       *    circle.setAttribute('cy', 100);
       *    circle.setAttribute('r', 50);
       *    circle.setAttribute('fill', 'green');
       *    svg.appendChild(circle);
       *    return svg;
       * });
       *
       * const geneSearchListener = event => {
       *    console.log('Gene searched', event.geneSymbol);
       *    console.log('Range of the gene', event.range);
       *    console.log('Center of the gene', event.centerX);
       * }
       * hgv.on('geneSearch', geneSearchListener);
       */
      on(event, callback, viewId, callbackId) {
        switch (event) {
          case "annotationCreated":
            return apiPubSub.subscribe("annotationCreated", callback);
          case "annotationChanged":
            return apiPubSub.subscribe("annotationChanged", callback);
          case "annotationRemoved":
            return apiPubSub.subscribe("annotationRemoved", callback);
          case "click":
            return apiPubSub.subscribe("click", callback);
          case "cursorLocation":
            return apiPubSub.subscribe("cursorLocation", callback);
          case "datasetInfo":
            return apiPubSub.subscribe("datasetInfo", callback);
          case "location":
            return self2.onLocationChange(viewId, callback, callbackId);
          case "mouseMoveZoom":
            return apiPubSub.subscribe("mouseMoveZoom", callback);
          case "wheel":
            return apiPubSub.subscribe("wheel", callback);
          case "rangeSelection":
            return apiPubSub.subscribe("rangeSelection", callback);
          case "viewConfig":
            return self2.onViewChange(callback);
          case "createSVG":
            return self2.onPostCreateSVG(callback);
          case "geneSearch":
            return apiPubSub.subscribe("geneSearch", callback);
          default:
            return void 0;
        }
      }
    }
  };
};
function createSymbolIcon(el2, id2, paths, viewBox) {
  const symbol = el2.append("symbol").attr("id", id2).attr("viewBox", viewBox);
  paths.forEach((d) => symbol.append("path").attr("d", d).attr("fill", "currentColor"));
}
const HiGlassComponentContext = /* @__PURE__ */ React.createContext(null);
const positionedTracksToAllTracks = (positionedTracks, {
  includeCombinedContents = true
} = {}) => {
  const allTracks = [];
  for (const trackType of TRACK_LOCATIONS) {
    const theseTracks = positionedTracks[trackType];
    theseTracks?.forEach((x) => {
      if ("contents" in x) {
        if (includeCombinedContents) {
          x.contents.forEach((y) => {
            allTracks.push(Object.assign({}, y, {
              position: trackType
            }));
          });
        }
      }
      allTracks.push(Object.assign({}, x, {
        position: trackType
      }));
    });
  }
  return allTracks;
};
const higlass = "_higlass_1k7ri_1";
const styles = {
  higlass,
  "higlass-dark-theme": "_higlass-dark-theme_1k7ri_5",
  "higlass-container-overflow": "_higlass-container-overflow_1k7ri_9",
  "higlass-scroll-container-overflow": "_higlass-scroll-container-overflow_1k7ri_10",
  "higlass-scroll-container-scroll": "_higlass-scroll-container-scroll_1k7ri_11",
  "higlass-canvas": "_higlass-canvas_1k7ri_28",
  "higlass-drawing-surface": "_higlass-drawing-surface_1k7ri_33",
  "higlass-svg": "_higlass-svg_1k7ri_38",
  "tiled-area": "_tiled-area_1k7ri_47",
  "track-mouseover-menu": "_track-mouseover-menu_1k7ri_54"
};
function _classCallCheck$1(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey$1(o.key), o);
  }
}
function _createClass$1(e, r2, t) {
  return r2 && _defineProperties$1(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper$1(t, o, e) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$1(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn$1(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t);
}
function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct$1 = function() {
    return !!t;
  })();
}
function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf$1(t);
}
function _inherits$1(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf$1(t, e);
}
function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf$1(t, e);
}
const NUM_GRID_COLUMNS = 12;
const DEFAULT_NEW_VIEW_HEIGHT = 12;
const VIEW_HEADER_HEIGHT = 20;
let HiGlassComponent = /* @__PURE__ */ (function(_React$Component) {
  function HiGlassComponent2(props) {
    var _this;
    _classCallCheck$1(this, HiGlassComponent2);
    _this = _callSuper$1(this, HiGlassComponent2, [props]);
    if (numericifyVersion(React__default.version) < 15.6) {
      console.warn("HiGlass requires React v15.6 or higher. Current version: ", React__default.version);
    }
    _this.topDivRef = /* @__PURE__ */ React__default.createRef();
    _this.pubSub = createPubSub();
    _this.domEvent = domEvent(_this.pubSub);
    _this.pubSubs = [];
    _this.minHorizontalHeight = 20;
    _this.minVerticalWidth = 20;
    _this.resizeSensor = null;
    _this.uid = slugid.nice();
    _this.tiledPlots = {};
    _this.genomePositionSearchBoxes = {};
    _this.xScales = {};
    _this.yScales = {};
    _this.projectionXDomains = {};
    _this.projectionYDomains = {};
    _this.topDiv = null;
    _this.zoomToDataExtentOnInit = /* @__PURE__ */ new Set();
    _this.viewTrackUidsToCombinedUid = {};
    _this.combinedUidToViewTrack = {};
    _this.scalesChangedListeners = {};
    _this.draggingChangedListeners = {};
    _this.valueScalesChangedListeners = {};
    _this.zoomLocks = {};
    _this.locationLocks = {};
    _this.locationLocksAxisWise = {
      x: {},
      y: {}
    };
    _this.valueScaleLocks = {};
    _this.prevAuthToken = props.options.authToken;
    _this.setCenters = {};
    _this.plusImg = {};
    _this.configImg = {};
    GLOBALS.PIXI = props.options?.PIXI || PIXI;
    _this.viewMarginTop = +props.options.viewMarginTop >= 0 ? +props.options.viewMarginTop : DEFAULT_VIEW_MARGIN;
    _this.viewMarginBottom = +props.options.viewMarginBottom >= 0 ? +props.options.viewMarginBottom : DEFAULT_VIEW_MARGIN;
    _this.viewMarginLeft = +props.options.viewMarginLeft >= 0 ? +props.options.viewMarginLeft : DEFAULT_VIEW_MARGIN;
    _this.viewMarginRight = +props.options.viewMarginRight >= 0 ? +props.options.viewMarginRight : DEFAULT_VIEW_MARGIN;
    _this.viewPaddingTop = +props.options.viewPaddingTop >= 0 ? +props.options.viewPaddingTop : DEFAULT_VIEW_PADDING;
    _this.viewPaddingBottom = +props.options.viewPaddingBottom >= 0 ? +props.options.viewPaddingBottom : DEFAULT_VIEW_PADDING;
    _this.viewPaddingLeft = +props.options.viewPaddingLeft >= 0 ? +props.options.viewPaddingLeft : DEFAULT_VIEW_PADDING;
    _this.viewPaddingRight = +props.options.viewPaddingRight >= 0 ? +props.options.viewPaddingRight : DEFAULT_VIEW_PADDING;
    _this.genomePositionSearchBox = null;
    _this.viewHeaders = {};
    _this.boundRefreshView = () => {
      _this.refreshView(LONG_DRAG_TIMEOUT);
    };
    _this.unsetOnLocationChange = [];
    _this.setTheme(props.options.theme, props.options.isDarkTheme);
    _this.viewconfLoaded = false;
    const {
      viewConfig
    } = _this.props;
    const views = _this.processViewConfig(JSON.parse(JSON.stringify(_this.props.viewConfig)));
    if (props.options.authToken) {
      setTileProxyAuthHeader(props.options.authToken);
    }
    _this.pixiRoot = new GLOBALS.PIXI.Container();
    _this.pixiRoot.interactive = true;
    _this.pixiStage = new GLOBALS.PIXI.Container();
    _this.pixiStage.interactive = true;
    _this.pixiRoot.addChild(_this.pixiStage);
    _this.pixiMask = new GLOBALS.PIXI.Graphics();
    _this.pixiRoot.addChild(_this.pixiMask);
    _this.pixiStage.mask = _this.pixiMask;
    _this.element = null;
    _this.scrollTop = 0;
    let mouseTool = MOUSE_TOOL_MOVE;
    if (_this.props.options) {
      switch (_this.props.options.mouseTool) {
        case MOUSE_TOOL_SELECT:
          mouseTool = MOUSE_TOOL_SELECT;
          break;
        case MOUSE_TOOL_TRACK_SELECT:
          mouseTool = MOUSE_TOOL_TRACK_SELECT;
          break;
      }
    }
    if (_this.props.options.pluginTracks) {
      window.higlassTracksByType = Object.assign(window.higlassTracksByType || {}, _this.props.options.pluginTracks);
    }
    const pluginTracks = {};
    try {
      if (window.higlassTracksByType) {
        Object.entries(window.higlassTracksByType).forEach(([trackType, trackDef]) => {
          pluginTracks[trackType] = trackDef;
        });
      }
    } catch (e) {
      console.warn("Broken config of a plugin track");
    }
    if (_this.props.options.pluginDataFetchers) {
      window.higlassDataFetchersByType = Object.assign(window.higlassDataFetchersByType || {}, _this.props.options.pluginDataFetchers);
    }
    const pluginDataFetchers = window.higlassDataFetchersByType;
    const rowHeight = _this.props.options.pixelPreciseMarginPadding ? 1 : 30;
    _this.mounted = false;
    _this.pluginTracks = pluginTracks;
    _this.pluginDataFetchers = pluginDataFetchers;
    _this.state = {
      width: 0,
      height: 0,
      rowHeight,
      svgElement: null,
      canvasElement: null,
      customDialog: null,
      views,
      viewConfig,
      addTrackPositionMenuPosition: null,
      typedEditable: void 0,
      mouseOverOverlayUid: null,
      mouseTool,
      overTrackChooser: null,
      isDarkTheme: false,
      rangeSelection1dSize: [0, Number.POSITIVE_INFINITY],
      rangeSelectionToInt: false,
      modal: null,
      sizeMode: _this.props.options?.sizeMode
    };
    _this.attachedToDOM = false;
    const {
      public: api3,
      destroy: apiDestroy,
      publish: apiPublish,
      stack: apiStack
    } = createApi(_this, _this.pubSub);
    _this.api = api3;
    _this.apiDestroy = apiDestroy;
    _this.apiPublish = apiPublish;
    _this.apiStack = apiStack;
    _this.viewChangeListener = [];
    _this.triggerViewChangeDb = debounce$1(_this.triggerViewChange.bind(_this), 250);
    _this.pubSubs = [];
    _this.rangeSelection = [null, null];
    _this.prevMouseHoverTrack = null;
    _this.zooming = false;
    _this.appClickHandlerBound = _this.appClickHandler.bind(_this);
    _this.canvasClickHandlerBound = _this.canvasClickHandler.bind(_this);
    _this.keyDownHandlerBound = _this.keyDownHandler.bind(_this);
    _this.keyUpHandlerBound = _this.keyUpHandler.bind(_this);
    _this.resizeHandlerBound = _this.resizeHandler.bind(_this);
    _this.resizeHandlerBound = _this.resizeHandler.bind(_this);
    _this.dispatchEventBound = _this.dispatchEvent.bind(_this);
    _this.animateOnMouseMoveHandlerBound = _this.animateOnMouseMoveHandler.bind(_this);
    _this.zoomStartHandlerBound = _this.zoomStartHandler.bind(_this);
    _this.zoomEndHandlerBound = _this.zoomEndHandler.bind(_this);
    _this.zoomHandlerBound = _this.zoomHandler.bind(_this);
    _this.trackDroppedHandlerBound = _this.trackDroppedHandler.bind(_this);
    _this.trackDimensionsModifiedHandlerBound = _this.trackDimensionsModifiedHandler.bind(_this);
    _this.animateBound = _this.animate.bind(_this);
    _this.animateOnGlobalEventBound = _this.animateOnGlobalEvent.bind(_this);
    _this.requestReceivedHandlerBound = _this.requestReceivedHandler.bind(_this);
    _this.wheelHandlerBound = _this.wheelHandler.bind(_this);
    _this.mouseMoveHandlerBound = _this.mouseMoveHandler.bind(_this);
    _this.onMouseLeaveHandlerBound = _this.onMouseLeaveHandler.bind(_this);
    _this.onBlurHandlerBound = _this.onBlurHandler.bind(_this);
    _this.openModalBound = _this.openModal.bind(_this);
    _this.closeModalBound = _this.closeModal.bind(_this);
    _this.handleEditViewConfigBound = _this.handleEditViewConfig.bind(_this);
    _this.onScrollHandlerBound = _this.onScrollHandler.bind(_this);
    _this.viewUidToNameBound = _this.viewUidToName.bind(_this);
    _this.typedText = "";
    _this.typedTextTimeout = null;
    _this.modal = {
      open: _this.openModalBound,
      close: _this.closeModalBound
    };
    _this.setBroadcastMousePositionGlobally(_this.props.options.broadcastMousePositionGlobally || _this.props.options.globalMousePosition);
    _this.setShowGlobalMousePosition(_this.props.options.showGlobalMousePosition || _this.props.options.globalMousePosition);
    return _this;
  }
  _inherits$1(HiGlassComponent2, _React$Component);
  return _createClass$1(HiGlassComponent2, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.domEvent.register("keydown", document);
      this.domEvent.register("keyup", document);
      this.domEvent.register("scroll", document);
      this.domEvent.register("resize", window);
      this.domEvent.register("orientationchange", window);
      this.domEvent.register("wheel", window);
      this.domEvent.register("mousedown", window, true);
      this.domEvent.register("mouseup", window, true);
      this.domEvent.register("click", window, true);
      this.domEvent.register("mousemove", window);
      this.domEvent.register("touchmove", window);
      this.domEvent.register("touchstart", window);
      this.domEvent.register("touchend", window);
      this.domEvent.register("touchcancel", window);
      this.domEvent.register("blur", window);
      this.pubSubs.push(this.pubSub.subscribe("app.click", this.appClickHandlerBound), this.pubSub.subscribe("blur", this.onBlurHandlerBound), this.pubSub.subscribe("keydown", this.keyDownHandlerBound), this.pubSub.subscribe("keyup", this.keyUpHandlerBound), this.pubSub.subscribe("resize", this.resizeHandlerBound), this.pubSub.subscribe("wheel", this.wheelHandlerBound), this.pubSub.subscribe("orientationchange", this.resizeHandlerBound), this.pubSub.subscribe("app.event", this.dispatchEventBound), this.pubSub.subscribe("app.animateOnMouseMove", this.animateOnMouseMoveHandlerBound), this.pubSub.subscribe("trackDropped", this.trackDroppedHandlerBound), this.pubSub.subscribe("trackDimensionsModified", this.trackDimensionsModifiedHandlerBound), this.pubSub.subscribe("app.zoomStart", this.zoomStartHandlerBound), this.pubSub.subscribe("app.zoomEnd", this.zoomEndHandlerBound), this.pubSub.subscribe("app.zoom", this.zoomHandlerBound), this.pubSub.subscribe("requestReceived", this.requestReceivedHandlerBound));
      if (this.props.getApi) {
        this.props.getApi(this.api);
      }
    }
  }, {
    key: "sizeMode",
    get: function() {
      return typeof this.state.sizeMode === "undefined" ? this.props.options.bounded ? "bounded" : SIZE_MODE_DEFAULT : this.state.sizeMode;
    }
  }, {
    key: "setBroadcastMousePositionGlobally",
    value: function setBroadcastMousePositionGlobally(isBroadcastMousePositionGlobally = false) {
      this.isBroadcastMousePositionGlobally = isBroadcastMousePositionGlobally;
    }
  }, {
    key: "setShowGlobalMousePosition",
    value: function setShowGlobalMousePosition(isShowGlobalMousePosition = false) {
      this.isShowGlobalMousePosition = isShowGlobalMousePosition;
      if (this.isShowGlobalMousePosition && !this.globalMousePositionListener) {
        this.globalMousePositionListener = globalPubSub.subscribe("higlass.mouseMove", this.animateOnGlobalEventBound);
        this.pubSubs.push(this.globalMousePositionListener);
      }
      if (this.isShowGlobalMousePosition && !this.globalMousePositionListener) {
        const index2 = this.pubSubs.findIndex((listener) => listener === this.globalMousePositionListener);
        globalPubSub.unsubscribe(this.globalMousePositionListener);
        if (index2 >= 0) this.pubSubs.splice(index2, 1);
        this.globalMousePositionListener = void 0;
      }
    }
  }, {
    key: "zoomStartHandler",
    value: function zoomStartHandler() {
      this.hideHoverMenu();
      this.zooming = true;
    }
  }, {
    key: "zoomEndHandler",
    value: function zoomEndHandler() {
      this.zooming = false;
    }
  }, {
    key: "zoomHandler",
    value: function zoomHandler(evt) {
      if (!evt.sourceEvent) return;
      this.mouseMoveHandler(evt.sourceEvent);
    }
  }, {
    key: "waitForDOMAttachment",
    value: function waitForDOMAttachment(callback) {
      if (!this.mounted) return;
      const thisElement = this.topDivRef.current;
      if (thisElement?.getRootNode().contains(thisElement)) {
        callback();
      } else {
        requestAnimationFrame(() => this.waitForDOMAttachment(callback));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.element = this.topDivRef.current;
      window.addEventListener("focus", this.boundRefreshView);
      Object.values(this.state.views).forEach((view) => {
        this.adjustLayoutToTrackSizes(view);
        if (!view.layout) {
          view.layout = this.generateViewLayout(view);
        } else {
          view.layout.i = view.uid;
        }
      });
      const rendererOptions = {
        width: this.state.width,
        height: this.state.height,
        view: this.canvasElement,
        antialias: true,
        transparent: true,
        resolution: 2,
        autoResize: true
      };
      switch (PIXI.VERSION[0]) {
        case "4":
          console.warn("Deprecation warning: please update Pixi.js to version 5!");
          if (this.props.options.renderer === "canvas") {
            this.pixiRenderer = new GLOBALS.PIXI.CanvasRenderer(rendererOptions);
          } else {
            this.pixiRenderer = new GLOBALS.PIXI.WebGLRenderer(rendererOptions);
          }
          break;
        // case '5':
        // case '6':
        // case '7': // Gosling uses PIXI.js v7
        default:
          if (this.props.options.renderer === "canvas") {
            this.pixiRenderer = new GLOBALS.PIXI.CanvasRenderer(rendererOptions);
          } else {
            this.pixiRenderer = new GLOBALS.PIXI.Renderer(rendererOptions);
          }
          break;
      }
      this.fitPixiToParentContainer();
      const [initialWidth, initialHeight] = getElementDim(this.element);
      this.setState({
        svgElement: this.svgElement,
        canvasElement: this.canvasElement,
        ...initialWidth > 0 ? {
          width: initialWidth
        } : {},
        ...initialHeight > 0 ? {
          height: initialHeight
        } : {}
      });
      this.waitForDOMAttachment(() => {
        cssElementQueriesExports.ElementQueries.listen();
        this.resizeSensor = new cssElementQueriesExports.ResizeSensor(this.element.parentNode, this.updateAfterResize.bind(this));
        this.updateAfterResize();
      });
      this.handleDragStart();
      this.handleDragStop();
      this.animate();
      const baseSvg = select(this.element).append("svg").style("display", "none");
      all.forEach((icon) => createSymbolIcon(baseSvg, icon.id, icon.paths, icon.viewBox));
    }
  }, {
    key: "getTrackObject",
    value: function getTrackObject(viewUid, trackUid) {
      return this.tiledPlots[viewUid]?.trackRenderer?.getTrackObject(trackUid);
    }
  }, {
    key: "getTrackRenderer",
    value: function getTrackRenderer2(viewUid) {
      return this.tiledPlots[viewUid]?.trackRenderer;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (this.mounted) {
        this.setState({
          viewConfig: newProps.viewConfig
        });
      }
      const viewsByUid = this.processViewConfig(JSON.parse(JSON.stringify(newProps.viewConfig)));
      if (newProps.options.authToken !== this.prevAuthToken) {
        setTileProxyAuthHeader(newProps.options.authToken);
        this.reload();
        this.prevAuthToken = newProps.options.authToken;
      }
      for (const view of dictValues(viewsByUid)) {
        this.adjustLayoutToTrackSizes(view);
      }
      this.setState({
        views: viewsByUid
      });
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate() {
      this.pixiRenderer.render(this.pixiRoot);
    }
  }, {
    key: "reload",
    value: function reload() {
      for (const viewId of this.iterateOverViews()) {
        const trackRenderer = this.getTrackRenderer(viewId);
        if (!trackRenderer) continue;
        const trackDefinitions = JSON.parse(trackRenderer.prevTrackDefinitions);
        trackRenderer.syncTrackObjects([]);
        trackRenderer.syncTrackObjects(trackDefinitions);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setTheme(this.props.options.theme, this.props.options.isDarkTheme);
      this.animate();
      this.triggerViewChangeDb();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.pixiStage.destroy(false);
      this.pixiStage = null;
      this.pixiRenderer.destroy(true);
      this.pixiRenderer = null;
      window.removeEventListener("focus", this.boundRefreshView);
      if (this.resizeSensor) this.resizeSensor.detach();
      this.domEvent.unregister("keydown", document);
      this.domEvent.unregister("keyup", document);
      this.domEvent.unregister("scroll", document);
      this.domEvent.unregister("wheel", window);
      this.domEvent.unregister("mousedown", window);
      this.domEvent.unregister("mouseup", window);
      this.domEvent.unregister("click", window);
      this.domEvent.unregister("mousemove", window);
      this.domEvent.unregister("touchmove", window);
      this.domEvent.unregister("touchstart", window);
      this.domEvent.unregister("touchend", window);
      this.domEvent.unregister("touchcancel", window);
      this.pubSubs.forEach((subscription) => this.pubSub.unsubscribe(subscription));
      this.pubSubs = [];
      this.apiDestroy();
    }
    /* ---------------------------- Custom Methods ---------------------------- */
  }, {
    key: "setTheme",
    value: function setTheme(newTheme = this.props.options.theme, isDarkTheme = this.props.options.isDarkTheme) {
      if (typeof isDarkTheme !== "undefined") {
        console.warn("The option `isDarkTheme` is deprecated. Please use `theme` instead.");
        this.theme = isDarkTheme ? "dark" : "light";
      } else {
        switch (newTheme) {
          case "dark":
            this.theme = THEME_DARK;
            break;
          case "light":
          case void 0:
            this.theme = THEME_LIGHT;
            break;
          default:
            console.warn(`Unknown theme "${newTheme}". Using light theme.`);
            this.theme = THEME_LIGHT;
            break;
        }
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent2(e) {
      if (!this.canvasElement) return;
      forwardEvent(e, this.canvasElement);
    }
  }, {
    key: "trackDroppedHandler",
    value: function trackDroppedHandler() {
      this.setState({
        draggingHappening: null
      });
    }
  }, {
    key: "requestReceivedHandler",
    value: function requestReceivedHandler() {
      if (!this.viewconfLoaded && requestsInFlight === 0) {
        this.viewconfLoaded = true;
        if (this.props.options.onViewConfLoaded) {
          this.props.options.onViewConfLoaded();
        }
      }
    }
  }, {
    key: "animateOnMouseMoveHandler",
    value: function animateOnMouseMoveHandler(active2) {
      if (active2 && !this.animateOnMouseMove) {
        this.pubSubs.push(this.pubSub.subscribe("app.mouseMove", this.animateBound));
      }
      this.animateOnMouseMove = active2;
    }
  }, {
    key: "fitPixiToParentContainer",
    value: function fitPixiToParentContainer() {
      const element = this.topDivRef.current;
      if (!element || !element.parentNode) {
        return;
      }
      const width = element.parentNode.clientWidth;
      const height = element.parentNode.clientHeight;
      this.pixiMask.beginFill(16777215).drawRect(0, 0, width, height).endFill();
      this.pixiRenderer.resize(width, height);
      this.pixiRenderer.view.style.width = `${width}px`;
      this.pixiRenderer.view.style.height = `${height}px`;
      this.pixiRenderer.render(this.pixiRoot);
    }
    /**
     * Add default track options. These can come from two places:
     *
     * 1. The track definitions (configs/tracks-info.js)
     * 2. The default options passed into the component
     *
     * Of these, #2 takes precendence over #1.
     *
     * @param {array} track The track to add default options to
     */
  }, {
    key: "addDefaultTrackOptions",
    value: function addDefaultTrackOptions(track) {
      const trackInfo2 = this.getTrackInfo(track.type);
      if (!trackInfo2) return;
      if (typeof track.options === "undefined") {
        track.options = {};
      }
      const trackOptions = track.options ? track.options : {};
      if (this.props.options.defaultTrackOptions) {
        if (this.props.options.defaultTrackOptions.trackSpecific?.[track.type]) {
          const options2 = this.props.options.defaultTrackOptions.trackSpecific[track.type];
          for (const optionName in options2) {
            track.options[optionName] = typeof track.options[optionName] !== "undefined" ? track.options[optionName] : JSON.parse(JSON.stringify(options2[optionName]));
          }
        }
        if (this.props.options.defaultTrackOptions.all) {
          const options2 = this.props.options.defaultTrackOptions.all;
          for (const optionName in options2) {
            track.options[optionName] = typeof track.options[optionName] !== "undefined" ? track.options[optionName] : JSON.parse(JSON.stringify(options2[optionName]));
          }
        }
      }
      if (trackInfo2.defaultOptions) {
        const defaultThemeOptions = trackInfo2.defaultOptionsByTheme?.[this.theme] ? trackInfo2.defaultOptionsByTheme[this.theme] : {};
        const defaultOptions2 = {
          ...trackInfo2.defaultOptions,
          ...defaultThemeOptions
        };
        if (!track.options) {
          track.options = JSON.parse(JSON.stringify(defaultOptions2));
        } else {
          for (const optionName in defaultOptions2) {
            track.options[optionName] = typeof track.options[optionName] !== "undefined" ? track.options[optionName] : JSON.parse(JSON.stringify(defaultOptions2[optionName]));
          }
        }
      } else {
        track.options = trackOptions;
      }
    }
  }, {
    key: "toggleTypedEditable",
    value: function toggleTypedEditable() {
      this.setState({
        typedEditable: !this.isEditable()
      });
    }
    /** Handle typed commands (e.g. e-d-i-t) */
  }, {
    key: "typedTextHandler",
    value: function typedTextHandler(event) {
      if (!this.props.options.cheatCodesEnabled) {
        return;
      }
      this.typedText = this.typedText.concat(event.key);
      if (this.typedText.endsWith("hgedit")) {
        this.toggleTypedEditable();
        this.typedText = "";
      }
      const TYPED_TEXT_TIMEOUT = 750;
      if (this.typedTextTimeout) {
        clearTimeout(this.typedTextTimeout);
      }
      this.typedTextTimeout = setTimeout(() => {
        this.typedText = "";
      }, TYPED_TEXT_TIMEOUT);
    }
  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(event) {
      this.typedTextHandler(event);
      if (this.props.options.rangeSelectionOnAlt && event.key === "Alt") {
        this.setState({
          mouseTool: MOUSE_TOOL_SELECT
        });
      }
    }
  }, {
    key: "keyUpHandler",
    value: function keyUpHandler(event) {
      if (this.props.options.rangeSelectionOnAlt && event.key === "Alt") {
        this.setState({
          mouseTool: MOUSE_TOOL_MOVE
        });
      }
    }
  }, {
    key: "openModal",
    value: function openModal(modal) {
      this.setState({
        // The following is only needed for testing purposes
        modal: /* @__PURE__ */ React__default.cloneElement(modal, {
          ref: (c) => {
            this.modalRef = c;
          }
        })
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modalRef = null;
      this.setState({
        modal: null
      });
    }
  }, {
    key: "handleEditViewConfig",
    value: function handleEditViewConfig() {
      const {
        viewConfig: viewConfigTmp
      } = this.state;
      this.setState({
        viewConfigTmp
      });
      this.openModal(/* @__PURE__ */ React__default.createElement(ViewConfigEditor$1, {
        onCancel: () => {
          const {
            viewConfigTmp: viewConfig
          } = this.state;
          const views = this.processViewConfig(viewConfig);
          for (const view of dictValues(views)) {
            this.adjustLayoutToTrackSizes(view);
          }
          this.setState({
            views,
            viewConfig,
            viewConfigTmp: null
          });
        },
        onChange: (viewConfigJson) => {
          const viewConfig = JSON.parse(viewConfigJson);
          const views = this.processViewConfig(viewConfig);
          for (const view of dictValues(views)) {
            this.adjustLayoutToTrackSizes(view);
          }
          this.setState({
            views,
            viewConfig
          });
        },
        onSave: (viewConfigJson) => {
          const viewConfig = JSON.parse(viewConfigJson);
          const views = this.processViewConfig(viewConfig);
          for (const view of dictValues(views)) {
            this.adjustLayoutToTrackSizes(view);
          }
          this.setState({
            views,
            viewConfig,
            viewConfigTmp: null
          });
        },
        viewConfig: this.getViewsAsString()
      }));
    }
  }, {
    key: "animate",
    value: function animate() {
      if (this.isRequestingAnimationFrame) return;
      this.isRequestingAnimationFrame = true;
      requestAnimationFrame(() => {
        if (!this.pixiRenderer) return;
        this.pixiRenderer.render(this.pixiRoot);
        this.isRequestingAnimationFrame = false;
      });
    }
  }, {
    key: "animateOnGlobalEvent",
    value: function animateOnGlobalEvent({
      sourceUid
    } = {}) {
      if (sourceUid !== this.uid && this.animateOnMouseMove) this.animate();
    }
  }, {
    key: "measureSize",
    value: function measureSize() {
      const [width, height] = getElementDim(this.element);
      if (width > 0 && height > 0) {
        this.setState({
          sizeMeasured: true,
          width,
          height
        });
      }
    }
  }, {
    key: "updateAfterResize",
    value: function updateAfterResize() {
      this.measureSize();
      this.updateRowHeight();
      this.fitPixiToParentContainer();
      this.refreshView(LONG_DRAG_TIMEOUT);
      this.resizeHandler();
    }
  }, {
    key: "handleOverlayMouseEnter",
    value: function handleOverlayMouseEnter(uid) {
      this.setState({
        mouseOverOverlayUid: uid
      });
    }
  }, {
    key: "handleOverlayMouseLeave",
    value: function handleOverlayMouseLeave() {
      this.setState({
        mouseOverOverlayUid: null
      });
    }
    /**
     * We want to lock the zoom of this view to the zoom of another view.
     *
     * First we pick which other view we want to lock to.
     *
     * The we calculate the current zoom offset and center offset. The differences
     * between the center of the two views will always remain the same, as will the
     * different between the zoom levels.
     */
  }, {
    key: "handleLockLocation",
    value: function handleLockLocation(uid) {
      this.setState({
        chooseViewHandler: (uid2) => this.handleLocationLockChosen(uid, uid2),
        mouseOverOverlayUid: uid
      });
    }
    /**
     * Can views be added, removed or rearranged and are the view headers
     * visible?
     */
  }, {
    key: "isEditable",
    value: function isEditable() {
      if (this.state.typedEditable !== void 0) {
        return this.state.typedEditable;
      }
      if (!this.props.options || !("editable" in this.props.options)) {
        return this.state.viewConfig.editable;
      }
      return this.props.options.editable && this.state.viewConfig.editable;
    }
    /**
     * Can views be added, removed or rearranged and are the view headers
     * visible?
     */
  }, {
    key: "isTrackMenuDisabled",
    value: function isTrackMenuDisabled() {
      if (this.props.options && (this.props.options.editable === false || this.props.options.tracksEditable === false)) {
        return true;
      }
      return this.state.viewConfig && (this.state.viewConfig.tracksEditable === false || this.state.viewConfig.editable === false);
    }
    /**
     * Can views be added, removed or rearranged and are the view headers
     * visible?
     */
  }, {
    key: "isViewHeaderDisabled",
    value: function isViewHeaderDisabled() {
      if (this.props.options && (this.props.options.editable === false || this.props.options.viewEditable === false)) {
        return true;
      }
      return this.state.viewConfig && (this.state.viewConfig.viewEditable === false || this.state.viewConfig.editable === false);
    }
    /**
     * Iteratate over all of the views in this component
     */
  }, {
    key: "iterateOverViews",
    value: function iterateOverViews() {
      const viewIds = [];
      for (const viewId of Object.keys(this.state.views)) {
        viewIds.push(viewId);
      }
      return viewIds;
    }
  }, {
    key: "iterateOverTracksInView",
    value: function iterateOverTracksInView(viewId) {
      const allTracks = [];
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      for (const trackType in tracks2) {
        for (const track of tracks2[trackType]) {
          if (track.type === "combined" && track.contents) {
            for (const subTrack of track.contents) {
              allTracks.push({
                viewId,
                trackId: subTrack.uid,
                track: subTrack
              });
            }
          } else {
            allTracks.push({
              viewId,
              trackId: track.uid,
              track
            });
          }
        }
      }
      return allTracks;
    }
    /**
     * Iterate over all the tracks in this component.
     */
  }, {
    key: "iterateOverTracks",
    value: function iterateOverTracks() {
      const allTracks = [];
      for (const viewId in this.state.views) {
        const {
          tracks: tracks2
        } = this.state.views[viewId];
        for (const trackType in tracks2) {
          for (const track of tracks2[trackType]) {
            if (track.type === "combined" && track.contents) {
              for (const subTrack of track.contents) {
                allTracks.push({
                  viewId,
                  trackId: subTrack.uid,
                  track: subTrack
                });
              }
            } else {
              allTracks.push({
                viewId,
                trackId: track.uid,
                track
              });
            }
          }
        }
      }
      return allTracks;
    }
  }, {
    key: "setMouseTool",
    value: function setMouseTool(mouseTool) {
      this.setState({
        mouseTool
      });
    }
  }, {
    key: "setSizeMode",
    value: function setSizeMode(sizeMode) {
      this.setState({
        sizeMode
      });
    }
    /**
     * Checks if a track's value scale is locked with another track
     */
  }, {
    key: "isValueScaleLocked",
    value: function isValueScaleLocked(viewUid, trackUid) {
      const uid = this.combineViewAndTrackUid(viewUid, trackUid);
      if (!this.state.views[viewUid]) {
        return false;
      }
      if (this.valueScaleLocks[uid]) {
        return true;
      }
      return false;
    }
    /**
     * Computed the minimal and maximal values of all tracks that are in the same
     * lockGroup as a given track
     * @param   {string}  viewUid  The id of the view containing the track
     * @param   {string}  trackUid   The id of the track
     * @return  {array}  Tuple [min,max] containing the overall extrema - or null.
     */
  }, {
    key: "getLockGroupExtrema",
    value: function getLockGroupExtrema(viewUid, trackUid) {
      const uid = this.combineViewAndTrackUid(viewUid, trackUid);
      if (!this.state.views[viewUid]) {
        return null;
      }
      if (!this.valueScaleLocks[uid]) {
        return null;
      }
      const lockGroup = this.valueScaleLocks[uid];
      const lockedTracks = Object.values(lockGroup).filter((track) => this.tiledPlots[track.view]).map((track) => this.tiledPlots[track.view].trackRenderer.getTrackObject(track.track)).filter((track) => track).filter((track) => track.valueScale || track.originalTrack?.valueScale).map((track) => track.originalTrack === void 0 ? track : track.originalTrack);
      const minValues = lockedTracks.filter((track) => track.minRawValue && track.maxRawValue).map((track) => lockGroup.ignoreOffScreenValues ? track.minVisibleValue(true) : track.minVisibleValueInTiles(true));
      const maxValues = lockedTracks.filter((track) => track.minRawValue && track.maxRawValue).map((track) => lockGroup.ignoreOffScreenValues ? track.maxVisibleValue(true) : track.maxVisibleValueInTiles(true));
      if (minValues.length === 0 || minValues.filter((x) => x === null || x === Number.POSITIVE_INFINITY).length > 0) {
        return null;
      }
      if (maxValues.length === 0 || maxValues.filter((x) => x === null || x === Number.NEGATIVE_INFINITY).length > 0) {
        return null;
      }
      const allMin = Math.min(...minValues);
      const allMax = Math.max(...maxValues);
      return [allMin, allMax];
    }
    /**
     * Syncing the values of locked scales
     *
     * Arguments
     * ---------
     *  viewUid: string
     *    The id of the view containing the track whose value scale initially changed
     *  trackUid: string
     *    The id of the track that whose value scale changed
     *
     * Returns
     * -------
     *    Nothing
     */
  }, {
    key: "syncValueScales",
    value: function syncValueScales(viewUid, trackUid) {
      const uid = this.combineViewAndTrackUid(viewUid, trackUid);
      if (!this.state.views[viewUid]) return;
      const sourceTrack = getTrackByUid(this.state.views[viewUid].tracks, trackUid);
      if (this.valueScaleLocks[uid]) {
        const lockGroup = this.valueScaleLocks[uid];
        const lockedTracks = Object.values(lockGroup).filter((track) => this.tiledPlots[track.view]).map((track) => this.tiledPlots[track.view].trackRenderer.getTrackObject(track.track)).filter((track) => track).map((track) => track.originalTrack === void 0 ? track : track.originalTrack);
        const lockGroupExtrema = this.getLockGroupExtrema(viewUid, trackUid);
        if (lockGroupExtrema === null) {
          return;
        }
        const allMin = lockGroupExtrema[0];
        const allMax = lockGroupExtrema[1];
        const epsilon3 = 1e-6;
        for (const lockedTrack of lockedTracks) {
          if (lockedTrack.minValue) {
            lockedTrack.minValue(allMin);
          }
          if (lockedTrack.maxValue) {
            lockedTrack.maxValue(allMax);
          }
          if (!lockedTrack.valueScale) {
            continue;
          }
          const hasScaleChanged = Math.abs(lockedTrack.minValue() - lockedTrack.valueScale.domain()[0]) > epsilon3 || Math.abs(lockedTrack.maxValue() - lockedTrack.valueScale.domain()[1]) > epsilon3;
          const hasBrushMoved = sourceTrack?.options && lockedTrack.options && typeof sourceTrack.options.scaleStartPercent !== "undefined" && typeof sourceTrack.options.scaleEndPercent !== "undefined" && (Math.abs(lockedTrack.options.scaleStartPercent - sourceTrack.options.scaleStartPercent) > epsilon3 || Math.abs(lockedTrack.options.scaleEndPercent - sourceTrack.options.scaleEndPercent) > epsilon3);
          if (lockedTrack.continuousScaling && !hasScaleChanged && !hasBrushMoved) {
            continue;
          }
          lockedTrack.valueScale.domain([allMin, allMax]);
          lockedTrack.prevValueScale = lockedTrack.valueScale.copy();
          if (hasBrushMoved) {
            lockedTrack.options.scaleStartPercent = sourceTrack.options.scaleStartPercent;
            lockedTrack.options.scaleEndPercent = sourceTrack.options.scaleEndPercent;
          }
          lockedTrack.rerender(lockedTrack.options, true);
        }
      }
    }
  }, {
    key: "handleNewTilesLoaded",
    value: function handleNewTilesLoaded(viewUid, trackUid) {
      this.animate();
    }
  }, {
    key: "notifyDragChangedListeners",
    value: function notifyDragChangedListeners(dragging) {
      dictValues(this.draggingChangedListeners).forEach((l) => {
        dictValues(l).forEach((listener) => listener(dragging));
      });
    }
    /**
     * Add a listener that will be called every time the view is updated.
     *
     * @param viewUid: The uid of the view being observed
     * @param listenerUid: The uid of the listener
     * @param eventHandler: The handler to be called when the scales change
     *    Event handler is called with parameters (xScale, yScale)
     */
  }, {
    key: "addDraggingChangedListener",
    value: function addDraggingChangedListener(viewUid, listenerUid, eventHandler) {
      if (!(viewUid in this.draggingChangedListeners)) {
        this.draggingChangedListeners[viewUid] = {};
      }
      this.draggingChangedListeners[viewUid][listenerUid] = eventHandler;
      eventHandler(true);
      eventHandler(false);
    }
    /**
     * Remove a scale change event listener
     *
     * @param viewUid: The view that it's listening on.
     * @param listenerUid: The uid of the listener itself.
     */
  }, {
    key: "removeDraggingChangedListener",
    value: function removeDraggingChangedListener(viewUid, listenerUid) {
      if (viewUid in this.draggingChangedListeners) {
        const listeners = this.draggingChangedListeners[viewUid];
        if (listenerUid in listeners) {
          listeners[listenerUid](false);
          delete listeners[listenerUid];
        }
      }
    }
    /**
     * Add an event listener that will be called every time the scale
     * of the view with uid viewUid is changed.
     *
     * @param viewUid: The uid of the view being observed
     * @param listenerUid: The uid of the listener
     * @param eventHandler: The handler to be called when the scales change
     *    Event handler is called with parameters (xScale, yScale)
     */
  }, {
    key: "addScalesChangedListener",
    value: function addScalesChangedListener(viewUid, listenerUid, eventHandler) {
      if (!this.scalesChangedListeners[viewUid]) {
        this.scalesChangedListeners[viewUid] = {};
      }
      this.scalesChangedListeners[viewUid][listenerUid] = eventHandler;
      if (!this.xScales[viewUid] || !this.yScales[viewUid]) {
        return;
      }
      eventHandler(this.xScales[viewUid], this.yScales[viewUid]);
    }
    /**
     * Remove a scale change event listener
     *
     * @param viewUid: The view that it's listening on.
     * @param listenerUid: The uid of the listener itself.
     */
  }, {
    key: "removeScalesChangedListener",
    value: function removeScalesChangedListener(viewUid, listenerUid) {
      if (this.scalesChangedListeners[viewUid]) {
        const listeners = this.scalesChangedListeners[viewUid];
        if (listeners[listenerUid]) {
          delete listeners[listenerUid];
        }
      }
    }
  }, {
    key: "createSVG",
    value: function createSVG() {
      const svg = document.createElement("svg");
      svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("version", "1.1");
      for (const tiledPlot of dictValues(this.tiledPlots)) {
        if (!tiledPlot) continue;
        for (const trackDefObject of dictValues(tiledPlot.trackRenderer.trackDefObjects)) {
          if (trackDefObject.trackObject.exportSVG) {
            const trackSVG = trackDefObject.trackObject.exportSVG();
            if (trackSVG) svg.appendChild(trackSVG[0]);
          }
        }
      }
      svg.setAttribute("width", this.canvasElement.style.width);
      svg.setAttribute("height", this.canvasElement.style.height);
      if (this.postCreateSVGCallback) {
        const modifiedSvg = this.postCreateSVGCallback(svg);
        return modifiedSvg;
      }
      return svg;
    }
  }, {
    key: "createSVGString",
    value: function createSVGString() {
      const svg = this.createSVG();
      let svgString = vkbeautify.xml(new window.XMLSerializer().serializeToString(svg));
      svgString = svgString.replace(/<a0:/g, "<");
      svgString = svgString.replace(/<\/a0:/g, "</");
      svgString = svgString.replace(/(<svg[\n\r])(\s+xmlns="http:\/\/www\.w3\.org\/1999\/xhtml"[\n\r])/gm, "$1");
      svgString = svgString.replace(/(\s+<clipPath[\n\r]\s+)(xmlns="http:\/\/www\.w3\.org\/2000\/svg")/gm, "$1");
      const xmlDeclaration = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>';
      const doctype2 = '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">';
      return `${xmlDeclaration}
${doctype2}
${svgString}`;
    }
  }, {
    key: "handleExportSVG",
    value: function handleExportSVG() {
      download("export.svg", new Blob([this.createSVGString()], {
        type: "image/svg+xml"
      }));
    }
  }, {
    key: "offPostCreateSVG",
    value: function offPostCreateSVG() {
      this.postCreateSVGCallback = null;
    }
  }, {
    key: "onPostCreateSVG",
    value: function onPostCreateSVG(callback) {
      this.postCreateSVGCallback = callback;
    }
  }, {
    key: "createPNGBlobPromise",
    value: function createPNGBlobPromise() {
      return new Promise((resolve) => {
        const svgString = this.createSVGString();
        const img = new Image(this.canvasElement.width, this.canvasElement.height);
        img.src = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`;
        img.onload = () => {
          const targetCanvas = document.createElement("canvas");
          targetCanvas.width = this.canvasElement.width / 2;
          targetCanvas.height = this.canvasElement.height / 2;
          targetCanvas.getContext("2d").drawImage(img, 0, 0);
          targetCanvas.toBlob((blob) => {
            resolve(blob);
          });
        };
      });
    }
  }, {
    key: "handleExportPNG",
    value: function handleExportPNG() {
      this.createPNGBlobPromise().then((blob) => {
        download("export.png", blob);
      });
    }
    /*
     * The scales of some view have changed (presumably in response to zooming).
     *
     * Mark the new scales and update any locked views.
     *
     * @param uid: The view of whom the scales have changed.
     */
  }, {
    key: "handleScalesChanged",
    value: function handleScalesChanged(uid, xScale, yScale, notify = true) {
      this.xScales[uid] = xScale;
      this.yScales[uid] = yScale;
      if (notify) {
        if (uid in this.scalesChangedListeners) {
          dictValues(this.scalesChangedListeners[uid]).forEach((x) => {
            x(xScale, yScale);
          });
        }
      }
      if (this.zoomLocks[uid]) {
        const lockGroup = this.zoomLocks[uid];
        const lockGroupItems = dictItems(lockGroup);
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          if (key === uid) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          const rk = value[2] / lockGroup[uid][2];
          const newK = k * rk;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](keyCenterX, keyCenterY, newK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (key in this.scalesChangedListeners) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      if (this.locationLocks[uid]) {
        const lockGroup = this.locationLocks[uid];
        const lockGroupItems = dictItems(lockGroup);
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          if (key === uid) {
            continue;
          }
          const dx = value[0] - lockGroup[uid][0];
          const dy = value[1] - lockGroup[uid][1];
          const newCenterX = centerX + dx;
          const newCenterY = centerY + dy;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](newCenterX, newCenterY, keyK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (key in this.scalesChangedListeners) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      if (this.locationLocksAxisWise.x[uid]) {
        const lockGroup = this.locationLocksAxisWise.x[uid].lock;
        const lockGroupItems = dictItems(lockGroup);
        const lockCrossAxis = this.locationLocksAxisWise.x[uid].axis !== "x";
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          if (key === uid) {
            continue;
          }
          const dx = value[0] - lockGroup[uid][0];
          const newCenterX = centerX + dx;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](lockCrossAxis ? keyCenterX : newCenterX, lockCrossAxis ? newCenterX : keyCenterY, keyK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (key in this.scalesChangedListeners) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      if (this.locationLocksAxisWise.y[uid]) {
        const lockGroup = this.locationLocksAxisWise.y[uid].lock;
        const lockGroupItems = dictItems(lockGroup);
        const lockCrossAxis = this.locationLocksAxisWise.y[uid].axis !== "y";
        const [centerX, centerY, k] = scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          const value = lockGroupItems[i][1];
          if (!this.xScales[key] || !this.yScales[key]) {
            continue;
          }
          const [keyCenterX, keyCenterY, keyK] = scalesCenterAndK(this.xScales[key], this.yScales[key]);
          if (key === uid) {
            continue;
          }
          const dy = value[1] - lockGroup[uid][1];
          const newCenterY = centerY + dy;
          if (!this.setCenters[key]) {
            continue;
          }
          const [newXScale, newYScale] = this.setCenters[key](lockCrossAxis ? newCenterY : keyCenterX, lockCrossAxis ? keyCenterY : newCenterY, keyK, false);
          this.xScales[key] = newXScale;
          this.yScales[key] = newYScale;
          if (key in this.scalesChangedListeners) {
            dictValues(this.scalesChangedListeners[key]).forEach((x) => {
              x(newXScale, newYScale);
            });
          }
        }
      }
      this.animate();
      this.triggerViewChangeDb();
    }
  }, {
    key: "handleProjectViewport",
    value: function handleProjectViewport(uid) {
      this.setState({
        chooseTrackHandler: (viewUid, trackUid) => this.handleViewportProjected(uid, viewUid, trackUid)
      });
    }
    /**
     * Adjust the zoom level so that all of the data is visible
     *
     * @param viewUid: The view uid for which to adjust the zoom level
     */
  }, {
    key: "handleZoomToData",
    value: function handleZoomToData(viewUid) {
      if (viewUid && !this.tiledPlots[viewUid]) {
        throw new Error(`View uid ${viewUid} does not exist in the current viewConfig`);
      }
      if (viewUid) {
        this.tiledPlots[viewUid].handleZoomToData();
      } else {
        Object.values(this.tiledPlots).forEach((tiledPlot) => tiledPlot.handleZoomToData());
      }
    }
    /**
     * Reset the viewport to the initial x and y domain
     * @param  {number} viewId - ID of the view for which the viewport should be
     *  reset.
     */
  }, {
    key: "resetViewport",
    value: function resetViewport(viewId) {
      if (viewId && !this.tiledPlots[viewId]) {
        throw new Error(`View uid ${viewId} does not exist in the current viewConfig`);
      }
      if (viewId) {
        this.tiledPlots[viewId].resetViewport();
      } else {
        Object.values(this.tiledPlots).forEach((tiledPlot) => tiledPlot.resetViewport());
      }
    }
    /**
     * We want to yank some attributes from another view.
     *
     * This will create a view selection overlay and then call the selected
     * provided function.
     */
  }, {
    key: "handleYankFunction",
    value: function handleYankFunction(uid, yankFunction) {
      this.setState({
        chooseViewHandler: (uid2) => yankFunction(uid, uid2),
        mouseOverOverlayUid: uid
      });
    }
    /**
     * We want to unlock uid from the zoom group that it's in.
     *
     * @param uid: The uid of a view.
     */
  }, {
    key: "handleUnlock",
    value: function handleUnlock(uid, lockGroups) {
      const lockGroup = lockGroups[uid];
      const lockGroupKeys = dictKeys(lockGroup);
      if (lockGroupKeys.length === 2) {
        delete lockGroups[lockGroupKeys[0]];
        delete lockGroups[lockGroupKeys[1]];
        return;
      }
      if (lockGroups[uid]) {
        if (lockGroups[uid][uid]) {
          delete lockGroups[uid][uid];
        }
      }
      if (lockGroups[uid]) {
        delete lockGroups[uid];
      }
    }
  }, {
    key: "viewScalesLockData",
    value: function viewScalesLockData(uid) {
      if (!this.xScales[uid] || !this.yScales[uid]) {
        console.warn("View scale lock doesn't correspond to existing uid: ", uid);
        return null;
      }
      return scalesCenterAndK(this.xScales[uid], this.yScales[uid]);
    }
    /*
     * :param uid1 (string): The uid of the first element to be locked (e.g. viewUid)
     * :param uid2 (string): The uid of the second element to be locked (e.g. viewUid)
     * :param lockGroups (dict): The set of locks where to store this lock (e.g. this.locationLocks)
     * :parma lockData (function): A function that takes two uids and calculates some extra data
     * to store with this lock data (e.g. scalesCenterAndK(this.xScales[uid1], this.yScales[uid1]))
     */
  }, {
    key: "addLock",
    value: function addLock(uid1, uid2, lockGroups, lockData) {
      let group1Members = [];
      let group2Members = [];
      if (!lockGroups[uid1]) {
        group1Members = [[uid1, lockData.bind(this)(uid1)]];
      } else {
        group1Members = dictItems(lockGroups[uid1]).filter((x) => lockData(x[0])).map((x) => [x[0], lockData(x[0])]);
      }
      if (!lockGroups[uid2]) {
        group2Members = [[uid2, lockData.bind(this)(uid2)]];
      } else {
        group2Members = dictItems(lockGroups[uid2]).filter((x) => lockData.bind(this)(x[0])).map((x) => (
          // x is [uid, [centerX, centerY, k]]
          [x[0], lockData.bind(this)(x[0])]
        ));
      }
      const allMembers = group1Members.concat(group2Members);
      const groupDict = dictFromTuples(allMembers);
      allMembers.forEach((m) => {
        lockGroups[m[0]] = groupDict;
      });
    }
    /* Views uid1 and uid2 need to be locked so that they always maintain the current
     * zoom and translation difference.
     * @param uid1: The view that the lock was called from
     * @param uid2: The view that the lock was called on (the view that was selected)
     */
  }, {
    key: "handleLocationLockChosen",
    value: function handleLocationLockChosen(uid1, uid2) {
      if (uid1 === uid2) {
        this.setState({
          chooseViewHandler: null
        });
        return;
      }
      this.addLock(uid1, uid2, this.locationLocks, this.viewScalesLockData.bind(this));
      this.setState({
        chooseViewHandler: null
      });
    }
    /* Views uid1 and uid2 need to be locked so that they always maintain the current
     * zoom and translation difference.
     * @param uid1: The view that the lock was called from
     * @param uid2: The view that the lock was called on (the view that was selected)
     */
  }, {
    key: "handleZoomLockChosen",
    value: function handleZoomLockChosen(uid1, uid2) {
      if (uid1 === uid2) {
        this.setState({
          chooseViewHandler: null
        });
        return;
      }
      this.addLock(uid1, uid2, this.zoomLocks, this.viewScalesLockData.bind(this));
      this.setState({
        chooseViewHandler: null
      });
    }
    /**
     * We want to project the viewport of fromView onto toTrack of toView.
     *
     * @param fromView: The uid of the view that we want to project
     * @param toView: The uid of the view that we want to project to
     * @param toTrack: The track we want to project to
     *
     * Returns
     * -------
     *
     *  newTrackUid: string
     *      The uid of the newly created viewport projection track
     */
  }, {
    key: "handleViewportProjected",
    value: function handleViewportProjected(fromView, toView, toTrack) {
      let newTrackUid = null;
      if (fromView === toView) {
        console.warn("A view can not show its own viewport.");
      } else {
        const hostTrack = getTrackByUid(this.state.views[toView].tracks, toTrack);
        const position = getTrackPositionByUid(this.state.views[toView].tracks, toTrack);
        newTrackUid = slugid.nice();
        const projectionTypes = {
          top: "horizontal",
          bottom: "horizontal",
          center: "center",
          left: "vertical",
          right: "vertical"
        };
        const newTrack = {
          uid: newTrackUid,
          type: `viewport-projection-${projectionTypes[position]}`,
          fromViewUid: fromView
        };
        this.addCallbacks(toView, newTrack);
        this.handleTrackAdded(toView, newTrack, position, null, hostTrack);
      }
      this.setState({
        chooseTrackHandler: null
      });
      return newTrackUid;
    }
    /**
     * Uid1 is copying the center of uid2
     */
  }, {
    key: "handleLocationYanked",
    value: function handleLocationYanked(uid1, uid2) {
      const sourceXScale = this.xScales[uid2];
      const sourceYScale = this.yScales[uid2];
      const targetXScale = this.xScales[uid1];
      const targetYScale = this.yScales[uid1];
      const [targetCenterX, targetCenterY, targetK] = scalesCenterAndK(targetXScale, targetYScale);
      const [sourceCenterX, sourceCenterY, sourceK] = scalesCenterAndK(sourceXScale, sourceYScale);
      this.setCenters[uid1](sourceCenterX, sourceCenterY, targetK, true);
      this.setState({
        chooseViewHandler: null
      });
    }
    /**
     * Uid1 yanked the zoom of uid2, now  make sure that they're synchronized.
     */
  }, {
    key: "handleZoomYanked",
    value: function handleZoomYanked(uid1, uid2) {
      const sourceXScale = this.xScales[uid2];
      const sourceYScale = this.yScales[uid2];
      const targetXScale = this.xScales[uid1];
      const targetYScale = this.yScales[uid1];
      const [targetCenterX, targetCenterY, targetK] = scalesCenterAndK(targetXScale, targetYScale);
      const [sourceCenterX, sourceCenterY, sourceK] = scalesCenterAndK(sourceXScale, sourceYScale);
      this.setCenters[uid1](targetCenterX, targetCenterY, sourceK, true);
      this.setState({
        chooseViewHandler: null
      });
    }
    /**
     * The user has chosen a position for the new track. The actual
     * track selection will be handled by TiledPlot
     *
     * We just need to close the menu here.
     */
  }, {
    key: "handleTrackPositionChosen",
    value: function handleTrackPositionChosen(viewUid, position, extent2) {
      this.setState({
        addTrackPosition: position,
        addTrackExtent: extent2,
        addTrackPositionView: viewUid
      });
    }
    /**
     * Update the height of each row in the layout so that it takes up all
     * of the available space in the div.
     */
  }, {
    key: "updateRowHeight",
    value: function updateRowHeight() {
      if (!this.props.options || this.sizeMode !== SIZE_MODE_BOUNDED && this.sizeMode !== SIZE_MODE_BOUNDED_OVERFLOW || this.props.options.pixelPreciseMarginPadding) {
        return;
      }
      const height = this.element.parentNode.clientHeight;
      let maxHeight = 1;
      let perTrackRowHeight = 0;
      for (const view of dictValues(this.state.views)) {
        maxHeight = Math.max(maxHeight, view.layout.y + view.layout.h);
        const topTrackHeights = view.tracks.top.filter((x) => x.height).map((x) => x.height).reduce((a, b) => a + b, 0);
        const bottomTrackHeights = view.tracks.bottom.filter((x) => x.height).map((x) => x.height).reduce((a, b) => a + b, 0);
        perTrackRowHeight = Math.ceil(Math.max(perTrackRowHeight, (topTrackHeights + bottomTrackHeights) / view.layout.h));
      }
      this.handleDragStart();
      this.handleDragStop();
      const MARGIN_HEIGHT = this.isEditable() ? 10 : 0;
      const marginHeight = MARGIN_HEIGHT * maxHeight - 1;
      const availableHeight = height - marginHeight;
      const prospectiveRowHeight = Math.floor(availableHeight / maxHeight);
      const chosenRowHeight = Math.max(prospectiveRowHeight, perTrackRowHeight);
      if (this.topDivRef.current) {
        this.setState({
          rowHeight: chosenRowHeight
        });
      }
    }
    /**
     * Notify the children that the layout has changed so that they
     * know to redraw themselves
     */
  }, {
    key: "handleLayoutChange",
    value: function handleLayoutChange(layout) {
      if (!this.element) return;
      layout.forEach((l) => {
        const view = this.state.views[l.i];
        if (view) {
          view.layout.x = l.x;
          view.layout.y = l.y;
          view.layout.w = l.w;
          view.layout.h = l.h;
          view.layout.i = l.i;
        }
      });
      this.updateRowHeight();
      this.refreshView(LONG_DRAG_TIMEOUT);
    }
    /**
     * Maybe somebody started dragging again before the previous drag
     * timeout fired. In that case, we need to clear this timeout so
     * that it doesn't override a previously set one.
     */
  }, {
    key: "clearDragTimeout",
    value: function clearDragTimeout() {
      if (this.dragTimeout) {
        clearTimeout(this.dragTimeout);
        this.dragTimeout = null;
      }
    }
  }, {
    key: "getTrackInfo",
    value: function getTrackInfo(trackType) {
      if (TRACKS_INFO_BY_TYPE[trackType]) {
        return TRACKS_INFO_BY_TYPE[trackType];
      }
      if (this.pluginTracks?.[trackType]) {
        return this.pluginTracks[trackType].config;
      }
      if (window.higlassTracksByType?.[trackType]) {
        return window.higlassTracksByType[trackType].config;
      }
      console.warn("Track type not found:", trackType, "(check app/scripts/config/ for a list of defined track types)");
      return void 0;
    }
  }, {
    key: "forceRefreshView",
    value: function forceRefreshView() {
      this.setState(this.state);
    }
  }, {
    key: "refreshView",
    value: function refreshView(timeout2 = SHORT_DRAG_TIMEOUT) {
      this.clearDragTimeout();
      this.notifyDragChangedListeners(true);
      this.clearDragTimeout();
      this.dragTimeout = setTimeout(() => {
        this.notifyDragChangedListeners(false);
      }, timeout2);
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart() {
      this.clearDragTimeout();
      this.notifyDragChangedListeners(true);
    }
  }, {
    key: "handleDragStop",
    value: function handleDragStop() {
      this.clearDragTimeout();
      this.dragTimeout = setTimeout(() => {
        this.notifyDragChangedListeners(false);
      }, LONG_DRAG_TIMEOUT);
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      objVals(this.viewHeaders).filter((x) => x).forEach((viewHeader) => viewHeader.checkWidth());
    }
    /**
     * Get the dimensions for this view, counting just the tracks
     * that are present in it
     *
     * @param view: A view containing a list of tracks as a member.
     * @return: A width and a height pair (e.g. [width, height])
     */
  }, {
    key: "calculateViewDimensions",
    value: function calculateViewDimensions(view) {
      const defaultHorizontalHeight = 20;
      const defaultVerticalWidth = 0;
      const defaultCenterHeight = 100;
      const defaultCenterWidth = 100;
      let currHeight = this.viewMarginTop + this.viewMarginBottom + this.viewPaddingTop + this.viewPaddingBottom;
      let currWidth = this.viewMarginLeft + this.viewMarginRight + this.viewPaddingLeft + this.viewPaddingRight;
      let minNecessaryHeight = 0;
      minNecessaryHeight += 10;
      const MIN_VERTICAL_HEIGHT = 20;
      if (view.tracks.top) {
        for (let i = 0; i < view.tracks.top.length; i++) {
          const track = view.tracks.top[i];
          currHeight += track.height ? track.height : defaultHorizontalHeight;
          minNecessaryHeight += track.height ? track.height : defaultHorizontalHeight;
        }
      }
      if (view.tracks.bottom) {
        for (let i = 0; i < view.tracks.bottom.length; i++) {
          const track = view.tracks.bottom[i];
          currHeight += track.height ? track.height : defaultHorizontalHeight;
          minNecessaryHeight += track.height ? track.height : defaultHorizontalHeight;
        }
      }
      if (view.tracks.left && view.tracks.left.length > 0 || view.tracks.right && view.tracks.right.length > 0 || view.tracks.center && view.tracks.center.length > 0) {
        minNecessaryHeight += MIN_VERTICAL_HEIGHT;
      }
      let leftHeight = 0;
      if (view.tracks.left) {
        for (let i = 0; i < view.tracks.left.length; i++) {
          const track = view.tracks.left[i];
          const thisHeight = track.height ? track.height : defaultCenterHeight;
          currWidth += track.width ? track.width : defaultVerticalWidth;
          leftHeight = Math.max(leftHeight, thisHeight);
        }
      }
      let rightHeight = 0;
      if (view.tracks.right) {
        for (let i = 0; i < view.tracks.right.length; i++) {
          const track = view.tracks.right[i];
          const thisHeight = track.height ? track.height : defaultCenterHeight;
          currWidth += track.width ? track.width : defaultVerticalWidth;
          rightHeight = Math.max(rightHeight, thisHeight);
        }
      }
      const sideHeight = Math.max(leftHeight, rightHeight);
      let centerHeight = 0;
      let centerWidth = 0;
      if (view.tracks.center && dictValues(view.tracks.center).length > 0) {
        if (!view.tracks.center[0].contents || view.tracks.center[0].contents.length > 0) {
          let height = null;
          let width = null;
          if (view.tracks.center[0].contents) {
            for (const track of view.tracks.center[0].contents) {
              height = Math.max(height, track.height ? track.height : defaultCenterHeight);
              width = Math.max(width, track.width ? track.width : defaultCenterWidth);
            }
          } else {
            height = view.tracks.center[0].height ? view.tracks.center[0].height : defaultCenterHeight;
            width = view.tracks.center[0].width ? view.tracks.center[0].width : defaultCenterWidth;
          }
          centerHeight = height;
          centerWidth = width;
        }
      } else if ((view.tracks.top && dictValues(view.tracks.top).length > 1 || view.tracks.bottom && dictValues(view.tracks.bottom).length > 1) && (view.tracks.left && dictValues(view.tracks.left).length || view.tracks.right && dictValues(view.tracks.right).length)) {
        centerWidth = defaultCenterWidth;
        centerHeight = defaultCenterHeight;
      }
      if (sideHeight > centerHeight) {
        currHeight += sideHeight;
      } else {
        currHeight += centerHeight;
      }
      let topHeight = 0;
      let bottomHeight = 0;
      let leftWidth = 0;
      let rightWidth = 0;
      if ("top" in view.tracks) {
        topHeight = view.tracks.top.map((x) => x.height ? x.height : defaultHorizontalHeight).reduce((a, b) => a + b, 0);
      }
      if ("bottom" in view.tracks) {
        bottomHeight = view.tracks.bottom.map((x) => x.height ? x.height : defaultHorizontalHeight).reduce((a, b) => a + b, 0);
      }
      if ("left" in view.tracks) {
        leftWidth = view.tracks.left.map((x) => x.width ? x.width : defaultVerticalWidth).reduce((a, b) => a + b, 0);
      }
      if ("right" in view.tracks) {
        rightWidth = view.tracks.right.map((x) => x.width ? x.width : defaultVerticalWidth).reduce((a, b) => a + b, 0);
      }
      return {
        totalWidth: currWidth,
        totalHeight: currHeight,
        topHeight,
        bottomHeight,
        leftWidth,
        rightWidth,
        centerWidth,
        centerHeight,
        minNecessaryHeight
      };
    }
  }, {
    key: "calculateZoomLimits",
    value: function calculateZoomLimits(view, initialXDomain) {
      const limits = [0, Number.POSITIVE_INFINITY];
      if ("zoomLimits" in view) {
        const diffX = initialXDomain[1] - initialXDomain[0];
        const viewConfLimit = view.zoomLimits;
        if (viewConfLimit.length !== 2) {
          return limits;
        }
        if (viewConfLimit[0] !== null && viewConfLimit[0] > 0) {
          const upperLimit = diffX / viewConfLimit[0];
          limits[1] = Math.max(upperLimit, 1);
          if (upperLimit < 1) {
            console.warn(`Invalid zoom limits. Lower limit set to ${diffX}`);
          }
        }
        if (viewConfLimit[1] !== null && viewConfLimit[1] > viewConfLimit[0]) {
          const lowerLimit = diffX / viewConfLimit[1];
          limits[0] = Math.min(lowerLimit, 1);
          if (lowerLimit > 1) {
            console.warn(`Invalid zoom limits. Upper limit set to ${diffX}`);
          }
        }
      }
      return limits;
    }
  }, {
    key: "generateViewLayout",
    value: function generateViewLayout(view) {
      let layout = null;
      if ("layout" in view) {
        ({
          layout
        } = view.layout);
      } else {
        layout = {
          x: 0,
          y: 0,
          w: NUM_GRID_COLUMNS,
          h: DEFAULT_NEW_VIEW_HEIGHT
        };
      }
      return layout;
    }
    /**
     * Remove all the tracks from a view
     *
     * @param {viewUid} Thie view's identifier
     */
  }, {
    key: "handleClearView",
    value: function handleClearView(viewUid) {
      const {
        views
      } = this.state;
      views[viewUid].tracks.top = [];
      views[viewUid].tracks.bottom = [];
      views[viewUid].tracks.center = [];
      views[viewUid].tracks.left = [];
      views[viewUid].tracks.right = [];
      views[viewUid].tracks.whole = [];
      this.setState({
        views
      });
    }
    /**
     * A view needs to be closed. Remove it from from the viewConfig and then clean
     * up all of its connections (zoom links, workers, etc...)
     *
     * @param {uid} This view's identifier
     */
  }, {
    key: "handleCloseView",
    value: function handleCloseView(uid) {
      if (dictValues(this.state.views).length === 1) {
        return;
      }
      this.handleUnlock(uid, this.zoomLocks);
      this.setState((prevState) => {
        delete prevState.views[uid];
        const viewsByUid = this.removeInvalidTracks(prevState.views);
        return {
          views: viewsByUid
        };
      });
    }
    /**
     * We're adding a new dataset to an existing track
     *
     * @param newTrack: The new track to be added.
     * @param position: Where the new series should be placed.
     *  (This could also be inferred from the hostTrack, but since
     *  we already have it, we might as well use it)
     * @param hostTrack: The track that will host the new series.
     */
  }, {
    key: "handleSeriesAdded",
    value: function handleSeriesAdded(viewId, newTrack, position, hostTrack) {
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      if (hostTrack.type === "combined") {
        hostTrack.contents.push(newTrack);
        hostTrack.uid = slugid.nice();
        if (newTrack.type === "heatmap") {
          this.compatibilityfyStackedHeatmaps(newTrack, hostTrack);
        }
      } else {
        const newHost = {
          type: "combined",
          uid: slugid.nice(),
          height: hostTrack.height,
          width: hostTrack.width,
          contents: [hostTrack, newTrack]
        };
        const positionTracks = tracks2[position];
        for (let i = 0; i < positionTracks.length; i++) {
          if (positionTracks[i].uid === hostTrack.uid) {
            positionTracks[i] = newHost;
          }
        }
      }
      this.setState((prevState) => ({
        views: prevState.views
      }));
      this.triggerViewChangeDb();
    }
  }, {
    key: "handleNoTrackAdded",
    value: function handleNoTrackAdded() {
      if (this.state.addTrackPosition) {
        this.setState({
          addTrackPosition: null,
          addTrackExtent: null
        });
      }
    }
    /**
     * Add multiple new tracks (likely from the AddTrackModal dialog)
     *
     * @param trackInfo: A JSON object that can be used as a track
     *                   definition
     * @param position: The position the track is being added to
     * @param host: If this track is being added to another track
     */
  }, {
    key: "handleTracksAdded",
    value: function handleTracksAdded(viewId, newTracks, position, extent2, host) {
      this.storeTrackSizes(viewId);
      for (const newTrack of newTracks) {
        this.handleTrackAdded(viewId, newTrack, position, extent2, host);
      }
    }
    /**
     * Change the type of a track. For example, convert a line to a bar track.
     *
     * Parameters
     * ----------
     *  viewUid: string
     *    The view containing the track to be changed
     *  trackUid: string
     *    The uid identifying the existin track
     *  newType: string
     *    The type to switch this track to.
     */
  }, {
    key: "handleChangeTrackType",
    value: function handleChangeTrackType(viewUid, trackUid, newType) {
      const view = this.state.views[viewUid];
      const trackConfig = getTrackByUid(view.tracks, trackUid);
      const oldUid = trackConfig.uid;
      trackConfig.uid = slugid.nice();
      trackConfig.type = newType;
      const newUid = trackConfig.uid;
      this.updateTrackLocks(viewUid, oldUid, newUid);
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
    /**
     * Change the data source for a track. E.g. when adding or
     * removing a divisor.
     *
     * Parameters
     * ----------
     *  viewUid: string
     *    The view containing the track to be changed
     *  trackUid: string
     *    The uid identifying the existin track
     *  newData: object
     *    The new data source section
     */
  }, {
    key: "handleChangeTrackData",
    value: function handleChangeTrackData(viewUid, trackUid, newData) {
      const view = this.state.views[viewUid];
      const trackConfig = getTrackByUid(view.tracks, trackUid);
      trackConfig.uid = slugid.nice();
      trackConfig.data = newData;
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
    /**
     * A track was added from the AddTrackModal dialog.
     *
     * @param trackInfo: A JSON object that can be used as a track
     *                   definition
     * @param position: The position the track is being added to
     * @param host: If this track is being added to another track
     *
     * @returns {Object}: A trackConfig (\{ uid: "", width: x \})
     *  describing this track
     */
  }, {
    key: "handleTrackAdded",
    value: function handleTrackAdded(viewId, newTrack, position, extent2 = null, host = null) {
      this.addDefaultTrackOptions(newTrack);
      if (!newTrack.uid) newTrack.uid = slugid.nice();
      if (newTrack.contents) {
        for (const ct of newTrack.contents) {
          this.addDefaultTrackOptions(ct);
        }
      }
      if (this.state.addTrackPosition) {
        this.setState({
          addTrackPosition: null,
          addTrackExtent: null
        });
      }
      if (host) {
        this.handleSeriesAdded(viewId, newTrack, position, host);
        return null;
      }
      newTrack.position = position;
      if (extent2) {
        newTrack.options.extent = extent2;
      }
      const trackInfo2 = this.getTrackInfo(newTrack.type);
      newTrack.width = trackInfo2.defaultWidth || trackInfo2.defaultOptions?.minWidth || this.minVerticalWidth;
      newTrack.height = trackInfo2.defaultHeight || trackInfo2.defaultOptions?.minHeight || this.minHorizontalHeight;
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      let numTracks = 0;
      visitPositionedTracks(tracks2, () => numTracks++);
      if (position === "left" || position === "top") {
        tracks2[position].unshift(newTrack);
      } else if (position === "center") {
        if (tracks2.center.length === 0) {
          const newCombined = {
            uid: slugid.nice(),
            type: "combined",
            contents: [newTrack]
          };
          tracks2.center = [newCombined];
        } else if (tracks2.center[0].type === "combined") {
          tracks2.center[0].contents.push(newTrack);
          if (newTrack.type === "heatmap") {
            this.compatibilityfyStackedHeatmaps(newTrack, tracks2.center[0]);
          }
        } else {
          const newCombined = {
            uid: slugid.nice(),
            type: "combined",
            contents: [tracks2.center[0], newTrack]
          };
          tracks2.center = [newCombined];
          if (newTrack.type === "heatmap") {
            this.compatibilityfyStackedHeatmaps(newTrack, newCombined);
          }
        }
      } else {
        if (!tracks2[position]) {
          tracks2[position] = [];
        }
        tracks2[position].push(newTrack);
      }
      this.adjustLayoutToTrackSizes(this.state.views[viewId]);
      if (Object.keys(this.state.views).length === 1 && numTracks === 0) {
        this.handleZoomToData(viewId);
        this.zoomToDataExtentOnInit.add(viewId);
      }
      return newTrack;
    }
    /**
     * We're adding a new heatmap to a combined track. We need to make sure that
     * their options are compatible.
     *
     * @param   {object}  newTrack  New heatmap track
     * @param   {object}  combinedTrack  Combined track the new heatmap is added to
     */
  }, {
    key: "compatibilityfyStackedHeatmaps",
    value: function compatibilityfyStackedHeatmaps(newTrack, combinedTrack) {
      let otherHeatmap;
      const hasHeatmaps = combinedTrack.contents.some((track) => {
        otherHeatmap = track;
        return track.type === "heatmap";
      });
      if (hasHeatmaps) {
        newTrack.options.backgroundColor = "transparent";
        newTrack.options.showTooltip = otherHeatmap.options.showTooltip;
        newTrack.options.showMousePosition = otherHeatmap.options.showMousePosition;
        newTrack.options.mousePositionColor = otherHeatmap.options.mousePositionColor;
      }
    }
    /**
     * Go through each track and store its size in the viewconf.
     *
     * This is so that sizes don't get lost when the view is unbounded
     * and new tracks are added.
     *
     * Parameters
     * ----------
     *
     *  viewId : string
     *      The id of the view whose tracks we're measuring
     *
     * Returns
     * -------
     *
     *  Nothing
     */
  }, {
    key: "storeTrackSizes",
    value: function storeTrackSizes(viewId) {
      visitPositionedTracks(this.state.views[viewId].tracks, (track) => {
        const trackObj = this.tiledPlots[viewId].trackRenderer.getTrackObject(track.uid);
        if (trackObj) [track.width, track.height] = trackObj.dimensions;
      });
    }
    /*
     * Adjust the layout to match the size of the contained tracks. If tracks
     * are added, the layout size needs to expand. If they're removed, it needs
     * to contract.
     *
     * This function should be called from handleTrackAdded and handleCloseTrack.
     *
     * Parameters
     * ----------
     *
     *  view : {...}
     *      The definition from the viewconf
     */
  }, {
    key: "adjustLayoutToTrackSizes",
    value: function adjustLayoutToTrackSizes(view) {
      if (!view.layout) return;
      const isEditable = this.isEditable();
      let totalTrackHeight = 0;
      if (isEditable) totalTrackHeight += VIEW_HEADER_HEIGHT;
      const {
        totalHeight
      } = this.calculateViewDimensions(view);
      totalTrackHeight += totalHeight;
      const MARGIN_HEIGHT = this.isEditable() ? 10 : 0;
      totalTrackHeight += MARGIN_HEIGHT;
      const rowHeight = this.state.rowHeight + MARGIN_HEIGHT;
      if (this.sizeMode !== SIZE_MODE_BOUNDED && this.sizeMode !== SIZE_MODE_BOUNDED_OVERFLOW) {
        view.layout.h = Math.ceil(totalTrackHeight / rowHeight);
      }
    }
  }, {
    key: "handleCloseTrack",
    value: function handleCloseTrack(viewId, uid) {
      const {
        tracks: tracks2
      } = this.state.views[viewId];
      this.handleUnlockValueScale(viewId, uid);
      for (const trackType in tracks2) {
        const theseTracks = tracks2[trackType];
        const newTracks = theseTracks.filter((d) => d.uid !== uid);
        if (newTracks.length === theseTracks.length) {
          const combinedTracks = newTracks.filter((x) => x.type === "combined");
          combinedTracks.forEach((ct) => {
            ct.contents = ct.contents.filter((x) => x.uid !== uid);
          });
        } else {
          tracks2[trackType] = newTracks;
        }
      }
      this.storeTrackSizes(viewId);
      this.adjustLayoutToTrackSizes(this.state.views[viewId]);
      this.setState((prevState) => ({
        views: prevState.views
      }));
      return this.state.views;
    }
  }, {
    key: "handleLockValueScale",
    value: function handleLockValueScale(fromViewUid, fromTrackUid) {
      this.setState({
        chooseTrackHandler: (toViewUid, toTrackUid) => this.handleValueScaleLocked(fromViewUid, fromTrackUid, toViewUid, toTrackUid)
      });
    }
  }, {
    key: "combineViewAndTrackUid",
    value: function combineViewAndTrackUid(viewUid, trackUid) {
      const uid = `${viewUid}.${trackUid}`;
      this.combinedUidToViewTrack[uid] = {
        view: viewUid,
        track: trackUid
      };
      if (this.viewTrackUidsToCombinedUid[viewUid]) {
        if (this.viewTrackUidsToCombinedUid[trackUid]) {
          return this.viewTrackUidsToCombinedUid[viewUid][trackUid];
        }
        this.viewTrackUidsToCombinedUid[viewUid][trackUid] = uid;
      } else {
        this.viewTrackUidsToCombinedUid[viewUid] = {};
        this.viewTrackUidsToCombinedUid[viewUid][trackUid] = uid;
      }
      return uid;
    }
    /**
     * Update all locks involving this track to use a new track uid.
     *
     * @param  {string} viewUid The view's uid
     * @param  {string} oldTrackUid The track's old uid
     * @param  {string} newTrackUid The track's new uid
     */
  }, {
    key: "updateTrackLocks",
    value: function updateTrackLocks(viewUid, oldTrackUid, newTrackUid) {
      const oldLockGroupUid = this.combineViewAndTrackUid(viewUid, oldTrackUid);
      const newLockGroupUid = this.combineViewAndTrackUid(viewUid, newTrackUid);
      if (this.valueScaleLocks[oldLockGroupUid]) {
        const lockGroup = this.valueScaleLocks[oldLockGroupUid];
        this.valueScaleLocks[newLockGroupUid] = lockGroup;
        delete this.valueScaleLocks[oldLockGroupUid];
      }
      for (const lockGroupUid in this.valueScaleLocks) {
        if (this.valueScaleLocks[lockGroupUid][oldLockGroupUid]) {
          const oldEntry = this.valueScaleLocks[lockGroupUid][oldLockGroupUid];
          this.valueScaleLocks[lockGroupUid][newLockGroupUid] = oldEntry;
          oldEntry.track = newTrackUid;
          delete this.valueScaleLocks[lockGroupUid][oldLockGroupUid];
        }
      }
    }
  }, {
    key: "handleUnlockValueScale",
    value: function handleUnlockValueScale(viewUid, trackUid) {
      if (this.tiledPlots[viewUid].trackRenderer.getTrackObject(trackUid).createdTracks) {
        const childTrackUids = dictKeys(this.tiledPlots[viewUid].trackRenderer.getTrackObject(trackUid).createdTracks);
        for (const childTrackUid of childTrackUids) {
          this.handleUnlock(this.combineViewAndTrackUid(viewUid, childTrackUid), this.valueScaleLocks);
        }
      } else {
        this.handleUnlock(this.combineViewAndTrackUid(viewUid, trackUid), this.valueScaleLocks);
      }
    }
  }, {
    key: "handleValueScaleLocked",
    value: function handleValueScaleLocked(fromViewUid, fromTrackUid, toViewUid, toTrackUid) {
      if (this.tiledPlots[fromViewUid].trackRenderer.getTrackObject(fromTrackUid).createdTracks) {
        const childTrackUids = dictKeys(this.tiledPlots[fromViewUid].trackRenderer.getTrackObject(fromTrackUid).createdTracks);
        for (const childTrackUid of childTrackUids) {
          this.handleValueScaleLocked(fromViewUid, childTrackUid, toViewUid, toTrackUid);
        }
        return;
      }
      if (this.tiledPlots[toViewUid].trackRenderer.getTrackObject(toTrackUid).createdTracks) {
        const childTrackUids = dictKeys(this.tiledPlots[toViewUid].trackRenderer.getTrackObject(toTrackUid).createdTracks);
        for (const childTrackUid of childTrackUids) {
          this.handleValueScaleLocked(fromViewUid, fromTrackUid, toViewUid, childTrackUid);
        }
        return;
      }
      const fromUid = this.combineViewAndTrackUid(fromViewUid, fromTrackUid);
      const toUid = this.combineViewAndTrackUid(toViewUid, toTrackUid);
      this.addLock(fromUid, toUid, this.valueScaleLocks, (uid) => this.combinedUidToViewTrack[uid]);
      this.syncValueScales(fromViewUid, fromTrackUid);
      this.setState({
        chooseTrackHandler: null
      });
    }
    /**
     * Add callbacks for functions that need them
     *
     * Done in place.
     *
     * @param {string} viewUid
     * @param {{
     *   type: string;
     *   uid: string;
     *   fromViewUid: string;
     *   registerViewportChanged: (string: trackId, listener: () => void) => void;
     *   removeViewportChanged: (string: trackId) => void;
     *   removeScalesChangedListener: (string: trackId) => void;
     * }} track A view with tracks.
     */
  }, {
    key: "addCallbacks",
    value: function addCallbacks(viewUid, track) {
      const trackInfo2 = this.getTrackInfo(track.type);
      if (track.type === "viewport-projection-center" || track.type === "viewport-projection-horizontal" || track.type === "viewport-projection-vertical" || trackInfo2?.projection) {
        const fromView = track.fromViewUid;
        track.registerViewportChanged = (trackId, listener) => this.addScalesChangedListener(fromView, trackId, listener);
        track.removeViewportChanged = (trackId) => this.removeScalesChangedListener(fromView, trackId);
        track.setDomainsCallback = (xDomain, yDomain) => {
          if (!fromView) {
            if (!this.projectionXDomains[viewUid]) {
              this.projectionXDomains[viewUid] = {};
            }
            if (!this.projectionYDomains[viewUid]) {
              this.projectionYDomains[viewUid] = {};
            }
            if (track.type === "viewport-projection-horizontal" || track.type === "viewport-projection-center") {
              this.projectionXDomains[viewUid][track.uid] = xDomain;
            }
            if (track.type === "viewport-projection-vertical" || track.type === "viewport-projection-center") {
              this.projectionYDomains[viewUid][track.uid] = yDomain;
            }
            this.triggerViewChangeDb();
            return;
          }
          const tXScale = linear().domain(xDomain).range(this.xScales[fromView].range());
          const tYScale = linear().domain(yDomain).range(this.yScales[fromView].range());
          const [tx, ty, k] = scalesCenterAndK(tXScale, tYScale);
          this.setCenters[fromView](tx, ty, k, false);
          let zoomLocked = false;
          let locationLocked = false;
          if (viewUid in this.zoomLocks) {
            zoomLocked = fromView in this.zoomLocks[viewUid];
          }
          if (zoomLocked) {
            this.handleUnlock(viewUid, this.zoomLocks);
          }
          if (viewUid in this.locationLocks) {
            locationLocked = fromView in this.locationLocks[viewUid];
          }
          if (locationLocked) {
            this.handleUnlock(viewUid, this.locationLocks);
          }
          this.handleScalesChanged(fromView, tXScale, tYScale, true);
          if (zoomLocked) {
            this.addLock(viewUid, fromView, this.zoomLocks, this.viewScalesLockData);
          }
          if (locationLocked) {
            this.addLock(viewUid, fromView, this.locationLocks, this.viewScalesLockData);
          }
        };
      }
    }
  }, {
    key: "validateLocks",
    value: function validateLocks(locks) {
      const toRemove = [];
      for (const viewUid of dictKeys(locks)) {
        if (!locks[viewUid] || !locks[viewUid][viewUid]) {
          toRemove.push(viewUid);
        }
      }
      for (const viewUid of toRemove) {
        if (locks[viewUid]) {
          console.warn(`View ${viewUid} not present in lock group. Removing...`);
          this.handleUnlock(viewUid, locks);
          delete locks[viewUid];
        }
      }
    }
  }, {
    key: "deserializeLocationLocks",
    value: function deserializeLocationLocks(viewConfig) {
      this.locationLocks = {};
      if (viewConfig.locationLocks) {
        for (const viewUid of dictKeys(viewConfig.locationLocks.locksByViewUid)) {
          if (typeof viewConfig.locationLocks.locksByViewUid[viewUid] !== "object") {
            this.locationLocks[viewUid] = viewConfig.locationLocks.locksDict[viewConfig.locationLocks.locksByViewUid[viewUid]];
          } else {
            if ("x" in viewConfig.locationLocks.locksByViewUid[viewUid]) {
              const lockInfo = viewConfig.locationLocks.locksDict[viewConfig.locationLocks.locksByViewUid[viewUid].x.lock];
              this.locationLocksAxisWise.x[viewUid] = {
                lock: lockInfo,
                axis: viewConfig.locationLocks.locksByViewUid[viewUid].x.axis
                // The axis of another view, either 'x' or 'y'
              };
            }
            if ("y" in viewConfig.locationLocks.locksByViewUid[viewUid]) {
              const lockInfo = viewConfig.locationLocks.locksDict[viewConfig.locationLocks.locksByViewUid[viewUid].y.lock];
              this.locationLocksAxisWise.y[viewUid] = {
                lock: lockInfo,
                axis: viewConfig.locationLocks.locksByViewUid[viewUid].y.axis
                // The axis of another view, either 'x' or 'y'
              };
            }
          }
        }
      }
      this.validateLocks(this.locationLocks);
    }
  }, {
    key: "deserializeZoomLocks",
    value: function deserializeZoomLocks(viewConfig) {
      this.zoomLocks = {};
      if (viewConfig.zoomLocks) {
        for (const viewUid of dictKeys(viewConfig.zoomLocks.locksByViewUid)) {
          this.zoomLocks[viewUid] = viewConfig.zoomLocks.locksDict[viewConfig.zoomLocks.locksByViewUid[viewUid]];
        }
      }
      this.validateLocks(this.zoomLocks);
    }
  }, {
    key: "deserializeValueScaleLocks",
    value: function deserializeValueScaleLocks(viewConfig) {
      this.valueScaleLocks = {};
      if (viewConfig.valueScaleLocks) {
        for (const viewUid of dictKeys(viewConfig.valueScaleLocks.locksByViewUid)) {
          this.valueScaleLocks[viewUid] = viewConfig.valueScaleLocks.locksDict[viewConfig.valueScaleLocks.locksByViewUid[viewUid]];
        }
      }
    }
  }, {
    key: "serializeLocks",
    value: function serializeLocks(locks) {
      const locksDict = {};
      const locksByViewUid = {};
      for (const viewUid of dictKeys(locks)) {
        let lockUid = locks[viewUid]?.uid;
        if (!lockUid) {
          lockUid = slugid.nice();
        }
        locks[viewUid].uid = lockUid;
        locksDict[lockUid] = locks[viewUid];
        locksByViewUid[viewUid] = locks[viewUid].uid;
      }
      return {
        locksByViewUid,
        locksDict
      };
    }
  }, {
    key: "getViewsAsJson",
    value: function getViewsAsJson(views) {
      const newJson = JSON.parse(JSON.stringify(this.state.viewConfig));
      newJson.views = Object.values(views || this.state.views).map((k) => {
        const newView = JSON.parse(JSON.stringify(k));
        visitPositionedTracks(newView.tracks, (track) => {
          if (track.server) {
            if (!URL.canParse(track.server)) {
              const url = new URL(window.location);
              url.pathname = track.server;
              track.server = url.href;
            }
          }
          if ((track.type === "viewport-projection-center" || track.type === "viewport-projection-horizontal") && this.projectionXDomains[k.uid] && this.projectionXDomains[k.uid][track.uid]) {
            track.projectionXDomain = this.projectionXDomains[k.uid][track.uid];
          }
          if ((track.type === "viewport-projection-center" || track.type === "viewport-projection-vertical") && this.projectionYDomains[k.uid] && this.projectionYDomains[k.uid][track.uid]) {
            track.projectionYDomain = this.projectionYDomains[k.uid][track.uid];
          }
          delete track.name;
          delete track.position;
          delete track.header;
          delete track.description;
          delete track.created;
          delete track.project;
          delete track.project_name;
          delete track.serverUidKey;
          delete track.uuid;
          delete track.private;
          delete track.maxZoom;
          delete track.coordSystem;
          delete track.coordSystem2;
          delete track.datatype;
          delete track.maxWidth;
          delete track.datafile;
          delete track.filetype;
          delete track.binsPerDimension;
          delete track.resolutions;
          delete track.row_infos;
          delete track.aggregationModes;
        });
        newView.uid = k.uid;
        newView.initialXDomain = this.xScales[k.uid].domain();
        newView.initialYDomain = this.yScales[k.uid].domain();
        delete newView.layout.i;
        return newView;
      });
      newJson.zoomLocks = this.serializeLocks(this.zoomLocks);
      newJson.locationLocks = this.serializeLocks(this.locationLocks);
      newJson.valueScaleLocks = this.serializeLocks(this.valueScaleLocks);
      return newJson;
    }
  }, {
    key: "getViewsAsString",
    value: function getViewsAsString() {
      return JSON.stringify(this.getViewsAsJson(), null, 2);
    }
  }, {
    key: "handleExportViewAsJSON",
    value: function handleExportViewAsJSON() {
      const data2 = this.getViewsAsString();
      download("viewconf.json", data2);
    }
  }, {
    key: "handleExportViewsAsLink",
    value: function handleExportViewsAsLink(url = this.state.viewConfig.exportViewUrl, fromApi = false) {
      const parsedUrl = new URL(url, window.location.origin);
      const req = fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: `{"viewconf":${this.getViewsAsString()}}`,
        credentials: "same-origin"
      }).then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      }).catch((err) => {
        console.warn("err:", err);
      }).then((_json) => ({
        id: _json.uid,
        url: `${parsedUrl.origin}/l/?d=${_json.uid}`
      }));
      if (!fromApi) {
        req.then((sharedView) => {
          this.openModal(/* @__PURE__ */ React__default.createElement(ExportLinkDialog, {
            onDone: () => {
              this.closeModalBound();
            },
            url: sharedView.url
          }));
        }).catch((e) => console.error("Exporting view config as link failed:", e));
      }
      return req;
    }
    /*
     * The initial[XY]Domain of a view has changed. Update its definition
     * and rerender.
     */
  }, {
    key: "handleDataDomainChanged",
    value: function handleDataDomainChanged(viewUid, newXDomain, newYDomain) {
      const {
        views
      } = this.state;
      views[viewUid].initialXDomain = newXDomain;
      views[viewUid].initialYDomain = newYDomain;
      this.xScales[viewUid] = linear().domain(newXDomain);
      this.yScales[viewUid] = linear().domain(newYDomain);
      if (this.zoomLocks[viewUid]) {
        const lockGroup = this.zoomLocks[viewUid];
        const lockGroupItems = dictItems(lockGroup);
        for (let i = 0; i < lockGroupItems.length; i++) {
          const key = lockGroupItems[i][0];
          if (!(key in this.locationLocks)) {
            continue;
          }
          views[key].initialXDomain = newXDomain;
          views[key].initialYDomain = newYDomain;
          this.xScales[key] = linear().domain(newXDomain);
          this.yScales[key] = linear().domain(newYDomain);
        }
      }
      this.setState({
        views
      });
    }
    /**
     * Check if we can place a view at this position
     */
  }, {
    key: "viewPositionAvailable",
    value: function viewPositionAvailable(pX, pY, w, h) {
      const pEndX = pX + w;
      const pEndY = pY + h;
      if (pX + w > NUM_GRID_COLUMNS) {
        return false;
      }
      const sortedViews = dictValues(this.state.views);
      for (let j = 0; j < sortedViews.length; j++) {
        const svX = sortedViews[j].layout.x;
        const svY = sortedViews[j].layout.y;
        const svEndX = svX + sortedViews[j].layout.w;
        const svEndY = svY + sortedViews[j].layout.h;
        if (pX < svEndX && pEndX > svX) {
          if (pY < svEndY && pEndY > svY) {
            return false;
          }
        }
      }
      return true;
    }
    /**
     * User clicked on the "Add View" button. We'll duplicate the last
     * view.
     */
  }, {
    key: "handleAddView",
    value: function handleAddView(view, newViewParams, noUpdate) {
      const views = dictValues(this.state.views);
      const lastView = view;
      const potentialPositions = [];
      if (view.layout.w === 12) {
        view.layout.w = 6;
      }
      for (let i = 0; i < views.length; i++) {
        let pX = views[i].layout.x + views[i].layout.w;
        let pY = views[i].layout.y;
        if (this.viewPositionAvailable(pX, pY, view.layout.w, view.layout.h)) {
          potentialPositions.push([pX, pY]);
        }
        pX = views[i].layout.x;
        pY = views[i].layout.y + views[i].layout.h;
        if (this.viewPositionAvailable(pX, pY, view.layout.w, view.layout.h)) {
          potentialPositions.push([pX, pY]);
        }
      }
      potentialPositions.sort((a, b) => {
        const n = a[1] - b[1];
        if (n === 0) {
          return a[0] - b[0];
        }
        return n;
      });
      const jsonString = JSON.stringify(lastView);
      let newView = JSON.parse(jsonString);
      newView.initialXDomain = this.xScales[newView.uid].domain();
      newView.initialYDomain = this.yScales[newView.uid].domain();
      if (newViewParams) {
        newView = {
          ...newView,
          ...newViewParams
        };
      }
      [[newView.layout.x, newView.layout.y]] = potentialPositions;
      newView.uid = slugid.nice();
      newView.layout.i = newView.uid;
      this.xScales[newView.uid] = linear().domain(newView.initialXDomain);
      this.yScales[newView.uid] = linear().domain(newView.initialYDomain);
      visitPositionedTracks(newView.tracks, (track) => {
        this.addCallbacks(newView.uid, track);
      });
      const createNewViews = (prevViews) => {
        const _views = JSON.parse(JSON.stringify(prevViews));
        _views[newView.uid] = newView;
        return _views;
      };
      let newViews = null;
      if (!noUpdate) {
        this.setState((prevState) => {
          newViews = createNewViews(prevState.views);
          return {
            views: newViews
          };
        });
      } else {
        newViews = createNewViews(this.state.views);
      }
      return {
        newViewUid: newView.uid,
        newViewconf: this.getViewsAsJson(newViews)
      };
    }
  }, {
    key: "createGenomePostionSearchBoxEntry",
    value: function createGenomePostionSearchBoxEntry(existingGenomePositionSearchBox, suggestedAssembly) {
      let newGpsb = existingGenomePositionSearchBox;
      const defaultGpsb = {
        autocompleteServer: DEFAULT_SERVER,
        // "autocompleteId": "OHJakQICQD6gTD7skx4EWA",
        chromInfoServer: DEFAULT_SERVER,
        visible: false
      };
      if (!newGpsb) {
        newGpsb = JSON.parse(JSON.stringify(defaultGpsb));
      }
      if (!newGpsb.autocompleteServer) {
        newGpsb.autocompleteServer = defaultGpsb.autocompleteServer;
      }
      if (!newGpsb.chromInfoId) {
        newGpsb.chromInfoId = suggestedAssembly;
      }
      if (!newGpsb.chromInfoServer) {
        newGpsb.chromInfoServer = defaultGpsb.chromInfoServer;
      }
      if (!newGpsb.visible) {
        newGpsb.visible = false;
      }
      return newGpsb;
    }
  }, {
    key: "handleTogglePositionSearchBox",
    value: function handleTogglePositionSearchBox(viewUid) {
      const view = this.state.views[viewUid];
      view.genomePositionSearchBoxVisible = !view.genomePositionSearchBoxVisible;
      const assemblyCounts = {};
      visitPositionedTracks(view.tracks, (track) => {
        if (track.coordSystem) {
          if (!assemblyCounts[track.coordSystem]) {
            assemblyCounts[track.coordSystem] = 0;
          }
          assemblyCounts[track.coordSystem] += 1;
        }
      });
      const sortedAssemblyCounts = dictItems(assemblyCounts).sort((a, b) => b[1] - a[1]);
      let selectedAssembly = "hg19";
      if (sortedAssemblyCounts.length) {
        selectedAssembly = sortedAssemblyCounts[0][0];
      }
      view.genomePositionSearchBox = this.createGenomePostionSearchBoxEntry(view.genomePositionSearchBox, selectedAssembly);
      view.genomePositionSearchBox.visible = !view.genomePositionSearchBox.visible;
      this.refreshView();
      this.setState({
        configMenuUid: null
      });
    }
  }, {
    key: "handleTrackOptionsChanged",
    value: function handleTrackOptionsChanged(viewUid, trackUid, newOptions) {
      const view = this.state.views[viewUid];
      const track = getTrackByUid(view.tracks, trackUid);
      if (!track) return;
      track.options = Object.assign(track.options, newOptions);
      if (this.mounted) {
        this.setState((prevState) => ({
          views: prevState.views
        }));
        this.adjustSplitHeatmapTrackOptions(track, newOptions, view.tracks, viewUid);
      }
    }
    /**
     * For convenience we adjust some options of split heatmap tracks when they are newly added.
     * This function has no effect when we get split heatmap tracks that are already correctly configured
     * (i.e. correctly set "lower-extend"/"upper-extend" options)
     * @param   {object}  track  Track whose options have changed
     * @param   {object}  options  New track options
     * @param   {list}  allTracks  All tracks
     * @param   {string}  viewUid  Related view UID
     */
  }, {
    key: "adjustSplitHeatmapTrackOptions",
    value: function adjustSplitHeatmapTrackOptions(track, options2, allTracks, viewUid) {
      if (track.type === "heatmap") {
        if (options2.extent === "upper-right" && allTracks.center[0].type === "combined" && allTracks.center[0].contents.length > 1) {
          allTracks.center[0].contents.some((otherTrack) => {
            if (otherTrack.type === "heatmap" && otherTrack.uid !== track.uid && otherTrack.options.extent === "full") {
              const otherNewOptions = {
                ...otherTrack.options,
                extent: "lower-left",
                labelPosition: "bottomLeft",
                colorbarPosition: "bottomLeft"
              };
              const originalNewOptions = {
                ...options2,
                labelPosition: "topRight",
                colorbarPosition: "topRight"
              };
              this.handleTrackOptionsChanged(viewUid, otherTrack.uid, otherNewOptions);
              this.handleTrackOptionsChanged(viewUid, track.uid, originalNewOptions);
              return true;
            }
            return false;
          });
        }
        if (options2.extent === "lower-left") {
          if (options2.extent === "lower-left" && allTracks.center[0].type === "combined" && allTracks.center[0].contents.length > 1) {
            allTracks.center[0].contents.some((otherTrack) => {
              if (otherTrack.type === "heatmap" && otherTrack.uid !== track.uid && otherTrack.options.extent === "full") {
                const otherNewOptions = {
                  ...otherTrack.options,
                  extent: "upper-right",
                  labelPosition: "topRight",
                  colorbarPosition: "topRight"
                };
                const originalNewOptions = {
                  ...options2,
                  labelPosition: "bottomLeft",
                  colorbarPosition: "bottomLeft"
                };
                this.handleTrackOptionsChanged(viewUid, otherTrack.uid, otherNewOptions);
                this.handleTrackOptionsChanged(viewUid, track.uid, originalNewOptions);
                return true;
              }
              return false;
            });
          }
        }
      }
    }
  }, {
    key: "handleViewOptionsChanged",
    value: function handleViewOptionsChanged(viewUid, newOptions) {
      const view = this.state.views[viewUid];
      if (!view) {
        return;
      }
      view.options = Object.assign(view.options || {}, newOptions);
      if (this.mounted) {
        this.setState((prevState) => ({
          views: prevState.views
        }));
      }
    }
    /**
     * Determine whether a track is valid and can be displayed.
     *
     * Tracks can be invalid due to inconsistent input such as
     * referral to views that don't exist
     *
     * @param track (object): A track definition
     * @param viewUidsPresent (Set): The view uids which are available
     */
  }, {
    key: "isTrackValid",
    value: function isTrackValid(track, viewUidsPresent) {
      if (track.type === "viewport-projection-center") {
        if (!viewUidsPresent.has(track.fromViewUid)) {
          return false;
        }
      }
      return true;
    }
    /**
     * Remove tracks which can no longer be shown (possibly because the views they
     * refer to no longer exist
     */
  }, {
    key: "removeInvalidTracks",
    value: function removeInvalidTracks(viewsByUid) {
      const viewUidsSet = new Set(dictKeys(viewsByUid));
      for (const v of dictValues(viewsByUid)) {
        for (const trackOrientation of ["left", "top", "center", "right", "bottom"]) {
          if (trackOrientation in (v.tracks ?? {})) {
            v.tracks[trackOrientation] = v.tracks[trackOrientation].filter((t) => this.isTrackValid(t, viewUidsSet));
            v.tracks[trackOrientation].forEach((t) => {
              if (t.type === "combined") {
                t.contents = t.contents.filter((c) => this.isTrackValid(c, viewUidsSet));
              }
            });
          }
        }
      }
      return viewsByUid;
    }
  }, {
    key: "processViewConfig",
    value: function processViewConfig(viewConfig) {
      let {
        views
      } = viewConfig;
      let viewsByUid = {};
      let maxHeight = 1;
      if (!viewConfig.views || viewConfig.views.length === 0) {
        console.warn("No views provided in viewConfig");
        views = [{
          editable: true,
          tracks: {}
        }];
      }
      views.forEach((v) => {
        if (v.tracks) {
          fillInMinWidths(v.tracks);
        }
        if (!v.uid) {
          v.uid = slugid.nice();
        }
        viewsByUid[v.uid] = v;
        if (this.zoomToDataExtentOnInit.has(v.uid)) {
          this.zoomToDataExtentOnInit.delete(v.uid);
        }
        if (!v.initialXDomain) {
          v.initialXDomain = [0, 100];
          this.zoomToDataExtentOnInit.add(v.uid);
        } else {
          v.initialXDomain[0] = +v.initialXDomain[0];
          v.initialXDomain[1] = +v.initialXDomain[1];
        }
        if (!v.initialYDomain) {
          v.initialYDomain = [v.initialXDomain[0], v.initialXDomain[1]];
        } else {
          v.initialXDomain[0] = +v.initialXDomain[0];
          v.initialXDomain[1] = +v.initialXDomain[1];
        }
        if (!this.xScales[v.uid]) {
          this.xScales[v.uid] = linear().domain(v.initialXDomain);
        }
        if (!this.yScales[v.uid]) {
          this.yScales[v.uid] = linear().domain(v.initialYDomain);
        }
        visitPositionedTracks(v.tracks, (track) => {
          if (this.state?.views?.[v.uid]) {
            const existingTrack = getTrackByUid(this.state.views[v.uid].tracks, track.uid);
            if (existingTrack) {
              track.maxZoom = existingTrack.maxZoom;
              track.resolutions = existingTrack.resolutions;
              track.binsPerDimension = existingTrack.binsPerDimension;
              track.maxWidth = existingTrack.maxWidth;
            }
          }
          if (!track.uid) track.uid = slugid.nice();
          this.addCallbacks(v.uid, track);
          this.addDefaultTrackOptions(track);
          if (track.contents) {
            for (const ct of track.contents) this.addDefaultTrackOptions(ct);
          }
        });
        if (v.layout) {
          v.layout.i = v.uid;
        } else {
          v.layout = this.generateViewLayout(v);
        }
        maxHeight = Math.max(maxHeight, v.layout.y + v.layout.h);
      });
      const TARGET_MAX_HEIGHT = 12;
      const multiplier = Math.ceil(TARGET_MAX_HEIGHT / maxHeight);
      views.forEach((v) => {
        v.layout.h *= multiplier;
        v.layout.y *= multiplier;
      });
      this.deserializeZoomLocks(viewConfig);
      this.deserializeLocationLocks(viewConfig);
      this.deserializeValueScaleLocks(viewConfig);
      viewsByUid = this.removeInvalidTracks(viewsByUid);
      return viewsByUid;
    }
  }, {
    key: "handleWindowFocused",
    value: function handleWindowFocused() {
    }
    /**
     * Handle range selection events.
     *
     * @description
     * Store active range selectio and forward the range selection event to the
     * API.
     *
     * @param  {Array}  range  Double array of the selected range.
     */
  }, {
    key: "rangeSelectionHandler",
    value: function rangeSelectionHandler(range2) {
      this.rangeSelection = range2;
      this.apiPublish("rangeSelection", range2);
    }
  }, {
    key: "offViewChange",
    value: function offViewChange(callback) {
      const index2 = this.viewChangeListener.indexOf(callback);
      if (index2 > -1) {
        this.viewChangeListener.splice(index2, 1);
      }
    }
  }, {
    key: "onViewChange",
    value: function onViewChange(callback) {
      return this.viewChangeListener.push(callback) - 1;
    }
  }, {
    key: "triggerViewChange",
    value: function triggerViewChange() {
      if (!this.mounted) return;
      const viewsString = this.getViewsAsString();
      this.viewChangeListener.forEach((callback) => callback(viewsString));
    }
  }, {
    key: "getGenomeLocation",
    value: function getGenomeLocation(viewId) {
      return api$1.get(this.state.views[viewId].chromInfoPath).then((chrInfo) => scalesToGenomeLoci(this.xScales[viewId], this.yScales[viewId], chrInfo));
    }
  }, {
    key: "offLocationChange",
    value: function offLocationChange(viewId, listenerId) {
      this.removeScalesChangedListener(viewId, listenerId);
    }
  }, {
    key: "zoomTo",
    value: function zoomTo(viewUid, start1Abs, end1Abs, start2Abs, end2Abs, animateTime) {
      if (!(viewUid in this.setCenters)) {
        throw Error(`Invalid viewUid. Current uuids: ${Object.keys(this.setCenters).join(",")}`);
      }
      if (Number.isNaN(+start1Abs) || Number.isNaN(+end1Abs)) {
        const coords = [start1Abs, end1Abs].join(", ");
        console.warn([`Invalid coordinates (${coords}). All coordinates need to be numbers
        and should represent absolute coordinates (not chromosome
        coordinates).`].join(" "));
        return;
      }
      if (Number.isNaN(+start2Abs) || Number.isNaN(+end2Abs) || start2Abs === null || end2Abs === null) {
        start2Abs = start1Abs;
        end2Abs = end1Abs;
      }
      const [centerX, centerY, k] = scalesCenterAndK(this.xScales[viewUid].copy().domain([start1Abs, end1Abs]), this.yScales[viewUid].copy().domain([start2Abs, end2Abs]));
      this.setCenters[viewUid](centerX, centerY, k, false, animateTime);
    }
  }, {
    key: "zoomToGene",
    value: function zoomToGene(viewUid, geneName, padding, animateTime) {
      if (!(viewUid in this.setCenters)) {
        throw Error(`Invalid viewUid. Current uuids: ${Object.keys(this.setCenters).join(",")}`);
      }
      if (!this.state.views[viewUid].genomePositionSearchBox || !this.state.views[viewUid].genomePositionSearchBox.autocompleteServer || !this.state.views[viewUid].genomePositionSearchBox.autocompleteId || !this.state.views[viewUid].chromInfoPath) {
        console.warn("Please set chromInfoPath, autocompleteServer, and autocompleteId to use the zoomToGene API");
        return;
      }
      this.suggestGene(viewUid, geneName, (suggestions) => {
        if (suggestions) {
          const exactMatch = suggestions.find((d) => d.geneName.toLowerCase() === geneName.toLowerCase());
          if (exactMatch) {
            const {
              chr,
              txStart,
              txEnd
            } = exactMatch;
            ChromosomeInfo(this.state.views[viewUid].chromInfoPath, (loadedChromInfo) => {
              const startAbs = loadedChromInfo.chrToAbs([chr, txStart]) - padding;
              const endAbs = loadedChromInfo.chrToAbs([chr, txEnd]) + padding;
              const [centerX, centerY, k] = scalesCenterAndK(this.xScales[viewUid].copy().domain([startAbs, endAbs]), this.yScales[viewUid].copy().domain([startAbs, endAbs]));
              this.setCenters[viewUid](centerX, centerY, k, false, animateTime);
            }, this.pubSub);
          } else {
            console.warn(`Couldn't find the gene symbol: ${geneName}`);
          }
        }
      });
    }
  }, {
    key: "suggestGene",
    value: function suggestGene(viewUid, keyword2, callback) {
      if (!(viewUid in this.setCenters)) {
        throw Error(`Invalid viewUid. Current uuids: ${Object.keys(this.setCenters).join(",")}`);
      }
      if (!this.state.views[viewUid].genomePositionSearchBox || !this.state.views[viewUid].genomePositionSearchBox.autocompleteServer || !this.state.views[viewUid].genomePositionSearchBox.autocompleteId) {
        console.warn("Please set autocompleteServer and autocompleteId to use the suggestGene API");
        return;
      }
      const autocompleteServer = this.state.views[viewUid].genomePositionSearchBox.autocompleteServer;
      const autocompleteId = this.state.views[viewUid].genomePositionSearchBox.autocompleteId;
      const url = `${autocompleteServer}/suggest/?d=${autocompleteId}&ac=${keyword2.toLowerCase()}`;
      api.json(url, toVoid, this.pubSub).then((suggestions) => {
        callback(suggestions);
      }).catch((error) => console.error(error));
    }
  }, {
    key: "onLocationChange",
    value: function onLocationChange(viewId, callback, callbackId) {
      const viewsIds = Object.keys(this.state.views);
      if (!viewsIds.length) {
        this.unsetOnLocationChange.push({
          viewId,
          callback,
          callbackId
        });
        return null;
      }
      viewId = typeof viewId === "undefined" && viewsIds.length === 1 ? viewsIds[0] : viewId;
      if (typeof viewId === "undefined" || viewsIds.indexOf(viewId) === -1) {
        console.error("onLocationChange either missing a viewId or passed an invalid viewId: ", viewId);
        return null;
      }
      const view = this.state.views[viewId];
      const middleLayerListener = (xScale, yScale) => {
        callback({
          xDomain: xScale.domain(),
          yDomain: yScale.domain(),
          xRange: xScale.range(),
          yRange: yScale.range()
        });
      };
      let newListenerId = 1;
      if (this.scalesChangedListeners[view.uid]) {
        newListenerId = Object.keys(this.scalesChangedListeners[view.uid]).filter((listenerId) => listenerId.indexOf(LOCATION_LISTENER_PREFIX) === 0).map((listenerId) => Number.parseInt(listenerId.slice(LOCATION_LISTENER_PREFIX.length + 1), 10)).reduce((max2, value) => Math.max(max2, value), 0) + 1;
      }
      this.addScalesChangedListener(view.uid, `${LOCATION_LISTENER_PREFIX}.${newListenerId}`, middleLayerListener);
      if (callbackId) {
        callbackId(`${LOCATION_LISTENER_PREFIX}.${newListenerId}`);
      }
      return newListenerId;
    }
    /**
     * List all the views that are at the given position view position
     */
  }, {
    key: "getTiledPlotAtPosition",
    value: function getTiledPlotAtPosition(x, y) {
      let foundTiledPlot;
      const views = dictValues(this.state.views);
      for (let i = 0; i < views.length; i++) {
        const tiledPlot = this.tiledPlots[views[i].uid];
        const area2 = this.tiledAreasDivs[views[i].uid].getBoundingClientRect();
        const {
          top: top2,
          left: left2
        } = area2;
        const bottom2 = top2 + area2.height;
        const right2 = left2 + area2.width;
        const withinX = x >= left2 && x <= right2;
        const withinY = y >= top2 && y <= bottom2;
        if (withinX && withinY) {
          foundTiledPlot = tiledPlot;
          break;
        }
      }
      return foundTiledPlot;
    }
    /**
     * Handle mousemove events by republishing the event using pubSub.
     *
     * @param {object}  e  Event object.
     */
  }, {
    key: "mouseMoveHandler",
    value: function mouseMoveHandler(e) {
      if (!this.topDivRef.current || this.state.modal) return;
      const absX = e.clientX;
      const absY = e.clientY;
      const relPos = pointer(e, this.topDivRef.current);
      relPos[1] += this.scrollTop;
      const hoveredTiledPlot = this.getTiledPlotAtPosition(absX, absY);
      const hoveredTracks = hoveredTiledPlot ? hoveredTiledPlot.listTracksAtPosition(relPos[0], relPos[1], true).map((track) => track.originalTrack || track) : [];
      const hoveredTrack = hoveredTracks.find((track) => !track.isAugmentationTrack);
      const relTrackPos = hoveredTrack ? [relPos[0] - hoveredTrack.position[0], relPos[1] - hoveredTrack.position[1]] : relPos;
      let dataX = -1;
      let dataY = -1;
      if (hoveredTrack) {
        dataX = !hoveredTrack.flipText ? hoveredTrack._xScale.invert(relTrackPos[0]) : hoveredTrack._xScale.invert(relTrackPos[1]);
        dataY = hoveredTrack.is2d ? hoveredTrack._yScale.invert(relTrackPos[1]) : dataX;
      }
      const evt = {
        x: relPos[0],
        y: relPos[1],
        relTrackX: hoveredTrack?.flipText ? relTrackPos[1] : relTrackPos[0],
        relTrackY: hoveredTrack?.flipText ? relTrackPos[0] : relTrackPos[1],
        dataX,
        dataY,
        // See below why we need these derived boolean values
        isFrom2dTrack: !!hoveredTrack?.is2d,
        isFromVerticalTrack: !!hoveredTrack?.flipText,
        track: hoveredTrack,
        origEvt: e,
        sourceUid: this.uid,
        hoveredTracks,
        // See below why we need these derived boolean values
        noHoveredTracks: hoveredTracks.length === 0
      };
      this.pubSub.publish("app.mouseMove", evt);
      if (this.isBroadcastMousePositionGlobally) {
        const eventDataOnly = {
          ...evt
        };
        eventDataOnly.origEvt = void 0;
        eventDataOnly.track = void 0;
        eventDataOnly.hoveredTracks = void 0;
        delete eventDataOnly.origEvt;
        delete eventDataOnly.track;
        delete eventDataOnly.hoveredTracks;
        globalPubSub.publish("higlass.mouseMove", eventDataOnly);
      }
      this.apiPublish("cursorLocation", {
        absX,
        absY,
        relX: evt.x,
        relY: evt.y,
        relTrackX: evt.relTrackX,
        relTrackY: evt.relTrackY,
        dataX: evt.dataX,
        dataY: evt.dataY,
        isFrom2dTrack: evt.isFrom2dTrack,
        isFromVerticalTrack: evt.isFromVerticalTrack
      });
      this.showHoverMenu(evt);
      this.showHoverUids(evt);
    }
  }, {
    key: "getMinMaxValue",
    value: function getMinMaxValue(viewId, trackId, ignoreOffScreenValues, ignoreFixedScale) {
      const track = getTrackObjById(this.tiledPlots, viewId, trackId);
      if (!track) {
        console.warn(`Track with ID: ${trackId} not found!`);
        return void 0;
      }
      if (!track.minVisibleValueInTiles || !track.maxVisibleValueInTiles) {
        console.warn(`Track ${trackId} doesn't support the retrieval of min or max values.`);
        return void 0;
      }
      if (ignoreOffScreenValues && track.getAggregatedVisibleValue) {
        return [track.getAggregatedVisibleValue("min"), track.getAggregatedVisibleValue("max")];
      }
      return [track.minVisibleValueInTiles(ignoreFixedScale), track.maxVisibleValueInTiles(ignoreFixedScale)];
    }
    /*
     * Someone has hovered over an item in sourceTrack so we need to inform
     * any other track that has that item that it's been hovered over.
     */
  }, {
    key: "showHoverUids",
    value: function showHoverUids(evt) {
      const mouseOverUids = evt.track?.getMouseOverUids ? evt.track.getMouseOverUids(evt.relTrackX, evt.relTrackY) : null;
      for (const track of this.iterateOverTracks()) {
        const trackObj = getTrackObjById(this.tiledPlots, track.viewId, track.trackId);
        if (trackObj.itemsHovered) {
          trackObj.itemsHovered(mouseOverUids);
        }
      }
    }
    /**
     * Show a menu displaying some information about the track under it
     */
  }, {
    key: "showHoverMenu",
    value: function showHoverMenu(evt) {
      const mouseOverHtml = evt.track?.getMouseOverHtml ? evt.track.getMouseOverHtml(evt.relTrackX, evt.relTrackY) : "";
      if (evt.track !== this.prevMouseHoverTrack) {
        if (this.prevMouseHoverTrack?.stopHover) {
          this.prevMouseHoverTrack.stopHover();
        }
      }
      this.prevMouseHoverTrack = evt.track;
      if (this.zooming) return;
      const data2 = mouseOverHtml?.length ? [1] : [];
      let mouseOverDiv = select("body").selectAll(".track-mouseover-menu").data(data2);
      mouseOverDiv.exit().remove();
      mouseOverDiv.enter().append("div").classed("track-mouseover-menu", true).classed(styles["track-mouseover-menu"], true);
      mouseOverDiv = select("body").selectAll(".track-mouseover-menu");
      const mousePos = pointer(evt.origEvt, select("body").node());
      const normalizedMousePos = [mousePos[0] - window.scrollX, mousePos[1] - window.scrollY];
      mouseOverDiv.style("left", `${normalizedMousePos[0]}px`).style("top", `${normalizedMousePos[1]}px`);
      if (!mouseOverDiv.node()) return;
      const bbox = mouseOverDiv.node().getBoundingClientRect();
      if (bbox.x + bbox.width > window.innerWidth) {
        mouseOverDiv.style("left", `${normalizedMousePos[0] - bbox.width}px`);
      }
      if (bbox.y + bbox.height > window.innerHeight) {
        mouseOverDiv.style("top", `${normalizedMousePos[1] - bbox.height}px`);
      }
      mouseOverDiv.html(mouseOverHtml);
    }
    /**
     * Hide the hover menu when e.g. the user starts zooming
     */
  }, {
    key: "hideHoverMenu",
    value: function hideHoverMenu() {
      select("body").selectAll(".track-mouseover-menu").remove();
    }
    /**
     * Close the custom dialog  (e.g. when the close button is clicked)
     */
  }, {
    key: "closeCustomDialog",
    value: function closeCustomDialog() {
      this.setState((prevState) => ({
        customDialog: null
      }));
    }
    /**
     * Handle internally broadcasted click events
     */
  }, {
    key: "appClickHandler",
    value: function appClickHandler(data2) {
      this.apiPublish("click", data2);
    }
    /** Handle click events on the canvas. The canvas is preferrable
     * to the top level div because the canvas's events aren't forwarded
     * so we only receive one click event
     */
  }, {
    key: "canvasClickHandler",
    value: function canvasClickHandler(evt) {
      const nativeEvent = evt.nativeEvent || evt;
      const absX = nativeEvent.clientX;
      const absY = nativeEvent.clientY;
      const hoveredTiledPlot = this.getTiledPlotAtPosition(absX, absY);
      const relPos = pointer(nativeEvent, this.topDivRef.current);
      relPos[1] += this.scrollTop;
      const hoveredTracks = hoveredTiledPlot ? hoveredTiledPlot.listTracksAtPosition(relPos[0], relPos[1], true).map((track) => track.originalTrack || track) : [];
      const hoveredTrack = hoveredTracks.find((track) => !track.isAugmentationTrack);
      const relTrackPos = hoveredTrack ? [relPos[0] - hoveredTrack.position[0], relPos[1] - hoveredTrack.position[1]] : relPos;
      const relTrackX = hoveredTrack?.flipText ? relTrackPos[1] : relTrackPos[0];
      const relTrackY = hoveredTrack?.flipText ? relTrackPos[0] : relTrackPos[1];
      for (const track of this.iterateOverTracks()) {
        const trackObj = getTrackObjById(this.tiledPlots, track.viewId, track.trackId);
        if (!trackObj.respondsToPosition(relPos[0], relPos[1])) {
          trackObj.clickOutside();
        }
      }
      const clickReturns = [];
      for (const track of hoveredTracks) {
        if (track.childTracks) {
          for (const subtrack of track.childTracks) {
            clickReturns.push({
              trackUid: subtrack.context.trackUid,
              viewUid: subtrack.context.viewUid,
              trackType: subtrack.context.trackType,
              data: subtrack.click(relTrackX, relTrackY, evt)
            });
          }
          clickReturns.push({
            trackUid: track.context.trackUid,
            viewUid: track.context.viewUid,
            trackType: track.context.trackType,
            data: {
              type: "generic",
              event: evt
            }
          });
        } else {
          clickReturns.push({
            trackUid: track.context.trackUid,
            viewUid: track.context.viewUid,
            trackType: track.context.trackType,
            data: track.click(relTrackX, relTrackY, evt)
          });
        }
      }
      const customDialog = [];
      clickReturns.forEach((clickReturn, i) => {
        const trackObj = getTrackObjById(this.tiledPlots, clickReturn.viewUid, clickReturn.trackUid);
        if (typeof trackObj.clickDialog === "function") {
          const dialogData = trackObj.clickDialog();
          if (dialogData) {
            customDialog.push(dialogData);
          }
        }
      });
      if (customDialog.length > 0) {
        this.setState((prevState) => ({
          customDialog
        }));
      }
      this.pubSub.publish("app.click", clickReturns);
    }
    /**
     * Handle mousemove and zoom events.
     */
  }, {
    key: "mouseMoveZoomHandler",
    value: function mouseMoveZoomHandler(data2) {
      this.apiPublish("mouseMoveZoom", data2);
    }
    /**
     * Handle gene search events.
     */
  }, {
    key: "geneSearchHandler",
    value: function geneSearchHandler(data2) {
      this.apiPublish("geneSearch", data2);
    }
    /**
     * Handle mousedown events/
     */
  }, {
    key: "mouseDownHandler",
    value: function mouseDownHandler(evt) {
    }
  }, {
    key: "onScrollHandler",
    value: function onScrollHandler() {
      if (this.sizeMode !== SIZE_MODE_SCROLL) return;
      this.scrollTop = this.scrollContainer.scrollTop;
      this.pixiStage.y = -this.scrollTop;
      this.pubSub.publish("app.scroll", this.scrollTop);
      this.animate();
    }
  }, {
    key: "setTrackValueScaleLimits",
    value: function setTrackValueScaleLimits(viewId, trackId, minValue, maxValue) {
      const track = getTrackObjById(this.tiledPlots, viewId, trackId);
      if (!track) {
        console.warn(`Could't find track: ${trackId}`);
        return;
      }
      if (track.setFixedValueScaleMin && track.setFixedValueScaleMax) {
        track.setFixedValueScaleMin(minValue);
        track.setFixedValueScaleMax(maxValue);
        track.rerender(track.options, true);
        track.animate();
      } else {
        console.warn("Track doesn't support fixed value scales.");
      }
    }
  }, {
    key: "setChromInfo",
    value: function setChromInfo(chromInfoPath, callback) {
      ChromosomeInfo(chromInfoPath, (newChromInfo) => {
        this.chromInfo = newChromInfo;
        callback();
      }, this.pubSub);
    }
  }, {
    key: "onMouseLeaveHandler",
    value: function onMouseLeaveHandler() {
      this.pubSub.publish("app.mouseLeave");
      this.hideHoverMenu();
      this.animate();
    }
  }, {
    key: "onBlurHandler",
    value: function onBlurHandler() {
      this.animate();
    }
  }, {
    key: "isZoomFixed",
    value: function isZoomFixed(view) {
      return this.props.zoomFixed || this.props.options.zoomFixed || this.state.viewConfig.zoomFixed || this.sizeMode === SIZE_MODE_SCROLL || view?.zoomFixed;
    }
    /**
     * Handle trackDimensionsModified events
     * @param {Object} settings
     * @param {string} settings.viewId = id of the view
     * @param {string} settings.trackId = id of the track
     * @param {number} settings.height = new height of the track or undefined if current height should remain
     * @param {nmber} settings.width = new width of the track or undefined if current width should remain
     */
  }, {
    key: "trackDimensionsModifiedHandler",
    value: function trackDimensionsModifiedHandler(settings) {
      const view = this.state.views[settings.viewId];
      if (!view) return;
      const track = getTrackByUid(view.tracks, settings.trackId);
      if (!track) return;
      if (settings.height !== void 0) {
        track.height = settings.height;
      }
      if (settings.width !== void 0) {
        track.width = settings.width;
      }
      this.adjustLayoutToTrackSizes(view);
      this.setState((prevState) => ({
        views: prevState.views
      }));
    }
  }, {
    key: "wheelHandler",
    value: function wheelHandler(evt) {
      if (this.state.modal || this.sizeMode === SIZE_MODE_SCROLL) return;
      const nativeEvent = evt.nativeEvent || evt;
      if (!hasParent(nativeEvent.target, this.topDivRef.current)) {
        return;
      }
      if (this.isZoomFixed()) {
        return;
      }
      const absX = nativeEvent.clientX;
      const absY = nativeEvent.clientY;
      const hoveredTiledPlot = this.getTiledPlotAtPosition(absX, absY);
      if (this.apiStack.wheel && this.apiStack.wheel.length > 0) {
        const relPos = pointer(nativeEvent, this.topDiv);
        relPos[1] += this.scrollTop;
        const hoveredTracks = hoveredTiledPlot ? hoveredTiledPlot.listTracksAtPosition(relPos[0], relPos[1], true).map((track) => track.originalTrack || track) : [];
        const hoveredTrack = hoveredTracks.find((track) => !track.isAugmentationTrack);
        const relTrackPos = hoveredTrack ? [relPos[0] - hoveredTrack.position[0], relPos[1] - hoveredTrack.position[1]] : relPos;
        const evtToPublish = {
          x: relPos[0],
          y: relPos[1],
          relTrackX: hoveredTrack?.flipText ? relTrackPos[1] : relTrackPos[0],
          relTrackY: hoveredTrack?.flipText ? relTrackPos[0] : relTrackPos[1],
          track: hoveredTrack,
          origEvt: nativeEvent,
          sourceUid: this.uid,
          hoveredTracks,
          noHoveredTracks: hoveredTracks.length === 0
        };
        this.apiPublish("wheel", evtToPublish);
      }
      const isTargetCanvas = evt.target === this.canvasElement;
      if (nativeEvent.forwarded || isTargetCanvas) {
        evt.stopPropagation();
        evt.preventDefault();
        return;
      }
      evt.preventDefault();
      if (hoveredTiledPlot) {
        const {
          trackRenderer
        } = hoveredTiledPlot;
        nativeEvent.forwarded = true;
        if (nativeEvent) {
          forwardEvent(nativeEvent, trackRenderer.eventTracker);
          nativeEvent.preventDefault();
        }
      }
    }
    /** Convert a viewUid to a view name so that when we create
     * viewport projects, we can show which view they refer to.
     * The name is usually a single letter like 'A'
     *  The view's name will also be visible in the header. */
  }, {
    key: "viewUidToName",
    value: function viewUidToName(viewUid) {
      const views = Object.keys(this.state.views);
      for (let i = 0; i < views.length; i++) {
        if (views[i] === viewUid) {
          return String.fromCharCode(65 + i);
        }
      }
      return "UU";
    }
  }, {
    key: "render",
    value: function render3() {
      this.tiledAreasDivs = {};
      this.tiledAreas = /* @__PURE__ */ React__default.createElement("div", {
        className: styles["tiled-area"]
      });
      if (this.mounted) {
        this.tiledAreas = dictValues(this.state.views).map((view) => {
          const addTrackPositionMenuPosition = view.uid === this.state.addTrackPositionMenuUid ? this.state.addTrackPositionMenuPosition : null;
          let overlay = null;
          if (this.state.chooseViewHandler) {
            let background = "transparent";
            if (this.state.mouseOverOverlayUid === view.uid) background = "green";
            overlay = /* @__PURE__ */ React__default.createElement("div", {
              className: "tiled-plot-overlay",
              onClick: () => this.state.chooseViewHandler(view.uid),
              onMouseEnter: () => this.handleOverlayMouseEnter(view.uid),
              onMouseLeave: () => this.handleOverlayMouseLeave(view.uid),
              onMouseMove: () => this.handleOverlayMouseEnter(view.uid),
              style: {
                position: "absolute",
                width: "100%",
                height: "100%",
                background,
                opacity: 0.3,
                zIndex: 1
              }
            });
          }
          const tiledPlot = /* @__PURE__ */ React__default.createElement(
            TiledPlot$1,
            {
              key: `tp${view.uid}`,
              ref: (c) => {
                this.tiledPlots[view.uid] = c;
              },
              addTrackExtent: this.state.addTrackPositionView === view.uid ? this.state.addTrackExtent : null,
              addTrackPosition: this.state.addTrackPositionView === view.uid ? this.state.addTrackPosition : null,
              addTrackPositionMenuPosition,
              apiPublish: this.apiPublish,
              canvasElement: this.state.canvasElement,
              chooseTrackHandler: this.state.chooseTrackHandler ? (trackId, evt) => this.state.chooseTrackHandler(view.uid, trackId, evt) : null,
              customDialog: this.state.customDialog,
              closeCustomDialog: () => this.closeCustomDialog(),
              chromInfoPath: view.chromInfoPath,
              disableTrackMenu: this.isTrackMenuDisabled(),
              draggingHappening: this.state.draggingHappening,
              editable: this.isEditable(),
              genomePositionSearchBox: this.genomePositionSearchBoxes[view.uid],
              getLockGroupExtrema: (uid) => this.getLockGroupExtrema(view.uid, uid),
              initialXDomain: view.initialXDomain,
              initialYDomain: view.initialYDomain,
              isShowGlobalMousePosition: this.isShowGlobalMousePosition,
              isValueScaleLocked: (uid) => this.isValueScaleLocked(view.uid, uid),
              marginBottom: this.viewMarginBottom,
              marginLeft: this.viewMarginLeft,
              marginRight: this.viewMarginRight,
              marginTop: this.viewMarginTop,
              metaTracks: view.metaTracks,
              mouseTool: this.state.mouseTool,
              onChangeTrackData: (trackId, newData) => this.handleChangeTrackData(view.uid, trackId, newData),
              onChangeTrackType: (trackId, newType) => this.handleChangeTrackType(view.uid, trackId, newType),
              onCloseTrack: (uid) => this.handleCloseTrack(view.uid, uid),
              onDataDomainChanged: (xDomain, yDomain) => this.handleDataDomainChanged(view.uid, xDomain, yDomain),
              onLockValueScale: (uid) => this.handleLockValueScale(view.uid, uid),
              onMouseMoveZoom: this.mouseMoveZoomHandler.bind(this),
              onNewTilesLoaded: (trackUid) => this.handleNewTilesLoaded(view.uid, trackUid),
              onNoTrackAdded: this.handleNoTrackAdded.bind(this),
              onRangeSelection: this.rangeSelectionHandler.bind(this),
              onResizeTrack: () => {
                this.adjustLayoutToTrackSizes(view);
                this.triggerViewChangeDb();
              },
              onScalesChanged: (x, y) => this.handleScalesChanged(view.uid, x, y),
              onTrackOptionsChanged: (trackId, options2) => this.handleTrackOptionsChanged(view.uid, trackId, options2),
              onTrackPositionChosen: this.handleTrackPositionChosen.bind(this),
              onTracksAdded: (newTracks, position, extent2, host) => this.handleTracksAdded(view.uid, newTracks, position, extent2, host),
              onUnlockValueScale: (uid) => this.handleUnlockValueScale(view.uid, uid),
              onValueScaleChanged: (uid) => this.syncValueScales(view.uid, uid),
              overlays: view.overlays,
              overTrackChooser: this.state.overTrackChooser,
              paddingBottom: this.viewPaddingBottom,
              paddingLeft: this.viewPaddingLeft,
              paddingRight: this.viewPaddingRight,
              paddingTop: this.viewPaddingTop,
              pixiRenderer: this.pixiRenderer,
              pixiStage: this.pixiStage,
              pluginDataFetchers: this.pluginDataFetchers,
              pluginTracks: this.pluginTracks,
              rangeSelection1dSize: this.state.rangeSelection1dSize,
              rangeSelectionToInt: this.state.rangeSelectionToInt,
              registerDraggingChangedListener: (listener) => this.addDraggingChangedListener(view.uid, view.uid, listener),
              removeDraggingChangedListener: (listener) => this.removeDraggingChangedListener(view.uid, view.uid, listener),
              setCentersFunction: (c) => {
                this.setCenters[view.uid] = c;
              },
              setOverTrackChooser: (val) => this.setState({
                overTrackChooser: val
              }),
              svgElement: this.state.svgElement,
              tracks: view.tracks,
              trackSourceServers: this.state.viewConfig.trackSourceServers,
              uid: view.uid,
              verticalMargin: this.verticalMargin,
              viewOptions: view.options,
              xDomainLimits: view.xDomainLimits,
              yDomainLimits: view.yDomainLimits,
              zoomable: !this.isZoomFixed(view),
              zoomLimits: this.calculateZoomLimits(view, view.initialXDomain),
              zoomToDataExtentOnInit: () => this.zoomToDataExtentOnInit.has(view.uid)
            }
          );
          const looseTracks = positionedTracksToAllTracks(view.tracks);
          const annotationTracks = looseTracks.filter((x) => x.type === "horizontal-gene-annotations" || x.type === "vertical-gene-annotations" || x.type === "gene-annotations");
          const chromSizesTracks = looseTracks.filter((x) => x.type === "horizontal-chromosome-labels" || x.type === "vertical-chromosome-labels" || x.type === "chromosome-labels");
          const uniqueAnnotationTilesets = new Set(annotationTracks.map((x) => x.tilesetUid));
          const uniqueChromSizesTilesets = new Set(chromSizesTracks.map((x) => x.tilesetUid));
          const getGenomePositionSearchBox = (isFocused, onFocus) => /* @__PURE__ */ React__default.createElement(
            GenomePositionSearchBox$1,
            {
              key: `gpsb${view.uid}`,
              ref: (c) => {
                this.genomePositionSearchBoxes[view.uid] = c;
              },
              autocompleteId: annotationTracks.length >= 1 && uniqueAnnotationTilesets.size === 1 ? annotationTracks[0].tilesetUid : null,
              autocompleteServer: annotationTracks.length >= 1 && uniqueAnnotationTilesets.size === 1 ? annotationTracks[0].server : null,
              chromInfoId: chromSizesTracks.length && chromSizesTracks[0].tilesetUid || view.genomePositionSearchBox?.chromInfoId || null,
              chromInfoServer: chromSizesTracks.length && chromSizesTracks[0].server || view.genomePositionSearchBox?.chromInfoServer || null,
              isFocused,
              onFocus,
              registerViewportChangedListener: (listener) => this.addScalesChangedListener(view.uid, view.uid, listener),
              removeViewportChangedListener: () => this.removeScalesChangedListener(view.uid, view.uid),
              setCenters: (centerX, centerY, k, animateTime) => this.setCenters[view.uid](centerX, centerY, k, false, animateTime),
              trackSourceServers: this.state.viewConfig.trackSourceServers,
              twoD: true,
              error: chromSizesTracks.length === 0 && "no chromosome track present" || chromSizesTracks.length >= 2 && uniqueChromSizesTilesets.size > 1 && "multiple chromosome tracks present" || annotationTracks.length >= 2 && uniqueAnnotationTilesets.size > 1 && "multiple annotation tracks present"
            }
          );
          const multiTrackHeader = this.isEditable() && !this.isViewHeaderDisabled() && !this.state.viewConfig.hideHeader ? /* @__PURE__ */ React__default.createElement(ViewHeader$1, {
            ref: (c) => {
              this.viewHeaders[view.uid] = c;
            },
            getGenomePositionSearchBox,
            isGenomePositionSearchBoxVisible: true,
            mouseTool: this.state.mouseTool,
            onAddView: () => this.handleAddView(view),
            onClearView: () => this.handleClearView(view.uid),
            onCloseView: () => this.handleCloseView(view.uid),
            onEditViewConfig: this.handleEditViewConfigBound,
            onExportPNG: this.handleExportPNG.bind(this),
            onExportSVG: this.handleExportSVG.bind(this),
            onExportViewsAsJSON: this.handleExportViewAsJSON.bind(this),
            onExportViewsAsLink: this.handleExportViewsAsLink.bind(this),
            onLockLocation: (uid) => this.handleYankFunction(uid, this.handleLocationLockChosen.bind(this)),
            onLockZoom: (uid) => this.handleYankFunction(uid, this.handleZoomLockChosen.bind(this)),
            onLockZoomAndLocation: (uid) => this.handleYankFunction(uid, (a, b) => {
              this.handleZoomLockChosen(a, b);
              this.handleLocationLockChosen(a, b);
            }),
            onProjectViewport: this.handleProjectViewport.bind(this),
            onTakeAndLockZoomAndLocation: (uid) => {
              this.handleYankFunction(uid, (a, b) => {
                this.handleZoomYanked(a, b);
                this.handleLocationYanked(a, b);
                this.handleZoomLockChosen(a, b);
                this.handleLocationLockChosen(a, b);
              });
            },
            onTogglePositionSearchBox: this.handleTogglePositionSearchBox.bind(this),
            onTrackPositionChosen: (position, extent2) => this.handleTrackPositionChosen(view.uid, position, extent2),
            onUnlockLocation: (uid) => this.handleUnlock(uid, this.locationLocks),
            onUnlockZoom: (uid) => this.handleUnlock(uid, this.zoomLocks),
            onUnlockZoomAndLocation: (uid) => {
              this.handleUnlock(uid, this.zoomLocks);
              this.handleUnlock(uid, this.locationLocks);
            },
            onViewOptionsChanged: (newOptions) => this.handleViewOptionsChanged(view.uid, newOptions),
            onYankLocation: (uid) => this.handleYankFunction(uid, this.handleLocationYanked.bind(this)),
            onYankZoom: (uid) => this.handleYankFunction(uid, this.handleZoomYanked.bind(this)),
            onYankZoomAndLocation: (uid) => this.handleYankFunction(uid, (a, b) => {
              this.handleZoomYanked(a, b);
              this.handleLocationYanked(a, b);
            }),
            onZoomToData: (uid) => this.handleZoomToData(uid),
            viewUid: view.uid
          }) : null;
          const marginY = this.isEditable() ? 10 : 0;
          const expectedPixelHeight = view.layout ? Math.round(this.state.rowHeight * view.layout.h + Math.max(0, view.layout.h - 1) * marginY) : void 0;
          return /* @__PURE__ */ React__default.createElement("div", {
            key: view.uid,
            style: expectedPixelHeight !== void 0 ? {
              maxHeight: expectedPixelHeight,
              overflow: "hidden"
            } : void 0
          }, /* @__PURE__ */ React__default.createElement("div", {
            ref: (c) => {
              this.tiledAreasDivs[view.uid] = c;
            },
            className: styles["tiled-area"]
          }, multiTrackHeader, tiledPlot, overlay));
        });
      }
      let layouts = this.mounted ? Object.values(this.state.views).filter((view) => view.layout).map((view) => view.layout) : [];
      layouts = JSON.parse(JSON.stringify(layouts));
      const defaultContainerPaddingX = this.isEditable() ? DEFAULT_CONTAINER_PADDING_X : 0;
      const defaultContainerPaddingY = this.isEditable() ? DEFAULT_CONTAINER_PADDING_Y : 0;
      const containerPaddingX = +this.props.options.containerPaddingX >= 0 ? +this.props.options.containerPaddingX : defaultContainerPaddingX;
      const containerPaddingY = +this.props.options.containerPaddingY >= 0 ? +this.props.options.containerPaddingY : defaultContainerPaddingY;
      const gridLayout = /* @__PURE__ */ React__default.createElement(GridLayout, {
        gridConfig: {
          cols: 12,
          rowHeight: this.state.rowHeight,
          // for some reason, this becomes 40 within the react-grid component
          // (try resizing the component to see how much the height changes)
          // Programming by coincidence FTW :-/
          margin: this.isEditable() ? [10, 10] : [0, 0],
          containerPadding: [containerPaddingX, containerPaddingY]
        },
        dragConfig: {
          enabled: this.isEditable(),
          handle: `.${stylesMTHeader["multitrack-header-grabber"]}`
        },
        resizeConfig: {
          enabled: this.isEditable()
        },
        compactor: getCompactor(this.state.viewConfig.compactLayout === false ? null : "vertical"),
        layout: layouts,
        onDragStart: this.handleDragStart.bind(this),
        onDragStop: this.handleDragStop.bind(this),
        onLayoutChange: this.handleLayoutChange.bind(this),
        onResize: this.resizeHandler.bind(this),
        width: this.state.width
      }, this.tiledAreas);
      return /* @__PURE__ */ React__default.createElement("div", {
        key: this.uid,
        ref: this.topDivRef,
        className: clsx$2("higlass", styles.higlass, {
          [styles["higlass-dark-theme"]]: this.theme === THEME_DARK,
          [styles["higlass-container-overflow"]]: this.sizeMode === SIZE_MODE_OVERFLOW || this.sizeMode === SIZE_MODE_BOUNDED_OVERFLOW || this.sizeMode === SIZE_MODE_SCROLL
        }),
        onMouseLeave: this.onMouseLeaveHandlerBound,
        onMouseMove: this.mouseMoveHandlerBound
      }, /* @__PURE__ */ React__default.createElement(Provider$1, {
        value: this.pubSub
      }, /* @__PURE__ */ React__default.createElement(Provider$2, {
        value: this.modal
      }, /* @__PURE__ */ React__default.createElement(Provider, {
        value: this.theme
      }, /* @__PURE__ */ React__default.createElement(HiGlassComponentContext.Provider, {
        value: {
          viewUidToName: this.viewUidToNameBound
        }
      }, this.state.modal, /* @__PURE__ */ React__default.createElement("canvas", {
        key: this.uid,
        ref: (c) => {
          this.canvasElement = c;
        },
        onClick: this.canvasClickHandlerBound,
        className: styles["higlass-canvas"]
      }), /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.scrollContainer = c;
        },
        className: clsx$2("higlass-scroll-container", {
          [styles["higlass-scroll-container-overflow"]]: this.sizeMode === SIZE_MODE_OVERFLOW || this.sizeMode === SIZE_MODE_BOUNDED_OVERFLOW,
          [styles["higlass-scroll-container-scroll"]]: this.sizeMode === SIZE_MODE_SCROLL
        }),
        onScroll: this.onScrollHandlerBound
      }, /* @__PURE__ */ React__default.createElement("div", {
        ref: (c) => {
          this.divDrawingSurface = c;
        },
        className: clsx$2("higlass-drawing-surface", styles["higlass-drawing-surface"])
      }, gridLayout), /* @__PURE__ */ React__default.createElement("svg", {
        ref: (c) => {
          this.svgElement = c;
        },
        style: {
          // inline the styles so they aren't overriden by other css
          // on the web page
          position: "absolute",
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
          pointerEvents: "none"
        },
        className: styles["higlass-svg"]
      })))))));
    }
  }]);
})(React__default.Component);
HiGlassComponent.defaultProps = {
  options: {},
  zoomFixed: false,
  compactLayout: true
};
HiGlassComponent.propTypes = {
  getApi: PropTypes.func,
  options: PropTypes.object,
  viewConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  zoomFixed: PropTypes.bool,
  compactLayout: PropTypes.bool
};
const _CSS = "._multitrack-header_4g480_1,._multitrack-header-focus_4g480_2,._multitrack-header-squeazed_4g480_3{position:relative;display:flex;justify-content:space-between;height:24px;margin-top:4px;margin-bottom:4px;color:#999;font-size:12px;line-height:24px;vertical-align:middle;border:0;border-radius:3px;background:#e5e5e5;transition:height .15s cubic-bezier(.25,.1,.25,1),margin .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-dark_4g480_20{background:#222}._multitrack-header-focus_4g480_2{height:32px;margin-top:0;margin-bottom:0}._multitrack-header-id_4g480_30{padding-left:3px}._multitrack-header-id_4g480_30:before{content:\"ID:\";font-weight:700;padding-right:5px}._multitrack-header-left_4g480_39{display:flex;flex-grow:1}._multitrack-header-grabber_4g480_44,._multitrack-header-grabber-squeazed_4g480_45{display:flex;align-items:center;justify-content:center;width:24px;height:100%;cursor:move;border-radius:3px 0 0 3px;transition:background .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-grabber_4g480_44:hover,._multitrack-header-grabber-squeazed_4g480_45:hover{background:#999}._multitrack-header-grabber_4g480_44:hover div,._multitrack-header-grabber-squeazed_4g480_45:hover div{background:#fff}._multitrack-header-grabber_4g480_44 div,._multitrack-header-grabber-squeazed_4g480_45 div{width:1px;height:50%;margin:1px;background:#999;transition:background .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-dark_4g480_20 ._multitrack-header-grabber_4g480_44 div{background:#666}._multitrack-header-grabber-squeazed_4g480_45{width:19.2px}._multitrack-header-search_4g480_80{position:relative;flex-grow:1;height:100%;margin-right:12px}._multitrack-header-search_4g480_80:after{position:absolute;top:3px;bottom:3px;right:-12px;display:block;content:\"\";width:1px;margin:0 6px;background:#ccc}._multitrack-header-dark_4g480_20 ._multitrack-header-search_4g480_80:after{background:#666}._multitrack-header-nav-list_4g480_102,._multitrack-header_4g480_1>nav{display:flex}._multitrack-header-icon_4g480_107,._multitrack-header-icon-squeazed_4g480_108{width:24px;height:100%;padding:6px;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1)}._multitrack-header-icon_4g480_107 g,._multitrack-header-icon-squeazed_4g480_108 g{stroke:#999}._multitrack-header-icon_4g480_107:hover,._multitrack-header-icon_4g480_107:active,._multitrack-header-icon_4g480_107:focus,._multitrack-header-icon-squeazed_4g480_108:hover,._multitrack-header-icon-squeazed_4g480_108:active,._multitrack-header-icon-squeazed_4g480_108:focus{color:#fff;background:#337ab7}._multitrack-header-icon_4g480_107:hover g,._multitrack-header-icon_4g480_107:active g,._multitrack-header-icon_4g480_107:focus g,._multitrack-header-icon-squeazed_4g480_108:hover g,._multitrack-header-icon-squeazed_4g480_108:active g,._multitrack-header-icon-squeazed_4g480_108:focus g{stroke:#fff}._multitrack-header-icon_4g480_107:last-child,._multitrack-header-icon-squeazed_4g480_108:last-child{border-radius:0 3px 3px 0}._mouse-tool-selection_4g480_136{color:#fff;border-radius:3px 0 0 3px;background:#337ab7}._multitrack-header-icon-squeazed_4g480_108{width:20px;padding-left:3px;padding-right:3px}._button_1wnjn_1{display:flex;align-items:center;box-sizing:border-box;padding:.5em;color:#000;font-size:1em;line-height:1em;border:0;border-radius:2.5px;background:#fff;box-shadow:0 0 0 1px #ccc;transition:transform .15s cubic-bezier(.25,.1,.25,1),box-shadow .15s cubic-bezier(.25,.1,.25,1),background .15s cubic-bezier(.25,.1,.25,1);-webkit-appearance:none}._button_1wnjn_1:hover{background:#f2f2f2;box-shadow:0 0 0 1px #ccc}._button_1wnjn_1:focus{box-shadow:0 0 0 2px #0089ff}._button_1wnjn_1:active{transform:scale(.9)}._button_1wnjn_1:hover,._button_1wnjn_1:focus,._button_1wnjn_1:active{cursor:pointer;outline:none}._button-shortcut_1wnjn_35{padding:.1em 5px;color:#999;font-size:.8em;transition:color .15s cubic-bezier(.25,.1,.25,1)}._cross_2ke8w_1{position:relative;width:1em;height:1em}._cross_2ke8w_1:before,._cross_2ke8w_1:after{content:\"\";display:block;position:absolute;top:50%;left:0;width:1em;height:1px;background:#000;transform-origin:center}._cross_2ke8w_1:before{-webkit-transform:translate(0,-50%) rotate(45deg);-moz-transform:translate(0,-50%) rotate(45deg);transform:translateY(-50%) rotate(45deg)}._cross_2ke8w_1:after{-webkit-transform:translate(0,-50%) rotate(-45deg);-moz-transform:translate(0,-50%) rotate(-45deg);transform:translateY(-50%) rotate(-45deg)}._modal-background_zzhoe_1{position:absolute;z-index:1000;inset:0;background:#000a;animation:_fade-in_zzhoe_1 .2s cubic-bezier(.25,.1,.25,1) 1;transition:opacity .2s cubic-bezier(.25,.1,.25,1)}._modal-hide_zzhoe_13{opacity:0}._modal-wrap_zzhoe_17{position:absolute;inset:20px}._modal-window_zzhoe_25{position:relative;width:100%;max-width:640px;max-height:100%;margin-left:auto;margin-right:auto;color:#000;border-radius:5px;background:#fff;animation:_fade-scale-in_zzhoe_1 .2s cubic-bezier(.25,.1,.25,1) 1}._modal-window-max-height_zzhoe_38{height:100%}._modal-content_zzhoe_42{padding:10px}@keyframes _fade-in_zzhoe_1{0%{opacity:0}to{opacity:1}}@keyframes _fade-scale-in_zzhoe_1{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}._dialog-header_wp50s_1{position:relative;z-index:2;display:flex;justify-content:space-between;margin:0 -10px 10px;padding:0 10px 10px;border-bottom:1px solid #cccccc}._dialog-header_wp50s_1 h3{margin:0;padding:0;font-size:20px;line-height:1em}._dialog-header_wp50s_1 button{font-size:10px}._dialog-main-max-height_wp50s_20{position:absolute;z-index:1;inset:40px 0 50px;padding:10px;overflow:auto}._dialog-footer_wp50s_31,._dialog-footer-max-height_wp50s_31{display:flex;justify-content:space-between;margin:10px -10px 0;padding:10px 10px 0;border-top:1px solid #cccccc}._dialog-footer_wp50s_31 button,._dialog-footer-max-height_wp50s_31 button{font-size:14px}._dialog-footer-max-height_wp50s_31{position:absolute;z-index:2;left:10px;right:10px;bottom:10px}._export-link-dialog-wrapper_p9gxw_1{display:flex}._export-link-dialog-wrapper_p9gxw_1 input{flex-grow:1}._genome-position-search_1l2sx_1,._genome-position-search-focus_1l2sx_2{position:relative;display:flex;align-items:stretch;height:100%;margin-bottom:0;font-size:13.7142857143px;transition:box-shadow .15s cubic-bezier(.25,.1,.25,1),font-size .15s cubic-bezier(.25,.1,.25,1)}._genome-position-search-focus_1l2sx_2{box-shadow:0 0 0 1px #337ab7,0 0 3px 1px #337ab7}._genome-position-search-bar_1l2sx_16{position:relative;box-sizing:border-box;width:100%;height:100%;padding:3px;color:#666;font-size:inherit;line-height:24px;border:0;border-radius:3px 0 0 3px;background:transparent}._genome-position-search-bar_1l2sx_16:focus{outline:none;color:#000}._genome-position-search-dark_1l2sx_34 ._genome-position-search-bar_1l2sx_16:focus{color:#e5e5e5}._genome-position-search-bar-button_1l2sx_38,._genome-position-search-bar-button-focus_1l2sx_39{display:block;height:100%;padding:0 8px!important;color:#999;border:0!important;border-radius:0!important;background:transparent;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1)}._genome-position-search-bar-button_1l2sx_38:active,._genome-position-search-bar-button_1l2sx_38:focus,._genome-position-search-bar-button_1l2sx_38:hover,._genome-position-search-bar-button-focus_1l2sx_39:active,._genome-position-search-bar-button-focus_1l2sx_39:focus,._genome-position-search-bar-button-focus_1l2sx_39:hover{color:#fff;background:#337ab7}._genome-position-search-bar-button-focus_1l2sx_39{color:#fff;background:#337ab7}._genome-position-search-bar-icon_1l2sx_62,._genome-position-search-bar-icon-focus_1l2sx_63{display:flex;align-items:center;transition:color .15s cubic-bezier(.25,.1,.25,1)}._genome-position-search-bar-icon_1l2sx_62:first-child,._genome-position-search-bar-icon-focus_1l2sx_63:first-child{margin-left:6px;margin-right:2px}._genome-position-search-bar-icon_1l2sx_62 span,._genome-position-search-bar-icon-focus_1l2sx_63 span{display:block;margin-top:-2px}._genome-position-search-bar-icon-focus_1l2sx_63{color:#337ab7}._genome-position-search-bar-suggestions_1l2sx_83{position:fixed;border-radius:3px;box-shadow:0 0 3px #0000001a,0 1px 5px #0000000d;background-color:#fffffff2;border:1px solid rgba(0,0,0,.1);padding:2px 0;font-size:90%;overflow:auto;max-height:50%}._btn_1l2sx_95{display:inline-block;margin-bottom:0;font-size:13.7142857143px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}._btn-sm_1l2sx_116{font-size:12px;line-height:1.5;border-radius:3px}._btn-default_1l2sx_122{color:#666;background-color:#fff;border-color:#ccc}._btn-default_1l2sx_122:hover{color:#000;background:#ccc}._btn-default_1l2sx_122:active,._btn-default_1l2sx_122:focus{color:#fff;border-color:#000;background:#000}._genome-position-search_1l2sx_1 ._btn_1l2sx_95{border-radius:0 3px 3px 0}.plot-type-selected{background-color:#0000ff4d}.plot-type-container{overflow-y:scroll;margin:5px;padding:3px;border:1px solid #aaaaaa;border-radius:5px;max-height:15vh}.plot-type-container-empty{margin:5px;padding:3px 8px;border:1px solid #aaaaaa;background-color:#e8e8e8;border-radius:5px}.plot-type-item{cursor:pointer}.plot-type-item:not(.plot-type-selected):hover{background-color:#3333cc1a}.track-thumbnail{width:30px;height:20px;display:inline-block;margin-right:10;vertical-align:middle}.track-thumbnail>svg{width:20px;height:20px}.tileset-finder-label{font-weight:700}.tileset-finder-search-box{margin-left:10px}.tileset-finder-search-bar{display:flex;margin-left:5px;justify-content:space-between;align-items:center}.tileset-finder-checkbox-tree{margin:5px;padding:3px;border:1px solid #aaaaaa;border-radius:5px}.react-checkbox-tree{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;font-size:16px}.react-checkbox-tree>ol{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.react-checkbox-tree ol{margin:0;padding-left:0;list-style-type:none}.react-checkbox-tree ol ol{padding-left:24px}.react-checkbox-tree button{line-height:normal;color:inherit}.react-checkbox-tree button:disabled{cursor:not-allowed}.react-checkbox-tree .rct-bare-label{cursor:default}.react-checkbox-tree label{margin-bottom:0;cursor:pointer}.react-checkbox-tree label:hover{background:#3333cc1a}.react-checkbox-tree label:active,.react-checkbox-tree label:focus{background:#3333cc26}.react-checkbox-tree:not(.rct-native-display) input{display:none}.react-checkbox-tree.rct-native-display input{margin:0 5px}.react-checkbox-tree .rct-icon{display:inline-block;text-align:center;text-rendering:auto;font-family:\"Font Awesome 5 Free\",FontAwesome,sans-serif;font-weight:400;font-variant:normal;font-style:normal}.rct-disabled>.rct-text>label{opacity:.75;cursor:not-allowed}.rct-disabled>.rct-text>label:hover{background:transparent}.rct-disabled>.rct-text>label:active{background:transparent}.rct-text{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.rct-options{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin-left:.5rem;text-align:right}.rct-option{opacity:.75;border:0;background:none;cursor:pointer;padding:0 4px;font-size:18px}.rct-option:hover{opacity:1}.rct-option+.rct-option{margin-left:2px}.rct-collapse,.rct-checkbox,.rct-node-icon{padding:0 5px}.rct-collapse *,.rct-checkbox *,.rct-node-icon *{display:inline-block;margin:0;width:14px}.rct-collapse{-ms-flex-item-align:stretch;align-self:stretch;border:0;background:none;line-height:normal;color:inherit;font-size:12px}.rct-collapse.rct-collapse-btn{cursor:pointer}.rct-collapse>.rct-icon-expand-close{opacity:.5}.rct-collapse>.rct-icon-expand-close:hover{opacity:1}.rct-native-display .rct-checkbox{display:none}.rct-node-clickable{cursor:pointer}.rct-node-clickable:hover{background:#3333cc1a}.rct-node-clickable:focus{outline:0;background:#33c3}.rct-node-icon{color:#33c}.rct-title{padding:0 5px}.rct-icons-fa4 .rct-icon-expand-close:before{content:\"\"}.rct-icons-fa4 .rct-icon-expand-open:before{content:\"\"}.rct-icons-fa4 .rct-icon-uncheck:before{content:\"\"}.rct-icons-fa4 .rct-icon-check:before{content:\"\"}.rct-icons-fa4 .rct-icon-half-check:before{opacity:.5;content:\"\"}.rct-icons-fa4 .rct-icon-leaf:before{content:\"\"}.rct-icons-fa4 .rct-icon-parent-open:before{content:\"\"}.rct-icons-fa4 .rct-icon-parent-close:before{content:\"\"}.rct-icons-fa4 .rct-icon-expand-all:before{content:\"\"}.rct-icons-fa4 .rct-icon-collapse-all:before{content:\"\"}.rct-icons-fa5 .rct-icon-expand-close:before{font-weight:900;content:\"\"}.rct-icons-fa5 .rct-icon-expand-open:before{font-weight:900;content:\"\"}.rct-icons-fa5 .rct-icon-uncheck:before{content:\"\"}.rct-icons-fa5 .rct-icon-check:before{content:\"\"}.rct-icons-fa5 .rct-icon-half-check:before{opacity:.5;content:\"\"}.rct-icons-fa5 .rct-icon-leaf:before{content:\"\"}.rct-icons-fa5 .rct-icon-parent-open:before{content:\"\"}.rct-icons-fa5 .rct-icon-parent-close:before{content:\"\"}.rct-icons-fa5 .rct-icon-expand-all:before{content:\"\"}.rct-icons-fa5 .rct-icon-collapse-all:before{content:\"\"}.rct-direction-rtl{direction:rtl}.rct-direction-rtl ol ol{padding-right:24px;padding-left:0}.rct-direction-rtl.rct-icons-fa4 .rct-icon-expand-close:before{content:\"\"}.rct-direction-rtl.rct-icons-fa5 .rct-icon-expand-close:before{content:\"\"}._track-control_w7hx2_1,._track-control-vertical_w7hx2_2{position:absolute;z-index:1;display:flex;background:#ffffffbf;right:2px;top:2px;border-radius:2.5px;box-shadow:0 0 0 1px #0000000d,0 0 3px #0000001a;opacity:0;transition:opacity .15s cubic-bezier(.25,.1,.25,1),background .15s cubic-bezier(.25,.1,.25,1),box-shadow .15s cubic-bezier(.25,.1,.25,1)}._track-control-dark_w7hx2_15,._track-control-dark_w7hx2_15 ._track-control-active_w7hx2_16{background:#282828d9}._track-control-vertical_w7hx2_2{flex-direction:column-reverse}._track-control-left_w7hx2_24{left:2px;right:auto}._track-control-active_w7hx2_16,._track-control-vertical-active_w7hx2_30{opacity:1;z-index:1}._track-control-active_w7hx2_16:hover,._track-control-vertical-active_w7hx2_30:hover{background:#fff;box-shadow:0 0 0 1px #0000001a,0 0 3px #0003}._track-control-dark_w7hx2_15._track-control-active_w7hx2_16:hover{background:#222222f2}._track-control-padding-right_w7hx2_48{right:80px}._track-control-button_w7hx2_52{width:20px;height:20px;padding:4px;cursor:pointer;opacity:.66;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1),opacity .15s cubic-bezier(.25,.1,.25,1)}._track-control-button_w7hx2_52:hover{color:#fff;background:#337ab7;opacity:1}._track-control-button_w7hx2_52:first-child{border-radius:2.5px 0 0 2.5px}._track-control-button_w7hx2_52:last-child{border-radius:0 2.5px 2.5px 0}._track-control-dark_w7hx2_15 ._track-control-button_w7hx2_52{color:#ccc}._track-control-dark_w7hx2_15 ._track-control-button_w7hx2_52:hover{color:#fff;background:#337ab7;opacity:1}._track-control-button-vertical_w7hx2_81:first-child{border-radius:0 0 2.5px 2.5px}._track-control-button-vertical_w7hx2_81:last-child{border-radius:2.5px 2.5px 0 0}._center-track_fiu64_1{position:relative;background:transparent}._center-track-container_fiu64_6{position:absolute;z-index:1}._track-range-selection_5bcsr_1{position:absolute;z-index:-1;opacity:0;transition:opacity .15s cubic-bezier(.25,.1,.25,1)}._track-range-selection-active_5bcsr_8{z-index:1;opacity:1}._track-range-selection-group-inactive_5bcsr_22{display:none}._track-range-selection-group-brush-selection_5bcsr_26{outline:2px solid rgba(0,0,0,.33);fill:#000;fill-opacity:.1}._context-menu_18ock_1{position:fixed;background-color:#fffffff2;border:1px solid rgba(0,0,0,.1);border-radius:3px;font-size:12px;cursor:default;padding:3px;box-shadow:0 0 3px #0000001a,0 1px 5px #0000000d}._context-menu-dark_18ock_12{color:#ccc;background-color:#444444f7}._context-menu-icon_18ock_17{display:inline-block;margin-right:3px;vertical-align:middle}._context-menu-icon_18ock_17>svg{width:30px;height:20px}._context-menu-item_18ock_27{padding:2px;white-space:nowrap;border-radius:2px;transition:background .15s cubic-bezier(.25,.1,.25,1),color .15s cubic-bezier(.25,.1,.25,1)}._context-menu-item_18ock_27:hover{background:#337ab7;color:#fff}._context-menu-hr_18ock_38{margin-top:5px;margin-bottom:5px;border:0;border-top:1px solid rgba(0,0,0,.1)}._play-icon_18ock_45{width:12px;height:12px;position:absolute;right:5px}._context-menu-span_18ock_52{margin-right:20px;vertical-align:middle;display:inline-block;line-height:normal;white-space:nowrap}._context-menu-thumbnail_18ock_60{margin-right:10px;border:1px solid #888888}._context-menu-thumbnail-inline_18ock_65{display:inline-block;margin-right:10px;vertical-align:middle}table.table-track-options{border-collapse:collapse;margin-left:auto;margin-right:auto}td.td-track-options{border:1px solid #fff;outline:none;padding:3px;position:relative;font-family:Roboto,sans-serif;font-size:14px;color:#666}.cell-label{position:absolute;left:0;top:0;margin-left:5px;color:#777}.modal-dialog{position:relative;display:table;overflow-y:auto;overflow-x:auto;width:auto;min-width:300px;margin:auto}._drag-listening-div-active_19gkt_1{z-index:10;box-shadow:inset 0 0 3px red}._gallery-tracks_fbxxi_1{position:relative;top:0;left:0;width:100%;height:100%}._gallery-track_fbxxi_1{position:absolute;box-sizing:border-box;inset:0}._gallery-sub-track_fbxxi_18,._gallery-invisible-track_fbxxi_19{position:absolute}._tiled-plot_lzpdn_1{position:relative;flex:1;overflow:hidden}._horizontalList_lzpdn_7{display:flex;width:600px;height:300px;white-space:nowrap}._list_lzpdn_14{width:400px;height:600px;overflow:hidden;-webkit-overflow-scrolling:touch}._stylizedList_lzpdn_21{position:relative;z-index:0;background-color:#f3f3f3;outline:none}._stylizedItem_lzpdn_28{position:relative;display:flex;align-items:center;width:100%;background-color:transparent;-webkit-user-select:none;user-select:none;color:#333;font-weight:400}._stylizedHelper_lzpdn_39{box-shadow:0 5px 5px -5px #0003,0 -5px 5px -5px #0003;background-color:#fffc;cursor:row-resize}._stylizedHelper_lzpdn_39._horizontalItem_lzpdn_44{cursor:col-resize}._horizontalItem_lzpdn_44{display:flex;flex-shrink:0;align-items:center;justify-content:center}._resizable-track_lzpdn_55{width:100%;height:100%}path._domain_lzpdn_60{stroke-width:0px}._tiled-plot-track-overlay-plain_lzpdn_64{background:transparent;z-index:1}._tiled-plot-track-overlay-animate_lzpdn_69{background:#ff0;opacity:.3;outline:2px solid rgba(255,0,0,.8);z-index:1;animation:_appear_lzpdn_1 1s}._tiled-plot-track-overlay-selected_lzpdn_77{border:5px solid black;background:#ff0;opacity:.4;z-index:1}._top-right-handle_cizw2_1,._bottom-right-handle_cizw2_2{border-right:black solid;border-top:black solid}._top-left-handle_cizw2_7,._bottom-left-handle_cizw2_8{border-left:black solid;border-top:black solid}._top-draggable-handle_cizw2_13,._bottom-draggable-handle_cizw2_14,._left-draggable-handle_cizw2_15,._right-draggable-handle_cizw2_16{position:absolute;opacity:0;transition:transform .15s cubic-bezier(.25,.1,.25,1),opacity .15s cubic-bezier(.25,.1,.25,1)}._draggable-div_cizw2_22{background-color:transparent;box-sizing:border-box}._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle-grabber_cizw2_28{width:10px;height:4px;border-top:1px solid black;border-bottom:1px solid black}._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle-grabber_cizw2_28{margin:4px 7px}._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle-grabber_cizw2_44{width:4px;height:10px;border-left:1px solid black;border-right:1px solid black}._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle-grabber_cizw2_44{margin:7px 4px}._draggable-div_cizw2_22:hover ._top-draggable-handle_cizw2_13,._draggable-div_cizw2_22:hover ._bottom-draggable-handle_cizw2_14,._draggable-div_cizw2_22:hover ._left-draggable-handle_cizw2_15,._draggable-div_cizw2_22:hover ._right-draggable-handle_cizw2_16{opacity:.5;background:#ffffffbf;box-shadow:0 0 3px 1px #ffffffbf;border-radius:3px}._top-draggable-handle_cizw2_13:hover,._top-draggable-handle_cizw2_13:active,._bottom-draggable-handle_cizw2_14:hover,._bottom-draggable-handle_cizw2_14:active,._left-draggable-handle_cizw2_15:hover,._left-draggable-handle_cizw2_15:active,._right-draggable-handle_cizw2_16:hover,._right-draggable-handle_cizw2_16:active{opacity:1!important;transform:scale(2)}._top-draggable-handle_cizw2_13:hover ._top-draggable-handle-grabber_cizw2_27,._top-draggable-handle_cizw2_13:hover ._bottom-draggable-handle-grabber_cizw2_28,._top-draggable-handle_cizw2_13:hover ._left-draggable-handle-grabber_cizw2_43,._top-draggable-handle_cizw2_13:hover ._right-draggable-handle-grabber_cizw2_44,._top-draggable-handle_cizw2_13:active ._top-draggable-handle-grabber_cizw2_27,._top-draggable-handle_cizw2_13:active ._bottom-draggable-handle-grabber_cizw2_28,._top-draggable-handle_cizw2_13:active ._left-draggable-handle-grabber_cizw2_43,._top-draggable-handle_cizw2_13:active ._right-draggable-handle-grabber_cizw2_44,._bottom-draggable-handle_cizw2_14:hover ._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle_cizw2_14:hover ._bottom-draggable-handle-grabber_cizw2_28,._bottom-draggable-handle_cizw2_14:hover ._left-draggable-handle-grabber_cizw2_43,._bottom-draggable-handle_cizw2_14:hover ._right-draggable-handle-grabber_cizw2_44,._bottom-draggable-handle_cizw2_14:active ._top-draggable-handle-grabber_cizw2_27,._bottom-draggable-handle_cizw2_14:active ._bottom-draggable-handle-grabber_cizw2_28,._bottom-draggable-handle_cizw2_14:active ._left-draggable-handle-grabber_cizw2_43,._bottom-draggable-handle_cizw2_14:active ._right-draggable-handle-grabber_cizw2_44,._left-draggable-handle_cizw2_15:hover ._top-draggable-handle-grabber_cizw2_27,._left-draggable-handle_cizw2_15:hover ._bottom-draggable-handle-grabber_cizw2_28,._left-draggable-handle_cizw2_15:hover ._left-draggable-handle-grabber_cizw2_43,._left-draggable-handle_cizw2_15:hover ._right-draggable-handle-grabber_cizw2_44,._left-draggable-handle_cizw2_15:active ._top-draggable-handle-grabber_cizw2_27,._left-draggable-handle_cizw2_15:active ._bottom-draggable-handle-grabber_cizw2_28,._left-draggable-handle_cizw2_15:active ._left-draggable-handle-grabber_cizw2_43,._left-draggable-handle_cizw2_15:active ._right-draggable-handle-grabber_cizw2_44,._right-draggable-handle_cizw2_16:hover ._top-draggable-handle-grabber_cizw2_27,._right-draggable-handle_cizw2_16:hover ._bottom-draggable-handle-grabber_cizw2_28,._right-draggable-handle_cizw2_16:hover ._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle_cizw2_16:hover ._right-draggable-handle-grabber_cizw2_44,._right-draggable-handle_cizw2_16:active ._top-draggable-handle-grabber_cizw2_27,._right-draggable-handle_cizw2_16:active ._bottom-draggable-handle-grabber_cizw2_28,._right-draggable-handle_cizw2_16:active ._left-draggable-handle-grabber_cizw2_43,._right-draggable-handle_cizw2_16:active ._right-draggable-handle-grabber_cizw2_44{box-shadow:0 0 3px 1px #0089ff;background:#0089ff}._top-draggable-handle_cizw2_13,._bottom-draggable-handle_cizw2_14{height:12px;cursor:row-resize}._left-draggable-handle_cizw2_15,._right-draggable-handle_cizw2_16{width:12px;cursor:col-resize}._horizontal-tiled-plot_1bqkg_1,._track-renderer_11dwb_1{position:relative}._track-renderer-element_11dwb_5,._track-renderer-events_11dwb_6{position:absolute;inset:0;z-index:-1}._track-renderer-events_11dwb_6{z-index:1}._vertical-tiled-plot_f3ho8_1{position:relative}._view-config-editor-header_1hlm6_1{margin:-10px -10px 0;padding:10px;display:flex;justify-content:space-between;background:#f2f2f2}._view-config-editor-header_1hlm6_1 button{display:flex;align-items:center;font-size:14px;background:#f2f2f2}._view-config-editor-header_1hlm6_1 button:hover{background:#e5e5e5}._view-config-editor-header_1hlm6_1 button:hover span{color:#666}._view-config-editor_1hlm6_1{position:absolute;inset:50px 0 0;margin:1px 0 0;padding:0;overflow:auto;font-size:12.5px;height:calc(100% - 80px)}._view-config-log_1hlm6_34{position:absolute;right:0;bottom:0;left:0;margin:1px 0 0;padding:0;min-height:30px;background:#f2f2f2;transition:height .15s cubic-bezier(.25,.1,.25,1)}._view-config-log-header_1hlm6_46{background:#f2f2f2;border-top:1px solid #cccccc;border-bottom:1px solid #cccccc;padding-left:10px;height:30px;display:flex;align-items:center;cursor:pointer;position:sticky;position:-webkit-sticky;top:0}._view-config-log-msg_1hlm6_60{background:#f2f2f2;overflow:auto;height:calc(100% - 30px)}._view-config-log-msg_1hlm6_60 tr,._view-config-log-msg_1hlm6_60 td{outline:none;vertical-align:top}._view-config-log-msg_1hlm6_60 ._title_1hlm6_70{font-weight:700;padding-left:8px;padding-top:8px;width:100px}._view-config-log-msg_1hlm6_60 ._Warning_1hlm6_76{color:orange}._view-config-log-msg_1hlm6_60 ._Success_1hlm6_79{color:green}._view-config-log-msg_1hlm6_60 ._Error_1hlm6_82{color:red}._view-config-log-msg_1hlm6_60 pre{background:#fff;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}._add-track-position-table_egwog_1{border-collapse:collapse;margin:5px;color:#666}._add-track-position-table-dark_egwog_7{color:#ccc}._add-track-position-other_egwog_11{outline:none}._add-track-position-top-center_egwog_15{min-width:80px;min-height:20px;text-align:center;outline:none;border-top:1px solid #999;border-left:1px solid #999;border-right:1px solid #999;border-radius:2px 2px 0 0}._add-track-position-top-center_egwog_15:hover{color:#fff;background-color:#337ab7}._add-track-position-middle-left_egwog_30{min-width:40px;text-align:center;outline:none;border-top:1px solid #999;border-left:1px solid #999;border-bottom:1px solid #999;border-radius:2px 0 0 2px}._add-track-position-middle-left_egwog_30:hover{background-color:#337ab7;color:#fff}._add-track-position-middle-right_egwog_45{min-width:40px;text-align:center;outline:none;border-top:1px solid #999;border-right:1px solid #999;border-bottom:1px solid #999;border-radius:0 2px 2px 0}._add-track-position-middle-right_egwog_45:hover{background-color:#337ab7;color:#fff}._add-track-position-middle-middle_egwog_60{text-align:center;outline:none;border:1px solid #999;position:relative}._add-track-position-middle-middle_egwog_60:hover{background-color:#337ab7;color:#fff}._add-track-position-middle-middle-full_egwog_72{height:80px;display:flex;flex-direction:column;justify-content:center;align-items:center}._add-track-position-middle-middle-upper-right_egwog_80{width:0;height:0;border-top:30px solid #999;border-left:30px solid transparent;position:absolute;top:0;right:0}._add-track-position-middle-middle-upper-right_egwog_80:hover{border-top:30px solid #337ab7}._add-track-position-middle-middle-lower-left_egwog_94{width:0;height:0;border-bottom:30px solid #999;border-right:30px solid transparent;position:absolute;bottom:0;left:0}._add-track-position-middle-middle-lower-left_egwog_94:hover{border-bottom:30px solid #337ab7}._add-track-position-bottom-middle_egwog_108{min-height:20px;text-align:center;outline:none;border-left:1px solid #999;border-right:1px solid #999;border-bottom:1px solid #999;border-radius:0 0 2px 2px}._add-track-position-bottom-middle_egwog_108:hover{background-color:#337ab7;color:#fff}._add-track-position-span_egwog_123{margin:5px}._higlass_1k7ri_1{position:relative}._higlass-dark-theme_1k7ri_5{background:#000}._higlass-container-overflow_1k7ri_9,._higlass-scroll-container-overflow_1k7ri_10,._higlass-scroll-container-scroll_1k7ri_11{position:absolute;inset:0}._higlass-scroll-container-overflow_1k7ri_10{overflow:hidden}._higlass-scroll-container-scroll_1k7ri_11{overflow-x:hidden;overflow-y:auto}._higlass-canvas_1k7ri_28{position:absolute;width:100%}._higlass-drawing-surface_1k7ri_33{position:relative;width:100%}._higlass-svg_1k7ri_38{position:absolute;width:100%;height:100%;left:0;top:0;pointer-events:none}._tiled-area_1k7ri_47{display:flex;flex-direction:column;width:100%;height:100%}._track-mouseover-menu_1k7ri_54{position:fixed;z-index:1;margin:17px 0 0 9px;padding:0 .25rem;max-width:50vw;word-wrap:break-word;font-size:.8em;pointer-events:none;background:#fff;border-radius:.25rem;box-shadow:0 0 0 1px #0000001a,0 0 3px #00000013,0 0 7px #0000000d}.react-grid-layout{position:relative;transition:height .2s ease}.react-grid-item{transition:all .2s ease;transition-property:left,top,width,height}.react-grid-item img{pointer-events:none;-webkit-user-select:none;user-select:none}.react-grid-item.cssTransforms{transition-property:transform,width,height}.react-grid-item.resizing{transition:none;z-index:1;will-change:width,height}.react-grid-item.react-draggable-dragging{transition:none;z-index:3;will-change:transform}.react-grid-item.dropping{visibility:hidden}.react-grid-item.react-grid-placeholder{background:red;opacity:.2;transition-duration:.1s;z-index:2;-webkit-user-select:none;user-select:none}.react-grid-item.react-grid-placeholder.placeholder-resizing{transition:none}.react-grid-item>.react-resizable-handle{position:absolute;width:20px;height:20px;opacity:0}.react-grid-item:hover>.react-resizable-handle{opacity:1}.react-grid-item>.react-resizable-handle:after{content:\"\";position:absolute;right:3px;bottom:3px;width:5px;height:5px;border-right:2px solid rgba(0,0,0,.4);border-bottom:2px solid rgba(0,0,0,.4)}.react-resizable-hide>.react-resizable-handle{display:none}.react-grid-item>.react-resizable-handle.react-resizable-handle-sw{bottom:0;left:0;cursor:sw-resize;transform:rotate(90deg)}.react-grid-item>.react-resizable-handle.react-resizable-handle-se{bottom:0;right:0;cursor:se-resize}.react-grid-item>.react-resizable-handle.react-resizable-handle-nw{top:0;left:0;cursor:nw-resize;transform:rotate(180deg)}.react-grid-item>.react-resizable-handle.react-resizable-handle-ne{top:0;right:0;cursor:ne-resize;transform:rotate(270deg)}.react-grid-item>.react-resizable-handle.react-resizable-handle-w,.react-grid-item>.react-resizable-handle.react-resizable-handle-e{top:50%;margin-top:-10px;cursor:ew-resize}.react-grid-item>.react-resizable-handle.react-resizable-handle-w{left:0;transform:rotate(135deg)}.react-grid-item>.react-resizable-handle.react-resizable-handle-e{right:0;transform:rotate(315deg)}.react-grid-item>.react-resizable-handle.react-resizable-handle-n,.react-grid-item>.react-resizable-handle.react-resizable-handle-s{left:50%;margin-left:-10px;cursor:ns-resize}.react-grid-item>.react-resizable-handle.react-resizable-handle-n{top:0;transform:rotate(225deg)}.react-grid-item>.react-resizable-handle.react-resizable-handle-s{bottom:0;transform:rotate(45deg)}.react-resizable{position:relative}.react-resizable-handle{position:absolute;width:20px;height:20px;background-repeat:no-repeat;background-origin:content-box;box-sizing:border-box;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+);background-position:bottom right;padding:0 3px 3px 0}.react-resizable-handle-sw{bottom:0;left:0;cursor:sw-resize;transform:rotate(90deg)}.react-resizable-handle-se{bottom:0;right:0;cursor:se-resize}.react-resizable-handle-nw{top:0;left:0;cursor:nw-resize;transform:rotate(180deg)}.react-resizable-handle-ne{top:0;right:0;cursor:ne-resize;transform:rotate(270deg)}.react-resizable-handle-w,.react-resizable-handle-e{top:50%;margin-top:-10px;cursor:ew-resize}.react-resizable-handle-w{left:0;transform:rotate(135deg)}.react-resizable-handle-e{right:0;transform:rotate(315deg)}.react-resizable-handle-n,.react-resizable-handle-s{left:50%;margin-left:-10px;cursor:ns-resize}.react-resizable-handle-n{top:0;transform:rotate(225deg)}.react-resizable-handle-s{bottom:0;transform:rotate(45deg)}code[class*=language-],pre[class*=language-]{color:#393a34;font-family:Consolas,Bitstream Vera Sans Mono,Courier New,Courier,monospace;direction:ltr;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;font-size:.95em;line-height:1.2em;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none}pre[class*=language-]::-moz-selection,pre[class*=language-] ::-moz-selection,code[class*=language-]::-moz-selection,code[class*=language-] ::-moz-selection{background:#b3d4fc}pre[class*=language-]::selection,pre[class*=language-] ::selection,code[class*=language-]::selection,code[class*=language-] ::selection{background:#b3d4fc}pre[class*=language-]{padding:1em;margin:.5em 0;overflow:auto;border:1px solid #dddddd;background-color:#fff}:not(pre)>code[class*=language-]{padding:1px .2em;background:#f8f8f8;border:1px solid #dddddd}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#998;font-style:italic}.token.namespace{opacity:.7}.token.string,.token.attr-value{color:#e3116c}.token.punctuation,.token.operator{color:#393a34}.token.entity,.token.url,.token.symbol,.token.number,.token.boolean,.token.variable,.token.constant,.token.property,.token.regex,.token.inserted{color:#36acaa}.token.atrule,.token.keyword,.token.attr-name,.language-autohotkey .token.selector{color:#00a4db}.token.function,.token.deleted,.language-autohotkey .token.tag{color:#9a050f}.token.tag,.token.selector,.language-autohotkey .token.keyword{color:#00009f}.token.important,.token.function,.token.bold{font-weight:700}.token.italic{font-style:italic}.higlass *{box-sizing:border-box}.higlass .react-resizable-handle{z-index:1;opacity:1}\n";
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r2) {
  for (var t = 0; t < r2.length; t++) {
    var o = r2[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r2, t) {
  return r2 && _defineProperties(e.prototype, r2), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r2) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t22) {
  }
  return (_isNativeReflectConstruct = function() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t22) {
    return t22.__proto__ || Object.getPrototypeOf(t22);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t22, e22) {
    return t22.__proto__ = e22, t22;
  }, _setPrototypeOf(t, e);
}
const trackViewer = (element, [xMin, xMax, yMin, yMax], trackConfig) => {
  if (!trackConfig.options.colorbarPosition) {
    trackConfig.options.colorbarPosition = "hidden";
  }
  if (!trackConfig.options.labelPosition) {
    trackConfig.options.labelPosition = "hidden";
  }
  const id2 = "arbitary-id";
  const viewConfig = {
    editable: false,
    zoomFixed: false,
    views: [{
      uid: id2,
      initialXDomain: [xMin, xMax],
      initialYDomain: [yMin, yMax],
      tracks: {
        center: [trackConfig]
      },
      layout: {
        w: 12,
        h: 12,
        x: 0,
        y: 0,
        moved: false,
        static: false
      }
    }]
  };
  const hgApi = viewer(element, viewConfig, {
    sizeMode: "bounded"
  });
  return {
    id: id2,
    hgApi
  };
};
let HiGlassTrackComponent = /* @__PURE__ */ (function(_React$Component) {
  function HiGlassTrackComponent2(props) {
    var _this;
    _classCallCheck(this, HiGlassTrackComponent2);
    _this = _callSuper(this, HiGlassTrackComponent2, [props]);
    _this.id = `id-${Math.random()}`;
    return _this;
  }
  _inherits(HiGlassTrackComponent2, _React$Component);
  return _createClass(HiGlassTrackComponent2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initTrackViewer();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      const {
        x,
        y,
        width,
        height
      } = nextProps;
      this.zoomTo(x, y, width, height);
      return false;
    }
  }, {
    key: "initTrackViewer",
    value: function initTrackViewer() {
      const {
        trackConfig,
        x,
        y,
        width,
        height
      } = this.props;
      const element = document.getElementById(this.id);
      const {
        id: id2,
        hgApi
      } = trackViewer(element, [x, x + width, y, y + height], trackConfig);
      this.viewUid = id2;
      this.viewer = hgApi;
    }
    /**
     * Zoom to a particular position.
     *
     * @param  {Number}  x       Left side of viewport
     * @param  {Number}  y       Top side of viewport
     * @param  {Number}  width   Width of viewport
     * @param  {Number}  height  Height of viewport
     */
  }, {
    key: "zoomTo",
    value: function zoomTo(x, y, width, height) {
      this.viewer.zoomTo(this.viewUid, x, x + width, y, y + height);
    }
  }, {
    key: "render",
    value: function render3() {
      return /* @__PURE__ */ React__default.createElement("div", {
        id: this.id,
        style: {
          height: "100%",
          width: "100%"
        }
      });
    }
  }]);
})(React__default.Component);
HiGlassTrackComponent.propTypes = {
  trackConfig: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number
};
const goslingExports = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DataFetcher,
  DenseDataExtrema1D,
  HeatmapTiledPixiTrack,
  PixiTrack,
  SVGTrack,
  TiledPixiTrack,
  Track,
  ViewportTrackerHorizontal,
  absToChr,
  chrToAbs,
  chromInfoBisector,
  colorToHex,
  fakePubSub,
  pixiTextToSvg,
  showMousePosition: setupShowMousePosition,
  svgLine,
  tileProxy: api
}, Symbol.toStringTag, { value: "Module" }));
const CSS = _CSS;
if (typeof document !== "undefined" && !document.querySelector("[data-higlass-styles]")) {
  const style = document.createElement("style");
  style.setAttribute("data-higlass-styles", "");
  style.textContent = CSS;
  document.head.appendChild(style);
}
const tracks = {
  SVGTrack,
  TiledPixiTrack,
  HorizontalGeneAnnotationsTrack
};
const launch = async (element, config, options2 = {}) => {
  await ensureReady();
  const hgc = await new Promise((resolve) => {
    renderToContainer(element, /* @__PURE__ */ React__default.createElement(HiGlassComponent, {
      ref: (ref2) => {
        ref2 && resolve(ref2);
      },
      options: options2,
      viewConfig: config
    }));
  });
  const viewUids = Object.keys(hgc.state.views);
  if (viewUids.length > 0) {
    await /** @type {Promise<void>} */
    new Promise((resolve) => {
      const start2 = performance.now();
      const check2 = () => {
        const allReady = viewUids.every((uid) => hgc.tiledPlots[uid]?.trackRenderer);
        if (allReady || performance.now() - start2 > 5e3) {
          resolve();
        } else {
          setTimeout(check2, 16);
        }
      };
      check2();
    });
  }
  return hgc;
};
const viewer = async (element, viewConfig, options2 = {}) => {
  const hg = await launch(element, typeof viewConfig === "string" ? await fetch(viewConfig).then((response) => response.json()) : viewConfig, options2);
  return hg.api;
};
export {
  CSS,
  ChromosomeInfo,
  HiGlassComponent,
  HiGlassTrackComponent,
  OPTIONS_INFO,
  TRACKS_INFO_BY_TYPE,
  debounce$1 as debounce,
  getDefaultTracksForDatatype$1 as getDefaultTracksForDatatype,
  getTrackByUid,
  getTrackObjectFromHGC,
  goslingExports as hggos,
  mountHGComponent,
  schema,
  trackViewer,
  tracks,
  version,
  viewer,
  waitForJsonComplete,
  waitForTilesLoaded,
  waitForTransitionsFinished
};
